import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  approval_status: any;
  bigint: any;
  bytea: any;
  dark_web_network: any;
  dark_web_password: any;
  date: any;
  domain_name_match_type: any;
  float8: any;
  json: any;
  jsonb: any;
  numeric: any;
  organization_status: any;
  organization_type: any;
  platform_type: any;
  social_media_account_type: any;
  spoofing_status: any;
  time: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

export type ActionOnEmailInput = {
  alert_id: Scalars['String'];
  body: Scalars['String'];
  message_id?: InputMaybe<Scalars['String']>;
  should_send_to_soc: Scalars['Boolean'];
  subject: Scalars['String'];
};

export type ActionOnEmailOutput = {
  __typename?: 'ActionOnEmailOutput';
  email_id: Scalars['String'];
};

export type ArchiveEntityLinksInput = {
  link_uuid: Scalars['uuid'];
  request_type: Scalars['String'];
};

export type ArchiveEntityLinksOutput = {
  __typename?: 'ArchiveEntityLinksOutput';
  message?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type CrudInput = {
  request_input: Scalars['json'];
  request_type: Scalars['String'];
};

export type CompanyInput = {
  isCurrent: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CompanyOutput = {
  __typename?: 'CompanyOutput';
  isCurrent: Scalars['Boolean'];
  name: Scalars['String'];
  uuid?: Maybe<Scalars['String']>;
};

export type CreateEntityLinksInput = {
  child_node?: InputMaybe<Scalars['jsonb']>;
  link_type?: InputMaybe<Scalars['String']>;
  parent_node: Scalars['jsonb'];
  request_type: Scalars['String'];
};

export type CreateEntityLinksOutput = {
  __typename?: 'CreateEntityLinksOutput';
  error?: Maybe<Scalars['String']>;
  graph?: Maybe<Scalars['jsonb']>;
  is_valid: Scalars['Boolean'];
};

export type CreateSimCampaignInput = {
  end_date: Scalars['String'];
  launch_date: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  org_id: Scalars['String'];
  sender_address: Scalars['String'];
  sim_user_ids: Array<InputMaybe<Scalars['String']>>;
};

export type CreateSimCampaignOutput = {
  __typename?: 'CreateSimCampaignOutput';
  campaign_id: Scalars['String'];
};

export type CreateUserOutput = {
  __typename?: 'CreateUserOutput';
  message?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

export type DeleteAlertInput = {
  alert_id: Scalars['String'];
};

export type DeleteAlertOutput = {
  __typename?: 'DeleteAlertOutput';
  success: Scalars['Boolean'];
};

export type DeleteReportFileInput = {
  file_name: Scalars['String'];
  spoof_report_id: Scalars['uuid'];
};

export type DeleteReportFileOutput = {
  __typename?: 'DeleteReportFileOutput';
  results?: Maybe<Scalars['jsonb']>;
};

export type DeleteUserInput = {
  request_type: Scalars['String'];
  user_id: Scalars['uuid'];
};

export type DeleteUserOutput = {
  __typename?: 'DeleteUserOutput';
  message?: Maybe<Scalars['String']>;
};

export type ElasticSearchQueriesInput = {
  add_result_attribution?: InputMaybe<Scalars['Boolean']>;
  aggregations?: InputMaybe<Scalars['jsonb']>;
  from?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  query: Scalars['String'];
  query_field?: InputMaybe<Scalars['String']>;
  query_structure?: InputMaybe<Scalars['jsonb']>;
  size?: InputMaybe<Scalars['Int']>;
};

export type ElasticSearchQueriesOutput = {
  __typename?: 'ElasticSearchQueriesOutput';
  data?: Maybe<Scalars['jsonb']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ElasticsearchField = {
  __typename?: 'ElasticsearchField';
  boost?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type ElasticsearchFieldsInput = {
  index: Scalars['String'];
};

export type ElasticsearchFieldsOutput = {
  __typename?: 'ElasticsearchFieldsOutput';
  fields?: Maybe<Array<Maybe<ElasticsearchField>>>;
};

export type EmailInput = {
  email: Scalars['String'];
};

export type EmailOutput = {
  __typename?: 'EmailOutput';
  email: Scalars['String'];
  uuid?: Maybe<Scalars['String']>;
};

export type EmailSettings = {
  email_domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enable_internal_acknowledgements?: InputMaybe<Scalars['Boolean']>;
  external_threat_box_address?: InputMaybe<Scalars['String']>;
  internal_threat_box_address?: InputMaybe<Scalars['String']>;
  soc_address?: InputMaybe<Scalars['String']>;
  spoofing_entity_id?: InputMaybe<Scalars['String']>;
};

export type FileData = {
  content: Scalars['bytea'];
  metadata?: InputMaybe<Scalars['jsonb']>;
  mime_type: Scalars['String'];
};

export type FlaggedCollectionInput = {
  chain: Scalars['String'];
  collection_name: Scalars['String'];
  collection_slug: Scalars['String'];
  contract_address: Scalars['String'];
  id: Scalars['String'];
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

export type GenerateSuggestedEnforcementsInput = {
  individual_enforcement_data?: InputMaybe<Scalars['jsonb']>;
  mode: Scalars['String'];
  product_form_data?: InputMaybe<Scalars['jsonb']>;
  product_type: Scalars['String'];
  spoof_report_ids: Array<Scalars['uuid']>;
  staged_enforcements?: InputMaybe<Array<InputMaybe<Scalars['jsonb']>>>;
};

export type GenerateSuggestedEnforcementsOutput = {
  __typename?: 'GenerateSuggestedEnforcementsOutput';
  generated_suggested_enforcements?: Maybe<Scalars['jsonb']>;
};

export type GetStatsDataInput = {
  date_range?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['String']>;
  filter_by?: InputMaybe<Scalars['jsonb']>;
  graph_name?: InputMaybe<Scalars['String']>;
  group_by?: InputMaybe<Scalars['String']>;
  is_init_run?: InputMaybe<Scalars['Boolean']>;
  organization_id: Scalars['uuid'];
  start_date?: InputMaybe<Scalars['String']>;
  stat_type?: InputMaybe<Scalars['String']>;
};

export type GetStatsDataOutput = {
  __typename?: 'GetStatsDataOutput';
  data?: Maybe<Scalars['jsonb']>;
};

export type GetThreatGraphDataInput = {
  alert_uuid?: InputMaybe<Scalars['uuid']>;
  entity_data_ids?: InputMaybe<Array<Scalars['String']>>;
  max_depth?: InputMaybe<Scalars['Int']>;
  max_neighbors?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  skipped_link_types?: InputMaybe<Array<Scalars['String']>>;
};

export type GetThreatGraphDataOutput = {
  __typename?: 'GetThreatGraphDataOutput';
  fully_expanded_node_ids?: Maybe<Array<Scalars['String']>>;
  links: Scalars['jsonb'];
  nodes: Scalars['jsonb'];
  root_node_ids?: Maybe<Array<Scalars['String']>>;
};

export type HandleAdminUrlSearchRequestInput = {
  enable_org_audit?: InputMaybe<Scalars['String']>;
  lookback_window_days?: InputMaybe<Scalars['Int']>;
  send_csv_async?: InputMaybe<Scalars['Boolean']>;
  urls: Array<Scalars['String']>;
};

export type HandleAdminUrlSearchRequestOutput = {
  __typename?: 'HandleAdminUrlSearchRequestOutput';
  response?: Maybe<Scalars['jsonb']>;
};

export type HandleAutoActioningAlertSelectionInput = {
  alert_id: Scalars['uuid'];
  autoactioning_metadata: Scalars['jsonb'];
};

export type HandleAutoActioningAlertSelectionOutput = {
  __typename?: 'HandleAutoActioningAlertSelectionOutput';
  results?: Maybe<Scalars['jsonb']>;
};

export type HandleDetectionSearchInput = {
  index_name: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  search_after?: InputMaybe<Scalars['String']>;
};

export type HandleDetectionSearchOutput = {
  __typename?: 'HandleDetectionSearchOutput';
  data?: Maybe<Scalars['jsonb']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type HandleSynchronousDetectionRequestAsyncActionInput = {
  create_detection_configs_for_url?: InputMaybe<Scalars['jsonb']>;
  run_detection_rule?: InputMaybe<Scalars['jsonb']>;
};

export type HandleSynchronousDetectionRequestAsyncActionOutput = {
  __typename?: 'HandleSynchronousDetectionRequestAsyncActionOutput';
  action_id: Scalars['uuid'];
};

export type HandleSynchronousDetectionRequestInput = {
  create_detection_configs_for_ioc?: InputMaybe<Scalars['jsonb']>;
  create_detection_configs_for_url?: InputMaybe<Scalars['jsonb']>;
  generate_hash_for_html?: InputMaybe<Scalars['jsonb']>;
  on_demand_sourcing_brands?: InputMaybe<Scalars['jsonb']>;
  on_demand_sourcing_queries?: InputMaybe<Scalars['jsonb']>;
  publish_adhoc_candidates?: InputMaybe<Scalars['jsonb']>;
  run_detection_rule?: InputMaybe<Scalars['jsonb']>;
};

export type HandleSynchronousDetectionRequestOutput = {
  __typename?: 'HandleSynchronousDetectionRequestOutput';
  response?: Maybe<Scalars['jsonb']>;
  success: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type LocationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};

export type LocationOutput = {
  __typename?: 'LocationOutput';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
  uuid?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type ManageGcsObjectsInput = {
  bucket_name: Scalars['String'];
  exact_match?: InputMaybe<Scalars['Boolean']>;
  file?: InputMaybe<FileData>;
  generation_number?: InputMaybe<Scalars['String']>;
  include_object?: InputMaybe<Scalars['Boolean']>;
  object_name: Scalars['String'];
  request_type: Scalars['String'];
};

export type ManageGcsObjectsOutput = {
  __typename?: 'ManageGCSObjectsOutput';
  object_info: Scalars['jsonb'];
};

export type ManageSafelistInput = {
  brand_ids?: InputMaybe<Array<InputMaybe<Scalars['uuid']>>>;
  customer_asset_id?: InputMaybe<Scalars['uuid']>;
  organization_id: Scalars['uuid'];
  request_type: Scalars['String'];
  unsanitized_input?: InputMaybe<Scalars['String']>;
};

export type ManageSafelistOutput = {
  __typename?: 'ManageSafelistOutput';
  id: Scalars['uuid'];
};

export type ManageTrademarksInput = {
  brand_ids?: InputMaybe<Array<InputMaybe<Scalars['uuid']>>>;
  country_code?: InputMaybe<Scalars['String']>;
  goods_or_services_classes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  holder_address?: InputMaybe<Scalars['String']>;
  holder_name?: InputMaybe<Scalars['String']>;
  holder_website?: InputMaybe<Scalars['String']>;
  mark?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  record_link?: InputMaybe<Scalars['String']>;
  registration_number?: InputMaybe<Scalars['String']>;
  registration_office?: InputMaybe<Scalars['String']>;
  request_type: Scalars['String'];
  trademark_certificate_file_data?: InputMaybe<FileData>;
  trademark_id?: InputMaybe<Scalars['uuid']>;
  trademark_image_file_data?: InputMaybe<FileData>;
  trademark_status?: InputMaybe<Scalars['String']>;
  trademark_type?: InputMaybe<Scalars['String']>;
};

export type ManageTrademarksOutput = {
  __typename?: 'ManageTrademarksOutput';
  trademark_id: Scalars['uuid'];
};

export type ManageUserAccessInput = {
  organization_id?: InputMaybe<Scalars['uuid']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  request_type: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  user_id: Scalars['uuid'];
};

export type ManageUserAccessOutput = {
  __typename?: 'ManageUserAccessOutput';
  message?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

export type ManageUsersInput = {
  email: Scalars['String'];
  is_internal?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organization_id: Scalars['uuid'];
  request_type: Scalars['String'];
};

export type ManageUsersInputV2 = {
  email: Scalars['String'];
  is_internal?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organizations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  request_type: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
};

export type ModifyAlertLinksOutput = {
  __typename?: 'ModifyAlertLinksOutput';
  response: Scalars['json'];
};

export type ModifyGcsObjectOutput = {
  __typename?: 'ModifyGCSObjectOutput';
  message?: Maybe<Scalars['String']>;
  public_url?: Maybe<Scalars['String']>;
};

export type NameSetInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
};

export type NameSetOutput = {
  __typename?: 'NameSetOutput';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type OpenAiInput = {
  alert_id: Scalars['uuid'];
};

export type OpenAiOutput = {
  __typename?: 'OpenAiOutput';
  notes: Scalars['String'];
};

export type PhoneNumberInput = {
  number: Scalars['String'];
};

export type PhoneNumberOutput = {
  __typename?: 'PhoneNumberOutput';
  number: Scalars['String'];
  uuid?: Maybe<Scalars['String']>;
};

export type PiiChangeOperationCompany = {
  to_add?: InputMaybe<Array<PiiCompanyChange>>;
  to_delete?: InputMaybe<Array<Scalars['String']>>;
  to_update?: InputMaybe<Array<PiiCompanyChange>>;
};

export type PiiChangeOperationEmail = {
  to_add?: InputMaybe<Array<PiiEmailChange>>;
  to_delete?: InputMaybe<Array<Scalars['String']>>;
  to_update?: InputMaybe<Array<PiiEmailChange>>;
};

export type PiiChangeOperationLocation = {
  to_add?: InputMaybe<Array<PiiLocationChange>>;
  to_delete?: InputMaybe<Array<Scalars['String']>>;
  to_update?: InputMaybe<Array<PiiLocationChange>>;
};

export type PiiChangeOperationName = {
  to_add?: InputMaybe<Array<PiiNameChange>>;
  to_delete?: InputMaybe<Array<Scalars['String']>>;
  to_update?: InputMaybe<Array<PiiNameChange>>;
};

export type PiiChangeOperationPhoneNumber = {
  to_add?: InputMaybe<Array<PiiPhoneNumberChange>>;
  to_delete?: InputMaybe<Array<Scalars['String']>>;
  to_update?: InputMaybe<Array<PiiPhoneNumberChange>>;
};

export type PiiChangeOperationRelative = {
  to_add?: InputMaybe<Array<PiiRelativeChange>>;
  to_delete?: InputMaybe<Array<Scalars['String']>>;
  to_update?: InputMaybe<Array<PiiRelativeChange>>;
};

export type PiiChanges = {
  birthDay?: InputMaybe<Scalars['String']>;
  birthMonth?: InputMaybe<Scalars['String']>;
  birthYear?: InputMaybe<Scalars['String']>;
  companies?: InputMaybe<PiiChangeOperationCompany>;
  emails?: InputMaybe<PiiChangeOperationEmail>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<PiiChangeOperationLocation>;
  names?: InputMaybe<PiiChangeOperationName>;
  phoneNumbers?: InputMaybe<PiiChangeOperationPhoneNumber>;
  relatives?: InputMaybe<PiiChangeOperationRelative>;
};

export type PiiCompanyChange = {
  isCurrent: Scalars['Boolean'];
  name: Scalars['String'];
  uuid?: InputMaybe<Scalars['String']>;
};

export type PiiCreateMemberInput = {
  birthDay?: InputMaybe<Scalars['String']>;
  birthMonth?: InputMaybe<Scalars['String']>;
  birthYear?: InputMaybe<Scalars['String']>;
  companies: Array<CompanyInput>;
  destinationUserId?: InputMaybe<Scalars['String']>;
  emails: Array<EmailInput>;
  isForCurrentUser?: InputMaybe<Scalars['Boolean']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  locations: Array<LocationInput>;
  names: Array<NameSetInput>;
  phoneNumbers: Array<PhoneNumberInput>;
  relatives: Array<NameSetInput>;
};

export type PiiCreateMemberOutput = {
  __typename?: 'PiiCreateMemberOutput';
  message: Scalars['String'];
  success: Scalars['Boolean'];
  uuid: Scalars['String'];
};

export type PiiDeleteMemberInput = {
  memberUuid: Scalars['String'];
};

export type PiiDeleteMemberOutput = {
  __typename?: 'PiiDeleteMemberOutput';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type PiiEditMemberInput = {
  changes: PiiChanges;
  memberUuid: Scalars['String'];
};

export type PiiEditMemberOutput = {
  __typename?: 'PiiEditMemberOutput';
  message: Scalars['String'];
  success: Scalars['Boolean'];
  uuid: Scalars['String'];
};

export type PiiEmailChange = {
  email: Scalars['String'];
  uuid?: InputMaybe<Scalars['String']>;
};

export type PiiGetMemberInput = {
  memberUuid: Scalars['String'];
};

export type PiiGetMemberOutput = {
  __typename?: 'PiiGetMemberOutput';
  birthDay?: Maybe<Scalars['String']>;
  birthMonth?: Maybe<Scalars['String']>;
  birthYear?: Maybe<Scalars['String']>;
  companies: Array<CompanyOutput>;
  emails: Array<EmailOutput>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locations: Array<LocationOutput>;
  names: Array<NameSetOutput>;
  phoneNumbers: Array<PhoneNumberOutput>;
  relatives: Array<NameSetOutput>;
};

export type PiiLocationChange = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  state: Scalars['String'];
  uuid?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type PiiNameChange = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type PiiPhoneNumberChange = {
  number: Scalars['String'];
  uuid?: InputMaybe<Scalars['String']>;
};

export type PiiRelativeChange = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type PostIocUpdatedInput = {
  ioc_id: Scalars['String'];
  new_value: Scalars['String'];
  old_value: Scalars['String'];
  type: Scalars['String'];
};

export type PostIocUpdatedOutput = {
  __typename?: 'PostIocUpdatedOutput';
  success: Scalars['Boolean'];
};

export type ProductEnablement = {
  enablement_status: Scalars['String'];
  product: Scalars['String'];
};

export type PublishRequestSpoofScreenshotInput = {
  report_id: Scalars['uuid'];
};

export type PublishRequestSpoofScreenshotOutput = {
  __typename?: 'PublishRequestSpoofScreenshotOutput';
  matches_published: Array<Scalars['uuid']>;
  report_screenshot_url: Scalars['String'];
  screenshot_url_already_exists: Scalars['Boolean'];
};

export type RequestAlertCsvExportInput = {
  organization_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['String']>;
  where_clause?: InputMaybe<Scalars['jsonb']>;
};

export type RequestAlertCsvExportOutput = {
  __typename?: 'RequestAlertCSVExportOutput';
  download_url: Scalars['String'];
};

export type RequestBulkScrapeInput = {
  flagged_collection: FlaggedCollectionInput;
};

export type RequestBulkScrapeOutput = {
  __typename?: 'RequestBulkScrapeOutput';
  collections_to_scrape: Scalars['Int'];
};

export type RunDeepfakeDetectionInput = {
  brand_image_url: Scalars['String'];
  brand_name: Scalars['String'];
};

export type RunDeepfakeDetectionOutput = {
  __typename?: 'RunDeepfakeDetectionOutput';
  candidates?: Maybe<Scalars['jsonb']>;
};

export type RunOcrAnalysisInput = {
  hyperlinks: Array<InputMaybe<Scalars['String']>>;
  phone_numbers: Array<InputMaybe<Scalars['String']>>;
};

export type RunOcrAnalysisOutput = {
  __typename?: 'RunOCRAnalysisOutput';
  image: Scalars['jsonb'];
};

export type SendSimEmailInput = {
  sim_email_id: Scalars['String'];
};

export type SendSimEmailOutput = {
  __typename?: 'SendSimEmailOutput';
  sim_email_id: Scalars['String'];
};

export type SlackMessageInput = {
  channel_id: Scalars['String'];
  message: Scalars['String'];
};

export type SlackMessageOutput = {
  __typename?: 'SlackMessageOutput';
  success?: Maybe<Scalars['Boolean']>;
};

export type SourcingAdhocRequestInput = {
  entity_id: Scalars['uuid'];
  from_date?: InputMaybe<Scalars['String']>;
  sourcer_label: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type SubmitAutoEnforcementRequestsInput = {
  action?: InputMaybe<Scalars['String']>;
  enforcement_request_ids: Array<Scalars['uuid']>;
  same_root_domain_report_ids?: InputMaybe<Array<Scalars['String']>>;
};

export type SubmitAutoEnforcementRequestsOutput = {
  __typename?: 'SubmitAutoEnforcementRequestsOutput';
  results?: Maybe<Scalars['jsonb']>;
};

export type SubmitFormAutoEnforcementRequestsInput = {
  enforcement_request_id: Scalars['uuid'];
};

export type SubmitFormAutoEnforcementRequestsOutput = {
  __typename?: 'SubmitFormAutoEnforcementRequestsOutput';
  results?: Maybe<Scalars['jsonb']>;
};

export type SuccessMessageOutput = {
  __typename?: 'SuccessMessageOutput';
  success: Scalars['Boolean'];
};

export type UpdateEnforcementRequestStatusInput = {
  enforcement_request_id?: InputMaybe<Scalars['uuid']>;
  enforcement_request_ids?: InputMaybe<Array<InputMaybe<Scalars['uuid']>>>;
  enforcement_request_status: Scalars['String'];
  filename?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
};

export type UpdateEnforcementRequestStatusOutput = {
  __typename?: 'UpdateEnforcementRequestStatusOutput';
  enforcement_request_id: Scalars['uuid'];
};

export type UpdateOrganizationInput = {
  organization_id: Scalars['String'];
  request_type: Scalars['String'];
  users_to_add?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  users_to_remove?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateOrganizationOutput = {
  __typename?: 'UpdateOrganizationOutput';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateReportsInput = {
  annotation_notes?: InputMaybe<Scalars['String']>;
  annotation_value?: InputMaybe<Scalars['String']>;
  brand_id?: InputMaybe<Scalars['uuid']>;
  external_assignee_id?: InputMaybe<Scalars['String']>;
  file_action?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  file_to_upload?: InputMaybe<Scalars['String']>;
  internal_assignee_id?: InputMaybe<Scalars['String']>;
  is_internal?: InputMaybe<Scalars['Boolean']>;
  last_actioned_at?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  report_classification?: InputMaybe<Scalars['String']>;
  report_ids: Array<Scalars['uuid']>;
  report_status?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  tag_action?: InputMaybe<Scalars['String']>;
  tag_id?: InputMaybe<Scalars['uuid']>;
  update_source: Scalars['String'];
};

export type UpdateReportsOutput = {
  __typename?: 'UpdateReportsOutput';
  ids: Array<Scalars['uuid']>;
  updated_fields?: Maybe<Scalars['jsonb']>;
};

export type UpdateUserInput = {
  onboarding_status: Scalars['String'];
  request_type: Scalars['String'];
  user_id: Scalars['uuid'];
};

export type UpdateUserOutput = {
  __typename?: 'UpdateUserOutput';
  message?: Maybe<Scalars['String']>;
};

export type UploadNewAlertInput = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  entity_value: Scalars['String'];
  is_customer_sourced: Scalars['Boolean'];
  notes?: InputMaybe<Scalars['String']>;
  organization_id: Scalars['uuid'];
};

export type UploadNewAlertOutput = {
  __typename?: 'UploadNewAlertOutput';
  alert?: Maybe<UploadedNewAlert>;
  error?: Maybe<UploadedNewAlertError>;
};

export type UploadNewDetectionAssetInput = {
  brand_id: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  enabled_usage: Scalars['String'];
  idempotency_key: Scalars['String'];
  ir_to_dr_rule_override?: InputMaybe<Scalars['String']>;
  is_generic_override?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
  value: Scalars['String'];
};

export type UploadNewDetectionAssetOutput = {
  __typename?: 'UploadNewDetectionAssetOutput';
  id: Scalars['String'];
};

export type UploadNewEnforcementRequestInput = {
  body?: InputMaybe<Scalars['String']>;
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  copyright_original_work_description?: InputMaybe<Scalars['String']>;
  copyrighted_content_url?: InputMaybe<Scalars['String']>;
  enforcement_type: Scalars['String'];
  original_content_type?: InputMaybe<Scalars['String']>;
  platform: Scalars['String'];
  screenshot_file?: InputMaybe<Scalars['String']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  status: Scalars['String'];
  submission_email?: InputMaybe<Scalars['String']>;
  submission_source?: InputMaybe<Scalars['String']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  suggested_enforcement_id?: InputMaybe<Scalars['uuid']>;
  trademark_id?: InputMaybe<Scalars['uuid']>;
};

export type UploadNewEnforcementRequestOutput = {
  __typename?: 'UploadNewEnforcementRequestOutput';
  id: Scalars['uuid'];
};

export type UploadNewEnforcementRequestV2Input = {
  body?: InputMaybe<Scalars['String']>;
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  copyright_original_work_description?: InputMaybe<Scalars['String']>;
  copyrighted_content_url?: InputMaybe<Scalars['String']>;
  enforcement_type: Scalars['String'];
  original_content_type?: InputMaybe<Scalars['String']>;
  platform: Scalars['String'];
  screenshot_file?: InputMaybe<Scalars['String']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  status: Scalars['String'];
  submission_email?: InputMaybe<Scalars['String']>;
  submission_source?: InputMaybe<Scalars['String']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  suggested_enforcement_id?: InputMaybe<Scalars['uuid']>;
  trademark_id?: InputMaybe<Scalars['uuid']>;
};

export type UploadNewEnforcementRequestV2Output = {
  __typename?: 'UploadNewEnforcementRequestV2Output';
  enforcement_request?: Maybe<UploadedNewEnforcementRequest>;
  error?: Maybe<UploadedNewEnforcementRequestError>;
};

export type UploadNewEnforcementTemplateInput = {
  enforcement_type: Scalars['String'];
  platform: Scalars['String'];
  stage: Scalars['String'];
  template_body: Scalars['String'];
};

export type UploadNewEnforcementTemplateOutput = {
  __typename?: 'UploadNewEnforcementTemplateOutput';
  platform: Scalars['String'];
  stage: Scalars['String'];
  template_body: Scalars['String'];
  type: Scalars['String'];
};

export type UploadNewNftCustomerCollectionInput = {
  collection_image_url?: InputMaybe<Scalars['String']>;
  collection_name: Scalars['String'];
  images?: InputMaybe<Scalars['jsonb']>;
  keywords?: InputMaybe<Scalars['jsonb']>;
  organization_id: Scalars['uuid'];
};

export type UploadNewNftCustomerCollectionOutput = {
  __typename?: 'UploadNewNftCustomerCollectionOutput';
  asset_ids: Array<Scalars['uuid']>;
  collection_id: Scalars['uuid'];
};

export type UploadNewNftMarketplaceCollectionInput = {
  collection_slugs: Array<Scalars['String']>;
  organization_id: Scalars['String'];
};

export type UploadNewNftMarketplaceCollectionOutput = {
  __typename?: 'UploadNewNftMarketplaceCollectionOutput';
  collections: Array<UploadNewNftMarketplaceCollectionOutputObj>;
};

export type UploadNewNftMarketplaceCollectionOutputObj = {
  __typename?: 'UploadNewNftMarketplaceCollectionOutputObj';
  id: Scalars['String'];
  slug: Scalars['String'];
};

export type UploadNewOrganizationInput = {
  abbr_name?: InputMaybe<Scalars['String']>;
  allowed_domain_enforcement_types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  analytics_summary_recipient_emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  approved_domains?: InputMaybe<Array<Scalars['String']>>;
  approved_emails?: InputMaybe<Array<Scalars['String']>>;
  authorization_letter_url?: InputMaybe<Scalars['String']>;
  authorization_letter_url_expiration_date?: InputMaybe<Scalars['String']>;
  child_organizations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  country_code?: InputMaybe<Scalars['String']>;
  customer_point_of_contact_email?: InputMaybe<Scalars['String']>;
  customer_type?: InputMaybe<Scalars['String']>;
  email_settings?: InputMaybe<EmailSettings>;
  enforcement_email?: InputMaybe<Scalars['String']>;
  is_app_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_code_repos_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_crypto_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_dark_market_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_dark_web_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_domain_purchasing_enabled?: InputMaybe<Scalars['Boolean']>;
  is_ecommerce_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_email_abuse_box_enabled?: InputMaybe<Scalars['Boolean']>;
  is_email_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_nft_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_paid_ads_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_parent?: InputMaybe<Scalars['Boolean']>;
  is_pii_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_social_media_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_suspicious_emails_enabled?: InputMaybe<Scalars['Boolean']>;
  is_telco_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_web2_enabled?: InputMaybe<Scalars['Boolean']>;
  legal_name?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  point_of_contact_id?: InputMaybe<Scalars['uuid']>;
  product_enablements?: InputMaybe<Array<InputMaybe<ProductEnablement>>>;
  rubric_link?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  trial_takedown_limit?: InputMaybe<Scalars['String']>;
};

export type UploadNewOrganizationOutput = {
  __typename?: 'UploadNewOrganizationOutput';
  organization_id: Scalars['String'];
};

export type UploadNewPlatformInput = {
  custom_urls_to_product?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  platform_domains?: InputMaybe<Array<Scalars['String']>>;
  product: Scalars['String'];
};

export type UploadNewPlatformOutput = {
  __typename?: 'UploadNewPlatformOutput';
  custom_urls_to_product?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  platform_domains?: Maybe<Array<Scalars['String']>>;
  product: Scalars['String'];
};

export type UploadNewProtectedAssetInput = {
  brand_id: Scalars['String'];
  is_primary?: InputMaybe<Scalars['Boolean']>;
  should_monitor?: InputMaybe<Scalars['Boolean']>;
  similarity_threshold?: InputMaybe<Scalars['Int']>;
  unsanitized_url: Scalars['String'];
};

export type UploadNewProtectedAssetOutput = {
  __typename?: 'UploadNewProtectedAssetOutput';
  id: Scalars['String'];
  is_generic?: Maybe<Scalars['Boolean']>;
  is_primary?: Maybe<Scalars['Boolean']>;
  platform_name: Scalars['String'];
  similarity_threshold?: Maybe<Scalars['Int']>;
  unsanitized_url: Scalars['String'];
};

export type UploadNewReportInput = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  is_customer_sourced: Scalars['Boolean'];
  notes?: InputMaybe<Scalars['String']>;
  organization_id: Scalars['uuid'];
  url: Scalars['String'];
};

export type UploadNewReportOutput = {
  __typename?: 'UploadNewReportOutput';
  error?: Maybe<UploadedNewReportError>;
  report?: Maybe<UploadedNewReport>;
};

export type UploadNewTrademarkInput = {
  entity_id?: InputMaybe<Scalars['uuid']>;
  entity_name: Scalars['String'];
  entity_name_search_queries?: InputMaybe<Scalars['jsonb']>;
  holder_address: Scalars['String'];
  holder_country_code: Scalars['String'];
  holder_name: Scalars['String'];
  organization_id?: InputMaybe<Scalars['uuid']>;
  registration_number: Scalars['String'];
};

export type UploadNewTrademarkOutput = {
  __typename?: 'UploadNewTrademarkOutput';
  id: Scalars['uuid'];
};

export type UploadNewWeb2EntityInput = {
  domain_configs: Scalars['jsonb'];
  entity_id?: InputMaybe<Scalars['uuid']>;
  entity_name: Scalars['String'];
  entity_name_search_queries?: InputMaybe<Scalars['jsonb']>;
  entity_type: Scalars['String'];
  entity_url?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  screenshot_url: Scalars['String'];
};

export type UploadNewWeb2EntityOutput = {
  __typename?: 'UploadNewWeb2EntityOutput';
  id: Scalars['uuid'];
};

export type UploadReportFileInput = {
  file: Scalars['String'];
  file_name: Scalars['String'];
  spoof_report_id: Scalars['uuid'];
};

export type UploadReportFileOutput = {
  __typename?: 'UploadReportFileOutput';
  results?: Maybe<Scalars['jsonb']>;
};

export type UploadedNewAlert = {
  __typename?: 'UploadedNewAlert';
  brand_name: Scalars['String'];
  classification: Scalars['String'];
  entity_value: Scalars['String'];
  id: Scalars['uuid'];
  is_existing: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  platform_name: Scalars['String'];
  product?: Maybe<Scalars['String']>;
  queue_state: Scalars['String'];
};

export type UploadedNewAlertError = {
  __typename?: 'UploadedNewAlertError';
  entity_value: Scalars['String'];
  reason: Scalars['String'];
};

export type UploadedNewEnforcementRequest = {
  __typename?: 'UploadedNewEnforcementRequest';
  id: Scalars['uuid'];
};

export type UploadedNewEnforcementRequestError = {
  __typename?: 'UploadedNewEnforcementRequestError';
  error_code: Scalars['Int'];
  message: Scalars['String'];
};

export type UploadedNewReport = {
  __typename?: 'UploadedNewReport';
  brand_name: Scalars['String'];
  classification: Scalars['String'];
  flagged_url: Scalars['String'];
  id: Scalars['uuid'];
  is_existing: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  platform_name: Scalars['String'];
  product?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type UploadedNewReportError = {
  __typename?: 'UploadedNewReportError';
  flagged_url: Scalars['String'];
  reason: Scalars['String'];
};

/** columns and relationships of "advertisement_data" */
export type Advertisement_Data = {
  __typename?: 'advertisement_data';
  ad_detail_html_url?: Maybe<Scalars['String']>;
  ad_detail_link: Scalars['String'];
  /** An object relationship */
  advertiser_data?: Maybe<Advertiser_Data>;
  advertiser_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamp'];
  date_first_shown?: Maybe<Scalars['timestamp']>;
  date_last_shown?: Maybe<Scalars['timestamp']>;
  estimated_impressions?: Maybe<Scalars['String']>;
  /** An object relationship */
  full_url?: Maybe<Full_Urls>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  image_content_urls?: Maybe<Array<Scalars['String']>>;
  /** An object relationship */
  platform_subtype: Platform_Subtypes;
  platform_subtype_id: Scalars['uuid'];
  raw_payload?: Maybe<Scalars['String']>;
  screenshot_url?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  text_content?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  video_content_urls?: Maybe<Array<Scalars['String']>>;
};

/** aggregated selection of "advertisement_data" */
export type Advertisement_Data_Aggregate = {
  __typename?: 'advertisement_data_aggregate';
  aggregate?: Maybe<Advertisement_Data_Aggregate_Fields>;
  nodes: Array<Advertisement_Data>;
};

/** aggregate fields of "advertisement_data" */
export type Advertisement_Data_Aggregate_Fields = {
  __typename?: 'advertisement_data_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Advertisement_Data_Max_Fields>;
  min?: Maybe<Advertisement_Data_Min_Fields>;
};


/** aggregate fields of "advertisement_data" */
export type Advertisement_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advertisement_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "advertisement_data". All fields are combined with a logical 'AND'. */
export type Advertisement_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Advertisement_Data_Bool_Exp>>;
  _not?: InputMaybe<Advertisement_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Advertisement_Data_Bool_Exp>>;
  ad_detail_html_url?: InputMaybe<String_Comparison_Exp>;
  ad_detail_link?: InputMaybe<String_Comparison_Exp>;
  advertiser_data?: InputMaybe<Advertiser_Data_Bool_Exp>;
  advertiser_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  date_first_shown?: InputMaybe<Timestamp_Comparison_Exp>;
  date_last_shown?: InputMaybe<Timestamp_Comparison_Exp>;
  estimated_impressions?: InputMaybe<String_Comparison_Exp>;
  full_url?: InputMaybe<Full_Urls_Bool_Exp>;
  full_url_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_content_urls?: InputMaybe<String_Array_Comparison_Exp>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Bool_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  raw_payload?: InputMaybe<String_Comparison_Exp>;
  screenshot_url?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  text_content?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  video_content_urls?: InputMaybe<String_Array_Comparison_Exp>;
};

/** unique or primary key constraints on table "advertisement_data" */
export enum Advertisement_Data_Constraint {
  /** unique or primary key constraint on columns "ad_detail_link" */
  AdvertisementDataAdDetailLinkKey = 'advertisement_data_ad_detail_link_key',
  /** unique or primary key constraint on columns "id" */
  AdvertisementDataPkey = 'advertisement_data_pkey'
}

/** input type for inserting data into table "advertisement_data" */
export type Advertisement_Data_Insert_Input = {
  ad_detail_html_url?: InputMaybe<Scalars['String']>;
  ad_detail_link?: InputMaybe<Scalars['String']>;
  advertiser_data?: InputMaybe<Advertiser_Data_Obj_Rel_Insert_Input>;
  advertiser_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  date_first_shown?: InputMaybe<Scalars['timestamp']>;
  date_last_shown?: InputMaybe<Scalars['timestamp']>;
  estimated_impressions?: InputMaybe<Scalars['String']>;
  full_url?: InputMaybe<Full_Urls_Obj_Rel_Insert_Input>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_content_urls?: InputMaybe<Array<Scalars['String']>>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Obj_Rel_Insert_Input>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  raw_payload?: InputMaybe<Scalars['String']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  text_content?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  video_content_urls?: InputMaybe<Array<Scalars['String']>>;
};

/** aggregate max on columns */
export type Advertisement_Data_Max_Fields = {
  __typename?: 'advertisement_data_max_fields';
  ad_detail_html_url?: Maybe<Scalars['String']>;
  ad_detail_link?: Maybe<Scalars['String']>;
  advertiser_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  date_first_shown?: Maybe<Scalars['timestamp']>;
  date_last_shown?: Maybe<Scalars['timestamp']>;
  estimated_impressions?: Maybe<Scalars['String']>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  image_content_urls?: Maybe<Array<Scalars['String']>>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  raw_payload?: Maybe<Scalars['String']>;
  screenshot_url?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  text_content?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  video_content_urls?: Maybe<Array<Scalars['String']>>;
};

/** aggregate min on columns */
export type Advertisement_Data_Min_Fields = {
  __typename?: 'advertisement_data_min_fields';
  ad_detail_html_url?: Maybe<Scalars['String']>;
  ad_detail_link?: Maybe<Scalars['String']>;
  advertiser_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  date_first_shown?: Maybe<Scalars['timestamp']>;
  date_last_shown?: Maybe<Scalars['timestamp']>;
  estimated_impressions?: Maybe<Scalars['String']>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  image_content_urls?: Maybe<Array<Scalars['String']>>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  raw_payload?: Maybe<Scalars['String']>;
  screenshot_url?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  text_content?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  video_content_urls?: Maybe<Array<Scalars['String']>>;
};

/** response of any mutation on the table "advertisement_data" */
export type Advertisement_Data_Mutation_Response = {
  __typename?: 'advertisement_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Advertisement_Data>;
};

/** input type for inserting object relation for remote table "advertisement_data" */
export type Advertisement_Data_Obj_Rel_Insert_Input = {
  data: Advertisement_Data_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Advertisement_Data_On_Conflict>;
};

/** on_conflict condition type for table "advertisement_data" */
export type Advertisement_Data_On_Conflict = {
  constraint: Advertisement_Data_Constraint;
  update_columns?: Array<Advertisement_Data_Update_Column>;
  where?: InputMaybe<Advertisement_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "advertisement_data". */
export type Advertisement_Data_Order_By = {
  ad_detail_html_url?: InputMaybe<Order_By>;
  ad_detail_link?: InputMaybe<Order_By>;
  advertiser_data?: InputMaybe<Advertiser_Data_Order_By>;
  advertiser_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date_first_shown?: InputMaybe<Order_By>;
  date_last_shown?: InputMaybe<Order_By>;
  estimated_impressions?: InputMaybe<Order_By>;
  full_url?: InputMaybe<Full_Urls_Order_By>;
  full_url_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_content_urls?: InputMaybe<Order_By>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  raw_payload?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  text_content?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_content_urls?: InputMaybe<Order_By>;
};

/** primary key columns input for table: advertisement_data */
export type Advertisement_Data_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "advertisement_data" */
export enum Advertisement_Data_Select_Column {
  /** column name */
  AdDetailHtmlUrl = 'ad_detail_html_url',
  /** column name */
  AdDetailLink = 'ad_detail_link',
  /** column name */
  AdvertiserId = 'advertiser_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateFirstShown = 'date_first_shown',
  /** column name */
  DateLastShown = 'date_last_shown',
  /** column name */
  EstimatedImpressions = 'estimated_impressions',
  /** column name */
  FullUrlId = 'full_url_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageContentUrls = 'image_content_urls',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  RawPayload = 'raw_payload',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  Source = 'source',
  /** column name */
  TextContent = 'text_content',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VideoContentUrls = 'video_content_urls'
}

/** input type for updating data in table "advertisement_data" */
export type Advertisement_Data_Set_Input = {
  ad_detail_html_url?: InputMaybe<Scalars['String']>;
  ad_detail_link?: InputMaybe<Scalars['String']>;
  advertiser_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  date_first_shown?: InputMaybe<Scalars['timestamp']>;
  date_last_shown?: InputMaybe<Scalars['timestamp']>;
  estimated_impressions?: InputMaybe<Scalars['String']>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_content_urls?: InputMaybe<Array<Scalars['String']>>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  raw_payload?: InputMaybe<Scalars['String']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  text_content?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  video_content_urls?: InputMaybe<Array<Scalars['String']>>;
};

/** Streaming cursor of the table "advertisement_data" */
export type Advertisement_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advertisement_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advertisement_Data_Stream_Cursor_Value_Input = {
  ad_detail_html_url?: InputMaybe<Scalars['String']>;
  ad_detail_link?: InputMaybe<Scalars['String']>;
  advertiser_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  date_first_shown?: InputMaybe<Scalars['timestamp']>;
  date_last_shown?: InputMaybe<Scalars['timestamp']>;
  estimated_impressions?: InputMaybe<Scalars['String']>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_content_urls?: InputMaybe<Array<Scalars['String']>>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  raw_payload?: InputMaybe<Scalars['String']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  text_content?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  video_content_urls?: InputMaybe<Array<Scalars['String']>>;
};

/** update columns of table "advertisement_data" */
export enum Advertisement_Data_Update_Column {
  /** column name */
  AdDetailHtmlUrl = 'ad_detail_html_url',
  /** column name */
  AdDetailLink = 'ad_detail_link',
  /** column name */
  AdvertiserId = 'advertiser_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateFirstShown = 'date_first_shown',
  /** column name */
  DateLastShown = 'date_last_shown',
  /** column name */
  EstimatedImpressions = 'estimated_impressions',
  /** column name */
  FullUrlId = 'full_url_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageContentUrls = 'image_content_urls',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  RawPayload = 'raw_payload',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  Source = 'source',
  /** column name */
  TextContent = 'text_content',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VideoContentUrls = 'video_content_urls'
}

export type Advertisement_Data_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Advertisement_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Advertisement_Data_Bool_Exp;
};

/** columns and relationships of "advertiser_data" */
export type Advertiser_Data = {
  __typename?: 'advertiser_data';
  advertiser_ads_link: Scalars['String'];
  advertiser_profile_link: Scalars['String'];
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  is_verified?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  num_ads?: Maybe<Scalars['Int']>;
  /** An object relationship */
  platform_subtype: Platform_Subtypes;
  platform_subtype_id: Scalars['uuid'];
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "advertiser_data" */
export type Advertiser_Data_Aggregate = {
  __typename?: 'advertiser_data_aggregate';
  aggregate?: Maybe<Advertiser_Data_Aggregate_Fields>;
  nodes: Array<Advertiser_Data>;
};

/** aggregate fields of "advertiser_data" */
export type Advertiser_Data_Aggregate_Fields = {
  __typename?: 'advertiser_data_aggregate_fields';
  avg?: Maybe<Advertiser_Data_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Advertiser_Data_Max_Fields>;
  min?: Maybe<Advertiser_Data_Min_Fields>;
  stddev?: Maybe<Advertiser_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Advertiser_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Advertiser_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Advertiser_Data_Sum_Fields>;
  var_pop?: Maybe<Advertiser_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Advertiser_Data_Var_Samp_Fields>;
  variance?: Maybe<Advertiser_Data_Variance_Fields>;
};


/** aggregate fields of "advertiser_data" */
export type Advertiser_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Advertiser_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Advertiser_Data_Avg_Fields = {
  __typename?: 'advertiser_data_avg_fields';
  num_ads?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "advertiser_data". All fields are combined with a logical 'AND'. */
export type Advertiser_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Advertiser_Data_Bool_Exp>>;
  _not?: InputMaybe<Advertiser_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Advertiser_Data_Bool_Exp>>;
  advertiser_ads_link?: InputMaybe<String_Comparison_Exp>;
  advertiser_profile_link?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  num_ads?: InputMaybe<Int_Comparison_Exp>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Bool_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "advertiser_data" */
export enum Advertiser_Data_Constraint {
  /** unique or primary key constraint on columns "advertiser_profile_link" */
  AdvertiserDataAdvertiserProfileLinkKey = 'advertiser_data_advertiser_profile_link_key',
  /** unique or primary key constraint on columns "id" */
  AdvertiserDataPkey = 'advertiser_data_pkey'
}

/** input type for incrementing numeric columns in table "advertiser_data" */
export type Advertiser_Data_Inc_Input = {
  num_ads?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "advertiser_data" */
export type Advertiser_Data_Insert_Input = {
  advertiser_ads_link?: InputMaybe<Scalars['String']>;
  advertiser_profile_link?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  num_ads?: InputMaybe<Scalars['Int']>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Obj_Rel_Insert_Input>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Advertiser_Data_Max_Fields = {
  __typename?: 'advertiser_data_max_fields';
  advertiser_ads_link?: Maybe<Scalars['String']>;
  advertiser_profile_link?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  num_ads?: Maybe<Scalars['Int']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Advertiser_Data_Min_Fields = {
  __typename?: 'advertiser_data_min_fields';
  advertiser_ads_link?: Maybe<Scalars['String']>;
  advertiser_profile_link?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  num_ads?: Maybe<Scalars['Int']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "advertiser_data" */
export type Advertiser_Data_Mutation_Response = {
  __typename?: 'advertiser_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Advertiser_Data>;
};

/** input type for inserting object relation for remote table "advertiser_data" */
export type Advertiser_Data_Obj_Rel_Insert_Input = {
  data: Advertiser_Data_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Advertiser_Data_On_Conflict>;
};

/** on_conflict condition type for table "advertiser_data" */
export type Advertiser_Data_On_Conflict = {
  constraint: Advertiser_Data_Constraint;
  update_columns?: Array<Advertiser_Data_Update_Column>;
  where?: InputMaybe<Advertiser_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "advertiser_data". */
export type Advertiser_Data_Order_By = {
  advertiser_ads_link?: InputMaybe<Order_By>;
  advertiser_profile_link?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  num_ads?: InputMaybe<Order_By>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: advertiser_data */
export type Advertiser_Data_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "advertiser_data" */
export enum Advertiser_Data_Select_Column {
  /** column name */
  AdvertiserAdsLink = 'advertiser_ads_link',
  /** column name */
  AdvertiserProfileLink = 'advertiser_profile_link',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  NumAds = 'num_ads',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "advertiser_data" */
export type Advertiser_Data_Set_Input = {
  advertiser_ads_link?: InputMaybe<Scalars['String']>;
  advertiser_profile_link?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  num_ads?: InputMaybe<Scalars['Int']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Advertiser_Data_Stddev_Fields = {
  __typename?: 'advertiser_data_stddev_fields';
  num_ads?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Advertiser_Data_Stddev_Pop_Fields = {
  __typename?: 'advertiser_data_stddev_pop_fields';
  num_ads?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Advertiser_Data_Stddev_Samp_Fields = {
  __typename?: 'advertiser_data_stddev_samp_fields';
  num_ads?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "advertiser_data" */
export type Advertiser_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Advertiser_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Advertiser_Data_Stream_Cursor_Value_Input = {
  advertiser_ads_link?: InputMaybe<Scalars['String']>;
  advertiser_profile_link?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  num_ads?: InputMaybe<Scalars['Int']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Advertiser_Data_Sum_Fields = {
  __typename?: 'advertiser_data_sum_fields';
  num_ads?: Maybe<Scalars['Int']>;
};

/** update columns of table "advertiser_data" */
export enum Advertiser_Data_Update_Column {
  /** column name */
  AdvertiserAdsLink = 'advertiser_ads_link',
  /** column name */
  AdvertiserProfileLink = 'advertiser_profile_link',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  NumAds = 'num_ads',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Advertiser_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Advertiser_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Advertiser_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Advertiser_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Advertiser_Data_Var_Pop_Fields = {
  __typename?: 'advertiser_data_var_pop_fields';
  num_ads?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Advertiser_Data_Var_Samp_Fields = {
  __typename?: 'advertiser_data_var_samp_fields';
  num_ads?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Advertiser_Data_Variance_Fields = {
  __typename?: 'advertiser_data_variance_fields';
  num_ads?: Maybe<Scalars['Float']>;
};

/** promtps for using gpt and other llms */
export type Ai_Prompts = {
  __typename?: 'ai_prompts';
  created_at?: Maybe<Scalars['timestamp']>;
  id: Scalars['uuid'];
  metadata?: Maybe<Scalars['jsonb']>;
  org_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  platform?: Maybe<Scalars['String']>;
  prompt: Scalars['String'];
  role?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
};


/** promtps for using gpt and other llms */
export type Ai_PromptsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ai_prompts" */
export type Ai_Prompts_Aggregate = {
  __typename?: 'ai_prompts_aggregate';
  aggregate?: Maybe<Ai_Prompts_Aggregate_Fields>;
  nodes: Array<Ai_Prompts>;
};

/** aggregate fields of "ai_prompts" */
export type Ai_Prompts_Aggregate_Fields = {
  __typename?: 'ai_prompts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ai_Prompts_Max_Fields>;
  min?: Maybe<Ai_Prompts_Min_Fields>;
};


/** aggregate fields of "ai_prompts" */
export type Ai_Prompts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ai_Prompts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ai_Prompts_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "ai_prompts". All fields are combined with a logical 'AND'. */
export type Ai_Prompts_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Prompts_Bool_Exp>>;
  _not?: InputMaybe<Ai_Prompts_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Prompts_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  prompt?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "ai_prompts" */
export enum Ai_Prompts_Constraint {
  /** unique or primary key constraint on columns "id" */
  AiPromptsPkey = 'ai_prompts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ai_Prompts_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ai_Prompts_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ai_Prompts_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "ai_prompts" */
export type Ai_Prompts_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  platform?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Ai_Prompts_Max_Fields = {
  __typename?: 'ai_prompts_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  prompt?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Ai_Prompts_Min_Fields = {
  __typename?: 'ai_prompts_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  prompt?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "ai_prompts" */
export type Ai_Prompts_Mutation_Response = {
  __typename?: 'ai_prompts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ai_Prompts>;
};

/** on_conflict condition type for table "ai_prompts" */
export type Ai_Prompts_On_Conflict = {
  constraint: Ai_Prompts_Constraint;
  update_columns?: Array<Ai_Prompts_Update_Column>;
  where?: InputMaybe<Ai_Prompts_Bool_Exp>;
};

/** Ordering options when selecting data from "ai_prompts". */
export type Ai_Prompts_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  platform?: InputMaybe<Order_By>;
  prompt?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: ai_prompts */
export type Ai_Prompts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ai_Prompts_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ai_prompts" */
export enum Ai_Prompts_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Prompt = 'prompt',
  /** column name */
  Role = 'role',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "ai_prompts" */
export type Ai_Prompts_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "ai_prompts" */
export type Ai_Prompts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ai_Prompts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ai_Prompts_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "ai_prompts" */
export enum Ai_Prompts_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Prompt = 'prompt',
  /** column name */
  Role = 'role',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Ai_Prompts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ai_Prompts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ai_Prompts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ai_Prompts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ai_Prompts_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ai_Prompts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ai_Prompts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ai_Prompts_Bool_Exp;
};

/** Recorded ai responses to measure for accuracy */
export type Ai_Responses = {
  __typename?: 'ai_responses';
  downvotes: Scalars['Int'];
  generated_response: Scalars['jsonb'];
  id: Scalars['uuid'];
  prompt_type: Scalars['String'];
  real_action?: Maybe<Scalars['String']>;
  /** An object relationship */
  report?: Maybe<Spoofing_Reports>;
  report_id?: Maybe<Scalars['uuid']>;
  upvotes: Scalars['Int'];
};


/** Recorded ai responses to measure for accuracy */
export type Ai_ResponsesGenerated_ResponseArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ai_responses" */
export type Ai_Responses_Aggregate = {
  __typename?: 'ai_responses_aggregate';
  aggregate?: Maybe<Ai_Responses_Aggregate_Fields>;
  nodes: Array<Ai_Responses>;
};

/** aggregate fields of "ai_responses" */
export type Ai_Responses_Aggregate_Fields = {
  __typename?: 'ai_responses_aggregate_fields';
  avg?: Maybe<Ai_Responses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ai_Responses_Max_Fields>;
  min?: Maybe<Ai_Responses_Min_Fields>;
  stddev?: Maybe<Ai_Responses_Stddev_Fields>;
  stddev_pop?: Maybe<Ai_Responses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ai_Responses_Stddev_Samp_Fields>;
  sum?: Maybe<Ai_Responses_Sum_Fields>;
  var_pop?: Maybe<Ai_Responses_Var_Pop_Fields>;
  var_samp?: Maybe<Ai_Responses_Var_Samp_Fields>;
  variance?: Maybe<Ai_Responses_Variance_Fields>;
};


/** aggregate fields of "ai_responses" */
export type Ai_Responses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ai_Responses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ai_Responses_Append_Input = {
  generated_response?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Ai_Responses_Avg_Fields = {
  __typename?: 'ai_responses_avg_fields';
  downvotes?: Maybe<Scalars['Float']>;
  upvotes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ai_responses". All fields are combined with a logical 'AND'. */
export type Ai_Responses_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Responses_Bool_Exp>>;
  _not?: InputMaybe<Ai_Responses_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Responses_Bool_Exp>>;
  downvotes?: InputMaybe<Int_Comparison_Exp>;
  generated_response?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  prompt_type?: InputMaybe<String_Comparison_Exp>;
  real_action?: InputMaybe<String_Comparison_Exp>;
  report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  report_id?: InputMaybe<Uuid_Comparison_Exp>;
  upvotes?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "ai_responses" */
export enum Ai_Responses_Constraint {
  /** unique or primary key constraint on columns "id" */
  AiResponsesPkey = 'ai_responses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ai_Responses_Delete_At_Path_Input = {
  generated_response?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ai_Responses_Delete_Elem_Input = {
  generated_response?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ai_Responses_Delete_Key_Input = {
  generated_response?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "ai_responses" */
export type Ai_Responses_Inc_Input = {
  downvotes?: InputMaybe<Scalars['Int']>;
  upvotes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ai_responses" */
export type Ai_Responses_Insert_Input = {
  downvotes?: InputMaybe<Scalars['Int']>;
  generated_response?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  prompt_type?: InputMaybe<Scalars['String']>;
  real_action?: InputMaybe<Scalars['String']>;
  report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  report_id?: InputMaybe<Scalars['uuid']>;
  upvotes?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Ai_Responses_Max_Fields = {
  __typename?: 'ai_responses_max_fields';
  downvotes?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  prompt_type?: Maybe<Scalars['String']>;
  real_action?: Maybe<Scalars['String']>;
  report_id?: Maybe<Scalars['uuid']>;
  upvotes?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Ai_Responses_Min_Fields = {
  __typename?: 'ai_responses_min_fields';
  downvotes?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  prompt_type?: Maybe<Scalars['String']>;
  real_action?: Maybe<Scalars['String']>;
  report_id?: Maybe<Scalars['uuid']>;
  upvotes?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "ai_responses" */
export type Ai_Responses_Mutation_Response = {
  __typename?: 'ai_responses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ai_Responses>;
};

/** on_conflict condition type for table "ai_responses" */
export type Ai_Responses_On_Conflict = {
  constraint: Ai_Responses_Constraint;
  update_columns?: Array<Ai_Responses_Update_Column>;
  where?: InputMaybe<Ai_Responses_Bool_Exp>;
};

/** Ordering options when selecting data from "ai_responses". */
export type Ai_Responses_Order_By = {
  downvotes?: InputMaybe<Order_By>;
  generated_response?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  prompt_type?: InputMaybe<Order_By>;
  real_action?: InputMaybe<Order_By>;
  report?: InputMaybe<Spoofing_Reports_Order_By>;
  report_id?: InputMaybe<Order_By>;
  upvotes?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ai_responses */
export type Ai_Responses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ai_Responses_Prepend_Input = {
  generated_response?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ai_responses" */
export enum Ai_Responses_Select_Column {
  /** column name */
  Downvotes = 'downvotes',
  /** column name */
  GeneratedResponse = 'generated_response',
  /** column name */
  Id = 'id',
  /** column name */
  PromptType = 'prompt_type',
  /** column name */
  RealAction = 'real_action',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  Upvotes = 'upvotes'
}

/** input type for updating data in table "ai_responses" */
export type Ai_Responses_Set_Input = {
  downvotes?: InputMaybe<Scalars['Int']>;
  generated_response?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  prompt_type?: InputMaybe<Scalars['String']>;
  real_action?: InputMaybe<Scalars['String']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  upvotes?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Ai_Responses_Stddev_Fields = {
  __typename?: 'ai_responses_stddev_fields';
  downvotes?: Maybe<Scalars['Float']>;
  upvotes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ai_Responses_Stddev_Pop_Fields = {
  __typename?: 'ai_responses_stddev_pop_fields';
  downvotes?: Maybe<Scalars['Float']>;
  upvotes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ai_Responses_Stddev_Samp_Fields = {
  __typename?: 'ai_responses_stddev_samp_fields';
  downvotes?: Maybe<Scalars['Float']>;
  upvotes?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ai_responses" */
export type Ai_Responses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ai_Responses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ai_Responses_Stream_Cursor_Value_Input = {
  downvotes?: InputMaybe<Scalars['Int']>;
  generated_response?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  prompt_type?: InputMaybe<Scalars['String']>;
  real_action?: InputMaybe<Scalars['String']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  upvotes?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Ai_Responses_Sum_Fields = {
  __typename?: 'ai_responses_sum_fields';
  downvotes?: Maybe<Scalars['Int']>;
  upvotes?: Maybe<Scalars['Int']>;
};

/** update columns of table "ai_responses" */
export enum Ai_Responses_Update_Column {
  /** column name */
  Downvotes = 'downvotes',
  /** column name */
  GeneratedResponse = 'generated_response',
  /** column name */
  Id = 'id',
  /** column name */
  PromptType = 'prompt_type',
  /** column name */
  RealAction = 'real_action',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  Upvotes = 'upvotes'
}

export type Ai_Responses_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ai_Responses_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ai_Responses_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ai_Responses_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ai_Responses_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ai_Responses_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ai_Responses_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ai_Responses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ai_Responses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ai_Responses_Var_Pop_Fields = {
  __typename?: 'ai_responses_var_pop_fields';
  downvotes?: Maybe<Scalars['Float']>;
  upvotes?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ai_Responses_Var_Samp_Fields = {
  __typename?: 'ai_responses_var_samp_fields';
  downvotes?: Maybe<Scalars['Float']>;
  upvotes?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ai_Responses_Variance_Fields = {
  __typename?: 'ai_responses_variance_fields';
  downvotes?: Maybe<Scalars['Float']>;
  upvotes?: Maybe<Scalars['Float']>;
};

/** Stores hashes for various resource types corresponding to specific alerts in our system */
export type Alert_Hashes = {
  __typename?: 'alert_hashes';
  alert_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  hash: Scalars['String'];
  hashing_method: Scalars['String'];
  id: Scalars['uuid'];
  resource_type: Scalars['String'];
  resource_url?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "alert_hashes" */
export type Alert_Hashes_Aggregate = {
  __typename?: 'alert_hashes_aggregate';
  aggregate?: Maybe<Alert_Hashes_Aggregate_Fields>;
  nodes: Array<Alert_Hashes>;
};

/** aggregate fields of "alert_hashes" */
export type Alert_Hashes_Aggregate_Fields = {
  __typename?: 'alert_hashes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Alert_Hashes_Max_Fields>;
  min?: Maybe<Alert_Hashes_Min_Fields>;
};


/** aggregate fields of "alert_hashes" */
export type Alert_Hashes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Alert_Hashes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "alert_hashes". All fields are combined with a logical 'AND'. */
export type Alert_Hashes_Bool_Exp = {
  _and?: InputMaybe<Array<Alert_Hashes_Bool_Exp>>;
  _not?: InputMaybe<Alert_Hashes_Bool_Exp>;
  _or?: InputMaybe<Array<Alert_Hashes_Bool_Exp>>;
  alert_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hash?: InputMaybe<String_Comparison_Exp>;
  hashing_method?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  resource_type?: InputMaybe<String_Comparison_Exp>;
  resource_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "alert_hashes" */
export enum Alert_Hashes_Constraint {
  /** unique or primary key constraint on columns "hashing_method", "resource_type", "alert_id" */
  AlertHashesAlertIdResourceTypeHashingMethodKey = 'alert_hashes_alert_id_resource_type_hashing_method_key',
  /** unique or primary key constraint on columns "id" */
  AlertHashesPkey = 'alert_hashes_pkey'
}

/** input type for inserting data into table "alert_hashes" */
export type Alert_Hashes_Insert_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hash?: InputMaybe<Scalars['String']>;
  hashing_method?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_type?: InputMaybe<Scalars['String']>;
  resource_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Alert_Hashes_Max_Fields = {
  __typename?: 'alert_hashes_max_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  hashing_method?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  resource_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Alert_Hashes_Min_Fields = {
  __typename?: 'alert_hashes_min_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  hashing_method?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  resource_type?: Maybe<Scalars['String']>;
  resource_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "alert_hashes" */
export type Alert_Hashes_Mutation_Response = {
  __typename?: 'alert_hashes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Alert_Hashes>;
};

/** on_conflict condition type for table "alert_hashes" */
export type Alert_Hashes_On_Conflict = {
  constraint: Alert_Hashes_Constraint;
  update_columns?: Array<Alert_Hashes_Update_Column>;
  where?: InputMaybe<Alert_Hashes_Bool_Exp>;
};

/** Ordering options when selecting data from "alert_hashes". */
export type Alert_Hashes_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  hashing_method?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource_type?: InputMaybe<Order_By>;
  resource_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: alert_hashes */
export type Alert_Hashes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "alert_hashes" */
export enum Alert_Hashes_Select_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Hash = 'hash',
  /** column name */
  HashingMethod = 'hashing_method',
  /** column name */
  Id = 'id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  ResourceUrl = 'resource_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "alert_hashes" */
export type Alert_Hashes_Set_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hash?: InputMaybe<Scalars['String']>;
  hashing_method?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_type?: InputMaybe<Scalars['String']>;
  resource_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "alert_hashes" */
export type Alert_Hashes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Alert_Hashes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Alert_Hashes_Stream_Cursor_Value_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  hash?: InputMaybe<Scalars['String']>;
  hashing_method?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource_type?: InputMaybe<Scalars['String']>;
  resource_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "alert_hashes" */
export enum Alert_Hashes_Update_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Hash = 'hash',
  /** column name */
  HashingMethod = 'hashing_method',
  /** column name */
  Id = 'id',
  /** column name */
  ResourceType = 'resource_type',
  /** column name */
  ResourceUrl = 'resource_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Alert_Hashes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Alert_Hashes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Alert_Hashes_Bool_Exp;
};

/** Records one row per labelling action */
export type Alert_Label_Events = {
  __typename?: 'alert_label_events';
  alert_id: Scalars['uuid'];
  id: Scalars['uuid'];
  label_notes?: Maybe<Scalars['String']>;
  label_type: Scalars['String'];
  label_value: Scalars['String'];
  labeled_at: Scalars['timestamptz'];
  match_id: Scalars['uuid'];
  /** An object relationship */
  spoof_match: Spoof_Matches;
  /** An object relationship */
  spoofing_report: Spoofing_Reports;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "alert_label_events" */
export type Alert_Label_Events_Aggregate = {
  __typename?: 'alert_label_events_aggregate';
  aggregate?: Maybe<Alert_Label_Events_Aggregate_Fields>;
  nodes: Array<Alert_Label_Events>;
};

/** aggregate fields of "alert_label_events" */
export type Alert_Label_Events_Aggregate_Fields = {
  __typename?: 'alert_label_events_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Alert_Label_Events_Max_Fields>;
  min?: Maybe<Alert_Label_Events_Min_Fields>;
};


/** aggregate fields of "alert_label_events" */
export type Alert_Label_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Alert_Label_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "alert_label_events". All fields are combined with a logical 'AND'. */
export type Alert_Label_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Alert_Label_Events_Bool_Exp>>;
  _not?: InputMaybe<Alert_Label_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Alert_Label_Events_Bool_Exp>>;
  alert_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label_notes?: InputMaybe<String_Comparison_Exp>;
  label_type?: InputMaybe<String_Comparison_Exp>;
  label_value?: InputMaybe<String_Comparison_Exp>;
  labeled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  match_id?: InputMaybe<Uuid_Comparison_Exp>;
  spoof_match?: InputMaybe<Spoof_Matches_Bool_Exp>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "alert_label_events" */
export enum Alert_Label_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  AlertLabelEventsPkey = 'alert_label_events_pkey'
}

/** input type for inserting data into table "alert_label_events" */
export type Alert_Label_Events_Insert_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  label_notes?: InputMaybe<Scalars['String']>;
  label_type?: InputMaybe<Scalars['String']>;
  label_value?: InputMaybe<Scalars['String']>;
  labeled_at?: InputMaybe<Scalars['timestamptz']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  spoof_match?: InputMaybe<Spoof_Matches_Obj_Rel_Insert_Input>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Alert_Label_Events_Max_Fields = {
  __typename?: 'alert_label_events_max_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  label_notes?: Maybe<Scalars['String']>;
  label_type?: Maybe<Scalars['String']>;
  label_value?: Maybe<Scalars['String']>;
  labeled_at?: Maybe<Scalars['timestamptz']>;
  match_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Alert_Label_Events_Min_Fields = {
  __typename?: 'alert_label_events_min_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  label_notes?: Maybe<Scalars['String']>;
  label_type?: Maybe<Scalars['String']>;
  label_value?: Maybe<Scalars['String']>;
  labeled_at?: Maybe<Scalars['timestamptz']>;
  match_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "alert_label_events" */
export type Alert_Label_Events_Mutation_Response = {
  __typename?: 'alert_label_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Alert_Label_Events>;
};

/** on_conflict condition type for table "alert_label_events" */
export type Alert_Label_Events_On_Conflict = {
  constraint: Alert_Label_Events_Constraint;
  update_columns?: Array<Alert_Label_Events_Update_Column>;
  where?: InputMaybe<Alert_Label_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "alert_label_events". */
export type Alert_Label_Events_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_notes?: InputMaybe<Order_By>;
  label_type?: InputMaybe<Order_By>;
  label_value?: InputMaybe<Order_By>;
  labeled_at?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  spoof_match?: InputMaybe<Spoof_Matches_Order_By>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: alert_label_events */
export type Alert_Label_Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "alert_label_events" */
export enum Alert_Label_Events_Select_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  Id = 'id',
  /** column name */
  LabelNotes = 'label_notes',
  /** column name */
  LabelType = 'label_type',
  /** column name */
  LabelValue = 'label_value',
  /** column name */
  LabeledAt = 'labeled_at',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "alert_label_events" */
export type Alert_Label_Events_Set_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  label_notes?: InputMaybe<Scalars['String']>;
  label_type?: InputMaybe<Scalars['String']>;
  label_value?: InputMaybe<Scalars['String']>;
  labeled_at?: InputMaybe<Scalars['timestamptz']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "alert_label_events" */
export type Alert_Label_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Alert_Label_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Alert_Label_Events_Stream_Cursor_Value_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  label_notes?: InputMaybe<Scalars['String']>;
  label_type?: InputMaybe<Scalars['String']>;
  label_value?: InputMaybe<Scalars['String']>;
  labeled_at?: InputMaybe<Scalars['timestamptz']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "alert_label_events" */
export enum Alert_Label_Events_Update_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  Id = 'id',
  /** column name */
  LabelNotes = 'label_notes',
  /** column name */
  LabelType = 'label_type',
  /** column name */
  LabelValue = 'label_value',
  /** column name */
  LabeledAt = 'labeled_at',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  UserId = 'user_id'
}

export type Alert_Label_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Alert_Label_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Alert_Label_Events_Bool_Exp;
};

/** columns and relationships of "alert_links" */
export type Alert_Links = {
  __typename?: 'alert_links';
  /** An object relationship */
  alert_1: Spoofing_Reports;
  /** An object relationship */
  alert_2: Spoofing_Reports;
  alert_id_1: Scalars['uuid'];
  alert_id_2: Scalars['uuid'];
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  relationship: Scalars['String'];
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
};

/** aggregated selection of "alert_links" */
export type Alert_Links_Aggregate = {
  __typename?: 'alert_links_aggregate';
  aggregate?: Maybe<Alert_Links_Aggregate_Fields>;
  nodes: Array<Alert_Links>;
};

export type Alert_Links_Aggregate_Bool_Exp = {
  count?: InputMaybe<Alert_Links_Aggregate_Bool_Exp_Count>;
};

export type Alert_Links_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Alert_Links_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Alert_Links_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "alert_links" */
export type Alert_Links_Aggregate_Fields = {
  __typename?: 'alert_links_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Alert_Links_Max_Fields>;
  min?: Maybe<Alert_Links_Min_Fields>;
};


/** aggregate fields of "alert_links" */
export type Alert_Links_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Alert_Links_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "alert_links" */
export type Alert_Links_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Alert_Links_Max_Order_By>;
  min?: InputMaybe<Alert_Links_Min_Order_By>;
};

/** input type for inserting array relation for remote table "alert_links" */
export type Alert_Links_Arr_Rel_Insert_Input = {
  data: Array<Alert_Links_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Alert_Links_On_Conflict>;
};

/** Boolean expression to filter rows from the table "alert_links". All fields are combined with a logical 'AND'. */
export type Alert_Links_Bool_Exp = {
  _and?: InputMaybe<Array<Alert_Links_Bool_Exp>>;
  _not?: InputMaybe<Alert_Links_Bool_Exp>;
  _or?: InputMaybe<Array<Alert_Links_Bool_Exp>>;
  alert_1?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  alert_2?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  alert_id_1?: InputMaybe<Uuid_Comparison_Exp>;
  alert_id_2?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  relationship?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "alert_links" */
export enum Alert_Links_Constraint {
  /** unique or primary key constraint on columns "id" */
  AlertLinksPkey = 'alert_links_pkey'
}

/** input type for inserting data into table "alert_links" */
export type Alert_Links_Insert_Input = {
  alert_1?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  alert_2?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  alert_id_1?: InputMaybe<Scalars['uuid']>;
  alert_id_2?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  relationship?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Alert_Links_Max_Fields = {
  __typename?: 'alert_links_max_fields';
  alert_id_1?: Maybe<Scalars['uuid']>;
  alert_id_2?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  relationship?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "alert_links" */
export type Alert_Links_Max_Order_By = {
  alert_id_1?: InputMaybe<Order_By>;
  alert_id_2?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  relationship?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Alert_Links_Min_Fields = {
  __typename?: 'alert_links_min_fields';
  alert_id_1?: Maybe<Scalars['uuid']>;
  alert_id_2?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  relationship?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "alert_links" */
export type Alert_Links_Min_Order_By = {
  alert_id_1?: InputMaybe<Order_By>;
  alert_id_2?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  relationship?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "alert_links" */
export type Alert_Links_Mutation_Response = {
  __typename?: 'alert_links_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Alert_Links>;
};

/** on_conflict condition type for table "alert_links" */
export type Alert_Links_On_Conflict = {
  constraint: Alert_Links_Constraint;
  update_columns?: Array<Alert_Links_Update_Column>;
  where?: InputMaybe<Alert_Links_Bool_Exp>;
};

/** Ordering options when selecting data from "alert_links". */
export type Alert_Links_Order_By = {
  alert_1?: InputMaybe<Spoofing_Reports_Order_By>;
  alert_2?: InputMaybe<Spoofing_Reports_Order_By>;
  alert_id_1?: InputMaybe<Order_By>;
  alert_id_2?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  relationship?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: alert_links */
export type Alert_Links_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "alert_links" */
export enum Alert_Links_Select_Column {
  /** column name */
  AlertId_1 = 'alert_id_1',
  /** column name */
  AlertId_2 = 'alert_id_2',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Relationship = 'relationship',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "alert_links" */
export type Alert_Links_Set_Input = {
  alert_id_1?: InputMaybe<Scalars['uuid']>;
  alert_id_2?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  relationship?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "alert_links" */
export type Alert_Links_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Alert_Links_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Alert_Links_Stream_Cursor_Value_Input = {
  alert_id_1?: InputMaybe<Scalars['uuid']>;
  alert_id_2?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  relationship?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "alert_links" */
export enum Alert_Links_Update_Column {
  /** column name */
  AlertId_1 = 'alert_id_1',
  /** column name */
  AlertId_2 = 'alert_id_2',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Relationship = 'relationship',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Alert_Links_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Alert_Links_Set_Input>;
  /** filter the rows which have to be updated */
  where: Alert_Links_Bool_Exp;
};

export type Alerts_Queue_State_Count_By_Product = {
  __typename?: 'alerts_queue_state_count_by_product';
  alerts_count: Scalars['bigint'];
  product: Scalars['String'];
};

/** alerts_queue_state_count_by_productNative Query Arguments */
export type Alerts_Queue_State_Count_By_Product_Arguments = {
  limit_per_product: Scalars['bigint'];
  organization_id: Scalars['uuid'];
  queue_state: Scalars['String'];
};

/** Boolean expression to filter rows from the logical model for "alerts_queue_state_count_by_product". All fields are combined with a logical 'AND'. */
export type Alerts_Queue_State_Count_By_Product_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Alerts_Queue_State_Count_By_Product_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Alerts_Queue_State_Count_By_Product_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Alerts_Queue_State_Count_By_Product_Bool_Exp_Bool_Exp>>;
  alerts_count?: InputMaybe<Bigint_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
};

export enum Alerts_Queue_State_Count_By_Product_Enum_Name {
  /** column name */
  AlertsCount = 'alerts_count',
  /** column name */
  Product = 'product'
}

/** Ordering options when selecting data from "alerts_queue_state_count_by_product". */
export type Alerts_Queue_State_Count_By_Product_Order_By = {
  alerts_count?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
};

export type Alerts_Resolved_Top_Metrics = {
  __typename?: 'alerts_resolved_top_metrics';
  metric: Scalars['String'];
  total_alerts: Scalars['Int'];
};

/** alerts_resolved_top_metricsNative Query Arguments */
export type Alerts_Resolved_Top_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  metric_type: Scalars['String'];
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  product?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "alerts_resolved_top_metrics". All fields are combined with a logical 'AND'. */
export type Alerts_Resolved_Top_Metrics_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Alerts_Resolved_Top_Metrics_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Alerts_Resolved_Top_Metrics_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Alerts_Resolved_Top_Metrics_Bool_Exp_Bool_Exp>>;
  metric?: InputMaybe<String_Comparison_Exp>;
  total_alerts?: InputMaybe<Int_Comparison_Exp>;
};

export enum Alerts_Resolved_Top_Metrics_Enum_Name {
  /** column name */
  Metric = 'metric',
  /** column name */
  TotalAlerts = 'total_alerts'
}

/** Ordering options when selecting data from "alerts_resolved_top_metrics". */
export type Alerts_Resolved_Top_Metrics_Order_By = {
  metric?: InputMaybe<Order_By>;
  total_alerts?: InputMaybe<Order_By>;
};

export type Alerts_Resolved_Total_Metrics = {
  __typename?: 'alerts_resolved_total_metrics';
  alert_ids?: Maybe<Scalars['jsonb']>;
  total_metric?: Maybe<Scalars['Int']>;
};


export type Alerts_Resolved_Total_MetricsAlert_IdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** alerts_resolved_total_metricsNative Query Arguments */
export type Alerts_Resolved_Total_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  /** Tags not to include */
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  product?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "alerts_resolved_total_metrics". All fields are combined with a logical 'AND'. */
export type Alerts_Resolved_Total_Metrics_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Alerts_Resolved_Total_Metrics_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Alerts_Resolved_Total_Metrics_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Alerts_Resolved_Total_Metrics_Bool_Exp_Bool_Exp>>;
  alert_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  total_metric?: InputMaybe<Int_Comparison_Exp>;
};

export enum Alerts_Resolved_Total_Metrics_Enum_Name {
  /** column name */
  AlertIds = 'alert_ids',
  /** column name */
  TotalMetric = 'total_metric'
}

/** Ordering options when selecting data from "alerts_resolved_total_metrics". */
export type Alerts_Resolved_Total_Metrics_Order_By = {
  alert_ids?: InputMaybe<Order_By>;
  total_metric?: InputMaybe<Order_By>;
};

export type Alerts_Surfaced_Top_Metrics = {
  __typename?: 'alerts_surfaced_top_metrics';
  metric: Scalars['String'];
  total_alerts: Scalars['Int'];
};

/** alerts_surfaced_top_metricsNative Query Arguments */
export type Alerts_Surfaced_Top_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  metric_type: Scalars['String'];
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  product?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "alerts_surfaced_top_metrics". All fields are combined with a logical 'AND'. */
export type Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp>>;
  metric?: InputMaybe<String_Comparison_Exp>;
  total_alerts?: InputMaybe<Int_Comparison_Exp>;
};

export enum Alerts_Surfaced_Top_Metrics_Enum_Name {
  /** column name */
  Metric = 'metric',
  /** column name */
  TotalAlerts = 'total_alerts'
}

/** Ordering options when selecting data from "alerts_surfaced_top_metrics". */
export type Alerts_Surfaced_Top_Metrics_Order_By = {
  metric?: InputMaybe<Order_By>;
  total_alerts?: InputMaybe<Order_By>;
};

export type Alerts_Times_To_Actioned_By_Platform_Metrics = {
  __typename?: 'alerts_times_to_actioned_by_platform_metrics';
  median_metric: Scalars['float8'];
  platform: Scalars['String'];
};

/** alerts_times_to_actioned_by_platform_metricsNative Query Arguments */
export type Alerts_Times_To_Actioned_By_Platform_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  /** Tags not to include */
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  /** Specific platforms to obtain times for */
  platforms?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  /** uploader */
  uploader?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "alerts_times_to_actioned_by_platform_metrics". All fields are combined with a logical 'AND'. */
export type Alerts_Times_To_Actioned_By_Platform_Metrics_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Alerts_Times_To_Actioned_By_Platform_Metrics_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Alerts_Times_To_Actioned_By_Platform_Metrics_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Alerts_Times_To_Actioned_By_Platform_Metrics_Bool_Exp_Bool_Exp>>;
  median_metric?: InputMaybe<Float8_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
};

export enum Alerts_Times_To_Actioned_By_Platform_Metrics_Enum_Name {
  /** column name */
  MedianMetric = 'median_metric',
  /** column name */
  Platform = 'platform'
}

/** Ordering options when selecting data from "alerts_times_to_actioned_by_platform_metrics". */
export type Alerts_Times_To_Actioned_By_Platform_Metrics_Order_By = {
  median_metric?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
};

export type Alerts_Times_To_Actioned_Graph_Metrics = {
  __typename?: 'alerts_times_to_actioned_graph_metrics';
  metric: Scalars['float8'];
  product: Scalars['String'];
  time_bucket: Scalars['date'];
};

/** alerts_times_to_actioned_graph_metricsNative Query Arguments */
export type Alerts_Times_To_Actioned_Graph_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  metric_type: Scalars['String'];
  /** Tags to not include */
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  product?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "alerts_times_to_actioned_graph_metrics". All fields are combined with a logical 'AND'. */
export type Alerts_Times_To_Actioned_Graph_Metrics_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Alerts_Times_To_Actioned_Graph_Metrics_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Alerts_Times_To_Actioned_Graph_Metrics_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Alerts_Times_To_Actioned_Graph_Metrics_Bool_Exp_Bool_Exp>>;
  metric?: InputMaybe<Float8_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  time_bucket?: InputMaybe<Date_Comparison_Exp>;
};

export enum Alerts_Times_To_Actioned_Graph_Metrics_Enum_Name {
  /** column name */
  Metric = 'metric',
  /** column name */
  Product = 'product',
  /** column name */
  TimeBucket = 'time_bucket'
}

/** Ordering options when selecting data from "alerts_times_to_actioned_graph_metrics". */
export type Alerts_Times_To_Actioned_Graph_Metrics_Order_By = {
  metric?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  time_bucket?: InputMaybe<Order_By>;
};

export type Alerts_Times_To_Actioned_Metrics = {
  __typename?: 'alerts_times_to_actioned_metrics';
  median_metric: Scalars['float8'];
};

/** alerts_times_to_actioned_metricsNative Query Arguments */
export type Alerts_Times_To_Actioned_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  metric_type: Scalars['String'];
  /** Tags to not include */
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  product?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "alerts_times_to_actioned_metrics". All fields are combined with a logical 'AND'. */
export type Alerts_Times_To_Actioned_Metrics_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Alerts_Times_To_Actioned_Metrics_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Alerts_Times_To_Actioned_Metrics_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Alerts_Times_To_Actioned_Metrics_Bool_Exp_Bool_Exp>>;
  median_metric?: InputMaybe<Float8_Comparison_Exp>;
};

export enum Alerts_Times_To_Actioned_Metrics_Enum_Name {
  /** column name */
  MedianMetric = 'median_metric'
}

/** Ordering options when selecting data from "alerts_times_to_actioned_metrics". */
export type Alerts_Times_To_Actioned_Metrics_Order_By = {
  median_metric?: InputMaybe<Order_By>;
};

export type Alerts_Verified_Top_Metrics = {
  __typename?: 'alerts_verified_top_metrics';
  metric: Scalars['String'];
  total_alerts: Scalars['Int'];
};

/** alerts_verified_top_metricsNative Query Arguments */
export type Alerts_Verified_Top_Metrics_Arguments = {
  /** brand */
  brand?: InputMaybe<Scalars['String']>;
  /** end date */
  end_date: Scalars['String'];
  /** when null, the default limit is 5 */
  limit?: InputMaybe<Scalars['Int']>;
  /** selected metric type */
  metric_type: Scalars['String'];
  /** Tags to not include */
  not_tags?: InputMaybe<Scalars['String']>;
  /** organization ID */
  org_id: Scalars['uuid'];
  product?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  /** start date */
  start_date: Scalars['String'];
  /** combination will be subset of any row that contains the tags listed */
  tags?: InputMaybe<Scalars['String']>;
  /** uploader of this alert */
  uploader?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "alerts_verified_top_metrics". All fields are combined with a logical 'AND'. */
export type Alerts_Verified_Top_Metrics_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Alerts_Verified_Top_Metrics_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Alerts_Verified_Top_Metrics_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Alerts_Verified_Top_Metrics_Bool_Exp_Bool_Exp>>;
  metric?: InputMaybe<String_Comparison_Exp>;
  total_alerts?: InputMaybe<Int_Comparison_Exp>;
};

export enum Alerts_Verified_Top_Metrics_Enum_Name {
  /** column name */
  Metric = 'metric',
  /** column name */
  TotalAlerts = 'total_alerts'
}

/** Ordering options when selecting data from "alerts_verified_top_metrics". */
export type Alerts_Verified_Top_Metrics_Order_By = {
  metric?: InputMaybe<Order_By>;
  total_alerts?: InputMaybe<Order_By>;
};

export type Alerts_Verified_Total_Metrics = {
  __typename?: 'alerts_verified_total_metrics';
  total_metric?: Maybe<Scalars['Int']>;
};

/** alerts_verified_total_metricsNative Query Arguments */
export type Alerts_Verified_Total_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  /** Tags to not include */
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  product?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "alerts_verified_total_metrics". All fields are combined with a logical 'AND'. */
export type Alerts_Verified_Total_Metrics_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Alerts_Verified_Total_Metrics_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Alerts_Verified_Total_Metrics_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Alerts_Verified_Total_Metrics_Bool_Exp_Bool_Exp>>;
  total_metric?: InputMaybe<Int_Comparison_Exp>;
};

export enum Alerts_Verified_Total_Metrics_Enum_Name {
  /** column name */
  TotalMetric = 'total_metric'
}

/** Ordering options when selecting data from "alerts_verified_total_metrics". */
export type Alerts_Verified_Total_Metrics_Order_By = {
  total_metric?: InputMaybe<Order_By>;
};

/** columns and relationships of "api_tokens" */
export type Api_Tokens = {
  __typename?: 'api_tokens';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  last_used_at: Scalars['timestamptz'];
  name: Scalars['String'];
  token_hash: Scalars['String'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "api_tokens" */
export type Api_Tokens_Aggregate = {
  __typename?: 'api_tokens_aggregate';
  aggregate?: Maybe<Api_Tokens_Aggregate_Fields>;
  nodes: Array<Api_Tokens>;
};

/** aggregate fields of "api_tokens" */
export type Api_Tokens_Aggregate_Fields = {
  __typename?: 'api_tokens_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Api_Tokens_Max_Fields>;
  min?: Maybe<Api_Tokens_Min_Fields>;
};


/** aggregate fields of "api_tokens" */
export type Api_Tokens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Api_Tokens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "api_tokens". All fields are combined with a logical 'AND'. */
export type Api_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Api_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Api_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Api_Tokens_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_used_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  token_hash?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "api_tokens" */
export enum Api_Tokens_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApiTokensPkey = 'api_tokens_pkey',
  /** unique or primary key constraint on columns "user_id", "name" */
  ApiTokensUserIdNameKey = 'api_tokens_user_id_name_key'
}

/** input type for inserting data into table "api_tokens" */
export type Api_Tokens_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_used_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  token_hash?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Api_Tokens_Max_Fields = {
  __typename?: 'api_tokens_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  last_used_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  token_hash?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Api_Tokens_Min_Fields = {
  __typename?: 'api_tokens_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  last_used_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  token_hash?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "api_tokens" */
export type Api_Tokens_Mutation_Response = {
  __typename?: 'api_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Api_Tokens>;
};

/** on_conflict condition type for table "api_tokens" */
export type Api_Tokens_On_Conflict = {
  constraint: Api_Tokens_Constraint;
  update_columns?: Array<Api_Tokens_Update_Column>;
  where?: InputMaybe<Api_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "api_tokens". */
export type Api_Tokens_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  token_hash?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: api_tokens */
export type Api_Tokens_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "api_tokens" */
export enum Api_Tokens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastUsedAt = 'last_used_at',
  /** column name */
  Name = 'name',
  /** column name */
  TokenHash = 'token_hash',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "api_tokens" */
export type Api_Tokens_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_used_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  token_hash?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "api_tokens" */
export type Api_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Api_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Api_Tokens_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_used_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  token_hash?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "api_tokens" */
export enum Api_Tokens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastUsedAt = 'last_used_at',
  /** column name */
  Name = 'name',
  /** column name */
  TokenHash = 'token_hash',
  /** column name */
  UserId = 'user_id'
}

export type Api_Tokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Api_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Api_Tokens_Bool_Exp;
};

/** https://docs.google.com/document/d/1rhemArsRc5qXEH1vNSuUEWloabGqKEcjjXufwTvPnnc */
export type Api_Usage_Records = {
  __typename?: 'api_usage_records';
  api_name: Scalars['String'];
  id: Scalars['uuid'];
  timestamp: Scalars['timestamp'];
};

/** aggregated selection of "api_usage_records" */
export type Api_Usage_Records_Aggregate = {
  __typename?: 'api_usage_records_aggregate';
  aggregate?: Maybe<Api_Usage_Records_Aggregate_Fields>;
  nodes: Array<Api_Usage_Records>;
};

/** aggregate fields of "api_usage_records" */
export type Api_Usage_Records_Aggregate_Fields = {
  __typename?: 'api_usage_records_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Api_Usage_Records_Max_Fields>;
  min?: Maybe<Api_Usage_Records_Min_Fields>;
};


/** aggregate fields of "api_usage_records" */
export type Api_Usage_Records_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Api_Usage_Records_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "api_usage_records". All fields are combined with a logical 'AND'. */
export type Api_Usage_Records_Bool_Exp = {
  _and?: InputMaybe<Array<Api_Usage_Records_Bool_Exp>>;
  _not?: InputMaybe<Api_Usage_Records_Bool_Exp>;
  _or?: InputMaybe<Array<Api_Usage_Records_Bool_Exp>>;
  api_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "api_usage_records" */
export enum Api_Usage_Records_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApiUsageRecordsPkey = 'api_usage_records_pkey'
}

/** input type for inserting data into table "api_usage_records" */
export type Api_Usage_Records_Insert_Input = {
  api_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Api_Usage_Records_Max_Fields = {
  __typename?: 'api_usage_records_max_fields';
  api_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Api_Usage_Records_Min_Fields = {
  __typename?: 'api_usage_records_min_fields';
  api_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "api_usage_records" */
export type Api_Usage_Records_Mutation_Response = {
  __typename?: 'api_usage_records_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Api_Usage_Records>;
};

/** on_conflict condition type for table "api_usage_records" */
export type Api_Usage_Records_On_Conflict = {
  constraint: Api_Usage_Records_Constraint;
  update_columns?: Array<Api_Usage_Records_Update_Column>;
  where?: InputMaybe<Api_Usage_Records_Bool_Exp>;
};

/** Ordering options when selecting data from "api_usage_records". */
export type Api_Usage_Records_Order_By = {
  api_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
};

/** primary key columns input for table: api_usage_records */
export type Api_Usage_Records_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "api_usage_records" */
export enum Api_Usage_Records_Select_Column {
  /** column name */
  ApiName = 'api_name',
  /** column name */
  Id = 'id',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "api_usage_records" */
export type Api_Usage_Records_Set_Input = {
  api_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "api_usage_records" */
export type Api_Usage_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Api_Usage_Records_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Api_Usage_Records_Stream_Cursor_Value_Input = {
  api_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "api_usage_records" */
export enum Api_Usage_Records_Update_Column {
  /** column name */
  ApiName = 'api_name',
  /** column name */
  Id = 'id',
  /** column name */
  Timestamp = 'timestamp'
}

export type Api_Usage_Records_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Api_Usage_Records_Set_Input>;
  /** filter the rows which have to be updated */
  where: Api_Usage_Records_Bool_Exp;
};

/** table to help keep track of apify scraping jobs. necessary for async implementation */
export type Apify_Scraping_Jobs = {
  __typename?: 'apify_scraping_jobs';
  actor_id: Scalars['String'];
  created_at?: Maybe<Scalars['timestamp']>;
  id: Scalars['uuid'];
  job_type: Scalars['String'];
  original_entity_id: Scalars['uuid'];
  run_id: Scalars['String'];
  run_status: Scalars['String'];
  search_query: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "apify_scraping_jobs" */
export type Apify_Scraping_Jobs_Aggregate = {
  __typename?: 'apify_scraping_jobs_aggregate';
  aggregate?: Maybe<Apify_Scraping_Jobs_Aggregate_Fields>;
  nodes: Array<Apify_Scraping_Jobs>;
};

/** aggregate fields of "apify_scraping_jobs" */
export type Apify_Scraping_Jobs_Aggregate_Fields = {
  __typename?: 'apify_scraping_jobs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Apify_Scraping_Jobs_Max_Fields>;
  min?: Maybe<Apify_Scraping_Jobs_Min_Fields>;
};


/** aggregate fields of "apify_scraping_jobs" */
export type Apify_Scraping_Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Apify_Scraping_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "apify_scraping_jobs". All fields are combined with a logical 'AND'. */
export type Apify_Scraping_Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Apify_Scraping_Jobs_Bool_Exp>>;
  _not?: InputMaybe<Apify_Scraping_Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Apify_Scraping_Jobs_Bool_Exp>>;
  actor_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_type?: InputMaybe<String_Comparison_Exp>;
  original_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  run_id?: InputMaybe<String_Comparison_Exp>;
  run_status?: InputMaybe<String_Comparison_Exp>;
  search_query?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "apify_scraping_jobs" */
export enum Apify_Scraping_Jobs_Constraint {
  /** unique or primary key constraint on columns "run_id", "actor_id" */
  ApifyScrapingJobsActorIdRunIdKey = 'apify_scraping_jobs_actor_id_run_id_key',
  /** unique or primary key constraint on columns "id" */
  ApifyScrapingJobsPkey = 'apify_scraping_jobs_pkey'
}

/** input type for inserting data into table "apify_scraping_jobs" */
export type Apify_Scraping_Jobs_Insert_Input = {
  actor_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_type?: InputMaybe<Scalars['String']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  run_id?: InputMaybe<Scalars['String']>;
  run_status?: InputMaybe<Scalars['String']>;
  search_query?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Apify_Scraping_Jobs_Max_Fields = {
  __typename?: 'apify_scraping_jobs_max_fields';
  actor_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  job_type?: Maybe<Scalars['String']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  run_id?: Maybe<Scalars['String']>;
  run_status?: Maybe<Scalars['String']>;
  search_query?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Apify_Scraping_Jobs_Min_Fields = {
  __typename?: 'apify_scraping_jobs_min_fields';
  actor_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  job_type?: Maybe<Scalars['String']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  run_id?: Maybe<Scalars['String']>;
  run_status?: Maybe<Scalars['String']>;
  search_query?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "apify_scraping_jobs" */
export type Apify_Scraping_Jobs_Mutation_Response = {
  __typename?: 'apify_scraping_jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Apify_Scraping_Jobs>;
};

/** on_conflict condition type for table "apify_scraping_jobs" */
export type Apify_Scraping_Jobs_On_Conflict = {
  constraint: Apify_Scraping_Jobs_Constraint;
  update_columns?: Array<Apify_Scraping_Jobs_Update_Column>;
  where?: InputMaybe<Apify_Scraping_Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "apify_scraping_jobs". */
export type Apify_Scraping_Jobs_Order_By = {
  actor_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_type?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  run_id?: InputMaybe<Order_By>;
  run_status?: InputMaybe<Order_By>;
  search_query?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: apify_scraping_jobs */
export type Apify_Scraping_Jobs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "apify_scraping_jobs" */
export enum Apify_Scraping_Jobs_Select_Column {
  /** column name */
  ActorId = 'actor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  JobType = 'job_type',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  RunId = 'run_id',
  /** column name */
  RunStatus = 'run_status',
  /** column name */
  SearchQuery = 'search_query',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "apify_scraping_jobs" */
export type Apify_Scraping_Jobs_Set_Input = {
  actor_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_type?: InputMaybe<Scalars['String']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  run_id?: InputMaybe<Scalars['String']>;
  run_status?: InputMaybe<Scalars['String']>;
  search_query?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "apify_scraping_jobs" */
export type Apify_Scraping_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Apify_Scraping_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Apify_Scraping_Jobs_Stream_Cursor_Value_Input = {
  actor_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_type?: InputMaybe<Scalars['String']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  run_id?: InputMaybe<Scalars['String']>;
  run_status?: InputMaybe<Scalars['String']>;
  search_query?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "apify_scraping_jobs" */
export enum Apify_Scraping_Jobs_Update_Column {
  /** column name */
  ActorId = 'actor_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  JobType = 'job_type',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  RunId = 'run_id',
  /** column name */
  RunStatus = 'run_status',
  /** column name */
  SearchQuery = 'search_query',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Apify_Scraping_Jobs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Apify_Scraping_Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Apify_Scraping_Jobs_Bool_Exp;
};

/** Boolean expression to compare columns of type "approval_status". All fields are combined with logical 'AND'. */
export type Approval_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['approval_status']>;
  _gt?: InputMaybe<Scalars['approval_status']>;
  _gte?: InputMaybe<Scalars['approval_status']>;
  _in?: InputMaybe<Array<Scalars['approval_status']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['approval_status']>;
  _lte?: InputMaybe<Scalars['approval_status']>;
  _neq?: InputMaybe<Scalars['approval_status']>;
  _nin?: InputMaybe<Array<Scalars['approval_status']>>;
};

/** columns and relationships of "approvals" */
export type Approvals = {
  __typename?: 'approvals';
  /** An object relationship */
  approver?: Maybe<Users>;
  approver_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  requester: Users;
  requester_id: Scalars['uuid'];
  /** An object relationship */
  spoofing_report: Spoofing_Reports;
  spoofing_report_id: Scalars['uuid'];
  status: Scalars['approval_status'];
  updated_at: Scalars['timestamp'];
};

/** aggregated selection of "approvals" */
export type Approvals_Aggregate = {
  __typename?: 'approvals_aggregate';
  aggregate?: Maybe<Approvals_Aggregate_Fields>;
  nodes: Array<Approvals>;
};

export type Approvals_Aggregate_Bool_Exp = {
  count?: InputMaybe<Approvals_Aggregate_Bool_Exp_Count>;
};

export type Approvals_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Approvals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Approvals_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "approvals" */
export type Approvals_Aggregate_Fields = {
  __typename?: 'approvals_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Approvals_Max_Fields>;
  min?: Maybe<Approvals_Min_Fields>;
};


/** aggregate fields of "approvals" */
export type Approvals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Approvals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "approvals" */
export type Approvals_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Approvals_Max_Order_By>;
  min?: InputMaybe<Approvals_Min_Order_By>;
};

/** input type for inserting array relation for remote table "approvals" */
export type Approvals_Arr_Rel_Insert_Input = {
  data: Array<Approvals_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Approvals_On_Conflict>;
};

/** Boolean expression to filter rows from the table "approvals". All fields are combined with a logical 'AND'. */
export type Approvals_Bool_Exp = {
  _and?: InputMaybe<Array<Approvals_Bool_Exp>>;
  _not?: InputMaybe<Approvals_Bool_Exp>;
  _or?: InputMaybe<Array<Approvals_Bool_Exp>>;
  approver?: InputMaybe<Users_Bool_Exp>;
  approver_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  requester?: InputMaybe<Users_Bool_Exp>;
  requester_id?: InputMaybe<Uuid_Comparison_Exp>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  spoofing_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Approval_Status_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "approvals" */
export enum Approvals_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApprovalsPkey = 'approvals_pkey'
}

/** input type for inserting data into table "approvals" */
export type Approvals_Insert_Input = {
  approver?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  approver_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  requester?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  requester_id?: InputMaybe<Scalars['uuid']>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['approval_status']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Approvals_Max_Fields = {
  __typename?: 'approvals_max_fields';
  approver_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  requester_id?: Maybe<Scalars['uuid']>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['approval_status']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "approvals" */
export type Approvals_Max_Order_By = {
  approver_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  spoofing_report_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Approvals_Min_Fields = {
  __typename?: 'approvals_min_fields';
  approver_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  requester_id?: Maybe<Scalars['uuid']>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['approval_status']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "approvals" */
export type Approvals_Min_Order_By = {
  approver_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  requester_id?: InputMaybe<Order_By>;
  spoofing_report_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "approvals" */
export type Approvals_Mutation_Response = {
  __typename?: 'approvals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Approvals>;
};

/** on_conflict condition type for table "approvals" */
export type Approvals_On_Conflict = {
  constraint: Approvals_Constraint;
  update_columns?: Array<Approvals_Update_Column>;
  where?: InputMaybe<Approvals_Bool_Exp>;
};

/** Ordering options when selecting data from "approvals". */
export type Approvals_Order_By = {
  approver?: InputMaybe<Users_Order_By>;
  approver_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  requester?: InputMaybe<Users_Order_By>;
  requester_id?: InputMaybe<Order_By>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Order_By>;
  spoofing_report_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: approvals */
export type Approvals_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "approvals" */
export enum Approvals_Select_Column {
  /** column name */
  ApproverId = 'approver_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  RequesterId = 'requester_id',
  /** column name */
  SpoofingReportId = 'spoofing_report_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "approvals" */
export type Approvals_Set_Input = {
  approver_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  requester_id?: InputMaybe<Scalars['uuid']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['approval_status']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "approvals" */
export type Approvals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Approvals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Approvals_Stream_Cursor_Value_Input = {
  approver_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  requester_id?: InputMaybe<Scalars['uuid']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['approval_status']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "approvals" */
export enum Approvals_Update_Column {
  /** column name */
  ApproverId = 'approver_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  RequesterId = 'requester_id',
  /** column name */
  SpoofingReportId = 'spoofing_report_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Approvals_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Approvals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Approvals_Bool_Exp;
};

/** columns and relationships of "audit.logged_actions" */
export type Audit_Logged_Actions = {
  __typename?: 'audit_logged_actions';
  action: Scalars['String'];
  action_tstamp?: Maybe<Scalars['timestamp']>;
  column_name?: Maybe<Scalars['String']>;
  event_id: Scalars['bigint'];
  new_value?: Maybe<Scalars['String']>;
  old_value?: Maybe<Scalars['String']>;
  revision_id?: Maybe<Scalars['uuid']>;
  row_id: Scalars['String'];
  schema_name: Scalars['String'];
  table_name: Scalars['String'];
};

/** aggregated selection of "audit.logged_actions" */
export type Audit_Logged_Actions_Aggregate = {
  __typename?: 'audit_logged_actions_aggregate';
  aggregate?: Maybe<Audit_Logged_Actions_Aggregate_Fields>;
  nodes: Array<Audit_Logged_Actions>;
};

/** aggregate fields of "audit.logged_actions" */
export type Audit_Logged_Actions_Aggregate_Fields = {
  __typename?: 'audit_logged_actions_aggregate_fields';
  avg?: Maybe<Audit_Logged_Actions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Audit_Logged_Actions_Max_Fields>;
  min?: Maybe<Audit_Logged_Actions_Min_Fields>;
  stddev?: Maybe<Audit_Logged_Actions_Stddev_Fields>;
  stddev_pop?: Maybe<Audit_Logged_Actions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Audit_Logged_Actions_Stddev_Samp_Fields>;
  sum?: Maybe<Audit_Logged_Actions_Sum_Fields>;
  var_pop?: Maybe<Audit_Logged_Actions_Var_Pop_Fields>;
  var_samp?: Maybe<Audit_Logged_Actions_Var_Samp_Fields>;
  variance?: Maybe<Audit_Logged_Actions_Variance_Fields>;
};


/** aggregate fields of "audit.logged_actions" */
export type Audit_Logged_Actions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Audit_Logged_Actions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Audit_Logged_Actions_Avg_Fields = {
  __typename?: 'audit_logged_actions_avg_fields';
  event_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "audit.logged_actions". All fields are combined with a logical 'AND'. */
export type Audit_Logged_Actions_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Logged_Actions_Bool_Exp>>;
  _not?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Logged_Actions_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  action_tstamp?: InputMaybe<Timestamp_Comparison_Exp>;
  column_name?: InputMaybe<String_Comparison_Exp>;
  event_id?: InputMaybe<Bigint_Comparison_Exp>;
  new_value?: InputMaybe<String_Comparison_Exp>;
  old_value?: InputMaybe<String_Comparison_Exp>;
  revision_id?: InputMaybe<Uuid_Comparison_Exp>;
  row_id?: InputMaybe<String_Comparison_Exp>;
  schema_name?: InputMaybe<String_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "audit.logged_actions" */
export enum Audit_Logged_Actions_Constraint {
  /** unique or primary key constraint on columns "event_id" */
  LoggedActionsPkey = 'logged_actions_pkey'
}

/** input type for incrementing numeric columns in table "audit.logged_actions" */
export type Audit_Logged_Actions_Inc_Input = {
  event_id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "audit.logged_actions" */
export type Audit_Logged_Actions_Insert_Input = {
  action?: InputMaybe<Scalars['String']>;
  action_tstamp?: InputMaybe<Scalars['timestamp']>;
  column_name?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['bigint']>;
  new_value?: InputMaybe<Scalars['String']>;
  old_value?: InputMaybe<Scalars['String']>;
  revision_id?: InputMaybe<Scalars['uuid']>;
  row_id?: InputMaybe<Scalars['String']>;
  schema_name?: InputMaybe<Scalars['String']>;
  table_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Audit_Logged_Actions_Max_Fields = {
  __typename?: 'audit_logged_actions_max_fields';
  action?: Maybe<Scalars['String']>;
  action_tstamp?: Maybe<Scalars['timestamp']>;
  column_name?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['bigint']>;
  new_value?: Maybe<Scalars['String']>;
  old_value?: Maybe<Scalars['String']>;
  revision_id?: Maybe<Scalars['uuid']>;
  row_id?: Maybe<Scalars['String']>;
  schema_name?: Maybe<Scalars['String']>;
  table_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Audit_Logged_Actions_Min_Fields = {
  __typename?: 'audit_logged_actions_min_fields';
  action?: Maybe<Scalars['String']>;
  action_tstamp?: Maybe<Scalars['timestamp']>;
  column_name?: Maybe<Scalars['String']>;
  event_id?: Maybe<Scalars['bigint']>;
  new_value?: Maybe<Scalars['String']>;
  old_value?: Maybe<Scalars['String']>;
  revision_id?: Maybe<Scalars['uuid']>;
  row_id?: Maybe<Scalars['String']>;
  schema_name?: Maybe<Scalars['String']>;
  table_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "audit.logged_actions" */
export type Audit_Logged_Actions_Mutation_Response = {
  __typename?: 'audit_logged_actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Audit_Logged_Actions>;
};

/** on_conflict condition type for table "audit.logged_actions" */
export type Audit_Logged_Actions_On_Conflict = {
  constraint: Audit_Logged_Actions_Constraint;
  update_columns?: Array<Audit_Logged_Actions_Update_Column>;
  where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};

/** Ordering options when selecting data from "audit.logged_actions". */
export type Audit_Logged_Actions_Order_By = {
  action?: InputMaybe<Order_By>;
  action_tstamp?: InputMaybe<Order_By>;
  column_name?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  new_value?: InputMaybe<Order_By>;
  old_value?: InputMaybe<Order_By>;
  revision_id?: InputMaybe<Order_By>;
  row_id?: InputMaybe<Order_By>;
  schema_name?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: audit.logged_actions */
export type Audit_Logged_Actions_Pk_Columns_Input = {
  event_id: Scalars['bigint'];
};

/** select columns of table "audit.logged_actions" */
export enum Audit_Logged_Actions_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTstamp = 'action_tstamp',
  /** column name */
  ColumnName = 'column_name',
  /** column name */
  EventId = 'event_id',
  /** column name */
  NewValue = 'new_value',
  /** column name */
  OldValue = 'old_value',
  /** column name */
  RevisionId = 'revision_id',
  /** column name */
  RowId = 'row_id',
  /** column name */
  SchemaName = 'schema_name',
  /** column name */
  TableName = 'table_name'
}

/** input type for updating data in table "audit.logged_actions" */
export type Audit_Logged_Actions_Set_Input = {
  action?: InputMaybe<Scalars['String']>;
  action_tstamp?: InputMaybe<Scalars['timestamp']>;
  column_name?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['bigint']>;
  new_value?: InputMaybe<Scalars['String']>;
  old_value?: InputMaybe<Scalars['String']>;
  revision_id?: InputMaybe<Scalars['uuid']>;
  row_id?: InputMaybe<Scalars['String']>;
  schema_name?: InputMaybe<Scalars['String']>;
  table_name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Audit_Logged_Actions_Stddev_Fields = {
  __typename?: 'audit_logged_actions_stddev_fields';
  event_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Audit_Logged_Actions_Stddev_Pop_Fields = {
  __typename?: 'audit_logged_actions_stddev_pop_fields';
  event_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Audit_Logged_Actions_Stddev_Samp_Fields = {
  __typename?: 'audit_logged_actions_stddev_samp_fields';
  event_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "audit_logged_actions" */
export type Audit_Logged_Actions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Logged_Actions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Logged_Actions_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']>;
  action_tstamp?: InputMaybe<Scalars['timestamp']>;
  column_name?: InputMaybe<Scalars['String']>;
  event_id?: InputMaybe<Scalars['bigint']>;
  new_value?: InputMaybe<Scalars['String']>;
  old_value?: InputMaybe<Scalars['String']>;
  revision_id?: InputMaybe<Scalars['uuid']>;
  row_id?: InputMaybe<Scalars['String']>;
  schema_name?: InputMaybe<Scalars['String']>;
  table_name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Audit_Logged_Actions_Sum_Fields = {
  __typename?: 'audit_logged_actions_sum_fields';
  event_id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "audit.logged_actions" */
export enum Audit_Logged_Actions_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  ActionTstamp = 'action_tstamp',
  /** column name */
  ColumnName = 'column_name',
  /** column name */
  EventId = 'event_id',
  /** column name */
  NewValue = 'new_value',
  /** column name */
  OldValue = 'old_value',
  /** column name */
  RevisionId = 'revision_id',
  /** column name */
  RowId = 'row_id',
  /** column name */
  SchemaName = 'schema_name',
  /** column name */
  TableName = 'table_name'
}

export type Audit_Logged_Actions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Audit_Logged_Actions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Audit_Logged_Actions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Audit_Logged_Actions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Audit_Logged_Actions_Var_Pop_Fields = {
  __typename?: 'audit_logged_actions_var_pop_fields';
  event_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Audit_Logged_Actions_Var_Samp_Fields = {
  __typename?: 'audit_logged_actions_var_samp_fields';
  event_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Audit_Logged_Actions_Variance_Fields = {
  __typename?: 'audit_logged_actions_variance_fields';
  event_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** Record changes to reports such as similarity_score change, importance_score, or classification */
export type Collection_Report_Changes = {
  __typename?: 'collection_report_changes';
  collection_report_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  enforcement_email?: Maybe<Enforcement_Emails>;
  enforcement_email_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  enforcement_request?: Maybe<Enforcement_Requests>;
  enforcement_request_id?: Maybe<Scalars['uuid']>;
  extra_data?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  new_value: Scalars['String'];
  old_value?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  spoof_match_id?: Maybe<Scalars['uuid']>;
  spoof_report_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  spoofing_report?: Maybe<Spoofing_Reports>;
  timestamp: Scalars['timestamp'];
  type: Scalars['String'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']>;
};


/** Record changes to reports such as similarity_score change, importance_score, or classification */
export type Collection_Report_ChangesExtra_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "collection_report_changes" */
export type Collection_Report_Changes_Aggregate = {
  __typename?: 'collection_report_changes_aggregate';
  aggregate?: Maybe<Collection_Report_Changes_Aggregate_Fields>;
  nodes: Array<Collection_Report_Changes>;
};

export type Collection_Report_Changes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Collection_Report_Changes_Aggregate_Bool_Exp_Count>;
};

export type Collection_Report_Changes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "collection_report_changes" */
export type Collection_Report_Changes_Aggregate_Fields = {
  __typename?: 'collection_report_changes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Collection_Report_Changes_Max_Fields>;
  min?: Maybe<Collection_Report_Changes_Min_Fields>;
};


/** aggregate fields of "collection_report_changes" */
export type Collection_Report_Changes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "collection_report_changes" */
export type Collection_Report_Changes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Collection_Report_Changes_Max_Order_By>;
  min?: InputMaybe<Collection_Report_Changes_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Collection_Report_Changes_Append_Input = {
  extra_data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "collection_report_changes" */
export type Collection_Report_Changes_Arr_Rel_Insert_Input = {
  data: Array<Collection_Report_Changes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Collection_Report_Changes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "collection_report_changes". All fields are combined with a logical 'AND'. */
export type Collection_Report_Changes_Bool_Exp = {
  _and?: InputMaybe<Array<Collection_Report_Changes_Bool_Exp>>;
  _not?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
  _or?: InputMaybe<Array<Collection_Report_Changes_Bool_Exp>>;
  collection_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  enforcement_email?: InputMaybe<Enforcement_Emails_Bool_Exp>;
  enforcement_email_id?: InputMaybe<Uuid_Comparison_Exp>;
  enforcement_request?: InputMaybe<Enforcement_Requests_Bool_Exp>;
  enforcement_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra_data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  new_value?: InputMaybe<String_Comparison_Exp>;
  old_value?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  spoof_match_id?: InputMaybe<Uuid_Comparison_Exp>;
  spoof_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "collection_report_changes" */
export enum Collection_Report_Changes_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollectionReportChangesPkey = 'collection_report_changes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Collection_Report_Changes_Delete_At_Path_Input = {
  extra_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Collection_Report_Changes_Delete_Elem_Input = {
  extra_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Collection_Report_Changes_Delete_Key_Input = {
  extra_data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "collection_report_changes" */
export type Collection_Report_Changes_Insert_Input = {
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  enforcement_email?: InputMaybe<Enforcement_Emails_Obj_Rel_Insert_Input>;
  enforcement_email_id?: InputMaybe<Scalars['uuid']>;
  enforcement_request?: InputMaybe<Enforcement_Requests_Obj_Rel_Insert_Input>;
  enforcement_request_id?: InputMaybe<Scalars['uuid']>;
  extra_data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  new_value?: InputMaybe<Scalars['String']>;
  old_value?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  spoof_match_id?: InputMaybe<Scalars['uuid']>;
  spoof_report_id?: InputMaybe<Scalars['uuid']>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Collection_Report_Changes_Max_Fields = {
  __typename?: 'collection_report_changes_max_fields';
  collection_report_id?: Maybe<Scalars['uuid']>;
  enforcement_email_id?: Maybe<Scalars['uuid']>;
  enforcement_request_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  new_value?: Maybe<Scalars['String']>;
  old_value?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  spoof_match_id?: Maybe<Scalars['uuid']>;
  spoof_report_id?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamp']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "collection_report_changes" */
export type Collection_Report_Changes_Max_Order_By = {
  collection_report_id?: InputMaybe<Order_By>;
  enforcement_email_id?: InputMaybe<Order_By>;
  enforcement_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_value?: InputMaybe<Order_By>;
  old_value?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  spoof_match_id?: InputMaybe<Order_By>;
  spoof_report_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Collection_Report_Changes_Min_Fields = {
  __typename?: 'collection_report_changes_min_fields';
  collection_report_id?: Maybe<Scalars['uuid']>;
  enforcement_email_id?: Maybe<Scalars['uuid']>;
  enforcement_request_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  new_value?: Maybe<Scalars['String']>;
  old_value?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  spoof_match_id?: Maybe<Scalars['uuid']>;
  spoof_report_id?: Maybe<Scalars['uuid']>;
  timestamp?: Maybe<Scalars['timestamp']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "collection_report_changes" */
export type Collection_Report_Changes_Min_Order_By = {
  collection_report_id?: InputMaybe<Order_By>;
  enforcement_email_id?: InputMaybe<Order_By>;
  enforcement_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_value?: InputMaybe<Order_By>;
  old_value?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  spoof_match_id?: InputMaybe<Order_By>;
  spoof_report_id?: InputMaybe<Order_By>;
  timestamp?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "collection_report_changes" */
export type Collection_Report_Changes_Mutation_Response = {
  __typename?: 'collection_report_changes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Collection_Report_Changes>;
};

/** on_conflict condition type for table "collection_report_changes" */
export type Collection_Report_Changes_On_Conflict = {
  constraint: Collection_Report_Changes_Constraint;
  update_columns?: Array<Collection_Report_Changes_Update_Column>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};

/** Ordering options when selecting data from "collection_report_changes". */
export type Collection_Report_Changes_Order_By = {
  collection_report_id?: InputMaybe<Order_By>;
  enforcement_email?: InputMaybe<Enforcement_Emails_Order_By>;
  enforcement_email_id?: InputMaybe<Order_By>;
  enforcement_request?: InputMaybe<Enforcement_Requests_Order_By>;
  enforcement_request_id?: InputMaybe<Order_By>;
  extra_data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_value?: InputMaybe<Order_By>;
  old_value?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  spoof_match_id?: InputMaybe<Order_By>;
  spoof_report_id?: InputMaybe<Order_By>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Order_By>;
  timestamp?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: collection_report_changes */
export type Collection_Report_Changes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Collection_Report_Changes_Prepend_Input = {
  extra_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "collection_report_changes" */
export enum Collection_Report_Changes_Select_Column {
  /** column name */
  CollectionReportId = 'collection_report_id',
  /** column name */
  EnforcementEmailId = 'enforcement_email_id',
  /** column name */
  EnforcementRequestId = 'enforcement_request_id',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  Id = 'id',
  /** column name */
  NewValue = 'new_value',
  /** column name */
  OldValue = 'old_value',
  /** column name */
  Source = 'source',
  /** column name */
  SpoofMatchId = 'spoof_match_id',
  /** column name */
  SpoofReportId = 'spoof_report_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "collection_report_changes" */
export type Collection_Report_Changes_Set_Input = {
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  enforcement_email_id?: InputMaybe<Scalars['uuid']>;
  enforcement_request_id?: InputMaybe<Scalars['uuid']>;
  extra_data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  new_value?: InputMaybe<Scalars['String']>;
  old_value?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  spoof_match_id?: InputMaybe<Scalars['uuid']>;
  spoof_report_id?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "collection_report_changes" */
export type Collection_Report_Changes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Collection_Report_Changes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Collection_Report_Changes_Stream_Cursor_Value_Input = {
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  enforcement_email_id?: InputMaybe<Scalars['uuid']>;
  enforcement_request_id?: InputMaybe<Scalars['uuid']>;
  extra_data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  new_value?: InputMaybe<Scalars['String']>;
  old_value?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  spoof_match_id?: InputMaybe<Scalars['uuid']>;
  spoof_report_id?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "collection_report_changes" */
export enum Collection_Report_Changes_Update_Column {
  /** column name */
  CollectionReportId = 'collection_report_id',
  /** column name */
  EnforcementEmailId = 'enforcement_email_id',
  /** column name */
  EnforcementRequestId = 'enforcement_request_id',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  Id = 'id',
  /** column name */
  NewValue = 'new_value',
  /** column name */
  OldValue = 'old_value',
  /** column name */
  Source = 'source',
  /** column name */
  SpoofMatchId = 'spoof_match_id',
  /** column name */
  SpoofReportId = 'spoof_report_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type Collection_Report_Changes_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Collection_Report_Changes_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Collection_Report_Changes_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Collection_Report_Changes_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Collection_Report_Changes_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Collection_Report_Changes_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Collection_Report_Changes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Collection_Report_Changes_Bool_Exp;
};

/** a state change that happens to a collection reporrt */
export type Collection_Report_State_Changes = {
  __typename?: 'collection_report_state_changes';
  collection_report_id: Scalars['uuid'];
  id: Scalars['uuid'];
  new_state: Scalars['String'];
  previous_state: Scalars['String'];
  reason_for_change?: Maybe<Scalars['String']>;
  timestamp_of_change: Scalars['timestamp'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "collection_report_state_changes" */
export type Collection_Report_State_Changes_Aggregate = {
  __typename?: 'collection_report_state_changes_aggregate';
  aggregate?: Maybe<Collection_Report_State_Changes_Aggregate_Fields>;
  nodes: Array<Collection_Report_State_Changes>;
};

/** aggregate fields of "collection_report_state_changes" */
export type Collection_Report_State_Changes_Aggregate_Fields = {
  __typename?: 'collection_report_state_changes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Collection_Report_State_Changes_Max_Fields>;
  min?: Maybe<Collection_Report_State_Changes_Min_Fields>;
};


/** aggregate fields of "collection_report_state_changes" */
export type Collection_Report_State_Changes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Collection_Report_State_Changes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "collection_report_state_changes". All fields are combined with a logical 'AND'. */
export type Collection_Report_State_Changes_Bool_Exp = {
  _and?: InputMaybe<Array<Collection_Report_State_Changes_Bool_Exp>>;
  _not?: InputMaybe<Collection_Report_State_Changes_Bool_Exp>;
  _or?: InputMaybe<Array<Collection_Report_State_Changes_Bool_Exp>>;
  collection_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  new_state?: InputMaybe<String_Comparison_Exp>;
  previous_state?: InputMaybe<String_Comparison_Exp>;
  reason_for_change?: InputMaybe<String_Comparison_Exp>;
  timestamp_of_change?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "collection_report_state_changes" */
export enum Collection_Report_State_Changes_Constraint {
  /** unique or primary key constraint on columns "id" */
  CollectionReportStateChangesPkey = 'collection_report_state_changes_pkey'
}

/** input type for inserting data into table "collection_report_state_changes" */
export type Collection_Report_State_Changes_Insert_Input = {
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  new_state?: InputMaybe<Scalars['String']>;
  previous_state?: InputMaybe<Scalars['String']>;
  reason_for_change?: InputMaybe<Scalars['String']>;
  timestamp_of_change?: InputMaybe<Scalars['timestamp']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Collection_Report_State_Changes_Max_Fields = {
  __typename?: 'collection_report_state_changes_max_fields';
  collection_report_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  new_state?: Maybe<Scalars['String']>;
  previous_state?: Maybe<Scalars['String']>;
  reason_for_change?: Maybe<Scalars['String']>;
  timestamp_of_change?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Collection_Report_State_Changes_Min_Fields = {
  __typename?: 'collection_report_state_changes_min_fields';
  collection_report_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  new_state?: Maybe<Scalars['String']>;
  previous_state?: Maybe<Scalars['String']>;
  reason_for_change?: Maybe<Scalars['String']>;
  timestamp_of_change?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "collection_report_state_changes" */
export type Collection_Report_State_Changes_Mutation_Response = {
  __typename?: 'collection_report_state_changes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Collection_Report_State_Changes>;
};

/** on_conflict condition type for table "collection_report_state_changes" */
export type Collection_Report_State_Changes_On_Conflict = {
  constraint: Collection_Report_State_Changes_Constraint;
  update_columns?: Array<Collection_Report_State_Changes_Update_Column>;
  where?: InputMaybe<Collection_Report_State_Changes_Bool_Exp>;
};

/** Ordering options when selecting data from "collection_report_state_changes". */
export type Collection_Report_State_Changes_Order_By = {
  collection_report_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_state?: InputMaybe<Order_By>;
  previous_state?: InputMaybe<Order_By>;
  reason_for_change?: InputMaybe<Order_By>;
  timestamp_of_change?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: collection_report_state_changes */
export type Collection_Report_State_Changes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "collection_report_state_changes" */
export enum Collection_Report_State_Changes_Select_Column {
  /** column name */
  CollectionReportId = 'collection_report_id',
  /** column name */
  Id = 'id',
  /** column name */
  NewState = 'new_state',
  /** column name */
  PreviousState = 'previous_state',
  /** column name */
  ReasonForChange = 'reason_for_change',
  /** column name */
  TimestampOfChange = 'timestamp_of_change',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "collection_report_state_changes" */
export type Collection_Report_State_Changes_Set_Input = {
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  new_state?: InputMaybe<Scalars['String']>;
  previous_state?: InputMaybe<Scalars['String']>;
  reason_for_change?: InputMaybe<Scalars['String']>;
  timestamp_of_change?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "collection_report_state_changes" */
export type Collection_Report_State_Changes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Collection_Report_State_Changes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Collection_Report_State_Changes_Stream_Cursor_Value_Input = {
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  new_state?: InputMaybe<Scalars['String']>;
  previous_state?: InputMaybe<Scalars['String']>;
  reason_for_change?: InputMaybe<Scalars['String']>;
  timestamp_of_change?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "collection_report_state_changes" */
export enum Collection_Report_State_Changes_Update_Column {
  /** column name */
  CollectionReportId = 'collection_report_id',
  /** column name */
  Id = 'id',
  /** column name */
  NewState = 'new_state',
  /** column name */
  PreviousState = 'previous_state',
  /** column name */
  ReasonForChange = 'reason_for_change',
  /** column name */
  TimestampOfChange = 'timestamp_of_change',
  /** column name */
  UserId = 'user_id'
}

export type Collection_Report_State_Changes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Collection_Report_State_Changes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Collection_Report_State_Changes_Bool_Exp;
};

/** This table contains the credit cards for the DarkWeb credit_card_leaks subplatform */
export type Credit_Cards = {
  __typename?: 'credit_cards';
  bin: Scalars['Int'];
  cardholder_address?: Maybe<Scalars['String']>;
  cardholder_name?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  credit_card_number?: Maybe<Scalars['String']>;
  expiration_date: Scalars['date'];
  id: Scalars['uuid'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "credit_cards" */
export type Credit_Cards_Aggregate = {
  __typename?: 'credit_cards_aggregate';
  aggregate?: Maybe<Credit_Cards_Aggregate_Fields>;
  nodes: Array<Credit_Cards>;
};

/** aggregate fields of "credit_cards" */
export type Credit_Cards_Aggregate_Fields = {
  __typename?: 'credit_cards_aggregate_fields';
  avg?: Maybe<Credit_Cards_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Credit_Cards_Max_Fields>;
  min?: Maybe<Credit_Cards_Min_Fields>;
  stddev?: Maybe<Credit_Cards_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Cards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Cards_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Cards_Sum_Fields>;
  var_pop?: Maybe<Credit_Cards_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Cards_Var_Samp_Fields>;
  variance?: Maybe<Credit_Cards_Variance_Fields>;
};


/** aggregate fields of "credit_cards" */
export type Credit_Cards_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Cards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Credit_Cards_Avg_Fields = {
  __typename?: 'credit_cards_avg_fields';
  bin?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "credit_cards". All fields are combined with a logical 'AND'. */
export type Credit_Cards_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Cards_Bool_Exp>>;
  _not?: InputMaybe<Credit_Cards_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Cards_Bool_Exp>>;
  bin?: InputMaybe<Int_Comparison_Exp>;
  cardholder_address?: InputMaybe<String_Comparison_Exp>;
  cardholder_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_card_number?: InputMaybe<String_Comparison_Exp>;
  expiration_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "credit_cards" */
export enum Credit_Cards_Constraint {
  /** unique or primary key constraint on columns "expiration_date", "credit_card_number", "bin" */
  CreditCardsCreditCardNumberExpirationDateBinKey = 'credit_cards_credit_card_number_expiration_date_bin_key',
  /** unique or primary key constraint on columns "credit_card_number" */
  CreditCardsCreditCardNumberKey = 'credit_cards_credit_card_number_key',
  /** unique or primary key constraint on columns "id" */
  CreditCardsPkey = 'credit_cards_pkey'
}

/** input type for incrementing numeric columns in table "credit_cards" */
export type Credit_Cards_Inc_Input = {
  bin?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "credit_cards" */
export type Credit_Cards_Insert_Input = {
  bin?: InputMaybe<Scalars['Int']>;
  cardholder_address?: InputMaybe<Scalars['String']>;
  cardholder_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit_card_number?: InputMaybe<Scalars['String']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Credit_Cards_Max_Fields = {
  __typename?: 'credit_cards_max_fields';
  bin?: Maybe<Scalars['Int']>;
  cardholder_address?: Maybe<Scalars['String']>;
  cardholder_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_card_number?: Maybe<Scalars['String']>;
  expiration_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Credit_Cards_Min_Fields = {
  __typename?: 'credit_cards_min_fields';
  bin?: Maybe<Scalars['Int']>;
  cardholder_address?: Maybe<Scalars['String']>;
  cardholder_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_card_number?: Maybe<Scalars['String']>;
  expiration_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "credit_cards" */
export type Credit_Cards_Mutation_Response = {
  __typename?: 'credit_cards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Credit_Cards>;
};

/** input type for inserting object relation for remote table "credit_cards" */
export type Credit_Cards_Obj_Rel_Insert_Input = {
  data: Credit_Cards_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Credit_Cards_On_Conflict>;
};

/** on_conflict condition type for table "credit_cards" */
export type Credit_Cards_On_Conflict = {
  constraint: Credit_Cards_Constraint;
  update_columns?: Array<Credit_Cards_Update_Column>;
  where?: InputMaybe<Credit_Cards_Bool_Exp>;
};

/** Ordering options when selecting data from "credit_cards". */
export type Credit_Cards_Order_By = {
  bin?: InputMaybe<Order_By>;
  cardholder_address?: InputMaybe<Order_By>;
  cardholder_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_card_number?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: credit_cards */
export type Credit_Cards_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "credit_cards" */
export enum Credit_Cards_Select_Column {
  /** column name */
  Bin = 'bin',
  /** column name */
  CardholderAddress = 'cardholder_address',
  /** column name */
  CardholderName = 'cardholder_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditCardNumber = 'credit_card_number',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "credit_cards" */
export type Credit_Cards_Set_Input = {
  bin?: InputMaybe<Scalars['Int']>;
  cardholder_address?: InputMaybe<Scalars['String']>;
  cardholder_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit_card_number?: InputMaybe<Scalars['String']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Credit_Cards_Stddev_Fields = {
  __typename?: 'credit_cards_stddev_fields';
  bin?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Credit_Cards_Stddev_Pop_Fields = {
  __typename?: 'credit_cards_stddev_pop_fields';
  bin?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Credit_Cards_Stddev_Samp_Fields = {
  __typename?: 'credit_cards_stddev_samp_fields';
  bin?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "credit_cards" */
export type Credit_Cards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Cards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Cards_Stream_Cursor_Value_Input = {
  bin?: InputMaybe<Scalars['Int']>;
  cardholder_address?: InputMaybe<Scalars['String']>;
  cardholder_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit_card_number?: InputMaybe<Scalars['String']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Credit_Cards_Sum_Fields = {
  __typename?: 'credit_cards_sum_fields';
  bin?: Maybe<Scalars['Int']>;
};

/** update columns of table "credit_cards" */
export enum Credit_Cards_Update_Column {
  /** column name */
  Bin = 'bin',
  /** column name */
  CardholderAddress = 'cardholder_address',
  /** column name */
  CardholderName = 'cardholder_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditCardNumber = 'credit_card_number',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Credit_Cards_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Credit_Cards_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Credit_Cards_Set_Input>;
  /** filter the rows which have to be updated */
  where: Credit_Cards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Credit_Cards_Var_Pop_Fields = {
  __typename?: 'credit_cards_var_pop_fields';
  bin?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Credit_Cards_Var_Samp_Fields = {
  __typename?: 'credit_cards_var_samp_fields';
  bin?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Credit_Cards_Variance_Fields = {
  __typename?: 'credit_cards_variance_fields';
  bin?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "customer_assets" */
export type Customer_Assets = {
  __typename?: 'customer_assets';
  created_at: Scalars['timestamp'];
  /** An array relationship */
  customer_assets_to_brands: Array<Customer_Assets_To_Brands>;
  /** An aggregate relationship */
  customer_assets_to_brands_aggregate: Customer_Assets_To_Brands_Aggregate;
  /** An object relationship */
  full_url?: Maybe<Full_Urls>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  mobile_app?: Maybe<Mobile_Apps>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id: Scalars['uuid'];
  /** An object relationship */
  platform_subtype?: Maybe<Platform_Subtypes>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  social_media_data?: Maybe<Social_Media_Data>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user?: Maybe<Users>;
  value: Scalars['String'];
};


/** columns and relationships of "customer_assets" */
export type Customer_AssetsCustomer_Assets_To_BrandsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_To_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_To_Brands_Order_By>>;
  where?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
};


/** columns and relationships of "customer_assets" */
export type Customer_AssetsCustomer_Assets_To_Brands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_To_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_To_Brands_Order_By>>;
  where?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
};

/** aggregated selection of "customer_assets" */
export type Customer_Assets_Aggregate = {
  __typename?: 'customer_assets_aggregate';
  aggregate?: Maybe<Customer_Assets_Aggregate_Fields>;
  nodes: Array<Customer_Assets>;
};

/** aggregate fields of "customer_assets" */
export type Customer_Assets_Aggregate_Fields = {
  __typename?: 'customer_assets_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Customer_Assets_Max_Fields>;
  min?: Maybe<Customer_Assets_Min_Fields>;
};


/** aggregate fields of "customer_assets" */
export type Customer_Assets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "customer_assets". All fields are combined with a logical 'AND'. */
export type Customer_Assets_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Assets_Bool_Exp>>;
  _not?: InputMaybe<Customer_Assets_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Assets_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_assets_to_brands?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
  customer_assets_to_brands_aggregate?: InputMaybe<Customer_Assets_To_Brands_Aggregate_Bool_Exp>;
  full_url?: InputMaybe<Full_Urls_Bool_Exp>;
  full_url_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  mobile_app?: InputMaybe<Mobile_Apps_Bool_Exp>;
  mobile_app_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Bool_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  social_media_data?: InputMaybe<Social_Media_Data_Bool_Exp>;
  social_media_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_assets" */
export enum Customer_Assets_Constraint {
  /** unique or primary key constraint on columns "organization_id", "value" */
  CustomerAssetsOrganizationIdValueKey = 'customer_assets_organization_id_value_key',
  /** unique or primary key constraint on columns "id" */
  CustomerAssetsPkey = 'customer_assets_pkey'
}

/** input type for inserting data into table "customer_assets" */
export type Customer_Assets_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  customer_assets_to_brands?: InputMaybe<Customer_Assets_To_Brands_Arr_Rel_Insert_Input>;
  full_url?: InputMaybe<Full_Urls_Obj_Rel_Insert_Input>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  mobile_app?: InputMaybe<Mobile_Apps_Obj_Rel_Insert_Input>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Obj_Rel_Insert_Input>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  social_media_data?: InputMaybe<Social_Media_Data_Obj_Rel_Insert_Input>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Customer_Assets_Max_Fields = {
  __typename?: 'customer_assets_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Customer_Assets_Min_Fields = {
  __typename?: 'customer_assets_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "customer_assets" */
export type Customer_Assets_Mutation_Response = {
  __typename?: 'customer_assets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Assets>;
};

/** input type for inserting object relation for remote table "customer_assets" */
export type Customer_Assets_Obj_Rel_Insert_Input = {
  data: Customer_Assets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Assets_On_Conflict>;
};

/** on_conflict condition type for table "customer_assets" */
export type Customer_Assets_On_Conflict = {
  constraint: Customer_Assets_Constraint;
  update_columns?: Array<Customer_Assets_Update_Column>;
  where?: InputMaybe<Customer_Assets_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_assets". */
export type Customer_Assets_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_assets_to_brands_aggregate?: InputMaybe<Customer_Assets_To_Brands_Aggregate_Order_By>;
  full_url?: InputMaybe<Full_Urls_Order_By>;
  full_url_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_by_user_id?: InputMaybe<Order_By>;
  mobile_app?: InputMaybe<Mobile_Apps_Order_By>;
  mobile_app_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  social_media_data?: InputMaybe<Social_Media_Data_Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_assets */
export type Customer_Assets_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "customer_assets" */
export enum Customer_Assets_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FullUrlId = 'full_url_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedByUserId = 'last_updated_by_user_id',
  /** column name */
  MobileAppId = 'mobile_app_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "customer_assets" */
export type Customer_Assets_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "customer_assets" */
export type Customer_Assets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Assets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Assets_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  value?: InputMaybe<Scalars['String']>;
};

/** bridge table between customer assets and brands (spoofing entities) */
export type Customer_Assets_To_Brands = {
  __typename?: 'customer_assets_to_brands';
  /** An object relationship */
  brand?: Maybe<Spoofing_Entities>;
  brand_id: Scalars['uuid'];
  /** An object relationship */
  customer_asset?: Maybe<Customer_Assets>;
  customer_asset_id: Scalars['uuid'];
};

/** aggregated selection of "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_Aggregate = {
  __typename?: 'customer_assets_to_brands_aggregate';
  aggregate?: Maybe<Customer_Assets_To_Brands_Aggregate_Fields>;
  nodes: Array<Customer_Assets_To_Brands>;
};

export type Customer_Assets_To_Brands_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_Assets_To_Brands_Aggregate_Bool_Exp_Count>;
};

export type Customer_Assets_To_Brands_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Assets_To_Brands_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_Aggregate_Fields = {
  __typename?: 'customer_assets_to_brands_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Customer_Assets_To_Brands_Max_Fields>;
  min?: Maybe<Customer_Assets_To_Brands_Min_Fields>;
};


/** aggregate fields of "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Assets_To_Brands_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Assets_To_Brands_Max_Order_By>;
  min?: InputMaybe<Customer_Assets_To_Brands_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_Arr_Rel_Insert_Input = {
  data: Array<Customer_Assets_To_Brands_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Assets_To_Brands_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_assets_to_brands". All fields are combined with a logical 'AND'. */
export type Customer_Assets_To_Brands_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Assets_To_Brands_Bool_Exp>>;
  _not?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Assets_To_Brands_Bool_Exp>>;
  brand?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Assets_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_assets_to_brands" */
export enum Customer_Assets_To_Brands_Constraint {
  /** unique or primary key constraint on columns "brand_id", "customer_asset_id" */
  CustomerAssetsToBrandsPkey = 'customer_assets_to_brands_pkey'
}

/** input type for inserting data into table "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_Insert_Input = {
  brand?: InputMaybe<Spoofing_Entities_Obj_Rel_Insert_Input>;
  brand_id?: InputMaybe<Scalars['uuid']>;
  customer_asset?: InputMaybe<Customer_Assets_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Customer_Assets_To_Brands_Max_Fields = {
  __typename?: 'customer_assets_to_brands_max_fields';
  brand_id?: Maybe<Scalars['uuid']>;
  customer_asset_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_Max_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Assets_To_Brands_Min_Fields = {
  __typename?: 'customer_assets_to_brands_min_fields';
  brand_id?: Maybe<Scalars['uuid']>;
  customer_asset_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_Min_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_Mutation_Response = {
  __typename?: 'customer_assets_to_brands_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Assets_To_Brands>;
};

/** on_conflict condition type for table "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_On_Conflict = {
  constraint: Customer_Assets_To_Brands_Constraint;
  update_columns?: Array<Customer_Assets_To_Brands_Update_Column>;
  where?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_assets_to_brands". */
export type Customer_Assets_To_Brands_Order_By = {
  brand?: InputMaybe<Spoofing_Entities_Order_By>;
  brand_id?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Assets_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_assets_to_brands */
export type Customer_Assets_To_Brands_Pk_Columns_Input = {
  brand_id: Scalars['uuid'];
  customer_asset_id: Scalars['uuid'];
};

/** select columns of table "customer_assets_to_brands" */
export enum Customer_Assets_To_Brands_Select_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CustomerAssetId = 'customer_asset_id'
}

/** input type for updating data in table "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_Set_Input = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "customer_assets_to_brands" */
export type Customer_Assets_To_Brands_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Assets_To_Brands_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Assets_To_Brands_Stream_Cursor_Value_Input = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "customer_assets_to_brands" */
export enum Customer_Assets_To_Brands_Update_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CustomerAssetId = 'customer_asset_id'
}

export type Customer_Assets_To_Brands_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Assets_To_Brands_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Assets_To_Brands_Bool_Exp;
};

/** update columns of table "customer_assets" */
export enum Customer_Assets_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FullUrlId = 'full_url_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedByUserId = 'last_updated_by_user_id',
  /** column name */
  MobileAppId = 'mobile_app_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Customer_Assets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Assets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Assets_Bool_Exp;
};

/** information about dark web */
export type Dark_Web = {
  __typename?: 'dark_web';
  additional_data?: Maybe<Scalars['jsonb']>;
  body?: Maybe<Scalars['String']>;
  body_hash?: Maybe<Scalars['String']>;
  crawled_at: Scalars['timestamp'];
  created_at: Scalars['timestamp'];
  /** URL that user/pass is associated with */
  credential_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  credit_card?: Maybe<Credit_Cards>;
  credit_card_id?: Maybe<Scalars['uuid']>;
  domain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  intelx_unique_key?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  languages?: Maybe<Scalars['jsonb']>;
  leak_name?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['dark_web_network']>;
  organization_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  password_type?: Maybe<Scalars['dark_web_password']>;
  risk_score?: Maybe<Scalars['numeric']>;
  source: Scalars['String'];
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  translated_body?: Maybe<Scalars['String']>;
  translated_title?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  /** Location where data was found */
  url?: Maybe<Scalars['String']>;
};


/** information about dark web */
export type Dark_WebAdditional_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** information about dark web */
export type Dark_WebLanguagesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "dark_web" */
export type Dark_Web_Aggregate = {
  __typename?: 'dark_web_aggregate';
  aggregate?: Maybe<Dark_Web_Aggregate_Fields>;
  nodes: Array<Dark_Web>;
};

/** aggregate fields of "dark_web" */
export type Dark_Web_Aggregate_Fields = {
  __typename?: 'dark_web_aggregate_fields';
  avg?: Maybe<Dark_Web_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Dark_Web_Max_Fields>;
  min?: Maybe<Dark_Web_Min_Fields>;
  stddev?: Maybe<Dark_Web_Stddev_Fields>;
  stddev_pop?: Maybe<Dark_Web_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dark_Web_Stddev_Samp_Fields>;
  sum?: Maybe<Dark_Web_Sum_Fields>;
  var_pop?: Maybe<Dark_Web_Var_Pop_Fields>;
  var_samp?: Maybe<Dark_Web_Var_Samp_Fields>;
  variance?: Maybe<Dark_Web_Variance_Fields>;
};


/** aggregate fields of "dark_web" */
export type Dark_Web_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dark_Web_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

export type Dark_Web_Alerts_Surfaced_Top_Metrics = {
  __typename?: 'dark_web_alerts_surfaced_top_metrics';
  metric: Scalars['String'];
  total_alerts: Scalars['Int'];
};

/** dark_web_alerts_surfaced_top_metricsNative Query Arguments */
export type Dark_Web_Alerts_Surfaced_Top_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  dark_web_leak_contents?: InputMaybe<Scalars['String']>;
  email_regex?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  metric_type: Scalars['String'];
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  password_regex?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the logical model for "dark_web_alerts_surfaced_top_metrics". All fields are combined with a logical 'AND'. */
export type Dark_Web_Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Dark_Web_Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Dark_Web_Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Dark_Web_Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp>>;
  metric?: InputMaybe<String_Comparison_Exp>;
  total_alerts?: InputMaybe<Int_Comparison_Exp>;
};

export enum Dark_Web_Alerts_Surfaced_Top_Metrics_Enum_Name {
  /** column name */
  Metric = 'metric',
  /** column name */
  TotalAlerts = 'total_alerts'
}

/** Ordering options when selecting data from "dark_web_alerts_surfaced_top_metrics". */
export type Dark_Web_Alerts_Surfaced_Top_Metrics_Order_By = {
  metric?: InputMaybe<Order_By>;
  total_alerts?: InputMaybe<Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Dark_Web_Append_Input = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  languages?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Dark_Web_Avg_Fields = {
  __typename?: 'dark_web_avg_fields';
  risk_score?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "dark_web". All fields are combined with a logical 'AND'. */
export type Dark_Web_Bool_Exp = {
  _and?: InputMaybe<Array<Dark_Web_Bool_Exp>>;
  _not?: InputMaybe<Dark_Web_Bool_Exp>;
  _or?: InputMaybe<Array<Dark_Web_Bool_Exp>>;
  additional_data?: InputMaybe<Jsonb_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  body_hash?: InputMaybe<String_Comparison_Exp>;
  crawled_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  credential_url?: InputMaybe<String_Comparison_Exp>;
  credit_card?: InputMaybe<Credit_Cards_Bool_Exp>;
  credit_card_id?: InputMaybe<Uuid_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  intelx_unique_key?: InputMaybe<String_Comparison_Exp>;
  ip?: InputMaybe<String_Comparison_Exp>;
  languages?: InputMaybe<Jsonb_Comparison_Exp>;
  leak_name?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  network?: InputMaybe<Dark_Web_Network_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  password_type?: InputMaybe<Dark_Web_Password_Comparison_Exp>;
  risk_score?: InputMaybe<Numeric_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  source_query?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_body?: InputMaybe<String_Comparison_Exp>;
  translated_title?: InputMaybe<String_Comparison_Exp>;
  uri?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dark_web" */
export enum Dark_Web_Constraint {
  /** unique or primary key constraint on columns "id" */
  DarkWebDataPkey = 'dark_web_data_pkey',
  /** unique or primary key constraint on columns "body_hash", "external_id", "source" */
  DarkWebExternalIdSourceBodyHashKey = 'dark_web_external_id_source_body_hash_key',
  /** unique or primary key constraint on columns "intelx_unique_key" */
  DarkWebIntelxUniqueKeyKey = 'dark_web_intelx_unique_key_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Dark_Web_Delete_At_Path_Input = {
  additional_data?: InputMaybe<Array<Scalars['String']>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Dark_Web_Delete_Elem_Input = {
  additional_data?: InputMaybe<Scalars['Int']>;
  languages?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Dark_Web_Delete_Key_Input = {
  additional_data?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "dark_web" */
export type Dark_Web_Inc_Input = {
  risk_score?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "dark_web" */
export type Dark_Web_Insert_Input = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  body?: InputMaybe<Scalars['String']>;
  body_hash?: InputMaybe<Scalars['String']>;
  crawled_at?: InputMaybe<Scalars['timestamp']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  /** URL that user/pass is associated with */
  credential_url?: InputMaybe<Scalars['String']>;
  credit_card?: InputMaybe<Credit_Cards_Obj_Rel_Insert_Input>;
  credit_card_id?: InputMaybe<Scalars['uuid']>;
  domain?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  intelx_unique_key?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Scalars['jsonb']>;
  leak_name?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  network?: InputMaybe<Scalars['dark_web_network']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  password?: InputMaybe<Scalars['String']>;
  password_type?: InputMaybe<Scalars['dark_web_password']>;
  risk_score?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  translated_body?: InputMaybe<Scalars['String']>;
  translated_title?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
  /** Location where data was found */
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Dark_Web_Max_Fields = {
  __typename?: 'dark_web_max_fields';
  body?: Maybe<Scalars['String']>;
  body_hash?: Maybe<Scalars['String']>;
  crawled_at?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamp']>;
  /** URL that user/pass is associated with */
  credential_url?: Maybe<Scalars['String']>;
  credit_card_id?: Maybe<Scalars['uuid']>;
  domain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  intelx_unique_key?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  leak_name?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['dark_web_network']>;
  organization_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  password_type?: Maybe<Scalars['dark_web_password']>;
  risk_score?: Maybe<Scalars['numeric']>;
  source?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  translated_body?: Maybe<Scalars['String']>;
  translated_title?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  /** Location where data was found */
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Dark_Web_Min_Fields = {
  __typename?: 'dark_web_min_fields';
  body?: Maybe<Scalars['String']>;
  body_hash?: Maybe<Scalars['String']>;
  crawled_at?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamp']>;
  /** URL that user/pass is associated with */
  credential_url?: Maybe<Scalars['String']>;
  credit_card_id?: Maybe<Scalars['uuid']>;
  domain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  intelx_unique_key?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  leak_name?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['dark_web_network']>;
  organization_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  password_type?: Maybe<Scalars['dark_web_password']>;
  risk_score?: Maybe<Scalars['numeric']>;
  source?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  translated_body?: Maybe<Scalars['String']>;
  translated_title?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  /** Location where data was found */
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "dark_web" */
export type Dark_Web_Mutation_Response = {
  __typename?: 'dark_web_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Dark_Web>;
};

/** Boolean expression to compare columns of type "dark_web_network". All fields are combined with logical 'AND'. */
export type Dark_Web_Network_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['dark_web_network']>;
  _gt?: InputMaybe<Scalars['dark_web_network']>;
  _gte?: InputMaybe<Scalars['dark_web_network']>;
  _in?: InputMaybe<Array<Scalars['dark_web_network']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['dark_web_network']>;
  _lte?: InputMaybe<Scalars['dark_web_network']>;
  _neq?: InputMaybe<Scalars['dark_web_network']>;
  _nin?: InputMaybe<Array<Scalars['dark_web_network']>>;
};

/** input type for inserting object relation for remote table "dark_web" */
export type Dark_Web_Obj_Rel_Insert_Input = {
  data: Dark_Web_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dark_Web_On_Conflict>;
};

/** on_conflict condition type for table "dark_web" */
export type Dark_Web_On_Conflict = {
  constraint: Dark_Web_Constraint;
  update_columns?: Array<Dark_Web_Update_Column>;
  where?: InputMaybe<Dark_Web_Bool_Exp>;
};

/** Ordering options when selecting data from "dark_web". */
export type Dark_Web_Order_By = {
  additional_data?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  body_hash?: InputMaybe<Order_By>;
  crawled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credential_url?: InputMaybe<Order_By>;
  credit_card?: InputMaybe<Credit_Cards_Order_By>;
  credit_card_id?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intelx_unique_key?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  leak_name?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  password_type?: InputMaybe<Order_By>;
  risk_score?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_query?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_body?: InputMaybe<Order_By>;
  translated_title?: InputMaybe<Order_By>;
  uri?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "dark_web_password". All fields are combined with logical 'AND'. */
export type Dark_Web_Password_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['dark_web_password']>;
  _gt?: InputMaybe<Scalars['dark_web_password']>;
  _gte?: InputMaybe<Scalars['dark_web_password']>;
  _in?: InputMaybe<Array<Scalars['dark_web_password']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['dark_web_password']>;
  _lte?: InputMaybe<Scalars['dark_web_password']>;
  _neq?: InputMaybe<Scalars['dark_web_password']>;
  _nin?: InputMaybe<Array<Scalars['dark_web_password']>>;
};

/** primary key columns input for table: dark_web */
export type Dark_Web_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Dark_Web_Prepend_Input = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  languages?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "dark_web" */
export enum Dark_Web_Select_Column {
  /** column name */
  AdditionalData = 'additional_data',
  /** column name */
  Body = 'body',
  /** column name */
  BodyHash = 'body_hash',
  /** column name */
  CrawledAt = 'crawled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CredentialUrl = 'credential_url',
  /** column name */
  CreditCardId = 'credit_card_id',
  /** column name */
  Domain = 'domain',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  IntelxUniqueKey = 'intelx_unique_key',
  /** column name */
  Ip = 'ip',
  /** column name */
  Languages = 'languages',
  /** column name */
  LeakName = 'leak_name',
  /** column name */
  Location = 'location',
  /** column name */
  Network = 'network',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Password = 'password',
  /** column name */
  PasswordType = 'password_type',
  /** column name */
  RiskScore = 'risk_score',
  /** column name */
  Source = 'source',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedBody = 'translated_body',
  /** column name */
  TranslatedTitle = 'translated_title',
  /** column name */
  Uri = 'uri',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "dark_web" */
export type Dark_Web_Set_Input = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  body?: InputMaybe<Scalars['String']>;
  body_hash?: InputMaybe<Scalars['String']>;
  crawled_at?: InputMaybe<Scalars['timestamp']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  /** URL that user/pass is associated with */
  credential_url?: InputMaybe<Scalars['String']>;
  credit_card_id?: InputMaybe<Scalars['uuid']>;
  domain?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  intelx_unique_key?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Scalars['jsonb']>;
  leak_name?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  network?: InputMaybe<Scalars['dark_web_network']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  password?: InputMaybe<Scalars['String']>;
  password_type?: InputMaybe<Scalars['dark_web_password']>;
  risk_score?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  translated_body?: InputMaybe<Scalars['String']>;
  translated_title?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
  /** Location where data was found */
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Dark_Web_Stddev_Fields = {
  __typename?: 'dark_web_stddev_fields';
  risk_score?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Dark_Web_Stddev_Pop_Fields = {
  __typename?: 'dark_web_stddev_pop_fields';
  risk_score?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Dark_Web_Stddev_Samp_Fields = {
  __typename?: 'dark_web_stddev_samp_fields';
  risk_score?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "dark_web" */
export type Dark_Web_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dark_Web_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dark_Web_Stream_Cursor_Value_Input = {
  additional_data?: InputMaybe<Scalars['jsonb']>;
  body?: InputMaybe<Scalars['String']>;
  body_hash?: InputMaybe<Scalars['String']>;
  crawled_at?: InputMaybe<Scalars['timestamp']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  /** URL that user/pass is associated with */
  credential_url?: InputMaybe<Scalars['String']>;
  credit_card_id?: InputMaybe<Scalars['uuid']>;
  domain?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  intelx_unique_key?: InputMaybe<Scalars['String']>;
  ip?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Scalars['jsonb']>;
  leak_name?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  network?: InputMaybe<Scalars['dark_web_network']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  password?: InputMaybe<Scalars['String']>;
  password_type?: InputMaybe<Scalars['dark_web_password']>;
  risk_score?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  translated_body?: InputMaybe<Scalars['String']>;
  translated_title?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
  /** Location where data was found */
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Dark_Web_Sum_Fields = {
  __typename?: 'dark_web_sum_fields';
  risk_score?: Maybe<Scalars['numeric']>;
};

/** update columns of table "dark_web" */
export enum Dark_Web_Update_Column {
  /** column name */
  AdditionalData = 'additional_data',
  /** column name */
  Body = 'body',
  /** column name */
  BodyHash = 'body_hash',
  /** column name */
  CrawledAt = 'crawled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CredentialUrl = 'credential_url',
  /** column name */
  CreditCardId = 'credit_card_id',
  /** column name */
  Domain = 'domain',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  IntelxUniqueKey = 'intelx_unique_key',
  /** column name */
  Ip = 'ip',
  /** column name */
  Languages = 'languages',
  /** column name */
  LeakName = 'leak_name',
  /** column name */
  Location = 'location',
  /** column name */
  Network = 'network',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Password = 'password',
  /** column name */
  PasswordType = 'password_type',
  /** column name */
  RiskScore = 'risk_score',
  /** column name */
  Source = 'source',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedBody = 'translated_body',
  /** column name */
  TranslatedTitle = 'translated_title',
  /** column name */
  Uri = 'uri',
  /** column name */
  Url = 'url'
}

export type Dark_Web_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Dark_Web_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Dark_Web_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Dark_Web_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Dark_Web_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Dark_Web_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Dark_Web_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dark_Web_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dark_Web_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Dark_Web_Var_Pop_Fields = {
  __typename?: 'dark_web_var_pop_fields';
  risk_score?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Dark_Web_Var_Samp_Fields = {
  __typename?: 'dark_web_var_samp_fields';
  risk_score?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Dark_Web_Variance_Fields = {
  __typename?: 'dark_web_variance_fields';
  risk_score?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** https://docs.google.com/document/d/1BtaxmRq3olg5cPNrywWXprSy0XosGSv5ctpjGDQZtbI/edit?pli=1 */
export type Defensive_Domain_Registration = {
  __typename?: 'defensive_domain_registration';
  created_at: Scalars['timestamp'];
  /** An object relationship */
  domain_data: Domain_Data;
  domain_data_id: Scalars['uuid'];
  id: Scalars['uuid'];
  organization_id: Scalars['uuid'];
  price: Scalars['numeric'];
  purchased_at?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  spoofing_report?: Maybe<Spoofing_Reports>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamp'];
};

/** aggregated selection of "defensive_domain_registration" */
export type Defensive_Domain_Registration_Aggregate = {
  __typename?: 'defensive_domain_registration_aggregate';
  aggregate?: Maybe<Defensive_Domain_Registration_Aggregate_Fields>;
  nodes: Array<Defensive_Domain_Registration>;
};

/** aggregate fields of "defensive_domain_registration" */
export type Defensive_Domain_Registration_Aggregate_Fields = {
  __typename?: 'defensive_domain_registration_aggregate_fields';
  avg?: Maybe<Defensive_Domain_Registration_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Defensive_Domain_Registration_Max_Fields>;
  min?: Maybe<Defensive_Domain_Registration_Min_Fields>;
  stddev?: Maybe<Defensive_Domain_Registration_Stddev_Fields>;
  stddev_pop?: Maybe<Defensive_Domain_Registration_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Defensive_Domain_Registration_Stddev_Samp_Fields>;
  sum?: Maybe<Defensive_Domain_Registration_Sum_Fields>;
  var_pop?: Maybe<Defensive_Domain_Registration_Var_Pop_Fields>;
  var_samp?: Maybe<Defensive_Domain_Registration_Var_Samp_Fields>;
  variance?: Maybe<Defensive_Domain_Registration_Variance_Fields>;
};


/** aggregate fields of "defensive_domain_registration" */
export type Defensive_Domain_Registration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Defensive_Domain_Registration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Defensive_Domain_Registration_Avg_Fields = {
  __typename?: 'defensive_domain_registration_avg_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "defensive_domain_registration". All fields are combined with a logical 'AND'. */
export type Defensive_Domain_Registration_Bool_Exp = {
  _and?: InputMaybe<Array<Defensive_Domain_Registration_Bool_Exp>>;
  _not?: InputMaybe<Defensive_Domain_Registration_Bool_Exp>;
  _or?: InputMaybe<Array<Defensive_Domain_Registration_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  domain_data?: InputMaybe<Domain_Data_Bool_Exp>;
  domain_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  purchased_at?: InputMaybe<Timestamp_Comparison_Exp>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  spoofing_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "defensive_domain_registration" */
export enum Defensive_Domain_Registration_Constraint {
  /** unique or primary key constraint on columns "organization_id", "domain_data_id" */
  DefensiveDomainRegistrationDomainDataIdOrganizationIKey = 'defensive_domain_registration_domain_data_id_organization_i_key',
  /** unique or primary key constraint on columns "id" */
  DefensiveDomainRegistrationPkey = 'defensive_domain_registration_pkey'
}

/** input type for incrementing numeric columns in table "defensive_domain_registration" */
export type Defensive_Domain_Registration_Inc_Input = {
  price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "defensive_domain_registration" */
export type Defensive_Domain_Registration_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data?: InputMaybe<Domain_Data_Obj_Rel_Insert_Input>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  purchased_at?: InputMaybe<Scalars['timestamp']>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Defensive_Domain_Registration_Max_Fields = {
  __typename?: 'defensive_domain_registration_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  purchased_at?: Maybe<Scalars['timestamp']>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Defensive_Domain_Registration_Min_Fields = {
  __typename?: 'defensive_domain_registration_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['numeric']>;
  purchased_at?: Maybe<Scalars['timestamp']>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "defensive_domain_registration" */
export type Defensive_Domain_Registration_Mutation_Response = {
  __typename?: 'defensive_domain_registration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Defensive_Domain_Registration>;
};

/** on_conflict condition type for table "defensive_domain_registration" */
export type Defensive_Domain_Registration_On_Conflict = {
  constraint: Defensive_Domain_Registration_Constraint;
  update_columns?: Array<Defensive_Domain_Registration_Update_Column>;
  where?: InputMaybe<Defensive_Domain_Registration_Bool_Exp>;
};

/** Ordering options when selecting data from "defensive_domain_registration". */
export type Defensive_Domain_Registration_Order_By = {
  created_at?: InputMaybe<Order_By>;
  domain_data?: InputMaybe<Domain_Data_Order_By>;
  domain_data_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  purchased_at?: InputMaybe<Order_By>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Order_By>;
  spoofing_report_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: defensive_domain_registration */
export type Defensive_Domain_Registration_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "defensive_domain_registration" */
export enum Defensive_Domain_Registration_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainDataId = 'domain_data_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Price = 'price',
  /** column name */
  PurchasedAt = 'purchased_at',
  /** column name */
  SpoofingReportId = 'spoofing_report_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "defensive_domain_registration" */
export type Defensive_Domain_Registration_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  purchased_at?: InputMaybe<Scalars['timestamp']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Defensive_Domain_Registration_Stddev_Fields = {
  __typename?: 'defensive_domain_registration_stddev_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Defensive_Domain_Registration_Stddev_Pop_Fields = {
  __typename?: 'defensive_domain_registration_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Defensive_Domain_Registration_Stddev_Samp_Fields = {
  __typename?: 'defensive_domain_registration_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "defensive_domain_registration" */
export type Defensive_Domain_Registration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Defensive_Domain_Registration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Defensive_Domain_Registration_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['numeric']>;
  purchased_at?: InputMaybe<Scalars['timestamp']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type Defensive_Domain_Registration_Sum_Fields = {
  __typename?: 'defensive_domain_registration_sum_fields';
  price?: Maybe<Scalars['numeric']>;
};

/** update columns of table "defensive_domain_registration" */
export enum Defensive_Domain_Registration_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainDataId = 'domain_data_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Price = 'price',
  /** column name */
  PurchasedAt = 'purchased_at',
  /** column name */
  SpoofingReportId = 'spoofing_report_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Defensive_Domain_Registration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Defensive_Domain_Registration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Defensive_Domain_Registration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Defensive_Domain_Registration_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Defensive_Domain_Registration_Var_Pop_Fields = {
  __typename?: 'defensive_domain_registration_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Defensive_Domain_Registration_Var_Samp_Fields = {
  __typename?: 'defensive_domain_registration_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Defensive_Domain_Registration_Variance_Fields = {
  __typename?: 'defensive_domain_registration_variance_fields';
  price?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "designated_takedown_assets" */
export type Designated_Takedown_Assets = {
  __typename?: 'designated_takedown_assets';
  brand_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  customer_asset: Customer_Assets;
  customer_asset_id: Scalars['uuid'];
  id: Scalars['uuid'];
  is_organization_default: Scalars['Boolean'];
  /** An object relationship */
  spoofing_entity?: Maybe<Spoofing_Entities>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "designated_takedown_assets" */
export type Designated_Takedown_Assets_Aggregate = {
  __typename?: 'designated_takedown_assets_aggregate';
  aggregate?: Maybe<Designated_Takedown_Assets_Aggregate_Fields>;
  nodes: Array<Designated_Takedown_Assets>;
};

export type Designated_Takedown_Assets_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Designated_Takedown_Assets_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Designated_Takedown_Assets_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Designated_Takedown_Assets_Aggregate_Bool_Exp_Count>;
};

export type Designated_Takedown_Assets_Aggregate_Bool_Exp_Bool_And = {
  arguments: Designated_Takedown_Assets_Select_Column_Designated_Takedown_Assets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Designated_Takedown_Assets_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Designated_Takedown_Assets_Select_Column_Designated_Takedown_Assets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Designated_Takedown_Assets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Designated_Takedown_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "designated_takedown_assets" */
export type Designated_Takedown_Assets_Aggregate_Fields = {
  __typename?: 'designated_takedown_assets_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Designated_Takedown_Assets_Max_Fields>;
  min?: Maybe<Designated_Takedown_Assets_Min_Fields>;
};


/** aggregate fields of "designated_takedown_assets" */
export type Designated_Takedown_Assets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Designated_Takedown_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "designated_takedown_assets" */
export type Designated_Takedown_Assets_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Designated_Takedown_Assets_Max_Order_By>;
  min?: InputMaybe<Designated_Takedown_Assets_Min_Order_By>;
};

/** input type for inserting array relation for remote table "designated_takedown_assets" */
export type Designated_Takedown_Assets_Arr_Rel_Insert_Input = {
  data: Array<Designated_Takedown_Assets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Designated_Takedown_Assets_On_Conflict>;
};

/** Boolean expression to filter rows from the table "designated_takedown_assets". All fields are combined with a logical 'AND'. */
export type Designated_Takedown_Assets_Bool_Exp = {
  _and?: InputMaybe<Array<Designated_Takedown_Assets_Bool_Exp>>;
  _not?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
  _or?: InputMaybe<Array<Designated_Takedown_Assets_Bool_Exp>>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_asset?: InputMaybe<Customer_Assets_Bool_Exp>;
  customer_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_organization_default?: InputMaybe<Boolean_Comparison_Exp>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "designated_takedown_assets" */
export enum Designated_Takedown_Assets_Constraint {
  /** unique or primary key constraint on columns "brand_id", "customer_asset_id" */
  DesignatedTakedownAssetsCustomerAssetIdBrandIdKey = 'designated_takedown_assets_customer_asset_id_brand_id_key',
  /** unique or primary key constraint on columns "id" */
  DesignatedTakedownAssetsPkey = 'designated_takedown_assets_pkey',
  /** unique or primary key constraint on columns "customer_asset_id" */
  UniqueOrgDefaultAsset = 'unique_org_default_asset'
}

/** input type for inserting data into table "designated_takedown_assets" */
export type Designated_Takedown_Assets_Insert_Input = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  customer_asset?: InputMaybe<Customer_Assets_Obj_Rel_Insert_Input>;
  customer_asset_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_organization_default?: InputMaybe<Scalars['Boolean']>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Designated_Takedown_Assets_Max_Fields = {
  __typename?: 'designated_takedown_assets_max_fields';
  brand_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_asset_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "designated_takedown_assets" */
export type Designated_Takedown_Assets_Max_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Designated_Takedown_Assets_Min_Fields = {
  __typename?: 'designated_takedown_assets_min_fields';
  brand_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_asset_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "designated_takedown_assets" */
export type Designated_Takedown_Assets_Min_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "designated_takedown_assets" */
export type Designated_Takedown_Assets_Mutation_Response = {
  __typename?: 'designated_takedown_assets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Designated_Takedown_Assets>;
};

/** on_conflict condition type for table "designated_takedown_assets" */
export type Designated_Takedown_Assets_On_Conflict = {
  constraint: Designated_Takedown_Assets_Constraint;
  update_columns?: Array<Designated_Takedown_Assets_Update_Column>;
  where?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
};

/** Ordering options when selecting data from "designated_takedown_assets". */
export type Designated_Takedown_Assets_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_asset?: InputMaybe<Customer_Assets_Order_By>;
  customer_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_organization_default?: InputMaybe<Order_By>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: designated_takedown_assets */
export type Designated_Takedown_Assets_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "designated_takedown_assets" */
export enum Designated_Takedown_Assets_Select_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsOrganizationDefault = 'is_organization_default',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "designated_takedown_assets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "designated_takedown_assets" */
export enum Designated_Takedown_Assets_Select_Column_Designated_Takedown_Assets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsOrganizationDefault = 'is_organization_default'
}

/** select "designated_takedown_assets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "designated_takedown_assets" */
export enum Designated_Takedown_Assets_Select_Column_Designated_Takedown_Assets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsOrganizationDefault = 'is_organization_default'
}

/** input type for updating data in table "designated_takedown_assets" */
export type Designated_Takedown_Assets_Set_Input = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_organization_default?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "designated_takedown_assets" */
export type Designated_Takedown_Assets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Designated_Takedown_Assets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Designated_Takedown_Assets_Stream_Cursor_Value_Input = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  customer_asset_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_organization_default?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "designated_takedown_assets" */
export enum Designated_Takedown_Assets_Update_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerAssetId = 'customer_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsOrganizationDefault = 'is_organization_default',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Designated_Takedown_Assets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Designated_Takedown_Assets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Designated_Takedown_Assets_Bool_Exp;
};

/** Contains trackable regex rules that may power sourcing, filtering, and classification https://docs.google.com/document/d/13nDiU3zCjpsLv-UahIrAYkTTDSbQwy1r355BNBQNh8A/edit?usp=sharing */
export type Detection_Assets = {
  __typename?: 'detection_assets';
  created_at: Scalars['timestamptz'];
  creation_method?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** specifies where the asset is used (ex: UrlSimilarityFeatureGeneration) */
  enabled_usage: Scalars['String'];
  /** An object relationship */
  full_url?: Maybe<Full_Urls>;
  id: Scalars['uuid'];
  idempotency_key: Scalars['String'];
  /** An object relationship */
  ioc?: Maybe<Iocs>;
  ir_to_dr_rule: Scalars['String'];
  is_generic: Scalars['Boolean'];
  is_valid?: Maybe<Scalars['Boolean']>;
  last_updated_by?: Maybe<Scalars['String']>;
  original_entity_id: Scalars['uuid'];
  /** id of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_id: Scalars['uuid'];
  /** type of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_type: Scalars['String'];
  /** An object relationship */
  protected_asset?: Maybe<Protected_Assets>;
  /** An object relationship */
  social_media?: Maybe<Social_Media_Data>;
  /** An object relationship */
  spoofing_entity: Spoofing_Entities;
  /** specifies type of asset (ex: Favicon, SiteText, SiteHtml) */
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "detection_assets" */
export type Detection_Assets_Aggregate = {
  __typename?: 'detection_assets_aggregate';
  aggregate?: Maybe<Detection_Assets_Aggregate_Fields>;
  nodes: Array<Detection_Assets>;
};

export type Detection_Assets_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Detection_Assets_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Detection_Assets_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Detection_Assets_Aggregate_Bool_Exp_Count>;
};

export type Detection_Assets_Aggregate_Bool_Exp_Bool_And = {
  arguments: Detection_Assets_Select_Column_Detection_Assets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Detection_Assets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Detection_Assets_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Detection_Assets_Select_Column_Detection_Assets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Detection_Assets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Detection_Assets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Detection_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Detection_Assets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "detection_assets" */
export type Detection_Assets_Aggregate_Fields = {
  __typename?: 'detection_assets_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Detection_Assets_Max_Fields>;
  min?: Maybe<Detection_Assets_Min_Fields>;
};


/** aggregate fields of "detection_assets" */
export type Detection_Assets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Detection_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "detection_assets" */
export type Detection_Assets_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Detection_Assets_Max_Order_By>;
  min?: InputMaybe<Detection_Assets_Min_Order_By>;
};

/** input type for inserting array relation for remote table "detection_assets" */
export type Detection_Assets_Arr_Rel_Insert_Input = {
  data: Array<Detection_Assets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Detection_Assets_On_Conflict>;
};

/** Boolean expression to filter rows from the table "detection_assets". All fields are combined with a logical 'AND'. */
export type Detection_Assets_Bool_Exp = {
  _and?: InputMaybe<Array<Detection_Assets_Bool_Exp>>;
  _not?: InputMaybe<Detection_Assets_Bool_Exp>;
  _or?: InputMaybe<Array<Detection_Assets_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_method?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  enabled_usage?: InputMaybe<String_Comparison_Exp>;
  full_url?: InputMaybe<Full_Urls_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idempotency_key?: InputMaybe<String_Comparison_Exp>;
  ioc?: InputMaybe<Iocs_Bool_Exp>;
  ir_to_dr_rule?: InputMaybe<String_Comparison_Exp>;
  is_generic?: InputMaybe<Boolean_Comparison_Exp>;
  is_valid?: InputMaybe<Boolean_Comparison_Exp>;
  last_updated_by?: InputMaybe<String_Comparison_Exp>;
  original_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  originator_id?: InputMaybe<Uuid_Comparison_Exp>;
  originator_type?: InputMaybe<String_Comparison_Exp>;
  protected_asset?: InputMaybe<Protected_Assets_Bool_Exp>;
  social_media?: InputMaybe<Social_Media_Data_Bool_Exp>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "detection_assets" */
export enum Detection_Assets_Constraint {
  /** unique or primary key constraint on columns "idempotency_key" */
  DetectionAssetsIdempotencyKeyKey = 'detection_assets_idempotency_key_key',
  /** unique or primary key constraint on columns "id" */
  RegexRulesPkey = 'regex_rules_pkey'
}

/** input type for inserting data into table "detection_assets" */
export type Detection_Assets_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  creation_method?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** specifies where the asset is used (ex: UrlSimilarityFeatureGeneration) */
  enabled_usage?: InputMaybe<Scalars['String']>;
  full_url?: InputMaybe<Full_Urls_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  idempotency_key?: InputMaybe<Scalars['String']>;
  ioc?: InputMaybe<Iocs_Obj_Rel_Insert_Input>;
  ir_to_dr_rule?: InputMaybe<Scalars['String']>;
  is_generic?: InputMaybe<Scalars['Boolean']>;
  is_valid?: InputMaybe<Scalars['Boolean']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  /** id of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_id?: InputMaybe<Scalars['uuid']>;
  /** type of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_type?: InputMaybe<Scalars['String']>;
  protected_asset?: InputMaybe<Protected_Assets_Obj_Rel_Insert_Input>;
  social_media?: InputMaybe<Social_Media_Data_Obj_Rel_Insert_Input>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Obj_Rel_Insert_Input>;
  /** specifies type of asset (ex: Favicon, SiteText, SiteHtml) */
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Detection_Assets_Max_Fields = {
  __typename?: 'detection_assets_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  creation_method?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** specifies where the asset is used (ex: UrlSimilarityFeatureGeneration) */
  enabled_usage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  idempotency_key?: Maybe<Scalars['String']>;
  ir_to_dr_rule?: Maybe<Scalars['String']>;
  last_updated_by?: Maybe<Scalars['String']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  /** id of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_id?: Maybe<Scalars['uuid']>;
  /** type of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_type?: Maybe<Scalars['String']>;
  /** specifies type of asset (ex: Favicon, SiteText, SiteHtml) */
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "detection_assets" */
export type Detection_Assets_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creation_method?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** specifies where the asset is used (ex: UrlSimilarityFeatureGeneration) */
  enabled_usage?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotency_key?: InputMaybe<Order_By>;
  ir_to_dr_rule?: InputMaybe<Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  /** id of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_id?: InputMaybe<Order_By>;
  /** type of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_type?: InputMaybe<Order_By>;
  /** specifies type of asset (ex: Favicon, SiteText, SiteHtml) */
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Detection_Assets_Min_Fields = {
  __typename?: 'detection_assets_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  creation_method?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** specifies where the asset is used (ex: UrlSimilarityFeatureGeneration) */
  enabled_usage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  idempotency_key?: Maybe<Scalars['String']>;
  ir_to_dr_rule?: Maybe<Scalars['String']>;
  last_updated_by?: Maybe<Scalars['String']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  /** id of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_id?: Maybe<Scalars['uuid']>;
  /** type of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_type?: Maybe<Scalars['String']>;
  /** specifies type of asset (ex: Favicon, SiteText, SiteHtml) */
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "detection_assets" */
export type Detection_Assets_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creation_method?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** specifies where the asset is used (ex: UrlSimilarityFeatureGeneration) */
  enabled_usage?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idempotency_key?: InputMaybe<Order_By>;
  ir_to_dr_rule?: InputMaybe<Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  /** id of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_id?: InputMaybe<Order_By>;
  /** type of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_type?: InputMaybe<Order_By>;
  /** specifies type of asset (ex: Favicon, SiteText, SiteHtml) */
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "detection_assets" */
export type Detection_Assets_Mutation_Response = {
  __typename?: 'detection_assets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Detection_Assets>;
};

/** input type for inserting object relation for remote table "detection_assets" */
export type Detection_Assets_Obj_Rel_Insert_Input = {
  data: Detection_Assets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Detection_Assets_On_Conflict>;
};

/** on_conflict condition type for table "detection_assets" */
export type Detection_Assets_On_Conflict = {
  constraint: Detection_Assets_Constraint;
  update_columns?: Array<Detection_Assets_Update_Column>;
  where?: InputMaybe<Detection_Assets_Bool_Exp>;
};

/** Ordering options when selecting data from "detection_assets". */
export type Detection_Assets_Order_By = {
  created_at?: InputMaybe<Order_By>;
  creation_method?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  enabled_usage?: InputMaybe<Order_By>;
  full_url?: InputMaybe<Full_Urls_Order_By>;
  id?: InputMaybe<Order_By>;
  idempotency_key?: InputMaybe<Order_By>;
  ioc?: InputMaybe<Iocs_Order_By>;
  ir_to_dr_rule?: InputMaybe<Order_By>;
  is_generic?: InputMaybe<Order_By>;
  is_valid?: InputMaybe<Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  originator_id?: InputMaybe<Order_By>;
  originator_type?: InputMaybe<Order_By>;
  protected_asset?: InputMaybe<Protected_Assets_Order_By>;
  social_media?: InputMaybe<Social_Media_Data_Order_By>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: detection_assets */
export type Detection_Assets_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "detection_assets" */
export enum Detection_Assets_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreationMethod = 'creation_method',
  /** column name */
  Description = 'description',
  /** column name */
  EnabledUsage = 'enabled_usage',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotencyKey = 'idempotency_key',
  /** column name */
  IrToDrRule = 'ir_to_dr_rule',
  /** column name */
  IsGeneric = 'is_generic',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  OriginatorId = 'originator_id',
  /** column name */
  OriginatorType = 'originator_type',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** select "detection_assets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "detection_assets" */
export enum Detection_Assets_Select_Column_Detection_Assets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsGeneric = 'is_generic',
  /** column name */
  IsValid = 'is_valid'
}

/** select "detection_assets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "detection_assets" */
export enum Detection_Assets_Select_Column_Detection_Assets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsGeneric = 'is_generic',
  /** column name */
  IsValid = 'is_valid'
}

/** input type for updating data in table "detection_assets" */
export type Detection_Assets_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  creation_method?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** specifies where the asset is used (ex: UrlSimilarityFeatureGeneration) */
  enabled_usage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  idempotency_key?: InputMaybe<Scalars['String']>;
  ir_to_dr_rule?: InputMaybe<Scalars['String']>;
  is_generic?: InputMaybe<Scalars['Boolean']>;
  is_valid?: InputMaybe<Scalars['Boolean']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  /** id of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_id?: InputMaybe<Scalars['uuid']>;
  /** type of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_type?: InputMaybe<Scalars['String']>;
  /** specifies type of asset (ex: Favicon, SiteText, SiteHtml) */
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "detection_assets" */
export type Detection_Assets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Detection_Assets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Detection_Assets_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  creation_method?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** specifies where the asset is used (ex: UrlSimilarityFeatureGeneration) */
  enabled_usage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  idempotency_key?: InputMaybe<Scalars['String']>;
  ir_to_dr_rule?: InputMaybe<Scalars['String']>;
  is_generic?: InputMaybe<Scalars['Boolean']>;
  is_valid?: InputMaybe<Scalars['Boolean']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  /** id of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_id?: InputMaybe<Scalars['uuid']>;
  /** type of the entity triggering the insert (ex: User, ProtectedAsset) */
  originator_type?: InputMaybe<Scalars['String']>;
  /** specifies type of asset (ex: Favicon, SiteText, SiteHtml) */
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "detection_assets" */
export enum Detection_Assets_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreationMethod = 'creation_method',
  /** column name */
  Description = 'description',
  /** column name */
  EnabledUsage = 'enabled_usage',
  /** column name */
  Id = 'id',
  /** column name */
  IdempotencyKey = 'idempotency_key',
  /** column name */
  IrToDrRule = 'ir_to_dr_rule',
  /** column name */
  IsGeneric = 'is_generic',
  /** column name */
  IsValid = 'is_valid',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  OriginatorId = 'originator_id',
  /** column name */
  OriginatorType = 'originator_type',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Detection_Assets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Detection_Assets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Detection_Assets_Bool_Exp;
};

/** columns and relationships of "detection_config_approvals" */
export type Detection_Config_Approvals = {
  __typename?: 'detection_config_approvals';
  approved_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  detection_assets?: Maybe<Detection_Assets>;
  detection_config_id: Scalars['uuid'];
  detection_config_type: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  ioc_detection_config_attribution?: Maybe<Ioc_Detection_Config_Attribution>;
  rejection_reason?: Maybe<Scalars['String']>;
  reviewed_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  rules?: Maybe<Rules>;
  /** An object relationship */
  sourcing_queries?: Maybe<Sourcing_Queries>;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "detection_config_approvals" */
export type Detection_Config_Approvals_Aggregate = {
  __typename?: 'detection_config_approvals_aggregate';
  aggregate?: Maybe<Detection_Config_Approvals_Aggregate_Fields>;
  nodes: Array<Detection_Config_Approvals>;
};

/** aggregate fields of "detection_config_approvals" */
export type Detection_Config_Approvals_Aggregate_Fields = {
  __typename?: 'detection_config_approvals_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Detection_Config_Approvals_Max_Fields>;
  min?: Maybe<Detection_Config_Approvals_Min_Fields>;
};


/** aggregate fields of "detection_config_approvals" */
export type Detection_Config_Approvals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Detection_Config_Approvals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "detection_config_approvals". All fields are combined with a logical 'AND'. */
export type Detection_Config_Approvals_Bool_Exp = {
  _and?: InputMaybe<Array<Detection_Config_Approvals_Bool_Exp>>;
  _not?: InputMaybe<Detection_Config_Approvals_Bool_Exp>;
  _or?: InputMaybe<Array<Detection_Config_Approvals_Bool_Exp>>;
  approved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  detection_assets?: InputMaybe<Detection_Assets_Bool_Exp>;
  detection_config_id?: InputMaybe<Uuid_Comparison_Exp>;
  detection_config_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ioc_detection_config_attribution?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
  rejection_reason?: InputMaybe<String_Comparison_Exp>;
  reviewed_by?: InputMaybe<Uuid_Comparison_Exp>;
  rules?: InputMaybe<Rules_Bool_Exp>;
  sourcing_queries?: InputMaybe<Sourcing_Queries_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "detection_config_approvals" */
export enum Detection_Config_Approvals_Constraint {
  /** unique or primary key constraint on columns "detection_config_type", "detection_config_id" */
  DetectionConfigApprovalsDetectionConfigIdDetectionCoKey = 'detection_config_approvals_detection_config_id_detection_co_key',
  /** unique or primary key constraint on columns "id" */
  DetectionConfigApprovalsPkey = 'detection_config_approvals_pkey'
}

/** input type for inserting data into table "detection_config_approvals" */
export type Detection_Config_Approvals_Insert_Input = {
  approved_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_assets?: InputMaybe<Detection_Assets_Obj_Rel_Insert_Input>;
  detection_config_id?: InputMaybe<Scalars['uuid']>;
  detection_config_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ioc_detection_config_attribution?: InputMaybe<Ioc_Detection_Config_Attribution_Obj_Rel_Insert_Input>;
  rejection_reason?: InputMaybe<Scalars['String']>;
  reviewed_by?: InputMaybe<Scalars['uuid']>;
  rules?: InputMaybe<Rules_Obj_Rel_Insert_Input>;
  sourcing_queries?: InputMaybe<Sourcing_Queries_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Detection_Config_Approvals_Max_Fields = {
  __typename?: 'detection_config_approvals_max_fields';
  approved_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  detection_config_id?: Maybe<Scalars['uuid']>;
  detection_config_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  rejection_reason?: Maybe<Scalars['String']>;
  reviewed_by?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Detection_Config_Approvals_Min_Fields = {
  __typename?: 'detection_config_approvals_min_fields';
  approved_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  detection_config_id?: Maybe<Scalars['uuid']>;
  detection_config_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  rejection_reason?: Maybe<Scalars['String']>;
  reviewed_by?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "detection_config_approvals" */
export type Detection_Config_Approvals_Mutation_Response = {
  __typename?: 'detection_config_approvals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Detection_Config_Approvals>;
};

/** on_conflict condition type for table "detection_config_approvals" */
export type Detection_Config_Approvals_On_Conflict = {
  constraint: Detection_Config_Approvals_Constraint;
  update_columns?: Array<Detection_Config_Approvals_Update_Column>;
  where?: InputMaybe<Detection_Config_Approvals_Bool_Exp>;
};

/** Ordering options when selecting data from "detection_config_approvals". */
export type Detection_Config_Approvals_Order_By = {
  approved_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  detection_assets?: InputMaybe<Detection_Assets_Order_By>;
  detection_config_id?: InputMaybe<Order_By>;
  detection_config_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ioc_detection_config_attribution?: InputMaybe<Ioc_Detection_Config_Attribution_Order_By>;
  rejection_reason?: InputMaybe<Order_By>;
  reviewed_by?: InputMaybe<Order_By>;
  rules?: InputMaybe<Rules_Order_By>;
  sourcing_queries?: InputMaybe<Sourcing_Queries_Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: detection_config_approvals */
export type Detection_Config_Approvals_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "detection_config_approvals" */
export enum Detection_Config_Approvals_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionConfigId = 'detection_config_id',
  /** column name */
  DetectionConfigType = 'detection_config_type',
  /** column name */
  Id = 'id',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  ReviewedBy = 'reviewed_by',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "detection_config_approvals" */
export type Detection_Config_Approvals_Set_Input = {
  approved_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_config_id?: InputMaybe<Scalars['uuid']>;
  detection_config_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  rejection_reason?: InputMaybe<Scalars['String']>;
  reviewed_by?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "detection_config_approvals" */
export type Detection_Config_Approvals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Detection_Config_Approvals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Detection_Config_Approvals_Stream_Cursor_Value_Input = {
  approved_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_config_id?: InputMaybe<Scalars['uuid']>;
  detection_config_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  rejection_reason?: InputMaybe<Scalars['String']>;
  reviewed_by?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "detection_config_approvals" */
export enum Detection_Config_Approvals_Update_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionConfigId = 'detection_config_id',
  /** column name */
  DetectionConfigType = 'detection_config_type',
  /** column name */
  Id = 'id',
  /** column name */
  RejectionReason = 'rejection_reason',
  /** column name */
  ReviewedBy = 'reviewed_by',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Detection_Config_Approvals_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Detection_Config_Approvals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Detection_Config_Approvals_Bool_Exp;
};

/** information about domains */
export type Domain_Data = {
  __typename?: 'domain_data';
  asn?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  /** The date when the domain was created as determined by the registrar */
  created_date?: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  full_urls: Array<Full_Urls>;
  /** An aggregate relationship */
  full_urls_aggregate: Full_Urls_Aggregate;
  hosting_provider?: Maybe<Scalars['String']>;
  iana_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  initial_discovery_source?: Maybe<Scalars['String']>;
  ip_address?: Maybe<Scalars['String']>;
  is_current: Scalars['Boolean'];
  mx_records?: Maybe<Scalars['jsonb']>;
  raw_data?: Maybe<Scalars['jsonb']>;
  raw_data_json?: Maybe<Scalars['jsonb']>;
  /** [DEPRECATED] Response message received from whois request */
  raw_text?: Maybe<Scalars['String']>;
  registrar_name?: Maybe<Scalars['String']>;
  root_domain: Scalars['String'];
  /** An array relationship */
  spoofing_reports: Array<Spoofing_Reports>;
  /** An aggregate relationship */
  spoofing_reports_aggregate: Spoofing_Reports_Aggregate;
  updated_date?: Maybe<Scalars['timestamp']>;
  /** Full html scraped from website */
  website_html?: Maybe<Scalars['String']>;
  website_text?: Maybe<Scalars['String']>;
};


/** information about domains */
export type Domain_DataFull_UrlsArgs = {
  distinct_on?: InputMaybe<Array<Full_Urls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Urls_Order_By>>;
  where?: InputMaybe<Full_Urls_Bool_Exp>;
};


/** information about domains */
export type Domain_DataFull_Urls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Full_Urls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Urls_Order_By>>;
  where?: InputMaybe<Full_Urls_Bool_Exp>;
};


/** information about domains */
export type Domain_DataMx_RecordsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** information about domains */
export type Domain_DataRaw_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** information about domains */
export type Domain_DataRaw_Data_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** information about domains */
export type Domain_DataSpoofing_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


/** information about domains */
export type Domain_DataSpoofing_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};

/** aggregated selection of "domain_data" */
export type Domain_Data_Aggregate = {
  __typename?: 'domain_data_aggregate';
  aggregate?: Maybe<Domain_Data_Aggregate_Fields>;
  nodes: Array<Domain_Data>;
};

/** aggregate fields of "domain_data" */
export type Domain_Data_Aggregate_Fields = {
  __typename?: 'domain_data_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Domain_Data_Max_Fields>;
  min?: Maybe<Domain_Data_Min_Fields>;
};


/** aggregate fields of "domain_data" */
export type Domain_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Domain_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Domain_Data_Append_Input = {
  mx_records?: InputMaybe<Scalars['jsonb']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
  raw_data_json?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "domain_data". All fields are combined with a logical 'AND'. */
export type Domain_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Domain_Data_Bool_Exp>>;
  _not?: InputMaybe<Domain_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Domain_Data_Bool_Exp>>;
  asn?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_date?: InputMaybe<Timestamp_Comparison_Exp>;
  full_urls?: InputMaybe<Full_Urls_Bool_Exp>;
  full_urls_aggregate?: InputMaybe<Full_Urls_Aggregate_Bool_Exp>;
  hosting_provider?: InputMaybe<String_Comparison_Exp>;
  iana_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initial_discovery_source?: InputMaybe<String_Comparison_Exp>;
  ip_address?: InputMaybe<String_Comparison_Exp>;
  is_current?: InputMaybe<Boolean_Comparison_Exp>;
  mx_records?: InputMaybe<Jsonb_Comparison_Exp>;
  raw_data?: InputMaybe<Jsonb_Comparison_Exp>;
  raw_data_json?: InputMaybe<Jsonb_Comparison_Exp>;
  raw_text?: InputMaybe<String_Comparison_Exp>;
  registrar_name?: InputMaybe<String_Comparison_Exp>;
  root_domain?: InputMaybe<String_Comparison_Exp>;
  spoofing_reports?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  spoofing_reports_aggregate?: InputMaybe<Spoofing_Reports_Aggregate_Bool_Exp>;
  updated_date?: InputMaybe<Timestamp_Comparison_Exp>;
  website_html?: InputMaybe<String_Comparison_Exp>;
  website_text?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "domain_data" */
export enum Domain_Data_Constraint {
  /** unique or primary key constraint on columns "root_domain" */
  DomainDataCurrentRootDomainKey = 'domain_data_current_root_domain_key',
  /** unique or primary key constraint on columns "id" */
  DomainDataPkey1 = 'domain_data_pkey1'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Domain_Data_Delete_At_Path_Input = {
  mx_records?: InputMaybe<Array<Scalars['String']>>;
  raw_data?: InputMaybe<Array<Scalars['String']>>;
  raw_data_json?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Domain_Data_Delete_Elem_Input = {
  mx_records?: InputMaybe<Scalars['Int']>;
  raw_data?: InputMaybe<Scalars['Int']>;
  raw_data_json?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Domain_Data_Delete_Key_Input = {
  mx_records?: InputMaybe<Scalars['String']>;
  raw_data?: InputMaybe<Scalars['String']>;
  raw_data_json?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "domain_data" */
export type Domain_Data_Insert_Input = {
  asn?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  /** The date when the domain was created as determined by the registrar */
  created_date?: InputMaybe<Scalars['timestamp']>;
  full_urls?: InputMaybe<Full_Urls_Arr_Rel_Insert_Input>;
  hosting_provider?: InputMaybe<Scalars['String']>;
  iana_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  initial_discovery_source?: InputMaybe<Scalars['String']>;
  ip_address?: InputMaybe<Scalars['String']>;
  is_current?: InputMaybe<Scalars['Boolean']>;
  mx_records?: InputMaybe<Scalars['jsonb']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
  raw_data_json?: InputMaybe<Scalars['jsonb']>;
  /** [DEPRECATED] Response message received from whois request */
  raw_text?: InputMaybe<Scalars['String']>;
  registrar_name?: InputMaybe<Scalars['String']>;
  root_domain?: InputMaybe<Scalars['String']>;
  spoofing_reports?: InputMaybe<Spoofing_Reports_Arr_Rel_Insert_Input>;
  updated_date?: InputMaybe<Scalars['timestamp']>;
  /** Full html scraped from website */
  website_html?: InputMaybe<Scalars['String']>;
  website_text?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Domain_Data_Max_Fields = {
  __typename?: 'domain_data_max_fields';
  asn?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  /** The date when the domain was created as determined by the registrar */
  created_date?: Maybe<Scalars['timestamp']>;
  hosting_provider?: Maybe<Scalars['String']>;
  iana_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  initial_discovery_source?: Maybe<Scalars['String']>;
  ip_address?: Maybe<Scalars['String']>;
  /** [DEPRECATED] Response message received from whois request */
  raw_text?: Maybe<Scalars['String']>;
  registrar_name?: Maybe<Scalars['String']>;
  root_domain?: Maybe<Scalars['String']>;
  updated_date?: Maybe<Scalars['timestamp']>;
  /** Full html scraped from website */
  website_html?: Maybe<Scalars['String']>;
  website_text?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Domain_Data_Min_Fields = {
  __typename?: 'domain_data_min_fields';
  asn?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  /** The date when the domain was created as determined by the registrar */
  created_date?: Maybe<Scalars['timestamp']>;
  hosting_provider?: Maybe<Scalars['String']>;
  iana_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  initial_discovery_source?: Maybe<Scalars['String']>;
  ip_address?: Maybe<Scalars['String']>;
  /** [DEPRECATED] Response message received from whois request */
  raw_text?: Maybe<Scalars['String']>;
  registrar_name?: Maybe<Scalars['String']>;
  root_domain?: Maybe<Scalars['String']>;
  updated_date?: Maybe<Scalars['timestamp']>;
  /** Full html scraped from website */
  website_html?: Maybe<Scalars['String']>;
  website_text?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "domain_data" */
export type Domain_Data_Mutation_Response = {
  __typename?: 'domain_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Domain_Data>;
};

/** input type for inserting object relation for remote table "domain_data" */
export type Domain_Data_Obj_Rel_Insert_Input = {
  data: Domain_Data_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Domain_Data_On_Conflict>;
};

/** on_conflict condition type for table "domain_data" */
export type Domain_Data_On_Conflict = {
  constraint: Domain_Data_Constraint;
  update_columns?: Array<Domain_Data_Update_Column>;
  where?: InputMaybe<Domain_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "domain_data". */
export type Domain_Data_Order_By = {
  asn?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  full_urls_aggregate?: InputMaybe<Full_Urls_Aggregate_Order_By>;
  hosting_provider?: InputMaybe<Order_By>;
  iana_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_discovery_source?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  is_current?: InputMaybe<Order_By>;
  mx_records?: InputMaybe<Order_By>;
  raw_data?: InputMaybe<Order_By>;
  raw_data_json?: InputMaybe<Order_By>;
  raw_text?: InputMaybe<Order_By>;
  registrar_name?: InputMaybe<Order_By>;
  root_domain?: InputMaybe<Order_By>;
  spoofing_reports_aggregate?: InputMaybe<Spoofing_Reports_Aggregate_Order_By>;
  updated_date?: InputMaybe<Order_By>;
  website_html?: InputMaybe<Order_By>;
  website_text?: InputMaybe<Order_By>;
};

/** primary key columns input for table: domain_data */
export type Domain_Data_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Domain_Data_Prepend_Input = {
  mx_records?: InputMaybe<Scalars['jsonb']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
  raw_data_json?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "domain_data" */
export enum Domain_Data_Select_Column {
  /** column name */
  Asn = 'asn',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  HostingProvider = 'hosting_provider',
  /** column name */
  IanaId = 'iana_id',
  /** column name */
  Id = 'id',
  /** column name */
  InitialDiscoverySource = 'initial_discovery_source',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  IsCurrent = 'is_current',
  /** column name */
  MxRecords = 'mx_records',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  RawDataJson = 'raw_data_json',
  /** column name */
  RawText = 'raw_text',
  /** column name */
  RegistrarName = 'registrar_name',
  /** column name */
  RootDomain = 'root_domain',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  WebsiteHtml = 'website_html',
  /** column name */
  WebsiteText = 'website_text'
}

/** input type for updating data in table "domain_data" */
export type Domain_Data_Set_Input = {
  asn?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  /** The date when the domain was created as determined by the registrar */
  created_date?: InputMaybe<Scalars['timestamp']>;
  hosting_provider?: InputMaybe<Scalars['String']>;
  iana_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  initial_discovery_source?: InputMaybe<Scalars['String']>;
  ip_address?: InputMaybe<Scalars['String']>;
  is_current?: InputMaybe<Scalars['Boolean']>;
  mx_records?: InputMaybe<Scalars['jsonb']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
  raw_data_json?: InputMaybe<Scalars['jsonb']>;
  /** [DEPRECATED] Response message received from whois request */
  raw_text?: InputMaybe<Scalars['String']>;
  registrar_name?: InputMaybe<Scalars['String']>;
  root_domain?: InputMaybe<Scalars['String']>;
  updated_date?: InputMaybe<Scalars['timestamp']>;
  /** Full html scraped from website */
  website_html?: InputMaybe<Scalars['String']>;
  website_text?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "domain_data" */
export type Domain_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Domain_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Domain_Data_Stream_Cursor_Value_Input = {
  asn?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  /** The date when the domain was created as determined by the registrar */
  created_date?: InputMaybe<Scalars['timestamp']>;
  hosting_provider?: InputMaybe<Scalars['String']>;
  iana_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  initial_discovery_source?: InputMaybe<Scalars['String']>;
  ip_address?: InputMaybe<Scalars['String']>;
  is_current?: InputMaybe<Scalars['Boolean']>;
  mx_records?: InputMaybe<Scalars['jsonb']>;
  raw_data?: InputMaybe<Scalars['jsonb']>;
  raw_data_json?: InputMaybe<Scalars['jsonb']>;
  /** [DEPRECATED] Response message received from whois request */
  raw_text?: InputMaybe<Scalars['String']>;
  registrar_name?: InputMaybe<Scalars['String']>;
  root_domain?: InputMaybe<Scalars['String']>;
  updated_date?: InputMaybe<Scalars['timestamp']>;
  /** Full html scraped from website */
  website_html?: InputMaybe<Scalars['String']>;
  website_text?: InputMaybe<Scalars['String']>;
};

/** update columns of table "domain_data" */
export enum Domain_Data_Update_Column {
  /** column name */
  Asn = 'asn',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  HostingProvider = 'hosting_provider',
  /** column name */
  IanaId = 'iana_id',
  /** column name */
  Id = 'id',
  /** column name */
  InitialDiscoverySource = 'initial_discovery_source',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  IsCurrent = 'is_current',
  /** column name */
  MxRecords = 'mx_records',
  /** column name */
  RawData = 'raw_data',
  /** column name */
  RawDataJson = 'raw_data_json',
  /** column name */
  RawText = 'raw_text',
  /** column name */
  RegistrarName = 'registrar_name',
  /** column name */
  RootDomain = 'root_domain',
  /** column name */
  UpdatedDate = 'updated_date',
  /** column name */
  WebsiteHtml = 'website_html',
  /** column name */
  WebsiteText = 'website_text'
}

export type Domain_Data_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Domain_Data_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Domain_Data_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Domain_Data_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Domain_Data_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Domain_Data_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Domain_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Domain_Data_Bool_Exp;
};

/** store relevant data about url domains */
export type Domain_Match_Data = {
  __typename?: 'domain_match_data';
  domain_name_match: Scalars['domain_name_match_type'];
  flagged_url: Scalars['String'];
  spoofing_entities_id: Scalars['uuid'];
};

/** aggregated selection of "domain_match_data" */
export type Domain_Match_Data_Aggregate = {
  __typename?: 'domain_match_data_aggregate';
  aggregate?: Maybe<Domain_Match_Data_Aggregate_Fields>;
  nodes: Array<Domain_Match_Data>;
};

/** aggregate fields of "domain_match_data" */
export type Domain_Match_Data_Aggregate_Fields = {
  __typename?: 'domain_match_data_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Domain_Match_Data_Max_Fields>;
  min?: Maybe<Domain_Match_Data_Min_Fields>;
};


/** aggregate fields of "domain_match_data" */
export type Domain_Match_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Domain_Match_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "domain_match_data". All fields are combined with a logical 'AND'. */
export type Domain_Match_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Domain_Match_Data_Bool_Exp>>;
  _not?: InputMaybe<Domain_Match_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Domain_Match_Data_Bool_Exp>>;
  domain_name_match?: InputMaybe<Domain_Name_Match_Type_Comparison_Exp>;
  flagged_url?: InputMaybe<String_Comparison_Exp>;
  spoofing_entities_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "domain_match_data" */
export enum Domain_Match_Data_Constraint {
  /** unique or primary key constraint on columns "spoofing_entities_id", "flagged_url" */
  DomainDataPkey = 'domain_data_pkey'
}

/** input type for inserting data into table "domain_match_data" */
export type Domain_Match_Data_Insert_Input = {
  domain_name_match?: InputMaybe<Scalars['domain_name_match_type']>;
  flagged_url?: InputMaybe<Scalars['String']>;
  spoofing_entities_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Domain_Match_Data_Max_Fields = {
  __typename?: 'domain_match_data_max_fields';
  domain_name_match?: Maybe<Scalars['domain_name_match_type']>;
  flagged_url?: Maybe<Scalars['String']>;
  spoofing_entities_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Domain_Match_Data_Min_Fields = {
  __typename?: 'domain_match_data_min_fields';
  domain_name_match?: Maybe<Scalars['domain_name_match_type']>;
  flagged_url?: Maybe<Scalars['String']>;
  spoofing_entities_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "domain_match_data" */
export type Domain_Match_Data_Mutation_Response = {
  __typename?: 'domain_match_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Domain_Match_Data>;
};

/** on_conflict condition type for table "domain_match_data" */
export type Domain_Match_Data_On_Conflict = {
  constraint: Domain_Match_Data_Constraint;
  update_columns?: Array<Domain_Match_Data_Update_Column>;
  where?: InputMaybe<Domain_Match_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "domain_match_data". */
export type Domain_Match_Data_Order_By = {
  domain_name_match?: InputMaybe<Order_By>;
  flagged_url?: InputMaybe<Order_By>;
  spoofing_entities_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: domain_match_data */
export type Domain_Match_Data_Pk_Columns_Input = {
  flagged_url: Scalars['String'];
  spoofing_entities_id: Scalars['uuid'];
};

/** select columns of table "domain_match_data" */
export enum Domain_Match_Data_Select_Column {
  /** column name */
  DomainNameMatch = 'domain_name_match',
  /** column name */
  FlaggedUrl = 'flagged_url',
  /** column name */
  SpoofingEntitiesId = 'spoofing_entities_id'
}

/** input type for updating data in table "domain_match_data" */
export type Domain_Match_Data_Set_Input = {
  domain_name_match?: InputMaybe<Scalars['domain_name_match_type']>;
  flagged_url?: InputMaybe<Scalars['String']>;
  spoofing_entities_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "domain_match_data" */
export type Domain_Match_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Domain_Match_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Domain_Match_Data_Stream_Cursor_Value_Input = {
  domain_name_match?: InputMaybe<Scalars['domain_name_match_type']>;
  flagged_url?: InputMaybe<Scalars['String']>;
  spoofing_entities_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "domain_match_data" */
export enum Domain_Match_Data_Update_Column {
  /** column name */
  DomainNameMatch = 'domain_name_match',
  /** column name */
  FlaggedUrl = 'flagged_url',
  /** column name */
  SpoofingEntitiesId = 'spoofing_entities_id'
}

export type Domain_Match_Data_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Domain_Match_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Domain_Match_Data_Bool_Exp;
};

/** Boolean expression to compare columns of type "domain_name_match_type". All fields are combined with logical 'AND'. */
export type Domain_Name_Match_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['domain_name_match_type']>;
  _gt?: InputMaybe<Scalars['domain_name_match_type']>;
  _gte?: InputMaybe<Scalars['domain_name_match_type']>;
  _in?: InputMaybe<Array<Scalars['domain_name_match_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['domain_name_match_type']>;
  _lte?: InputMaybe<Scalars['domain_name_match_type']>;
  _neq?: InputMaybe<Scalars['domain_name_match_type']>;
  _nin?: InputMaybe<Array<Scalars['domain_name_match_type']>>;
};

/** Table to store ecommerce listing data */
export type Ecommerce_Listings = {
  __typename?: 'ecommerce_listings';
  created_at: Scalars['timestamp'];
  description?: Maybe<Scalars['String']>;
  discord_info?: Maybe<Scalars['jsonb']>;
  external_created_at?: Maybe<Scalars['timestamp']>;
  external_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  num_units?: Maybe<Scalars['Int']>;
  num_units_sold?: Maybe<Scalars['Int']>;
  platform_name: Scalars['String'];
  /** An object relationship */
  platform_subtype?: Maybe<Platform_Subtypes>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  seller_name?: Maybe<Scalars['String']>;
  shop_name?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  source_url?: Maybe<Scalars['String']>;
  telegram_info?: Maybe<Scalars['jsonb']>;
  title?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};


/** Table to store ecommerce listing data */
export type Ecommerce_ListingsDiscord_InfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Table to store ecommerce listing data */
export type Ecommerce_ListingsTelegram_InfoArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ecommerce_listings" */
export type Ecommerce_Listings_Aggregate = {
  __typename?: 'ecommerce_listings_aggregate';
  aggregate?: Maybe<Ecommerce_Listings_Aggregate_Fields>;
  nodes: Array<Ecommerce_Listings>;
};

/** aggregate fields of "ecommerce_listings" */
export type Ecommerce_Listings_Aggregate_Fields = {
  __typename?: 'ecommerce_listings_aggregate_fields';
  avg?: Maybe<Ecommerce_Listings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ecommerce_Listings_Max_Fields>;
  min?: Maybe<Ecommerce_Listings_Min_Fields>;
  stddev?: Maybe<Ecommerce_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Ecommerce_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ecommerce_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Ecommerce_Listings_Sum_Fields>;
  var_pop?: Maybe<Ecommerce_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Ecommerce_Listings_Var_Samp_Fields>;
  variance?: Maybe<Ecommerce_Listings_Variance_Fields>;
};


/** aggregate fields of "ecommerce_listings" */
export type Ecommerce_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ecommerce_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ecommerce_Listings_Append_Input = {
  discord_info?: InputMaybe<Scalars['jsonb']>;
  telegram_info?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Ecommerce_Listings_Avg_Fields = {
  __typename?: 'ecommerce_listings_avg_fields';
  num_units?: Maybe<Scalars['Float']>;
  num_units_sold?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ecommerce_listings". All fields are combined with a logical 'AND'. */
export type Ecommerce_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Ecommerce_Listings_Bool_Exp>>;
  _not?: InputMaybe<Ecommerce_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Ecommerce_Listings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discord_info?: InputMaybe<Jsonb_Comparison_Exp>;
  external_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  num_units?: InputMaybe<Int_Comparison_Exp>;
  num_units_sold?: InputMaybe<Int_Comparison_Exp>;
  platform_name?: InputMaybe<String_Comparison_Exp>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Bool_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<Float_Comparison_Exp>;
  rating?: InputMaybe<Float_Comparison_Exp>;
  seller_name?: InputMaybe<String_Comparison_Exp>;
  shop_name?: InputMaybe<String_Comparison_Exp>;
  source_query?: InputMaybe<String_Comparison_Exp>;
  source_url?: InputMaybe<String_Comparison_Exp>;
  telegram_info?: InputMaybe<Jsonb_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ecommerce_listings" */
export enum Ecommerce_Listings_Constraint {
  /** unique or primary key constraint on columns "id" */
  EcommerceListingsPkey = 'ecommerce_listings_pkey',
  /** unique or primary key constraint on columns "url" */
  EcommerceListingsUrlKey = 'ecommerce_listings_url_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ecommerce_Listings_Delete_At_Path_Input = {
  discord_info?: InputMaybe<Array<Scalars['String']>>;
  telegram_info?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ecommerce_Listings_Delete_Elem_Input = {
  discord_info?: InputMaybe<Scalars['Int']>;
  telegram_info?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ecommerce_Listings_Delete_Key_Input = {
  discord_info?: InputMaybe<Scalars['String']>;
  telegram_info?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "ecommerce_listings" */
export type Ecommerce_Listings_Inc_Input = {
  num_units?: InputMaybe<Scalars['Int']>;
  num_units_sold?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  rating?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "ecommerce_listings" */
export type Ecommerce_Listings_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  discord_info?: InputMaybe<Scalars['jsonb']>;
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  num_units?: InputMaybe<Scalars['Int']>;
  num_units_sold?: InputMaybe<Scalars['Int']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Obj_Rel_Insert_Input>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['Float']>;
  rating?: InputMaybe<Scalars['Float']>;
  seller_name?: InputMaybe<Scalars['String']>;
  shop_name?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  source_url?: InputMaybe<Scalars['String']>;
  telegram_info?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ecommerce_Listings_Max_Fields = {
  __typename?: 'ecommerce_listings_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  external_created_at?: Maybe<Scalars['timestamp']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  num_units?: Maybe<Scalars['Int']>;
  num_units_sold?: Maybe<Scalars['Int']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  seller_name?: Maybe<Scalars['String']>;
  shop_name?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  source_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ecommerce_Listings_Min_Fields = {
  __typename?: 'ecommerce_listings_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  external_created_at?: Maybe<Scalars['timestamp']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  num_units?: Maybe<Scalars['Int']>;
  num_units_sold?: Maybe<Scalars['Int']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
  seller_name?: Maybe<Scalars['String']>;
  shop_name?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  source_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ecommerce_listings" */
export type Ecommerce_Listings_Mutation_Response = {
  __typename?: 'ecommerce_listings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ecommerce_Listings>;
};

/** input type for inserting object relation for remote table "ecommerce_listings" */
export type Ecommerce_Listings_Obj_Rel_Insert_Input = {
  data: Ecommerce_Listings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ecommerce_Listings_On_Conflict>;
};

/** on_conflict condition type for table "ecommerce_listings" */
export type Ecommerce_Listings_On_Conflict = {
  constraint: Ecommerce_Listings_Constraint;
  update_columns?: Array<Ecommerce_Listings_Update_Column>;
  where?: InputMaybe<Ecommerce_Listings_Bool_Exp>;
};

/** Ordering options when selecting data from "ecommerce_listings". */
export type Ecommerce_Listings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discord_info?: InputMaybe<Order_By>;
  external_created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_units?: InputMaybe<Order_By>;
  num_units_sold?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  seller_name?: InputMaybe<Order_By>;
  shop_name?: InputMaybe<Order_By>;
  source_query?: InputMaybe<Order_By>;
  source_url?: InputMaybe<Order_By>;
  telegram_info?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ecommerce_listings */
export type Ecommerce_Listings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ecommerce_Listings_Prepend_Input = {
  discord_info?: InputMaybe<Scalars['jsonb']>;
  telegram_info?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ecommerce_listings" */
export enum Ecommerce_Listings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DiscordInfo = 'discord_info',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  NumUnits = 'num_units',
  /** column name */
  NumUnitsSold = 'num_units_sold',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  Price = 'price',
  /** column name */
  Rating = 'rating',
  /** column name */
  SellerName = 'seller_name',
  /** column name */
  ShopName = 'shop_name',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  SourceUrl = 'source_url',
  /** column name */
  TelegramInfo = 'telegram_info',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "ecommerce_listings" */
export type Ecommerce_Listings_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  discord_info?: InputMaybe<Scalars['jsonb']>;
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  num_units?: InputMaybe<Scalars['Int']>;
  num_units_sold?: InputMaybe<Scalars['Int']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['Float']>;
  rating?: InputMaybe<Scalars['Float']>;
  seller_name?: InputMaybe<Scalars['String']>;
  shop_name?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  source_url?: InputMaybe<Scalars['String']>;
  telegram_info?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Ecommerce_Listings_Stddev_Fields = {
  __typename?: 'ecommerce_listings_stddev_fields';
  num_units?: Maybe<Scalars['Float']>;
  num_units_sold?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ecommerce_Listings_Stddev_Pop_Fields = {
  __typename?: 'ecommerce_listings_stddev_pop_fields';
  num_units?: Maybe<Scalars['Float']>;
  num_units_sold?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ecommerce_Listings_Stddev_Samp_Fields = {
  __typename?: 'ecommerce_listings_stddev_samp_fields';
  num_units?: Maybe<Scalars['Float']>;
  num_units_sold?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ecommerce_listings" */
export type Ecommerce_Listings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ecommerce_Listings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ecommerce_Listings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  discord_info?: InputMaybe<Scalars['jsonb']>;
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  num_units?: InputMaybe<Scalars['Int']>;
  num_units_sold?: InputMaybe<Scalars['Int']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['Float']>;
  rating?: InputMaybe<Scalars['Float']>;
  seller_name?: InputMaybe<Scalars['String']>;
  shop_name?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  source_url?: InputMaybe<Scalars['String']>;
  telegram_info?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Ecommerce_Listings_Sum_Fields = {
  __typename?: 'ecommerce_listings_sum_fields';
  num_units?: Maybe<Scalars['Int']>;
  num_units_sold?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** update columns of table "ecommerce_listings" */
export enum Ecommerce_Listings_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DiscordInfo = 'discord_info',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  NumUnits = 'num_units',
  /** column name */
  NumUnitsSold = 'num_units_sold',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  Price = 'price',
  /** column name */
  Rating = 'rating',
  /** column name */
  SellerName = 'seller_name',
  /** column name */
  ShopName = 'shop_name',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  SourceUrl = 'source_url',
  /** column name */
  TelegramInfo = 'telegram_info',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url'
}

export type Ecommerce_Listings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ecommerce_Listings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ecommerce_Listings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ecommerce_Listings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ecommerce_Listings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ecommerce_Listings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ecommerce_Listings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ecommerce_Listings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ecommerce_Listings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ecommerce_Listings_Var_Pop_Fields = {
  __typename?: 'ecommerce_listings_var_pop_fields';
  num_units?: Maybe<Scalars['Float']>;
  num_units_sold?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ecommerce_Listings_Var_Samp_Fields = {
  __typename?: 'ecommerce_listings_var_samp_fields';
  num_units?: Maybe<Scalars['Float']>;
  num_units_sold?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ecommerce_Listings_Variance_Fields = {
  __typename?: 'ecommerce_listings_variance_fields';
  num_units?: Maybe<Scalars['Float']>;
  num_units_sold?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "email_addresses" */
export type Email_Addresses = {
  __typename?: 'email_addresses';
  created_at: Scalars['timestamptz'];
  email_address: Scalars['String'];
  /** An array relationship */
  entity_data: Array<Entity_Data>;
  /** An aggregate relationship */
  entity_data_aggregate: Entity_Data_Aggregate;
  id: Scalars['uuid'];
};


/** columns and relationships of "email_addresses" */
export type Email_AddressesEntity_DataArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


/** columns and relationships of "email_addresses" */
export type Email_AddressesEntity_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};

/** aggregated selection of "email_addresses" */
export type Email_Addresses_Aggregate = {
  __typename?: 'email_addresses_aggregate';
  aggregate?: Maybe<Email_Addresses_Aggregate_Fields>;
  nodes: Array<Email_Addresses>;
};

/** aggregate fields of "email_addresses" */
export type Email_Addresses_Aggregate_Fields = {
  __typename?: 'email_addresses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Email_Addresses_Max_Fields>;
  min?: Maybe<Email_Addresses_Min_Fields>;
};


/** aggregate fields of "email_addresses" */
export type Email_Addresses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Addresses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "email_addresses". All fields are combined with a logical 'AND'. */
export type Email_Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Addresses_Bool_Exp>>;
  _not?: InputMaybe<Email_Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Addresses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  entity_data?: InputMaybe<Entity_Data_Bool_Exp>;
  entity_data_aggregate?: InputMaybe<Entity_Data_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_addresses" */
export enum Email_Addresses_Constraint {
  /** unique or primary key constraint on columns "email_address" */
  EmailAddressesEmailAddressKey = 'email_addresses_email_address_key',
  /** unique or primary key constraint on columns "id" */
  EmailAddressesPkey = 'email_addresses_pkey'
}

/** input type for inserting data into table "email_addresses" */
export type Email_Addresses_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_address?: InputMaybe<Scalars['String']>;
  entity_data?: InputMaybe<Entity_Data_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Email_Addresses_Max_Fields = {
  __typename?: 'email_addresses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Email_Addresses_Min_Fields = {
  __typename?: 'email_addresses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "email_addresses" */
export type Email_Addresses_Mutation_Response = {
  __typename?: 'email_addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Addresses>;
};

/** input type for inserting object relation for remote table "email_addresses" */
export type Email_Addresses_Obj_Rel_Insert_Input = {
  data: Email_Addresses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Addresses_On_Conflict>;
};

/** on_conflict condition type for table "email_addresses" */
export type Email_Addresses_On_Conflict = {
  constraint: Email_Addresses_Constraint;
  update_columns?: Array<Email_Addresses_Update_Column>;
  where?: InputMaybe<Email_Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "email_addresses". */
export type Email_Addresses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  entity_data_aggregate?: InputMaybe<Entity_Data_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_addresses */
export type Email_Addresses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "email_addresses" */
export enum Email_Addresses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "email_addresses" */
export type Email_Addresses_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "email_addresses" */
export type Email_Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Addresses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "email_addresses" */
export enum Email_Addresses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  Id = 'id'
}

export type Email_Addresses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Addresses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Addresses_Bool_Exp;
};

/** email_alerts_resolved_top_metricsNative Query Arguments */
export type Email_Alerts_Resolved_Top_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  metric_type: Scalars['String'];
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  product?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** email_alerts_resolved_total_metricsNative Query Arguments */
export type Email_Alerts_Resolved_Total_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  product?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** email_alerts_times_to_actioned_graph_metricsNative Query Arguments */
export type Email_Alerts_Times_To_Actioned_Graph_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  metric_type: Scalars['String'];
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  product?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** email_alerts_times_to_actioned_metricsNative Query Arguments */
export type Email_Alerts_Times_To_Actioned_Metrics_Arguments = {
  brand?: InputMaybe<Scalars['String']>;
  end_date: Scalars['String'];
  metric_type: Scalars['String'];
  not_tags?: InputMaybe<Scalars['String']>;
  org_id: Scalars['uuid'];
  product?: InputMaybe<Scalars['String']>;
  start_date: Scalars['String'];
  tags?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "email_correspondence" */
export type Email_Correspondence = {
  __typename?: 'email_correspondence';
  body: Scalars['String'];
  correspondence_type: Scalars['String'];
  created_at: Scalars['timestamp'];
  /** An object relationship */
  email: Emails;
  email_id: Scalars['uuid'];
  id: Scalars['uuid'];
  message_id?: Maybe<Scalars['String']>;
  receiver: Scalars['String'];
  sender: Scalars['String'];
  thread_id: Scalars['String'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "email_correspondence" */
export type Email_Correspondence_Aggregate = {
  __typename?: 'email_correspondence_aggregate';
  aggregate?: Maybe<Email_Correspondence_Aggregate_Fields>;
  nodes: Array<Email_Correspondence>;
};

export type Email_Correspondence_Aggregate_Bool_Exp = {
  count?: InputMaybe<Email_Correspondence_Aggregate_Bool_Exp_Count>;
};

export type Email_Correspondence_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Email_Correspondence_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Email_Correspondence_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "email_correspondence" */
export type Email_Correspondence_Aggregate_Fields = {
  __typename?: 'email_correspondence_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Email_Correspondence_Max_Fields>;
  min?: Maybe<Email_Correspondence_Min_Fields>;
};


/** aggregate fields of "email_correspondence" */
export type Email_Correspondence_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Correspondence_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "email_correspondence" */
export type Email_Correspondence_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Correspondence_Max_Order_By>;
  min?: InputMaybe<Email_Correspondence_Min_Order_By>;
};

/** input type for inserting array relation for remote table "email_correspondence" */
export type Email_Correspondence_Arr_Rel_Insert_Input = {
  data: Array<Email_Correspondence_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Correspondence_On_Conflict>;
};

/** Boolean expression to filter rows from the table "email_correspondence". All fields are combined with a logical 'AND'. */
export type Email_Correspondence_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Correspondence_Bool_Exp>>;
  _not?: InputMaybe<Email_Correspondence_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Correspondence_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  correspondence_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email?: InputMaybe<Emails_Bool_Exp>;
  email_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message_id?: InputMaybe<String_Comparison_Exp>;
  receiver?: InputMaybe<String_Comparison_Exp>;
  sender?: InputMaybe<String_Comparison_Exp>;
  thread_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_correspondence" */
export enum Email_Correspondence_Constraint {
  /** unique or primary key constraint on columns "message_id" */
  EmailCorrespondenceMessageIdKey = 'email_correspondence_message_id_key',
  /** unique or primary key constraint on columns "id" */
  EmailCorrespondencePkey = 'email_correspondence_pkey'
}

/** input type for inserting data into table "email_correspondence" */
export type Email_Correspondence_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  correspondence_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Emails_Obj_Rel_Insert_Input>;
  email_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['String']>;
  receiver?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  thread_id?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Email_Correspondence_Max_Fields = {
  __typename?: 'email_correspondence_max_fields';
  body?: Maybe<Scalars['String']>;
  correspondence_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  email_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['String']>;
  receiver?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  thread_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "email_correspondence" */
export type Email_Correspondence_Max_Order_By = {
  body?: InputMaybe<Order_By>;
  correspondence_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  receiver?: InputMaybe<Order_By>;
  sender?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Correspondence_Min_Fields = {
  __typename?: 'email_correspondence_min_fields';
  body?: Maybe<Scalars['String']>;
  correspondence_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  email_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['String']>;
  receiver?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  thread_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "email_correspondence" */
export type Email_Correspondence_Min_Order_By = {
  body?: InputMaybe<Order_By>;
  correspondence_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  receiver?: InputMaybe<Order_By>;
  sender?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_correspondence" */
export type Email_Correspondence_Mutation_Response = {
  __typename?: 'email_correspondence_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Correspondence>;
};

/** on_conflict condition type for table "email_correspondence" */
export type Email_Correspondence_On_Conflict = {
  constraint: Email_Correspondence_Constraint;
  update_columns?: Array<Email_Correspondence_Update_Column>;
  where?: InputMaybe<Email_Correspondence_Bool_Exp>;
};

/** Ordering options when selecting data from "email_correspondence". */
export type Email_Correspondence_Order_By = {
  body?: InputMaybe<Order_By>;
  correspondence_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Emails_Order_By>;
  email_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  receiver?: InputMaybe<Order_By>;
  sender?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_correspondence */
export type Email_Correspondence_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "email_correspondence" */
export enum Email_Correspondence_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CorrespondenceType = 'correspondence_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Receiver = 'receiver',
  /** column name */
  Sender = 'sender',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "email_correspondence" */
export type Email_Correspondence_Set_Input = {
  body?: InputMaybe<Scalars['String']>;
  correspondence_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['String']>;
  receiver?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  thread_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "email_correspondence" */
export type Email_Correspondence_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Correspondence_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Correspondence_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  correspondence_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['String']>;
  receiver?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  thread_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "email_correspondence" */
export enum Email_Correspondence_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CorrespondenceType = 'correspondence_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  Receiver = 'receiver',
  /** column name */
  Sender = 'sender',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  UserId = 'user_id'
}

export type Email_Correspondence_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Correspondence_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Correspondence_Bool_Exp;
};

/** columns and relationships of "email_settings" */
export type Email_Settings = {
  __typename?: 'email_settings';
  abaas_email_address?: Maybe<Scalars['String']>;
  dne_template?: Maybe<Scalars['String']>;
  email_domains: Scalars['jsonb'];
  er_acknowledgement_enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  is_eur_enabled: Scalars['Boolean'];
  malicious_template?: Maybe<Scalars['String']>;
  ntd_template?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
  pir_email_address?: Maybe<Scalars['String']>;
  should_send_eur_to_soc: Scalars['Boolean'];
  soc_email_address?: Maybe<Scalars['String']>;
  /** An object relationship */
  spoofing_entity: Spoofing_Entities;
  spoofing_entity_id: Scalars['uuid'];
};


/** columns and relationships of "email_settings" */
export type Email_SettingsEmail_DomainsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "email_settings" */
export type Email_Settings_Aggregate = {
  __typename?: 'email_settings_aggregate';
  aggregate?: Maybe<Email_Settings_Aggregate_Fields>;
  nodes: Array<Email_Settings>;
};

/** aggregate fields of "email_settings" */
export type Email_Settings_Aggregate_Fields = {
  __typename?: 'email_settings_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Email_Settings_Max_Fields>;
  min?: Maybe<Email_Settings_Min_Fields>;
};


/** aggregate fields of "email_settings" */
export type Email_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Email_Settings_Append_Input = {
  email_domains?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "email_settings". All fields are combined with a logical 'AND'. */
export type Email_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Settings_Bool_Exp>>;
  _not?: InputMaybe<Email_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Settings_Bool_Exp>>;
  abaas_email_address?: InputMaybe<String_Comparison_Exp>;
  dne_template?: InputMaybe<String_Comparison_Exp>;
  email_domains?: InputMaybe<Jsonb_Comparison_Exp>;
  er_acknowledgement_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_eur_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  malicious_template?: InputMaybe<String_Comparison_Exp>;
  ntd_template?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  pir_email_address?: InputMaybe<String_Comparison_Exp>;
  should_send_eur_to_soc?: InputMaybe<Boolean_Comparison_Exp>;
  soc_email_address?: InputMaybe<String_Comparison_Exp>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  spoofing_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_settings" */
export enum Email_Settings_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  EmailSettingsOrganizationIdKey = 'email_settings_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  EmailSettingsPkey = 'email_settings_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Email_Settings_Delete_At_Path_Input = {
  email_domains?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Email_Settings_Delete_Elem_Input = {
  email_domains?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Email_Settings_Delete_Key_Input = {
  email_domains?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "email_settings" */
export type Email_Settings_Insert_Input = {
  abaas_email_address?: InputMaybe<Scalars['String']>;
  dne_template?: InputMaybe<Scalars['String']>;
  email_domains?: InputMaybe<Scalars['jsonb']>;
  er_acknowledgement_enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_eur_enabled?: InputMaybe<Scalars['Boolean']>;
  malicious_template?: InputMaybe<Scalars['String']>;
  ntd_template?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  pir_email_address?: InputMaybe<Scalars['String']>;
  should_send_eur_to_soc?: InputMaybe<Scalars['Boolean']>;
  soc_email_address?: InputMaybe<Scalars['String']>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Obj_Rel_Insert_Input>;
  spoofing_entity_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Email_Settings_Max_Fields = {
  __typename?: 'email_settings_max_fields';
  abaas_email_address?: Maybe<Scalars['String']>;
  dne_template?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  malicious_template?: Maybe<Scalars['String']>;
  ntd_template?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  pir_email_address?: Maybe<Scalars['String']>;
  soc_email_address?: Maybe<Scalars['String']>;
  spoofing_entity_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Email_Settings_Min_Fields = {
  __typename?: 'email_settings_min_fields';
  abaas_email_address?: Maybe<Scalars['String']>;
  dne_template?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  malicious_template?: Maybe<Scalars['String']>;
  ntd_template?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  pir_email_address?: Maybe<Scalars['String']>;
  soc_email_address?: Maybe<Scalars['String']>;
  spoofing_entity_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "email_settings" */
export type Email_Settings_Mutation_Response = {
  __typename?: 'email_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Settings>;
};

/** on_conflict condition type for table "email_settings" */
export type Email_Settings_On_Conflict = {
  constraint: Email_Settings_Constraint;
  update_columns?: Array<Email_Settings_Update_Column>;
  where?: InputMaybe<Email_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "email_settings". */
export type Email_Settings_Order_By = {
  abaas_email_address?: InputMaybe<Order_By>;
  dne_template?: InputMaybe<Order_By>;
  email_domains?: InputMaybe<Order_By>;
  er_acknowledgement_enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_eur_enabled?: InputMaybe<Order_By>;
  malicious_template?: InputMaybe<Order_By>;
  ntd_template?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  pir_email_address?: InputMaybe<Order_By>;
  should_send_eur_to_soc?: InputMaybe<Order_By>;
  soc_email_address?: InputMaybe<Order_By>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Order_By>;
  spoofing_entity_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_settings */
export type Email_Settings_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Email_Settings_Prepend_Input = {
  email_domains?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "email_settings" */
export enum Email_Settings_Select_Column {
  /** column name */
  AbaasEmailAddress = 'abaas_email_address',
  /** column name */
  DneTemplate = 'dne_template',
  /** column name */
  EmailDomains = 'email_domains',
  /** column name */
  ErAcknowledgementEnabled = 'er_acknowledgement_enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsEurEnabled = 'is_eur_enabled',
  /** column name */
  MaliciousTemplate = 'malicious_template',
  /** column name */
  NtdTemplate = 'ntd_template',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PirEmailAddress = 'pir_email_address',
  /** column name */
  ShouldSendEurToSoc = 'should_send_eur_to_soc',
  /** column name */
  SocEmailAddress = 'soc_email_address',
  /** column name */
  SpoofingEntityId = 'spoofing_entity_id'
}

/** input type for updating data in table "email_settings" */
export type Email_Settings_Set_Input = {
  abaas_email_address?: InputMaybe<Scalars['String']>;
  dne_template?: InputMaybe<Scalars['String']>;
  email_domains?: InputMaybe<Scalars['jsonb']>;
  er_acknowledgement_enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_eur_enabled?: InputMaybe<Scalars['Boolean']>;
  malicious_template?: InputMaybe<Scalars['String']>;
  ntd_template?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  pir_email_address?: InputMaybe<Scalars['String']>;
  should_send_eur_to_soc?: InputMaybe<Scalars['Boolean']>;
  soc_email_address?: InputMaybe<Scalars['String']>;
  spoofing_entity_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "email_settings" */
export type Email_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Settings_Stream_Cursor_Value_Input = {
  abaas_email_address?: InputMaybe<Scalars['String']>;
  dne_template?: InputMaybe<Scalars['String']>;
  email_domains?: InputMaybe<Scalars['jsonb']>;
  er_acknowledgement_enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_eur_enabled?: InputMaybe<Scalars['Boolean']>;
  malicious_template?: InputMaybe<Scalars['String']>;
  ntd_template?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  pir_email_address?: InputMaybe<Scalars['String']>;
  should_send_eur_to_soc?: InputMaybe<Scalars['Boolean']>;
  soc_email_address?: InputMaybe<Scalars['String']>;
  spoofing_entity_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "email_settings" */
export enum Email_Settings_Update_Column {
  /** column name */
  AbaasEmailAddress = 'abaas_email_address',
  /** column name */
  DneTemplate = 'dne_template',
  /** column name */
  EmailDomains = 'email_domains',
  /** column name */
  ErAcknowledgementEnabled = 'er_acknowledgement_enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsEurEnabled = 'is_eur_enabled',
  /** column name */
  MaliciousTemplate = 'malicious_template',
  /** column name */
  NtdTemplate = 'ntd_template',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PirEmailAddress = 'pir_email_address',
  /** column name */
  ShouldSendEurToSoc = 'should_send_eur_to_soc',
  /** column name */
  SocEmailAddress = 'soc_email_address',
  /** column name */
  SpoofingEntityId = 'spoofing_entity_id'
}

export type Email_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Email_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Email_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Email_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Email_Settings_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Email_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Settings_Bool_Exp;
};

/** email content that we're monitoring and flagging to customers */
export type Emails = {
  __typename?: 'emails';
  bcc?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  cc?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamp'];
  dkim?: Maybe<Scalars['String']>;
  dmarc?: Maybe<Scalars['String']>;
  /** An array relationship */
  email_correspondences: Array<Email_Correspondence>;
  /** An aggregate relationship */
  email_correspondences_aggregate: Email_Correspondence_Aggregate;
  eml_url?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  forward_data?: Maybe<Scalars['jsonb']>;
  header_analysis?: Maybe<Scalars['jsonb']>;
  headers?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  message_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id: Scalars['uuid'];
  received_at: Scalars['timestamp'];
  receiver?: Maybe<Scalars['String']>;
  reply_to?: Maybe<Scalars['String']>;
  screenshot_url?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  sentiment_analysis?: Maybe<Scalars['jsonb']>;
  /** The email address for the inbox that this email was found in */
  source_inbox?: Maybe<Scalars['String']>;
  spf?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamp'];
};


/** email content that we're monitoring and flagging to customers */
export type EmailsEmail_CorrespondencesArgs = {
  distinct_on?: InputMaybe<Array<Email_Correspondence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Correspondence_Order_By>>;
  where?: InputMaybe<Email_Correspondence_Bool_Exp>;
};


/** email content that we're monitoring and flagging to customers */
export type EmailsEmail_Correspondences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Correspondence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Correspondence_Order_By>>;
  where?: InputMaybe<Email_Correspondence_Bool_Exp>;
};


/** email content that we're monitoring and flagging to customers */
export type EmailsForward_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** email content that we're monitoring and flagging to customers */
export type EmailsHeader_AnalysisArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** email content that we're monitoring and flagging to customers */
export type EmailsHeadersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** email content that we're monitoring and flagging to customers */
export type EmailsSentiment_AnalysisArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "emails" */
export type Emails_Aggregate = {
  __typename?: 'emails_aggregate';
  aggregate?: Maybe<Emails_Aggregate_Fields>;
  nodes: Array<Emails>;
};

/** aggregate fields of "emails" */
export type Emails_Aggregate_Fields = {
  __typename?: 'emails_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Emails_Max_Fields>;
  min?: Maybe<Emails_Min_Fields>;
};


/** aggregate fields of "emails" */
export type Emails_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Emails_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Emails_Append_Input = {
  forward_data?: InputMaybe<Scalars['jsonb']>;
  header_analysis?: InputMaybe<Scalars['jsonb']>;
  headers?: InputMaybe<Scalars['jsonb']>;
  sentiment_analysis?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "emails". All fields are combined with a logical 'AND'. */
export type Emails_Bool_Exp = {
  _and?: InputMaybe<Array<Emails_Bool_Exp>>;
  _not?: InputMaybe<Emails_Bool_Exp>;
  _or?: InputMaybe<Array<Emails_Bool_Exp>>;
  bcc?: InputMaybe<String_Comparison_Exp>;
  body?: InputMaybe<String_Comparison_Exp>;
  cc?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  dkim?: InputMaybe<String_Comparison_Exp>;
  dmarc?: InputMaybe<String_Comparison_Exp>;
  email_correspondences?: InputMaybe<Email_Correspondence_Bool_Exp>;
  email_correspondences_aggregate?: InputMaybe<Email_Correspondence_Aggregate_Bool_Exp>;
  eml_url?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  forward_data?: InputMaybe<Jsonb_Comparison_Exp>;
  header_analysis?: InputMaybe<Jsonb_Comparison_Exp>;
  headers?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message_id?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  received_at?: InputMaybe<Timestamp_Comparison_Exp>;
  receiver?: InputMaybe<String_Comparison_Exp>;
  reply_to?: InputMaybe<String_Comparison_Exp>;
  screenshot_url?: InputMaybe<String_Comparison_Exp>;
  sender?: InputMaybe<String_Comparison_Exp>;
  sentiment_analysis?: InputMaybe<Jsonb_Comparison_Exp>;
  source_inbox?: InputMaybe<String_Comparison_Exp>;
  spf?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "emails" */
export enum Emails_Constraint {
  /** unique or primary key constraint on columns "external_id" */
  EmailsExternalIdKey1 = 'emails_external_id_key1',
  /** unique or primary key constraint on columns "id" */
  EmailsPkey1 = 'emails_pkey1'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Emails_Delete_At_Path_Input = {
  forward_data?: InputMaybe<Array<Scalars['String']>>;
  header_analysis?: InputMaybe<Array<Scalars['String']>>;
  headers?: InputMaybe<Array<Scalars['String']>>;
  sentiment_analysis?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Emails_Delete_Elem_Input = {
  forward_data?: InputMaybe<Scalars['Int']>;
  header_analysis?: InputMaybe<Scalars['Int']>;
  headers?: InputMaybe<Scalars['Int']>;
  sentiment_analysis?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Emails_Delete_Key_Input = {
  forward_data?: InputMaybe<Scalars['String']>;
  header_analysis?: InputMaybe<Scalars['String']>;
  headers?: InputMaybe<Scalars['String']>;
  sentiment_analysis?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "emails" */
export type Emails_Insert_Input = {
  bcc?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  dkim?: InputMaybe<Scalars['String']>;
  dmarc?: InputMaybe<Scalars['String']>;
  email_correspondences?: InputMaybe<Email_Correspondence_Arr_Rel_Insert_Input>;
  eml_url?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  forward_data?: InputMaybe<Scalars['jsonb']>;
  header_analysis?: InputMaybe<Scalars['jsonb']>;
  headers?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  received_at?: InputMaybe<Scalars['timestamp']>;
  receiver?: InputMaybe<Scalars['String']>;
  reply_to?: InputMaybe<Scalars['String']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  sentiment_analysis?: InputMaybe<Scalars['jsonb']>;
  /** The email address for the inbox that this email was found in */
  source_inbox?: InputMaybe<Scalars['String']>;
  spf?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Emails_Max_Fields = {
  __typename?: 'emails_max_fields';
  bcc?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  cc?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  dkim?: Maybe<Scalars['String']>;
  dmarc?: Maybe<Scalars['String']>;
  eml_url?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamp']>;
  receiver?: Maybe<Scalars['String']>;
  reply_to?: Maybe<Scalars['String']>;
  screenshot_url?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  /** The email address for the inbox that this email was found in */
  source_inbox?: Maybe<Scalars['String']>;
  spf?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Emails_Min_Fields = {
  __typename?: 'emails_min_fields';
  bcc?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  cc?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  dkim?: Maybe<Scalars['String']>;
  dmarc?: Maybe<Scalars['String']>;
  eml_url?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message_id?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  received_at?: Maybe<Scalars['timestamp']>;
  receiver?: Maybe<Scalars['String']>;
  reply_to?: Maybe<Scalars['String']>;
  screenshot_url?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  /** The email address for the inbox that this email was found in */
  source_inbox?: Maybe<Scalars['String']>;
  spf?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "emails" */
export type Emails_Mutation_Response = {
  __typename?: 'emails_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Emails>;
};

/** input type for inserting object relation for remote table "emails" */
export type Emails_Obj_Rel_Insert_Input = {
  data: Emails_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Emails_On_Conflict>;
};

/** on_conflict condition type for table "emails" */
export type Emails_On_Conflict = {
  constraint: Emails_Constraint;
  update_columns?: Array<Emails_Update_Column>;
  where?: InputMaybe<Emails_Bool_Exp>;
};

/** Ordering options when selecting data from "emails". */
export type Emails_Order_By = {
  bcc?: InputMaybe<Order_By>;
  body?: InputMaybe<Order_By>;
  cc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dkim?: InputMaybe<Order_By>;
  dmarc?: InputMaybe<Order_By>;
  email_correspondences_aggregate?: InputMaybe<Email_Correspondence_Aggregate_Order_By>;
  eml_url?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  forward_data?: InputMaybe<Order_By>;
  header_analysis?: InputMaybe<Order_By>;
  headers?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  receiver?: InputMaybe<Order_By>;
  reply_to?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  sender?: InputMaybe<Order_By>;
  sentiment_analysis?: InputMaybe<Order_By>;
  source_inbox?: InputMaybe<Order_By>;
  spf?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: emails */
export type Emails_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Emails_Prepend_Input = {
  forward_data?: InputMaybe<Scalars['jsonb']>;
  header_analysis?: InputMaybe<Scalars['jsonb']>;
  headers?: InputMaybe<Scalars['jsonb']>;
  sentiment_analysis?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "emails" */
export enum Emails_Select_Column {
  /** column name */
  Bcc = 'bcc',
  /** column name */
  Body = 'body',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dkim = 'dkim',
  /** column name */
  Dmarc = 'dmarc',
  /** column name */
  EmlUrl = 'eml_url',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ForwardData = 'forward_data',
  /** column name */
  HeaderAnalysis = 'header_analysis',
  /** column name */
  Headers = 'headers',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  Receiver = 'receiver',
  /** column name */
  ReplyTo = 'reply_to',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  Sender = 'sender',
  /** column name */
  SentimentAnalysis = 'sentiment_analysis',
  /** column name */
  SourceInbox = 'source_inbox',
  /** column name */
  Spf = 'spf',
  /** column name */
  Subject = 'subject',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "emails" */
export type Emails_Set_Input = {
  bcc?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  dkim?: InputMaybe<Scalars['String']>;
  dmarc?: InputMaybe<Scalars['String']>;
  eml_url?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  forward_data?: InputMaybe<Scalars['jsonb']>;
  header_analysis?: InputMaybe<Scalars['jsonb']>;
  headers?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  received_at?: InputMaybe<Scalars['timestamp']>;
  receiver?: InputMaybe<Scalars['String']>;
  reply_to?: InputMaybe<Scalars['String']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  sentiment_analysis?: InputMaybe<Scalars['jsonb']>;
  /** The email address for the inbox that this email was found in */
  source_inbox?: InputMaybe<Scalars['String']>;
  spf?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "emails" */
export type Emails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emails_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emails_Stream_Cursor_Value_Input = {
  bcc?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  dkim?: InputMaybe<Scalars['String']>;
  dmarc?: InputMaybe<Scalars['String']>;
  eml_url?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  forward_data?: InputMaybe<Scalars['jsonb']>;
  header_analysis?: InputMaybe<Scalars['jsonb']>;
  headers?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  message_id?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  received_at?: InputMaybe<Scalars['timestamp']>;
  receiver?: InputMaybe<Scalars['String']>;
  reply_to?: InputMaybe<Scalars['String']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  sentiment_analysis?: InputMaybe<Scalars['jsonb']>;
  /** The email address for the inbox that this email was found in */
  source_inbox?: InputMaybe<Scalars['String']>;
  spf?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "emails" */
export enum Emails_Update_Column {
  /** column name */
  Bcc = 'bcc',
  /** column name */
  Body = 'body',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dkim = 'dkim',
  /** column name */
  Dmarc = 'dmarc',
  /** column name */
  EmlUrl = 'eml_url',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ForwardData = 'forward_data',
  /** column name */
  HeaderAnalysis = 'header_analysis',
  /** column name */
  Headers = 'headers',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  Receiver = 'receiver',
  /** column name */
  ReplyTo = 'reply_to',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  Sender = 'sender',
  /** column name */
  SentimentAnalysis = 'sentiment_analysis',
  /** column name */
  SourceInbox = 'source_inbox',
  /** column name */
  Spf = 'spf',
  /** column name */
  Subject = 'subject',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Emails_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Emails_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Emails_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Emails_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Emails_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Emails_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Emails_Set_Input>;
  /** filter the rows which have to be updated */
  where: Emails_Bool_Exp;
};

/** columns and relationships of "enforcement_emails" */
export type Enforcement_Emails = {
  __typename?: 'enforcement_emails';
  /** An object relationship */
  enforcement_request?: Maybe<Enforcement_Requests>;
  enforcement_request_id?: Maybe<Scalars['uuid']>;
  external_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  llm_justification?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  platform_external_id?: Maybe<Scalars['String']>;
  processed_at: Scalars['timestamp'];
  received_at: Scalars['timestamp'];
  receiver: Scalars['String'];
  reply_to?: Maybe<Scalars['String']>;
  reported_url?: Maybe<Scalars['String']>;
  sender: Scalars['String'];
  subject: Scalars['String'];
  type: Scalars['String'];
};

/** aggregated selection of "enforcement_emails" */
export type Enforcement_Emails_Aggregate = {
  __typename?: 'enforcement_emails_aggregate';
  aggregate?: Maybe<Enforcement_Emails_Aggregate_Fields>;
  nodes: Array<Enforcement_Emails>;
};

/** aggregate fields of "enforcement_emails" */
export type Enforcement_Emails_Aggregate_Fields = {
  __typename?: 'enforcement_emails_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enforcement_Emails_Max_Fields>;
  min?: Maybe<Enforcement_Emails_Min_Fields>;
};


/** aggregate fields of "enforcement_emails" */
export type Enforcement_Emails_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enforcement_Emails_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enforcement_emails". All fields are combined with a logical 'AND'. */
export type Enforcement_Emails_Bool_Exp = {
  _and?: InputMaybe<Array<Enforcement_Emails_Bool_Exp>>;
  _not?: InputMaybe<Enforcement_Emails_Bool_Exp>;
  _or?: InputMaybe<Array<Enforcement_Emails_Bool_Exp>>;
  enforcement_request?: InputMaybe<Enforcement_Requests_Bool_Exp>;
  enforcement_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  llm_justification?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  platform_external_id?: InputMaybe<String_Comparison_Exp>;
  processed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  received_at?: InputMaybe<Timestamp_Comparison_Exp>;
  receiver?: InputMaybe<String_Comparison_Exp>;
  reply_to?: InputMaybe<String_Comparison_Exp>;
  reported_url?: InputMaybe<String_Comparison_Exp>;
  sender?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enforcement_emails" */
export enum Enforcement_Emails_Constraint {
  /** unique or primary key constraint on columns "external_id" */
  EmailsExternalIdKey = 'emails_external_id_key',
  /** unique or primary key constraint on columns "id" */
  EmailsPkey = 'emails_pkey'
}

/** input type for inserting data into table "enforcement_emails" */
export type Enforcement_Emails_Insert_Input = {
  enforcement_request?: InputMaybe<Enforcement_Requests_Obj_Rel_Insert_Input>;
  enforcement_request_id?: InputMaybe<Scalars['uuid']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_justification?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  platform_external_id?: InputMaybe<Scalars['String']>;
  processed_at?: InputMaybe<Scalars['timestamp']>;
  received_at?: InputMaybe<Scalars['timestamp']>;
  receiver?: InputMaybe<Scalars['String']>;
  reply_to?: InputMaybe<Scalars['String']>;
  reported_url?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Enforcement_Emails_Max_Fields = {
  __typename?: 'enforcement_emails_max_fields';
  enforcement_request_id?: Maybe<Scalars['uuid']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_justification?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  platform_external_id?: Maybe<Scalars['String']>;
  processed_at?: Maybe<Scalars['timestamp']>;
  received_at?: Maybe<Scalars['timestamp']>;
  receiver?: Maybe<Scalars['String']>;
  reply_to?: Maybe<Scalars['String']>;
  reported_url?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Enforcement_Emails_Min_Fields = {
  __typename?: 'enforcement_emails_min_fields';
  enforcement_request_id?: Maybe<Scalars['uuid']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  llm_justification?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  platform_external_id?: Maybe<Scalars['String']>;
  processed_at?: Maybe<Scalars['timestamp']>;
  received_at?: Maybe<Scalars['timestamp']>;
  receiver?: Maybe<Scalars['String']>;
  reply_to?: Maybe<Scalars['String']>;
  reported_url?: Maybe<Scalars['String']>;
  sender?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enforcement_emails" */
export type Enforcement_Emails_Mutation_Response = {
  __typename?: 'enforcement_emails_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enforcement_Emails>;
};

/** input type for inserting object relation for remote table "enforcement_emails" */
export type Enforcement_Emails_Obj_Rel_Insert_Input = {
  data: Enforcement_Emails_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enforcement_Emails_On_Conflict>;
};

/** on_conflict condition type for table "enforcement_emails" */
export type Enforcement_Emails_On_Conflict = {
  constraint: Enforcement_Emails_Constraint;
  update_columns?: Array<Enforcement_Emails_Update_Column>;
  where?: InputMaybe<Enforcement_Emails_Bool_Exp>;
};

/** Ordering options when selecting data from "enforcement_emails". */
export type Enforcement_Emails_Order_By = {
  enforcement_request?: InputMaybe<Enforcement_Requests_Order_By>;
  enforcement_request_id?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llm_justification?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  platform_external_id?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  receiver?: InputMaybe<Order_By>;
  reply_to?: InputMaybe<Order_By>;
  reported_url?: InputMaybe<Order_By>;
  sender?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enforcement_emails */
export type Enforcement_Emails_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "enforcement_emails" */
export enum Enforcement_Emails_Select_Column {
  /** column name */
  EnforcementRequestId = 'enforcement_request_id',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LlmJustification = 'llm_justification',
  /** column name */
  Platform = 'platform',
  /** column name */
  PlatformExternalId = 'platform_external_id',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  Receiver = 'receiver',
  /** column name */
  ReplyTo = 'reply_to',
  /** column name */
  ReportedUrl = 'reported_url',
  /** column name */
  Sender = 'sender',
  /** column name */
  Subject = 'subject',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "enforcement_emails" */
export type Enforcement_Emails_Set_Input = {
  enforcement_request_id?: InputMaybe<Scalars['uuid']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_justification?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  platform_external_id?: InputMaybe<Scalars['String']>;
  processed_at?: InputMaybe<Scalars['timestamp']>;
  received_at?: InputMaybe<Scalars['timestamp']>;
  receiver?: InputMaybe<Scalars['String']>;
  reply_to?: InputMaybe<Scalars['String']>;
  reported_url?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "enforcement_emails" */
export type Enforcement_Emails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enforcement_Emails_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enforcement_Emails_Stream_Cursor_Value_Input = {
  enforcement_request_id?: InputMaybe<Scalars['uuid']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_justification?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  platform_external_id?: InputMaybe<Scalars['String']>;
  processed_at?: InputMaybe<Scalars['timestamp']>;
  received_at?: InputMaybe<Scalars['timestamp']>;
  receiver?: InputMaybe<Scalars['String']>;
  reply_to?: InputMaybe<Scalars['String']>;
  reported_url?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enforcement_emails" */
export enum Enforcement_Emails_Update_Column {
  /** column name */
  EnforcementRequestId = 'enforcement_request_id',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LlmJustification = 'llm_justification',
  /** column name */
  Platform = 'platform',
  /** column name */
  PlatformExternalId = 'platform_external_id',
  /** column name */
  ProcessedAt = 'processed_at',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  Receiver = 'receiver',
  /** column name */
  ReplyTo = 'reply_to',
  /** column name */
  ReportedUrl = 'reported_url',
  /** column name */
  Sender = 'sender',
  /** column name */
  Subject = 'subject',
  /** column name */
  Type = 'type'
}

export type Enforcement_Emails_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enforcement_Emails_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enforcement_Emails_Bool_Exp;
};

/** Metadata for auto-submitting enforcement requests */
export type Enforcement_Metadata = {
  __typename?: 'enforcement_metadata';
  allowed_domain_enforcement_types: Scalars['jsonb'];
  /** file name in gcs bucket */
  authorization_letter_url?: Maybe<Scalars['String']>;
  authorization_letter_url_expiration_date?: Maybe<Scalars['date']>;
  /** 2 letters only */
  country_code?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamp'];
  enforcement_email?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  legal_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
};


/** Metadata for auto-submitting enforcement requests */
export type Enforcement_MetadataAllowed_Domain_Enforcement_TypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "enforcement_metadata" */
export type Enforcement_Metadata_Aggregate = {
  __typename?: 'enforcement_metadata_aggregate';
  aggregate?: Maybe<Enforcement_Metadata_Aggregate_Fields>;
  nodes: Array<Enforcement_Metadata>;
};

/** aggregate fields of "enforcement_metadata" */
export type Enforcement_Metadata_Aggregate_Fields = {
  __typename?: 'enforcement_metadata_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enforcement_Metadata_Max_Fields>;
  min?: Maybe<Enforcement_Metadata_Min_Fields>;
};


/** aggregate fields of "enforcement_metadata" */
export type Enforcement_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enforcement_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Enforcement_Metadata_Append_Input = {
  allowed_domain_enforcement_types?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "enforcement_metadata". All fields are combined with a logical 'AND'. */
export type Enforcement_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Enforcement_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Enforcement_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Enforcement_Metadata_Bool_Exp>>;
  allowed_domain_enforcement_types?: InputMaybe<Jsonb_Comparison_Exp>;
  authorization_letter_url?: InputMaybe<String_Comparison_Exp>;
  authorization_letter_url_expiration_date?: InputMaybe<Date_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  enforcement_email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  legal_name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "enforcement_metadata" */
export enum Enforcement_Metadata_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  EnforcementMetadataOrganizationIdKey = 'enforcement_metadata_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  EnforcementMetadataPkey = 'enforcement_metadata_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Enforcement_Metadata_Delete_At_Path_Input = {
  allowed_domain_enforcement_types?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Enforcement_Metadata_Delete_Elem_Input = {
  allowed_domain_enforcement_types?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Enforcement_Metadata_Delete_Key_Input = {
  allowed_domain_enforcement_types?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "enforcement_metadata" */
export type Enforcement_Metadata_Insert_Input = {
  allowed_domain_enforcement_types?: InputMaybe<Scalars['jsonb']>;
  /** file name in gcs bucket */
  authorization_letter_url?: InputMaybe<Scalars['String']>;
  authorization_letter_url_expiration_date?: InputMaybe<Scalars['date']>;
  /** 2 letters only */
  country_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  enforcement_email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  legal_name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Enforcement_Metadata_Max_Fields = {
  __typename?: 'enforcement_metadata_max_fields';
  /** file name in gcs bucket */
  authorization_letter_url?: Maybe<Scalars['String']>;
  authorization_letter_url_expiration_date?: Maybe<Scalars['date']>;
  /** 2 letters only */
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  enforcement_email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  legal_name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Enforcement_Metadata_Min_Fields = {
  __typename?: 'enforcement_metadata_min_fields';
  /** file name in gcs bucket */
  authorization_letter_url?: Maybe<Scalars['String']>;
  authorization_letter_url_expiration_date?: Maybe<Scalars['date']>;
  /** 2 letters only */
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  enforcement_email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  legal_name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "enforcement_metadata" */
export type Enforcement_Metadata_Mutation_Response = {
  __typename?: 'enforcement_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enforcement_Metadata>;
};

/** input type for inserting object relation for remote table "enforcement_metadata" */
export type Enforcement_Metadata_Obj_Rel_Insert_Input = {
  data: Enforcement_Metadata_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enforcement_Metadata_On_Conflict>;
};

/** on_conflict condition type for table "enforcement_metadata" */
export type Enforcement_Metadata_On_Conflict = {
  constraint: Enforcement_Metadata_Constraint;
  update_columns?: Array<Enforcement_Metadata_Update_Column>;
  where?: InputMaybe<Enforcement_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "enforcement_metadata". */
export type Enforcement_Metadata_Order_By = {
  allowed_domain_enforcement_types?: InputMaybe<Order_By>;
  authorization_letter_url?: InputMaybe<Order_By>;
  authorization_letter_url_expiration_date?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enforcement_email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legal_name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enforcement_metadata */
export type Enforcement_Metadata_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Enforcement_Metadata_Prepend_Input = {
  allowed_domain_enforcement_types?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "enforcement_metadata" */
export enum Enforcement_Metadata_Select_Column {
  /** column name */
  AllowedDomainEnforcementTypes = 'allowed_domain_enforcement_types',
  /** column name */
  AuthorizationLetterUrl = 'authorization_letter_url',
  /** column name */
  AuthorizationLetterUrlExpirationDate = 'authorization_letter_url_expiration_date',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnforcementEmail = 'enforcement_email',
  /** column name */
  Id = 'id',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  OrganizationId = 'organization_id'
}

/** input type for updating data in table "enforcement_metadata" */
export type Enforcement_Metadata_Set_Input = {
  allowed_domain_enforcement_types?: InputMaybe<Scalars['jsonb']>;
  /** file name in gcs bucket */
  authorization_letter_url?: InputMaybe<Scalars['String']>;
  authorization_letter_url_expiration_date?: InputMaybe<Scalars['date']>;
  /** 2 letters only */
  country_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  enforcement_email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  legal_name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "enforcement_metadata" */
export type Enforcement_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enforcement_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enforcement_Metadata_Stream_Cursor_Value_Input = {
  allowed_domain_enforcement_types?: InputMaybe<Scalars['jsonb']>;
  /** file name in gcs bucket */
  authorization_letter_url?: InputMaybe<Scalars['String']>;
  authorization_letter_url_expiration_date?: InputMaybe<Scalars['date']>;
  /** 2 letters only */
  country_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  enforcement_email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  legal_name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "enforcement_metadata" */
export enum Enforcement_Metadata_Update_Column {
  /** column name */
  AllowedDomainEnforcementTypes = 'allowed_domain_enforcement_types',
  /** column name */
  AuthorizationLetterUrl = 'authorization_letter_url',
  /** column name */
  AuthorizationLetterUrlExpirationDate = 'authorization_letter_url_expiration_date',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnforcementEmail = 'enforcement_email',
  /** column name */
  Id = 'id',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  OrganizationId = 'organization_id'
}

export type Enforcement_Metadata_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Enforcement_Metadata_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Enforcement_Metadata_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Enforcement_Metadata_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Enforcement_Metadata_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Enforcement_Metadata_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enforcement_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enforcement_Metadata_Bool_Exp;
};

/** Platforms used to send enforcements */
export type Enforcement_Platforms = {
  __typename?: 'enforcement_platforms';
  api_link?: Maybe<Scalars['String']>;
  as_numbers?: Maybe<Scalars['jsonb']>;
  compliance_status: Scalars['String'];
  created_at?: Maybe<Scalars['timestamp']>;
  default_timeout?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  /** An array relationship */
  enforcement_categories: Array<Enforcement_Types>;
  /** An aggregate relationship */
  enforcement_categories_aggregate: Enforcement_Types_Aggregate;
  enforcement_types: Scalars['jsonb'];
  escalate_enforcement_methods?: Maybe<Scalars['jsonb']>;
  escalate_time?: Maybe<Scalars['Int']>;
  form_link?: Maybe<Scalars['String']>;
  iana_ids?: Maybe<Scalars['jsonb']>;
  initial_enforcement_methods: Scalars['jsonb'];
  match_strings: Scalars['jsonb'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  types?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
};


/** Platforms used to send enforcements */
export type Enforcement_PlatformsAs_NumbersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Platforms used to send enforcements */
export type Enforcement_PlatformsEnforcement_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Types_Order_By>>;
  where?: InputMaybe<Enforcement_Types_Bool_Exp>;
};


/** Platforms used to send enforcements */
export type Enforcement_PlatformsEnforcement_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Types_Order_By>>;
  where?: InputMaybe<Enforcement_Types_Bool_Exp>;
};


/** Platforms used to send enforcements */
export type Enforcement_PlatformsEnforcement_TypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Platforms used to send enforcements */
export type Enforcement_PlatformsEscalate_Enforcement_MethodsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Platforms used to send enforcements */
export type Enforcement_PlatformsIana_IdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Platforms used to send enforcements */
export type Enforcement_PlatformsInitial_Enforcement_MethodsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Platforms used to send enforcements */
export type Enforcement_PlatformsMatch_StringsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Platforms used to send enforcements */
export type Enforcement_PlatformsTypesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "enforcement_platforms" */
export type Enforcement_Platforms_Aggregate = {
  __typename?: 'enforcement_platforms_aggregate';
  aggregate?: Maybe<Enforcement_Platforms_Aggregate_Fields>;
  nodes: Array<Enforcement_Platforms>;
};

/** aggregate fields of "enforcement_platforms" */
export type Enforcement_Platforms_Aggregate_Fields = {
  __typename?: 'enforcement_platforms_aggregate_fields';
  avg?: Maybe<Enforcement_Platforms_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Enforcement_Platforms_Max_Fields>;
  min?: Maybe<Enforcement_Platforms_Min_Fields>;
  stddev?: Maybe<Enforcement_Platforms_Stddev_Fields>;
  stddev_pop?: Maybe<Enforcement_Platforms_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Enforcement_Platforms_Stddev_Samp_Fields>;
  sum?: Maybe<Enforcement_Platforms_Sum_Fields>;
  var_pop?: Maybe<Enforcement_Platforms_Var_Pop_Fields>;
  var_samp?: Maybe<Enforcement_Platforms_Var_Samp_Fields>;
  variance?: Maybe<Enforcement_Platforms_Variance_Fields>;
};


/** aggregate fields of "enforcement_platforms" */
export type Enforcement_Platforms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enforcement_Platforms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Enforcement_Platforms_Append_Input = {
  as_numbers?: InputMaybe<Scalars['jsonb']>;
  enforcement_types?: InputMaybe<Scalars['jsonb']>;
  escalate_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  iana_ids?: InputMaybe<Scalars['jsonb']>;
  initial_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  match_strings?: InputMaybe<Scalars['jsonb']>;
  types?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Enforcement_Platforms_Avg_Fields = {
  __typename?: 'enforcement_platforms_avg_fields';
  default_timeout?: Maybe<Scalars['Float']>;
  escalate_time?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "enforcement_platforms". All fields are combined with a logical 'AND'. */
export type Enforcement_Platforms_Bool_Exp = {
  _and?: InputMaybe<Array<Enforcement_Platforms_Bool_Exp>>;
  _not?: InputMaybe<Enforcement_Platforms_Bool_Exp>;
  _or?: InputMaybe<Array<Enforcement_Platforms_Bool_Exp>>;
  api_link?: InputMaybe<String_Comparison_Exp>;
  as_numbers?: InputMaybe<Jsonb_Comparison_Exp>;
  compliance_status?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  default_timeout?: InputMaybe<Int_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  enforcement_categories?: InputMaybe<Enforcement_Types_Bool_Exp>;
  enforcement_categories_aggregate?: InputMaybe<Enforcement_Types_Aggregate_Bool_Exp>;
  enforcement_types?: InputMaybe<Jsonb_Comparison_Exp>;
  escalate_enforcement_methods?: InputMaybe<Jsonb_Comparison_Exp>;
  escalate_time?: InputMaybe<Int_Comparison_Exp>;
  form_link?: InputMaybe<String_Comparison_Exp>;
  iana_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  initial_enforcement_methods?: InputMaybe<Jsonb_Comparison_Exp>;
  match_strings?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  types?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "enforcement_platforms" */
export enum Enforcement_Platforms_Constraint {
  /** unique or primary key constraint on columns "name" */
  EnforcementPlatformsPkey = 'enforcement_platforms_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Enforcement_Platforms_Delete_At_Path_Input = {
  as_numbers?: InputMaybe<Array<Scalars['String']>>;
  enforcement_types?: InputMaybe<Array<Scalars['String']>>;
  escalate_enforcement_methods?: InputMaybe<Array<Scalars['String']>>;
  iana_ids?: InputMaybe<Array<Scalars['String']>>;
  initial_enforcement_methods?: InputMaybe<Array<Scalars['String']>>;
  match_strings?: InputMaybe<Array<Scalars['String']>>;
  types?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Enforcement_Platforms_Delete_Elem_Input = {
  as_numbers?: InputMaybe<Scalars['Int']>;
  enforcement_types?: InputMaybe<Scalars['Int']>;
  escalate_enforcement_methods?: InputMaybe<Scalars['Int']>;
  iana_ids?: InputMaybe<Scalars['Int']>;
  initial_enforcement_methods?: InputMaybe<Scalars['Int']>;
  match_strings?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Enforcement_Platforms_Delete_Key_Input = {
  as_numbers?: InputMaybe<Scalars['String']>;
  enforcement_types?: InputMaybe<Scalars['String']>;
  escalate_enforcement_methods?: InputMaybe<Scalars['String']>;
  iana_ids?: InputMaybe<Scalars['String']>;
  initial_enforcement_methods?: InputMaybe<Scalars['String']>;
  match_strings?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "enforcement_platforms" */
export type Enforcement_Platforms_Inc_Input = {
  default_timeout?: InputMaybe<Scalars['Int']>;
  escalate_time?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "enforcement_platforms" */
export type Enforcement_Platforms_Insert_Input = {
  api_link?: InputMaybe<Scalars['String']>;
  as_numbers?: InputMaybe<Scalars['jsonb']>;
  compliance_status?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  default_timeout?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  enforcement_categories?: InputMaybe<Enforcement_Types_Arr_Rel_Insert_Input>;
  enforcement_types?: InputMaybe<Scalars['jsonb']>;
  escalate_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  escalate_time?: InputMaybe<Scalars['Int']>;
  form_link?: InputMaybe<Scalars['String']>;
  iana_ids?: InputMaybe<Scalars['jsonb']>;
  initial_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  match_strings?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Enforcement_Platforms_Max_Fields = {
  __typename?: 'enforcement_platforms_max_fields';
  api_link?: Maybe<Scalars['String']>;
  compliance_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  default_timeout?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  escalate_time?: Maybe<Scalars['Int']>;
  form_link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Enforcement_Platforms_Min_Fields = {
  __typename?: 'enforcement_platforms_min_fields';
  api_link?: Maybe<Scalars['String']>;
  compliance_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  default_timeout?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  escalate_time?: Maybe<Scalars['Int']>;
  form_link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "enforcement_platforms" */
export type Enforcement_Platforms_Mutation_Response = {
  __typename?: 'enforcement_platforms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enforcement_Platforms>;
};

/** input type for inserting object relation for remote table "enforcement_platforms" */
export type Enforcement_Platforms_Obj_Rel_Insert_Input = {
  data: Enforcement_Platforms_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enforcement_Platforms_On_Conflict>;
};

/** on_conflict condition type for table "enforcement_platforms" */
export type Enforcement_Platforms_On_Conflict = {
  constraint: Enforcement_Platforms_Constraint;
  update_columns?: Array<Enforcement_Platforms_Update_Column>;
  where?: InputMaybe<Enforcement_Platforms_Bool_Exp>;
};

/** Ordering options when selecting data from "enforcement_platforms". */
export type Enforcement_Platforms_Order_By = {
  api_link?: InputMaybe<Order_By>;
  as_numbers?: InputMaybe<Order_By>;
  compliance_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  default_timeout?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  enforcement_categories_aggregate?: InputMaybe<Enforcement_Types_Aggregate_Order_By>;
  enforcement_types?: InputMaybe<Order_By>;
  escalate_enforcement_methods?: InputMaybe<Order_By>;
  escalate_time?: InputMaybe<Order_By>;
  form_link?: InputMaybe<Order_By>;
  iana_ids?: InputMaybe<Order_By>;
  initial_enforcement_methods?: InputMaybe<Order_By>;
  match_strings?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  types?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: enforcement_platforms */
export type Enforcement_Platforms_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Enforcement_Platforms_Prepend_Input = {
  as_numbers?: InputMaybe<Scalars['jsonb']>;
  enforcement_types?: InputMaybe<Scalars['jsonb']>;
  escalate_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  iana_ids?: InputMaybe<Scalars['jsonb']>;
  initial_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  match_strings?: InputMaybe<Scalars['jsonb']>;
  types?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "enforcement_platforms" */
export enum Enforcement_Platforms_Select_Column {
  /** column name */
  ApiLink = 'api_link',
  /** column name */
  AsNumbers = 'as_numbers',
  /** column name */
  ComplianceStatus = 'compliance_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultTimeout = 'default_timeout',
  /** column name */
  Email = 'email',
  /** column name */
  EnforcementTypes = 'enforcement_types',
  /** column name */
  EscalateEnforcementMethods = 'escalate_enforcement_methods',
  /** column name */
  EscalateTime = 'escalate_time',
  /** column name */
  FormLink = 'form_link',
  /** column name */
  IanaIds = 'iana_ids',
  /** column name */
  InitialEnforcementMethods = 'initial_enforcement_methods',
  /** column name */
  MatchStrings = 'match_strings',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  Platform = 'platform',
  /** column name */
  Product = 'product',
  /** column name */
  Types = 'types',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "enforcement_platforms" */
export type Enforcement_Platforms_Set_Input = {
  api_link?: InputMaybe<Scalars['String']>;
  as_numbers?: InputMaybe<Scalars['jsonb']>;
  compliance_status?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  default_timeout?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  enforcement_types?: InputMaybe<Scalars['jsonb']>;
  escalate_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  escalate_time?: InputMaybe<Scalars['Int']>;
  form_link?: InputMaybe<Scalars['String']>;
  iana_ids?: InputMaybe<Scalars['jsonb']>;
  initial_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  match_strings?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Enforcement_Platforms_Stddev_Fields = {
  __typename?: 'enforcement_platforms_stddev_fields';
  default_timeout?: Maybe<Scalars['Float']>;
  escalate_time?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Enforcement_Platforms_Stddev_Pop_Fields = {
  __typename?: 'enforcement_platforms_stddev_pop_fields';
  default_timeout?: Maybe<Scalars['Float']>;
  escalate_time?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Enforcement_Platforms_Stddev_Samp_Fields = {
  __typename?: 'enforcement_platforms_stddev_samp_fields';
  default_timeout?: Maybe<Scalars['Float']>;
  escalate_time?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "enforcement_platforms" */
export type Enforcement_Platforms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enforcement_Platforms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enforcement_Platforms_Stream_Cursor_Value_Input = {
  api_link?: InputMaybe<Scalars['String']>;
  as_numbers?: InputMaybe<Scalars['jsonb']>;
  compliance_status?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  default_timeout?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  enforcement_types?: InputMaybe<Scalars['jsonb']>;
  escalate_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  escalate_time?: InputMaybe<Scalars['Int']>;
  form_link?: InputMaybe<Scalars['String']>;
  iana_ids?: InputMaybe<Scalars['jsonb']>;
  initial_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  match_strings?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Enforcement_Platforms_Sum_Fields = {
  __typename?: 'enforcement_platforms_sum_fields';
  default_timeout?: Maybe<Scalars['Int']>;
  escalate_time?: Maybe<Scalars['Int']>;
};

/** update columns of table "enforcement_platforms" */
export enum Enforcement_Platforms_Update_Column {
  /** column name */
  ApiLink = 'api_link',
  /** column name */
  AsNumbers = 'as_numbers',
  /** column name */
  ComplianceStatus = 'compliance_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DefaultTimeout = 'default_timeout',
  /** column name */
  Email = 'email',
  /** column name */
  EnforcementTypes = 'enforcement_types',
  /** column name */
  EscalateEnforcementMethods = 'escalate_enforcement_methods',
  /** column name */
  EscalateTime = 'escalate_time',
  /** column name */
  FormLink = 'form_link',
  /** column name */
  IanaIds = 'iana_ids',
  /** column name */
  InitialEnforcementMethods = 'initial_enforcement_methods',
  /** column name */
  MatchStrings = 'match_strings',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  Platform = 'platform',
  /** column name */
  Product = 'product',
  /** column name */
  Types = 'types',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Enforcement_Platforms_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Enforcement_Platforms_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Enforcement_Platforms_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Enforcement_Platforms_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Enforcement_Platforms_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Enforcement_Platforms_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Enforcement_Platforms_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enforcement_Platforms_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enforcement_Platforms_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Enforcement_Platforms_Var_Pop_Fields = {
  __typename?: 'enforcement_platforms_var_pop_fields';
  default_timeout?: Maybe<Scalars['Float']>;
  escalate_time?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Enforcement_Platforms_Var_Samp_Fields = {
  __typename?: 'enforcement_platforms_var_samp_fields';
  default_timeout?: Maybe<Scalars['Float']>;
  escalate_time?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Enforcement_Platforms_Variance_Fields = {
  __typename?: 'enforcement_platforms_variance_fields';
  default_timeout?: Maybe<Scalars['Float']>;
  escalate_time?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "enforcement_requests" */
export type Enforcement_Requests = {
  __typename?: 'enforcement_requests';
  body?: Maybe<Scalars['String']>;
  /** An array relationship */
  collection_report_changes: Array<Collection_Report_Changes>;
  /** An aggregate relationship */
  collection_report_changes_aggregate: Collection_Report_Changes_Aggregate;
  collection_report_id?: Maybe<Scalars['uuid']>;
  copyright_original_work_description?: Maybe<Scalars['String']>;
  copyrighted_content_url?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  /** An array relationship */
  jira_metadata: Array<Jira_Metadata>;
  /** An aggregate relationship */
  jira_metadata_aggregate: Jira_Metadata_Aggregate;
  mx_provider_description?: Maybe<Scalars['String']>;
  original_content_type?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  retraction_description?: Maybe<Scalars['String']>;
  retraction_proof_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  spoofing_report?: Maybe<Spoofing_Reports>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  submission_email?: Maybe<Scalars['String']>;
  submission_external_id?: Maybe<Scalars['String']>;
  submission_proof_url?: Maybe<Scalars['String']>;
  submission_source?: Maybe<Scalars['String']>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  submitter_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  suggested_enforcement?: Maybe<Suggested_Enforcements>;
  suggested_enforcement_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  trademark?: Maybe<Trademarks>;
  trademark_id?: Maybe<Scalars['uuid']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user?: Maybe<Users>;
};


/** columns and relationships of "enforcement_requests" */
export type Enforcement_RequestsCollection_Report_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};


/** columns and relationships of "enforcement_requests" */
export type Enforcement_RequestsCollection_Report_Changes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};


/** columns and relationships of "enforcement_requests" */
export type Enforcement_RequestsJira_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Jira_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jira_Metadata_Order_By>>;
  where?: InputMaybe<Jira_Metadata_Bool_Exp>;
};


/** columns and relationships of "enforcement_requests" */
export type Enforcement_RequestsJira_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jira_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jira_Metadata_Order_By>>;
  where?: InputMaybe<Jira_Metadata_Bool_Exp>;
};

/** aggregated selection of "enforcement_requests" */
export type Enforcement_Requests_Aggregate = {
  __typename?: 'enforcement_requests_aggregate';
  aggregate?: Maybe<Enforcement_Requests_Aggregate_Fields>;
  nodes: Array<Enforcement_Requests>;
};

export type Enforcement_Requests_Aggregate_Bool_Exp = {
  count?: InputMaybe<Enforcement_Requests_Aggregate_Bool_Exp_Count>;
};

export type Enforcement_Requests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Enforcement_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Enforcement_Requests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "enforcement_requests" */
export type Enforcement_Requests_Aggregate_Fields = {
  __typename?: 'enforcement_requests_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enforcement_Requests_Max_Fields>;
  min?: Maybe<Enforcement_Requests_Min_Fields>;
};


/** aggregate fields of "enforcement_requests" */
export type Enforcement_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enforcement_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "enforcement_requests" */
export type Enforcement_Requests_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Enforcement_Requests_Max_Order_By>;
  min?: InputMaybe<Enforcement_Requests_Min_Order_By>;
};

/** input type for inserting array relation for remote table "enforcement_requests" */
export type Enforcement_Requests_Arr_Rel_Insert_Input = {
  data: Array<Enforcement_Requests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Enforcement_Requests_On_Conflict>;
};

/** Boolean expression to filter rows from the table "enforcement_requests". All fields are combined with a logical 'AND'. */
export type Enforcement_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Enforcement_Requests_Bool_Exp>>;
  _not?: InputMaybe<Enforcement_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Enforcement_Requests_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  collection_report_changes?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
  collection_report_changes_aggregate?: InputMaybe<Collection_Report_Changes_Aggregate_Bool_Exp>;
  collection_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  copyright_original_work_description?: InputMaybe<String_Comparison_Exp>;
  copyrighted_content_url?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jira_metadata?: InputMaybe<Jira_Metadata_Bool_Exp>;
  jira_metadata_aggregate?: InputMaybe<Jira_Metadata_Aggregate_Bool_Exp>;
  mx_provider_description?: InputMaybe<String_Comparison_Exp>;
  original_content_type?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  retraction_description?: InputMaybe<String_Comparison_Exp>;
  retraction_proof_url?: InputMaybe<String_Comparison_Exp>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  spoofing_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  submission_email?: InputMaybe<String_Comparison_Exp>;
  submission_external_id?: InputMaybe<String_Comparison_Exp>;
  submission_proof_url?: InputMaybe<String_Comparison_Exp>;
  submission_source?: InputMaybe<String_Comparison_Exp>;
  submitted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  submitter_id?: InputMaybe<Uuid_Comparison_Exp>;
  suggested_enforcement?: InputMaybe<Suggested_Enforcements_Bool_Exp>;
  suggested_enforcement_id?: InputMaybe<Uuid_Comparison_Exp>;
  trademark?: InputMaybe<Trademarks_Bool_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "enforcement_requests" */
export enum Enforcement_Requests_Constraint {
  /** unique or primary key constraint on columns "id" */
  EnforcementRequestsPkey = 'enforcement_requests_pkey'
}

/** input type for inserting data into table "enforcement_requests" */
export type Enforcement_Requests_Insert_Input = {
  body?: InputMaybe<Scalars['String']>;
  collection_report_changes?: InputMaybe<Collection_Report_Changes_Arr_Rel_Insert_Input>;
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  copyright_original_work_description?: InputMaybe<Scalars['String']>;
  copyrighted_content_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  jira_metadata?: InputMaybe<Jira_Metadata_Arr_Rel_Insert_Input>;
  mx_provider_description?: InputMaybe<Scalars['String']>;
  original_content_type?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  retraction_description?: InputMaybe<Scalars['String']>;
  retraction_proof_url?: InputMaybe<Scalars['String']>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  submission_email?: InputMaybe<Scalars['String']>;
  submission_external_id?: InputMaybe<Scalars['String']>;
  submission_proof_url?: InputMaybe<Scalars['String']>;
  submission_source?: InputMaybe<Scalars['String']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  submitter_id?: InputMaybe<Scalars['uuid']>;
  suggested_enforcement?: InputMaybe<Suggested_Enforcements_Obj_Rel_Insert_Input>;
  suggested_enforcement_id?: InputMaybe<Scalars['uuid']>;
  trademark?: InputMaybe<Trademarks_Obj_Rel_Insert_Input>;
  trademark_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Enforcement_Requests_Max_Fields = {
  __typename?: 'enforcement_requests_max_fields';
  body?: Maybe<Scalars['String']>;
  collection_report_id?: Maybe<Scalars['uuid']>;
  copyright_original_work_description?: Maybe<Scalars['String']>;
  copyrighted_content_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  mx_provider_description?: Maybe<Scalars['String']>;
  original_content_type?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  retraction_description?: Maybe<Scalars['String']>;
  retraction_proof_url?: Maybe<Scalars['String']>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  submission_email?: Maybe<Scalars['String']>;
  submission_external_id?: Maybe<Scalars['String']>;
  submission_proof_url?: Maybe<Scalars['String']>;
  submission_source?: Maybe<Scalars['String']>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  submitter_id?: Maybe<Scalars['uuid']>;
  suggested_enforcement_id?: Maybe<Scalars['uuid']>;
  trademark_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "enforcement_requests" */
export type Enforcement_Requests_Max_Order_By = {
  body?: InputMaybe<Order_By>;
  collection_report_id?: InputMaybe<Order_By>;
  copyright_original_work_description?: InputMaybe<Order_By>;
  copyrighted_content_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mx_provider_description?: InputMaybe<Order_By>;
  original_content_type?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  retraction_description?: InputMaybe<Order_By>;
  retraction_proof_url?: InputMaybe<Order_By>;
  spoofing_report_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submission_email?: InputMaybe<Order_By>;
  submission_external_id?: InputMaybe<Order_By>;
  submission_proof_url?: InputMaybe<Order_By>;
  submission_source?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  submitter_id?: InputMaybe<Order_By>;
  suggested_enforcement_id?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Enforcement_Requests_Min_Fields = {
  __typename?: 'enforcement_requests_min_fields';
  body?: Maybe<Scalars['String']>;
  collection_report_id?: Maybe<Scalars['uuid']>;
  copyright_original_work_description?: Maybe<Scalars['String']>;
  copyrighted_content_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  mx_provider_description?: Maybe<Scalars['String']>;
  original_content_type?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  retraction_description?: Maybe<Scalars['String']>;
  retraction_proof_url?: Maybe<Scalars['String']>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  submission_email?: Maybe<Scalars['String']>;
  submission_external_id?: Maybe<Scalars['String']>;
  submission_proof_url?: Maybe<Scalars['String']>;
  submission_source?: Maybe<Scalars['String']>;
  submitted_at?: Maybe<Scalars['timestamp']>;
  submitter_id?: Maybe<Scalars['uuid']>;
  suggested_enforcement_id?: Maybe<Scalars['uuid']>;
  trademark_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "enforcement_requests" */
export type Enforcement_Requests_Min_Order_By = {
  body?: InputMaybe<Order_By>;
  collection_report_id?: InputMaybe<Order_By>;
  copyright_original_work_description?: InputMaybe<Order_By>;
  copyrighted_content_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mx_provider_description?: InputMaybe<Order_By>;
  original_content_type?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  retraction_description?: InputMaybe<Order_By>;
  retraction_proof_url?: InputMaybe<Order_By>;
  spoofing_report_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submission_email?: InputMaybe<Order_By>;
  submission_external_id?: InputMaybe<Order_By>;
  submission_proof_url?: InputMaybe<Order_By>;
  submission_source?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  submitter_id?: InputMaybe<Order_By>;
  suggested_enforcement_id?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "enforcement_requests" */
export type Enforcement_Requests_Mutation_Response = {
  __typename?: 'enforcement_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enforcement_Requests>;
};

/** input type for inserting object relation for remote table "enforcement_requests" */
export type Enforcement_Requests_Obj_Rel_Insert_Input = {
  data: Enforcement_Requests_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enforcement_Requests_On_Conflict>;
};

/** on_conflict condition type for table "enforcement_requests" */
export type Enforcement_Requests_On_Conflict = {
  constraint: Enforcement_Requests_Constraint;
  update_columns?: Array<Enforcement_Requests_Update_Column>;
  where?: InputMaybe<Enforcement_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "enforcement_requests". */
export type Enforcement_Requests_Order_By = {
  body?: InputMaybe<Order_By>;
  collection_report_changes_aggregate?: InputMaybe<Collection_Report_Changes_Aggregate_Order_By>;
  collection_report_id?: InputMaybe<Order_By>;
  copyright_original_work_description?: InputMaybe<Order_By>;
  copyrighted_content_url?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jira_metadata_aggregate?: InputMaybe<Jira_Metadata_Aggregate_Order_By>;
  mx_provider_description?: InputMaybe<Order_By>;
  original_content_type?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  retraction_description?: InputMaybe<Order_By>;
  retraction_proof_url?: InputMaybe<Order_By>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Order_By>;
  spoofing_report_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  submission_email?: InputMaybe<Order_By>;
  submission_external_id?: InputMaybe<Order_By>;
  submission_proof_url?: InputMaybe<Order_By>;
  submission_source?: InputMaybe<Order_By>;
  submitted_at?: InputMaybe<Order_By>;
  submitter_id?: InputMaybe<Order_By>;
  suggested_enforcement?: InputMaybe<Suggested_Enforcements_Order_By>;
  suggested_enforcement_id?: InputMaybe<Order_By>;
  trademark?: InputMaybe<Trademarks_Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: enforcement_requests */
export type Enforcement_Requests_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "enforcement_requests" */
export enum Enforcement_Requests_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CollectionReportId = 'collection_report_id',
  /** column name */
  CopyrightOriginalWorkDescription = 'copyright_original_work_description',
  /** column name */
  CopyrightedContentUrl = 'copyrighted_content_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MxProviderDescription = 'mx_provider_description',
  /** column name */
  OriginalContentType = 'original_content_type',
  /** column name */
  Platform = 'platform',
  /** column name */
  Reason = 'reason',
  /** column name */
  RetractionDescription = 'retraction_description',
  /** column name */
  RetractionProofUrl = 'retraction_proof_url',
  /** column name */
  SpoofingReportId = 'spoofing_report_id',
  /** column name */
  Status = 'status',
  /** column name */
  SubmissionEmail = 'submission_email',
  /** column name */
  SubmissionExternalId = 'submission_external_id',
  /** column name */
  SubmissionProofUrl = 'submission_proof_url',
  /** column name */
  SubmissionSource = 'submission_source',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  SubmitterId = 'submitter_id',
  /** column name */
  SuggestedEnforcementId = 'suggested_enforcement_id',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "enforcement_requests" */
export type Enforcement_Requests_Set_Input = {
  body?: InputMaybe<Scalars['String']>;
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  copyright_original_work_description?: InputMaybe<Scalars['String']>;
  copyrighted_content_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  mx_provider_description?: InputMaybe<Scalars['String']>;
  original_content_type?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  retraction_description?: InputMaybe<Scalars['String']>;
  retraction_proof_url?: InputMaybe<Scalars['String']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  submission_email?: InputMaybe<Scalars['String']>;
  submission_external_id?: InputMaybe<Scalars['String']>;
  submission_proof_url?: InputMaybe<Scalars['String']>;
  submission_source?: InputMaybe<Scalars['String']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  submitter_id?: InputMaybe<Scalars['uuid']>;
  suggested_enforcement_id?: InputMaybe<Scalars['uuid']>;
  trademark_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "enforcement_requests" */
export type Enforcement_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enforcement_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enforcement_Requests_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']>;
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  copyright_original_work_description?: InputMaybe<Scalars['String']>;
  copyrighted_content_url?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  mx_provider_description?: InputMaybe<Scalars['String']>;
  original_content_type?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  retraction_description?: InputMaybe<Scalars['String']>;
  retraction_proof_url?: InputMaybe<Scalars['String']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  submission_email?: InputMaybe<Scalars['String']>;
  submission_external_id?: InputMaybe<Scalars['String']>;
  submission_proof_url?: InputMaybe<Scalars['String']>;
  submission_source?: InputMaybe<Scalars['String']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  submitter_id?: InputMaybe<Scalars['uuid']>;
  suggested_enforcement_id?: InputMaybe<Scalars['uuid']>;
  trademark_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "enforcement_requests" */
export enum Enforcement_Requests_Update_Column {
  /** column name */
  Body = 'body',
  /** column name */
  CollectionReportId = 'collection_report_id',
  /** column name */
  CopyrightOriginalWorkDescription = 'copyright_original_work_description',
  /** column name */
  CopyrightedContentUrl = 'copyrighted_content_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MxProviderDescription = 'mx_provider_description',
  /** column name */
  OriginalContentType = 'original_content_type',
  /** column name */
  Platform = 'platform',
  /** column name */
  Reason = 'reason',
  /** column name */
  RetractionDescription = 'retraction_description',
  /** column name */
  RetractionProofUrl = 'retraction_proof_url',
  /** column name */
  SpoofingReportId = 'spoofing_report_id',
  /** column name */
  Status = 'status',
  /** column name */
  SubmissionEmail = 'submission_email',
  /** column name */
  SubmissionExternalId = 'submission_external_id',
  /** column name */
  SubmissionProofUrl = 'submission_proof_url',
  /** column name */
  SubmissionSource = 'submission_source',
  /** column name */
  SubmittedAt = 'submitted_at',
  /** column name */
  SubmitterId = 'submitter_id',
  /** column name */
  SuggestedEnforcementId = 'suggested_enforcement_id',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Enforcement_Requests_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enforcement_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enforcement_Requests_Bool_Exp;
};

/** storing information about takedown requests */
export type Enforcement_Templates = {
  __typename?: 'enforcement_templates';
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  optional_input: Scalars['jsonb'];
  platform: Scalars['String'];
  stage?: Maybe<Scalars['String']>;
  template_body: Scalars['String'];
  type: Scalars['String'];
  updated_at: Scalars['timestamp'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
};


/** storing information about takedown requests */
export type Enforcement_TemplatesOptional_InputArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "enforcement_templates" */
export type Enforcement_Templates_Aggregate = {
  __typename?: 'enforcement_templates_aggregate';
  aggregate?: Maybe<Enforcement_Templates_Aggregate_Fields>;
  nodes: Array<Enforcement_Templates>;
};

/** aggregate fields of "enforcement_templates" */
export type Enforcement_Templates_Aggregate_Fields = {
  __typename?: 'enforcement_templates_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enforcement_Templates_Max_Fields>;
  min?: Maybe<Enforcement_Templates_Min_Fields>;
};


/** aggregate fields of "enforcement_templates" */
export type Enforcement_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enforcement_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Enforcement_Templates_Append_Input = {
  optional_input?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "enforcement_templates". All fields are combined with a logical 'AND'. */
export type Enforcement_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Enforcement_Templates_Bool_Exp>>;
  _not?: InputMaybe<Enforcement_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Enforcement_Templates_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  optional_input?: InputMaybe<Jsonb_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  stage?: InputMaybe<String_Comparison_Exp>;
  template_body?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "enforcement_templates" */
export enum Enforcement_Templates_Constraint {
  /** unique or primary key constraint on columns "type", "platform", "stage" */
  EnforcementTemplatesPlatformTypeStageKey = 'enforcement_templates_platform_type_stage_key',
  /** unique or primary key constraint on columns "id" */
  TakedownRequestTemplatesPkey = 'takedown_request_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Enforcement_Templates_Delete_At_Path_Input = {
  optional_input?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Enforcement_Templates_Delete_Elem_Input = {
  optional_input?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Enforcement_Templates_Delete_Key_Input = {
  optional_input?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "enforcement_templates" */
export type Enforcement_Templates_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  optional_input?: InputMaybe<Scalars['jsonb']>;
  platform?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Scalars['String']>;
  template_body?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Enforcement_Templates_Max_Fields = {
  __typename?: 'enforcement_templates_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  template_body?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Enforcement_Templates_Min_Fields = {
  __typename?: 'enforcement_templates_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  template_body?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "enforcement_templates" */
export type Enforcement_Templates_Mutation_Response = {
  __typename?: 'enforcement_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enforcement_Templates>;
};

/** on_conflict condition type for table "enforcement_templates" */
export type Enforcement_Templates_On_Conflict = {
  constraint: Enforcement_Templates_Constraint;
  update_columns?: Array<Enforcement_Templates_Update_Column>;
  where?: InputMaybe<Enforcement_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "enforcement_templates". */
export type Enforcement_Templates_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  optional_input?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  template_body?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: enforcement_templates */
export type Enforcement_Templates_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Enforcement_Templates_Prepend_Input = {
  optional_input?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "enforcement_templates" */
export enum Enforcement_Templates_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OptionalInput = 'optional_input',
  /** column name */
  Platform = 'platform',
  /** column name */
  Stage = 'stage',
  /** column name */
  TemplateBody = 'template_body',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "enforcement_templates" */
export type Enforcement_Templates_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  optional_input?: InputMaybe<Scalars['jsonb']>;
  platform?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Scalars['String']>;
  template_body?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "enforcement_templates" */
export type Enforcement_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enforcement_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enforcement_Templates_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  optional_input?: InputMaybe<Scalars['jsonb']>;
  platform?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Scalars['String']>;
  template_body?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "enforcement_templates" */
export enum Enforcement_Templates_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OptionalInput = 'optional_input',
  /** column name */
  Platform = 'platform',
  /** column name */
  Stage = 'stage',
  /** column name */
  TemplateBody = 'template_body',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Enforcement_Templates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Enforcement_Templates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Enforcement_Templates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Enforcement_Templates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Enforcement_Templates_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Enforcement_Templates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enforcement_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enforcement_Templates_Bool_Exp;
};

/** columns and relationships of "enforcement_types" */
export type Enforcement_Types = {
  __typename?: 'enforcement_types';
  content_type?: Maybe<Scalars['String']>;
  content_type_display_name?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamp'];
  enforcement_method_data?: Maybe<Scalars['String']>;
  enforcement_method_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  enforcement_platform: Enforcement_Platforms;
  id: Scalars['uuid'];
  manual_form_fields?: Maybe<Scalars['jsonb']>;
  platform: Scalars['String'];
  priority: Scalars['Int'];
  stage?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamp'];
  updated_by?: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "enforcement_types" */
export type Enforcement_TypesManual_Form_FieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "enforcement_types" */
export type Enforcement_Types_Aggregate = {
  __typename?: 'enforcement_types_aggregate';
  aggregate?: Maybe<Enforcement_Types_Aggregate_Fields>;
  nodes: Array<Enforcement_Types>;
};

export type Enforcement_Types_Aggregate_Bool_Exp = {
  count?: InputMaybe<Enforcement_Types_Aggregate_Bool_Exp_Count>;
};

export type Enforcement_Types_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Enforcement_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Enforcement_Types_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "enforcement_types" */
export type Enforcement_Types_Aggregate_Fields = {
  __typename?: 'enforcement_types_aggregate_fields';
  avg?: Maybe<Enforcement_Types_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Enforcement_Types_Max_Fields>;
  min?: Maybe<Enforcement_Types_Min_Fields>;
  stddev?: Maybe<Enforcement_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Enforcement_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Enforcement_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Enforcement_Types_Sum_Fields>;
  var_pop?: Maybe<Enforcement_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Enforcement_Types_Var_Samp_Fields>;
  variance?: Maybe<Enforcement_Types_Variance_Fields>;
};


/** aggregate fields of "enforcement_types" */
export type Enforcement_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enforcement_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "enforcement_types" */
export type Enforcement_Types_Aggregate_Order_By = {
  avg?: InputMaybe<Enforcement_Types_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Enforcement_Types_Max_Order_By>;
  min?: InputMaybe<Enforcement_Types_Min_Order_By>;
  stddev?: InputMaybe<Enforcement_Types_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Enforcement_Types_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Enforcement_Types_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Enforcement_Types_Sum_Order_By>;
  var_pop?: InputMaybe<Enforcement_Types_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Enforcement_Types_Var_Samp_Order_By>;
  variance?: InputMaybe<Enforcement_Types_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Enforcement_Types_Append_Input = {
  manual_form_fields?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "enforcement_types" */
export type Enforcement_Types_Arr_Rel_Insert_Input = {
  data: Array<Enforcement_Types_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Enforcement_Types_On_Conflict>;
};

/** aggregate avg on columns */
export type Enforcement_Types_Avg_Fields = {
  __typename?: 'enforcement_types_avg_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "enforcement_types" */
export type Enforcement_Types_Avg_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "enforcement_types". All fields are combined with a logical 'AND'. */
export type Enforcement_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Enforcement_Types_Bool_Exp>>;
  _not?: InputMaybe<Enforcement_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Enforcement_Types_Bool_Exp>>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  content_type_display_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  enforcement_method_data?: InputMaybe<String_Comparison_Exp>;
  enforcement_method_type?: InputMaybe<String_Comparison_Exp>;
  enforcement_platform?: InputMaybe<Enforcement_Platforms_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  manual_form_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  stage?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "enforcement_types" */
export enum Enforcement_Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  EnforcementTypesPkey = 'enforcement_types_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Enforcement_Types_Delete_At_Path_Input = {
  manual_form_fields?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Enforcement_Types_Delete_Elem_Input = {
  manual_form_fields?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Enforcement_Types_Delete_Key_Input = {
  manual_form_fields?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "enforcement_types" */
export type Enforcement_Types_Inc_Input = {
  priority?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "enforcement_types" */
export type Enforcement_Types_Insert_Input = {
  content_type?: InputMaybe<Scalars['String']>;
  content_type_display_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  enforcement_method_data?: InputMaybe<Scalars['String']>;
  enforcement_method_type?: InputMaybe<Scalars['String']>;
  enforcement_platform?: InputMaybe<Enforcement_Platforms_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  manual_form_fields?: InputMaybe<Scalars['jsonb']>;
  platform?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Enforcement_Types_Max_Fields = {
  __typename?: 'enforcement_types_max_fields';
  content_type?: Maybe<Scalars['String']>;
  content_type_display_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  enforcement_method_data?: Maybe<Scalars['String']>;
  enforcement_method_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  stage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "enforcement_types" */
export type Enforcement_Types_Max_Order_By = {
  content_type?: InputMaybe<Order_By>;
  content_type_display_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enforcement_method_data?: InputMaybe<Order_By>;
  enforcement_method_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Enforcement_Types_Min_Fields = {
  __typename?: 'enforcement_types_min_fields';
  content_type?: Maybe<Scalars['String']>;
  content_type_display_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  enforcement_method_data?: Maybe<Scalars['String']>;
  enforcement_method_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  stage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "enforcement_types" */
export type Enforcement_Types_Min_Order_By = {
  content_type?: InputMaybe<Order_By>;
  content_type_display_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enforcement_method_data?: InputMaybe<Order_By>;
  enforcement_method_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "enforcement_types" */
export type Enforcement_Types_Mutation_Response = {
  __typename?: 'enforcement_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enforcement_Types>;
};

/** on_conflict condition type for table "enforcement_types" */
export type Enforcement_Types_On_Conflict = {
  constraint: Enforcement_Types_Constraint;
  update_columns?: Array<Enforcement_Types_Update_Column>;
  where?: InputMaybe<Enforcement_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "enforcement_types". */
export type Enforcement_Types_Order_By = {
  content_type?: InputMaybe<Order_By>;
  content_type_display_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enforcement_method_data?: InputMaybe<Order_By>;
  enforcement_method_type?: InputMaybe<Order_By>;
  enforcement_platform?: InputMaybe<Enforcement_Platforms_Order_By>;
  id?: InputMaybe<Order_By>;
  manual_form_fields?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enforcement_types */
export type Enforcement_Types_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Enforcement_Types_Prepend_Input = {
  manual_form_fields?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "enforcement_types" */
export enum Enforcement_Types_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  ContentTypeDisplayName = 'content_type_display_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnforcementMethodData = 'enforcement_method_data',
  /** column name */
  EnforcementMethodType = 'enforcement_method_type',
  /** column name */
  Id = 'id',
  /** column name */
  ManualFormFields = 'manual_form_fields',
  /** column name */
  Platform = 'platform',
  /** column name */
  Priority = 'priority',
  /** column name */
  Stage = 'stage',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "enforcement_types" */
export type Enforcement_Types_Set_Input = {
  content_type?: InputMaybe<Scalars['String']>;
  content_type_display_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  enforcement_method_data?: InputMaybe<Scalars['String']>;
  enforcement_method_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  manual_form_fields?: InputMaybe<Scalars['jsonb']>;
  platform?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Enforcement_Types_Stddev_Fields = {
  __typename?: 'enforcement_types_stddev_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "enforcement_types" */
export type Enforcement_Types_Stddev_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Enforcement_Types_Stddev_Pop_Fields = {
  __typename?: 'enforcement_types_stddev_pop_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "enforcement_types" */
export type Enforcement_Types_Stddev_Pop_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Enforcement_Types_Stddev_Samp_Fields = {
  __typename?: 'enforcement_types_stddev_samp_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "enforcement_types" */
export type Enforcement_Types_Stddev_Samp_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "enforcement_types" */
export type Enforcement_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enforcement_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enforcement_Types_Stream_Cursor_Value_Input = {
  content_type?: InputMaybe<Scalars['String']>;
  content_type_display_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  enforcement_method_data?: InputMaybe<Scalars['String']>;
  enforcement_method_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  manual_form_fields?: InputMaybe<Scalars['jsonb']>;
  platform?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Enforcement_Types_Sum_Fields = {
  __typename?: 'enforcement_types_sum_fields';
  priority?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "enforcement_types" */
export type Enforcement_Types_Sum_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** update columns of table "enforcement_types" */
export enum Enforcement_Types_Update_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  ContentTypeDisplayName = 'content_type_display_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnforcementMethodData = 'enforcement_method_data',
  /** column name */
  EnforcementMethodType = 'enforcement_method_type',
  /** column name */
  Id = 'id',
  /** column name */
  ManualFormFields = 'manual_form_fields',
  /** column name */
  Platform = 'platform',
  /** column name */
  Priority = 'priority',
  /** column name */
  Stage = 'stage',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Enforcement_Types_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Enforcement_Types_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Enforcement_Types_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Enforcement_Types_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Enforcement_Types_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Enforcement_Types_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Enforcement_Types_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enforcement_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enforcement_Types_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Enforcement_Types_Var_Pop_Fields = {
  __typename?: 'enforcement_types_var_pop_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "enforcement_types" */
export type Enforcement_Types_Var_Pop_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Enforcement_Types_Var_Samp_Fields = {
  __typename?: 'enforcement_types_var_samp_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "enforcement_types" */
export type Enforcement_Types_Var_Samp_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Enforcement_Types_Variance_Fields = {
  __typename?: 'enforcement_types_variance_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "enforcement_types" */
export type Enforcement_Types_Variance_Order_By = {
  priority?: InputMaybe<Order_By>;
};

/** columns and relationships of "entity_aggregates" */
export type Entity_Aggregates = {
  __typename?: 'entity_aggregates';
  id: Scalars['uuid'];
  table_name: Scalars['String'];
  unique_id: Scalars['String'];
};

/** aggregated selection of "entity_aggregates" */
export type Entity_Aggregates_Aggregate = {
  __typename?: 'entity_aggregates_aggregate';
  aggregate?: Maybe<Entity_Aggregates_Aggregate_Fields>;
  nodes: Array<Entity_Aggregates>;
};

/** aggregate fields of "entity_aggregates" */
export type Entity_Aggregates_Aggregate_Fields = {
  __typename?: 'entity_aggregates_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Entity_Aggregates_Max_Fields>;
  min?: Maybe<Entity_Aggregates_Min_Fields>;
};


/** aggregate fields of "entity_aggregates" */
export type Entity_Aggregates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entity_Aggregates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "entity_aggregates". All fields are combined with a logical 'AND'. */
export type Entity_Aggregates_Bool_Exp = {
  _and?: InputMaybe<Array<Entity_Aggregates_Bool_Exp>>;
  _not?: InputMaybe<Entity_Aggregates_Bool_Exp>;
  _or?: InputMaybe<Array<Entity_Aggregates_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  unique_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_aggregates" */
export enum Entity_Aggregates_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityAggregatePkey = 'entity_aggregate_pkey',
  /** unique or primary key constraint on columns "unique_id", "table_name" */
  EntityAggregateUniqueIdTableNameKey = 'entity_aggregate_unique_id_table_name_key'
}

/** input type for inserting data into table "entity_aggregates" */
export type Entity_Aggregates_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  table_name?: InputMaybe<Scalars['String']>;
  unique_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Entity_Aggregates_Max_Fields = {
  __typename?: 'entity_aggregates_max_fields';
  id?: Maybe<Scalars['uuid']>;
  table_name?: Maybe<Scalars['String']>;
  unique_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Entity_Aggregates_Min_Fields = {
  __typename?: 'entity_aggregates_min_fields';
  id?: Maybe<Scalars['uuid']>;
  table_name?: Maybe<Scalars['String']>;
  unique_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "entity_aggregates" */
export type Entity_Aggregates_Mutation_Response = {
  __typename?: 'entity_aggregates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Entity_Aggregates>;
};

/** input type for inserting object relation for remote table "entity_aggregates" */
export type Entity_Aggregates_Obj_Rel_Insert_Input = {
  data: Entity_Aggregates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Entity_Aggregates_On_Conflict>;
};

/** on_conflict condition type for table "entity_aggregates" */
export type Entity_Aggregates_On_Conflict = {
  constraint: Entity_Aggregates_Constraint;
  update_columns?: Array<Entity_Aggregates_Update_Column>;
  where?: InputMaybe<Entity_Aggregates_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_aggregates". */
export type Entity_Aggregates_Order_By = {
  id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  unique_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_aggregates */
export type Entity_Aggregates_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "entity_aggregates" */
export enum Entity_Aggregates_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UniqueId = 'unique_id'
}

/** input type for updating data in table "entity_aggregates" */
export type Entity_Aggregates_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  table_name?: InputMaybe<Scalars['String']>;
  unique_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "entity_aggregates" */
export type Entity_Aggregates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entity_Aggregates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entity_Aggregates_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  table_name?: InputMaybe<Scalars['String']>;
  unique_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "entity_aggregates" */
export enum Entity_Aggregates_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UniqueId = 'unique_id'
}

export type Entity_Aggregates_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Entity_Aggregates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Entity_Aggregates_Bool_Exp;
};

/** columns and relationships of "entity_data" */
export type Entity_Data = {
  __typename?: 'entity_data';
  /** An object relationship */
  advertisement_data?: Maybe<Advertisement_Data>;
  advertisement_data_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  advertiser_data?: Maybe<Advertiser_Data>;
  advertiser_data_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  dark_web?: Maybe<Dark_Web>;
  dark_web_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  domain_data?: Maybe<Domain_Data>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ecommerce_listing?: Maybe<Ecommerce_Listings>;
  ecommerce_listing_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  email?: Maybe<Emails>;
  /** An object relationship */
  email_address?: Maybe<Email_Addresses>;
  email_address_id?: Maybe<Scalars['uuid']>;
  email_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  entity_aggregate?: Maybe<Entity_Aggregates>;
  entity_aggregate_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  full_url?: Maybe<Full_Urls>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  mobile_app?: Maybe<Mobile_Apps>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  phone_number?: Maybe<Phone_Numbers>;
  phone_number_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  social_media_data?: Maybe<Social_Media_Data>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  social_media_group?: Maybe<Social_Media_Group>;
  social_media_group_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  social_media_post?: Maybe<Social_Media_Post>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  spoof_matches: Array<Spoof_Matches>;
  /** An aggregate relationship */
  spoof_matches_aggregate: Spoof_Matches_Aggregate;
};


/** columns and relationships of "entity_data" */
export type Entity_DataSpoof_MatchesArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};


/** columns and relationships of "entity_data" */
export type Entity_DataSpoof_Matches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};

/** aggregated selection of "entity_data" */
export type Entity_Data_Aggregate = {
  __typename?: 'entity_data_aggregate';
  aggregate?: Maybe<Entity_Data_Aggregate_Fields>;
  nodes: Array<Entity_Data>;
};

export type Entity_Data_Aggregate_Bool_Exp = {
  count?: InputMaybe<Entity_Data_Aggregate_Bool_Exp_Count>;
};

export type Entity_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Entity_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Entity_Data_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "entity_data" */
export type Entity_Data_Aggregate_Fields = {
  __typename?: 'entity_data_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Entity_Data_Max_Fields>;
  min?: Maybe<Entity_Data_Min_Fields>;
};


/** aggregate fields of "entity_data" */
export type Entity_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entity_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "entity_data" */
export type Entity_Data_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Entity_Data_Max_Order_By>;
  min?: InputMaybe<Entity_Data_Min_Order_By>;
};

/** input type for inserting array relation for remote table "entity_data" */
export type Entity_Data_Arr_Rel_Insert_Input = {
  data: Array<Entity_Data_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Entity_Data_On_Conflict>;
};

/** Boolean expression to filter rows from the table "entity_data". All fields are combined with a logical 'AND'. */
export type Entity_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Entity_Data_Bool_Exp>>;
  _not?: InputMaybe<Entity_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Entity_Data_Bool_Exp>>;
  advertisement_data?: InputMaybe<Advertisement_Data_Bool_Exp>;
  advertisement_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  advertiser_data?: InputMaybe<Advertiser_Data_Bool_Exp>;
  advertiser_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  dark_web?: InputMaybe<Dark_Web_Bool_Exp>;
  dark_web_id?: InputMaybe<Uuid_Comparison_Exp>;
  domain_data?: InputMaybe<Domain_Data_Bool_Exp>;
  domain_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  ecommerce_listing?: InputMaybe<Ecommerce_Listings_Bool_Exp>;
  ecommerce_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  email?: InputMaybe<Emails_Bool_Exp>;
  email_address?: InputMaybe<Email_Addresses_Bool_Exp>;
  email_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_id?: InputMaybe<Uuid_Comparison_Exp>;
  entity_aggregate?: InputMaybe<Entity_Aggregates_Bool_Exp>;
  entity_aggregate_id?: InputMaybe<Uuid_Comparison_Exp>;
  full_url?: InputMaybe<Full_Urls_Bool_Exp>;
  full_url_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mobile_app?: InputMaybe<Mobile_Apps_Bool_Exp>;
  mobile_app_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_number?: InputMaybe<Phone_Numbers_Bool_Exp>;
  phone_number_id?: InputMaybe<Uuid_Comparison_Exp>;
  social_media_data?: InputMaybe<Social_Media_Data_Bool_Exp>;
  social_media_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  social_media_group?: InputMaybe<Social_Media_Group_Bool_Exp>;
  social_media_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  social_media_post?: InputMaybe<Social_Media_Post_Bool_Exp>;
  social_media_post_id?: InputMaybe<Uuid_Comparison_Exp>;
  spoof_matches?: InputMaybe<Spoof_Matches_Bool_Exp>;
  spoof_matches_aggregate?: InputMaybe<Spoof_Matches_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "entity_data" */
export enum Entity_Data_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityDataPkey = 'entity_data_pkey'
}

/** input type for inserting data into table "entity_data" */
export type Entity_Data_Insert_Input = {
  advertisement_data?: InputMaybe<Advertisement_Data_Obj_Rel_Insert_Input>;
  advertisement_data_id?: InputMaybe<Scalars['uuid']>;
  advertiser_data?: InputMaybe<Advertiser_Data_Obj_Rel_Insert_Input>;
  advertiser_data_id?: InputMaybe<Scalars['uuid']>;
  dark_web?: InputMaybe<Dark_Web_Obj_Rel_Insert_Input>;
  dark_web_id?: InputMaybe<Scalars['uuid']>;
  domain_data?: InputMaybe<Domain_Data_Obj_Rel_Insert_Input>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  ecommerce_listing?: InputMaybe<Ecommerce_Listings_Obj_Rel_Insert_Input>;
  ecommerce_listing_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Emails_Obj_Rel_Insert_Input>;
  email_address?: InputMaybe<Email_Addresses_Obj_Rel_Insert_Input>;
  email_address_id?: InputMaybe<Scalars['uuid']>;
  email_id?: InputMaybe<Scalars['uuid']>;
  entity_aggregate?: InputMaybe<Entity_Aggregates_Obj_Rel_Insert_Input>;
  entity_aggregate_id?: InputMaybe<Scalars['uuid']>;
  full_url?: InputMaybe<Full_Urls_Obj_Rel_Insert_Input>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  mobile_app?: InputMaybe<Mobile_Apps_Obj_Rel_Insert_Input>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  phone_number?: InputMaybe<Phone_Numbers_Obj_Rel_Insert_Input>;
  phone_number_id?: InputMaybe<Scalars['uuid']>;
  social_media_data?: InputMaybe<Social_Media_Data_Obj_Rel_Insert_Input>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_group?: InputMaybe<Social_Media_Group_Obj_Rel_Insert_Input>;
  social_media_group_id?: InputMaybe<Scalars['uuid']>;
  social_media_post?: InputMaybe<Social_Media_Post_Obj_Rel_Insert_Input>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  spoof_matches?: InputMaybe<Spoof_Matches_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Entity_Data_Max_Fields = {
  __typename?: 'entity_data_max_fields';
  advertisement_data_id?: Maybe<Scalars['uuid']>;
  advertiser_data_id?: Maybe<Scalars['uuid']>;
  dark_web_id?: Maybe<Scalars['uuid']>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  ecommerce_listing_id?: Maybe<Scalars['uuid']>;
  email_address_id?: Maybe<Scalars['uuid']>;
  email_id?: Maybe<Scalars['uuid']>;
  entity_aggregate_id?: Maybe<Scalars['uuid']>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  phone_number_id?: Maybe<Scalars['uuid']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  social_media_group_id?: Maybe<Scalars['uuid']>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "entity_data" */
export type Entity_Data_Max_Order_By = {
  advertisement_data_id?: InputMaybe<Order_By>;
  advertiser_data_id?: InputMaybe<Order_By>;
  dark_web_id?: InputMaybe<Order_By>;
  domain_data_id?: InputMaybe<Order_By>;
  ecommerce_listing_id?: InputMaybe<Order_By>;
  email_address_id?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  entity_aggregate_id?: InputMaybe<Order_By>;
  full_url_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mobile_app_id?: InputMaybe<Order_By>;
  phone_number_id?: InputMaybe<Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  social_media_group_id?: InputMaybe<Order_By>;
  social_media_post_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Entity_Data_Min_Fields = {
  __typename?: 'entity_data_min_fields';
  advertisement_data_id?: Maybe<Scalars['uuid']>;
  advertiser_data_id?: Maybe<Scalars['uuid']>;
  dark_web_id?: Maybe<Scalars['uuid']>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  ecommerce_listing_id?: Maybe<Scalars['uuid']>;
  email_address_id?: Maybe<Scalars['uuid']>;
  email_id?: Maybe<Scalars['uuid']>;
  entity_aggregate_id?: Maybe<Scalars['uuid']>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  phone_number_id?: Maybe<Scalars['uuid']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  social_media_group_id?: Maybe<Scalars['uuid']>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "entity_data" */
export type Entity_Data_Min_Order_By = {
  advertisement_data_id?: InputMaybe<Order_By>;
  advertiser_data_id?: InputMaybe<Order_By>;
  dark_web_id?: InputMaybe<Order_By>;
  domain_data_id?: InputMaybe<Order_By>;
  ecommerce_listing_id?: InputMaybe<Order_By>;
  email_address_id?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  entity_aggregate_id?: InputMaybe<Order_By>;
  full_url_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mobile_app_id?: InputMaybe<Order_By>;
  phone_number_id?: InputMaybe<Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  social_media_group_id?: InputMaybe<Order_By>;
  social_media_post_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entity_data" */
export type Entity_Data_Mutation_Response = {
  __typename?: 'entity_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Entity_Data>;
};

/** input type for inserting object relation for remote table "entity_data" */
export type Entity_Data_Obj_Rel_Insert_Input = {
  data: Entity_Data_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Entity_Data_On_Conflict>;
};

/** on_conflict condition type for table "entity_data" */
export type Entity_Data_On_Conflict = {
  constraint: Entity_Data_Constraint;
  update_columns?: Array<Entity_Data_Update_Column>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_data". */
export type Entity_Data_Order_By = {
  advertisement_data?: InputMaybe<Advertisement_Data_Order_By>;
  advertisement_data_id?: InputMaybe<Order_By>;
  advertiser_data?: InputMaybe<Advertiser_Data_Order_By>;
  advertiser_data_id?: InputMaybe<Order_By>;
  dark_web?: InputMaybe<Dark_Web_Order_By>;
  dark_web_id?: InputMaybe<Order_By>;
  domain_data?: InputMaybe<Domain_Data_Order_By>;
  domain_data_id?: InputMaybe<Order_By>;
  ecommerce_listing?: InputMaybe<Ecommerce_Listings_Order_By>;
  ecommerce_listing_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Emails_Order_By>;
  email_address?: InputMaybe<Email_Addresses_Order_By>;
  email_address_id?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  entity_aggregate?: InputMaybe<Entity_Aggregates_Order_By>;
  entity_aggregate_id?: InputMaybe<Order_By>;
  full_url?: InputMaybe<Full_Urls_Order_By>;
  full_url_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mobile_app?: InputMaybe<Mobile_Apps_Order_By>;
  mobile_app_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Phone_Numbers_Order_By>;
  phone_number_id?: InputMaybe<Order_By>;
  social_media_data?: InputMaybe<Social_Media_Data_Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  social_media_group?: InputMaybe<Social_Media_Group_Order_By>;
  social_media_group_id?: InputMaybe<Order_By>;
  social_media_post?: InputMaybe<Social_Media_Post_Order_By>;
  social_media_post_id?: InputMaybe<Order_By>;
  spoof_matches_aggregate?: InputMaybe<Spoof_Matches_Aggregate_Order_By>;
};

/** primary key columns input for table: entity_data */
export type Entity_Data_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "entity_data" */
export enum Entity_Data_Select_Column {
  /** column name */
  AdvertisementDataId = 'advertisement_data_id',
  /** column name */
  AdvertiserDataId = 'advertiser_data_id',
  /** column name */
  DarkWebId = 'dark_web_id',
  /** column name */
  DomainDataId = 'domain_data_id',
  /** column name */
  EcommerceListingId = 'ecommerce_listing_id',
  /** column name */
  EmailAddressId = 'email_address_id',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  EntityAggregateId = 'entity_aggregate_id',
  /** column name */
  FullUrlId = 'full_url_id',
  /** column name */
  Id = 'id',
  /** column name */
  MobileAppId = 'mobile_app_id',
  /** column name */
  PhoneNumberId = 'phone_number_id',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SocialMediaGroupId = 'social_media_group_id',
  /** column name */
  SocialMediaPostId = 'social_media_post_id'
}

/** input type for updating data in table "entity_data" */
export type Entity_Data_Set_Input = {
  advertisement_data_id?: InputMaybe<Scalars['uuid']>;
  advertiser_data_id?: InputMaybe<Scalars['uuid']>;
  dark_web_id?: InputMaybe<Scalars['uuid']>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  ecommerce_listing_id?: InputMaybe<Scalars['uuid']>;
  email_address_id?: InputMaybe<Scalars['uuid']>;
  email_id?: InputMaybe<Scalars['uuid']>;
  entity_aggregate_id?: InputMaybe<Scalars['uuid']>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  phone_number_id?: InputMaybe<Scalars['uuid']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_group_id?: InputMaybe<Scalars['uuid']>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "entity_data" */
export type Entity_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entity_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entity_Data_Stream_Cursor_Value_Input = {
  advertisement_data_id?: InputMaybe<Scalars['uuid']>;
  advertiser_data_id?: InputMaybe<Scalars['uuid']>;
  dark_web_id?: InputMaybe<Scalars['uuid']>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  ecommerce_listing_id?: InputMaybe<Scalars['uuid']>;
  email_address_id?: InputMaybe<Scalars['uuid']>;
  email_id?: InputMaybe<Scalars['uuid']>;
  entity_aggregate_id?: InputMaybe<Scalars['uuid']>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  phone_number_id?: InputMaybe<Scalars['uuid']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_group_id?: InputMaybe<Scalars['uuid']>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "entity_data" */
export enum Entity_Data_Update_Column {
  /** column name */
  AdvertisementDataId = 'advertisement_data_id',
  /** column name */
  AdvertiserDataId = 'advertiser_data_id',
  /** column name */
  DarkWebId = 'dark_web_id',
  /** column name */
  DomainDataId = 'domain_data_id',
  /** column name */
  EcommerceListingId = 'ecommerce_listing_id',
  /** column name */
  EmailAddressId = 'email_address_id',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  EntityAggregateId = 'entity_aggregate_id',
  /** column name */
  FullUrlId = 'full_url_id',
  /** column name */
  Id = 'id',
  /** column name */
  MobileAppId = 'mobile_app_id',
  /** column name */
  PhoneNumberId = 'phone_number_id',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SocialMediaGroupId = 'social_media_group_id',
  /** column name */
  SocialMediaPostId = 'social_media_post_id'
}

export type Entity_Data_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Entity_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Entity_Data_Bool_Exp;
};

/** columns and relationships of "entity_links" */
export type Entity_Links = {
  __typename?: 'entity_links';
  /** An object relationship */
  child_entity_aggregate?: Maybe<Entity_Aggregates>;
  child_entity_aggregate_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  child_entity_data?: Maybe<Entity_Data>;
  child_entity_data_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  link_type: Scalars['String'];
  /** An object relationship */
  parent_entity_aggregate?: Maybe<Entity_Aggregates>;
  parent_entity_aggregate_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  parent_entity_data?: Maybe<Entity_Data>;
  parent_entity_data_id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  updated_at: Scalars['timestamp'];
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "entity_links" */
export type Entity_Links_Aggregate = {
  __typename?: 'entity_links_aggregate';
  aggregate?: Maybe<Entity_Links_Aggregate_Fields>;
  nodes: Array<Entity_Links>;
};

/** aggregate fields of "entity_links" */
export type Entity_Links_Aggregate_Fields = {
  __typename?: 'entity_links_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Entity_Links_Max_Fields>;
  min?: Maybe<Entity_Links_Min_Fields>;
};


/** aggregate fields of "entity_links" */
export type Entity_Links_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entity_Links_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "entity_links". All fields are combined with a logical 'AND'. */
export type Entity_Links_Bool_Exp = {
  _and?: InputMaybe<Array<Entity_Links_Bool_Exp>>;
  _not?: InputMaybe<Entity_Links_Bool_Exp>;
  _or?: InputMaybe<Array<Entity_Links_Bool_Exp>>;
  child_entity_aggregate?: InputMaybe<Entity_Aggregates_Bool_Exp>;
  child_entity_aggregate_id?: InputMaybe<Uuid_Comparison_Exp>;
  child_entity_data?: InputMaybe<Entity_Data_Bool_Exp>;
  child_entity_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  link_type?: InputMaybe<String_Comparison_Exp>;
  parent_entity_aggregate?: InputMaybe<Entity_Aggregates_Bool_Exp>;
  parent_entity_aggregate_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_entity_data?: InputMaybe<Entity_Data_Bool_Exp>;
  parent_entity_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_links" */
export enum Entity_Links_Constraint {
  /** unique or primary key constraint on columns "child_entity_aggregate_id", "parent_entity_aggregate_id", "link_type" */
  EntityLinksParentEntityAggregateChildEntityAggregateKey = 'entity_links_parent_entity_aggregate_child_entity_aggregate_key',
  /** unique or primary key constraint on columns "child_entity_data_id", "parent_entity_aggregate_id", "link_type" */
  EntityLinksParentEntityAggregateChildEntityDataKey = 'entity_links_parent_entity_aggregate_child_entity_data_key',
  /** unique or primary key constraint on columns "child_entity_aggregate_id", "parent_entity_data_id", "link_type" */
  EntityLinksParentEntityDataChildEntityAggregateKey = 'entity_links_parent_entity_data_child_entity_aggregate_key',
  /** unique or primary key constraint on columns "parent_entity_data_id", "child_entity_data_id", "link_type" */
  EntityLinksParentEntityDataChildEntityDataKey = 'entity_links_parent_entity_data_child_entity_data_key',
  /** unique or primary key constraint on columns "id" */
  EntityLinksPkey = 'entity_links_pkey'
}

/** input type for inserting data into table "entity_links" */
export type Entity_Links_Insert_Input = {
  child_entity_aggregate?: InputMaybe<Entity_Aggregates_Obj_Rel_Insert_Input>;
  child_entity_aggregate_id?: InputMaybe<Scalars['uuid']>;
  child_entity_data?: InputMaybe<Entity_Data_Obj_Rel_Insert_Input>;
  child_entity_data_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  link_type?: InputMaybe<Scalars['String']>;
  parent_entity_aggregate?: InputMaybe<Entity_Aggregates_Obj_Rel_Insert_Input>;
  parent_entity_aggregate_id?: InputMaybe<Scalars['uuid']>;
  parent_entity_data?: InputMaybe<Entity_Data_Obj_Rel_Insert_Input>;
  parent_entity_data_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Entity_Links_Max_Fields = {
  __typename?: 'entity_links_max_fields';
  child_entity_aggregate_id?: Maybe<Scalars['uuid']>;
  child_entity_data_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  link_type?: Maybe<Scalars['String']>;
  parent_entity_aggregate_id?: Maybe<Scalars['uuid']>;
  parent_entity_data_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Entity_Links_Min_Fields = {
  __typename?: 'entity_links_min_fields';
  child_entity_aggregate_id?: Maybe<Scalars['uuid']>;
  child_entity_data_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  link_type?: Maybe<Scalars['String']>;
  parent_entity_aggregate_id?: Maybe<Scalars['uuid']>;
  parent_entity_data_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "entity_links" */
export type Entity_Links_Mutation_Response = {
  __typename?: 'entity_links_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Entity_Links>;
};

/** on_conflict condition type for table "entity_links" */
export type Entity_Links_On_Conflict = {
  constraint: Entity_Links_Constraint;
  update_columns?: Array<Entity_Links_Update_Column>;
  where?: InputMaybe<Entity_Links_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_links". */
export type Entity_Links_Order_By = {
  child_entity_aggregate?: InputMaybe<Entity_Aggregates_Order_By>;
  child_entity_aggregate_id?: InputMaybe<Order_By>;
  child_entity_data?: InputMaybe<Entity_Data_Order_By>;
  child_entity_data_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link_type?: InputMaybe<Order_By>;
  parent_entity_aggregate?: InputMaybe<Entity_Aggregates_Order_By>;
  parent_entity_aggregate_id?: InputMaybe<Order_By>;
  parent_entity_data?: InputMaybe<Entity_Data_Order_By>;
  parent_entity_data_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_links */
export type Entity_Links_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "entity_links" */
export enum Entity_Links_Select_Column {
  /** column name */
  ChildEntityAggregateId = 'child_entity_aggregate_id',
  /** column name */
  ChildEntityDataId = 'child_entity_data_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LinkType = 'link_type',
  /** column name */
  ParentEntityAggregateId = 'parent_entity_aggregate_id',
  /** column name */
  ParentEntityDataId = 'parent_entity_data_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "entity_links" */
export type Entity_Links_Set_Input = {
  child_entity_aggregate_id?: InputMaybe<Scalars['uuid']>;
  child_entity_data_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  link_type?: InputMaybe<Scalars['String']>;
  parent_entity_aggregate_id?: InputMaybe<Scalars['uuid']>;
  parent_entity_data_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "entity_links" */
export type Entity_Links_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entity_Links_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entity_Links_Stream_Cursor_Value_Input = {
  child_entity_aggregate_id?: InputMaybe<Scalars['uuid']>;
  child_entity_data_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  link_type?: InputMaybe<Scalars['String']>;
  parent_entity_aggregate_id?: InputMaybe<Scalars['uuid']>;
  parent_entity_data_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "entity_links" */
export enum Entity_Links_Update_Column {
  /** column name */
  ChildEntityAggregateId = 'child_entity_aggregate_id',
  /** column name */
  ChildEntityDataId = 'child_entity_data_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LinkType = 'link_type',
  /** column name */
  ParentEntityAggregateId = 'parent_entity_aggregate_id',
  /** column name */
  ParentEntityDataId = 'parent_entity_data_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Entity_Links_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Entity_Links_Set_Input>;
  /** filter the rows which have to be updated */
  where: Entity_Links_Bool_Exp;
};

/** For storing information about entity state classifications */
export type Entity_State_Classifications = {
  __typename?: 'entity_state_classifications';
  /** An object relationship */
  alert?: Maybe<Spoofing_Reports>;
  alert_id?: Maybe<Scalars['uuid']>;
  classification_evidence?: Maybe<Scalars['jsonb']>;
  classification_reason?: Maybe<Scalars['String']>;
  classified_state: Scalars['String'];
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  /** An object relationship */
  platform_subtype?: Maybe<Platform_Subtypes>;
  platform_subtype_id: Scalars['uuid'];
  previous_state?: Maybe<Scalars['String']>;
  priority: Scalars['String'];
  scrape_successful?: Maybe<Scalars['Boolean']>;
  source: Scalars['String'];
  unsanitized_string?: Maybe<Scalars['String']>;
};


/** For storing information about entity state classifications */
export type Entity_State_ClassificationsClassification_EvidenceArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "entity_state_classifications" */
export type Entity_State_Classifications_Aggregate = {
  __typename?: 'entity_state_classifications_aggregate';
  aggregate?: Maybe<Entity_State_Classifications_Aggregate_Fields>;
  nodes: Array<Entity_State_Classifications>;
};

/** aggregate fields of "entity_state_classifications" */
export type Entity_State_Classifications_Aggregate_Fields = {
  __typename?: 'entity_state_classifications_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Entity_State_Classifications_Max_Fields>;
  min?: Maybe<Entity_State_Classifications_Min_Fields>;
};


/** aggregate fields of "entity_state_classifications" */
export type Entity_State_Classifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entity_State_Classifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Entity_State_Classifications_Append_Input = {
  classification_evidence?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "entity_state_classifications". All fields are combined with a logical 'AND'. */
export type Entity_State_Classifications_Bool_Exp = {
  _and?: InputMaybe<Array<Entity_State_Classifications_Bool_Exp>>;
  _not?: InputMaybe<Entity_State_Classifications_Bool_Exp>;
  _or?: InputMaybe<Array<Entity_State_Classifications_Bool_Exp>>;
  alert?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  alert_id?: InputMaybe<Uuid_Comparison_Exp>;
  classification_evidence?: InputMaybe<Jsonb_Comparison_Exp>;
  classification_reason?: InputMaybe<String_Comparison_Exp>;
  classified_state?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Bool_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  previous_state?: InputMaybe<String_Comparison_Exp>;
  priority?: InputMaybe<String_Comparison_Exp>;
  scrape_successful?: InputMaybe<Boolean_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  unsanitized_string?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_state_classifications" */
export enum Entity_State_Classifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityStateClassificationsPkey = 'entity_state_classifications_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Entity_State_Classifications_Delete_At_Path_Input = {
  classification_evidence?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Entity_State_Classifications_Delete_Elem_Input = {
  classification_evidence?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Entity_State_Classifications_Delete_Key_Input = {
  classification_evidence?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "entity_state_classifications" */
export type Entity_State_Classifications_Insert_Input = {
  alert?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  alert_id?: InputMaybe<Scalars['uuid']>;
  classification_evidence?: InputMaybe<Scalars['jsonb']>;
  classification_reason?: InputMaybe<Scalars['String']>;
  classified_state?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Obj_Rel_Insert_Input>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  previous_state?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['String']>;
  scrape_successful?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
  unsanitized_string?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Entity_State_Classifications_Max_Fields = {
  __typename?: 'entity_state_classifications_max_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  classification_reason?: Maybe<Scalars['String']>;
  classified_state?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  previous_state?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  unsanitized_string?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Entity_State_Classifications_Min_Fields = {
  __typename?: 'entity_state_classifications_min_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  classification_reason?: Maybe<Scalars['String']>;
  classified_state?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  previous_state?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  unsanitized_string?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "entity_state_classifications" */
export type Entity_State_Classifications_Mutation_Response = {
  __typename?: 'entity_state_classifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Entity_State_Classifications>;
};

/** on_conflict condition type for table "entity_state_classifications" */
export type Entity_State_Classifications_On_Conflict = {
  constraint: Entity_State_Classifications_Constraint;
  update_columns?: Array<Entity_State_Classifications_Update_Column>;
  where?: InputMaybe<Entity_State_Classifications_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_state_classifications". */
export type Entity_State_Classifications_Order_By = {
  alert?: InputMaybe<Spoofing_Reports_Order_By>;
  alert_id?: InputMaybe<Order_By>;
  classification_evidence?: InputMaybe<Order_By>;
  classification_reason?: InputMaybe<Order_By>;
  classified_state?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  previous_state?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  scrape_successful?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  unsanitized_string?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_state_classifications */
export type Entity_State_Classifications_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Entity_State_Classifications_Prepend_Input = {
  classification_evidence?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "entity_state_classifications" */
export enum Entity_State_Classifications_Select_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  ClassificationEvidence = 'classification_evidence',
  /** column name */
  ClassificationReason = 'classification_reason',
  /** column name */
  ClassifiedState = 'classified_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  PreviousState = 'previous_state',
  /** column name */
  Priority = 'priority',
  /** column name */
  ScrapeSuccessful = 'scrape_successful',
  /** column name */
  Source = 'source',
  /** column name */
  UnsanitizedString = 'unsanitized_string'
}

/** input type for updating data in table "entity_state_classifications" */
export type Entity_State_Classifications_Set_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  classification_evidence?: InputMaybe<Scalars['jsonb']>;
  classification_reason?: InputMaybe<Scalars['String']>;
  classified_state?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  previous_state?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['String']>;
  scrape_successful?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
  unsanitized_string?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "entity_state_classifications" */
export type Entity_State_Classifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entity_State_Classifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entity_State_Classifications_Stream_Cursor_Value_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  classification_evidence?: InputMaybe<Scalars['jsonb']>;
  classification_reason?: InputMaybe<Scalars['String']>;
  classified_state?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  previous_state?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['String']>;
  scrape_successful?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['String']>;
  unsanitized_string?: InputMaybe<Scalars['String']>;
};

/** update columns of table "entity_state_classifications" */
export enum Entity_State_Classifications_Update_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  ClassificationEvidence = 'classification_evidence',
  /** column name */
  ClassificationReason = 'classification_reason',
  /** column name */
  ClassifiedState = 'classified_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  PreviousState = 'previous_state',
  /** column name */
  Priority = 'priority',
  /** column name */
  ScrapeSuccessful = 'scrape_successful',
  /** column name */
  Source = 'source',
  /** column name */
  UnsanitizedString = 'unsanitized_string'
}

export type Entity_State_Classifications_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Entity_State_Classifications_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Entity_State_Classifications_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Entity_State_Classifications_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Entity_State_Classifications_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Entity_State_Classifications_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Entity_State_Classifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Entity_State_Classifications_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** all domains/subdomains/paths */
export type Full_Urls = {
  __typename?: 'full_urls';
  created_at: Scalars['timestamp'];
  /** An object relationship */
  domain_data: Domain_Data;
  domain_data_id: Scalars['uuid'];
  /** An array relationship */
  entity_data: Array<Entity_Data>;
  /** An aggregate relationship */
  entity_data_aggregate: Entity_Data_Aggregate;
  /** gcs url for where favicon image is stored */
  favicon_url?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  initial_discovery_source?: Maybe<Scalars['String']>;
  is_current: Scalars['Boolean'];
  screenshot_url?: Maybe<Scalars['String']>;
  site_html?: Maybe<Scalars['String']>;
  /** URL to HTTP GET the site_text as a file */
  site_html_url?: Maybe<Scalars['String']>;
  site_text?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  /** An array relationship */
  spoof_matches: Array<Spoof_Matches>;
  /** An aggregate relationship */
  spoof_matches_aggregate: Spoof_Matches_Aggregate;
  /** Status of url irrespective to the brand it matches with (active, down, parked, bot_detected) */
  status?: Maybe<Scalars['String']>;
  unsanitized_url?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamp'];
  url: Scalars['String'];
};


/** all domains/subdomains/paths */
export type Full_UrlsEntity_DataArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


/** all domains/subdomains/paths */
export type Full_UrlsEntity_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


/** all domains/subdomains/paths */
export type Full_UrlsSpoof_MatchesArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};


/** all domains/subdomains/paths */
export type Full_UrlsSpoof_Matches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};

/** aggregated selection of "full_urls" */
export type Full_Urls_Aggregate = {
  __typename?: 'full_urls_aggregate';
  aggregate?: Maybe<Full_Urls_Aggregate_Fields>;
  nodes: Array<Full_Urls>;
};

export type Full_Urls_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Full_Urls_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Full_Urls_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Full_Urls_Aggregate_Bool_Exp_Count>;
};

export type Full_Urls_Aggregate_Bool_Exp_Bool_And = {
  arguments: Full_Urls_Select_Column_Full_Urls_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Full_Urls_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Full_Urls_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Full_Urls_Select_Column_Full_Urls_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Full_Urls_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Full_Urls_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Full_Urls_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Full_Urls_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "full_urls" */
export type Full_Urls_Aggregate_Fields = {
  __typename?: 'full_urls_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Full_Urls_Max_Fields>;
  min?: Maybe<Full_Urls_Min_Fields>;
};


/** aggregate fields of "full_urls" */
export type Full_Urls_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Full_Urls_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "full_urls" */
export type Full_Urls_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Full_Urls_Max_Order_By>;
  min?: InputMaybe<Full_Urls_Min_Order_By>;
};

/** input type for inserting array relation for remote table "full_urls" */
export type Full_Urls_Arr_Rel_Insert_Input = {
  data: Array<Full_Urls_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Full_Urls_On_Conflict>;
};

/** Boolean expression to filter rows from the table "full_urls". All fields are combined with a logical 'AND'. */
export type Full_Urls_Bool_Exp = {
  _and?: InputMaybe<Array<Full_Urls_Bool_Exp>>;
  _not?: InputMaybe<Full_Urls_Bool_Exp>;
  _or?: InputMaybe<Array<Full_Urls_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  domain_data?: InputMaybe<Domain_Data_Bool_Exp>;
  domain_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  entity_data?: InputMaybe<Entity_Data_Bool_Exp>;
  entity_data_aggregate?: InputMaybe<Entity_Data_Aggregate_Bool_Exp>;
  favicon_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initial_discovery_source?: InputMaybe<String_Comparison_Exp>;
  is_current?: InputMaybe<Boolean_Comparison_Exp>;
  screenshot_url?: InputMaybe<String_Comparison_Exp>;
  site_html?: InputMaybe<String_Comparison_Exp>;
  site_html_url?: InputMaybe<String_Comparison_Exp>;
  site_text?: InputMaybe<String_Comparison_Exp>;
  source_query?: InputMaybe<String_Comparison_Exp>;
  spoof_matches?: InputMaybe<Spoof_Matches_Bool_Exp>;
  spoof_matches_aggregate?: InputMaybe<Spoof_Matches_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  unsanitized_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "full_urls" */
export enum Full_Urls_Constraint {
  /** unique or primary key constraint on columns "url" */
  FullUrlsCurrentUrlKey = 'full_urls_current_url_key',
  /** unique or primary key constraint on columns "id" */
  FullUrlsPkey = 'full_urls_pkey'
}

/** input type for inserting data into table "full_urls" */
export type Full_Urls_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data?: InputMaybe<Domain_Data_Obj_Rel_Insert_Input>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  entity_data?: InputMaybe<Entity_Data_Arr_Rel_Insert_Input>;
  /** gcs url for where favicon image is stored */
  favicon_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  initial_discovery_source?: InputMaybe<Scalars['String']>;
  is_current?: InputMaybe<Scalars['Boolean']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  site_html?: InputMaybe<Scalars['String']>;
  /** URL to HTTP GET the site_text as a file */
  site_html_url?: InputMaybe<Scalars['String']>;
  site_text?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  spoof_matches?: InputMaybe<Spoof_Matches_Arr_Rel_Insert_Input>;
  /** Status of url irrespective to the brand it matches with (active, down, parked, bot_detected) */
  status?: InputMaybe<Scalars['String']>;
  unsanitized_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Full_Urls_Max_Fields = {
  __typename?: 'full_urls_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  /** gcs url for where favicon image is stored */
  favicon_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  initial_discovery_source?: Maybe<Scalars['String']>;
  screenshot_url?: Maybe<Scalars['String']>;
  site_html?: Maybe<Scalars['String']>;
  /** URL to HTTP GET the site_text as a file */
  site_html_url?: Maybe<Scalars['String']>;
  site_text?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  /** Status of url irrespective to the brand it matches with (active, down, parked, bot_detected) */
  status?: Maybe<Scalars['String']>;
  unsanitized_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "full_urls" */
export type Full_Urls_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  domain_data_id?: InputMaybe<Order_By>;
  /** gcs url for where favicon image is stored */
  favicon_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_discovery_source?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  site_html?: InputMaybe<Order_By>;
  /** URL to HTTP GET the site_text as a file */
  site_html_url?: InputMaybe<Order_By>;
  site_text?: InputMaybe<Order_By>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Order_By>;
  /** Status of url irrespective to the brand it matches with (active, down, parked, bot_detected) */
  status?: InputMaybe<Order_By>;
  unsanitized_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Full_Urls_Min_Fields = {
  __typename?: 'full_urls_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  /** gcs url for where favicon image is stored */
  favicon_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  initial_discovery_source?: Maybe<Scalars['String']>;
  screenshot_url?: Maybe<Scalars['String']>;
  site_html?: Maybe<Scalars['String']>;
  /** URL to HTTP GET the site_text as a file */
  site_html_url?: Maybe<Scalars['String']>;
  site_text?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  /** Status of url irrespective to the brand it matches with (active, down, parked, bot_detected) */
  status?: Maybe<Scalars['String']>;
  unsanitized_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "full_urls" */
export type Full_Urls_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  domain_data_id?: InputMaybe<Order_By>;
  /** gcs url for where favicon image is stored */
  favicon_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_discovery_source?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  site_html?: InputMaybe<Order_By>;
  /** URL to HTTP GET the site_text as a file */
  site_html_url?: InputMaybe<Order_By>;
  site_text?: InputMaybe<Order_By>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Order_By>;
  /** Status of url irrespective to the brand it matches with (active, down, parked, bot_detected) */
  status?: InputMaybe<Order_By>;
  unsanitized_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "full_urls" */
export type Full_Urls_Mutation_Response = {
  __typename?: 'full_urls_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Full_Urls>;
};

/** input type for inserting object relation for remote table "full_urls" */
export type Full_Urls_Obj_Rel_Insert_Input = {
  data: Full_Urls_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Full_Urls_On_Conflict>;
};

/** on_conflict condition type for table "full_urls" */
export type Full_Urls_On_Conflict = {
  constraint: Full_Urls_Constraint;
  update_columns?: Array<Full_Urls_Update_Column>;
  where?: InputMaybe<Full_Urls_Bool_Exp>;
};

/** Ordering options when selecting data from "full_urls". */
export type Full_Urls_Order_By = {
  created_at?: InputMaybe<Order_By>;
  domain_data?: InputMaybe<Domain_Data_Order_By>;
  domain_data_id?: InputMaybe<Order_By>;
  entity_data_aggregate?: InputMaybe<Entity_Data_Aggregate_Order_By>;
  favicon_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_discovery_source?: InputMaybe<Order_By>;
  is_current?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  site_html?: InputMaybe<Order_By>;
  site_html_url?: InputMaybe<Order_By>;
  site_text?: InputMaybe<Order_By>;
  source_query?: InputMaybe<Order_By>;
  spoof_matches_aggregate?: InputMaybe<Spoof_Matches_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  unsanitized_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: full_urls */
export type Full_Urls_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "full_urls" */
export enum Full_Urls_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainDataId = 'domain_data_id',
  /** column name */
  FaviconUrl = 'favicon_url',
  /** column name */
  Id = 'id',
  /** column name */
  InitialDiscoverySource = 'initial_discovery_source',
  /** column name */
  IsCurrent = 'is_current',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  SiteHtml = 'site_html',
  /** column name */
  SiteHtmlUrl = 'site_html_url',
  /** column name */
  SiteText = 'site_text',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  Status = 'status',
  /** column name */
  UnsanitizedUrl = 'unsanitized_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** select "full_urls_aggregate_bool_exp_bool_and_arguments_columns" columns of table "full_urls" */
export enum Full_Urls_Select_Column_Full_Urls_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCurrent = 'is_current'
}

/** select "full_urls_aggregate_bool_exp_bool_or_arguments_columns" columns of table "full_urls" */
export enum Full_Urls_Select_Column_Full_Urls_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCurrent = 'is_current'
}

/** input type for updating data in table "full_urls" */
export type Full_Urls_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  /** gcs url for where favicon image is stored */
  favicon_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  initial_discovery_source?: InputMaybe<Scalars['String']>;
  is_current?: InputMaybe<Scalars['Boolean']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  site_html?: InputMaybe<Scalars['String']>;
  /** URL to HTTP GET the site_text as a file */
  site_html_url?: InputMaybe<Scalars['String']>;
  site_text?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  /** Status of url irrespective to the brand it matches with (active, down, parked, bot_detected) */
  status?: InputMaybe<Scalars['String']>;
  unsanitized_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "full_urls" */
export type Full_Urls_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Full_Urls_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Full_Urls_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  /** gcs url for where favicon image is stored */
  favicon_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  initial_discovery_source?: InputMaybe<Scalars['String']>;
  is_current?: InputMaybe<Scalars['Boolean']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  site_html?: InputMaybe<Scalars['String']>;
  /** URL to HTTP GET the site_text as a file */
  site_html_url?: InputMaybe<Scalars['String']>;
  site_text?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  /** Status of url irrespective to the brand it matches with (active, down, parked, bot_detected) */
  status?: InputMaybe<Scalars['String']>;
  unsanitized_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "full_urls" */
export enum Full_Urls_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainDataId = 'domain_data_id',
  /** column name */
  FaviconUrl = 'favicon_url',
  /** column name */
  Id = 'id',
  /** column name */
  InitialDiscoverySource = 'initial_discovery_source',
  /** column name */
  IsCurrent = 'is_current',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  SiteHtml = 'site_html',
  /** column name */
  SiteHtmlUrl = 'site_html_url',
  /** column name */
  SiteText = 'site_text',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  Status = 'status',
  /** column name */
  UnsanitizedUrl = 'unsanitized_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type Full_Urls_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Full_Urls_Set_Input>;
  /** filter the rows which have to be updated */
  where: Full_Urls_Bool_Exp;
};

export type Get_Pii_Reports_With_Screenshots_Args = {
  p_databroker_uuid?: InputMaybe<Scalars['uuid']>;
  p_limit?: InputMaybe<Scalars['Int']>;
  p_offset?: InputMaybe<Scalars['Int']>;
  p_removal_status?: InputMaybe<Scalars['Int']>;
  p_user_id?: InputMaybe<Scalars['uuid']>;
};

/** fields of action: "handle_synchronous_detection_request_async_action" */
export type Handle_Synchronous_Detection_Request_Async_Action = {
  __typename?: 'handle_synchronous_detection_request_async_action';
  /** the time at which this action was created */
  created_at: Scalars['timestamptz'];
  /** errors related to the invocation */
  errors?: Maybe<Scalars['json']>;
  /** the unique id of an action */
  id: Scalars['uuid'];
  /** the output fields of this action */
  output?: Maybe<HandleSynchronousDetectionRequestAsyncActionOutput>;
};

/** columns and relationships of "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_Stats = {
  __typename?: 'hourly_spoofing_reports_stats';
  created_at: Scalars['timestamp'];
  date: Scalars['date'];
  id: Scalars['uuid'];
  median_latency_detected_to_reported?: Maybe<Scalars['jsonb']>;
  median_latency_reported_to_delisted?: Maybe<Scalars['jsonb']>;
  median_latency_reported_to_first_mitigated?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
  original_entity_id?: Maybe<Scalars['uuid']>;
  report_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  spoofing_entity?: Maybe<Spoofing_Entities>;
  total_count: Scalars['Int'];
  total_reported_count: Scalars['Int'];
  total_resolved_count: Scalars['Int'];
};


/** columns and relationships of "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_StatsMedian_Latency_Detected_To_ReportedArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_StatsMedian_Latency_Reported_To_DelistedArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_StatsMedian_Latency_Reported_To_First_MitigatedArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_Stats_Aggregate = {
  __typename?: 'hourly_spoofing_reports_stats_aggregate';
  aggregate?: Maybe<Hourly_Spoofing_Reports_Stats_Aggregate_Fields>;
  nodes: Array<Hourly_Spoofing_Reports_Stats>;
};

/** aggregate fields of "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_Stats_Aggregate_Fields = {
  __typename?: 'hourly_spoofing_reports_stats_aggregate_fields';
  avg?: Maybe<Hourly_Spoofing_Reports_Stats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Hourly_Spoofing_Reports_Stats_Max_Fields>;
  min?: Maybe<Hourly_Spoofing_Reports_Stats_Min_Fields>;
  stddev?: Maybe<Hourly_Spoofing_Reports_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Hourly_Spoofing_Reports_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Hourly_Spoofing_Reports_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Hourly_Spoofing_Reports_Stats_Sum_Fields>;
  var_pop?: Maybe<Hourly_Spoofing_Reports_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Hourly_Spoofing_Reports_Stats_Var_Samp_Fields>;
  variance?: Maybe<Hourly_Spoofing_Reports_Stats_Variance_Fields>;
};


/** aggregate fields of "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hourly_Spoofing_Reports_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Hourly_Spoofing_Reports_Stats_Append_Input = {
  median_latency_detected_to_reported?: InputMaybe<Scalars['jsonb']>;
  median_latency_reported_to_delisted?: InputMaybe<Scalars['jsonb']>;
  median_latency_reported_to_first_mitigated?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Hourly_Spoofing_Reports_Stats_Avg_Fields = {
  __typename?: 'hourly_spoofing_reports_stats_avg_fields';
  total_count?: Maybe<Scalars['Float']>;
  total_reported_count?: Maybe<Scalars['Float']>;
  total_resolved_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "hourly_spoofing_reports_stats". All fields are combined with a logical 'AND'. */
export type Hourly_Spoofing_Reports_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Hourly_Spoofing_Reports_Stats_Bool_Exp>>;
  _not?: InputMaybe<Hourly_Spoofing_Reports_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Hourly_Spoofing_Reports_Stats_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  median_latency_detected_to_reported?: InputMaybe<Jsonb_Comparison_Exp>;
  median_latency_reported_to_delisted?: InputMaybe<Jsonb_Comparison_Exp>;
  median_latency_reported_to_first_mitigated?: InputMaybe<Jsonb_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  original_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  report_type?: InputMaybe<String_Comparison_Exp>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  total_count?: InputMaybe<Int_Comparison_Exp>;
  total_reported_count?: InputMaybe<Int_Comparison_Exp>;
  total_resolved_count?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "hourly_spoofing_reports_stats" */
export enum Hourly_Spoofing_Reports_Stats_Constraint {
  /** unique or primary key constraint on columns "id" */
  HourlySpoofingReportsStatsPkey = 'hourly_spoofing_reports_stats_pkey',
  /** unique or primary key constraint on columns "organization_id", "date", "report_type", "original_entity_id" */
  HourlySpoofingReportsStatsReportTypeOriginalEntityIdDa = 'hourly_spoofing_reports_stats_report_type_original_entity_id_da'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Hourly_Spoofing_Reports_Stats_Delete_At_Path_Input = {
  median_latency_detected_to_reported?: InputMaybe<Array<Scalars['String']>>;
  median_latency_reported_to_delisted?: InputMaybe<Array<Scalars['String']>>;
  median_latency_reported_to_first_mitigated?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Hourly_Spoofing_Reports_Stats_Delete_Elem_Input = {
  median_latency_detected_to_reported?: InputMaybe<Scalars['Int']>;
  median_latency_reported_to_delisted?: InputMaybe<Scalars['Int']>;
  median_latency_reported_to_first_mitigated?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Hourly_Spoofing_Reports_Stats_Delete_Key_Input = {
  median_latency_detected_to_reported?: InputMaybe<Scalars['String']>;
  median_latency_reported_to_delisted?: InputMaybe<Scalars['String']>;
  median_latency_reported_to_first_mitigated?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_Stats_Inc_Input = {
  total_count?: InputMaybe<Scalars['Int']>;
  total_reported_count?: InputMaybe<Scalars['Int']>;
  total_resolved_count?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_Stats_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  median_latency_detected_to_reported?: InputMaybe<Scalars['jsonb']>;
  median_latency_reported_to_delisted?: InputMaybe<Scalars['jsonb']>;
  median_latency_reported_to_first_mitigated?: InputMaybe<Scalars['jsonb']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  report_type?: InputMaybe<Scalars['String']>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Obj_Rel_Insert_Input>;
  total_count?: InputMaybe<Scalars['Int']>;
  total_reported_count?: InputMaybe<Scalars['Int']>;
  total_resolved_count?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Hourly_Spoofing_Reports_Stats_Max_Fields = {
  __typename?: 'hourly_spoofing_reports_stats_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  report_type?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
  total_reported_count?: Maybe<Scalars['Int']>;
  total_resolved_count?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Hourly_Spoofing_Reports_Stats_Min_Fields = {
  __typename?: 'hourly_spoofing_reports_stats_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  report_type?: Maybe<Scalars['String']>;
  total_count?: Maybe<Scalars['Int']>;
  total_reported_count?: Maybe<Scalars['Int']>;
  total_resolved_count?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_Stats_Mutation_Response = {
  __typename?: 'hourly_spoofing_reports_stats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hourly_Spoofing_Reports_Stats>;
};

/** on_conflict condition type for table "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_Stats_On_Conflict = {
  constraint: Hourly_Spoofing_Reports_Stats_Constraint;
  update_columns?: Array<Hourly_Spoofing_Reports_Stats_Update_Column>;
  where?: InputMaybe<Hourly_Spoofing_Reports_Stats_Bool_Exp>;
};

/** Ordering options when selecting data from "hourly_spoofing_reports_stats". */
export type Hourly_Spoofing_Reports_Stats_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  median_latency_detected_to_reported?: InputMaybe<Order_By>;
  median_latency_reported_to_delisted?: InputMaybe<Order_By>;
  median_latency_reported_to_first_mitigated?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  report_type?: InputMaybe<Order_By>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Order_By>;
  total_count?: InputMaybe<Order_By>;
  total_reported_count?: InputMaybe<Order_By>;
  total_resolved_count?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hourly_spoofing_reports_stats */
export type Hourly_Spoofing_Reports_Stats_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Hourly_Spoofing_Reports_Stats_Prepend_Input = {
  median_latency_detected_to_reported?: InputMaybe<Scalars['jsonb']>;
  median_latency_reported_to_delisted?: InputMaybe<Scalars['jsonb']>;
  median_latency_reported_to_first_mitigated?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "hourly_spoofing_reports_stats" */
export enum Hourly_Spoofing_Reports_Stats_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  MedianLatencyDetectedToReported = 'median_latency_detected_to_reported',
  /** column name */
  MedianLatencyReportedToDelisted = 'median_latency_reported_to_delisted',
  /** column name */
  MedianLatencyReportedToFirstMitigated = 'median_latency_reported_to_first_mitigated',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  ReportType = 'report_type',
  /** column name */
  TotalCount = 'total_count',
  /** column name */
  TotalReportedCount = 'total_reported_count',
  /** column name */
  TotalResolvedCount = 'total_resolved_count'
}

/** input type for updating data in table "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_Stats_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  median_latency_detected_to_reported?: InputMaybe<Scalars['jsonb']>;
  median_latency_reported_to_delisted?: InputMaybe<Scalars['jsonb']>;
  median_latency_reported_to_first_mitigated?: InputMaybe<Scalars['jsonb']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  report_type?: InputMaybe<Scalars['String']>;
  total_count?: InputMaybe<Scalars['Int']>;
  total_reported_count?: InputMaybe<Scalars['Int']>;
  total_resolved_count?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Hourly_Spoofing_Reports_Stats_Stddev_Fields = {
  __typename?: 'hourly_spoofing_reports_stats_stddev_fields';
  total_count?: Maybe<Scalars['Float']>;
  total_reported_count?: Maybe<Scalars['Float']>;
  total_resolved_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Hourly_Spoofing_Reports_Stats_Stddev_Pop_Fields = {
  __typename?: 'hourly_spoofing_reports_stats_stddev_pop_fields';
  total_count?: Maybe<Scalars['Float']>;
  total_reported_count?: Maybe<Scalars['Float']>;
  total_resolved_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Hourly_Spoofing_Reports_Stats_Stddev_Samp_Fields = {
  __typename?: 'hourly_spoofing_reports_stats_stddev_samp_fields';
  total_count?: Maybe<Scalars['Float']>;
  total_reported_count?: Maybe<Scalars['Float']>;
  total_resolved_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "hourly_spoofing_reports_stats" */
export type Hourly_Spoofing_Reports_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hourly_Spoofing_Reports_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hourly_Spoofing_Reports_Stats_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  median_latency_detected_to_reported?: InputMaybe<Scalars['jsonb']>;
  median_latency_reported_to_delisted?: InputMaybe<Scalars['jsonb']>;
  median_latency_reported_to_first_mitigated?: InputMaybe<Scalars['jsonb']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  report_type?: InputMaybe<Scalars['String']>;
  total_count?: InputMaybe<Scalars['Int']>;
  total_reported_count?: InputMaybe<Scalars['Int']>;
  total_resolved_count?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Hourly_Spoofing_Reports_Stats_Sum_Fields = {
  __typename?: 'hourly_spoofing_reports_stats_sum_fields';
  total_count?: Maybe<Scalars['Int']>;
  total_reported_count?: Maybe<Scalars['Int']>;
  total_resolved_count?: Maybe<Scalars['Int']>;
};

/** update columns of table "hourly_spoofing_reports_stats" */
export enum Hourly_Spoofing_Reports_Stats_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  MedianLatencyDetectedToReported = 'median_latency_detected_to_reported',
  /** column name */
  MedianLatencyReportedToDelisted = 'median_latency_reported_to_delisted',
  /** column name */
  MedianLatencyReportedToFirstMitigated = 'median_latency_reported_to_first_mitigated',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  ReportType = 'report_type',
  /** column name */
  TotalCount = 'total_count',
  /** column name */
  TotalReportedCount = 'total_reported_count',
  /** column name */
  TotalResolvedCount = 'total_resolved_count'
}

export type Hourly_Spoofing_Reports_Stats_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Hourly_Spoofing_Reports_Stats_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Hourly_Spoofing_Reports_Stats_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Hourly_Spoofing_Reports_Stats_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Hourly_Spoofing_Reports_Stats_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Hourly_Spoofing_Reports_Stats_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Hourly_Spoofing_Reports_Stats_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hourly_Spoofing_Reports_Stats_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hourly_Spoofing_Reports_Stats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Hourly_Spoofing_Reports_Stats_Var_Pop_Fields = {
  __typename?: 'hourly_spoofing_reports_stats_var_pop_fields';
  total_count?: Maybe<Scalars['Float']>;
  total_reported_count?: Maybe<Scalars['Float']>;
  total_resolved_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Hourly_Spoofing_Reports_Stats_Var_Samp_Fields = {
  __typename?: 'hourly_spoofing_reports_stats_var_samp_fields';
  total_count?: Maybe<Scalars['Float']>;
  total_reported_count?: Maybe<Scalars['Float']>;
  total_resolved_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Hourly_Spoofing_Reports_Stats_Variance_Fields = {
  __typename?: 'hourly_spoofing_reports_stats_variance_fields';
  total_count?: Maybe<Scalars['Float']>;
  total_reported_count?: Maybe<Scalars['Float']>;
  total_resolved_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ioc_alert_attribution" */
export type Ioc_Alert_Attribution = {
  __typename?: 'ioc_alert_attribution';
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  /** An object relationship */
  ioc: Iocs;
  ioc_id: Scalars['uuid'];
  match_id: Scalars['uuid'];
  /** An object relationship */
  spoof_match: Spoof_Matches;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_Aggregate = {
  __typename?: 'ioc_alert_attribution_aggregate';
  aggregate?: Maybe<Ioc_Alert_Attribution_Aggregate_Fields>;
  nodes: Array<Ioc_Alert_Attribution>;
};

export type Ioc_Alert_Attribution_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ioc_Alert_Attribution_Aggregate_Bool_Exp_Count>;
};

export type Ioc_Alert_Attribution_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ioc_Alert_Attribution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ioc_Alert_Attribution_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_Aggregate_Fields = {
  __typename?: 'ioc_alert_attribution_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ioc_Alert_Attribution_Max_Fields>;
  min?: Maybe<Ioc_Alert_Attribution_Min_Fields>;
};


/** aggregate fields of "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ioc_Alert_Attribution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ioc_Alert_Attribution_Max_Order_By>;
  min?: InputMaybe<Ioc_Alert_Attribution_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_Arr_Rel_Insert_Input = {
  data: Array<Ioc_Alert_Attribution_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ioc_Alert_Attribution_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ioc_alert_attribution". All fields are combined with a logical 'AND'. */
export type Ioc_Alert_Attribution_Bool_Exp = {
  _and?: InputMaybe<Array<Ioc_Alert_Attribution_Bool_Exp>>;
  _not?: InputMaybe<Ioc_Alert_Attribution_Bool_Exp>;
  _or?: InputMaybe<Array<Ioc_Alert_Attribution_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ioc?: InputMaybe<Iocs_Bool_Exp>;
  ioc_id?: InputMaybe<Uuid_Comparison_Exp>;
  match_id?: InputMaybe<Uuid_Comparison_Exp>;
  spoof_match?: InputMaybe<Spoof_Matches_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ioc_alert_attribution" */
export enum Ioc_Alert_Attribution_Constraint {
  /** unique or primary key constraint on columns "ioc_id", "match_id" */
  IocAlertAttributionIocIdMatchIdKey = 'ioc_alert_attribution_ioc_id_match_id_key',
  /** unique or primary key constraint on columns "id" */
  IocAlertAttributionPkey = 'ioc_alert_attribution_pkey'
}

/** input type for inserting data into table "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  ioc?: InputMaybe<Iocs_Obj_Rel_Insert_Input>;
  ioc_id?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  spoof_match?: InputMaybe<Spoof_Matches_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ioc_Alert_Attribution_Max_Fields = {
  __typename?: 'ioc_alert_attribution_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  ioc_id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ioc_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ioc_Alert_Attribution_Min_Fields = {
  __typename?: 'ioc_alert_attribution_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  ioc_id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ioc_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_Mutation_Response = {
  __typename?: 'ioc_alert_attribution_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ioc_Alert_Attribution>;
};

/** on_conflict condition type for table "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_On_Conflict = {
  constraint: Ioc_Alert_Attribution_Constraint;
  update_columns?: Array<Ioc_Alert_Attribution_Update_Column>;
  where?: InputMaybe<Ioc_Alert_Attribution_Bool_Exp>;
};

/** Ordering options when selecting data from "ioc_alert_attribution". */
export type Ioc_Alert_Attribution_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ioc?: InputMaybe<Iocs_Order_By>;
  ioc_id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  spoof_match?: InputMaybe<Spoof_Matches_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ioc_alert_attribution */
export type Ioc_Alert_Attribution_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ioc_alert_attribution" */
export enum Ioc_Alert_Attribution_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IocId = 'ioc_id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  ioc_id?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "ioc_alert_attribution" */
export type Ioc_Alert_Attribution_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ioc_Alert_Attribution_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ioc_Alert_Attribution_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  ioc_id?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ioc_alert_attribution" */
export enum Ioc_Alert_Attribution_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IocId = 'ioc_id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ioc_Alert_Attribution_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ioc_Alert_Attribution_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ioc_Alert_Attribution_Bool_Exp;
};

/** columns and relationships of "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution = {
  __typename?: 'ioc_detection_config_attribution';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  detection_assets?: Maybe<Detection_Assets>;
  detection_config_id: Scalars['uuid'];
  detection_config_type: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  ioc: Iocs;
  ioc_id: Scalars['uuid'];
  /** An object relationship */
  rules?: Maybe<Rules>;
  /** An object relationship */
  sourcing_queries?: Maybe<Sourcing_Queries>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Aggregate = {
  __typename?: 'ioc_detection_config_attribution_aggregate';
  aggregate?: Maybe<Ioc_Detection_Config_Attribution_Aggregate_Fields>;
  nodes: Array<Ioc_Detection_Config_Attribution>;
};

export type Ioc_Detection_Config_Attribution_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ioc_Detection_Config_Attribution_Aggregate_Bool_Exp_Count>;
};

export type Ioc_Detection_Config_Attribution_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Aggregate_Fields = {
  __typename?: 'ioc_detection_config_attribution_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ioc_Detection_Config_Attribution_Max_Fields>;
  min?: Maybe<Ioc_Detection_Config_Attribution_Min_Fields>;
};


/** aggregate fields of "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ioc_Detection_Config_Attribution_Max_Order_By>;
  min?: InputMaybe<Ioc_Detection_Config_Attribution_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Arr_Rel_Insert_Input = {
  data: Array<Ioc_Detection_Config_Attribution_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ioc_Detection_Config_Attribution_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ioc_detection_config_attribution". All fields are combined with a logical 'AND'. */
export type Ioc_Detection_Config_Attribution_Bool_Exp = {
  _and?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Bool_Exp>>;
  _not?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
  _or?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  detection_assets?: InputMaybe<Detection_Assets_Bool_Exp>;
  detection_config_id?: InputMaybe<Uuid_Comparison_Exp>;
  detection_config_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ioc?: InputMaybe<Iocs_Bool_Exp>;
  ioc_id?: InputMaybe<Uuid_Comparison_Exp>;
  rules?: InputMaybe<Rules_Bool_Exp>;
  sourcing_queries?: InputMaybe<Sourcing_Queries_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ioc_detection_config_attribution" */
export enum Ioc_Detection_Config_Attribution_Constraint {
  /** unique or primary key constraint on columns "detection_config_type", "detection_config_id", "ioc_id" */
  IocDetectionConfigAttributionIocIdDetectionConfigTypeD = 'ioc_detection_config_attribution_ioc_id_detection_config_type_d',
  /** unique or primary key constraint on columns "id" */
  IocDetectionConfigAttributionPkey = 'ioc_detection_config_attribution_pkey'
}

/** input type for inserting data into table "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_assets?: InputMaybe<Detection_Assets_Obj_Rel_Insert_Input>;
  detection_config_id?: InputMaybe<Scalars['uuid']>;
  detection_config_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ioc?: InputMaybe<Iocs_Obj_Rel_Insert_Input>;
  ioc_id?: InputMaybe<Scalars['uuid']>;
  rules?: InputMaybe<Rules_Obj_Rel_Insert_Input>;
  sourcing_queries?: InputMaybe<Sourcing_Queries_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ioc_Detection_Config_Attribution_Max_Fields = {
  __typename?: 'ioc_detection_config_attribution_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  detection_config_id?: Maybe<Scalars['uuid']>;
  detection_config_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ioc_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  detection_config_id?: InputMaybe<Order_By>;
  detection_config_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ioc_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ioc_Detection_Config_Attribution_Min_Fields = {
  __typename?: 'ioc_detection_config_attribution_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  detection_config_id?: Maybe<Scalars['uuid']>;
  detection_config_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  ioc_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  detection_config_id?: InputMaybe<Order_By>;
  detection_config_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ioc_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Mutation_Response = {
  __typename?: 'ioc_detection_config_attribution_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ioc_Detection_Config_Attribution>;
};

/** input type for inserting object relation for remote table "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Obj_Rel_Insert_Input = {
  data: Ioc_Detection_Config_Attribution_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ioc_Detection_Config_Attribution_On_Conflict>;
};

/** on_conflict condition type for table "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_On_Conflict = {
  constraint: Ioc_Detection_Config_Attribution_Constraint;
  update_columns?: Array<Ioc_Detection_Config_Attribution_Update_Column>;
  where?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
};

/** Ordering options when selecting data from "ioc_detection_config_attribution". */
export type Ioc_Detection_Config_Attribution_Order_By = {
  created_at?: InputMaybe<Order_By>;
  detection_assets?: InputMaybe<Detection_Assets_Order_By>;
  detection_config_id?: InputMaybe<Order_By>;
  detection_config_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ioc?: InputMaybe<Iocs_Order_By>;
  ioc_id?: InputMaybe<Order_By>;
  rules?: InputMaybe<Rules_Order_By>;
  sourcing_queries?: InputMaybe<Sourcing_Queries_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ioc_detection_config_attribution */
export type Ioc_Detection_Config_Attribution_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ioc_detection_config_attribution" */
export enum Ioc_Detection_Config_Attribution_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionConfigId = 'detection_config_id',
  /** column name */
  DetectionConfigType = 'detection_config_type',
  /** column name */
  Id = 'id',
  /** column name */
  IocId = 'ioc_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_config_id?: InputMaybe<Scalars['uuid']>;
  detection_config_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ioc_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "ioc_detection_config_attribution" */
export type Ioc_Detection_Config_Attribution_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ioc_Detection_Config_Attribution_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ioc_Detection_Config_Attribution_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_config_id?: InputMaybe<Scalars['uuid']>;
  detection_config_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ioc_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ioc_detection_config_attribution" */
export enum Ioc_Detection_Config_Attribution_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionConfigId = 'detection_config_id',
  /** column name */
  DetectionConfigType = 'detection_config_type',
  /** column name */
  Id = 'id',
  /** column name */
  IocId = 'ioc_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ioc_Detection_Config_Attribution_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ioc_Detection_Config_Attribution_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ioc_Detection_Config_Attribution_Bool_Exp;
};

/** columns and relationships of "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution = {
  __typename?: 'ioc_entity_data_attribution';
  created_at: Scalars['timestamptz'];
  entity_data_id: Scalars['uuid'];
  /** An object relationship */
  entity_datum: Entity_Data;
  id: Scalars['uuid'];
  /** An object relationship */
  ioc: Iocs;
  ioc_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_Aggregate = {
  __typename?: 'ioc_entity_data_attribution_aggregate';
  aggregate?: Maybe<Ioc_Entity_Data_Attribution_Aggregate_Fields>;
  nodes: Array<Ioc_Entity_Data_Attribution>;
};

export type Ioc_Entity_Data_Attribution_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ioc_Entity_Data_Attribution_Aggregate_Bool_Exp_Count>;
};

export type Ioc_Entity_Data_Attribution_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ioc_Entity_Data_Attribution_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_Aggregate_Fields = {
  __typename?: 'ioc_entity_data_attribution_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ioc_Entity_Data_Attribution_Max_Fields>;
  min?: Maybe<Ioc_Entity_Data_Attribution_Min_Fields>;
};


/** aggregate fields of "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ioc_Entity_Data_Attribution_Max_Order_By>;
  min?: InputMaybe<Ioc_Entity_Data_Attribution_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_Arr_Rel_Insert_Input = {
  data: Array<Ioc_Entity_Data_Attribution_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ioc_Entity_Data_Attribution_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ioc_entity_data_attribution". All fields are combined with a logical 'AND'. */
export type Ioc_Entity_Data_Attribution_Bool_Exp = {
  _and?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Bool_Exp>>;
  _not?: InputMaybe<Ioc_Entity_Data_Attribution_Bool_Exp>;
  _or?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  entity_datum?: InputMaybe<Entity_Data_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ioc?: InputMaybe<Iocs_Bool_Exp>;
  ioc_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "ioc_entity_data_attribution" */
export enum Ioc_Entity_Data_Attribution_Constraint {
  /** unique or primary key constraint on columns "ioc_id", "entity_data_id" */
  IocEntityDataAttributionIocIdEntityDataIdKey = 'ioc_entity_data_attribution_ioc_id_entity_data_id_key',
  /** unique or primary key constraint on columns "id" */
  IocEntityDataAttributionPkey = 'ioc_entity_data_attribution_pkey'
}

/** input type for inserting data into table "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entity_data_id?: InputMaybe<Scalars['uuid']>;
  entity_datum?: InputMaybe<Entity_Data_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  ioc?: InputMaybe<Iocs_Obj_Rel_Insert_Input>;
  ioc_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Ioc_Entity_Data_Attribution_Max_Fields = {
  __typename?: 'ioc_entity_data_attribution_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  entity_data_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  ioc_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_data_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ioc_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ioc_Entity_Data_Attribution_Min_Fields = {
  __typename?: 'ioc_entity_data_attribution_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  entity_data_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  ioc_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_data_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ioc_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_Mutation_Response = {
  __typename?: 'ioc_entity_data_attribution_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ioc_Entity_Data_Attribution>;
};

/** on_conflict condition type for table "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_On_Conflict = {
  constraint: Ioc_Entity_Data_Attribution_Constraint;
  update_columns?: Array<Ioc_Entity_Data_Attribution_Update_Column>;
  where?: InputMaybe<Ioc_Entity_Data_Attribution_Bool_Exp>;
};

/** Ordering options when selecting data from "ioc_entity_data_attribution". */
export type Ioc_Entity_Data_Attribution_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_data_id?: InputMaybe<Order_By>;
  entity_datum?: InputMaybe<Entity_Data_Order_By>;
  id?: InputMaybe<Order_By>;
  ioc?: InputMaybe<Iocs_Order_By>;
  ioc_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ioc_entity_data_attribution */
export type Ioc_Entity_Data_Attribution_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ioc_entity_data_attribution" */
export enum Ioc_Entity_Data_Attribution_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityDataId = 'entity_data_id',
  /** column name */
  Id = 'id',
  /** column name */
  IocId = 'ioc_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entity_data_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  ioc_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "ioc_entity_data_attribution" */
export type Ioc_Entity_Data_Attribution_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ioc_Entity_Data_Attribution_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ioc_Entity_Data_Attribution_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entity_data_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  ioc_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "ioc_entity_data_attribution" */
export enum Ioc_Entity_Data_Attribution_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityDataId = 'entity_data_id',
  /** column name */
  Id = 'id',
  /** column name */
  IocId = 'ioc_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Ioc_Entity_Data_Attribution_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ioc_Entity_Data_Attribution_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ioc_Entity_Data_Attribution_Bool_Exp;
};

/** columns and relationships of "iocs" */
export type Iocs = {
  __typename?: 'iocs';
  additional_metadata: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  entity_data?: Maybe<Entity_Data>;
  entity_data_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An array relationship */
  ioc_alert_attributions: Array<Ioc_Alert_Attribution>;
  /** An aggregate relationship */
  ioc_alert_attributions_aggregate: Ioc_Alert_Attribution_Aggregate;
  /** An array relationship */
  ioc_detection_config_attributions: Array<Ioc_Detection_Config_Attribution>;
  /** An aggregate relationship */
  ioc_detection_config_attributions_aggregate: Ioc_Detection_Config_Attribution_Aggregate;
  /** An array relationship */
  ioc_entity_data_attributions: Array<Ioc_Entity_Data_Attribution>;
  /** An aggregate relationship */
  ioc_entity_data_attributions_aggregate: Ioc_Entity_Data_Attribution_Aggregate;
  last_updated_by?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  type: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  value: Scalars['String'];
};


/** columns and relationships of "iocs" */
export type IocsAdditional_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "iocs" */
export type IocsIoc_Alert_AttributionsArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Alert_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Alert_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Alert_Attribution_Bool_Exp>;
};


/** columns and relationships of "iocs" */
export type IocsIoc_Alert_Attributions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Alert_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Alert_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Alert_Attribution_Bool_Exp>;
};


/** columns and relationships of "iocs" */
export type IocsIoc_Detection_Config_AttributionsArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
};


/** columns and relationships of "iocs" */
export type IocsIoc_Detection_Config_Attributions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
};


/** columns and relationships of "iocs" */
export type IocsIoc_Entity_Data_AttributionsArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Entity_Data_Attribution_Bool_Exp>;
};


/** columns and relationships of "iocs" */
export type IocsIoc_Entity_Data_Attributions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Entity_Data_Attribution_Bool_Exp>;
};

/** aggregated selection of "iocs" */
export type Iocs_Aggregate = {
  __typename?: 'iocs_aggregate';
  aggregate?: Maybe<Iocs_Aggregate_Fields>;
  nodes: Array<Iocs>;
};

/** aggregate fields of "iocs" */
export type Iocs_Aggregate_Fields = {
  __typename?: 'iocs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Iocs_Max_Fields>;
  min?: Maybe<Iocs_Min_Fields>;
};


/** aggregate fields of "iocs" */
export type Iocs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Iocs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Iocs_Append_Input = {
  additional_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "iocs". All fields are combined with a logical 'AND'. */
export type Iocs_Bool_Exp = {
  _and?: InputMaybe<Array<Iocs_Bool_Exp>>;
  _not?: InputMaybe<Iocs_Bool_Exp>;
  _or?: InputMaybe<Array<Iocs_Bool_Exp>>;
  additional_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_data?: InputMaybe<Entity_Data_Bool_Exp>;
  entity_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ioc_alert_attributions?: InputMaybe<Ioc_Alert_Attribution_Bool_Exp>;
  ioc_alert_attributions_aggregate?: InputMaybe<Ioc_Alert_Attribution_Aggregate_Bool_Exp>;
  ioc_detection_config_attributions?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
  ioc_detection_config_attributions_aggregate?: InputMaybe<Ioc_Detection_Config_Attribution_Aggregate_Bool_Exp>;
  ioc_entity_data_attributions?: InputMaybe<Ioc_Entity_Data_Attribution_Bool_Exp>;
  ioc_entity_data_attributions_aggregate?: InputMaybe<Ioc_Entity_Data_Attribution_Aggregate_Bool_Exp>;
  last_updated_by?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "iocs" */
export enum Iocs_Constraint {
  /** unique or primary key constraint on columns "id" */
  IocPkey = 'IOC_pkey',
  /** unique or primary key constraint on columns "type", "value" */
  IocTypeValueKey = 'IOC_type_value_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Iocs_Delete_At_Path_Input = {
  additional_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Iocs_Delete_Elem_Input = {
  additional_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Iocs_Delete_Key_Input = {
  additional_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "iocs" */
export type Iocs_Insert_Input = {
  additional_metadata?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entity_data?: InputMaybe<Entity_Data_Obj_Rel_Insert_Input>;
  entity_data_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  ioc_alert_attributions?: InputMaybe<Ioc_Alert_Attribution_Arr_Rel_Insert_Input>;
  ioc_detection_config_attributions?: InputMaybe<Ioc_Detection_Config_Attribution_Arr_Rel_Insert_Input>;
  ioc_entity_data_attributions?: InputMaybe<Ioc_Entity_Data_Attribution_Arr_Rel_Insert_Input>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Iocs_Max_Fields = {
  __typename?: 'iocs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  entity_data_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Iocs_Min_Fields = {
  __typename?: 'iocs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  entity_data_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "iocs" */
export type Iocs_Mutation_Response = {
  __typename?: 'iocs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Iocs>;
};

/** input type for inserting object relation for remote table "iocs" */
export type Iocs_Obj_Rel_Insert_Input = {
  data: Iocs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Iocs_On_Conflict>;
};

/** on_conflict condition type for table "iocs" */
export type Iocs_On_Conflict = {
  constraint: Iocs_Constraint;
  update_columns?: Array<Iocs_Update_Column>;
  where?: InputMaybe<Iocs_Bool_Exp>;
};

/** Ordering options when selecting data from "iocs". */
export type Iocs_Order_By = {
  additional_metadata?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entity_data?: InputMaybe<Entity_Data_Order_By>;
  entity_data_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ioc_alert_attributions_aggregate?: InputMaybe<Ioc_Alert_Attribution_Aggregate_Order_By>;
  ioc_detection_config_attributions_aggregate?: InputMaybe<Ioc_Detection_Config_Attribution_Aggregate_Order_By>;
  ioc_entity_data_attributions_aggregate?: InputMaybe<Ioc_Entity_Data_Attribution_Aggregate_Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: iocs */
export type Iocs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Iocs_Prepend_Input = {
  additional_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "iocs" */
export enum Iocs_Select_Column {
  /** column name */
  AdditionalMetadata = 'additional_metadata',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityDataId = 'entity_data_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "iocs" */
export type Iocs_Set_Input = {
  additional_metadata?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entity_data_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "iocs" */
export type Iocs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Iocs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Iocs_Stream_Cursor_Value_Input = {
  additional_metadata?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  entity_data_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "iocs" */
export enum Iocs_Update_Column {
  /** column name */
  AdditionalMetadata = 'additional_metadata',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityDataId = 'entity_data_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Iocs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Iocs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Iocs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Iocs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Iocs_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Iocs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Iocs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Iocs_Bool_Exp;
};

/** columns and relationships of "jira_metadata" */
export type Jira_Metadata = {
  __typename?: 'jira_metadata';
  comments?: Maybe<Scalars['jsonb']>;
  description: Scalars['String'];
  /** An object relationship */
  enforcement_request?: Maybe<Enforcement_Requests>;
  enforcement_request_id?: Maybe<Scalars['uuid']>;
  has_platform_reply?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  labels?: Maybe<Scalars['jsonb']>;
  report_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  spoofing_report?: Maybe<Spoofing_Reports>;
  status: Scalars['String'];
  summary: Scalars['String'];
  ticket_id: Scalars['String'];
};


/** columns and relationships of "jira_metadata" */
export type Jira_MetadataCommentsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "jira_metadata" */
export type Jira_MetadataLabelsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "jira_metadata" */
export type Jira_Metadata_Aggregate = {
  __typename?: 'jira_metadata_aggregate';
  aggregate?: Maybe<Jira_Metadata_Aggregate_Fields>;
  nodes: Array<Jira_Metadata>;
};

export type Jira_Metadata_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Jira_Metadata_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Jira_Metadata_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Jira_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Jira_Metadata_Aggregate_Bool_Exp_Bool_And = {
  arguments: Jira_Metadata_Select_Column_Jira_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Jira_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Jira_Metadata_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Jira_Metadata_Select_Column_Jira_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Jira_Metadata_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Jira_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Jira_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Jira_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "jira_metadata" */
export type Jira_Metadata_Aggregate_Fields = {
  __typename?: 'jira_metadata_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Jira_Metadata_Max_Fields>;
  min?: Maybe<Jira_Metadata_Min_Fields>;
};


/** aggregate fields of "jira_metadata" */
export type Jira_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Jira_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "jira_metadata" */
export type Jira_Metadata_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Jira_Metadata_Max_Order_By>;
  min?: InputMaybe<Jira_Metadata_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Jira_Metadata_Append_Input = {
  comments?: InputMaybe<Scalars['jsonb']>;
  labels?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "jira_metadata" */
export type Jira_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Jira_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Jira_Metadata_On_Conflict>;
};

/** Boolean expression to filter rows from the table "jira_metadata". All fields are combined with a logical 'AND'. */
export type Jira_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Jira_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Jira_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Jira_Metadata_Bool_Exp>>;
  comments?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  enforcement_request?: InputMaybe<Enforcement_Requests_Bool_Exp>;
  enforcement_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_platform_reply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  labels?: InputMaybe<Jsonb_Comparison_Exp>;
  report_id?: InputMaybe<Uuid_Comparison_Exp>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  summary?: InputMaybe<String_Comparison_Exp>;
  ticket_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "jira_metadata" */
export enum Jira_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  JiraMetadataIdKey = 'jira_metadata_id_key',
  /** unique or primary key constraint on columns "id" */
  JiraMetadataPkey = 'jira_metadata_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Jira_Metadata_Delete_At_Path_Input = {
  comments?: InputMaybe<Array<Scalars['String']>>;
  labels?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Jira_Metadata_Delete_Elem_Input = {
  comments?: InputMaybe<Scalars['Int']>;
  labels?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Jira_Metadata_Delete_Key_Input = {
  comments?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "jira_metadata" */
export type Jira_Metadata_Insert_Input = {
  comments?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  enforcement_request?: InputMaybe<Enforcement_Requests_Obj_Rel_Insert_Input>;
  enforcement_request_id?: InputMaybe<Scalars['uuid']>;
  has_platform_reply?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  labels?: InputMaybe<Scalars['jsonb']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  ticket_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Jira_Metadata_Max_Fields = {
  __typename?: 'jira_metadata_max_fields';
  description?: Maybe<Scalars['String']>;
  enforcement_request_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  report_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  ticket_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "jira_metadata" */
export type Jira_Metadata_Max_Order_By = {
  description?: InputMaybe<Order_By>;
  enforcement_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Jira_Metadata_Min_Fields = {
  __typename?: 'jira_metadata_min_fields';
  description?: Maybe<Scalars['String']>;
  enforcement_request_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  report_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  ticket_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "jira_metadata" */
export type Jira_Metadata_Min_Order_By = {
  description?: InputMaybe<Order_By>;
  enforcement_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "jira_metadata" */
export type Jira_Metadata_Mutation_Response = {
  __typename?: 'jira_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Jira_Metadata>;
};

/** on_conflict condition type for table "jira_metadata" */
export type Jira_Metadata_On_Conflict = {
  constraint: Jira_Metadata_Constraint;
  update_columns?: Array<Jira_Metadata_Update_Column>;
  where?: InputMaybe<Jira_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "jira_metadata". */
export type Jira_Metadata_Order_By = {
  comments?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  enforcement_request?: InputMaybe<Enforcement_Requests_Order_By>;
  enforcement_request_id?: InputMaybe<Order_By>;
  has_platform_reply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  labels?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Order_By>;
  status?: InputMaybe<Order_By>;
  summary?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: jira_metadata */
export type Jira_Metadata_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Jira_Metadata_Prepend_Input = {
  comments?: InputMaybe<Scalars['jsonb']>;
  labels?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "jira_metadata" */
export enum Jira_Metadata_Select_Column {
  /** column name */
  Comments = 'comments',
  /** column name */
  Description = 'description',
  /** column name */
  EnforcementRequestId = 'enforcement_request_id',
  /** column name */
  HasPlatformReply = 'has_platform_reply',
  /** column name */
  Id = 'id',
  /** column name */
  Labels = 'labels',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  Status = 'status',
  /** column name */
  Summary = 'summary',
  /** column name */
  TicketId = 'ticket_id'
}

/** select "jira_metadata_aggregate_bool_exp_bool_and_arguments_columns" columns of table "jira_metadata" */
export enum Jira_Metadata_Select_Column_Jira_Metadata_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasPlatformReply = 'has_platform_reply'
}

/** select "jira_metadata_aggregate_bool_exp_bool_or_arguments_columns" columns of table "jira_metadata" */
export enum Jira_Metadata_Select_Column_Jira_Metadata_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasPlatformReply = 'has_platform_reply'
}

/** input type for updating data in table "jira_metadata" */
export type Jira_Metadata_Set_Input = {
  comments?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  enforcement_request_id?: InputMaybe<Scalars['uuid']>;
  has_platform_reply?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  labels?: InputMaybe<Scalars['jsonb']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  ticket_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "jira_metadata" */
export type Jira_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Jira_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Jira_Metadata_Stream_Cursor_Value_Input = {
  comments?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  enforcement_request_id?: InputMaybe<Scalars['uuid']>;
  has_platform_reply?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  labels?: InputMaybe<Scalars['jsonb']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  ticket_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "jira_metadata" */
export enum Jira_Metadata_Update_Column {
  /** column name */
  Comments = 'comments',
  /** column name */
  Description = 'description',
  /** column name */
  EnforcementRequestId = 'enforcement_request_id',
  /** column name */
  HasPlatformReply = 'has_platform_reply',
  /** column name */
  Id = 'id',
  /** column name */
  Labels = 'labels',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  Status = 'status',
  /** column name */
  Summary = 'summary',
  /** column name */
  TicketId = 'ticket_id'
}

export type Jira_Metadata_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Jira_Metadata_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Jira_Metadata_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Jira_Metadata_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Jira_Metadata_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Jira_Metadata_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Jira_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Jira_Metadata_Bool_Exp;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** Attributes matches to the entities that are responsible for their existence */
export type Match_Attributions = {
  __typename?: 'match_attributions';
  attribution_id: Scalars['uuid'];
  attribution_type: Scalars['String'];
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  detection_assets?: Maybe<Detection_Assets>;
  id: Scalars['uuid'];
  match_id: Scalars['uuid'];
  metadata: Scalars['jsonb'];
  /** An object relationship */
  rules?: Maybe<Rules>;
  /** An object relationship */
  sourcing_queries?: Maybe<Sourcing_Queries>;
  /** An object relationship */
  spoof_match: Spoof_Matches;
};


/** Attributes matches to the entities that are responsible for their existence */
export type Match_AttributionsMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "match_attributions" */
export type Match_Attributions_Aggregate = {
  __typename?: 'match_attributions_aggregate';
  aggregate?: Maybe<Match_Attributions_Aggregate_Fields>;
  nodes: Array<Match_Attributions>;
};

export type Match_Attributions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Match_Attributions_Aggregate_Bool_Exp_Count>;
};

export type Match_Attributions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Match_Attributions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Match_Attributions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "match_attributions" */
export type Match_Attributions_Aggregate_Fields = {
  __typename?: 'match_attributions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Match_Attributions_Max_Fields>;
  min?: Maybe<Match_Attributions_Min_Fields>;
};


/** aggregate fields of "match_attributions" */
export type Match_Attributions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Match_Attributions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "match_attributions" */
export type Match_Attributions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Match_Attributions_Max_Order_By>;
  min?: InputMaybe<Match_Attributions_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Match_Attributions_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "match_attributions" */
export type Match_Attributions_Arr_Rel_Insert_Input = {
  data: Array<Match_Attributions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Match_Attributions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "match_attributions". All fields are combined with a logical 'AND'. */
export type Match_Attributions_Bool_Exp = {
  _and?: InputMaybe<Array<Match_Attributions_Bool_Exp>>;
  _not?: InputMaybe<Match_Attributions_Bool_Exp>;
  _or?: InputMaybe<Array<Match_Attributions_Bool_Exp>>;
  attribution_id?: InputMaybe<Uuid_Comparison_Exp>;
  attribution_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  detection_assets?: InputMaybe<Detection_Assets_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  match_id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  rules?: InputMaybe<Rules_Bool_Exp>;
  sourcing_queries?: InputMaybe<Sourcing_Queries_Bool_Exp>;
  spoof_match?: InputMaybe<Spoof_Matches_Bool_Exp>;
};

/** unique or primary key constraints on table "match_attributions" */
export enum Match_Attributions_Constraint {
  /** unique or primary key constraint on columns "attribution_id", "match_id" */
  MatchAttributionsMatchIdAttributionIdKey = 'match_attributions_match_id_attribution_id_key',
  /** unique or primary key constraint on columns "id" */
  MatchAttributionsPkey = 'match_attributions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Match_Attributions_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Match_Attributions_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Match_Attributions_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "match_attributions" */
export type Match_Attributions_Insert_Input = {
  attribution_id?: InputMaybe<Scalars['uuid']>;
  attribution_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detection_assets?: InputMaybe<Detection_Assets_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  rules?: InputMaybe<Rules_Obj_Rel_Insert_Input>;
  sourcing_queries?: InputMaybe<Sourcing_Queries_Obj_Rel_Insert_Input>;
  spoof_match?: InputMaybe<Spoof_Matches_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Match_Attributions_Max_Fields = {
  __typename?: 'match_attributions_max_fields';
  attribution_id?: Maybe<Scalars['uuid']>;
  attribution_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "match_attributions" */
export type Match_Attributions_Max_Order_By = {
  attribution_id?: InputMaybe<Order_By>;
  attribution_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Match_Attributions_Min_Fields = {
  __typename?: 'match_attributions_min_fields';
  attribution_id?: Maybe<Scalars['uuid']>;
  attribution_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "match_attributions" */
export type Match_Attributions_Min_Order_By = {
  attribution_id?: InputMaybe<Order_By>;
  attribution_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "match_attributions" */
export type Match_Attributions_Mutation_Response = {
  __typename?: 'match_attributions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Match_Attributions>;
};

/** on_conflict condition type for table "match_attributions" */
export type Match_Attributions_On_Conflict = {
  constraint: Match_Attributions_Constraint;
  update_columns?: Array<Match_Attributions_Update_Column>;
  where?: InputMaybe<Match_Attributions_Bool_Exp>;
};

/** Ordering options when selecting data from "match_attributions". */
export type Match_Attributions_Order_By = {
  attribution_id?: InputMaybe<Order_By>;
  attribution_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  detection_assets?: InputMaybe<Detection_Assets_Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  rules?: InputMaybe<Rules_Order_By>;
  sourcing_queries?: InputMaybe<Sourcing_Queries_Order_By>;
  spoof_match?: InputMaybe<Spoof_Matches_Order_By>;
};

/** primary key columns input for table: match_attributions */
export type Match_Attributions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Match_Attributions_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "match_attributions" */
export enum Match_Attributions_Select_Column {
  /** column name */
  AttributionId = 'attribution_id',
  /** column name */
  AttributionType = 'attribution_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  Metadata = 'metadata'
}

/** input type for updating data in table "match_attributions" */
export type Match_Attributions_Set_Input = {
  attribution_id?: InputMaybe<Scalars['uuid']>;
  attribution_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "match_attributions" */
export type Match_Attributions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Match_Attributions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Match_Attributions_Stream_Cursor_Value_Input = {
  attribution_id?: InputMaybe<Scalars['uuid']>;
  attribution_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "match_attributions" */
export enum Match_Attributions_Update_Column {
  /** column name */
  AttributionId = 'attribution_id',
  /** column name */
  AttributionType = 'attribution_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  Metadata = 'metadata'
}

export type Match_Attributions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Match_Attributions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Match_Attributions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Match_Attributions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Match_Attributions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Match_Attributions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Match_Attributions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Match_Attributions_Bool_Exp;
};

/** Vectorized values that describe attributes of flagged objects or pairwise matches between flagged objects and one of our customer's protected assets. Features are used for our scoring/classification */
export type Ml_Features = {
  __typename?: 'ml_features';
  created_at: Scalars['timestamp'];
  /** An object relationship */
  detection_asset?: Maybe<Detection_Assets>;
  detection_asset_id?: Maybe<Scalars['uuid']>;
  extra_data?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  /** we store model outputs as features in this table even though they technically aren't features. this is because we may experiment with different models and storing in this table allows us to see in one place all the features that contributed to this output */
  is_value_from_model: Scalars['Boolean'];
  match_id: Scalars['uuid'];
  name: Scalars['String'];
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: Maybe<Scalars['numeric']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value: Scalars['String'];
};


/** Vectorized values that describe attributes of flagged objects or pairwise matches between flagged objects and one of our customer's protected assets. Features are used for our scoring/classification */
export type Ml_FeaturesExtra_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "ml_features" */
export type Ml_Features_Aggregate = {
  __typename?: 'ml_features_aggregate';
  aggregate?: Maybe<Ml_Features_Aggregate_Fields>;
  nodes: Array<Ml_Features>;
};

export type Ml_Features_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ml_Features_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ml_Features_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ml_Features_Aggregate_Bool_Exp_Count>;
};

export type Ml_Features_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ml_Features_Select_Column_Ml_Features_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ml_Features_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ml_Features_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ml_Features_Select_Column_Ml_Features_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ml_Features_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ml_Features_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ml_Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ml_Features_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ml_features" */
export type Ml_Features_Aggregate_Fields = {
  __typename?: 'ml_features_aggregate_fields';
  avg?: Maybe<Ml_Features_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ml_Features_Max_Fields>;
  min?: Maybe<Ml_Features_Min_Fields>;
  stddev?: Maybe<Ml_Features_Stddev_Fields>;
  stddev_pop?: Maybe<Ml_Features_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ml_Features_Stddev_Samp_Fields>;
  sum?: Maybe<Ml_Features_Sum_Fields>;
  var_pop?: Maybe<Ml_Features_Var_Pop_Fields>;
  var_samp?: Maybe<Ml_Features_Var_Samp_Fields>;
  variance?: Maybe<Ml_Features_Variance_Fields>;
};


/** aggregate fields of "ml_features" */
export type Ml_Features_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ml_Features_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ml_features" */
export type Ml_Features_Aggregate_Order_By = {
  avg?: InputMaybe<Ml_Features_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ml_Features_Max_Order_By>;
  min?: InputMaybe<Ml_Features_Min_Order_By>;
  stddev?: InputMaybe<Ml_Features_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ml_Features_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ml_Features_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ml_Features_Sum_Order_By>;
  var_pop?: InputMaybe<Ml_Features_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ml_Features_Var_Samp_Order_By>;
  variance?: InputMaybe<Ml_Features_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ml_Features_Append_Input = {
  extra_data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "ml_features" */
export type Ml_Features_Arr_Rel_Insert_Input = {
  data: Array<Ml_Features_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ml_Features_On_Conflict>;
};

/** aggregate avg on columns */
export type Ml_Features_Avg_Fields = {
  __typename?: 'ml_features_avg_fields';
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: Maybe<Scalars['Float']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ml_features" */
export type Ml_Features_Avg_Order_By = {
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Order_By>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ml_features". All fields are combined with a logical 'AND'. */
export type Ml_Features_Bool_Exp = {
  _and?: InputMaybe<Array<Ml_Features_Bool_Exp>>;
  _not?: InputMaybe<Ml_Features_Bool_Exp>;
  _or?: InputMaybe<Array<Ml_Features_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  detection_asset?: InputMaybe<Detection_Assets_Bool_Exp>;
  detection_asset_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra_data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_value_from_model?: InputMaybe<Boolean_Comparison_Exp>;
  match_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  normalized_value?: InputMaybe<Numeric_Comparison_Exp>;
  threshold?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ml_features" */
export enum Ml_Features_Constraint {
  /** unique or primary key constraint on columns "name", "match_id" */
  FeaturesNameMatchIdKey = 'features_name_match_id_key',
  /** unique or primary key constraint on columns "id" */
  FeaturesPkey = 'features_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ml_Features_Delete_At_Path_Input = {
  extra_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ml_Features_Delete_Elem_Input = {
  extra_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ml_Features_Delete_Key_Input = {
  extra_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "ml_features" */
export type Ml_Features_Inc_Input = {
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Scalars['numeric']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "ml_features" */
export type Ml_Features_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  detection_asset?: InputMaybe<Detection_Assets_Obj_Rel_Insert_Input>;
  detection_asset_id?: InputMaybe<Scalars['uuid']>;
  extra_data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** we store model outputs as features in this table even though they technically aren't features. this is because we may experiment with different models and storing in this table allows us to see in one place all the features that contributed to this output */
  is_value_from_model?: InputMaybe<Scalars['Boolean']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Scalars['numeric']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ml_Features_Max_Fields = {
  __typename?: 'ml_features_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  detection_asset_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: Maybe<Scalars['numeric']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ml_features" */
export type Ml_Features_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  detection_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Order_By>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ml_Features_Min_Fields = {
  __typename?: 'ml_features_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  detection_asset_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: Maybe<Scalars['numeric']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ml_features" */
export type Ml_Features_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  detection_asset_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Order_By>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ml_features" */
export type Ml_Features_Mutation_Response = {
  __typename?: 'ml_features_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ml_Features>;
};

/** on_conflict condition type for table "ml_features" */
export type Ml_Features_On_Conflict = {
  constraint: Ml_Features_Constraint;
  update_columns?: Array<Ml_Features_Update_Column>;
  where?: InputMaybe<Ml_Features_Bool_Exp>;
};

/** Ordering options when selecting data from "ml_features". */
export type Ml_Features_Order_By = {
  created_at?: InputMaybe<Order_By>;
  detection_asset?: InputMaybe<Detection_Assets_Order_By>;
  detection_asset_id?: InputMaybe<Order_By>;
  extra_data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_value_from_model?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  normalized_value?: InputMaybe<Order_By>;
  threshold?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ml_features */
export type Ml_Features_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ml_Features_Prepend_Input = {
  extra_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "ml_features" */
export enum Ml_Features_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionAssetId = 'detection_asset_id',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  Id = 'id',
  /** column name */
  IsValueFromModel = 'is_value_from_model',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  Name = 'name',
  /** column name */
  NormalizedValue = 'normalized_value',
  /** column name */
  Threshold = 'threshold',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** select "ml_features_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ml_features" */
export enum Ml_Features_Select_Column_Ml_Features_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsValueFromModel = 'is_value_from_model'
}

/** select "ml_features_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ml_features" */
export enum Ml_Features_Select_Column_Ml_Features_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsValueFromModel = 'is_value_from_model'
}

/** input type for updating data in table "ml_features" */
export type Ml_Features_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  detection_asset_id?: InputMaybe<Scalars['uuid']>;
  extra_data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** we store model outputs as features in this table even though they technically aren't features. this is because we may experiment with different models and storing in this table allows us to see in one place all the features that contributed to this output */
  is_value_from_model?: InputMaybe<Scalars['Boolean']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Scalars['numeric']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Ml_Features_Stddev_Fields = {
  __typename?: 'ml_features_stddev_fields';
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: Maybe<Scalars['Float']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ml_features" */
export type Ml_Features_Stddev_Order_By = {
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Order_By>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ml_Features_Stddev_Pop_Fields = {
  __typename?: 'ml_features_stddev_pop_fields';
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: Maybe<Scalars['Float']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ml_features" */
export type Ml_Features_Stddev_Pop_Order_By = {
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Order_By>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ml_Features_Stddev_Samp_Fields = {
  __typename?: 'ml_features_stddev_samp_fields';
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: Maybe<Scalars['Float']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ml_features" */
export type Ml_Features_Stddev_Samp_Order_By = {
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Order_By>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ml_features" */
export type Ml_Features_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ml_Features_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ml_Features_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  detection_asset_id?: InputMaybe<Scalars['uuid']>;
  extra_data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** we store model outputs as features in this table even though they technically aren't features. this is because we may experiment with different models and storing in this table allows us to see in one place all the features that contributed to this output */
  is_value_from_model?: InputMaybe<Scalars['Boolean']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Scalars['numeric']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Ml_Features_Sum_Fields = {
  __typename?: 'ml_features_sum_fields';
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: Maybe<Scalars['numeric']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "ml_features" */
export type Ml_Features_Sum_Order_By = {
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Order_By>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Order_By>;
};

/** update columns of table "ml_features" */
export enum Ml_Features_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetectionAssetId = 'detection_asset_id',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  Id = 'id',
  /** column name */
  IsValueFromModel = 'is_value_from_model',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  Name = 'name',
  /** column name */
  NormalizedValue = 'normalized_value',
  /** column name */
  Threshold = 'threshold',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Ml_Features_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ml_Features_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ml_Features_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ml_Features_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ml_Features_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ml_Features_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ml_Features_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ml_Features_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ml_Features_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ml_Features_Var_Pop_Fields = {
  __typename?: 'ml_features_var_pop_fields';
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: Maybe<Scalars['Float']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ml_features" */
export type Ml_Features_Var_Pop_Order_By = {
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Order_By>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ml_Features_Var_Samp_Fields = {
  __typename?: 'ml_features_var_samp_fields';
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: Maybe<Scalars['Float']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ml_features" */
export type Ml_Features_Var_Samp_Order_By = {
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Order_By>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ml_Features_Variance_Fields = {
  __typename?: 'ml_features_variance_fields';
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: Maybe<Scalars['Float']>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ml_features" */
export type Ml_Features_Variance_Order_By = {
  /** consumers can look at this field and decide which feature resulted in the "best" score. basically value/threshold */
  normalized_value?: InputMaybe<Order_By>;
  /** the threshold we used to determine if the feature is "qualified" aka value >= threshold */
  threshold?: InputMaybe<Order_By>;
};

/** columns and relationships of "mobile_apps" */
export type Mobile_Apps = {
  __typename?: 'mobile_apps';
  app_id?: Maybe<Scalars['String']>;
  bundle_id?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamp'];
  description?: Maybe<Scalars['String']>;
  developer_id?: Maybe<Scalars['String']>;
  developer_name?: Maybe<Scalars['String']>;
  external_created_at?: Maybe<Scalars['timestamp']>;
  id: Scalars['uuid'];
  link: Scalars['String'];
  platform_name: Scalars['String'];
  /** An object relationship */
  platform_subtype?: Maybe<Platform_Subtypes>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  screenshot_url?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  thumbnail_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamp'];
};

/** aggregated selection of "mobile_apps" */
export type Mobile_Apps_Aggregate = {
  __typename?: 'mobile_apps_aggregate';
  aggregate?: Maybe<Mobile_Apps_Aggregate_Fields>;
  nodes: Array<Mobile_Apps>;
};

/** aggregate fields of "mobile_apps" */
export type Mobile_Apps_Aggregate_Fields = {
  __typename?: 'mobile_apps_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Mobile_Apps_Max_Fields>;
  min?: Maybe<Mobile_Apps_Min_Fields>;
};


/** aggregate fields of "mobile_apps" */
export type Mobile_Apps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mobile_Apps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "mobile_apps". All fields are combined with a logical 'AND'. */
export type Mobile_Apps_Bool_Exp = {
  _and?: InputMaybe<Array<Mobile_Apps_Bool_Exp>>;
  _not?: InputMaybe<Mobile_Apps_Bool_Exp>;
  _or?: InputMaybe<Array<Mobile_Apps_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  bundle_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  developer_id?: InputMaybe<String_Comparison_Exp>;
  developer_name?: InputMaybe<String_Comparison_Exp>;
  external_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  platform_name?: InputMaybe<String_Comparison_Exp>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Bool_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  screenshot_url?: InputMaybe<String_Comparison_Exp>;
  source_query?: InputMaybe<String_Comparison_Exp>;
  thumbnail_url?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "mobile_apps" */
export enum Mobile_Apps_Constraint {
  /** unique or primary key constraint on columns "link" */
  MobileAppsLinkKey = 'mobile_apps_link_key',
  /** unique or primary key constraint on columns "id" */
  MobileAppsPkey = 'mobile_apps_pkey'
}

/** input type for inserting data into table "mobile_apps" */
export type Mobile_Apps_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  developer_id?: InputMaybe<Scalars['String']>;
  developer_name?: InputMaybe<Scalars['String']>;
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  link?: InputMaybe<Scalars['String']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Obj_Rel_Insert_Input>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  thumbnail_url?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Mobile_Apps_Max_Fields = {
  __typename?: 'mobile_apps_max_fields';
  app_id?: Maybe<Scalars['String']>;
  bundle_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  developer_id?: Maybe<Scalars['String']>;
  developer_name?: Maybe<Scalars['String']>;
  external_created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  screenshot_url?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  thumbnail_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Mobile_Apps_Min_Fields = {
  __typename?: 'mobile_apps_min_fields';
  app_id?: Maybe<Scalars['String']>;
  bundle_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  developer_id?: Maybe<Scalars['String']>;
  developer_name?: Maybe<Scalars['String']>;
  external_created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  link?: Maybe<Scalars['String']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  screenshot_url?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  thumbnail_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "mobile_apps" */
export type Mobile_Apps_Mutation_Response = {
  __typename?: 'mobile_apps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Mobile_Apps>;
};

/** input type for inserting object relation for remote table "mobile_apps" */
export type Mobile_Apps_Obj_Rel_Insert_Input = {
  data: Mobile_Apps_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mobile_Apps_On_Conflict>;
};

/** on_conflict condition type for table "mobile_apps" */
export type Mobile_Apps_On_Conflict = {
  constraint: Mobile_Apps_Constraint;
  update_columns?: Array<Mobile_Apps_Update_Column>;
  where?: InputMaybe<Mobile_Apps_Bool_Exp>;
};

/** Ordering options when selecting data from "mobile_apps". */
export type Mobile_Apps_Order_By = {
  app_id?: InputMaybe<Order_By>;
  bundle_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  developer_id?: InputMaybe<Order_By>;
  developer_name?: InputMaybe<Order_By>;
  external_created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  source_query?: InputMaybe<Order_By>;
  thumbnail_url?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mobile_apps */
export type Mobile_Apps_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "mobile_apps" */
export enum Mobile_Apps_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  BundleId = 'bundle_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DeveloperId = 'developer_id',
  /** column name */
  DeveloperName = 'developer_name',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mobile_apps" */
export type Mobile_Apps_Set_Input = {
  app_id?: InputMaybe<Scalars['String']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  developer_id?: InputMaybe<Scalars['String']>;
  developer_name?: InputMaybe<Scalars['String']>;
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  link?: InputMaybe<Scalars['String']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  thumbnail_url?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "mobile_apps" */
export type Mobile_Apps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mobile_Apps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mobile_Apps_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']>;
  bundle_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  developer_id?: InputMaybe<Scalars['String']>;
  developer_name?: InputMaybe<Scalars['String']>;
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  link?: InputMaybe<Scalars['String']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  thumbnail_url?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "mobile_apps" */
export enum Mobile_Apps_Update_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  BundleId = 'bundle_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DeveloperId = 'developer_id',
  /** column name */
  DeveloperName = 'developer_name',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Mobile_Apps_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mobile_Apps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mobile_Apps_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** action_on_email */
  action_on_email?: Maybe<ActionOnEmailOutput>;
  /** archive_entity_link */
  archive_entity_link?: Maybe<ArchiveEntityLinksOutput>;
  create_entity_link?: Maybe<CreateEntityLinksOutput>;
  /** Use the API of Optery to create a new Member */
  create_pii_member?: Maybe<PiiCreateMemberOutput>;
  /** create_sim_campaign */
  create_sim_campaign?: Maybe<CreateSimCampaignOutput>;
  create_user?: Maybe<CreateUserOutput>;
  /** V2 for creating users */
  create_user_v2?: Maybe<CreateUserOutput>;
  /** delete data from the table: "advertisement_data" */
  delete_advertisement_data?: Maybe<Advertisement_Data_Mutation_Response>;
  /** delete single row from the table: "advertisement_data" */
  delete_advertisement_data_by_pk?: Maybe<Advertisement_Data>;
  /** delete data from the table: "advertiser_data" */
  delete_advertiser_data?: Maybe<Advertiser_Data_Mutation_Response>;
  /** delete single row from the table: "advertiser_data" */
  delete_advertiser_data_by_pk?: Maybe<Advertiser_Data>;
  /** delete data from the table: "ai_prompts" */
  delete_ai_prompts?: Maybe<Ai_Prompts_Mutation_Response>;
  /** delete single row from the table: "ai_prompts" */
  delete_ai_prompts_by_pk?: Maybe<Ai_Prompts>;
  /** delete data from the table: "ai_responses" */
  delete_ai_responses?: Maybe<Ai_Responses_Mutation_Response>;
  /** delete single row from the table: "ai_responses" */
  delete_ai_responses_by_pk?: Maybe<Ai_Responses>;
  /** delete_alert */
  delete_alert?: Maybe<DeleteAlertOutput>;
  /** delete data from the table: "alert_hashes" */
  delete_alert_hashes?: Maybe<Alert_Hashes_Mutation_Response>;
  /** delete single row from the table: "alert_hashes" */
  delete_alert_hashes_by_pk?: Maybe<Alert_Hashes>;
  /** delete data from the table: "alert_label_events" */
  delete_alert_label_events?: Maybe<Alert_Label_Events_Mutation_Response>;
  /** delete single row from the table: "alert_label_events" */
  delete_alert_label_events_by_pk?: Maybe<Alert_Label_Events>;
  /** delete data from the table: "alert_links" */
  delete_alert_links?: Maybe<Alert_Links_Mutation_Response>;
  /** delete single row from the table: "alert_links" */
  delete_alert_links_by_pk?: Maybe<Alert_Links>;
  /** delete data from the table: "api_tokens" */
  delete_api_tokens?: Maybe<Api_Tokens_Mutation_Response>;
  /** delete single row from the table: "api_tokens" */
  delete_api_tokens_by_pk?: Maybe<Api_Tokens>;
  /** delete data from the table: "api_usage_records" */
  delete_api_usage_records?: Maybe<Api_Usage_Records_Mutation_Response>;
  /** delete single row from the table: "api_usage_records" */
  delete_api_usage_records_by_pk?: Maybe<Api_Usage_Records>;
  /** delete data from the table: "apify_scraping_jobs" */
  delete_apify_scraping_jobs?: Maybe<Apify_Scraping_Jobs_Mutation_Response>;
  /** delete single row from the table: "apify_scraping_jobs" */
  delete_apify_scraping_jobs_by_pk?: Maybe<Apify_Scraping_Jobs>;
  /** delete data from the table: "approvals" */
  delete_approvals?: Maybe<Approvals_Mutation_Response>;
  /** delete single row from the table: "approvals" */
  delete_approvals_by_pk?: Maybe<Approvals>;
  /** delete data from the table: "audit.logged_actions" */
  delete_audit_logged_actions?: Maybe<Audit_Logged_Actions_Mutation_Response>;
  /** delete single row from the table: "audit.logged_actions" */
  delete_audit_logged_actions_by_pk?: Maybe<Audit_Logged_Actions>;
  /** delete data from the table: "collection_report_changes" */
  delete_collection_report_changes?: Maybe<Collection_Report_Changes_Mutation_Response>;
  /** delete single row from the table: "collection_report_changes" */
  delete_collection_report_changes_by_pk?: Maybe<Collection_Report_Changes>;
  /** delete data from the table: "collection_report_state_changes" */
  delete_collection_report_state_changes?: Maybe<Collection_Report_State_Changes_Mutation_Response>;
  /** delete single row from the table: "collection_report_state_changes" */
  delete_collection_report_state_changes_by_pk?: Maybe<Collection_Report_State_Changes>;
  /** delete data from the table: "credit_cards" */
  delete_credit_cards?: Maybe<Credit_Cards_Mutation_Response>;
  /** delete single row from the table: "credit_cards" */
  delete_credit_cards_by_pk?: Maybe<Credit_Cards>;
  /** delete data from the table: "customer_assets" */
  delete_customer_assets?: Maybe<Customer_Assets_Mutation_Response>;
  /** delete single row from the table: "customer_assets" */
  delete_customer_assets_by_pk?: Maybe<Customer_Assets>;
  /** delete data from the table: "customer_assets_to_brands" */
  delete_customer_assets_to_brands?: Maybe<Customer_Assets_To_Brands_Mutation_Response>;
  /** delete single row from the table: "customer_assets_to_brands" */
  delete_customer_assets_to_brands_by_pk?: Maybe<Customer_Assets_To_Brands>;
  /** delete data from the table: "dark_web" */
  delete_dark_web?: Maybe<Dark_Web_Mutation_Response>;
  /** delete single row from the table: "dark_web" */
  delete_dark_web_by_pk?: Maybe<Dark_Web>;
  /** delete data from the table: "defensive_domain_registration" */
  delete_defensive_domain_registration?: Maybe<Defensive_Domain_Registration_Mutation_Response>;
  /** delete single row from the table: "defensive_domain_registration" */
  delete_defensive_domain_registration_by_pk?: Maybe<Defensive_Domain_Registration>;
  /** delete data from the table: "designated_takedown_assets" */
  delete_designated_takedown_assets?: Maybe<Designated_Takedown_Assets_Mutation_Response>;
  /** delete single row from the table: "designated_takedown_assets" */
  delete_designated_takedown_assets_by_pk?: Maybe<Designated_Takedown_Assets>;
  /** delete data from the table: "detection_assets" */
  delete_detection_assets?: Maybe<Detection_Assets_Mutation_Response>;
  /** delete single row from the table: "detection_assets" */
  delete_detection_assets_by_pk?: Maybe<Detection_Assets>;
  /** delete data from the table: "detection_config_approvals" */
  delete_detection_config_approvals?: Maybe<Detection_Config_Approvals_Mutation_Response>;
  /** delete single row from the table: "detection_config_approvals" */
  delete_detection_config_approvals_by_pk?: Maybe<Detection_Config_Approvals>;
  /** delete data from the table: "domain_data" */
  delete_domain_data?: Maybe<Domain_Data_Mutation_Response>;
  /** delete single row from the table: "domain_data" */
  delete_domain_data_by_pk?: Maybe<Domain_Data>;
  /** delete data from the table: "domain_match_data" */
  delete_domain_match_data?: Maybe<Domain_Match_Data_Mutation_Response>;
  /** delete single row from the table: "domain_match_data" */
  delete_domain_match_data_by_pk?: Maybe<Domain_Match_Data>;
  /** delete data from the table: "ecommerce_listings" */
  delete_ecommerce_listings?: Maybe<Ecommerce_Listings_Mutation_Response>;
  /** delete single row from the table: "ecommerce_listings" */
  delete_ecommerce_listings_by_pk?: Maybe<Ecommerce_Listings>;
  /** delete data from the table: "email_addresses" */
  delete_email_addresses?: Maybe<Email_Addresses_Mutation_Response>;
  /** delete single row from the table: "email_addresses" */
  delete_email_addresses_by_pk?: Maybe<Email_Addresses>;
  /** delete data from the table: "email_correspondence" */
  delete_email_correspondence?: Maybe<Email_Correspondence_Mutation_Response>;
  /** delete single row from the table: "email_correspondence" */
  delete_email_correspondence_by_pk?: Maybe<Email_Correspondence>;
  /** delete data from the table: "email_settings" */
  delete_email_settings?: Maybe<Email_Settings_Mutation_Response>;
  /** delete single row from the table: "email_settings" */
  delete_email_settings_by_pk?: Maybe<Email_Settings>;
  /** delete data from the table: "emails" */
  delete_emails?: Maybe<Emails_Mutation_Response>;
  /** delete single row from the table: "emails" */
  delete_emails_by_pk?: Maybe<Emails>;
  /** delete data from the table: "enforcement_emails" */
  delete_enforcement_emails?: Maybe<Enforcement_Emails_Mutation_Response>;
  /** delete single row from the table: "enforcement_emails" */
  delete_enforcement_emails_by_pk?: Maybe<Enforcement_Emails>;
  /** delete data from the table: "enforcement_metadata" */
  delete_enforcement_metadata?: Maybe<Enforcement_Metadata_Mutation_Response>;
  /** delete single row from the table: "enforcement_metadata" */
  delete_enforcement_metadata_by_pk?: Maybe<Enforcement_Metadata>;
  /** delete data from the table: "enforcement_platforms" */
  delete_enforcement_platforms?: Maybe<Enforcement_Platforms_Mutation_Response>;
  /** delete single row from the table: "enforcement_platforms" */
  delete_enforcement_platforms_by_pk?: Maybe<Enforcement_Platforms>;
  /** delete data from the table: "enforcement_requests" */
  delete_enforcement_requests?: Maybe<Enforcement_Requests_Mutation_Response>;
  /** delete single row from the table: "enforcement_requests" */
  delete_enforcement_requests_by_pk?: Maybe<Enforcement_Requests>;
  /** delete data from the table: "enforcement_templates" */
  delete_enforcement_templates?: Maybe<Enforcement_Templates_Mutation_Response>;
  /** delete single row from the table: "enforcement_templates" */
  delete_enforcement_templates_by_pk?: Maybe<Enforcement_Templates>;
  /** delete data from the table: "enforcement_types" */
  delete_enforcement_types?: Maybe<Enforcement_Types_Mutation_Response>;
  /** delete single row from the table: "enforcement_types" */
  delete_enforcement_types_by_pk?: Maybe<Enforcement_Types>;
  /** delete data from the table: "entity_aggregates" */
  delete_entity_aggregates?: Maybe<Entity_Aggregates_Mutation_Response>;
  /** delete single row from the table: "entity_aggregates" */
  delete_entity_aggregates_by_pk?: Maybe<Entity_Aggregates>;
  /** delete data from the table: "entity_data" */
  delete_entity_data?: Maybe<Entity_Data_Mutation_Response>;
  /** delete single row from the table: "entity_data" */
  delete_entity_data_by_pk?: Maybe<Entity_Data>;
  /** delete data from the table: "entity_links" */
  delete_entity_links?: Maybe<Entity_Links_Mutation_Response>;
  /** delete single row from the table: "entity_links" */
  delete_entity_links_by_pk?: Maybe<Entity_Links>;
  /** delete data from the table: "entity_state_classifications" */
  delete_entity_state_classifications?: Maybe<Entity_State_Classifications_Mutation_Response>;
  /** delete single row from the table: "entity_state_classifications" */
  delete_entity_state_classifications_by_pk?: Maybe<Entity_State_Classifications>;
  /** delete data from the table: "full_urls" */
  delete_full_urls?: Maybe<Full_Urls_Mutation_Response>;
  /** delete single row from the table: "full_urls" */
  delete_full_urls_by_pk?: Maybe<Full_Urls>;
  /** delete data from the table: "hourly_spoofing_reports_stats" */
  delete_hourly_spoofing_reports_stats?: Maybe<Hourly_Spoofing_Reports_Stats_Mutation_Response>;
  /** delete single row from the table: "hourly_spoofing_reports_stats" */
  delete_hourly_spoofing_reports_stats_by_pk?: Maybe<Hourly_Spoofing_Reports_Stats>;
  /** delete data from the table: "ioc_alert_attribution" */
  delete_ioc_alert_attribution?: Maybe<Ioc_Alert_Attribution_Mutation_Response>;
  /** delete single row from the table: "ioc_alert_attribution" */
  delete_ioc_alert_attribution_by_pk?: Maybe<Ioc_Alert_Attribution>;
  /** delete data from the table: "ioc_detection_config_attribution" */
  delete_ioc_detection_config_attribution?: Maybe<Ioc_Detection_Config_Attribution_Mutation_Response>;
  /** delete single row from the table: "ioc_detection_config_attribution" */
  delete_ioc_detection_config_attribution_by_pk?: Maybe<Ioc_Detection_Config_Attribution>;
  /** delete data from the table: "ioc_entity_data_attribution" */
  delete_ioc_entity_data_attribution?: Maybe<Ioc_Entity_Data_Attribution_Mutation_Response>;
  /** delete single row from the table: "ioc_entity_data_attribution" */
  delete_ioc_entity_data_attribution_by_pk?: Maybe<Ioc_Entity_Data_Attribution>;
  /** delete data from the table: "iocs" */
  delete_iocs?: Maybe<Iocs_Mutation_Response>;
  /** delete single row from the table: "iocs" */
  delete_iocs_by_pk?: Maybe<Iocs>;
  /** delete data from the table: "jira_metadata" */
  delete_jira_metadata?: Maybe<Jira_Metadata_Mutation_Response>;
  /** delete single row from the table: "jira_metadata" */
  delete_jira_metadata_by_pk?: Maybe<Jira_Metadata>;
  /** delete data from the table: "match_attributions" */
  delete_match_attributions?: Maybe<Match_Attributions_Mutation_Response>;
  /** delete single row from the table: "match_attributions" */
  delete_match_attributions_by_pk?: Maybe<Match_Attributions>;
  /** delete data from the table: "ml_features" */
  delete_ml_features?: Maybe<Ml_Features_Mutation_Response>;
  /** delete single row from the table: "ml_features" */
  delete_ml_features_by_pk?: Maybe<Ml_Features>;
  /** delete data from the table: "mobile_apps" */
  delete_mobile_apps?: Maybe<Mobile_Apps_Mutation_Response>;
  /** delete single row from the table: "mobile_apps" */
  delete_mobile_apps_by_pk?: Maybe<Mobile_Apps>;
  /** delete data from the table: "nft_opensea_processed" */
  delete_nft_opensea_processed?: Maybe<Nft_Opensea_Processed_Mutation_Response>;
  /** delete single row from the table: "nft_opensea_processed" */
  delete_nft_opensea_processed_by_pk?: Maybe<Nft_Opensea_Processed>;
  /** delete data from the table: "nft_processing_cursor" */
  delete_nft_processing_cursor?: Maybe<Nft_Processing_Cursor_Mutation_Response>;
  /** delete single row from the table: "nft_processing_cursor" */
  delete_nft_processing_cursor_by_pk?: Maybe<Nft_Processing_Cursor>;
  /** delete data from the table: "notification_subscriptions" */
  delete_notification_subscriptions?: Maybe<Notification_Subscriptions_Mutation_Response>;
  /** delete single row from the table: "notification_subscriptions" */
  delete_notification_subscriptions_by_pk?: Maybe<Notification_Subscriptions>;
  /** delete data from the table: "organization_id_api_keys" */
  delete_organization_id_api_keys?: Maybe<Organization_Id_Api_Keys_Mutation_Response>;
  /** delete single row from the table: "organization_id_api_keys" */
  delete_organization_id_api_keys_by_pk?: Maybe<Organization_Id_Api_Keys>;
  /** delete data from the table: "organization_products" */
  delete_organization_products?: Maybe<Organization_Products_Mutation_Response>;
  /** delete single row from the table: "organization_products" */
  delete_organization_products_by_pk?: Maybe<Organization_Products>;
  /** delete data from the table: "organizations" */
  delete_organizations?: Maybe<Organizations_Mutation_Response>;
  /** delete single row from the table: "organizations" */
  delete_organizations_by_pk?: Maybe<Organizations>;
  /** delete data from the table: "organizations_metadata" */
  delete_organizations_metadata?: Maybe<Organizations_Metadata_Mutation_Response>;
  /** delete single row from the table: "organizations_metadata" */
  delete_organizations_metadata_by_pk?: Maybe<Organizations_Metadata>;
  /** delete data from the table: "permissions" */
  delete_permissions?: Maybe<Permissions_Mutation_Response>;
  /** delete single row from the table: "permissions" */
  delete_permissions_by_pk?: Maybe<Permissions>;
  /** delete data from the table: "phone_numbers" */
  delete_phone_numbers?: Maybe<Phone_Numbers_Mutation_Response>;
  /** delete single row from the table: "phone_numbers" */
  delete_phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** delete data from the table: "pii_databrokers" */
  delete_pii_databrokers?: Maybe<Pii_Databrokers_Mutation_Response>;
  /** delete single row from the table: "pii_databrokers" */
  delete_pii_databrokers_by_pk?: Maybe<Pii_Databrokers>;
  /** delete data from the table: "pii_events" */
  delete_pii_events?: Maybe<Pii_Events_Mutation_Response>;
  /** delete single row from the table: "pii_events" */
  delete_pii_events_by_pk?: Maybe<Pii_Events>;
  /** Use the API of Optery to delete a Member, also, delete related data in Hasura */
  delete_pii_member?: Maybe<PiiDeleteMemberOutput>;
  /** delete data from the table: "pii_reports" */
  delete_pii_reports?: Maybe<Pii_Reports_Mutation_Response>;
  /** delete single row from the table: "pii_reports" */
  delete_pii_reports_by_pk?: Maybe<Pii_Reports>;
  /** delete data from the table: "pii_statistics" */
  delete_pii_statistics?: Maybe<Pii_Statistics_Mutation_Response>;
  /** delete single row from the table: "pii_statistics" */
  delete_pii_statistics_by_pk?: Maybe<Pii_Statistics>;
  /** delete data from the table: "platform_subtypes" */
  delete_platform_subtypes?: Maybe<Platform_Subtypes_Mutation_Response>;
  /** delete single row from the table: "platform_subtypes" */
  delete_platform_subtypes_by_pk?: Maybe<Platform_Subtypes>;
  /** delete data from the table: "platforms" */
  delete_platforms?: Maybe<Platforms_Mutation_Response>;
  /** delete single row from the table: "platforms" */
  delete_platforms_by_pk?: Maybe<Platforms>;
  /** delete data from the table: "pre_collections" */
  delete_pre_collections?: Maybe<Pre_Collections_Mutation_Response>;
  /** delete single row from the table: "pre_collections" */
  delete_pre_collections_by_pk?: Maybe<Pre_Collections>;
  /** delete data from the table: "predicted_enforcement_types" */
  delete_predicted_enforcement_types?: Maybe<Predicted_Enforcement_Types_Mutation_Response>;
  /** delete single row from the table: "predicted_enforcement_types" */
  delete_predicted_enforcement_types_by_pk?: Maybe<Predicted_Enforcement_Types>;
  /** delete data from the table: "protected_assets" */
  delete_protected_assets?: Maybe<Protected_Assets_Mutation_Response>;
  /** delete single row from the table: "protected_assets" */
  delete_protected_assets_by_pk?: Maybe<Protected_Assets>;
  /** delete_report_file */
  delete_report_file?: Maybe<DeleteReportFileOutput>;
  /** delete data from the table: "report_tags" */
  delete_report_tags?: Maybe<Report_Tags_Mutation_Response>;
  /** delete single row from the table: "report_tags" */
  delete_report_tags_by_pk?: Maybe<Report_Tags>;
  /** delete data from the table: "reports_to_reports" */
  delete_reports_to_reports?: Maybe<Reports_To_Reports_Mutation_Response>;
  /** delete single row from the table: "reports_to_reports" */
  delete_reports_to_reports_by_pk?: Maybe<Reports_To_Reports>;
  /** delete data from the table: "role_permissions" */
  delete_role_permissions?: Maybe<Role_Permissions_Mutation_Response>;
  /** delete single row from the table: "role_permissions" */
  delete_role_permissions_by_pk?: Maybe<Role_Permissions>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "rules" */
  delete_rules?: Maybe<Rules_Mutation_Response>;
  /** delete single row from the table: "rules" */
  delete_rules_by_pk?: Maybe<Rules>;
  /** delete data from the table: "safelist_ip_addresses" */
  delete_safelist_ip_addresses?: Maybe<Safelist_Ip_Addresses_Mutation_Response>;
  /** delete single row from the table: "safelist_ip_addresses" */
  delete_safelist_ip_addresses_by_pk?: Maybe<Safelist_Ip_Addresses>;
  /** delete data from the table: "salesforce_organizations_data" */
  delete_salesforce_organizations_data?: Maybe<Salesforce_Organizations_Data_Mutation_Response>;
  /** delete single row from the table: "salesforce_organizations_data" */
  delete_salesforce_organizations_data_by_pk?: Maybe<Salesforce_Organizations_Data>;
  /** delete data from the table: "scan_results" */
  delete_scan_results?: Maybe<Scan_Results_Mutation_Response>;
  /** delete single row from the table: "scan_results" */
  delete_scan_results_by_pk?: Maybe<Scan_Results>;
  /** delete data from the table: "scans" */
  delete_scans?: Maybe<Scans_Mutation_Response>;
  /** delete single row from the table: "scans" */
  delete_scans_by_pk?: Maybe<Scans>;
  /** delete data from the table: "scraping_configs" */
  delete_scraping_configs?: Maybe<Scraping_Configs_Mutation_Response>;
  /** delete single row from the table: "scraping_configs" */
  delete_scraping_configs_by_pk?: Maybe<Scraping_Configs>;
  /** delete data from the table: "sim_campaign_observations" */
  delete_sim_campaign_observations?: Maybe<Sim_Campaign_Observations_Mutation_Response>;
  /** delete single row from the table: "sim_campaign_observations" */
  delete_sim_campaign_observations_by_pk?: Maybe<Sim_Campaign_Observations>;
  /** delete data from the table: "sim_campaigns" */
  delete_sim_campaigns?: Maybe<Sim_Campaigns_Mutation_Response>;
  /** delete single row from the table: "sim_campaigns" */
  delete_sim_campaigns_by_pk?: Maybe<Sim_Campaigns>;
  /** delete data from the table: "sim_emails" */
  delete_sim_emails?: Maybe<Sim_Emails_Mutation_Response>;
  /** delete single row from the table: "sim_emails" */
  delete_sim_emails_by_pk?: Maybe<Sim_Emails>;
  /** delete data from the table: "sim_groups" */
  delete_sim_groups?: Maybe<Sim_Groups_Mutation_Response>;
  /** delete single row from the table: "sim_groups" */
  delete_sim_groups_by_pk?: Maybe<Sim_Groups>;
  /** delete data from the table: "sim_users" */
  delete_sim_users?: Maybe<Sim_Users_Mutation_Response>;
  /** delete single row from the table: "sim_users" */
  delete_sim_users_by_pk?: Maybe<Sim_Users>;
  /** delete data from the table: "slack_installations" */
  delete_slack_installations?: Maybe<Slack_Installations_Mutation_Response>;
  /** delete single row from the table: "slack_installations" */
  delete_slack_installations_by_pk?: Maybe<Slack_Installations>;
  /** delete data from the table: "social_media_comments" */
  delete_social_media_comments?: Maybe<Social_Media_Comments_Mutation_Response>;
  /** delete single row from the table: "social_media_comments" */
  delete_social_media_comments_by_pk?: Maybe<Social_Media_Comments>;
  /** delete data from the table: "social_media_data" */
  delete_social_media_data?: Maybe<Social_Media_Data_Mutation_Response>;
  /** delete single row from the table: "social_media_data" */
  delete_social_media_data_by_pk?: Maybe<Social_Media_Data>;
  /** delete data from the table: "social_media_group" */
  delete_social_media_group?: Maybe<Social_Media_Group_Mutation_Response>;
  /** delete single row from the table: "social_media_group" */
  delete_social_media_group_by_pk?: Maybe<Social_Media_Group>;
  /** delete data from the table: "social_media_post" */
  delete_social_media_post?: Maybe<Social_Media_Post_Mutation_Response>;
  /** delete single row from the table: "social_media_post" */
  delete_social_media_post_by_pk?: Maybe<Social_Media_Post>;
  /** delete data from the table: "sourcing_queries" */
  delete_sourcing_queries?: Maybe<Sourcing_Queries_Mutation_Response>;
  /** delete single row from the table: "sourcing_queries" */
  delete_sourcing_queries_by_pk?: Maybe<Sourcing_Queries>;
  /** delete data from the table: "sourcing_query_executions" */
  delete_sourcing_query_executions?: Maybe<Sourcing_Query_Executions_Mutation_Response>;
  /** delete single row from the table: "sourcing_query_executions" */
  delete_sourcing_query_executions_by_pk?: Maybe<Sourcing_Query_Executions>;
  /** delete data from the table: "spoof_matches" */
  delete_spoof_matches?: Maybe<Spoof_Matches_Mutation_Response>;
  /** delete single row from the table: "spoof_matches" */
  delete_spoof_matches_by_pk?: Maybe<Spoof_Matches>;
  /** delete data from the table: "spoofing_entities" */
  delete_spoofing_entities?: Maybe<Spoofing_Entities_Mutation_Response>;
  /** delete single row from the table: "spoofing_entities" */
  delete_spoofing_entities_by_pk?: Maybe<Spoofing_Entities>;
  /** delete data from the table: "spoofing_report_search_results" */
  delete_spoofing_report_search_results?: Maybe<Spoofing_Report_Search_Results_Mutation_Response>;
  /** delete data from the table: "spoofing_reports" */
  delete_spoofing_reports?: Maybe<Spoofing_Reports_Mutation_Response>;
  /** delete single row from the table: "spoofing_reports" */
  delete_spoofing_reports_by_pk?: Maybe<Spoofing_Reports>;
  /** delete data from the table: "spoofing_reports_to_tags" */
  delete_spoofing_reports_to_tags?: Maybe<Spoofing_Reports_To_Tags_Mutation_Response>;
  /** delete single row from the table: "spoofing_reports_to_tags" */
  delete_spoofing_reports_to_tags_by_pk?: Maybe<Spoofing_Reports_To_Tags>;
  /** delete data from the table: "suggested_enforcements" */
  delete_suggested_enforcements?: Maybe<Suggested_Enforcements_Mutation_Response>;
  /** delete single row from the table: "suggested_enforcements" */
  delete_suggested_enforcements_by_pk?: Maybe<Suggested_Enforcements>;
  /** delete data from the table: "suggested_enforcements_form_responses" */
  delete_suggested_enforcements_form_responses?: Maybe<Suggested_Enforcements_Form_Responses_Mutation_Response>;
  /** delete single row from the table: "suggested_enforcements_form_responses" */
  delete_suggested_enforcements_form_responses_by_pk?: Maybe<Suggested_Enforcements_Form_Responses>;
  /** delete data from the table: "tags" */
  delete_tags?: Maybe<Tags_Mutation_Response>;
  /** delete single row from the table: "tags" */
  delete_tags_by_pk?: Maybe<Tags>;
  /** delete data from the table: "threat_intel_actor_to_campaign" */
  delete_threat_intel_actor_to_campaign?: Maybe<Threat_Intel_Actor_To_Campaign_Mutation_Response>;
  /** delete single row from the table: "threat_intel_actor_to_campaign" */
  delete_threat_intel_actor_to_campaign_by_pk?: Maybe<Threat_Intel_Actor_To_Campaign>;
  /** delete data from the table: "threat_intel_actors" */
  delete_threat_intel_actors?: Maybe<Threat_Intel_Actors_Mutation_Response>;
  /** delete single row from the table: "threat_intel_actors" */
  delete_threat_intel_actors_by_pk?: Maybe<Threat_Intel_Actors>;
  /** delete data from the table: "threat_intel_campaign_to_entities" */
  delete_threat_intel_campaign_to_entities?: Maybe<Threat_Intel_Campaign_To_Entities_Mutation_Response>;
  /** delete single row from the table: "threat_intel_campaign_to_entities" */
  delete_threat_intel_campaign_to_entities_by_pk?: Maybe<Threat_Intel_Campaign_To_Entities>;
  /** delete data from the table: "threat_intel_campaigns" */
  delete_threat_intel_campaigns?: Maybe<Threat_Intel_Campaigns_Mutation_Response>;
  /** delete single row from the table: "threat_intel_campaigns" */
  delete_threat_intel_campaigns_by_pk?: Maybe<Threat_Intel_Campaigns>;
  /** delete data from the table: "trademarks" */
  delete_trademarks?: Maybe<Trademarks_Mutation_Response>;
  /** delete single row from the table: "trademarks" */
  delete_trademarks_by_pk?: Maybe<Trademarks>;
  /** delete data from the table: "uploaded_files" */
  delete_uploaded_files?: Maybe<Uploaded_Files_Mutation_Response>;
  /** delete single row from the table: "uploaded_files" */
  delete_uploaded_files_by_pk?: Maybe<Uploaded_Files>;
  delete_user?: Maybe<DeleteUserOutput>;
  /** delete data from the table: "user_feedback" */
  delete_user_feedback?: Maybe<User_Feedback_Mutation_Response>;
  /** delete single row from the table: "user_feedback" */
  delete_user_feedback_by_pk?: Maybe<User_Feedback>;
  /** delete data from the table: "user_organizations" */
  delete_user_organizations?: Maybe<User_Organizations_Mutation_Response>;
  /** delete single row from the table: "user_organizations" */
  delete_user_organizations_by_pk?: Maybe<User_Organizations>;
  /** delete data from the table: "user_products" */
  delete_user_products?: Maybe<User_Products_Mutation_Response>;
  /** delete single row from the table: "user_products" */
  delete_user_products_by_pk?: Maybe<User_Products>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "vetric_screenshot_webhooks" */
  delete_vetric_screenshot_webhooks?: Maybe<Vetric_Screenshot_Webhooks_Mutation_Response>;
  /** delete single row from the table: "vetric_screenshot_webhooks" */
  delete_vetric_screenshot_webhooks_by_pk?: Maybe<Vetric_Screenshot_Webhooks>;
  /** delete data from the table: "webhook_targets" */
  delete_webhook_targets?: Maybe<Webhook_Targets_Mutation_Response>;
  /** delete single row from the table: "webhook_targets" */
  delete_webhook_targets_by_pk?: Maybe<Webhook_Targets>;
  edit_pii_member?: Maybe<PiiEditMemberOutput>;
  /** For generating suggested enforcements */
  generate_suggested_enforcements?: Maybe<GenerateSuggestedEnforcementsOutput>;
  /** Sync action for handle_admin_url_search_request GCF */
  handle_admin_url_search_request: HandleAdminUrlSearchRequestOutput;
  /** handle_auto_actioning_alert_selection to trigger autoactioning */
  handle_auto_actioning_alert_selection?: Maybe<HandleAutoActioningAlertSelectionOutput>;
  /** Sync action for handle_synchronous_detection_request GCF */
  handle_synchronous_detection_request: HandleSynchronousDetectionRequestOutput;
  /** Async action for handle_synchronous_detection_request GCF (for long-running detection asset creation requests) */
  handle_synchronous_detection_request_async_action: Scalars['uuid'];
  /** insert data into the table: "advertisement_data" */
  insert_advertisement_data?: Maybe<Advertisement_Data_Mutation_Response>;
  /** insert a single row into the table: "advertisement_data" */
  insert_advertisement_data_one?: Maybe<Advertisement_Data>;
  /** insert data into the table: "advertiser_data" */
  insert_advertiser_data?: Maybe<Advertiser_Data_Mutation_Response>;
  /** insert a single row into the table: "advertiser_data" */
  insert_advertiser_data_one?: Maybe<Advertiser_Data>;
  /** insert data into the table: "ai_prompts" */
  insert_ai_prompts?: Maybe<Ai_Prompts_Mutation_Response>;
  /** insert a single row into the table: "ai_prompts" */
  insert_ai_prompts_one?: Maybe<Ai_Prompts>;
  /** insert data into the table: "ai_responses" */
  insert_ai_responses?: Maybe<Ai_Responses_Mutation_Response>;
  /** insert a single row into the table: "ai_responses" */
  insert_ai_responses_one?: Maybe<Ai_Responses>;
  /** insert data into the table: "alert_hashes" */
  insert_alert_hashes?: Maybe<Alert_Hashes_Mutation_Response>;
  /** insert a single row into the table: "alert_hashes" */
  insert_alert_hashes_one?: Maybe<Alert_Hashes>;
  /** insert data into the table: "alert_label_events" */
  insert_alert_label_events?: Maybe<Alert_Label_Events_Mutation_Response>;
  /** insert a single row into the table: "alert_label_events" */
  insert_alert_label_events_one?: Maybe<Alert_Label_Events>;
  /** insert data into the table: "alert_links" */
  insert_alert_links?: Maybe<Alert_Links_Mutation_Response>;
  /** insert a single row into the table: "alert_links" */
  insert_alert_links_one?: Maybe<Alert_Links>;
  /** insert data into the table: "api_tokens" */
  insert_api_tokens?: Maybe<Api_Tokens_Mutation_Response>;
  /** insert a single row into the table: "api_tokens" */
  insert_api_tokens_one?: Maybe<Api_Tokens>;
  /** insert data into the table: "api_usage_records" */
  insert_api_usage_records?: Maybe<Api_Usage_Records_Mutation_Response>;
  /** insert a single row into the table: "api_usage_records" */
  insert_api_usage_records_one?: Maybe<Api_Usage_Records>;
  /** insert data into the table: "apify_scraping_jobs" */
  insert_apify_scraping_jobs?: Maybe<Apify_Scraping_Jobs_Mutation_Response>;
  /** insert a single row into the table: "apify_scraping_jobs" */
  insert_apify_scraping_jobs_one?: Maybe<Apify_Scraping_Jobs>;
  /** insert data into the table: "approvals" */
  insert_approvals?: Maybe<Approvals_Mutation_Response>;
  /** insert a single row into the table: "approvals" */
  insert_approvals_one?: Maybe<Approvals>;
  /** insert data into the table: "audit.logged_actions" */
  insert_audit_logged_actions?: Maybe<Audit_Logged_Actions_Mutation_Response>;
  /** insert a single row into the table: "audit.logged_actions" */
  insert_audit_logged_actions_one?: Maybe<Audit_Logged_Actions>;
  /** insert data into the table: "collection_report_changes" */
  insert_collection_report_changes?: Maybe<Collection_Report_Changes_Mutation_Response>;
  /** insert a single row into the table: "collection_report_changes" */
  insert_collection_report_changes_one?: Maybe<Collection_Report_Changes>;
  /** insert data into the table: "collection_report_state_changes" */
  insert_collection_report_state_changes?: Maybe<Collection_Report_State_Changes_Mutation_Response>;
  /** insert a single row into the table: "collection_report_state_changes" */
  insert_collection_report_state_changes_one?: Maybe<Collection_Report_State_Changes>;
  /** insert data into the table: "credit_cards" */
  insert_credit_cards?: Maybe<Credit_Cards_Mutation_Response>;
  /** insert a single row into the table: "credit_cards" */
  insert_credit_cards_one?: Maybe<Credit_Cards>;
  /** insert data into the table: "customer_assets" */
  insert_customer_assets?: Maybe<Customer_Assets_Mutation_Response>;
  /** insert a single row into the table: "customer_assets" */
  insert_customer_assets_one?: Maybe<Customer_Assets>;
  /** insert data into the table: "customer_assets_to_brands" */
  insert_customer_assets_to_brands?: Maybe<Customer_Assets_To_Brands_Mutation_Response>;
  /** insert a single row into the table: "customer_assets_to_brands" */
  insert_customer_assets_to_brands_one?: Maybe<Customer_Assets_To_Brands>;
  /** insert data into the table: "dark_web" */
  insert_dark_web?: Maybe<Dark_Web_Mutation_Response>;
  /** insert a single row into the table: "dark_web" */
  insert_dark_web_one?: Maybe<Dark_Web>;
  /** insert data into the table: "defensive_domain_registration" */
  insert_defensive_domain_registration?: Maybe<Defensive_Domain_Registration_Mutation_Response>;
  /** insert a single row into the table: "defensive_domain_registration" */
  insert_defensive_domain_registration_one?: Maybe<Defensive_Domain_Registration>;
  /** insert data into the table: "designated_takedown_assets" */
  insert_designated_takedown_assets?: Maybe<Designated_Takedown_Assets_Mutation_Response>;
  /** insert a single row into the table: "designated_takedown_assets" */
  insert_designated_takedown_assets_one?: Maybe<Designated_Takedown_Assets>;
  /** insert data into the table: "detection_assets" */
  insert_detection_assets?: Maybe<Detection_Assets_Mutation_Response>;
  /** insert a single row into the table: "detection_assets" */
  insert_detection_assets_one?: Maybe<Detection_Assets>;
  /** insert data into the table: "detection_config_approvals" */
  insert_detection_config_approvals?: Maybe<Detection_Config_Approvals_Mutation_Response>;
  /** insert a single row into the table: "detection_config_approvals" */
  insert_detection_config_approvals_one?: Maybe<Detection_Config_Approvals>;
  /** insert data into the table: "domain_data" */
  insert_domain_data?: Maybe<Domain_Data_Mutation_Response>;
  /** insert a single row into the table: "domain_data" */
  insert_domain_data_one?: Maybe<Domain_Data>;
  /** insert data into the table: "domain_match_data" */
  insert_domain_match_data?: Maybe<Domain_Match_Data_Mutation_Response>;
  /** insert a single row into the table: "domain_match_data" */
  insert_domain_match_data_one?: Maybe<Domain_Match_Data>;
  /** insert data into the table: "ecommerce_listings" */
  insert_ecommerce_listings?: Maybe<Ecommerce_Listings_Mutation_Response>;
  /** insert a single row into the table: "ecommerce_listings" */
  insert_ecommerce_listings_one?: Maybe<Ecommerce_Listings>;
  /** insert data into the table: "email_addresses" */
  insert_email_addresses?: Maybe<Email_Addresses_Mutation_Response>;
  /** insert a single row into the table: "email_addresses" */
  insert_email_addresses_one?: Maybe<Email_Addresses>;
  /** insert data into the table: "email_correspondence" */
  insert_email_correspondence?: Maybe<Email_Correspondence_Mutation_Response>;
  /** insert a single row into the table: "email_correspondence" */
  insert_email_correspondence_one?: Maybe<Email_Correspondence>;
  /** insert data into the table: "email_settings" */
  insert_email_settings?: Maybe<Email_Settings_Mutation_Response>;
  /** insert a single row into the table: "email_settings" */
  insert_email_settings_one?: Maybe<Email_Settings>;
  /** insert data into the table: "emails" */
  insert_emails?: Maybe<Emails_Mutation_Response>;
  /** insert a single row into the table: "emails" */
  insert_emails_one?: Maybe<Emails>;
  /** insert data into the table: "enforcement_emails" */
  insert_enforcement_emails?: Maybe<Enforcement_Emails_Mutation_Response>;
  /** insert a single row into the table: "enforcement_emails" */
  insert_enforcement_emails_one?: Maybe<Enforcement_Emails>;
  /** insert data into the table: "enforcement_metadata" */
  insert_enforcement_metadata?: Maybe<Enforcement_Metadata_Mutation_Response>;
  /** insert a single row into the table: "enforcement_metadata" */
  insert_enforcement_metadata_one?: Maybe<Enforcement_Metadata>;
  /** insert data into the table: "enforcement_platforms" */
  insert_enforcement_platforms?: Maybe<Enforcement_Platforms_Mutation_Response>;
  /** insert a single row into the table: "enforcement_platforms" */
  insert_enforcement_platforms_one?: Maybe<Enforcement_Platforms>;
  /** insert data into the table: "enforcement_requests" */
  insert_enforcement_requests?: Maybe<Enforcement_Requests_Mutation_Response>;
  /** insert a single row into the table: "enforcement_requests" */
  insert_enforcement_requests_one?: Maybe<Enforcement_Requests>;
  /** insert data into the table: "enforcement_templates" */
  insert_enforcement_templates?: Maybe<Enforcement_Templates_Mutation_Response>;
  /** insert a single row into the table: "enforcement_templates" */
  insert_enforcement_templates_one?: Maybe<Enforcement_Templates>;
  /** insert data into the table: "enforcement_types" */
  insert_enforcement_types?: Maybe<Enforcement_Types_Mutation_Response>;
  /** insert a single row into the table: "enforcement_types" */
  insert_enforcement_types_one?: Maybe<Enforcement_Types>;
  /** insert data into the table: "entity_aggregates" */
  insert_entity_aggregates?: Maybe<Entity_Aggregates_Mutation_Response>;
  /** insert a single row into the table: "entity_aggregates" */
  insert_entity_aggregates_one?: Maybe<Entity_Aggregates>;
  /** insert data into the table: "entity_data" */
  insert_entity_data?: Maybe<Entity_Data_Mutation_Response>;
  /** insert a single row into the table: "entity_data" */
  insert_entity_data_one?: Maybe<Entity_Data>;
  /** insert data into the table: "entity_links" */
  insert_entity_links?: Maybe<Entity_Links_Mutation_Response>;
  /** insert a single row into the table: "entity_links" */
  insert_entity_links_one?: Maybe<Entity_Links>;
  /** insert data into the table: "entity_state_classifications" */
  insert_entity_state_classifications?: Maybe<Entity_State_Classifications_Mutation_Response>;
  /** insert a single row into the table: "entity_state_classifications" */
  insert_entity_state_classifications_one?: Maybe<Entity_State_Classifications>;
  /** insert data into the table: "full_urls" */
  insert_full_urls?: Maybe<Full_Urls_Mutation_Response>;
  /** insert a single row into the table: "full_urls" */
  insert_full_urls_one?: Maybe<Full_Urls>;
  /** insert data into the table: "hourly_spoofing_reports_stats" */
  insert_hourly_spoofing_reports_stats?: Maybe<Hourly_Spoofing_Reports_Stats_Mutation_Response>;
  /** insert a single row into the table: "hourly_spoofing_reports_stats" */
  insert_hourly_spoofing_reports_stats_one?: Maybe<Hourly_Spoofing_Reports_Stats>;
  /** insert data into the table: "ioc_alert_attribution" */
  insert_ioc_alert_attribution?: Maybe<Ioc_Alert_Attribution_Mutation_Response>;
  /** insert a single row into the table: "ioc_alert_attribution" */
  insert_ioc_alert_attribution_one?: Maybe<Ioc_Alert_Attribution>;
  /** insert data into the table: "ioc_detection_config_attribution" */
  insert_ioc_detection_config_attribution?: Maybe<Ioc_Detection_Config_Attribution_Mutation_Response>;
  /** insert a single row into the table: "ioc_detection_config_attribution" */
  insert_ioc_detection_config_attribution_one?: Maybe<Ioc_Detection_Config_Attribution>;
  /** insert data into the table: "ioc_entity_data_attribution" */
  insert_ioc_entity_data_attribution?: Maybe<Ioc_Entity_Data_Attribution_Mutation_Response>;
  /** insert a single row into the table: "ioc_entity_data_attribution" */
  insert_ioc_entity_data_attribution_one?: Maybe<Ioc_Entity_Data_Attribution>;
  /** insert data into the table: "iocs" */
  insert_iocs?: Maybe<Iocs_Mutation_Response>;
  /** insert a single row into the table: "iocs" */
  insert_iocs_one?: Maybe<Iocs>;
  /** insert data into the table: "jira_metadata" */
  insert_jira_metadata?: Maybe<Jira_Metadata_Mutation_Response>;
  /** insert a single row into the table: "jira_metadata" */
  insert_jira_metadata_one?: Maybe<Jira_Metadata>;
  /** insert data into the table: "match_attributions" */
  insert_match_attributions?: Maybe<Match_Attributions_Mutation_Response>;
  /** insert a single row into the table: "match_attributions" */
  insert_match_attributions_one?: Maybe<Match_Attributions>;
  /** insert data into the table: "ml_features" */
  insert_ml_features?: Maybe<Ml_Features_Mutation_Response>;
  /** insert a single row into the table: "ml_features" */
  insert_ml_features_one?: Maybe<Ml_Features>;
  /** insert data into the table: "mobile_apps" */
  insert_mobile_apps?: Maybe<Mobile_Apps_Mutation_Response>;
  /** insert a single row into the table: "mobile_apps" */
  insert_mobile_apps_one?: Maybe<Mobile_Apps>;
  /** insert data into the table: "nft_opensea_processed" */
  insert_nft_opensea_processed?: Maybe<Nft_Opensea_Processed_Mutation_Response>;
  /** insert a single row into the table: "nft_opensea_processed" */
  insert_nft_opensea_processed_one?: Maybe<Nft_Opensea_Processed>;
  /** insert data into the table: "nft_processing_cursor" */
  insert_nft_processing_cursor?: Maybe<Nft_Processing_Cursor_Mutation_Response>;
  /** insert a single row into the table: "nft_processing_cursor" */
  insert_nft_processing_cursor_one?: Maybe<Nft_Processing_Cursor>;
  /** insert data into the table: "notification_subscriptions" */
  insert_notification_subscriptions?: Maybe<Notification_Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "notification_subscriptions" */
  insert_notification_subscriptions_one?: Maybe<Notification_Subscriptions>;
  /** insert data into the table: "organization_id_api_keys" */
  insert_organization_id_api_keys?: Maybe<Organization_Id_Api_Keys_Mutation_Response>;
  /** insert a single row into the table: "organization_id_api_keys" */
  insert_organization_id_api_keys_one?: Maybe<Organization_Id_Api_Keys>;
  /** insert data into the table: "organization_products" */
  insert_organization_products?: Maybe<Organization_Products_Mutation_Response>;
  /** insert a single row into the table: "organization_products" */
  insert_organization_products_one?: Maybe<Organization_Products>;
  /** insert data into the table: "organizations" */
  insert_organizations?: Maybe<Organizations_Mutation_Response>;
  /** insert data into the table: "organizations_metadata" */
  insert_organizations_metadata?: Maybe<Organizations_Metadata_Mutation_Response>;
  /** insert a single row into the table: "organizations_metadata" */
  insert_organizations_metadata_one?: Maybe<Organizations_Metadata>;
  /** insert a single row into the table: "organizations" */
  insert_organizations_one?: Maybe<Organizations>;
  /** insert data into the table: "permissions" */
  insert_permissions?: Maybe<Permissions_Mutation_Response>;
  /** insert a single row into the table: "permissions" */
  insert_permissions_one?: Maybe<Permissions>;
  /** insert data into the table: "phone_numbers" */
  insert_phone_numbers?: Maybe<Phone_Numbers_Mutation_Response>;
  /** insert a single row into the table: "phone_numbers" */
  insert_phone_numbers_one?: Maybe<Phone_Numbers>;
  /** insert data into the table: "pii_databrokers" */
  insert_pii_databrokers?: Maybe<Pii_Databrokers_Mutation_Response>;
  /** insert a single row into the table: "pii_databrokers" */
  insert_pii_databrokers_one?: Maybe<Pii_Databrokers>;
  /** insert data into the table: "pii_events" */
  insert_pii_events?: Maybe<Pii_Events_Mutation_Response>;
  /** insert a single row into the table: "pii_events" */
  insert_pii_events_one?: Maybe<Pii_Events>;
  /** insert data into the table: "pii_reports" */
  insert_pii_reports?: Maybe<Pii_Reports_Mutation_Response>;
  /** insert a single row into the table: "pii_reports" */
  insert_pii_reports_one?: Maybe<Pii_Reports>;
  /** insert data into the table: "pii_statistics" */
  insert_pii_statistics?: Maybe<Pii_Statistics_Mutation_Response>;
  /** insert a single row into the table: "pii_statistics" */
  insert_pii_statistics_one?: Maybe<Pii_Statistics>;
  /** insert data into the table: "platform_subtypes" */
  insert_platform_subtypes?: Maybe<Platform_Subtypes_Mutation_Response>;
  /** insert a single row into the table: "platform_subtypes" */
  insert_platform_subtypes_one?: Maybe<Platform_Subtypes>;
  /** insert data into the table: "platforms" */
  insert_platforms?: Maybe<Platforms_Mutation_Response>;
  /** insert a single row into the table: "platforms" */
  insert_platforms_one?: Maybe<Platforms>;
  /** insert data into the table: "pre_collections" */
  insert_pre_collections?: Maybe<Pre_Collections_Mutation_Response>;
  /** insert a single row into the table: "pre_collections" */
  insert_pre_collections_one?: Maybe<Pre_Collections>;
  /** insert data into the table: "predicted_enforcement_types" */
  insert_predicted_enforcement_types?: Maybe<Predicted_Enforcement_Types_Mutation_Response>;
  /** insert a single row into the table: "predicted_enforcement_types" */
  insert_predicted_enforcement_types_one?: Maybe<Predicted_Enforcement_Types>;
  /** insert data into the table: "protected_assets" */
  insert_protected_assets?: Maybe<Protected_Assets_Mutation_Response>;
  /** insert a single row into the table: "protected_assets" */
  insert_protected_assets_one?: Maybe<Protected_Assets>;
  /** insert data into the table: "report_tags" */
  insert_report_tags?: Maybe<Report_Tags_Mutation_Response>;
  /** insert a single row into the table: "report_tags" */
  insert_report_tags_one?: Maybe<Report_Tags>;
  /** insert data into the table: "reports_to_reports" */
  insert_reports_to_reports?: Maybe<Reports_To_Reports_Mutation_Response>;
  /** insert a single row into the table: "reports_to_reports" */
  insert_reports_to_reports_one?: Maybe<Reports_To_Reports>;
  /** insert data into the table: "role_permissions" */
  insert_role_permissions?: Maybe<Role_Permissions_Mutation_Response>;
  /** insert a single row into the table: "role_permissions" */
  insert_role_permissions_one?: Maybe<Role_Permissions>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "rules" */
  insert_rules?: Maybe<Rules_Mutation_Response>;
  /** insert a single row into the table: "rules" */
  insert_rules_one?: Maybe<Rules>;
  /** insert data into the table: "safelist_ip_addresses" */
  insert_safelist_ip_addresses?: Maybe<Safelist_Ip_Addresses_Mutation_Response>;
  /** insert a single row into the table: "safelist_ip_addresses" */
  insert_safelist_ip_addresses_one?: Maybe<Safelist_Ip_Addresses>;
  /** insert data into the table: "salesforce_organizations_data" */
  insert_salesforce_organizations_data?: Maybe<Salesforce_Organizations_Data_Mutation_Response>;
  /** insert a single row into the table: "salesforce_organizations_data" */
  insert_salesforce_organizations_data_one?: Maybe<Salesforce_Organizations_Data>;
  /** insert data into the table: "scan_results" */
  insert_scan_results?: Maybe<Scan_Results_Mutation_Response>;
  /** insert a single row into the table: "scan_results" */
  insert_scan_results_one?: Maybe<Scan_Results>;
  /** insert data into the table: "scans" */
  insert_scans?: Maybe<Scans_Mutation_Response>;
  /** insert a single row into the table: "scans" */
  insert_scans_one?: Maybe<Scans>;
  /** insert data into the table: "scraping_configs" */
  insert_scraping_configs?: Maybe<Scraping_Configs_Mutation_Response>;
  /** insert a single row into the table: "scraping_configs" */
  insert_scraping_configs_one?: Maybe<Scraping_Configs>;
  /** insert data into the table: "sim_campaign_observations" */
  insert_sim_campaign_observations?: Maybe<Sim_Campaign_Observations_Mutation_Response>;
  /** insert a single row into the table: "sim_campaign_observations" */
  insert_sim_campaign_observations_one?: Maybe<Sim_Campaign_Observations>;
  /** insert data into the table: "sim_campaigns" */
  insert_sim_campaigns?: Maybe<Sim_Campaigns_Mutation_Response>;
  /** insert a single row into the table: "sim_campaigns" */
  insert_sim_campaigns_one?: Maybe<Sim_Campaigns>;
  /** insert data into the table: "sim_emails" */
  insert_sim_emails?: Maybe<Sim_Emails_Mutation_Response>;
  /** insert a single row into the table: "sim_emails" */
  insert_sim_emails_one?: Maybe<Sim_Emails>;
  /** insert data into the table: "sim_groups" */
  insert_sim_groups?: Maybe<Sim_Groups_Mutation_Response>;
  /** insert a single row into the table: "sim_groups" */
  insert_sim_groups_one?: Maybe<Sim_Groups>;
  /** insert data into the table: "sim_users" */
  insert_sim_users?: Maybe<Sim_Users_Mutation_Response>;
  /** insert a single row into the table: "sim_users" */
  insert_sim_users_one?: Maybe<Sim_Users>;
  /** insert data into the table: "slack_installations" */
  insert_slack_installations?: Maybe<Slack_Installations_Mutation_Response>;
  /** insert a single row into the table: "slack_installations" */
  insert_slack_installations_one?: Maybe<Slack_Installations>;
  /** insert data into the table: "social_media_comments" */
  insert_social_media_comments?: Maybe<Social_Media_Comments_Mutation_Response>;
  /** insert a single row into the table: "social_media_comments" */
  insert_social_media_comments_one?: Maybe<Social_Media_Comments>;
  /** insert data into the table: "social_media_data" */
  insert_social_media_data?: Maybe<Social_Media_Data_Mutation_Response>;
  /** insert a single row into the table: "social_media_data" */
  insert_social_media_data_one?: Maybe<Social_Media_Data>;
  /** insert data into the table: "social_media_group" */
  insert_social_media_group?: Maybe<Social_Media_Group_Mutation_Response>;
  /** insert a single row into the table: "social_media_group" */
  insert_social_media_group_one?: Maybe<Social_Media_Group>;
  /** insert data into the table: "social_media_post" */
  insert_social_media_post?: Maybe<Social_Media_Post_Mutation_Response>;
  /** insert a single row into the table: "social_media_post" */
  insert_social_media_post_one?: Maybe<Social_Media_Post>;
  /** insert data into the table: "sourcing_queries" */
  insert_sourcing_queries?: Maybe<Sourcing_Queries_Mutation_Response>;
  /** insert a single row into the table: "sourcing_queries" */
  insert_sourcing_queries_one?: Maybe<Sourcing_Queries>;
  /** insert data into the table: "sourcing_query_executions" */
  insert_sourcing_query_executions?: Maybe<Sourcing_Query_Executions_Mutation_Response>;
  /** insert a single row into the table: "sourcing_query_executions" */
  insert_sourcing_query_executions_one?: Maybe<Sourcing_Query_Executions>;
  /** insert data into the table: "spoof_matches" */
  insert_spoof_matches?: Maybe<Spoof_Matches_Mutation_Response>;
  /** insert a single row into the table: "spoof_matches" */
  insert_spoof_matches_one?: Maybe<Spoof_Matches>;
  /** insert data into the table: "spoofing_entities" */
  insert_spoofing_entities?: Maybe<Spoofing_Entities_Mutation_Response>;
  /** insert a single row into the table: "spoofing_entities" */
  insert_spoofing_entities_one?: Maybe<Spoofing_Entities>;
  /** insert data into the table: "spoofing_report_search_results" */
  insert_spoofing_report_search_results?: Maybe<Spoofing_Report_Search_Results_Mutation_Response>;
  /** insert a single row into the table: "spoofing_report_search_results" */
  insert_spoofing_report_search_results_one?: Maybe<Spoofing_Report_Search_Results>;
  /** insert data into the table: "spoofing_reports" */
  insert_spoofing_reports?: Maybe<Spoofing_Reports_Mutation_Response>;
  /** insert a single row into the table: "spoofing_reports" */
  insert_spoofing_reports_one?: Maybe<Spoofing_Reports>;
  /** insert data into the table: "spoofing_reports_to_tags" */
  insert_spoofing_reports_to_tags?: Maybe<Spoofing_Reports_To_Tags_Mutation_Response>;
  /** insert a single row into the table: "spoofing_reports_to_tags" */
  insert_spoofing_reports_to_tags_one?: Maybe<Spoofing_Reports_To_Tags>;
  /** insert data into the table: "suggested_enforcements" */
  insert_suggested_enforcements?: Maybe<Suggested_Enforcements_Mutation_Response>;
  /** insert data into the table: "suggested_enforcements_form_responses" */
  insert_suggested_enforcements_form_responses?: Maybe<Suggested_Enforcements_Form_Responses_Mutation_Response>;
  /** insert a single row into the table: "suggested_enforcements_form_responses" */
  insert_suggested_enforcements_form_responses_one?: Maybe<Suggested_Enforcements_Form_Responses>;
  /** insert a single row into the table: "suggested_enforcements" */
  insert_suggested_enforcements_one?: Maybe<Suggested_Enforcements>;
  /** insert data into the table: "tags" */
  insert_tags?: Maybe<Tags_Mutation_Response>;
  /** insert a single row into the table: "tags" */
  insert_tags_one?: Maybe<Tags>;
  /** insert data into the table: "threat_intel_actor_to_campaign" */
  insert_threat_intel_actor_to_campaign?: Maybe<Threat_Intel_Actor_To_Campaign_Mutation_Response>;
  /** insert a single row into the table: "threat_intel_actor_to_campaign" */
  insert_threat_intel_actor_to_campaign_one?: Maybe<Threat_Intel_Actor_To_Campaign>;
  /** insert data into the table: "threat_intel_actors" */
  insert_threat_intel_actors?: Maybe<Threat_Intel_Actors_Mutation_Response>;
  /** insert a single row into the table: "threat_intel_actors" */
  insert_threat_intel_actors_one?: Maybe<Threat_Intel_Actors>;
  /** insert data into the table: "threat_intel_campaign_to_entities" */
  insert_threat_intel_campaign_to_entities?: Maybe<Threat_Intel_Campaign_To_Entities_Mutation_Response>;
  /** insert a single row into the table: "threat_intel_campaign_to_entities" */
  insert_threat_intel_campaign_to_entities_one?: Maybe<Threat_Intel_Campaign_To_Entities>;
  /** insert data into the table: "threat_intel_campaigns" */
  insert_threat_intel_campaigns?: Maybe<Threat_Intel_Campaigns_Mutation_Response>;
  /** insert a single row into the table: "threat_intel_campaigns" */
  insert_threat_intel_campaigns_one?: Maybe<Threat_Intel_Campaigns>;
  /** insert data into the table: "trademarks" */
  insert_trademarks?: Maybe<Trademarks_Mutation_Response>;
  /** insert a single row into the table: "trademarks" */
  insert_trademarks_one?: Maybe<Trademarks>;
  /** insert data into the table: "uploaded_files" */
  insert_uploaded_files?: Maybe<Uploaded_Files_Mutation_Response>;
  /** insert a single row into the table: "uploaded_files" */
  insert_uploaded_files_one?: Maybe<Uploaded_Files>;
  /** insert data into the table: "user_feedback" */
  insert_user_feedback?: Maybe<User_Feedback_Mutation_Response>;
  /** insert a single row into the table: "user_feedback" */
  insert_user_feedback_one?: Maybe<User_Feedback>;
  /** insert data into the table: "user_organizations" */
  insert_user_organizations?: Maybe<User_Organizations_Mutation_Response>;
  /** insert a single row into the table: "user_organizations" */
  insert_user_organizations_one?: Maybe<User_Organizations>;
  /** insert data into the table: "user_products" */
  insert_user_products?: Maybe<User_Products_Mutation_Response>;
  /** insert a single row into the table: "user_products" */
  insert_user_products_one?: Maybe<User_Products>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "vetric_screenshot_webhooks" */
  insert_vetric_screenshot_webhooks?: Maybe<Vetric_Screenshot_Webhooks_Mutation_Response>;
  /** insert a single row into the table: "vetric_screenshot_webhooks" */
  insert_vetric_screenshot_webhooks_one?: Maybe<Vetric_Screenshot_Webhooks>;
  /** insert data into the table: "webhook_targets" */
  insert_webhook_targets?: Maybe<Webhook_Targets_Mutation_Response>;
  /** insert a single row into the table: "webhook_targets" */
  insert_webhook_targets_one?: Maybe<Webhook_Targets>;
  /** Uploads a new safelist item */
  manage_safelist?: Maybe<ManageSafelistOutput>;
  /** Upload or update a trademark */
  manage_trademarks?: Maybe<ManageTrademarksOutput>;
  /** modify_alert_links */
  modify_alert_links: ModifyAlertLinksOutput;
  modify_gcs_object?: Maybe<ModifyGcsObjectOutput>;
  post_ioc_updated?: Maybe<PostIocUpdatedOutput>;
  publish_request_spoof_screenshot?: Maybe<PublishRequestSpoofScreenshotOutput>;
  request_alert_csv_export: Scalars['uuid'];
  /** request_bulk_scrape */
  request_bulk_scrape: RequestBulkScrapeOutput;
  /** Run Deepfake Detection */
  run_deepfake_detection?: Maybe<RunDeepfakeDetectionOutput>;
  send_sim_email?: Maybe<SendSimEmailOutput>;
  /** Send a. custom notification in slack */
  send_slack_message?: Maybe<SlackMessageOutput>;
  submit_auto_enforcement_requests?: Maybe<SubmitAutoEnforcementRequestsOutput>;
  /** Used to submit auto_form requests */
  submit_form_auto_enforcement_requests?: Maybe<SubmitFormAutoEnforcementRequestsOutput>;
  /** update data of the table: "advertisement_data" */
  update_advertisement_data?: Maybe<Advertisement_Data_Mutation_Response>;
  /** update single row of the table: "advertisement_data" */
  update_advertisement_data_by_pk?: Maybe<Advertisement_Data>;
  /** update multiples rows of table: "advertisement_data" */
  update_advertisement_data_many?: Maybe<Array<Maybe<Advertisement_Data_Mutation_Response>>>;
  /** update data of the table: "advertiser_data" */
  update_advertiser_data?: Maybe<Advertiser_Data_Mutation_Response>;
  /** update single row of the table: "advertiser_data" */
  update_advertiser_data_by_pk?: Maybe<Advertiser_Data>;
  /** update multiples rows of table: "advertiser_data" */
  update_advertiser_data_many?: Maybe<Array<Maybe<Advertiser_Data_Mutation_Response>>>;
  /** update data of the table: "ai_prompts" */
  update_ai_prompts?: Maybe<Ai_Prompts_Mutation_Response>;
  /** update single row of the table: "ai_prompts" */
  update_ai_prompts_by_pk?: Maybe<Ai_Prompts>;
  /** update multiples rows of table: "ai_prompts" */
  update_ai_prompts_many?: Maybe<Array<Maybe<Ai_Prompts_Mutation_Response>>>;
  /** update data of the table: "ai_responses" */
  update_ai_responses?: Maybe<Ai_Responses_Mutation_Response>;
  /** update single row of the table: "ai_responses" */
  update_ai_responses_by_pk?: Maybe<Ai_Responses>;
  /** update multiples rows of table: "ai_responses" */
  update_ai_responses_many?: Maybe<Array<Maybe<Ai_Responses_Mutation_Response>>>;
  /** update data of the table: "alert_hashes" */
  update_alert_hashes?: Maybe<Alert_Hashes_Mutation_Response>;
  /** update single row of the table: "alert_hashes" */
  update_alert_hashes_by_pk?: Maybe<Alert_Hashes>;
  /** update multiples rows of table: "alert_hashes" */
  update_alert_hashes_many?: Maybe<Array<Maybe<Alert_Hashes_Mutation_Response>>>;
  /** update data of the table: "alert_label_events" */
  update_alert_label_events?: Maybe<Alert_Label_Events_Mutation_Response>;
  /** update single row of the table: "alert_label_events" */
  update_alert_label_events_by_pk?: Maybe<Alert_Label_Events>;
  /** update multiples rows of table: "alert_label_events" */
  update_alert_label_events_many?: Maybe<Array<Maybe<Alert_Label_Events_Mutation_Response>>>;
  /** update data of the table: "alert_links" */
  update_alert_links?: Maybe<Alert_Links_Mutation_Response>;
  /** update single row of the table: "alert_links" */
  update_alert_links_by_pk?: Maybe<Alert_Links>;
  /** update multiples rows of table: "alert_links" */
  update_alert_links_many?: Maybe<Array<Maybe<Alert_Links_Mutation_Response>>>;
  /** update data of the table: "api_tokens" */
  update_api_tokens?: Maybe<Api_Tokens_Mutation_Response>;
  /** update single row of the table: "api_tokens" */
  update_api_tokens_by_pk?: Maybe<Api_Tokens>;
  /** update multiples rows of table: "api_tokens" */
  update_api_tokens_many?: Maybe<Array<Maybe<Api_Tokens_Mutation_Response>>>;
  /** update data of the table: "api_usage_records" */
  update_api_usage_records?: Maybe<Api_Usage_Records_Mutation_Response>;
  /** update single row of the table: "api_usage_records" */
  update_api_usage_records_by_pk?: Maybe<Api_Usage_Records>;
  /** update multiples rows of table: "api_usage_records" */
  update_api_usage_records_many?: Maybe<Array<Maybe<Api_Usage_Records_Mutation_Response>>>;
  /** update data of the table: "apify_scraping_jobs" */
  update_apify_scraping_jobs?: Maybe<Apify_Scraping_Jobs_Mutation_Response>;
  /** update single row of the table: "apify_scraping_jobs" */
  update_apify_scraping_jobs_by_pk?: Maybe<Apify_Scraping_Jobs>;
  /** update multiples rows of table: "apify_scraping_jobs" */
  update_apify_scraping_jobs_many?: Maybe<Array<Maybe<Apify_Scraping_Jobs_Mutation_Response>>>;
  /** update data of the table: "approvals" */
  update_approvals?: Maybe<Approvals_Mutation_Response>;
  /** update single row of the table: "approvals" */
  update_approvals_by_pk?: Maybe<Approvals>;
  /** update multiples rows of table: "approvals" */
  update_approvals_many?: Maybe<Array<Maybe<Approvals_Mutation_Response>>>;
  /** update data of the table: "audit.logged_actions" */
  update_audit_logged_actions?: Maybe<Audit_Logged_Actions_Mutation_Response>;
  /** update single row of the table: "audit.logged_actions" */
  update_audit_logged_actions_by_pk?: Maybe<Audit_Logged_Actions>;
  /** update multiples rows of table: "audit.logged_actions" */
  update_audit_logged_actions_many?: Maybe<Array<Maybe<Audit_Logged_Actions_Mutation_Response>>>;
  /** update data of the table: "collection_report_changes" */
  update_collection_report_changes?: Maybe<Collection_Report_Changes_Mutation_Response>;
  /** update single row of the table: "collection_report_changes" */
  update_collection_report_changes_by_pk?: Maybe<Collection_Report_Changes>;
  /** update multiples rows of table: "collection_report_changes" */
  update_collection_report_changes_many?: Maybe<Array<Maybe<Collection_Report_Changes_Mutation_Response>>>;
  /** update data of the table: "collection_report_state_changes" */
  update_collection_report_state_changes?: Maybe<Collection_Report_State_Changes_Mutation_Response>;
  /** update single row of the table: "collection_report_state_changes" */
  update_collection_report_state_changes_by_pk?: Maybe<Collection_Report_State_Changes>;
  /** update multiples rows of table: "collection_report_state_changes" */
  update_collection_report_state_changes_many?: Maybe<Array<Maybe<Collection_Report_State_Changes_Mutation_Response>>>;
  /** update data of the table: "credit_cards" */
  update_credit_cards?: Maybe<Credit_Cards_Mutation_Response>;
  /** update single row of the table: "credit_cards" */
  update_credit_cards_by_pk?: Maybe<Credit_Cards>;
  /** update multiples rows of table: "credit_cards" */
  update_credit_cards_many?: Maybe<Array<Maybe<Credit_Cards_Mutation_Response>>>;
  /** update data of the table: "customer_assets" */
  update_customer_assets?: Maybe<Customer_Assets_Mutation_Response>;
  /** update single row of the table: "customer_assets" */
  update_customer_assets_by_pk?: Maybe<Customer_Assets>;
  /** update multiples rows of table: "customer_assets" */
  update_customer_assets_many?: Maybe<Array<Maybe<Customer_Assets_Mutation_Response>>>;
  /** update data of the table: "customer_assets_to_brands" */
  update_customer_assets_to_brands?: Maybe<Customer_Assets_To_Brands_Mutation_Response>;
  /** update single row of the table: "customer_assets_to_brands" */
  update_customer_assets_to_brands_by_pk?: Maybe<Customer_Assets_To_Brands>;
  /** update multiples rows of table: "customer_assets_to_brands" */
  update_customer_assets_to_brands_many?: Maybe<Array<Maybe<Customer_Assets_To_Brands_Mutation_Response>>>;
  /** update data of the table: "dark_web" */
  update_dark_web?: Maybe<Dark_Web_Mutation_Response>;
  /** update single row of the table: "dark_web" */
  update_dark_web_by_pk?: Maybe<Dark_Web>;
  /** update multiples rows of table: "dark_web" */
  update_dark_web_many?: Maybe<Array<Maybe<Dark_Web_Mutation_Response>>>;
  /** update data of the table: "defensive_domain_registration" */
  update_defensive_domain_registration?: Maybe<Defensive_Domain_Registration_Mutation_Response>;
  /** update single row of the table: "defensive_domain_registration" */
  update_defensive_domain_registration_by_pk?: Maybe<Defensive_Domain_Registration>;
  /** update multiples rows of table: "defensive_domain_registration" */
  update_defensive_domain_registration_many?: Maybe<Array<Maybe<Defensive_Domain_Registration_Mutation_Response>>>;
  /** update data of the table: "designated_takedown_assets" */
  update_designated_takedown_assets?: Maybe<Designated_Takedown_Assets_Mutation_Response>;
  /** update single row of the table: "designated_takedown_assets" */
  update_designated_takedown_assets_by_pk?: Maybe<Designated_Takedown_Assets>;
  /** update multiples rows of table: "designated_takedown_assets" */
  update_designated_takedown_assets_many?: Maybe<Array<Maybe<Designated_Takedown_Assets_Mutation_Response>>>;
  /** update data of the table: "detection_assets" */
  update_detection_assets?: Maybe<Detection_Assets_Mutation_Response>;
  /** update single row of the table: "detection_assets" */
  update_detection_assets_by_pk?: Maybe<Detection_Assets>;
  /** update multiples rows of table: "detection_assets" */
  update_detection_assets_many?: Maybe<Array<Maybe<Detection_Assets_Mutation_Response>>>;
  /** update data of the table: "detection_config_approvals" */
  update_detection_config_approvals?: Maybe<Detection_Config_Approvals_Mutation_Response>;
  /** update single row of the table: "detection_config_approvals" */
  update_detection_config_approvals_by_pk?: Maybe<Detection_Config_Approvals>;
  /** update multiples rows of table: "detection_config_approvals" */
  update_detection_config_approvals_many?: Maybe<Array<Maybe<Detection_Config_Approvals_Mutation_Response>>>;
  /** update data of the table: "domain_data" */
  update_domain_data?: Maybe<Domain_Data_Mutation_Response>;
  /** update single row of the table: "domain_data" */
  update_domain_data_by_pk?: Maybe<Domain_Data>;
  /** update multiples rows of table: "domain_data" */
  update_domain_data_many?: Maybe<Array<Maybe<Domain_Data_Mutation_Response>>>;
  /** update data of the table: "domain_match_data" */
  update_domain_match_data?: Maybe<Domain_Match_Data_Mutation_Response>;
  /** update single row of the table: "domain_match_data" */
  update_domain_match_data_by_pk?: Maybe<Domain_Match_Data>;
  /** update multiples rows of table: "domain_match_data" */
  update_domain_match_data_many?: Maybe<Array<Maybe<Domain_Match_Data_Mutation_Response>>>;
  /** update data of the table: "ecommerce_listings" */
  update_ecommerce_listings?: Maybe<Ecommerce_Listings_Mutation_Response>;
  /** update single row of the table: "ecommerce_listings" */
  update_ecommerce_listings_by_pk?: Maybe<Ecommerce_Listings>;
  /** update multiples rows of table: "ecommerce_listings" */
  update_ecommerce_listings_many?: Maybe<Array<Maybe<Ecommerce_Listings_Mutation_Response>>>;
  /** update data of the table: "email_addresses" */
  update_email_addresses?: Maybe<Email_Addresses_Mutation_Response>;
  /** update single row of the table: "email_addresses" */
  update_email_addresses_by_pk?: Maybe<Email_Addresses>;
  /** update multiples rows of table: "email_addresses" */
  update_email_addresses_many?: Maybe<Array<Maybe<Email_Addresses_Mutation_Response>>>;
  /** update data of the table: "email_correspondence" */
  update_email_correspondence?: Maybe<Email_Correspondence_Mutation_Response>;
  /** update single row of the table: "email_correspondence" */
  update_email_correspondence_by_pk?: Maybe<Email_Correspondence>;
  /** update multiples rows of table: "email_correspondence" */
  update_email_correspondence_many?: Maybe<Array<Maybe<Email_Correspondence_Mutation_Response>>>;
  /** update data of the table: "email_settings" */
  update_email_settings?: Maybe<Email_Settings_Mutation_Response>;
  /** update single row of the table: "email_settings" */
  update_email_settings_by_pk?: Maybe<Email_Settings>;
  /** update multiples rows of table: "email_settings" */
  update_email_settings_many?: Maybe<Array<Maybe<Email_Settings_Mutation_Response>>>;
  /** update data of the table: "emails" */
  update_emails?: Maybe<Emails_Mutation_Response>;
  /** update single row of the table: "emails" */
  update_emails_by_pk?: Maybe<Emails>;
  /** update multiples rows of table: "emails" */
  update_emails_many?: Maybe<Array<Maybe<Emails_Mutation_Response>>>;
  /** update data of the table: "enforcement_emails" */
  update_enforcement_emails?: Maybe<Enforcement_Emails_Mutation_Response>;
  /** update single row of the table: "enforcement_emails" */
  update_enforcement_emails_by_pk?: Maybe<Enforcement_Emails>;
  /** update multiples rows of table: "enforcement_emails" */
  update_enforcement_emails_many?: Maybe<Array<Maybe<Enforcement_Emails_Mutation_Response>>>;
  /** update data of the table: "enforcement_metadata" */
  update_enforcement_metadata?: Maybe<Enforcement_Metadata_Mutation_Response>;
  /** update single row of the table: "enforcement_metadata" */
  update_enforcement_metadata_by_pk?: Maybe<Enforcement_Metadata>;
  /** update multiples rows of table: "enforcement_metadata" */
  update_enforcement_metadata_many?: Maybe<Array<Maybe<Enforcement_Metadata_Mutation_Response>>>;
  /** update data of the table: "enforcement_platforms" */
  update_enforcement_platforms?: Maybe<Enforcement_Platforms_Mutation_Response>;
  /** update single row of the table: "enforcement_platforms" */
  update_enforcement_platforms_by_pk?: Maybe<Enforcement_Platforms>;
  /** update multiples rows of table: "enforcement_platforms" */
  update_enforcement_platforms_many?: Maybe<Array<Maybe<Enforcement_Platforms_Mutation_Response>>>;
  update_enforcement_request_status?: Maybe<UpdateEnforcementRequestStatusOutput>;
  /** update data of the table: "enforcement_requests" */
  update_enforcement_requests?: Maybe<Enforcement_Requests_Mutation_Response>;
  /** update single row of the table: "enforcement_requests" */
  update_enforcement_requests_by_pk?: Maybe<Enforcement_Requests>;
  /** update multiples rows of table: "enforcement_requests" */
  update_enforcement_requests_many?: Maybe<Array<Maybe<Enforcement_Requests_Mutation_Response>>>;
  /** update data of the table: "enforcement_templates" */
  update_enforcement_templates?: Maybe<Enforcement_Templates_Mutation_Response>;
  /** update single row of the table: "enforcement_templates" */
  update_enforcement_templates_by_pk?: Maybe<Enforcement_Templates>;
  /** update multiples rows of table: "enforcement_templates" */
  update_enforcement_templates_many?: Maybe<Array<Maybe<Enforcement_Templates_Mutation_Response>>>;
  /** update data of the table: "enforcement_types" */
  update_enforcement_types?: Maybe<Enforcement_Types_Mutation_Response>;
  /** update single row of the table: "enforcement_types" */
  update_enforcement_types_by_pk?: Maybe<Enforcement_Types>;
  /** update multiples rows of table: "enforcement_types" */
  update_enforcement_types_many?: Maybe<Array<Maybe<Enforcement_Types_Mutation_Response>>>;
  /** update data of the table: "entity_aggregates" */
  update_entity_aggregates?: Maybe<Entity_Aggregates_Mutation_Response>;
  /** update single row of the table: "entity_aggregates" */
  update_entity_aggregates_by_pk?: Maybe<Entity_Aggregates>;
  /** update multiples rows of table: "entity_aggregates" */
  update_entity_aggregates_many?: Maybe<Array<Maybe<Entity_Aggregates_Mutation_Response>>>;
  /** update data of the table: "entity_data" */
  update_entity_data?: Maybe<Entity_Data_Mutation_Response>;
  /** update single row of the table: "entity_data" */
  update_entity_data_by_pk?: Maybe<Entity_Data>;
  /** update multiples rows of table: "entity_data" */
  update_entity_data_many?: Maybe<Array<Maybe<Entity_Data_Mutation_Response>>>;
  /** update data of the table: "entity_links" */
  update_entity_links?: Maybe<Entity_Links_Mutation_Response>;
  /** update single row of the table: "entity_links" */
  update_entity_links_by_pk?: Maybe<Entity_Links>;
  /** update multiples rows of table: "entity_links" */
  update_entity_links_many?: Maybe<Array<Maybe<Entity_Links_Mutation_Response>>>;
  /** update data of the table: "entity_state_classifications" */
  update_entity_state_classifications?: Maybe<Entity_State_Classifications_Mutation_Response>;
  /** update single row of the table: "entity_state_classifications" */
  update_entity_state_classifications_by_pk?: Maybe<Entity_State_Classifications>;
  /** update multiples rows of table: "entity_state_classifications" */
  update_entity_state_classifications_many?: Maybe<Array<Maybe<Entity_State_Classifications_Mutation_Response>>>;
  /** update data of the table: "full_urls" */
  update_full_urls?: Maybe<Full_Urls_Mutation_Response>;
  /** update single row of the table: "full_urls" */
  update_full_urls_by_pk?: Maybe<Full_Urls>;
  /** update multiples rows of table: "full_urls" */
  update_full_urls_many?: Maybe<Array<Maybe<Full_Urls_Mutation_Response>>>;
  /** update data of the table: "hourly_spoofing_reports_stats" */
  update_hourly_spoofing_reports_stats?: Maybe<Hourly_Spoofing_Reports_Stats_Mutation_Response>;
  /** update single row of the table: "hourly_spoofing_reports_stats" */
  update_hourly_spoofing_reports_stats_by_pk?: Maybe<Hourly_Spoofing_Reports_Stats>;
  /** update multiples rows of table: "hourly_spoofing_reports_stats" */
  update_hourly_spoofing_reports_stats_many?: Maybe<Array<Maybe<Hourly_Spoofing_Reports_Stats_Mutation_Response>>>;
  /** update data of the table: "ioc_alert_attribution" */
  update_ioc_alert_attribution?: Maybe<Ioc_Alert_Attribution_Mutation_Response>;
  /** update single row of the table: "ioc_alert_attribution" */
  update_ioc_alert_attribution_by_pk?: Maybe<Ioc_Alert_Attribution>;
  /** update multiples rows of table: "ioc_alert_attribution" */
  update_ioc_alert_attribution_many?: Maybe<Array<Maybe<Ioc_Alert_Attribution_Mutation_Response>>>;
  /** update data of the table: "ioc_detection_config_attribution" */
  update_ioc_detection_config_attribution?: Maybe<Ioc_Detection_Config_Attribution_Mutation_Response>;
  /** update single row of the table: "ioc_detection_config_attribution" */
  update_ioc_detection_config_attribution_by_pk?: Maybe<Ioc_Detection_Config_Attribution>;
  /** update multiples rows of table: "ioc_detection_config_attribution" */
  update_ioc_detection_config_attribution_many?: Maybe<Array<Maybe<Ioc_Detection_Config_Attribution_Mutation_Response>>>;
  /** update data of the table: "ioc_entity_data_attribution" */
  update_ioc_entity_data_attribution?: Maybe<Ioc_Entity_Data_Attribution_Mutation_Response>;
  /** update single row of the table: "ioc_entity_data_attribution" */
  update_ioc_entity_data_attribution_by_pk?: Maybe<Ioc_Entity_Data_Attribution>;
  /** update multiples rows of table: "ioc_entity_data_attribution" */
  update_ioc_entity_data_attribution_many?: Maybe<Array<Maybe<Ioc_Entity_Data_Attribution_Mutation_Response>>>;
  /** update data of the table: "iocs" */
  update_iocs?: Maybe<Iocs_Mutation_Response>;
  /** update single row of the table: "iocs" */
  update_iocs_by_pk?: Maybe<Iocs>;
  /** update multiples rows of table: "iocs" */
  update_iocs_many?: Maybe<Array<Maybe<Iocs_Mutation_Response>>>;
  /** update data of the table: "jira_metadata" */
  update_jira_metadata?: Maybe<Jira_Metadata_Mutation_Response>;
  /** update single row of the table: "jira_metadata" */
  update_jira_metadata_by_pk?: Maybe<Jira_Metadata>;
  /** update multiples rows of table: "jira_metadata" */
  update_jira_metadata_many?: Maybe<Array<Maybe<Jira_Metadata_Mutation_Response>>>;
  /** update data of the table: "match_attributions" */
  update_match_attributions?: Maybe<Match_Attributions_Mutation_Response>;
  /** update single row of the table: "match_attributions" */
  update_match_attributions_by_pk?: Maybe<Match_Attributions>;
  /** update multiples rows of table: "match_attributions" */
  update_match_attributions_many?: Maybe<Array<Maybe<Match_Attributions_Mutation_Response>>>;
  /** update data of the table: "ml_features" */
  update_ml_features?: Maybe<Ml_Features_Mutation_Response>;
  /** update single row of the table: "ml_features" */
  update_ml_features_by_pk?: Maybe<Ml_Features>;
  /** update multiples rows of table: "ml_features" */
  update_ml_features_many?: Maybe<Array<Maybe<Ml_Features_Mutation_Response>>>;
  /** update data of the table: "mobile_apps" */
  update_mobile_apps?: Maybe<Mobile_Apps_Mutation_Response>;
  /** update single row of the table: "mobile_apps" */
  update_mobile_apps_by_pk?: Maybe<Mobile_Apps>;
  /** update multiples rows of table: "mobile_apps" */
  update_mobile_apps_many?: Maybe<Array<Maybe<Mobile_Apps_Mutation_Response>>>;
  /** update data of the table: "nft_opensea_processed" */
  update_nft_opensea_processed?: Maybe<Nft_Opensea_Processed_Mutation_Response>;
  /** update single row of the table: "nft_opensea_processed" */
  update_nft_opensea_processed_by_pk?: Maybe<Nft_Opensea_Processed>;
  /** update multiples rows of table: "nft_opensea_processed" */
  update_nft_opensea_processed_many?: Maybe<Array<Maybe<Nft_Opensea_Processed_Mutation_Response>>>;
  /** update data of the table: "nft_processing_cursor" */
  update_nft_processing_cursor?: Maybe<Nft_Processing_Cursor_Mutation_Response>;
  /** update single row of the table: "nft_processing_cursor" */
  update_nft_processing_cursor_by_pk?: Maybe<Nft_Processing_Cursor>;
  /** update multiples rows of table: "nft_processing_cursor" */
  update_nft_processing_cursor_many?: Maybe<Array<Maybe<Nft_Processing_Cursor_Mutation_Response>>>;
  /** update data of the table: "notification_subscriptions" */
  update_notification_subscriptions?: Maybe<Notification_Subscriptions_Mutation_Response>;
  /** update single row of the table: "notification_subscriptions" */
  update_notification_subscriptions_by_pk?: Maybe<Notification_Subscriptions>;
  /** update multiples rows of table: "notification_subscriptions" */
  update_notification_subscriptions_many?: Maybe<Array<Maybe<Notification_Subscriptions_Mutation_Response>>>;
  update_organization?: Maybe<UpdateOrganizationOutput>;
  /** update data of the table: "organization_id_api_keys" */
  update_organization_id_api_keys?: Maybe<Organization_Id_Api_Keys_Mutation_Response>;
  /** update single row of the table: "organization_id_api_keys" */
  update_organization_id_api_keys_by_pk?: Maybe<Organization_Id_Api_Keys>;
  /** update multiples rows of table: "organization_id_api_keys" */
  update_organization_id_api_keys_many?: Maybe<Array<Maybe<Organization_Id_Api_Keys_Mutation_Response>>>;
  /** update data of the table: "organization_products" */
  update_organization_products?: Maybe<Organization_Products_Mutation_Response>;
  /** update single row of the table: "organization_products" */
  update_organization_products_by_pk?: Maybe<Organization_Products>;
  /** update multiples rows of table: "organization_products" */
  update_organization_products_many?: Maybe<Array<Maybe<Organization_Products_Mutation_Response>>>;
  /** update data of the table: "organizations" */
  update_organizations?: Maybe<Organizations_Mutation_Response>;
  /** update single row of the table: "organizations" */
  update_organizations_by_pk?: Maybe<Organizations>;
  /** update multiples rows of table: "organizations" */
  update_organizations_many?: Maybe<Array<Maybe<Organizations_Mutation_Response>>>;
  /** update data of the table: "organizations_metadata" */
  update_organizations_metadata?: Maybe<Organizations_Metadata_Mutation_Response>;
  /** update single row of the table: "organizations_metadata" */
  update_organizations_metadata_by_pk?: Maybe<Organizations_Metadata>;
  /** update multiples rows of table: "organizations_metadata" */
  update_organizations_metadata_many?: Maybe<Array<Maybe<Organizations_Metadata_Mutation_Response>>>;
  /** update data of the table: "permissions" */
  update_permissions?: Maybe<Permissions_Mutation_Response>;
  /** update single row of the table: "permissions" */
  update_permissions_by_pk?: Maybe<Permissions>;
  /** update multiples rows of table: "permissions" */
  update_permissions_many?: Maybe<Array<Maybe<Permissions_Mutation_Response>>>;
  /** update data of the table: "phone_numbers" */
  update_phone_numbers?: Maybe<Phone_Numbers_Mutation_Response>;
  /** update single row of the table: "phone_numbers" */
  update_phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** update multiples rows of table: "phone_numbers" */
  update_phone_numbers_many?: Maybe<Array<Maybe<Phone_Numbers_Mutation_Response>>>;
  /** update data of the table: "pii_databrokers" */
  update_pii_databrokers?: Maybe<Pii_Databrokers_Mutation_Response>;
  /** update single row of the table: "pii_databrokers" */
  update_pii_databrokers_by_pk?: Maybe<Pii_Databrokers>;
  /** update multiples rows of table: "pii_databrokers" */
  update_pii_databrokers_many?: Maybe<Array<Maybe<Pii_Databrokers_Mutation_Response>>>;
  /** update data of the table: "pii_events" */
  update_pii_events?: Maybe<Pii_Events_Mutation_Response>;
  /** update single row of the table: "pii_events" */
  update_pii_events_by_pk?: Maybe<Pii_Events>;
  /** update multiples rows of table: "pii_events" */
  update_pii_events_many?: Maybe<Array<Maybe<Pii_Events_Mutation_Response>>>;
  /** update data of the table: "pii_reports" */
  update_pii_reports?: Maybe<Pii_Reports_Mutation_Response>;
  /** update single row of the table: "pii_reports" */
  update_pii_reports_by_pk?: Maybe<Pii_Reports>;
  /** update multiples rows of table: "pii_reports" */
  update_pii_reports_many?: Maybe<Array<Maybe<Pii_Reports_Mutation_Response>>>;
  /** update data of the table: "pii_statistics" */
  update_pii_statistics?: Maybe<Pii_Statistics_Mutation_Response>;
  /** update single row of the table: "pii_statistics" */
  update_pii_statistics_by_pk?: Maybe<Pii_Statistics>;
  /** update multiples rows of table: "pii_statistics" */
  update_pii_statistics_many?: Maybe<Array<Maybe<Pii_Statistics_Mutation_Response>>>;
  /** update data of the table: "platform_subtypes" */
  update_platform_subtypes?: Maybe<Platform_Subtypes_Mutation_Response>;
  /** update single row of the table: "platform_subtypes" */
  update_platform_subtypes_by_pk?: Maybe<Platform_Subtypes>;
  /** update multiples rows of table: "platform_subtypes" */
  update_platform_subtypes_many?: Maybe<Array<Maybe<Platform_Subtypes_Mutation_Response>>>;
  /** update data of the table: "platforms" */
  update_platforms?: Maybe<Platforms_Mutation_Response>;
  /** update single row of the table: "platforms" */
  update_platforms_by_pk?: Maybe<Platforms>;
  /** update multiples rows of table: "platforms" */
  update_platforms_many?: Maybe<Array<Maybe<Platforms_Mutation_Response>>>;
  /** update data of the table: "pre_collections" */
  update_pre_collections?: Maybe<Pre_Collections_Mutation_Response>;
  /** update single row of the table: "pre_collections" */
  update_pre_collections_by_pk?: Maybe<Pre_Collections>;
  /** update multiples rows of table: "pre_collections" */
  update_pre_collections_many?: Maybe<Array<Maybe<Pre_Collections_Mutation_Response>>>;
  /** update data of the table: "predicted_enforcement_types" */
  update_predicted_enforcement_types?: Maybe<Predicted_Enforcement_Types_Mutation_Response>;
  /** update single row of the table: "predicted_enforcement_types" */
  update_predicted_enforcement_types_by_pk?: Maybe<Predicted_Enforcement_Types>;
  /** update multiples rows of table: "predicted_enforcement_types" */
  update_predicted_enforcement_types_many?: Maybe<Array<Maybe<Predicted_Enforcement_Types_Mutation_Response>>>;
  /** update data of the table: "protected_assets" */
  update_protected_assets?: Maybe<Protected_Assets_Mutation_Response>;
  /** update single row of the table: "protected_assets" */
  update_protected_assets_by_pk?: Maybe<Protected_Assets>;
  /** update multiples rows of table: "protected_assets" */
  update_protected_assets_many?: Maybe<Array<Maybe<Protected_Assets_Mutation_Response>>>;
  /** update data of the table: "report_tags" */
  update_report_tags?: Maybe<Report_Tags_Mutation_Response>;
  /** update single row of the table: "report_tags" */
  update_report_tags_by_pk?: Maybe<Report_Tags>;
  /** update multiples rows of table: "report_tags" */
  update_report_tags_many?: Maybe<Array<Maybe<Report_Tags_Mutation_Response>>>;
  /** Bulk updates reports with given fields. */
  update_reports_action?: Maybe<UpdateReportsOutput>;
  /** update data of the table: "reports_to_reports" */
  update_reports_to_reports?: Maybe<Reports_To_Reports_Mutation_Response>;
  /** update single row of the table: "reports_to_reports" */
  update_reports_to_reports_by_pk?: Maybe<Reports_To_Reports>;
  /** update multiples rows of table: "reports_to_reports" */
  update_reports_to_reports_many?: Maybe<Array<Maybe<Reports_To_Reports_Mutation_Response>>>;
  /** update data of the table: "role_permissions" */
  update_role_permissions?: Maybe<Role_Permissions_Mutation_Response>;
  /** update single row of the table: "role_permissions" */
  update_role_permissions_by_pk?: Maybe<Role_Permissions>;
  /** update multiples rows of table: "role_permissions" */
  update_role_permissions_many?: Maybe<Array<Maybe<Role_Permissions_Mutation_Response>>>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update multiples rows of table: "roles" */
  update_roles_many?: Maybe<Array<Maybe<Roles_Mutation_Response>>>;
  /** update data of the table: "rules" */
  update_rules?: Maybe<Rules_Mutation_Response>;
  /** update single row of the table: "rules" */
  update_rules_by_pk?: Maybe<Rules>;
  /** update multiples rows of table: "rules" */
  update_rules_many?: Maybe<Array<Maybe<Rules_Mutation_Response>>>;
  /** update data of the table: "safelist_ip_addresses" */
  update_safelist_ip_addresses?: Maybe<Safelist_Ip_Addresses_Mutation_Response>;
  /** update single row of the table: "safelist_ip_addresses" */
  update_safelist_ip_addresses_by_pk?: Maybe<Safelist_Ip_Addresses>;
  /** update multiples rows of table: "safelist_ip_addresses" */
  update_safelist_ip_addresses_many?: Maybe<Array<Maybe<Safelist_Ip_Addresses_Mutation_Response>>>;
  /** update data of the table: "salesforce_organizations_data" */
  update_salesforce_organizations_data?: Maybe<Salesforce_Organizations_Data_Mutation_Response>;
  /** update single row of the table: "salesforce_organizations_data" */
  update_salesforce_organizations_data_by_pk?: Maybe<Salesforce_Organizations_Data>;
  /** update multiples rows of table: "salesforce_organizations_data" */
  update_salesforce_organizations_data_many?: Maybe<Array<Maybe<Salesforce_Organizations_Data_Mutation_Response>>>;
  /** update data of the table: "scan_results" */
  update_scan_results?: Maybe<Scan_Results_Mutation_Response>;
  /** update single row of the table: "scan_results" */
  update_scan_results_by_pk?: Maybe<Scan_Results>;
  /** update multiples rows of table: "scan_results" */
  update_scan_results_many?: Maybe<Array<Maybe<Scan_Results_Mutation_Response>>>;
  /** update data of the table: "scans" */
  update_scans?: Maybe<Scans_Mutation_Response>;
  /** update single row of the table: "scans" */
  update_scans_by_pk?: Maybe<Scans>;
  /** update multiples rows of table: "scans" */
  update_scans_many?: Maybe<Array<Maybe<Scans_Mutation_Response>>>;
  /** update data of the table: "scraping_configs" */
  update_scraping_configs?: Maybe<Scraping_Configs_Mutation_Response>;
  /** update single row of the table: "scraping_configs" */
  update_scraping_configs_by_pk?: Maybe<Scraping_Configs>;
  /** update multiples rows of table: "scraping_configs" */
  update_scraping_configs_many?: Maybe<Array<Maybe<Scraping_Configs_Mutation_Response>>>;
  /** update data of the table: "sim_campaign_observations" */
  update_sim_campaign_observations?: Maybe<Sim_Campaign_Observations_Mutation_Response>;
  /** update single row of the table: "sim_campaign_observations" */
  update_sim_campaign_observations_by_pk?: Maybe<Sim_Campaign_Observations>;
  /** update multiples rows of table: "sim_campaign_observations" */
  update_sim_campaign_observations_many?: Maybe<Array<Maybe<Sim_Campaign_Observations_Mutation_Response>>>;
  /** update data of the table: "sim_campaigns" */
  update_sim_campaigns?: Maybe<Sim_Campaigns_Mutation_Response>;
  /** update single row of the table: "sim_campaigns" */
  update_sim_campaigns_by_pk?: Maybe<Sim_Campaigns>;
  /** update multiples rows of table: "sim_campaigns" */
  update_sim_campaigns_many?: Maybe<Array<Maybe<Sim_Campaigns_Mutation_Response>>>;
  /** update data of the table: "sim_emails" */
  update_sim_emails?: Maybe<Sim_Emails_Mutation_Response>;
  /** update single row of the table: "sim_emails" */
  update_sim_emails_by_pk?: Maybe<Sim_Emails>;
  /** update multiples rows of table: "sim_emails" */
  update_sim_emails_many?: Maybe<Array<Maybe<Sim_Emails_Mutation_Response>>>;
  /** update data of the table: "sim_groups" */
  update_sim_groups?: Maybe<Sim_Groups_Mutation_Response>;
  /** update single row of the table: "sim_groups" */
  update_sim_groups_by_pk?: Maybe<Sim_Groups>;
  /** update multiples rows of table: "sim_groups" */
  update_sim_groups_many?: Maybe<Array<Maybe<Sim_Groups_Mutation_Response>>>;
  /** update data of the table: "sim_users" */
  update_sim_users?: Maybe<Sim_Users_Mutation_Response>;
  /** update single row of the table: "sim_users" */
  update_sim_users_by_pk?: Maybe<Sim_Users>;
  /** update multiples rows of table: "sim_users" */
  update_sim_users_many?: Maybe<Array<Maybe<Sim_Users_Mutation_Response>>>;
  /** update data of the table: "slack_installations" */
  update_slack_installations?: Maybe<Slack_Installations_Mutation_Response>;
  /** update single row of the table: "slack_installations" */
  update_slack_installations_by_pk?: Maybe<Slack_Installations>;
  /** update multiples rows of table: "slack_installations" */
  update_slack_installations_many?: Maybe<Array<Maybe<Slack_Installations_Mutation_Response>>>;
  /** update data of the table: "social_media_comments" */
  update_social_media_comments?: Maybe<Social_Media_Comments_Mutation_Response>;
  /** update single row of the table: "social_media_comments" */
  update_social_media_comments_by_pk?: Maybe<Social_Media_Comments>;
  /** update multiples rows of table: "social_media_comments" */
  update_social_media_comments_many?: Maybe<Array<Maybe<Social_Media_Comments_Mutation_Response>>>;
  /** update data of the table: "social_media_data" */
  update_social_media_data?: Maybe<Social_Media_Data_Mutation_Response>;
  /** update single row of the table: "social_media_data" */
  update_social_media_data_by_pk?: Maybe<Social_Media_Data>;
  /** update multiples rows of table: "social_media_data" */
  update_social_media_data_many?: Maybe<Array<Maybe<Social_Media_Data_Mutation_Response>>>;
  /** update data of the table: "social_media_group" */
  update_social_media_group?: Maybe<Social_Media_Group_Mutation_Response>;
  /** update single row of the table: "social_media_group" */
  update_social_media_group_by_pk?: Maybe<Social_Media_Group>;
  /** update multiples rows of table: "social_media_group" */
  update_social_media_group_many?: Maybe<Array<Maybe<Social_Media_Group_Mutation_Response>>>;
  /** update data of the table: "social_media_post" */
  update_social_media_post?: Maybe<Social_Media_Post_Mutation_Response>;
  /** update single row of the table: "social_media_post" */
  update_social_media_post_by_pk?: Maybe<Social_Media_Post>;
  /** update multiples rows of table: "social_media_post" */
  update_social_media_post_many?: Maybe<Array<Maybe<Social_Media_Post_Mutation_Response>>>;
  /** update data of the table: "sourcing_queries" */
  update_sourcing_queries?: Maybe<Sourcing_Queries_Mutation_Response>;
  /** update single row of the table: "sourcing_queries" */
  update_sourcing_queries_by_pk?: Maybe<Sourcing_Queries>;
  /** update multiples rows of table: "sourcing_queries" */
  update_sourcing_queries_many?: Maybe<Array<Maybe<Sourcing_Queries_Mutation_Response>>>;
  /** update data of the table: "sourcing_query_executions" */
  update_sourcing_query_executions?: Maybe<Sourcing_Query_Executions_Mutation_Response>;
  /** update single row of the table: "sourcing_query_executions" */
  update_sourcing_query_executions_by_pk?: Maybe<Sourcing_Query_Executions>;
  /** update multiples rows of table: "sourcing_query_executions" */
  update_sourcing_query_executions_many?: Maybe<Array<Maybe<Sourcing_Query_Executions_Mutation_Response>>>;
  /** update data of the table: "spoof_matches" */
  update_spoof_matches?: Maybe<Spoof_Matches_Mutation_Response>;
  /** update single row of the table: "spoof_matches" */
  update_spoof_matches_by_pk?: Maybe<Spoof_Matches>;
  /** update multiples rows of table: "spoof_matches" */
  update_spoof_matches_many?: Maybe<Array<Maybe<Spoof_Matches_Mutation_Response>>>;
  /** update data of the table: "spoofing_entities" */
  update_spoofing_entities?: Maybe<Spoofing_Entities_Mutation_Response>;
  /** update single row of the table: "spoofing_entities" */
  update_spoofing_entities_by_pk?: Maybe<Spoofing_Entities>;
  /** update multiples rows of table: "spoofing_entities" */
  update_spoofing_entities_many?: Maybe<Array<Maybe<Spoofing_Entities_Mutation_Response>>>;
  /** update data of the table: "spoofing_report_search_results" */
  update_spoofing_report_search_results?: Maybe<Spoofing_Report_Search_Results_Mutation_Response>;
  /** update multiples rows of table: "spoofing_report_search_results" */
  update_spoofing_report_search_results_many?: Maybe<Array<Maybe<Spoofing_Report_Search_Results_Mutation_Response>>>;
  /** update data of the table: "spoofing_reports" */
  update_spoofing_reports?: Maybe<Spoofing_Reports_Mutation_Response>;
  /** update single row of the table: "spoofing_reports" */
  update_spoofing_reports_by_pk?: Maybe<Spoofing_Reports>;
  /** update multiples rows of table: "spoofing_reports" */
  update_spoofing_reports_many?: Maybe<Array<Maybe<Spoofing_Reports_Mutation_Response>>>;
  /** update data of the table: "spoofing_reports_to_tags" */
  update_spoofing_reports_to_tags?: Maybe<Spoofing_Reports_To_Tags_Mutation_Response>;
  /** update single row of the table: "spoofing_reports_to_tags" */
  update_spoofing_reports_to_tags_by_pk?: Maybe<Spoofing_Reports_To_Tags>;
  /** update multiples rows of table: "spoofing_reports_to_tags" */
  update_spoofing_reports_to_tags_many?: Maybe<Array<Maybe<Spoofing_Reports_To_Tags_Mutation_Response>>>;
  /** update data of the table: "suggested_enforcements" */
  update_suggested_enforcements?: Maybe<Suggested_Enforcements_Mutation_Response>;
  /** update single row of the table: "suggested_enforcements" */
  update_suggested_enforcements_by_pk?: Maybe<Suggested_Enforcements>;
  /** update data of the table: "suggested_enforcements_form_responses" */
  update_suggested_enforcements_form_responses?: Maybe<Suggested_Enforcements_Form_Responses_Mutation_Response>;
  /** update single row of the table: "suggested_enforcements_form_responses" */
  update_suggested_enforcements_form_responses_by_pk?: Maybe<Suggested_Enforcements_Form_Responses>;
  /** update multiples rows of table: "suggested_enforcements_form_responses" */
  update_suggested_enforcements_form_responses_many?: Maybe<Array<Maybe<Suggested_Enforcements_Form_Responses_Mutation_Response>>>;
  /** update multiples rows of table: "suggested_enforcements" */
  update_suggested_enforcements_many?: Maybe<Array<Maybe<Suggested_Enforcements_Mutation_Response>>>;
  /** update data of the table: "tags" */
  update_tags?: Maybe<Tags_Mutation_Response>;
  /** update single row of the table: "tags" */
  update_tags_by_pk?: Maybe<Tags>;
  /** update multiples rows of table: "tags" */
  update_tags_many?: Maybe<Array<Maybe<Tags_Mutation_Response>>>;
  /** update data of the table: "threat_intel_actor_to_campaign" */
  update_threat_intel_actor_to_campaign?: Maybe<Threat_Intel_Actor_To_Campaign_Mutation_Response>;
  /** update single row of the table: "threat_intel_actor_to_campaign" */
  update_threat_intel_actor_to_campaign_by_pk?: Maybe<Threat_Intel_Actor_To_Campaign>;
  /** update multiples rows of table: "threat_intel_actor_to_campaign" */
  update_threat_intel_actor_to_campaign_many?: Maybe<Array<Maybe<Threat_Intel_Actor_To_Campaign_Mutation_Response>>>;
  /** update data of the table: "threat_intel_actors" */
  update_threat_intel_actors?: Maybe<Threat_Intel_Actors_Mutation_Response>;
  /** update single row of the table: "threat_intel_actors" */
  update_threat_intel_actors_by_pk?: Maybe<Threat_Intel_Actors>;
  /** update multiples rows of table: "threat_intel_actors" */
  update_threat_intel_actors_many?: Maybe<Array<Maybe<Threat_Intel_Actors_Mutation_Response>>>;
  /** update data of the table: "threat_intel_campaign_to_entities" */
  update_threat_intel_campaign_to_entities?: Maybe<Threat_Intel_Campaign_To_Entities_Mutation_Response>;
  /** update single row of the table: "threat_intel_campaign_to_entities" */
  update_threat_intel_campaign_to_entities_by_pk?: Maybe<Threat_Intel_Campaign_To_Entities>;
  /** update multiples rows of table: "threat_intel_campaign_to_entities" */
  update_threat_intel_campaign_to_entities_many?: Maybe<Array<Maybe<Threat_Intel_Campaign_To_Entities_Mutation_Response>>>;
  /** update data of the table: "threat_intel_campaigns" */
  update_threat_intel_campaigns?: Maybe<Threat_Intel_Campaigns_Mutation_Response>;
  /** update single row of the table: "threat_intel_campaigns" */
  update_threat_intel_campaigns_by_pk?: Maybe<Threat_Intel_Campaigns>;
  /** update multiples rows of table: "threat_intel_campaigns" */
  update_threat_intel_campaigns_many?: Maybe<Array<Maybe<Threat_Intel_Campaigns_Mutation_Response>>>;
  /** update data of the table: "trademarks" */
  update_trademarks?: Maybe<Trademarks_Mutation_Response>;
  /** update single row of the table: "trademarks" */
  update_trademarks_by_pk?: Maybe<Trademarks>;
  /** update multiples rows of table: "trademarks" */
  update_trademarks_many?: Maybe<Array<Maybe<Trademarks_Mutation_Response>>>;
  /** update data of the table: "uploaded_files" */
  update_uploaded_files?: Maybe<Uploaded_Files_Mutation_Response>;
  /** update single row of the table: "uploaded_files" */
  update_uploaded_files_by_pk?: Maybe<Uploaded_Files>;
  /** update multiples rows of table: "uploaded_files" */
  update_uploaded_files_many?: Maybe<Array<Maybe<Uploaded_Files_Mutation_Response>>>;
  update_user_access?: Maybe<ManageUserAccessOutput>;
  /** update data of the table: "user_feedback" */
  update_user_feedback?: Maybe<User_Feedback_Mutation_Response>;
  /** update single row of the table: "user_feedback" */
  update_user_feedback_by_pk?: Maybe<User_Feedback>;
  /** update multiples rows of table: "user_feedback" */
  update_user_feedback_many?: Maybe<Array<Maybe<User_Feedback_Mutation_Response>>>;
  /** update data of the table: "user_organizations" */
  update_user_organizations?: Maybe<User_Organizations_Mutation_Response>;
  /** update single row of the table: "user_organizations" */
  update_user_organizations_by_pk?: Maybe<User_Organizations>;
  /** update multiples rows of table: "user_organizations" */
  update_user_organizations_many?: Maybe<Array<Maybe<User_Organizations_Mutation_Response>>>;
  /** update data of the table: "user_products" */
  update_user_products?: Maybe<User_Products_Mutation_Response>;
  /** update single row of the table: "user_products" */
  update_user_products_by_pk?: Maybe<User_Products>;
  /** update multiples rows of table: "user_products" */
  update_user_products_many?: Maybe<Array<Maybe<User_Products_Mutation_Response>>>;
  /** update user using manage_users_v2 */
  update_user_v2?: Maybe<UpdateUserOutput>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "vetric_screenshot_webhooks" */
  update_vetric_screenshot_webhooks?: Maybe<Vetric_Screenshot_Webhooks_Mutation_Response>;
  /** update single row of the table: "vetric_screenshot_webhooks" */
  update_vetric_screenshot_webhooks_by_pk?: Maybe<Vetric_Screenshot_Webhooks>;
  /** update multiples rows of table: "vetric_screenshot_webhooks" */
  update_vetric_screenshot_webhooks_many?: Maybe<Array<Maybe<Vetric_Screenshot_Webhooks_Mutation_Response>>>;
  /** update data of the table: "webhook_targets" */
  update_webhook_targets?: Maybe<Webhook_Targets_Mutation_Response>;
  /** update single row of the table: "webhook_targets" */
  update_webhook_targets_by_pk?: Maybe<Webhook_Targets>;
  /** update multiples rows of table: "webhook_targets" */
  update_webhook_targets_many?: Maybe<Array<Maybe<Webhook_Targets_Mutation_Response>>>;
  /** upload_new_alert */
  upload_new_alert_action?: Maybe<UploadNewAlertOutput>;
  /** Uploads a new detection asset to the system */
  upload_new_detection_asset?: Maybe<UploadNewDetectionAssetOutput>;
  upload_new_enforcement_request?: Maybe<UploadNewEnforcementRequestOutput>;
  /** upload_new_enforcement_request_v2 */
  upload_new_enforcement_request_v2?: Maybe<UploadNewEnforcementRequestV2Output>;
  /** Uploads a new enforcement template */
  upload_new_enforcement_template?: Maybe<UploadNewEnforcementTemplateOutput>;
  upload_new_nft_customer_collection?: Maybe<UploadNewNftCustomerCollectionOutput>;
  upload_new_nft_marketplace_collection?: Maybe<UploadNewNftMarketplaceCollectionOutput>;
  /** Uploads a new organization to the system */
  upload_new_organization?: Maybe<UploadNewOrganizationOutput>;
  /** Uploads a new platform */
  upload_new_platform?: Maybe<UploadNewPlatformOutput>;
  /** Uploads a new protected asset */
  upload_new_protected_asset?: Maybe<UploadNewProtectedAssetOutput>;
  upload_new_report_action?: Maybe<UploadNewReportOutput>;
  upload_new_trademark?: Maybe<UploadNewTrademarkOutput>;
  upload_new_web2_entity?: Maybe<UploadNewWeb2EntityOutput>;
  upload_report_file?: Maybe<UploadReportFileOutput>;
};


/** mutation root */
export type Mutation_RootAction_On_EmailArgs = {
  action_on_email_input: ActionOnEmailInput;
};


/** mutation root */
export type Mutation_RootArchive_Entity_LinkArgs = {
  archive_entity_links_input: ArchiveEntityLinksInput;
};


/** mutation root */
export type Mutation_RootCreate_Entity_LinkArgs = {
  create_entity_links_input: CreateEntityLinksInput;
};


/** mutation root */
export type Mutation_RootCreate_Pii_MemberArgs = {
  pii_create_member_input: PiiCreateMemberInput;
};


/** mutation root */
export type Mutation_RootCreate_Sim_CampaignArgs = {
  create_sim_campaign_input: CreateSimCampaignInput;
};


/** mutation root */
export type Mutation_RootCreate_UserArgs = {
  manage_users_input: ManageUsersInput;
};


/** mutation root */
export type Mutation_RootCreate_User_V2Args = {
  manage_users_input: ManageUsersInputV2;
};


/** mutation root */
export type Mutation_RootDelete_Advertisement_DataArgs = {
  where: Advertisement_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Advertisement_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Advertiser_DataArgs = {
  where: Advertiser_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Advertiser_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ai_PromptsArgs = {
  where: Ai_Prompts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ai_Prompts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ai_ResponsesArgs = {
  where: Ai_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ai_Responses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_AlertArgs = {
  delete_alert_input: DeleteAlertInput;
};


/** mutation root */
export type Mutation_RootDelete_Alert_HashesArgs = {
  where: Alert_Hashes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Alert_Hashes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Alert_Label_EventsArgs = {
  where: Alert_Label_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Alert_Label_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Alert_LinksArgs = {
  where: Alert_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Alert_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Api_TokensArgs = {
  where: Api_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Api_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Api_Usage_RecordsArgs = {
  where: Api_Usage_Records_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Api_Usage_Records_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Apify_Scraping_JobsArgs = {
  where: Apify_Scraping_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Apify_Scraping_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ApprovalsArgs = {
  where: Approvals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Approvals_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Audit_Logged_ActionsArgs = {
  where: Audit_Logged_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Audit_Logged_Actions_By_PkArgs = {
  event_id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Collection_Report_ChangesArgs = {
  where: Collection_Report_Changes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Collection_Report_Changes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Collection_Report_State_ChangesArgs = {
  where: Collection_Report_State_Changes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Collection_Report_State_Changes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Credit_CardsArgs = {
  where: Credit_Cards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Credit_Cards_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_AssetsArgs = {
  where: Customer_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_Assets_To_BrandsArgs = {
  where: Customer_Assets_To_Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Assets_To_Brands_By_PkArgs = {
  brand_id: Scalars['uuid'];
  customer_asset_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Dark_WebArgs = {
  where: Dark_Web_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dark_Web_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Defensive_Domain_RegistrationArgs = {
  where: Defensive_Domain_Registration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Defensive_Domain_Registration_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Designated_Takedown_AssetsArgs = {
  where: Designated_Takedown_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Designated_Takedown_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Detection_AssetsArgs = {
  where: Detection_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Detection_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Detection_Config_ApprovalsArgs = {
  where: Detection_Config_Approvals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Detection_Config_Approvals_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Domain_DataArgs = {
  where: Domain_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Domain_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Domain_Match_DataArgs = {
  where: Domain_Match_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Domain_Match_Data_By_PkArgs = {
  flagged_url: Scalars['String'];
  spoofing_entities_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ecommerce_ListingsArgs = {
  where: Ecommerce_Listings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ecommerce_Listings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Email_AddressesArgs = {
  where: Email_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Addresses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Email_CorrespondenceArgs = {
  where: Email_Correspondence_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Correspondence_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Email_SettingsArgs = {
  where: Email_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_EmailsArgs = {
  where: Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Emails_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_EmailsArgs = {
  where: Enforcement_Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_Emails_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_MetadataArgs = {
  where: Enforcement_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_PlatformsArgs = {
  where: Enforcement_Platforms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_Platforms_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_RequestsArgs = {
  where: Enforcement_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_Requests_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_TemplatesArgs = {
  where: Enforcement_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_Templates_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_TypesArgs = {
  where: Enforcement_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enforcement_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Entity_AggregatesArgs = {
  where: Entity_Aggregates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Entity_Aggregates_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Entity_DataArgs = {
  where: Entity_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Entity_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Entity_LinksArgs = {
  where: Entity_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Entity_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Entity_State_ClassificationsArgs = {
  where: Entity_State_Classifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Entity_State_Classifications_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Full_UrlsArgs = {
  where: Full_Urls_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Full_Urls_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Hourly_Spoofing_Reports_StatsArgs = {
  where: Hourly_Spoofing_Reports_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hourly_Spoofing_Reports_Stats_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ioc_Alert_AttributionArgs = {
  where: Ioc_Alert_Attribution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ioc_Alert_Attribution_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ioc_Detection_Config_AttributionArgs = {
  where: Ioc_Detection_Config_Attribution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ioc_Detection_Config_Attribution_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ioc_Entity_Data_AttributionArgs = {
  where: Ioc_Entity_Data_Attribution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ioc_Entity_Data_Attribution_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_IocsArgs = {
  where: Iocs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Iocs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Jira_MetadataArgs = {
  where: Jira_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Jira_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Match_AttributionsArgs = {
  where: Match_Attributions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Match_Attributions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ml_FeaturesArgs = {
  where: Ml_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ml_Features_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Mobile_AppsArgs = {
  where: Mobile_Apps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mobile_Apps_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Nft_Opensea_ProcessedArgs = {
  where: Nft_Opensea_Processed_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nft_Opensea_Processed_By_PkArgs = {
  direction: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Nft_Processing_CursorArgs = {
  where: Nft_Processing_Cursor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nft_Processing_Cursor_By_PkArgs = {
  direction: Scalars['String'];
  marketplace: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_SubscriptionsArgs = {
  where: Notification_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Subscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Id_Api_KeysArgs = {
  where: Organization_Id_Api_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Id_Api_Keys_By_PkArgs = {
  api_key: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_ProductsArgs = {
  where: Organization_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Products_By_PkArgs = {
  organization_id: Scalars['uuid'];
  product: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationsArgs = {
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organizations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organizations_MetadataArgs = {
  where: Organizations_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organizations_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PermissionsArgs = {
  where: Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Permissions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Phone_NumbersArgs = {
  where: Phone_Numbers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Phone_Numbers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Pii_DatabrokersArgs = {
  where: Pii_Databrokers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pii_Databrokers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Pii_EventsArgs = {
  where: Pii_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pii_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Pii_MemberArgs = {
  pii_delete_member_input: PiiDeleteMemberInput;
};


/** mutation root */
export type Mutation_RootDelete_Pii_ReportsArgs = {
  where: Pii_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pii_Reports_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Pii_StatisticsArgs = {
  where: Pii_Statistics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pii_Statistics_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Platform_SubtypesArgs = {
  where: Platform_Subtypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Platform_Subtypes_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_PlatformsArgs = {
  where: Platforms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Platforms_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Pre_CollectionsArgs = {
  where: Pre_Collections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pre_Collections_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Predicted_Enforcement_TypesArgs = {
  where: Predicted_Enforcement_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Predicted_Enforcement_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Protected_AssetsArgs = {
  where: Protected_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Protected_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Report_FileArgs = {
  delete_report_file_input: DeleteReportFileInput;
};


/** mutation root */
export type Mutation_RootDelete_Report_TagsArgs = {
  where: Report_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Report_Tags_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Reports_To_ReportsArgs = {
  where: Reports_To_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reports_To_Reports_By_PkArgs = {
  dest_report_id: Scalars['uuid'];
  relationship_type: Scalars['String'];
  source_report_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Role_PermissionsArgs = {
  where: Role_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_Permissions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_RulesArgs = {
  where: Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rules_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Safelist_Ip_AddressesArgs = {
  where: Safelist_Ip_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Safelist_Ip_Addresses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Salesforce_Organizations_DataArgs = {
  where: Salesforce_Organizations_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Salesforce_Organizations_Data_By_PkArgs = {
  account_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Scan_ResultsArgs = {
  where: Scan_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scan_Results_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ScansArgs = {
  where: Scans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scans_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Scraping_ConfigsArgs = {
  where: Scraping_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Scraping_Configs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sim_Campaign_ObservationsArgs = {
  where: Sim_Campaign_Observations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sim_Campaign_Observations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sim_CampaignsArgs = {
  where: Sim_Campaigns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sim_Campaigns_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sim_EmailsArgs = {
  where: Sim_Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sim_Emails_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sim_GroupsArgs = {
  where: Sim_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sim_Groups_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sim_UsersArgs = {
  where: Sim_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sim_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Slack_InstallationsArgs = {
  where: Slack_Installations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Slack_Installations_By_PkArgs = {
  team_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Social_Media_CommentsArgs = {
  where: Social_Media_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Social_Media_Comments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Social_Media_DataArgs = {
  where: Social_Media_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Social_Media_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Social_Media_GroupArgs = {
  where: Social_Media_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Social_Media_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Social_Media_PostArgs = {
  where: Social_Media_Post_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Social_Media_Post_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sourcing_QueriesArgs = {
  where: Sourcing_Queries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sourcing_Queries_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Sourcing_Query_ExecutionsArgs = {
  where: Sourcing_Query_Executions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Sourcing_Query_Executions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Spoof_MatchesArgs = {
  where: Spoof_Matches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Spoof_Matches_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Spoofing_EntitiesArgs = {
  where: Spoofing_Entities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Spoofing_Entities_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Spoofing_Report_Search_ResultsArgs = {
  where: Spoofing_Report_Search_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Spoofing_ReportsArgs = {
  where: Spoofing_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Spoofing_Reports_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Spoofing_Reports_To_TagsArgs = {
  where: Spoofing_Reports_To_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Spoofing_Reports_To_Tags_By_PkArgs = {
  spoofing_report_id: Scalars['uuid'];
  tag_name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Suggested_EnforcementsArgs = {
  where: Suggested_Enforcements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Suggested_Enforcements_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Suggested_Enforcements_Form_ResponsesArgs = {
  where: Suggested_Enforcements_Form_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Suggested_Enforcements_Form_Responses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TagsArgs = {
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tags_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Threat_Intel_Actor_To_CampaignArgs = {
  where: Threat_Intel_Actor_To_Campaign_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Threat_Intel_Actor_To_Campaign_By_PkArgs = {
  actor_id: Scalars['uuid'];
  campaign_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Threat_Intel_ActorsArgs = {
  where: Threat_Intel_Actors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Threat_Intel_Actors_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Threat_Intel_Campaign_To_EntitiesArgs = {
  where: Threat_Intel_Campaign_To_Entities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Threat_Intel_Campaign_To_Entities_By_PkArgs = {
  campaign_id: Scalars['uuid'];
  entity_data_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Threat_Intel_CampaignsArgs = {
  where: Threat_Intel_Campaigns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Threat_Intel_Campaigns_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TrademarksArgs = {
  where: Trademarks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademarks_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Uploaded_FilesArgs = {
  where: Uploaded_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uploaded_Files_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  manage_users_input: DeleteUserInput;
};


/** mutation root */
export type Mutation_RootDelete_User_FeedbackArgs = {
  where: User_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Feedback_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_OrganizationsArgs = {
  where: User_Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Organizations_By_PkArgs = {
  organization_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_ProductsArgs = {
  where: User_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Products_By_PkArgs = {
  organization_id: Scalars['uuid'];
  product: Scalars['String'];
  user_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Vetric_Screenshot_WebhooksArgs = {
  where: Vetric_Screenshot_Webhooks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vetric_Screenshot_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Webhook_TargetsArgs = {
  where: Webhook_Targets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Webhook_Targets_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootEdit_Pii_MemberArgs = {
  pii_edit_member_input: PiiEditMemberInput;
};


/** mutation root */
export type Mutation_RootGenerate_Suggested_EnforcementsArgs = {
  generate_suggested_enforcements_input?: InputMaybe<GenerateSuggestedEnforcementsInput>;
};


/** mutation root */
export type Mutation_RootHandle_Admin_Url_Search_RequestArgs = {
  handle_admin_url_search_request_input: HandleAdminUrlSearchRequestInput;
};


/** mutation root */
export type Mutation_RootHandle_Auto_Actioning_Alert_SelectionArgs = {
  handle_auto_actioning_alert_selection_input?: InputMaybe<HandleAutoActioningAlertSelectionInput>;
};


/** mutation root */
export type Mutation_RootHandle_Synchronous_Detection_RequestArgs = {
  handle_synchronous_detection_request_input: HandleSynchronousDetectionRequestInput;
};


/** mutation root */
export type Mutation_RootHandle_Synchronous_Detection_Request_Async_ActionArgs = {
  handle_synchronous_detection_request_input: HandleSynchronousDetectionRequestAsyncActionInput;
};


/** mutation root */
export type Mutation_RootInsert_Advertisement_DataArgs = {
  objects: Array<Advertisement_Data_Insert_Input>;
  on_conflict?: InputMaybe<Advertisement_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advertisement_Data_OneArgs = {
  object: Advertisement_Data_Insert_Input;
  on_conflict?: InputMaybe<Advertisement_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advertiser_DataArgs = {
  objects: Array<Advertiser_Data_Insert_Input>;
  on_conflict?: InputMaybe<Advertiser_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Advertiser_Data_OneArgs = {
  object: Advertiser_Data_Insert_Input;
  on_conflict?: InputMaybe<Advertiser_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_PromptsArgs = {
  objects: Array<Ai_Prompts_Insert_Input>;
  on_conflict?: InputMaybe<Ai_Prompts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_Prompts_OneArgs = {
  object: Ai_Prompts_Insert_Input;
  on_conflict?: InputMaybe<Ai_Prompts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_ResponsesArgs = {
  objects: Array<Ai_Responses_Insert_Input>;
  on_conflict?: InputMaybe<Ai_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_Responses_OneArgs = {
  object: Ai_Responses_Insert_Input;
  on_conflict?: InputMaybe<Ai_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alert_HashesArgs = {
  objects: Array<Alert_Hashes_Insert_Input>;
  on_conflict?: InputMaybe<Alert_Hashes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alert_Hashes_OneArgs = {
  object: Alert_Hashes_Insert_Input;
  on_conflict?: InputMaybe<Alert_Hashes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alert_Label_EventsArgs = {
  objects: Array<Alert_Label_Events_Insert_Input>;
  on_conflict?: InputMaybe<Alert_Label_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alert_Label_Events_OneArgs = {
  object: Alert_Label_Events_Insert_Input;
  on_conflict?: InputMaybe<Alert_Label_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alert_LinksArgs = {
  objects: Array<Alert_Links_Insert_Input>;
  on_conflict?: InputMaybe<Alert_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Alert_Links_OneArgs = {
  object: Alert_Links_Insert_Input;
  on_conflict?: InputMaybe<Alert_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Api_TokensArgs = {
  objects: Array<Api_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Api_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Api_Tokens_OneArgs = {
  object: Api_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Api_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Api_Usage_RecordsArgs = {
  objects: Array<Api_Usage_Records_Insert_Input>;
  on_conflict?: InputMaybe<Api_Usage_Records_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Api_Usage_Records_OneArgs = {
  object: Api_Usage_Records_Insert_Input;
  on_conflict?: InputMaybe<Api_Usage_Records_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Apify_Scraping_JobsArgs = {
  objects: Array<Apify_Scraping_Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Apify_Scraping_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Apify_Scraping_Jobs_OneArgs = {
  object: Apify_Scraping_Jobs_Insert_Input;
  on_conflict?: InputMaybe<Apify_Scraping_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApprovalsArgs = {
  objects: Array<Approvals_Insert_Input>;
  on_conflict?: InputMaybe<Approvals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Approvals_OneArgs = {
  object: Approvals_Insert_Input;
  on_conflict?: InputMaybe<Approvals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Logged_ActionsArgs = {
  objects: Array<Audit_Logged_Actions_Insert_Input>;
  on_conflict?: InputMaybe<Audit_Logged_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Logged_Actions_OneArgs = {
  object: Audit_Logged_Actions_Insert_Input;
  on_conflict?: InputMaybe<Audit_Logged_Actions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Collection_Report_ChangesArgs = {
  objects: Array<Collection_Report_Changes_Insert_Input>;
  on_conflict?: InputMaybe<Collection_Report_Changes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Collection_Report_Changes_OneArgs = {
  object: Collection_Report_Changes_Insert_Input;
  on_conflict?: InputMaybe<Collection_Report_Changes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Collection_Report_State_ChangesArgs = {
  objects: Array<Collection_Report_State_Changes_Insert_Input>;
  on_conflict?: InputMaybe<Collection_Report_State_Changes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Collection_Report_State_Changes_OneArgs = {
  object: Collection_Report_State_Changes_Insert_Input;
  on_conflict?: InputMaybe<Collection_Report_State_Changes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_CardsArgs = {
  objects: Array<Credit_Cards_Insert_Input>;
  on_conflict?: InputMaybe<Credit_Cards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Cards_OneArgs = {
  object: Credit_Cards_Insert_Input;
  on_conflict?: InputMaybe<Credit_Cards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_AssetsArgs = {
  objects: Array<Customer_Assets_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Assets_OneArgs = {
  object: Customer_Assets_Insert_Input;
  on_conflict?: InputMaybe<Customer_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Assets_To_BrandsArgs = {
  objects: Array<Customer_Assets_To_Brands_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Assets_To_Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Assets_To_Brands_OneArgs = {
  object: Customer_Assets_To_Brands_Insert_Input;
  on_conflict?: InputMaybe<Customer_Assets_To_Brands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dark_WebArgs = {
  objects: Array<Dark_Web_Insert_Input>;
  on_conflict?: InputMaybe<Dark_Web_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dark_Web_OneArgs = {
  object: Dark_Web_Insert_Input;
  on_conflict?: InputMaybe<Dark_Web_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Defensive_Domain_RegistrationArgs = {
  objects: Array<Defensive_Domain_Registration_Insert_Input>;
  on_conflict?: InputMaybe<Defensive_Domain_Registration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Defensive_Domain_Registration_OneArgs = {
  object: Defensive_Domain_Registration_Insert_Input;
  on_conflict?: InputMaybe<Defensive_Domain_Registration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Designated_Takedown_AssetsArgs = {
  objects: Array<Designated_Takedown_Assets_Insert_Input>;
  on_conflict?: InputMaybe<Designated_Takedown_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Designated_Takedown_Assets_OneArgs = {
  object: Designated_Takedown_Assets_Insert_Input;
  on_conflict?: InputMaybe<Designated_Takedown_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Detection_AssetsArgs = {
  objects: Array<Detection_Assets_Insert_Input>;
  on_conflict?: InputMaybe<Detection_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Detection_Assets_OneArgs = {
  object: Detection_Assets_Insert_Input;
  on_conflict?: InputMaybe<Detection_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Detection_Config_ApprovalsArgs = {
  objects: Array<Detection_Config_Approvals_Insert_Input>;
  on_conflict?: InputMaybe<Detection_Config_Approvals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Detection_Config_Approvals_OneArgs = {
  object: Detection_Config_Approvals_Insert_Input;
  on_conflict?: InputMaybe<Detection_Config_Approvals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Domain_DataArgs = {
  objects: Array<Domain_Data_Insert_Input>;
  on_conflict?: InputMaybe<Domain_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Domain_Data_OneArgs = {
  object: Domain_Data_Insert_Input;
  on_conflict?: InputMaybe<Domain_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Domain_Match_DataArgs = {
  objects: Array<Domain_Match_Data_Insert_Input>;
  on_conflict?: InputMaybe<Domain_Match_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Domain_Match_Data_OneArgs = {
  object: Domain_Match_Data_Insert_Input;
  on_conflict?: InputMaybe<Domain_Match_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ecommerce_ListingsArgs = {
  objects: Array<Ecommerce_Listings_Insert_Input>;
  on_conflict?: InputMaybe<Ecommerce_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ecommerce_Listings_OneArgs = {
  object: Ecommerce_Listings_Insert_Input;
  on_conflict?: InputMaybe<Ecommerce_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_AddressesArgs = {
  objects: Array<Email_Addresses_Insert_Input>;
  on_conflict?: InputMaybe<Email_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Addresses_OneArgs = {
  object: Email_Addresses_Insert_Input;
  on_conflict?: InputMaybe<Email_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_CorrespondenceArgs = {
  objects: Array<Email_Correspondence_Insert_Input>;
  on_conflict?: InputMaybe<Email_Correspondence_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Correspondence_OneArgs = {
  object: Email_Correspondence_Insert_Input;
  on_conflict?: InputMaybe<Email_Correspondence_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_SettingsArgs = {
  objects: Array<Email_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Email_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Settings_OneArgs = {
  object: Email_Settings_Insert_Input;
  on_conflict?: InputMaybe<Email_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EmailsArgs = {
  objects: Array<Emails_Insert_Input>;
  on_conflict?: InputMaybe<Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Emails_OneArgs = {
  object: Emails_Insert_Input;
  on_conflict?: InputMaybe<Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_EmailsArgs = {
  objects: Array<Enforcement_Emails_Insert_Input>;
  on_conflict?: InputMaybe<Enforcement_Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_Emails_OneArgs = {
  object: Enforcement_Emails_Insert_Input;
  on_conflict?: InputMaybe<Enforcement_Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_MetadataArgs = {
  objects: Array<Enforcement_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Enforcement_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_Metadata_OneArgs = {
  object: Enforcement_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Enforcement_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_PlatformsArgs = {
  objects: Array<Enforcement_Platforms_Insert_Input>;
  on_conflict?: InputMaybe<Enforcement_Platforms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_Platforms_OneArgs = {
  object: Enforcement_Platforms_Insert_Input;
  on_conflict?: InputMaybe<Enforcement_Platforms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_RequestsArgs = {
  objects: Array<Enforcement_Requests_Insert_Input>;
  on_conflict?: InputMaybe<Enforcement_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_Requests_OneArgs = {
  object: Enforcement_Requests_Insert_Input;
  on_conflict?: InputMaybe<Enforcement_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_TemplatesArgs = {
  objects: Array<Enforcement_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Enforcement_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_Templates_OneArgs = {
  object: Enforcement_Templates_Insert_Input;
  on_conflict?: InputMaybe<Enforcement_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_TypesArgs = {
  objects: Array<Enforcement_Types_Insert_Input>;
  on_conflict?: InputMaybe<Enforcement_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enforcement_Types_OneArgs = {
  object: Enforcement_Types_Insert_Input;
  on_conflict?: InputMaybe<Enforcement_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_AggregatesArgs = {
  objects: Array<Entity_Aggregates_Insert_Input>;
  on_conflict?: InputMaybe<Entity_Aggregates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_Aggregates_OneArgs = {
  object: Entity_Aggregates_Insert_Input;
  on_conflict?: InputMaybe<Entity_Aggregates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_DataArgs = {
  objects: Array<Entity_Data_Insert_Input>;
  on_conflict?: InputMaybe<Entity_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_Data_OneArgs = {
  object: Entity_Data_Insert_Input;
  on_conflict?: InputMaybe<Entity_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_LinksArgs = {
  objects: Array<Entity_Links_Insert_Input>;
  on_conflict?: InputMaybe<Entity_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_Links_OneArgs = {
  object: Entity_Links_Insert_Input;
  on_conflict?: InputMaybe<Entity_Links_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_State_ClassificationsArgs = {
  objects: Array<Entity_State_Classifications_Insert_Input>;
  on_conflict?: InputMaybe<Entity_State_Classifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_State_Classifications_OneArgs = {
  object: Entity_State_Classifications_Insert_Input;
  on_conflict?: InputMaybe<Entity_State_Classifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Full_UrlsArgs = {
  objects: Array<Full_Urls_Insert_Input>;
  on_conflict?: InputMaybe<Full_Urls_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Full_Urls_OneArgs = {
  object: Full_Urls_Insert_Input;
  on_conflict?: InputMaybe<Full_Urls_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hourly_Spoofing_Reports_StatsArgs = {
  objects: Array<Hourly_Spoofing_Reports_Stats_Insert_Input>;
  on_conflict?: InputMaybe<Hourly_Spoofing_Reports_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hourly_Spoofing_Reports_Stats_OneArgs = {
  object: Hourly_Spoofing_Reports_Stats_Insert_Input;
  on_conflict?: InputMaybe<Hourly_Spoofing_Reports_Stats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ioc_Alert_AttributionArgs = {
  objects: Array<Ioc_Alert_Attribution_Insert_Input>;
  on_conflict?: InputMaybe<Ioc_Alert_Attribution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ioc_Alert_Attribution_OneArgs = {
  object: Ioc_Alert_Attribution_Insert_Input;
  on_conflict?: InputMaybe<Ioc_Alert_Attribution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ioc_Detection_Config_AttributionArgs = {
  objects: Array<Ioc_Detection_Config_Attribution_Insert_Input>;
  on_conflict?: InputMaybe<Ioc_Detection_Config_Attribution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ioc_Detection_Config_Attribution_OneArgs = {
  object: Ioc_Detection_Config_Attribution_Insert_Input;
  on_conflict?: InputMaybe<Ioc_Detection_Config_Attribution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ioc_Entity_Data_AttributionArgs = {
  objects: Array<Ioc_Entity_Data_Attribution_Insert_Input>;
  on_conflict?: InputMaybe<Ioc_Entity_Data_Attribution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ioc_Entity_Data_Attribution_OneArgs = {
  object: Ioc_Entity_Data_Attribution_Insert_Input;
  on_conflict?: InputMaybe<Ioc_Entity_Data_Attribution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IocsArgs = {
  objects: Array<Iocs_Insert_Input>;
  on_conflict?: InputMaybe<Iocs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Iocs_OneArgs = {
  object: Iocs_Insert_Input;
  on_conflict?: InputMaybe<Iocs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Jira_MetadataArgs = {
  objects: Array<Jira_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Jira_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Jira_Metadata_OneArgs = {
  object: Jira_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Jira_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Match_AttributionsArgs = {
  objects: Array<Match_Attributions_Insert_Input>;
  on_conflict?: InputMaybe<Match_Attributions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Match_Attributions_OneArgs = {
  object: Match_Attributions_Insert_Input;
  on_conflict?: InputMaybe<Match_Attributions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ml_FeaturesArgs = {
  objects: Array<Ml_Features_Insert_Input>;
  on_conflict?: InputMaybe<Ml_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ml_Features_OneArgs = {
  object: Ml_Features_Insert_Input;
  on_conflict?: InputMaybe<Ml_Features_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mobile_AppsArgs = {
  objects: Array<Mobile_Apps_Insert_Input>;
  on_conflict?: InputMaybe<Mobile_Apps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mobile_Apps_OneArgs = {
  object: Mobile_Apps_Insert_Input;
  on_conflict?: InputMaybe<Mobile_Apps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nft_Opensea_ProcessedArgs = {
  objects: Array<Nft_Opensea_Processed_Insert_Input>;
  on_conflict?: InputMaybe<Nft_Opensea_Processed_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nft_Opensea_Processed_OneArgs = {
  object: Nft_Opensea_Processed_Insert_Input;
  on_conflict?: InputMaybe<Nft_Opensea_Processed_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nft_Processing_CursorArgs = {
  objects: Array<Nft_Processing_Cursor_Insert_Input>;
  on_conflict?: InputMaybe<Nft_Processing_Cursor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nft_Processing_Cursor_OneArgs = {
  object: Nft_Processing_Cursor_Insert_Input;
  on_conflict?: InputMaybe<Nft_Processing_Cursor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_SubscriptionsArgs = {
  objects: Array<Notification_Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Subscriptions_OneArgs = {
  object: Notification_Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<Notification_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Id_Api_KeysArgs = {
  objects: Array<Organization_Id_Api_Keys_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Id_Api_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Id_Api_Keys_OneArgs = {
  object: Organization_Id_Api_Keys_Insert_Input;
  on_conflict?: InputMaybe<Organization_Id_Api_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_ProductsArgs = {
  objects: Array<Organization_Products_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Products_OneArgs = {
  object: Organization_Products_Insert_Input;
  on_conflict?: InputMaybe<Organization_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationsArgs = {
  objects: Array<Organizations_Insert_Input>;
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_MetadataArgs = {
  objects: Array<Organizations_Metadata_Insert_Input>;
  on_conflict?: InputMaybe<Organizations_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_Metadata_OneArgs = {
  object: Organizations_Metadata_Insert_Input;
  on_conflict?: InputMaybe<Organizations_Metadata_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_OneArgs = {
  object: Organizations_Insert_Input;
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PermissionsArgs = {
  objects: Array<Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permissions_OneArgs = {
  object: Permissions_Insert_Input;
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_NumbersArgs = {
  objects: Array<Phone_Numbers_Insert_Input>;
  on_conflict?: InputMaybe<Phone_Numbers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_Numbers_OneArgs = {
  object: Phone_Numbers_Insert_Input;
  on_conflict?: InputMaybe<Phone_Numbers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pii_DatabrokersArgs = {
  objects: Array<Pii_Databrokers_Insert_Input>;
  on_conflict?: InputMaybe<Pii_Databrokers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pii_Databrokers_OneArgs = {
  object: Pii_Databrokers_Insert_Input;
  on_conflict?: InputMaybe<Pii_Databrokers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pii_EventsArgs = {
  objects: Array<Pii_Events_Insert_Input>;
  on_conflict?: InputMaybe<Pii_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pii_Events_OneArgs = {
  object: Pii_Events_Insert_Input;
  on_conflict?: InputMaybe<Pii_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pii_ReportsArgs = {
  objects: Array<Pii_Reports_Insert_Input>;
  on_conflict?: InputMaybe<Pii_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pii_Reports_OneArgs = {
  object: Pii_Reports_Insert_Input;
  on_conflict?: InputMaybe<Pii_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pii_StatisticsArgs = {
  objects: Array<Pii_Statistics_Insert_Input>;
  on_conflict?: InputMaybe<Pii_Statistics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pii_Statistics_OneArgs = {
  object: Pii_Statistics_Insert_Input;
  on_conflict?: InputMaybe<Pii_Statistics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Platform_SubtypesArgs = {
  objects: Array<Platform_Subtypes_Insert_Input>;
  on_conflict?: InputMaybe<Platform_Subtypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Platform_Subtypes_OneArgs = {
  object: Platform_Subtypes_Insert_Input;
  on_conflict?: InputMaybe<Platform_Subtypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlatformsArgs = {
  objects: Array<Platforms_Insert_Input>;
  on_conflict?: InputMaybe<Platforms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Platforms_OneArgs = {
  object: Platforms_Insert_Input;
  on_conflict?: InputMaybe<Platforms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pre_CollectionsArgs = {
  objects: Array<Pre_Collections_Insert_Input>;
  on_conflict?: InputMaybe<Pre_Collections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pre_Collections_OneArgs = {
  object: Pre_Collections_Insert_Input;
  on_conflict?: InputMaybe<Pre_Collections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Predicted_Enforcement_TypesArgs = {
  objects: Array<Predicted_Enforcement_Types_Insert_Input>;
  on_conflict?: InputMaybe<Predicted_Enforcement_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Predicted_Enforcement_Types_OneArgs = {
  object: Predicted_Enforcement_Types_Insert_Input;
  on_conflict?: InputMaybe<Predicted_Enforcement_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Protected_AssetsArgs = {
  objects: Array<Protected_Assets_Insert_Input>;
  on_conflict?: InputMaybe<Protected_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Protected_Assets_OneArgs = {
  object: Protected_Assets_Insert_Input;
  on_conflict?: InputMaybe<Protected_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_TagsArgs = {
  objects: Array<Report_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Report_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_Tags_OneArgs = {
  object: Report_Tags_Insert_Input;
  on_conflict?: InputMaybe<Report_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reports_To_ReportsArgs = {
  objects: Array<Reports_To_Reports_Insert_Input>;
  on_conflict?: InputMaybe<Reports_To_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reports_To_Reports_OneArgs = {
  object: Reports_To_Reports_Insert_Input;
  on_conflict?: InputMaybe<Reports_To_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_PermissionsArgs = {
  objects: Array<Role_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Role_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_Permissions_OneArgs = {
  object: Role_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Role_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RulesArgs = {
  objects: Array<Rules_Insert_Input>;
  on_conflict?: InputMaybe<Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rules_OneArgs = {
  object: Rules_Insert_Input;
  on_conflict?: InputMaybe<Rules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safelist_Ip_AddressesArgs = {
  objects: Array<Safelist_Ip_Addresses_Insert_Input>;
  on_conflict?: InputMaybe<Safelist_Ip_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Safelist_Ip_Addresses_OneArgs = {
  object: Safelist_Ip_Addresses_Insert_Input;
  on_conflict?: InputMaybe<Safelist_Ip_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Salesforce_Organizations_DataArgs = {
  objects: Array<Salesforce_Organizations_Data_Insert_Input>;
  on_conflict?: InputMaybe<Salesforce_Organizations_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Salesforce_Organizations_Data_OneArgs = {
  object: Salesforce_Organizations_Data_Insert_Input;
  on_conflict?: InputMaybe<Salesforce_Organizations_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scan_ResultsArgs = {
  objects: Array<Scan_Results_Insert_Input>;
  on_conflict?: InputMaybe<Scan_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scan_Results_OneArgs = {
  object: Scan_Results_Insert_Input;
  on_conflict?: InputMaybe<Scan_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ScansArgs = {
  objects: Array<Scans_Insert_Input>;
  on_conflict?: InputMaybe<Scans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scans_OneArgs = {
  object: Scans_Insert_Input;
  on_conflict?: InputMaybe<Scans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scraping_ConfigsArgs = {
  objects: Array<Scraping_Configs_Insert_Input>;
  on_conflict?: InputMaybe<Scraping_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scraping_Configs_OneArgs = {
  object: Scraping_Configs_Insert_Input;
  on_conflict?: InputMaybe<Scraping_Configs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sim_Campaign_ObservationsArgs = {
  objects: Array<Sim_Campaign_Observations_Insert_Input>;
  on_conflict?: InputMaybe<Sim_Campaign_Observations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sim_Campaign_Observations_OneArgs = {
  object: Sim_Campaign_Observations_Insert_Input;
  on_conflict?: InputMaybe<Sim_Campaign_Observations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sim_CampaignsArgs = {
  objects: Array<Sim_Campaigns_Insert_Input>;
  on_conflict?: InputMaybe<Sim_Campaigns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sim_Campaigns_OneArgs = {
  object: Sim_Campaigns_Insert_Input;
  on_conflict?: InputMaybe<Sim_Campaigns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sim_EmailsArgs = {
  objects: Array<Sim_Emails_Insert_Input>;
  on_conflict?: InputMaybe<Sim_Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sim_Emails_OneArgs = {
  object: Sim_Emails_Insert_Input;
  on_conflict?: InputMaybe<Sim_Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sim_GroupsArgs = {
  objects: Array<Sim_Groups_Insert_Input>;
  on_conflict?: InputMaybe<Sim_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sim_Groups_OneArgs = {
  object: Sim_Groups_Insert_Input;
  on_conflict?: InputMaybe<Sim_Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sim_UsersArgs = {
  objects: Array<Sim_Users_Insert_Input>;
  on_conflict?: InputMaybe<Sim_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sim_Users_OneArgs = {
  object: Sim_Users_Insert_Input;
  on_conflict?: InputMaybe<Sim_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Slack_InstallationsArgs = {
  objects: Array<Slack_Installations_Insert_Input>;
  on_conflict?: InputMaybe<Slack_Installations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Slack_Installations_OneArgs = {
  object: Slack_Installations_Insert_Input;
  on_conflict?: InputMaybe<Slack_Installations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Social_Media_CommentsArgs = {
  objects: Array<Social_Media_Comments_Insert_Input>;
  on_conflict?: InputMaybe<Social_Media_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Social_Media_Comments_OneArgs = {
  object: Social_Media_Comments_Insert_Input;
  on_conflict?: InputMaybe<Social_Media_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Social_Media_DataArgs = {
  objects: Array<Social_Media_Data_Insert_Input>;
  on_conflict?: InputMaybe<Social_Media_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Social_Media_Data_OneArgs = {
  object: Social_Media_Data_Insert_Input;
  on_conflict?: InputMaybe<Social_Media_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Social_Media_GroupArgs = {
  objects: Array<Social_Media_Group_Insert_Input>;
  on_conflict?: InputMaybe<Social_Media_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Social_Media_Group_OneArgs = {
  object: Social_Media_Group_Insert_Input;
  on_conflict?: InputMaybe<Social_Media_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Social_Media_PostArgs = {
  objects: Array<Social_Media_Post_Insert_Input>;
  on_conflict?: InputMaybe<Social_Media_Post_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Social_Media_Post_OneArgs = {
  object: Social_Media_Post_Insert_Input;
  on_conflict?: InputMaybe<Social_Media_Post_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sourcing_QueriesArgs = {
  objects: Array<Sourcing_Queries_Insert_Input>;
  on_conflict?: InputMaybe<Sourcing_Queries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sourcing_Queries_OneArgs = {
  object: Sourcing_Queries_Insert_Input;
  on_conflict?: InputMaybe<Sourcing_Queries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sourcing_Query_ExecutionsArgs = {
  objects: Array<Sourcing_Query_Executions_Insert_Input>;
  on_conflict?: InputMaybe<Sourcing_Query_Executions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Sourcing_Query_Executions_OneArgs = {
  object: Sourcing_Query_Executions_Insert_Input;
  on_conflict?: InputMaybe<Sourcing_Query_Executions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spoof_MatchesArgs = {
  objects: Array<Spoof_Matches_Insert_Input>;
  on_conflict?: InputMaybe<Spoof_Matches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spoof_Matches_OneArgs = {
  object: Spoof_Matches_Insert_Input;
  on_conflict?: InputMaybe<Spoof_Matches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spoofing_EntitiesArgs = {
  objects: Array<Spoofing_Entities_Insert_Input>;
  on_conflict?: InputMaybe<Spoofing_Entities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spoofing_Entities_OneArgs = {
  object: Spoofing_Entities_Insert_Input;
  on_conflict?: InputMaybe<Spoofing_Entities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spoofing_Report_Search_ResultsArgs = {
  objects: Array<Spoofing_Report_Search_Results_Insert_Input>;
  on_conflict?: InputMaybe<Spoofing_Report_Search_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spoofing_Report_Search_Results_OneArgs = {
  object: Spoofing_Report_Search_Results_Insert_Input;
  on_conflict?: InputMaybe<Spoofing_Report_Search_Results_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spoofing_ReportsArgs = {
  objects: Array<Spoofing_Reports_Insert_Input>;
  on_conflict?: InputMaybe<Spoofing_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spoofing_Reports_OneArgs = {
  object: Spoofing_Reports_Insert_Input;
  on_conflict?: InputMaybe<Spoofing_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spoofing_Reports_To_TagsArgs = {
  objects: Array<Spoofing_Reports_To_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Spoofing_Reports_To_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spoofing_Reports_To_Tags_OneArgs = {
  object: Spoofing_Reports_To_Tags_Insert_Input;
  on_conflict?: InputMaybe<Spoofing_Reports_To_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Suggested_EnforcementsArgs = {
  objects: Array<Suggested_Enforcements_Insert_Input>;
  on_conflict?: InputMaybe<Suggested_Enforcements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Suggested_Enforcements_Form_ResponsesArgs = {
  objects: Array<Suggested_Enforcements_Form_Responses_Insert_Input>;
  on_conflict?: InputMaybe<Suggested_Enforcements_Form_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Suggested_Enforcements_Form_Responses_OneArgs = {
  object: Suggested_Enforcements_Form_Responses_Insert_Input;
  on_conflict?: InputMaybe<Suggested_Enforcements_Form_Responses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Suggested_Enforcements_OneArgs = {
  object: Suggested_Enforcements_Insert_Input;
  on_conflict?: InputMaybe<Suggested_Enforcements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TagsArgs = {
  objects: Array<Tags_Insert_Input>;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tags_OneArgs = {
  object: Tags_Insert_Input;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Threat_Intel_Actor_To_CampaignArgs = {
  objects: Array<Threat_Intel_Actor_To_Campaign_Insert_Input>;
  on_conflict?: InputMaybe<Threat_Intel_Actor_To_Campaign_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Threat_Intel_Actor_To_Campaign_OneArgs = {
  object: Threat_Intel_Actor_To_Campaign_Insert_Input;
  on_conflict?: InputMaybe<Threat_Intel_Actor_To_Campaign_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Threat_Intel_ActorsArgs = {
  objects: Array<Threat_Intel_Actors_Insert_Input>;
  on_conflict?: InputMaybe<Threat_Intel_Actors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Threat_Intel_Actors_OneArgs = {
  object: Threat_Intel_Actors_Insert_Input;
  on_conflict?: InputMaybe<Threat_Intel_Actors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Threat_Intel_Campaign_To_EntitiesArgs = {
  objects: Array<Threat_Intel_Campaign_To_Entities_Insert_Input>;
  on_conflict?: InputMaybe<Threat_Intel_Campaign_To_Entities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Threat_Intel_Campaign_To_Entities_OneArgs = {
  object: Threat_Intel_Campaign_To_Entities_Insert_Input;
  on_conflict?: InputMaybe<Threat_Intel_Campaign_To_Entities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Threat_Intel_CampaignsArgs = {
  objects: Array<Threat_Intel_Campaigns_Insert_Input>;
  on_conflict?: InputMaybe<Threat_Intel_Campaigns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Threat_Intel_Campaigns_OneArgs = {
  object: Threat_Intel_Campaigns_Insert_Input;
  on_conflict?: InputMaybe<Threat_Intel_Campaigns_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TrademarksArgs = {
  objects: Array<Trademarks_Insert_Input>;
  on_conflict?: InputMaybe<Trademarks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademarks_OneArgs = {
  object: Trademarks_Insert_Input;
  on_conflict?: InputMaybe<Trademarks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uploaded_FilesArgs = {
  objects: Array<Uploaded_Files_Insert_Input>;
  on_conflict?: InputMaybe<Uploaded_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uploaded_Files_OneArgs = {
  object: Uploaded_Files_Insert_Input;
  on_conflict?: InputMaybe<Uploaded_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_FeedbackArgs = {
  objects: Array<User_Feedback_Insert_Input>;
  on_conflict?: InputMaybe<User_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Feedback_OneArgs = {
  object: User_Feedback_Insert_Input;
  on_conflict?: InputMaybe<User_Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OrganizationsArgs = {
  objects: Array<User_Organizations_Insert_Input>;
  on_conflict?: InputMaybe<User_Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Organizations_OneArgs = {
  object: User_Organizations_Insert_Input;
  on_conflict?: InputMaybe<User_Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ProductsArgs = {
  objects: Array<User_Products_Insert_Input>;
  on_conflict?: InputMaybe<User_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Products_OneArgs = {
  object: User_Products_Insert_Input;
  on_conflict?: InputMaybe<User_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vetric_Screenshot_WebhooksArgs = {
  objects: Array<Vetric_Screenshot_Webhooks_Insert_Input>;
  on_conflict?: InputMaybe<Vetric_Screenshot_Webhooks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vetric_Screenshot_Webhooks_OneArgs = {
  object: Vetric_Screenshot_Webhooks_Insert_Input;
  on_conflict?: InputMaybe<Vetric_Screenshot_Webhooks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Webhook_TargetsArgs = {
  objects: Array<Webhook_Targets_Insert_Input>;
  on_conflict?: InputMaybe<Webhook_Targets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Webhook_Targets_OneArgs = {
  object: Webhook_Targets_Insert_Input;
  on_conflict?: InputMaybe<Webhook_Targets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootManage_SafelistArgs = {
  manage_safelist_input: ManageSafelistInput;
};


/** mutation root */
export type Mutation_RootManage_TrademarksArgs = {
  manage_trademarks_input: ManageTrademarksInput;
};


/** mutation root */
export type Mutation_RootModify_Alert_LinksArgs = {
  modify_alert_links_input: CrudInput;
};


/** mutation root */
export type Mutation_RootModify_Gcs_ObjectArgs = {
  manage_gcs_objects_input: ManageGcsObjectsInput;
};


/** mutation root */
export type Mutation_RootPost_Ioc_UpdatedArgs = {
  post_ioc_updated_input: PostIocUpdatedInput;
};


/** mutation root */
export type Mutation_RootPublish_Request_Spoof_ScreenshotArgs = {
  publish_request_spoof_screenshot_input: PublishRequestSpoofScreenshotInput;
};


/** mutation root */
export type Mutation_RootRequest_Alert_Csv_ExportArgs = {
  request_alert_csv_export_input: RequestAlertCsvExportInput;
};


/** mutation root */
export type Mutation_RootRequest_Bulk_ScrapeArgs = {
  collection_reports: Array<InputMaybe<RequestBulkScrapeInput>>;
};


/** mutation root */
export type Mutation_RootRun_Deepfake_DetectionArgs = {
  run_deepfake_detection_input: RunDeepfakeDetectionInput;
};


/** mutation root */
export type Mutation_RootSend_Sim_EmailArgs = {
  send_sim_email_input: SendSimEmailInput;
};


/** mutation root */
export type Mutation_RootSend_Slack_MessageArgs = {
  slack_message_input: SlackMessageInput;
};


/** mutation root */
export type Mutation_RootSubmit_Auto_Enforcement_RequestsArgs = {
  submit_auto_enforcement_requests_input?: InputMaybe<SubmitAutoEnforcementRequestsInput>;
};


/** mutation root */
export type Mutation_RootSubmit_Form_Auto_Enforcement_RequestsArgs = {
  submit_form_auto_enforcement_requests_input?: InputMaybe<SubmitFormAutoEnforcementRequestsInput>;
};


/** mutation root */
export type Mutation_RootUpdate_Advertisement_DataArgs = {
  _set?: InputMaybe<Advertisement_Data_Set_Input>;
  where: Advertisement_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Advertisement_Data_By_PkArgs = {
  _set?: InputMaybe<Advertisement_Data_Set_Input>;
  pk_columns: Advertisement_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Advertisement_Data_ManyArgs = {
  updates: Array<Advertisement_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Advertiser_DataArgs = {
  _inc?: InputMaybe<Advertiser_Data_Inc_Input>;
  _set?: InputMaybe<Advertiser_Data_Set_Input>;
  where: Advertiser_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Advertiser_Data_By_PkArgs = {
  _inc?: InputMaybe<Advertiser_Data_Inc_Input>;
  _set?: InputMaybe<Advertiser_Data_Set_Input>;
  pk_columns: Advertiser_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Advertiser_Data_ManyArgs = {
  updates: Array<Advertiser_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_PromptsArgs = {
  _append?: InputMaybe<Ai_Prompts_Append_Input>;
  _delete_at_path?: InputMaybe<Ai_Prompts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ai_Prompts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ai_Prompts_Delete_Key_Input>;
  _prepend?: InputMaybe<Ai_Prompts_Prepend_Input>;
  _set?: InputMaybe<Ai_Prompts_Set_Input>;
  where: Ai_Prompts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Prompts_By_PkArgs = {
  _append?: InputMaybe<Ai_Prompts_Append_Input>;
  _delete_at_path?: InputMaybe<Ai_Prompts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ai_Prompts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ai_Prompts_Delete_Key_Input>;
  _prepend?: InputMaybe<Ai_Prompts_Prepend_Input>;
  _set?: InputMaybe<Ai_Prompts_Set_Input>;
  pk_columns: Ai_Prompts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Prompts_ManyArgs = {
  updates: Array<Ai_Prompts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_ResponsesArgs = {
  _append?: InputMaybe<Ai_Responses_Append_Input>;
  _delete_at_path?: InputMaybe<Ai_Responses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ai_Responses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ai_Responses_Delete_Key_Input>;
  _inc?: InputMaybe<Ai_Responses_Inc_Input>;
  _prepend?: InputMaybe<Ai_Responses_Prepend_Input>;
  _set?: InputMaybe<Ai_Responses_Set_Input>;
  where: Ai_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Responses_By_PkArgs = {
  _append?: InputMaybe<Ai_Responses_Append_Input>;
  _delete_at_path?: InputMaybe<Ai_Responses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ai_Responses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ai_Responses_Delete_Key_Input>;
  _inc?: InputMaybe<Ai_Responses_Inc_Input>;
  _prepend?: InputMaybe<Ai_Responses_Prepend_Input>;
  _set?: InputMaybe<Ai_Responses_Set_Input>;
  pk_columns: Ai_Responses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Responses_ManyArgs = {
  updates: Array<Ai_Responses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_HashesArgs = {
  _set?: InputMaybe<Alert_Hashes_Set_Input>;
  where: Alert_Hashes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_Hashes_By_PkArgs = {
  _set?: InputMaybe<Alert_Hashes_Set_Input>;
  pk_columns: Alert_Hashes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_Hashes_ManyArgs = {
  updates: Array<Alert_Hashes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_Label_EventsArgs = {
  _set?: InputMaybe<Alert_Label_Events_Set_Input>;
  where: Alert_Label_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_Label_Events_By_PkArgs = {
  _set?: InputMaybe<Alert_Label_Events_Set_Input>;
  pk_columns: Alert_Label_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_Label_Events_ManyArgs = {
  updates: Array<Alert_Label_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_LinksArgs = {
  _set?: InputMaybe<Alert_Links_Set_Input>;
  where: Alert_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_Links_By_PkArgs = {
  _set?: InputMaybe<Alert_Links_Set_Input>;
  pk_columns: Alert_Links_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Alert_Links_ManyArgs = {
  updates: Array<Alert_Links_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Api_TokensArgs = {
  _set?: InputMaybe<Api_Tokens_Set_Input>;
  where: Api_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Api_Tokens_By_PkArgs = {
  _set?: InputMaybe<Api_Tokens_Set_Input>;
  pk_columns: Api_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Api_Tokens_ManyArgs = {
  updates: Array<Api_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Api_Usage_RecordsArgs = {
  _set?: InputMaybe<Api_Usage_Records_Set_Input>;
  where: Api_Usage_Records_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Api_Usage_Records_By_PkArgs = {
  _set?: InputMaybe<Api_Usage_Records_Set_Input>;
  pk_columns: Api_Usage_Records_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Api_Usage_Records_ManyArgs = {
  updates: Array<Api_Usage_Records_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Apify_Scraping_JobsArgs = {
  _set?: InputMaybe<Apify_Scraping_Jobs_Set_Input>;
  where: Apify_Scraping_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Apify_Scraping_Jobs_By_PkArgs = {
  _set?: InputMaybe<Apify_Scraping_Jobs_Set_Input>;
  pk_columns: Apify_Scraping_Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Apify_Scraping_Jobs_ManyArgs = {
  updates: Array<Apify_Scraping_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApprovalsArgs = {
  _set?: InputMaybe<Approvals_Set_Input>;
  where: Approvals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Approvals_By_PkArgs = {
  _set?: InputMaybe<Approvals_Set_Input>;
  pk_columns: Approvals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Approvals_ManyArgs = {
  updates: Array<Approvals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Logged_ActionsArgs = {
  _inc?: InputMaybe<Audit_Logged_Actions_Inc_Input>;
  _set?: InputMaybe<Audit_Logged_Actions_Set_Input>;
  where: Audit_Logged_Actions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Logged_Actions_By_PkArgs = {
  _inc?: InputMaybe<Audit_Logged_Actions_Inc_Input>;
  _set?: InputMaybe<Audit_Logged_Actions_Set_Input>;
  pk_columns: Audit_Logged_Actions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Logged_Actions_ManyArgs = {
  updates: Array<Audit_Logged_Actions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_Report_ChangesArgs = {
  _append?: InputMaybe<Collection_Report_Changes_Append_Input>;
  _delete_at_path?: InputMaybe<Collection_Report_Changes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Collection_Report_Changes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Collection_Report_Changes_Delete_Key_Input>;
  _prepend?: InputMaybe<Collection_Report_Changes_Prepend_Input>;
  _set?: InputMaybe<Collection_Report_Changes_Set_Input>;
  where: Collection_Report_Changes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_Report_Changes_By_PkArgs = {
  _append?: InputMaybe<Collection_Report_Changes_Append_Input>;
  _delete_at_path?: InputMaybe<Collection_Report_Changes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Collection_Report_Changes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Collection_Report_Changes_Delete_Key_Input>;
  _prepend?: InputMaybe<Collection_Report_Changes_Prepend_Input>;
  _set?: InputMaybe<Collection_Report_Changes_Set_Input>;
  pk_columns: Collection_Report_Changes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_Report_Changes_ManyArgs = {
  updates: Array<Collection_Report_Changes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_Report_State_ChangesArgs = {
  _set?: InputMaybe<Collection_Report_State_Changes_Set_Input>;
  where: Collection_Report_State_Changes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_Report_State_Changes_By_PkArgs = {
  _set?: InputMaybe<Collection_Report_State_Changes_Set_Input>;
  pk_columns: Collection_Report_State_Changes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Collection_Report_State_Changes_ManyArgs = {
  updates: Array<Collection_Report_State_Changes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_CardsArgs = {
  _inc?: InputMaybe<Credit_Cards_Inc_Input>;
  _set?: InputMaybe<Credit_Cards_Set_Input>;
  where: Credit_Cards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Cards_By_PkArgs = {
  _inc?: InputMaybe<Credit_Cards_Inc_Input>;
  _set?: InputMaybe<Credit_Cards_Set_Input>;
  pk_columns: Credit_Cards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Cards_ManyArgs = {
  updates: Array<Credit_Cards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_AssetsArgs = {
  _set?: InputMaybe<Customer_Assets_Set_Input>;
  where: Customer_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Assets_By_PkArgs = {
  _set?: InputMaybe<Customer_Assets_Set_Input>;
  pk_columns: Customer_Assets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Assets_ManyArgs = {
  updates: Array<Customer_Assets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Assets_To_BrandsArgs = {
  _set?: InputMaybe<Customer_Assets_To_Brands_Set_Input>;
  where: Customer_Assets_To_Brands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Assets_To_Brands_By_PkArgs = {
  _set?: InputMaybe<Customer_Assets_To_Brands_Set_Input>;
  pk_columns: Customer_Assets_To_Brands_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Assets_To_Brands_ManyArgs = {
  updates: Array<Customer_Assets_To_Brands_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dark_WebArgs = {
  _append?: InputMaybe<Dark_Web_Append_Input>;
  _delete_at_path?: InputMaybe<Dark_Web_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Dark_Web_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Dark_Web_Delete_Key_Input>;
  _inc?: InputMaybe<Dark_Web_Inc_Input>;
  _prepend?: InputMaybe<Dark_Web_Prepend_Input>;
  _set?: InputMaybe<Dark_Web_Set_Input>;
  where: Dark_Web_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dark_Web_By_PkArgs = {
  _append?: InputMaybe<Dark_Web_Append_Input>;
  _delete_at_path?: InputMaybe<Dark_Web_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Dark_Web_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Dark_Web_Delete_Key_Input>;
  _inc?: InputMaybe<Dark_Web_Inc_Input>;
  _prepend?: InputMaybe<Dark_Web_Prepend_Input>;
  _set?: InputMaybe<Dark_Web_Set_Input>;
  pk_columns: Dark_Web_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dark_Web_ManyArgs = {
  updates: Array<Dark_Web_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Defensive_Domain_RegistrationArgs = {
  _inc?: InputMaybe<Defensive_Domain_Registration_Inc_Input>;
  _set?: InputMaybe<Defensive_Domain_Registration_Set_Input>;
  where: Defensive_Domain_Registration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Defensive_Domain_Registration_By_PkArgs = {
  _inc?: InputMaybe<Defensive_Domain_Registration_Inc_Input>;
  _set?: InputMaybe<Defensive_Domain_Registration_Set_Input>;
  pk_columns: Defensive_Domain_Registration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Defensive_Domain_Registration_ManyArgs = {
  updates: Array<Defensive_Domain_Registration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Designated_Takedown_AssetsArgs = {
  _set?: InputMaybe<Designated_Takedown_Assets_Set_Input>;
  where: Designated_Takedown_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Designated_Takedown_Assets_By_PkArgs = {
  _set?: InputMaybe<Designated_Takedown_Assets_Set_Input>;
  pk_columns: Designated_Takedown_Assets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Designated_Takedown_Assets_ManyArgs = {
  updates: Array<Designated_Takedown_Assets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Detection_AssetsArgs = {
  _set?: InputMaybe<Detection_Assets_Set_Input>;
  where: Detection_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Detection_Assets_By_PkArgs = {
  _set?: InputMaybe<Detection_Assets_Set_Input>;
  pk_columns: Detection_Assets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Detection_Assets_ManyArgs = {
  updates: Array<Detection_Assets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Detection_Config_ApprovalsArgs = {
  _set?: InputMaybe<Detection_Config_Approvals_Set_Input>;
  where: Detection_Config_Approvals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Detection_Config_Approvals_By_PkArgs = {
  _set?: InputMaybe<Detection_Config_Approvals_Set_Input>;
  pk_columns: Detection_Config_Approvals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Detection_Config_Approvals_ManyArgs = {
  updates: Array<Detection_Config_Approvals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Domain_DataArgs = {
  _append?: InputMaybe<Domain_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Domain_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Domain_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Domain_Data_Delete_Key_Input>;
  _prepend?: InputMaybe<Domain_Data_Prepend_Input>;
  _set?: InputMaybe<Domain_Data_Set_Input>;
  where: Domain_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Domain_Data_By_PkArgs = {
  _append?: InputMaybe<Domain_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Domain_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Domain_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Domain_Data_Delete_Key_Input>;
  _prepend?: InputMaybe<Domain_Data_Prepend_Input>;
  _set?: InputMaybe<Domain_Data_Set_Input>;
  pk_columns: Domain_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Domain_Data_ManyArgs = {
  updates: Array<Domain_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Domain_Match_DataArgs = {
  _set?: InputMaybe<Domain_Match_Data_Set_Input>;
  where: Domain_Match_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Domain_Match_Data_By_PkArgs = {
  _set?: InputMaybe<Domain_Match_Data_Set_Input>;
  pk_columns: Domain_Match_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Domain_Match_Data_ManyArgs = {
  updates: Array<Domain_Match_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ecommerce_ListingsArgs = {
  _append?: InputMaybe<Ecommerce_Listings_Append_Input>;
  _delete_at_path?: InputMaybe<Ecommerce_Listings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ecommerce_Listings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ecommerce_Listings_Delete_Key_Input>;
  _inc?: InputMaybe<Ecommerce_Listings_Inc_Input>;
  _prepend?: InputMaybe<Ecommerce_Listings_Prepend_Input>;
  _set?: InputMaybe<Ecommerce_Listings_Set_Input>;
  where: Ecommerce_Listings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ecommerce_Listings_By_PkArgs = {
  _append?: InputMaybe<Ecommerce_Listings_Append_Input>;
  _delete_at_path?: InputMaybe<Ecommerce_Listings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ecommerce_Listings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ecommerce_Listings_Delete_Key_Input>;
  _inc?: InputMaybe<Ecommerce_Listings_Inc_Input>;
  _prepend?: InputMaybe<Ecommerce_Listings_Prepend_Input>;
  _set?: InputMaybe<Ecommerce_Listings_Set_Input>;
  pk_columns: Ecommerce_Listings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ecommerce_Listings_ManyArgs = {
  updates: Array<Ecommerce_Listings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_AddressesArgs = {
  _set?: InputMaybe<Email_Addresses_Set_Input>;
  where: Email_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Addresses_By_PkArgs = {
  _set?: InputMaybe<Email_Addresses_Set_Input>;
  pk_columns: Email_Addresses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Addresses_ManyArgs = {
  updates: Array<Email_Addresses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_CorrespondenceArgs = {
  _set?: InputMaybe<Email_Correspondence_Set_Input>;
  where: Email_Correspondence_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Correspondence_By_PkArgs = {
  _set?: InputMaybe<Email_Correspondence_Set_Input>;
  pk_columns: Email_Correspondence_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Correspondence_ManyArgs = {
  updates: Array<Email_Correspondence_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_SettingsArgs = {
  _append?: InputMaybe<Email_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Settings_Prepend_Input>;
  _set?: InputMaybe<Email_Settings_Set_Input>;
  where: Email_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Settings_By_PkArgs = {
  _append?: InputMaybe<Email_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Settings_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Settings_Prepend_Input>;
  _set?: InputMaybe<Email_Settings_Set_Input>;
  pk_columns: Email_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Settings_ManyArgs = {
  updates: Array<Email_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EmailsArgs = {
  _append?: InputMaybe<Emails_Append_Input>;
  _delete_at_path?: InputMaybe<Emails_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Emails_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Emails_Delete_Key_Input>;
  _prepend?: InputMaybe<Emails_Prepend_Input>;
  _set?: InputMaybe<Emails_Set_Input>;
  where: Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Emails_By_PkArgs = {
  _append?: InputMaybe<Emails_Append_Input>;
  _delete_at_path?: InputMaybe<Emails_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Emails_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Emails_Delete_Key_Input>;
  _prepend?: InputMaybe<Emails_Prepend_Input>;
  _set?: InputMaybe<Emails_Set_Input>;
  pk_columns: Emails_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Emails_ManyArgs = {
  updates: Array<Emails_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_EmailsArgs = {
  _set?: InputMaybe<Enforcement_Emails_Set_Input>;
  where: Enforcement_Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Emails_By_PkArgs = {
  _set?: InputMaybe<Enforcement_Emails_Set_Input>;
  pk_columns: Enforcement_Emails_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Emails_ManyArgs = {
  updates: Array<Enforcement_Emails_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_MetadataArgs = {
  _append?: InputMaybe<Enforcement_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Enforcement_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Enforcement_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Enforcement_Metadata_Delete_Key_Input>;
  _prepend?: InputMaybe<Enforcement_Metadata_Prepend_Input>;
  _set?: InputMaybe<Enforcement_Metadata_Set_Input>;
  where: Enforcement_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Metadata_By_PkArgs = {
  _append?: InputMaybe<Enforcement_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Enforcement_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Enforcement_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Enforcement_Metadata_Delete_Key_Input>;
  _prepend?: InputMaybe<Enforcement_Metadata_Prepend_Input>;
  _set?: InputMaybe<Enforcement_Metadata_Set_Input>;
  pk_columns: Enforcement_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Metadata_ManyArgs = {
  updates: Array<Enforcement_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_PlatformsArgs = {
  _append?: InputMaybe<Enforcement_Platforms_Append_Input>;
  _delete_at_path?: InputMaybe<Enforcement_Platforms_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Enforcement_Platforms_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Enforcement_Platforms_Delete_Key_Input>;
  _inc?: InputMaybe<Enforcement_Platforms_Inc_Input>;
  _prepend?: InputMaybe<Enforcement_Platforms_Prepend_Input>;
  _set?: InputMaybe<Enforcement_Platforms_Set_Input>;
  where: Enforcement_Platforms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Platforms_By_PkArgs = {
  _append?: InputMaybe<Enforcement_Platforms_Append_Input>;
  _delete_at_path?: InputMaybe<Enforcement_Platforms_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Enforcement_Platforms_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Enforcement_Platforms_Delete_Key_Input>;
  _inc?: InputMaybe<Enforcement_Platforms_Inc_Input>;
  _prepend?: InputMaybe<Enforcement_Platforms_Prepend_Input>;
  _set?: InputMaybe<Enforcement_Platforms_Set_Input>;
  pk_columns: Enforcement_Platforms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Platforms_ManyArgs = {
  updates: Array<Enforcement_Platforms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Request_StatusArgs = {
  update_enforcement_request_status_input?: InputMaybe<UpdateEnforcementRequestStatusInput>;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_RequestsArgs = {
  _set?: InputMaybe<Enforcement_Requests_Set_Input>;
  where: Enforcement_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Requests_By_PkArgs = {
  _set?: InputMaybe<Enforcement_Requests_Set_Input>;
  pk_columns: Enforcement_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Requests_ManyArgs = {
  updates: Array<Enforcement_Requests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_TemplatesArgs = {
  _append?: InputMaybe<Enforcement_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Enforcement_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Enforcement_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Enforcement_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Enforcement_Templates_Prepend_Input>;
  _set?: InputMaybe<Enforcement_Templates_Set_Input>;
  where: Enforcement_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Templates_By_PkArgs = {
  _append?: InputMaybe<Enforcement_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Enforcement_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Enforcement_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Enforcement_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Enforcement_Templates_Prepend_Input>;
  _set?: InputMaybe<Enforcement_Templates_Set_Input>;
  pk_columns: Enforcement_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Templates_ManyArgs = {
  updates: Array<Enforcement_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_TypesArgs = {
  _append?: InputMaybe<Enforcement_Types_Append_Input>;
  _delete_at_path?: InputMaybe<Enforcement_Types_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Enforcement_Types_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Enforcement_Types_Delete_Key_Input>;
  _inc?: InputMaybe<Enforcement_Types_Inc_Input>;
  _prepend?: InputMaybe<Enforcement_Types_Prepend_Input>;
  _set?: InputMaybe<Enforcement_Types_Set_Input>;
  where: Enforcement_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Types_By_PkArgs = {
  _append?: InputMaybe<Enforcement_Types_Append_Input>;
  _delete_at_path?: InputMaybe<Enforcement_Types_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Enforcement_Types_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Enforcement_Types_Delete_Key_Input>;
  _inc?: InputMaybe<Enforcement_Types_Inc_Input>;
  _prepend?: InputMaybe<Enforcement_Types_Prepend_Input>;
  _set?: InputMaybe<Enforcement_Types_Set_Input>;
  pk_columns: Enforcement_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enforcement_Types_ManyArgs = {
  updates: Array<Enforcement_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_AggregatesArgs = {
  _set?: InputMaybe<Entity_Aggregates_Set_Input>;
  where: Entity_Aggregates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_Aggregates_By_PkArgs = {
  _set?: InputMaybe<Entity_Aggregates_Set_Input>;
  pk_columns: Entity_Aggregates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_Aggregates_ManyArgs = {
  updates: Array<Entity_Aggregates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_DataArgs = {
  _set?: InputMaybe<Entity_Data_Set_Input>;
  where: Entity_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_Data_By_PkArgs = {
  _set?: InputMaybe<Entity_Data_Set_Input>;
  pk_columns: Entity_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_Data_ManyArgs = {
  updates: Array<Entity_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_LinksArgs = {
  _set?: InputMaybe<Entity_Links_Set_Input>;
  where: Entity_Links_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_Links_By_PkArgs = {
  _set?: InputMaybe<Entity_Links_Set_Input>;
  pk_columns: Entity_Links_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_Links_ManyArgs = {
  updates: Array<Entity_Links_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_State_ClassificationsArgs = {
  _append?: InputMaybe<Entity_State_Classifications_Append_Input>;
  _delete_at_path?: InputMaybe<Entity_State_Classifications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Entity_State_Classifications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Entity_State_Classifications_Delete_Key_Input>;
  _prepend?: InputMaybe<Entity_State_Classifications_Prepend_Input>;
  _set?: InputMaybe<Entity_State_Classifications_Set_Input>;
  where: Entity_State_Classifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_State_Classifications_By_PkArgs = {
  _append?: InputMaybe<Entity_State_Classifications_Append_Input>;
  _delete_at_path?: InputMaybe<Entity_State_Classifications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Entity_State_Classifications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Entity_State_Classifications_Delete_Key_Input>;
  _prepend?: InputMaybe<Entity_State_Classifications_Prepend_Input>;
  _set?: InputMaybe<Entity_State_Classifications_Set_Input>;
  pk_columns: Entity_State_Classifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_State_Classifications_ManyArgs = {
  updates: Array<Entity_State_Classifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Full_UrlsArgs = {
  _set?: InputMaybe<Full_Urls_Set_Input>;
  where: Full_Urls_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Full_Urls_By_PkArgs = {
  _set?: InputMaybe<Full_Urls_Set_Input>;
  pk_columns: Full_Urls_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Full_Urls_ManyArgs = {
  updates: Array<Full_Urls_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hourly_Spoofing_Reports_StatsArgs = {
  _append?: InputMaybe<Hourly_Spoofing_Reports_Stats_Append_Input>;
  _delete_at_path?: InputMaybe<Hourly_Spoofing_Reports_Stats_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Hourly_Spoofing_Reports_Stats_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Hourly_Spoofing_Reports_Stats_Delete_Key_Input>;
  _inc?: InputMaybe<Hourly_Spoofing_Reports_Stats_Inc_Input>;
  _prepend?: InputMaybe<Hourly_Spoofing_Reports_Stats_Prepend_Input>;
  _set?: InputMaybe<Hourly_Spoofing_Reports_Stats_Set_Input>;
  where: Hourly_Spoofing_Reports_Stats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hourly_Spoofing_Reports_Stats_By_PkArgs = {
  _append?: InputMaybe<Hourly_Spoofing_Reports_Stats_Append_Input>;
  _delete_at_path?: InputMaybe<Hourly_Spoofing_Reports_Stats_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Hourly_Spoofing_Reports_Stats_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Hourly_Spoofing_Reports_Stats_Delete_Key_Input>;
  _inc?: InputMaybe<Hourly_Spoofing_Reports_Stats_Inc_Input>;
  _prepend?: InputMaybe<Hourly_Spoofing_Reports_Stats_Prepend_Input>;
  _set?: InputMaybe<Hourly_Spoofing_Reports_Stats_Set_Input>;
  pk_columns: Hourly_Spoofing_Reports_Stats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hourly_Spoofing_Reports_Stats_ManyArgs = {
  updates: Array<Hourly_Spoofing_Reports_Stats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ioc_Alert_AttributionArgs = {
  _set?: InputMaybe<Ioc_Alert_Attribution_Set_Input>;
  where: Ioc_Alert_Attribution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ioc_Alert_Attribution_By_PkArgs = {
  _set?: InputMaybe<Ioc_Alert_Attribution_Set_Input>;
  pk_columns: Ioc_Alert_Attribution_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ioc_Alert_Attribution_ManyArgs = {
  updates: Array<Ioc_Alert_Attribution_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ioc_Detection_Config_AttributionArgs = {
  _set?: InputMaybe<Ioc_Detection_Config_Attribution_Set_Input>;
  where: Ioc_Detection_Config_Attribution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ioc_Detection_Config_Attribution_By_PkArgs = {
  _set?: InputMaybe<Ioc_Detection_Config_Attribution_Set_Input>;
  pk_columns: Ioc_Detection_Config_Attribution_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ioc_Detection_Config_Attribution_ManyArgs = {
  updates: Array<Ioc_Detection_Config_Attribution_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ioc_Entity_Data_AttributionArgs = {
  _set?: InputMaybe<Ioc_Entity_Data_Attribution_Set_Input>;
  where: Ioc_Entity_Data_Attribution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ioc_Entity_Data_Attribution_By_PkArgs = {
  _set?: InputMaybe<Ioc_Entity_Data_Attribution_Set_Input>;
  pk_columns: Ioc_Entity_Data_Attribution_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ioc_Entity_Data_Attribution_ManyArgs = {
  updates: Array<Ioc_Entity_Data_Attribution_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IocsArgs = {
  _append?: InputMaybe<Iocs_Append_Input>;
  _delete_at_path?: InputMaybe<Iocs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Iocs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Iocs_Delete_Key_Input>;
  _prepend?: InputMaybe<Iocs_Prepend_Input>;
  _set?: InputMaybe<Iocs_Set_Input>;
  where: Iocs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Iocs_By_PkArgs = {
  _append?: InputMaybe<Iocs_Append_Input>;
  _delete_at_path?: InputMaybe<Iocs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Iocs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Iocs_Delete_Key_Input>;
  _prepend?: InputMaybe<Iocs_Prepend_Input>;
  _set?: InputMaybe<Iocs_Set_Input>;
  pk_columns: Iocs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Iocs_ManyArgs = {
  updates: Array<Iocs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Jira_MetadataArgs = {
  _append?: InputMaybe<Jira_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Jira_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Jira_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Jira_Metadata_Delete_Key_Input>;
  _prepend?: InputMaybe<Jira_Metadata_Prepend_Input>;
  _set?: InputMaybe<Jira_Metadata_Set_Input>;
  where: Jira_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Jira_Metadata_By_PkArgs = {
  _append?: InputMaybe<Jira_Metadata_Append_Input>;
  _delete_at_path?: InputMaybe<Jira_Metadata_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Jira_Metadata_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Jira_Metadata_Delete_Key_Input>;
  _prepend?: InputMaybe<Jira_Metadata_Prepend_Input>;
  _set?: InputMaybe<Jira_Metadata_Set_Input>;
  pk_columns: Jira_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Jira_Metadata_ManyArgs = {
  updates: Array<Jira_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Match_AttributionsArgs = {
  _append?: InputMaybe<Match_Attributions_Append_Input>;
  _delete_at_path?: InputMaybe<Match_Attributions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Match_Attributions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Match_Attributions_Delete_Key_Input>;
  _prepend?: InputMaybe<Match_Attributions_Prepend_Input>;
  _set?: InputMaybe<Match_Attributions_Set_Input>;
  where: Match_Attributions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Match_Attributions_By_PkArgs = {
  _append?: InputMaybe<Match_Attributions_Append_Input>;
  _delete_at_path?: InputMaybe<Match_Attributions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Match_Attributions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Match_Attributions_Delete_Key_Input>;
  _prepend?: InputMaybe<Match_Attributions_Prepend_Input>;
  _set?: InputMaybe<Match_Attributions_Set_Input>;
  pk_columns: Match_Attributions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Match_Attributions_ManyArgs = {
  updates: Array<Match_Attributions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ml_FeaturesArgs = {
  _append?: InputMaybe<Ml_Features_Append_Input>;
  _delete_at_path?: InputMaybe<Ml_Features_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ml_Features_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ml_Features_Delete_Key_Input>;
  _inc?: InputMaybe<Ml_Features_Inc_Input>;
  _prepend?: InputMaybe<Ml_Features_Prepend_Input>;
  _set?: InputMaybe<Ml_Features_Set_Input>;
  where: Ml_Features_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ml_Features_By_PkArgs = {
  _append?: InputMaybe<Ml_Features_Append_Input>;
  _delete_at_path?: InputMaybe<Ml_Features_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ml_Features_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ml_Features_Delete_Key_Input>;
  _inc?: InputMaybe<Ml_Features_Inc_Input>;
  _prepend?: InputMaybe<Ml_Features_Prepend_Input>;
  _set?: InputMaybe<Ml_Features_Set_Input>;
  pk_columns: Ml_Features_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ml_Features_ManyArgs = {
  updates: Array<Ml_Features_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_AppsArgs = {
  _set?: InputMaybe<Mobile_Apps_Set_Input>;
  where: Mobile_Apps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Apps_By_PkArgs = {
  _set?: InputMaybe<Mobile_Apps_Set_Input>;
  pk_columns: Mobile_Apps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mobile_Apps_ManyArgs = {
  updates: Array<Mobile_Apps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nft_Opensea_ProcessedArgs = {
  _set?: InputMaybe<Nft_Opensea_Processed_Set_Input>;
  where: Nft_Opensea_Processed_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nft_Opensea_Processed_By_PkArgs = {
  _set?: InputMaybe<Nft_Opensea_Processed_Set_Input>;
  pk_columns: Nft_Opensea_Processed_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nft_Opensea_Processed_ManyArgs = {
  updates: Array<Nft_Opensea_Processed_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nft_Processing_CursorArgs = {
  _set?: InputMaybe<Nft_Processing_Cursor_Set_Input>;
  where: Nft_Processing_Cursor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nft_Processing_Cursor_By_PkArgs = {
  _set?: InputMaybe<Nft_Processing_Cursor_Set_Input>;
  pk_columns: Nft_Processing_Cursor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Nft_Processing_Cursor_ManyArgs = {
  updates: Array<Nft_Processing_Cursor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_SubscriptionsArgs = {
  _append?: InputMaybe<Notification_Subscriptions_Append_Input>;
  _delete_at_path?: InputMaybe<Notification_Subscriptions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notification_Subscriptions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notification_Subscriptions_Delete_Key_Input>;
  _prepend?: InputMaybe<Notification_Subscriptions_Prepend_Input>;
  _set?: InputMaybe<Notification_Subscriptions_Set_Input>;
  where: Notification_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Subscriptions_By_PkArgs = {
  _append?: InputMaybe<Notification_Subscriptions_Append_Input>;
  _delete_at_path?: InputMaybe<Notification_Subscriptions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notification_Subscriptions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notification_Subscriptions_Delete_Key_Input>;
  _prepend?: InputMaybe<Notification_Subscriptions_Prepend_Input>;
  _set?: InputMaybe<Notification_Subscriptions_Set_Input>;
  pk_columns: Notification_Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Subscriptions_ManyArgs = {
  updates: Array<Notification_Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationArgs = {
  manage_organization_input: UpdateOrganizationInput;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Id_Api_KeysArgs = {
  _set?: InputMaybe<Organization_Id_Api_Keys_Set_Input>;
  where: Organization_Id_Api_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Id_Api_Keys_By_PkArgs = {
  _set?: InputMaybe<Organization_Id_Api_Keys_Set_Input>;
  pk_columns: Organization_Id_Api_Keys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Id_Api_Keys_ManyArgs = {
  updates: Array<Organization_Id_Api_Keys_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_ProductsArgs = {
  _set?: InputMaybe<Organization_Products_Set_Input>;
  where: Organization_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Products_By_PkArgs = {
  _set?: InputMaybe<Organization_Products_Set_Input>;
  pk_columns: Organization_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Products_ManyArgs = {
  updates: Array<Organization_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationsArgs = {
  _append?: InputMaybe<Organizations_Append_Input>;
  _delete_at_path?: InputMaybe<Organizations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organizations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organizations_Delete_Key_Input>;
  _prepend?: InputMaybe<Organizations_Prepend_Input>;
  _set?: InputMaybe<Organizations_Set_Input>;
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_By_PkArgs = {
  _append?: InputMaybe<Organizations_Append_Input>;
  _delete_at_path?: InputMaybe<Organizations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organizations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organizations_Delete_Key_Input>;
  _prepend?: InputMaybe<Organizations_Prepend_Input>;
  _set?: InputMaybe<Organizations_Set_Input>;
  pk_columns: Organizations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_ManyArgs = {
  updates: Array<Organizations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_MetadataArgs = {
  _set?: InputMaybe<Organizations_Metadata_Set_Input>;
  where: Organizations_Metadata_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_Metadata_By_PkArgs = {
  _set?: InputMaybe<Organizations_Metadata_Set_Input>;
  pk_columns: Organizations_Metadata_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_Metadata_ManyArgs = {
  updates: Array<Organizations_Metadata_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PermissionsArgs = {
  _set?: InputMaybe<Permissions_Set_Input>;
  where: Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_By_PkArgs = {
  _set?: InputMaybe<Permissions_Set_Input>;
  pk_columns: Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_ManyArgs = {
  updates: Array<Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_NumbersArgs = {
  _set?: InputMaybe<Phone_Numbers_Set_Input>;
  where: Phone_Numbers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_Numbers_By_PkArgs = {
  _set?: InputMaybe<Phone_Numbers_Set_Input>;
  pk_columns: Phone_Numbers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_Numbers_ManyArgs = {
  updates: Array<Phone_Numbers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_DatabrokersArgs = {
  _set?: InputMaybe<Pii_Databrokers_Set_Input>;
  where: Pii_Databrokers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_Databrokers_By_PkArgs = {
  _set?: InputMaybe<Pii_Databrokers_Set_Input>;
  pk_columns: Pii_Databrokers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_Databrokers_ManyArgs = {
  updates: Array<Pii_Databrokers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_EventsArgs = {
  _set?: InputMaybe<Pii_Events_Set_Input>;
  where: Pii_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_Events_By_PkArgs = {
  _set?: InputMaybe<Pii_Events_Set_Input>;
  pk_columns: Pii_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_Events_ManyArgs = {
  updates: Array<Pii_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_ReportsArgs = {
  _inc?: InputMaybe<Pii_Reports_Inc_Input>;
  _set?: InputMaybe<Pii_Reports_Set_Input>;
  where: Pii_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_Reports_By_PkArgs = {
  _inc?: InputMaybe<Pii_Reports_Inc_Input>;
  _set?: InputMaybe<Pii_Reports_Set_Input>;
  pk_columns: Pii_Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_Reports_ManyArgs = {
  updates: Array<Pii_Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_StatisticsArgs = {
  _inc?: InputMaybe<Pii_Statistics_Inc_Input>;
  _set?: InputMaybe<Pii_Statistics_Set_Input>;
  where: Pii_Statistics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_Statistics_By_PkArgs = {
  _inc?: InputMaybe<Pii_Statistics_Inc_Input>;
  _set?: InputMaybe<Pii_Statistics_Set_Input>;
  pk_columns: Pii_Statistics_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pii_Statistics_ManyArgs = {
  updates: Array<Pii_Statistics_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Platform_SubtypesArgs = {
  _set?: InputMaybe<Platform_Subtypes_Set_Input>;
  where: Platform_Subtypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Platform_Subtypes_By_PkArgs = {
  _set?: InputMaybe<Platform_Subtypes_Set_Input>;
  pk_columns: Platform_Subtypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Platform_Subtypes_ManyArgs = {
  updates: Array<Platform_Subtypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlatformsArgs = {
  _append?: InputMaybe<Platforms_Append_Input>;
  _delete_at_path?: InputMaybe<Platforms_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Platforms_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Platforms_Delete_Key_Input>;
  _prepend?: InputMaybe<Platforms_Prepend_Input>;
  _set?: InputMaybe<Platforms_Set_Input>;
  where: Platforms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Platforms_By_PkArgs = {
  _append?: InputMaybe<Platforms_Append_Input>;
  _delete_at_path?: InputMaybe<Platforms_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Platforms_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Platforms_Delete_Key_Input>;
  _prepend?: InputMaybe<Platforms_Prepend_Input>;
  _set?: InputMaybe<Platforms_Set_Input>;
  pk_columns: Platforms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Platforms_ManyArgs = {
  updates: Array<Platforms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pre_CollectionsArgs = {
  _set?: InputMaybe<Pre_Collections_Set_Input>;
  where: Pre_Collections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pre_Collections_By_PkArgs = {
  _set?: InputMaybe<Pre_Collections_Set_Input>;
  pk_columns: Pre_Collections_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pre_Collections_ManyArgs = {
  updates: Array<Pre_Collections_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Predicted_Enforcement_TypesArgs = {
  _set?: InputMaybe<Predicted_Enforcement_Types_Set_Input>;
  where: Predicted_Enforcement_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Predicted_Enforcement_Types_By_PkArgs = {
  _set?: InputMaybe<Predicted_Enforcement_Types_Set_Input>;
  pk_columns: Predicted_Enforcement_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Predicted_Enforcement_Types_ManyArgs = {
  updates: Array<Predicted_Enforcement_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Protected_AssetsArgs = {
  _inc?: InputMaybe<Protected_Assets_Inc_Input>;
  _set?: InputMaybe<Protected_Assets_Set_Input>;
  where: Protected_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Protected_Assets_By_PkArgs = {
  _inc?: InputMaybe<Protected_Assets_Inc_Input>;
  _set?: InputMaybe<Protected_Assets_Set_Input>;
  pk_columns: Protected_Assets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Protected_Assets_ManyArgs = {
  updates: Array<Protected_Assets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Report_TagsArgs = {
  _set?: InputMaybe<Report_Tags_Set_Input>;
  where: Report_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Report_Tags_By_PkArgs = {
  _set?: InputMaybe<Report_Tags_Set_Input>;
  pk_columns: Report_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Report_Tags_ManyArgs = {
  updates: Array<Report_Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Reports_ActionArgs = {
  update_reports_input: UpdateReportsInput;
};


/** mutation root */
export type Mutation_RootUpdate_Reports_To_ReportsArgs = {
  _set?: InputMaybe<Reports_To_Reports_Set_Input>;
  where: Reports_To_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reports_To_Reports_By_PkArgs = {
  _set?: InputMaybe<Reports_To_Reports_Set_Input>;
  pk_columns: Reports_To_Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reports_To_Reports_ManyArgs = {
  updates: Array<Reports_To_Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Role_PermissionsArgs = {
  _set?: InputMaybe<Role_Permissions_Set_Input>;
  where: Role_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Permissions_By_PkArgs = {
  _set?: InputMaybe<Role_Permissions_Set_Input>;
  pk_columns: Role_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Permissions_ManyArgs = {
  updates: Array<Role_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _set?: InputMaybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _set?: InputMaybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_ManyArgs = {
  updates: Array<Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RulesArgs = {
  _append?: InputMaybe<Rules_Append_Input>;
  _delete_at_path?: InputMaybe<Rules_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rules_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rules_Delete_Key_Input>;
  _prepend?: InputMaybe<Rules_Prepend_Input>;
  _set?: InputMaybe<Rules_Set_Input>;
  where: Rules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rules_By_PkArgs = {
  _append?: InputMaybe<Rules_Append_Input>;
  _delete_at_path?: InputMaybe<Rules_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rules_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rules_Delete_Key_Input>;
  _prepend?: InputMaybe<Rules_Prepend_Input>;
  _set?: InputMaybe<Rules_Set_Input>;
  pk_columns: Rules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rules_ManyArgs = {
  updates: Array<Rules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Safelist_Ip_AddressesArgs = {
  _set?: InputMaybe<Safelist_Ip_Addresses_Set_Input>;
  where: Safelist_Ip_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Safelist_Ip_Addresses_By_PkArgs = {
  _set?: InputMaybe<Safelist_Ip_Addresses_Set_Input>;
  pk_columns: Safelist_Ip_Addresses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Safelist_Ip_Addresses_ManyArgs = {
  updates: Array<Safelist_Ip_Addresses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Salesforce_Organizations_DataArgs = {
  _inc?: InputMaybe<Salesforce_Organizations_Data_Inc_Input>;
  _set?: InputMaybe<Salesforce_Organizations_Data_Set_Input>;
  where: Salesforce_Organizations_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Salesforce_Organizations_Data_By_PkArgs = {
  _inc?: InputMaybe<Salesforce_Organizations_Data_Inc_Input>;
  _set?: InputMaybe<Salesforce_Organizations_Data_Set_Input>;
  pk_columns: Salesforce_Organizations_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Salesforce_Organizations_Data_ManyArgs = {
  updates: Array<Salesforce_Organizations_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scan_ResultsArgs = {
  _append?: InputMaybe<Scan_Results_Append_Input>;
  _delete_at_path?: InputMaybe<Scan_Results_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scan_Results_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scan_Results_Delete_Key_Input>;
  _prepend?: InputMaybe<Scan_Results_Prepend_Input>;
  _set?: InputMaybe<Scan_Results_Set_Input>;
  where: Scan_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scan_Results_By_PkArgs = {
  _append?: InputMaybe<Scan_Results_Append_Input>;
  _delete_at_path?: InputMaybe<Scan_Results_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scan_Results_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scan_Results_Delete_Key_Input>;
  _prepend?: InputMaybe<Scan_Results_Prepend_Input>;
  _set?: InputMaybe<Scan_Results_Set_Input>;
  pk_columns: Scan_Results_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scan_Results_ManyArgs = {
  updates: Array<Scan_Results_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ScansArgs = {
  _set?: InputMaybe<Scans_Set_Input>;
  where: Scans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scans_By_PkArgs = {
  _set?: InputMaybe<Scans_Set_Input>;
  pk_columns: Scans_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scans_ManyArgs = {
  updates: Array<Scans_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scraping_ConfigsArgs = {
  _append?: InputMaybe<Scraping_Configs_Append_Input>;
  _delete_at_path?: InputMaybe<Scraping_Configs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scraping_Configs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scraping_Configs_Delete_Key_Input>;
  _prepend?: InputMaybe<Scraping_Configs_Prepend_Input>;
  _set?: InputMaybe<Scraping_Configs_Set_Input>;
  where: Scraping_Configs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scraping_Configs_By_PkArgs = {
  _append?: InputMaybe<Scraping_Configs_Append_Input>;
  _delete_at_path?: InputMaybe<Scraping_Configs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Scraping_Configs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Scraping_Configs_Delete_Key_Input>;
  _prepend?: InputMaybe<Scraping_Configs_Prepend_Input>;
  _set?: InputMaybe<Scraping_Configs_Set_Input>;
  pk_columns: Scraping_Configs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Scraping_Configs_ManyArgs = {
  updates: Array<Scraping_Configs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_Campaign_ObservationsArgs = {
  _set?: InputMaybe<Sim_Campaign_Observations_Set_Input>;
  where: Sim_Campaign_Observations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_Campaign_Observations_By_PkArgs = {
  _set?: InputMaybe<Sim_Campaign_Observations_Set_Input>;
  pk_columns: Sim_Campaign_Observations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_Campaign_Observations_ManyArgs = {
  updates: Array<Sim_Campaign_Observations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_CampaignsArgs = {
  _set?: InputMaybe<Sim_Campaigns_Set_Input>;
  where: Sim_Campaigns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_Campaigns_By_PkArgs = {
  _set?: InputMaybe<Sim_Campaigns_Set_Input>;
  pk_columns: Sim_Campaigns_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_Campaigns_ManyArgs = {
  updates: Array<Sim_Campaigns_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_EmailsArgs = {
  _append?: InputMaybe<Sim_Emails_Append_Input>;
  _delete_at_path?: InputMaybe<Sim_Emails_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sim_Emails_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sim_Emails_Delete_Key_Input>;
  _prepend?: InputMaybe<Sim_Emails_Prepend_Input>;
  _set?: InputMaybe<Sim_Emails_Set_Input>;
  where: Sim_Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_Emails_By_PkArgs = {
  _append?: InputMaybe<Sim_Emails_Append_Input>;
  _delete_at_path?: InputMaybe<Sim_Emails_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Sim_Emails_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Sim_Emails_Delete_Key_Input>;
  _prepend?: InputMaybe<Sim_Emails_Prepend_Input>;
  _set?: InputMaybe<Sim_Emails_Set_Input>;
  pk_columns: Sim_Emails_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_Emails_ManyArgs = {
  updates: Array<Sim_Emails_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_GroupsArgs = {
  _set?: InputMaybe<Sim_Groups_Set_Input>;
  where: Sim_Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_Groups_By_PkArgs = {
  _set?: InputMaybe<Sim_Groups_Set_Input>;
  pk_columns: Sim_Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_Groups_ManyArgs = {
  updates: Array<Sim_Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_UsersArgs = {
  _set?: InputMaybe<Sim_Users_Set_Input>;
  where: Sim_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_Users_By_PkArgs = {
  _set?: InputMaybe<Sim_Users_Set_Input>;
  pk_columns: Sim_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sim_Users_ManyArgs = {
  updates: Array<Sim_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Slack_InstallationsArgs = {
  _append?: InputMaybe<Slack_Installations_Append_Input>;
  _delete_at_path?: InputMaybe<Slack_Installations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Slack_Installations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Slack_Installations_Delete_Key_Input>;
  _prepend?: InputMaybe<Slack_Installations_Prepend_Input>;
  _set?: InputMaybe<Slack_Installations_Set_Input>;
  where: Slack_Installations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Slack_Installations_By_PkArgs = {
  _append?: InputMaybe<Slack_Installations_Append_Input>;
  _delete_at_path?: InputMaybe<Slack_Installations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Slack_Installations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Slack_Installations_Delete_Key_Input>;
  _prepend?: InputMaybe<Slack_Installations_Prepend_Input>;
  _set?: InputMaybe<Slack_Installations_Set_Input>;
  pk_columns: Slack_Installations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Slack_Installations_ManyArgs = {
  updates: Array<Slack_Installations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_CommentsArgs = {
  _inc?: InputMaybe<Social_Media_Comments_Inc_Input>;
  _set?: InputMaybe<Social_Media_Comments_Set_Input>;
  where: Social_Media_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_Comments_By_PkArgs = {
  _inc?: InputMaybe<Social_Media_Comments_Inc_Input>;
  _set?: InputMaybe<Social_Media_Comments_Set_Input>;
  pk_columns: Social_Media_Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_Comments_ManyArgs = {
  updates: Array<Social_Media_Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_DataArgs = {
  _inc?: InputMaybe<Social_Media_Data_Inc_Input>;
  _set?: InputMaybe<Social_Media_Data_Set_Input>;
  where: Social_Media_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_Data_By_PkArgs = {
  _inc?: InputMaybe<Social_Media_Data_Inc_Input>;
  _set?: InputMaybe<Social_Media_Data_Set_Input>;
  pk_columns: Social_Media_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_Data_ManyArgs = {
  updates: Array<Social_Media_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_GroupArgs = {
  _append?: InputMaybe<Social_Media_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Social_Media_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Social_Media_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Social_Media_Group_Delete_Key_Input>;
  _inc?: InputMaybe<Social_Media_Group_Inc_Input>;
  _prepend?: InputMaybe<Social_Media_Group_Prepend_Input>;
  _set?: InputMaybe<Social_Media_Group_Set_Input>;
  where: Social_Media_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_Group_By_PkArgs = {
  _append?: InputMaybe<Social_Media_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Social_Media_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Social_Media_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Social_Media_Group_Delete_Key_Input>;
  _inc?: InputMaybe<Social_Media_Group_Inc_Input>;
  _prepend?: InputMaybe<Social_Media_Group_Prepend_Input>;
  _set?: InputMaybe<Social_Media_Group_Set_Input>;
  pk_columns: Social_Media_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_Group_ManyArgs = {
  updates: Array<Social_Media_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_PostArgs = {
  _append?: InputMaybe<Social_Media_Post_Append_Input>;
  _delete_at_path?: InputMaybe<Social_Media_Post_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Social_Media_Post_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Social_Media_Post_Delete_Key_Input>;
  _inc?: InputMaybe<Social_Media_Post_Inc_Input>;
  _prepend?: InputMaybe<Social_Media_Post_Prepend_Input>;
  _set?: InputMaybe<Social_Media_Post_Set_Input>;
  where: Social_Media_Post_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_Post_By_PkArgs = {
  _append?: InputMaybe<Social_Media_Post_Append_Input>;
  _delete_at_path?: InputMaybe<Social_Media_Post_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Social_Media_Post_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Social_Media_Post_Delete_Key_Input>;
  _inc?: InputMaybe<Social_Media_Post_Inc_Input>;
  _prepend?: InputMaybe<Social_Media_Post_Prepend_Input>;
  _set?: InputMaybe<Social_Media_Post_Set_Input>;
  pk_columns: Social_Media_Post_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Social_Media_Post_ManyArgs = {
  updates: Array<Social_Media_Post_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sourcing_QueriesArgs = {
  _inc?: InputMaybe<Sourcing_Queries_Inc_Input>;
  _set?: InputMaybe<Sourcing_Queries_Set_Input>;
  where: Sourcing_Queries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sourcing_Queries_By_PkArgs = {
  _inc?: InputMaybe<Sourcing_Queries_Inc_Input>;
  _set?: InputMaybe<Sourcing_Queries_Set_Input>;
  pk_columns: Sourcing_Queries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sourcing_Queries_ManyArgs = {
  updates: Array<Sourcing_Queries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Sourcing_Query_ExecutionsArgs = {
  _inc?: InputMaybe<Sourcing_Query_Executions_Inc_Input>;
  _set?: InputMaybe<Sourcing_Query_Executions_Set_Input>;
  where: Sourcing_Query_Executions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Sourcing_Query_Executions_By_PkArgs = {
  _inc?: InputMaybe<Sourcing_Query_Executions_Inc_Input>;
  _set?: InputMaybe<Sourcing_Query_Executions_Set_Input>;
  pk_columns: Sourcing_Query_Executions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Sourcing_Query_Executions_ManyArgs = {
  updates: Array<Sourcing_Query_Executions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Spoof_MatchesArgs = {
  _inc?: InputMaybe<Spoof_Matches_Inc_Input>;
  _set?: InputMaybe<Spoof_Matches_Set_Input>;
  where: Spoof_Matches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Spoof_Matches_By_PkArgs = {
  _inc?: InputMaybe<Spoof_Matches_Inc_Input>;
  _set?: InputMaybe<Spoof_Matches_Set_Input>;
  pk_columns: Spoof_Matches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Spoof_Matches_ManyArgs = {
  updates: Array<Spoof_Matches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Spoofing_EntitiesArgs = {
  _append?: InputMaybe<Spoofing_Entities_Append_Input>;
  _delete_at_path?: InputMaybe<Spoofing_Entities_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Spoofing_Entities_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Spoofing_Entities_Delete_Key_Input>;
  _prepend?: InputMaybe<Spoofing_Entities_Prepend_Input>;
  _set?: InputMaybe<Spoofing_Entities_Set_Input>;
  where: Spoofing_Entities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Spoofing_Entities_By_PkArgs = {
  _append?: InputMaybe<Spoofing_Entities_Append_Input>;
  _delete_at_path?: InputMaybe<Spoofing_Entities_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Spoofing_Entities_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Spoofing_Entities_Delete_Key_Input>;
  _prepend?: InputMaybe<Spoofing_Entities_Prepend_Input>;
  _set?: InputMaybe<Spoofing_Entities_Set_Input>;
  pk_columns: Spoofing_Entities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Spoofing_Entities_ManyArgs = {
  updates: Array<Spoofing_Entities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Spoofing_Report_Search_ResultsArgs = {
  _append?: InputMaybe<Spoofing_Report_Search_Results_Append_Input>;
  _delete_at_path?: InputMaybe<Spoofing_Report_Search_Results_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Spoofing_Report_Search_Results_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Spoofing_Report_Search_Results_Delete_Key_Input>;
  _inc?: InputMaybe<Spoofing_Report_Search_Results_Inc_Input>;
  _prepend?: InputMaybe<Spoofing_Report_Search_Results_Prepend_Input>;
  _set?: InputMaybe<Spoofing_Report_Search_Results_Set_Input>;
  where: Spoofing_Report_Search_Results_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Spoofing_Report_Search_Results_ManyArgs = {
  updates: Array<Spoofing_Report_Search_Results_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Spoofing_ReportsArgs = {
  _append?: InputMaybe<Spoofing_Reports_Append_Input>;
  _delete_at_path?: InputMaybe<Spoofing_Reports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Spoofing_Reports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Spoofing_Reports_Delete_Key_Input>;
  _inc?: InputMaybe<Spoofing_Reports_Inc_Input>;
  _prepend?: InputMaybe<Spoofing_Reports_Prepend_Input>;
  _set?: InputMaybe<Spoofing_Reports_Set_Input>;
  where: Spoofing_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Spoofing_Reports_By_PkArgs = {
  _append?: InputMaybe<Spoofing_Reports_Append_Input>;
  _delete_at_path?: InputMaybe<Spoofing_Reports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Spoofing_Reports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Spoofing_Reports_Delete_Key_Input>;
  _inc?: InputMaybe<Spoofing_Reports_Inc_Input>;
  _prepend?: InputMaybe<Spoofing_Reports_Prepend_Input>;
  _set?: InputMaybe<Spoofing_Reports_Set_Input>;
  pk_columns: Spoofing_Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Spoofing_Reports_ManyArgs = {
  updates: Array<Spoofing_Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Spoofing_Reports_To_TagsArgs = {
  _set?: InputMaybe<Spoofing_Reports_To_Tags_Set_Input>;
  where: Spoofing_Reports_To_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Spoofing_Reports_To_Tags_By_PkArgs = {
  _set?: InputMaybe<Spoofing_Reports_To_Tags_Set_Input>;
  pk_columns: Spoofing_Reports_To_Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Spoofing_Reports_To_Tags_ManyArgs = {
  updates: Array<Spoofing_Reports_To_Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Suggested_EnforcementsArgs = {
  _append?: InputMaybe<Suggested_Enforcements_Append_Input>;
  _delete_at_path?: InputMaybe<Suggested_Enforcements_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Suggested_Enforcements_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Suggested_Enforcements_Delete_Key_Input>;
  _prepend?: InputMaybe<Suggested_Enforcements_Prepend_Input>;
  _set?: InputMaybe<Suggested_Enforcements_Set_Input>;
  where: Suggested_Enforcements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Suggested_Enforcements_By_PkArgs = {
  _append?: InputMaybe<Suggested_Enforcements_Append_Input>;
  _delete_at_path?: InputMaybe<Suggested_Enforcements_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Suggested_Enforcements_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Suggested_Enforcements_Delete_Key_Input>;
  _prepend?: InputMaybe<Suggested_Enforcements_Prepend_Input>;
  _set?: InputMaybe<Suggested_Enforcements_Set_Input>;
  pk_columns: Suggested_Enforcements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Suggested_Enforcements_Form_ResponsesArgs = {
  _append?: InputMaybe<Suggested_Enforcements_Form_Responses_Append_Input>;
  _delete_at_path?: InputMaybe<Suggested_Enforcements_Form_Responses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Suggested_Enforcements_Form_Responses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Suggested_Enforcements_Form_Responses_Delete_Key_Input>;
  _prepend?: InputMaybe<Suggested_Enforcements_Form_Responses_Prepend_Input>;
  _set?: InputMaybe<Suggested_Enforcements_Form_Responses_Set_Input>;
  where: Suggested_Enforcements_Form_Responses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Suggested_Enforcements_Form_Responses_By_PkArgs = {
  _append?: InputMaybe<Suggested_Enforcements_Form_Responses_Append_Input>;
  _delete_at_path?: InputMaybe<Suggested_Enforcements_Form_Responses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Suggested_Enforcements_Form_Responses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Suggested_Enforcements_Form_Responses_Delete_Key_Input>;
  _prepend?: InputMaybe<Suggested_Enforcements_Form_Responses_Prepend_Input>;
  _set?: InputMaybe<Suggested_Enforcements_Form_Responses_Set_Input>;
  pk_columns: Suggested_Enforcements_Form_Responses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Suggested_Enforcements_Form_Responses_ManyArgs = {
  updates: Array<Suggested_Enforcements_Form_Responses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Suggested_Enforcements_ManyArgs = {
  updates: Array<Suggested_Enforcements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TagsArgs = {
  _set?: InputMaybe<Tags_Set_Input>;
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_By_PkArgs = {
  _set?: InputMaybe<Tags_Set_Input>;
  pk_columns: Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_ManyArgs = {
  updates: Array<Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_Actor_To_CampaignArgs = {
  _set?: InputMaybe<Threat_Intel_Actor_To_Campaign_Set_Input>;
  where: Threat_Intel_Actor_To_Campaign_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_Actor_To_Campaign_By_PkArgs = {
  _set?: InputMaybe<Threat_Intel_Actor_To_Campaign_Set_Input>;
  pk_columns: Threat_Intel_Actor_To_Campaign_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_Actor_To_Campaign_ManyArgs = {
  updates: Array<Threat_Intel_Actor_To_Campaign_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_ActorsArgs = {
  _set?: InputMaybe<Threat_Intel_Actors_Set_Input>;
  where: Threat_Intel_Actors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_Actors_By_PkArgs = {
  _set?: InputMaybe<Threat_Intel_Actors_Set_Input>;
  pk_columns: Threat_Intel_Actors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_Actors_ManyArgs = {
  updates: Array<Threat_Intel_Actors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_Campaign_To_EntitiesArgs = {
  _set?: InputMaybe<Threat_Intel_Campaign_To_Entities_Set_Input>;
  where: Threat_Intel_Campaign_To_Entities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_Campaign_To_Entities_By_PkArgs = {
  _set?: InputMaybe<Threat_Intel_Campaign_To_Entities_Set_Input>;
  pk_columns: Threat_Intel_Campaign_To_Entities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_Campaign_To_Entities_ManyArgs = {
  updates: Array<Threat_Intel_Campaign_To_Entities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_CampaignsArgs = {
  _append?: InputMaybe<Threat_Intel_Campaigns_Append_Input>;
  _delete_at_path?: InputMaybe<Threat_Intel_Campaigns_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Threat_Intel_Campaigns_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Threat_Intel_Campaigns_Delete_Key_Input>;
  _prepend?: InputMaybe<Threat_Intel_Campaigns_Prepend_Input>;
  _set?: InputMaybe<Threat_Intel_Campaigns_Set_Input>;
  where: Threat_Intel_Campaigns_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_Campaigns_By_PkArgs = {
  _append?: InputMaybe<Threat_Intel_Campaigns_Append_Input>;
  _delete_at_path?: InputMaybe<Threat_Intel_Campaigns_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Threat_Intel_Campaigns_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Threat_Intel_Campaigns_Delete_Key_Input>;
  _prepend?: InputMaybe<Threat_Intel_Campaigns_Prepend_Input>;
  _set?: InputMaybe<Threat_Intel_Campaigns_Set_Input>;
  pk_columns: Threat_Intel_Campaigns_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Threat_Intel_Campaigns_ManyArgs = {
  updates: Array<Threat_Intel_Campaigns_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TrademarksArgs = {
  _set?: InputMaybe<Trademarks_Set_Input>;
  where: Trademarks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademarks_By_PkArgs = {
  _set?: InputMaybe<Trademarks_Set_Input>;
  pk_columns: Trademarks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademarks_ManyArgs = {
  updates: Array<Trademarks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uploaded_FilesArgs = {
  _set?: InputMaybe<Uploaded_Files_Set_Input>;
  where: Uploaded_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uploaded_Files_By_PkArgs = {
  _set?: InputMaybe<Uploaded_Files_Set_Input>;
  pk_columns: Uploaded_Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uploaded_Files_ManyArgs = {
  updates: Array<Uploaded_Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_AccessArgs = {
  manage_user_access_input: ManageUserAccessInput;
};


/** mutation root */
export type Mutation_RootUpdate_User_FeedbackArgs = {
  _set?: InputMaybe<User_Feedback_Set_Input>;
  where: User_Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Feedback_By_PkArgs = {
  _set?: InputMaybe<User_Feedback_Set_Input>;
  pk_columns: User_Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Feedback_ManyArgs = {
  updates: Array<User_Feedback_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_OrganizationsArgs = {
  _set?: InputMaybe<User_Organizations_Set_Input>;
  where: User_Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Organizations_By_PkArgs = {
  _set?: InputMaybe<User_Organizations_Set_Input>;
  pk_columns: User_Organizations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Organizations_ManyArgs = {
  updates: Array<User_Organizations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ProductsArgs = {
  _set?: InputMaybe<User_Products_Set_Input>;
  where: User_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Products_By_PkArgs = {
  _set?: InputMaybe<User_Products_Set_Input>;
  pk_columns: User_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Products_ManyArgs = {
  updates: Array<User_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_V2Args = {
  manage_users_input: UpdateUserInput;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vetric_Screenshot_WebhooksArgs = {
  _inc?: InputMaybe<Vetric_Screenshot_Webhooks_Inc_Input>;
  _set?: InputMaybe<Vetric_Screenshot_Webhooks_Set_Input>;
  where: Vetric_Screenshot_Webhooks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vetric_Screenshot_Webhooks_By_PkArgs = {
  _inc?: InputMaybe<Vetric_Screenshot_Webhooks_Inc_Input>;
  _set?: InputMaybe<Vetric_Screenshot_Webhooks_Set_Input>;
  pk_columns: Vetric_Screenshot_Webhooks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vetric_Screenshot_Webhooks_ManyArgs = {
  updates: Array<Vetric_Screenshot_Webhooks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Webhook_TargetsArgs = {
  _append?: InputMaybe<Webhook_Targets_Append_Input>;
  _delete_at_path?: InputMaybe<Webhook_Targets_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Webhook_Targets_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Webhook_Targets_Delete_Key_Input>;
  _prepend?: InputMaybe<Webhook_Targets_Prepend_Input>;
  _set?: InputMaybe<Webhook_Targets_Set_Input>;
  where: Webhook_Targets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Webhook_Targets_By_PkArgs = {
  _append?: InputMaybe<Webhook_Targets_Append_Input>;
  _delete_at_path?: InputMaybe<Webhook_Targets_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Webhook_Targets_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Webhook_Targets_Delete_Key_Input>;
  _prepend?: InputMaybe<Webhook_Targets_Prepend_Input>;
  _set?: InputMaybe<Webhook_Targets_Set_Input>;
  pk_columns: Webhook_Targets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Webhook_Targets_ManyArgs = {
  updates: Array<Webhook_Targets_Updates>;
};


/** mutation root */
export type Mutation_RootUpload_New_Alert_ActionArgs = {
  upload_new_alert_input: UploadNewAlertInput;
};


/** mutation root */
export type Mutation_RootUpload_New_Detection_AssetArgs = {
  upload_new_detection_asset_input: UploadNewDetectionAssetInput;
};


/** mutation root */
export type Mutation_RootUpload_New_Enforcement_RequestArgs = {
  upload_new_enforcement_request_input: UploadNewEnforcementRequestInput;
};


/** mutation root */
export type Mutation_RootUpload_New_Enforcement_Request_V2Args = {
  upload_new_enforcement_request_v2_input: UploadNewEnforcementRequestV2Input;
};


/** mutation root */
export type Mutation_RootUpload_New_Enforcement_TemplateArgs = {
  upload_new_enforcement_template_input: UploadNewEnforcementTemplateInput;
};


/** mutation root */
export type Mutation_RootUpload_New_Nft_Customer_CollectionArgs = {
  upload_new_nft_customer_collection_input: UploadNewNftCustomerCollectionInput;
};


/** mutation root */
export type Mutation_RootUpload_New_Nft_Marketplace_CollectionArgs = {
  upload_new_nft_marketplace_collection_input: UploadNewNftMarketplaceCollectionInput;
};


/** mutation root */
export type Mutation_RootUpload_New_OrganizationArgs = {
  upload_new_organization_input: UploadNewOrganizationInput;
};


/** mutation root */
export type Mutation_RootUpload_New_PlatformArgs = {
  upload_new_platform_input: UploadNewPlatformInput;
};


/** mutation root */
export type Mutation_RootUpload_New_Protected_AssetArgs = {
  upload_new_protected_asset_input: UploadNewProtectedAssetInput;
};


/** mutation root */
export type Mutation_RootUpload_New_Report_ActionArgs = {
  upload_new_report_input: UploadNewReportInput;
};


/** mutation root */
export type Mutation_RootUpload_New_TrademarkArgs = {
  upload_new_trademark_input: UploadNewTrademarkInput;
};


/** mutation root */
export type Mutation_RootUpload_New_Web2_EntityArgs = {
  upload_new_web2_entity_input: UploadNewWeb2EntityInput;
};


/** mutation root */
export type Mutation_RootUpload_Report_FileArgs = {
  upload_report_file_input: UploadReportFileInput;
};

/** columns and relationships of "mv_alerts_surfaced_by_day" */
export type Mv_Alerts_Surfaced_By_Day = {
  __typename?: 'mv_alerts_surfaced_by_day';
  alert_ids?: Maybe<Array<Scalars['uuid']>>;
  alert_status?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
  uploader?: Maybe<Scalars['String']>;
};

/** aggregated selection of "mv_alerts_surfaced_by_day" */
export type Mv_Alerts_Surfaced_By_Day_Aggregate = {
  __typename?: 'mv_alerts_surfaced_by_day_aggregate';
  aggregate?: Maybe<Mv_Alerts_Surfaced_By_Day_Aggregate_Fields>;
  nodes: Array<Mv_Alerts_Surfaced_By_Day>;
};

/** aggregate fields of "mv_alerts_surfaced_by_day" */
export type Mv_Alerts_Surfaced_By_Day_Aggregate_Fields = {
  __typename?: 'mv_alerts_surfaced_by_day_aggregate_fields';
  avg?: Maybe<Mv_Alerts_Surfaced_By_Day_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mv_Alerts_Surfaced_By_Day_Max_Fields>;
  min?: Maybe<Mv_Alerts_Surfaced_By_Day_Min_Fields>;
  stddev?: Maybe<Mv_Alerts_Surfaced_By_Day_Stddev_Fields>;
  stddev_pop?: Maybe<Mv_Alerts_Surfaced_By_Day_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mv_Alerts_Surfaced_By_Day_Stddev_Samp_Fields>;
  sum?: Maybe<Mv_Alerts_Surfaced_By_Day_Sum_Fields>;
  var_pop?: Maybe<Mv_Alerts_Surfaced_By_Day_Var_Pop_Fields>;
  var_samp?: Maybe<Mv_Alerts_Surfaced_By_Day_Var_Samp_Fields>;
  variance?: Maybe<Mv_Alerts_Surfaced_By_Day_Variance_Fields>;
};


/** aggregate fields of "mv_alerts_surfaced_by_day" */
export type Mv_Alerts_Surfaced_By_Day_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Day_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mv_Alerts_Surfaced_By_Day_Avg_Fields = {
  __typename?: 'mv_alerts_surfaced_by_day_avg_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mv_alerts_surfaced_by_day". All fields are combined with a logical 'AND'. */
export type Mv_Alerts_Surfaced_By_Day_Bool_Exp = {
  _and?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Day_Bool_Exp>>;
  _not?: InputMaybe<Mv_Alerts_Surfaced_By_Day_Bool_Exp>;
  _or?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Day_Bool_Exp>>;
  alert_ids?: InputMaybe<Uuid_Array_Comparison_Exp>;
  alert_status?: InputMaybe<String_Comparison_Exp>;
  brand?: InputMaybe<String_Comparison_Exp>;
  num_alerts?: InputMaybe<Bigint_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<String_Array_Comparison_Exp>;
  time_bucket?: InputMaybe<String_Comparison_Exp>;
  uploader?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mv_Alerts_Surfaced_By_Day_Max_Fields = {
  __typename?: 'mv_alerts_surfaced_by_day_max_fields';
  alert_ids?: Maybe<Array<Scalars['uuid']>>;
  alert_status?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
  uploader?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mv_Alerts_Surfaced_By_Day_Min_Fields = {
  __typename?: 'mv_alerts_surfaced_by_day_min_fields';
  alert_ids?: Maybe<Array<Scalars['uuid']>>;
  alert_status?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
  uploader?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "mv_alerts_surfaced_by_day". */
export type Mv_Alerts_Surfaced_By_Day_Order_By = {
  alert_ids?: InputMaybe<Order_By>;
  alert_status?: InputMaybe<Order_By>;
  brand?: InputMaybe<Order_By>;
  num_alerts?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  time_bucket?: InputMaybe<Order_By>;
  uploader?: InputMaybe<Order_By>;
};

/** select columns of table "mv_alerts_surfaced_by_day" */
export enum Mv_Alerts_Surfaced_By_Day_Select_Column {
  /** column name */
  AlertIds = 'alert_ids',
  /** column name */
  AlertStatus = 'alert_status',
  /** column name */
  Brand = 'brand',
  /** column name */
  NumAlerts = 'num_alerts',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Product = 'product',
  /** column name */
  Source = 'source',
  /** column name */
  Tags = 'tags',
  /** column name */
  TimeBucket = 'time_bucket',
  /** column name */
  Uploader = 'uploader'
}

/** aggregate stddev on columns */
export type Mv_Alerts_Surfaced_By_Day_Stddev_Fields = {
  __typename?: 'mv_alerts_surfaced_by_day_stddev_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mv_Alerts_Surfaced_By_Day_Stddev_Pop_Fields = {
  __typename?: 'mv_alerts_surfaced_by_day_stddev_pop_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mv_Alerts_Surfaced_By_Day_Stddev_Samp_Fields = {
  __typename?: 'mv_alerts_surfaced_by_day_stddev_samp_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mv_alerts_surfaced_by_day" */
export type Mv_Alerts_Surfaced_By_Day_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mv_Alerts_Surfaced_By_Day_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mv_Alerts_Surfaced_By_Day_Stream_Cursor_Value_Input = {
  alert_ids?: InputMaybe<Array<Scalars['uuid']>>;
  alert_status?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  num_alerts?: InputMaybe<Scalars['bigint']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  time_bucket?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Mv_Alerts_Surfaced_By_Day_Sum_Fields = {
  __typename?: 'mv_alerts_surfaced_by_day_sum_fields';
  num_alerts?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Mv_Alerts_Surfaced_By_Day_Var_Pop_Fields = {
  __typename?: 'mv_alerts_surfaced_by_day_var_pop_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mv_Alerts_Surfaced_By_Day_Var_Samp_Fields = {
  __typename?: 'mv_alerts_surfaced_by_day_var_samp_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mv_Alerts_Surfaced_By_Day_Variance_Fields = {
  __typename?: 'mv_alerts_surfaced_by_day_variance_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "mv_alerts_surfaced_by_hour" */
export type Mv_Alerts_Surfaced_By_Hour = {
  __typename?: 'mv_alerts_surfaced_by_hour';
  alert_ids?: Maybe<Array<Scalars['uuid']>>;
  alert_status?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
  uploader?: Maybe<Scalars['String']>;
};

/** aggregated selection of "mv_alerts_surfaced_by_hour" */
export type Mv_Alerts_Surfaced_By_Hour_Aggregate = {
  __typename?: 'mv_alerts_surfaced_by_hour_aggregate';
  aggregate?: Maybe<Mv_Alerts_Surfaced_By_Hour_Aggregate_Fields>;
  nodes: Array<Mv_Alerts_Surfaced_By_Hour>;
};

/** aggregate fields of "mv_alerts_surfaced_by_hour" */
export type Mv_Alerts_Surfaced_By_Hour_Aggregate_Fields = {
  __typename?: 'mv_alerts_surfaced_by_hour_aggregate_fields';
  avg?: Maybe<Mv_Alerts_Surfaced_By_Hour_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mv_Alerts_Surfaced_By_Hour_Max_Fields>;
  min?: Maybe<Mv_Alerts_Surfaced_By_Hour_Min_Fields>;
  stddev?: Maybe<Mv_Alerts_Surfaced_By_Hour_Stddev_Fields>;
  stddev_pop?: Maybe<Mv_Alerts_Surfaced_By_Hour_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mv_Alerts_Surfaced_By_Hour_Stddev_Samp_Fields>;
  sum?: Maybe<Mv_Alerts_Surfaced_By_Hour_Sum_Fields>;
  var_pop?: Maybe<Mv_Alerts_Surfaced_By_Hour_Var_Pop_Fields>;
  var_samp?: Maybe<Mv_Alerts_Surfaced_By_Hour_Var_Samp_Fields>;
  variance?: Maybe<Mv_Alerts_Surfaced_By_Hour_Variance_Fields>;
};


/** aggregate fields of "mv_alerts_surfaced_by_hour" */
export type Mv_Alerts_Surfaced_By_Hour_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Hour_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mv_Alerts_Surfaced_By_Hour_Avg_Fields = {
  __typename?: 'mv_alerts_surfaced_by_hour_avg_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mv_alerts_surfaced_by_hour". All fields are combined with a logical 'AND'. */
export type Mv_Alerts_Surfaced_By_Hour_Bool_Exp = {
  _and?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Hour_Bool_Exp>>;
  _not?: InputMaybe<Mv_Alerts_Surfaced_By_Hour_Bool_Exp>;
  _or?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Hour_Bool_Exp>>;
  alert_ids?: InputMaybe<Uuid_Array_Comparison_Exp>;
  alert_status?: InputMaybe<String_Comparison_Exp>;
  brand?: InputMaybe<String_Comparison_Exp>;
  num_alerts?: InputMaybe<Bigint_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<String_Array_Comparison_Exp>;
  time_bucket?: InputMaybe<String_Comparison_Exp>;
  uploader?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mv_Alerts_Surfaced_By_Hour_Max_Fields = {
  __typename?: 'mv_alerts_surfaced_by_hour_max_fields';
  alert_ids?: Maybe<Array<Scalars['uuid']>>;
  alert_status?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
  uploader?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mv_Alerts_Surfaced_By_Hour_Min_Fields = {
  __typename?: 'mv_alerts_surfaced_by_hour_min_fields';
  alert_ids?: Maybe<Array<Scalars['uuid']>>;
  alert_status?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
  uploader?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "mv_alerts_surfaced_by_hour". */
export type Mv_Alerts_Surfaced_By_Hour_Order_By = {
  alert_ids?: InputMaybe<Order_By>;
  alert_status?: InputMaybe<Order_By>;
  brand?: InputMaybe<Order_By>;
  num_alerts?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  time_bucket?: InputMaybe<Order_By>;
  uploader?: InputMaybe<Order_By>;
};

/** select columns of table "mv_alerts_surfaced_by_hour" */
export enum Mv_Alerts_Surfaced_By_Hour_Select_Column {
  /** column name */
  AlertIds = 'alert_ids',
  /** column name */
  AlertStatus = 'alert_status',
  /** column name */
  Brand = 'brand',
  /** column name */
  NumAlerts = 'num_alerts',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Product = 'product',
  /** column name */
  Source = 'source',
  /** column name */
  Tags = 'tags',
  /** column name */
  TimeBucket = 'time_bucket',
  /** column name */
  Uploader = 'uploader'
}

/** aggregate stddev on columns */
export type Mv_Alerts_Surfaced_By_Hour_Stddev_Fields = {
  __typename?: 'mv_alerts_surfaced_by_hour_stddev_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mv_Alerts_Surfaced_By_Hour_Stddev_Pop_Fields = {
  __typename?: 'mv_alerts_surfaced_by_hour_stddev_pop_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mv_Alerts_Surfaced_By_Hour_Stddev_Samp_Fields = {
  __typename?: 'mv_alerts_surfaced_by_hour_stddev_samp_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mv_alerts_surfaced_by_hour" */
export type Mv_Alerts_Surfaced_By_Hour_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mv_Alerts_Surfaced_By_Hour_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mv_Alerts_Surfaced_By_Hour_Stream_Cursor_Value_Input = {
  alert_ids?: InputMaybe<Array<Scalars['uuid']>>;
  alert_status?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  num_alerts?: InputMaybe<Scalars['bigint']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  time_bucket?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Mv_Alerts_Surfaced_By_Hour_Sum_Fields = {
  __typename?: 'mv_alerts_surfaced_by_hour_sum_fields';
  num_alerts?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Mv_Alerts_Surfaced_By_Hour_Var_Pop_Fields = {
  __typename?: 'mv_alerts_surfaced_by_hour_var_pop_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mv_Alerts_Surfaced_By_Hour_Var_Samp_Fields = {
  __typename?: 'mv_alerts_surfaced_by_hour_var_samp_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mv_Alerts_Surfaced_By_Hour_Variance_Fields = {
  __typename?: 'mv_alerts_surfaced_by_hour_variance_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "mv_alerts_times_to_actioned" */
export type Mv_Alerts_Times_To_Actioned = {
  __typename?: 'mv_alerts_times_to_actioned';
  alert_id?: Maybe<Scalars['uuid']>;
  brand?: Maybe<Scalars['String']>;
  created_timestamp?: Maybe<Scalars['timestamp']>;
  mitigated_timestamp?: Maybe<Scalars['timestamp']>;
  mitigation_time_hours?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_type?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  resolution_time_hours?: Maybe<Scalars['numeric']>;
  resolved_timestamp?: Maybe<Scalars['timestamp']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['date']>;
  uploader?: Maybe<Scalars['String']>;
};

/** aggregated selection of "mv_alerts_times_to_actioned" */
export type Mv_Alerts_Times_To_Actioned_Aggregate = {
  __typename?: 'mv_alerts_times_to_actioned_aggregate';
  aggregate?: Maybe<Mv_Alerts_Times_To_Actioned_Aggregate_Fields>;
  nodes: Array<Mv_Alerts_Times_To_Actioned>;
};

/** aggregate fields of "mv_alerts_times_to_actioned" */
export type Mv_Alerts_Times_To_Actioned_Aggregate_Fields = {
  __typename?: 'mv_alerts_times_to_actioned_aggregate_fields';
  avg?: Maybe<Mv_Alerts_Times_To_Actioned_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mv_Alerts_Times_To_Actioned_Max_Fields>;
  min?: Maybe<Mv_Alerts_Times_To_Actioned_Min_Fields>;
  stddev?: Maybe<Mv_Alerts_Times_To_Actioned_Stddev_Fields>;
  stddev_pop?: Maybe<Mv_Alerts_Times_To_Actioned_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mv_Alerts_Times_To_Actioned_Stddev_Samp_Fields>;
  sum?: Maybe<Mv_Alerts_Times_To_Actioned_Sum_Fields>;
  var_pop?: Maybe<Mv_Alerts_Times_To_Actioned_Var_Pop_Fields>;
  var_samp?: Maybe<Mv_Alerts_Times_To_Actioned_Var_Samp_Fields>;
  variance?: Maybe<Mv_Alerts_Times_To_Actioned_Variance_Fields>;
};


/** aggregate fields of "mv_alerts_times_to_actioned" */
export type Mv_Alerts_Times_To_Actioned_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mv_Alerts_Times_To_Actioned_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mv_Alerts_Times_To_Actioned_Avg_Fields = {
  __typename?: 'mv_alerts_times_to_actioned_avg_fields';
  mitigation_time_hours?: Maybe<Scalars['Float']>;
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mv_alerts_times_to_actioned". All fields are combined with a logical 'AND'. */
export type Mv_Alerts_Times_To_Actioned_Bool_Exp = {
  _and?: InputMaybe<Array<Mv_Alerts_Times_To_Actioned_Bool_Exp>>;
  _not?: InputMaybe<Mv_Alerts_Times_To_Actioned_Bool_Exp>;
  _or?: InputMaybe<Array<Mv_Alerts_Times_To_Actioned_Bool_Exp>>;
  alert_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand?: InputMaybe<String_Comparison_Exp>;
  created_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  mitigated_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  mitigation_time_hours?: InputMaybe<Numeric_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  platform_name?: InputMaybe<String_Comparison_Exp>;
  platform_type?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  resolution_time_hours?: InputMaybe<Numeric_Comparison_Exp>;
  resolved_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<String_Array_Comparison_Exp>;
  time_bucket?: InputMaybe<Date_Comparison_Exp>;
  uploader?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mv_Alerts_Times_To_Actioned_Max_Fields = {
  __typename?: 'mv_alerts_times_to_actioned_max_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  brand?: Maybe<Scalars['String']>;
  created_timestamp?: Maybe<Scalars['timestamp']>;
  mitigated_timestamp?: Maybe<Scalars['timestamp']>;
  mitigation_time_hours?: Maybe<Scalars['numeric']>;
  organization_id?: Maybe<Scalars['uuid']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_type?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  resolution_time_hours?: Maybe<Scalars['numeric']>;
  resolved_timestamp?: Maybe<Scalars['timestamp']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['date']>;
  uploader?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mv_Alerts_Times_To_Actioned_Min_Fields = {
  __typename?: 'mv_alerts_times_to_actioned_min_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  brand?: Maybe<Scalars['String']>;
  created_timestamp?: Maybe<Scalars['timestamp']>;
  mitigated_timestamp?: Maybe<Scalars['timestamp']>;
  mitigation_time_hours?: Maybe<Scalars['numeric']>;
  organization_id?: Maybe<Scalars['uuid']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_type?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  resolution_time_hours?: Maybe<Scalars['numeric']>;
  resolved_timestamp?: Maybe<Scalars['timestamp']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['date']>;
  uploader?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "mv_alerts_times_to_actioned". */
export type Mv_Alerts_Times_To_Actioned_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  brand?: InputMaybe<Order_By>;
  created_timestamp?: InputMaybe<Order_By>;
  mitigated_timestamp?: InputMaybe<Order_By>;
  mitigation_time_hours?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  platform_type?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  resolution_time_hours?: InputMaybe<Order_By>;
  resolved_timestamp?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  time_bucket?: InputMaybe<Order_By>;
  uploader?: InputMaybe<Order_By>;
};

/** select columns of table "mv_alerts_times_to_actioned" */
export enum Mv_Alerts_Times_To_Actioned_Select_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  Brand = 'brand',
  /** column name */
  CreatedTimestamp = 'created_timestamp',
  /** column name */
  MitigatedTimestamp = 'mitigated_timestamp',
  /** column name */
  MitigationTimeHours = 'mitigation_time_hours',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PlatformType = 'platform_type',
  /** column name */
  Product = 'product',
  /** column name */
  ResolutionTimeHours = 'resolution_time_hours',
  /** column name */
  ResolvedTimestamp = 'resolved_timestamp',
  /** column name */
  Source = 'source',
  /** column name */
  Tags = 'tags',
  /** column name */
  TimeBucket = 'time_bucket',
  /** column name */
  Uploader = 'uploader'
}

/** aggregate stddev on columns */
export type Mv_Alerts_Times_To_Actioned_Stddev_Fields = {
  __typename?: 'mv_alerts_times_to_actioned_stddev_fields';
  mitigation_time_hours?: Maybe<Scalars['Float']>;
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mv_Alerts_Times_To_Actioned_Stddev_Pop_Fields = {
  __typename?: 'mv_alerts_times_to_actioned_stddev_pop_fields';
  mitigation_time_hours?: Maybe<Scalars['Float']>;
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mv_Alerts_Times_To_Actioned_Stddev_Samp_Fields = {
  __typename?: 'mv_alerts_times_to_actioned_stddev_samp_fields';
  mitigation_time_hours?: Maybe<Scalars['Float']>;
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mv_alerts_times_to_actioned" */
export type Mv_Alerts_Times_To_Actioned_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mv_Alerts_Times_To_Actioned_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mv_Alerts_Times_To_Actioned_Stream_Cursor_Value_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  brand?: InputMaybe<Scalars['String']>;
  created_timestamp?: InputMaybe<Scalars['timestamp']>;
  mitigated_timestamp?: InputMaybe<Scalars['timestamp']>;
  mitigation_time_hours?: InputMaybe<Scalars['numeric']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_type?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  resolution_time_hours?: InputMaybe<Scalars['numeric']>;
  resolved_timestamp?: InputMaybe<Scalars['timestamp']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  time_bucket?: InputMaybe<Scalars['date']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Mv_Alerts_Times_To_Actioned_Sum_Fields = {
  __typename?: 'mv_alerts_times_to_actioned_sum_fields';
  mitigation_time_hours?: Maybe<Scalars['numeric']>;
  resolution_time_hours?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Mv_Alerts_Times_To_Actioned_Var_Pop_Fields = {
  __typename?: 'mv_alerts_times_to_actioned_var_pop_fields';
  mitigation_time_hours?: Maybe<Scalars['Float']>;
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mv_Alerts_Times_To_Actioned_Var_Samp_Fields = {
  __typename?: 'mv_alerts_times_to_actioned_var_samp_fields';
  mitigation_time_hours?: Maybe<Scalars['Float']>;
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mv_Alerts_Times_To_Actioned_Variance_Fields = {
  __typename?: 'mv_alerts_times_to_actioned_variance_fields';
  mitigation_time_hours?: Maybe<Scalars['Float']>;
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "mv_alerts_verified" */
export type Mv_Alerts_Verified = {
  __typename?: 'mv_alerts_verified';
  brand?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  hosting_provider?: Maybe<Scalars['String']>;
  num_reports?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']>;
  platform_name?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  registrar_name?: Maybe<Scalars['String']>;
  report_status?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
  uploader?: Maybe<Scalars['String']>;
};

/** aggregated selection of "mv_alerts_verified" */
export type Mv_Alerts_Verified_Aggregate = {
  __typename?: 'mv_alerts_verified_aggregate';
  aggregate?: Maybe<Mv_Alerts_Verified_Aggregate_Fields>;
  nodes: Array<Mv_Alerts_Verified>;
};

/** aggregate fields of "mv_alerts_verified" */
export type Mv_Alerts_Verified_Aggregate_Fields = {
  __typename?: 'mv_alerts_verified_aggregate_fields';
  avg?: Maybe<Mv_Alerts_Verified_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mv_Alerts_Verified_Max_Fields>;
  min?: Maybe<Mv_Alerts_Verified_Min_Fields>;
  stddev?: Maybe<Mv_Alerts_Verified_Stddev_Fields>;
  stddev_pop?: Maybe<Mv_Alerts_Verified_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mv_Alerts_Verified_Stddev_Samp_Fields>;
  sum?: Maybe<Mv_Alerts_Verified_Sum_Fields>;
  var_pop?: Maybe<Mv_Alerts_Verified_Var_Pop_Fields>;
  var_samp?: Maybe<Mv_Alerts_Verified_Var_Samp_Fields>;
  variance?: Maybe<Mv_Alerts_Verified_Variance_Fields>;
};


/** aggregate fields of "mv_alerts_verified" */
export type Mv_Alerts_Verified_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mv_Alerts_Verified_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mv_Alerts_Verified_Avg_Fields = {
  __typename?: 'mv_alerts_verified_avg_fields';
  num_reports?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mv_alerts_verified". All fields are combined with a logical 'AND'. */
export type Mv_Alerts_Verified_Bool_Exp = {
  _and?: InputMaybe<Array<Mv_Alerts_Verified_Bool_Exp>>;
  _not?: InputMaybe<Mv_Alerts_Verified_Bool_Exp>;
  _or?: InputMaybe<Array<Mv_Alerts_Verified_Bool_Exp>>;
  brand?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  hosting_provider?: InputMaybe<String_Comparison_Exp>;
  num_reports?: InputMaybe<Bigint_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  platform_name?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  registrar_name?: InputMaybe<String_Comparison_Exp>;
  report_status?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<String_Array_Comparison_Exp>;
  time_bucket?: InputMaybe<String_Comparison_Exp>;
  uploader?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mv_Alerts_Verified_Max_Fields = {
  __typename?: 'mv_alerts_verified_max_fields';
  brand?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  hosting_provider?: Maybe<Scalars['String']>;
  num_reports?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  platform_name?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  registrar_name?: Maybe<Scalars['String']>;
  report_status?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
  uploader?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mv_Alerts_Verified_Min_Fields = {
  __typename?: 'mv_alerts_verified_min_fields';
  brand?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  hosting_provider?: Maybe<Scalars['String']>;
  num_reports?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  platform_name?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  registrar_name?: Maybe<Scalars['String']>;
  report_status?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
  uploader?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "mv_alerts_verified". */
export type Mv_Alerts_Verified_Order_By = {
  brand?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  hosting_provider?: InputMaybe<Order_By>;
  num_reports?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  registrar_name?: InputMaybe<Order_By>;
  report_status?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  time_bucket?: InputMaybe<Order_By>;
  uploader?: InputMaybe<Order_By>;
};

/** select columns of table "mv_alerts_verified" */
export enum Mv_Alerts_Verified_Select_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  HostingProvider = 'hosting_provider',
  /** column name */
  NumReports = 'num_reports',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  Product = 'product',
  /** column name */
  RegistrarName = 'registrar_name',
  /** column name */
  ReportStatus = 'report_status',
  /** column name */
  Source = 'source',
  /** column name */
  Tags = 'tags',
  /** column name */
  TimeBucket = 'time_bucket',
  /** column name */
  Uploader = 'uploader'
}

/** aggregate stddev on columns */
export type Mv_Alerts_Verified_Stddev_Fields = {
  __typename?: 'mv_alerts_verified_stddev_fields';
  num_reports?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mv_Alerts_Verified_Stddev_Pop_Fields = {
  __typename?: 'mv_alerts_verified_stddev_pop_fields';
  num_reports?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mv_Alerts_Verified_Stddev_Samp_Fields = {
  __typename?: 'mv_alerts_verified_stddev_samp_fields';
  num_reports?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mv_alerts_verified" */
export type Mv_Alerts_Verified_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mv_Alerts_Verified_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mv_Alerts_Verified_Stream_Cursor_Value_Input = {
  brand?: InputMaybe<Scalars['String']>;
  country_code?: InputMaybe<Scalars['String']>;
  hosting_provider?: InputMaybe<Scalars['String']>;
  num_reports?: InputMaybe<Scalars['bigint']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  platform_name?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  registrar_name?: InputMaybe<Scalars['String']>;
  report_status?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  time_bucket?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Mv_Alerts_Verified_Sum_Fields = {
  __typename?: 'mv_alerts_verified_sum_fields';
  num_reports?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Mv_Alerts_Verified_Var_Pop_Fields = {
  __typename?: 'mv_alerts_verified_var_pop_fields';
  num_reports?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mv_Alerts_Verified_Var_Samp_Fields = {
  __typename?: 'mv_alerts_verified_var_samp_fields';
  num_reports?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mv_Alerts_Verified_Variance_Fields = {
  __typename?: 'mv_alerts_verified_variance_fields';
  num_reports?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "mv_dark_web_alerts_surfaced" */
export type Mv_Dark_Web_Alerts_Surfaced = {
  __typename?: 'mv_dark_web_alerts_surfaced';
  brand?: Maybe<Scalars['String']>;
  credential_url?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['dark_web_network']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  password_type?: Maybe<Scalars['dark_web_password']>;
  platform?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
};

/** aggregated selection of "mv_dark_web_alerts_surfaced" */
export type Mv_Dark_Web_Alerts_Surfaced_Aggregate = {
  __typename?: 'mv_dark_web_alerts_surfaced_aggregate';
  aggregate?: Maybe<Mv_Dark_Web_Alerts_Surfaced_Aggregate_Fields>;
  nodes: Array<Mv_Dark_Web_Alerts_Surfaced>;
};

/** aggregate fields of "mv_dark_web_alerts_surfaced" */
export type Mv_Dark_Web_Alerts_Surfaced_Aggregate_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_aggregate_fields';
  avg?: Maybe<Mv_Dark_Web_Alerts_Surfaced_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mv_Dark_Web_Alerts_Surfaced_Max_Fields>;
  min?: Maybe<Mv_Dark_Web_Alerts_Surfaced_Min_Fields>;
  stddev?: Maybe<Mv_Dark_Web_Alerts_Surfaced_Stddev_Fields>;
  stddev_pop?: Maybe<Mv_Dark_Web_Alerts_Surfaced_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mv_Dark_Web_Alerts_Surfaced_Stddev_Samp_Fields>;
  sum?: Maybe<Mv_Dark_Web_Alerts_Surfaced_Sum_Fields>;
  var_pop?: Maybe<Mv_Dark_Web_Alerts_Surfaced_Var_Pop_Fields>;
  var_samp?: Maybe<Mv_Dark_Web_Alerts_Surfaced_Var_Samp_Fields>;
  variance?: Maybe<Mv_Dark_Web_Alerts_Surfaced_Variance_Fields>;
};


/** aggregate fields of "mv_dark_web_alerts_surfaced" */
export type Mv_Dark_Web_Alerts_Surfaced_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mv_Dark_Web_Alerts_Surfaced_Avg_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_avg_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mv_dark_web_alerts_surfaced". All fields are combined with a logical 'AND'. */
export type Mv_Dark_Web_Alerts_Surfaced_Bool_Exp = {
  _and?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_Bool_Exp>>;
  _not?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_Bool_Exp>;
  _or?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_Bool_Exp>>;
  brand?: InputMaybe<String_Comparison_Exp>;
  credential_url?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  network?: InputMaybe<Dark_Web_Network_Comparison_Exp>;
  num_alerts?: InputMaybe<Bigint_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  password_type?: InputMaybe<Dark_Web_Password_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<String_Array_Comparison_Exp>;
  time_bucket?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "mv_dark_web_alerts_surfaced_by_hour" */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour';
  brand?: Maybe<Scalars['String']>;
  credential_url?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['dark_web_network']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  password_type?: Maybe<Scalars['dark_web_password']>;
  platform?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
};

/** aggregated selection of "mv_dark_web_alerts_surfaced_by_hour" */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Aggregate = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_aggregate';
  aggregate?: Maybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Aggregate_Fields>;
  nodes: Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour>;
};

/** aggregate fields of "mv_dark_web_alerts_surfaced_by_hour" */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Aggregate_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_aggregate_fields';
  avg?: Maybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Max_Fields>;
  min?: Maybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Min_Fields>;
  stddev?: Maybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Stddev_Fields>;
  stddev_pop?: Maybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Stddev_Samp_Fields>;
  sum?: Maybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Sum_Fields>;
  var_pop?: Maybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Var_Pop_Fields>;
  var_samp?: Maybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Var_Samp_Fields>;
  variance?: Maybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Variance_Fields>;
};


/** aggregate fields of "mv_dark_web_alerts_surfaced_by_hour" */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Avg_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_avg_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mv_dark_web_alerts_surfaced_by_hour". All fields are combined with a logical 'AND'. */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Bool_Exp = {
  _and?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Bool_Exp>>;
  _not?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Bool_Exp>;
  _or?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Bool_Exp>>;
  brand?: InputMaybe<String_Comparison_Exp>;
  credential_url?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  network?: InputMaybe<Dark_Web_Network_Comparison_Exp>;
  num_alerts?: InputMaybe<Bigint_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  password_type?: InputMaybe<Dark_Web_Password_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<String_Array_Comparison_Exp>;
  time_bucket?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Max_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_max_fields';
  brand?: Maybe<Scalars['String']>;
  credential_url?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['dark_web_network']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  password_type?: Maybe<Scalars['dark_web_password']>;
  platform?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Min_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_min_fields';
  brand?: Maybe<Scalars['String']>;
  credential_url?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['dark_web_network']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  password_type?: Maybe<Scalars['dark_web_password']>;
  platform?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "mv_dark_web_alerts_surfaced_by_hour". */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Order_By = {
  brand?: InputMaybe<Order_By>;
  credential_url?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  num_alerts?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  password_type?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  time_bucket?: InputMaybe<Order_By>;
};

/** select columns of table "mv_dark_web_alerts_surfaced_by_hour" */
export enum Mv_Dark_Web_Alerts_Surfaced_By_Hour_Select_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  CredentialUrl = 'credential_url',
  /** column name */
  Email = 'email',
  /** column name */
  Network = 'network',
  /** column name */
  NumAlerts = 'num_alerts',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Password = 'password',
  /** column name */
  PasswordType = 'password_type',
  /** column name */
  Platform = 'platform',
  /** column name */
  Tags = 'tags',
  /** column name */
  TimeBucket = 'time_bucket'
}

/** aggregate stddev on columns */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Stddev_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_stddev_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Stddev_Pop_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_stddev_pop_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Stddev_Samp_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_stddev_samp_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mv_dark_web_alerts_surfaced_by_hour" */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mv_Dark_Web_Alerts_Surfaced_By_Hour_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Stream_Cursor_Value_Input = {
  brand?: InputMaybe<Scalars['String']>;
  credential_url?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  network?: InputMaybe<Scalars['dark_web_network']>;
  num_alerts?: InputMaybe<Scalars['bigint']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  password?: InputMaybe<Scalars['String']>;
  password_type?: InputMaybe<Scalars['dark_web_password']>;
  platform?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  time_bucket?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Sum_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_sum_fields';
  num_alerts?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Var_Pop_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_var_pop_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Var_Samp_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_var_samp_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mv_Dark_Web_Alerts_Surfaced_By_Hour_Variance_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_by_hour_variance_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Mv_Dark_Web_Alerts_Surfaced_Max_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_max_fields';
  brand?: Maybe<Scalars['String']>;
  credential_url?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['dark_web_network']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  password_type?: Maybe<Scalars['dark_web_password']>;
  platform?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mv_Dark_Web_Alerts_Surfaced_Min_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_min_fields';
  brand?: Maybe<Scalars['String']>;
  credential_url?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['dark_web_network']>;
  num_alerts?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  password?: Maybe<Scalars['String']>;
  password_type?: Maybe<Scalars['dark_web_password']>;
  platform?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "mv_dark_web_alerts_surfaced". */
export type Mv_Dark_Web_Alerts_Surfaced_Order_By = {
  brand?: InputMaybe<Order_By>;
  credential_url?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  num_alerts?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  password_type?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  time_bucket?: InputMaybe<Order_By>;
};

/** select columns of table "mv_dark_web_alerts_surfaced" */
export enum Mv_Dark_Web_Alerts_Surfaced_Select_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  CredentialUrl = 'credential_url',
  /** column name */
  Email = 'email',
  /** column name */
  Network = 'network',
  /** column name */
  NumAlerts = 'num_alerts',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Password = 'password',
  /** column name */
  PasswordType = 'password_type',
  /** column name */
  Platform = 'platform',
  /** column name */
  Tags = 'tags',
  /** column name */
  TimeBucket = 'time_bucket'
}

/** aggregate stddev on columns */
export type Mv_Dark_Web_Alerts_Surfaced_Stddev_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_stddev_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mv_Dark_Web_Alerts_Surfaced_Stddev_Pop_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_stddev_pop_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mv_Dark_Web_Alerts_Surfaced_Stddev_Samp_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_stddev_samp_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mv_dark_web_alerts_surfaced" */
export type Mv_Dark_Web_Alerts_Surfaced_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mv_Dark_Web_Alerts_Surfaced_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mv_Dark_Web_Alerts_Surfaced_Stream_Cursor_Value_Input = {
  brand?: InputMaybe<Scalars['String']>;
  credential_url?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  network?: InputMaybe<Scalars['dark_web_network']>;
  num_alerts?: InputMaybe<Scalars['bigint']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  password?: InputMaybe<Scalars['String']>;
  password_type?: InputMaybe<Scalars['dark_web_password']>;
  platform?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  time_bucket?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Mv_Dark_Web_Alerts_Surfaced_Sum_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_sum_fields';
  num_alerts?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Mv_Dark_Web_Alerts_Surfaced_Var_Pop_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_var_pop_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mv_Dark_Web_Alerts_Surfaced_Var_Samp_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_var_samp_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mv_Dark_Web_Alerts_Surfaced_Variance_Fields = {
  __typename?: 'mv_dark_web_alerts_surfaced_variance_fields';
  num_alerts?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "mv_email_alerts_times_to_actioned" */
export type Mv_Email_Alerts_Times_To_Actioned = {
  __typename?: 'mv_email_alerts_times_to_actioned';
  alert_id?: Maybe<Scalars['uuid']>;
  brand?: Maybe<Scalars['String']>;
  created_timestamp?: Maybe<Scalars['timestamp']>;
  organization_id?: Maybe<Scalars['uuid']>;
  platform_type?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  resolution_time_hours?: Maybe<Scalars['numeric']>;
  resolved_timestamp?: Maybe<Scalars['timestamp']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['date']>;
  uploader?: Maybe<Scalars['String']>;
};

/** aggregated selection of "mv_email_alerts_times_to_actioned" */
export type Mv_Email_Alerts_Times_To_Actioned_Aggregate = {
  __typename?: 'mv_email_alerts_times_to_actioned_aggregate';
  aggregate?: Maybe<Mv_Email_Alerts_Times_To_Actioned_Aggregate_Fields>;
  nodes: Array<Mv_Email_Alerts_Times_To_Actioned>;
};

/** aggregate fields of "mv_email_alerts_times_to_actioned" */
export type Mv_Email_Alerts_Times_To_Actioned_Aggregate_Fields = {
  __typename?: 'mv_email_alerts_times_to_actioned_aggregate_fields';
  avg?: Maybe<Mv_Email_Alerts_Times_To_Actioned_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Mv_Email_Alerts_Times_To_Actioned_Max_Fields>;
  min?: Maybe<Mv_Email_Alerts_Times_To_Actioned_Min_Fields>;
  stddev?: Maybe<Mv_Email_Alerts_Times_To_Actioned_Stddev_Fields>;
  stddev_pop?: Maybe<Mv_Email_Alerts_Times_To_Actioned_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mv_Email_Alerts_Times_To_Actioned_Stddev_Samp_Fields>;
  sum?: Maybe<Mv_Email_Alerts_Times_To_Actioned_Sum_Fields>;
  var_pop?: Maybe<Mv_Email_Alerts_Times_To_Actioned_Var_Pop_Fields>;
  var_samp?: Maybe<Mv_Email_Alerts_Times_To_Actioned_Var_Samp_Fields>;
  variance?: Maybe<Mv_Email_Alerts_Times_To_Actioned_Variance_Fields>;
};


/** aggregate fields of "mv_email_alerts_times_to_actioned" */
export type Mv_Email_Alerts_Times_To_Actioned_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mv_Email_Alerts_Times_To_Actioned_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Mv_Email_Alerts_Times_To_Actioned_Avg_Fields = {
  __typename?: 'mv_email_alerts_times_to_actioned_avg_fields';
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "mv_email_alerts_times_to_actioned". All fields are combined with a logical 'AND'. */
export type Mv_Email_Alerts_Times_To_Actioned_Bool_Exp = {
  _and?: InputMaybe<Array<Mv_Email_Alerts_Times_To_Actioned_Bool_Exp>>;
  _not?: InputMaybe<Mv_Email_Alerts_Times_To_Actioned_Bool_Exp>;
  _or?: InputMaybe<Array<Mv_Email_Alerts_Times_To_Actioned_Bool_Exp>>;
  alert_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand?: InputMaybe<String_Comparison_Exp>;
  created_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  platform_type?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  resolution_time_hours?: InputMaybe<Numeric_Comparison_Exp>;
  resolved_timestamp?: InputMaybe<Timestamp_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<String_Array_Comparison_Exp>;
  time_bucket?: InputMaybe<Date_Comparison_Exp>;
  uploader?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mv_Email_Alerts_Times_To_Actioned_Max_Fields = {
  __typename?: 'mv_email_alerts_times_to_actioned_max_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  brand?: Maybe<Scalars['String']>;
  created_timestamp?: Maybe<Scalars['timestamp']>;
  organization_id?: Maybe<Scalars['uuid']>;
  platform_type?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  resolution_time_hours?: Maybe<Scalars['numeric']>;
  resolved_timestamp?: Maybe<Scalars['timestamp']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['date']>;
  uploader?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Mv_Email_Alerts_Times_To_Actioned_Min_Fields = {
  __typename?: 'mv_email_alerts_times_to_actioned_min_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  brand?: Maybe<Scalars['String']>;
  created_timestamp?: Maybe<Scalars['timestamp']>;
  organization_id?: Maybe<Scalars['uuid']>;
  platform_type?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  resolution_time_hours?: Maybe<Scalars['numeric']>;
  resolved_timestamp?: Maybe<Scalars['timestamp']>;
  source?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  time_bucket?: Maybe<Scalars['date']>;
  uploader?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "mv_email_alerts_times_to_actioned". */
export type Mv_Email_Alerts_Times_To_Actioned_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  brand?: InputMaybe<Order_By>;
  created_timestamp?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  platform_type?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  resolution_time_hours?: InputMaybe<Order_By>;
  resolved_timestamp?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  time_bucket?: InputMaybe<Order_By>;
  uploader?: InputMaybe<Order_By>;
};

/** select columns of table "mv_email_alerts_times_to_actioned" */
export enum Mv_Email_Alerts_Times_To_Actioned_Select_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  Brand = 'brand',
  /** column name */
  CreatedTimestamp = 'created_timestamp',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PlatformType = 'platform_type',
  /** column name */
  Product = 'product',
  /** column name */
  ResolutionTimeHours = 'resolution_time_hours',
  /** column name */
  ResolvedTimestamp = 'resolved_timestamp',
  /** column name */
  Source = 'source',
  /** column name */
  Tags = 'tags',
  /** column name */
  TimeBucket = 'time_bucket',
  /** column name */
  Uploader = 'uploader'
}

/** aggregate stddev on columns */
export type Mv_Email_Alerts_Times_To_Actioned_Stddev_Fields = {
  __typename?: 'mv_email_alerts_times_to_actioned_stddev_fields';
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Mv_Email_Alerts_Times_To_Actioned_Stddev_Pop_Fields = {
  __typename?: 'mv_email_alerts_times_to_actioned_stddev_pop_fields';
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Mv_Email_Alerts_Times_To_Actioned_Stddev_Samp_Fields = {
  __typename?: 'mv_email_alerts_times_to_actioned_stddev_samp_fields';
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "mv_email_alerts_times_to_actioned" */
export type Mv_Email_Alerts_Times_To_Actioned_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mv_Email_Alerts_Times_To_Actioned_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mv_Email_Alerts_Times_To_Actioned_Stream_Cursor_Value_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  brand?: InputMaybe<Scalars['String']>;
  created_timestamp?: InputMaybe<Scalars['timestamp']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  platform_type?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  resolution_time_hours?: InputMaybe<Scalars['numeric']>;
  resolved_timestamp?: InputMaybe<Scalars['timestamp']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  time_bucket?: InputMaybe<Scalars['date']>;
  uploader?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Mv_Email_Alerts_Times_To_Actioned_Sum_Fields = {
  __typename?: 'mv_email_alerts_times_to_actioned_sum_fields';
  resolution_time_hours?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Mv_Email_Alerts_Times_To_Actioned_Var_Pop_Fields = {
  __typename?: 'mv_email_alerts_times_to_actioned_var_pop_fields';
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Mv_Email_Alerts_Times_To_Actioned_Var_Samp_Fields = {
  __typename?: 'mv_email_alerts_times_to_actioned_var_samp_fields';
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Mv_Email_Alerts_Times_To_Actioned_Variance_Fields = {
  __typename?: 'mv_email_alerts_times_to_actioned_variance_fields';
  resolution_time_hours?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "nft_opensea_processed" */
export type Nft_Opensea_Processed = {
  __typename?: 'nft_opensea_processed';
  cursor: Scalars['String'];
  direction: Scalars['String'];
  worker_start_time: Scalars['timestamp'];
};

/** aggregated selection of "nft_opensea_processed" */
export type Nft_Opensea_Processed_Aggregate = {
  __typename?: 'nft_opensea_processed_aggregate';
  aggregate?: Maybe<Nft_Opensea_Processed_Aggregate_Fields>;
  nodes: Array<Nft_Opensea_Processed>;
};

/** aggregate fields of "nft_opensea_processed" */
export type Nft_Opensea_Processed_Aggregate_Fields = {
  __typename?: 'nft_opensea_processed_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nft_Opensea_Processed_Max_Fields>;
  min?: Maybe<Nft_Opensea_Processed_Min_Fields>;
};


/** aggregate fields of "nft_opensea_processed" */
export type Nft_Opensea_Processed_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nft_Opensea_Processed_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "nft_opensea_processed". All fields are combined with a logical 'AND'. */
export type Nft_Opensea_Processed_Bool_Exp = {
  _and?: InputMaybe<Array<Nft_Opensea_Processed_Bool_Exp>>;
  _not?: InputMaybe<Nft_Opensea_Processed_Bool_Exp>;
  _or?: InputMaybe<Array<Nft_Opensea_Processed_Bool_Exp>>;
  cursor?: InputMaybe<String_Comparison_Exp>;
  direction?: InputMaybe<String_Comparison_Exp>;
  worker_start_time?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "nft_opensea_processed" */
export enum Nft_Opensea_Processed_Constraint {
  /** unique or primary key constraint on columns "direction" */
  NftOpenseaProcessedPkey = 'nft_opensea_processed_pkey'
}

/** input type for inserting data into table "nft_opensea_processed" */
export type Nft_Opensea_Processed_Insert_Input = {
  cursor?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  worker_start_time?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Nft_Opensea_Processed_Max_Fields = {
  __typename?: 'nft_opensea_processed_max_fields';
  cursor?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  worker_start_time?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Nft_Opensea_Processed_Min_Fields = {
  __typename?: 'nft_opensea_processed_min_fields';
  cursor?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  worker_start_time?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "nft_opensea_processed" */
export type Nft_Opensea_Processed_Mutation_Response = {
  __typename?: 'nft_opensea_processed_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nft_Opensea_Processed>;
};

/** on_conflict condition type for table "nft_opensea_processed" */
export type Nft_Opensea_Processed_On_Conflict = {
  constraint: Nft_Opensea_Processed_Constraint;
  update_columns?: Array<Nft_Opensea_Processed_Update_Column>;
  where?: InputMaybe<Nft_Opensea_Processed_Bool_Exp>;
};

/** Ordering options when selecting data from "nft_opensea_processed". */
export type Nft_Opensea_Processed_Order_By = {
  cursor?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  worker_start_time?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nft_opensea_processed */
export type Nft_Opensea_Processed_Pk_Columns_Input = {
  direction: Scalars['String'];
};

/** select columns of table "nft_opensea_processed" */
export enum Nft_Opensea_Processed_Select_Column {
  /** column name */
  Cursor = 'cursor',
  /** column name */
  Direction = 'direction',
  /** column name */
  WorkerStartTime = 'worker_start_time'
}

/** input type for updating data in table "nft_opensea_processed" */
export type Nft_Opensea_Processed_Set_Input = {
  cursor?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  worker_start_time?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "nft_opensea_processed" */
export type Nft_Opensea_Processed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nft_Opensea_Processed_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nft_Opensea_Processed_Stream_Cursor_Value_Input = {
  cursor?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  worker_start_time?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "nft_opensea_processed" */
export enum Nft_Opensea_Processed_Update_Column {
  /** column name */
  Cursor = 'cursor',
  /** column name */
  Direction = 'direction',
  /** column name */
  WorkerStartTime = 'worker_start_time'
}

export type Nft_Opensea_Processed_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nft_Opensea_Processed_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nft_Opensea_Processed_Bool_Exp;
};

/** columns and relationships of "nft_processing_cursor" */
export type Nft_Processing_Cursor = {
  __typename?: 'nft_processing_cursor';
  cursor: Scalars['String'];
  direction: Scalars['String'];
  marketplace: Scalars['String'];
  worker_start_time: Scalars['timestamp'];
};

/** aggregated selection of "nft_processing_cursor" */
export type Nft_Processing_Cursor_Aggregate = {
  __typename?: 'nft_processing_cursor_aggregate';
  aggregate?: Maybe<Nft_Processing_Cursor_Aggregate_Fields>;
  nodes: Array<Nft_Processing_Cursor>;
};

/** aggregate fields of "nft_processing_cursor" */
export type Nft_Processing_Cursor_Aggregate_Fields = {
  __typename?: 'nft_processing_cursor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Nft_Processing_Cursor_Max_Fields>;
  min?: Maybe<Nft_Processing_Cursor_Min_Fields>;
};


/** aggregate fields of "nft_processing_cursor" */
export type Nft_Processing_Cursor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nft_Processing_Cursor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "nft_processing_cursor". All fields are combined with a logical 'AND'. */
export type Nft_Processing_Cursor_Bool_Exp = {
  _and?: InputMaybe<Array<Nft_Processing_Cursor_Bool_Exp>>;
  _not?: InputMaybe<Nft_Processing_Cursor_Bool_Exp>;
  _or?: InputMaybe<Array<Nft_Processing_Cursor_Bool_Exp>>;
  cursor?: InputMaybe<String_Comparison_Exp>;
  direction?: InputMaybe<String_Comparison_Exp>;
  marketplace?: InputMaybe<String_Comparison_Exp>;
  worker_start_time?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "nft_processing_cursor" */
export enum Nft_Processing_Cursor_Constraint {
  /** unique or primary key constraint on columns "direction", "marketplace" */
  NftProcessingCursorPkey = 'nft_processing_cursor_pkey'
}

/** input type for inserting data into table "nft_processing_cursor" */
export type Nft_Processing_Cursor_Insert_Input = {
  cursor?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  marketplace?: InputMaybe<Scalars['String']>;
  worker_start_time?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Nft_Processing_Cursor_Max_Fields = {
  __typename?: 'nft_processing_cursor_max_fields';
  cursor?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  marketplace?: Maybe<Scalars['String']>;
  worker_start_time?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Nft_Processing_Cursor_Min_Fields = {
  __typename?: 'nft_processing_cursor_min_fields';
  cursor?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  marketplace?: Maybe<Scalars['String']>;
  worker_start_time?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "nft_processing_cursor" */
export type Nft_Processing_Cursor_Mutation_Response = {
  __typename?: 'nft_processing_cursor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nft_Processing_Cursor>;
};

/** on_conflict condition type for table "nft_processing_cursor" */
export type Nft_Processing_Cursor_On_Conflict = {
  constraint: Nft_Processing_Cursor_Constraint;
  update_columns?: Array<Nft_Processing_Cursor_Update_Column>;
  where?: InputMaybe<Nft_Processing_Cursor_Bool_Exp>;
};

/** Ordering options when selecting data from "nft_processing_cursor". */
export type Nft_Processing_Cursor_Order_By = {
  cursor?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  marketplace?: InputMaybe<Order_By>;
  worker_start_time?: InputMaybe<Order_By>;
};

/** primary key columns input for table: nft_processing_cursor */
export type Nft_Processing_Cursor_Pk_Columns_Input = {
  direction: Scalars['String'];
  marketplace: Scalars['String'];
};

/** select columns of table "nft_processing_cursor" */
export enum Nft_Processing_Cursor_Select_Column {
  /** column name */
  Cursor = 'cursor',
  /** column name */
  Direction = 'direction',
  /** column name */
  Marketplace = 'marketplace',
  /** column name */
  WorkerStartTime = 'worker_start_time'
}

/** input type for updating data in table "nft_processing_cursor" */
export type Nft_Processing_Cursor_Set_Input = {
  cursor?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  marketplace?: InputMaybe<Scalars['String']>;
  worker_start_time?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "nft_processing_cursor" */
export type Nft_Processing_Cursor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nft_Processing_Cursor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nft_Processing_Cursor_Stream_Cursor_Value_Input = {
  cursor?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['String']>;
  marketplace?: InputMaybe<Scalars['String']>;
  worker_start_time?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "nft_processing_cursor" */
export enum Nft_Processing_Cursor_Update_Column {
  /** column name */
  Cursor = 'cursor',
  /** column name */
  Direction = 'direction',
  /** column name */
  Marketplace = 'marketplace',
  /** column name */
  WorkerStartTime = 'worker_start_time'
}

export type Nft_Processing_Cursor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nft_Processing_Cursor_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nft_Processing_Cursor_Bool_Exp;
};

/** Stores various customer notifications */
export type Notification_Subscriptions = {
  __typename?: 'notification_subscriptions';
  created_at: Scalars['timestamp'];
  emails_to_notify?: Maybe<Scalars['jsonb']>;
  first_notification_date: Scalars['timestamp'];
  frequency: Scalars['String'];
  id: Scalars['uuid'];
  notification_type: Scalars['String'];
  org_id: Scalars['uuid'];
  /** An object relationship */
  organization: Organizations;
  platform: Scalars['String'];
  report_type?: Maybe<Scalars['String']>;
  sendgrid_template_id?: Maybe<Scalars['String']>;
  slack_channel_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamp'];
  updated_by: Scalars['uuid'];
  /** An object relationship */
  user: Users;
};


/** Stores various customer notifications */
export type Notification_SubscriptionsEmails_To_NotifyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notification_subscriptions" */
export type Notification_Subscriptions_Aggregate = {
  __typename?: 'notification_subscriptions_aggregate';
  aggregate?: Maybe<Notification_Subscriptions_Aggregate_Fields>;
  nodes: Array<Notification_Subscriptions>;
};

/** aggregate fields of "notification_subscriptions" */
export type Notification_Subscriptions_Aggregate_Fields = {
  __typename?: 'notification_subscriptions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Subscriptions_Max_Fields>;
  min?: Maybe<Notification_Subscriptions_Min_Fields>;
};


/** aggregate fields of "notification_subscriptions" */
export type Notification_Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Notification_Subscriptions_Append_Input = {
  emails_to_notify?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "notification_subscriptions". All fields are combined with a logical 'AND'. */
export type Notification_Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Notification_Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Subscriptions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  emails_to_notify?: InputMaybe<Jsonb_Comparison_Exp>;
  first_notification_date?: InputMaybe<Timestamp_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notification_type?: InputMaybe<String_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  report_type?: InputMaybe<String_Comparison_Exp>;
  sendgrid_template_id?: InputMaybe<String_Comparison_Exp>;
  slack_channel_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "notification_subscriptions" */
export enum Notification_Subscriptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationSubscriptionsPkey = 'notification_subscriptions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Notification_Subscriptions_Delete_At_Path_Input = {
  emails_to_notify?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Notification_Subscriptions_Delete_Elem_Input = {
  emails_to_notify?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Notification_Subscriptions_Delete_Key_Input = {
  emails_to_notify?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "notification_subscriptions" */
export type Notification_Subscriptions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  emails_to_notify?: InputMaybe<Scalars['jsonb']>;
  first_notification_date?: InputMaybe<Scalars['timestamp']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_type?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  platform?: InputMaybe<Scalars['String']>;
  report_type?: InputMaybe<Scalars['String']>;
  sendgrid_template_id?: InputMaybe<Scalars['String']>;
  slack_channel_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Notification_Subscriptions_Max_Fields = {
  __typename?: 'notification_subscriptions_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  first_notification_date?: Maybe<Scalars['timestamp']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notification_type?: Maybe<Scalars['String']>;
  org_id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  report_type?: Maybe<Scalars['String']>;
  sendgrid_template_id?: Maybe<Scalars['String']>;
  slack_channel_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Notification_Subscriptions_Min_Fields = {
  __typename?: 'notification_subscriptions_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  first_notification_date?: Maybe<Scalars['timestamp']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  notification_type?: Maybe<Scalars['String']>;
  org_id?: Maybe<Scalars['uuid']>;
  platform?: Maybe<Scalars['String']>;
  report_type?: Maybe<Scalars['String']>;
  sendgrid_template_id?: Maybe<Scalars['String']>;
  slack_channel_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "notification_subscriptions" */
export type Notification_Subscriptions_Mutation_Response = {
  __typename?: 'notification_subscriptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Subscriptions>;
};

/** on_conflict condition type for table "notification_subscriptions" */
export type Notification_Subscriptions_On_Conflict = {
  constraint: Notification_Subscriptions_Constraint;
  update_columns?: Array<Notification_Subscriptions_Update_Column>;
  where?: InputMaybe<Notification_Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_subscriptions". */
export type Notification_Subscriptions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  emails_to_notify?: InputMaybe<Order_By>;
  first_notification_date?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification_type?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  platform?: InputMaybe<Order_By>;
  report_type?: InputMaybe<Order_By>;
  sendgrid_template_id?: InputMaybe<Order_By>;
  slack_channel_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: notification_subscriptions */
export type Notification_Subscriptions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Notification_Subscriptions_Prepend_Input = {
  emails_to_notify?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notification_subscriptions" */
export enum Notification_Subscriptions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailsToNotify = 'emails_to_notify',
  /** column name */
  FirstNotificationDate = 'first_notification_date',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationType = 'notification_type',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Platform = 'platform',
  /** column name */
  ReportType = 'report_type',
  /** column name */
  SendgridTemplateId = 'sendgrid_template_id',
  /** column name */
  SlackChannelId = 'slack_channel_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "notification_subscriptions" */
export type Notification_Subscriptions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  emails_to_notify?: InputMaybe<Scalars['jsonb']>;
  first_notification_date?: InputMaybe<Scalars['timestamp']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_type?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['String']>;
  report_type?: InputMaybe<Scalars['String']>;
  sendgrid_template_id?: InputMaybe<Scalars['String']>;
  slack_channel_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "notification_subscriptions" */
export type Notification_Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Subscriptions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  emails_to_notify?: InputMaybe<Scalars['jsonb']>;
  first_notification_date?: InputMaybe<Scalars['timestamp']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  notification_type?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['String']>;
  report_type?: InputMaybe<Scalars['String']>;
  sendgrid_template_id?: InputMaybe<Scalars['String']>;
  slack_channel_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "notification_subscriptions" */
export enum Notification_Subscriptions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailsToNotify = 'emails_to_notify',
  /** column name */
  FirstNotificationDate = 'first_notification_date',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationType = 'notification_type',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Platform = 'platform',
  /** column name */
  ReportType = 'report_type',
  /** column name */
  SendgridTemplateId = 'sendgrid_template_id',
  /** column name */
  SlackChannelId = 'slack_channel_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Notification_Subscriptions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Notification_Subscriptions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Notification_Subscriptions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Notification_Subscriptions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Notification_Subscriptions_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Notification_Subscriptions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Subscriptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Subscriptions_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** mapping from organization to api key */
export type Organization_Id_Api_Keys = {
  __typename?: 'organization_id_api_keys';
  api_key: Scalars['String'];
  organization_id: Scalars['uuid'];
};

/** aggregated selection of "organization_id_api_keys" */
export type Organization_Id_Api_Keys_Aggregate = {
  __typename?: 'organization_id_api_keys_aggregate';
  aggregate?: Maybe<Organization_Id_Api_Keys_Aggregate_Fields>;
  nodes: Array<Organization_Id_Api_Keys>;
};

/** aggregate fields of "organization_id_api_keys" */
export type Organization_Id_Api_Keys_Aggregate_Fields = {
  __typename?: 'organization_id_api_keys_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Id_Api_Keys_Max_Fields>;
  min?: Maybe<Organization_Id_Api_Keys_Min_Fields>;
};


/** aggregate fields of "organization_id_api_keys" */
export type Organization_Id_Api_Keys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Id_Api_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "organization_id_api_keys". All fields are combined with a logical 'AND'. */
export type Organization_Id_Api_Keys_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Id_Api_Keys_Bool_Exp>>;
  _not?: InputMaybe<Organization_Id_Api_Keys_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Id_Api_Keys_Bool_Exp>>;
  api_key?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_id_api_keys" */
export enum Organization_Id_Api_Keys_Constraint {
  /** unique or primary key constraint on columns "api_key" */
  OrganizationApiKeysPkey = 'organization_api_keys_pkey'
}

/** input type for inserting data into table "organization_id_api_keys" */
export type Organization_Id_Api_Keys_Insert_Input = {
  api_key?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Organization_Id_Api_Keys_Max_Fields = {
  __typename?: 'organization_id_api_keys_max_fields';
  api_key?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Organization_Id_Api_Keys_Min_Fields = {
  __typename?: 'organization_id_api_keys_min_fields';
  api_key?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "organization_id_api_keys" */
export type Organization_Id_Api_Keys_Mutation_Response = {
  __typename?: 'organization_id_api_keys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Id_Api_Keys>;
};

/** on_conflict condition type for table "organization_id_api_keys" */
export type Organization_Id_Api_Keys_On_Conflict = {
  constraint: Organization_Id_Api_Keys_Constraint;
  update_columns?: Array<Organization_Id_Api_Keys_Update_Column>;
  where?: InputMaybe<Organization_Id_Api_Keys_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_id_api_keys". */
export type Organization_Id_Api_Keys_Order_By = {
  api_key?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_id_api_keys */
export type Organization_Id_Api_Keys_Pk_Columns_Input = {
  api_key: Scalars['String'];
};

/** select columns of table "organization_id_api_keys" */
export enum Organization_Id_Api_Keys_Select_Column {
  /** column name */
  ApiKey = 'api_key',
  /** column name */
  OrganizationId = 'organization_id'
}

/** input type for updating data in table "organization_id_api_keys" */
export type Organization_Id_Api_Keys_Set_Input = {
  api_key?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "organization_id_api_keys" */
export type Organization_Id_Api_Keys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Id_Api_Keys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Id_Api_Keys_Stream_Cursor_Value_Input = {
  api_key?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "organization_id_api_keys" */
export enum Organization_Id_Api_Keys_Update_Column {
  /** column name */
  ApiKey = 'api_key',
  /** column name */
  OrganizationId = 'organization_id'
}

export type Organization_Id_Api_Keys_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Id_Api_Keys_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Id_Api_Keys_Bool_Exp;
};

/** columns and relationships of "organization_products" */
export type Organization_Products = {
  __typename?: 'organization_products';
  created_at: Scalars['timestamptz'];
  enablement_status: Scalars['String'];
  organization_id: Scalars['uuid'];
  /** An object relationship */
  organization_users?: Maybe<User_Organizations>;
  product: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "organization_products" */
export type Organization_Products_Aggregate = {
  __typename?: 'organization_products_aggregate';
  aggregate?: Maybe<Organization_Products_Aggregate_Fields>;
  nodes: Array<Organization_Products>;
};

export type Organization_Products_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Products_Aggregate_Bool_Exp_Count>;
};

export type Organization_Products_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Products_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_products" */
export type Organization_Products_Aggregate_Fields = {
  __typename?: 'organization_products_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Products_Max_Fields>;
  min?: Maybe<Organization_Products_Min_Fields>;
};


/** aggregate fields of "organization_products" */
export type Organization_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organization_products" */
export type Organization_Products_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Products_Max_Order_By>;
  min?: InputMaybe<Organization_Products_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_products" */
export type Organization_Products_Arr_Rel_Insert_Input = {
  data: Array<Organization_Products_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Products_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_products". All fields are combined with a logical 'AND'. */
export type Organization_Products_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Products_Bool_Exp>>;
  _not?: InputMaybe<Organization_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Products_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enablement_status?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_users?: InputMaybe<User_Organizations_Bool_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_products" */
export enum Organization_Products_Constraint {
  /** unique or primary key constraint on columns "product", "organization_id" */
  OrganizationProductsPkey = 'organization_products_pkey'
}

/** input type for inserting data into table "organization_products" */
export type Organization_Products_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  enablement_status?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  organization_users?: InputMaybe<User_Organizations_Obj_Rel_Insert_Input>;
  product?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Organization_Products_Max_Fields = {
  __typename?: 'organization_products_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  enablement_status?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "organization_products" */
export type Organization_Products_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  enablement_status?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Products_Min_Fields = {
  __typename?: 'organization_products_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  enablement_status?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "organization_products" */
export type Organization_Products_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  enablement_status?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_products" */
export type Organization_Products_Mutation_Response = {
  __typename?: 'organization_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Products>;
};

/** on_conflict condition type for table "organization_products" */
export type Organization_Products_On_Conflict = {
  constraint: Organization_Products_Constraint;
  update_columns?: Array<Organization_Products_Update_Column>;
  where?: InputMaybe<Organization_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_products". */
export type Organization_Products_Order_By = {
  created_at?: InputMaybe<Order_By>;
  enablement_status?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organization_users?: InputMaybe<User_Organizations_Order_By>;
  product?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_products */
export type Organization_Products_Pk_Columns_Input = {
  organization_id: Scalars['uuid'];
  product: Scalars['String'];
};

/** select columns of table "organization_products" */
export enum Organization_Products_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnablementStatus = 'enablement_status',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Product = 'product',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "organization_products" */
export type Organization_Products_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  enablement_status?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "organization_products" */
export type Organization_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Products_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  enablement_status?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "organization_products" */
export enum Organization_Products_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnablementStatus = 'enablement_status',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Product = 'product',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Organization_Products_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Products_Bool_Exp;
};

/** Boolean expression to compare columns of type "organization_status". All fields are combined with logical 'AND'. */
export type Organization_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['organization_status']>;
  _gt?: InputMaybe<Scalars['organization_status']>;
  _gte?: InputMaybe<Scalars['organization_status']>;
  _in?: InputMaybe<Array<Scalars['organization_status']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['organization_status']>;
  _lte?: InputMaybe<Scalars['organization_status']>;
  _neq?: InputMaybe<Scalars['organization_status']>;
  _nin?: InputMaybe<Array<Scalars['organization_status']>>;
};

/** Boolean expression to compare columns of type "organization_type". All fields are combined with logical 'AND'. */
export type Organization_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['organization_type']>;
  _gt?: InputMaybe<Scalars['organization_type']>;
  _gte?: InputMaybe<Scalars['organization_type']>;
  _in?: InputMaybe<Array<Scalars['organization_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['organization_type']>;
  _lte?: InputMaybe<Scalars['organization_type']>;
  _neq?: InputMaybe<Scalars['organization_type']>;
  _nin?: InputMaybe<Array<Scalars['organization_type']>>;
};

/** columns and relationships of "organizations" */
export type Organizations = {
  __typename?: 'organizations';
  abbr_name?: Maybe<Scalars['String']>;
  analytics_summary_recipient_emails?: Maybe<Scalars['jsonb']>;
  approved_domains?: Maybe<Scalars['jsonb']>;
  approved_emails?: Maybe<Scalars['jsonb']>;
  auth_configs?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  children: Array<Organizations>;
  /** An aggregate relationship */
  children_aggregate: Organizations_Aggregate;
  created_at: Scalars['timestamp'];
  customer_point_of_contact_email?: Maybe<Scalars['String']>;
  /** type of customer, i.e. crypto */
  customer_type: Scalars['String'];
  emails_subscribed_to_weekly_summary?: Maybe<Array<Scalars['String']>>;
  /** An object relationship */
  enforcement_metadata?: Maybe<Enforcement_Metadata>;
  headless_login_tokens?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  is_app_detection_enabled: Scalars['Boolean'];
  is_code_repos_detection_enabled: Scalars['Boolean'];
  is_crypto_detection_enabled: Scalars['Boolean'];
  is_dark_market_detection_enabled: Scalars['Boolean'];
  is_dark_web_detection_enabled: Scalars['Boolean'];
  is_domain_purchasing_enabled: Scalars['Boolean'];
  is_ecommerce_detection_enabled: Scalars['Boolean'];
  is_email_abuse_box_enabled?: Maybe<Scalars['Boolean']>;
  is_email_detection_enabled: Scalars['Boolean'];
  is_full_service?: Maybe<Scalars['Boolean']>;
  is_logo_detection_enabled?: Maybe<Scalars['Boolean']>;
  is_nft_detection_enabled: Scalars['Boolean'];
  /** tells us if the brand is the IP holder or just a licensee of the IP */
  is_original_ip_holder?: Maybe<Scalars['Boolean']>;
  is_paid_ads_detection_enabled: Scalars['Boolean'];
  is_parent?: Maybe<Scalars['Boolean']>;
  is_phishing_sim_enabled: Scalars['Boolean'];
  is_pii_detection_enabled: Scalars['Boolean'];
  /** allows brands to fill out universal report form from within app */
  is_report_form_enabled?: Maybe<Scalars['Boolean']>;
  is_social_media_detection_enabled: Scalars['Boolean'];
  is_suspicious_emails_enabled?: Maybe<Scalars['Boolean']>;
  is_telco_detection_enabled: Scalars['Boolean'];
  /** Web2 Frontend is visible to customer */
  is_web2_enabled: Scalars['Boolean'];
  last_weekly_summary_sent?: Maybe<Scalars['timestamp']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  legal_rep_company?: Maybe<Scalars['String']>;
  legal_rep_company_website?: Maybe<Scalars['String']>;
  legal_rep_documentary_evidence_doc_link?: Maybe<Scalars['String']>;
  legal_rep_email_address?: Maybe<Scalars['String']>;
  legal_rep_first_name?: Maybe<Scalars['String']>;
  legal_rep_job_title?: Maybe<Scalars['String']>;
  legal_rep_last_name?: Maybe<Scalars['String']>;
  legal_rep_phone_number?: Maybe<Scalars['String']>;
  /** An array relationship */
  metadata: Array<Organizations_Metadata>;
  /** An aggregate relationship */
  metadata_aggregate: Organizations_Metadata_Aggregate;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  organization_email?: Maybe<Scalars['String']>;
  /** An array relationship */
  organization_products: Array<Organization_Products>;
  /** An aggregate relationship */
  organization_products_aggregate: Organization_Products_Aggregate;
  organization_status: Scalars['organization_status'];
  organization_type: Scalars['organization_type'];
  /** An array relationship */
  organization_users: Array<User_Organizations>;
  /** An aggregate relationship */
  organization_users_aggregate: User_Organizations_Aggregate;
  /** An object relationship */
  parent?: Maybe<Organizations>;
  parent_org_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  point_of_contact?: Maybe<Users>;
  point_of_contact_id?: Maybe<Scalars['uuid']>;
  rubric_link?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  salesforce_organizations_data?: Maybe<Salesforce_Organizations_Data>;
  slack_access_token?: Maybe<Scalars['String']>;
  /** An array relationship */
  spoofing_entities: Array<Spoofing_Entities>;
  /** An aggregate relationship */
  spoofing_entities_aggregate: Spoofing_Entities_Aggregate;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
};


/** columns and relationships of "organizations" */
export type OrganizationsAnalytics_Summary_Recipient_EmailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsApproved_DomainsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsApproved_EmailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsAuth_ConfigsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsChildrenArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsHeadless_Login_TokensArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organizations" */
export type OrganizationsMetadataArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Metadata_Order_By>>;
  where?: InputMaybe<Organizations_Metadata_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsMetadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Metadata_Order_By>>;
  where?: InputMaybe<Organizations_Metadata_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganization_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Products_Order_By>>;
  where?: InputMaybe<Organization_Products_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganization_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Products_Order_By>>;
  where?: InputMaybe<Organization_Products_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganization_UsersArgs = {
  distinct_on?: InputMaybe<Array<User_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Organizations_Order_By>>;
  where?: InputMaybe<User_Organizations_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsOrganization_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Organizations_Order_By>>;
  where?: InputMaybe<User_Organizations_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsSpoofing_EntitiesArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Entities_Order_By>>;
  where?: InputMaybe<Spoofing_Entities_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsSpoofing_Entities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Entities_Order_By>>;
  where?: InputMaybe<Spoofing_Entities_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "organizations" */
export type Organizations_Aggregate = {
  __typename?: 'organizations_aggregate';
  aggregate?: Maybe<Organizations_Aggregate_Fields>;
  nodes: Array<Organizations>;
};

export type Organizations_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organizations_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organizations_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organizations_Aggregate_Bool_Exp_Count>;
};

export type Organizations_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organizations_Select_Column_Organizations_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organizations_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organizations_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organizations_Select_Column_Organizations_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organizations_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organizations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organizations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organizations" */
export type Organizations_Aggregate_Fields = {
  __typename?: 'organizations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organizations_Max_Fields>;
  min?: Maybe<Organizations_Min_Fields>;
};


/** aggregate fields of "organizations" */
export type Organizations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organizations" */
export type Organizations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organizations_Max_Order_By>;
  min?: InputMaybe<Organizations_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organizations_Append_Input = {
  analytics_summary_recipient_emails?: InputMaybe<Scalars['jsonb']>;
  approved_domains?: InputMaybe<Scalars['jsonb']>;
  approved_emails?: InputMaybe<Scalars['jsonb']>;
  auth_configs?: InputMaybe<Scalars['jsonb']>;
  headless_login_tokens?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "organizations" */
export type Organizations_Arr_Rel_Insert_Input = {
  data: Array<Organizations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type Organizations_Bool_Exp = {
  _and?: InputMaybe<Array<Organizations_Bool_Exp>>;
  _not?: InputMaybe<Organizations_Bool_Exp>;
  _or?: InputMaybe<Array<Organizations_Bool_Exp>>;
  abbr_name?: InputMaybe<String_Comparison_Exp>;
  analytics_summary_recipient_emails?: InputMaybe<Jsonb_Comparison_Exp>;
  approved_domains?: InputMaybe<Jsonb_Comparison_Exp>;
  approved_emails?: InputMaybe<Jsonb_Comparison_Exp>;
  auth_configs?: InputMaybe<Jsonb_Comparison_Exp>;
  children?: InputMaybe<Organizations_Bool_Exp>;
  children_aggregate?: InputMaybe<Organizations_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_point_of_contact_email?: InputMaybe<String_Comparison_Exp>;
  customer_type?: InputMaybe<String_Comparison_Exp>;
  emails_subscribed_to_weekly_summary?: InputMaybe<String_Array_Comparison_Exp>;
  enforcement_metadata?: InputMaybe<Enforcement_Metadata_Bool_Exp>;
  headless_login_tokens?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_app_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_code_repos_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_crypto_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_dark_market_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_dark_web_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_domain_purchasing_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_ecommerce_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_email_abuse_box_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_email_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_full_service?: InputMaybe<Boolean_Comparison_Exp>;
  is_logo_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_nft_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_original_ip_holder?: InputMaybe<Boolean_Comparison_Exp>;
  is_paid_ads_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_parent?: InputMaybe<Boolean_Comparison_Exp>;
  is_phishing_sim_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_pii_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_report_form_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_social_media_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_suspicious_emails_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_telco_detection_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_web2_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  last_weekly_summary_sent?: InputMaybe<Timestamp_Comparison_Exp>;
  legal_entity_name?: InputMaybe<String_Comparison_Exp>;
  legal_rep_company?: InputMaybe<String_Comparison_Exp>;
  legal_rep_company_website?: InputMaybe<String_Comparison_Exp>;
  legal_rep_documentary_evidence_doc_link?: InputMaybe<String_Comparison_Exp>;
  legal_rep_email_address?: InputMaybe<String_Comparison_Exp>;
  legal_rep_first_name?: InputMaybe<String_Comparison_Exp>;
  legal_rep_job_title?: InputMaybe<String_Comparison_Exp>;
  legal_rep_last_name?: InputMaybe<String_Comparison_Exp>;
  legal_rep_phone_number?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Organizations_Metadata_Bool_Exp>;
  metadata_aggregate?: InputMaybe<Organizations_Metadata_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  organization_email?: InputMaybe<String_Comparison_Exp>;
  organization_products?: InputMaybe<Organization_Products_Bool_Exp>;
  organization_products_aggregate?: InputMaybe<Organization_Products_Aggregate_Bool_Exp>;
  organization_status?: InputMaybe<Organization_Status_Comparison_Exp>;
  organization_type?: InputMaybe<Organization_Type_Comparison_Exp>;
  organization_users?: InputMaybe<User_Organizations_Bool_Exp>;
  organization_users_aggregate?: InputMaybe<User_Organizations_Aggregate_Bool_Exp>;
  parent?: InputMaybe<Organizations_Bool_Exp>;
  parent_org_id?: InputMaybe<Uuid_Comparison_Exp>;
  point_of_contact?: InputMaybe<Users_Bool_Exp>;
  point_of_contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  rubric_link?: InputMaybe<String_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_organizations_data?: InputMaybe<Salesforce_Organizations_Data_Bool_Exp>;
  slack_access_token?: InputMaybe<String_Comparison_Exp>;
  spoofing_entities?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  spoofing_entities_aggregate?: InputMaybe<Spoofing_Entities_Aggregate_Bool_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "organizations" */
export enum Organizations_Constraint {
  /** unique or primary key constraint on columns "abbr_name" */
  OrganizationsAbbrNameKey = 'organizations_abbr_name_key',
  /** unique or primary key constraint on columns "name" */
  OrganizationsNameKey = 'organizations_name_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationsPkey = 'organizations_pkey',
  /** unique or primary key constraint on columns "salesforce_account_id" */
  OrganizationsSalesforceAccountIdKey = 'organizations_salesforce_account_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organizations_Delete_At_Path_Input = {
  analytics_summary_recipient_emails?: InputMaybe<Array<Scalars['String']>>;
  approved_domains?: InputMaybe<Array<Scalars['String']>>;
  approved_emails?: InputMaybe<Array<Scalars['String']>>;
  auth_configs?: InputMaybe<Array<Scalars['String']>>;
  headless_login_tokens?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organizations_Delete_Elem_Input = {
  analytics_summary_recipient_emails?: InputMaybe<Scalars['Int']>;
  approved_domains?: InputMaybe<Scalars['Int']>;
  approved_emails?: InputMaybe<Scalars['Int']>;
  auth_configs?: InputMaybe<Scalars['Int']>;
  headless_login_tokens?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organizations_Delete_Key_Input = {
  analytics_summary_recipient_emails?: InputMaybe<Scalars['String']>;
  approved_domains?: InputMaybe<Scalars['String']>;
  approved_emails?: InputMaybe<Scalars['String']>;
  auth_configs?: InputMaybe<Scalars['String']>;
  headless_login_tokens?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "organizations" */
export type Organizations_Insert_Input = {
  abbr_name?: InputMaybe<Scalars['String']>;
  analytics_summary_recipient_emails?: InputMaybe<Scalars['jsonb']>;
  approved_domains?: InputMaybe<Scalars['jsonb']>;
  approved_emails?: InputMaybe<Scalars['jsonb']>;
  auth_configs?: InputMaybe<Scalars['jsonb']>;
  children?: InputMaybe<Organizations_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  customer_point_of_contact_email?: InputMaybe<Scalars['String']>;
  /** type of customer, i.e. crypto */
  customer_type?: InputMaybe<Scalars['String']>;
  emails_subscribed_to_weekly_summary?: InputMaybe<Array<Scalars['String']>>;
  enforcement_metadata?: InputMaybe<Enforcement_Metadata_Obj_Rel_Insert_Input>;
  headless_login_tokens?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_app_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_code_repos_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_crypto_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_dark_market_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_dark_web_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_domain_purchasing_enabled?: InputMaybe<Scalars['Boolean']>;
  is_ecommerce_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_email_abuse_box_enabled?: InputMaybe<Scalars['Boolean']>;
  is_email_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_full_service?: InputMaybe<Scalars['Boolean']>;
  is_logo_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_nft_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  /** tells us if the brand is the IP holder or just a licensee of the IP */
  is_original_ip_holder?: InputMaybe<Scalars['Boolean']>;
  is_paid_ads_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_parent?: InputMaybe<Scalars['Boolean']>;
  is_phishing_sim_enabled?: InputMaybe<Scalars['Boolean']>;
  is_pii_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  /** allows brands to fill out universal report form from within app */
  is_report_form_enabled?: InputMaybe<Scalars['Boolean']>;
  is_social_media_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_suspicious_emails_enabled?: InputMaybe<Scalars['Boolean']>;
  is_telco_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  /** Web2 Frontend is visible to customer */
  is_web2_enabled?: InputMaybe<Scalars['Boolean']>;
  last_weekly_summary_sent?: InputMaybe<Scalars['timestamp']>;
  legal_entity_name?: InputMaybe<Scalars['String']>;
  legal_rep_company?: InputMaybe<Scalars['String']>;
  legal_rep_company_website?: InputMaybe<Scalars['String']>;
  legal_rep_documentary_evidence_doc_link?: InputMaybe<Scalars['String']>;
  legal_rep_email_address?: InputMaybe<Scalars['String']>;
  legal_rep_first_name?: InputMaybe<Scalars['String']>;
  legal_rep_job_title?: InputMaybe<Scalars['String']>;
  legal_rep_last_name?: InputMaybe<Scalars['String']>;
  legal_rep_phone_number?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Organizations_Metadata_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organization_email?: InputMaybe<Scalars['String']>;
  organization_products?: InputMaybe<Organization_Products_Arr_Rel_Insert_Input>;
  organization_status?: InputMaybe<Scalars['organization_status']>;
  organization_type?: InputMaybe<Scalars['organization_type']>;
  organization_users?: InputMaybe<User_Organizations_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  parent_org_id?: InputMaybe<Scalars['uuid']>;
  point_of_contact?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  point_of_contact_id?: InputMaybe<Scalars['uuid']>;
  rubric_link?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_organizations_data?: InputMaybe<Salesforce_Organizations_Data_Obj_Rel_Insert_Input>;
  slack_access_token?: InputMaybe<Scalars['String']>;
  spoofing_entities?: InputMaybe<Spoofing_Entities_Arr_Rel_Insert_Input>;
  users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Organizations_Max_Fields = {
  __typename?: 'organizations_max_fields';
  abbr_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  customer_point_of_contact_email?: Maybe<Scalars['String']>;
  /** type of customer, i.e. crypto */
  customer_type?: Maybe<Scalars['String']>;
  emails_subscribed_to_weekly_summary?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['uuid']>;
  last_weekly_summary_sent?: Maybe<Scalars['timestamp']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  legal_rep_company?: Maybe<Scalars['String']>;
  legal_rep_company_website?: Maybe<Scalars['String']>;
  legal_rep_documentary_evidence_doc_link?: Maybe<Scalars['String']>;
  legal_rep_email_address?: Maybe<Scalars['String']>;
  legal_rep_first_name?: Maybe<Scalars['String']>;
  legal_rep_job_title?: Maybe<Scalars['String']>;
  legal_rep_last_name?: Maybe<Scalars['String']>;
  legal_rep_phone_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  organization_email?: Maybe<Scalars['String']>;
  organization_status?: Maybe<Scalars['organization_status']>;
  organization_type?: Maybe<Scalars['organization_type']>;
  parent_org_id?: Maybe<Scalars['uuid']>;
  point_of_contact_id?: Maybe<Scalars['uuid']>;
  rubric_link?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  slack_access_token?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "organizations" */
export type Organizations_Max_Order_By = {
  abbr_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_point_of_contact_email?: InputMaybe<Order_By>;
  /** type of customer, i.e. crypto */
  customer_type?: InputMaybe<Order_By>;
  emails_subscribed_to_weekly_summary?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_weekly_summary_sent?: InputMaybe<Order_By>;
  legal_entity_name?: InputMaybe<Order_By>;
  legal_rep_company?: InputMaybe<Order_By>;
  legal_rep_company_website?: InputMaybe<Order_By>;
  legal_rep_documentary_evidence_doc_link?: InputMaybe<Order_By>;
  legal_rep_email_address?: InputMaybe<Order_By>;
  legal_rep_first_name?: InputMaybe<Order_By>;
  legal_rep_job_title?: InputMaybe<Order_By>;
  legal_rep_last_name?: InputMaybe<Order_By>;
  legal_rep_phone_number?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization_email?: InputMaybe<Order_By>;
  organization_status?: InputMaybe<Order_By>;
  organization_type?: InputMaybe<Order_By>;
  parent_org_id?: InputMaybe<Order_By>;
  point_of_contact_id?: InputMaybe<Order_By>;
  rubric_link?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  slack_access_token?: InputMaybe<Order_By>;
};

/** Holds metadata about organizations */
export type Organizations_Metadata = {
  __typename?: 'organizations_metadata';
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  key: Scalars['String'];
  last_updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user?: Maybe<Users>;
  value: Scalars['String'];
};

/** aggregated selection of "organizations_metadata" */
export type Organizations_Metadata_Aggregate = {
  __typename?: 'organizations_metadata_aggregate';
  aggregate?: Maybe<Organizations_Metadata_Aggregate_Fields>;
  nodes: Array<Organizations_Metadata>;
};

export type Organizations_Metadata_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organizations_Metadata_Aggregate_Bool_Exp_Count>;
};

export type Organizations_Metadata_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organizations_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organizations_Metadata_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organizations_metadata" */
export type Organizations_Metadata_Aggregate_Fields = {
  __typename?: 'organizations_metadata_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organizations_Metadata_Max_Fields>;
  min?: Maybe<Organizations_Metadata_Min_Fields>;
};


/** aggregate fields of "organizations_metadata" */
export type Organizations_Metadata_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organizations_Metadata_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organizations_metadata" */
export type Organizations_Metadata_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organizations_Metadata_Max_Order_By>;
  min?: InputMaybe<Organizations_Metadata_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organizations_metadata" */
export type Organizations_Metadata_Arr_Rel_Insert_Input = {
  data: Array<Organizations_Metadata_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organizations_Metadata_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organizations_metadata". All fields are combined with a logical 'AND'. */
export type Organizations_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Organizations_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Organizations_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Organizations_Metadata_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  last_updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organizations_metadata" */
export enum Organizations_Metadata_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationsMetadataIdKey = 'organizations_metadata_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationsMetadataPkey = 'organizations_metadata_pkey'
}

/** input type for inserting data into table "organizations_metadata" */
export type Organizations_Metadata_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
  last_updated_by?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Organizations_Metadata_Max_Fields = {
  __typename?: 'organizations_metadata_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  last_updated_by?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "organizations_metadata" */
export type Organizations_Metadata_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organizations_Metadata_Min_Fields = {
  __typename?: 'organizations_metadata_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  last_updated_by?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "organizations_metadata" */
export type Organizations_Metadata_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organizations_metadata" */
export type Organizations_Metadata_Mutation_Response = {
  __typename?: 'organizations_metadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations_Metadata>;
};

/** on_conflict condition type for table "organizations_metadata" */
export type Organizations_Metadata_On_Conflict = {
  constraint: Organizations_Metadata_Constraint;
  update_columns?: Array<Organizations_Metadata_Update_Column>;
  where?: InputMaybe<Organizations_Metadata_Bool_Exp>;
};

/** Ordering options when selecting data from "organizations_metadata". */
export type Organizations_Metadata_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organizations_metadata */
export type Organizations_Metadata_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "organizations_metadata" */
export enum Organizations_Metadata_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "organizations_metadata" */
export type Organizations_Metadata_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
  last_updated_by?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "organizations_metadata" */
export type Organizations_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organizations_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organizations_Metadata_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
  last_updated_by?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "organizations_metadata" */
export enum Organizations_Metadata_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Organizations_Metadata_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organizations_Metadata_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organizations_Metadata_Bool_Exp;
};

/** aggregate min on columns */
export type Organizations_Min_Fields = {
  __typename?: 'organizations_min_fields';
  abbr_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  customer_point_of_contact_email?: Maybe<Scalars['String']>;
  /** type of customer, i.e. crypto */
  customer_type?: Maybe<Scalars['String']>;
  emails_subscribed_to_weekly_summary?: Maybe<Array<Scalars['String']>>;
  id?: Maybe<Scalars['uuid']>;
  last_weekly_summary_sent?: Maybe<Scalars['timestamp']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  legal_rep_company?: Maybe<Scalars['String']>;
  legal_rep_company_website?: Maybe<Scalars['String']>;
  legal_rep_documentary_evidence_doc_link?: Maybe<Scalars['String']>;
  legal_rep_email_address?: Maybe<Scalars['String']>;
  legal_rep_first_name?: Maybe<Scalars['String']>;
  legal_rep_job_title?: Maybe<Scalars['String']>;
  legal_rep_last_name?: Maybe<Scalars['String']>;
  legal_rep_phone_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  organization_email?: Maybe<Scalars['String']>;
  organization_status?: Maybe<Scalars['organization_status']>;
  organization_type?: Maybe<Scalars['organization_type']>;
  parent_org_id?: Maybe<Scalars['uuid']>;
  point_of_contact_id?: Maybe<Scalars['uuid']>;
  rubric_link?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  slack_access_token?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "organizations" */
export type Organizations_Min_Order_By = {
  abbr_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_point_of_contact_email?: InputMaybe<Order_By>;
  /** type of customer, i.e. crypto */
  customer_type?: InputMaybe<Order_By>;
  emails_subscribed_to_weekly_summary?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_weekly_summary_sent?: InputMaybe<Order_By>;
  legal_entity_name?: InputMaybe<Order_By>;
  legal_rep_company?: InputMaybe<Order_By>;
  legal_rep_company_website?: InputMaybe<Order_By>;
  legal_rep_documentary_evidence_doc_link?: InputMaybe<Order_By>;
  legal_rep_email_address?: InputMaybe<Order_By>;
  legal_rep_first_name?: InputMaybe<Order_By>;
  legal_rep_job_title?: InputMaybe<Order_By>;
  legal_rep_last_name?: InputMaybe<Order_By>;
  legal_rep_phone_number?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization_email?: InputMaybe<Order_By>;
  organization_status?: InputMaybe<Order_By>;
  organization_type?: InputMaybe<Order_By>;
  parent_org_id?: InputMaybe<Order_By>;
  point_of_contact_id?: InputMaybe<Order_By>;
  rubric_link?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  slack_access_token?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organizations" */
export type Organizations_Mutation_Response = {
  __typename?: 'organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations>;
};

/** input type for inserting object relation for remote table "organizations" */
export type Organizations_Obj_Rel_Insert_Input = {
  data: Organizations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organizations_On_Conflict>;
};

/** on_conflict condition type for table "organizations" */
export type Organizations_On_Conflict = {
  constraint: Organizations_Constraint;
  update_columns?: Array<Organizations_Update_Column>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};

/** Ordering options when selecting data from "organizations". */
export type Organizations_Order_By = {
  abbr_name?: InputMaybe<Order_By>;
  analytics_summary_recipient_emails?: InputMaybe<Order_By>;
  approved_domains?: InputMaybe<Order_By>;
  approved_emails?: InputMaybe<Order_By>;
  auth_configs?: InputMaybe<Order_By>;
  children_aggregate?: InputMaybe<Organizations_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_point_of_contact_email?: InputMaybe<Order_By>;
  customer_type?: InputMaybe<Order_By>;
  emails_subscribed_to_weekly_summary?: InputMaybe<Order_By>;
  enforcement_metadata?: InputMaybe<Enforcement_Metadata_Order_By>;
  headless_login_tokens?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_app_detection_enabled?: InputMaybe<Order_By>;
  is_code_repos_detection_enabled?: InputMaybe<Order_By>;
  is_crypto_detection_enabled?: InputMaybe<Order_By>;
  is_dark_market_detection_enabled?: InputMaybe<Order_By>;
  is_dark_web_detection_enabled?: InputMaybe<Order_By>;
  is_domain_purchasing_enabled?: InputMaybe<Order_By>;
  is_ecommerce_detection_enabled?: InputMaybe<Order_By>;
  is_email_abuse_box_enabled?: InputMaybe<Order_By>;
  is_email_detection_enabled?: InputMaybe<Order_By>;
  is_full_service?: InputMaybe<Order_By>;
  is_logo_detection_enabled?: InputMaybe<Order_By>;
  is_nft_detection_enabled?: InputMaybe<Order_By>;
  is_original_ip_holder?: InputMaybe<Order_By>;
  is_paid_ads_detection_enabled?: InputMaybe<Order_By>;
  is_parent?: InputMaybe<Order_By>;
  is_phishing_sim_enabled?: InputMaybe<Order_By>;
  is_pii_detection_enabled?: InputMaybe<Order_By>;
  is_report_form_enabled?: InputMaybe<Order_By>;
  is_social_media_detection_enabled?: InputMaybe<Order_By>;
  is_suspicious_emails_enabled?: InputMaybe<Order_By>;
  is_telco_detection_enabled?: InputMaybe<Order_By>;
  is_web2_enabled?: InputMaybe<Order_By>;
  last_weekly_summary_sent?: InputMaybe<Order_By>;
  legal_entity_name?: InputMaybe<Order_By>;
  legal_rep_company?: InputMaybe<Order_By>;
  legal_rep_company_website?: InputMaybe<Order_By>;
  legal_rep_documentary_evidence_doc_link?: InputMaybe<Order_By>;
  legal_rep_email_address?: InputMaybe<Order_By>;
  legal_rep_first_name?: InputMaybe<Order_By>;
  legal_rep_job_title?: InputMaybe<Order_By>;
  legal_rep_last_name?: InputMaybe<Order_By>;
  legal_rep_phone_number?: InputMaybe<Order_By>;
  metadata_aggregate?: InputMaybe<Organizations_Metadata_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization_email?: InputMaybe<Order_By>;
  organization_products_aggregate?: InputMaybe<Organization_Products_Aggregate_Order_By>;
  organization_status?: InputMaybe<Order_By>;
  organization_type?: InputMaybe<Order_By>;
  organization_users_aggregate?: InputMaybe<User_Organizations_Aggregate_Order_By>;
  parent?: InputMaybe<Organizations_Order_By>;
  parent_org_id?: InputMaybe<Order_By>;
  point_of_contact?: InputMaybe<Users_Order_By>;
  point_of_contact_id?: InputMaybe<Order_By>;
  rubric_link?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_organizations_data?: InputMaybe<Salesforce_Organizations_Data_Order_By>;
  slack_access_token?: InputMaybe<Order_By>;
  spoofing_entities_aggregate?: InputMaybe<Spoofing_Entities_Aggregate_Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: organizations */
export type Organizations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organizations_Prepend_Input = {
  analytics_summary_recipient_emails?: InputMaybe<Scalars['jsonb']>;
  approved_domains?: InputMaybe<Scalars['jsonb']>;
  approved_emails?: InputMaybe<Scalars['jsonb']>;
  auth_configs?: InputMaybe<Scalars['jsonb']>;
  headless_login_tokens?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "organizations" */
export enum Organizations_Select_Column {
  /** column name */
  AbbrName = 'abbr_name',
  /** column name */
  AnalyticsSummaryRecipientEmails = 'analytics_summary_recipient_emails',
  /** column name */
  ApprovedDomains = 'approved_domains',
  /** column name */
  ApprovedEmails = 'approved_emails',
  /** column name */
  AuthConfigs = 'auth_configs',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerPointOfContactEmail = 'customer_point_of_contact_email',
  /** column name */
  CustomerType = 'customer_type',
  /** column name */
  EmailsSubscribedToWeeklySummary = 'emails_subscribed_to_weekly_summary',
  /** column name */
  HeadlessLoginTokens = 'headless_login_tokens',
  /** column name */
  Id = 'id',
  /** column name */
  IsAppDetectionEnabled = 'is_app_detection_enabled',
  /** column name */
  IsCodeReposDetectionEnabled = 'is_code_repos_detection_enabled',
  /** column name */
  IsCryptoDetectionEnabled = 'is_crypto_detection_enabled',
  /** column name */
  IsDarkMarketDetectionEnabled = 'is_dark_market_detection_enabled',
  /** column name */
  IsDarkWebDetectionEnabled = 'is_dark_web_detection_enabled',
  /** column name */
  IsDomainPurchasingEnabled = 'is_domain_purchasing_enabled',
  /** column name */
  IsEcommerceDetectionEnabled = 'is_ecommerce_detection_enabled',
  /** column name */
  IsEmailAbuseBoxEnabled = 'is_email_abuse_box_enabled',
  /** column name */
  IsEmailDetectionEnabled = 'is_email_detection_enabled',
  /** column name */
  IsFullService = 'is_full_service',
  /** column name */
  IsLogoDetectionEnabled = 'is_logo_detection_enabled',
  /** column name */
  IsNftDetectionEnabled = 'is_nft_detection_enabled',
  /** column name */
  IsOriginalIpHolder = 'is_original_ip_holder',
  /** column name */
  IsPaidAdsDetectionEnabled = 'is_paid_ads_detection_enabled',
  /** column name */
  IsParent = 'is_parent',
  /** column name */
  IsPhishingSimEnabled = 'is_phishing_sim_enabled',
  /** column name */
  IsPiiDetectionEnabled = 'is_pii_detection_enabled',
  /** column name */
  IsReportFormEnabled = 'is_report_form_enabled',
  /** column name */
  IsSocialMediaDetectionEnabled = 'is_social_media_detection_enabled',
  /** column name */
  IsSuspiciousEmailsEnabled = 'is_suspicious_emails_enabled',
  /** column name */
  IsTelcoDetectionEnabled = 'is_telco_detection_enabled',
  /** column name */
  IsWeb2Enabled = 'is_web2_enabled',
  /** column name */
  LastWeeklySummarySent = 'last_weekly_summary_sent',
  /** column name */
  LegalEntityName = 'legal_entity_name',
  /** column name */
  LegalRepCompany = 'legal_rep_company',
  /** column name */
  LegalRepCompanyWebsite = 'legal_rep_company_website',
  /** column name */
  LegalRepDocumentaryEvidenceDocLink = 'legal_rep_documentary_evidence_doc_link',
  /** column name */
  LegalRepEmailAddress = 'legal_rep_email_address',
  /** column name */
  LegalRepFirstName = 'legal_rep_first_name',
  /** column name */
  LegalRepJobTitle = 'legal_rep_job_title',
  /** column name */
  LegalRepLastName = 'legal_rep_last_name',
  /** column name */
  LegalRepPhoneNumber = 'legal_rep_phone_number',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationEmail = 'organization_email',
  /** column name */
  OrganizationStatus = 'organization_status',
  /** column name */
  OrganizationType = 'organization_type',
  /** column name */
  ParentOrgId = 'parent_org_id',
  /** column name */
  PointOfContactId = 'point_of_contact_id',
  /** column name */
  RubricLink = 'rubric_link',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SlackAccessToken = 'slack_access_token'
}

/** select "organizations_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organizations" */
export enum Organizations_Select_Column_Organizations_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAppDetectionEnabled = 'is_app_detection_enabled',
  /** column name */
  IsCodeReposDetectionEnabled = 'is_code_repos_detection_enabled',
  /** column name */
  IsCryptoDetectionEnabled = 'is_crypto_detection_enabled',
  /** column name */
  IsDarkMarketDetectionEnabled = 'is_dark_market_detection_enabled',
  /** column name */
  IsDarkWebDetectionEnabled = 'is_dark_web_detection_enabled',
  /** column name */
  IsDomainPurchasingEnabled = 'is_domain_purchasing_enabled',
  /** column name */
  IsEcommerceDetectionEnabled = 'is_ecommerce_detection_enabled',
  /** column name */
  IsEmailAbuseBoxEnabled = 'is_email_abuse_box_enabled',
  /** column name */
  IsEmailDetectionEnabled = 'is_email_detection_enabled',
  /** column name */
  IsFullService = 'is_full_service',
  /** column name */
  IsLogoDetectionEnabled = 'is_logo_detection_enabled',
  /** column name */
  IsNftDetectionEnabled = 'is_nft_detection_enabled',
  /** column name */
  IsOriginalIpHolder = 'is_original_ip_holder',
  /** column name */
  IsPaidAdsDetectionEnabled = 'is_paid_ads_detection_enabled',
  /** column name */
  IsParent = 'is_parent',
  /** column name */
  IsPhishingSimEnabled = 'is_phishing_sim_enabled',
  /** column name */
  IsPiiDetectionEnabled = 'is_pii_detection_enabled',
  /** column name */
  IsReportFormEnabled = 'is_report_form_enabled',
  /** column name */
  IsSocialMediaDetectionEnabled = 'is_social_media_detection_enabled',
  /** column name */
  IsSuspiciousEmailsEnabled = 'is_suspicious_emails_enabled',
  /** column name */
  IsTelcoDetectionEnabled = 'is_telco_detection_enabled',
  /** column name */
  IsWeb2Enabled = 'is_web2_enabled'
}

/** select "organizations_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organizations" */
export enum Organizations_Select_Column_Organizations_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAppDetectionEnabled = 'is_app_detection_enabled',
  /** column name */
  IsCodeReposDetectionEnabled = 'is_code_repos_detection_enabled',
  /** column name */
  IsCryptoDetectionEnabled = 'is_crypto_detection_enabled',
  /** column name */
  IsDarkMarketDetectionEnabled = 'is_dark_market_detection_enabled',
  /** column name */
  IsDarkWebDetectionEnabled = 'is_dark_web_detection_enabled',
  /** column name */
  IsDomainPurchasingEnabled = 'is_domain_purchasing_enabled',
  /** column name */
  IsEcommerceDetectionEnabled = 'is_ecommerce_detection_enabled',
  /** column name */
  IsEmailAbuseBoxEnabled = 'is_email_abuse_box_enabled',
  /** column name */
  IsEmailDetectionEnabled = 'is_email_detection_enabled',
  /** column name */
  IsFullService = 'is_full_service',
  /** column name */
  IsLogoDetectionEnabled = 'is_logo_detection_enabled',
  /** column name */
  IsNftDetectionEnabled = 'is_nft_detection_enabled',
  /** column name */
  IsOriginalIpHolder = 'is_original_ip_holder',
  /** column name */
  IsPaidAdsDetectionEnabled = 'is_paid_ads_detection_enabled',
  /** column name */
  IsParent = 'is_parent',
  /** column name */
  IsPhishingSimEnabled = 'is_phishing_sim_enabled',
  /** column name */
  IsPiiDetectionEnabled = 'is_pii_detection_enabled',
  /** column name */
  IsReportFormEnabled = 'is_report_form_enabled',
  /** column name */
  IsSocialMediaDetectionEnabled = 'is_social_media_detection_enabled',
  /** column name */
  IsSuspiciousEmailsEnabled = 'is_suspicious_emails_enabled',
  /** column name */
  IsTelcoDetectionEnabled = 'is_telco_detection_enabled',
  /** column name */
  IsWeb2Enabled = 'is_web2_enabled'
}

/** input type for updating data in table "organizations" */
export type Organizations_Set_Input = {
  abbr_name?: InputMaybe<Scalars['String']>;
  analytics_summary_recipient_emails?: InputMaybe<Scalars['jsonb']>;
  approved_domains?: InputMaybe<Scalars['jsonb']>;
  approved_emails?: InputMaybe<Scalars['jsonb']>;
  auth_configs?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  customer_point_of_contact_email?: InputMaybe<Scalars['String']>;
  /** type of customer, i.e. crypto */
  customer_type?: InputMaybe<Scalars['String']>;
  emails_subscribed_to_weekly_summary?: InputMaybe<Array<Scalars['String']>>;
  headless_login_tokens?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_app_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_code_repos_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_crypto_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_dark_market_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_dark_web_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_domain_purchasing_enabled?: InputMaybe<Scalars['Boolean']>;
  is_ecommerce_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_email_abuse_box_enabled?: InputMaybe<Scalars['Boolean']>;
  is_email_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_full_service?: InputMaybe<Scalars['Boolean']>;
  is_logo_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_nft_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  /** tells us if the brand is the IP holder or just a licensee of the IP */
  is_original_ip_holder?: InputMaybe<Scalars['Boolean']>;
  is_paid_ads_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_parent?: InputMaybe<Scalars['Boolean']>;
  is_phishing_sim_enabled?: InputMaybe<Scalars['Boolean']>;
  is_pii_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  /** allows brands to fill out universal report form from within app */
  is_report_form_enabled?: InputMaybe<Scalars['Boolean']>;
  is_social_media_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_suspicious_emails_enabled?: InputMaybe<Scalars['Boolean']>;
  is_telco_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  /** Web2 Frontend is visible to customer */
  is_web2_enabled?: InputMaybe<Scalars['Boolean']>;
  last_weekly_summary_sent?: InputMaybe<Scalars['timestamp']>;
  legal_entity_name?: InputMaybe<Scalars['String']>;
  legal_rep_company?: InputMaybe<Scalars['String']>;
  legal_rep_company_website?: InputMaybe<Scalars['String']>;
  legal_rep_documentary_evidence_doc_link?: InputMaybe<Scalars['String']>;
  legal_rep_email_address?: InputMaybe<Scalars['String']>;
  legal_rep_first_name?: InputMaybe<Scalars['String']>;
  legal_rep_job_title?: InputMaybe<Scalars['String']>;
  legal_rep_last_name?: InputMaybe<Scalars['String']>;
  legal_rep_phone_number?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organization_email?: InputMaybe<Scalars['String']>;
  organization_status?: InputMaybe<Scalars['organization_status']>;
  organization_type?: InputMaybe<Scalars['organization_type']>;
  parent_org_id?: InputMaybe<Scalars['uuid']>;
  point_of_contact_id?: InputMaybe<Scalars['uuid']>;
  rubric_link?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  slack_access_token?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "organizations" */
export type Organizations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organizations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organizations_Stream_Cursor_Value_Input = {
  abbr_name?: InputMaybe<Scalars['String']>;
  analytics_summary_recipient_emails?: InputMaybe<Scalars['jsonb']>;
  approved_domains?: InputMaybe<Scalars['jsonb']>;
  approved_emails?: InputMaybe<Scalars['jsonb']>;
  auth_configs?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  customer_point_of_contact_email?: InputMaybe<Scalars['String']>;
  /** type of customer, i.e. crypto */
  customer_type?: InputMaybe<Scalars['String']>;
  emails_subscribed_to_weekly_summary?: InputMaybe<Array<Scalars['String']>>;
  headless_login_tokens?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_app_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_code_repos_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_crypto_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_dark_market_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_dark_web_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_domain_purchasing_enabled?: InputMaybe<Scalars['Boolean']>;
  is_ecommerce_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_email_abuse_box_enabled?: InputMaybe<Scalars['Boolean']>;
  is_email_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_full_service?: InputMaybe<Scalars['Boolean']>;
  is_logo_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_nft_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  /** tells us if the brand is the IP holder or just a licensee of the IP */
  is_original_ip_holder?: InputMaybe<Scalars['Boolean']>;
  is_paid_ads_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_parent?: InputMaybe<Scalars['Boolean']>;
  is_phishing_sim_enabled?: InputMaybe<Scalars['Boolean']>;
  is_pii_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  /** allows brands to fill out universal report form from within app */
  is_report_form_enabled?: InputMaybe<Scalars['Boolean']>;
  is_social_media_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  is_suspicious_emails_enabled?: InputMaybe<Scalars['Boolean']>;
  is_telco_detection_enabled?: InputMaybe<Scalars['Boolean']>;
  /** Web2 Frontend is visible to customer */
  is_web2_enabled?: InputMaybe<Scalars['Boolean']>;
  last_weekly_summary_sent?: InputMaybe<Scalars['timestamp']>;
  legal_entity_name?: InputMaybe<Scalars['String']>;
  legal_rep_company?: InputMaybe<Scalars['String']>;
  legal_rep_company_website?: InputMaybe<Scalars['String']>;
  legal_rep_documentary_evidence_doc_link?: InputMaybe<Scalars['String']>;
  legal_rep_email_address?: InputMaybe<Scalars['String']>;
  legal_rep_first_name?: InputMaybe<Scalars['String']>;
  legal_rep_job_title?: InputMaybe<Scalars['String']>;
  legal_rep_last_name?: InputMaybe<Scalars['String']>;
  legal_rep_phone_number?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  organization_email?: InputMaybe<Scalars['String']>;
  organization_status?: InputMaybe<Scalars['organization_status']>;
  organization_type?: InputMaybe<Scalars['organization_type']>;
  parent_org_id?: InputMaybe<Scalars['uuid']>;
  point_of_contact_id?: InputMaybe<Scalars['uuid']>;
  rubric_link?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  slack_access_token?: InputMaybe<Scalars['String']>;
};

/** update columns of table "organizations" */
export enum Organizations_Update_Column {
  /** column name */
  AbbrName = 'abbr_name',
  /** column name */
  AnalyticsSummaryRecipientEmails = 'analytics_summary_recipient_emails',
  /** column name */
  ApprovedDomains = 'approved_domains',
  /** column name */
  ApprovedEmails = 'approved_emails',
  /** column name */
  AuthConfigs = 'auth_configs',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerPointOfContactEmail = 'customer_point_of_contact_email',
  /** column name */
  CustomerType = 'customer_type',
  /** column name */
  EmailsSubscribedToWeeklySummary = 'emails_subscribed_to_weekly_summary',
  /** column name */
  HeadlessLoginTokens = 'headless_login_tokens',
  /** column name */
  Id = 'id',
  /** column name */
  IsAppDetectionEnabled = 'is_app_detection_enabled',
  /** column name */
  IsCodeReposDetectionEnabled = 'is_code_repos_detection_enabled',
  /** column name */
  IsCryptoDetectionEnabled = 'is_crypto_detection_enabled',
  /** column name */
  IsDarkMarketDetectionEnabled = 'is_dark_market_detection_enabled',
  /** column name */
  IsDarkWebDetectionEnabled = 'is_dark_web_detection_enabled',
  /** column name */
  IsDomainPurchasingEnabled = 'is_domain_purchasing_enabled',
  /** column name */
  IsEcommerceDetectionEnabled = 'is_ecommerce_detection_enabled',
  /** column name */
  IsEmailAbuseBoxEnabled = 'is_email_abuse_box_enabled',
  /** column name */
  IsEmailDetectionEnabled = 'is_email_detection_enabled',
  /** column name */
  IsFullService = 'is_full_service',
  /** column name */
  IsLogoDetectionEnabled = 'is_logo_detection_enabled',
  /** column name */
  IsNftDetectionEnabled = 'is_nft_detection_enabled',
  /** column name */
  IsOriginalIpHolder = 'is_original_ip_holder',
  /** column name */
  IsPaidAdsDetectionEnabled = 'is_paid_ads_detection_enabled',
  /** column name */
  IsParent = 'is_parent',
  /** column name */
  IsPhishingSimEnabled = 'is_phishing_sim_enabled',
  /** column name */
  IsPiiDetectionEnabled = 'is_pii_detection_enabled',
  /** column name */
  IsReportFormEnabled = 'is_report_form_enabled',
  /** column name */
  IsSocialMediaDetectionEnabled = 'is_social_media_detection_enabled',
  /** column name */
  IsSuspiciousEmailsEnabled = 'is_suspicious_emails_enabled',
  /** column name */
  IsTelcoDetectionEnabled = 'is_telco_detection_enabled',
  /** column name */
  IsWeb2Enabled = 'is_web2_enabled',
  /** column name */
  LastWeeklySummarySent = 'last_weekly_summary_sent',
  /** column name */
  LegalEntityName = 'legal_entity_name',
  /** column name */
  LegalRepCompany = 'legal_rep_company',
  /** column name */
  LegalRepCompanyWebsite = 'legal_rep_company_website',
  /** column name */
  LegalRepDocumentaryEvidenceDocLink = 'legal_rep_documentary_evidence_doc_link',
  /** column name */
  LegalRepEmailAddress = 'legal_rep_email_address',
  /** column name */
  LegalRepFirstName = 'legal_rep_first_name',
  /** column name */
  LegalRepJobTitle = 'legal_rep_job_title',
  /** column name */
  LegalRepLastName = 'legal_rep_last_name',
  /** column name */
  LegalRepPhoneNumber = 'legal_rep_phone_number',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationEmail = 'organization_email',
  /** column name */
  OrganizationStatus = 'organization_status',
  /** column name */
  OrganizationType = 'organization_type',
  /** column name */
  ParentOrgId = 'parent_org_id',
  /** column name */
  PointOfContactId = 'point_of_contact_id',
  /** column name */
  RubricLink = 'rubric_link',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SlackAccessToken = 'slack_access_token'
}

export type Organizations_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organizations_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organizations_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organizations_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organizations_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organizations_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organizations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organizations_Bool_Exp;
};

/** columns and relationships of "permissions" */
export type Permissions = {
  __typename?: 'permissions';
  action: Scalars['String'];
  created_at: Scalars['timestamptz'];
  feature?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  resource: Scalars['String'];
  /** An array relationship */
  role_permissions: Array<Role_Permissions>;
  /** An aggregate relationship */
  role_permissions_aggregate: Role_Permissions_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "permissions" */
export type PermissionsRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


/** columns and relationships of "permissions" */
export type PermissionsRole_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};

/** aggregated selection of "permissions" */
export type Permissions_Aggregate = {
  __typename?: 'permissions_aggregate';
  aggregate?: Maybe<Permissions_Aggregate_Fields>;
  nodes: Array<Permissions>;
};

/** aggregate fields of "permissions" */
export type Permissions_Aggregate_Fields = {
  __typename?: 'permissions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Permissions_Max_Fields>;
  min?: Maybe<Permissions_Min_Fields>;
};


/** aggregate fields of "permissions" */
export type Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "permissions". All fields are combined with a logical 'AND'. */
export type Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Permissions_Bool_Exp>>;
  _not?: InputMaybe<Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Permissions_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  feature?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  resource?: InputMaybe<String_Comparison_Exp>;
  role_permissions?: InputMaybe<Role_Permissions_Bool_Exp>;
  role_permissions_aggregate?: InputMaybe<Role_Permissions_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "permissions" */
export enum Permissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PermissionsPkey = 'permissions_pkey',
  /** unique or primary key constraint on columns "action", "resource", "feature" */
  PermissionsResourceFeatureActionKey = 'permissions_resource_feature_action_key'
}

/** input type for inserting data into table "permissions" */
export type Permissions_Insert_Input = {
  action?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feature?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource?: InputMaybe<Scalars['String']>;
  role_permissions?: InputMaybe<Role_Permissions_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Permissions_Max_Fields = {
  __typename?: 'permissions_max_fields';
  action?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  feature?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  resource?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Permissions_Min_Fields = {
  __typename?: 'permissions_min_fields';
  action?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  feature?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  resource?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "permissions" */
export type Permissions_Mutation_Response = {
  __typename?: 'permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Permissions>;
};

/** input type for inserting object relation for remote table "permissions" */
export type Permissions_Obj_Rel_Insert_Input = {
  data: Permissions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};

/** on_conflict condition type for table "permissions" */
export type Permissions_On_Conflict = {
  constraint: Permissions_Constraint;
  update_columns?: Array<Permissions_Update_Column>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "permissions". */
export type Permissions_Order_By = {
  action?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  feature?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  resource?: InputMaybe<Order_By>;
  role_permissions_aggregate?: InputMaybe<Role_Permissions_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: permissions */
export type Permissions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "permissions" */
export enum Permissions_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Feature = 'feature',
  /** column name */
  Id = 'id',
  /** column name */
  Resource = 'resource',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "permissions" */
export type Permissions_Set_Input = {
  action?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feature?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "permissions" */
export type Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permissions_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  feature?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  resource?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "permissions" */
export enum Permissions_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Feature = 'feature',
  /** column name */
  Id = 'id',
  /** column name */
  Resource = 'resource',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Permissions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Permissions_Bool_Exp;
};

/** columns and relationships of "phone_numbers" */
export type Phone_Numbers = {
  __typename?: 'phone_numbers';
  country_code: Scalars['String'];
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  number: Scalars['String'];
  telco_provider?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamp'];
};

/** aggregated selection of "phone_numbers" */
export type Phone_Numbers_Aggregate = {
  __typename?: 'phone_numbers_aggregate';
  aggregate?: Maybe<Phone_Numbers_Aggregate_Fields>;
  nodes: Array<Phone_Numbers>;
};

/** aggregate fields of "phone_numbers" */
export type Phone_Numbers_Aggregate_Fields = {
  __typename?: 'phone_numbers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Phone_Numbers_Max_Fields>;
  min?: Maybe<Phone_Numbers_Min_Fields>;
};


/** aggregate fields of "phone_numbers" */
export type Phone_Numbers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "phone_numbers". All fields are combined with a logical 'AND'. */
export type Phone_Numbers_Bool_Exp = {
  _and?: InputMaybe<Array<Phone_Numbers_Bool_Exp>>;
  _not?: InputMaybe<Phone_Numbers_Bool_Exp>;
  _or?: InputMaybe<Array<Phone_Numbers_Bool_Exp>>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  telco_provider?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "phone_numbers" */
export enum Phone_Numbers_Constraint {
  /** unique or primary key constraint on columns "country_code", "number" */
  PhoneNumbersNumberCountryCodeKey = 'phone_numbers_number_country_code_key',
  /** unique or primary key constraint on columns "id" */
  PhoneNumbersPkey = 'phone_numbers_pkey'
}

/** input type for inserting data into table "phone_numbers" */
export type Phone_Numbers_Insert_Input = {
  country_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  number?: InputMaybe<Scalars['String']>;
  telco_provider?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Phone_Numbers_Max_Fields = {
  __typename?: 'phone_numbers_max_fields';
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  telco_provider?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Phone_Numbers_Min_Fields = {
  __typename?: 'phone_numbers_min_fields';
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  telco_provider?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "phone_numbers" */
export type Phone_Numbers_Mutation_Response = {
  __typename?: 'phone_numbers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Phone_Numbers>;
};

/** input type for inserting object relation for remote table "phone_numbers" */
export type Phone_Numbers_Obj_Rel_Insert_Input = {
  data: Phone_Numbers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Phone_Numbers_On_Conflict>;
};

/** on_conflict condition type for table "phone_numbers" */
export type Phone_Numbers_On_Conflict = {
  constraint: Phone_Numbers_Constraint;
  update_columns?: Array<Phone_Numbers_Update_Column>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};

/** Ordering options when selecting data from "phone_numbers". */
export type Phone_Numbers_Order_By = {
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  telco_provider?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: phone_numbers */
export type Phone_Numbers_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "phone_numbers" */
export enum Phone_Numbers_Select_Column {
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  TelcoProvider = 'telco_provider',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "phone_numbers" */
export type Phone_Numbers_Set_Input = {
  country_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  number?: InputMaybe<Scalars['String']>;
  telco_provider?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "phone_numbers" */
export type Phone_Numbers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Phone_Numbers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Phone_Numbers_Stream_Cursor_Value_Input = {
  country_code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  number?: InputMaybe<Scalars['String']>;
  telco_provider?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "phone_numbers" */
export enum Phone_Numbers_Update_Column {
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  TelcoProvider = 'telco_provider',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Phone_Numbers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Phone_Numbers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Phone_Numbers_Bool_Exp;
};

/** columns and relationships of "pii_databrokers" */
export type Pii_Databrokers = {
  __typename?: 'pii_databrokers';
  created_at: Scalars['timestamptz'];
  databroker_logo?: Maybe<Scalars['String']>;
  databroker_name: Scalars['String'];
  databroker_uuid: Scalars['uuid'];
  id: Scalars['uuid'];
};

/** aggregated selection of "pii_databrokers" */
export type Pii_Databrokers_Aggregate = {
  __typename?: 'pii_databrokers_aggregate';
  aggregate?: Maybe<Pii_Databrokers_Aggregate_Fields>;
  nodes: Array<Pii_Databrokers>;
};

/** aggregate fields of "pii_databrokers" */
export type Pii_Databrokers_Aggregate_Fields = {
  __typename?: 'pii_databrokers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Pii_Databrokers_Max_Fields>;
  min?: Maybe<Pii_Databrokers_Min_Fields>;
};


/** aggregate fields of "pii_databrokers" */
export type Pii_Databrokers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pii_Databrokers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "pii_databrokers". All fields are combined with a logical 'AND'. */
export type Pii_Databrokers_Bool_Exp = {
  _and?: InputMaybe<Array<Pii_Databrokers_Bool_Exp>>;
  _not?: InputMaybe<Pii_Databrokers_Bool_Exp>;
  _or?: InputMaybe<Array<Pii_Databrokers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  databroker_logo?: InputMaybe<String_Comparison_Exp>;
  databroker_name?: InputMaybe<String_Comparison_Exp>;
  databroker_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "pii_databrokers" */
export enum Pii_Databrokers_Constraint {
  /** unique or primary key constraint on columns "databroker_name" */
  PiiDatabrokersDatabrokerNameKey = 'pii_databrokers_databroker_name_key',
  /** unique or primary key constraint on columns "id" */
  PiiDatabrokersPkey = 'pii_databrokers_pkey'
}

/** input type for inserting data into table "pii_databrokers" */
export type Pii_Databrokers_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  databroker_logo?: InputMaybe<Scalars['String']>;
  databroker_name?: InputMaybe<Scalars['String']>;
  databroker_uuid?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Pii_Databrokers_Max_Fields = {
  __typename?: 'pii_databrokers_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  databroker_logo?: Maybe<Scalars['String']>;
  databroker_name?: Maybe<Scalars['String']>;
  databroker_uuid?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Pii_Databrokers_Min_Fields = {
  __typename?: 'pii_databrokers_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  databroker_logo?: Maybe<Scalars['String']>;
  databroker_name?: Maybe<Scalars['String']>;
  databroker_uuid?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "pii_databrokers" */
export type Pii_Databrokers_Mutation_Response = {
  __typename?: 'pii_databrokers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pii_Databrokers>;
};

/** input type for inserting object relation for remote table "pii_databrokers" */
export type Pii_Databrokers_Obj_Rel_Insert_Input = {
  data: Pii_Databrokers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pii_Databrokers_On_Conflict>;
};

/** on_conflict condition type for table "pii_databrokers" */
export type Pii_Databrokers_On_Conflict = {
  constraint: Pii_Databrokers_Constraint;
  update_columns?: Array<Pii_Databrokers_Update_Column>;
  where?: InputMaybe<Pii_Databrokers_Bool_Exp>;
};

/** Ordering options when selecting data from "pii_databrokers". */
export type Pii_Databrokers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  databroker_logo?: InputMaybe<Order_By>;
  databroker_name?: InputMaybe<Order_By>;
  databroker_uuid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pii_databrokers */
export type Pii_Databrokers_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "pii_databrokers" */
export enum Pii_Databrokers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DatabrokerLogo = 'databroker_logo',
  /** column name */
  DatabrokerName = 'databroker_name',
  /** column name */
  DatabrokerUuid = 'databroker_uuid',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "pii_databrokers" */
export type Pii_Databrokers_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  databroker_logo?: InputMaybe<Scalars['String']>;
  databroker_name?: InputMaybe<Scalars['String']>;
  databroker_uuid?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "pii_databrokers" */
export type Pii_Databrokers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pii_Databrokers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pii_Databrokers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  databroker_logo?: InputMaybe<Scalars['String']>;
  databroker_name?: InputMaybe<Scalars['String']>;
  databroker_uuid?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "pii_databrokers" */
export enum Pii_Databrokers_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DatabrokerLogo = 'databroker_logo',
  /** column name */
  DatabrokerName = 'databroker_name',
  /** column name */
  DatabrokerUuid = 'databroker_uuid',
  /** column name */
  Id = 'id'
}

export type Pii_Databrokers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pii_Databrokers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pii_Databrokers_Bool_Exp;
};

/** columns and relationships of "pii_events" */
export type Pii_Events = {
  __typename?: 'pii_events';
  created_at: Scalars['timestamp'];
  /** An object relationship */
  databroker?: Maybe<Pii_Databrokers>;
  databroker_uuid?: Maybe<Scalars['uuid']>;
  external_created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  message: Scalars['String'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "pii_events" */
export type Pii_Events_Aggregate = {
  __typename?: 'pii_events_aggregate';
  aggregate?: Maybe<Pii_Events_Aggregate_Fields>;
  nodes: Array<Pii_Events>;
};

/** aggregate fields of "pii_events" */
export type Pii_Events_Aggregate_Fields = {
  __typename?: 'pii_events_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Pii_Events_Max_Fields>;
  min?: Maybe<Pii_Events_Min_Fields>;
};


/** aggregate fields of "pii_events" */
export type Pii_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pii_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "pii_events". All fields are combined with a logical 'AND'. */
export type Pii_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Pii_Events_Bool_Exp>>;
  _not?: InputMaybe<Pii_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Pii_Events_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  databroker?: InputMaybe<Pii_Databrokers_Bool_Exp>;
  databroker_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  external_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "pii_events" */
export enum Pii_Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  PiiEventsPkey = 'pii_events_pkey',
  /** unique or primary key constraint on columns "user_id", "external_created_at", "databroker_uuid", "message" */
  PiiEventsUserIdDatabrokerUuidExternalCreatedAtMessage = 'pii_events_user_id_databroker_uuid_external_created_at_message_'
}

/** input type for inserting data into table "pii_events" */
export type Pii_Events_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  databroker?: InputMaybe<Pii_Databrokers_Obj_Rel_Insert_Input>;
  databroker_uuid?: InputMaybe<Scalars['uuid']>;
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Pii_Events_Max_Fields = {
  __typename?: 'pii_events_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  databroker_uuid?: Maybe<Scalars['uuid']>;
  external_created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Pii_Events_Min_Fields = {
  __typename?: 'pii_events_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  databroker_uuid?: Maybe<Scalars['uuid']>;
  external_created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "pii_events" */
export type Pii_Events_Mutation_Response = {
  __typename?: 'pii_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pii_Events>;
};

/** on_conflict condition type for table "pii_events" */
export type Pii_Events_On_Conflict = {
  constraint: Pii_Events_Constraint;
  update_columns?: Array<Pii_Events_Update_Column>;
  where?: InputMaybe<Pii_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "pii_events". */
export type Pii_Events_Order_By = {
  created_at?: InputMaybe<Order_By>;
  databroker?: InputMaybe<Pii_Databrokers_Order_By>;
  databroker_uuid?: InputMaybe<Order_By>;
  external_created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pii_events */
export type Pii_Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "pii_events" */
export enum Pii_Events_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DatabrokerUuid = 'databroker_uuid',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "pii_events" */
export type Pii_Events_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  databroker_uuid?: InputMaybe<Scalars['uuid']>;
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "pii_events" */
export type Pii_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pii_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pii_Events_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  databroker_uuid?: InputMaybe<Scalars['uuid']>;
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "pii_events" */
export enum Pii_Events_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DatabrokerUuid = 'databroker_uuid',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  UserId = 'user_id'
}

export type Pii_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pii_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pii_Events_Bool_Exp;
};

/** columns and relationships of "pii_leaks_by_databroker" */
export type Pii_Leaks_By_Databroker = {
  __typename?: 'pii_leaks_by_databroker';
  databroker_name?: Maybe<Scalars['String']>;
  leak_count?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "pii_leaks_by_databroker" */
export type Pii_Leaks_By_Databroker_Aggregate = {
  __typename?: 'pii_leaks_by_databroker_aggregate';
  aggregate?: Maybe<Pii_Leaks_By_Databroker_Aggregate_Fields>;
  nodes: Array<Pii_Leaks_By_Databroker>;
};

/** aggregate fields of "pii_leaks_by_databroker" */
export type Pii_Leaks_By_Databroker_Aggregate_Fields = {
  __typename?: 'pii_leaks_by_databroker_aggregate_fields';
  avg?: Maybe<Pii_Leaks_By_Databroker_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pii_Leaks_By_Databroker_Max_Fields>;
  min?: Maybe<Pii_Leaks_By_Databroker_Min_Fields>;
  stddev?: Maybe<Pii_Leaks_By_Databroker_Stddev_Fields>;
  stddev_pop?: Maybe<Pii_Leaks_By_Databroker_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pii_Leaks_By_Databroker_Stddev_Samp_Fields>;
  sum?: Maybe<Pii_Leaks_By_Databroker_Sum_Fields>;
  var_pop?: Maybe<Pii_Leaks_By_Databroker_Var_Pop_Fields>;
  var_samp?: Maybe<Pii_Leaks_By_Databroker_Var_Samp_Fields>;
  variance?: Maybe<Pii_Leaks_By_Databroker_Variance_Fields>;
};


/** aggregate fields of "pii_leaks_by_databroker" */
export type Pii_Leaks_By_Databroker_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pii_Leaks_By_Databroker_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pii_Leaks_By_Databroker_Avg_Fields = {
  __typename?: 'pii_leaks_by_databroker_avg_fields';
  leak_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pii_leaks_by_databroker". All fields are combined with a logical 'AND'. */
export type Pii_Leaks_By_Databroker_Bool_Exp = {
  _and?: InputMaybe<Array<Pii_Leaks_By_Databroker_Bool_Exp>>;
  _not?: InputMaybe<Pii_Leaks_By_Databroker_Bool_Exp>;
  _or?: InputMaybe<Array<Pii_Leaks_By_Databroker_Bool_Exp>>;
  databroker_name?: InputMaybe<String_Comparison_Exp>;
  leak_count?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pii_Leaks_By_Databroker_Max_Fields = {
  __typename?: 'pii_leaks_by_databroker_max_fields';
  databroker_name?: Maybe<Scalars['String']>;
  leak_count?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Pii_Leaks_By_Databroker_Min_Fields = {
  __typename?: 'pii_leaks_by_databroker_min_fields';
  databroker_name?: Maybe<Scalars['String']>;
  leak_count?: Maybe<Scalars['bigint']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "pii_leaks_by_databroker". */
export type Pii_Leaks_By_Databroker_Order_By = {
  databroker_name?: InputMaybe<Order_By>;
  leak_count?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "pii_leaks_by_databroker" */
export enum Pii_Leaks_By_Databroker_Select_Column {
  /** column name */
  DatabrokerName = 'databroker_name',
  /** column name */
  LeakCount = 'leak_count',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Pii_Leaks_By_Databroker_Stddev_Fields = {
  __typename?: 'pii_leaks_by_databroker_stddev_fields';
  leak_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pii_Leaks_By_Databroker_Stddev_Pop_Fields = {
  __typename?: 'pii_leaks_by_databroker_stddev_pop_fields';
  leak_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pii_Leaks_By_Databroker_Stddev_Samp_Fields = {
  __typename?: 'pii_leaks_by_databroker_stddev_samp_fields';
  leak_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pii_leaks_by_databroker" */
export type Pii_Leaks_By_Databroker_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pii_Leaks_By_Databroker_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pii_Leaks_By_Databroker_Stream_Cursor_Value_Input = {
  databroker_name?: InputMaybe<Scalars['String']>;
  leak_count?: InputMaybe<Scalars['bigint']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Pii_Leaks_By_Databroker_Sum_Fields = {
  __typename?: 'pii_leaks_by_databroker_sum_fields';
  leak_count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Pii_Leaks_By_Databroker_Var_Pop_Fields = {
  __typename?: 'pii_leaks_by_databroker_var_pop_fields';
  leak_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pii_Leaks_By_Databroker_Var_Samp_Fields = {
  __typename?: 'pii_leaks_by_databroker_var_samp_fields';
  leak_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pii_Leaks_By_Databroker_Variance_Fields = {
  __typename?: 'pii_leaks_by_databroker_variance_fields';
  leak_count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pii_reports" */
export type Pii_Reports = {
  __typename?: 'pii_reports';
  created_at: Scalars['timestamp'];
  /** An object relationship */
  databroker?: Maybe<Pii_Databrokers>;
  databroker_uuid: Scalars['uuid'];
  exposure_status: Scalars['Int'];
  exposure_status_description: Scalars['String'];
  exposure_url?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  removal_status: Scalars['Int'];
  removal_status_description: Scalars['String'];
  screenshot_found_created_at?: Maybe<Scalars['timestamp']>;
  screenshot_found_image?: Maybe<Scalars['String']>;
  screenshot_found_thumbnail?: Maybe<Scalars['String']>;
  screenshot_found_url?: Maybe<Scalars['String']>;
  screenshot_notfound_created_at?: Maybe<Scalars['timestamp']>;
  screenshot_notfound_image?: Maybe<Scalars['String']>;
  screenshot_notfound_thumbnail?: Maybe<Scalars['String']>;
  screenshot_notfound_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

export type Pii_Reports_Aggregate = {
  __typename?: 'pii_reports_aggregate';
  aggregate?: Maybe<Pii_Reports_Aggregate_Fields>;
  nodes: Array<Pii_Reports>;
};

/** aggregate fields of "pii_reports" */
export type Pii_Reports_Aggregate_Fields = {
  __typename?: 'pii_reports_aggregate_fields';
  avg?: Maybe<Pii_Reports_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pii_Reports_Max_Fields>;
  min?: Maybe<Pii_Reports_Min_Fields>;
  stddev?: Maybe<Pii_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Pii_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pii_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Pii_Reports_Sum_Fields>;
  var_pop?: Maybe<Pii_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Pii_Reports_Var_Samp_Fields>;
  variance?: Maybe<Pii_Reports_Variance_Fields>;
};


/** aggregate fields of "pii_reports" */
export type Pii_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pii_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pii_Reports_Avg_Fields = {
  __typename?: 'pii_reports_avg_fields';
  exposure_status?: Maybe<Scalars['Float']>;
  removal_status?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pii_reports". All fields are combined with a logical 'AND'. */
export type Pii_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Pii_Reports_Bool_Exp>>;
  _not?: InputMaybe<Pii_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Pii_Reports_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  databroker?: InputMaybe<Pii_Databrokers_Bool_Exp>;
  databroker_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  exposure_status?: InputMaybe<Int_Comparison_Exp>;
  exposure_status_description?: InputMaybe<String_Comparison_Exp>;
  exposure_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  removal_status?: InputMaybe<Int_Comparison_Exp>;
  removal_status_description?: InputMaybe<String_Comparison_Exp>;
  screenshot_found_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  screenshot_found_image?: InputMaybe<String_Comparison_Exp>;
  screenshot_found_thumbnail?: InputMaybe<String_Comparison_Exp>;
  screenshot_found_url?: InputMaybe<String_Comparison_Exp>;
  screenshot_notfound_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  screenshot_notfound_image?: InputMaybe<String_Comparison_Exp>;
  screenshot_notfound_thumbnail?: InputMaybe<String_Comparison_Exp>;
  screenshot_notfound_url?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "pii_reports" */
export enum Pii_Reports_Constraint {
  /** unique or primary key constraint on columns "user_id", "databroker_uuid" */
  PiiReportsDatabrokerUuidUserIdKey = 'pii_reports_databroker_uuid_user_id_key',
  /** unique or primary key constraint on columns "id" */
  PiiReportsPkey = 'pii_reports_pkey'
}

/** input type for incrementing numeric columns in table "pii_reports" */
export type Pii_Reports_Inc_Input = {
  exposure_status?: InputMaybe<Scalars['Int']>;
  removal_status?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pii_reports" */
export type Pii_Reports_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  databroker?: InputMaybe<Pii_Databrokers_Obj_Rel_Insert_Input>;
  databroker_uuid?: InputMaybe<Scalars['uuid']>;
  exposure_status?: InputMaybe<Scalars['Int']>;
  exposure_status_description?: InputMaybe<Scalars['String']>;
  exposure_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  removal_status?: InputMaybe<Scalars['Int']>;
  removal_status_description?: InputMaybe<Scalars['String']>;
  screenshot_found_created_at?: InputMaybe<Scalars['timestamp']>;
  screenshot_found_image?: InputMaybe<Scalars['String']>;
  screenshot_found_thumbnail?: InputMaybe<Scalars['String']>;
  screenshot_found_url?: InputMaybe<Scalars['String']>;
  screenshot_notfound_created_at?: InputMaybe<Scalars['timestamp']>;
  screenshot_notfound_image?: InputMaybe<Scalars['String']>;
  screenshot_notfound_thumbnail?: InputMaybe<Scalars['String']>;
  screenshot_notfound_url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Pii_Reports_Max_Fields = {
  __typename?: 'pii_reports_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  databroker_uuid?: Maybe<Scalars['uuid']>;
  exposure_status?: Maybe<Scalars['Int']>;
  exposure_status_description?: Maybe<Scalars['String']>;
  exposure_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  removal_status?: Maybe<Scalars['Int']>;
  removal_status_description?: Maybe<Scalars['String']>;
  screenshot_found_created_at?: Maybe<Scalars['timestamp']>;
  screenshot_found_image?: Maybe<Scalars['String']>;
  screenshot_found_thumbnail?: Maybe<Scalars['String']>;
  screenshot_found_url?: Maybe<Scalars['String']>;
  screenshot_notfound_created_at?: Maybe<Scalars['timestamp']>;
  screenshot_notfound_image?: Maybe<Scalars['String']>;
  screenshot_notfound_thumbnail?: Maybe<Scalars['String']>;
  screenshot_notfound_url?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Pii_Reports_Min_Fields = {
  __typename?: 'pii_reports_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  databroker_uuid?: Maybe<Scalars['uuid']>;
  exposure_status?: Maybe<Scalars['Int']>;
  exposure_status_description?: Maybe<Scalars['String']>;
  exposure_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  removal_status?: Maybe<Scalars['Int']>;
  removal_status_description?: Maybe<Scalars['String']>;
  screenshot_found_created_at?: Maybe<Scalars['timestamp']>;
  screenshot_found_image?: Maybe<Scalars['String']>;
  screenshot_found_thumbnail?: Maybe<Scalars['String']>;
  screenshot_found_url?: Maybe<Scalars['String']>;
  screenshot_notfound_created_at?: Maybe<Scalars['timestamp']>;
  screenshot_notfound_image?: Maybe<Scalars['String']>;
  screenshot_notfound_thumbnail?: Maybe<Scalars['String']>;
  screenshot_notfound_url?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "pii_reports" */
export type Pii_Reports_Mutation_Response = {
  __typename?: 'pii_reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pii_Reports>;
};

/** on_conflict condition type for table "pii_reports" */
export type Pii_Reports_On_Conflict = {
  constraint: Pii_Reports_Constraint;
  update_columns?: Array<Pii_Reports_Update_Column>;
  where?: InputMaybe<Pii_Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "pii_reports". */
export type Pii_Reports_Order_By = {
  created_at?: InputMaybe<Order_By>;
  databroker?: InputMaybe<Pii_Databrokers_Order_By>;
  databroker_uuid?: InputMaybe<Order_By>;
  exposure_status?: InputMaybe<Order_By>;
  exposure_status_description?: InputMaybe<Order_By>;
  exposure_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  removal_status?: InputMaybe<Order_By>;
  removal_status_description?: InputMaybe<Order_By>;
  screenshot_found_created_at?: InputMaybe<Order_By>;
  screenshot_found_image?: InputMaybe<Order_By>;
  screenshot_found_thumbnail?: InputMaybe<Order_By>;
  screenshot_found_url?: InputMaybe<Order_By>;
  screenshot_notfound_created_at?: InputMaybe<Order_By>;
  screenshot_notfound_image?: InputMaybe<Order_By>;
  screenshot_notfound_thumbnail?: InputMaybe<Order_By>;
  screenshot_notfound_url?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pii_reports */
export type Pii_Reports_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "pii_reports" */
export enum Pii_Reports_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DatabrokerUuid = 'databroker_uuid',
  /** column name */
  ExposureStatus = 'exposure_status',
  /** column name */
  ExposureStatusDescription = 'exposure_status_description',
  /** column name */
  ExposureUrl = 'exposure_url',
  /** column name */
  Id = 'id',
  /** column name */
  RemovalStatus = 'removal_status',
  /** column name */
  RemovalStatusDescription = 'removal_status_description',
  /** column name */
  ScreenshotFoundCreatedAt = 'screenshot_found_created_at',
  /** column name */
  ScreenshotFoundImage = 'screenshot_found_image',
  /** column name */
  ScreenshotFoundThumbnail = 'screenshot_found_thumbnail',
  /** column name */
  ScreenshotFoundUrl = 'screenshot_found_url',
  /** column name */
  ScreenshotNotfoundCreatedAt = 'screenshot_notfound_created_at',
  /** column name */
  ScreenshotNotfoundImage = 'screenshot_notfound_image',
  /** column name */
  ScreenshotNotfoundThumbnail = 'screenshot_notfound_thumbnail',
  /** column name */
  ScreenshotNotfoundUrl = 'screenshot_notfound_url',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "pii_reports" */
export type Pii_Reports_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  databroker_uuid?: InputMaybe<Scalars['uuid']>;
  exposure_status?: InputMaybe<Scalars['Int']>;
  exposure_status_description?: InputMaybe<Scalars['String']>;
  exposure_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  removal_status?: InputMaybe<Scalars['Int']>;
  removal_status_description?: InputMaybe<Scalars['String']>;
  screenshot_found_created_at?: InputMaybe<Scalars['timestamp']>;
  screenshot_found_image?: InputMaybe<Scalars['String']>;
  screenshot_found_thumbnail?: InputMaybe<Scalars['String']>;
  screenshot_found_url?: InputMaybe<Scalars['String']>;
  screenshot_notfound_created_at?: InputMaybe<Scalars['timestamp']>;
  screenshot_notfound_image?: InputMaybe<Scalars['String']>;
  screenshot_notfound_thumbnail?: InputMaybe<Scalars['String']>;
  screenshot_notfound_url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Pii_Reports_Stddev_Fields = {
  __typename?: 'pii_reports_stddev_fields';
  exposure_status?: Maybe<Scalars['Float']>;
  removal_status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pii_Reports_Stddev_Pop_Fields = {
  __typename?: 'pii_reports_stddev_pop_fields';
  exposure_status?: Maybe<Scalars['Float']>;
  removal_status?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pii_Reports_Stddev_Samp_Fields = {
  __typename?: 'pii_reports_stddev_samp_fields';
  exposure_status?: Maybe<Scalars['Float']>;
  removal_status?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pii_reports" */
export type Pii_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pii_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pii_Reports_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  databroker_uuid?: InputMaybe<Scalars['uuid']>;
  exposure_status?: InputMaybe<Scalars['Int']>;
  exposure_status_description?: InputMaybe<Scalars['String']>;
  exposure_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  removal_status?: InputMaybe<Scalars['Int']>;
  removal_status_description?: InputMaybe<Scalars['String']>;
  screenshot_found_created_at?: InputMaybe<Scalars['timestamp']>;
  screenshot_found_image?: InputMaybe<Scalars['String']>;
  screenshot_found_thumbnail?: InputMaybe<Scalars['String']>;
  screenshot_found_url?: InputMaybe<Scalars['String']>;
  screenshot_notfound_created_at?: InputMaybe<Scalars['timestamp']>;
  screenshot_notfound_image?: InputMaybe<Scalars['String']>;
  screenshot_notfound_thumbnail?: InputMaybe<Scalars['String']>;
  screenshot_notfound_url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Pii_Reports_Sum_Fields = {
  __typename?: 'pii_reports_sum_fields';
  exposure_status?: Maybe<Scalars['Int']>;
  removal_status?: Maybe<Scalars['Int']>;
};

/** update columns of table "pii_reports" */
export enum Pii_Reports_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DatabrokerUuid = 'databroker_uuid',
  /** column name */
  ExposureStatus = 'exposure_status',
  /** column name */
  ExposureStatusDescription = 'exposure_status_description',
  /** column name */
  ExposureUrl = 'exposure_url',
  /** column name */
  Id = 'id',
  /** column name */
  RemovalStatus = 'removal_status',
  /** column name */
  RemovalStatusDescription = 'removal_status_description',
  /** column name */
  ScreenshotFoundCreatedAt = 'screenshot_found_created_at',
  /** column name */
  ScreenshotFoundImage = 'screenshot_found_image',
  /** column name */
  ScreenshotFoundThumbnail = 'screenshot_found_thumbnail',
  /** column name */
  ScreenshotFoundUrl = 'screenshot_found_url',
  /** column name */
  ScreenshotNotfoundCreatedAt = 'screenshot_notfound_created_at',
  /** column name */
  ScreenshotNotfoundImage = 'screenshot_notfound_image',
  /** column name */
  ScreenshotNotfoundThumbnail = 'screenshot_notfound_thumbnail',
  /** column name */
  ScreenshotNotfoundUrl = 'screenshot_notfound_url',
  /** column name */
  UserId = 'user_id'
}

export type Pii_Reports_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pii_Reports_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pii_Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pii_Reports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pii_Reports_Var_Pop_Fields = {
  __typename?: 'pii_reports_var_pop_fields';
  exposure_status?: Maybe<Scalars['Float']>;
  removal_status?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pii_Reports_Var_Samp_Fields = {
  __typename?: 'pii_reports_var_samp_fields';
  exposure_status?: Maybe<Scalars['Float']>;
  removal_status?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pii_Reports_Variance_Fields = {
  __typename?: 'pii_reports_variance_fields';
  exposure_status?: Maybe<Scalars['Float']>;
  removal_status?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "pii_statistics" */
export type Pii_Statistics = {
  __typename?: 'pii_statistics';
  /** Record creation timestamp */
  created_at: Scalars['timestamp'];
  date: Scalars['date'];
  /** Total number of data brokers covered by the plan */
  db_covered: Scalars['Int'];
  /** Total profiles found exposed */
  exposed: Scalars['Int'];
  /** Auto-generated unique identifier */
  id: Scalars['uuid'];
  /** Total removals in progress */
  removals_in_progress: Scalars['Int'];
  /** Total removals pending */
  removals_pending: Scalars['Int'];
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found: Scalars['Int'];
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found: Scalars['Int'];
  /** An object relationship */
  user: Users;
  /** User identifier, foreign key to users.id */
  user_id: Scalars['uuid'];
};

/** aggregated selection of "pii_statistics" */
export type Pii_Statistics_Aggregate = {
  __typename?: 'pii_statistics_aggregate';
  aggregate?: Maybe<Pii_Statistics_Aggregate_Fields>;
  nodes: Array<Pii_Statistics>;
};

/** aggregate fields of "pii_statistics" */
export type Pii_Statistics_Aggregate_Fields = {
  __typename?: 'pii_statistics_aggregate_fields';
  avg?: Maybe<Pii_Statistics_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Pii_Statistics_Max_Fields>;
  min?: Maybe<Pii_Statistics_Min_Fields>;
  stddev?: Maybe<Pii_Statistics_Stddev_Fields>;
  stddev_pop?: Maybe<Pii_Statistics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pii_Statistics_Stddev_Samp_Fields>;
  sum?: Maybe<Pii_Statistics_Sum_Fields>;
  var_pop?: Maybe<Pii_Statistics_Var_Pop_Fields>;
  var_samp?: Maybe<Pii_Statistics_Var_Samp_Fields>;
  variance?: Maybe<Pii_Statistics_Variance_Fields>;
};


/** aggregate fields of "pii_statistics" */
export type Pii_Statistics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pii_Statistics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pii_Statistics_Avg_Fields = {
  __typename?: 'pii_statistics_avg_fields';
  /** Total number of data brokers covered by the plan */
  db_covered?: Maybe<Scalars['Float']>;
  /** Total profiles found exposed */
  exposed?: Maybe<Scalars['Float']>;
  /** Total removals in progress */
  removals_in_progress?: Maybe<Scalars['Float']>;
  /** Total removals pending */
  removals_pending?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "pii_statistics". All fields are combined with a logical 'AND'. */
export type Pii_Statistics_Bool_Exp = {
  _and?: InputMaybe<Array<Pii_Statistics_Bool_Exp>>;
  _not?: InputMaybe<Pii_Statistics_Bool_Exp>;
  _or?: InputMaybe<Array<Pii_Statistics_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  db_covered?: InputMaybe<Int_Comparison_Exp>;
  exposed?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  removals_in_progress?: InputMaybe<Int_Comparison_Exp>;
  removals_pending?: InputMaybe<Int_Comparison_Exp>;
  removed_not_found?: InputMaybe<Int_Comparison_Exp>;
  total_removed_not_found?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "pii_statistics" */
export enum Pii_Statistics_Constraint {
  /** unique or primary key constraint on columns "id" */
  PiiStatisticsPkey = 'pii_statistics_pkey',
  /** unique or primary key constraint on columns "user_id", "date" */
  PiiStatisticsUserIdDateKey = 'pii_statistics_user_id_date_key'
}

/** input type for incrementing numeric columns in table "pii_statistics" */
export type Pii_Statistics_Inc_Input = {
  /** Total number of data brokers covered by the plan */
  db_covered?: InputMaybe<Scalars['Int']>;
  /** Total profiles found exposed */
  exposed?: InputMaybe<Scalars['Int']>;
  /** Total removals in progress */
  removals_in_progress?: InputMaybe<Scalars['Int']>;
  /** Total removals pending */
  removals_pending?: InputMaybe<Scalars['Int']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: InputMaybe<Scalars['Int']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "pii_statistics" */
export type Pii_Statistics_Insert_Input = {
  /** Record creation timestamp */
  created_at?: InputMaybe<Scalars['timestamp']>;
  date?: InputMaybe<Scalars['date']>;
  /** Total number of data brokers covered by the plan */
  db_covered?: InputMaybe<Scalars['Int']>;
  /** Total profiles found exposed */
  exposed?: InputMaybe<Scalars['Int']>;
  /** Auto-generated unique identifier */
  id?: InputMaybe<Scalars['uuid']>;
  /** Total removals in progress */
  removals_in_progress?: InputMaybe<Scalars['Int']>;
  /** Total removals pending */
  removals_pending?: InputMaybe<Scalars['Int']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: InputMaybe<Scalars['Int']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  /** User identifier, foreign key to users.id */
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Pii_Statistics_Max_Fields = {
  __typename?: 'pii_statistics_max_fields';
  /** Record creation timestamp */
  created_at?: Maybe<Scalars['timestamp']>;
  date?: Maybe<Scalars['date']>;
  /** Total number of data brokers covered by the plan */
  db_covered?: Maybe<Scalars['Int']>;
  /** Total profiles found exposed */
  exposed?: Maybe<Scalars['Int']>;
  /** Auto-generated unique identifier */
  id?: Maybe<Scalars['uuid']>;
  /** Total removals in progress */
  removals_in_progress?: Maybe<Scalars['Int']>;
  /** Total removals pending */
  removals_pending?: Maybe<Scalars['Int']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: Maybe<Scalars['Int']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: Maybe<Scalars['Int']>;
  /** User identifier, foreign key to users.id */
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Pii_Statistics_Min_Fields = {
  __typename?: 'pii_statistics_min_fields';
  /** Record creation timestamp */
  created_at?: Maybe<Scalars['timestamp']>;
  date?: Maybe<Scalars['date']>;
  /** Total number of data brokers covered by the plan */
  db_covered?: Maybe<Scalars['Int']>;
  /** Total profiles found exposed */
  exposed?: Maybe<Scalars['Int']>;
  /** Auto-generated unique identifier */
  id?: Maybe<Scalars['uuid']>;
  /** Total removals in progress */
  removals_in_progress?: Maybe<Scalars['Int']>;
  /** Total removals pending */
  removals_pending?: Maybe<Scalars['Int']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: Maybe<Scalars['Int']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: Maybe<Scalars['Int']>;
  /** User identifier, foreign key to users.id */
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "pii_statistics" */
export type Pii_Statistics_Mutation_Response = {
  __typename?: 'pii_statistics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pii_Statistics>;
};

/** on_conflict condition type for table "pii_statistics" */
export type Pii_Statistics_On_Conflict = {
  constraint: Pii_Statistics_Constraint;
  update_columns?: Array<Pii_Statistics_Update_Column>;
  where?: InputMaybe<Pii_Statistics_Bool_Exp>;
};

/** Ordering options when selecting data from "pii_statistics". */
export type Pii_Statistics_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  db_covered?: InputMaybe<Order_By>;
  exposed?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  removals_in_progress?: InputMaybe<Order_By>;
  removals_pending?: InputMaybe<Order_By>;
  removed_not_found?: InputMaybe<Order_By>;
  total_removed_not_found?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pii_statistics */
export type Pii_Statistics_Pk_Columns_Input = {
  /** Auto-generated unique identifier */
  id: Scalars['uuid'];
};

/** select columns of table "pii_statistics" */
export enum Pii_Statistics_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  DbCovered = 'db_covered',
  /** column name */
  Exposed = 'exposed',
  /** column name */
  Id = 'id',
  /** column name */
  RemovalsInProgress = 'removals_in_progress',
  /** column name */
  RemovalsPending = 'removals_pending',
  /** column name */
  RemovedNotFound = 'removed_not_found',
  /** column name */
  TotalRemovedNotFound = 'total_removed_not_found',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "pii_statistics" */
export type Pii_Statistics_Set_Input = {
  /** Record creation timestamp */
  created_at?: InputMaybe<Scalars['timestamp']>;
  date?: InputMaybe<Scalars['date']>;
  /** Total number of data brokers covered by the plan */
  db_covered?: InputMaybe<Scalars['Int']>;
  /** Total profiles found exposed */
  exposed?: InputMaybe<Scalars['Int']>;
  /** Auto-generated unique identifier */
  id?: InputMaybe<Scalars['uuid']>;
  /** Total removals in progress */
  removals_in_progress?: InputMaybe<Scalars['Int']>;
  /** Total removals pending */
  removals_pending?: InputMaybe<Scalars['Int']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: InputMaybe<Scalars['Int']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: InputMaybe<Scalars['Int']>;
  /** User identifier, foreign key to users.id */
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Pii_Statistics_Stddev_Fields = {
  __typename?: 'pii_statistics_stddev_fields';
  /** Total number of data brokers covered by the plan */
  db_covered?: Maybe<Scalars['Float']>;
  /** Total profiles found exposed */
  exposed?: Maybe<Scalars['Float']>;
  /** Total removals in progress */
  removals_in_progress?: Maybe<Scalars['Float']>;
  /** Total removals pending */
  removals_pending?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pii_Statistics_Stddev_Pop_Fields = {
  __typename?: 'pii_statistics_stddev_pop_fields';
  /** Total number of data brokers covered by the plan */
  db_covered?: Maybe<Scalars['Float']>;
  /** Total profiles found exposed */
  exposed?: Maybe<Scalars['Float']>;
  /** Total removals in progress */
  removals_in_progress?: Maybe<Scalars['Float']>;
  /** Total removals pending */
  removals_pending?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pii_Statistics_Stddev_Samp_Fields = {
  __typename?: 'pii_statistics_stddev_samp_fields';
  /** Total number of data brokers covered by the plan */
  db_covered?: Maybe<Scalars['Float']>;
  /** Total profiles found exposed */
  exposed?: Maybe<Scalars['Float']>;
  /** Total removals in progress */
  removals_in_progress?: Maybe<Scalars['Float']>;
  /** Total removals pending */
  removals_pending?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "pii_statistics" */
export type Pii_Statistics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pii_Statistics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pii_Statistics_Stream_Cursor_Value_Input = {
  /** Record creation timestamp */
  created_at?: InputMaybe<Scalars['timestamp']>;
  date?: InputMaybe<Scalars['date']>;
  /** Total number of data brokers covered by the plan */
  db_covered?: InputMaybe<Scalars['Int']>;
  /** Total profiles found exposed */
  exposed?: InputMaybe<Scalars['Int']>;
  /** Auto-generated unique identifier */
  id?: InputMaybe<Scalars['uuid']>;
  /** Total removals in progress */
  removals_in_progress?: InputMaybe<Scalars['Int']>;
  /** Total removals pending */
  removals_pending?: InputMaybe<Scalars['Int']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: InputMaybe<Scalars['Int']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: InputMaybe<Scalars['Int']>;
  /** User identifier, foreign key to users.id */
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Pii_Statistics_Sum_Fields = {
  __typename?: 'pii_statistics_sum_fields';
  /** Total number of data brokers covered by the plan */
  db_covered?: Maybe<Scalars['Int']>;
  /** Total profiles found exposed */
  exposed?: Maybe<Scalars['Int']>;
  /** Total removals in progress */
  removals_in_progress?: Maybe<Scalars['Int']>;
  /** Total removals pending */
  removals_pending?: Maybe<Scalars['Int']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: Maybe<Scalars['Int']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: Maybe<Scalars['Int']>;
};

/** update columns of table "pii_statistics" */
export enum Pii_Statistics_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  DbCovered = 'db_covered',
  /** column name */
  Exposed = 'exposed',
  /** column name */
  Id = 'id',
  /** column name */
  RemovalsInProgress = 'removals_in_progress',
  /** column name */
  RemovalsPending = 'removals_pending',
  /** column name */
  RemovedNotFound = 'removed_not_found',
  /** column name */
  TotalRemovedNotFound = 'total_removed_not_found',
  /** column name */
  UserId = 'user_id'
}

export type Pii_Statistics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Pii_Statistics_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pii_Statistics_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pii_Statistics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Pii_Statistics_Var_Pop_Fields = {
  __typename?: 'pii_statistics_var_pop_fields';
  /** Total number of data brokers covered by the plan */
  db_covered?: Maybe<Scalars['Float']>;
  /** Total profiles found exposed */
  exposed?: Maybe<Scalars['Float']>;
  /** Total removals in progress */
  removals_in_progress?: Maybe<Scalars['Float']>;
  /** Total removals pending */
  removals_pending?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pii_Statistics_Var_Samp_Fields = {
  __typename?: 'pii_statistics_var_samp_fields';
  /** Total number of data brokers covered by the plan */
  db_covered?: Maybe<Scalars['Float']>;
  /** Total profiles found exposed */
  exposed?: Maybe<Scalars['Float']>;
  /** Total removals in progress */
  removals_in_progress?: Maybe<Scalars['Float']>;
  /** Total removals pending */
  removals_pending?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pii_Statistics_Variance_Fields = {
  __typename?: 'pii_statistics_variance_fields';
  /** Total number of data brokers covered by the plan */
  db_covered?: Maybe<Scalars['Float']>;
  /** Total profiles found exposed */
  exposed?: Maybe<Scalars['Float']>;
  /** Total removals in progress */
  removals_in_progress?: Maybe<Scalars['Float']>;
  /** Total removals pending */
  removals_pending?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, only databrokers that are in plan */
  removed_not_found?: Maybe<Scalars['Float']>;
  /** Total profiles removed / not found, including databrokers that are not in plan */
  total_removed_not_found?: Maybe<Scalars['Float']>;
};

/** list of all platform subtypes; rows determine the associated platform, archetype, and product as well */
export type Platform_Subtypes = {
  __typename?: 'platform_subtypes';
  archetype: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  platform: Scalars['String'];
  product: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "platform_subtypes" */
export type Platform_Subtypes_Aggregate = {
  __typename?: 'platform_subtypes_aggregate';
  aggregate?: Maybe<Platform_Subtypes_Aggregate_Fields>;
  nodes: Array<Platform_Subtypes>;
};

/** aggregate fields of "platform_subtypes" */
export type Platform_Subtypes_Aggregate_Fields = {
  __typename?: 'platform_subtypes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Platform_Subtypes_Max_Fields>;
  min?: Maybe<Platform_Subtypes_Min_Fields>;
};


/** aggregate fields of "platform_subtypes" */
export type Platform_Subtypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Platform_Subtypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "platform_subtypes". All fields are combined with a logical 'AND'. */
export type Platform_Subtypes_Bool_Exp = {
  _and?: InputMaybe<Array<Platform_Subtypes_Bool_Exp>>;
  _not?: InputMaybe<Platform_Subtypes_Bool_Exp>;
  _or?: InputMaybe<Array<Platform_Subtypes_Bool_Exp>>;
  archetype?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "platform_subtypes" */
export enum Platform_Subtypes_Constraint {
  /** unique or primary key constraint on columns "name" */
  PlatformSubtypesNameKey = 'platform_subtypes_name_key',
  /** unique or primary key constraint on columns "id" */
  PlatformSubtypesPkey = 'platform_subtypes_pkey'
}

/** input type for inserting data into table "platform_subtypes" */
export type Platform_Subtypes_Insert_Input = {
  archetype?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Platform_Subtypes_Max_Fields = {
  __typename?: 'platform_subtypes_max_fields';
  archetype?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Platform_Subtypes_Min_Fields = {
  __typename?: 'platform_subtypes_min_fields';
  archetype?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "platform_subtypes" */
export type Platform_Subtypes_Mutation_Response = {
  __typename?: 'platform_subtypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Platform_Subtypes>;
};

/** input type for inserting object relation for remote table "platform_subtypes" */
export type Platform_Subtypes_Obj_Rel_Insert_Input = {
  data: Platform_Subtypes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Platform_Subtypes_On_Conflict>;
};

/** on_conflict condition type for table "platform_subtypes" */
export type Platform_Subtypes_On_Conflict = {
  constraint: Platform_Subtypes_Constraint;
  update_columns?: Array<Platform_Subtypes_Update_Column>;
  where?: InputMaybe<Platform_Subtypes_Bool_Exp>;
};

/** Ordering options when selecting data from "platform_subtypes". */
export type Platform_Subtypes_Order_By = {
  archetype?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: platform_subtypes */
export type Platform_Subtypes_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "platform_subtypes" */
export enum Platform_Subtypes_Select_Column {
  /** column name */
  Archetype = 'archetype',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  Product = 'product',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "platform_subtypes" */
export type Platform_Subtypes_Set_Input = {
  archetype?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "platform_subtypes" */
export type Platform_Subtypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Platform_Subtypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Platform_Subtypes_Stream_Cursor_Value_Input = {
  archetype?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "platform_subtypes" */
export enum Platform_Subtypes_Update_Column {
  /** column name */
  Archetype = 'archetype',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  Product = 'product',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Platform_Subtypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Platform_Subtypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Platform_Subtypes_Bool_Exp;
};

/** Boolean expression to compare columns of type "platform_type". All fields are combined with logical 'AND'. */
export type Platform_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['platform_type']>;
  _gt?: InputMaybe<Scalars['platform_type']>;
  _gte?: InputMaybe<Scalars['platform_type']>;
  _in?: InputMaybe<Array<Scalars['platform_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['platform_type']>;
  _lte?: InputMaybe<Scalars['platform_type']>;
  _neq?: InputMaybe<Scalars['platform_type']>;
  _nin?: InputMaybe<Array<Scalars['platform_type']>>;
};

/** columns and relationships of "platforms" */
export type Platforms = {
  __typename?: 'platforms';
  created_at: Scalars['timestamptz'];
  /** helps get correct product type for custom url paths i.e. facebook.com/marketplace should be product type eommerce and not social media */
  custom_urls_to_product?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  platform_domains: Scalars['jsonb'];
  product: Scalars['platform_type'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "platforms" */
export type PlatformsCustom_Urls_To_ProductArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platforms" */
export type PlatformsPlatform_DomainsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "platforms" */
export type Platforms_Aggregate = {
  __typename?: 'platforms_aggregate';
  aggregate?: Maybe<Platforms_Aggregate_Fields>;
  nodes: Array<Platforms>;
};

/** aggregate fields of "platforms" */
export type Platforms_Aggregate_Fields = {
  __typename?: 'platforms_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Platforms_Max_Fields>;
  min?: Maybe<Platforms_Min_Fields>;
};


/** aggregate fields of "platforms" */
export type Platforms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Platforms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Platforms_Append_Input = {
  /** helps get correct product type for custom url paths i.e. facebook.com/marketplace should be product type eommerce and not social media */
  custom_urls_to_product?: InputMaybe<Scalars['jsonb']>;
  platform_domains?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "platforms". All fields are combined with a logical 'AND'. */
export type Platforms_Bool_Exp = {
  _and?: InputMaybe<Array<Platforms_Bool_Exp>>;
  _not?: InputMaybe<Platforms_Bool_Exp>;
  _or?: InputMaybe<Array<Platforms_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_urls_to_product?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  platform_domains?: InputMaybe<Jsonb_Comparison_Exp>;
  product?: InputMaybe<Platform_Type_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "platforms" */
export enum Platforms_Constraint {
  /** unique or primary key constraint on columns "name" */
  PlatformsNameKey = 'platforms_name_key',
  /** unique or primary key constraint on columns "name" */
  PlatformsPkey = 'platforms_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Platforms_Delete_At_Path_Input = {
  /** helps get correct product type for custom url paths i.e. facebook.com/marketplace should be product type eommerce and not social media */
  custom_urls_to_product?: InputMaybe<Array<Scalars['String']>>;
  platform_domains?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Platforms_Delete_Elem_Input = {
  /** helps get correct product type for custom url paths i.e. facebook.com/marketplace should be product type eommerce and not social media */
  custom_urls_to_product?: InputMaybe<Scalars['Int']>;
  platform_domains?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Platforms_Delete_Key_Input = {
  /** helps get correct product type for custom url paths i.e. facebook.com/marketplace should be product type eommerce and not social media */
  custom_urls_to_product?: InputMaybe<Scalars['String']>;
  platform_domains?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "platforms" */
export type Platforms_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** helps get correct product type for custom url paths i.e. facebook.com/marketplace should be product type eommerce and not social media */
  custom_urls_to_product?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  platform_domains?: InputMaybe<Scalars['jsonb']>;
  product?: InputMaybe<Scalars['platform_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Platforms_Max_Fields = {
  __typename?: 'platforms_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['platform_type']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Platforms_Min_Fields = {
  __typename?: 'platforms_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['platform_type']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "platforms" */
export type Platforms_Mutation_Response = {
  __typename?: 'platforms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Platforms>;
};

/** input type for inserting object relation for remote table "platforms" */
export type Platforms_Obj_Rel_Insert_Input = {
  data: Platforms_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Platforms_On_Conflict>;
};

/** on_conflict condition type for table "platforms" */
export type Platforms_On_Conflict = {
  constraint: Platforms_Constraint;
  update_columns?: Array<Platforms_Update_Column>;
  where?: InputMaybe<Platforms_Bool_Exp>;
};

/** Ordering options when selecting data from "platforms". */
export type Platforms_Order_By = {
  created_at?: InputMaybe<Order_By>;
  custom_urls_to_product?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform_domains?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: platforms */
export type Platforms_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Platforms_Prepend_Input = {
  /** helps get correct product type for custom url paths i.e. facebook.com/marketplace should be product type eommerce and not social media */
  custom_urls_to_product?: InputMaybe<Scalars['jsonb']>;
  platform_domains?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "platforms" */
export enum Platforms_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomUrlsToProduct = 'custom_urls_to_product',
  /** column name */
  Name = 'name',
  /** column name */
  PlatformDomains = 'platform_domains',
  /** column name */
  Product = 'product',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "platforms" */
export type Platforms_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** helps get correct product type for custom url paths i.e. facebook.com/marketplace should be product type eommerce and not social media */
  custom_urls_to_product?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  platform_domains?: InputMaybe<Scalars['jsonb']>;
  product?: InputMaybe<Scalars['platform_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "platforms" */
export type Platforms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Platforms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Platforms_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  /** helps get correct product type for custom url paths i.e. facebook.com/marketplace should be product type eommerce and not social media */
  custom_urls_to_product?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  platform_domains?: InputMaybe<Scalars['jsonb']>;
  product?: InputMaybe<Scalars['platform_type']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "platforms" */
export enum Platforms_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomUrlsToProduct = 'custom_urls_to_product',
  /** column name */
  Name = 'name',
  /** column name */
  PlatformDomains = 'platform_domains',
  /** column name */
  Product = 'product',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Platforms_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Platforms_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Platforms_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Platforms_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Platforms_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Platforms_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Platforms_Set_Input>;
  /** filter the rows which have to be updated */
  where: Platforms_Bool_Exp;
};

/** columns and relationships of "pre_collections" */
export type Pre_Collections = {
  __typename?: 'pre_collections';
  api_collection_id: Scalars['String'];
  banner_image_url?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  organization_id: Scalars['uuid'];
};

/** aggregated selection of "pre_collections" */
export type Pre_Collections_Aggregate = {
  __typename?: 'pre_collections_aggregate';
  aggregate?: Maybe<Pre_Collections_Aggregate_Fields>;
  nodes: Array<Pre_Collections>;
};

/** aggregate fields of "pre_collections" */
export type Pre_Collections_Aggregate_Fields = {
  __typename?: 'pre_collections_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Pre_Collections_Max_Fields>;
  min?: Maybe<Pre_Collections_Min_Fields>;
};


/** aggregate fields of "pre_collections" */
export type Pre_Collections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pre_Collections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "pre_collections". All fields are combined with a logical 'AND'. */
export type Pre_Collections_Bool_Exp = {
  _and?: InputMaybe<Array<Pre_Collections_Bool_Exp>>;
  _not?: InputMaybe<Pre_Collections_Bool_Exp>;
  _or?: InputMaybe<Array<Pre_Collections_Bool_Exp>>;
  api_collection_id?: InputMaybe<String_Comparison_Exp>;
  banner_image_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "pre_collections" */
export enum Pre_Collections_Constraint {
  /** unique or primary key constraint on columns "api_collection_id", "organization_id" */
  PreCollectionsApiCollectionIdOrganizationIdKey = 'pre_collections_api_collection_id_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  PreCollectionsPkey = 'pre_collections_pkey'
}

/** input type for inserting data into table "pre_collections" */
export type Pre_Collections_Insert_Input = {
  api_collection_id?: InputMaybe<Scalars['String']>;
  banner_image_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Pre_Collections_Max_Fields = {
  __typename?: 'pre_collections_max_fields';
  api_collection_id?: Maybe<Scalars['String']>;
  banner_image_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Pre_Collections_Min_Fields = {
  __typename?: 'pre_collections_min_fields';
  api_collection_id?: Maybe<Scalars['String']>;
  banner_image_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "pre_collections" */
export type Pre_Collections_Mutation_Response = {
  __typename?: 'pre_collections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pre_Collections>;
};

/** on_conflict condition type for table "pre_collections" */
export type Pre_Collections_On_Conflict = {
  constraint: Pre_Collections_Constraint;
  update_columns?: Array<Pre_Collections_Update_Column>;
  where?: InputMaybe<Pre_Collections_Bool_Exp>;
};

/** Ordering options when selecting data from "pre_collections". */
export type Pre_Collections_Order_By = {
  api_collection_id?: InputMaybe<Order_By>;
  banner_image_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pre_collections */
export type Pre_Collections_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "pre_collections" */
export enum Pre_Collections_Select_Column {
  /** column name */
  ApiCollectionId = 'api_collection_id',
  /** column name */
  BannerImageUrl = 'banner_image_url',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  OrganizationId = 'organization_id'
}

/** input type for updating data in table "pre_collections" */
export type Pre_Collections_Set_Input = {
  api_collection_id?: InputMaybe<Scalars['String']>;
  banner_image_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "pre_collections" */
export type Pre_Collections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pre_Collections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pre_Collections_Stream_Cursor_Value_Input = {
  api_collection_id?: InputMaybe<Scalars['String']>;
  banner_image_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "pre_collections" */
export enum Pre_Collections_Update_Column {
  /** column name */
  ApiCollectionId = 'api_collection_id',
  /** column name */
  BannerImageUrl = 'banner_image_url',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  OrganizationId = 'organization_id'
}

export type Pre_Collections_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pre_Collections_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pre_Collections_Bool_Exp;
};

/** Predicted enforcement types for alerts in DR */
export type Predicted_Enforcement_Types = {
  __typename?: 'predicted_enforcement_types';
  alert_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  llm_decision_reason: Scalars['String'];
  llm_invocation: Scalars['uuid'];
  match_id: Scalars['uuid'];
  predicted_enforcement_type: Scalars['String'];
  /** An object relationship */
  spoof_match: Spoof_Matches;
  /** An object relationship */
  spoofing_report: Spoofing_Reports;
};

/** aggregated selection of "predicted_enforcement_types" */
export type Predicted_Enforcement_Types_Aggregate = {
  __typename?: 'predicted_enforcement_types_aggregate';
  aggregate?: Maybe<Predicted_Enforcement_Types_Aggregate_Fields>;
  nodes: Array<Predicted_Enforcement_Types>;
};

/** aggregate fields of "predicted_enforcement_types" */
export type Predicted_Enforcement_Types_Aggregate_Fields = {
  __typename?: 'predicted_enforcement_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Predicted_Enforcement_Types_Max_Fields>;
  min?: Maybe<Predicted_Enforcement_Types_Min_Fields>;
};


/** aggregate fields of "predicted_enforcement_types" */
export type Predicted_Enforcement_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Predicted_Enforcement_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "predicted_enforcement_types". All fields are combined with a logical 'AND'. */
export type Predicted_Enforcement_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Predicted_Enforcement_Types_Bool_Exp>>;
  _not?: InputMaybe<Predicted_Enforcement_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Predicted_Enforcement_Types_Bool_Exp>>;
  alert_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  llm_decision_reason?: InputMaybe<String_Comparison_Exp>;
  llm_invocation?: InputMaybe<Uuid_Comparison_Exp>;
  match_id?: InputMaybe<Uuid_Comparison_Exp>;
  predicted_enforcement_type?: InputMaybe<String_Comparison_Exp>;
  spoof_match?: InputMaybe<Spoof_Matches_Bool_Exp>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};

/** unique or primary key constraints on table "predicted_enforcement_types" */
export enum Predicted_Enforcement_Types_Constraint {
  /** unique or primary key constraint on columns "id" */
  PredictedEnforcementTypesPkey = 'predicted_enforcement_types_pkey'
}

/** input type for inserting data into table "predicted_enforcement_types" */
export type Predicted_Enforcement_Types_Insert_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_decision_reason?: InputMaybe<Scalars['String']>;
  llm_invocation?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  predicted_enforcement_type?: InputMaybe<Scalars['String']>;
  spoof_match?: InputMaybe<Spoof_Matches_Obj_Rel_Insert_Input>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Predicted_Enforcement_Types_Max_Fields = {
  __typename?: 'predicted_enforcement_types_max_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_decision_reason?: Maybe<Scalars['String']>;
  llm_invocation?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  predicted_enforcement_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Predicted_Enforcement_Types_Min_Fields = {
  __typename?: 'predicted_enforcement_types_min_fields';
  alert_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  llm_decision_reason?: Maybe<Scalars['String']>;
  llm_invocation?: Maybe<Scalars['uuid']>;
  match_id?: Maybe<Scalars['uuid']>;
  predicted_enforcement_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "predicted_enforcement_types" */
export type Predicted_Enforcement_Types_Mutation_Response = {
  __typename?: 'predicted_enforcement_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Predicted_Enforcement_Types>;
};

/** on_conflict condition type for table "predicted_enforcement_types" */
export type Predicted_Enforcement_Types_On_Conflict = {
  constraint: Predicted_Enforcement_Types_Constraint;
  update_columns?: Array<Predicted_Enforcement_Types_Update_Column>;
  where?: InputMaybe<Predicted_Enforcement_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "predicted_enforcement_types". */
export type Predicted_Enforcement_Types_Order_By = {
  alert_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llm_decision_reason?: InputMaybe<Order_By>;
  llm_invocation?: InputMaybe<Order_By>;
  match_id?: InputMaybe<Order_By>;
  predicted_enforcement_type?: InputMaybe<Order_By>;
  spoof_match?: InputMaybe<Spoof_Matches_Order_By>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Order_By>;
};

/** primary key columns input for table: predicted_enforcement_types */
export type Predicted_Enforcement_Types_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "predicted_enforcement_types" */
export enum Predicted_Enforcement_Types_Select_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LlmDecisionReason = 'llm_decision_reason',
  /** column name */
  LlmInvocation = 'llm_invocation',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  PredictedEnforcementType = 'predicted_enforcement_type'
}

/** input type for updating data in table "predicted_enforcement_types" */
export type Predicted_Enforcement_Types_Set_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_decision_reason?: InputMaybe<Scalars['String']>;
  llm_invocation?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  predicted_enforcement_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "predicted_enforcement_types" */
export type Predicted_Enforcement_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Predicted_Enforcement_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Predicted_Enforcement_Types_Stream_Cursor_Value_Input = {
  alert_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_decision_reason?: InputMaybe<Scalars['String']>;
  llm_invocation?: InputMaybe<Scalars['uuid']>;
  match_id?: InputMaybe<Scalars['uuid']>;
  predicted_enforcement_type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "predicted_enforcement_types" */
export enum Predicted_Enforcement_Types_Update_Column {
  /** column name */
  AlertId = 'alert_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LlmDecisionReason = 'llm_decision_reason',
  /** column name */
  LlmInvocation = 'llm_invocation',
  /** column name */
  MatchId = 'match_id',
  /** column name */
  PredictedEnforcementType = 'predicted_enforcement_type'
}

export type Predicted_Enforcement_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Predicted_Enforcement_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Predicted_Enforcement_Types_Bool_Exp;
};

/** customer assets (domains, social media, etc) that need to be protected. each spoofing entity (brand) will have many */
export type Protected_Assets = {
  __typename?: 'protected_assets';
  auto_send_high_url_match_to_dr: Scalars['Boolean'];
  /** An object relationship */
  brand: Spoofing_Entities;
  created_at: Scalars['timestamp'];
  /** An object relationship */
  full_url?: Maybe<Full_Urls>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** used for marking generic domains, so we can process them a little bit differently vs normal domains */
  is_generic?: Maybe<Scalars['Boolean']>;
  is_primary: Scalars['Boolean'];
  /** An object relationship */
  last_updated_by_user?: Maybe<Users>;
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  mobile_app?: Maybe<Mobile_Apps>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  original_entity_id: Scalars['uuid'];
  /** An object relationship */
  platform?: Maybe<Platforms>;
  platform_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  platform_subtype?: Maybe<Platform_Subtypes>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  should_monitor?: Maybe<Scalars['Boolean']>;
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: Maybe<Scalars['Int']>;
  /** An object relationship */
  social_media?: Maybe<Social_Media_Data>;
  social_media_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "protected_assets" */
export type Protected_Assets_Aggregate = {
  __typename?: 'protected_assets_aggregate';
  aggregate?: Maybe<Protected_Assets_Aggregate_Fields>;
  nodes: Array<Protected_Assets>;
};

export type Protected_Assets_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Protected_Assets_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Protected_Assets_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Protected_Assets_Aggregate_Bool_Exp_Count>;
};

export type Protected_Assets_Aggregate_Bool_Exp_Bool_And = {
  arguments: Protected_Assets_Select_Column_Protected_Assets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Protected_Assets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Protected_Assets_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Protected_Assets_Select_Column_Protected_Assets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Protected_Assets_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Protected_Assets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Protected_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Protected_Assets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "protected_assets" */
export type Protected_Assets_Aggregate_Fields = {
  __typename?: 'protected_assets_aggregate_fields';
  avg?: Maybe<Protected_Assets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Protected_Assets_Max_Fields>;
  min?: Maybe<Protected_Assets_Min_Fields>;
  stddev?: Maybe<Protected_Assets_Stddev_Fields>;
  stddev_pop?: Maybe<Protected_Assets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Protected_Assets_Stddev_Samp_Fields>;
  sum?: Maybe<Protected_Assets_Sum_Fields>;
  var_pop?: Maybe<Protected_Assets_Var_Pop_Fields>;
  var_samp?: Maybe<Protected_Assets_Var_Samp_Fields>;
  variance?: Maybe<Protected_Assets_Variance_Fields>;
};


/** aggregate fields of "protected_assets" */
export type Protected_Assets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Protected_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "protected_assets" */
export type Protected_Assets_Aggregate_Order_By = {
  avg?: InputMaybe<Protected_Assets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Protected_Assets_Max_Order_By>;
  min?: InputMaybe<Protected_Assets_Min_Order_By>;
  stddev?: InputMaybe<Protected_Assets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Protected_Assets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Protected_Assets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Protected_Assets_Sum_Order_By>;
  var_pop?: InputMaybe<Protected_Assets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Protected_Assets_Var_Samp_Order_By>;
  variance?: InputMaybe<Protected_Assets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "protected_assets" */
export type Protected_Assets_Arr_Rel_Insert_Input = {
  data: Array<Protected_Assets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Protected_Assets_On_Conflict>;
};

/** aggregate avg on columns */
export type Protected_Assets_Avg_Fields = {
  __typename?: 'protected_assets_avg_fields';
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "protected_assets" */
export type Protected_Assets_Avg_Order_By = {
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "protected_assets". All fields are combined with a logical 'AND'. */
export type Protected_Assets_Bool_Exp = {
  _and?: InputMaybe<Array<Protected_Assets_Bool_Exp>>;
  _not?: InputMaybe<Protected_Assets_Bool_Exp>;
  _or?: InputMaybe<Array<Protected_Assets_Bool_Exp>>;
  auto_send_high_url_match_to_dr?: InputMaybe<Boolean_Comparison_Exp>;
  brand?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  full_url?: InputMaybe<Full_Urls_Bool_Exp>;
  full_url_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_generic?: InputMaybe<Boolean_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  last_updated_by_user?: InputMaybe<Users_Bool_Exp>;
  last_updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  mobile_app?: InputMaybe<Mobile_Apps_Bool_Exp>;
  mobile_app_id?: InputMaybe<Uuid_Comparison_Exp>;
  original_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  platform?: InputMaybe<Platforms_Bool_Exp>;
  platform_name?: InputMaybe<String_Comparison_Exp>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Bool_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  should_monitor?: InputMaybe<Boolean_Comparison_Exp>;
  similarity_threshold?: InputMaybe<Int_Comparison_Exp>;
  social_media?: InputMaybe<Social_Media_Data_Bool_Exp>;
  social_media_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "protected_assets" */
export enum Protected_Assets_Constraint {
  /** unique or primary key constraint on columns "original_entity_id" */
  IdxUniquePrimaryDomainProtectedAssetPerEntity = 'idx_unique_primary_domain_protected_asset_per_entity',
  /** unique or primary key constraint on columns "full_url_id", "original_entity_id" */
  ProtectedAssetsOriginalEntityIdFullUrlIdKey = 'protected_assets_original_entity_id_full_url_id_key',
  /** unique or primary key constraint on columns "mobile_app_id", "original_entity_id" */
  ProtectedAssetsOriginalEntityIdMobileAppIdKey = 'protected_assets_original_entity_id_mobile_app_id_key',
  /** unique or primary key constraint on columns "social_media_id", "original_entity_id" */
  ProtectedAssetsOriginalEntityIdSocialMediaIdKey = 'protected_assets_original_entity_id_social_media_id_key',
  /** unique or primary key constraint on columns "value", "original_entity_id" */
  ProtectedAssetsOriginalEntityIdValueKey = 'protected_assets_original_entity_id_value_key',
  /** unique or primary key constraint on columns "id" */
  ProtectedAssetsPkey = 'protected_assets_pkey'
}

/** input type for incrementing numeric columns in table "protected_assets" */
export type Protected_Assets_Inc_Input = {
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "protected_assets" */
export type Protected_Assets_Insert_Input = {
  auto_send_high_url_match_to_dr?: InputMaybe<Scalars['Boolean']>;
  brand?: InputMaybe<Spoofing_Entities_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  full_url?: InputMaybe<Full_Urls_Obj_Rel_Insert_Input>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** used for marking generic domains, so we can process them a little bit differently vs normal domains */
  is_generic?: InputMaybe<Scalars['Boolean']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  last_updated_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  mobile_app?: InputMaybe<Mobile_Apps_Obj_Rel_Insert_Input>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Platforms_Obj_Rel_Insert_Input>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Obj_Rel_Insert_Input>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  should_monitor?: InputMaybe<Scalars['Boolean']>;
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Scalars['Int']>;
  social_media?: InputMaybe<Social_Media_Data_Obj_Rel_Insert_Input>;
  social_media_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Protected_Assets_Max_Fields = {
  __typename?: 'protected_assets_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: Maybe<Scalars['Int']>;
  social_media_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "protected_assets" */
export type Protected_Assets_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  full_url_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_by_user_id?: InputMaybe<Order_By>;
  mobile_app_id?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Order_By>;
  social_media_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Protected_Assets_Min_Fields = {
  __typename?: 'protected_assets_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: Maybe<Scalars['Int']>;
  social_media_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "protected_assets" */
export type Protected_Assets_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  full_url_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_by_user_id?: InputMaybe<Order_By>;
  mobile_app_id?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Order_By>;
  social_media_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "protected_assets" */
export type Protected_Assets_Mutation_Response = {
  __typename?: 'protected_assets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Protected_Assets>;
};

/** input type for inserting object relation for remote table "protected_assets" */
export type Protected_Assets_Obj_Rel_Insert_Input = {
  data: Protected_Assets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Protected_Assets_On_Conflict>;
};

/** on_conflict condition type for table "protected_assets" */
export type Protected_Assets_On_Conflict = {
  constraint: Protected_Assets_Constraint;
  update_columns?: Array<Protected_Assets_Update_Column>;
  where?: InputMaybe<Protected_Assets_Bool_Exp>;
};

/** Ordering options when selecting data from "protected_assets". */
export type Protected_Assets_Order_By = {
  auto_send_high_url_match_to_dr?: InputMaybe<Order_By>;
  brand?: InputMaybe<Spoofing_Entities_Order_By>;
  created_at?: InputMaybe<Order_By>;
  full_url?: InputMaybe<Full_Urls_Order_By>;
  full_url_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_generic?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  last_updated_by_user?: InputMaybe<Users_Order_By>;
  last_updated_by_user_id?: InputMaybe<Order_By>;
  mobile_app?: InputMaybe<Mobile_Apps_Order_By>;
  mobile_app_id?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Platforms_Order_By>;
  platform_name?: InputMaybe<Order_By>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  should_monitor?: InputMaybe<Order_By>;
  similarity_threshold?: InputMaybe<Order_By>;
  social_media?: InputMaybe<Social_Media_Data_Order_By>;
  social_media_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: protected_assets */
export type Protected_Assets_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "protected_assets" */
export enum Protected_Assets_Select_Column {
  /** column name */
  AutoSendHighUrlMatchToDr = 'auto_send_high_url_match_to_dr',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FullUrlId = 'full_url_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsGeneric = 'is_generic',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  LastUpdatedByUserId = 'last_updated_by_user_id',
  /** column name */
  MobileAppId = 'mobile_app_id',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  ShouldMonitor = 'should_monitor',
  /** column name */
  SimilarityThreshold = 'similarity_threshold',
  /** column name */
  SocialMediaId = 'social_media_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

/** select "protected_assets_aggregate_bool_exp_bool_and_arguments_columns" columns of table "protected_assets" */
export enum Protected_Assets_Select_Column_Protected_Assets_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AutoSendHighUrlMatchToDr = 'auto_send_high_url_match_to_dr',
  /** column name */
  IsGeneric = 'is_generic',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  ShouldMonitor = 'should_monitor'
}

/** select "protected_assets_aggregate_bool_exp_bool_or_arguments_columns" columns of table "protected_assets" */
export enum Protected_Assets_Select_Column_Protected_Assets_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AutoSendHighUrlMatchToDr = 'auto_send_high_url_match_to_dr',
  /** column name */
  IsGeneric = 'is_generic',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  ShouldMonitor = 'should_monitor'
}

/** input type for updating data in table "protected_assets" */
export type Protected_Assets_Set_Input = {
  auto_send_high_url_match_to_dr?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** used for marking generic domains, so we can process them a little bit differently vs normal domains */
  is_generic?: InputMaybe<Scalars['Boolean']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  should_monitor?: InputMaybe<Scalars['Boolean']>;
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Scalars['Int']>;
  social_media_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Protected_Assets_Stddev_Fields = {
  __typename?: 'protected_assets_stddev_fields';
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "protected_assets" */
export type Protected_Assets_Stddev_Order_By = {
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Protected_Assets_Stddev_Pop_Fields = {
  __typename?: 'protected_assets_stddev_pop_fields';
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "protected_assets" */
export type Protected_Assets_Stddev_Pop_Order_By = {
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Protected_Assets_Stddev_Samp_Fields = {
  __typename?: 'protected_assets_stddev_samp_fields';
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "protected_assets" */
export type Protected_Assets_Stddev_Samp_Order_By = {
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "protected_assets" */
export type Protected_Assets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Protected_Assets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Protected_Assets_Stream_Cursor_Value_Input = {
  auto_send_high_url_match_to_dr?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** used for marking generic domains, so we can process them a little bit differently vs normal domains */
  is_generic?: InputMaybe<Scalars['Boolean']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  should_monitor?: InputMaybe<Scalars['Boolean']>;
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Scalars['Int']>;
  social_media_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Protected_Assets_Sum_Fields = {
  __typename?: 'protected_assets_sum_fields';
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "protected_assets" */
export type Protected_Assets_Sum_Order_By = {
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Order_By>;
};

/** update columns of table "protected_assets" */
export enum Protected_Assets_Update_Column {
  /** column name */
  AutoSendHighUrlMatchToDr = 'auto_send_high_url_match_to_dr',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FullUrlId = 'full_url_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsGeneric = 'is_generic',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  LastUpdatedByUserId = 'last_updated_by_user_id',
  /** column name */
  MobileAppId = 'mobile_app_id',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  ShouldMonitor = 'should_monitor',
  /** column name */
  SimilarityThreshold = 'similarity_threshold',
  /** column name */
  SocialMediaId = 'social_media_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type Protected_Assets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Protected_Assets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Protected_Assets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Protected_Assets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Protected_Assets_Var_Pop_Fields = {
  __typename?: 'protected_assets_var_pop_fields';
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "protected_assets" */
export type Protected_Assets_Var_Pop_Order_By = {
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Protected_Assets_Var_Samp_Fields = {
  __typename?: 'protected_assets_var_samp_fields';
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "protected_assets" */
export type Protected_Assets_Var_Samp_Order_By = {
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Protected_Assets_Variance_Fields = {
  __typename?: 'protected_assets_variance_fields';
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "protected_assets" */
export type Protected_Assets_Variance_Order_By = {
  /** number from 0 - 100 denoting the level of similarity a domain report must be to be classified */
  similarity_threshold?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "advertisement_data" */
  advertisement_data: Array<Advertisement_Data>;
  /** fetch aggregated fields from the table: "advertisement_data" */
  advertisement_data_aggregate: Advertisement_Data_Aggregate;
  /** fetch data from the table: "advertisement_data" using primary key columns */
  advertisement_data_by_pk?: Maybe<Advertisement_Data>;
  /** fetch data from the table: "advertiser_data" */
  advertiser_data: Array<Advertiser_Data>;
  /** fetch aggregated fields from the table: "advertiser_data" */
  advertiser_data_aggregate: Advertiser_Data_Aggregate;
  /** fetch data from the table: "advertiser_data" using primary key columns */
  advertiser_data_by_pk?: Maybe<Advertiser_Data>;
  /** fetch data from the table: "ai_prompts" */
  ai_prompts: Array<Ai_Prompts>;
  /** fetch aggregated fields from the table: "ai_prompts" */
  ai_prompts_aggregate: Ai_Prompts_Aggregate;
  /** fetch data from the table: "ai_prompts" using primary key columns */
  ai_prompts_by_pk?: Maybe<Ai_Prompts>;
  /** fetch data from the table: "ai_responses" */
  ai_responses: Array<Ai_Responses>;
  /** fetch aggregated fields from the table: "ai_responses" */
  ai_responses_aggregate: Ai_Responses_Aggregate;
  /** fetch data from the table: "ai_responses" using primary key columns */
  ai_responses_by_pk?: Maybe<Ai_Responses>;
  /** fetch data from the table: "alert_hashes" */
  alert_hashes: Array<Alert_Hashes>;
  /** fetch aggregated fields from the table: "alert_hashes" */
  alert_hashes_aggregate: Alert_Hashes_Aggregate;
  /** fetch data from the table: "alert_hashes" using primary key columns */
  alert_hashes_by_pk?: Maybe<Alert_Hashes>;
  /** fetch data from the table: "alert_label_events" */
  alert_label_events: Array<Alert_Label_Events>;
  /** fetch aggregated fields from the table: "alert_label_events" */
  alert_label_events_aggregate: Alert_Label_Events_Aggregate;
  /** fetch data from the table: "alert_label_events" using primary key columns */
  alert_label_events_by_pk?: Maybe<Alert_Label_Events>;
  /** An array relationship */
  alert_links: Array<Alert_Links>;
  /** An aggregate relationship */
  alert_links_aggregate: Alert_Links_Aggregate;
  /** fetch data from the table: "alert_links" using primary key columns */
  alert_links_by_pk?: Maybe<Alert_Links>;
  alerts_queue_state_count_by_product: Array<Alerts_Queue_State_Count_By_Product>;
  alerts_resolved_top_metrics: Array<Alerts_Resolved_Top_Metrics>;
  alerts_resolved_total_metrics: Array<Alerts_Resolved_Total_Metrics>;
  alerts_surfaced_top_metrics: Array<Alerts_Surfaced_Top_Metrics>;
  alerts_times_to_actioned_by_platform_metrics: Array<Alerts_Times_To_Actioned_By_Platform_Metrics>;
  alerts_times_to_actioned_graph_metrics: Array<Alerts_Times_To_Actioned_Graph_Metrics>;
  alerts_times_to_actioned_metrics: Array<Alerts_Times_To_Actioned_Metrics>;
  alerts_verified_top_metrics: Array<Alerts_Verified_Top_Metrics>;
  alerts_verified_total_metrics: Array<Alerts_Verified_Total_Metrics>;
  /** fetch data from the table: "api_tokens" */
  api_tokens: Array<Api_Tokens>;
  /** fetch aggregated fields from the table: "api_tokens" */
  api_tokens_aggregate: Api_Tokens_Aggregate;
  /** fetch data from the table: "api_tokens" using primary key columns */
  api_tokens_by_pk?: Maybe<Api_Tokens>;
  /** fetch data from the table: "api_usage_records" */
  api_usage_records: Array<Api_Usage_Records>;
  /** fetch aggregated fields from the table: "api_usage_records" */
  api_usage_records_aggregate: Api_Usage_Records_Aggregate;
  /** fetch data from the table: "api_usage_records" using primary key columns */
  api_usage_records_by_pk?: Maybe<Api_Usage_Records>;
  /** fetch data from the table: "apify_scraping_jobs" */
  apify_scraping_jobs: Array<Apify_Scraping_Jobs>;
  /** fetch aggregated fields from the table: "apify_scraping_jobs" */
  apify_scraping_jobs_aggregate: Apify_Scraping_Jobs_Aggregate;
  /** fetch data from the table: "apify_scraping_jobs" using primary key columns */
  apify_scraping_jobs_by_pk?: Maybe<Apify_Scraping_Jobs>;
  /** An array relationship */
  approvals: Array<Approvals>;
  /** An aggregate relationship */
  approvals_aggregate: Approvals_Aggregate;
  /** fetch data from the table: "approvals" using primary key columns */
  approvals_by_pk?: Maybe<Approvals>;
  /** fetch data from the table: "audit.logged_actions" */
  audit_logged_actions: Array<Audit_Logged_Actions>;
  /** fetch aggregated fields from the table: "audit.logged_actions" */
  audit_logged_actions_aggregate: Audit_Logged_Actions_Aggregate;
  /** fetch data from the table: "audit.logged_actions" using primary key columns */
  audit_logged_actions_by_pk?: Maybe<Audit_Logged_Actions>;
  /** An array relationship */
  collection_report_changes: Array<Collection_Report_Changes>;
  /** An aggregate relationship */
  collection_report_changes_aggregate: Collection_Report_Changes_Aggregate;
  /** fetch data from the table: "collection_report_changes" using primary key columns */
  collection_report_changes_by_pk?: Maybe<Collection_Report_Changes>;
  /** fetch data from the table: "collection_report_state_changes" */
  collection_report_state_changes: Array<Collection_Report_State_Changes>;
  /** fetch aggregated fields from the table: "collection_report_state_changes" */
  collection_report_state_changes_aggregate: Collection_Report_State_Changes_Aggregate;
  /** fetch data from the table: "collection_report_state_changes" using primary key columns */
  collection_report_state_changes_by_pk?: Maybe<Collection_Report_State_Changes>;
  /** fetch data from the table: "credit_cards" */
  credit_cards: Array<Credit_Cards>;
  /** fetch aggregated fields from the table: "credit_cards" */
  credit_cards_aggregate: Credit_Cards_Aggregate;
  /** fetch data from the table: "credit_cards" using primary key columns */
  credit_cards_by_pk?: Maybe<Credit_Cards>;
  /** fetch data from the table: "customer_assets" */
  customer_assets: Array<Customer_Assets>;
  /** fetch aggregated fields from the table: "customer_assets" */
  customer_assets_aggregate: Customer_Assets_Aggregate;
  /** fetch data from the table: "customer_assets" using primary key columns */
  customer_assets_by_pk?: Maybe<Customer_Assets>;
  /** An array relationship */
  customer_assets_to_brands: Array<Customer_Assets_To_Brands>;
  /** An aggregate relationship */
  customer_assets_to_brands_aggregate: Customer_Assets_To_Brands_Aggregate;
  /** fetch data from the table: "customer_assets_to_brands" using primary key columns */
  customer_assets_to_brands_by_pk?: Maybe<Customer_Assets_To_Brands>;
  /** fetch data from the table: "dark_web" */
  dark_web: Array<Dark_Web>;
  /** fetch aggregated fields from the table: "dark_web" */
  dark_web_aggregate: Dark_Web_Aggregate;
  dark_web_alerts_surfaced_top_metrics: Array<Dark_Web_Alerts_Surfaced_Top_Metrics>;
  /** fetch data from the table: "dark_web" using primary key columns */
  dark_web_by_pk?: Maybe<Dark_Web>;
  /** fetch data from the table: "defensive_domain_registration" */
  defensive_domain_registration: Array<Defensive_Domain_Registration>;
  /** fetch aggregated fields from the table: "defensive_domain_registration" */
  defensive_domain_registration_aggregate: Defensive_Domain_Registration_Aggregate;
  /** fetch data from the table: "defensive_domain_registration" using primary key columns */
  defensive_domain_registration_by_pk?: Maybe<Defensive_Domain_Registration>;
  /** An array relationship */
  designated_takedown_assets: Array<Designated_Takedown_Assets>;
  /** An aggregate relationship */
  designated_takedown_assets_aggregate: Designated_Takedown_Assets_Aggregate;
  /** fetch data from the table: "designated_takedown_assets" using primary key columns */
  designated_takedown_assets_by_pk?: Maybe<Designated_Takedown_Assets>;
  /** An array relationship */
  detection_assets: Array<Detection_Assets>;
  /** An aggregate relationship */
  detection_assets_aggregate: Detection_Assets_Aggregate;
  /** fetch data from the table: "detection_assets" using primary key columns */
  detection_assets_by_pk?: Maybe<Detection_Assets>;
  /** fetch data from the table: "detection_config_approvals" */
  detection_config_approvals: Array<Detection_Config_Approvals>;
  /** fetch aggregated fields from the table: "detection_config_approvals" */
  detection_config_approvals_aggregate: Detection_Config_Approvals_Aggregate;
  /** fetch data from the table: "detection_config_approvals" using primary key columns */
  detection_config_approvals_by_pk?: Maybe<Detection_Config_Approvals>;
  /** fetch data from the table: "domain_data" */
  domain_data: Array<Domain_Data>;
  /** fetch aggregated fields from the table: "domain_data" */
  domain_data_aggregate: Domain_Data_Aggregate;
  /** fetch data from the table: "domain_data" using primary key columns */
  domain_data_by_pk?: Maybe<Domain_Data>;
  /** fetch data from the table: "domain_match_data" */
  domain_match_data: Array<Domain_Match_Data>;
  /** fetch aggregated fields from the table: "domain_match_data" */
  domain_match_data_aggregate: Domain_Match_Data_Aggregate;
  /** fetch data from the table: "domain_match_data" using primary key columns */
  domain_match_data_by_pk?: Maybe<Domain_Match_Data>;
  /** fetch data from the table: "ecommerce_listings" */
  ecommerce_listings: Array<Ecommerce_Listings>;
  /** fetch aggregated fields from the table: "ecommerce_listings" */
  ecommerce_listings_aggregate: Ecommerce_Listings_Aggregate;
  /** fetch data from the table: "ecommerce_listings" using primary key columns */
  ecommerce_listings_by_pk?: Maybe<Ecommerce_Listings>;
  /** fetch data from the table: "email_addresses" */
  email_addresses: Array<Email_Addresses>;
  /** fetch aggregated fields from the table: "email_addresses" */
  email_addresses_aggregate: Email_Addresses_Aggregate;
  /** fetch data from the table: "email_addresses" using primary key columns */
  email_addresses_by_pk?: Maybe<Email_Addresses>;
  email_alerts_resolved_top_metrics: Array<Alerts_Resolved_Top_Metrics>;
  email_alerts_resolved_total_metrics: Array<Alerts_Resolved_Total_Metrics>;
  email_alerts_times_to_actioned_graph_metrics: Array<Alerts_Times_To_Actioned_Graph_Metrics>;
  email_alerts_times_to_actioned_metrics: Array<Alerts_Times_To_Actioned_Metrics>;
  /** fetch data from the table: "email_correspondence" */
  email_correspondence: Array<Email_Correspondence>;
  /** fetch aggregated fields from the table: "email_correspondence" */
  email_correspondence_aggregate: Email_Correspondence_Aggregate;
  /** fetch data from the table: "email_correspondence" using primary key columns */
  email_correspondence_by_pk?: Maybe<Email_Correspondence>;
  /** fetch data from the table: "email_settings" */
  email_settings: Array<Email_Settings>;
  /** fetch aggregated fields from the table: "email_settings" */
  email_settings_aggregate: Email_Settings_Aggregate;
  /** fetch data from the table: "email_settings" using primary key columns */
  email_settings_by_pk?: Maybe<Email_Settings>;
  /** fetch data from the table: "emails" */
  emails: Array<Emails>;
  /** fetch aggregated fields from the table: "emails" */
  emails_aggregate: Emails_Aggregate;
  /** fetch data from the table: "emails" using primary key columns */
  emails_by_pk?: Maybe<Emails>;
  /** fetch data from the table: "enforcement_emails" */
  enforcement_emails: Array<Enforcement_Emails>;
  /** fetch aggregated fields from the table: "enforcement_emails" */
  enforcement_emails_aggregate: Enforcement_Emails_Aggregate;
  /** fetch data from the table: "enforcement_emails" using primary key columns */
  enforcement_emails_by_pk?: Maybe<Enforcement_Emails>;
  /** fetch data from the table: "enforcement_metadata" */
  enforcement_metadata: Array<Enforcement_Metadata>;
  /** fetch aggregated fields from the table: "enforcement_metadata" */
  enforcement_metadata_aggregate: Enforcement_Metadata_Aggregate;
  /** fetch data from the table: "enforcement_metadata" using primary key columns */
  enforcement_metadata_by_pk?: Maybe<Enforcement_Metadata>;
  /** fetch data from the table: "enforcement_platforms" */
  enforcement_platforms: Array<Enforcement_Platforms>;
  /** fetch aggregated fields from the table: "enforcement_platforms" */
  enforcement_platforms_aggregate: Enforcement_Platforms_Aggregate;
  /** fetch data from the table: "enforcement_platforms" using primary key columns */
  enforcement_platforms_by_pk?: Maybe<Enforcement_Platforms>;
  /** An array relationship */
  enforcement_requests: Array<Enforcement_Requests>;
  /** An aggregate relationship */
  enforcement_requests_aggregate: Enforcement_Requests_Aggregate;
  /** fetch data from the table: "enforcement_requests" using primary key columns */
  enforcement_requests_by_pk?: Maybe<Enforcement_Requests>;
  /** fetch data from the table: "enforcement_templates" */
  enforcement_templates: Array<Enforcement_Templates>;
  /** fetch aggregated fields from the table: "enforcement_templates" */
  enforcement_templates_aggregate: Enforcement_Templates_Aggregate;
  /** fetch data from the table: "enforcement_templates" using primary key columns */
  enforcement_templates_by_pk?: Maybe<Enforcement_Templates>;
  /** fetch data from the table: "enforcement_types" */
  enforcement_types: Array<Enforcement_Types>;
  /** fetch aggregated fields from the table: "enforcement_types" */
  enforcement_types_aggregate: Enforcement_Types_Aggregate;
  /** fetch data from the table: "enforcement_types" using primary key columns */
  enforcement_types_by_pk?: Maybe<Enforcement_Types>;
  /** fetch data from the table: "entity_aggregates" */
  entity_aggregates: Array<Entity_Aggregates>;
  /** fetch aggregated fields from the table: "entity_aggregates" */
  entity_aggregates_aggregate: Entity_Aggregates_Aggregate;
  /** fetch data from the table: "entity_aggregates" using primary key columns */
  entity_aggregates_by_pk?: Maybe<Entity_Aggregates>;
  /** An array relationship */
  entity_data: Array<Entity_Data>;
  /** An aggregate relationship */
  entity_data_aggregate: Entity_Data_Aggregate;
  /** fetch data from the table: "entity_data" using primary key columns */
  entity_data_by_pk?: Maybe<Entity_Data>;
  /** fetch data from the table: "entity_links" */
  entity_links: Array<Entity_Links>;
  /** fetch aggregated fields from the table: "entity_links" */
  entity_links_aggregate: Entity_Links_Aggregate;
  /** fetch data from the table: "entity_links" using primary key columns */
  entity_links_by_pk?: Maybe<Entity_Links>;
  /** fetch data from the table: "entity_state_classifications" */
  entity_state_classifications: Array<Entity_State_Classifications>;
  /** fetch aggregated fields from the table: "entity_state_classifications" */
  entity_state_classifications_aggregate: Entity_State_Classifications_Aggregate;
  /** fetch data from the table: "entity_state_classifications" using primary key columns */
  entity_state_classifications_by_pk?: Maybe<Entity_State_Classifications>;
  /** An array relationship */
  full_urls: Array<Full_Urls>;
  /** An aggregate relationship */
  full_urls_aggregate: Full_Urls_Aggregate;
  /** fetch data from the table: "full_urls" using primary key columns */
  full_urls_by_pk?: Maybe<Full_Urls>;
  /** get_elasticsearch_fields */
  get_elasticsearch_fields: ElasticsearchFieldsOutput;
  get_gcs_object: ManageGcsObjectsOutput;
  get_pii_member?: Maybe<PiiGetMemberOutput>;
  /** execute function "get_pii_reports_with_screenshots" which returns "pii_reports" */
  get_pii_reports_with_screenshots: Array<Pii_Reports>;
  /** execute function "get_pii_reports_with_screenshots" and query aggregates on result of table type "pii_reports" */
  get_pii_reports_with_screenshots_aggregate: Pii_Reports_Aggregate;
  get_stats_data: GetStatsDataOutput;
  /** returns threat graph data for visualization (currently single-alert only) */
  get_threat_graph_data?: Maybe<GetThreatGraphDataOutput>;
  /** handle detection search */
  handle_detection_search: HandleDetectionSearchOutput;
  /** Async action for handle_synchronous_detection_request GCF (for long-running detection asset creation requests) */
  handle_synchronous_detection_request_async_action?: Maybe<Handle_Synchronous_Detection_Request_Async_Action>;
  /** fetch data from the table: "hourly_spoofing_reports_stats" */
  hourly_spoofing_reports_stats: Array<Hourly_Spoofing_Reports_Stats>;
  /** fetch aggregated fields from the table: "hourly_spoofing_reports_stats" */
  hourly_spoofing_reports_stats_aggregate: Hourly_Spoofing_Reports_Stats_Aggregate;
  /** fetch data from the table: "hourly_spoofing_reports_stats" using primary key columns */
  hourly_spoofing_reports_stats_by_pk?: Maybe<Hourly_Spoofing_Reports_Stats>;
  /** fetch data from the table: "ioc_alert_attribution" */
  ioc_alert_attribution: Array<Ioc_Alert_Attribution>;
  /** fetch aggregated fields from the table: "ioc_alert_attribution" */
  ioc_alert_attribution_aggregate: Ioc_Alert_Attribution_Aggregate;
  /** fetch data from the table: "ioc_alert_attribution" using primary key columns */
  ioc_alert_attribution_by_pk?: Maybe<Ioc_Alert_Attribution>;
  /** fetch data from the table: "ioc_detection_config_attribution" */
  ioc_detection_config_attribution: Array<Ioc_Detection_Config_Attribution>;
  /** fetch aggregated fields from the table: "ioc_detection_config_attribution" */
  ioc_detection_config_attribution_aggregate: Ioc_Detection_Config_Attribution_Aggregate;
  /** fetch data from the table: "ioc_detection_config_attribution" using primary key columns */
  ioc_detection_config_attribution_by_pk?: Maybe<Ioc_Detection_Config_Attribution>;
  /** fetch data from the table: "ioc_entity_data_attribution" */
  ioc_entity_data_attribution: Array<Ioc_Entity_Data_Attribution>;
  /** fetch aggregated fields from the table: "ioc_entity_data_attribution" */
  ioc_entity_data_attribution_aggregate: Ioc_Entity_Data_Attribution_Aggregate;
  /** fetch data from the table: "ioc_entity_data_attribution" using primary key columns */
  ioc_entity_data_attribution_by_pk?: Maybe<Ioc_Entity_Data_Attribution>;
  /** fetch data from the table: "iocs" */
  iocs: Array<Iocs>;
  /** fetch aggregated fields from the table: "iocs" */
  iocs_aggregate: Iocs_Aggregate;
  /** fetch data from the table: "iocs" using primary key columns */
  iocs_by_pk?: Maybe<Iocs>;
  /** An array relationship */
  jira_metadata: Array<Jira_Metadata>;
  /** An aggregate relationship */
  jira_metadata_aggregate: Jira_Metadata_Aggregate;
  /** fetch data from the table: "jira_metadata" using primary key columns */
  jira_metadata_by_pk?: Maybe<Jira_Metadata>;
  /** manage_elastic_search_queries */
  manage_elastic_search_queries: ElasticSearchQueriesOutput;
  /** An array relationship */
  match_attributions: Array<Match_Attributions>;
  /** An aggregate relationship */
  match_attributions_aggregate: Match_Attributions_Aggregate;
  /** fetch data from the table: "match_attributions" using primary key columns */
  match_attributions_by_pk?: Maybe<Match_Attributions>;
  /** An array relationship */
  ml_features: Array<Ml_Features>;
  /** An aggregate relationship */
  ml_features_aggregate: Ml_Features_Aggregate;
  /** fetch data from the table: "ml_features" using primary key columns */
  ml_features_by_pk?: Maybe<Ml_Features>;
  /** fetch data from the table: "mobile_apps" */
  mobile_apps: Array<Mobile_Apps>;
  /** fetch aggregated fields from the table: "mobile_apps" */
  mobile_apps_aggregate: Mobile_Apps_Aggregate;
  /** fetch data from the table: "mobile_apps" using primary key columns */
  mobile_apps_by_pk?: Maybe<Mobile_Apps>;
  /** fetch data from the table: "mv_alerts_surfaced_by_day" */
  mv_alerts_surfaced_by_day: Array<Mv_Alerts_Surfaced_By_Day>;
  /** fetch aggregated fields from the table: "mv_alerts_surfaced_by_day" */
  mv_alerts_surfaced_by_day_aggregate: Mv_Alerts_Surfaced_By_Day_Aggregate;
  /** fetch data from the table: "mv_alerts_surfaced_by_hour" */
  mv_alerts_surfaced_by_hour: Array<Mv_Alerts_Surfaced_By_Hour>;
  /** fetch aggregated fields from the table: "mv_alerts_surfaced_by_hour" */
  mv_alerts_surfaced_by_hour_aggregate: Mv_Alerts_Surfaced_By_Hour_Aggregate;
  /** fetch data from the table: "mv_alerts_times_to_actioned" */
  mv_alerts_times_to_actioned: Array<Mv_Alerts_Times_To_Actioned>;
  /** fetch aggregated fields from the table: "mv_alerts_times_to_actioned" */
  mv_alerts_times_to_actioned_aggregate: Mv_Alerts_Times_To_Actioned_Aggregate;
  /** fetch data from the table: "mv_alerts_verified" */
  mv_alerts_verified: Array<Mv_Alerts_Verified>;
  /** fetch aggregated fields from the table: "mv_alerts_verified" */
  mv_alerts_verified_aggregate: Mv_Alerts_Verified_Aggregate;
  /** fetch data from the table: "mv_dark_web_alerts_surfaced" */
  mv_dark_web_alerts_surfaced: Array<Mv_Dark_Web_Alerts_Surfaced>;
  /** fetch aggregated fields from the table: "mv_dark_web_alerts_surfaced" */
  mv_dark_web_alerts_surfaced_aggregate: Mv_Dark_Web_Alerts_Surfaced_Aggregate;
  /** fetch data from the table: "mv_dark_web_alerts_surfaced_by_hour" */
  mv_dark_web_alerts_surfaced_by_hour: Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour>;
  /** fetch aggregated fields from the table: "mv_dark_web_alerts_surfaced_by_hour" */
  mv_dark_web_alerts_surfaced_by_hour_aggregate: Mv_Dark_Web_Alerts_Surfaced_By_Hour_Aggregate;
  /** fetch data from the table: "mv_email_alerts_times_to_actioned" */
  mv_email_alerts_times_to_actioned: Array<Mv_Email_Alerts_Times_To_Actioned>;
  /** fetch aggregated fields from the table: "mv_email_alerts_times_to_actioned" */
  mv_email_alerts_times_to_actioned_aggregate: Mv_Email_Alerts_Times_To_Actioned_Aggregate;
  /** fetch data from the table: "nft_opensea_processed" */
  nft_opensea_processed: Array<Nft_Opensea_Processed>;
  /** fetch aggregated fields from the table: "nft_opensea_processed" */
  nft_opensea_processed_aggregate: Nft_Opensea_Processed_Aggregate;
  /** fetch data from the table: "nft_opensea_processed" using primary key columns */
  nft_opensea_processed_by_pk?: Maybe<Nft_Opensea_Processed>;
  /** fetch data from the table: "nft_processing_cursor" */
  nft_processing_cursor: Array<Nft_Processing_Cursor>;
  /** fetch aggregated fields from the table: "nft_processing_cursor" */
  nft_processing_cursor_aggregate: Nft_Processing_Cursor_Aggregate;
  /** fetch data from the table: "nft_processing_cursor" using primary key columns */
  nft_processing_cursor_by_pk?: Maybe<Nft_Processing_Cursor>;
  /** fetch data from the table: "notification_subscriptions" */
  notification_subscriptions: Array<Notification_Subscriptions>;
  /** fetch aggregated fields from the table: "notification_subscriptions" */
  notification_subscriptions_aggregate: Notification_Subscriptions_Aggregate;
  /** fetch data from the table: "notification_subscriptions" using primary key columns */
  notification_subscriptions_by_pk?: Maybe<Notification_Subscriptions>;
  /** Temporary Demo Action for OpenAI */
  openai_demo_action?: Maybe<OpenAiOutput>;
  /** fetch data from the table: "organization_id_api_keys" */
  organization_id_api_keys: Array<Organization_Id_Api_Keys>;
  /** fetch aggregated fields from the table: "organization_id_api_keys" */
  organization_id_api_keys_aggregate: Organization_Id_Api_Keys_Aggregate;
  /** fetch data from the table: "organization_id_api_keys" using primary key columns */
  organization_id_api_keys_by_pk?: Maybe<Organization_Id_Api_Keys>;
  /** An array relationship */
  organization_products: Array<Organization_Products>;
  /** An aggregate relationship */
  organization_products_aggregate: Organization_Products_Aggregate;
  /** fetch data from the table: "organization_products" using primary key columns */
  organization_products_by_pk?: Maybe<Organization_Products>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table: "organizations_metadata" */
  organizations_metadata: Array<Organizations_Metadata>;
  /** fetch aggregated fields from the table: "organizations_metadata" */
  organizations_metadata_aggregate: Organizations_Metadata_Aggregate;
  /** fetch data from the table: "organizations_metadata" using primary key columns */
  organizations_metadata_by_pk?: Maybe<Organizations_Metadata>;
  /** fetch data from the table: "permissions" */
  permissions: Array<Permissions>;
  /** fetch aggregated fields from the table: "permissions" */
  permissions_aggregate: Permissions_Aggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: Maybe<Permissions>;
  /** fetch data from the table: "phone_numbers" */
  phone_numbers: Array<Phone_Numbers>;
  /** fetch aggregated fields from the table: "phone_numbers" */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  /** fetch data from the table: "phone_numbers" using primary key columns */
  phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** fetch data from the table: "pii_databrokers" */
  pii_databrokers: Array<Pii_Databrokers>;
  /** fetch aggregated fields from the table: "pii_databrokers" */
  pii_databrokers_aggregate: Pii_Databrokers_Aggregate;
  /** fetch data from the table: "pii_databrokers" using primary key columns */
  pii_databrokers_by_pk?: Maybe<Pii_Databrokers>;
  /** fetch data from the table: "pii_events" */
  pii_events: Array<Pii_Events>;
  /** fetch aggregated fields from the table: "pii_events" */
  pii_events_aggregate: Pii_Events_Aggregate;
  /** fetch data from the table: "pii_events" using primary key columns */
  pii_events_by_pk?: Maybe<Pii_Events>;
  /** fetch data from the table: "pii_leaks_by_databroker" */
  pii_leaks_by_databroker: Array<Pii_Leaks_By_Databroker>;
  /** fetch aggregated fields from the table: "pii_leaks_by_databroker" */
  pii_leaks_by_databroker_aggregate: Pii_Leaks_By_Databroker_Aggregate;
  /** fetch data from the table: "pii_reports" */
  pii_reports: Array<Pii_Reports>;
  /** fetch aggregated fields from the table: "pii_reports" */
  pii_reports_aggregate: Pii_Reports_Aggregate;
  /** fetch data from the table: "pii_reports" using primary key columns */
  pii_reports_by_pk?: Maybe<Pii_Reports>;
  /** fetch data from the table: "pii_statistics" */
  pii_statistics: Array<Pii_Statistics>;
  /** fetch aggregated fields from the table: "pii_statistics" */
  pii_statistics_aggregate: Pii_Statistics_Aggregate;
  /** fetch data from the table: "pii_statistics" using primary key columns */
  pii_statistics_by_pk?: Maybe<Pii_Statistics>;
  /** fetch data from the table: "platform_subtypes" */
  platform_subtypes: Array<Platform_Subtypes>;
  /** fetch aggregated fields from the table: "platform_subtypes" */
  platform_subtypes_aggregate: Platform_Subtypes_Aggregate;
  /** fetch data from the table: "platform_subtypes" using primary key columns */
  platform_subtypes_by_pk?: Maybe<Platform_Subtypes>;
  /** fetch data from the table: "platforms" */
  platforms: Array<Platforms>;
  /** fetch aggregated fields from the table: "platforms" */
  platforms_aggregate: Platforms_Aggregate;
  /** fetch data from the table: "platforms" using primary key columns */
  platforms_by_pk?: Maybe<Platforms>;
  /** fetch data from the table: "pre_collections" */
  pre_collections: Array<Pre_Collections>;
  /** fetch aggregated fields from the table: "pre_collections" */
  pre_collections_aggregate: Pre_Collections_Aggregate;
  /** fetch data from the table: "pre_collections" using primary key columns */
  pre_collections_by_pk?: Maybe<Pre_Collections>;
  /** fetch data from the table: "predicted_enforcement_types" */
  predicted_enforcement_types: Array<Predicted_Enforcement_Types>;
  /** fetch aggregated fields from the table: "predicted_enforcement_types" */
  predicted_enforcement_types_aggregate: Predicted_Enforcement_Types_Aggregate;
  /** fetch data from the table: "predicted_enforcement_types" using primary key columns */
  predicted_enforcement_types_by_pk?: Maybe<Predicted_Enforcement_Types>;
  /** An array relationship */
  protected_assets: Array<Protected_Assets>;
  /** An aggregate relationship */
  protected_assets_aggregate: Protected_Assets_Aggregate;
  /** fetch data from the table: "protected_assets" using primary key columns */
  protected_assets_by_pk?: Maybe<Protected_Assets>;
  /** An array relationship */
  report_tags: Array<Report_Tags>;
  /** An aggregate relationship */
  report_tags_aggregate: Report_Tags_Aggregate;
  /** fetch data from the table: "report_tags" using primary key columns */
  report_tags_by_pk?: Maybe<Report_Tags>;
  /** fetch data from the table: "reports_to_reports" */
  reports_to_reports: Array<Reports_To_Reports>;
  /** fetch aggregated fields from the table: "reports_to_reports" */
  reports_to_reports_aggregate: Reports_To_Reports_Aggregate;
  /** fetch data from the table: "reports_to_reports" using primary key columns */
  reports_to_reports_by_pk?: Maybe<Reports_To_Reports>;
  request_alert_csv_export?: Maybe<Request_Alert_Csv_Export>;
  /** An array relationship */
  role_permissions: Array<Role_Permissions>;
  /** An aggregate relationship */
  role_permissions_aggregate: Role_Permissions_Aggregate;
  /** fetch data from the table: "role_permissions" using primary key columns */
  role_permissions_by_pk?: Maybe<Role_Permissions>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "rules" */
  rules: Array<Rules>;
  /** fetch aggregated fields from the table: "rules" */
  rules_aggregate: Rules_Aggregate;
  /** fetch data from the table: "rules" using primary key columns */
  rules_by_pk?: Maybe<Rules>;
  /** run_ocr_analysis */
  run_ocr_analysis: RunOcrAnalysisOutput;
  /** fetch data from the table: "safelist_ip_addresses" */
  safelist_ip_addresses: Array<Safelist_Ip_Addresses>;
  /** fetch aggregated fields from the table: "safelist_ip_addresses" */
  safelist_ip_addresses_aggregate: Safelist_Ip_Addresses_Aggregate;
  /** fetch data from the table: "safelist_ip_addresses" using primary key columns */
  safelist_ip_addresses_by_pk?: Maybe<Safelist_Ip_Addresses>;
  /** fetch data from the table: "salesforce_organizations_data" */
  salesforce_organizations_data: Array<Salesforce_Organizations_Data>;
  /** fetch aggregated fields from the table: "salesforce_organizations_data" */
  salesforce_organizations_data_aggregate: Salesforce_Organizations_Data_Aggregate;
  /** fetch data from the table: "salesforce_organizations_data" using primary key columns */
  salesforce_organizations_data_by_pk?: Maybe<Salesforce_Organizations_Data>;
  /** An array relationship */
  scan_results: Array<Scan_Results>;
  /** An aggregate relationship */
  scan_results_aggregate: Scan_Results_Aggregate;
  /** fetch data from the table: "scan_results" using primary key columns */
  scan_results_by_pk?: Maybe<Scan_Results>;
  /** fetch data from the table: "scans" */
  scans: Array<Scans>;
  /** fetch aggregated fields from the table: "scans" */
  scans_aggregate: Scans_Aggregate;
  /** fetch data from the table: "scans" using primary key columns */
  scans_by_pk?: Maybe<Scans>;
  /** fetch data from the table: "scraping_configs" */
  scraping_configs: Array<Scraping_Configs>;
  /** fetch aggregated fields from the table: "scraping_configs" */
  scraping_configs_aggregate: Scraping_Configs_Aggregate;
  /** fetch data from the table: "scraping_configs" using primary key columns */
  scraping_configs_by_pk?: Maybe<Scraping_Configs>;
  /** execute function "search_spoofing_reports" which returns "spoofing_reports" */
  search_spoofing_reports: Array<Spoofing_Reports>;
  /** execute function "search_spoofing_reports" and query aggregates on result of table type "spoofing_reports" */
  search_spoofing_reports_aggregate: Spoofing_Reports_Aggregate;
  /** fetch data from the table: "sim_campaign_observations" */
  sim_campaign_observations: Array<Sim_Campaign_Observations>;
  /** fetch aggregated fields from the table: "sim_campaign_observations" */
  sim_campaign_observations_aggregate: Sim_Campaign_Observations_Aggregate;
  /** fetch data from the table: "sim_campaign_observations" using primary key columns */
  sim_campaign_observations_by_pk?: Maybe<Sim_Campaign_Observations>;
  /** fetch data from the table: "sim_campaigns" */
  sim_campaigns: Array<Sim_Campaigns>;
  /** fetch aggregated fields from the table: "sim_campaigns" */
  sim_campaigns_aggregate: Sim_Campaigns_Aggregate;
  /** fetch data from the table: "sim_campaigns" using primary key columns */
  sim_campaigns_by_pk?: Maybe<Sim_Campaigns>;
  /** fetch data from the table: "sim_emails" */
  sim_emails: Array<Sim_Emails>;
  /** fetch aggregated fields from the table: "sim_emails" */
  sim_emails_aggregate: Sim_Emails_Aggregate;
  /** fetch data from the table: "sim_emails" using primary key columns */
  sim_emails_by_pk?: Maybe<Sim_Emails>;
  /** fetch data from the table: "sim_groups" */
  sim_groups: Array<Sim_Groups>;
  /** fetch aggregated fields from the table: "sim_groups" */
  sim_groups_aggregate: Sim_Groups_Aggregate;
  /** fetch data from the table: "sim_groups" using primary key columns */
  sim_groups_by_pk?: Maybe<Sim_Groups>;
  /** fetch data from the table: "sim_users" */
  sim_users: Array<Sim_Users>;
  /** fetch aggregated fields from the table: "sim_users" */
  sim_users_aggregate: Sim_Users_Aggregate;
  /** fetch data from the table: "sim_users" using primary key columns */
  sim_users_by_pk?: Maybe<Sim_Users>;
  /** fetch data from the table: "slack_installations" */
  slack_installations: Array<Slack_Installations>;
  /** fetch aggregated fields from the table: "slack_installations" */
  slack_installations_aggregate: Slack_Installations_Aggregate;
  /** fetch data from the table: "slack_installations" using primary key columns */
  slack_installations_by_pk?: Maybe<Slack_Installations>;
  /** fetch data from the table: "social_media_comments" */
  social_media_comments: Array<Social_Media_Comments>;
  /** fetch aggregated fields from the table: "social_media_comments" */
  social_media_comments_aggregate: Social_Media_Comments_Aggregate;
  /** fetch data from the table: "social_media_comments" using primary key columns */
  social_media_comments_by_pk?: Maybe<Social_Media_Comments>;
  /** fetch data from the table: "social_media_data" */
  social_media_data: Array<Social_Media_Data>;
  /** fetch aggregated fields from the table: "social_media_data" */
  social_media_data_aggregate: Social_Media_Data_Aggregate;
  /** fetch data from the table: "social_media_data" using primary key columns */
  social_media_data_by_pk?: Maybe<Social_Media_Data>;
  /** fetch data from the table: "social_media_group" */
  social_media_group: Array<Social_Media_Group>;
  /** fetch aggregated fields from the table: "social_media_group" */
  social_media_group_aggregate: Social_Media_Group_Aggregate;
  /** fetch data from the table: "social_media_group" using primary key columns */
  social_media_group_by_pk?: Maybe<Social_Media_Group>;
  /** fetch data from the table: "social_media_post" */
  social_media_post: Array<Social_Media_Post>;
  /** fetch aggregated fields from the table: "social_media_post" */
  social_media_post_aggregate: Social_Media_Post_Aggregate;
  /** fetch data from the table: "social_media_post" using primary key columns */
  social_media_post_by_pk?: Maybe<Social_Media_Post>;
  sourcing_adhoc_request: SuccessMessageOutput;
  /** An array relationship */
  sourcing_queries: Array<Sourcing_Queries>;
  /** An aggregate relationship */
  sourcing_queries_aggregate: Sourcing_Queries_Aggregate;
  /** fetch data from the table: "sourcing_queries" using primary key columns */
  sourcing_queries_by_pk?: Maybe<Sourcing_Queries>;
  /** fetch data from the table: "sourcing_query_executions" */
  sourcing_query_executions: Array<Sourcing_Query_Executions>;
  /** fetch aggregated fields from the table: "sourcing_query_executions" */
  sourcing_query_executions_aggregate: Sourcing_Query_Executions_Aggregate;
  /** fetch data from the table: "sourcing_query_executions" using primary key columns */
  sourcing_query_executions_by_pk?: Maybe<Sourcing_Query_Executions>;
  /** An array relationship */
  spoof_matches: Array<Spoof_Matches>;
  /** An aggregate relationship */
  spoof_matches_aggregate: Spoof_Matches_Aggregate;
  /** fetch data from the table: "spoof_matches" using primary key columns */
  spoof_matches_by_pk?: Maybe<Spoof_Matches>;
  /** An array relationship */
  spoofing_entities: Array<Spoofing_Entities>;
  /** An aggregate relationship */
  spoofing_entities_aggregate: Spoofing_Entities_Aggregate;
  /** fetch data from the table: "spoofing_entities" using primary key columns */
  spoofing_entities_by_pk?: Maybe<Spoofing_Entities>;
  /** fetch data from the table: "spoofing_report_search_results" */
  spoofing_report_search_results: Array<Spoofing_Report_Search_Results>;
  /** fetch aggregated fields from the table: "spoofing_report_search_results" */
  spoofing_report_search_results_aggregate: Spoofing_Report_Search_Results_Aggregate;
  /** An array relationship */
  spoofing_reports: Array<Spoofing_Reports>;
  /** An aggregate relationship */
  spoofing_reports_aggregate: Spoofing_Reports_Aggregate;
  /** fetch data from the table: "spoofing_reports" using primary key columns */
  spoofing_reports_by_pk?: Maybe<Spoofing_Reports>;
  /** An array relationship */
  spoofing_reports_to_tags: Array<Spoofing_Reports_To_Tags>;
  /** An aggregate relationship */
  spoofing_reports_to_tags_aggregate: Spoofing_Reports_To_Tags_Aggregate;
  /** fetch data from the table: "spoofing_reports_to_tags" using primary key columns */
  spoofing_reports_to_tags_by_pk?: Maybe<Spoofing_Reports_To_Tags>;
  /** fetch data from the table: "suggested_enforcements" */
  suggested_enforcements: Array<Suggested_Enforcements>;
  /** fetch aggregated fields from the table: "suggested_enforcements" */
  suggested_enforcements_aggregate: Suggested_Enforcements_Aggregate;
  /** fetch data from the table: "suggested_enforcements" using primary key columns */
  suggested_enforcements_by_pk?: Maybe<Suggested_Enforcements>;
  /** fetch data from the table: "suggested_enforcements_form_responses" */
  suggested_enforcements_form_responses: Array<Suggested_Enforcements_Form_Responses>;
  /** fetch aggregated fields from the table: "suggested_enforcements_form_responses" */
  suggested_enforcements_form_responses_aggregate: Suggested_Enforcements_Form_Responses_Aggregate;
  /** fetch data from the table: "suggested_enforcements_form_responses" using primary key columns */
  suggested_enforcements_form_responses_by_pk?: Maybe<Suggested_Enforcements_Form_Responses>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** An array relationship */
  threat_intel_actor_to_campaign: Array<Threat_Intel_Actor_To_Campaign>;
  /** An aggregate relationship */
  threat_intel_actor_to_campaign_aggregate: Threat_Intel_Actor_To_Campaign_Aggregate;
  /** fetch data from the table: "threat_intel_actor_to_campaign" using primary key columns */
  threat_intel_actor_to_campaign_by_pk?: Maybe<Threat_Intel_Actor_To_Campaign>;
  /** fetch data from the table: "threat_intel_actors" */
  threat_intel_actors: Array<Threat_Intel_Actors>;
  /** fetch aggregated fields from the table: "threat_intel_actors" */
  threat_intel_actors_aggregate: Threat_Intel_Actors_Aggregate;
  /** fetch data from the table: "threat_intel_actors" using primary key columns */
  threat_intel_actors_by_pk?: Maybe<Threat_Intel_Actors>;
  /** An array relationship */
  threat_intel_campaign_to_entities: Array<Threat_Intel_Campaign_To_Entities>;
  /** An aggregate relationship */
  threat_intel_campaign_to_entities_aggregate: Threat_Intel_Campaign_To_Entities_Aggregate;
  /** fetch data from the table: "threat_intel_campaign_to_entities" using primary key columns */
  threat_intel_campaign_to_entities_by_pk?: Maybe<Threat_Intel_Campaign_To_Entities>;
  /** fetch data from the table: "threat_intel_campaigns" */
  threat_intel_campaigns: Array<Threat_Intel_Campaigns>;
  /** fetch aggregated fields from the table: "threat_intel_campaigns" */
  threat_intel_campaigns_aggregate: Threat_Intel_Campaigns_Aggregate;
  /** fetch data from the table: "threat_intel_campaigns" using primary key columns */
  threat_intel_campaigns_by_pk?: Maybe<Threat_Intel_Campaigns>;
  /** An array relationship */
  trademarks: Array<Trademarks>;
  /** An aggregate relationship */
  trademarks_aggregate: Trademarks_Aggregate;
  /** fetch data from the table: "trademarks" using primary key columns */
  trademarks_by_pk?: Maybe<Trademarks>;
  /** fetch data from the table: "uploaded_files" */
  uploaded_files: Array<Uploaded_Files>;
  /** fetch aggregated fields from the table: "uploaded_files" */
  uploaded_files_aggregate: Uploaded_Files_Aggregate;
  /** fetch data from the table: "uploaded_files" using primary key columns */
  uploaded_files_by_pk?: Maybe<Uploaded_Files>;
  /** fetch data from the table: "user_feedback" */
  user_feedback: Array<User_Feedback>;
  /** fetch aggregated fields from the table: "user_feedback" */
  user_feedback_aggregate: User_Feedback_Aggregate;
  /** fetch data from the table: "user_feedback" using primary key columns */
  user_feedback_by_pk?: Maybe<User_Feedback>;
  /** fetch data from the table: "user_organizations" */
  user_organizations: Array<User_Organizations>;
  /** fetch aggregated fields from the table: "user_organizations" */
  user_organizations_aggregate: User_Organizations_Aggregate;
  /** fetch data from the table: "user_organizations" using primary key columns */
  user_organizations_by_pk?: Maybe<User_Organizations>;
  /** fetch data from the table: "user_products" */
  user_products: Array<User_Products>;
  /** fetch aggregated fields from the table: "user_products" */
  user_products_aggregate: User_Products_Aggregate;
  /** fetch data from the table: "user_products" using primary key columns */
  user_products_by_pk?: Maybe<User_Products>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** Similar to a dry-run of create_entity_link */
  validate_entity_link?: Maybe<CreateEntityLinksOutput>;
  /** fetch data from the table: "vetric_screenshot_webhooks" */
  vetric_screenshot_webhooks: Array<Vetric_Screenshot_Webhooks>;
  /** fetch aggregated fields from the table: "vetric_screenshot_webhooks" */
  vetric_screenshot_webhooks_aggregate: Vetric_Screenshot_Webhooks_Aggregate;
  /** fetch data from the table: "vetric_screenshot_webhooks" using primary key columns */
  vetric_screenshot_webhooks_by_pk?: Maybe<Vetric_Screenshot_Webhooks>;
  /** fetch data from the table: "webhook_targets" */
  webhook_targets: Array<Webhook_Targets>;
  /** fetch aggregated fields from the table: "webhook_targets" */
  webhook_targets_aggregate: Webhook_Targets_Aggregate;
  /** fetch data from the table: "webhook_targets" using primary key columns */
  webhook_targets_by_pk?: Maybe<Webhook_Targets>;
};


export type Query_RootAdvertisement_DataArgs = {
  distinct_on?: InputMaybe<Array<Advertisement_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advertisement_Data_Order_By>>;
  where?: InputMaybe<Advertisement_Data_Bool_Exp>;
};


export type Query_RootAdvertisement_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advertisement_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advertisement_Data_Order_By>>;
  where?: InputMaybe<Advertisement_Data_Bool_Exp>;
};


export type Query_RootAdvertisement_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAdvertiser_DataArgs = {
  distinct_on?: InputMaybe<Array<Advertiser_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advertiser_Data_Order_By>>;
  where?: InputMaybe<Advertiser_Data_Bool_Exp>;
};


export type Query_RootAdvertiser_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advertiser_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advertiser_Data_Order_By>>;
  where?: InputMaybe<Advertiser_Data_Bool_Exp>;
};


export type Query_RootAdvertiser_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAi_PromptsArgs = {
  distinct_on?: InputMaybe<Array<Ai_Prompts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Prompts_Order_By>>;
  where?: InputMaybe<Ai_Prompts_Bool_Exp>;
};


export type Query_RootAi_Prompts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Prompts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Prompts_Order_By>>;
  where?: InputMaybe<Ai_Prompts_Bool_Exp>;
};


export type Query_RootAi_Prompts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAi_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Ai_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Responses_Order_By>>;
  where?: InputMaybe<Ai_Responses_Bool_Exp>;
};


export type Query_RootAi_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Responses_Order_By>>;
  where?: InputMaybe<Ai_Responses_Bool_Exp>;
};


export type Query_RootAi_Responses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAlert_HashesArgs = {
  distinct_on?: InputMaybe<Array<Alert_Hashes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Hashes_Order_By>>;
  where?: InputMaybe<Alert_Hashes_Bool_Exp>;
};


export type Query_RootAlert_Hashes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Hashes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Hashes_Order_By>>;
  where?: InputMaybe<Alert_Hashes_Bool_Exp>;
};


export type Query_RootAlert_Hashes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAlert_Label_EventsArgs = {
  distinct_on?: InputMaybe<Array<Alert_Label_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Label_Events_Order_By>>;
  where?: InputMaybe<Alert_Label_Events_Bool_Exp>;
};


export type Query_RootAlert_Label_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Label_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Label_Events_Order_By>>;
  where?: InputMaybe<Alert_Label_Events_Bool_Exp>;
};


export type Query_RootAlert_Label_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAlert_LinksArgs = {
  distinct_on?: InputMaybe<Array<Alert_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Links_Order_By>>;
  where?: InputMaybe<Alert_Links_Bool_Exp>;
};


export type Query_RootAlert_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Links_Order_By>>;
  where?: InputMaybe<Alert_Links_Bool_Exp>;
};


export type Query_RootAlert_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAlerts_Queue_State_Count_By_ProductArgs = {
  args: Alerts_Queue_State_Count_By_Product_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Queue_State_Count_By_Product_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Queue_State_Count_By_Product_Order_By>>;
  where?: InputMaybe<Alerts_Queue_State_Count_By_Product_Bool_Exp_Bool_Exp>;
};


export type Query_RootAlerts_Resolved_Top_MetricsArgs = {
  args: Alerts_Resolved_Top_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Resolved_Top_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Resolved_Top_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Resolved_Top_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootAlerts_Resolved_Total_MetricsArgs = {
  args: Alerts_Resolved_Total_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Resolved_Total_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Resolved_Total_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Resolved_Total_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootAlerts_Surfaced_Top_MetricsArgs = {
  args: Alerts_Surfaced_Top_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Surfaced_Top_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Surfaced_Top_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootAlerts_Times_To_Actioned_By_Platform_MetricsArgs = {
  args: Alerts_Times_To_Actioned_By_Platform_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Times_To_Actioned_By_Platform_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Times_To_Actioned_By_Platform_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Times_To_Actioned_By_Platform_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootAlerts_Times_To_Actioned_Graph_MetricsArgs = {
  args: Alerts_Times_To_Actioned_Graph_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Times_To_Actioned_Graph_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Times_To_Actioned_Graph_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Times_To_Actioned_Graph_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootAlerts_Times_To_Actioned_MetricsArgs = {
  args: Alerts_Times_To_Actioned_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Times_To_Actioned_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Times_To_Actioned_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Times_To_Actioned_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootAlerts_Verified_Top_MetricsArgs = {
  args: Alerts_Verified_Top_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Verified_Top_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Verified_Top_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Verified_Top_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootAlerts_Verified_Total_MetricsArgs = {
  args: Alerts_Verified_Total_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Verified_Total_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Verified_Total_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Verified_Total_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootApi_TokensArgs = {
  distinct_on?: InputMaybe<Array<Api_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Tokens_Order_By>>;
  where?: InputMaybe<Api_Tokens_Bool_Exp>;
};


export type Query_RootApi_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Api_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Tokens_Order_By>>;
  where?: InputMaybe<Api_Tokens_Bool_Exp>;
};


export type Query_RootApi_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootApi_Usage_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Api_Usage_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Usage_Records_Order_By>>;
  where?: InputMaybe<Api_Usage_Records_Bool_Exp>;
};


export type Query_RootApi_Usage_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Api_Usage_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Usage_Records_Order_By>>;
  where?: InputMaybe<Api_Usage_Records_Bool_Exp>;
};


export type Query_RootApi_Usage_Records_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootApify_Scraping_JobsArgs = {
  distinct_on?: InputMaybe<Array<Apify_Scraping_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Apify_Scraping_Jobs_Order_By>>;
  where?: InputMaybe<Apify_Scraping_Jobs_Bool_Exp>;
};


export type Query_RootApify_Scraping_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Apify_Scraping_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Apify_Scraping_Jobs_Order_By>>;
  where?: InputMaybe<Apify_Scraping_Jobs_Bool_Exp>;
};


export type Query_RootApify_Scraping_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootApprovalsArgs = {
  distinct_on?: InputMaybe<Array<Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approvals_Order_By>>;
  where?: InputMaybe<Approvals_Bool_Exp>;
};


export type Query_RootApprovals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approvals_Order_By>>;
  where?: InputMaybe<Approvals_Bool_Exp>;
};


export type Query_RootApprovals_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAudit_Logged_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Audit_Logged_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Logged_Actions_Order_By>>;
  where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};


export type Query_RootAudit_Logged_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Logged_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Logged_Actions_Order_By>>;
  where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};


export type Query_RootAudit_Logged_Actions_By_PkArgs = {
  event_id: Scalars['bigint'];
};


export type Query_RootCollection_Report_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};


export type Query_RootCollection_Report_Changes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};


export type Query_RootCollection_Report_Changes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCollection_Report_State_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_State_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_State_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_State_Changes_Bool_Exp>;
};


export type Query_RootCollection_Report_State_Changes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_State_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_State_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_State_Changes_Bool_Exp>;
};


export type Query_RootCollection_Report_State_Changes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCredit_CardsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Cards_Order_By>>;
  where?: InputMaybe<Credit_Cards_Bool_Exp>;
};


export type Query_RootCredit_Cards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Cards_Order_By>>;
  where?: InputMaybe<Credit_Cards_Bool_Exp>;
};


export type Query_RootCredit_Cards_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCustomer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_Order_By>>;
  where?: InputMaybe<Customer_Assets_Bool_Exp>;
};


export type Query_RootCustomer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_Order_By>>;
  where?: InputMaybe<Customer_Assets_Bool_Exp>;
};


export type Query_RootCustomer_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCustomer_Assets_To_BrandsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_To_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_To_Brands_Order_By>>;
  where?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
};


export type Query_RootCustomer_Assets_To_Brands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_To_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_To_Brands_Order_By>>;
  where?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
};


export type Query_RootCustomer_Assets_To_Brands_By_PkArgs = {
  brand_id: Scalars['uuid'];
  customer_asset_id: Scalars['uuid'];
};


export type Query_RootDark_WebArgs = {
  distinct_on?: InputMaybe<Array<Dark_Web_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Web_Order_By>>;
  where?: InputMaybe<Dark_Web_Bool_Exp>;
};


export type Query_RootDark_Web_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dark_Web_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Web_Order_By>>;
  where?: InputMaybe<Dark_Web_Bool_Exp>;
};


export type Query_RootDark_Web_Alerts_Surfaced_Top_MetricsArgs = {
  args: Dark_Web_Alerts_Surfaced_Top_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Dark_Web_Alerts_Surfaced_Top_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Web_Alerts_Surfaced_Top_Metrics_Order_By>>;
  where?: InputMaybe<Dark_Web_Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootDark_Web_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDefensive_Domain_RegistrationArgs = {
  distinct_on?: InputMaybe<Array<Defensive_Domain_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Defensive_Domain_Registration_Order_By>>;
  where?: InputMaybe<Defensive_Domain_Registration_Bool_Exp>;
};


export type Query_RootDefensive_Domain_Registration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Defensive_Domain_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Defensive_Domain_Registration_Order_By>>;
  where?: InputMaybe<Defensive_Domain_Registration_Bool_Exp>;
};


export type Query_RootDefensive_Domain_Registration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDesignated_Takedown_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Designated_Takedown_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Designated_Takedown_Assets_Order_By>>;
  where?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
};


export type Query_RootDesignated_Takedown_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Designated_Takedown_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Designated_Takedown_Assets_Order_By>>;
  where?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
};


export type Query_RootDesignated_Takedown_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDetection_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Detection_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_Assets_Order_By>>;
  where?: InputMaybe<Detection_Assets_Bool_Exp>;
};


export type Query_RootDetection_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Detection_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_Assets_Order_By>>;
  where?: InputMaybe<Detection_Assets_Bool_Exp>;
};


export type Query_RootDetection_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDetection_Config_ApprovalsArgs = {
  distinct_on?: InputMaybe<Array<Detection_Config_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_Config_Approvals_Order_By>>;
  where?: InputMaybe<Detection_Config_Approvals_Bool_Exp>;
};


export type Query_RootDetection_Config_Approvals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Detection_Config_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_Config_Approvals_Order_By>>;
  where?: InputMaybe<Detection_Config_Approvals_Bool_Exp>;
};


export type Query_RootDetection_Config_Approvals_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDomain_DataArgs = {
  distinct_on?: InputMaybe<Array<Domain_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Domain_Data_Order_By>>;
  where?: InputMaybe<Domain_Data_Bool_Exp>;
};


export type Query_RootDomain_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Domain_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Domain_Data_Order_By>>;
  where?: InputMaybe<Domain_Data_Bool_Exp>;
};


export type Query_RootDomain_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDomain_Match_DataArgs = {
  distinct_on?: InputMaybe<Array<Domain_Match_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Domain_Match_Data_Order_By>>;
  where?: InputMaybe<Domain_Match_Data_Bool_Exp>;
};


export type Query_RootDomain_Match_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Domain_Match_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Domain_Match_Data_Order_By>>;
  where?: InputMaybe<Domain_Match_Data_Bool_Exp>;
};


export type Query_RootDomain_Match_Data_By_PkArgs = {
  flagged_url: Scalars['String'];
  spoofing_entities_id: Scalars['uuid'];
};


export type Query_RootEcommerce_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ecommerce_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecommerce_Listings_Order_By>>;
  where?: InputMaybe<Ecommerce_Listings_Bool_Exp>;
};


export type Query_RootEcommerce_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ecommerce_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecommerce_Listings_Order_By>>;
  where?: InputMaybe<Ecommerce_Listings_Bool_Exp>;
};


export type Query_RootEcommerce_Listings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEmail_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Email_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Addresses_Order_By>>;
  where?: InputMaybe<Email_Addresses_Bool_Exp>;
};


export type Query_RootEmail_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Addresses_Order_By>>;
  where?: InputMaybe<Email_Addresses_Bool_Exp>;
};


export type Query_RootEmail_Addresses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEmail_Alerts_Resolved_Top_MetricsArgs = {
  args: Email_Alerts_Resolved_Top_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Resolved_Top_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Resolved_Top_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Resolved_Top_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootEmail_Alerts_Resolved_Total_MetricsArgs = {
  args: Email_Alerts_Resolved_Total_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Resolved_Total_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Resolved_Total_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Resolved_Total_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootEmail_Alerts_Times_To_Actioned_Graph_MetricsArgs = {
  args: Email_Alerts_Times_To_Actioned_Graph_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Times_To_Actioned_Graph_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Times_To_Actioned_Graph_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Times_To_Actioned_Graph_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootEmail_Alerts_Times_To_Actioned_MetricsArgs = {
  args: Email_Alerts_Times_To_Actioned_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Times_To_Actioned_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Times_To_Actioned_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Times_To_Actioned_Metrics_Bool_Exp_Bool_Exp>;
};


export type Query_RootEmail_CorrespondenceArgs = {
  distinct_on?: InputMaybe<Array<Email_Correspondence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Correspondence_Order_By>>;
  where?: InputMaybe<Email_Correspondence_Bool_Exp>;
};


export type Query_RootEmail_Correspondence_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Correspondence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Correspondence_Order_By>>;
  where?: InputMaybe<Email_Correspondence_Bool_Exp>;
};


export type Query_RootEmail_Correspondence_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEmail_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Email_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Settings_Order_By>>;
  where?: InputMaybe<Email_Settings_Bool_Exp>;
};


export type Query_RootEmail_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Settings_Order_By>>;
  where?: InputMaybe<Email_Settings_Bool_Exp>;
};


export type Query_RootEmail_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Query_RootEmails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Query_RootEmails_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEnforcement_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Emails_Order_By>>;
  where?: InputMaybe<Enforcement_Emails_Bool_Exp>;
};


export type Query_RootEnforcement_Emails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Emails_Order_By>>;
  where?: InputMaybe<Enforcement_Emails_Bool_Exp>;
};


export type Query_RootEnforcement_Emails_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEnforcement_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Metadata_Order_By>>;
  where?: InputMaybe<Enforcement_Metadata_Bool_Exp>;
};


export type Query_RootEnforcement_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Metadata_Order_By>>;
  where?: InputMaybe<Enforcement_Metadata_Bool_Exp>;
};


export type Query_RootEnforcement_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEnforcement_PlatformsArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Platforms_Order_By>>;
  where?: InputMaybe<Enforcement_Platforms_Bool_Exp>;
};


export type Query_RootEnforcement_Platforms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Platforms_Order_By>>;
  where?: InputMaybe<Enforcement_Platforms_Bool_Exp>;
};


export type Query_RootEnforcement_Platforms_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEnforcement_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Requests_Order_By>>;
  where?: InputMaybe<Enforcement_Requests_Bool_Exp>;
};


export type Query_RootEnforcement_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Requests_Order_By>>;
  where?: InputMaybe<Enforcement_Requests_Bool_Exp>;
};


export type Query_RootEnforcement_Requests_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEnforcement_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Templates_Order_By>>;
  where?: InputMaybe<Enforcement_Templates_Bool_Exp>;
};


export type Query_RootEnforcement_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Templates_Order_By>>;
  where?: InputMaybe<Enforcement_Templates_Bool_Exp>;
};


export type Query_RootEnforcement_Templates_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEnforcement_TypesArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Types_Order_By>>;
  where?: InputMaybe<Enforcement_Types_Bool_Exp>;
};


export type Query_RootEnforcement_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Types_Order_By>>;
  where?: InputMaybe<Enforcement_Types_Bool_Exp>;
};


export type Query_RootEnforcement_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEntity_AggregatesArgs = {
  distinct_on?: InputMaybe<Array<Entity_Aggregates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Aggregates_Order_By>>;
  where?: InputMaybe<Entity_Aggregates_Bool_Exp>;
};


export type Query_RootEntity_Aggregates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Aggregates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Aggregates_Order_By>>;
  where?: InputMaybe<Entity_Aggregates_Bool_Exp>;
};


export type Query_RootEntity_Aggregates_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEntity_DataArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


export type Query_RootEntity_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


export type Query_RootEntity_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEntity_LinksArgs = {
  distinct_on?: InputMaybe<Array<Entity_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Links_Order_By>>;
  where?: InputMaybe<Entity_Links_Bool_Exp>;
};


export type Query_RootEntity_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Links_Order_By>>;
  where?: InputMaybe<Entity_Links_Bool_Exp>;
};


export type Query_RootEntity_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEntity_State_ClassificationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Classifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Classifications_Order_By>>;
  where?: InputMaybe<Entity_State_Classifications_Bool_Exp>;
};


export type Query_RootEntity_State_Classifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Classifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Classifications_Order_By>>;
  where?: InputMaybe<Entity_State_Classifications_Bool_Exp>;
};


export type Query_RootEntity_State_Classifications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFull_UrlsArgs = {
  distinct_on?: InputMaybe<Array<Full_Urls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Urls_Order_By>>;
  where?: InputMaybe<Full_Urls_Bool_Exp>;
};


export type Query_RootFull_Urls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Full_Urls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Urls_Order_By>>;
  where?: InputMaybe<Full_Urls_Bool_Exp>;
};


export type Query_RootFull_Urls_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGet_Elasticsearch_FieldsArgs = {
  get_elasticsearch_fields_input: ElasticsearchFieldsInput;
};


export type Query_RootGet_Gcs_ObjectArgs = {
  manage_gcs_objects_input: ManageGcsObjectsInput;
};


export type Query_RootGet_Pii_MemberArgs = {
  pii_get_member_input: PiiGetMemberInput;
};


export type Query_RootGet_Pii_Reports_With_ScreenshotsArgs = {
  args: Get_Pii_Reports_With_Screenshots_Args;
  distinct_on?: InputMaybe<Array<Pii_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Reports_Order_By>>;
  where?: InputMaybe<Pii_Reports_Bool_Exp>;
};


export type Query_RootGet_Pii_Reports_With_Screenshots_AggregateArgs = {
  args: Get_Pii_Reports_With_Screenshots_Args;
  distinct_on?: InputMaybe<Array<Pii_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Reports_Order_By>>;
  where?: InputMaybe<Pii_Reports_Bool_Exp>;
};


export type Query_RootGet_Stats_DataArgs = {
  get_stats_data_input: GetStatsDataInput;
};


export type Query_RootGet_Threat_Graph_DataArgs = {
  get_threat_graph_data_input: GetThreatGraphDataInput;
};


export type Query_RootHandle_Detection_SearchArgs = {
  handle_detection_search_input: HandleDetectionSearchInput;
};


export type Query_RootHandle_Synchronous_Detection_Request_Async_ActionArgs = {
  id: Scalars['uuid'];
};


export type Query_RootHourly_Spoofing_Reports_StatsArgs = {
  distinct_on?: InputMaybe<Array<Hourly_Spoofing_Reports_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hourly_Spoofing_Reports_Stats_Order_By>>;
  where?: InputMaybe<Hourly_Spoofing_Reports_Stats_Bool_Exp>;
};


export type Query_RootHourly_Spoofing_Reports_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hourly_Spoofing_Reports_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hourly_Spoofing_Reports_Stats_Order_By>>;
  where?: InputMaybe<Hourly_Spoofing_Reports_Stats_Bool_Exp>;
};


export type Query_RootHourly_Spoofing_Reports_Stats_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootIoc_Alert_AttributionArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Alert_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Alert_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Alert_Attribution_Bool_Exp>;
};


export type Query_RootIoc_Alert_Attribution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Alert_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Alert_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Alert_Attribution_Bool_Exp>;
};


export type Query_RootIoc_Alert_Attribution_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootIoc_Detection_Config_AttributionArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
};


export type Query_RootIoc_Detection_Config_Attribution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
};


export type Query_RootIoc_Detection_Config_Attribution_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootIoc_Entity_Data_AttributionArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Entity_Data_Attribution_Bool_Exp>;
};


export type Query_RootIoc_Entity_Data_Attribution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Entity_Data_Attribution_Bool_Exp>;
};


export type Query_RootIoc_Entity_Data_Attribution_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootIocsArgs = {
  distinct_on?: InputMaybe<Array<Iocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Iocs_Order_By>>;
  where?: InputMaybe<Iocs_Bool_Exp>;
};


export type Query_RootIocs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Iocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Iocs_Order_By>>;
  where?: InputMaybe<Iocs_Bool_Exp>;
};


export type Query_RootIocs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootJira_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Jira_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jira_Metadata_Order_By>>;
  where?: InputMaybe<Jira_Metadata_Bool_Exp>;
};


export type Query_RootJira_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jira_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jira_Metadata_Order_By>>;
  where?: InputMaybe<Jira_Metadata_Bool_Exp>;
};


export type Query_RootJira_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootManage_Elastic_Search_QueriesArgs = {
  elastic_search_queries_input: ElasticSearchQueriesInput;
};


export type Query_RootMatch_AttributionsArgs = {
  distinct_on?: InputMaybe<Array<Match_Attributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Attributions_Order_By>>;
  where?: InputMaybe<Match_Attributions_Bool_Exp>;
};


export type Query_RootMatch_Attributions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Match_Attributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Attributions_Order_By>>;
  where?: InputMaybe<Match_Attributions_Bool_Exp>;
};


export type Query_RootMatch_Attributions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMl_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Ml_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ml_Features_Order_By>>;
  where?: InputMaybe<Ml_Features_Bool_Exp>;
};


export type Query_RootMl_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ml_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ml_Features_Order_By>>;
  where?: InputMaybe<Ml_Features_Bool_Exp>;
};


export type Query_RootMl_Features_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMobile_AppsArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Apps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mobile_Apps_Order_By>>;
  where?: InputMaybe<Mobile_Apps_Bool_Exp>;
};


export type Query_RootMobile_Apps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Apps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mobile_Apps_Order_By>>;
  where?: InputMaybe<Mobile_Apps_Bool_Exp>;
};


export type Query_RootMobile_Apps_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMv_Alerts_Surfaced_By_DayArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Day_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Surfaced_By_Day_Bool_Exp>;
};


export type Query_RootMv_Alerts_Surfaced_By_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Day_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Surfaced_By_Day_Bool_Exp>;
};


export type Query_RootMv_Alerts_Surfaced_By_HourArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Hour_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Surfaced_By_Hour_Bool_Exp>;
};


export type Query_RootMv_Alerts_Surfaced_By_Hour_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Hour_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Surfaced_By_Hour_Bool_Exp>;
};


export type Query_RootMv_Alerts_Times_To_ActionedArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Times_To_Actioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Times_To_Actioned_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Times_To_Actioned_Bool_Exp>;
};


export type Query_RootMv_Alerts_Times_To_Actioned_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Times_To_Actioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Times_To_Actioned_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Times_To_Actioned_Bool_Exp>;
};


export type Query_RootMv_Alerts_VerifiedArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Verified_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Verified_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Verified_Bool_Exp>;
};


export type Query_RootMv_Alerts_Verified_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Verified_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Verified_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Verified_Bool_Exp>;
};


export type Query_RootMv_Dark_Web_Alerts_SurfacedArgs = {
  distinct_on?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_Order_By>>;
  where?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_Bool_Exp>;
};


export type Query_RootMv_Dark_Web_Alerts_Surfaced_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_Order_By>>;
  where?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_Bool_Exp>;
};


export type Query_RootMv_Dark_Web_Alerts_Surfaced_By_HourArgs = {
  distinct_on?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Order_By>>;
  where?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Bool_Exp>;
};


export type Query_RootMv_Dark_Web_Alerts_Surfaced_By_Hour_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Order_By>>;
  where?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Bool_Exp>;
};


export type Query_RootMv_Email_Alerts_Times_To_ActionedArgs = {
  distinct_on?: InputMaybe<Array<Mv_Email_Alerts_Times_To_Actioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Email_Alerts_Times_To_Actioned_Order_By>>;
  where?: InputMaybe<Mv_Email_Alerts_Times_To_Actioned_Bool_Exp>;
};


export type Query_RootMv_Email_Alerts_Times_To_Actioned_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Email_Alerts_Times_To_Actioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Email_Alerts_Times_To_Actioned_Order_By>>;
  where?: InputMaybe<Mv_Email_Alerts_Times_To_Actioned_Bool_Exp>;
};


export type Query_RootNft_Opensea_ProcessedArgs = {
  distinct_on?: InputMaybe<Array<Nft_Opensea_Processed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nft_Opensea_Processed_Order_By>>;
  where?: InputMaybe<Nft_Opensea_Processed_Bool_Exp>;
};


export type Query_RootNft_Opensea_Processed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nft_Opensea_Processed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nft_Opensea_Processed_Order_By>>;
  where?: InputMaybe<Nft_Opensea_Processed_Bool_Exp>;
};


export type Query_RootNft_Opensea_Processed_By_PkArgs = {
  direction: Scalars['String'];
};


export type Query_RootNft_Processing_CursorArgs = {
  distinct_on?: InputMaybe<Array<Nft_Processing_Cursor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nft_Processing_Cursor_Order_By>>;
  where?: InputMaybe<Nft_Processing_Cursor_Bool_Exp>;
};


export type Query_RootNft_Processing_Cursor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nft_Processing_Cursor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nft_Processing_Cursor_Order_By>>;
  where?: InputMaybe<Nft_Processing_Cursor_Bool_Exp>;
};


export type Query_RootNft_Processing_Cursor_By_PkArgs = {
  direction: Scalars['String'];
  marketplace: Scalars['String'];
};


export type Query_RootNotification_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Subscriptions_Order_By>>;
  where?: InputMaybe<Notification_Subscriptions_Bool_Exp>;
};


export type Query_RootNotification_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Subscriptions_Order_By>>;
  where?: InputMaybe<Notification_Subscriptions_Bool_Exp>;
};


export type Query_RootNotification_Subscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOpenai_Demo_ActionArgs = {
  open_ai_input: OpenAiInput;
};


export type Query_RootOrganization_Id_Api_KeysArgs = {
  distinct_on?: InputMaybe<Array<Organization_Id_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Id_Api_Keys_Order_By>>;
  where?: InputMaybe<Organization_Id_Api_Keys_Bool_Exp>;
};


export type Query_RootOrganization_Id_Api_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Id_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Id_Api_Keys_Order_By>>;
  where?: InputMaybe<Organization_Id_Api_Keys_Bool_Exp>;
};


export type Query_RootOrganization_Id_Api_Keys_By_PkArgs = {
  api_key: Scalars['String'];
};


export type Query_RootOrganization_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Products_Order_By>>;
  where?: InputMaybe<Organization_Products_Bool_Exp>;
};


export type Query_RootOrganization_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Products_Order_By>>;
  where?: InputMaybe<Organization_Products_Bool_Exp>;
};


export type Query_RootOrganization_Products_By_PkArgs = {
  organization_id: Scalars['uuid'];
  product: Scalars['String'];
};


export type Query_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Query_RootOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Query_RootOrganizations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganizations_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Metadata_Order_By>>;
  where?: InputMaybe<Organizations_Metadata_Bool_Exp>;
};


export type Query_RootOrganizations_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Metadata_Order_By>>;
  where?: InputMaybe<Organizations_Metadata_Bool_Exp>;
};


export type Query_RootOrganizations_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Query_RootPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Query_RootPermissions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Query_RootPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Query_RootPhone_Numbers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPii_DatabrokersArgs = {
  distinct_on?: InputMaybe<Array<Pii_Databrokers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Databrokers_Order_By>>;
  where?: InputMaybe<Pii_Databrokers_Bool_Exp>;
};


export type Query_RootPii_Databrokers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pii_Databrokers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Databrokers_Order_By>>;
  where?: InputMaybe<Pii_Databrokers_Bool_Exp>;
};


export type Query_RootPii_Databrokers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPii_EventsArgs = {
  distinct_on?: InputMaybe<Array<Pii_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Events_Order_By>>;
  where?: InputMaybe<Pii_Events_Bool_Exp>;
};


export type Query_RootPii_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pii_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Events_Order_By>>;
  where?: InputMaybe<Pii_Events_Bool_Exp>;
};


export type Query_RootPii_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPii_Leaks_By_DatabrokerArgs = {
  distinct_on?: InputMaybe<Array<Pii_Leaks_By_Databroker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Leaks_By_Databroker_Order_By>>;
  where?: InputMaybe<Pii_Leaks_By_Databroker_Bool_Exp>;
};


export type Query_RootPii_Leaks_By_Databroker_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pii_Leaks_By_Databroker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Leaks_By_Databroker_Order_By>>;
  where?: InputMaybe<Pii_Leaks_By_Databroker_Bool_Exp>;
};


export type Query_RootPii_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Pii_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Reports_Order_By>>;
  where?: InputMaybe<Pii_Reports_Bool_Exp>;
};


export type Query_RootPii_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pii_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Reports_Order_By>>;
  where?: InputMaybe<Pii_Reports_Bool_Exp>;
};


export type Query_RootPii_Reports_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPii_StatisticsArgs = {
  distinct_on?: InputMaybe<Array<Pii_Statistics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Statistics_Order_By>>;
  where?: InputMaybe<Pii_Statistics_Bool_Exp>;
};


export type Query_RootPii_Statistics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pii_Statistics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Statistics_Order_By>>;
  where?: InputMaybe<Pii_Statistics_Bool_Exp>;
};


export type Query_RootPii_Statistics_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlatform_SubtypesArgs = {
  distinct_on?: InputMaybe<Array<Platform_Subtypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Subtypes_Order_By>>;
  where?: InputMaybe<Platform_Subtypes_Bool_Exp>;
};


export type Query_RootPlatform_Subtypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Subtypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Subtypes_Order_By>>;
  where?: InputMaybe<Platform_Subtypes_Bool_Exp>;
};


export type Query_RootPlatform_Subtypes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPlatformsArgs = {
  distinct_on?: InputMaybe<Array<Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platforms_Order_By>>;
  where?: InputMaybe<Platforms_Bool_Exp>;
};


export type Query_RootPlatforms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platforms_Order_By>>;
  where?: InputMaybe<Platforms_Bool_Exp>;
};


export type Query_RootPlatforms_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootPre_CollectionsArgs = {
  distinct_on?: InputMaybe<Array<Pre_Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Collections_Order_By>>;
  where?: InputMaybe<Pre_Collections_Bool_Exp>;
};


export type Query_RootPre_Collections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pre_Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Collections_Order_By>>;
  where?: InputMaybe<Pre_Collections_Bool_Exp>;
};


export type Query_RootPre_Collections_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPredicted_Enforcement_TypesArgs = {
  distinct_on?: InputMaybe<Array<Predicted_Enforcement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Predicted_Enforcement_Types_Order_By>>;
  where?: InputMaybe<Predicted_Enforcement_Types_Bool_Exp>;
};


export type Query_RootPredicted_Enforcement_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Predicted_Enforcement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Predicted_Enforcement_Types_Order_By>>;
  where?: InputMaybe<Predicted_Enforcement_Types_Bool_Exp>;
};


export type Query_RootPredicted_Enforcement_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProtected_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Protected_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Protected_Assets_Order_By>>;
  where?: InputMaybe<Protected_Assets_Bool_Exp>;
};


export type Query_RootProtected_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Protected_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Protected_Assets_Order_By>>;
  where?: InputMaybe<Protected_Assets_Bool_Exp>;
};


export type Query_RootProtected_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootReport_TagsArgs = {
  distinct_on?: InputMaybe<Array<Report_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Tags_Order_By>>;
  where?: InputMaybe<Report_Tags_Bool_Exp>;
};


export type Query_RootReport_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Tags_Order_By>>;
  where?: InputMaybe<Report_Tags_Bool_Exp>;
};


export type Query_RootReport_Tags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootReports_To_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_To_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_To_Reports_Order_By>>;
  where?: InputMaybe<Reports_To_Reports_Bool_Exp>;
};


export type Query_RootReports_To_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_To_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_To_Reports_Order_By>>;
  where?: InputMaybe<Reports_To_Reports_Bool_Exp>;
};


export type Query_RootReports_To_Reports_By_PkArgs = {
  dest_report_id: Scalars['uuid'];
  relationship_type: Scalars['String'];
  source_report_id: Scalars['uuid'];
};


export type Query_RootRequest_Alert_Csv_ExportArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


export type Query_RootRole_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


export type Query_RootRole_Permissions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRulesArgs = {
  distinct_on?: InputMaybe<Array<Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rules_Order_By>>;
  where?: InputMaybe<Rules_Bool_Exp>;
};


export type Query_RootRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rules_Order_By>>;
  where?: InputMaybe<Rules_Bool_Exp>;
};


export type Query_RootRules_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootRun_Ocr_AnalysisArgs = {
  run_ocr_analysis_input: RunOcrAnalysisInput;
};


export type Query_RootSafelist_Ip_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Safelist_Ip_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Safelist_Ip_Addresses_Order_By>>;
  where?: InputMaybe<Safelist_Ip_Addresses_Bool_Exp>;
};


export type Query_RootSafelist_Ip_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safelist_Ip_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Safelist_Ip_Addresses_Order_By>>;
  where?: InputMaybe<Safelist_Ip_Addresses_Bool_Exp>;
};


export type Query_RootSafelist_Ip_Addresses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSalesforce_Organizations_DataArgs = {
  distinct_on?: InputMaybe<Array<Salesforce_Organizations_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salesforce_Organizations_Data_Order_By>>;
  where?: InputMaybe<Salesforce_Organizations_Data_Bool_Exp>;
};


export type Query_RootSalesforce_Organizations_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Salesforce_Organizations_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salesforce_Organizations_Data_Order_By>>;
  where?: InputMaybe<Salesforce_Organizations_Data_Bool_Exp>;
};


export type Query_RootSalesforce_Organizations_Data_By_PkArgs = {
  account_id: Scalars['String'];
};


export type Query_RootScan_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Scan_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scan_Results_Order_By>>;
  where?: InputMaybe<Scan_Results_Bool_Exp>;
};


export type Query_RootScan_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scan_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scan_Results_Order_By>>;
  where?: InputMaybe<Scan_Results_Bool_Exp>;
};


export type Query_RootScan_Results_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootScansArgs = {
  distinct_on?: InputMaybe<Array<Scans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scans_Order_By>>;
  where?: InputMaybe<Scans_Bool_Exp>;
};


export type Query_RootScans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scans_Order_By>>;
  where?: InputMaybe<Scans_Bool_Exp>;
};


export type Query_RootScans_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootScraping_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Scraping_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scraping_Configs_Order_By>>;
  where?: InputMaybe<Scraping_Configs_Bool_Exp>;
};


export type Query_RootScraping_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scraping_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scraping_Configs_Order_By>>;
  where?: InputMaybe<Scraping_Configs_Bool_Exp>;
};


export type Query_RootScraping_Configs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSearch_Spoofing_ReportsArgs = {
  args: Search_Spoofing_Reports_Args;
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


export type Query_RootSearch_Spoofing_Reports_AggregateArgs = {
  args: Search_Spoofing_Reports_Args;
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


export type Query_RootSim_Campaign_ObservationsArgs = {
  distinct_on?: InputMaybe<Array<Sim_Campaign_Observations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Campaign_Observations_Order_By>>;
  where?: InputMaybe<Sim_Campaign_Observations_Bool_Exp>;
};


export type Query_RootSim_Campaign_Observations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sim_Campaign_Observations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Campaign_Observations_Order_By>>;
  where?: InputMaybe<Sim_Campaign_Observations_Bool_Exp>;
};


export type Query_RootSim_Campaign_Observations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSim_CampaignsArgs = {
  distinct_on?: InputMaybe<Array<Sim_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Campaigns_Order_By>>;
  where?: InputMaybe<Sim_Campaigns_Bool_Exp>;
};


export type Query_RootSim_Campaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sim_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Campaigns_Order_By>>;
  where?: InputMaybe<Sim_Campaigns_Bool_Exp>;
};


export type Query_RootSim_Campaigns_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSim_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Sim_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Emails_Order_By>>;
  where?: InputMaybe<Sim_Emails_Bool_Exp>;
};


export type Query_RootSim_Emails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sim_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Emails_Order_By>>;
  where?: InputMaybe<Sim_Emails_Bool_Exp>;
};


export type Query_RootSim_Emails_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSim_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Sim_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Groups_Order_By>>;
  where?: InputMaybe<Sim_Groups_Bool_Exp>;
};


export type Query_RootSim_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sim_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Groups_Order_By>>;
  where?: InputMaybe<Sim_Groups_Bool_Exp>;
};


export type Query_RootSim_Groups_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSim_UsersArgs = {
  distinct_on?: InputMaybe<Array<Sim_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Users_Order_By>>;
  where?: InputMaybe<Sim_Users_Bool_Exp>;
};


export type Query_RootSim_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sim_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Users_Order_By>>;
  where?: InputMaybe<Sim_Users_Bool_Exp>;
};


export type Query_RootSim_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSlack_InstallationsArgs = {
  distinct_on?: InputMaybe<Array<Slack_Installations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Slack_Installations_Order_By>>;
  where?: InputMaybe<Slack_Installations_Bool_Exp>;
};


export type Query_RootSlack_Installations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Slack_Installations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Slack_Installations_Order_By>>;
  where?: InputMaybe<Slack_Installations_Bool_Exp>;
};


export type Query_RootSlack_Installations_By_PkArgs = {
  team_id: Scalars['String'];
};


export type Query_RootSocial_Media_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Comments_Order_By>>;
  where?: InputMaybe<Social_Media_Comments_Bool_Exp>;
};


export type Query_RootSocial_Media_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Comments_Order_By>>;
  where?: InputMaybe<Social_Media_Comments_Bool_Exp>;
};


export type Query_RootSocial_Media_Comments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSocial_Media_DataArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Data_Order_By>>;
  where?: InputMaybe<Social_Media_Data_Bool_Exp>;
};


export type Query_RootSocial_Media_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Data_Order_By>>;
  where?: InputMaybe<Social_Media_Data_Bool_Exp>;
};


export type Query_RootSocial_Media_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSocial_Media_GroupArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Group_Order_By>>;
  where?: InputMaybe<Social_Media_Group_Bool_Exp>;
};


export type Query_RootSocial_Media_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Group_Order_By>>;
  where?: InputMaybe<Social_Media_Group_Bool_Exp>;
};


export type Query_RootSocial_Media_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSocial_Media_PostArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Post_Order_By>>;
  where?: InputMaybe<Social_Media_Post_Bool_Exp>;
};


export type Query_RootSocial_Media_Post_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Post_Order_By>>;
  where?: InputMaybe<Social_Media_Post_Bool_Exp>;
};


export type Query_RootSocial_Media_Post_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSourcing_Adhoc_RequestArgs = {
  sourcing_adhoc_request_input: SourcingAdhocRequestInput;
};


export type Query_RootSourcing_QueriesArgs = {
  distinct_on?: InputMaybe<Array<Sourcing_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sourcing_Queries_Order_By>>;
  where?: InputMaybe<Sourcing_Queries_Bool_Exp>;
};


export type Query_RootSourcing_Queries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sourcing_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sourcing_Queries_Order_By>>;
  where?: InputMaybe<Sourcing_Queries_Bool_Exp>;
};


export type Query_RootSourcing_Queries_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSourcing_Query_ExecutionsArgs = {
  distinct_on?: InputMaybe<Array<Sourcing_Query_Executions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sourcing_Query_Executions_Order_By>>;
  where?: InputMaybe<Sourcing_Query_Executions_Bool_Exp>;
};


export type Query_RootSourcing_Query_Executions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sourcing_Query_Executions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sourcing_Query_Executions_Order_By>>;
  where?: InputMaybe<Sourcing_Query_Executions_Bool_Exp>;
};


export type Query_RootSourcing_Query_Executions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSpoof_MatchesArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};


export type Query_RootSpoof_Matches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};


export type Query_RootSpoof_Matches_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSpoofing_EntitiesArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Entities_Order_By>>;
  where?: InputMaybe<Spoofing_Entities_Bool_Exp>;
};


export type Query_RootSpoofing_Entities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Entities_Order_By>>;
  where?: InputMaybe<Spoofing_Entities_Bool_Exp>;
};


export type Query_RootSpoofing_Entities_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSpoofing_Report_Search_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Report_Search_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Report_Search_Results_Order_By>>;
  where?: InputMaybe<Spoofing_Report_Search_Results_Bool_Exp>;
};


export type Query_RootSpoofing_Report_Search_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Report_Search_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Report_Search_Results_Order_By>>;
  where?: InputMaybe<Spoofing_Report_Search_Results_Bool_Exp>;
};


export type Query_RootSpoofing_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


export type Query_RootSpoofing_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


export type Query_RootSpoofing_Reports_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSpoofing_Reports_To_TagsArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_To_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_To_Tags_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_To_Tags_Bool_Exp>;
};


export type Query_RootSpoofing_Reports_To_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_To_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_To_Tags_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_To_Tags_Bool_Exp>;
};


export type Query_RootSpoofing_Reports_To_Tags_By_PkArgs = {
  spoofing_report_id: Scalars['uuid'];
  tag_name: Scalars['String'];
};


export type Query_RootSuggested_EnforcementsArgs = {
  distinct_on?: InputMaybe<Array<Suggested_Enforcements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggested_Enforcements_Order_By>>;
  where?: InputMaybe<Suggested_Enforcements_Bool_Exp>;
};


export type Query_RootSuggested_Enforcements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Suggested_Enforcements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggested_Enforcements_Order_By>>;
  where?: InputMaybe<Suggested_Enforcements_Bool_Exp>;
};


export type Query_RootSuggested_Enforcements_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSuggested_Enforcements_Form_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Suggested_Enforcements_Form_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggested_Enforcements_Form_Responses_Order_By>>;
  where?: InputMaybe<Suggested_Enforcements_Form_Responses_Bool_Exp>;
};


export type Query_RootSuggested_Enforcements_Form_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Suggested_Enforcements_Form_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggested_Enforcements_Form_Responses_Order_By>>;
  where?: InputMaybe<Suggested_Enforcements_Form_Responses_Bool_Exp>;
};


export type Query_RootSuggested_Enforcements_Form_Responses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootThreat_Intel_Actor_To_CampaignArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
};


export type Query_RootThreat_Intel_Actor_To_Campaign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
};


export type Query_RootThreat_Intel_Actor_To_Campaign_By_PkArgs = {
  actor_id: Scalars['uuid'];
  campaign_id: Scalars['uuid'];
};


export type Query_RootThreat_Intel_ActorsArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actors_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actors_Bool_Exp>;
};


export type Query_RootThreat_Intel_Actors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actors_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actors_Bool_Exp>;
};


export type Query_RootThreat_Intel_Actors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootThreat_Intel_Campaign_To_EntitiesArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Order_By>>;
  where?: InputMaybe<Threat_Intel_Campaign_To_Entities_Bool_Exp>;
};


export type Query_RootThreat_Intel_Campaign_To_Entities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Order_By>>;
  where?: InputMaybe<Threat_Intel_Campaign_To_Entities_Bool_Exp>;
};


export type Query_RootThreat_Intel_Campaign_To_Entities_By_PkArgs = {
  campaign_id: Scalars['uuid'];
  entity_data_id: Scalars['uuid'];
};


export type Query_RootThreat_Intel_CampaignsArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Campaigns_Order_By>>;
  where?: InputMaybe<Threat_Intel_Campaigns_Bool_Exp>;
};


export type Query_RootThreat_Intel_Campaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Campaigns_Order_By>>;
  where?: InputMaybe<Threat_Intel_Campaigns_Bool_Exp>;
};


export type Query_RootThreat_Intel_Campaigns_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTrademarksArgs = {
  distinct_on?: InputMaybe<Array<Trademarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trademarks_Order_By>>;
  where?: InputMaybe<Trademarks_Bool_Exp>;
};


export type Query_RootTrademarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trademarks_Order_By>>;
  where?: InputMaybe<Trademarks_Bool_Exp>;
};


export type Query_RootTrademarks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUploaded_FilesArgs = {
  distinct_on?: InputMaybe<Array<Uploaded_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uploaded_Files_Order_By>>;
  where?: InputMaybe<Uploaded_Files_Bool_Exp>;
};


export type Query_RootUploaded_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uploaded_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uploaded_Files_Order_By>>;
  where?: InputMaybe<Uploaded_Files_Bool_Exp>;
};


export type Query_RootUploaded_Files_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<User_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Feedback_Order_By>>;
  where?: InputMaybe<User_Feedback_Bool_Exp>;
};


export type Query_RootUser_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Feedback_Order_By>>;
  where?: InputMaybe<User_Feedback_Bool_Exp>;
};


export type Query_RootUser_Feedback_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<User_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Organizations_Order_By>>;
  where?: InputMaybe<User_Organizations_Bool_Exp>;
};


export type Query_RootUser_Organizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Organizations_Order_By>>;
  where?: InputMaybe<User_Organizations_Bool_Exp>;
};


export type Query_RootUser_Organizations_By_PkArgs = {
  organization_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Query_RootUser_ProductsArgs = {
  distinct_on?: InputMaybe<Array<User_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Products_Order_By>>;
  where?: InputMaybe<User_Products_Bool_Exp>;
};


export type Query_RootUser_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Products_Order_By>>;
  where?: InputMaybe<User_Products_Bool_Exp>;
};


export type Query_RootUser_Products_By_PkArgs = {
  organization_id: Scalars['uuid'];
  product: Scalars['String'];
  user_id: Scalars['uuid'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootValidate_Entity_LinkArgs = {
  create_entity_links_input: CreateEntityLinksInput;
};


export type Query_RootVetric_Screenshot_WebhooksArgs = {
  distinct_on?: InputMaybe<Array<Vetric_Screenshot_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vetric_Screenshot_Webhooks_Order_By>>;
  where?: InputMaybe<Vetric_Screenshot_Webhooks_Bool_Exp>;
};


export type Query_RootVetric_Screenshot_Webhooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vetric_Screenshot_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vetric_Screenshot_Webhooks_Order_By>>;
  where?: InputMaybe<Vetric_Screenshot_Webhooks_Bool_Exp>;
};


export type Query_RootVetric_Screenshot_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWebhook_TargetsArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Targets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Webhook_Targets_Order_By>>;
  where?: InputMaybe<Webhook_Targets_Bool_Exp>;
};


export type Query_RootWebhook_Targets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Targets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Webhook_Targets_Order_By>>;
  where?: InputMaybe<Webhook_Targets_Bool_Exp>;
};


export type Query_RootWebhook_Targets_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "report_tags" */
export type Report_Tags = {
  __typename?: 'report_tags';
  id: Scalars['uuid'];
  report_id: Scalars['uuid'];
  /** An object relationship */
  spoofing_report: Spoofing_Reports;
  /** An object relationship */
  tag: Tags;
  tag_id: Scalars['uuid'];
};

/** aggregated selection of "report_tags" */
export type Report_Tags_Aggregate = {
  __typename?: 'report_tags_aggregate';
  aggregate?: Maybe<Report_Tags_Aggregate_Fields>;
  nodes: Array<Report_Tags>;
};

export type Report_Tags_Aggregate_Bool_Exp = {
  count?: InputMaybe<Report_Tags_Aggregate_Bool_Exp_Count>;
};

export type Report_Tags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Report_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Report_Tags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "report_tags" */
export type Report_Tags_Aggregate_Fields = {
  __typename?: 'report_tags_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Report_Tags_Max_Fields>;
  min?: Maybe<Report_Tags_Min_Fields>;
};


/** aggregate fields of "report_tags" */
export type Report_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Report_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "report_tags" */
export type Report_Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Report_Tags_Max_Order_By>;
  min?: InputMaybe<Report_Tags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "report_tags" */
export type Report_Tags_Arr_Rel_Insert_Input = {
  data: Array<Report_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Report_Tags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "report_tags". All fields are combined with a logical 'AND'. */
export type Report_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Report_Tags_Bool_Exp>>;
  _not?: InputMaybe<Report_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Report_Tags_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  report_id?: InputMaybe<Uuid_Comparison_Exp>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  tag?: InputMaybe<Tags_Bool_Exp>;
  tag_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "report_tags" */
export enum Report_Tags_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReportTagsPkey = 'report_tags_pkey',
  /** unique or primary key constraint on columns "report_id", "tag_id" */
  ReportTagsReportIdTagIdKey = 'report_tags_report_id_tag_id_key'
}

/** input type for inserting data into table "report_tags" */
export type Report_Tags_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  tag?: InputMaybe<Tags_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Report_Tags_Max_Fields = {
  __typename?: 'report_tags_max_fields';
  id?: Maybe<Scalars['uuid']>;
  report_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "report_tags" */
export type Report_Tags_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Report_Tags_Min_Fields = {
  __typename?: 'report_tags_min_fields';
  id?: Maybe<Scalars['uuid']>;
  report_id?: Maybe<Scalars['uuid']>;
  tag_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "report_tags" */
export type Report_Tags_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "report_tags" */
export type Report_Tags_Mutation_Response = {
  __typename?: 'report_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Report_Tags>;
};

/** on_conflict condition type for table "report_tags" */
export type Report_Tags_On_Conflict = {
  constraint: Report_Tags_Constraint;
  update_columns?: Array<Report_Tags_Update_Column>;
  where?: InputMaybe<Report_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "report_tags". */
export type Report_Tags_Order_By = {
  id?: InputMaybe<Order_By>;
  report_id?: InputMaybe<Order_By>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Order_By>;
  tag?: InputMaybe<Tags_Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: report_tags */
export type Report_Tags_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "report_tags" */
export enum Report_Tags_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  TagId = 'tag_id'
}

/** input type for updating data in table "report_tags" */
export type Report_Tags_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  tag_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "report_tags" */
export type Report_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Report_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Report_Tags_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  report_id?: InputMaybe<Scalars['uuid']>;
  tag_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "report_tags" */
export enum Report_Tags_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ReportId = 'report_id',
  /** column name */
  TagId = 'tag_id'
}

export type Report_Tags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Report_Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Report_Tags_Bool_Exp;
};

/** https://docs.google.com/document/d/1b1_yEgslIn7xJIc7bxm9ZAU1-MMzqcKx7zyCBmmnwO0/edit */
export type Reports_To_Reports = {
  __typename?: 'reports_to_reports';
  dest_report_id: Scalars['uuid'];
  relationship_type: Scalars['String'];
  source_report_id: Scalars['uuid'];
};

/** aggregated selection of "reports_to_reports" */
export type Reports_To_Reports_Aggregate = {
  __typename?: 'reports_to_reports_aggregate';
  aggregate?: Maybe<Reports_To_Reports_Aggregate_Fields>;
  nodes: Array<Reports_To_Reports>;
};

/** aggregate fields of "reports_to_reports" */
export type Reports_To_Reports_Aggregate_Fields = {
  __typename?: 'reports_to_reports_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Reports_To_Reports_Max_Fields>;
  min?: Maybe<Reports_To_Reports_Min_Fields>;
};


/** aggregate fields of "reports_to_reports" */
export type Reports_To_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reports_To_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "reports_to_reports". All fields are combined with a logical 'AND'. */
export type Reports_To_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Reports_To_Reports_Bool_Exp>>;
  _not?: InputMaybe<Reports_To_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Reports_To_Reports_Bool_Exp>>;
  dest_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  relationship_type?: InputMaybe<String_Comparison_Exp>;
  source_report_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "reports_to_reports" */
export enum Reports_To_Reports_Constraint {
  /** unique or primary key constraint on columns "relationship_type", "dest_report_id", "source_report_id" */
  ReportsToReportsPkey = 'reports_to_reports_pkey'
}

/** input type for inserting data into table "reports_to_reports" */
export type Reports_To_Reports_Insert_Input = {
  dest_report_id?: InputMaybe<Scalars['uuid']>;
  relationship_type?: InputMaybe<Scalars['String']>;
  source_report_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Reports_To_Reports_Max_Fields = {
  __typename?: 'reports_to_reports_max_fields';
  dest_report_id?: Maybe<Scalars['uuid']>;
  relationship_type?: Maybe<Scalars['String']>;
  source_report_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Reports_To_Reports_Min_Fields = {
  __typename?: 'reports_to_reports_min_fields';
  dest_report_id?: Maybe<Scalars['uuid']>;
  relationship_type?: Maybe<Scalars['String']>;
  source_report_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "reports_to_reports" */
export type Reports_To_Reports_Mutation_Response = {
  __typename?: 'reports_to_reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Reports_To_Reports>;
};

/** on_conflict condition type for table "reports_to_reports" */
export type Reports_To_Reports_On_Conflict = {
  constraint: Reports_To_Reports_Constraint;
  update_columns?: Array<Reports_To_Reports_Update_Column>;
  where?: InputMaybe<Reports_To_Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "reports_to_reports". */
export type Reports_To_Reports_Order_By = {
  dest_report_id?: InputMaybe<Order_By>;
  relationship_type?: InputMaybe<Order_By>;
  source_report_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reports_to_reports */
export type Reports_To_Reports_Pk_Columns_Input = {
  dest_report_id: Scalars['uuid'];
  relationship_type: Scalars['String'];
  source_report_id: Scalars['uuid'];
};

/** select columns of table "reports_to_reports" */
export enum Reports_To_Reports_Select_Column {
  /** column name */
  DestReportId = 'dest_report_id',
  /** column name */
  RelationshipType = 'relationship_type',
  /** column name */
  SourceReportId = 'source_report_id'
}

/** input type for updating data in table "reports_to_reports" */
export type Reports_To_Reports_Set_Input = {
  dest_report_id?: InputMaybe<Scalars['uuid']>;
  relationship_type?: InputMaybe<Scalars['String']>;
  source_report_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "reports_to_reports" */
export type Reports_To_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reports_To_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reports_To_Reports_Stream_Cursor_Value_Input = {
  dest_report_id?: InputMaybe<Scalars['uuid']>;
  relationship_type?: InputMaybe<Scalars['String']>;
  source_report_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "reports_to_reports" */
export enum Reports_To_Reports_Update_Column {
  /** column name */
  DestReportId = 'dest_report_id',
  /** column name */
  RelationshipType = 'relationship_type',
  /** column name */
  SourceReportId = 'source_report_id'
}

export type Reports_To_Reports_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reports_To_Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reports_To_Reports_Bool_Exp;
};

/** fields of action: "request_alert_csv_export" */
export type Request_Alert_Csv_Export = {
  __typename?: 'request_alert_csv_export';
  /** the time at which this action was created */
  created_at: Scalars['timestamptz'];
  /** errors related to the invocation */
  errors?: Maybe<Scalars['json']>;
  /** the unique id of an action */
  id: Scalars['uuid'];
  /** the output fields of this action */
  output?: Maybe<RequestAlertCsvExportOutput>;
};

/** columns and relationships of "role_permissions" */
export type Role_Permissions = {
  __typename?: 'role_permissions';
  id: Scalars['uuid'];
  /** An object relationship */
  permission: Permissions;
  permission_id: Scalars['uuid'];
  /** An object relationship */
  role: Roles;
  role_id: Scalars['uuid'];
};

/** aggregated selection of "role_permissions" */
export type Role_Permissions_Aggregate = {
  __typename?: 'role_permissions_aggregate';
  aggregate?: Maybe<Role_Permissions_Aggregate_Fields>;
  nodes: Array<Role_Permissions>;
};

export type Role_Permissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Role_Permissions_Aggregate_Bool_Exp_Count>;
};

export type Role_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Role_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "role_permissions" */
export type Role_Permissions_Aggregate_Fields = {
  __typename?: 'role_permissions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Role_Permissions_Max_Fields>;
  min?: Maybe<Role_Permissions_Min_Fields>;
};


/** aggregate fields of "role_permissions" */
export type Role_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "role_permissions" */
export type Role_Permissions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Role_Permissions_Max_Order_By>;
  min?: InputMaybe<Role_Permissions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "role_permissions" */
export type Role_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Role_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_Permissions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "role_permissions". All fields are combined with a logical 'AND'. */
export type Role_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Role_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Permissions_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  permission?: InputMaybe<Permissions_Bool_Exp>;
  permission_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "role_permissions" */
export enum Role_Permissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  RolePermissionsPkey = 'role_permissions_pkey',
  /** unique or primary key constraint on columns "permission_id", "role_id" */
  RolePermissionsRoleIdPermissionIdKey = 'role_permissions_role_id_permission_id_key'
}

/** input type for inserting data into table "role_permissions" */
export type Role_Permissions_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  permission?: InputMaybe<Permissions_Obj_Rel_Insert_Input>;
  permission_id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Role_Permissions_Max_Fields = {
  __typename?: 'role_permissions_max_fields';
  id?: Maybe<Scalars['uuid']>;
  permission_id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "role_permissions" */
export type Role_Permissions_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Role_Permissions_Min_Fields = {
  __typename?: 'role_permissions_min_fields';
  id?: Maybe<Scalars['uuid']>;
  permission_id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "role_permissions" */
export type Role_Permissions_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "role_permissions" */
export type Role_Permissions_Mutation_Response = {
  __typename?: 'role_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Role_Permissions>;
};

/** on_conflict condition type for table "role_permissions" */
export type Role_Permissions_On_Conflict = {
  constraint: Role_Permissions_Constraint;
  update_columns?: Array<Role_Permissions_Update_Column>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "role_permissions". */
export type Role_Permissions_Order_By = {
  id?: InputMaybe<Order_By>;
  permission?: InputMaybe<Permissions_Order_By>;
  permission_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: role_permissions */
export type Role_Permissions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "role_permissions" */
export enum Role_Permissions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  RoleId = 'role_id'
}

/** input type for updating data in table "role_permissions" */
export type Role_Permissions_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  permission_id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "role_permissions" */
export type Role_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Permissions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  permission_id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "role_permissions" */
export enum Role_Permissions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PermissionId = 'permission_id',
  /** column name */
  RoleId = 'role_id'
}

export type Role_Permissions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Permissions_Bool_Exp;
};

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  role_permissions: Array<Role_Permissions>;
  /** An aggregate relationship */
  role_permissions_aggregate: Role_Permissions_Aggregate;
};


/** columns and relationships of "roles" */
export type RolesRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


/** columns and relationships of "roles" */
export type RolesRole_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Roles_Max_Fields>;
  min?: Maybe<Roles_Min_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  role_permissions?: InputMaybe<Role_Permissions_Bool_Exp>;
  role_permissions_aggregate?: InputMaybe<Role_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint on columns "id" */
  RolesPkey = 'roles_pkey'
}

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  role_permissions?: InputMaybe<Role_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns?: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  role_permissions_aggregate?: InputMaybe<Role_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "roles" */
export type Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Roles_Bool_Exp;
};

/** stores rules that tie a set of conditions to actions */
export type Rules = {
  __typename?: 'rules';
  brand_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamptz'];
  created_by: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_enabled: Scalars['Boolean'];
  is_realtime: Scalars['Boolean'];
  last_updated_by?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  product_type: Scalars['String'];
  rule_expression: Scalars['jsonb'];
  /** An object relationship */
  spoofing_entity?: Maybe<Spoofing_Entities>;
  type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** stores rules that tie a set of conditions to actions */
export type RulesRule_ExpressionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "rules" */
export type Rules_Aggregate = {
  __typename?: 'rules_aggregate';
  aggregate?: Maybe<Rules_Aggregate_Fields>;
  nodes: Array<Rules>;
};

/** aggregate fields of "rules" */
export type Rules_Aggregate_Fields = {
  __typename?: 'rules_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Rules_Max_Fields>;
  min?: Maybe<Rules_Min_Fields>;
};


/** aggregate fields of "rules" */
export type Rules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Rules_Append_Input = {
  rule_expression?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "rules". All fields are combined with a logical 'AND'. */
export type Rules_Bool_Exp = {
  _and?: InputMaybe<Array<Rules_Bool_Exp>>;
  _not?: InputMaybe<Rules_Bool_Exp>;
  _or?: InputMaybe<Array<Rules_Bool_Exp>>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  is_realtime?: InputMaybe<Boolean_Comparison_Exp>;
  last_updated_by?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  product_type?: InputMaybe<String_Comparison_Exp>;
  rule_expression?: InputMaybe<Jsonb_Comparison_Exp>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rules" */
export enum Rules_Constraint {
  /** unique or primary key constraint on columns "id" */
  RulesPkey = 'rules_pkey',
  /** unique or primary key constraint on columns "rule_expression", "brand_id", "product_type" */
  RulesRuleExpressionBrandIdProductTypeKey = 'rules_rule_expression_brand_id_product_type_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Rules_Delete_At_Path_Input = {
  rule_expression?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Rules_Delete_Elem_Input = {
  rule_expression?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Rules_Delete_Key_Input = {
  rule_expression?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "rules" */
export type Rules_Insert_Input = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_enabled?: InputMaybe<Scalars['Boolean']>;
  is_realtime?: InputMaybe<Scalars['Boolean']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  product_type?: InputMaybe<Scalars['String']>;
  rule_expression?: InputMaybe<Scalars['jsonb']>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Rules_Max_Fields = {
  __typename?: 'rules_max_fields';
  brand_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Rules_Min_Fields = {
  __typename?: 'rules_min_fields';
  brand_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "rules" */
export type Rules_Mutation_Response = {
  __typename?: 'rules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Rules>;
};

/** input type for inserting object relation for remote table "rules" */
export type Rules_Obj_Rel_Insert_Input = {
  data: Rules_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Rules_On_Conflict>;
};

/** on_conflict condition type for table "rules" */
export type Rules_On_Conflict = {
  constraint: Rules_Constraint;
  update_columns?: Array<Rules_Update_Column>;
  where?: InputMaybe<Rules_Bool_Exp>;
};

/** Ordering options when selecting data from "rules". */
export type Rules_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_enabled?: InputMaybe<Order_By>;
  is_realtime?: InputMaybe<Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  product_type?: InputMaybe<Order_By>;
  rule_expression?: InputMaybe<Order_By>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rules */
export type Rules_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Rules_Prepend_Input = {
  rule_expression?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "rules" */
export enum Rules_Select_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsEnabled = 'is_enabled',
  /** column name */
  IsRealtime = 'is_realtime',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  ProductType = 'product_type',
  /** column name */
  RuleExpression = 'rule_expression',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "rules" */
export type Rules_Set_Input = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_enabled?: InputMaybe<Scalars['Boolean']>;
  is_realtime?: InputMaybe<Scalars['Boolean']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  product_type?: InputMaybe<Scalars['String']>;
  rule_expression?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "rules" */
export type Rules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rules_Stream_Cursor_Value_Input = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_enabled?: InputMaybe<Scalars['Boolean']>;
  is_realtime?: InputMaybe<Scalars['Boolean']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  product_type?: InputMaybe<Scalars['String']>;
  rule_expression?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "rules" */
export enum Rules_Update_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsEnabled = 'is_enabled',
  /** column name */
  IsRealtime = 'is_realtime',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  Notes = 'notes',
  /** column name */
  ProductType = 'product_type',
  /** column name */
  RuleExpression = 'rule_expression',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Rules_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Rules_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Rules_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Rules_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Rules_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Rules_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rules_Bool_Exp;
};

/** Holds the IP addresses in the safelist */
export type Safelist_Ip_Addresses = {
  __typename?: 'safelist_ip_addresses';
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  ip_address: Scalars['String'];
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id: Scalars['uuid'];
  status: Scalars['String'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** aggregated selection of "safelist_ip_addresses" */
export type Safelist_Ip_Addresses_Aggregate = {
  __typename?: 'safelist_ip_addresses_aggregate';
  aggregate?: Maybe<Safelist_Ip_Addresses_Aggregate_Fields>;
  nodes: Array<Safelist_Ip_Addresses>;
};

/** aggregate fields of "safelist_ip_addresses" */
export type Safelist_Ip_Addresses_Aggregate_Fields = {
  __typename?: 'safelist_ip_addresses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Safelist_Ip_Addresses_Max_Fields>;
  min?: Maybe<Safelist_Ip_Addresses_Min_Fields>;
};


/** aggregate fields of "safelist_ip_addresses" */
export type Safelist_Ip_Addresses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Safelist_Ip_Addresses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "safelist_ip_addresses". All fields are combined with a logical 'AND'. */
export type Safelist_Ip_Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Safelist_Ip_Addresses_Bool_Exp>>;
  _not?: InputMaybe<Safelist_Ip_Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Safelist_Ip_Addresses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip_address?: InputMaybe<String_Comparison_Exp>;
  last_updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "safelist_ip_addresses" */
export enum Safelist_Ip_Addresses_Constraint {
  /** unique or primary key constraint on columns "ip_address", "organization_id" */
  SafelistIpAddressesOrganizationIdIpAddressKey = 'safelist_ip_addresses_organization_id_ip_address_key',
  /** unique or primary key constraint on columns "id" */
  SafelistIpAddressesPkey = 'safelist_ip_addresses_pkey'
}

/** input type for inserting data into table "safelist_ip_addresses" */
export type Safelist_Ip_Addresses_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip_address?: InputMaybe<Scalars['String']>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Safelist_Ip_Addresses_Max_Fields = {
  __typename?: 'safelist_ip_addresses_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  ip_address?: Maybe<Scalars['String']>;
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Safelist_Ip_Addresses_Min_Fields = {
  __typename?: 'safelist_ip_addresses_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  ip_address?: Maybe<Scalars['String']>;
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "safelist_ip_addresses" */
export type Safelist_Ip_Addresses_Mutation_Response = {
  __typename?: 'safelist_ip_addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Safelist_Ip_Addresses>;
};

/** on_conflict condition type for table "safelist_ip_addresses" */
export type Safelist_Ip_Addresses_On_Conflict = {
  constraint: Safelist_Ip_Addresses_Constraint;
  update_columns?: Array<Safelist_Ip_Addresses_Update_Column>;
  where?: InputMaybe<Safelist_Ip_Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "safelist_ip_addresses". */
export type Safelist_Ip_Addresses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  last_updated_by_user_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: safelist_ip_addresses */
export type Safelist_Ip_Addresses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "safelist_ip_addresses" */
export enum Safelist_Ip_Addresses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  LastUpdatedByUserId = 'last_updated_by_user_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "safelist_ip_addresses" */
export type Safelist_Ip_Addresses_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip_address?: InputMaybe<Scalars['String']>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "safelist_ip_addresses" */
export type Safelist_Ip_Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Safelist_Ip_Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Safelist_Ip_Addresses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip_address?: InputMaybe<Scalars['String']>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "safelist_ip_addresses" */
export enum Safelist_Ip_Addresses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  LastUpdatedByUserId = 'last_updated_by_user_id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Safelist_Ip_Addresses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Safelist_Ip_Addresses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Safelist_Ip_Addresses_Bool_Exp;
};

/** columns and relationships of "salesforce_organizations_data" */
export type Salesforce_Organizations_Data = {
  __typename?: 'salesforce_organizations_data';
  account_id: Scalars['String'];
  account_name?: Maybe<Scalars['String']>;
  account_owner?: Maybe<Scalars['String']>;
  annual_revenue?: Maybe<Scalars['String']>;
  billing_city?: Maybe<Scalars['String']>;
  billing_country?: Maybe<Scalars['String']>;
  billing_postal_code?: Maybe<Scalars['String']>;
  billing_state?: Maybe<Scalars['String']>;
  billing_street?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  created_by_email?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  number_of_employees?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  organization_by_salesforce_account_id?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']>;
  owner_email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
  sic_description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregated selection of "salesforce_organizations_data" */
export type Salesforce_Organizations_Data_Aggregate = {
  __typename?: 'salesforce_organizations_data_aggregate';
  aggregate?: Maybe<Salesforce_Organizations_Data_Aggregate_Fields>;
  nodes: Array<Salesforce_Organizations_Data>;
};

/** aggregate fields of "salesforce_organizations_data" */
export type Salesforce_Organizations_Data_Aggregate_Fields = {
  __typename?: 'salesforce_organizations_data_aggregate_fields';
  avg?: Maybe<Salesforce_Organizations_Data_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Salesforce_Organizations_Data_Max_Fields>;
  min?: Maybe<Salesforce_Organizations_Data_Min_Fields>;
  stddev?: Maybe<Salesforce_Organizations_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Salesforce_Organizations_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Salesforce_Organizations_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Salesforce_Organizations_Data_Sum_Fields>;
  var_pop?: Maybe<Salesforce_Organizations_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Salesforce_Organizations_Data_Var_Samp_Fields>;
  variance?: Maybe<Salesforce_Organizations_Data_Variance_Fields>;
};


/** aggregate fields of "salesforce_organizations_data" */
export type Salesforce_Organizations_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Salesforce_Organizations_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Salesforce_Organizations_Data_Avg_Fields = {
  __typename?: 'salesforce_organizations_data_avg_fields';
  number_of_employees?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "salesforce_organizations_data". All fields are combined with a logical 'AND'. */
export type Salesforce_Organizations_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Salesforce_Organizations_Data_Bool_Exp>>;
  _not?: InputMaybe<Salesforce_Organizations_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Salesforce_Organizations_Data_Bool_Exp>>;
  account_id?: InputMaybe<String_Comparison_Exp>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  account_owner?: InputMaybe<String_Comparison_Exp>;
  annual_revenue?: InputMaybe<String_Comparison_Exp>;
  billing_city?: InputMaybe<String_Comparison_Exp>;
  billing_country?: InputMaybe<String_Comparison_Exp>;
  billing_postal_code?: InputMaybe<String_Comparison_Exp>;
  billing_state?: InputMaybe<String_Comparison_Exp>;
  billing_street?: InputMaybe<String_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  created_by_email?: InputMaybe<String_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  industry?: InputMaybe<String_Comparison_Exp>;
  number_of_employees?: InputMaybe<Bigint_Comparison_Exp>;
  organization_by_salesforce_account_id?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_email?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  segment?: InputMaybe<String_Comparison_Exp>;
  sic_description?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "salesforce_organizations_data" */
export enum Salesforce_Organizations_Data_Constraint {
  /** unique or primary key constraint on columns "account_id" */
  SalesforceOrganizationsDataPkey = 'salesforce_organizations_data_pkey'
}

/** input type for incrementing numeric columns in table "salesforce_organizations_data" */
export type Salesforce_Organizations_Data_Inc_Input = {
  number_of_employees?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "salesforce_organizations_data" */
export type Salesforce_Organizations_Data_Insert_Input = {
  account_id?: InputMaybe<Scalars['String']>;
  account_name?: InputMaybe<Scalars['String']>;
  account_owner?: InputMaybe<Scalars['String']>;
  annual_revenue?: InputMaybe<Scalars['String']>;
  billing_city?: InputMaybe<Scalars['String']>;
  billing_country?: InputMaybe<Scalars['String']>;
  billing_postal_code?: InputMaybe<Scalars['String']>;
  billing_state?: InputMaybe<Scalars['String']>;
  billing_street?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_by_email?: InputMaybe<Scalars['String']>;
  created_date?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  number_of_employees?: InputMaybe<Scalars['bigint']>;
  organization_by_salesforce_account_id?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  owner_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<Scalars['String']>;
  sic_description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Salesforce_Organizations_Data_Max_Fields = {
  __typename?: 'salesforce_organizations_data_max_fields';
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  account_owner?: Maybe<Scalars['String']>;
  annual_revenue?: Maybe<Scalars['String']>;
  billing_city?: Maybe<Scalars['String']>;
  billing_country?: Maybe<Scalars['String']>;
  billing_postal_code?: Maybe<Scalars['String']>;
  billing_state?: Maybe<Scalars['String']>;
  billing_street?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  created_by_email?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  number_of_employees?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  owner_email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
  sic_description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Salesforce_Organizations_Data_Min_Fields = {
  __typename?: 'salesforce_organizations_data_min_fields';
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  account_owner?: Maybe<Scalars['String']>;
  annual_revenue?: Maybe<Scalars['String']>;
  billing_city?: Maybe<Scalars['String']>;
  billing_country?: Maybe<Scalars['String']>;
  billing_postal_code?: Maybe<Scalars['String']>;
  billing_state?: Maybe<Scalars['String']>;
  billing_street?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['String']>;
  created_by_email?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  number_of_employees?: Maybe<Scalars['bigint']>;
  organization_id?: Maybe<Scalars['uuid']>;
  owner_email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  segment?: Maybe<Scalars['String']>;
  sic_description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "salesforce_organizations_data" */
export type Salesforce_Organizations_Data_Mutation_Response = {
  __typename?: 'salesforce_organizations_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Salesforce_Organizations_Data>;
};

/** input type for inserting object relation for remote table "salesforce_organizations_data" */
export type Salesforce_Organizations_Data_Obj_Rel_Insert_Input = {
  data: Salesforce_Organizations_Data_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Salesforce_Organizations_Data_On_Conflict>;
};

/** on_conflict condition type for table "salesforce_organizations_data" */
export type Salesforce_Organizations_Data_On_Conflict = {
  constraint: Salesforce_Organizations_Data_Constraint;
  update_columns?: Array<Salesforce_Organizations_Data_Update_Column>;
  where?: InputMaybe<Salesforce_Organizations_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "salesforce_organizations_data". */
export type Salesforce_Organizations_Data_Order_By = {
  account_id?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  account_owner?: InputMaybe<Order_By>;
  annual_revenue?: InputMaybe<Order_By>;
  billing_city?: InputMaybe<Order_By>;
  billing_country?: InputMaybe<Order_By>;
  billing_postal_code?: InputMaybe<Order_By>;
  billing_state?: InputMaybe<Order_By>;
  billing_street?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_email?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  industry?: InputMaybe<Order_By>;
  number_of_employees?: InputMaybe<Order_By>;
  organization_by_salesforce_account_id?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  owner_email?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  segment?: InputMaybe<Order_By>;
  sic_description?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: salesforce_organizations_data */
export type Salesforce_Organizations_Data_Pk_Columns_Input = {
  account_id: Scalars['String'];
};

/** select columns of table "salesforce_organizations_data" */
export enum Salesforce_Organizations_Data_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AccountOwner = 'account_owner',
  /** column name */
  AnnualRevenue = 'annual_revenue',
  /** column name */
  BillingCity = 'billing_city',
  /** column name */
  BillingCountry = 'billing_country',
  /** column name */
  BillingPostalCode = 'billing_postal_code',
  /** column name */
  BillingState = 'billing_state',
  /** column name */
  BillingStreet = 'billing_street',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedByEmail = 'created_by_email',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Description = 'description',
  /** column name */
  Industry = 'industry',
  /** column name */
  NumberOfEmployees = 'number_of_employees',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OwnerEmail = 'owner_email',
  /** column name */
  Phone = 'phone',
  /** column name */
  Segment = 'segment',
  /** column name */
  SicDescription = 'sic_description',
  /** column name */
  Type = 'type',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "salesforce_organizations_data" */
export type Salesforce_Organizations_Data_Set_Input = {
  account_id?: InputMaybe<Scalars['String']>;
  account_name?: InputMaybe<Scalars['String']>;
  account_owner?: InputMaybe<Scalars['String']>;
  annual_revenue?: InputMaybe<Scalars['String']>;
  billing_city?: InputMaybe<Scalars['String']>;
  billing_country?: InputMaybe<Scalars['String']>;
  billing_postal_code?: InputMaybe<Scalars['String']>;
  billing_state?: InputMaybe<Scalars['String']>;
  billing_street?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_by_email?: InputMaybe<Scalars['String']>;
  created_date?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  number_of_employees?: InputMaybe<Scalars['bigint']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  owner_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<Scalars['String']>;
  sic_description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Salesforce_Organizations_Data_Stddev_Fields = {
  __typename?: 'salesforce_organizations_data_stddev_fields';
  number_of_employees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Salesforce_Organizations_Data_Stddev_Pop_Fields = {
  __typename?: 'salesforce_organizations_data_stddev_pop_fields';
  number_of_employees?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Salesforce_Organizations_Data_Stddev_Samp_Fields = {
  __typename?: 'salesforce_organizations_data_stddev_samp_fields';
  number_of_employees?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "salesforce_organizations_data" */
export type Salesforce_Organizations_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Salesforce_Organizations_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Salesforce_Organizations_Data_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['String']>;
  account_name?: InputMaybe<Scalars['String']>;
  account_owner?: InputMaybe<Scalars['String']>;
  annual_revenue?: InputMaybe<Scalars['String']>;
  billing_city?: InputMaybe<Scalars['String']>;
  billing_country?: InputMaybe<Scalars['String']>;
  billing_postal_code?: InputMaybe<Scalars['String']>;
  billing_state?: InputMaybe<Scalars['String']>;
  billing_street?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_by_email?: InputMaybe<Scalars['String']>;
  created_date?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  number_of_employees?: InputMaybe<Scalars['bigint']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  owner_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  segment?: InputMaybe<Scalars['String']>;
  sic_description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Salesforce_Organizations_Data_Sum_Fields = {
  __typename?: 'salesforce_organizations_data_sum_fields';
  number_of_employees?: Maybe<Scalars['bigint']>;
};

/** update columns of table "salesforce_organizations_data" */
export enum Salesforce_Organizations_Data_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AccountOwner = 'account_owner',
  /** column name */
  AnnualRevenue = 'annual_revenue',
  /** column name */
  BillingCity = 'billing_city',
  /** column name */
  BillingCountry = 'billing_country',
  /** column name */
  BillingPostalCode = 'billing_postal_code',
  /** column name */
  BillingState = 'billing_state',
  /** column name */
  BillingStreet = 'billing_street',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CreatedByEmail = 'created_by_email',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Description = 'description',
  /** column name */
  Industry = 'industry',
  /** column name */
  NumberOfEmployees = 'number_of_employees',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OwnerEmail = 'owner_email',
  /** column name */
  Phone = 'phone',
  /** column name */
  Segment = 'segment',
  /** column name */
  SicDescription = 'sic_description',
  /** column name */
  Type = 'type',
  /** column name */
  Website = 'website'
}

export type Salesforce_Organizations_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Salesforce_Organizations_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Salesforce_Organizations_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Salesforce_Organizations_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Salesforce_Organizations_Data_Var_Pop_Fields = {
  __typename?: 'salesforce_organizations_data_var_pop_fields';
  number_of_employees?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Salesforce_Organizations_Data_Var_Samp_Fields = {
  __typename?: 'salesforce_organizations_data_var_samp_fields';
  number_of_employees?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Salesforce_Organizations_Data_Variance_Fields = {
  __typename?: 'salesforce_organizations_data_variance_fields';
  number_of_employees?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "scan_results" */
export type Scan_Results = {
  __typename?: 'scan_results';
  category: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  scan?: Maybe<Scans>;
  scan_data?: Maybe<Scalars['jsonb']>;
  scan_id: Scalars['uuid'];
  suspiciousness: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "scan_results" */
export type Scan_ResultsScan_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "scan_results" */
export type Scan_Results_Aggregate = {
  __typename?: 'scan_results_aggregate';
  aggregate?: Maybe<Scan_Results_Aggregate_Fields>;
  nodes: Array<Scan_Results>;
};

export type Scan_Results_Aggregate_Bool_Exp = {
  count?: InputMaybe<Scan_Results_Aggregate_Bool_Exp_Count>;
};

export type Scan_Results_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Scan_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Scan_Results_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "scan_results" */
export type Scan_Results_Aggregate_Fields = {
  __typename?: 'scan_results_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Scan_Results_Max_Fields>;
  min?: Maybe<Scan_Results_Min_Fields>;
};


/** aggregate fields of "scan_results" */
export type Scan_Results_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scan_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "scan_results" */
export type Scan_Results_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Scan_Results_Max_Order_By>;
  min?: InputMaybe<Scan_Results_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Scan_Results_Append_Input = {
  scan_data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "scan_results" */
export type Scan_Results_Arr_Rel_Insert_Input = {
  data: Array<Scan_Results_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Scan_Results_On_Conflict>;
};

/** Boolean expression to filter rows from the table "scan_results". All fields are combined with a logical 'AND'. */
export type Scan_Results_Bool_Exp = {
  _and?: InputMaybe<Array<Scan_Results_Bool_Exp>>;
  _not?: InputMaybe<Scan_Results_Bool_Exp>;
  _or?: InputMaybe<Array<Scan_Results_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  scan?: InputMaybe<Scans_Bool_Exp>;
  scan_data?: InputMaybe<Jsonb_Comparison_Exp>;
  scan_id?: InputMaybe<Uuid_Comparison_Exp>;
  suspiciousness?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "scan_results" */
export enum Scan_Results_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScanResultsPkey = 'scan_results_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Scan_Results_Delete_At_Path_Input = {
  scan_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Scan_Results_Delete_Elem_Input = {
  scan_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Scan_Results_Delete_Key_Input = {
  scan_data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "scan_results" */
export type Scan_Results_Insert_Input = {
  category?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  scan?: InputMaybe<Scans_Obj_Rel_Insert_Input>;
  scan_data?: InputMaybe<Scalars['jsonb']>;
  scan_id?: InputMaybe<Scalars['uuid']>;
  suspiciousness?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Scan_Results_Max_Fields = {
  __typename?: 'scan_results_max_fields';
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  scan_id?: Maybe<Scalars['uuid']>;
  suspiciousness?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "scan_results" */
export type Scan_Results_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scan_id?: InputMaybe<Order_By>;
  suspiciousness?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Scan_Results_Min_Fields = {
  __typename?: 'scan_results_min_fields';
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  scan_id?: Maybe<Scalars['uuid']>;
  suspiciousness?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "scan_results" */
export type Scan_Results_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scan_id?: InputMaybe<Order_By>;
  suspiciousness?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "scan_results" */
export type Scan_Results_Mutation_Response = {
  __typename?: 'scan_results_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Scan_Results>;
};

/** on_conflict condition type for table "scan_results" */
export type Scan_Results_On_Conflict = {
  constraint: Scan_Results_Constraint;
  update_columns?: Array<Scan_Results_Update_Column>;
  where?: InputMaybe<Scan_Results_Bool_Exp>;
};

/** Ordering options when selecting data from "scan_results". */
export type Scan_Results_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  scan?: InputMaybe<Scans_Order_By>;
  scan_data?: InputMaybe<Order_By>;
  scan_id?: InputMaybe<Order_By>;
  suspiciousness?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scan_results */
export type Scan_Results_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Scan_Results_Prepend_Input = {
  scan_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "scan_results" */
export enum Scan_Results_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ScanData = 'scan_data',
  /** column name */
  ScanId = 'scan_id',
  /** column name */
  Suspiciousness = 'suspiciousness',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "scan_results" */
export type Scan_Results_Set_Input = {
  category?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  scan_data?: InputMaybe<Scalars['jsonb']>;
  scan_id?: InputMaybe<Scalars['uuid']>;
  suspiciousness?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "scan_results" */
export type Scan_Results_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scan_Results_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scan_Results_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  scan_data?: InputMaybe<Scalars['jsonb']>;
  scan_id?: InputMaybe<Scalars['uuid']>;
  suspiciousness?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "scan_results" */
export enum Scan_Results_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ScanData = 'scan_data',
  /** column name */
  ScanId = 'scan_id',
  /** column name */
  Suspiciousness = 'suspiciousness',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Scan_Results_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Scan_Results_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Scan_Results_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Scan_Results_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Scan_Results_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Scan_Results_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scan_Results_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scan_Results_Bool_Exp;
};

/** columns and relationships of "scans" */
export type Scans = {
  __typename?: 'scans';
  associated_urls: Array<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  organization_id: Scalars['uuid'];
  /** An array relationship */
  scan_results: Array<Scan_Results>;
  /** An aggregate relationship */
  scan_results_aggregate: Scan_Results_Aggregate;
  url: Scalars['String'];
};


/** columns and relationships of "scans" */
export type ScansScan_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Scan_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scan_Results_Order_By>>;
  where?: InputMaybe<Scan_Results_Bool_Exp>;
};


/** columns and relationships of "scans" */
export type ScansScan_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scan_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scan_Results_Order_By>>;
  where?: InputMaybe<Scan_Results_Bool_Exp>;
};

/** aggregated selection of "scans" */
export type Scans_Aggregate = {
  __typename?: 'scans_aggregate';
  aggregate?: Maybe<Scans_Aggregate_Fields>;
  nodes: Array<Scans>;
};

/** aggregate fields of "scans" */
export type Scans_Aggregate_Fields = {
  __typename?: 'scans_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Scans_Max_Fields>;
  min?: Maybe<Scans_Min_Fields>;
};


/** aggregate fields of "scans" */
export type Scans_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scans_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "scans". All fields are combined with a logical 'AND'. */
export type Scans_Bool_Exp = {
  _and?: InputMaybe<Array<Scans_Bool_Exp>>;
  _not?: InputMaybe<Scans_Bool_Exp>;
  _or?: InputMaybe<Array<Scans_Bool_Exp>>;
  associated_urls?: InputMaybe<String_Array_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  scan_results?: InputMaybe<Scan_Results_Bool_Exp>;
  scan_results_aggregate?: InputMaybe<Scan_Results_Aggregate_Bool_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "scans" */
export enum Scans_Constraint {
  /** unique or primary key constraint on columns "id" */
  ScanApiUrlsPkey = 'scan_api_urls_pkey'
}

/** input type for inserting data into table "scans" */
export type Scans_Insert_Input = {
  associated_urls?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  scan_results?: InputMaybe<Scan_Results_Arr_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Scans_Max_Fields = {
  __typename?: 'scans_max_fields';
  associated_urls?: Maybe<Array<Scalars['String']>>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Scans_Min_Fields = {
  __typename?: 'scans_min_fields';
  associated_urls?: Maybe<Array<Scalars['String']>>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "scans" */
export type Scans_Mutation_Response = {
  __typename?: 'scans_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Scans>;
};

/** input type for inserting object relation for remote table "scans" */
export type Scans_Obj_Rel_Insert_Input = {
  data: Scans_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Scans_On_Conflict>;
};

/** on_conflict condition type for table "scans" */
export type Scans_On_Conflict = {
  constraint: Scans_Constraint;
  update_columns?: Array<Scans_Update_Column>;
  where?: InputMaybe<Scans_Bool_Exp>;
};

/** Ordering options when selecting data from "scans". */
export type Scans_Order_By = {
  associated_urls?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  scan_results_aggregate?: InputMaybe<Scan_Results_Aggregate_Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scans */
export type Scans_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "scans" */
export enum Scans_Select_Column {
  /** column name */
  AssociatedUrls = 'associated_urls',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "scans" */
export type Scans_Set_Input = {
  associated_urls?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "scans" */
export type Scans_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scans_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scans_Stream_Cursor_Value_Input = {
  associated_urls?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "scans" */
export enum Scans_Update_Column {
  /** column name */
  AssociatedUrls = 'associated_urls',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Url = 'url'
}

export type Scans_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scans_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scans_Bool_Exp;
};

/** Contains custom, org-specific scraping configurations used by our scrapers */
export type Scraping_Configs = {
  __typename?: 'scraping_configs';
  config: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  last_updated_by?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};


/** Contains custom, org-specific scraping configurations used by our scrapers */
export type Scraping_ConfigsConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "scraping_configs" */
export type Scraping_Configs_Aggregate = {
  __typename?: 'scraping_configs_aggregate';
  aggregate?: Maybe<Scraping_Configs_Aggregate_Fields>;
  nodes: Array<Scraping_Configs>;
};

/** aggregate fields of "scraping_configs" */
export type Scraping_Configs_Aggregate_Fields = {
  __typename?: 'scraping_configs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Scraping_Configs_Max_Fields>;
  min?: Maybe<Scraping_Configs_Min_Fields>;
};


/** aggregate fields of "scraping_configs" */
export type Scraping_Configs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scraping_Configs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Scraping_Configs_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "scraping_configs". All fields are combined with a logical 'AND'. */
export type Scraping_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Scraping_Configs_Bool_Exp>>;
  _not?: InputMaybe<Scraping_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Scraping_Configs_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_updated_by?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "scraping_configs" */
export enum Scraping_Configs_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  ScrapingConfigsOrganizationIdKey = 'scraping_configs_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  ScrapingConfigsPkey = 'scraping_configs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Scraping_Configs_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Scraping_Configs_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Scraping_Configs_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "scraping_configs" */
export type Scraping_Configs_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Scraping_Configs_Max_Fields = {
  __typename?: 'scraping_configs_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Scraping_Configs_Min_Fields = {
  __typename?: 'scraping_configs_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "scraping_configs" */
export type Scraping_Configs_Mutation_Response = {
  __typename?: 'scraping_configs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Scraping_Configs>;
};

/** on_conflict condition type for table "scraping_configs" */
export type Scraping_Configs_On_Conflict = {
  constraint: Scraping_Configs_Constraint;
  update_columns?: Array<Scraping_Configs_Update_Column>;
  where?: InputMaybe<Scraping_Configs_Bool_Exp>;
};

/** Ordering options when selecting data from "scraping_configs". */
export type Scraping_Configs_Order_By = {
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: scraping_configs */
export type Scraping_Configs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Scraping_Configs_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "scraping_configs" */
export enum Scraping_Configs_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "scraping_configs" */
export type Scraping_Configs_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "scraping_configs" */
export type Scraping_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scraping_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scraping_Configs_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "scraping_configs" */
export enum Scraping_Configs_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Scraping_Configs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Scraping_Configs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Scraping_Configs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Scraping_Configs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Scraping_Configs_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Scraping_Configs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scraping_Configs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scraping_Configs_Bool_Exp;
};

export type Search_Spoofing_Reports_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "sim_campaign_observations" */
export type Sim_Campaign_Observations = {
  __typename?: 'sim_campaign_observations';
  action: Scalars['String'];
  campaign_id: Scalars['uuid'];
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  org_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  /** An object relationship */
  sim_campaign: Sim_Campaigns;
  /** An object relationship */
  sim_email?: Maybe<Sim_Emails>;
  sim_email_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  sim_user: Sim_Users;
  sim_user_id: Scalars['uuid'];
};

/** aggregated selection of "sim_campaign_observations" */
export type Sim_Campaign_Observations_Aggregate = {
  __typename?: 'sim_campaign_observations_aggregate';
  aggregate?: Maybe<Sim_Campaign_Observations_Aggregate_Fields>;
  nodes: Array<Sim_Campaign_Observations>;
};

/** aggregate fields of "sim_campaign_observations" */
export type Sim_Campaign_Observations_Aggregate_Fields = {
  __typename?: 'sim_campaign_observations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Sim_Campaign_Observations_Max_Fields>;
  min?: Maybe<Sim_Campaign_Observations_Min_Fields>;
};


/** aggregate fields of "sim_campaign_observations" */
export type Sim_Campaign_Observations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sim_Campaign_Observations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "sim_campaign_observations". All fields are combined with a logical 'AND'. */
export type Sim_Campaign_Observations_Bool_Exp = {
  _and?: InputMaybe<Array<Sim_Campaign_Observations_Bool_Exp>>;
  _not?: InputMaybe<Sim_Campaign_Observations_Bool_Exp>;
  _or?: InputMaybe<Array<Sim_Campaign_Observations_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  sim_campaign?: InputMaybe<Sim_Campaigns_Bool_Exp>;
  sim_email?: InputMaybe<Sim_Emails_Bool_Exp>;
  sim_email_id?: InputMaybe<Uuid_Comparison_Exp>;
  sim_user?: InputMaybe<Sim_Users_Bool_Exp>;
  sim_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "sim_campaign_observations" */
export enum Sim_Campaign_Observations_Constraint {
  /** unique or primary key constraint on columns "id" */
  SimCampaignObservationsPkey = 'sim_campaign_observations_pkey'
}

/** input type for inserting data into table "sim_campaign_observations" */
export type Sim_Campaign_Observations_Insert_Input = {
  action?: InputMaybe<Scalars['String']>;
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  sim_campaign?: InputMaybe<Sim_Campaigns_Obj_Rel_Insert_Input>;
  sim_email?: InputMaybe<Sim_Emails_Obj_Rel_Insert_Input>;
  sim_email_id?: InputMaybe<Scalars['uuid']>;
  sim_user?: InputMaybe<Sim_Users_Obj_Rel_Insert_Input>;
  sim_user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Sim_Campaign_Observations_Max_Fields = {
  __typename?: 'sim_campaign_observations_max_fields';
  action?: Maybe<Scalars['String']>;
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  sim_email_id?: Maybe<Scalars['uuid']>;
  sim_user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Sim_Campaign_Observations_Min_Fields = {
  __typename?: 'sim_campaign_observations_min_fields';
  action?: Maybe<Scalars['String']>;
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  sim_email_id?: Maybe<Scalars['uuid']>;
  sim_user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "sim_campaign_observations" */
export type Sim_Campaign_Observations_Mutation_Response = {
  __typename?: 'sim_campaign_observations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sim_Campaign_Observations>;
};

/** on_conflict condition type for table "sim_campaign_observations" */
export type Sim_Campaign_Observations_On_Conflict = {
  constraint: Sim_Campaign_Observations_Constraint;
  update_columns?: Array<Sim_Campaign_Observations_Update_Column>;
  where?: InputMaybe<Sim_Campaign_Observations_Bool_Exp>;
};

/** Ordering options when selecting data from "sim_campaign_observations". */
export type Sim_Campaign_Observations_Order_By = {
  action?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  sim_campaign?: InputMaybe<Sim_Campaigns_Order_By>;
  sim_email?: InputMaybe<Sim_Emails_Order_By>;
  sim_email_id?: InputMaybe<Order_By>;
  sim_user?: InputMaybe<Sim_Users_Order_By>;
  sim_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sim_campaign_observations */
export type Sim_Campaign_Observations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "sim_campaign_observations" */
export enum Sim_Campaign_Observations_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SimEmailId = 'sim_email_id',
  /** column name */
  SimUserId = 'sim_user_id'
}

/** input type for updating data in table "sim_campaign_observations" */
export type Sim_Campaign_Observations_Set_Input = {
  action?: InputMaybe<Scalars['String']>;
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  sim_email_id?: InputMaybe<Scalars['uuid']>;
  sim_user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "sim_campaign_observations" */
export type Sim_Campaign_Observations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sim_Campaign_Observations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sim_Campaign_Observations_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']>;
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  sim_email_id?: InputMaybe<Scalars['uuid']>;
  sim_user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "sim_campaign_observations" */
export enum Sim_Campaign_Observations_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SimEmailId = 'sim_email_id',
  /** column name */
  SimUserId = 'sim_user_id'
}

export type Sim_Campaign_Observations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sim_Campaign_Observations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sim_Campaign_Observations_Bool_Exp;
};

/** columns and relationships of "sim_campaigns" */
export type Sim_Campaigns = {
  __typename?: 'sim_campaigns';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['uuid'];
  end_date: Scalars['timestamp'];
  id: Scalars['uuid'];
  launch_date: Scalars['timestamp'];
  name: Scalars['String'];
  org_id: Scalars['uuid'];
  /** An object relationship */
  organization: Organizations;
  sender_address: Scalars['String'];
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "sim_campaigns" */
export type Sim_Campaigns_Aggregate = {
  __typename?: 'sim_campaigns_aggregate';
  aggregate?: Maybe<Sim_Campaigns_Aggregate_Fields>;
  nodes: Array<Sim_Campaigns>;
};

/** aggregate fields of "sim_campaigns" */
export type Sim_Campaigns_Aggregate_Fields = {
  __typename?: 'sim_campaigns_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Sim_Campaigns_Max_Fields>;
  min?: Maybe<Sim_Campaigns_Min_Fields>;
};


/** aggregate fields of "sim_campaigns" */
export type Sim_Campaigns_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sim_Campaigns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "sim_campaigns". All fields are combined with a logical 'AND'. */
export type Sim_Campaigns_Bool_Exp = {
  _and?: InputMaybe<Array<Sim_Campaigns_Bool_Exp>>;
  _not?: InputMaybe<Sim_Campaigns_Bool_Exp>;
  _or?: InputMaybe<Array<Sim_Campaigns_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  end_date?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  launch_date?: InputMaybe<Timestamp_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  sender_address?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "sim_campaigns" */
export enum Sim_Campaigns_Constraint {
  /** unique or primary key constraint on columns "id" */
  SimCampaignsPkey = 'sim_campaigns_pkey'
}

/** input type for inserting data into table "sim_campaigns" */
export type Sim_Campaigns_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['uuid']>;
  end_date?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  launch_date?: InputMaybe<Scalars['timestamp']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  sender_address?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Sim_Campaigns_Max_Fields = {
  __typename?: 'sim_campaigns_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  launch_date?: Maybe<Scalars['timestamp']>;
  name?: Maybe<Scalars['String']>;
  org_id?: Maybe<Scalars['uuid']>;
  sender_address?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Sim_Campaigns_Min_Fields = {
  __typename?: 'sim_campaigns_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['uuid']>;
  end_date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  launch_date?: Maybe<Scalars['timestamp']>;
  name?: Maybe<Scalars['String']>;
  org_id?: Maybe<Scalars['uuid']>;
  sender_address?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "sim_campaigns" */
export type Sim_Campaigns_Mutation_Response = {
  __typename?: 'sim_campaigns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sim_Campaigns>;
};

/** input type for inserting object relation for remote table "sim_campaigns" */
export type Sim_Campaigns_Obj_Rel_Insert_Input = {
  data: Sim_Campaigns_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sim_Campaigns_On_Conflict>;
};

/** on_conflict condition type for table "sim_campaigns" */
export type Sim_Campaigns_On_Conflict = {
  constraint: Sim_Campaigns_Constraint;
  update_columns?: Array<Sim_Campaigns_Update_Column>;
  where?: InputMaybe<Sim_Campaigns_Bool_Exp>;
};

/** Ordering options when selecting data from "sim_campaigns". */
export type Sim_Campaigns_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  launch_date?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  sender_address?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: sim_campaigns */
export type Sim_Campaigns_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "sim_campaigns" */
export enum Sim_Campaigns_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LaunchDate = 'launch_date',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SenderAddress = 'sender_address',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "sim_campaigns" */
export type Sim_Campaigns_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['uuid']>;
  end_date?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  launch_date?: InputMaybe<Scalars['timestamp']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  sender_address?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "sim_campaigns" */
export type Sim_Campaigns_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sim_Campaigns_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sim_Campaigns_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['uuid']>;
  end_date?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  launch_date?: InputMaybe<Scalars['timestamp']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  sender_address?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "sim_campaigns" */
export enum Sim_Campaigns_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LaunchDate = 'launch_date',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SenderAddress = 'sender_address',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sim_Campaigns_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sim_Campaigns_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sim_Campaigns_Bool_Exp;
};

/** columns and relationships of "sim_emails" */
export type Sim_Emails = {
  __typename?: 'sim_emails';
  campaign_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  html: Scalars['String'];
  id: Scalars['uuid'];
  llm_details?: Maybe<Scalars['jsonb']>;
  org_id: Scalars['uuid'];
  /** An object relationship */
  organization: Organizations;
  /** An object relationship */
  sim_campaign: Sim_Campaigns;
  /** An object relationship */
  sim_user: Sim_Users;
  sim_user_id: Scalars['uuid'];
  status: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
};


/** columns and relationships of "sim_emails" */
export type Sim_EmailsLlm_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "sim_emails" */
export type Sim_Emails_Aggregate = {
  __typename?: 'sim_emails_aggregate';
  aggregate?: Maybe<Sim_Emails_Aggregate_Fields>;
  nodes: Array<Sim_Emails>;
};

/** aggregate fields of "sim_emails" */
export type Sim_Emails_Aggregate_Fields = {
  __typename?: 'sim_emails_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Sim_Emails_Max_Fields>;
  min?: Maybe<Sim_Emails_Min_Fields>;
};


/** aggregate fields of "sim_emails" */
export type Sim_Emails_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sim_Emails_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Sim_Emails_Append_Input = {
  llm_details?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "sim_emails". All fields are combined with a logical 'AND'. */
export type Sim_Emails_Bool_Exp = {
  _and?: InputMaybe<Array<Sim_Emails_Bool_Exp>>;
  _not?: InputMaybe<Sim_Emails_Bool_Exp>;
  _or?: InputMaybe<Array<Sim_Emails_Bool_Exp>>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  html?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  llm_details?: InputMaybe<Jsonb_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  sim_campaign?: InputMaybe<Sim_Campaigns_Bool_Exp>;
  sim_user?: InputMaybe<Sim_Users_Bool_Exp>;
  sim_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sim_emails" */
export enum Sim_Emails_Constraint {
  /** unique or primary key constraint on columns "id" */
  SimEmailsPkey = 'sim_emails_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Sim_Emails_Delete_At_Path_Input = {
  llm_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Sim_Emails_Delete_Elem_Input = {
  llm_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Sim_Emails_Delete_Key_Input = {
  llm_details?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "sim_emails" */
export type Sim_Emails_Insert_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_details?: InputMaybe<Scalars['jsonb']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  sim_campaign?: InputMaybe<Sim_Campaigns_Obj_Rel_Insert_Input>;
  sim_user?: InputMaybe<Sim_Users_Obj_Rel_Insert_Input>;
  sim_user_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Sim_Emails_Max_Fields = {
  __typename?: 'sim_emails_max_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  sim_user_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Sim_Emails_Min_Fields = {
  __typename?: 'sim_emails_min_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  sim_user_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "sim_emails" */
export type Sim_Emails_Mutation_Response = {
  __typename?: 'sim_emails_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sim_Emails>;
};

/** input type for inserting object relation for remote table "sim_emails" */
export type Sim_Emails_Obj_Rel_Insert_Input = {
  data: Sim_Emails_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sim_Emails_On_Conflict>;
};

/** on_conflict condition type for table "sim_emails" */
export type Sim_Emails_On_Conflict = {
  constraint: Sim_Emails_Constraint;
  update_columns?: Array<Sim_Emails_Update_Column>;
  where?: InputMaybe<Sim_Emails_Bool_Exp>;
};

/** Ordering options when selecting data from "sim_emails". */
export type Sim_Emails_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  html?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  llm_details?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  sim_campaign?: InputMaybe<Sim_Campaigns_Order_By>;
  sim_user?: InputMaybe<Sim_Users_Order_By>;
  sim_user_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sim_emails */
export type Sim_Emails_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Sim_Emails_Prepend_Input = {
  llm_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "sim_emails" */
export enum Sim_Emails_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Html = 'html',
  /** column name */
  Id = 'id',
  /** column name */
  LlmDetails = 'llm_details',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SimUserId = 'sim_user_id',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject'
}

/** input type for updating data in table "sim_emails" */
export type Sim_Emails_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_details?: InputMaybe<Scalars['jsonb']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  sim_user_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "sim_emails" */
export type Sim_Emails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sim_Emails_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sim_Emails_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  llm_details?: InputMaybe<Scalars['jsonb']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  sim_user_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

/** update columns of table "sim_emails" */
export enum Sim_Emails_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Html = 'html',
  /** column name */
  Id = 'id',
  /** column name */
  LlmDetails = 'llm_details',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SimUserId = 'sim_user_id',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject'
}

export type Sim_Emails_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Sim_Emails_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Sim_Emails_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Sim_Emails_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Sim_Emails_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Sim_Emails_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sim_Emails_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sim_Emails_Bool_Exp;
};

/** columns and relationships of "sim_groups" */
export type Sim_Groups = {
  __typename?: 'sim_groups';
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  org_id: Scalars['uuid'];
  /** An object relationship */
  organization: Organizations;
};

/** aggregated selection of "sim_groups" */
export type Sim_Groups_Aggregate = {
  __typename?: 'sim_groups_aggregate';
  aggregate?: Maybe<Sim_Groups_Aggregate_Fields>;
  nodes: Array<Sim_Groups>;
};

/** aggregate fields of "sim_groups" */
export type Sim_Groups_Aggregate_Fields = {
  __typename?: 'sim_groups_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Sim_Groups_Max_Fields>;
  min?: Maybe<Sim_Groups_Min_Fields>;
};


/** aggregate fields of "sim_groups" */
export type Sim_Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sim_Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "sim_groups". All fields are combined with a logical 'AND'. */
export type Sim_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Sim_Groups_Bool_Exp>>;
  _not?: InputMaybe<Sim_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Sim_Groups_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
};

/** unique or primary key constraints on table "sim_groups" */
export enum Sim_Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  SimGroupsPkey = 'sim_groups_pkey'
}

/** input type for inserting data into table "sim_groups" */
export type Sim_Groups_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Sim_Groups_Max_Fields = {
  __typename?: 'sim_groups_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  org_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Sim_Groups_Min_Fields = {
  __typename?: 'sim_groups_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  org_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "sim_groups" */
export type Sim_Groups_Mutation_Response = {
  __typename?: 'sim_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sim_Groups>;
};

/** on_conflict condition type for table "sim_groups" */
export type Sim_Groups_On_Conflict = {
  constraint: Sim_Groups_Constraint;
  update_columns?: Array<Sim_Groups_Update_Column>;
  where?: InputMaybe<Sim_Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "sim_groups". */
export type Sim_Groups_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
};

/** primary key columns input for table: sim_groups */
export type Sim_Groups_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "sim_groups" */
export enum Sim_Groups_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id'
}

/** input type for updating data in table "sim_groups" */
export type Sim_Groups_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "sim_groups" */
export type Sim_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sim_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sim_Groups_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "sim_groups" */
export enum Sim_Groups_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id'
}

export type Sim_Groups_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sim_Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sim_Groups_Bool_Exp;
};

/** columns and relationships of "sim_users" */
export type Sim_Users = {
  __typename?: 'sim_users';
  created_at: Scalars['timestamp'];
  department?: Maybe<Scalars['String']>;
  email_address: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['uuid'];
  last_name: Scalars['String'];
  org_id: Scalars['uuid'];
  /** An object relationship */
  organization: Organizations;
};

/** aggregated selection of "sim_users" */
export type Sim_Users_Aggregate = {
  __typename?: 'sim_users_aggregate';
  aggregate?: Maybe<Sim_Users_Aggregate_Fields>;
  nodes: Array<Sim_Users>;
};

/** aggregate fields of "sim_users" */
export type Sim_Users_Aggregate_Fields = {
  __typename?: 'sim_users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Sim_Users_Max_Fields>;
  min?: Maybe<Sim_Users_Min_Fields>;
};


/** aggregate fields of "sim_users" */
export type Sim_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sim_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "sim_users". All fields are combined with a logical 'AND'. */
export type Sim_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Sim_Users_Bool_Exp>>;
  _not?: InputMaybe<Sim_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Sim_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  department?: InputMaybe<String_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
};

/** unique or primary key constraints on table "sim_users" */
export enum Sim_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  SimUsersPkey = 'sim_users_pkey'
}

/** input type for inserting data into table "sim_users" */
export type Sim_Users_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  department?: InputMaybe<Scalars['String']>;
  email_address?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Sim_Users_Max_Fields = {
  __typename?: 'sim_users_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  department?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  org_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Sim_Users_Min_Fields = {
  __typename?: 'sim_users_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  department?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  org_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "sim_users" */
export type Sim_Users_Mutation_Response = {
  __typename?: 'sim_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sim_Users>;
};

/** input type for inserting object relation for remote table "sim_users" */
export type Sim_Users_Obj_Rel_Insert_Input = {
  data: Sim_Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sim_Users_On_Conflict>;
};

/** on_conflict condition type for table "sim_users" */
export type Sim_Users_On_Conflict = {
  constraint: Sim_Users_Constraint;
  update_columns?: Array<Sim_Users_Update_Column>;
  where?: InputMaybe<Sim_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "sim_users". */
export type Sim_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  department?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
};

/** primary key columns input for table: sim_users */
export type Sim_Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "sim_users" */
export enum Sim_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Department = 'department',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrgId = 'org_id'
}

/** input type for updating data in table "sim_users" */
export type Sim_Users_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  department?: InputMaybe<Scalars['String']>;
  email_address?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "sim_users" */
export type Sim_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sim_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sim_Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  department?: InputMaybe<Scalars['String']>;
  email_address?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "sim_users" */
export enum Sim_Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Department = 'department',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  OrgId = 'org_id'
}

export type Sim_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sim_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sim_Users_Bool_Exp;
};

/** keeps track of slack installations across multiple workspaces */
export type Slack_Installations = {
  __typename?: 'slack_installations';
  bot_token: Scalars['String'];
  installation_data: Scalars['jsonb'];
  team_id: Scalars['String'];
};


/** keeps track of slack installations across multiple workspaces */
export type Slack_InstallationsInstallation_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "slack_installations" */
export type Slack_Installations_Aggregate = {
  __typename?: 'slack_installations_aggregate';
  aggregate?: Maybe<Slack_Installations_Aggregate_Fields>;
  nodes: Array<Slack_Installations>;
};

/** aggregate fields of "slack_installations" */
export type Slack_Installations_Aggregate_Fields = {
  __typename?: 'slack_installations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Slack_Installations_Max_Fields>;
  min?: Maybe<Slack_Installations_Min_Fields>;
};


/** aggregate fields of "slack_installations" */
export type Slack_Installations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Slack_Installations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Slack_Installations_Append_Input = {
  installation_data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "slack_installations". All fields are combined with a logical 'AND'. */
export type Slack_Installations_Bool_Exp = {
  _and?: InputMaybe<Array<Slack_Installations_Bool_Exp>>;
  _not?: InputMaybe<Slack_Installations_Bool_Exp>;
  _or?: InputMaybe<Array<Slack_Installations_Bool_Exp>>;
  bot_token?: InputMaybe<String_Comparison_Exp>;
  installation_data?: InputMaybe<Jsonb_Comparison_Exp>;
  team_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "slack_installations" */
export enum Slack_Installations_Constraint {
  /** unique or primary key constraint on columns "team_id" */
  SlackInstallationsPkey = 'slack_installations_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Slack_Installations_Delete_At_Path_Input = {
  installation_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Slack_Installations_Delete_Elem_Input = {
  installation_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Slack_Installations_Delete_Key_Input = {
  installation_data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "slack_installations" */
export type Slack_Installations_Insert_Input = {
  bot_token?: InputMaybe<Scalars['String']>;
  installation_data?: InputMaybe<Scalars['jsonb']>;
  team_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Slack_Installations_Max_Fields = {
  __typename?: 'slack_installations_max_fields';
  bot_token?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Slack_Installations_Min_Fields = {
  __typename?: 'slack_installations_min_fields';
  bot_token?: Maybe<Scalars['String']>;
  team_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "slack_installations" */
export type Slack_Installations_Mutation_Response = {
  __typename?: 'slack_installations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Slack_Installations>;
};

/** on_conflict condition type for table "slack_installations" */
export type Slack_Installations_On_Conflict = {
  constraint: Slack_Installations_Constraint;
  update_columns?: Array<Slack_Installations_Update_Column>;
  where?: InputMaybe<Slack_Installations_Bool_Exp>;
};

/** Ordering options when selecting data from "slack_installations". */
export type Slack_Installations_Order_By = {
  bot_token?: InputMaybe<Order_By>;
  installation_data?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: slack_installations */
export type Slack_Installations_Pk_Columns_Input = {
  team_id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Slack_Installations_Prepend_Input = {
  installation_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "slack_installations" */
export enum Slack_Installations_Select_Column {
  /** column name */
  BotToken = 'bot_token',
  /** column name */
  InstallationData = 'installation_data',
  /** column name */
  TeamId = 'team_id'
}

/** input type for updating data in table "slack_installations" */
export type Slack_Installations_Set_Input = {
  bot_token?: InputMaybe<Scalars['String']>;
  installation_data?: InputMaybe<Scalars['jsonb']>;
  team_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "slack_installations" */
export type Slack_Installations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Slack_Installations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Slack_Installations_Stream_Cursor_Value_Input = {
  bot_token?: InputMaybe<Scalars['String']>;
  installation_data?: InputMaybe<Scalars['jsonb']>;
  team_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "slack_installations" */
export enum Slack_Installations_Update_Column {
  /** column name */
  BotToken = 'bot_token',
  /** column name */
  InstallationData = 'installation_data',
  /** column name */
  TeamId = 'team_id'
}

export type Slack_Installations_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Slack_Installations_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Slack_Installations_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Slack_Installations_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Slack_Installations_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Slack_Installations_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Slack_Installations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Slack_Installations_Bool_Exp;
};

/** Boolean expression to compare columns of type "social_media_account_type". All fields are combined with logical 'AND'. */
export type Social_Media_Account_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['social_media_account_type']>;
  _gt?: InputMaybe<Scalars['social_media_account_type']>;
  _gte?: InputMaybe<Scalars['social_media_account_type']>;
  _in?: InputMaybe<Array<Scalars['social_media_account_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['social_media_account_type']>;
  _lte?: InputMaybe<Scalars['social_media_account_type']>;
  _neq?: InputMaybe<Scalars['social_media_account_type']>;
  _nin?: InputMaybe<Array<Scalars['social_media_account_type']>>;
};

/** stores comments for social media posts (which are stored in social_media_post table) */
export type Social_Media_Comments = {
  __typename?: 'social_media_comments';
  /** when this row was created and added to this table */
  created_at: Scalars['timestamp'];
  /** the timestamp which the comment was created on the corresponding social media platform */
  external_created_at?: Maybe<Scalars['timestamp']>;
  /** the id of the comment on the social media platform it came from */
  external_id?: Maybe<Scalars['String']>;
  full_text: Scalars['String'];
  id: Scalars['uuid'];
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: Maybe<Scalars['Int']>;
  social_media_data_id: Scalars['uuid'];
  social_media_post_id: Scalars['uuid'];
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregated selection of "social_media_comments" */
export type Social_Media_Comments_Aggregate = {
  __typename?: 'social_media_comments_aggregate';
  aggregate?: Maybe<Social_Media_Comments_Aggregate_Fields>;
  nodes: Array<Social_Media_Comments>;
};

/** aggregate fields of "social_media_comments" */
export type Social_Media_Comments_Aggregate_Fields = {
  __typename?: 'social_media_comments_aggregate_fields';
  avg?: Maybe<Social_Media_Comments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Social_Media_Comments_Max_Fields>;
  min?: Maybe<Social_Media_Comments_Min_Fields>;
  stddev?: Maybe<Social_Media_Comments_Stddev_Fields>;
  stddev_pop?: Maybe<Social_Media_Comments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Social_Media_Comments_Stddev_Samp_Fields>;
  sum?: Maybe<Social_Media_Comments_Sum_Fields>;
  var_pop?: Maybe<Social_Media_Comments_Var_Pop_Fields>;
  var_samp?: Maybe<Social_Media_Comments_Var_Samp_Fields>;
  variance?: Maybe<Social_Media_Comments_Variance_Fields>;
};


/** aggregate fields of "social_media_comments" */
export type Social_Media_Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Social_Media_Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Social_Media_Comments_Avg_Fields = {
  __typename?: 'social_media_comments_avg_fields';
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "social_media_comments". All fields are combined with a logical 'AND'. */
export type Social_Media_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Social_Media_Comments_Bool_Exp>>;
  _not?: InputMaybe<Social_Media_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Social_Media_Comments_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  external_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  full_text?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  num_upvotes?: InputMaybe<Int_Comparison_Exp>;
  social_media_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  social_media_post_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_query?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "social_media_comments" */
export enum Social_Media_Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  SocialMediaCommentsPkey = 'social_media_comments_pkey',
  /** unique or primary key constraint on columns "social_media_post_id", "external_id" */
  SocialMediaCommentsSocialMediaPostIdExternalIdKey = 'social_media_comments_social_media_post_id_external_id_key'
}

/** input type for incrementing numeric columns in table "social_media_comments" */
export type Social_Media_Comments_Inc_Input = {
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "social_media_comments" */
export type Social_Media_Comments_Insert_Input = {
  /** when this row was created and added to this table */
  created_at?: InputMaybe<Scalars['timestamp']>;
  /** the timestamp which the comment was created on the corresponding social media platform */
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  /** the id of the comment on the social media platform it came from */
  external_id?: InputMaybe<Scalars['String']>;
  full_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: InputMaybe<Scalars['Int']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Social_Media_Comments_Max_Fields = {
  __typename?: 'social_media_comments_max_fields';
  /** when this row was created and added to this table */
  created_at?: Maybe<Scalars['timestamp']>;
  /** the timestamp which the comment was created on the corresponding social media platform */
  external_created_at?: Maybe<Scalars['timestamp']>;
  /** the id of the comment on the social media platform it came from */
  external_id?: Maybe<Scalars['String']>;
  full_text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: Maybe<Scalars['Int']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Social_Media_Comments_Min_Fields = {
  __typename?: 'social_media_comments_min_fields';
  /** when this row was created and added to this table */
  created_at?: Maybe<Scalars['timestamp']>;
  /** the timestamp which the comment was created on the corresponding social media platform */
  external_created_at?: Maybe<Scalars['timestamp']>;
  /** the id of the comment on the social media platform it came from */
  external_id?: Maybe<Scalars['String']>;
  full_text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: Maybe<Scalars['Int']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "social_media_comments" */
export type Social_Media_Comments_Mutation_Response = {
  __typename?: 'social_media_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Social_Media_Comments>;
};

/** on_conflict condition type for table "social_media_comments" */
export type Social_Media_Comments_On_Conflict = {
  constraint: Social_Media_Comments_Constraint;
  update_columns?: Array<Social_Media_Comments_Update_Column>;
  where?: InputMaybe<Social_Media_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "social_media_comments". */
export type Social_Media_Comments_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  full_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  social_media_post_id?: InputMaybe<Order_By>;
  source_query?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: social_media_comments */
export type Social_Media_Comments_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "social_media_comments" */
export enum Social_Media_Comments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FullText = 'full_text',
  /** column name */
  Id = 'id',
  /** column name */
  NumUpvotes = 'num_upvotes',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SocialMediaPostId = 'social_media_post_id',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "social_media_comments" */
export type Social_Media_Comments_Set_Input = {
  /** when this row was created and added to this table */
  created_at?: InputMaybe<Scalars['timestamp']>;
  /** the timestamp which the comment was created on the corresponding social media platform */
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  /** the id of the comment on the social media platform it came from */
  external_id?: InputMaybe<Scalars['String']>;
  full_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: InputMaybe<Scalars['Int']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Social_Media_Comments_Stddev_Fields = {
  __typename?: 'social_media_comments_stddev_fields';
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Social_Media_Comments_Stddev_Pop_Fields = {
  __typename?: 'social_media_comments_stddev_pop_fields';
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Social_Media_Comments_Stddev_Samp_Fields = {
  __typename?: 'social_media_comments_stddev_samp_fields';
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "social_media_comments" */
export type Social_Media_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Social_Media_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Social_Media_Comments_Stream_Cursor_Value_Input = {
  /** when this row was created and added to this table */
  created_at?: InputMaybe<Scalars['timestamp']>;
  /** the timestamp which the comment was created on the corresponding social media platform */
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  /** the id of the comment on the social media platform it came from */
  external_id?: InputMaybe<Scalars['String']>;
  full_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: InputMaybe<Scalars['Int']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Social_Media_Comments_Sum_Fields = {
  __typename?: 'social_media_comments_sum_fields';
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: Maybe<Scalars['Int']>;
};

/** update columns of table "social_media_comments" */
export enum Social_Media_Comments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FullText = 'full_text',
  /** column name */
  Id = 'id',
  /** column name */
  NumUpvotes = 'num_upvotes',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SocialMediaPostId = 'social_media_post_id',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  Url = 'url'
}

export type Social_Media_Comments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Social_Media_Comments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Social_Media_Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Social_Media_Comments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Social_Media_Comments_Var_Pop_Fields = {
  __typename?: 'social_media_comments_var_pop_fields';
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Social_Media_Comments_Var_Samp_Fields = {
  __typename?: 'social_media_comments_var_samp_fields';
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Social_Media_Comments_Variance_Fields = {
  __typename?: 'social_media_comments_variance_fields';
  /** likes, upvotes etc no good way to generalize this across social media platforms. i.e. Reddit uses upvotes but Instagram uses likes */
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** social media users. original design doc https://docs.google.com/document/d/1cpp6Xa_ONfiIE8_13jz_9v6SVgO6CO5WiO7_E6cGf94 */
export type Social_Media_Data = {
  __typename?: 'social_media_data';
  account_creation_time?: Maybe<Scalars['timestamp']>;
  created_at: Scalars['timestamp'];
  delisted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  entity_data?: Maybe<Entity_Data>;
  external_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  internal_unique_id: Scalars['String'];
  is_account_verified?: Maybe<Scalars['Boolean']>;
  is_current: Scalars['Boolean'];
  num_followers?: Maybe<Scalars['Int']>;
  platform_name: Scalars['String'];
  /** An object relationship */
  platform_subtype?: Maybe<Platform_Subtypes>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  profile_description?: Maybe<Scalars['String']>;
  profile_display_name?: Maybe<Scalars['String']>;
  profile_display_url?: Maybe<Scalars['String']>;
  profile_image_hash?: Maybe<Scalars['String']>;
  profile_image_url?: Maybe<Scalars['String']>;
  raw_enriched_data?: Maybe<Scalars['String']>;
  screenshot_url?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  /** An array relationship */
  social_media_posts: Array<Social_Media_Post>;
  /** An aggregate relationship */
  social_media_posts_aggregate: Social_Media_Post_Aggregate;
  source?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  /** An array relationship */
  spoofing_reports: Array<Spoofing_Reports>;
  /** An aggregate relationship */
  spoofing_reports_aggregate: Spoofing_Reports_Aggregate;
  type?: Maybe<Scalars['social_media_account_type']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  url?: Maybe<Scalars['String']>;
};


/** social media users. original design doc https://docs.google.com/document/d/1cpp6Xa_ONfiIE8_13jz_9v6SVgO6CO5WiO7_E6cGf94 */
export type Social_Media_DataSocial_Media_PostsArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Post_Order_By>>;
  where?: InputMaybe<Social_Media_Post_Bool_Exp>;
};


/** social media users. original design doc https://docs.google.com/document/d/1cpp6Xa_ONfiIE8_13jz_9v6SVgO6CO5WiO7_E6cGf94 */
export type Social_Media_DataSocial_Media_Posts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Post_Order_By>>;
  where?: InputMaybe<Social_Media_Post_Bool_Exp>;
};


/** social media users. original design doc https://docs.google.com/document/d/1cpp6Xa_ONfiIE8_13jz_9v6SVgO6CO5WiO7_E6cGf94 */
export type Social_Media_DataSpoofing_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


/** social media users. original design doc https://docs.google.com/document/d/1cpp6Xa_ONfiIE8_13jz_9v6SVgO6CO5WiO7_E6cGf94 */
export type Social_Media_DataSpoofing_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};

/** aggregated selection of "social_media_data" */
export type Social_Media_Data_Aggregate = {
  __typename?: 'social_media_data_aggregate';
  aggregate?: Maybe<Social_Media_Data_Aggregate_Fields>;
  nodes: Array<Social_Media_Data>;
};

/** aggregate fields of "social_media_data" */
export type Social_Media_Data_Aggregate_Fields = {
  __typename?: 'social_media_data_aggregate_fields';
  avg?: Maybe<Social_Media_Data_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Social_Media_Data_Max_Fields>;
  min?: Maybe<Social_Media_Data_Min_Fields>;
  stddev?: Maybe<Social_Media_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Social_Media_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Social_Media_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Social_Media_Data_Sum_Fields>;
  var_pop?: Maybe<Social_Media_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Social_Media_Data_Var_Samp_Fields>;
  variance?: Maybe<Social_Media_Data_Variance_Fields>;
};


/** aggregate fields of "social_media_data" */
export type Social_Media_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Social_Media_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Social_Media_Data_Avg_Fields = {
  __typename?: 'social_media_data_avg_fields';
  num_followers?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "social_media_data". All fields are combined with a logical 'AND'. */
export type Social_Media_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Social_Media_Data_Bool_Exp>>;
  _not?: InputMaybe<Social_Media_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Social_Media_Data_Bool_Exp>>;
  account_creation_time?: InputMaybe<Timestamp_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  delisted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entity_data?: InputMaybe<Entity_Data_Bool_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_unique_id?: InputMaybe<String_Comparison_Exp>;
  is_account_verified?: InputMaybe<Boolean_Comparison_Exp>;
  is_current?: InputMaybe<Boolean_Comparison_Exp>;
  num_followers?: InputMaybe<Int_Comparison_Exp>;
  platform_name?: InputMaybe<String_Comparison_Exp>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Bool_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_description?: InputMaybe<String_Comparison_Exp>;
  profile_display_name?: InputMaybe<String_Comparison_Exp>;
  profile_display_url?: InputMaybe<String_Comparison_Exp>;
  profile_image_hash?: InputMaybe<String_Comparison_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
  raw_enriched_data?: InputMaybe<String_Comparison_Exp>;
  screenshot_url?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  social_media_posts?: InputMaybe<Social_Media_Post_Bool_Exp>;
  social_media_posts_aggregate?: InputMaybe<Social_Media_Post_Aggregate_Bool_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  source_query?: InputMaybe<String_Comparison_Exp>;
  spoofing_reports?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  spoofing_reports_aggregate?: InputMaybe<Spoofing_Reports_Aggregate_Bool_Exp>;
  type?: InputMaybe<Social_Media_Account_Type_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "social_media_data" */
export enum Social_Media_Data_Constraint {
  /** unique or primary key constraint on columns "platform_subtype_id", "internal_unique_id" */
  SocialMediaDataCurrentUniqueIdSubtypeKey = 'social_media_data_current_unique_id_subtype_key',
  /** unique or primary key constraint on columns "url" */
  SocialMediaDataCurrentUrlKey = 'social_media_data_current_url_key',
  /** unique or primary key constraint on columns "id" */
  SocialMediaDataPkey = 'social_media_data_pkey'
}

/** input type for incrementing numeric columns in table "social_media_data" */
export type Social_Media_Data_Inc_Input = {
  num_followers?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "social_media_data" */
export type Social_Media_Data_Insert_Input = {
  account_creation_time?: InputMaybe<Scalars['timestamp']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  delisted_at?: InputMaybe<Scalars['timestamptz']>;
  entity_data?: InputMaybe<Entity_Data_Obj_Rel_Insert_Input>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internal_unique_id?: InputMaybe<Scalars['String']>;
  is_account_verified?: InputMaybe<Scalars['Boolean']>;
  is_current?: InputMaybe<Scalars['Boolean']>;
  num_followers?: InputMaybe<Scalars['Int']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Obj_Rel_Insert_Input>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  profile_description?: InputMaybe<Scalars['String']>;
  profile_display_name?: InputMaybe<Scalars['String']>;
  profile_display_url?: InputMaybe<Scalars['String']>;
  profile_image_hash?: InputMaybe<Scalars['String']>;
  profile_image_url?: InputMaybe<Scalars['String']>;
  raw_enriched_data?: InputMaybe<Scalars['String']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  social_media_posts?: InputMaybe<Social_Media_Post_Arr_Rel_Insert_Input>;
  source?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  spoofing_reports?: InputMaybe<Spoofing_Reports_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['social_media_account_type']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Social_Media_Data_Max_Fields = {
  __typename?: 'social_media_data_max_fields';
  account_creation_time?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamp']>;
  delisted_at?: Maybe<Scalars['timestamptz']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internal_unique_id?: Maybe<Scalars['String']>;
  num_followers?: Maybe<Scalars['Int']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  profile_description?: Maybe<Scalars['String']>;
  profile_display_name?: Maybe<Scalars['String']>;
  profile_display_url?: Maybe<Scalars['String']>;
  profile_image_hash?: Maybe<Scalars['String']>;
  profile_image_url?: Maybe<Scalars['String']>;
  raw_enriched_data?: Maybe<Scalars['String']>;
  screenshot_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['social_media_account_type']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Social_Media_Data_Min_Fields = {
  __typename?: 'social_media_data_min_fields';
  account_creation_time?: Maybe<Scalars['timestamp']>;
  created_at?: Maybe<Scalars['timestamp']>;
  delisted_at?: Maybe<Scalars['timestamptz']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  internal_unique_id?: Maybe<Scalars['String']>;
  num_followers?: Maybe<Scalars['Int']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  profile_description?: Maybe<Scalars['String']>;
  profile_display_name?: Maybe<Scalars['String']>;
  profile_display_url?: Maybe<Scalars['String']>;
  profile_image_hash?: Maybe<Scalars['String']>;
  profile_image_url?: Maybe<Scalars['String']>;
  raw_enriched_data?: Maybe<Scalars['String']>;
  screenshot_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['social_media_account_type']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "social_media_data" */
export type Social_Media_Data_Mutation_Response = {
  __typename?: 'social_media_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Social_Media_Data>;
};

/** input type for inserting object relation for remote table "social_media_data" */
export type Social_Media_Data_Obj_Rel_Insert_Input = {
  data: Social_Media_Data_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Social_Media_Data_On_Conflict>;
};

/** on_conflict condition type for table "social_media_data" */
export type Social_Media_Data_On_Conflict = {
  constraint: Social_Media_Data_Constraint;
  update_columns?: Array<Social_Media_Data_Update_Column>;
  where?: InputMaybe<Social_Media_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "social_media_data". */
export type Social_Media_Data_Order_By = {
  account_creation_time?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  delisted_at?: InputMaybe<Order_By>;
  entity_data?: InputMaybe<Entity_Data_Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_unique_id?: InputMaybe<Order_By>;
  is_account_verified?: InputMaybe<Order_By>;
  is_current?: InputMaybe<Order_By>;
  num_followers?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  profile_description?: InputMaybe<Order_By>;
  profile_display_name?: InputMaybe<Order_By>;
  profile_display_url?: InputMaybe<Order_By>;
  profile_image_hash?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  raw_enriched_data?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  social_media_posts_aggregate?: InputMaybe<Social_Media_Post_Aggregate_Order_By>;
  source?: InputMaybe<Order_By>;
  source_query?: InputMaybe<Order_By>;
  spoofing_reports_aggregate?: InputMaybe<Spoofing_Reports_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: social_media_data */
export type Social_Media_Data_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "social_media_data" */
export enum Social_Media_Data_Select_Column {
  /** column name */
  AccountCreationTime = 'account_creation_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DelistedAt = 'delisted_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  InternalUniqueId = 'internal_unique_id',
  /** column name */
  IsAccountVerified = 'is_account_verified',
  /** column name */
  IsCurrent = 'is_current',
  /** column name */
  NumFollowers = 'num_followers',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  ProfileDescription = 'profile_description',
  /** column name */
  ProfileDisplayName = 'profile_display_name',
  /** column name */
  ProfileDisplayUrl = 'profile_display_url',
  /** column name */
  ProfileImageHash = 'profile_image_hash',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  RawEnrichedData = 'raw_enriched_data',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "social_media_data" */
export type Social_Media_Data_Set_Input = {
  account_creation_time?: InputMaybe<Scalars['timestamp']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  delisted_at?: InputMaybe<Scalars['timestamptz']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internal_unique_id?: InputMaybe<Scalars['String']>;
  is_account_verified?: InputMaybe<Scalars['Boolean']>;
  is_current?: InputMaybe<Scalars['Boolean']>;
  num_followers?: InputMaybe<Scalars['Int']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  profile_description?: InputMaybe<Scalars['String']>;
  profile_display_name?: InputMaybe<Scalars['String']>;
  profile_display_url?: InputMaybe<Scalars['String']>;
  profile_image_hash?: InputMaybe<Scalars['String']>;
  profile_image_url?: InputMaybe<Scalars['String']>;
  raw_enriched_data?: InputMaybe<Scalars['String']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['social_media_account_type']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Social_Media_Data_Stddev_Fields = {
  __typename?: 'social_media_data_stddev_fields';
  num_followers?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Social_Media_Data_Stddev_Pop_Fields = {
  __typename?: 'social_media_data_stddev_pop_fields';
  num_followers?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Social_Media_Data_Stddev_Samp_Fields = {
  __typename?: 'social_media_data_stddev_samp_fields';
  num_followers?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "social_media_data" */
export type Social_Media_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Social_Media_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Social_Media_Data_Stream_Cursor_Value_Input = {
  account_creation_time?: InputMaybe<Scalars['timestamp']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  delisted_at?: InputMaybe<Scalars['timestamptz']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  internal_unique_id?: InputMaybe<Scalars['String']>;
  is_account_verified?: InputMaybe<Scalars['Boolean']>;
  is_current?: InputMaybe<Scalars['Boolean']>;
  num_followers?: InputMaybe<Scalars['Int']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  profile_description?: InputMaybe<Scalars['String']>;
  profile_display_name?: InputMaybe<Scalars['String']>;
  profile_display_url?: InputMaybe<Scalars['String']>;
  profile_image_hash?: InputMaybe<Scalars['String']>;
  profile_image_url?: InputMaybe<Scalars['String']>;
  raw_enriched_data?: InputMaybe<Scalars['String']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['social_media_account_type']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Social_Media_Data_Sum_Fields = {
  __typename?: 'social_media_data_sum_fields';
  num_followers?: Maybe<Scalars['Int']>;
};

/** update columns of table "social_media_data" */
export enum Social_Media_Data_Update_Column {
  /** column name */
  AccountCreationTime = 'account_creation_time',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DelistedAt = 'delisted_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  InternalUniqueId = 'internal_unique_id',
  /** column name */
  IsAccountVerified = 'is_account_verified',
  /** column name */
  IsCurrent = 'is_current',
  /** column name */
  NumFollowers = 'num_followers',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  ProfileDescription = 'profile_description',
  /** column name */
  ProfileDisplayName = 'profile_display_name',
  /** column name */
  ProfileDisplayUrl = 'profile_display_url',
  /** column name */
  ProfileImageHash = 'profile_image_hash',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  RawEnrichedData = 'raw_enriched_data',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  Slug = 'slug',
  /** column name */
  Source = 'source',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type Social_Media_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Social_Media_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Social_Media_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Social_Media_Data_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Social_Media_Data_Var_Pop_Fields = {
  __typename?: 'social_media_data_var_pop_fields';
  num_followers?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Social_Media_Data_Var_Samp_Fields = {
  __typename?: 'social_media_data_var_samp_fields';
  num_followers?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Social_Media_Data_Variance_Fields = {
  __typename?: 'social_media_data_variance_fields';
  num_followers?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "social_media_group" */
export type Social_Media_Group = {
  __typename?: 'social_media_group';
  created_at: Scalars['time'];
  description?: Maybe<Scalars['String']>;
  /** the timestamp which the group was created on the corresponding social media platform */
  external_created_at?: Maybe<Scalars['time']>;
  external_id?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  is_private?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  num_members?: Maybe<Scalars['Int']>;
  platform_subtype_id: Scalars['uuid'];
  raw_enriched_data?: Maybe<Scalars['jsonb']>;
  screenshot_url?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "social_media_group" */
export type Social_Media_GroupRaw_Enriched_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "social_media_group" */
export type Social_Media_Group_Aggregate = {
  __typename?: 'social_media_group_aggregate';
  aggregate?: Maybe<Social_Media_Group_Aggregate_Fields>;
  nodes: Array<Social_Media_Group>;
};

/** aggregate fields of "social_media_group" */
export type Social_Media_Group_Aggregate_Fields = {
  __typename?: 'social_media_group_aggregate_fields';
  avg?: Maybe<Social_Media_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Social_Media_Group_Max_Fields>;
  min?: Maybe<Social_Media_Group_Min_Fields>;
  stddev?: Maybe<Social_Media_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Social_Media_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Social_Media_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Social_Media_Group_Sum_Fields>;
  var_pop?: Maybe<Social_Media_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Social_Media_Group_Var_Samp_Fields>;
  variance?: Maybe<Social_Media_Group_Variance_Fields>;
};


/** aggregate fields of "social_media_group" */
export type Social_Media_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Social_Media_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Social_Media_Group_Append_Input = {
  raw_enriched_data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Social_Media_Group_Avg_Fields = {
  __typename?: 'social_media_group_avg_fields';
  num_members?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "social_media_group". All fields are combined with a logical 'AND'. */
export type Social_Media_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Social_Media_Group_Bool_Exp>>;
  _not?: InputMaybe<Social_Media_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Social_Media_Group_Bool_Exp>>;
  created_at?: InputMaybe<Time_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  external_created_at?: InputMaybe<Time_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  is_private?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  num_members?: InputMaybe<Int_Comparison_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  raw_enriched_data?: InputMaybe<Jsonb_Comparison_Exp>;
  screenshot_url?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "social_media_group" */
export enum Social_Media_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  SocialMediaGroupPkey = 'social_media_group_pkey',
  /** unique or primary key constraint on columns "url" */
  SocialMediaGroupUrlKey = 'social_media_group_url_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Social_Media_Group_Delete_At_Path_Input = {
  raw_enriched_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Social_Media_Group_Delete_Elem_Input = {
  raw_enriched_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Social_Media_Group_Delete_Key_Input = {
  raw_enriched_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "social_media_group" */
export type Social_Media_Group_Inc_Input = {
  num_members?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "social_media_group" */
export type Social_Media_Group_Insert_Input = {
  created_at?: InputMaybe<Scalars['time']>;
  description?: InputMaybe<Scalars['String']>;
  /** the timestamp which the group was created on the corresponding social media platform */
  external_created_at?: InputMaybe<Scalars['time']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  num_members?: InputMaybe<Scalars['Int']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  raw_enriched_data?: InputMaybe<Scalars['jsonb']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Social_Media_Group_Max_Fields = {
  __typename?: 'social_media_group_max_fields';
  description?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  num_members?: Maybe<Scalars['Int']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  screenshot_url?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Social_Media_Group_Min_Fields = {
  __typename?: 'social_media_group_min_fields';
  description?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  num_members?: Maybe<Scalars['Int']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  screenshot_url?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "social_media_group" */
export type Social_Media_Group_Mutation_Response = {
  __typename?: 'social_media_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Social_Media_Group>;
};

/** input type for inserting object relation for remote table "social_media_group" */
export type Social_Media_Group_Obj_Rel_Insert_Input = {
  data: Social_Media_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Social_Media_Group_On_Conflict>;
};

/** on_conflict condition type for table "social_media_group" */
export type Social_Media_Group_On_Conflict = {
  constraint: Social_Media_Group_Constraint;
  update_columns?: Array<Social_Media_Group_Update_Column>;
  where?: InputMaybe<Social_Media_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "social_media_group". */
export type Social_Media_Group_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  external_created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  is_private?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  num_members?: InputMaybe<Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  raw_enriched_data?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: social_media_group */
export type Social_Media_Group_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Social_Media_Group_Prepend_Input = {
  raw_enriched_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "social_media_group" */
export enum Social_Media_Group_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsPrivate = 'is_private',
  /** column name */
  Name = 'name',
  /** column name */
  NumMembers = 'num_members',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  RawEnrichedData = 'raw_enriched_data',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "social_media_group" */
export type Social_Media_Group_Set_Input = {
  created_at?: InputMaybe<Scalars['time']>;
  description?: InputMaybe<Scalars['String']>;
  /** the timestamp which the group was created on the corresponding social media platform */
  external_created_at?: InputMaybe<Scalars['time']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  num_members?: InputMaybe<Scalars['Int']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  raw_enriched_data?: InputMaybe<Scalars['jsonb']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Social_Media_Group_Stddev_Fields = {
  __typename?: 'social_media_group_stddev_fields';
  num_members?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Social_Media_Group_Stddev_Pop_Fields = {
  __typename?: 'social_media_group_stddev_pop_fields';
  num_members?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Social_Media_Group_Stddev_Samp_Fields = {
  __typename?: 'social_media_group_stddev_samp_fields';
  num_members?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "social_media_group" */
export type Social_Media_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Social_Media_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Social_Media_Group_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['time']>;
  description?: InputMaybe<Scalars['String']>;
  /** the timestamp which the group was created on the corresponding social media platform */
  external_created_at?: InputMaybe<Scalars['time']>;
  external_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  num_members?: InputMaybe<Scalars['Int']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  raw_enriched_data?: InputMaybe<Scalars['jsonb']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Social_Media_Group_Sum_Fields = {
  __typename?: 'social_media_group_sum_fields';
  num_members?: Maybe<Scalars['Int']>;
};

/** update columns of table "social_media_group" */
export enum Social_Media_Group_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  IsPrivate = 'is_private',
  /** column name */
  Name = 'name',
  /** column name */
  NumMembers = 'num_members',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  RawEnrichedData = 'raw_enriched_data',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  Url = 'url'
}

export type Social_Media_Group_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Social_Media_Group_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Social_Media_Group_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Social_Media_Group_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Social_Media_Group_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Social_Media_Group_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Social_Media_Group_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Social_Media_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Social_Media_Group_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Social_Media_Group_Var_Pop_Fields = {
  __typename?: 'social_media_group_var_pop_fields';
  num_members?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Social_Media_Group_Var_Samp_Fields = {
  __typename?: 'social_media_group_var_samp_fields';
  num_members?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Social_Media_Group_Variance_Fields = {
  __typename?: 'social_media_group_variance_fields';
  num_members?: Maybe<Scalars['Float']>;
};

/** social media posts from twitter / instagram / etc */
export type Social_Media_Post = {
  __typename?: 'social_media_post';
  /** when this row was created and added to this table */
  created_at: Scalars['timestamp'];
  /** An array relationship */
  entity_data: Array<Entity_Data>;
  /** An aggregate relationship */
  entity_data_aggregate: Entity_Data_Aggregate;
  /** the timestamp which the post was created on the corresponding social media platform */
  external_created_at?: Maybe<Scalars['timestamp']>;
  /** The ID that the platform uses to identify the post. Is not necessarily unique (eg twitter retweets) */
  external_id?: Maybe<Scalars['String']>;
  extra_urls?: Maybe<Scalars['jsonb']>;
  full_text: Scalars['String'];
  id: Scalars['uuid'];
  num_reposts?: Maybe<Scalars['Int']>;
  num_upvotes?: Maybe<Scalars['Int']>;
  platform?: Maybe<Scalars['String']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  raw_enriched_data?: Maybe<Scalars['jsonb']>;
  screenshot_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  social_media_account?: Maybe<Social_Media_Data>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


/** social media posts from twitter / instagram / etc */
export type Social_Media_PostEntity_DataArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


/** social media posts from twitter / instagram / etc */
export type Social_Media_PostEntity_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


/** social media posts from twitter / instagram / etc */
export type Social_Media_PostExtra_UrlsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** social media posts from twitter / instagram / etc */
export type Social_Media_PostRaw_Enriched_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "social_media_post" */
export type Social_Media_Post_Aggregate = {
  __typename?: 'social_media_post_aggregate';
  aggregate?: Maybe<Social_Media_Post_Aggregate_Fields>;
  nodes: Array<Social_Media_Post>;
};

export type Social_Media_Post_Aggregate_Bool_Exp = {
  count?: InputMaybe<Social_Media_Post_Aggregate_Bool_Exp_Count>;
};

export type Social_Media_Post_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Social_Media_Post_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Social_Media_Post_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "social_media_post" */
export type Social_Media_Post_Aggregate_Fields = {
  __typename?: 'social_media_post_aggregate_fields';
  avg?: Maybe<Social_Media_Post_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Social_Media_Post_Max_Fields>;
  min?: Maybe<Social_Media_Post_Min_Fields>;
  stddev?: Maybe<Social_Media_Post_Stddev_Fields>;
  stddev_pop?: Maybe<Social_Media_Post_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Social_Media_Post_Stddev_Samp_Fields>;
  sum?: Maybe<Social_Media_Post_Sum_Fields>;
  var_pop?: Maybe<Social_Media_Post_Var_Pop_Fields>;
  var_samp?: Maybe<Social_Media_Post_Var_Samp_Fields>;
  variance?: Maybe<Social_Media_Post_Variance_Fields>;
};


/** aggregate fields of "social_media_post" */
export type Social_Media_Post_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Social_Media_Post_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "social_media_post" */
export type Social_Media_Post_Aggregate_Order_By = {
  avg?: InputMaybe<Social_Media_Post_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Social_Media_Post_Max_Order_By>;
  min?: InputMaybe<Social_Media_Post_Min_Order_By>;
  stddev?: InputMaybe<Social_Media_Post_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Social_Media_Post_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Social_Media_Post_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Social_Media_Post_Sum_Order_By>;
  var_pop?: InputMaybe<Social_Media_Post_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Social_Media_Post_Var_Samp_Order_By>;
  variance?: InputMaybe<Social_Media_Post_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Social_Media_Post_Append_Input = {
  extra_urls?: InputMaybe<Scalars['jsonb']>;
  raw_enriched_data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "social_media_post" */
export type Social_Media_Post_Arr_Rel_Insert_Input = {
  data: Array<Social_Media_Post_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Social_Media_Post_On_Conflict>;
};

/** aggregate avg on columns */
export type Social_Media_Post_Avg_Fields = {
  __typename?: 'social_media_post_avg_fields';
  num_reposts?: Maybe<Scalars['Float']>;
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "social_media_post" */
export type Social_Media_Post_Avg_Order_By = {
  num_reposts?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "social_media_post". All fields are combined with a logical 'AND'. */
export type Social_Media_Post_Bool_Exp = {
  _and?: InputMaybe<Array<Social_Media_Post_Bool_Exp>>;
  _not?: InputMaybe<Social_Media_Post_Bool_Exp>;
  _or?: InputMaybe<Array<Social_Media_Post_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  entity_data?: InputMaybe<Entity_Data_Bool_Exp>;
  entity_data_aggregate?: InputMaybe<Entity_Data_Aggregate_Bool_Exp>;
  external_created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  extra_urls?: InputMaybe<Jsonb_Comparison_Exp>;
  full_text?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  num_reposts?: InputMaybe<Int_Comparison_Exp>;
  num_upvotes?: InputMaybe<Int_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  raw_enriched_data?: InputMaybe<Jsonb_Comparison_Exp>;
  screenshot_url?: InputMaybe<String_Comparison_Exp>;
  social_media_account?: InputMaybe<Social_Media_Data_Bool_Exp>;
  social_media_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_query?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "social_media_post" */
export enum Social_Media_Post_Constraint {
  /** unique or primary key constraint on columns "id" */
  SocialMediaPostPkey = 'social_media_post_pkey',
  /** unique or primary key constraint on columns "url" */
  SocialMediaPostUrlKey = 'social_media_post_url_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Social_Media_Post_Delete_At_Path_Input = {
  extra_urls?: InputMaybe<Array<Scalars['String']>>;
  raw_enriched_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Social_Media_Post_Delete_Elem_Input = {
  extra_urls?: InputMaybe<Scalars['Int']>;
  raw_enriched_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Social_Media_Post_Delete_Key_Input = {
  extra_urls?: InputMaybe<Scalars['String']>;
  raw_enriched_data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "social_media_post" */
export type Social_Media_Post_Inc_Input = {
  num_reposts?: InputMaybe<Scalars['Int']>;
  num_upvotes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "social_media_post" */
export type Social_Media_Post_Insert_Input = {
  /** when this row was created and added to this table */
  created_at?: InputMaybe<Scalars['timestamp']>;
  entity_data?: InputMaybe<Entity_Data_Arr_Rel_Insert_Input>;
  /** the timestamp which the post was created on the corresponding social media platform */
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  /** The ID that the platform uses to identify the post. Is not necessarily unique (eg twitter retweets) */
  external_id?: InputMaybe<Scalars['String']>;
  extra_urls?: InputMaybe<Scalars['jsonb']>;
  full_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  num_reposts?: InputMaybe<Scalars['Int']>;
  num_upvotes?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  raw_enriched_data?: InputMaybe<Scalars['jsonb']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  social_media_account?: InputMaybe<Social_Media_Data_Obj_Rel_Insert_Input>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Social_Media_Post_Max_Fields = {
  __typename?: 'social_media_post_max_fields';
  /** when this row was created and added to this table */
  created_at?: Maybe<Scalars['timestamp']>;
  /** the timestamp which the post was created on the corresponding social media platform */
  external_created_at?: Maybe<Scalars['timestamp']>;
  /** The ID that the platform uses to identify the post. Is not necessarily unique (eg twitter retweets) */
  external_id?: Maybe<Scalars['String']>;
  full_text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  num_reposts?: Maybe<Scalars['Int']>;
  num_upvotes?: Maybe<Scalars['Int']>;
  platform?: Maybe<Scalars['String']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  screenshot_url?: Maybe<Scalars['String']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "social_media_post" */
export type Social_Media_Post_Max_Order_By = {
  /** when this row was created and added to this table */
  created_at?: InputMaybe<Order_By>;
  /** the timestamp which the post was created on the corresponding social media platform */
  external_created_at?: InputMaybe<Order_By>;
  /** The ID that the platform uses to identify the post. Is not necessarily unique (eg twitter retweets) */
  external_id?: InputMaybe<Order_By>;
  full_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_reposts?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Social_Media_Post_Min_Fields = {
  __typename?: 'social_media_post_min_fields';
  /** when this row was created and added to this table */
  created_at?: Maybe<Scalars['timestamp']>;
  /** the timestamp which the post was created on the corresponding social media platform */
  external_created_at?: Maybe<Scalars['timestamp']>;
  /** The ID that the platform uses to identify the post. Is not necessarily unique (eg twitter retweets) */
  external_id?: Maybe<Scalars['String']>;
  full_text?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  num_reposts?: Maybe<Scalars['Int']>;
  num_upvotes?: Maybe<Scalars['Int']>;
  platform?: Maybe<Scalars['String']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  screenshot_url?: Maybe<Scalars['String']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "social_media_post" */
export type Social_Media_Post_Min_Order_By = {
  /** when this row was created and added to this table */
  created_at?: InputMaybe<Order_By>;
  /** the timestamp which the post was created on the corresponding social media platform */
  external_created_at?: InputMaybe<Order_By>;
  /** The ID that the platform uses to identify the post. Is not necessarily unique (eg twitter retweets) */
  external_id?: InputMaybe<Order_By>;
  full_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_reposts?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "social_media_post" */
export type Social_Media_Post_Mutation_Response = {
  __typename?: 'social_media_post_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Social_Media_Post>;
};

/** input type for inserting object relation for remote table "social_media_post" */
export type Social_Media_Post_Obj_Rel_Insert_Input = {
  data: Social_Media_Post_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Social_Media_Post_On_Conflict>;
};

/** on_conflict condition type for table "social_media_post" */
export type Social_Media_Post_On_Conflict = {
  constraint: Social_Media_Post_Constraint;
  update_columns?: Array<Social_Media_Post_Update_Column>;
  where?: InputMaybe<Social_Media_Post_Bool_Exp>;
};

/** Ordering options when selecting data from "social_media_post". */
export type Social_Media_Post_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_data_aggregate?: InputMaybe<Entity_Data_Aggregate_Order_By>;
  external_created_at?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  extra_urls?: InputMaybe<Order_By>;
  full_text?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_reposts?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  raw_enriched_data?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  social_media_account?: InputMaybe<Social_Media_Data_Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  source_query?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: social_media_post */
export type Social_Media_Post_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Social_Media_Post_Prepend_Input = {
  extra_urls?: InputMaybe<Scalars['jsonb']>;
  raw_enriched_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "social_media_post" */
export enum Social_Media_Post_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExtraUrls = 'extra_urls',
  /** column name */
  FullText = 'full_text',
  /** column name */
  Id = 'id',
  /** column name */
  NumReposts = 'num_reposts',
  /** column name */
  NumUpvotes = 'num_upvotes',
  /** column name */
  Platform = 'platform',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  RawEnrichedData = 'raw_enriched_data',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "social_media_post" */
export type Social_Media_Post_Set_Input = {
  /** when this row was created and added to this table */
  created_at?: InputMaybe<Scalars['timestamp']>;
  /** the timestamp which the post was created on the corresponding social media platform */
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  /** The ID that the platform uses to identify the post. Is not necessarily unique (eg twitter retweets) */
  external_id?: InputMaybe<Scalars['String']>;
  extra_urls?: InputMaybe<Scalars['jsonb']>;
  full_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  num_reposts?: InputMaybe<Scalars['Int']>;
  num_upvotes?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  raw_enriched_data?: InputMaybe<Scalars['jsonb']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Social_Media_Post_Stddev_Fields = {
  __typename?: 'social_media_post_stddev_fields';
  num_reposts?: Maybe<Scalars['Float']>;
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "social_media_post" */
export type Social_Media_Post_Stddev_Order_By = {
  num_reposts?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Social_Media_Post_Stddev_Pop_Fields = {
  __typename?: 'social_media_post_stddev_pop_fields';
  num_reposts?: Maybe<Scalars['Float']>;
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "social_media_post" */
export type Social_Media_Post_Stddev_Pop_Order_By = {
  num_reposts?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Social_Media_Post_Stddev_Samp_Fields = {
  __typename?: 'social_media_post_stddev_samp_fields';
  num_reposts?: Maybe<Scalars['Float']>;
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "social_media_post" */
export type Social_Media_Post_Stddev_Samp_Order_By = {
  num_reposts?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "social_media_post" */
export type Social_Media_Post_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Social_Media_Post_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Social_Media_Post_Stream_Cursor_Value_Input = {
  /** when this row was created and added to this table */
  created_at?: InputMaybe<Scalars['timestamp']>;
  /** the timestamp which the post was created on the corresponding social media platform */
  external_created_at?: InputMaybe<Scalars['timestamp']>;
  /** The ID that the platform uses to identify the post. Is not necessarily unique (eg twitter retweets) */
  external_id?: InputMaybe<Scalars['String']>;
  extra_urls?: InputMaybe<Scalars['jsonb']>;
  full_text?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  num_reposts?: InputMaybe<Scalars['Int']>;
  num_upvotes?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Scalars['String']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  raw_enriched_data?: InputMaybe<Scalars['jsonb']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  /** the source query/keyword(s) that were used to fetch this data */
  source_query?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Social_Media_Post_Sum_Fields = {
  __typename?: 'social_media_post_sum_fields';
  num_reposts?: Maybe<Scalars['Int']>;
  num_upvotes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "social_media_post" */
export type Social_Media_Post_Sum_Order_By = {
  num_reposts?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
};

/** update columns of table "social_media_post" */
export enum Social_Media_Post_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalCreatedAt = 'external_created_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExtraUrls = 'extra_urls',
  /** column name */
  FullText = 'full_text',
  /** column name */
  Id = 'id',
  /** column name */
  NumReposts = 'num_reposts',
  /** column name */
  NumUpvotes = 'num_upvotes',
  /** column name */
  Platform = 'platform',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  RawEnrichedData = 'raw_enriched_data',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SourceQuery = 'source_query',
  /** column name */
  Url = 'url'
}

export type Social_Media_Post_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Social_Media_Post_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Social_Media_Post_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Social_Media_Post_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Social_Media_Post_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Social_Media_Post_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Social_Media_Post_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Social_Media_Post_Set_Input>;
  /** filter the rows which have to be updated */
  where: Social_Media_Post_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Social_Media_Post_Var_Pop_Fields = {
  __typename?: 'social_media_post_var_pop_fields';
  num_reposts?: Maybe<Scalars['Float']>;
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "social_media_post" */
export type Social_Media_Post_Var_Pop_Order_By = {
  num_reposts?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Social_Media_Post_Var_Samp_Fields = {
  __typename?: 'social_media_post_var_samp_fields';
  num_reposts?: Maybe<Scalars['Float']>;
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "social_media_post" */
export type Social_Media_Post_Var_Samp_Order_By = {
  num_reposts?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Social_Media_Post_Variance_Fields = {
  __typename?: 'social_media_post_variance_fields';
  num_reposts?: Maybe<Scalars['Float']>;
  num_upvotes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "social_media_post" */
export type Social_Media_Post_Variance_Order_By = {
  num_reposts?: InputMaybe<Order_By>;
  num_upvotes?: InputMaybe<Order_By>;
};

/** stores custom queries used for sourcing for a particular brand and source combination */
export type Sourcing_Queries = {
  __typename?: 'sourcing_queries';
  brand_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['String']>;
  execution_frequency_minutes?: Maybe<Scalars['Int']>;
  force_create_report: Scalars['Boolean'];
  id: Scalars['uuid'];
  last_updated_by?: Maybe<Scalars['String']>;
  last_used_at?: Maybe<Scalars['timestamp']>;
  notes?: Maybe<Scalars['String']>;
  platform_name?: Maybe<Scalars['String']>;
  query: Scalars['String'];
  sourcer_label: Scalars['String'];
  /** An object relationship */
  spoofing_entity: Spoofing_Entities;
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "sourcing_queries" */
export type Sourcing_Queries_Aggregate = {
  __typename?: 'sourcing_queries_aggregate';
  aggregate?: Maybe<Sourcing_Queries_Aggregate_Fields>;
  nodes: Array<Sourcing_Queries>;
};

export type Sourcing_Queries_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Sourcing_Queries_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Sourcing_Queries_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Sourcing_Queries_Aggregate_Bool_Exp_Count>;
};

export type Sourcing_Queries_Aggregate_Bool_Exp_Bool_And = {
  arguments: Sourcing_Queries_Select_Column_Sourcing_Queries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sourcing_Queries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sourcing_Queries_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Sourcing_Queries_Select_Column_Sourcing_Queries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sourcing_Queries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Sourcing_Queries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Sourcing_Queries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Sourcing_Queries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sourcing_queries" */
export type Sourcing_Queries_Aggregate_Fields = {
  __typename?: 'sourcing_queries_aggregate_fields';
  avg?: Maybe<Sourcing_Queries_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sourcing_Queries_Max_Fields>;
  min?: Maybe<Sourcing_Queries_Min_Fields>;
  stddev?: Maybe<Sourcing_Queries_Stddev_Fields>;
  stddev_pop?: Maybe<Sourcing_Queries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sourcing_Queries_Stddev_Samp_Fields>;
  sum?: Maybe<Sourcing_Queries_Sum_Fields>;
  var_pop?: Maybe<Sourcing_Queries_Var_Pop_Fields>;
  var_samp?: Maybe<Sourcing_Queries_Var_Samp_Fields>;
  variance?: Maybe<Sourcing_Queries_Variance_Fields>;
};


/** aggregate fields of "sourcing_queries" */
export type Sourcing_Queries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sourcing_Queries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sourcing_queries" */
export type Sourcing_Queries_Aggregate_Order_By = {
  avg?: InputMaybe<Sourcing_Queries_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sourcing_Queries_Max_Order_By>;
  min?: InputMaybe<Sourcing_Queries_Min_Order_By>;
  stddev?: InputMaybe<Sourcing_Queries_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sourcing_Queries_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sourcing_Queries_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sourcing_Queries_Sum_Order_By>;
  var_pop?: InputMaybe<Sourcing_Queries_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sourcing_Queries_Var_Samp_Order_By>;
  variance?: InputMaybe<Sourcing_Queries_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sourcing_queries" */
export type Sourcing_Queries_Arr_Rel_Insert_Input = {
  data: Array<Sourcing_Queries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Sourcing_Queries_On_Conflict>;
};

/** aggregate avg on columns */
export type Sourcing_Queries_Avg_Fields = {
  __typename?: 'sourcing_queries_avg_fields';
  execution_frequency_minutes?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sourcing_queries" */
export type Sourcing_Queries_Avg_Order_By = {
  execution_frequency_minutes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sourcing_queries". All fields are combined with a logical 'AND'. */
export type Sourcing_Queries_Bool_Exp = {
  _and?: InputMaybe<Array<Sourcing_Queries_Bool_Exp>>;
  _not?: InputMaybe<Sourcing_Queries_Bool_Exp>;
  _or?: InputMaybe<Array<Sourcing_Queries_Bool_Exp>>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  execution_frequency_minutes?: InputMaybe<Int_Comparison_Exp>;
  force_create_report?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_updated_by?: InputMaybe<String_Comparison_Exp>;
  last_used_at?: InputMaybe<Timestamp_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  platform_name?: InputMaybe<String_Comparison_Exp>;
  query?: InputMaybe<String_Comparison_Exp>;
  sourcer_label?: InputMaybe<String_Comparison_Exp>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sourcing_queries" */
export enum Sourcing_Queries_Constraint {
  /** unique or primary key constraint on columns "query", "brand_id", "sourcer_label" */
  SourcingQueriesBrandIdQuerySourcerLabelKey = 'sourcing_queries_brand_id_query_sourcer_label_key',
  /** unique or primary key constraint on columns "id" */
  SourcingQueriesPkey = 'sourcing_queries_pkey'
}

/** input type for incrementing numeric columns in table "sourcing_queries" */
export type Sourcing_Queries_Inc_Input = {
  execution_frequency_minutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sourcing_queries" */
export type Sourcing_Queries_Insert_Input = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  execution_frequency_minutes?: InputMaybe<Scalars['Int']>;
  force_create_report?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  last_used_at?: InputMaybe<Scalars['timestamp']>;
  notes?: InputMaybe<Scalars['String']>;
  platform_name?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  sourcer_label?: InputMaybe<Scalars['String']>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Sourcing_Queries_Max_Fields = {
  __typename?: 'sourcing_queries_max_fields';
  brand_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  execution_frequency_minutes?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by?: Maybe<Scalars['String']>;
  last_used_at?: Maybe<Scalars['timestamp']>;
  notes?: Maybe<Scalars['String']>;
  platform_name?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  sourcer_label?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "sourcing_queries" */
export type Sourcing_Queries_Max_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  execution_frequency_minutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  query?: InputMaybe<Order_By>;
  sourcer_label?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Sourcing_Queries_Min_Fields = {
  __typename?: 'sourcing_queries_min_fields';
  brand_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  execution_frequency_minutes?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by?: Maybe<Scalars['String']>;
  last_used_at?: Maybe<Scalars['timestamp']>;
  notes?: Maybe<Scalars['String']>;
  platform_name?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  sourcer_label?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "sourcing_queries" */
export type Sourcing_Queries_Min_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  execution_frequency_minutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  query?: InputMaybe<Order_By>;
  sourcer_label?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sourcing_queries" */
export type Sourcing_Queries_Mutation_Response = {
  __typename?: 'sourcing_queries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sourcing_Queries>;
};

/** input type for inserting object relation for remote table "sourcing_queries" */
export type Sourcing_Queries_Obj_Rel_Insert_Input = {
  data: Sourcing_Queries_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Sourcing_Queries_On_Conflict>;
};

/** on_conflict condition type for table "sourcing_queries" */
export type Sourcing_Queries_On_Conflict = {
  constraint: Sourcing_Queries_Constraint;
  update_columns?: Array<Sourcing_Queries_Update_Column>;
  where?: InputMaybe<Sourcing_Queries_Bool_Exp>;
};

/** Ordering options when selecting data from "sourcing_queries". */
export type Sourcing_Queries_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  execution_frequency_minutes?: InputMaybe<Order_By>;
  force_create_report?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_by?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  query?: InputMaybe<Order_By>;
  sourcer_label?: InputMaybe<Order_By>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sourcing_queries */
export type Sourcing_Queries_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "sourcing_queries" */
export enum Sourcing_Queries_Select_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  ExecutionFrequencyMinutes = 'execution_frequency_minutes',
  /** column name */
  ForceCreateReport = 'force_create_report',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  LastUsedAt = 'last_used_at',
  /** column name */
  Notes = 'notes',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  Query = 'query',
  /** column name */
  SourcerLabel = 'sourcer_label',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "sourcing_queries_aggregate_bool_exp_bool_and_arguments_columns" columns of table "sourcing_queries" */
export enum Sourcing_Queries_Select_Column_Sourcing_Queries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ForceCreateReport = 'force_create_report'
}

/** select "sourcing_queries_aggregate_bool_exp_bool_or_arguments_columns" columns of table "sourcing_queries" */
export enum Sourcing_Queries_Select_Column_Sourcing_Queries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ForceCreateReport = 'force_create_report'
}

/** input type for updating data in table "sourcing_queries" */
export type Sourcing_Queries_Set_Input = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  execution_frequency_minutes?: InputMaybe<Scalars['Int']>;
  force_create_report?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  last_used_at?: InputMaybe<Scalars['timestamp']>;
  notes?: InputMaybe<Scalars['String']>;
  platform_name?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  sourcer_label?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Sourcing_Queries_Stddev_Fields = {
  __typename?: 'sourcing_queries_stddev_fields';
  execution_frequency_minutes?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sourcing_queries" */
export type Sourcing_Queries_Stddev_Order_By = {
  execution_frequency_minutes?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Sourcing_Queries_Stddev_Pop_Fields = {
  __typename?: 'sourcing_queries_stddev_pop_fields';
  execution_frequency_minutes?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sourcing_queries" */
export type Sourcing_Queries_Stddev_Pop_Order_By = {
  execution_frequency_minutes?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Sourcing_Queries_Stddev_Samp_Fields = {
  __typename?: 'sourcing_queries_stddev_samp_fields';
  execution_frequency_minutes?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sourcing_queries" */
export type Sourcing_Queries_Stddev_Samp_Order_By = {
  execution_frequency_minutes?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sourcing_queries" */
export type Sourcing_Queries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sourcing_Queries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sourcing_Queries_Stream_Cursor_Value_Input = {
  brand_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  execution_frequency_minutes?: InputMaybe<Scalars['Int']>;
  force_create_report?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  last_used_at?: InputMaybe<Scalars['timestamp']>;
  notes?: InputMaybe<Scalars['String']>;
  platform_name?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  sourcer_label?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Sourcing_Queries_Sum_Fields = {
  __typename?: 'sourcing_queries_sum_fields';
  execution_frequency_minutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "sourcing_queries" */
export type Sourcing_Queries_Sum_Order_By = {
  execution_frequency_minutes?: InputMaybe<Order_By>;
};

/** update columns of table "sourcing_queries" */
export enum Sourcing_Queries_Update_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  ExecutionFrequencyMinutes = 'execution_frequency_minutes',
  /** column name */
  ForceCreateReport = 'force_create_report',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedBy = 'last_updated_by',
  /** column name */
  LastUsedAt = 'last_used_at',
  /** column name */
  Notes = 'notes',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  Query = 'query',
  /** column name */
  SourcerLabel = 'sourcer_label',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sourcing_Queries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sourcing_Queries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sourcing_Queries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sourcing_Queries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sourcing_Queries_Var_Pop_Fields = {
  __typename?: 'sourcing_queries_var_pop_fields';
  execution_frequency_minutes?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sourcing_queries" */
export type Sourcing_Queries_Var_Pop_Order_By = {
  execution_frequency_minutes?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Sourcing_Queries_Var_Samp_Fields = {
  __typename?: 'sourcing_queries_var_samp_fields';
  execution_frequency_minutes?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sourcing_queries" */
export type Sourcing_Queries_Var_Samp_Order_By = {
  execution_frequency_minutes?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Sourcing_Queries_Variance_Fields = {
  __typename?: 'sourcing_queries_variance_fields';
  execution_frequency_minutes?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sourcing_queries" */
export type Sourcing_Queries_Variance_Order_By = {
  execution_frequency_minutes?: InputMaybe<Order_By>;
};

/** columns and relationships of "sourcing_query_executions" */
export type Sourcing_Query_Executions = {
  __typename?: 'sourcing_query_executions';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  number_of_candidates_sourced?: Maybe<Scalars['Int']>;
  sourced_urls_uri?: Maybe<Scalars['String']>;
  sourcing_query_id: Scalars['uuid'];
  status: Scalars['String'];
  status_reason?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "sourcing_query_executions" */
export type Sourcing_Query_Executions_Aggregate = {
  __typename?: 'sourcing_query_executions_aggregate';
  aggregate?: Maybe<Sourcing_Query_Executions_Aggregate_Fields>;
  nodes: Array<Sourcing_Query_Executions>;
};

/** aggregate fields of "sourcing_query_executions" */
export type Sourcing_Query_Executions_Aggregate_Fields = {
  __typename?: 'sourcing_query_executions_aggregate_fields';
  avg?: Maybe<Sourcing_Query_Executions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Sourcing_Query_Executions_Max_Fields>;
  min?: Maybe<Sourcing_Query_Executions_Min_Fields>;
  stddev?: Maybe<Sourcing_Query_Executions_Stddev_Fields>;
  stddev_pop?: Maybe<Sourcing_Query_Executions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Sourcing_Query_Executions_Stddev_Samp_Fields>;
  sum?: Maybe<Sourcing_Query_Executions_Sum_Fields>;
  var_pop?: Maybe<Sourcing_Query_Executions_Var_Pop_Fields>;
  var_samp?: Maybe<Sourcing_Query_Executions_Var_Samp_Fields>;
  variance?: Maybe<Sourcing_Query_Executions_Variance_Fields>;
};


/** aggregate fields of "sourcing_query_executions" */
export type Sourcing_Query_Executions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Sourcing_Query_Executions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Sourcing_Query_Executions_Avg_Fields = {
  __typename?: 'sourcing_query_executions_avg_fields';
  number_of_candidates_sourced?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sourcing_query_executions". All fields are combined with a logical 'AND'. */
export type Sourcing_Query_Executions_Bool_Exp = {
  _and?: InputMaybe<Array<Sourcing_Query_Executions_Bool_Exp>>;
  _not?: InputMaybe<Sourcing_Query_Executions_Bool_Exp>;
  _or?: InputMaybe<Array<Sourcing_Query_Executions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_candidates_sourced?: InputMaybe<Int_Comparison_Exp>;
  sourced_urls_uri?: InputMaybe<String_Comparison_Exp>;
  sourcing_query_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_reason?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sourcing_query_executions" */
export enum Sourcing_Query_Executions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SourcingQueryExecutionsPkey = 'sourcing_query_executions_pkey'
}

/** input type for incrementing numeric columns in table "sourcing_query_executions" */
export type Sourcing_Query_Executions_Inc_Input = {
  number_of_candidates_sourced?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sourcing_query_executions" */
export type Sourcing_Query_Executions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  number_of_candidates_sourced?: InputMaybe<Scalars['Int']>;
  sourced_urls_uri?: InputMaybe<Scalars['String']>;
  sourcing_query_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  status_reason?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Sourcing_Query_Executions_Max_Fields = {
  __typename?: 'sourcing_query_executions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number_of_candidates_sourced?: Maybe<Scalars['Int']>;
  sourced_urls_uri?: Maybe<Scalars['String']>;
  sourcing_query_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  status_reason?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Sourcing_Query_Executions_Min_Fields = {
  __typename?: 'sourcing_query_executions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number_of_candidates_sourced?: Maybe<Scalars['Int']>;
  sourced_urls_uri?: Maybe<Scalars['String']>;
  sourcing_query_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  status_reason?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "sourcing_query_executions" */
export type Sourcing_Query_Executions_Mutation_Response = {
  __typename?: 'sourcing_query_executions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Sourcing_Query_Executions>;
};

/** on_conflict condition type for table "sourcing_query_executions" */
export type Sourcing_Query_Executions_On_Conflict = {
  constraint: Sourcing_Query_Executions_Constraint;
  update_columns?: Array<Sourcing_Query_Executions_Update_Column>;
  where?: InputMaybe<Sourcing_Query_Executions_Bool_Exp>;
};

/** Ordering options when selecting data from "sourcing_query_executions". */
export type Sourcing_Query_Executions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number_of_candidates_sourced?: InputMaybe<Order_By>;
  sourced_urls_uri?: InputMaybe<Order_By>;
  sourcing_query_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_reason?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sourcing_query_executions */
export type Sourcing_Query_Executions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "sourcing_query_executions" */
export enum Sourcing_Query_Executions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NumberOfCandidatesSourced = 'number_of_candidates_sourced',
  /** column name */
  SourcedUrlsUri = 'sourced_urls_uri',
  /** column name */
  SourcingQueryId = 'sourcing_query_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusReason = 'status_reason',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "sourcing_query_executions" */
export type Sourcing_Query_Executions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  number_of_candidates_sourced?: InputMaybe<Scalars['Int']>;
  sourced_urls_uri?: InputMaybe<Scalars['String']>;
  sourcing_query_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  status_reason?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Sourcing_Query_Executions_Stddev_Fields = {
  __typename?: 'sourcing_query_executions_stddev_fields';
  number_of_candidates_sourced?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Sourcing_Query_Executions_Stddev_Pop_Fields = {
  __typename?: 'sourcing_query_executions_stddev_pop_fields';
  number_of_candidates_sourced?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Sourcing_Query_Executions_Stddev_Samp_Fields = {
  __typename?: 'sourcing_query_executions_stddev_samp_fields';
  number_of_candidates_sourced?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sourcing_query_executions" */
export type Sourcing_Query_Executions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sourcing_Query_Executions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sourcing_Query_Executions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  number_of_candidates_sourced?: InputMaybe<Scalars['Int']>;
  sourced_urls_uri?: InputMaybe<Scalars['String']>;
  sourcing_query_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  status_reason?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Sourcing_Query_Executions_Sum_Fields = {
  __typename?: 'sourcing_query_executions_sum_fields';
  number_of_candidates_sourced?: Maybe<Scalars['Int']>;
};

/** update columns of table "sourcing_query_executions" */
export enum Sourcing_Query_Executions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NumberOfCandidatesSourced = 'number_of_candidates_sourced',
  /** column name */
  SourcedUrlsUri = 'sourced_urls_uri',
  /** column name */
  SourcingQueryId = 'sourcing_query_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusReason = 'status_reason',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Sourcing_Query_Executions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Sourcing_Query_Executions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sourcing_Query_Executions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Sourcing_Query_Executions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Sourcing_Query_Executions_Var_Pop_Fields = {
  __typename?: 'sourcing_query_executions_var_pop_fields';
  number_of_candidates_sourced?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Sourcing_Query_Executions_Var_Samp_Fields = {
  __typename?: 'sourcing_query_executions_var_samp_fields';
  number_of_candidates_sourced?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Sourcing_Query_Executions_Variance_Fields = {
  __typename?: 'sourcing_query_executions_variance_fields';
  number_of_candidates_sourced?: Maybe<Scalars['Float']>;
};

/** match of root domains/subdomains/paths to original entity */
export type Spoof_Matches = {
  __typename?: 'spoof_matches';
  /** An object relationship */
  advertisement_data?: Maybe<Advertisement_Data>;
  advertisement_data_id?: Maybe<Scalars['uuid']>;
  classification: Scalars['spoofing_status'];
  created_at: Scalars['timestamp'];
  /** An object relationship */
  dark_web?: Maybe<Dark_Web>;
  dark_web_id?: Maybe<Scalars['uuid']>;
  delist_screenshot_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  ecommerce_listing?: Maybe<Ecommerce_Listings>;
  ecommerce_listing_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  email?: Maybe<Emails>;
  email_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  entity_data: Array<Entity_Data>;
  /** An aggregate relationship */
  entity_data_aggregate: Entity_Data_Aggregate;
  /** An object relationship */
  full_url?: Maybe<Full_Urls>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  id_similarity_score?: Maybe<Scalars['Float']>;
  latest_alert_queue_state?: Maybe<Scalars['String']>;
  /** An array relationship */
  match_attributions: Array<Match_Attributions>;
  /** An aggregate relationship */
  match_attributions_aggregate: Match_Attributions_Aggregate;
  /** An array relationship */
  ml_features: Array<Ml_Features>;
  /** An aggregate relationship */
  ml_features_aggregate: Ml_Features_Aggregate;
  /** An object relationship */
  mobile_app?: Maybe<Mobile_Apps>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  phone_number?: Maybe<Phone_Numbers>;
  phone_number_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  platform_subtype?: Maybe<Platform_Subtypes>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  snapshot_source: Scalars['String'];
  /** An object relationship */
  social_media_data?: Maybe<Social_Media_Data>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  social_media_group?: Maybe<Social_Media_Group>;
  social_media_group_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  social_media_post?: Maybe<Social_Media_Post>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  spoof_report_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  spoofing_report?: Maybe<Spoofing_Reports>;
  suspicion_score?: Maybe<Scalars['numeric']>;
  universal_entity_id?: Maybe<Scalars['uuid']>;
};


/** match of root domains/subdomains/paths to original entity */
export type Spoof_MatchesEntity_DataArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


/** match of root domains/subdomains/paths to original entity */
export type Spoof_MatchesEntity_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


/** match of root domains/subdomains/paths to original entity */
export type Spoof_MatchesMatch_AttributionsArgs = {
  distinct_on?: InputMaybe<Array<Match_Attributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Attributions_Order_By>>;
  where?: InputMaybe<Match_Attributions_Bool_Exp>;
};


/** match of root domains/subdomains/paths to original entity */
export type Spoof_MatchesMatch_Attributions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Match_Attributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Attributions_Order_By>>;
  where?: InputMaybe<Match_Attributions_Bool_Exp>;
};


/** match of root domains/subdomains/paths to original entity */
export type Spoof_MatchesMl_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Ml_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ml_Features_Order_By>>;
  where?: InputMaybe<Ml_Features_Bool_Exp>;
};


/** match of root domains/subdomains/paths to original entity */
export type Spoof_MatchesMl_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ml_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ml_Features_Order_By>>;
  where?: InputMaybe<Ml_Features_Bool_Exp>;
};

/** aggregated selection of "spoof_matches" */
export type Spoof_Matches_Aggregate = {
  __typename?: 'spoof_matches_aggregate';
  aggregate?: Maybe<Spoof_Matches_Aggregate_Fields>;
  nodes: Array<Spoof_Matches>;
};

export type Spoof_Matches_Aggregate_Bool_Exp = {
  count?: InputMaybe<Spoof_Matches_Aggregate_Bool_Exp_Count>;
};

export type Spoof_Matches_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Spoof_Matches_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spoof_matches" */
export type Spoof_Matches_Aggregate_Fields = {
  __typename?: 'spoof_matches_aggregate_fields';
  avg?: Maybe<Spoof_Matches_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Spoof_Matches_Max_Fields>;
  min?: Maybe<Spoof_Matches_Min_Fields>;
  stddev?: Maybe<Spoof_Matches_Stddev_Fields>;
  stddev_pop?: Maybe<Spoof_Matches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spoof_Matches_Stddev_Samp_Fields>;
  sum?: Maybe<Spoof_Matches_Sum_Fields>;
  var_pop?: Maybe<Spoof_Matches_Var_Pop_Fields>;
  var_samp?: Maybe<Spoof_Matches_Var_Samp_Fields>;
  variance?: Maybe<Spoof_Matches_Variance_Fields>;
};


/** aggregate fields of "spoof_matches" */
export type Spoof_Matches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "spoof_matches" */
export type Spoof_Matches_Aggregate_Order_By = {
  avg?: InputMaybe<Spoof_Matches_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spoof_Matches_Max_Order_By>;
  min?: InputMaybe<Spoof_Matches_Min_Order_By>;
  stddev?: InputMaybe<Spoof_Matches_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spoof_Matches_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spoof_Matches_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spoof_Matches_Sum_Order_By>;
  var_pop?: InputMaybe<Spoof_Matches_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spoof_Matches_Var_Samp_Order_By>;
  variance?: InputMaybe<Spoof_Matches_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spoof_matches" */
export type Spoof_Matches_Arr_Rel_Insert_Input = {
  data: Array<Spoof_Matches_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spoof_Matches_On_Conflict>;
};

/** aggregate avg on columns */
export type Spoof_Matches_Avg_Fields = {
  __typename?: 'spoof_matches_avg_fields';
  id_similarity_score?: Maybe<Scalars['Float']>;
  suspicion_score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "spoof_matches" */
export type Spoof_Matches_Avg_Order_By = {
  id_similarity_score?: InputMaybe<Order_By>;
  suspicion_score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spoof_matches". All fields are combined with a logical 'AND'. */
export type Spoof_Matches_Bool_Exp = {
  _and?: InputMaybe<Array<Spoof_Matches_Bool_Exp>>;
  _not?: InputMaybe<Spoof_Matches_Bool_Exp>;
  _or?: InputMaybe<Array<Spoof_Matches_Bool_Exp>>;
  advertisement_data?: InputMaybe<Advertisement_Data_Bool_Exp>;
  advertisement_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  classification?: InputMaybe<Spoofing_Status_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  dark_web?: InputMaybe<Dark_Web_Bool_Exp>;
  dark_web_id?: InputMaybe<Uuid_Comparison_Exp>;
  delist_screenshot_url?: InputMaybe<String_Comparison_Exp>;
  ecommerce_listing?: InputMaybe<Ecommerce_Listings_Bool_Exp>;
  ecommerce_listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  email?: InputMaybe<Emails_Bool_Exp>;
  email_id?: InputMaybe<Uuid_Comparison_Exp>;
  entity_data?: InputMaybe<Entity_Data_Bool_Exp>;
  entity_data_aggregate?: InputMaybe<Entity_Data_Aggregate_Bool_Exp>;
  full_url?: InputMaybe<Full_Urls_Bool_Exp>;
  full_url_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  id_similarity_score?: InputMaybe<Float_Comparison_Exp>;
  latest_alert_queue_state?: InputMaybe<String_Comparison_Exp>;
  match_attributions?: InputMaybe<Match_Attributions_Bool_Exp>;
  match_attributions_aggregate?: InputMaybe<Match_Attributions_Aggregate_Bool_Exp>;
  ml_features?: InputMaybe<Ml_Features_Bool_Exp>;
  ml_features_aggregate?: InputMaybe<Ml_Features_Aggregate_Bool_Exp>;
  mobile_app?: InputMaybe<Mobile_Apps_Bool_Exp>;
  mobile_app_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_number?: InputMaybe<Phone_Numbers_Bool_Exp>;
  phone_number_id?: InputMaybe<Uuid_Comparison_Exp>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Bool_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  snapshot_source?: InputMaybe<String_Comparison_Exp>;
  social_media_data?: InputMaybe<Social_Media_Data_Bool_Exp>;
  social_media_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  social_media_group?: InputMaybe<Social_Media_Group_Bool_Exp>;
  social_media_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  social_media_post?: InputMaybe<Social_Media_Post_Bool_Exp>;
  social_media_post_id?: InputMaybe<Uuid_Comparison_Exp>;
  spoof_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  suspicion_score?: InputMaybe<Numeric_Comparison_Exp>;
  universal_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "spoof_matches" */
export enum Spoof_Matches_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpoofMatchesPkey = 'spoof_matches_pkey',
  /** unique or primary key constraint on columns "social_media_group_id", "spoof_report_id" */
  SpoofMatchesSocialMediaGroupIdSpoofReportIdKey = 'spoof_matches_social_media_group_id_spoof_report_id_key',
  /** unique or primary key constraint on columns "social_media_post_id", "spoof_report_id" */
  SpoofMatchesSocialMediaPostIdSpoofReportIdKey = 'spoof_matches_social_media_post_id_spoof_report_id_key',
  /** unique or primary key constraint on columns "spoof_report_id", "advertisement_data_id" */
  SpoofMatchesSpoofReportIdAdvertisementDataIdKey = 'spoof_matches_spoof_report_id_advertisement_data_id_key',
  /** unique or primary key constraint on columns "spoof_report_id", "dark_web_id" */
  SpoofMatchesSpoofReportIdDarkWebIdKey = 'spoof_matches_spoof_report_id_dark_web_id_key',
  /** unique or primary key constraint on columns "ecommerce_listing_id", "spoof_report_id" */
  SpoofMatchesSpoofReportIdEcommerceListingIdKey = 'spoof_matches_spoof_report_id_ecommerce_listing_id_key',
  /** unique or primary key constraint on columns "spoof_report_id", "email_id" */
  SpoofMatchesSpoofReportIdEmailIdKey = 'spoof_matches_spoof_report_id_email_id_key',
  /** unique or primary key constraint on columns "full_url_id", "spoof_report_id" */
  SpoofMatchesSpoofReportIdFullUrlIdKey = 'spoof_matches_spoof_report_id_full_url_id_key',
  /** unique or primary key constraint on columns "spoof_report_id", "mobile_app_id" */
  SpoofMatchesSpoofReportIdMobileAppsIdKey = 'spoof_matches_spoof_report_id_mobile_apps_id_key',
  /** unique or primary key constraint on columns "spoof_report_id", "phone_number_id" */
  SpoofMatchesSpoofReportIdPhoneNumberIdKey = 'spoof_matches_spoof_report_id_phone_number_id_key',
  /** unique or primary key constraint on columns "spoof_report_id", "social_media_data_id" */
  SpoofMatchesSpoofReportIdSocialMediaDataIdKey = 'spoof_matches_spoof_report_id_social_media_data_id_key',
  /** unique or primary key constraint on columns "social_media_post_id", "spoof_report_id" */
  SpoofMatchesSpoofReportIdSocialMediaPostIdKey = 'spoof_matches_spoof_report_id_social_media_post_id_key',
  /** unique or primary key constraint on columns "spoof_report_id", "universal_entity_id" */
  SpoofMatchesUniversalEntityIdSpoofReportIdKey = 'spoof_matches_universal_entity_id_spoof_report_id_key'
}

/** input type for incrementing numeric columns in table "spoof_matches" */
export type Spoof_Matches_Inc_Input = {
  id_similarity_score?: InputMaybe<Scalars['Float']>;
  suspicion_score?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "spoof_matches" */
export type Spoof_Matches_Insert_Input = {
  advertisement_data?: InputMaybe<Advertisement_Data_Obj_Rel_Insert_Input>;
  advertisement_data_id?: InputMaybe<Scalars['uuid']>;
  classification?: InputMaybe<Scalars['spoofing_status']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  dark_web?: InputMaybe<Dark_Web_Obj_Rel_Insert_Input>;
  dark_web_id?: InputMaybe<Scalars['uuid']>;
  delist_screenshot_url?: InputMaybe<Scalars['String']>;
  ecommerce_listing?: InputMaybe<Ecommerce_Listings_Obj_Rel_Insert_Input>;
  ecommerce_listing_id?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Emails_Obj_Rel_Insert_Input>;
  email_id?: InputMaybe<Scalars['uuid']>;
  entity_data?: InputMaybe<Entity_Data_Arr_Rel_Insert_Input>;
  full_url?: InputMaybe<Full_Urls_Obj_Rel_Insert_Input>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  id_similarity_score?: InputMaybe<Scalars['Float']>;
  latest_alert_queue_state?: InputMaybe<Scalars['String']>;
  match_attributions?: InputMaybe<Match_Attributions_Arr_Rel_Insert_Input>;
  ml_features?: InputMaybe<Ml_Features_Arr_Rel_Insert_Input>;
  mobile_app?: InputMaybe<Mobile_Apps_Obj_Rel_Insert_Input>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  phone_number?: InputMaybe<Phone_Numbers_Obj_Rel_Insert_Input>;
  phone_number_id?: InputMaybe<Scalars['uuid']>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Obj_Rel_Insert_Input>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  snapshot_source?: InputMaybe<Scalars['String']>;
  social_media_data?: InputMaybe<Social_Media_Data_Obj_Rel_Insert_Input>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_group?: InputMaybe<Social_Media_Group_Obj_Rel_Insert_Input>;
  social_media_group_id?: InputMaybe<Scalars['uuid']>;
  social_media_post?: InputMaybe<Social_Media_Post_Obj_Rel_Insert_Input>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  spoof_report_id?: InputMaybe<Scalars['uuid']>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  suspicion_score?: InputMaybe<Scalars['numeric']>;
  universal_entity_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Spoof_Matches_Max_Fields = {
  __typename?: 'spoof_matches_max_fields';
  advertisement_data_id?: Maybe<Scalars['uuid']>;
  classification?: Maybe<Scalars['spoofing_status']>;
  created_at?: Maybe<Scalars['timestamp']>;
  dark_web_id?: Maybe<Scalars['uuid']>;
  delist_screenshot_url?: Maybe<Scalars['String']>;
  ecommerce_listing_id?: Maybe<Scalars['uuid']>;
  email_id?: Maybe<Scalars['uuid']>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  id_similarity_score?: Maybe<Scalars['Float']>;
  latest_alert_queue_state?: Maybe<Scalars['String']>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  phone_number_id?: Maybe<Scalars['uuid']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  snapshot_source?: Maybe<Scalars['String']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  social_media_group_id?: Maybe<Scalars['uuid']>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  spoof_report_id?: Maybe<Scalars['uuid']>;
  suspicion_score?: Maybe<Scalars['numeric']>;
  universal_entity_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "spoof_matches" */
export type Spoof_Matches_Max_Order_By = {
  advertisement_data_id?: InputMaybe<Order_By>;
  classification?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dark_web_id?: InputMaybe<Order_By>;
  delist_screenshot_url?: InputMaybe<Order_By>;
  ecommerce_listing_id?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  full_url_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_similarity_score?: InputMaybe<Order_By>;
  latest_alert_queue_state?: InputMaybe<Order_By>;
  mobile_app_id?: InputMaybe<Order_By>;
  phone_number_id?: InputMaybe<Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  snapshot_source?: InputMaybe<Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  social_media_group_id?: InputMaybe<Order_By>;
  social_media_post_id?: InputMaybe<Order_By>;
  spoof_report_id?: InputMaybe<Order_By>;
  suspicion_score?: InputMaybe<Order_By>;
  universal_entity_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spoof_Matches_Min_Fields = {
  __typename?: 'spoof_matches_min_fields';
  advertisement_data_id?: Maybe<Scalars['uuid']>;
  classification?: Maybe<Scalars['spoofing_status']>;
  created_at?: Maybe<Scalars['timestamp']>;
  dark_web_id?: Maybe<Scalars['uuid']>;
  delist_screenshot_url?: Maybe<Scalars['String']>;
  ecommerce_listing_id?: Maybe<Scalars['uuid']>;
  email_id?: Maybe<Scalars['uuid']>;
  full_url_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  id_similarity_score?: Maybe<Scalars['Float']>;
  latest_alert_queue_state?: Maybe<Scalars['String']>;
  mobile_app_id?: Maybe<Scalars['uuid']>;
  phone_number_id?: Maybe<Scalars['uuid']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  snapshot_source?: Maybe<Scalars['String']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  social_media_group_id?: Maybe<Scalars['uuid']>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  spoof_report_id?: Maybe<Scalars['uuid']>;
  suspicion_score?: Maybe<Scalars['numeric']>;
  universal_entity_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "spoof_matches" */
export type Spoof_Matches_Min_Order_By = {
  advertisement_data_id?: InputMaybe<Order_By>;
  classification?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dark_web_id?: InputMaybe<Order_By>;
  delist_screenshot_url?: InputMaybe<Order_By>;
  ecommerce_listing_id?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  full_url_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_similarity_score?: InputMaybe<Order_By>;
  latest_alert_queue_state?: InputMaybe<Order_By>;
  mobile_app_id?: InputMaybe<Order_By>;
  phone_number_id?: InputMaybe<Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  snapshot_source?: InputMaybe<Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  social_media_group_id?: InputMaybe<Order_By>;
  social_media_post_id?: InputMaybe<Order_By>;
  spoof_report_id?: InputMaybe<Order_By>;
  suspicion_score?: InputMaybe<Order_By>;
  universal_entity_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spoof_matches" */
export type Spoof_Matches_Mutation_Response = {
  __typename?: 'spoof_matches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Spoof_Matches>;
};

/** input type for inserting object relation for remote table "spoof_matches" */
export type Spoof_Matches_Obj_Rel_Insert_Input = {
  data: Spoof_Matches_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Spoof_Matches_On_Conflict>;
};

/** on_conflict condition type for table "spoof_matches" */
export type Spoof_Matches_On_Conflict = {
  constraint: Spoof_Matches_Constraint;
  update_columns?: Array<Spoof_Matches_Update_Column>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};

/** Ordering options when selecting data from "spoof_matches". */
export type Spoof_Matches_Order_By = {
  advertisement_data?: InputMaybe<Advertisement_Data_Order_By>;
  advertisement_data_id?: InputMaybe<Order_By>;
  classification?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dark_web?: InputMaybe<Dark_Web_Order_By>;
  dark_web_id?: InputMaybe<Order_By>;
  delist_screenshot_url?: InputMaybe<Order_By>;
  ecommerce_listing?: InputMaybe<Ecommerce_Listings_Order_By>;
  ecommerce_listing_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Emails_Order_By>;
  email_id?: InputMaybe<Order_By>;
  entity_data_aggregate?: InputMaybe<Entity_Data_Aggregate_Order_By>;
  full_url?: InputMaybe<Full_Urls_Order_By>;
  full_url_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_similarity_score?: InputMaybe<Order_By>;
  latest_alert_queue_state?: InputMaybe<Order_By>;
  match_attributions_aggregate?: InputMaybe<Match_Attributions_Aggregate_Order_By>;
  ml_features_aggregate?: InputMaybe<Ml_Features_Aggregate_Order_By>;
  mobile_app?: InputMaybe<Mobile_Apps_Order_By>;
  mobile_app_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Phone_Numbers_Order_By>;
  phone_number_id?: InputMaybe<Order_By>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  snapshot_source?: InputMaybe<Order_By>;
  social_media_data?: InputMaybe<Social_Media_Data_Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  social_media_group?: InputMaybe<Social_Media_Group_Order_By>;
  social_media_group_id?: InputMaybe<Order_By>;
  social_media_post?: InputMaybe<Social_Media_Post_Order_By>;
  social_media_post_id?: InputMaybe<Order_By>;
  spoof_report_id?: InputMaybe<Order_By>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Order_By>;
  suspicion_score?: InputMaybe<Order_By>;
  universal_entity_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spoof_matches */
export type Spoof_Matches_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "spoof_matches" */
export enum Spoof_Matches_Select_Column {
  /** column name */
  AdvertisementDataId = 'advertisement_data_id',
  /** column name */
  Classification = 'classification',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DarkWebId = 'dark_web_id',
  /** column name */
  DelistScreenshotUrl = 'delist_screenshot_url',
  /** column name */
  EcommerceListingId = 'ecommerce_listing_id',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  FullUrlId = 'full_url_id',
  /** column name */
  Id = 'id',
  /** column name */
  IdSimilarityScore = 'id_similarity_score',
  /** column name */
  LatestAlertQueueState = 'latest_alert_queue_state',
  /** column name */
  MobileAppId = 'mobile_app_id',
  /** column name */
  PhoneNumberId = 'phone_number_id',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  SnapshotSource = 'snapshot_source',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SocialMediaGroupId = 'social_media_group_id',
  /** column name */
  SocialMediaPostId = 'social_media_post_id',
  /** column name */
  SpoofReportId = 'spoof_report_id',
  /** column name */
  SuspicionScore = 'suspicion_score',
  /** column name */
  UniversalEntityId = 'universal_entity_id'
}

/** input type for updating data in table "spoof_matches" */
export type Spoof_Matches_Set_Input = {
  advertisement_data_id?: InputMaybe<Scalars['uuid']>;
  classification?: InputMaybe<Scalars['spoofing_status']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  dark_web_id?: InputMaybe<Scalars['uuid']>;
  delist_screenshot_url?: InputMaybe<Scalars['String']>;
  ecommerce_listing_id?: InputMaybe<Scalars['uuid']>;
  email_id?: InputMaybe<Scalars['uuid']>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  id_similarity_score?: InputMaybe<Scalars['Float']>;
  latest_alert_queue_state?: InputMaybe<Scalars['String']>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  phone_number_id?: InputMaybe<Scalars['uuid']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  snapshot_source?: InputMaybe<Scalars['String']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_group_id?: InputMaybe<Scalars['uuid']>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  spoof_report_id?: InputMaybe<Scalars['uuid']>;
  suspicion_score?: InputMaybe<Scalars['numeric']>;
  universal_entity_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Spoof_Matches_Stddev_Fields = {
  __typename?: 'spoof_matches_stddev_fields';
  id_similarity_score?: Maybe<Scalars['Float']>;
  suspicion_score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "spoof_matches" */
export type Spoof_Matches_Stddev_Order_By = {
  id_similarity_score?: InputMaybe<Order_By>;
  suspicion_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spoof_Matches_Stddev_Pop_Fields = {
  __typename?: 'spoof_matches_stddev_pop_fields';
  id_similarity_score?: Maybe<Scalars['Float']>;
  suspicion_score?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "spoof_matches" */
export type Spoof_Matches_Stddev_Pop_Order_By = {
  id_similarity_score?: InputMaybe<Order_By>;
  suspicion_score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spoof_Matches_Stddev_Samp_Fields = {
  __typename?: 'spoof_matches_stddev_samp_fields';
  id_similarity_score?: Maybe<Scalars['Float']>;
  suspicion_score?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "spoof_matches" */
export type Spoof_Matches_Stddev_Samp_Order_By = {
  id_similarity_score?: InputMaybe<Order_By>;
  suspicion_score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spoof_matches" */
export type Spoof_Matches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spoof_Matches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spoof_Matches_Stream_Cursor_Value_Input = {
  advertisement_data_id?: InputMaybe<Scalars['uuid']>;
  classification?: InputMaybe<Scalars['spoofing_status']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  dark_web_id?: InputMaybe<Scalars['uuid']>;
  delist_screenshot_url?: InputMaybe<Scalars['String']>;
  ecommerce_listing_id?: InputMaybe<Scalars['uuid']>;
  email_id?: InputMaybe<Scalars['uuid']>;
  full_url_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  id_similarity_score?: InputMaybe<Scalars['Float']>;
  latest_alert_queue_state?: InputMaybe<Scalars['String']>;
  mobile_app_id?: InputMaybe<Scalars['uuid']>;
  phone_number_id?: InputMaybe<Scalars['uuid']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  snapshot_source?: InputMaybe<Scalars['String']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_group_id?: InputMaybe<Scalars['uuid']>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  spoof_report_id?: InputMaybe<Scalars['uuid']>;
  suspicion_score?: InputMaybe<Scalars['numeric']>;
  universal_entity_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Spoof_Matches_Sum_Fields = {
  __typename?: 'spoof_matches_sum_fields';
  id_similarity_score?: Maybe<Scalars['Float']>;
  suspicion_score?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "spoof_matches" */
export type Spoof_Matches_Sum_Order_By = {
  id_similarity_score?: InputMaybe<Order_By>;
  suspicion_score?: InputMaybe<Order_By>;
};

/** update columns of table "spoof_matches" */
export enum Spoof_Matches_Update_Column {
  /** column name */
  AdvertisementDataId = 'advertisement_data_id',
  /** column name */
  Classification = 'classification',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DarkWebId = 'dark_web_id',
  /** column name */
  DelistScreenshotUrl = 'delist_screenshot_url',
  /** column name */
  EcommerceListingId = 'ecommerce_listing_id',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  FullUrlId = 'full_url_id',
  /** column name */
  Id = 'id',
  /** column name */
  IdSimilarityScore = 'id_similarity_score',
  /** column name */
  LatestAlertQueueState = 'latest_alert_queue_state',
  /** column name */
  MobileAppId = 'mobile_app_id',
  /** column name */
  PhoneNumberId = 'phone_number_id',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  SnapshotSource = 'snapshot_source',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SocialMediaGroupId = 'social_media_group_id',
  /** column name */
  SocialMediaPostId = 'social_media_post_id',
  /** column name */
  SpoofReportId = 'spoof_report_id',
  /** column name */
  SuspicionScore = 'suspicion_score',
  /** column name */
  UniversalEntityId = 'universal_entity_id'
}

export type Spoof_Matches_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spoof_Matches_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spoof_Matches_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spoof_Matches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spoof_Matches_Var_Pop_Fields = {
  __typename?: 'spoof_matches_var_pop_fields';
  id_similarity_score?: Maybe<Scalars['Float']>;
  suspicion_score?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "spoof_matches" */
export type Spoof_Matches_Var_Pop_Order_By = {
  id_similarity_score?: InputMaybe<Order_By>;
  suspicion_score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spoof_Matches_Var_Samp_Fields = {
  __typename?: 'spoof_matches_var_samp_fields';
  id_similarity_score?: Maybe<Scalars['Float']>;
  suspicion_score?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "spoof_matches" */
export type Spoof_Matches_Var_Samp_Order_By = {
  id_similarity_score?: InputMaybe<Order_By>;
  suspicion_score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spoof_Matches_Variance_Fields = {
  __typename?: 'spoof_matches_variance_fields';
  id_similarity_score?: Maybe<Scalars['Float']>;
  suspicion_score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "spoof_matches" */
export type Spoof_Matches_Variance_Order_By = {
  id_similarity_score?: InputMaybe<Order_By>;
  suspicion_score?: InputMaybe<Order_By>;
};

/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_Entities = {
  __typename?: 'spoofing_entities';
  created_at?: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  customer_assets_to_brands: Array<Customer_Assets_To_Brands>;
  /** An aggregate relationship */
  customer_assets_to_brands_aggregate: Customer_Assets_To_Brands_Aggregate;
  /** An array relationship */
  designated_takedown_assets: Array<Designated_Takedown_Assets>;
  /** An aggregate relationship */
  designated_takedown_assets_aggregate: Designated_Takedown_Assets_Aggregate;
  /** An array relationship */
  detection_assets: Array<Detection_Assets>;
  /** An aggregate relationship */
  detection_assets_aggregate: Detection_Assets_Aggregate;
  domain_data: Scalars['jsonb'];
  entity_name: Scalars['String'];
  entity_name_search_queries?: Maybe<Scalars['jsonb']>;
  entity_type: Scalars['String'];
  entity_url?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  last_updated_by_user?: Maybe<Users>;
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  negative_keywords?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
  /** An array relationship */
  protected_assets: Array<Protected_Assets>;
  /** An aggregate relationship */
  protected_assets_aggregate: Protected_Assets_Aggregate;
  screenshot_url?: Maybe<Scalars['String']>;
  social_media_data: Scalars['jsonb'];
  /** An array relationship */
  sourcing_queries: Array<Sourcing_Queries>;
  /** An aggregate relationship */
  sourcing_queries_aggregate: Sourcing_Queries_Aggregate;
  trademark_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  trademarks: Array<Trademarks>;
  /** An aggregate relationship */
  trademarks_aggregate: Trademarks_Aggregate;
  updated_at?: Maybe<Scalars['timestamp']>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesCustomer_Assets_To_BrandsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_To_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_To_Brands_Order_By>>;
  where?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesCustomer_Assets_To_Brands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_To_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_To_Brands_Order_By>>;
  where?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesDesignated_Takedown_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Designated_Takedown_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Designated_Takedown_Assets_Order_By>>;
  where?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesDesignated_Takedown_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Designated_Takedown_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Designated_Takedown_Assets_Order_By>>;
  where?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesDetection_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Detection_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_Assets_Order_By>>;
  where?: InputMaybe<Detection_Assets_Bool_Exp>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesDetection_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Detection_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_Assets_Order_By>>;
  where?: InputMaybe<Detection_Assets_Bool_Exp>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesDomain_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesEntity_Name_Search_QueriesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesNegative_KeywordsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesProtected_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Protected_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Protected_Assets_Order_By>>;
  where?: InputMaybe<Protected_Assets_Bool_Exp>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesProtected_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Protected_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Protected_Assets_Order_By>>;
  where?: InputMaybe<Protected_Assets_Bool_Exp>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesSocial_Media_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesSourcing_QueriesArgs = {
  distinct_on?: InputMaybe<Array<Sourcing_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sourcing_Queries_Order_By>>;
  where?: InputMaybe<Sourcing_Queries_Bool_Exp>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesSourcing_Queries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sourcing_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sourcing_Queries_Order_By>>;
  where?: InputMaybe<Sourcing_Queries_Bool_Exp>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesTrademarksArgs = {
  distinct_on?: InputMaybe<Array<Trademarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trademarks_Order_By>>;
  where?: InputMaybe<Trademarks_Bool_Exp>;
};


/** This contains all the information related to a brand or a collection owned by the brand */
export type Spoofing_EntitiesTrademarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trademarks_Order_By>>;
  where?: InputMaybe<Trademarks_Bool_Exp>;
};

/** aggregated selection of "spoofing_entities" */
export type Spoofing_Entities_Aggregate = {
  __typename?: 'spoofing_entities_aggregate';
  aggregate?: Maybe<Spoofing_Entities_Aggregate_Fields>;
  nodes: Array<Spoofing_Entities>;
};

export type Spoofing_Entities_Aggregate_Bool_Exp = {
  count?: InputMaybe<Spoofing_Entities_Aggregate_Bool_Exp_Count>;
};

export type Spoofing_Entities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spoofing_Entities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spoofing_entities" */
export type Spoofing_Entities_Aggregate_Fields = {
  __typename?: 'spoofing_entities_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Spoofing_Entities_Max_Fields>;
  min?: Maybe<Spoofing_Entities_Min_Fields>;
};


/** aggregate fields of "spoofing_entities" */
export type Spoofing_Entities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spoofing_Entities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "spoofing_entities" */
export type Spoofing_Entities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spoofing_Entities_Max_Order_By>;
  min?: InputMaybe<Spoofing_Entities_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Spoofing_Entities_Append_Input = {
  domain_data?: InputMaybe<Scalars['jsonb']>;
  entity_name_search_queries?: InputMaybe<Scalars['jsonb']>;
  negative_keywords?: InputMaybe<Scalars['jsonb']>;
  social_media_data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "spoofing_entities" */
export type Spoofing_Entities_Arr_Rel_Insert_Input = {
  data: Array<Spoofing_Entities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spoofing_Entities_On_Conflict>;
};

/** Boolean expression to filter rows from the table "spoofing_entities". All fields are combined with a logical 'AND'. */
export type Spoofing_Entities_Bool_Exp = {
  _and?: InputMaybe<Array<Spoofing_Entities_Bool_Exp>>;
  _not?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  _or?: InputMaybe<Array<Spoofing_Entities_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  customer_assets_to_brands?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
  customer_assets_to_brands_aggregate?: InputMaybe<Customer_Assets_To_Brands_Aggregate_Bool_Exp>;
  designated_takedown_assets?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
  designated_takedown_assets_aggregate?: InputMaybe<Designated_Takedown_Assets_Aggregate_Bool_Exp>;
  detection_assets?: InputMaybe<Detection_Assets_Bool_Exp>;
  detection_assets_aggregate?: InputMaybe<Detection_Assets_Aggregate_Bool_Exp>;
  domain_data?: InputMaybe<Jsonb_Comparison_Exp>;
  entity_name?: InputMaybe<String_Comparison_Exp>;
  entity_name_search_queries?: InputMaybe<Jsonb_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  entity_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_updated_by_user?: InputMaybe<Users_Bool_Exp>;
  last_updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  negative_keywords?: InputMaybe<Jsonb_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  protected_assets?: InputMaybe<Protected_Assets_Bool_Exp>;
  protected_assets_aggregate?: InputMaybe<Protected_Assets_Aggregate_Bool_Exp>;
  screenshot_url?: InputMaybe<String_Comparison_Exp>;
  social_media_data?: InputMaybe<Jsonb_Comparison_Exp>;
  sourcing_queries?: InputMaybe<Sourcing_Queries_Bool_Exp>;
  sourcing_queries_aggregate?: InputMaybe<Sourcing_Queries_Aggregate_Bool_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  trademarks?: InputMaybe<Trademarks_Bool_Exp>;
  trademarks_aggregate?: InputMaybe<Trademarks_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "spoofing_entities" */
export enum Spoofing_Entities_Constraint {
  /** unique or primary key constraint on columns "entity_name", "organization_id" */
  SpoofingEntitiesOrganizationIdEntityNameKey = 'spoofing_entities_organization_id_entity_name_key',
  /** unique or primary key constraint on columns "id" */
  SpoofingEntitiesPkey = 'spoofing_entities_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Spoofing_Entities_Delete_At_Path_Input = {
  domain_data?: InputMaybe<Array<Scalars['String']>>;
  entity_name_search_queries?: InputMaybe<Array<Scalars['String']>>;
  negative_keywords?: InputMaybe<Array<Scalars['String']>>;
  social_media_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Spoofing_Entities_Delete_Elem_Input = {
  domain_data?: InputMaybe<Scalars['Int']>;
  entity_name_search_queries?: InputMaybe<Scalars['Int']>;
  negative_keywords?: InputMaybe<Scalars['Int']>;
  social_media_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Spoofing_Entities_Delete_Key_Input = {
  domain_data?: InputMaybe<Scalars['String']>;
  entity_name_search_queries?: InputMaybe<Scalars['String']>;
  negative_keywords?: InputMaybe<Scalars['String']>;
  social_media_data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "spoofing_entities" */
export type Spoofing_Entities_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  customer_assets_to_brands?: InputMaybe<Customer_Assets_To_Brands_Arr_Rel_Insert_Input>;
  designated_takedown_assets?: InputMaybe<Designated_Takedown_Assets_Arr_Rel_Insert_Input>;
  detection_assets?: InputMaybe<Detection_Assets_Arr_Rel_Insert_Input>;
  domain_data?: InputMaybe<Scalars['jsonb']>;
  entity_name?: InputMaybe<Scalars['String']>;
  entity_name_search_queries?: InputMaybe<Scalars['jsonb']>;
  entity_type?: InputMaybe<Scalars['String']>;
  entity_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  negative_keywords?: InputMaybe<Scalars['jsonb']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  protected_assets?: InputMaybe<Protected_Assets_Arr_Rel_Insert_Input>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  social_media_data?: InputMaybe<Scalars['jsonb']>;
  sourcing_queries?: InputMaybe<Sourcing_Queries_Arr_Rel_Insert_Input>;
  trademark_id?: InputMaybe<Scalars['uuid']>;
  trademarks?: InputMaybe<Trademarks_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Spoofing_Entities_Max_Fields = {
  __typename?: 'spoofing_entities_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  entity_name?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  entity_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  screenshot_url?: Maybe<Scalars['String']>;
  trademark_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "spoofing_entities" */
export type Spoofing_Entities_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_name?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  entity_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_by_user_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spoofing_Entities_Min_Fields = {
  __typename?: 'spoofing_entities_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  entity_name?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  entity_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_updated_by_user_id?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  screenshot_url?: Maybe<Scalars['String']>;
  trademark_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "spoofing_entities" */
export type Spoofing_Entities_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  entity_name?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  entity_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_by_user_id?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spoofing_entities" */
export type Spoofing_Entities_Mutation_Response = {
  __typename?: 'spoofing_entities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Spoofing_Entities>;
};

/** input type for inserting object relation for remote table "spoofing_entities" */
export type Spoofing_Entities_Obj_Rel_Insert_Input = {
  data: Spoofing_Entities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Spoofing_Entities_On_Conflict>;
};

/** on_conflict condition type for table "spoofing_entities" */
export type Spoofing_Entities_On_Conflict = {
  constraint: Spoofing_Entities_Constraint;
  update_columns?: Array<Spoofing_Entities_Update_Column>;
  where?: InputMaybe<Spoofing_Entities_Bool_Exp>;
};

/** Ordering options when selecting data from "spoofing_entities". */
export type Spoofing_Entities_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customer_assets_to_brands_aggregate?: InputMaybe<Customer_Assets_To_Brands_Aggregate_Order_By>;
  designated_takedown_assets_aggregate?: InputMaybe<Designated_Takedown_Assets_Aggregate_Order_By>;
  detection_assets_aggregate?: InputMaybe<Detection_Assets_Aggregate_Order_By>;
  domain_data?: InputMaybe<Order_By>;
  entity_name?: InputMaybe<Order_By>;
  entity_name_search_queries?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  entity_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_updated_by_user?: InputMaybe<Users_Order_By>;
  last_updated_by_user_id?: InputMaybe<Order_By>;
  negative_keywords?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  protected_assets_aggregate?: InputMaybe<Protected_Assets_Aggregate_Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  social_media_data?: InputMaybe<Order_By>;
  sourcing_queries_aggregate?: InputMaybe<Sourcing_Queries_Aggregate_Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  trademarks_aggregate?: InputMaybe<Trademarks_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spoofing_entities */
export type Spoofing_Entities_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Spoofing_Entities_Prepend_Input = {
  domain_data?: InputMaybe<Scalars['jsonb']>;
  entity_name_search_queries?: InputMaybe<Scalars['jsonb']>;
  negative_keywords?: InputMaybe<Scalars['jsonb']>;
  social_media_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "spoofing_entities" */
export enum Spoofing_Entities_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainData = 'domain_data',
  /** column name */
  EntityName = 'entity_name',
  /** column name */
  EntityNameSearchQueries = 'entity_name_search_queries',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  EntityUrl = 'entity_url',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedByUserId = 'last_updated_by_user_id',
  /** column name */
  NegativeKeywords = 'negative_keywords',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  SocialMediaData = 'social_media_data',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "spoofing_entities" */
export type Spoofing_Entities_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data?: InputMaybe<Scalars['jsonb']>;
  entity_name?: InputMaybe<Scalars['String']>;
  entity_name_search_queries?: InputMaybe<Scalars['jsonb']>;
  entity_type?: InputMaybe<Scalars['String']>;
  entity_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  negative_keywords?: InputMaybe<Scalars['jsonb']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  social_media_data?: InputMaybe<Scalars['jsonb']>;
  trademark_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "spoofing_entities" */
export type Spoofing_Entities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spoofing_Entities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spoofing_Entities_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data?: InputMaybe<Scalars['jsonb']>;
  entity_name?: InputMaybe<Scalars['String']>;
  entity_name_search_queries?: InputMaybe<Scalars['jsonb']>;
  entity_type?: InputMaybe<Scalars['String']>;
  entity_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_updated_by_user_id?: InputMaybe<Scalars['uuid']>;
  negative_keywords?: InputMaybe<Scalars['jsonb']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  social_media_data?: InputMaybe<Scalars['jsonb']>;
  trademark_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "spoofing_entities" */
export enum Spoofing_Entities_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainData = 'domain_data',
  /** column name */
  EntityName = 'entity_name',
  /** column name */
  EntityNameSearchQueries = 'entity_name_search_queries',
  /** column name */
  EntityType = 'entity_type',
  /** column name */
  EntityUrl = 'entity_url',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedByUserId = 'last_updated_by_user_id',
  /** column name */
  NegativeKeywords = 'negative_keywords',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  SocialMediaData = 'social_media_data',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Spoofing_Entities_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Spoofing_Entities_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Spoofing_Entities_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Spoofing_Entities_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Spoofing_Entities_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Spoofing_Entities_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spoofing_Entities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spoofing_Entities_Bool_Exp;
};

/** columns and relationships of "spoofing_report_search_results" */
export type Spoofing_Report_Search_Results = {
  __typename?: 'spoofing_report_search_results';
  /** An array relationship */
  collection_report_changes: Array<Collection_Report_Changes>;
  /** An aggregate relationship */
  collection_report_changes_aggregate: Collection_Report_Changes_Aggregate;
  created_at?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  domain_data?: Maybe<Domain_Data>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  domain_name_match?: Maybe<Scalars['domain_name_match_type']>;
  /** An array relationship */
  enforcement_requests: Array<Enforcement_Requests>;
  /** An aggregate relationship */
  enforcement_requests_aggregate: Enforcement_Requests_Aggregate;
  flagged_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  importance_score?: Maybe<Scalars['numeric']>;
  is_exact_flagged_url?: Maybe<Scalars['Boolean']>;
  is_exact_match_url?: Maybe<Scalars['Boolean']>;
  is_similar_flagged_url?: Maybe<Scalars['Boolean']>;
  is_similar_match_url?: Maybe<Scalars['Boolean']>;
  last_reported_at?: Maybe<Scalars['timestamp']>;
  last_resolved_at?: Maybe<Scalars['timestamp']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  report_screenshots?: Maybe<Scalars['jsonb']>;
  report_status?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  screenshot_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  social_media_data?: Maybe<Social_Media_Data>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  social_media_post?: Maybe<Social_Media_Post>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  /** An array relationship */
  spoof_matches: Array<Spoof_Matches>;
  /** An aggregate relationship */
  spoof_matches_aggregate: Spoof_Matches_Aggregate;
  spoof_status?: Maybe<Scalars['spoofing_status']>;
  /** An object relationship */
  spoofing_entity?: Maybe<Spoofing_Entities>;
  type?: Maybe<Scalars['String']>;
  unsanitized_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  uploader?: Maybe<Users>;
  uploader_id?: Maybe<Scalars['uuid']>;
  website_content?: Maybe<Scalars['String']>;
};


/** columns and relationships of "spoofing_report_search_results" */
export type Spoofing_Report_Search_ResultsCollection_Report_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};


/** columns and relationships of "spoofing_report_search_results" */
export type Spoofing_Report_Search_ResultsCollection_Report_Changes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};


/** columns and relationships of "spoofing_report_search_results" */
export type Spoofing_Report_Search_ResultsEnforcement_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Requests_Order_By>>;
  where?: InputMaybe<Enforcement_Requests_Bool_Exp>;
};


/** columns and relationships of "spoofing_report_search_results" */
export type Spoofing_Report_Search_ResultsEnforcement_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Requests_Order_By>>;
  where?: InputMaybe<Enforcement_Requests_Bool_Exp>;
};


/** columns and relationships of "spoofing_report_search_results" */
export type Spoofing_Report_Search_ResultsReport_ScreenshotsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "spoofing_report_search_results" */
export type Spoofing_Report_Search_ResultsSpoof_MatchesArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};


/** columns and relationships of "spoofing_report_search_results" */
export type Spoofing_Report_Search_ResultsSpoof_Matches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};

/** aggregated selection of "spoofing_report_search_results" */
export type Spoofing_Report_Search_Results_Aggregate = {
  __typename?: 'spoofing_report_search_results_aggregate';
  aggregate?: Maybe<Spoofing_Report_Search_Results_Aggregate_Fields>;
  nodes: Array<Spoofing_Report_Search_Results>;
};

/** aggregate fields of "spoofing_report_search_results" */
export type Spoofing_Report_Search_Results_Aggregate_Fields = {
  __typename?: 'spoofing_report_search_results_aggregate_fields';
  avg?: Maybe<Spoofing_Report_Search_Results_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Spoofing_Report_Search_Results_Max_Fields>;
  min?: Maybe<Spoofing_Report_Search_Results_Min_Fields>;
  stddev?: Maybe<Spoofing_Report_Search_Results_Stddev_Fields>;
  stddev_pop?: Maybe<Spoofing_Report_Search_Results_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spoofing_Report_Search_Results_Stddev_Samp_Fields>;
  sum?: Maybe<Spoofing_Report_Search_Results_Sum_Fields>;
  var_pop?: Maybe<Spoofing_Report_Search_Results_Var_Pop_Fields>;
  var_samp?: Maybe<Spoofing_Report_Search_Results_Var_Samp_Fields>;
  variance?: Maybe<Spoofing_Report_Search_Results_Variance_Fields>;
};


/** aggregate fields of "spoofing_report_search_results" */
export type Spoofing_Report_Search_Results_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spoofing_Report_Search_Results_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Spoofing_Report_Search_Results_Append_Input = {
  report_screenshots?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Spoofing_Report_Search_Results_Avg_Fields = {
  __typename?: 'spoofing_report_search_results_avg_fields';
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "spoofing_report_search_results". All fields are combined with a logical 'AND'. */
export type Spoofing_Report_Search_Results_Bool_Exp = {
  _and?: InputMaybe<Array<Spoofing_Report_Search_Results_Bool_Exp>>;
  _not?: InputMaybe<Spoofing_Report_Search_Results_Bool_Exp>;
  _or?: InputMaybe<Array<Spoofing_Report_Search_Results_Bool_Exp>>;
  collection_report_changes?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
  collection_report_changes_aggregate?: InputMaybe<Collection_Report_Changes_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  domain_data?: InputMaybe<Domain_Data_Bool_Exp>;
  domain_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  domain_name_match?: InputMaybe<Domain_Name_Match_Type_Comparison_Exp>;
  enforcement_requests?: InputMaybe<Enforcement_Requests_Bool_Exp>;
  enforcement_requests_aggregate?: InputMaybe<Enforcement_Requests_Aggregate_Bool_Exp>;
  flagged_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  importance_score?: InputMaybe<Numeric_Comparison_Exp>;
  is_exact_flagged_url?: InputMaybe<Boolean_Comparison_Exp>;
  is_exact_match_url?: InputMaybe<Boolean_Comparison_Exp>;
  is_similar_flagged_url?: InputMaybe<Boolean_Comparison_Exp>;
  is_similar_match_url?: InputMaybe<Boolean_Comparison_Exp>;
  last_reported_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_resolved_at?: InputMaybe<Timestamp_Comparison_Exp>;
  max_id_similarity_score?: InputMaybe<Float_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  original_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  report_screenshots?: InputMaybe<Jsonb_Comparison_Exp>;
  report_status?: InputMaybe<String_Comparison_Exp>;
  score?: InputMaybe<Float_Comparison_Exp>;
  screenshot_url?: InputMaybe<String_Comparison_Exp>;
  social_media_data?: InputMaybe<Social_Media_Data_Bool_Exp>;
  social_media_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  social_media_post?: InputMaybe<Social_Media_Post_Bool_Exp>;
  social_media_post_id?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  spoof_matches?: InputMaybe<Spoof_Matches_Bool_Exp>;
  spoof_matches_aggregate?: InputMaybe<Spoof_Matches_Aggregate_Bool_Exp>;
  spoof_status?: InputMaybe<Spoofing_Status_Comparison_Exp>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unsanitized_url?: InputMaybe<String_Comparison_Exp>;
  uploader?: InputMaybe<Users_Bool_Exp>;
  uploader_id?: InputMaybe<Uuid_Comparison_Exp>;
  website_content?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spoofing_report_search_results" */
export enum Spoofing_Report_Search_Results_Constraint {
  /** unique or primary key constraint on columns "organization_id", "flagged_url" */
  SpoofingReportsSearchFlaggedUrlOrganizationIdKey = 'spoofing_reports_search_flagged_url_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  SpoofingReportsSearchPkey = 'spoofing_reports_search_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Spoofing_Report_Search_Results_Delete_At_Path_Input = {
  report_screenshots?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Spoofing_Report_Search_Results_Delete_Elem_Input = {
  report_screenshots?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Spoofing_Report_Search_Results_Delete_Key_Input = {
  report_screenshots?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "spoofing_report_search_results" */
export type Spoofing_Report_Search_Results_Inc_Input = {
  importance_score?: InputMaybe<Scalars['numeric']>;
  max_id_similarity_score?: InputMaybe<Scalars['Float']>;
  score?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "spoofing_report_search_results" */
export type Spoofing_Report_Search_Results_Insert_Input = {
  collection_report_changes?: InputMaybe<Collection_Report_Changes_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data?: InputMaybe<Domain_Data_Obj_Rel_Insert_Input>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  domain_name_match?: InputMaybe<Scalars['domain_name_match_type']>;
  enforcement_requests?: InputMaybe<Enforcement_Requests_Arr_Rel_Insert_Input>;
  flagged_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  importance_score?: InputMaybe<Scalars['numeric']>;
  is_exact_flagged_url?: InputMaybe<Scalars['Boolean']>;
  is_exact_match_url?: InputMaybe<Scalars['Boolean']>;
  is_similar_flagged_url?: InputMaybe<Scalars['Boolean']>;
  is_similar_match_url?: InputMaybe<Scalars['Boolean']>;
  last_reported_at?: InputMaybe<Scalars['timestamp']>;
  last_resolved_at?: InputMaybe<Scalars['timestamp']>;
  max_id_similarity_score?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  report_screenshots?: InputMaybe<Scalars['jsonb']>;
  report_status?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  social_media_data?: InputMaybe<Social_Media_Data_Obj_Rel_Insert_Input>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_post?: InputMaybe<Social_Media_Post_Obj_Rel_Insert_Input>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  spoof_matches?: InputMaybe<Spoof_Matches_Arr_Rel_Insert_Input>;
  spoof_status?: InputMaybe<Scalars['spoofing_status']>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']>;
  unsanitized_url?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  uploader_id?: InputMaybe<Scalars['uuid']>;
  website_content?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Spoofing_Report_Search_Results_Max_Fields = {
  __typename?: 'spoofing_report_search_results_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  domain_name_match?: Maybe<Scalars['domain_name_match_type']>;
  flagged_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  importance_score?: Maybe<Scalars['numeric']>;
  last_reported_at?: Maybe<Scalars['timestamp']>;
  last_resolved_at?: Maybe<Scalars['timestamp']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  report_status?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  screenshot_url?: Maybe<Scalars['String']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  spoof_status?: Maybe<Scalars['spoofing_status']>;
  type?: Maybe<Scalars['String']>;
  unsanitized_url?: Maybe<Scalars['String']>;
  uploader_id?: Maybe<Scalars['uuid']>;
  website_content?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Spoofing_Report_Search_Results_Min_Fields = {
  __typename?: 'spoofing_report_search_results_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  domain_name_match?: Maybe<Scalars['domain_name_match_type']>;
  flagged_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  importance_score?: Maybe<Scalars['numeric']>;
  last_reported_at?: Maybe<Scalars['timestamp']>;
  last_resolved_at?: Maybe<Scalars['timestamp']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  report_status?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  screenshot_url?: Maybe<Scalars['String']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  spoof_status?: Maybe<Scalars['spoofing_status']>;
  type?: Maybe<Scalars['String']>;
  unsanitized_url?: Maybe<Scalars['String']>;
  uploader_id?: Maybe<Scalars['uuid']>;
  website_content?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "spoofing_report_search_results" */
export type Spoofing_Report_Search_Results_Mutation_Response = {
  __typename?: 'spoofing_report_search_results_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Spoofing_Report_Search_Results>;
};

/** on_conflict condition type for table "spoofing_report_search_results" */
export type Spoofing_Report_Search_Results_On_Conflict = {
  constraint: Spoofing_Report_Search_Results_Constraint;
  update_columns?: Array<Spoofing_Report_Search_Results_Update_Column>;
  where?: InputMaybe<Spoofing_Report_Search_Results_Bool_Exp>;
};

/** Ordering options when selecting data from "spoofing_report_search_results". */
export type Spoofing_Report_Search_Results_Order_By = {
  collection_report_changes_aggregate?: InputMaybe<Collection_Report_Changes_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  domain_data?: InputMaybe<Domain_Data_Order_By>;
  domain_data_id?: InputMaybe<Order_By>;
  domain_name_match?: InputMaybe<Order_By>;
  enforcement_requests_aggregate?: InputMaybe<Enforcement_Requests_Aggregate_Order_By>;
  flagged_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  is_exact_flagged_url?: InputMaybe<Order_By>;
  is_exact_match_url?: InputMaybe<Order_By>;
  is_similar_flagged_url?: InputMaybe<Order_By>;
  is_similar_match_url?: InputMaybe<Order_By>;
  last_reported_at?: InputMaybe<Order_By>;
  last_resolved_at?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  report_screenshots?: InputMaybe<Order_By>;
  report_status?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  social_media_data?: InputMaybe<Social_Media_Data_Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  social_media_post?: InputMaybe<Social_Media_Post_Order_By>;
  social_media_post_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  spoof_matches_aggregate?: InputMaybe<Spoof_Matches_Aggregate_Order_By>;
  spoof_status?: InputMaybe<Order_By>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Order_By>;
  type?: InputMaybe<Order_By>;
  unsanitized_url?: InputMaybe<Order_By>;
  uploader?: InputMaybe<Users_Order_By>;
  uploader_id?: InputMaybe<Order_By>;
  website_content?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Spoofing_Report_Search_Results_Prepend_Input = {
  report_screenshots?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "spoofing_report_search_results" */
export enum Spoofing_Report_Search_Results_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainDataId = 'domain_data_id',
  /** column name */
  DomainNameMatch = 'domain_name_match',
  /** column name */
  FlaggedUrl = 'flagged_url',
  /** column name */
  Id = 'id',
  /** column name */
  ImportanceScore = 'importance_score',
  /** column name */
  IsExactFlaggedUrl = 'is_exact_flagged_url',
  /** column name */
  IsExactMatchUrl = 'is_exact_match_url',
  /** column name */
  IsSimilarFlaggedUrl = 'is_similar_flagged_url',
  /** column name */
  IsSimilarMatchUrl = 'is_similar_match_url',
  /** column name */
  LastReportedAt = 'last_reported_at',
  /** column name */
  LastResolvedAt = 'last_resolved_at',
  /** column name */
  MaxIdSimilarityScore = 'max_id_similarity_score',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  ReportScreenshots = 'report_screenshots',
  /** column name */
  ReportStatus = 'report_status',
  /** column name */
  Score = 'score',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SocialMediaPostId = 'social_media_post_id',
  /** column name */
  Source = 'source',
  /** column name */
  SpoofStatus = 'spoof_status',
  /** column name */
  Type = 'type',
  /** column name */
  UnsanitizedUrl = 'unsanitized_url',
  /** column name */
  UploaderId = 'uploader_id',
  /** column name */
  WebsiteContent = 'website_content'
}

/** input type for updating data in table "spoofing_report_search_results" */
export type Spoofing_Report_Search_Results_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  domain_name_match?: InputMaybe<Scalars['domain_name_match_type']>;
  flagged_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  importance_score?: InputMaybe<Scalars['numeric']>;
  is_exact_flagged_url?: InputMaybe<Scalars['Boolean']>;
  is_exact_match_url?: InputMaybe<Scalars['Boolean']>;
  is_similar_flagged_url?: InputMaybe<Scalars['Boolean']>;
  is_similar_match_url?: InputMaybe<Scalars['Boolean']>;
  last_reported_at?: InputMaybe<Scalars['timestamp']>;
  last_resolved_at?: InputMaybe<Scalars['timestamp']>;
  max_id_similarity_score?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  report_screenshots?: InputMaybe<Scalars['jsonb']>;
  report_status?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  spoof_status?: InputMaybe<Scalars['spoofing_status']>;
  type?: InputMaybe<Scalars['String']>;
  unsanitized_url?: InputMaybe<Scalars['String']>;
  uploader_id?: InputMaybe<Scalars['uuid']>;
  website_content?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Spoofing_Report_Search_Results_Stddev_Fields = {
  __typename?: 'spoofing_report_search_results_stddev_fields';
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Spoofing_Report_Search_Results_Stddev_Pop_Fields = {
  __typename?: 'spoofing_report_search_results_stddev_pop_fields';
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Spoofing_Report_Search_Results_Stddev_Samp_Fields = {
  __typename?: 'spoofing_report_search_results_stddev_samp_fields';
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "spoofing_report_search_results" */
export type Spoofing_Report_Search_Results_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spoofing_Report_Search_Results_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spoofing_Report_Search_Results_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  domain_name_match?: InputMaybe<Scalars['domain_name_match_type']>;
  flagged_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  importance_score?: InputMaybe<Scalars['numeric']>;
  is_exact_flagged_url?: InputMaybe<Scalars['Boolean']>;
  is_exact_match_url?: InputMaybe<Scalars['Boolean']>;
  is_similar_flagged_url?: InputMaybe<Scalars['Boolean']>;
  is_similar_match_url?: InputMaybe<Scalars['Boolean']>;
  last_reported_at?: InputMaybe<Scalars['timestamp']>;
  last_resolved_at?: InputMaybe<Scalars['timestamp']>;
  max_id_similarity_score?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  report_screenshots?: InputMaybe<Scalars['jsonb']>;
  report_status?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  spoof_status?: InputMaybe<Scalars['spoofing_status']>;
  type?: InputMaybe<Scalars['String']>;
  unsanitized_url?: InputMaybe<Scalars['String']>;
  uploader_id?: InputMaybe<Scalars['uuid']>;
  website_content?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Spoofing_Report_Search_Results_Sum_Fields = {
  __typename?: 'spoofing_report_search_results_sum_fields';
  importance_score?: Maybe<Scalars['numeric']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** update columns of table "spoofing_report_search_results" */
export enum Spoofing_Report_Search_Results_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainDataId = 'domain_data_id',
  /** column name */
  DomainNameMatch = 'domain_name_match',
  /** column name */
  FlaggedUrl = 'flagged_url',
  /** column name */
  Id = 'id',
  /** column name */
  ImportanceScore = 'importance_score',
  /** column name */
  IsExactFlaggedUrl = 'is_exact_flagged_url',
  /** column name */
  IsExactMatchUrl = 'is_exact_match_url',
  /** column name */
  IsSimilarFlaggedUrl = 'is_similar_flagged_url',
  /** column name */
  IsSimilarMatchUrl = 'is_similar_match_url',
  /** column name */
  LastReportedAt = 'last_reported_at',
  /** column name */
  LastResolvedAt = 'last_resolved_at',
  /** column name */
  MaxIdSimilarityScore = 'max_id_similarity_score',
  /** column name */
  Notes = 'notes',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  ReportScreenshots = 'report_screenshots',
  /** column name */
  ReportStatus = 'report_status',
  /** column name */
  Score = 'score',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SocialMediaPostId = 'social_media_post_id',
  /** column name */
  Source = 'source',
  /** column name */
  SpoofStatus = 'spoof_status',
  /** column name */
  Type = 'type',
  /** column name */
  UnsanitizedUrl = 'unsanitized_url',
  /** column name */
  UploaderId = 'uploader_id',
  /** column name */
  WebsiteContent = 'website_content'
}

export type Spoofing_Report_Search_Results_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Spoofing_Report_Search_Results_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Spoofing_Report_Search_Results_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Spoofing_Report_Search_Results_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Spoofing_Report_Search_Results_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spoofing_Report_Search_Results_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Spoofing_Report_Search_Results_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spoofing_Report_Search_Results_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spoofing_Report_Search_Results_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spoofing_Report_Search_Results_Var_Pop_Fields = {
  __typename?: 'spoofing_report_search_results_var_pop_fields';
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Spoofing_Report_Search_Results_Var_Samp_Fields = {
  __typename?: 'spoofing_report_search_results_var_samp_fields';
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Spoofing_Report_Search_Results_Variance_Fields = {
  __typename?: 'spoofing_report_search_results_variance_fields';
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_Reports = {
  __typename?: 'spoofing_reports';
  /** An array relationship */
  alert_links: Array<Alert_Links>;
  /** An array relationship */
  alert_links_2: Array<Alert_Links>;
  /** An aggregate relationship */
  alert_links_2_aggregate: Alert_Links_Aggregate;
  /** An aggregate relationship */
  alert_links_aggregate: Alert_Links_Aggregate;
  /** An array relationship */
  approvals: Array<Approvals>;
  /** An aggregate relationship */
  approvals_aggregate: Approvals_Aggregate;
  /** An array relationship */
  collection_report_changes: Array<Collection_Report_Changes>;
  /** An aggregate relationship */
  collection_report_changes_aggregate: Collection_Report_Changes_Aggregate;
  created_at: Scalars['timestamp'];
  /** An object relationship */
  domain_data?: Maybe<Domain_Data>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  domain_name_match?: Maybe<Scalars['String']>;
  /** An array relationship */
  enforcement_requests: Array<Enforcement_Requests>;
  /** An aggregate relationship */
  enforcement_requests_aggregate: Enforcement_Requests_Aggregate;
  estimated_usd_price?: Maybe<Scalars['Float']>;
  /** An object relationship */
  external_alert_assignee?: Maybe<Users>;
  external_assignee_id?: Maybe<Scalars['uuid']>;
  external_id?: Maybe<Scalars['Int']>;
  /** If report is uploaded manually, this optional source captures where the report was sourced from */
  external_source?: Maybe<Scalars['String']>;
  flagged_url: Scalars['String'];
  id: Scalars['uuid'];
  importance_score?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  internal_alert_assignee?: Maybe<Users>;
  internal_assignee_id?: Maybe<Scalars['uuid']>;
  is_customer_sourced?: Maybe<Scalars['Boolean']>;
  last_actioned_at?: Maybe<Scalars['timestamp']>;
  last_activity_timestamp: Scalars['timestamptz'];
  last_delisted_at?: Maybe<Scalars['timestamp']>;
  last_reported_at?: Maybe<Scalars['timestamp']>;
  last_resolved_at?: Maybe<Scalars['timestamp']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  /** When the underlying data came online, i.e. crawled_at for dark web, activated_at for social media, registered_at for domain, etc. */
  online_at?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
  original_entity_id: Scalars['uuid'];
  /** An object relationship */
  platform?: Maybe<Platforms>;
  /** An object relationship */
  platform_subtype?: Maybe<Platform_Subtypes>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  report_screenshots?: Maybe<Scalars['jsonb']>;
  report_status: Scalars['String'];
  /** An array relationship */
  report_tags: Array<Report_Tags>;
  /** An aggregate relationship */
  report_tags_aggregate: Report_Tags_Aggregate;
  score?: Maybe<Scalars['Float']>;
  screenshot_url?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  /** An object relationship */
  social_media_data?: Maybe<Social_Media_Data>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  social_media_post?: Maybe<Social_Media_Post>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  /** An array relationship */
  spoof_matches: Array<Spoof_Matches>;
  /** An aggregate relationship */
  spoof_matches_aggregate: Spoof_Matches_Aggregate;
  spoof_status: Scalars['spoofing_status'];
  /** An object relationship */
  spoofing_entity: Spoofing_Entities;
  /** An array relationship */
  spoofing_reports_to_tags: Array<Spoofing_Reports_To_Tags>;
  /** An aggregate relationship */
  spoofing_reports_to_tags_aggregate: Spoofing_Reports_To_Tags_Aggregate;
  type: Scalars['String'];
  unsanitized_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  uploader?: Maybe<Users>;
  uploader_id?: Maybe<Scalars['uuid']>;
  website_content?: Maybe<Scalars['String']>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsAlert_LinksArgs = {
  distinct_on?: InputMaybe<Array<Alert_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Links_Order_By>>;
  where?: InputMaybe<Alert_Links_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsAlert_Links_2Args = {
  distinct_on?: InputMaybe<Array<Alert_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Links_Order_By>>;
  where?: InputMaybe<Alert_Links_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsAlert_Links_2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Links_Order_By>>;
  where?: InputMaybe<Alert_Links_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsAlert_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Links_Order_By>>;
  where?: InputMaybe<Alert_Links_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsApprovalsArgs = {
  distinct_on?: InputMaybe<Array<Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approvals_Order_By>>;
  where?: InputMaybe<Approvals_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsApprovals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approvals_Order_By>>;
  where?: InputMaybe<Approvals_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsCollection_Report_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsCollection_Report_Changes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsEnforcement_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Requests_Order_By>>;
  where?: InputMaybe<Enforcement_Requests_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsEnforcement_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Requests_Order_By>>;
  where?: InputMaybe<Enforcement_Requests_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsReport_ScreenshotsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsReport_TagsArgs = {
  distinct_on?: InputMaybe<Array<Report_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Tags_Order_By>>;
  where?: InputMaybe<Report_Tags_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsReport_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Tags_Order_By>>;
  where?: InputMaybe<Report_Tags_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsSpoof_MatchesArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsSpoof_Matches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsSpoofing_Reports_To_TagsArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_To_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_To_Tags_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_To_Tags_Bool_Exp>;
};


/** Reports for brand/trademark infringement cases across Web2 such as domain, social media, ecommerce */
export type Spoofing_ReportsSpoofing_Reports_To_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_To_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_To_Tags_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_To_Tags_Bool_Exp>;
};

/** aggregated selection of "spoofing_reports" */
export type Spoofing_Reports_Aggregate = {
  __typename?: 'spoofing_reports_aggregate';
  aggregate?: Maybe<Spoofing_Reports_Aggregate_Fields>;
  nodes: Array<Spoofing_Reports>;
};

export type Spoofing_Reports_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Spoofing_Reports_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Spoofing_Reports_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Spoofing_Reports_Aggregate_Bool_Exp_Count>;
};

export type Spoofing_Reports_Aggregate_Bool_Exp_Bool_And = {
  arguments: Spoofing_Reports_Select_Column_Spoofing_Reports_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spoofing_Reports_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Spoofing_Reports_Select_Column_Spoofing_Reports_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Spoofing_Reports_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spoofing_reports" */
export type Spoofing_Reports_Aggregate_Fields = {
  __typename?: 'spoofing_reports_aggregate_fields';
  avg?: Maybe<Spoofing_Reports_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Spoofing_Reports_Max_Fields>;
  min?: Maybe<Spoofing_Reports_Min_Fields>;
  stddev?: Maybe<Spoofing_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Spoofing_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spoofing_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Spoofing_Reports_Sum_Fields>;
  var_pop?: Maybe<Spoofing_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Spoofing_Reports_Var_Samp_Fields>;
  variance?: Maybe<Spoofing_Reports_Variance_Fields>;
};


/** aggregate fields of "spoofing_reports" */
export type Spoofing_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "spoofing_reports" */
export type Spoofing_Reports_Aggregate_Order_By = {
  avg?: InputMaybe<Spoofing_Reports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spoofing_Reports_Max_Order_By>;
  min?: InputMaybe<Spoofing_Reports_Min_Order_By>;
  stddev?: InputMaybe<Spoofing_Reports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Spoofing_Reports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Spoofing_Reports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Spoofing_Reports_Sum_Order_By>;
  var_pop?: InputMaybe<Spoofing_Reports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Spoofing_Reports_Var_Samp_Order_By>;
  variance?: InputMaybe<Spoofing_Reports_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Spoofing_Reports_Append_Input = {
  report_screenshots?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "spoofing_reports" */
export type Spoofing_Reports_Arr_Rel_Insert_Input = {
  data: Array<Spoofing_Reports_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spoofing_Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Spoofing_Reports_Avg_Fields = {
  __typename?: 'spoofing_reports_avg_fields';
  estimated_usd_price?: Maybe<Scalars['Float']>;
  external_id?: Maybe<Scalars['Float']>;
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "spoofing_reports" */
export type Spoofing_Reports_Avg_Order_By = {
  estimated_usd_price?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spoofing_reports". All fields are combined with a logical 'AND'. */
export type Spoofing_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Spoofing_Reports_Bool_Exp>>;
  _not?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Spoofing_Reports_Bool_Exp>>;
  alert_links?: InputMaybe<Alert_Links_Bool_Exp>;
  alert_links_2?: InputMaybe<Alert_Links_Bool_Exp>;
  alert_links_2_aggregate?: InputMaybe<Alert_Links_Aggregate_Bool_Exp>;
  alert_links_aggregate?: InputMaybe<Alert_Links_Aggregate_Bool_Exp>;
  approvals?: InputMaybe<Approvals_Bool_Exp>;
  approvals_aggregate?: InputMaybe<Approvals_Aggregate_Bool_Exp>;
  collection_report_changes?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
  collection_report_changes_aggregate?: InputMaybe<Collection_Report_Changes_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  domain_data?: InputMaybe<Domain_Data_Bool_Exp>;
  domain_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  domain_name_match?: InputMaybe<String_Comparison_Exp>;
  enforcement_requests?: InputMaybe<Enforcement_Requests_Bool_Exp>;
  enforcement_requests_aggregate?: InputMaybe<Enforcement_Requests_Aggregate_Bool_Exp>;
  estimated_usd_price?: InputMaybe<Float_Comparison_Exp>;
  external_alert_assignee?: InputMaybe<Users_Bool_Exp>;
  external_assignee_id?: InputMaybe<Uuid_Comparison_Exp>;
  external_id?: InputMaybe<Int_Comparison_Exp>;
  external_source?: InputMaybe<String_Comparison_Exp>;
  flagged_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  importance_score?: InputMaybe<Numeric_Comparison_Exp>;
  internal_alert_assignee?: InputMaybe<Users_Bool_Exp>;
  internal_assignee_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_customer_sourced?: InputMaybe<Boolean_Comparison_Exp>;
  last_actioned_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_activity_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_delisted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_reported_at?: InputMaybe<Timestamp_Comparison_Exp>;
  last_resolved_at?: InputMaybe<Timestamp_Comparison_Exp>;
  max_id_similarity_score?: InputMaybe<Float_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  online_at?: InputMaybe<Timestamp_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  original_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  platform?: InputMaybe<Platforms_Bool_Exp>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Bool_Exp>;
  platform_subtype_id?: InputMaybe<Uuid_Comparison_Exp>;
  report_screenshots?: InputMaybe<Jsonb_Comparison_Exp>;
  report_status?: InputMaybe<String_Comparison_Exp>;
  report_tags?: InputMaybe<Report_Tags_Bool_Exp>;
  report_tags_aggregate?: InputMaybe<Report_Tags_Aggregate_Bool_Exp>;
  score?: InputMaybe<Float_Comparison_Exp>;
  screenshot_url?: InputMaybe<String_Comparison_Exp>;
  severity?: InputMaybe<String_Comparison_Exp>;
  social_media_data?: InputMaybe<Social_Media_Data_Bool_Exp>;
  social_media_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  social_media_post?: InputMaybe<Social_Media_Post_Bool_Exp>;
  social_media_post_id?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  spoof_matches?: InputMaybe<Spoof_Matches_Bool_Exp>;
  spoof_matches_aggregate?: InputMaybe<Spoof_Matches_Aggregate_Bool_Exp>;
  spoof_status?: InputMaybe<Spoofing_Status_Comparison_Exp>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  spoofing_reports_to_tags?: InputMaybe<Spoofing_Reports_To_Tags_Bool_Exp>;
  spoofing_reports_to_tags_aggregate?: InputMaybe<Spoofing_Reports_To_Tags_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unsanitized_url?: InputMaybe<String_Comparison_Exp>;
  uploader?: InputMaybe<Users_Bool_Exp>;
  uploader_id?: InputMaybe<Uuid_Comparison_Exp>;
  website_content?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spoofing_reports" */
export enum Spoofing_Reports_Constraint {
  /** unique or primary key constraint on columns "organization_id", "flagged_url" */
  SpoofingReportsFlaggedUrlOrganizationIdKey = 'spoofing_reports_flagged_url_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  SpoofingReportsPkey = 'spoofing_reports_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Spoofing_Reports_Delete_At_Path_Input = {
  report_screenshots?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Spoofing_Reports_Delete_Elem_Input = {
  report_screenshots?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Spoofing_Reports_Delete_Key_Input = {
  report_screenshots?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "spoofing_reports" */
export type Spoofing_Reports_Inc_Input = {
  estimated_usd_price?: InputMaybe<Scalars['Float']>;
  external_id?: InputMaybe<Scalars['Int']>;
  importance_score?: InputMaybe<Scalars['numeric']>;
  max_id_similarity_score?: InputMaybe<Scalars['Float']>;
  score?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "spoofing_reports" */
export type Spoofing_Reports_Insert_Input = {
  alert_links?: InputMaybe<Alert_Links_Arr_Rel_Insert_Input>;
  alert_links_2?: InputMaybe<Alert_Links_Arr_Rel_Insert_Input>;
  approvals?: InputMaybe<Approvals_Arr_Rel_Insert_Input>;
  collection_report_changes?: InputMaybe<Collection_Report_Changes_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data?: InputMaybe<Domain_Data_Obj_Rel_Insert_Input>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  domain_name_match?: InputMaybe<Scalars['String']>;
  enforcement_requests?: InputMaybe<Enforcement_Requests_Arr_Rel_Insert_Input>;
  estimated_usd_price?: InputMaybe<Scalars['Float']>;
  external_alert_assignee?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  external_assignee_id?: InputMaybe<Scalars['uuid']>;
  external_id?: InputMaybe<Scalars['Int']>;
  /** If report is uploaded manually, this optional source captures where the report was sourced from */
  external_source?: InputMaybe<Scalars['String']>;
  flagged_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  importance_score?: InputMaybe<Scalars['numeric']>;
  internal_alert_assignee?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  internal_assignee_id?: InputMaybe<Scalars['uuid']>;
  is_customer_sourced?: InputMaybe<Scalars['Boolean']>;
  last_actioned_at?: InputMaybe<Scalars['timestamp']>;
  last_activity_timestamp?: InputMaybe<Scalars['timestamptz']>;
  last_delisted_at?: InputMaybe<Scalars['timestamp']>;
  last_reported_at?: InputMaybe<Scalars['timestamp']>;
  last_resolved_at?: InputMaybe<Scalars['timestamp']>;
  max_id_similarity_score?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  /** When the underlying data came online, i.e. crawled_at for dark web, activated_at for social media, registered_at for domain, etc. */
  online_at?: InputMaybe<Scalars['timestamp']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Platforms_Obj_Rel_Insert_Input>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Obj_Rel_Insert_Input>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  report_screenshots?: InputMaybe<Scalars['jsonb']>;
  report_status?: InputMaybe<Scalars['String']>;
  report_tags?: InputMaybe<Report_Tags_Arr_Rel_Insert_Input>;
  score?: InputMaybe<Scalars['Float']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  social_media_data?: InputMaybe<Social_Media_Data_Obj_Rel_Insert_Input>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_post?: InputMaybe<Social_Media_Post_Obj_Rel_Insert_Input>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  spoof_matches?: InputMaybe<Spoof_Matches_Arr_Rel_Insert_Input>;
  spoof_status?: InputMaybe<Scalars['spoofing_status']>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Obj_Rel_Insert_Input>;
  spoofing_reports_to_tags?: InputMaybe<Spoofing_Reports_To_Tags_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']>;
  unsanitized_url?: InputMaybe<Scalars['String']>;
  uploader?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  uploader_id?: InputMaybe<Scalars['uuid']>;
  website_content?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Spoofing_Reports_Max_Fields = {
  __typename?: 'spoofing_reports_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  domain_name_match?: Maybe<Scalars['String']>;
  estimated_usd_price?: Maybe<Scalars['Float']>;
  external_assignee_id?: Maybe<Scalars['uuid']>;
  external_id?: Maybe<Scalars['Int']>;
  /** If report is uploaded manually, this optional source captures where the report was sourced from */
  external_source?: Maybe<Scalars['String']>;
  flagged_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  importance_score?: Maybe<Scalars['numeric']>;
  internal_assignee_id?: Maybe<Scalars['uuid']>;
  last_actioned_at?: Maybe<Scalars['timestamp']>;
  last_activity_timestamp?: Maybe<Scalars['timestamptz']>;
  last_delisted_at?: Maybe<Scalars['timestamp']>;
  last_reported_at?: Maybe<Scalars['timestamp']>;
  last_resolved_at?: Maybe<Scalars['timestamp']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  /** When the underlying data came online, i.e. crawled_at for dark web, activated_at for social media, registered_at for domain, etc. */
  online_at?: Maybe<Scalars['timestamp']>;
  organization_id?: Maybe<Scalars['uuid']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  report_status?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  screenshot_url?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  spoof_status?: Maybe<Scalars['spoofing_status']>;
  type?: Maybe<Scalars['String']>;
  unsanitized_url?: Maybe<Scalars['String']>;
  uploader_id?: Maybe<Scalars['uuid']>;
  website_content?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "spoofing_reports" */
export type Spoofing_Reports_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  domain_data_id?: InputMaybe<Order_By>;
  domain_name_match?: InputMaybe<Order_By>;
  estimated_usd_price?: InputMaybe<Order_By>;
  external_assignee_id?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  /** If report is uploaded manually, this optional source captures where the report was sourced from */
  external_source?: InputMaybe<Order_By>;
  flagged_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  internal_assignee_id?: InputMaybe<Order_By>;
  last_actioned_at?: InputMaybe<Order_By>;
  last_activity_timestamp?: InputMaybe<Order_By>;
  last_delisted_at?: InputMaybe<Order_By>;
  last_reported_at?: InputMaybe<Order_By>;
  last_resolved_at?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  /** When the underlying data came online, i.e. crawled_at for dark web, activated_at for social media, registered_at for domain, etc. */
  online_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  report_status?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  social_media_post_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  spoof_status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unsanitized_url?: InputMaybe<Order_By>;
  uploader_id?: InputMaybe<Order_By>;
  website_content?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spoofing_Reports_Min_Fields = {
  __typename?: 'spoofing_reports_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  domain_data_id?: Maybe<Scalars['uuid']>;
  domain_name_match?: Maybe<Scalars['String']>;
  estimated_usd_price?: Maybe<Scalars['Float']>;
  external_assignee_id?: Maybe<Scalars['uuid']>;
  external_id?: Maybe<Scalars['Int']>;
  /** If report is uploaded manually, this optional source captures where the report was sourced from */
  external_source?: Maybe<Scalars['String']>;
  flagged_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  importance_score?: Maybe<Scalars['numeric']>;
  internal_assignee_id?: Maybe<Scalars['uuid']>;
  last_actioned_at?: Maybe<Scalars['timestamp']>;
  last_activity_timestamp?: Maybe<Scalars['timestamptz']>;
  last_delisted_at?: Maybe<Scalars['timestamp']>;
  last_reported_at?: Maybe<Scalars['timestamp']>;
  last_resolved_at?: Maybe<Scalars['timestamp']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  /** When the underlying data came online, i.e. crawled_at for dark web, activated_at for social media, registered_at for domain, etc. */
  online_at?: Maybe<Scalars['timestamp']>;
  organization_id?: Maybe<Scalars['uuid']>;
  original_entity_id?: Maybe<Scalars['uuid']>;
  platform_subtype_id?: Maybe<Scalars['uuid']>;
  report_status?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  screenshot_url?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['String']>;
  social_media_data_id?: Maybe<Scalars['uuid']>;
  social_media_post_id?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  spoof_status?: Maybe<Scalars['spoofing_status']>;
  type?: Maybe<Scalars['String']>;
  unsanitized_url?: Maybe<Scalars['String']>;
  uploader_id?: Maybe<Scalars['uuid']>;
  website_content?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "spoofing_reports" */
export type Spoofing_Reports_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  domain_data_id?: InputMaybe<Order_By>;
  domain_name_match?: InputMaybe<Order_By>;
  estimated_usd_price?: InputMaybe<Order_By>;
  external_assignee_id?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  /** If report is uploaded manually, this optional source captures where the report was sourced from */
  external_source?: InputMaybe<Order_By>;
  flagged_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  internal_assignee_id?: InputMaybe<Order_By>;
  last_actioned_at?: InputMaybe<Order_By>;
  last_activity_timestamp?: InputMaybe<Order_By>;
  last_delisted_at?: InputMaybe<Order_By>;
  last_reported_at?: InputMaybe<Order_By>;
  last_resolved_at?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  /** When the underlying data came online, i.e. crawled_at for dark web, activated_at for social media, registered_at for domain, etc. */
  online_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  report_status?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  social_media_post_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  spoof_status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unsanitized_url?: InputMaybe<Order_By>;
  uploader_id?: InputMaybe<Order_By>;
  website_content?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spoofing_reports" */
export type Spoofing_Reports_Mutation_Response = {
  __typename?: 'spoofing_reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Spoofing_Reports>;
};

/** input type for inserting object relation for remote table "spoofing_reports" */
export type Spoofing_Reports_Obj_Rel_Insert_Input = {
  data: Spoofing_Reports_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Spoofing_Reports_On_Conflict>;
};

/** on_conflict condition type for table "spoofing_reports" */
export type Spoofing_Reports_On_Conflict = {
  constraint: Spoofing_Reports_Constraint;
  update_columns?: Array<Spoofing_Reports_Update_Column>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "spoofing_reports". */
export type Spoofing_Reports_Order_By = {
  alert_links_2_aggregate?: InputMaybe<Alert_Links_Aggregate_Order_By>;
  alert_links_aggregate?: InputMaybe<Alert_Links_Aggregate_Order_By>;
  approvals_aggregate?: InputMaybe<Approvals_Aggregate_Order_By>;
  collection_report_changes_aggregate?: InputMaybe<Collection_Report_Changes_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  domain_data?: InputMaybe<Domain_Data_Order_By>;
  domain_data_id?: InputMaybe<Order_By>;
  domain_name_match?: InputMaybe<Order_By>;
  enforcement_requests_aggregate?: InputMaybe<Enforcement_Requests_Aggregate_Order_By>;
  estimated_usd_price?: InputMaybe<Order_By>;
  external_alert_assignee?: InputMaybe<Users_Order_By>;
  external_assignee_id?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  external_source?: InputMaybe<Order_By>;
  flagged_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  internal_alert_assignee?: InputMaybe<Users_Order_By>;
  internal_assignee_id?: InputMaybe<Order_By>;
  is_customer_sourced?: InputMaybe<Order_By>;
  last_actioned_at?: InputMaybe<Order_By>;
  last_activity_timestamp?: InputMaybe<Order_By>;
  last_delisted_at?: InputMaybe<Order_By>;
  last_reported_at?: InputMaybe<Order_By>;
  last_resolved_at?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  online_at?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  original_entity_id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Platforms_Order_By>;
  platform_subtype?: InputMaybe<Platform_Subtypes_Order_By>;
  platform_subtype_id?: InputMaybe<Order_By>;
  report_screenshots?: InputMaybe<Order_By>;
  report_status?: InputMaybe<Order_By>;
  report_tags_aggregate?: InputMaybe<Report_Tags_Aggregate_Order_By>;
  score?: InputMaybe<Order_By>;
  screenshot_url?: InputMaybe<Order_By>;
  severity?: InputMaybe<Order_By>;
  social_media_data?: InputMaybe<Social_Media_Data_Order_By>;
  social_media_data_id?: InputMaybe<Order_By>;
  social_media_post?: InputMaybe<Social_Media_Post_Order_By>;
  social_media_post_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  spoof_matches_aggregate?: InputMaybe<Spoof_Matches_Aggregate_Order_By>;
  spoof_status?: InputMaybe<Order_By>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Order_By>;
  spoofing_reports_to_tags_aggregate?: InputMaybe<Spoofing_Reports_To_Tags_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  unsanitized_url?: InputMaybe<Order_By>;
  uploader?: InputMaybe<Users_Order_By>;
  uploader_id?: InputMaybe<Order_By>;
  website_content?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spoofing_reports */
export type Spoofing_Reports_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Spoofing_Reports_Prepend_Input = {
  report_screenshots?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "spoofing_reports" */
export enum Spoofing_Reports_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainDataId = 'domain_data_id',
  /** column name */
  DomainNameMatch = 'domain_name_match',
  /** column name */
  EstimatedUsdPrice = 'estimated_usd_price',
  /** column name */
  ExternalAssigneeId = 'external_assignee_id',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  FlaggedUrl = 'flagged_url',
  /** column name */
  Id = 'id',
  /** column name */
  ImportanceScore = 'importance_score',
  /** column name */
  InternalAssigneeId = 'internal_assignee_id',
  /** column name */
  IsCustomerSourced = 'is_customer_sourced',
  /** column name */
  LastActionedAt = 'last_actioned_at',
  /** column name */
  LastActivityTimestamp = 'last_activity_timestamp',
  /** column name */
  LastDelistedAt = 'last_delisted_at',
  /** column name */
  LastReportedAt = 'last_reported_at',
  /** column name */
  LastResolvedAt = 'last_resolved_at',
  /** column name */
  MaxIdSimilarityScore = 'max_id_similarity_score',
  /** column name */
  Notes = 'notes',
  /** column name */
  OnlineAt = 'online_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  ReportScreenshots = 'report_screenshots',
  /** column name */
  ReportStatus = 'report_status',
  /** column name */
  Score = 'score',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  Severity = 'severity',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SocialMediaPostId = 'social_media_post_id',
  /** column name */
  Source = 'source',
  /** column name */
  SpoofStatus = 'spoof_status',
  /** column name */
  Type = 'type',
  /** column name */
  UnsanitizedUrl = 'unsanitized_url',
  /** column name */
  UploaderId = 'uploader_id',
  /** column name */
  WebsiteContent = 'website_content'
}

/** select "spoofing_reports_aggregate_bool_exp_bool_and_arguments_columns" columns of table "spoofing_reports" */
export enum Spoofing_Reports_Select_Column_Spoofing_Reports_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCustomerSourced = 'is_customer_sourced'
}

/** select "spoofing_reports_aggregate_bool_exp_bool_or_arguments_columns" columns of table "spoofing_reports" */
export enum Spoofing_Reports_Select_Column_Spoofing_Reports_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCustomerSourced = 'is_customer_sourced'
}

/** input type for updating data in table "spoofing_reports" */
export type Spoofing_Reports_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  domain_name_match?: InputMaybe<Scalars['String']>;
  estimated_usd_price?: InputMaybe<Scalars['Float']>;
  external_assignee_id?: InputMaybe<Scalars['uuid']>;
  external_id?: InputMaybe<Scalars['Int']>;
  /** If report is uploaded manually, this optional source captures where the report was sourced from */
  external_source?: InputMaybe<Scalars['String']>;
  flagged_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  importance_score?: InputMaybe<Scalars['numeric']>;
  internal_assignee_id?: InputMaybe<Scalars['uuid']>;
  is_customer_sourced?: InputMaybe<Scalars['Boolean']>;
  last_actioned_at?: InputMaybe<Scalars['timestamp']>;
  last_activity_timestamp?: InputMaybe<Scalars['timestamptz']>;
  last_delisted_at?: InputMaybe<Scalars['timestamp']>;
  last_reported_at?: InputMaybe<Scalars['timestamp']>;
  last_resolved_at?: InputMaybe<Scalars['timestamp']>;
  max_id_similarity_score?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  /** When the underlying data came online, i.e. crawled_at for dark web, activated_at for social media, registered_at for domain, etc. */
  online_at?: InputMaybe<Scalars['timestamp']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  report_screenshots?: InputMaybe<Scalars['jsonb']>;
  report_status?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  spoof_status?: InputMaybe<Scalars['spoofing_status']>;
  type?: InputMaybe<Scalars['String']>;
  unsanitized_url?: InputMaybe<Scalars['String']>;
  uploader_id?: InputMaybe<Scalars['uuid']>;
  website_content?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Spoofing_Reports_Stddev_Fields = {
  __typename?: 'spoofing_reports_stddev_fields';
  estimated_usd_price?: Maybe<Scalars['Float']>;
  external_id?: Maybe<Scalars['Float']>;
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "spoofing_reports" */
export type Spoofing_Reports_Stddev_Order_By = {
  estimated_usd_price?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spoofing_Reports_Stddev_Pop_Fields = {
  __typename?: 'spoofing_reports_stddev_pop_fields';
  estimated_usd_price?: Maybe<Scalars['Float']>;
  external_id?: Maybe<Scalars['Float']>;
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "spoofing_reports" */
export type Spoofing_Reports_Stddev_Pop_Order_By = {
  estimated_usd_price?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spoofing_Reports_Stddev_Samp_Fields = {
  __typename?: 'spoofing_reports_stddev_samp_fields';
  estimated_usd_price?: Maybe<Scalars['Float']>;
  external_id?: Maybe<Scalars['Float']>;
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "spoofing_reports" */
export type Spoofing_Reports_Stddev_Samp_Order_By = {
  estimated_usd_price?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "spoofing_reports" */
export type Spoofing_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spoofing_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spoofing_Reports_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  domain_data_id?: InputMaybe<Scalars['uuid']>;
  domain_name_match?: InputMaybe<Scalars['String']>;
  estimated_usd_price?: InputMaybe<Scalars['Float']>;
  external_assignee_id?: InputMaybe<Scalars['uuid']>;
  external_id?: InputMaybe<Scalars['Int']>;
  /** If report is uploaded manually, this optional source captures where the report was sourced from */
  external_source?: InputMaybe<Scalars['String']>;
  flagged_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  importance_score?: InputMaybe<Scalars['numeric']>;
  internal_assignee_id?: InputMaybe<Scalars['uuid']>;
  is_customer_sourced?: InputMaybe<Scalars['Boolean']>;
  last_actioned_at?: InputMaybe<Scalars['timestamp']>;
  last_activity_timestamp?: InputMaybe<Scalars['timestamptz']>;
  last_delisted_at?: InputMaybe<Scalars['timestamp']>;
  last_reported_at?: InputMaybe<Scalars['timestamp']>;
  last_resolved_at?: InputMaybe<Scalars['timestamp']>;
  max_id_similarity_score?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  /** When the underlying data came online, i.e. crawled_at for dark web, activated_at for social media, registered_at for domain, etc. */
  online_at?: InputMaybe<Scalars['timestamp']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  original_entity_id?: InputMaybe<Scalars['uuid']>;
  platform_subtype_id?: InputMaybe<Scalars['uuid']>;
  report_screenshots?: InputMaybe<Scalars['jsonb']>;
  report_status?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
  screenshot_url?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  social_media_data_id?: InputMaybe<Scalars['uuid']>;
  social_media_post_id?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  spoof_status?: InputMaybe<Scalars['spoofing_status']>;
  type?: InputMaybe<Scalars['String']>;
  unsanitized_url?: InputMaybe<Scalars['String']>;
  uploader_id?: InputMaybe<Scalars['uuid']>;
  website_content?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Spoofing_Reports_Sum_Fields = {
  __typename?: 'spoofing_reports_sum_fields';
  estimated_usd_price?: Maybe<Scalars['Float']>;
  external_id?: Maybe<Scalars['Int']>;
  importance_score?: Maybe<Scalars['numeric']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by sum() on columns of table "spoofing_reports" */
export type Spoofing_Reports_Sum_Order_By = {
  estimated_usd_price?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** columns and relationships of "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags = {
  __typename?: 'spoofing_reports_to_tags';
  created_at: Scalars['timestamp'];
  /** An object relationship */
  spoofing_report: Spoofing_Reports;
  spoofing_report_id: Scalars['uuid'];
  tag_name: Scalars['String'];
};

/** aggregated selection of "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_Aggregate = {
  __typename?: 'spoofing_reports_to_tags_aggregate';
  aggregate?: Maybe<Spoofing_Reports_To_Tags_Aggregate_Fields>;
  nodes: Array<Spoofing_Reports_To_Tags>;
};

export type Spoofing_Reports_To_Tags_Aggregate_Bool_Exp = {
  count?: InputMaybe<Spoofing_Reports_To_Tags_Aggregate_Bool_Exp_Count>;
};

export type Spoofing_Reports_To_Tags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Spoofing_Reports_To_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Spoofing_Reports_To_Tags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_Aggregate_Fields = {
  __typename?: 'spoofing_reports_to_tags_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Spoofing_Reports_To_Tags_Max_Fields>;
  min?: Maybe<Spoofing_Reports_To_Tags_Min_Fields>;
};


/** aggregate fields of "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Spoofing_Reports_To_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Spoofing_Reports_To_Tags_Max_Order_By>;
  min?: InputMaybe<Spoofing_Reports_To_Tags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_Arr_Rel_Insert_Input = {
  data: Array<Spoofing_Reports_To_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Spoofing_Reports_To_Tags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "spoofing_reports_to_tags". All fields are combined with a logical 'AND'. */
export type Spoofing_Reports_To_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Spoofing_Reports_To_Tags_Bool_Exp>>;
  _not?: InputMaybe<Spoofing_Reports_To_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Spoofing_Reports_To_Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  spoofing_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  tag_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spoofing_reports_to_tags" */
export enum Spoofing_Reports_To_Tags_Constraint {
  /** unique or primary key constraint on columns "spoofing_report_id", "tag_name" */
  SpoofingReportsToTagsPkey = 'spoofing_reports_to_tags_pkey',
  /** unique or primary key constraint on columns "spoofing_report_id", "tag_name" */
  SpoofingReportsToTagsSpoofingReportIdTagNameKey = 'spoofing_reports_to_tags_spoofing_report_id_tag_name_key'
}

/** input type for inserting data into table "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  tag_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Spoofing_Reports_To_Tags_Max_Fields = {
  __typename?: 'spoofing_reports_to_tags_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  tag_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  spoofing_report_id?: InputMaybe<Order_By>;
  tag_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Spoofing_Reports_To_Tags_Min_Fields = {
  __typename?: 'spoofing_reports_to_tags_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  tag_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  spoofing_report_id?: InputMaybe<Order_By>;
  tag_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_Mutation_Response = {
  __typename?: 'spoofing_reports_to_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Spoofing_Reports_To_Tags>;
};

/** on_conflict condition type for table "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_On_Conflict = {
  constraint: Spoofing_Reports_To_Tags_Constraint;
  update_columns?: Array<Spoofing_Reports_To_Tags_Update_Column>;
  where?: InputMaybe<Spoofing_Reports_To_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "spoofing_reports_to_tags". */
export type Spoofing_Reports_To_Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Order_By>;
  spoofing_report_id?: InputMaybe<Order_By>;
  tag_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: spoofing_reports_to_tags */
export type Spoofing_Reports_To_Tags_Pk_Columns_Input = {
  spoofing_report_id: Scalars['uuid'];
  tag_name: Scalars['String'];
};

/** select columns of table "spoofing_reports_to_tags" */
export enum Spoofing_Reports_To_Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  SpoofingReportId = 'spoofing_report_id',
  /** column name */
  TagName = 'tag_name'
}

/** input type for updating data in table "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  tag_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "spoofing_reports_to_tags" */
export type Spoofing_Reports_To_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Spoofing_Reports_To_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Spoofing_Reports_To_Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  tag_name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "spoofing_reports_to_tags" */
export enum Spoofing_Reports_To_Tags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  SpoofingReportId = 'spoofing_report_id',
  /** column name */
  TagName = 'tag_name'
}

export type Spoofing_Reports_To_Tags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spoofing_Reports_To_Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spoofing_Reports_To_Tags_Bool_Exp;
};

/** update columns of table "spoofing_reports" */
export enum Spoofing_Reports_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainDataId = 'domain_data_id',
  /** column name */
  DomainNameMatch = 'domain_name_match',
  /** column name */
  EstimatedUsdPrice = 'estimated_usd_price',
  /** column name */
  ExternalAssigneeId = 'external_assignee_id',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  ExternalSource = 'external_source',
  /** column name */
  FlaggedUrl = 'flagged_url',
  /** column name */
  Id = 'id',
  /** column name */
  ImportanceScore = 'importance_score',
  /** column name */
  InternalAssigneeId = 'internal_assignee_id',
  /** column name */
  IsCustomerSourced = 'is_customer_sourced',
  /** column name */
  LastActionedAt = 'last_actioned_at',
  /** column name */
  LastActivityTimestamp = 'last_activity_timestamp',
  /** column name */
  LastDelistedAt = 'last_delisted_at',
  /** column name */
  LastReportedAt = 'last_reported_at',
  /** column name */
  LastResolvedAt = 'last_resolved_at',
  /** column name */
  MaxIdSimilarityScore = 'max_id_similarity_score',
  /** column name */
  Notes = 'notes',
  /** column name */
  OnlineAt = 'online_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  OriginalEntityId = 'original_entity_id',
  /** column name */
  PlatformSubtypeId = 'platform_subtype_id',
  /** column name */
  ReportScreenshots = 'report_screenshots',
  /** column name */
  ReportStatus = 'report_status',
  /** column name */
  Score = 'score',
  /** column name */
  ScreenshotUrl = 'screenshot_url',
  /** column name */
  Severity = 'severity',
  /** column name */
  SocialMediaDataId = 'social_media_data_id',
  /** column name */
  SocialMediaPostId = 'social_media_post_id',
  /** column name */
  Source = 'source',
  /** column name */
  SpoofStatus = 'spoof_status',
  /** column name */
  Type = 'type',
  /** column name */
  UnsanitizedUrl = 'unsanitized_url',
  /** column name */
  UploaderId = 'uploader_id',
  /** column name */
  WebsiteContent = 'website_content'
}

export type Spoofing_Reports_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Spoofing_Reports_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Spoofing_Reports_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Spoofing_Reports_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Spoofing_Reports_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Spoofing_Reports_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Spoofing_Reports_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Spoofing_Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Spoofing_Reports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Spoofing_Reports_Var_Pop_Fields = {
  __typename?: 'spoofing_reports_var_pop_fields';
  estimated_usd_price?: Maybe<Scalars['Float']>;
  external_id?: Maybe<Scalars['Float']>;
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "spoofing_reports" */
export type Spoofing_Reports_Var_Pop_Order_By = {
  estimated_usd_price?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spoofing_Reports_Var_Samp_Fields = {
  __typename?: 'spoofing_reports_var_samp_fields';
  estimated_usd_price?: Maybe<Scalars['Float']>;
  external_id?: Maybe<Scalars['Float']>;
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "spoofing_reports" */
export type Spoofing_Reports_Var_Samp_Order_By = {
  estimated_usd_price?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Spoofing_Reports_Variance_Fields = {
  __typename?: 'spoofing_reports_variance_fields';
  estimated_usd_price?: Maybe<Scalars['Float']>;
  external_id?: Maybe<Scalars['Float']>;
  importance_score?: Maybe<Scalars['Float']>;
  max_id_similarity_score?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "spoofing_reports" */
export type Spoofing_Reports_Variance_Order_By = {
  estimated_usd_price?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  importance_score?: InputMaybe<Order_By>;
  max_id_similarity_score?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "spoofing_status". All fields are combined with logical 'AND'. */
export type Spoofing_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['spoofing_status']>;
  _gt?: InputMaybe<Scalars['spoofing_status']>;
  _gte?: InputMaybe<Scalars['spoofing_status']>;
  _in?: InputMaybe<Array<Scalars['spoofing_status']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['spoofing_status']>;
  _lte?: InputMaybe<Scalars['spoofing_status']>;
  _neq?: InputMaybe<Scalars['spoofing_status']>;
  _nin?: InputMaybe<Array<Scalars['spoofing_status']>>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "advertisement_data" */
  advertisement_data: Array<Advertisement_Data>;
  /** fetch aggregated fields from the table: "advertisement_data" */
  advertisement_data_aggregate: Advertisement_Data_Aggregate;
  /** fetch data from the table: "advertisement_data" using primary key columns */
  advertisement_data_by_pk?: Maybe<Advertisement_Data>;
  /** fetch data from the table in a streaming manner: "advertisement_data" */
  advertisement_data_stream: Array<Advertisement_Data>;
  /** fetch data from the table: "advertiser_data" */
  advertiser_data: Array<Advertiser_Data>;
  /** fetch aggregated fields from the table: "advertiser_data" */
  advertiser_data_aggregate: Advertiser_Data_Aggregate;
  /** fetch data from the table: "advertiser_data" using primary key columns */
  advertiser_data_by_pk?: Maybe<Advertiser_Data>;
  /** fetch data from the table in a streaming manner: "advertiser_data" */
  advertiser_data_stream: Array<Advertiser_Data>;
  /** fetch data from the table: "ai_prompts" */
  ai_prompts: Array<Ai_Prompts>;
  /** fetch aggregated fields from the table: "ai_prompts" */
  ai_prompts_aggregate: Ai_Prompts_Aggregate;
  /** fetch data from the table: "ai_prompts" using primary key columns */
  ai_prompts_by_pk?: Maybe<Ai_Prompts>;
  /** fetch data from the table in a streaming manner: "ai_prompts" */
  ai_prompts_stream: Array<Ai_Prompts>;
  /** fetch data from the table: "ai_responses" */
  ai_responses: Array<Ai_Responses>;
  /** fetch aggregated fields from the table: "ai_responses" */
  ai_responses_aggregate: Ai_Responses_Aggregate;
  /** fetch data from the table: "ai_responses" using primary key columns */
  ai_responses_by_pk?: Maybe<Ai_Responses>;
  /** fetch data from the table in a streaming manner: "ai_responses" */
  ai_responses_stream: Array<Ai_Responses>;
  /** fetch data from the table: "alert_hashes" */
  alert_hashes: Array<Alert_Hashes>;
  /** fetch aggregated fields from the table: "alert_hashes" */
  alert_hashes_aggregate: Alert_Hashes_Aggregate;
  /** fetch data from the table: "alert_hashes" using primary key columns */
  alert_hashes_by_pk?: Maybe<Alert_Hashes>;
  /** fetch data from the table in a streaming manner: "alert_hashes" */
  alert_hashes_stream: Array<Alert_Hashes>;
  /** fetch data from the table: "alert_label_events" */
  alert_label_events: Array<Alert_Label_Events>;
  /** fetch aggregated fields from the table: "alert_label_events" */
  alert_label_events_aggregate: Alert_Label_Events_Aggregate;
  /** fetch data from the table: "alert_label_events" using primary key columns */
  alert_label_events_by_pk?: Maybe<Alert_Label_Events>;
  /** fetch data from the table in a streaming manner: "alert_label_events" */
  alert_label_events_stream: Array<Alert_Label_Events>;
  /** An array relationship */
  alert_links: Array<Alert_Links>;
  /** An aggregate relationship */
  alert_links_aggregate: Alert_Links_Aggregate;
  /** fetch data from the table: "alert_links" using primary key columns */
  alert_links_by_pk?: Maybe<Alert_Links>;
  /** fetch data from the table in a streaming manner: "alert_links" */
  alert_links_stream: Array<Alert_Links>;
  alerts_queue_state_count_by_product: Array<Alerts_Queue_State_Count_By_Product>;
  alerts_resolved_top_metrics: Array<Alerts_Resolved_Top_Metrics>;
  alerts_resolved_total_metrics: Array<Alerts_Resolved_Total_Metrics>;
  alerts_surfaced_top_metrics: Array<Alerts_Surfaced_Top_Metrics>;
  alerts_times_to_actioned_by_platform_metrics: Array<Alerts_Times_To_Actioned_By_Platform_Metrics>;
  alerts_times_to_actioned_graph_metrics: Array<Alerts_Times_To_Actioned_Graph_Metrics>;
  alerts_times_to_actioned_metrics: Array<Alerts_Times_To_Actioned_Metrics>;
  alerts_verified_top_metrics: Array<Alerts_Verified_Top_Metrics>;
  alerts_verified_total_metrics: Array<Alerts_Verified_Total_Metrics>;
  /** fetch data from the table: "api_tokens" */
  api_tokens: Array<Api_Tokens>;
  /** fetch aggregated fields from the table: "api_tokens" */
  api_tokens_aggregate: Api_Tokens_Aggregate;
  /** fetch data from the table: "api_tokens" using primary key columns */
  api_tokens_by_pk?: Maybe<Api_Tokens>;
  /** fetch data from the table in a streaming manner: "api_tokens" */
  api_tokens_stream: Array<Api_Tokens>;
  /** fetch data from the table: "api_usage_records" */
  api_usage_records: Array<Api_Usage_Records>;
  /** fetch aggregated fields from the table: "api_usage_records" */
  api_usage_records_aggregate: Api_Usage_Records_Aggregate;
  /** fetch data from the table: "api_usage_records" using primary key columns */
  api_usage_records_by_pk?: Maybe<Api_Usage_Records>;
  /** fetch data from the table in a streaming manner: "api_usage_records" */
  api_usage_records_stream: Array<Api_Usage_Records>;
  /** fetch data from the table: "apify_scraping_jobs" */
  apify_scraping_jobs: Array<Apify_Scraping_Jobs>;
  /** fetch aggregated fields from the table: "apify_scraping_jobs" */
  apify_scraping_jobs_aggregate: Apify_Scraping_Jobs_Aggregate;
  /** fetch data from the table: "apify_scraping_jobs" using primary key columns */
  apify_scraping_jobs_by_pk?: Maybe<Apify_Scraping_Jobs>;
  /** fetch data from the table in a streaming manner: "apify_scraping_jobs" */
  apify_scraping_jobs_stream: Array<Apify_Scraping_Jobs>;
  /** An array relationship */
  approvals: Array<Approvals>;
  /** An aggregate relationship */
  approvals_aggregate: Approvals_Aggregate;
  /** fetch data from the table: "approvals" using primary key columns */
  approvals_by_pk?: Maybe<Approvals>;
  /** fetch data from the table in a streaming manner: "approvals" */
  approvals_stream: Array<Approvals>;
  /** fetch data from the table: "audit.logged_actions" */
  audit_logged_actions: Array<Audit_Logged_Actions>;
  /** fetch aggregated fields from the table: "audit.logged_actions" */
  audit_logged_actions_aggregate: Audit_Logged_Actions_Aggregate;
  /** fetch data from the table: "audit.logged_actions" using primary key columns */
  audit_logged_actions_by_pk?: Maybe<Audit_Logged_Actions>;
  /** fetch data from the table in a streaming manner: "audit.logged_actions" */
  audit_logged_actions_stream: Array<Audit_Logged_Actions>;
  /** An array relationship */
  collection_report_changes: Array<Collection_Report_Changes>;
  /** An aggregate relationship */
  collection_report_changes_aggregate: Collection_Report_Changes_Aggregate;
  /** fetch data from the table: "collection_report_changes" using primary key columns */
  collection_report_changes_by_pk?: Maybe<Collection_Report_Changes>;
  /** fetch data from the table in a streaming manner: "collection_report_changes" */
  collection_report_changes_stream: Array<Collection_Report_Changes>;
  /** fetch data from the table: "collection_report_state_changes" */
  collection_report_state_changes: Array<Collection_Report_State_Changes>;
  /** fetch aggregated fields from the table: "collection_report_state_changes" */
  collection_report_state_changes_aggregate: Collection_Report_State_Changes_Aggregate;
  /** fetch data from the table: "collection_report_state_changes" using primary key columns */
  collection_report_state_changes_by_pk?: Maybe<Collection_Report_State_Changes>;
  /** fetch data from the table in a streaming manner: "collection_report_state_changes" */
  collection_report_state_changes_stream: Array<Collection_Report_State_Changes>;
  /** fetch data from the table: "credit_cards" */
  credit_cards: Array<Credit_Cards>;
  /** fetch aggregated fields from the table: "credit_cards" */
  credit_cards_aggregate: Credit_Cards_Aggregate;
  /** fetch data from the table: "credit_cards" using primary key columns */
  credit_cards_by_pk?: Maybe<Credit_Cards>;
  /** fetch data from the table in a streaming manner: "credit_cards" */
  credit_cards_stream: Array<Credit_Cards>;
  /** fetch data from the table: "customer_assets" */
  customer_assets: Array<Customer_Assets>;
  /** fetch aggregated fields from the table: "customer_assets" */
  customer_assets_aggregate: Customer_Assets_Aggregate;
  /** fetch data from the table: "customer_assets" using primary key columns */
  customer_assets_by_pk?: Maybe<Customer_Assets>;
  /** fetch data from the table in a streaming manner: "customer_assets" */
  customer_assets_stream: Array<Customer_Assets>;
  /** An array relationship */
  customer_assets_to_brands: Array<Customer_Assets_To_Brands>;
  /** An aggregate relationship */
  customer_assets_to_brands_aggregate: Customer_Assets_To_Brands_Aggregate;
  /** fetch data from the table: "customer_assets_to_brands" using primary key columns */
  customer_assets_to_brands_by_pk?: Maybe<Customer_Assets_To_Brands>;
  /** fetch data from the table in a streaming manner: "customer_assets_to_brands" */
  customer_assets_to_brands_stream: Array<Customer_Assets_To_Brands>;
  /** fetch data from the table: "dark_web" */
  dark_web: Array<Dark_Web>;
  /** fetch aggregated fields from the table: "dark_web" */
  dark_web_aggregate: Dark_Web_Aggregate;
  dark_web_alerts_surfaced_top_metrics: Array<Dark_Web_Alerts_Surfaced_Top_Metrics>;
  /** fetch data from the table: "dark_web" using primary key columns */
  dark_web_by_pk?: Maybe<Dark_Web>;
  /** fetch data from the table in a streaming manner: "dark_web" */
  dark_web_stream: Array<Dark_Web>;
  /** fetch data from the table: "defensive_domain_registration" */
  defensive_domain_registration: Array<Defensive_Domain_Registration>;
  /** fetch aggregated fields from the table: "defensive_domain_registration" */
  defensive_domain_registration_aggregate: Defensive_Domain_Registration_Aggregate;
  /** fetch data from the table: "defensive_domain_registration" using primary key columns */
  defensive_domain_registration_by_pk?: Maybe<Defensive_Domain_Registration>;
  /** fetch data from the table in a streaming manner: "defensive_domain_registration" */
  defensive_domain_registration_stream: Array<Defensive_Domain_Registration>;
  /** An array relationship */
  designated_takedown_assets: Array<Designated_Takedown_Assets>;
  /** An aggregate relationship */
  designated_takedown_assets_aggregate: Designated_Takedown_Assets_Aggregate;
  /** fetch data from the table: "designated_takedown_assets" using primary key columns */
  designated_takedown_assets_by_pk?: Maybe<Designated_Takedown_Assets>;
  /** fetch data from the table in a streaming manner: "designated_takedown_assets" */
  designated_takedown_assets_stream: Array<Designated_Takedown_Assets>;
  /** An array relationship */
  detection_assets: Array<Detection_Assets>;
  /** An aggregate relationship */
  detection_assets_aggregate: Detection_Assets_Aggregate;
  /** fetch data from the table: "detection_assets" using primary key columns */
  detection_assets_by_pk?: Maybe<Detection_Assets>;
  /** fetch data from the table in a streaming manner: "detection_assets" */
  detection_assets_stream: Array<Detection_Assets>;
  /** fetch data from the table: "detection_config_approvals" */
  detection_config_approvals: Array<Detection_Config_Approvals>;
  /** fetch aggregated fields from the table: "detection_config_approvals" */
  detection_config_approvals_aggregate: Detection_Config_Approvals_Aggregate;
  /** fetch data from the table: "detection_config_approvals" using primary key columns */
  detection_config_approvals_by_pk?: Maybe<Detection_Config_Approvals>;
  /** fetch data from the table in a streaming manner: "detection_config_approvals" */
  detection_config_approvals_stream: Array<Detection_Config_Approvals>;
  /** fetch data from the table: "domain_data" */
  domain_data: Array<Domain_Data>;
  /** fetch aggregated fields from the table: "domain_data" */
  domain_data_aggregate: Domain_Data_Aggregate;
  /** fetch data from the table: "domain_data" using primary key columns */
  domain_data_by_pk?: Maybe<Domain_Data>;
  /** fetch data from the table in a streaming manner: "domain_data" */
  domain_data_stream: Array<Domain_Data>;
  /** fetch data from the table: "domain_match_data" */
  domain_match_data: Array<Domain_Match_Data>;
  /** fetch aggregated fields from the table: "domain_match_data" */
  domain_match_data_aggregate: Domain_Match_Data_Aggregate;
  /** fetch data from the table: "domain_match_data" using primary key columns */
  domain_match_data_by_pk?: Maybe<Domain_Match_Data>;
  /** fetch data from the table in a streaming manner: "domain_match_data" */
  domain_match_data_stream: Array<Domain_Match_Data>;
  /** fetch data from the table: "ecommerce_listings" */
  ecommerce_listings: Array<Ecommerce_Listings>;
  /** fetch aggregated fields from the table: "ecommerce_listings" */
  ecommerce_listings_aggregate: Ecommerce_Listings_Aggregate;
  /** fetch data from the table: "ecommerce_listings" using primary key columns */
  ecommerce_listings_by_pk?: Maybe<Ecommerce_Listings>;
  /** fetch data from the table in a streaming manner: "ecommerce_listings" */
  ecommerce_listings_stream: Array<Ecommerce_Listings>;
  /** fetch data from the table: "email_addresses" */
  email_addresses: Array<Email_Addresses>;
  /** fetch aggregated fields from the table: "email_addresses" */
  email_addresses_aggregate: Email_Addresses_Aggregate;
  /** fetch data from the table: "email_addresses" using primary key columns */
  email_addresses_by_pk?: Maybe<Email_Addresses>;
  /** fetch data from the table in a streaming manner: "email_addresses" */
  email_addresses_stream: Array<Email_Addresses>;
  email_alerts_resolved_top_metrics: Array<Alerts_Resolved_Top_Metrics>;
  email_alerts_resolved_total_metrics: Array<Alerts_Resolved_Total_Metrics>;
  email_alerts_times_to_actioned_graph_metrics: Array<Alerts_Times_To_Actioned_Graph_Metrics>;
  email_alerts_times_to_actioned_metrics: Array<Alerts_Times_To_Actioned_Metrics>;
  /** fetch data from the table: "email_correspondence" */
  email_correspondence: Array<Email_Correspondence>;
  /** fetch aggregated fields from the table: "email_correspondence" */
  email_correspondence_aggregate: Email_Correspondence_Aggregate;
  /** fetch data from the table: "email_correspondence" using primary key columns */
  email_correspondence_by_pk?: Maybe<Email_Correspondence>;
  /** fetch data from the table in a streaming manner: "email_correspondence" */
  email_correspondence_stream: Array<Email_Correspondence>;
  /** fetch data from the table: "email_settings" */
  email_settings: Array<Email_Settings>;
  /** fetch aggregated fields from the table: "email_settings" */
  email_settings_aggregate: Email_Settings_Aggregate;
  /** fetch data from the table: "email_settings" using primary key columns */
  email_settings_by_pk?: Maybe<Email_Settings>;
  /** fetch data from the table in a streaming manner: "email_settings" */
  email_settings_stream: Array<Email_Settings>;
  /** fetch data from the table: "emails" */
  emails: Array<Emails>;
  /** fetch aggregated fields from the table: "emails" */
  emails_aggregate: Emails_Aggregate;
  /** fetch data from the table: "emails" using primary key columns */
  emails_by_pk?: Maybe<Emails>;
  /** fetch data from the table in a streaming manner: "emails" */
  emails_stream: Array<Emails>;
  /** fetch data from the table: "enforcement_emails" */
  enforcement_emails: Array<Enforcement_Emails>;
  /** fetch aggregated fields from the table: "enforcement_emails" */
  enforcement_emails_aggregate: Enforcement_Emails_Aggregate;
  /** fetch data from the table: "enforcement_emails" using primary key columns */
  enforcement_emails_by_pk?: Maybe<Enforcement_Emails>;
  /** fetch data from the table in a streaming manner: "enforcement_emails" */
  enforcement_emails_stream: Array<Enforcement_Emails>;
  /** fetch data from the table: "enforcement_metadata" */
  enforcement_metadata: Array<Enforcement_Metadata>;
  /** fetch aggregated fields from the table: "enforcement_metadata" */
  enforcement_metadata_aggregate: Enforcement_Metadata_Aggregate;
  /** fetch data from the table: "enforcement_metadata" using primary key columns */
  enforcement_metadata_by_pk?: Maybe<Enforcement_Metadata>;
  /** fetch data from the table in a streaming manner: "enforcement_metadata" */
  enforcement_metadata_stream: Array<Enforcement_Metadata>;
  /** fetch data from the table: "enforcement_platforms" */
  enforcement_platforms: Array<Enforcement_Platforms>;
  /** fetch aggregated fields from the table: "enforcement_platforms" */
  enforcement_platforms_aggregate: Enforcement_Platforms_Aggregate;
  /** fetch data from the table: "enforcement_platforms" using primary key columns */
  enforcement_platforms_by_pk?: Maybe<Enforcement_Platforms>;
  /** fetch data from the table in a streaming manner: "enforcement_platforms" */
  enforcement_platforms_stream: Array<Enforcement_Platforms>;
  /** An array relationship */
  enforcement_requests: Array<Enforcement_Requests>;
  /** An aggregate relationship */
  enforcement_requests_aggregate: Enforcement_Requests_Aggregate;
  /** fetch data from the table: "enforcement_requests" using primary key columns */
  enforcement_requests_by_pk?: Maybe<Enforcement_Requests>;
  /** fetch data from the table in a streaming manner: "enforcement_requests" */
  enforcement_requests_stream: Array<Enforcement_Requests>;
  /** fetch data from the table: "enforcement_templates" */
  enforcement_templates: Array<Enforcement_Templates>;
  /** fetch aggregated fields from the table: "enforcement_templates" */
  enforcement_templates_aggregate: Enforcement_Templates_Aggregate;
  /** fetch data from the table: "enforcement_templates" using primary key columns */
  enforcement_templates_by_pk?: Maybe<Enforcement_Templates>;
  /** fetch data from the table in a streaming manner: "enforcement_templates" */
  enforcement_templates_stream: Array<Enforcement_Templates>;
  /** fetch data from the table: "enforcement_types" */
  enforcement_types: Array<Enforcement_Types>;
  /** fetch aggregated fields from the table: "enforcement_types" */
  enforcement_types_aggregate: Enforcement_Types_Aggregate;
  /** fetch data from the table: "enforcement_types" using primary key columns */
  enforcement_types_by_pk?: Maybe<Enforcement_Types>;
  /** fetch data from the table in a streaming manner: "enforcement_types" */
  enforcement_types_stream: Array<Enforcement_Types>;
  /** fetch data from the table: "entity_aggregates" */
  entity_aggregates: Array<Entity_Aggregates>;
  /** fetch aggregated fields from the table: "entity_aggregates" */
  entity_aggregates_aggregate: Entity_Aggregates_Aggregate;
  /** fetch data from the table: "entity_aggregates" using primary key columns */
  entity_aggregates_by_pk?: Maybe<Entity_Aggregates>;
  /** fetch data from the table in a streaming manner: "entity_aggregates" */
  entity_aggregates_stream: Array<Entity_Aggregates>;
  /** An array relationship */
  entity_data: Array<Entity_Data>;
  /** An aggregate relationship */
  entity_data_aggregate: Entity_Data_Aggregate;
  /** fetch data from the table: "entity_data" using primary key columns */
  entity_data_by_pk?: Maybe<Entity_Data>;
  /** fetch data from the table in a streaming manner: "entity_data" */
  entity_data_stream: Array<Entity_Data>;
  /** fetch data from the table: "entity_links" */
  entity_links: Array<Entity_Links>;
  /** fetch aggregated fields from the table: "entity_links" */
  entity_links_aggregate: Entity_Links_Aggregate;
  /** fetch data from the table: "entity_links" using primary key columns */
  entity_links_by_pk?: Maybe<Entity_Links>;
  /** fetch data from the table in a streaming manner: "entity_links" */
  entity_links_stream: Array<Entity_Links>;
  /** fetch data from the table: "entity_state_classifications" */
  entity_state_classifications: Array<Entity_State_Classifications>;
  /** fetch aggregated fields from the table: "entity_state_classifications" */
  entity_state_classifications_aggregate: Entity_State_Classifications_Aggregate;
  /** fetch data from the table: "entity_state_classifications" using primary key columns */
  entity_state_classifications_by_pk?: Maybe<Entity_State_Classifications>;
  /** fetch data from the table in a streaming manner: "entity_state_classifications" */
  entity_state_classifications_stream: Array<Entity_State_Classifications>;
  /** An array relationship */
  full_urls: Array<Full_Urls>;
  /** An aggregate relationship */
  full_urls_aggregate: Full_Urls_Aggregate;
  /** fetch data from the table: "full_urls" using primary key columns */
  full_urls_by_pk?: Maybe<Full_Urls>;
  /** fetch data from the table in a streaming manner: "full_urls" */
  full_urls_stream: Array<Full_Urls>;
  /** execute function "get_pii_reports_with_screenshots" which returns "pii_reports" */
  get_pii_reports_with_screenshots: Array<Pii_Reports>;
  /** execute function "get_pii_reports_with_screenshots" and query aggregates on result of table type "pii_reports" */
  get_pii_reports_with_screenshots_aggregate: Pii_Reports_Aggregate;
  /** Async action for handle_synchronous_detection_request GCF (for long-running detection asset creation requests) */
  handle_synchronous_detection_request_async_action?: Maybe<Handle_Synchronous_Detection_Request_Async_Action>;
  /** fetch data from the table: "hourly_spoofing_reports_stats" */
  hourly_spoofing_reports_stats: Array<Hourly_Spoofing_Reports_Stats>;
  /** fetch aggregated fields from the table: "hourly_spoofing_reports_stats" */
  hourly_spoofing_reports_stats_aggregate: Hourly_Spoofing_Reports_Stats_Aggregate;
  /** fetch data from the table: "hourly_spoofing_reports_stats" using primary key columns */
  hourly_spoofing_reports_stats_by_pk?: Maybe<Hourly_Spoofing_Reports_Stats>;
  /** fetch data from the table in a streaming manner: "hourly_spoofing_reports_stats" */
  hourly_spoofing_reports_stats_stream: Array<Hourly_Spoofing_Reports_Stats>;
  /** fetch data from the table: "ioc_alert_attribution" */
  ioc_alert_attribution: Array<Ioc_Alert_Attribution>;
  /** fetch aggregated fields from the table: "ioc_alert_attribution" */
  ioc_alert_attribution_aggregate: Ioc_Alert_Attribution_Aggregate;
  /** fetch data from the table: "ioc_alert_attribution" using primary key columns */
  ioc_alert_attribution_by_pk?: Maybe<Ioc_Alert_Attribution>;
  /** fetch data from the table in a streaming manner: "ioc_alert_attribution" */
  ioc_alert_attribution_stream: Array<Ioc_Alert_Attribution>;
  /** fetch data from the table: "ioc_detection_config_attribution" */
  ioc_detection_config_attribution: Array<Ioc_Detection_Config_Attribution>;
  /** fetch aggregated fields from the table: "ioc_detection_config_attribution" */
  ioc_detection_config_attribution_aggregate: Ioc_Detection_Config_Attribution_Aggregate;
  /** fetch data from the table: "ioc_detection_config_attribution" using primary key columns */
  ioc_detection_config_attribution_by_pk?: Maybe<Ioc_Detection_Config_Attribution>;
  /** fetch data from the table in a streaming manner: "ioc_detection_config_attribution" */
  ioc_detection_config_attribution_stream: Array<Ioc_Detection_Config_Attribution>;
  /** fetch data from the table: "ioc_entity_data_attribution" */
  ioc_entity_data_attribution: Array<Ioc_Entity_Data_Attribution>;
  /** fetch aggregated fields from the table: "ioc_entity_data_attribution" */
  ioc_entity_data_attribution_aggregate: Ioc_Entity_Data_Attribution_Aggregate;
  /** fetch data from the table: "ioc_entity_data_attribution" using primary key columns */
  ioc_entity_data_attribution_by_pk?: Maybe<Ioc_Entity_Data_Attribution>;
  /** fetch data from the table in a streaming manner: "ioc_entity_data_attribution" */
  ioc_entity_data_attribution_stream: Array<Ioc_Entity_Data_Attribution>;
  /** fetch data from the table: "iocs" */
  iocs: Array<Iocs>;
  /** fetch aggregated fields from the table: "iocs" */
  iocs_aggregate: Iocs_Aggregate;
  /** fetch data from the table: "iocs" using primary key columns */
  iocs_by_pk?: Maybe<Iocs>;
  /** fetch data from the table in a streaming manner: "iocs" */
  iocs_stream: Array<Iocs>;
  /** An array relationship */
  jira_metadata: Array<Jira_Metadata>;
  /** An aggregate relationship */
  jira_metadata_aggregate: Jira_Metadata_Aggregate;
  /** fetch data from the table: "jira_metadata" using primary key columns */
  jira_metadata_by_pk?: Maybe<Jira_Metadata>;
  /** fetch data from the table in a streaming manner: "jira_metadata" */
  jira_metadata_stream: Array<Jira_Metadata>;
  /** An array relationship */
  match_attributions: Array<Match_Attributions>;
  /** An aggregate relationship */
  match_attributions_aggregate: Match_Attributions_Aggregate;
  /** fetch data from the table: "match_attributions" using primary key columns */
  match_attributions_by_pk?: Maybe<Match_Attributions>;
  /** fetch data from the table in a streaming manner: "match_attributions" */
  match_attributions_stream: Array<Match_Attributions>;
  /** An array relationship */
  ml_features: Array<Ml_Features>;
  /** An aggregate relationship */
  ml_features_aggregate: Ml_Features_Aggregate;
  /** fetch data from the table: "ml_features" using primary key columns */
  ml_features_by_pk?: Maybe<Ml_Features>;
  /** fetch data from the table in a streaming manner: "ml_features" */
  ml_features_stream: Array<Ml_Features>;
  /** fetch data from the table: "mobile_apps" */
  mobile_apps: Array<Mobile_Apps>;
  /** fetch aggregated fields from the table: "mobile_apps" */
  mobile_apps_aggregate: Mobile_Apps_Aggregate;
  /** fetch data from the table: "mobile_apps" using primary key columns */
  mobile_apps_by_pk?: Maybe<Mobile_Apps>;
  /** fetch data from the table in a streaming manner: "mobile_apps" */
  mobile_apps_stream: Array<Mobile_Apps>;
  /** fetch data from the table: "mv_alerts_surfaced_by_day" */
  mv_alerts_surfaced_by_day: Array<Mv_Alerts_Surfaced_By_Day>;
  /** fetch aggregated fields from the table: "mv_alerts_surfaced_by_day" */
  mv_alerts_surfaced_by_day_aggregate: Mv_Alerts_Surfaced_By_Day_Aggregate;
  /** fetch data from the table in a streaming manner: "mv_alerts_surfaced_by_day" */
  mv_alerts_surfaced_by_day_stream: Array<Mv_Alerts_Surfaced_By_Day>;
  /** fetch data from the table: "mv_alerts_surfaced_by_hour" */
  mv_alerts_surfaced_by_hour: Array<Mv_Alerts_Surfaced_By_Hour>;
  /** fetch aggregated fields from the table: "mv_alerts_surfaced_by_hour" */
  mv_alerts_surfaced_by_hour_aggregate: Mv_Alerts_Surfaced_By_Hour_Aggregate;
  /** fetch data from the table in a streaming manner: "mv_alerts_surfaced_by_hour" */
  mv_alerts_surfaced_by_hour_stream: Array<Mv_Alerts_Surfaced_By_Hour>;
  /** fetch data from the table: "mv_alerts_times_to_actioned" */
  mv_alerts_times_to_actioned: Array<Mv_Alerts_Times_To_Actioned>;
  /** fetch aggregated fields from the table: "mv_alerts_times_to_actioned" */
  mv_alerts_times_to_actioned_aggregate: Mv_Alerts_Times_To_Actioned_Aggregate;
  /** fetch data from the table in a streaming manner: "mv_alerts_times_to_actioned" */
  mv_alerts_times_to_actioned_stream: Array<Mv_Alerts_Times_To_Actioned>;
  /** fetch data from the table: "mv_alerts_verified" */
  mv_alerts_verified: Array<Mv_Alerts_Verified>;
  /** fetch aggregated fields from the table: "mv_alerts_verified" */
  mv_alerts_verified_aggregate: Mv_Alerts_Verified_Aggregate;
  /** fetch data from the table in a streaming manner: "mv_alerts_verified" */
  mv_alerts_verified_stream: Array<Mv_Alerts_Verified>;
  /** fetch data from the table: "mv_dark_web_alerts_surfaced" */
  mv_dark_web_alerts_surfaced: Array<Mv_Dark_Web_Alerts_Surfaced>;
  /** fetch aggregated fields from the table: "mv_dark_web_alerts_surfaced" */
  mv_dark_web_alerts_surfaced_aggregate: Mv_Dark_Web_Alerts_Surfaced_Aggregate;
  /** fetch data from the table: "mv_dark_web_alerts_surfaced_by_hour" */
  mv_dark_web_alerts_surfaced_by_hour: Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour>;
  /** fetch aggregated fields from the table: "mv_dark_web_alerts_surfaced_by_hour" */
  mv_dark_web_alerts_surfaced_by_hour_aggregate: Mv_Dark_Web_Alerts_Surfaced_By_Hour_Aggregate;
  /** fetch data from the table in a streaming manner: "mv_dark_web_alerts_surfaced_by_hour" */
  mv_dark_web_alerts_surfaced_by_hour_stream: Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour>;
  /** fetch data from the table in a streaming manner: "mv_dark_web_alerts_surfaced" */
  mv_dark_web_alerts_surfaced_stream: Array<Mv_Dark_Web_Alerts_Surfaced>;
  /** fetch data from the table: "mv_email_alerts_times_to_actioned" */
  mv_email_alerts_times_to_actioned: Array<Mv_Email_Alerts_Times_To_Actioned>;
  /** fetch aggregated fields from the table: "mv_email_alerts_times_to_actioned" */
  mv_email_alerts_times_to_actioned_aggregate: Mv_Email_Alerts_Times_To_Actioned_Aggregate;
  /** fetch data from the table in a streaming manner: "mv_email_alerts_times_to_actioned" */
  mv_email_alerts_times_to_actioned_stream: Array<Mv_Email_Alerts_Times_To_Actioned>;
  /** fetch data from the table: "nft_opensea_processed" */
  nft_opensea_processed: Array<Nft_Opensea_Processed>;
  /** fetch aggregated fields from the table: "nft_opensea_processed" */
  nft_opensea_processed_aggregate: Nft_Opensea_Processed_Aggregate;
  /** fetch data from the table: "nft_opensea_processed" using primary key columns */
  nft_opensea_processed_by_pk?: Maybe<Nft_Opensea_Processed>;
  /** fetch data from the table in a streaming manner: "nft_opensea_processed" */
  nft_opensea_processed_stream: Array<Nft_Opensea_Processed>;
  /** fetch data from the table: "nft_processing_cursor" */
  nft_processing_cursor: Array<Nft_Processing_Cursor>;
  /** fetch aggregated fields from the table: "nft_processing_cursor" */
  nft_processing_cursor_aggregate: Nft_Processing_Cursor_Aggregate;
  /** fetch data from the table: "nft_processing_cursor" using primary key columns */
  nft_processing_cursor_by_pk?: Maybe<Nft_Processing_Cursor>;
  /** fetch data from the table in a streaming manner: "nft_processing_cursor" */
  nft_processing_cursor_stream: Array<Nft_Processing_Cursor>;
  /** fetch data from the table: "notification_subscriptions" */
  notification_subscriptions: Array<Notification_Subscriptions>;
  /** fetch aggregated fields from the table: "notification_subscriptions" */
  notification_subscriptions_aggregate: Notification_Subscriptions_Aggregate;
  /** fetch data from the table: "notification_subscriptions" using primary key columns */
  notification_subscriptions_by_pk?: Maybe<Notification_Subscriptions>;
  /** fetch data from the table in a streaming manner: "notification_subscriptions" */
  notification_subscriptions_stream: Array<Notification_Subscriptions>;
  /** fetch data from the table: "organization_id_api_keys" */
  organization_id_api_keys: Array<Organization_Id_Api_Keys>;
  /** fetch aggregated fields from the table: "organization_id_api_keys" */
  organization_id_api_keys_aggregate: Organization_Id_Api_Keys_Aggregate;
  /** fetch data from the table: "organization_id_api_keys" using primary key columns */
  organization_id_api_keys_by_pk?: Maybe<Organization_Id_Api_Keys>;
  /** fetch data from the table in a streaming manner: "organization_id_api_keys" */
  organization_id_api_keys_stream: Array<Organization_Id_Api_Keys>;
  /** An array relationship */
  organization_products: Array<Organization_Products>;
  /** An aggregate relationship */
  organization_products_aggregate: Organization_Products_Aggregate;
  /** fetch data from the table: "organization_products" using primary key columns */
  organization_products_by_pk?: Maybe<Organization_Products>;
  /** fetch data from the table in a streaming manner: "organization_products" */
  organization_products_stream: Array<Organization_Products>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table: "organizations_metadata" */
  organizations_metadata: Array<Organizations_Metadata>;
  /** fetch aggregated fields from the table: "organizations_metadata" */
  organizations_metadata_aggregate: Organizations_Metadata_Aggregate;
  /** fetch data from the table: "organizations_metadata" using primary key columns */
  organizations_metadata_by_pk?: Maybe<Organizations_Metadata>;
  /** fetch data from the table in a streaming manner: "organizations_metadata" */
  organizations_metadata_stream: Array<Organizations_Metadata>;
  /** fetch data from the table in a streaming manner: "organizations" */
  organizations_stream: Array<Organizations>;
  /** fetch data from the table: "permissions" */
  permissions: Array<Permissions>;
  /** fetch aggregated fields from the table: "permissions" */
  permissions_aggregate: Permissions_Aggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: Maybe<Permissions>;
  /** fetch data from the table in a streaming manner: "permissions" */
  permissions_stream: Array<Permissions>;
  /** fetch data from the table: "phone_numbers" */
  phone_numbers: Array<Phone_Numbers>;
  /** fetch aggregated fields from the table: "phone_numbers" */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  /** fetch data from the table: "phone_numbers" using primary key columns */
  phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** fetch data from the table in a streaming manner: "phone_numbers" */
  phone_numbers_stream: Array<Phone_Numbers>;
  /** fetch data from the table: "pii_databrokers" */
  pii_databrokers: Array<Pii_Databrokers>;
  /** fetch aggregated fields from the table: "pii_databrokers" */
  pii_databrokers_aggregate: Pii_Databrokers_Aggregate;
  /** fetch data from the table: "pii_databrokers" using primary key columns */
  pii_databrokers_by_pk?: Maybe<Pii_Databrokers>;
  /** fetch data from the table in a streaming manner: "pii_databrokers" */
  pii_databrokers_stream: Array<Pii_Databrokers>;
  /** fetch data from the table: "pii_events" */
  pii_events: Array<Pii_Events>;
  /** fetch aggregated fields from the table: "pii_events" */
  pii_events_aggregate: Pii_Events_Aggregate;
  /** fetch data from the table: "pii_events" using primary key columns */
  pii_events_by_pk?: Maybe<Pii_Events>;
  /** fetch data from the table in a streaming manner: "pii_events" */
  pii_events_stream: Array<Pii_Events>;
  /** fetch data from the table: "pii_leaks_by_databroker" */
  pii_leaks_by_databroker: Array<Pii_Leaks_By_Databroker>;
  /** fetch aggregated fields from the table: "pii_leaks_by_databroker" */
  pii_leaks_by_databroker_aggregate: Pii_Leaks_By_Databroker_Aggregate;
  /** fetch data from the table in a streaming manner: "pii_leaks_by_databroker" */
  pii_leaks_by_databroker_stream: Array<Pii_Leaks_By_Databroker>;
  /** fetch data from the table: "pii_reports" */
  pii_reports: Array<Pii_Reports>;
  /** fetch aggregated fields from the table: "pii_reports" */
  pii_reports_aggregate: Pii_Reports_Aggregate;
  /** fetch data from the table: "pii_reports" using primary key columns */
  pii_reports_by_pk?: Maybe<Pii_Reports>;
  /** fetch data from the table in a streaming manner: "pii_reports" */
  pii_reports_stream: Array<Pii_Reports>;
  /** fetch data from the table: "pii_statistics" */
  pii_statistics: Array<Pii_Statistics>;
  /** fetch aggregated fields from the table: "pii_statistics" */
  pii_statistics_aggregate: Pii_Statistics_Aggregate;
  /** fetch data from the table: "pii_statistics" using primary key columns */
  pii_statistics_by_pk?: Maybe<Pii_Statistics>;
  /** fetch data from the table in a streaming manner: "pii_statistics" */
  pii_statistics_stream: Array<Pii_Statistics>;
  /** fetch data from the table: "platform_subtypes" */
  platform_subtypes: Array<Platform_Subtypes>;
  /** fetch aggregated fields from the table: "platform_subtypes" */
  platform_subtypes_aggregate: Platform_Subtypes_Aggregate;
  /** fetch data from the table: "platform_subtypes" using primary key columns */
  platform_subtypes_by_pk?: Maybe<Platform_Subtypes>;
  /** fetch data from the table in a streaming manner: "platform_subtypes" */
  platform_subtypes_stream: Array<Platform_Subtypes>;
  /** fetch data from the table: "platforms" */
  platforms: Array<Platforms>;
  /** fetch aggregated fields from the table: "platforms" */
  platforms_aggregate: Platforms_Aggregate;
  /** fetch data from the table: "platforms" using primary key columns */
  platforms_by_pk?: Maybe<Platforms>;
  /** fetch data from the table in a streaming manner: "platforms" */
  platforms_stream: Array<Platforms>;
  /** fetch data from the table: "pre_collections" */
  pre_collections: Array<Pre_Collections>;
  /** fetch aggregated fields from the table: "pre_collections" */
  pre_collections_aggregate: Pre_Collections_Aggregate;
  /** fetch data from the table: "pre_collections" using primary key columns */
  pre_collections_by_pk?: Maybe<Pre_Collections>;
  /** fetch data from the table in a streaming manner: "pre_collections" */
  pre_collections_stream: Array<Pre_Collections>;
  /** fetch data from the table: "predicted_enforcement_types" */
  predicted_enforcement_types: Array<Predicted_Enforcement_Types>;
  /** fetch aggregated fields from the table: "predicted_enforcement_types" */
  predicted_enforcement_types_aggregate: Predicted_Enforcement_Types_Aggregate;
  /** fetch data from the table: "predicted_enforcement_types" using primary key columns */
  predicted_enforcement_types_by_pk?: Maybe<Predicted_Enforcement_Types>;
  /** fetch data from the table in a streaming manner: "predicted_enforcement_types" */
  predicted_enforcement_types_stream: Array<Predicted_Enforcement_Types>;
  /** An array relationship */
  protected_assets: Array<Protected_Assets>;
  /** An aggregate relationship */
  protected_assets_aggregate: Protected_Assets_Aggregate;
  /** fetch data from the table: "protected_assets" using primary key columns */
  protected_assets_by_pk?: Maybe<Protected_Assets>;
  /** fetch data from the table in a streaming manner: "protected_assets" */
  protected_assets_stream: Array<Protected_Assets>;
  /** An array relationship */
  report_tags: Array<Report_Tags>;
  /** An aggregate relationship */
  report_tags_aggregate: Report_Tags_Aggregate;
  /** fetch data from the table: "report_tags" using primary key columns */
  report_tags_by_pk?: Maybe<Report_Tags>;
  /** fetch data from the table in a streaming manner: "report_tags" */
  report_tags_stream: Array<Report_Tags>;
  /** fetch data from the table: "reports_to_reports" */
  reports_to_reports: Array<Reports_To_Reports>;
  /** fetch aggregated fields from the table: "reports_to_reports" */
  reports_to_reports_aggregate: Reports_To_Reports_Aggregate;
  /** fetch data from the table: "reports_to_reports" using primary key columns */
  reports_to_reports_by_pk?: Maybe<Reports_To_Reports>;
  /** fetch data from the table in a streaming manner: "reports_to_reports" */
  reports_to_reports_stream: Array<Reports_To_Reports>;
  request_alert_csv_export?: Maybe<Request_Alert_Csv_Export>;
  /** An array relationship */
  role_permissions: Array<Role_Permissions>;
  /** An aggregate relationship */
  role_permissions_aggregate: Role_Permissions_Aggregate;
  /** fetch data from the table: "role_permissions" using primary key columns */
  role_permissions_by_pk?: Maybe<Role_Permissions>;
  /** fetch data from the table in a streaming manner: "role_permissions" */
  role_permissions_stream: Array<Role_Permissions>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table in a streaming manner: "roles" */
  roles_stream: Array<Roles>;
  /** fetch data from the table: "rules" */
  rules: Array<Rules>;
  /** fetch aggregated fields from the table: "rules" */
  rules_aggregate: Rules_Aggregate;
  /** fetch data from the table: "rules" using primary key columns */
  rules_by_pk?: Maybe<Rules>;
  /** fetch data from the table in a streaming manner: "rules" */
  rules_stream: Array<Rules>;
  /** fetch data from the table: "safelist_ip_addresses" */
  safelist_ip_addresses: Array<Safelist_Ip_Addresses>;
  /** fetch aggregated fields from the table: "safelist_ip_addresses" */
  safelist_ip_addresses_aggregate: Safelist_Ip_Addresses_Aggregate;
  /** fetch data from the table: "safelist_ip_addresses" using primary key columns */
  safelist_ip_addresses_by_pk?: Maybe<Safelist_Ip_Addresses>;
  /** fetch data from the table in a streaming manner: "safelist_ip_addresses" */
  safelist_ip_addresses_stream: Array<Safelist_Ip_Addresses>;
  /** fetch data from the table: "salesforce_organizations_data" */
  salesforce_organizations_data: Array<Salesforce_Organizations_Data>;
  /** fetch aggregated fields from the table: "salesforce_organizations_data" */
  salesforce_organizations_data_aggregate: Salesforce_Organizations_Data_Aggregate;
  /** fetch data from the table: "salesforce_organizations_data" using primary key columns */
  salesforce_organizations_data_by_pk?: Maybe<Salesforce_Organizations_Data>;
  /** fetch data from the table in a streaming manner: "salesforce_organizations_data" */
  salesforce_organizations_data_stream: Array<Salesforce_Organizations_Data>;
  /** An array relationship */
  scan_results: Array<Scan_Results>;
  /** An aggregate relationship */
  scan_results_aggregate: Scan_Results_Aggregate;
  /** fetch data from the table: "scan_results" using primary key columns */
  scan_results_by_pk?: Maybe<Scan_Results>;
  /** fetch data from the table in a streaming manner: "scan_results" */
  scan_results_stream: Array<Scan_Results>;
  /** fetch data from the table: "scans" */
  scans: Array<Scans>;
  /** fetch aggregated fields from the table: "scans" */
  scans_aggregate: Scans_Aggregate;
  /** fetch data from the table: "scans" using primary key columns */
  scans_by_pk?: Maybe<Scans>;
  /** fetch data from the table in a streaming manner: "scans" */
  scans_stream: Array<Scans>;
  /** fetch data from the table: "scraping_configs" */
  scraping_configs: Array<Scraping_Configs>;
  /** fetch aggregated fields from the table: "scraping_configs" */
  scraping_configs_aggregate: Scraping_Configs_Aggregate;
  /** fetch data from the table: "scraping_configs" using primary key columns */
  scraping_configs_by_pk?: Maybe<Scraping_Configs>;
  /** fetch data from the table in a streaming manner: "scraping_configs" */
  scraping_configs_stream: Array<Scraping_Configs>;
  /** execute function "search_spoofing_reports" which returns "spoofing_reports" */
  search_spoofing_reports: Array<Spoofing_Reports>;
  /** execute function "search_spoofing_reports" and query aggregates on result of table type "spoofing_reports" */
  search_spoofing_reports_aggregate: Spoofing_Reports_Aggregate;
  /** fetch data from the table: "sim_campaign_observations" */
  sim_campaign_observations: Array<Sim_Campaign_Observations>;
  /** fetch aggregated fields from the table: "sim_campaign_observations" */
  sim_campaign_observations_aggregate: Sim_Campaign_Observations_Aggregate;
  /** fetch data from the table: "sim_campaign_observations" using primary key columns */
  sim_campaign_observations_by_pk?: Maybe<Sim_Campaign_Observations>;
  /** fetch data from the table in a streaming manner: "sim_campaign_observations" */
  sim_campaign_observations_stream: Array<Sim_Campaign_Observations>;
  /** fetch data from the table: "sim_campaigns" */
  sim_campaigns: Array<Sim_Campaigns>;
  /** fetch aggregated fields from the table: "sim_campaigns" */
  sim_campaigns_aggregate: Sim_Campaigns_Aggregate;
  /** fetch data from the table: "sim_campaigns" using primary key columns */
  sim_campaigns_by_pk?: Maybe<Sim_Campaigns>;
  /** fetch data from the table in a streaming manner: "sim_campaigns" */
  sim_campaigns_stream: Array<Sim_Campaigns>;
  /** fetch data from the table: "sim_emails" */
  sim_emails: Array<Sim_Emails>;
  /** fetch aggregated fields from the table: "sim_emails" */
  sim_emails_aggregate: Sim_Emails_Aggregate;
  /** fetch data from the table: "sim_emails" using primary key columns */
  sim_emails_by_pk?: Maybe<Sim_Emails>;
  /** fetch data from the table in a streaming manner: "sim_emails" */
  sim_emails_stream: Array<Sim_Emails>;
  /** fetch data from the table: "sim_groups" */
  sim_groups: Array<Sim_Groups>;
  /** fetch aggregated fields from the table: "sim_groups" */
  sim_groups_aggregate: Sim_Groups_Aggregate;
  /** fetch data from the table: "sim_groups" using primary key columns */
  sim_groups_by_pk?: Maybe<Sim_Groups>;
  /** fetch data from the table in a streaming manner: "sim_groups" */
  sim_groups_stream: Array<Sim_Groups>;
  /** fetch data from the table: "sim_users" */
  sim_users: Array<Sim_Users>;
  /** fetch aggregated fields from the table: "sim_users" */
  sim_users_aggregate: Sim_Users_Aggregate;
  /** fetch data from the table: "sim_users" using primary key columns */
  sim_users_by_pk?: Maybe<Sim_Users>;
  /** fetch data from the table in a streaming manner: "sim_users" */
  sim_users_stream: Array<Sim_Users>;
  /** fetch data from the table: "slack_installations" */
  slack_installations: Array<Slack_Installations>;
  /** fetch aggregated fields from the table: "slack_installations" */
  slack_installations_aggregate: Slack_Installations_Aggregate;
  /** fetch data from the table: "slack_installations" using primary key columns */
  slack_installations_by_pk?: Maybe<Slack_Installations>;
  /** fetch data from the table in a streaming manner: "slack_installations" */
  slack_installations_stream: Array<Slack_Installations>;
  /** fetch data from the table: "social_media_comments" */
  social_media_comments: Array<Social_Media_Comments>;
  /** fetch aggregated fields from the table: "social_media_comments" */
  social_media_comments_aggregate: Social_Media_Comments_Aggregate;
  /** fetch data from the table: "social_media_comments" using primary key columns */
  social_media_comments_by_pk?: Maybe<Social_Media_Comments>;
  /** fetch data from the table in a streaming manner: "social_media_comments" */
  social_media_comments_stream: Array<Social_Media_Comments>;
  /** fetch data from the table: "social_media_data" */
  social_media_data: Array<Social_Media_Data>;
  /** fetch aggregated fields from the table: "social_media_data" */
  social_media_data_aggregate: Social_Media_Data_Aggregate;
  /** fetch data from the table: "social_media_data" using primary key columns */
  social_media_data_by_pk?: Maybe<Social_Media_Data>;
  /** fetch data from the table in a streaming manner: "social_media_data" */
  social_media_data_stream: Array<Social_Media_Data>;
  /** fetch data from the table: "social_media_group" */
  social_media_group: Array<Social_Media_Group>;
  /** fetch aggregated fields from the table: "social_media_group" */
  social_media_group_aggregate: Social_Media_Group_Aggregate;
  /** fetch data from the table: "social_media_group" using primary key columns */
  social_media_group_by_pk?: Maybe<Social_Media_Group>;
  /** fetch data from the table in a streaming manner: "social_media_group" */
  social_media_group_stream: Array<Social_Media_Group>;
  /** fetch data from the table: "social_media_post" */
  social_media_post: Array<Social_Media_Post>;
  /** fetch aggregated fields from the table: "social_media_post" */
  social_media_post_aggregate: Social_Media_Post_Aggregate;
  /** fetch data from the table: "social_media_post" using primary key columns */
  social_media_post_by_pk?: Maybe<Social_Media_Post>;
  /** fetch data from the table in a streaming manner: "social_media_post" */
  social_media_post_stream: Array<Social_Media_Post>;
  /** An array relationship */
  sourcing_queries: Array<Sourcing_Queries>;
  /** An aggregate relationship */
  sourcing_queries_aggregate: Sourcing_Queries_Aggregate;
  /** fetch data from the table: "sourcing_queries" using primary key columns */
  sourcing_queries_by_pk?: Maybe<Sourcing_Queries>;
  /** fetch data from the table in a streaming manner: "sourcing_queries" */
  sourcing_queries_stream: Array<Sourcing_Queries>;
  /** fetch data from the table: "sourcing_query_executions" */
  sourcing_query_executions: Array<Sourcing_Query_Executions>;
  /** fetch aggregated fields from the table: "sourcing_query_executions" */
  sourcing_query_executions_aggregate: Sourcing_Query_Executions_Aggregate;
  /** fetch data from the table: "sourcing_query_executions" using primary key columns */
  sourcing_query_executions_by_pk?: Maybe<Sourcing_Query_Executions>;
  /** fetch data from the table in a streaming manner: "sourcing_query_executions" */
  sourcing_query_executions_stream: Array<Sourcing_Query_Executions>;
  /** An array relationship */
  spoof_matches: Array<Spoof_Matches>;
  /** An aggregate relationship */
  spoof_matches_aggregate: Spoof_Matches_Aggregate;
  /** fetch data from the table: "spoof_matches" using primary key columns */
  spoof_matches_by_pk?: Maybe<Spoof_Matches>;
  /** fetch data from the table in a streaming manner: "spoof_matches" */
  spoof_matches_stream: Array<Spoof_Matches>;
  /** An array relationship */
  spoofing_entities: Array<Spoofing_Entities>;
  /** An aggregate relationship */
  spoofing_entities_aggregate: Spoofing_Entities_Aggregate;
  /** fetch data from the table: "spoofing_entities" using primary key columns */
  spoofing_entities_by_pk?: Maybe<Spoofing_Entities>;
  /** fetch data from the table in a streaming manner: "spoofing_entities" */
  spoofing_entities_stream: Array<Spoofing_Entities>;
  /** fetch data from the table: "spoofing_report_search_results" */
  spoofing_report_search_results: Array<Spoofing_Report_Search_Results>;
  /** fetch aggregated fields from the table: "spoofing_report_search_results" */
  spoofing_report_search_results_aggregate: Spoofing_Report_Search_Results_Aggregate;
  /** fetch data from the table in a streaming manner: "spoofing_report_search_results" */
  spoofing_report_search_results_stream: Array<Spoofing_Report_Search_Results>;
  /** An array relationship */
  spoofing_reports: Array<Spoofing_Reports>;
  /** An aggregate relationship */
  spoofing_reports_aggregate: Spoofing_Reports_Aggregate;
  /** fetch data from the table: "spoofing_reports" using primary key columns */
  spoofing_reports_by_pk?: Maybe<Spoofing_Reports>;
  /** fetch data from the table in a streaming manner: "spoofing_reports" */
  spoofing_reports_stream: Array<Spoofing_Reports>;
  /** An array relationship */
  spoofing_reports_to_tags: Array<Spoofing_Reports_To_Tags>;
  /** An aggregate relationship */
  spoofing_reports_to_tags_aggregate: Spoofing_Reports_To_Tags_Aggregate;
  /** fetch data from the table: "spoofing_reports_to_tags" using primary key columns */
  spoofing_reports_to_tags_by_pk?: Maybe<Spoofing_Reports_To_Tags>;
  /** fetch data from the table in a streaming manner: "spoofing_reports_to_tags" */
  spoofing_reports_to_tags_stream: Array<Spoofing_Reports_To_Tags>;
  /** fetch data from the table: "suggested_enforcements" */
  suggested_enforcements: Array<Suggested_Enforcements>;
  /** fetch aggregated fields from the table: "suggested_enforcements" */
  suggested_enforcements_aggregate: Suggested_Enforcements_Aggregate;
  /** fetch data from the table: "suggested_enforcements" using primary key columns */
  suggested_enforcements_by_pk?: Maybe<Suggested_Enforcements>;
  /** fetch data from the table: "suggested_enforcements_form_responses" */
  suggested_enforcements_form_responses: Array<Suggested_Enforcements_Form_Responses>;
  /** fetch aggregated fields from the table: "suggested_enforcements_form_responses" */
  suggested_enforcements_form_responses_aggregate: Suggested_Enforcements_Form_Responses_Aggregate;
  /** fetch data from the table: "suggested_enforcements_form_responses" using primary key columns */
  suggested_enforcements_form_responses_by_pk?: Maybe<Suggested_Enforcements_Form_Responses>;
  /** fetch data from the table in a streaming manner: "suggested_enforcements_form_responses" */
  suggested_enforcements_form_responses_stream: Array<Suggested_Enforcements_Form_Responses>;
  /** fetch data from the table in a streaming manner: "suggested_enforcements" */
  suggested_enforcements_stream: Array<Suggested_Enforcements>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** fetch data from the table in a streaming manner: "tags" */
  tags_stream: Array<Tags>;
  /** An array relationship */
  threat_intel_actor_to_campaign: Array<Threat_Intel_Actor_To_Campaign>;
  /** An aggregate relationship */
  threat_intel_actor_to_campaign_aggregate: Threat_Intel_Actor_To_Campaign_Aggregate;
  /** fetch data from the table: "threat_intel_actor_to_campaign" using primary key columns */
  threat_intel_actor_to_campaign_by_pk?: Maybe<Threat_Intel_Actor_To_Campaign>;
  /** fetch data from the table in a streaming manner: "threat_intel_actor_to_campaign" */
  threat_intel_actor_to_campaign_stream: Array<Threat_Intel_Actor_To_Campaign>;
  /** fetch data from the table: "threat_intel_actors" */
  threat_intel_actors: Array<Threat_Intel_Actors>;
  /** fetch aggregated fields from the table: "threat_intel_actors" */
  threat_intel_actors_aggregate: Threat_Intel_Actors_Aggregate;
  /** fetch data from the table: "threat_intel_actors" using primary key columns */
  threat_intel_actors_by_pk?: Maybe<Threat_Intel_Actors>;
  /** fetch data from the table in a streaming manner: "threat_intel_actors" */
  threat_intel_actors_stream: Array<Threat_Intel_Actors>;
  /** An array relationship */
  threat_intel_campaign_to_entities: Array<Threat_Intel_Campaign_To_Entities>;
  /** An aggregate relationship */
  threat_intel_campaign_to_entities_aggregate: Threat_Intel_Campaign_To_Entities_Aggregate;
  /** fetch data from the table: "threat_intel_campaign_to_entities" using primary key columns */
  threat_intel_campaign_to_entities_by_pk?: Maybe<Threat_Intel_Campaign_To_Entities>;
  /** fetch data from the table in a streaming manner: "threat_intel_campaign_to_entities" */
  threat_intel_campaign_to_entities_stream: Array<Threat_Intel_Campaign_To_Entities>;
  /** fetch data from the table: "threat_intel_campaigns" */
  threat_intel_campaigns: Array<Threat_Intel_Campaigns>;
  /** fetch aggregated fields from the table: "threat_intel_campaigns" */
  threat_intel_campaigns_aggregate: Threat_Intel_Campaigns_Aggregate;
  /** fetch data from the table: "threat_intel_campaigns" using primary key columns */
  threat_intel_campaigns_by_pk?: Maybe<Threat_Intel_Campaigns>;
  /** fetch data from the table in a streaming manner: "threat_intel_campaigns" */
  threat_intel_campaigns_stream: Array<Threat_Intel_Campaigns>;
  /** An array relationship */
  trademarks: Array<Trademarks>;
  /** An aggregate relationship */
  trademarks_aggregate: Trademarks_Aggregate;
  /** fetch data from the table: "trademarks" using primary key columns */
  trademarks_by_pk?: Maybe<Trademarks>;
  /** fetch data from the table in a streaming manner: "trademarks" */
  trademarks_stream: Array<Trademarks>;
  /** fetch data from the table: "uploaded_files" */
  uploaded_files: Array<Uploaded_Files>;
  /** fetch aggregated fields from the table: "uploaded_files" */
  uploaded_files_aggregate: Uploaded_Files_Aggregate;
  /** fetch data from the table: "uploaded_files" using primary key columns */
  uploaded_files_by_pk?: Maybe<Uploaded_Files>;
  /** fetch data from the table in a streaming manner: "uploaded_files" */
  uploaded_files_stream: Array<Uploaded_Files>;
  /** fetch data from the table: "user_feedback" */
  user_feedback: Array<User_Feedback>;
  /** fetch aggregated fields from the table: "user_feedback" */
  user_feedback_aggregate: User_Feedback_Aggregate;
  /** fetch data from the table: "user_feedback" using primary key columns */
  user_feedback_by_pk?: Maybe<User_Feedback>;
  /** fetch data from the table in a streaming manner: "user_feedback" */
  user_feedback_stream: Array<User_Feedback>;
  /** fetch data from the table: "user_organizations" */
  user_organizations: Array<User_Organizations>;
  /** fetch aggregated fields from the table: "user_organizations" */
  user_organizations_aggregate: User_Organizations_Aggregate;
  /** fetch data from the table: "user_organizations" using primary key columns */
  user_organizations_by_pk?: Maybe<User_Organizations>;
  /** fetch data from the table in a streaming manner: "user_organizations" */
  user_organizations_stream: Array<User_Organizations>;
  /** fetch data from the table: "user_products" */
  user_products: Array<User_Products>;
  /** fetch aggregated fields from the table: "user_products" */
  user_products_aggregate: User_Products_Aggregate;
  /** fetch data from the table: "user_products" using primary key columns */
  user_products_by_pk?: Maybe<User_Products>;
  /** fetch data from the table in a streaming manner: "user_products" */
  user_products_stream: Array<User_Products>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "vetric_screenshot_webhooks" */
  vetric_screenshot_webhooks: Array<Vetric_Screenshot_Webhooks>;
  /** fetch aggregated fields from the table: "vetric_screenshot_webhooks" */
  vetric_screenshot_webhooks_aggregate: Vetric_Screenshot_Webhooks_Aggregate;
  /** fetch data from the table: "vetric_screenshot_webhooks" using primary key columns */
  vetric_screenshot_webhooks_by_pk?: Maybe<Vetric_Screenshot_Webhooks>;
  /** fetch data from the table in a streaming manner: "vetric_screenshot_webhooks" */
  vetric_screenshot_webhooks_stream: Array<Vetric_Screenshot_Webhooks>;
  /** fetch data from the table: "webhook_targets" */
  webhook_targets: Array<Webhook_Targets>;
  /** fetch aggregated fields from the table: "webhook_targets" */
  webhook_targets_aggregate: Webhook_Targets_Aggregate;
  /** fetch data from the table: "webhook_targets" using primary key columns */
  webhook_targets_by_pk?: Maybe<Webhook_Targets>;
  /** fetch data from the table in a streaming manner: "webhook_targets" */
  webhook_targets_stream: Array<Webhook_Targets>;
};


export type Subscription_RootAdvertisement_DataArgs = {
  distinct_on?: InputMaybe<Array<Advertisement_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advertisement_Data_Order_By>>;
  where?: InputMaybe<Advertisement_Data_Bool_Exp>;
};


export type Subscription_RootAdvertisement_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advertisement_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advertisement_Data_Order_By>>;
  where?: InputMaybe<Advertisement_Data_Bool_Exp>;
};


export type Subscription_RootAdvertisement_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAdvertisement_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Advertisement_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Advertisement_Data_Bool_Exp>;
};


export type Subscription_RootAdvertiser_DataArgs = {
  distinct_on?: InputMaybe<Array<Advertiser_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advertiser_Data_Order_By>>;
  where?: InputMaybe<Advertiser_Data_Bool_Exp>;
};


export type Subscription_RootAdvertiser_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Advertiser_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Advertiser_Data_Order_By>>;
  where?: InputMaybe<Advertiser_Data_Bool_Exp>;
};


export type Subscription_RootAdvertiser_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAdvertiser_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Advertiser_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Advertiser_Data_Bool_Exp>;
};


export type Subscription_RootAi_PromptsArgs = {
  distinct_on?: InputMaybe<Array<Ai_Prompts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Prompts_Order_By>>;
  where?: InputMaybe<Ai_Prompts_Bool_Exp>;
};


export type Subscription_RootAi_Prompts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Prompts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Prompts_Order_By>>;
  where?: InputMaybe<Ai_Prompts_Bool_Exp>;
};


export type Subscription_RootAi_Prompts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAi_Prompts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ai_Prompts_Stream_Cursor_Input>>;
  where?: InputMaybe<Ai_Prompts_Bool_Exp>;
};


export type Subscription_RootAi_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Ai_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Responses_Order_By>>;
  where?: InputMaybe<Ai_Responses_Bool_Exp>;
};


export type Subscription_RootAi_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Responses_Order_By>>;
  where?: InputMaybe<Ai_Responses_Bool_Exp>;
};


export type Subscription_RootAi_Responses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAi_Responses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ai_Responses_Stream_Cursor_Input>>;
  where?: InputMaybe<Ai_Responses_Bool_Exp>;
};


export type Subscription_RootAlert_HashesArgs = {
  distinct_on?: InputMaybe<Array<Alert_Hashes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Hashes_Order_By>>;
  where?: InputMaybe<Alert_Hashes_Bool_Exp>;
};


export type Subscription_RootAlert_Hashes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Hashes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Hashes_Order_By>>;
  where?: InputMaybe<Alert_Hashes_Bool_Exp>;
};


export type Subscription_RootAlert_Hashes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAlert_Hashes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Alert_Hashes_Stream_Cursor_Input>>;
  where?: InputMaybe<Alert_Hashes_Bool_Exp>;
};


export type Subscription_RootAlert_Label_EventsArgs = {
  distinct_on?: InputMaybe<Array<Alert_Label_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Label_Events_Order_By>>;
  where?: InputMaybe<Alert_Label_Events_Bool_Exp>;
};


export type Subscription_RootAlert_Label_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Label_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Label_Events_Order_By>>;
  where?: InputMaybe<Alert_Label_Events_Bool_Exp>;
};


export type Subscription_RootAlert_Label_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAlert_Label_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Alert_Label_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Alert_Label_Events_Bool_Exp>;
};


export type Subscription_RootAlert_LinksArgs = {
  distinct_on?: InputMaybe<Array<Alert_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Links_Order_By>>;
  where?: InputMaybe<Alert_Links_Bool_Exp>;
};


export type Subscription_RootAlert_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Alert_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alert_Links_Order_By>>;
  where?: InputMaybe<Alert_Links_Bool_Exp>;
};


export type Subscription_RootAlert_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAlert_Links_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Alert_Links_Stream_Cursor_Input>>;
  where?: InputMaybe<Alert_Links_Bool_Exp>;
};


export type Subscription_RootAlerts_Queue_State_Count_By_ProductArgs = {
  args: Alerts_Queue_State_Count_By_Product_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Queue_State_Count_By_Product_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Queue_State_Count_By_Product_Order_By>>;
  where?: InputMaybe<Alerts_Queue_State_Count_By_Product_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootAlerts_Resolved_Top_MetricsArgs = {
  args: Alerts_Resolved_Top_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Resolved_Top_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Resolved_Top_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Resolved_Top_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootAlerts_Resolved_Total_MetricsArgs = {
  args: Alerts_Resolved_Total_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Resolved_Total_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Resolved_Total_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Resolved_Total_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootAlerts_Surfaced_Top_MetricsArgs = {
  args: Alerts_Surfaced_Top_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Surfaced_Top_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Surfaced_Top_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootAlerts_Times_To_Actioned_By_Platform_MetricsArgs = {
  args: Alerts_Times_To_Actioned_By_Platform_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Times_To_Actioned_By_Platform_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Times_To_Actioned_By_Platform_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Times_To_Actioned_By_Platform_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootAlerts_Times_To_Actioned_Graph_MetricsArgs = {
  args: Alerts_Times_To_Actioned_Graph_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Times_To_Actioned_Graph_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Times_To_Actioned_Graph_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Times_To_Actioned_Graph_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootAlerts_Times_To_Actioned_MetricsArgs = {
  args: Alerts_Times_To_Actioned_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Times_To_Actioned_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Times_To_Actioned_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Times_To_Actioned_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootAlerts_Verified_Top_MetricsArgs = {
  args: Alerts_Verified_Top_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Verified_Top_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Verified_Top_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Verified_Top_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootAlerts_Verified_Total_MetricsArgs = {
  args: Alerts_Verified_Total_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Verified_Total_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Verified_Total_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Verified_Total_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootApi_TokensArgs = {
  distinct_on?: InputMaybe<Array<Api_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Tokens_Order_By>>;
  where?: InputMaybe<Api_Tokens_Bool_Exp>;
};


export type Subscription_RootApi_Tokens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Api_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Tokens_Order_By>>;
  where?: InputMaybe<Api_Tokens_Bool_Exp>;
};


export type Subscription_RootApi_Tokens_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootApi_Tokens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Api_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Api_Tokens_Bool_Exp>;
};


export type Subscription_RootApi_Usage_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Api_Usage_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Usage_Records_Order_By>>;
  where?: InputMaybe<Api_Usage_Records_Bool_Exp>;
};


export type Subscription_RootApi_Usage_Records_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Api_Usage_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Usage_Records_Order_By>>;
  where?: InputMaybe<Api_Usage_Records_Bool_Exp>;
};


export type Subscription_RootApi_Usage_Records_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootApi_Usage_Records_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Api_Usage_Records_Stream_Cursor_Input>>;
  where?: InputMaybe<Api_Usage_Records_Bool_Exp>;
};


export type Subscription_RootApify_Scraping_JobsArgs = {
  distinct_on?: InputMaybe<Array<Apify_Scraping_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Apify_Scraping_Jobs_Order_By>>;
  where?: InputMaybe<Apify_Scraping_Jobs_Bool_Exp>;
};


export type Subscription_RootApify_Scraping_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Apify_Scraping_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Apify_Scraping_Jobs_Order_By>>;
  where?: InputMaybe<Apify_Scraping_Jobs_Bool_Exp>;
};


export type Subscription_RootApify_Scraping_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootApify_Scraping_Jobs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Apify_Scraping_Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Apify_Scraping_Jobs_Bool_Exp>;
};


export type Subscription_RootApprovalsArgs = {
  distinct_on?: InputMaybe<Array<Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approvals_Order_By>>;
  where?: InputMaybe<Approvals_Bool_Exp>;
};


export type Subscription_RootApprovals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Approvals_Order_By>>;
  where?: InputMaybe<Approvals_Bool_Exp>;
};


export type Subscription_RootApprovals_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootApprovals_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Approvals_Stream_Cursor_Input>>;
  where?: InputMaybe<Approvals_Bool_Exp>;
};


export type Subscription_RootAudit_Logged_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Audit_Logged_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Logged_Actions_Order_By>>;
  where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};


export type Subscription_RootAudit_Logged_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Logged_Actions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Audit_Logged_Actions_Order_By>>;
  where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};


export type Subscription_RootAudit_Logged_Actions_By_PkArgs = {
  event_id: Scalars['bigint'];
};


export type Subscription_RootAudit_Logged_Actions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Audit_Logged_Actions_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Logged_Actions_Bool_Exp>;
};


export type Subscription_RootCollection_Report_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};


export type Subscription_RootCollection_Report_Changes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};


export type Subscription_RootCollection_Report_Changes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCollection_Report_Changes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Collection_Report_Changes_Stream_Cursor_Input>>;
  where?: InputMaybe<Collection_Report_Changes_Bool_Exp>;
};


export type Subscription_RootCollection_Report_State_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_State_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_State_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_State_Changes_Bool_Exp>;
};


export type Subscription_RootCollection_Report_State_Changes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collection_Report_State_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Collection_Report_State_Changes_Order_By>>;
  where?: InputMaybe<Collection_Report_State_Changes_Bool_Exp>;
};


export type Subscription_RootCollection_Report_State_Changes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCollection_Report_State_Changes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Collection_Report_State_Changes_Stream_Cursor_Input>>;
  where?: InputMaybe<Collection_Report_State_Changes_Bool_Exp>;
};


export type Subscription_RootCredit_CardsArgs = {
  distinct_on?: InputMaybe<Array<Credit_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Cards_Order_By>>;
  where?: InputMaybe<Credit_Cards_Bool_Exp>;
};


export type Subscription_RootCredit_Cards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Credit_Cards_Order_By>>;
  where?: InputMaybe<Credit_Cards_Bool_Exp>;
};


export type Subscription_RootCredit_Cards_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCredit_Cards_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Credit_Cards_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Cards_Bool_Exp>;
};


export type Subscription_RootCustomer_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_Order_By>>;
  where?: InputMaybe<Customer_Assets_Bool_Exp>;
};


export type Subscription_RootCustomer_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_Order_By>>;
  where?: InputMaybe<Customer_Assets_Bool_Exp>;
};


export type Subscription_RootCustomer_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCustomer_Assets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customer_Assets_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Assets_Bool_Exp>;
};


export type Subscription_RootCustomer_Assets_To_BrandsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_To_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_To_Brands_Order_By>>;
  where?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
};


export type Subscription_RootCustomer_Assets_To_Brands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Assets_To_Brands_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_To_Brands_Order_By>>;
  where?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
};


export type Subscription_RootCustomer_Assets_To_Brands_By_PkArgs = {
  brand_id: Scalars['uuid'];
  customer_asset_id: Scalars['uuid'];
};


export type Subscription_RootCustomer_Assets_To_Brands_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customer_Assets_To_Brands_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Assets_To_Brands_Bool_Exp>;
};


export type Subscription_RootDark_WebArgs = {
  distinct_on?: InputMaybe<Array<Dark_Web_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Web_Order_By>>;
  where?: InputMaybe<Dark_Web_Bool_Exp>;
};


export type Subscription_RootDark_Web_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dark_Web_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Web_Order_By>>;
  where?: InputMaybe<Dark_Web_Bool_Exp>;
};


export type Subscription_RootDark_Web_Alerts_Surfaced_Top_MetricsArgs = {
  args: Dark_Web_Alerts_Surfaced_Top_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Dark_Web_Alerts_Surfaced_Top_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dark_Web_Alerts_Surfaced_Top_Metrics_Order_By>>;
  where?: InputMaybe<Dark_Web_Alerts_Surfaced_Top_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootDark_Web_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDark_Web_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dark_Web_Stream_Cursor_Input>>;
  where?: InputMaybe<Dark_Web_Bool_Exp>;
};


export type Subscription_RootDefensive_Domain_RegistrationArgs = {
  distinct_on?: InputMaybe<Array<Defensive_Domain_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Defensive_Domain_Registration_Order_By>>;
  where?: InputMaybe<Defensive_Domain_Registration_Bool_Exp>;
};


export type Subscription_RootDefensive_Domain_Registration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Defensive_Domain_Registration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Defensive_Domain_Registration_Order_By>>;
  where?: InputMaybe<Defensive_Domain_Registration_Bool_Exp>;
};


export type Subscription_RootDefensive_Domain_Registration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDefensive_Domain_Registration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Defensive_Domain_Registration_Stream_Cursor_Input>>;
  where?: InputMaybe<Defensive_Domain_Registration_Bool_Exp>;
};


export type Subscription_RootDesignated_Takedown_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Designated_Takedown_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Designated_Takedown_Assets_Order_By>>;
  where?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
};


export type Subscription_RootDesignated_Takedown_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Designated_Takedown_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Designated_Takedown_Assets_Order_By>>;
  where?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
};


export type Subscription_RootDesignated_Takedown_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDesignated_Takedown_Assets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Designated_Takedown_Assets_Stream_Cursor_Input>>;
  where?: InputMaybe<Designated_Takedown_Assets_Bool_Exp>;
};


export type Subscription_RootDetection_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Detection_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_Assets_Order_By>>;
  where?: InputMaybe<Detection_Assets_Bool_Exp>;
};


export type Subscription_RootDetection_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Detection_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_Assets_Order_By>>;
  where?: InputMaybe<Detection_Assets_Bool_Exp>;
};


export type Subscription_RootDetection_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDetection_Assets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Detection_Assets_Stream_Cursor_Input>>;
  where?: InputMaybe<Detection_Assets_Bool_Exp>;
};


export type Subscription_RootDetection_Config_ApprovalsArgs = {
  distinct_on?: InputMaybe<Array<Detection_Config_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_Config_Approvals_Order_By>>;
  where?: InputMaybe<Detection_Config_Approvals_Bool_Exp>;
};


export type Subscription_RootDetection_Config_Approvals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Detection_Config_Approvals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_Config_Approvals_Order_By>>;
  where?: InputMaybe<Detection_Config_Approvals_Bool_Exp>;
};


export type Subscription_RootDetection_Config_Approvals_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDetection_Config_Approvals_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Detection_Config_Approvals_Stream_Cursor_Input>>;
  where?: InputMaybe<Detection_Config_Approvals_Bool_Exp>;
};


export type Subscription_RootDomain_DataArgs = {
  distinct_on?: InputMaybe<Array<Domain_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Domain_Data_Order_By>>;
  where?: InputMaybe<Domain_Data_Bool_Exp>;
};


export type Subscription_RootDomain_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Domain_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Domain_Data_Order_By>>;
  where?: InputMaybe<Domain_Data_Bool_Exp>;
};


export type Subscription_RootDomain_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDomain_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Domain_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Domain_Data_Bool_Exp>;
};


export type Subscription_RootDomain_Match_DataArgs = {
  distinct_on?: InputMaybe<Array<Domain_Match_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Domain_Match_Data_Order_By>>;
  where?: InputMaybe<Domain_Match_Data_Bool_Exp>;
};


export type Subscription_RootDomain_Match_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Domain_Match_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Domain_Match_Data_Order_By>>;
  where?: InputMaybe<Domain_Match_Data_Bool_Exp>;
};


export type Subscription_RootDomain_Match_Data_By_PkArgs = {
  flagged_url: Scalars['String'];
  spoofing_entities_id: Scalars['uuid'];
};


export type Subscription_RootDomain_Match_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Domain_Match_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Domain_Match_Data_Bool_Exp>;
};


export type Subscription_RootEcommerce_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ecommerce_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecommerce_Listings_Order_By>>;
  where?: InputMaybe<Ecommerce_Listings_Bool_Exp>;
};


export type Subscription_RootEcommerce_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ecommerce_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ecommerce_Listings_Order_By>>;
  where?: InputMaybe<Ecommerce_Listings_Bool_Exp>;
};


export type Subscription_RootEcommerce_Listings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEcommerce_Listings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ecommerce_Listings_Stream_Cursor_Input>>;
  where?: InputMaybe<Ecommerce_Listings_Bool_Exp>;
};


export type Subscription_RootEmail_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Email_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Addresses_Order_By>>;
  where?: InputMaybe<Email_Addresses_Bool_Exp>;
};


export type Subscription_RootEmail_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Addresses_Order_By>>;
  where?: InputMaybe<Email_Addresses_Bool_Exp>;
};


export type Subscription_RootEmail_Addresses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmail_Addresses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Addresses_Bool_Exp>;
};


export type Subscription_RootEmail_Alerts_Resolved_Top_MetricsArgs = {
  args: Email_Alerts_Resolved_Top_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Resolved_Top_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Resolved_Top_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Resolved_Top_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootEmail_Alerts_Resolved_Total_MetricsArgs = {
  args: Email_Alerts_Resolved_Total_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Resolved_Total_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Resolved_Total_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Resolved_Total_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootEmail_Alerts_Times_To_Actioned_Graph_MetricsArgs = {
  args: Email_Alerts_Times_To_Actioned_Graph_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Times_To_Actioned_Graph_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Times_To_Actioned_Graph_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Times_To_Actioned_Graph_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootEmail_Alerts_Times_To_Actioned_MetricsArgs = {
  args: Email_Alerts_Times_To_Actioned_Metrics_Arguments;
  distinct_on?: InputMaybe<Array<Alerts_Times_To_Actioned_Metrics_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Alerts_Times_To_Actioned_Metrics_Order_By>>;
  where?: InputMaybe<Alerts_Times_To_Actioned_Metrics_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootEmail_CorrespondenceArgs = {
  distinct_on?: InputMaybe<Array<Email_Correspondence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Correspondence_Order_By>>;
  where?: InputMaybe<Email_Correspondence_Bool_Exp>;
};


export type Subscription_RootEmail_Correspondence_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Correspondence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Correspondence_Order_By>>;
  where?: InputMaybe<Email_Correspondence_Bool_Exp>;
};


export type Subscription_RootEmail_Correspondence_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmail_Correspondence_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Correspondence_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Correspondence_Bool_Exp>;
};


export type Subscription_RootEmail_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Email_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Settings_Order_By>>;
  where?: InputMaybe<Email_Settings_Bool_Exp>;
};


export type Subscription_RootEmail_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Settings_Order_By>>;
  where?: InputMaybe<Email_Settings_Bool_Exp>;
};


export type Subscription_RootEmail_Settings_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmail_Settings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Settings_Bool_Exp>;
};


export type Subscription_RootEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Subscription_RootEmails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Subscription_RootEmails_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmails_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Emails_Stream_Cursor_Input>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Subscription_RootEnforcement_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Emails_Order_By>>;
  where?: InputMaybe<Enforcement_Emails_Bool_Exp>;
};


export type Subscription_RootEnforcement_Emails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Emails_Order_By>>;
  where?: InputMaybe<Enforcement_Emails_Bool_Exp>;
};


export type Subscription_RootEnforcement_Emails_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEnforcement_Emails_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Enforcement_Emails_Stream_Cursor_Input>>;
  where?: InputMaybe<Enforcement_Emails_Bool_Exp>;
};


export type Subscription_RootEnforcement_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Metadata_Order_By>>;
  where?: InputMaybe<Enforcement_Metadata_Bool_Exp>;
};


export type Subscription_RootEnforcement_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Metadata_Order_By>>;
  where?: InputMaybe<Enforcement_Metadata_Bool_Exp>;
};


export type Subscription_RootEnforcement_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEnforcement_Metadata_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Enforcement_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Enforcement_Metadata_Bool_Exp>;
};


export type Subscription_RootEnforcement_PlatformsArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Platforms_Order_By>>;
  where?: InputMaybe<Enforcement_Platforms_Bool_Exp>;
};


export type Subscription_RootEnforcement_Platforms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Platforms_Order_By>>;
  where?: InputMaybe<Enforcement_Platforms_Bool_Exp>;
};


export type Subscription_RootEnforcement_Platforms_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEnforcement_Platforms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Enforcement_Platforms_Stream_Cursor_Input>>;
  where?: InputMaybe<Enforcement_Platforms_Bool_Exp>;
};


export type Subscription_RootEnforcement_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Requests_Order_By>>;
  where?: InputMaybe<Enforcement_Requests_Bool_Exp>;
};


export type Subscription_RootEnforcement_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Requests_Order_By>>;
  where?: InputMaybe<Enforcement_Requests_Bool_Exp>;
};


export type Subscription_RootEnforcement_Requests_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEnforcement_Requests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Enforcement_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Enforcement_Requests_Bool_Exp>;
};


export type Subscription_RootEnforcement_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Templates_Order_By>>;
  where?: InputMaybe<Enforcement_Templates_Bool_Exp>;
};


export type Subscription_RootEnforcement_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Templates_Order_By>>;
  where?: InputMaybe<Enforcement_Templates_Bool_Exp>;
};


export type Subscription_RootEnforcement_Templates_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEnforcement_Templates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Enforcement_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Enforcement_Templates_Bool_Exp>;
};


export type Subscription_RootEnforcement_TypesArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Types_Order_By>>;
  where?: InputMaybe<Enforcement_Types_Bool_Exp>;
};


export type Subscription_RootEnforcement_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enforcement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enforcement_Types_Order_By>>;
  where?: InputMaybe<Enforcement_Types_Bool_Exp>;
};


export type Subscription_RootEnforcement_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEnforcement_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Enforcement_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Enforcement_Types_Bool_Exp>;
};


export type Subscription_RootEntity_AggregatesArgs = {
  distinct_on?: InputMaybe<Array<Entity_Aggregates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Aggregates_Order_By>>;
  where?: InputMaybe<Entity_Aggregates_Bool_Exp>;
};


export type Subscription_RootEntity_Aggregates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Aggregates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Aggregates_Order_By>>;
  where?: InputMaybe<Entity_Aggregates_Bool_Exp>;
};


export type Subscription_RootEntity_Aggregates_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEntity_Aggregates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Entity_Aggregates_Stream_Cursor_Input>>;
  where?: InputMaybe<Entity_Aggregates_Bool_Exp>;
};


export type Subscription_RootEntity_DataArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


export type Subscription_RootEntity_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Data_Order_By>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


export type Subscription_RootEntity_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEntity_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Entity_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Entity_Data_Bool_Exp>;
};


export type Subscription_RootEntity_LinksArgs = {
  distinct_on?: InputMaybe<Array<Entity_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Links_Order_By>>;
  where?: InputMaybe<Entity_Links_Bool_Exp>;
};


export type Subscription_RootEntity_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Links_Order_By>>;
  where?: InputMaybe<Entity_Links_Bool_Exp>;
};


export type Subscription_RootEntity_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEntity_Links_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Entity_Links_Stream_Cursor_Input>>;
  where?: InputMaybe<Entity_Links_Bool_Exp>;
};


export type Subscription_RootEntity_State_ClassificationsArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Classifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Classifications_Order_By>>;
  where?: InputMaybe<Entity_State_Classifications_Bool_Exp>;
};


export type Subscription_RootEntity_State_Classifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_State_Classifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_State_Classifications_Order_By>>;
  where?: InputMaybe<Entity_State_Classifications_Bool_Exp>;
};


export type Subscription_RootEntity_State_Classifications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEntity_State_Classifications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Entity_State_Classifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Entity_State_Classifications_Bool_Exp>;
};


export type Subscription_RootFull_UrlsArgs = {
  distinct_on?: InputMaybe<Array<Full_Urls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Urls_Order_By>>;
  where?: InputMaybe<Full_Urls_Bool_Exp>;
};


export type Subscription_RootFull_Urls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Full_Urls_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Full_Urls_Order_By>>;
  where?: InputMaybe<Full_Urls_Bool_Exp>;
};


export type Subscription_RootFull_Urls_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFull_Urls_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Full_Urls_Stream_Cursor_Input>>;
  where?: InputMaybe<Full_Urls_Bool_Exp>;
};


export type Subscription_RootGet_Pii_Reports_With_ScreenshotsArgs = {
  args: Get_Pii_Reports_With_Screenshots_Args;
  distinct_on?: InputMaybe<Array<Pii_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Reports_Order_By>>;
  where?: InputMaybe<Pii_Reports_Bool_Exp>;
};


export type Subscription_RootGet_Pii_Reports_With_Screenshots_AggregateArgs = {
  args: Get_Pii_Reports_With_Screenshots_Args;
  distinct_on?: InputMaybe<Array<Pii_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Reports_Order_By>>;
  where?: InputMaybe<Pii_Reports_Bool_Exp>;
};


export type Subscription_RootHandle_Synchronous_Detection_Request_Async_ActionArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootHourly_Spoofing_Reports_StatsArgs = {
  distinct_on?: InputMaybe<Array<Hourly_Spoofing_Reports_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hourly_Spoofing_Reports_Stats_Order_By>>;
  where?: InputMaybe<Hourly_Spoofing_Reports_Stats_Bool_Exp>;
};


export type Subscription_RootHourly_Spoofing_Reports_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hourly_Spoofing_Reports_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hourly_Spoofing_Reports_Stats_Order_By>>;
  where?: InputMaybe<Hourly_Spoofing_Reports_Stats_Bool_Exp>;
};


export type Subscription_RootHourly_Spoofing_Reports_Stats_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootHourly_Spoofing_Reports_Stats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hourly_Spoofing_Reports_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Hourly_Spoofing_Reports_Stats_Bool_Exp>;
};


export type Subscription_RootIoc_Alert_AttributionArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Alert_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Alert_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Alert_Attribution_Bool_Exp>;
};


export type Subscription_RootIoc_Alert_Attribution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Alert_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Alert_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Alert_Attribution_Bool_Exp>;
};


export type Subscription_RootIoc_Alert_Attribution_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootIoc_Alert_Attribution_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ioc_Alert_Attribution_Stream_Cursor_Input>>;
  where?: InputMaybe<Ioc_Alert_Attribution_Bool_Exp>;
};


export type Subscription_RootIoc_Detection_Config_AttributionArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
};


export type Subscription_RootIoc_Detection_Config_Attribution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Detection_Config_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
};


export type Subscription_RootIoc_Detection_Config_Attribution_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootIoc_Detection_Config_Attribution_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ioc_Detection_Config_Attribution_Stream_Cursor_Input>>;
  where?: InputMaybe<Ioc_Detection_Config_Attribution_Bool_Exp>;
};


export type Subscription_RootIoc_Entity_Data_AttributionArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Entity_Data_Attribution_Bool_Exp>;
};


export type Subscription_RootIoc_Entity_Data_Attribution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ioc_Entity_Data_Attribution_Order_By>>;
  where?: InputMaybe<Ioc_Entity_Data_Attribution_Bool_Exp>;
};


export type Subscription_RootIoc_Entity_Data_Attribution_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootIoc_Entity_Data_Attribution_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ioc_Entity_Data_Attribution_Stream_Cursor_Input>>;
  where?: InputMaybe<Ioc_Entity_Data_Attribution_Bool_Exp>;
};


export type Subscription_RootIocsArgs = {
  distinct_on?: InputMaybe<Array<Iocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Iocs_Order_By>>;
  where?: InputMaybe<Iocs_Bool_Exp>;
};


export type Subscription_RootIocs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Iocs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Iocs_Order_By>>;
  where?: InputMaybe<Iocs_Bool_Exp>;
};


export type Subscription_RootIocs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootIocs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Iocs_Stream_Cursor_Input>>;
  where?: InputMaybe<Iocs_Bool_Exp>;
};


export type Subscription_RootJira_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Jira_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jira_Metadata_Order_By>>;
  where?: InputMaybe<Jira_Metadata_Bool_Exp>;
};


export type Subscription_RootJira_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jira_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jira_Metadata_Order_By>>;
  where?: InputMaybe<Jira_Metadata_Bool_Exp>;
};


export type Subscription_RootJira_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootJira_Metadata_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Jira_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Jira_Metadata_Bool_Exp>;
};


export type Subscription_RootMatch_AttributionsArgs = {
  distinct_on?: InputMaybe<Array<Match_Attributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Attributions_Order_By>>;
  where?: InputMaybe<Match_Attributions_Bool_Exp>;
};


export type Subscription_RootMatch_Attributions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Match_Attributions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Match_Attributions_Order_By>>;
  where?: InputMaybe<Match_Attributions_Bool_Exp>;
};


export type Subscription_RootMatch_Attributions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMatch_Attributions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Match_Attributions_Stream_Cursor_Input>>;
  where?: InputMaybe<Match_Attributions_Bool_Exp>;
};


export type Subscription_RootMl_FeaturesArgs = {
  distinct_on?: InputMaybe<Array<Ml_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ml_Features_Order_By>>;
  where?: InputMaybe<Ml_Features_Bool_Exp>;
};


export type Subscription_RootMl_Features_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ml_Features_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ml_Features_Order_By>>;
  where?: InputMaybe<Ml_Features_Bool_Exp>;
};


export type Subscription_RootMl_Features_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMl_Features_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ml_Features_Stream_Cursor_Input>>;
  where?: InputMaybe<Ml_Features_Bool_Exp>;
};


export type Subscription_RootMobile_AppsArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Apps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mobile_Apps_Order_By>>;
  where?: InputMaybe<Mobile_Apps_Bool_Exp>;
};


export type Subscription_RootMobile_Apps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mobile_Apps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mobile_Apps_Order_By>>;
  where?: InputMaybe<Mobile_Apps_Bool_Exp>;
};


export type Subscription_RootMobile_Apps_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMobile_Apps_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mobile_Apps_Stream_Cursor_Input>>;
  where?: InputMaybe<Mobile_Apps_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_Surfaced_By_DayArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Day_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Surfaced_By_Day_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_Surfaced_By_Day_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Day_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Day_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Surfaced_By_Day_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_Surfaced_By_Day_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mv_Alerts_Surfaced_By_Day_Stream_Cursor_Input>>;
  where?: InputMaybe<Mv_Alerts_Surfaced_By_Day_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_Surfaced_By_HourArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Hour_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Surfaced_By_Hour_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_Surfaced_By_Hour_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Surfaced_By_Hour_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Surfaced_By_Hour_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_Surfaced_By_Hour_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mv_Alerts_Surfaced_By_Hour_Stream_Cursor_Input>>;
  where?: InputMaybe<Mv_Alerts_Surfaced_By_Hour_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_Times_To_ActionedArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Times_To_Actioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Times_To_Actioned_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Times_To_Actioned_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_Times_To_Actioned_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Times_To_Actioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Times_To_Actioned_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Times_To_Actioned_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_Times_To_Actioned_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mv_Alerts_Times_To_Actioned_Stream_Cursor_Input>>;
  where?: InputMaybe<Mv_Alerts_Times_To_Actioned_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_VerifiedArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Verified_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Verified_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Verified_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_Verified_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Alerts_Verified_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Alerts_Verified_Order_By>>;
  where?: InputMaybe<Mv_Alerts_Verified_Bool_Exp>;
};


export type Subscription_RootMv_Alerts_Verified_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mv_Alerts_Verified_Stream_Cursor_Input>>;
  where?: InputMaybe<Mv_Alerts_Verified_Bool_Exp>;
};


export type Subscription_RootMv_Dark_Web_Alerts_SurfacedArgs = {
  distinct_on?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_Order_By>>;
  where?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_Bool_Exp>;
};


export type Subscription_RootMv_Dark_Web_Alerts_Surfaced_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_Order_By>>;
  where?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_Bool_Exp>;
};


export type Subscription_RootMv_Dark_Web_Alerts_Surfaced_By_HourArgs = {
  distinct_on?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Order_By>>;
  where?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Bool_Exp>;
};


export type Subscription_RootMv_Dark_Web_Alerts_Surfaced_By_Hour_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Order_By>>;
  where?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Bool_Exp>;
};


export type Subscription_RootMv_Dark_Web_Alerts_Surfaced_By_Hour_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Stream_Cursor_Input>>;
  where?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_By_Hour_Bool_Exp>;
};


export type Subscription_RootMv_Dark_Web_Alerts_Surfaced_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mv_Dark_Web_Alerts_Surfaced_Stream_Cursor_Input>>;
  where?: InputMaybe<Mv_Dark_Web_Alerts_Surfaced_Bool_Exp>;
};


export type Subscription_RootMv_Email_Alerts_Times_To_ActionedArgs = {
  distinct_on?: InputMaybe<Array<Mv_Email_Alerts_Times_To_Actioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Email_Alerts_Times_To_Actioned_Order_By>>;
  where?: InputMaybe<Mv_Email_Alerts_Times_To_Actioned_Bool_Exp>;
};


export type Subscription_RootMv_Email_Alerts_Times_To_Actioned_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mv_Email_Alerts_Times_To_Actioned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Mv_Email_Alerts_Times_To_Actioned_Order_By>>;
  where?: InputMaybe<Mv_Email_Alerts_Times_To_Actioned_Bool_Exp>;
};


export type Subscription_RootMv_Email_Alerts_Times_To_Actioned_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Mv_Email_Alerts_Times_To_Actioned_Stream_Cursor_Input>>;
  where?: InputMaybe<Mv_Email_Alerts_Times_To_Actioned_Bool_Exp>;
};


export type Subscription_RootNft_Opensea_ProcessedArgs = {
  distinct_on?: InputMaybe<Array<Nft_Opensea_Processed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nft_Opensea_Processed_Order_By>>;
  where?: InputMaybe<Nft_Opensea_Processed_Bool_Exp>;
};


export type Subscription_RootNft_Opensea_Processed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nft_Opensea_Processed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nft_Opensea_Processed_Order_By>>;
  where?: InputMaybe<Nft_Opensea_Processed_Bool_Exp>;
};


export type Subscription_RootNft_Opensea_Processed_By_PkArgs = {
  direction: Scalars['String'];
};


export type Subscription_RootNft_Opensea_Processed_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nft_Opensea_Processed_Stream_Cursor_Input>>;
  where?: InputMaybe<Nft_Opensea_Processed_Bool_Exp>;
};


export type Subscription_RootNft_Processing_CursorArgs = {
  distinct_on?: InputMaybe<Array<Nft_Processing_Cursor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nft_Processing_Cursor_Order_By>>;
  where?: InputMaybe<Nft_Processing_Cursor_Bool_Exp>;
};


export type Subscription_RootNft_Processing_Cursor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nft_Processing_Cursor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nft_Processing_Cursor_Order_By>>;
  where?: InputMaybe<Nft_Processing_Cursor_Bool_Exp>;
};


export type Subscription_RootNft_Processing_Cursor_By_PkArgs = {
  direction: Scalars['String'];
  marketplace: Scalars['String'];
};


export type Subscription_RootNft_Processing_Cursor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nft_Processing_Cursor_Stream_Cursor_Input>>;
  where?: InputMaybe<Nft_Processing_Cursor_Bool_Exp>;
};


export type Subscription_RootNotification_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Subscriptions_Order_By>>;
  where?: InputMaybe<Notification_Subscriptions_Bool_Exp>;
};


export type Subscription_RootNotification_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Subscriptions_Order_By>>;
  where?: InputMaybe<Notification_Subscriptions_Bool_Exp>;
};


export type Subscription_RootNotification_Subscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNotification_Subscriptions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Subscriptions_Bool_Exp>;
};


export type Subscription_RootOrganization_Id_Api_KeysArgs = {
  distinct_on?: InputMaybe<Array<Organization_Id_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Id_Api_Keys_Order_By>>;
  where?: InputMaybe<Organization_Id_Api_Keys_Bool_Exp>;
};


export type Subscription_RootOrganization_Id_Api_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Id_Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Id_Api_Keys_Order_By>>;
  where?: InputMaybe<Organization_Id_Api_Keys_Bool_Exp>;
};


export type Subscription_RootOrganization_Id_Api_Keys_By_PkArgs = {
  api_key: Scalars['String'];
};


export type Subscription_RootOrganization_Id_Api_Keys_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Id_Api_Keys_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Id_Api_Keys_Bool_Exp>;
};


export type Subscription_RootOrganization_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Products_Order_By>>;
  where?: InputMaybe<Organization_Products_Bool_Exp>;
};


export type Subscription_RootOrganization_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Products_Order_By>>;
  where?: InputMaybe<Organization_Products_Bool_Exp>;
};


export type Subscription_RootOrganization_Products_By_PkArgs = {
  organization_id: Scalars['uuid'];
  product: Scalars['String'];
};


export type Subscription_RootOrganization_Products_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Products_Bool_Exp>;
};


export type Subscription_RootOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Order_By>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootOrganizations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganizations_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Metadata_Order_By>>;
  where?: InputMaybe<Organizations_Metadata_Bool_Exp>;
};


export type Subscription_RootOrganizations_Metadata_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Metadata_Order_By>>;
  where?: InputMaybe<Organizations_Metadata_Bool_Exp>;
};


export type Subscription_RootOrganizations_Metadata_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganizations_Metadata_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organizations_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Organizations_Metadata_Bool_Exp>;
};


export type Subscription_RootOrganizations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organizations_Stream_Cursor_Input>>;
  where?: InputMaybe<Organizations_Bool_Exp>;
};


export type Subscription_RootPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPermissions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPermissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootPhone_Numbers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPhone_Numbers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Phone_Numbers_Stream_Cursor_Input>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootPii_DatabrokersArgs = {
  distinct_on?: InputMaybe<Array<Pii_Databrokers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Databrokers_Order_By>>;
  where?: InputMaybe<Pii_Databrokers_Bool_Exp>;
};


export type Subscription_RootPii_Databrokers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pii_Databrokers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Databrokers_Order_By>>;
  where?: InputMaybe<Pii_Databrokers_Bool_Exp>;
};


export type Subscription_RootPii_Databrokers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPii_Databrokers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pii_Databrokers_Stream_Cursor_Input>>;
  where?: InputMaybe<Pii_Databrokers_Bool_Exp>;
};


export type Subscription_RootPii_EventsArgs = {
  distinct_on?: InputMaybe<Array<Pii_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Events_Order_By>>;
  where?: InputMaybe<Pii_Events_Bool_Exp>;
};


export type Subscription_RootPii_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pii_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Events_Order_By>>;
  where?: InputMaybe<Pii_Events_Bool_Exp>;
};


export type Subscription_RootPii_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPii_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pii_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Pii_Events_Bool_Exp>;
};


export type Subscription_RootPii_Leaks_By_DatabrokerArgs = {
  distinct_on?: InputMaybe<Array<Pii_Leaks_By_Databroker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Leaks_By_Databroker_Order_By>>;
  where?: InputMaybe<Pii_Leaks_By_Databroker_Bool_Exp>;
};


export type Subscription_RootPii_Leaks_By_Databroker_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pii_Leaks_By_Databroker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Leaks_By_Databroker_Order_By>>;
  where?: InputMaybe<Pii_Leaks_By_Databroker_Bool_Exp>;
};


export type Subscription_RootPii_Leaks_By_Databroker_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pii_Leaks_By_Databroker_Stream_Cursor_Input>>;
  where?: InputMaybe<Pii_Leaks_By_Databroker_Bool_Exp>;
};


export type Subscription_RootPii_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Pii_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Reports_Order_By>>;
  where?: InputMaybe<Pii_Reports_Bool_Exp>;
};


export type Subscription_RootPii_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pii_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Reports_Order_By>>;
  where?: InputMaybe<Pii_Reports_Bool_Exp>;
};


export type Subscription_RootPii_Reports_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPii_Reports_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pii_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Pii_Reports_Bool_Exp>;
};


export type Subscription_RootPii_StatisticsArgs = {
  distinct_on?: InputMaybe<Array<Pii_Statistics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Statistics_Order_By>>;
  where?: InputMaybe<Pii_Statistics_Bool_Exp>;
};


export type Subscription_RootPii_Statistics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pii_Statistics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pii_Statistics_Order_By>>;
  where?: InputMaybe<Pii_Statistics_Bool_Exp>;
};


export type Subscription_RootPii_Statistics_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPii_Statistics_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pii_Statistics_Stream_Cursor_Input>>;
  where?: InputMaybe<Pii_Statistics_Bool_Exp>;
};


export type Subscription_RootPlatform_SubtypesArgs = {
  distinct_on?: InputMaybe<Array<Platform_Subtypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Subtypes_Order_By>>;
  where?: InputMaybe<Platform_Subtypes_Bool_Exp>;
};


export type Subscription_RootPlatform_Subtypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Subtypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Subtypes_Order_By>>;
  where?: InputMaybe<Platform_Subtypes_Bool_Exp>;
};


export type Subscription_RootPlatform_Subtypes_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlatform_Subtypes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Platform_Subtypes_Stream_Cursor_Input>>;
  where?: InputMaybe<Platform_Subtypes_Bool_Exp>;
};


export type Subscription_RootPlatformsArgs = {
  distinct_on?: InputMaybe<Array<Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platforms_Order_By>>;
  where?: InputMaybe<Platforms_Bool_Exp>;
};


export type Subscription_RootPlatforms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platforms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platforms_Order_By>>;
  where?: InputMaybe<Platforms_Bool_Exp>;
};


export type Subscription_RootPlatforms_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPlatforms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Platforms_Stream_Cursor_Input>>;
  where?: InputMaybe<Platforms_Bool_Exp>;
};


export type Subscription_RootPre_CollectionsArgs = {
  distinct_on?: InputMaybe<Array<Pre_Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Collections_Order_By>>;
  where?: InputMaybe<Pre_Collections_Bool_Exp>;
};


export type Subscription_RootPre_Collections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pre_Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Collections_Order_By>>;
  where?: InputMaybe<Pre_Collections_Bool_Exp>;
};


export type Subscription_RootPre_Collections_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPre_Collections_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pre_Collections_Stream_Cursor_Input>>;
  where?: InputMaybe<Pre_Collections_Bool_Exp>;
};


export type Subscription_RootPredicted_Enforcement_TypesArgs = {
  distinct_on?: InputMaybe<Array<Predicted_Enforcement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Predicted_Enforcement_Types_Order_By>>;
  where?: InputMaybe<Predicted_Enforcement_Types_Bool_Exp>;
};


export type Subscription_RootPredicted_Enforcement_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Predicted_Enforcement_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Predicted_Enforcement_Types_Order_By>>;
  where?: InputMaybe<Predicted_Enforcement_Types_Bool_Exp>;
};


export type Subscription_RootPredicted_Enforcement_Types_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPredicted_Enforcement_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Predicted_Enforcement_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Predicted_Enforcement_Types_Bool_Exp>;
};


export type Subscription_RootProtected_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Protected_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Protected_Assets_Order_By>>;
  where?: InputMaybe<Protected_Assets_Bool_Exp>;
};


export type Subscription_RootProtected_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Protected_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Protected_Assets_Order_By>>;
  where?: InputMaybe<Protected_Assets_Bool_Exp>;
};


export type Subscription_RootProtected_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProtected_Assets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Protected_Assets_Stream_Cursor_Input>>;
  where?: InputMaybe<Protected_Assets_Bool_Exp>;
};


export type Subscription_RootReport_TagsArgs = {
  distinct_on?: InputMaybe<Array<Report_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Tags_Order_By>>;
  where?: InputMaybe<Report_Tags_Bool_Exp>;
};


export type Subscription_RootReport_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Tags_Order_By>>;
  where?: InputMaybe<Report_Tags_Bool_Exp>;
};


export type Subscription_RootReport_Tags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootReport_Tags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Report_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Report_Tags_Bool_Exp>;
};


export type Subscription_RootReports_To_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_To_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_To_Reports_Order_By>>;
  where?: InputMaybe<Reports_To_Reports_Bool_Exp>;
};


export type Subscription_RootReports_To_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_To_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_To_Reports_Order_By>>;
  where?: InputMaybe<Reports_To_Reports_Bool_Exp>;
};


export type Subscription_RootReports_To_Reports_By_PkArgs = {
  dest_report_id: Scalars['uuid'];
  relationship_type: Scalars['String'];
  source_report_id: Scalars['uuid'];
};


export type Subscription_RootReports_To_Reports_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Reports_To_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Reports_To_Reports_Bool_Exp>;
};


export type Subscription_RootRequest_Alert_Csv_ExportArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


export type Subscription_RootRole_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


export type Subscription_RootRole_Permissions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRole_Permissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Role_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


export type Subscription_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRoles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRulesArgs = {
  distinct_on?: InputMaybe<Array<Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rules_Order_By>>;
  where?: InputMaybe<Rules_Bool_Exp>;
};


export type Subscription_RootRules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rules_Order_By>>;
  where?: InputMaybe<Rules_Bool_Exp>;
};


export type Subscription_RootRules_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRules_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Rules_Stream_Cursor_Input>>;
  where?: InputMaybe<Rules_Bool_Exp>;
};


export type Subscription_RootSafelist_Ip_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Safelist_Ip_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Safelist_Ip_Addresses_Order_By>>;
  where?: InputMaybe<Safelist_Ip_Addresses_Bool_Exp>;
};


export type Subscription_RootSafelist_Ip_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Safelist_Ip_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Safelist_Ip_Addresses_Order_By>>;
  where?: InputMaybe<Safelist_Ip_Addresses_Bool_Exp>;
};


export type Subscription_RootSafelist_Ip_Addresses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSafelist_Ip_Addresses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Safelist_Ip_Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<Safelist_Ip_Addresses_Bool_Exp>;
};


export type Subscription_RootSalesforce_Organizations_DataArgs = {
  distinct_on?: InputMaybe<Array<Salesforce_Organizations_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salesforce_Organizations_Data_Order_By>>;
  where?: InputMaybe<Salesforce_Organizations_Data_Bool_Exp>;
};


export type Subscription_RootSalesforce_Organizations_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Salesforce_Organizations_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salesforce_Organizations_Data_Order_By>>;
  where?: InputMaybe<Salesforce_Organizations_Data_Bool_Exp>;
};


export type Subscription_RootSalesforce_Organizations_Data_By_PkArgs = {
  account_id: Scalars['String'];
};


export type Subscription_RootSalesforce_Organizations_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Salesforce_Organizations_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Salesforce_Organizations_Data_Bool_Exp>;
};


export type Subscription_RootScan_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Scan_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scan_Results_Order_By>>;
  where?: InputMaybe<Scan_Results_Bool_Exp>;
};


export type Subscription_RootScan_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scan_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scan_Results_Order_By>>;
  where?: InputMaybe<Scan_Results_Bool_Exp>;
};


export type Subscription_RootScan_Results_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootScan_Results_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Scan_Results_Stream_Cursor_Input>>;
  where?: InputMaybe<Scan_Results_Bool_Exp>;
};


export type Subscription_RootScansArgs = {
  distinct_on?: InputMaybe<Array<Scans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scans_Order_By>>;
  where?: InputMaybe<Scans_Bool_Exp>;
};


export type Subscription_RootScans_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scans_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scans_Order_By>>;
  where?: InputMaybe<Scans_Bool_Exp>;
};


export type Subscription_RootScans_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootScans_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Scans_Stream_Cursor_Input>>;
  where?: InputMaybe<Scans_Bool_Exp>;
};


export type Subscription_RootScraping_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Scraping_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scraping_Configs_Order_By>>;
  where?: InputMaybe<Scraping_Configs_Bool_Exp>;
};


export type Subscription_RootScraping_Configs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scraping_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scraping_Configs_Order_By>>;
  where?: InputMaybe<Scraping_Configs_Bool_Exp>;
};


export type Subscription_RootScraping_Configs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootScraping_Configs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Scraping_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<Scraping_Configs_Bool_Exp>;
};


export type Subscription_RootSearch_Spoofing_ReportsArgs = {
  args: Search_Spoofing_Reports_Args;
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


export type Subscription_RootSearch_Spoofing_Reports_AggregateArgs = {
  args: Search_Spoofing_Reports_Args;
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


export type Subscription_RootSim_Campaign_ObservationsArgs = {
  distinct_on?: InputMaybe<Array<Sim_Campaign_Observations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Campaign_Observations_Order_By>>;
  where?: InputMaybe<Sim_Campaign_Observations_Bool_Exp>;
};


export type Subscription_RootSim_Campaign_Observations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sim_Campaign_Observations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Campaign_Observations_Order_By>>;
  where?: InputMaybe<Sim_Campaign_Observations_Bool_Exp>;
};


export type Subscription_RootSim_Campaign_Observations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSim_Campaign_Observations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sim_Campaign_Observations_Stream_Cursor_Input>>;
  where?: InputMaybe<Sim_Campaign_Observations_Bool_Exp>;
};


export type Subscription_RootSim_CampaignsArgs = {
  distinct_on?: InputMaybe<Array<Sim_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Campaigns_Order_By>>;
  where?: InputMaybe<Sim_Campaigns_Bool_Exp>;
};


export type Subscription_RootSim_Campaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sim_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Campaigns_Order_By>>;
  where?: InputMaybe<Sim_Campaigns_Bool_Exp>;
};


export type Subscription_RootSim_Campaigns_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSim_Campaigns_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sim_Campaigns_Stream_Cursor_Input>>;
  where?: InputMaybe<Sim_Campaigns_Bool_Exp>;
};


export type Subscription_RootSim_EmailsArgs = {
  distinct_on?: InputMaybe<Array<Sim_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Emails_Order_By>>;
  where?: InputMaybe<Sim_Emails_Bool_Exp>;
};


export type Subscription_RootSim_Emails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sim_Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Emails_Order_By>>;
  where?: InputMaybe<Sim_Emails_Bool_Exp>;
};


export type Subscription_RootSim_Emails_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSim_Emails_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sim_Emails_Stream_Cursor_Input>>;
  where?: InputMaybe<Sim_Emails_Bool_Exp>;
};


export type Subscription_RootSim_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Sim_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Groups_Order_By>>;
  where?: InputMaybe<Sim_Groups_Bool_Exp>;
};


export type Subscription_RootSim_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sim_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Groups_Order_By>>;
  where?: InputMaybe<Sim_Groups_Bool_Exp>;
};


export type Subscription_RootSim_Groups_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSim_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sim_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Sim_Groups_Bool_Exp>;
};


export type Subscription_RootSim_UsersArgs = {
  distinct_on?: InputMaybe<Array<Sim_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Users_Order_By>>;
  where?: InputMaybe<Sim_Users_Bool_Exp>;
};


export type Subscription_RootSim_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sim_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sim_Users_Order_By>>;
  where?: InputMaybe<Sim_Users_Bool_Exp>;
};


export type Subscription_RootSim_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSim_Users_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sim_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Sim_Users_Bool_Exp>;
};


export type Subscription_RootSlack_InstallationsArgs = {
  distinct_on?: InputMaybe<Array<Slack_Installations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Slack_Installations_Order_By>>;
  where?: InputMaybe<Slack_Installations_Bool_Exp>;
};


export type Subscription_RootSlack_Installations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Slack_Installations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Slack_Installations_Order_By>>;
  where?: InputMaybe<Slack_Installations_Bool_Exp>;
};


export type Subscription_RootSlack_Installations_By_PkArgs = {
  team_id: Scalars['String'];
};


export type Subscription_RootSlack_Installations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Slack_Installations_Stream_Cursor_Input>>;
  where?: InputMaybe<Slack_Installations_Bool_Exp>;
};


export type Subscription_RootSocial_Media_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Comments_Order_By>>;
  where?: InputMaybe<Social_Media_Comments_Bool_Exp>;
};


export type Subscription_RootSocial_Media_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Comments_Order_By>>;
  where?: InputMaybe<Social_Media_Comments_Bool_Exp>;
};


export type Subscription_RootSocial_Media_Comments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSocial_Media_Comments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Social_Media_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Social_Media_Comments_Bool_Exp>;
};


export type Subscription_RootSocial_Media_DataArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Data_Order_By>>;
  where?: InputMaybe<Social_Media_Data_Bool_Exp>;
};


export type Subscription_RootSocial_Media_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Data_Order_By>>;
  where?: InputMaybe<Social_Media_Data_Bool_Exp>;
};


export type Subscription_RootSocial_Media_Data_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSocial_Media_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Social_Media_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Social_Media_Data_Bool_Exp>;
};


export type Subscription_RootSocial_Media_GroupArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Group_Order_By>>;
  where?: InputMaybe<Social_Media_Group_Bool_Exp>;
};


export type Subscription_RootSocial_Media_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Group_Order_By>>;
  where?: InputMaybe<Social_Media_Group_Bool_Exp>;
};


export type Subscription_RootSocial_Media_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSocial_Media_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Social_Media_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Social_Media_Group_Bool_Exp>;
};


export type Subscription_RootSocial_Media_PostArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Post_Order_By>>;
  where?: InputMaybe<Social_Media_Post_Bool_Exp>;
};


export type Subscription_RootSocial_Media_Post_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Social_Media_Post_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Social_Media_Post_Order_By>>;
  where?: InputMaybe<Social_Media_Post_Bool_Exp>;
};


export type Subscription_RootSocial_Media_Post_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSocial_Media_Post_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Social_Media_Post_Stream_Cursor_Input>>;
  where?: InputMaybe<Social_Media_Post_Bool_Exp>;
};


export type Subscription_RootSourcing_QueriesArgs = {
  distinct_on?: InputMaybe<Array<Sourcing_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sourcing_Queries_Order_By>>;
  where?: InputMaybe<Sourcing_Queries_Bool_Exp>;
};


export type Subscription_RootSourcing_Queries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sourcing_Queries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sourcing_Queries_Order_By>>;
  where?: InputMaybe<Sourcing_Queries_Bool_Exp>;
};


export type Subscription_RootSourcing_Queries_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSourcing_Queries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sourcing_Queries_Stream_Cursor_Input>>;
  where?: InputMaybe<Sourcing_Queries_Bool_Exp>;
};


export type Subscription_RootSourcing_Query_ExecutionsArgs = {
  distinct_on?: InputMaybe<Array<Sourcing_Query_Executions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sourcing_Query_Executions_Order_By>>;
  where?: InputMaybe<Sourcing_Query_Executions_Bool_Exp>;
};


export type Subscription_RootSourcing_Query_Executions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Sourcing_Query_Executions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Sourcing_Query_Executions_Order_By>>;
  where?: InputMaybe<Sourcing_Query_Executions_Bool_Exp>;
};


export type Subscription_RootSourcing_Query_Executions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSourcing_Query_Executions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Sourcing_Query_Executions_Stream_Cursor_Input>>;
  where?: InputMaybe<Sourcing_Query_Executions_Bool_Exp>;
};


export type Subscription_RootSpoof_MatchesArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};


export type Subscription_RootSpoof_Matches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoof_Matches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoof_Matches_Order_By>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};


export type Subscription_RootSpoof_Matches_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSpoof_Matches_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Spoof_Matches_Stream_Cursor_Input>>;
  where?: InputMaybe<Spoof_Matches_Bool_Exp>;
};


export type Subscription_RootSpoofing_EntitiesArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Entities_Order_By>>;
  where?: InputMaybe<Spoofing_Entities_Bool_Exp>;
};


export type Subscription_RootSpoofing_Entities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Entities_Order_By>>;
  where?: InputMaybe<Spoofing_Entities_Bool_Exp>;
};


export type Subscription_RootSpoofing_Entities_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSpoofing_Entities_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Spoofing_Entities_Stream_Cursor_Input>>;
  where?: InputMaybe<Spoofing_Entities_Bool_Exp>;
};


export type Subscription_RootSpoofing_Report_Search_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Report_Search_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Report_Search_Results_Order_By>>;
  where?: InputMaybe<Spoofing_Report_Search_Results_Bool_Exp>;
};


export type Subscription_RootSpoofing_Report_Search_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Report_Search_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Report_Search_Results_Order_By>>;
  where?: InputMaybe<Spoofing_Report_Search_Results_Bool_Exp>;
};


export type Subscription_RootSpoofing_Report_Search_Results_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Spoofing_Report_Search_Results_Stream_Cursor_Input>>;
  where?: InputMaybe<Spoofing_Report_Search_Results_Bool_Exp>;
};


export type Subscription_RootSpoofing_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


export type Subscription_RootSpoofing_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


export type Subscription_RootSpoofing_Reports_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSpoofing_Reports_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Spoofing_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


export type Subscription_RootSpoofing_Reports_To_TagsArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_To_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_To_Tags_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_To_Tags_Bool_Exp>;
};


export type Subscription_RootSpoofing_Reports_To_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_To_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_To_Tags_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_To_Tags_Bool_Exp>;
};


export type Subscription_RootSpoofing_Reports_To_Tags_By_PkArgs = {
  spoofing_report_id: Scalars['uuid'];
  tag_name: Scalars['String'];
};


export type Subscription_RootSpoofing_Reports_To_Tags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Spoofing_Reports_To_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Spoofing_Reports_To_Tags_Bool_Exp>;
};


export type Subscription_RootSuggested_EnforcementsArgs = {
  distinct_on?: InputMaybe<Array<Suggested_Enforcements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggested_Enforcements_Order_By>>;
  where?: InputMaybe<Suggested_Enforcements_Bool_Exp>;
};


export type Subscription_RootSuggested_Enforcements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Suggested_Enforcements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggested_Enforcements_Order_By>>;
  where?: InputMaybe<Suggested_Enforcements_Bool_Exp>;
};


export type Subscription_RootSuggested_Enforcements_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSuggested_Enforcements_Form_ResponsesArgs = {
  distinct_on?: InputMaybe<Array<Suggested_Enforcements_Form_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggested_Enforcements_Form_Responses_Order_By>>;
  where?: InputMaybe<Suggested_Enforcements_Form_Responses_Bool_Exp>;
};


export type Subscription_RootSuggested_Enforcements_Form_Responses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Suggested_Enforcements_Form_Responses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggested_Enforcements_Form_Responses_Order_By>>;
  where?: InputMaybe<Suggested_Enforcements_Form_Responses_Bool_Exp>;
};


export type Subscription_RootSuggested_Enforcements_Form_Responses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSuggested_Enforcements_Form_Responses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Suggested_Enforcements_Form_Responses_Stream_Cursor_Input>>;
  where?: InputMaybe<Suggested_Enforcements_Form_Responses_Bool_Exp>;
};


export type Subscription_RootSuggested_Enforcements_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Suggested_Enforcements_Stream_Cursor_Input>>;
  where?: InputMaybe<Suggested_Enforcements_Bool_Exp>;
};


export type Subscription_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_Actor_To_CampaignArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_Actor_To_Campaign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_Actor_To_Campaign_By_PkArgs = {
  actor_id: Scalars['uuid'];
  campaign_id: Scalars['uuid'];
};


export type Subscription_RootThreat_Intel_Actor_To_Campaign_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Threat_Intel_Actor_To_Campaign_Stream_Cursor_Input>>;
  where?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_ActorsArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actors_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actors_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_Actors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actors_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actors_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_Actors_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootThreat_Intel_Actors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Threat_Intel_Actors_Stream_Cursor_Input>>;
  where?: InputMaybe<Threat_Intel_Actors_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_Campaign_To_EntitiesArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Order_By>>;
  where?: InputMaybe<Threat_Intel_Campaign_To_Entities_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_Campaign_To_Entities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Order_By>>;
  where?: InputMaybe<Threat_Intel_Campaign_To_Entities_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_Campaign_To_Entities_By_PkArgs = {
  campaign_id: Scalars['uuid'];
  entity_data_id: Scalars['uuid'];
};


export type Subscription_RootThreat_Intel_Campaign_To_Entities_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Threat_Intel_Campaign_To_Entities_Stream_Cursor_Input>>;
  where?: InputMaybe<Threat_Intel_Campaign_To_Entities_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_CampaignsArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Campaigns_Order_By>>;
  where?: InputMaybe<Threat_Intel_Campaigns_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_Campaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Campaigns_Order_By>>;
  where?: InputMaybe<Threat_Intel_Campaigns_Bool_Exp>;
};


export type Subscription_RootThreat_Intel_Campaigns_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootThreat_Intel_Campaigns_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Threat_Intel_Campaigns_Stream_Cursor_Input>>;
  where?: InputMaybe<Threat_Intel_Campaigns_Bool_Exp>;
};


export type Subscription_RootTrademarksArgs = {
  distinct_on?: InputMaybe<Array<Trademarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trademarks_Order_By>>;
  where?: InputMaybe<Trademarks_Bool_Exp>;
};


export type Subscription_RootTrademarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademarks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trademarks_Order_By>>;
  where?: InputMaybe<Trademarks_Bool_Exp>;
};


export type Subscription_RootTrademarks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTrademarks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trademarks_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademarks_Bool_Exp>;
};


export type Subscription_RootUploaded_FilesArgs = {
  distinct_on?: InputMaybe<Array<Uploaded_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uploaded_Files_Order_By>>;
  where?: InputMaybe<Uploaded_Files_Bool_Exp>;
};


export type Subscription_RootUploaded_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uploaded_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uploaded_Files_Order_By>>;
  where?: InputMaybe<Uploaded_Files_Bool_Exp>;
};


export type Subscription_RootUploaded_Files_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUploaded_Files_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Uploaded_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Uploaded_Files_Bool_Exp>;
};


export type Subscription_RootUser_FeedbackArgs = {
  distinct_on?: InputMaybe<Array<User_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Feedback_Order_By>>;
  where?: InputMaybe<User_Feedback_Bool_Exp>;
};


export type Subscription_RootUser_Feedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Feedback_Order_By>>;
  where?: InputMaybe<User_Feedback_Bool_Exp>;
};


export type Subscription_RootUser_Feedback_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Feedback_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Feedback_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Feedback_Bool_Exp>;
};


export type Subscription_RootUser_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<User_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Organizations_Order_By>>;
  where?: InputMaybe<User_Organizations_Bool_Exp>;
};


export type Subscription_RootUser_Organizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Organizations_Order_By>>;
  where?: InputMaybe<User_Organizations_Bool_Exp>;
};


export type Subscription_RootUser_Organizations_By_PkArgs = {
  organization_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type Subscription_RootUser_Organizations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Organizations_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Organizations_Bool_Exp>;
};


export type Subscription_RootUser_ProductsArgs = {
  distinct_on?: InputMaybe<Array<User_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Products_Order_By>>;
  where?: InputMaybe<User_Products_Bool_Exp>;
};


export type Subscription_RootUser_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Products_Order_By>>;
  where?: InputMaybe<User_Products_Bool_Exp>;
};


export type Subscription_RootUser_Products_By_PkArgs = {
  organization_id: Scalars['uuid'];
  product: Scalars['String'];
  user_id: Scalars['uuid'];
};


export type Subscription_RootUser_Products_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Products_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVetric_Screenshot_WebhooksArgs = {
  distinct_on?: InputMaybe<Array<Vetric_Screenshot_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vetric_Screenshot_Webhooks_Order_By>>;
  where?: InputMaybe<Vetric_Screenshot_Webhooks_Bool_Exp>;
};


export type Subscription_RootVetric_Screenshot_Webhooks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vetric_Screenshot_Webhooks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vetric_Screenshot_Webhooks_Order_By>>;
  where?: InputMaybe<Vetric_Screenshot_Webhooks_Bool_Exp>;
};


export type Subscription_RootVetric_Screenshot_Webhooks_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVetric_Screenshot_Webhooks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vetric_Screenshot_Webhooks_Stream_Cursor_Input>>;
  where?: InputMaybe<Vetric_Screenshot_Webhooks_Bool_Exp>;
};


export type Subscription_RootWebhook_TargetsArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Targets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Webhook_Targets_Order_By>>;
  where?: InputMaybe<Webhook_Targets_Bool_Exp>;
};


export type Subscription_RootWebhook_Targets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Targets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Webhook_Targets_Order_By>>;
  where?: InputMaybe<Webhook_Targets_Bool_Exp>;
};


export type Subscription_RootWebhook_Targets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWebhook_Targets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Webhook_Targets_Stream_Cursor_Input>>;
  where?: InputMaybe<Webhook_Targets_Bool_Exp>;
};

/** For storing metadata related to suggested enforcements */
export type Suggested_Enforcements = {
  __typename?: 'suggested_enforcements';
  additional_template_info?: Maybe<Scalars['String']>;
  allowed_enforcement_methods: Scalars['jsonb'];
  cleaned_match_string?: Maybe<Scalars['String']>;
  content_type?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamp'];
  enforcement_type: Scalars['String'];
  flagged_content?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  platform_type?: Maybe<Scalars['String']>;
  product_type: Scalars['String'];
  protected_content?: Maybe<Scalars['String']>;
  provider_name: Scalars['String'];
  same_root_domain_ids?: Maybe<Scalars['jsonb']>;
  selected_method?: Maybe<Scalars['jsonb']>;
  selected_platform_name?: Maybe<Scalars['String']>;
  selected_platform_selection_method?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An object relationship */
  suggested_enforcement_form_response?: Maybe<Suggested_Enforcements_Form_Responses>;
  suggested_form_response_id?: Maybe<Scalars['uuid']>;
  suggested_platform_name: Scalars['String'];
  suggested_platform_selection_method: Scalars['String'];
  suggested_template_fields?: Maybe<Scalars['jsonb']>;
  unfilled_suggested_template?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamp'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
};


/** For storing metadata related to suggested enforcements */
export type Suggested_EnforcementsAllowed_Enforcement_MethodsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** For storing metadata related to suggested enforcements */
export type Suggested_EnforcementsSame_Root_Domain_IdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** For storing metadata related to suggested enforcements */
export type Suggested_EnforcementsSelected_MethodArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** For storing metadata related to suggested enforcements */
export type Suggested_EnforcementsSuggested_Template_FieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "suggested_enforcements" */
export type Suggested_Enforcements_Aggregate = {
  __typename?: 'suggested_enforcements_aggregate';
  aggregate?: Maybe<Suggested_Enforcements_Aggregate_Fields>;
  nodes: Array<Suggested_Enforcements>;
};

/** aggregate fields of "suggested_enforcements" */
export type Suggested_Enforcements_Aggregate_Fields = {
  __typename?: 'suggested_enforcements_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Suggested_Enforcements_Max_Fields>;
  min?: Maybe<Suggested_Enforcements_Min_Fields>;
};


/** aggregate fields of "suggested_enforcements" */
export type Suggested_Enforcements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Suggested_Enforcements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Suggested_Enforcements_Append_Input = {
  allowed_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  same_root_domain_ids?: InputMaybe<Scalars['jsonb']>;
  selected_method?: InputMaybe<Scalars['jsonb']>;
  suggested_template_fields?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "suggested_enforcements". All fields are combined with a logical 'AND'. */
export type Suggested_Enforcements_Bool_Exp = {
  _and?: InputMaybe<Array<Suggested_Enforcements_Bool_Exp>>;
  _not?: InputMaybe<Suggested_Enforcements_Bool_Exp>;
  _or?: InputMaybe<Array<Suggested_Enforcements_Bool_Exp>>;
  additional_template_info?: InputMaybe<String_Comparison_Exp>;
  allowed_enforcement_methods?: InputMaybe<Jsonb_Comparison_Exp>;
  cleaned_match_string?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  enforcement_type?: InputMaybe<String_Comparison_Exp>;
  flagged_content?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  platform_type?: InputMaybe<String_Comparison_Exp>;
  product_type?: InputMaybe<String_Comparison_Exp>;
  protected_content?: InputMaybe<String_Comparison_Exp>;
  provider_name?: InputMaybe<String_Comparison_Exp>;
  same_root_domain_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  selected_method?: InputMaybe<Jsonb_Comparison_Exp>;
  selected_platform_name?: InputMaybe<String_Comparison_Exp>;
  selected_platform_selection_method?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  suggested_enforcement_form_response?: InputMaybe<Suggested_Enforcements_Form_Responses_Bool_Exp>;
  suggested_form_response_id?: InputMaybe<Uuid_Comparison_Exp>;
  suggested_platform_name?: InputMaybe<String_Comparison_Exp>;
  suggested_platform_selection_method?: InputMaybe<String_Comparison_Exp>;
  suggested_template_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  unfilled_suggested_template?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "suggested_enforcements" */
export enum Suggested_Enforcements_Constraint {
  /** unique or primary key constraint on columns "id" */
  SuggestedEnforcementsPkey = 'suggested_enforcements_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Suggested_Enforcements_Delete_At_Path_Input = {
  allowed_enforcement_methods?: InputMaybe<Array<Scalars['String']>>;
  same_root_domain_ids?: InputMaybe<Array<Scalars['String']>>;
  selected_method?: InputMaybe<Array<Scalars['String']>>;
  suggested_template_fields?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Suggested_Enforcements_Delete_Elem_Input = {
  allowed_enforcement_methods?: InputMaybe<Scalars['Int']>;
  same_root_domain_ids?: InputMaybe<Scalars['Int']>;
  selected_method?: InputMaybe<Scalars['Int']>;
  suggested_template_fields?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Suggested_Enforcements_Delete_Key_Input = {
  allowed_enforcement_methods?: InputMaybe<Scalars['String']>;
  same_root_domain_ids?: InputMaybe<Scalars['String']>;
  selected_method?: InputMaybe<Scalars['String']>;
  suggested_template_fields?: InputMaybe<Scalars['String']>;
};

/** Responses to Suggested Enforcements Form */
export type Suggested_Enforcements_Form_Responses = {
  __typename?: 'suggested_enforcements_form_responses';
  created_at: Scalars['timestamp'];
  data: Scalars['jsonb'];
  id: Scalars['uuid'];
  updated_at: Scalars['timestamp'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
};


/** Responses to Suggested Enforcements Form */
export type Suggested_Enforcements_Form_ResponsesDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "suggested_enforcements_form_responses" */
export type Suggested_Enforcements_Form_Responses_Aggregate = {
  __typename?: 'suggested_enforcements_form_responses_aggregate';
  aggregate?: Maybe<Suggested_Enforcements_Form_Responses_Aggregate_Fields>;
  nodes: Array<Suggested_Enforcements_Form_Responses>;
};

/** aggregate fields of "suggested_enforcements_form_responses" */
export type Suggested_Enforcements_Form_Responses_Aggregate_Fields = {
  __typename?: 'suggested_enforcements_form_responses_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Suggested_Enforcements_Form_Responses_Max_Fields>;
  min?: Maybe<Suggested_Enforcements_Form_Responses_Min_Fields>;
};


/** aggregate fields of "suggested_enforcements_form_responses" */
export type Suggested_Enforcements_Form_Responses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Suggested_Enforcements_Form_Responses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Suggested_Enforcements_Form_Responses_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "suggested_enforcements_form_responses". All fields are combined with a logical 'AND'. */
export type Suggested_Enforcements_Form_Responses_Bool_Exp = {
  _and?: InputMaybe<Array<Suggested_Enforcements_Form_Responses_Bool_Exp>>;
  _not?: InputMaybe<Suggested_Enforcements_Form_Responses_Bool_Exp>;
  _or?: InputMaybe<Array<Suggested_Enforcements_Form_Responses_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "suggested_enforcements_form_responses" */
export enum Suggested_Enforcements_Form_Responses_Constraint {
  /** unique or primary key constraint on columns "id" */
  SuggestedEnforcementsFormResponsesPkey = 'suggested_enforcements_form_responses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Suggested_Enforcements_Form_Responses_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Suggested_Enforcements_Form_Responses_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Suggested_Enforcements_Form_Responses_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "suggested_enforcements_form_responses" */
export type Suggested_Enforcements_Form_Responses_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Suggested_Enforcements_Form_Responses_Max_Fields = {
  __typename?: 'suggested_enforcements_form_responses_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Suggested_Enforcements_Form_Responses_Min_Fields = {
  __typename?: 'suggested_enforcements_form_responses_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "suggested_enforcements_form_responses" */
export type Suggested_Enforcements_Form_Responses_Mutation_Response = {
  __typename?: 'suggested_enforcements_form_responses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Suggested_Enforcements_Form_Responses>;
};

/** input type for inserting object relation for remote table "suggested_enforcements_form_responses" */
export type Suggested_Enforcements_Form_Responses_Obj_Rel_Insert_Input = {
  data: Suggested_Enforcements_Form_Responses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Suggested_Enforcements_Form_Responses_On_Conflict>;
};

/** on_conflict condition type for table "suggested_enforcements_form_responses" */
export type Suggested_Enforcements_Form_Responses_On_Conflict = {
  constraint: Suggested_Enforcements_Form_Responses_Constraint;
  update_columns?: Array<Suggested_Enforcements_Form_Responses_Update_Column>;
  where?: InputMaybe<Suggested_Enforcements_Form_Responses_Bool_Exp>;
};

/** Ordering options when selecting data from "suggested_enforcements_form_responses". */
export type Suggested_Enforcements_Form_Responses_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: suggested_enforcements_form_responses */
export type Suggested_Enforcements_Form_Responses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Suggested_Enforcements_Form_Responses_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "suggested_enforcements_form_responses" */
export enum Suggested_Enforcements_Form_Responses_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "suggested_enforcements_form_responses" */
export type Suggested_Enforcements_Form_Responses_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "suggested_enforcements_form_responses" */
export type Suggested_Enforcements_Form_Responses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Suggested_Enforcements_Form_Responses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Suggested_Enforcements_Form_Responses_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "suggested_enforcements_form_responses" */
export enum Suggested_Enforcements_Form_Responses_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Suggested_Enforcements_Form_Responses_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Suggested_Enforcements_Form_Responses_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Suggested_Enforcements_Form_Responses_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Suggested_Enforcements_Form_Responses_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Suggested_Enforcements_Form_Responses_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Suggested_Enforcements_Form_Responses_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Suggested_Enforcements_Form_Responses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Suggested_Enforcements_Form_Responses_Bool_Exp;
};

/** input type for inserting data into table "suggested_enforcements" */
export type Suggested_Enforcements_Insert_Input = {
  additional_template_info?: InputMaybe<Scalars['String']>;
  allowed_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  cleaned_match_string?: InputMaybe<Scalars['String']>;
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  enforcement_type?: InputMaybe<Scalars['String']>;
  flagged_content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform_type?: InputMaybe<Scalars['String']>;
  product_type?: InputMaybe<Scalars['String']>;
  protected_content?: InputMaybe<Scalars['String']>;
  provider_name?: InputMaybe<Scalars['String']>;
  same_root_domain_ids?: InputMaybe<Scalars['jsonb']>;
  selected_method?: InputMaybe<Scalars['jsonb']>;
  selected_platform_name?: InputMaybe<Scalars['String']>;
  selected_platform_selection_method?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  suggested_enforcement_form_response?: InputMaybe<Suggested_Enforcements_Form_Responses_Obj_Rel_Insert_Input>;
  suggested_form_response_id?: InputMaybe<Scalars['uuid']>;
  suggested_platform_name?: InputMaybe<Scalars['String']>;
  suggested_platform_selection_method?: InputMaybe<Scalars['String']>;
  suggested_template_fields?: InputMaybe<Scalars['jsonb']>;
  unfilled_suggested_template?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Suggested_Enforcements_Max_Fields = {
  __typename?: 'suggested_enforcements_max_fields';
  additional_template_info?: Maybe<Scalars['String']>;
  cleaned_match_string?: Maybe<Scalars['String']>;
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  enforcement_type?: Maybe<Scalars['String']>;
  flagged_content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  platform_type?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  protected_content?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  selected_platform_name?: Maybe<Scalars['String']>;
  selected_platform_selection_method?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  suggested_form_response_id?: Maybe<Scalars['uuid']>;
  suggested_platform_name?: Maybe<Scalars['String']>;
  suggested_platform_selection_method?: Maybe<Scalars['String']>;
  unfilled_suggested_template?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Suggested_Enforcements_Min_Fields = {
  __typename?: 'suggested_enforcements_min_fields';
  additional_template_info?: Maybe<Scalars['String']>;
  cleaned_match_string?: Maybe<Scalars['String']>;
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  enforcement_type?: Maybe<Scalars['String']>;
  flagged_content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  platform_type?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  protected_content?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  selected_platform_name?: Maybe<Scalars['String']>;
  selected_platform_selection_method?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  suggested_form_response_id?: Maybe<Scalars['uuid']>;
  suggested_platform_name?: Maybe<Scalars['String']>;
  suggested_platform_selection_method?: Maybe<Scalars['String']>;
  unfilled_suggested_template?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "suggested_enforcements" */
export type Suggested_Enforcements_Mutation_Response = {
  __typename?: 'suggested_enforcements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Suggested_Enforcements>;
};

/** input type for inserting object relation for remote table "suggested_enforcements" */
export type Suggested_Enforcements_Obj_Rel_Insert_Input = {
  data: Suggested_Enforcements_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Suggested_Enforcements_On_Conflict>;
};

/** on_conflict condition type for table "suggested_enforcements" */
export type Suggested_Enforcements_On_Conflict = {
  constraint: Suggested_Enforcements_Constraint;
  update_columns?: Array<Suggested_Enforcements_Update_Column>;
  where?: InputMaybe<Suggested_Enforcements_Bool_Exp>;
};

/** Ordering options when selecting data from "suggested_enforcements". */
export type Suggested_Enforcements_Order_By = {
  additional_template_info?: InputMaybe<Order_By>;
  allowed_enforcement_methods?: InputMaybe<Order_By>;
  cleaned_match_string?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enforcement_type?: InputMaybe<Order_By>;
  flagged_content?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform_type?: InputMaybe<Order_By>;
  product_type?: InputMaybe<Order_By>;
  protected_content?: InputMaybe<Order_By>;
  provider_name?: InputMaybe<Order_By>;
  same_root_domain_ids?: InputMaybe<Order_By>;
  selected_method?: InputMaybe<Order_By>;
  selected_platform_name?: InputMaybe<Order_By>;
  selected_platform_selection_method?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  suggested_enforcement_form_response?: InputMaybe<Suggested_Enforcements_Form_Responses_Order_By>;
  suggested_form_response_id?: InputMaybe<Order_By>;
  suggested_platform_name?: InputMaybe<Order_By>;
  suggested_platform_selection_method?: InputMaybe<Order_By>;
  suggested_template_fields?: InputMaybe<Order_By>;
  unfilled_suggested_template?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: suggested_enforcements */
export type Suggested_Enforcements_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Suggested_Enforcements_Prepend_Input = {
  allowed_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  same_root_domain_ids?: InputMaybe<Scalars['jsonb']>;
  selected_method?: InputMaybe<Scalars['jsonb']>;
  suggested_template_fields?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "suggested_enforcements" */
export enum Suggested_Enforcements_Select_Column {
  /** column name */
  AdditionalTemplateInfo = 'additional_template_info',
  /** column name */
  AllowedEnforcementMethods = 'allowed_enforcement_methods',
  /** column name */
  CleanedMatchString = 'cleaned_match_string',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnforcementType = 'enforcement_type',
  /** column name */
  FlaggedContent = 'flagged_content',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformType = 'platform_type',
  /** column name */
  ProductType = 'product_type',
  /** column name */
  ProtectedContent = 'protected_content',
  /** column name */
  ProviderName = 'provider_name',
  /** column name */
  SameRootDomainIds = 'same_root_domain_ids',
  /** column name */
  SelectedMethod = 'selected_method',
  /** column name */
  SelectedPlatformName = 'selected_platform_name',
  /** column name */
  SelectedPlatformSelectionMethod = 'selected_platform_selection_method',
  /** column name */
  Status = 'status',
  /** column name */
  SuggestedFormResponseId = 'suggested_form_response_id',
  /** column name */
  SuggestedPlatformName = 'suggested_platform_name',
  /** column name */
  SuggestedPlatformSelectionMethod = 'suggested_platform_selection_method',
  /** column name */
  SuggestedTemplateFields = 'suggested_template_fields',
  /** column name */
  UnfilledSuggestedTemplate = 'unfilled_suggested_template',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "suggested_enforcements" */
export type Suggested_Enforcements_Set_Input = {
  additional_template_info?: InputMaybe<Scalars['String']>;
  allowed_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  cleaned_match_string?: InputMaybe<Scalars['String']>;
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  enforcement_type?: InputMaybe<Scalars['String']>;
  flagged_content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform_type?: InputMaybe<Scalars['String']>;
  product_type?: InputMaybe<Scalars['String']>;
  protected_content?: InputMaybe<Scalars['String']>;
  provider_name?: InputMaybe<Scalars['String']>;
  same_root_domain_ids?: InputMaybe<Scalars['jsonb']>;
  selected_method?: InputMaybe<Scalars['jsonb']>;
  selected_platform_name?: InputMaybe<Scalars['String']>;
  selected_platform_selection_method?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  suggested_form_response_id?: InputMaybe<Scalars['uuid']>;
  suggested_platform_name?: InputMaybe<Scalars['String']>;
  suggested_platform_selection_method?: InputMaybe<Scalars['String']>;
  suggested_template_fields?: InputMaybe<Scalars['jsonb']>;
  unfilled_suggested_template?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "suggested_enforcements" */
export type Suggested_Enforcements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Suggested_Enforcements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Suggested_Enforcements_Stream_Cursor_Value_Input = {
  additional_template_info?: InputMaybe<Scalars['String']>;
  allowed_enforcement_methods?: InputMaybe<Scalars['jsonb']>;
  cleaned_match_string?: InputMaybe<Scalars['String']>;
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  enforcement_type?: InputMaybe<Scalars['String']>;
  flagged_content?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform_type?: InputMaybe<Scalars['String']>;
  product_type?: InputMaybe<Scalars['String']>;
  protected_content?: InputMaybe<Scalars['String']>;
  provider_name?: InputMaybe<Scalars['String']>;
  same_root_domain_ids?: InputMaybe<Scalars['jsonb']>;
  selected_method?: InputMaybe<Scalars['jsonb']>;
  selected_platform_name?: InputMaybe<Scalars['String']>;
  selected_platform_selection_method?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  suggested_form_response_id?: InputMaybe<Scalars['uuid']>;
  suggested_platform_name?: InputMaybe<Scalars['String']>;
  suggested_platform_selection_method?: InputMaybe<Scalars['String']>;
  suggested_template_fields?: InputMaybe<Scalars['jsonb']>;
  unfilled_suggested_template?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "suggested_enforcements" */
export enum Suggested_Enforcements_Update_Column {
  /** column name */
  AdditionalTemplateInfo = 'additional_template_info',
  /** column name */
  AllowedEnforcementMethods = 'allowed_enforcement_methods',
  /** column name */
  CleanedMatchString = 'cleaned_match_string',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EnforcementType = 'enforcement_type',
  /** column name */
  FlaggedContent = 'flagged_content',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformType = 'platform_type',
  /** column name */
  ProductType = 'product_type',
  /** column name */
  ProtectedContent = 'protected_content',
  /** column name */
  ProviderName = 'provider_name',
  /** column name */
  SameRootDomainIds = 'same_root_domain_ids',
  /** column name */
  SelectedMethod = 'selected_method',
  /** column name */
  SelectedPlatformName = 'selected_platform_name',
  /** column name */
  SelectedPlatformSelectionMethod = 'selected_platform_selection_method',
  /** column name */
  Status = 'status',
  /** column name */
  SuggestedFormResponseId = 'suggested_form_response_id',
  /** column name */
  SuggestedPlatformName = 'suggested_platform_name',
  /** column name */
  SuggestedPlatformSelectionMethod = 'suggested_platform_selection_method',
  /** column name */
  SuggestedTemplateFields = 'suggested_template_fields',
  /** column name */
  UnfilledSuggestedTemplate = 'unfilled_suggested_template',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Suggested_Enforcements_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Suggested_Enforcements_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Suggested_Enforcements_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Suggested_Enforcements_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Suggested_Enforcements_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Suggested_Enforcements_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Suggested_Enforcements_Set_Input>;
  /** filter the rows which have to be updated */
  where: Suggested_Enforcements_Bool_Exp;
};

/** columns and relationships of "tags" */
export type Tags = {
  __typename?: 'tags';
  created_at: Scalars['timestamp'];
  created_by?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  id: Scalars['uuid'];
  is_internal: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  report_tags: Array<Report_Tags>;
  /** An aggregate relationship */
  report_tags_aggregate: Report_Tags_Aggregate;
};


/** columns and relationships of "tags" */
export type TagsReport_TagsArgs = {
  distinct_on?: InputMaybe<Array<Report_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Tags_Order_By>>;
  where?: InputMaybe<Report_Tags_Bool_Exp>;
};


/** columns and relationships of "tags" */
export type TagsReport_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Tags_Order_By>>;
  where?: InputMaybe<Report_Tags_Bool_Exp>;
};

/** aggregated selection of "tags" */
export type Tags_Aggregate = {
  __typename?: 'tags_aggregate';
  aggregate?: Maybe<Tags_Aggregate_Fields>;
  nodes: Array<Tags>;
};

/** aggregate fields of "tags" */
export type Tags_Aggregate_Fields = {
  __typename?: 'tags_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Tags_Max_Fields>;
  min?: Maybe<Tags_Min_Fields>;
};


/** aggregate fields of "tags" */
export type Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "tags". All fields are combined with a logical 'AND'. */
export type Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Tags_Bool_Exp>>;
  _not?: InputMaybe<Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_internal?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  report_tags?: InputMaybe<Report_Tags_Bool_Exp>;
  report_tags_aggregate?: InputMaybe<Report_Tags_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tags" */
export enum Tags_Constraint {
  /** unique or primary key constraint on columns "organization_id", "name" */
  TagsNameOrganizationIdKey = 'tags_name_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  TagsPkey = 'tags_pkey'
}

/** input type for inserting data into table "tags" */
export type Tags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_internal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  report_tags?: InputMaybe<Report_Tags_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tags_Max_Fields = {
  __typename?: 'tags_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Tags_Min_Fields = {
  __typename?: 'tags_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "tags" */
export type Tags_Mutation_Response = {
  __typename?: 'tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tags>;
};

/** input type for inserting object relation for remote table "tags" */
export type Tags_Obj_Rel_Insert_Input = {
  data: Tags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};

/** on_conflict condition type for table "tags" */
export type Tags_On_Conflict = {
  constraint: Tags_Constraint;
  update_columns?: Array<Tags_Update_Column>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "tags". */
export type Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_internal?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  report_tags_aggregate?: InputMaybe<Report_Tags_Aggregate_Order_By>;
};

/** primary key columns input for table: tags */
export type Tags_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tags" */
export enum Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsInternal = 'is_internal',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id'
}

/** input type for updating data in table "tags" */
export type Tags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_internal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "tags" */
export type Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_internal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "tags" */
export enum Tags_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsInternal = 'is_internal',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id'
}

export type Tags_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tags_Bool_Exp;
};

/** columns and relationships of "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign = {
  __typename?: 'threat_intel_actor_to_campaign';
  actor_id: Scalars['uuid'];
  campaign_id: Scalars['uuid'];
  created_at: Scalars['timestamp'];
  /** An object relationship */
  threat_intel_actor: Threat_Intel_Actors;
  /** An object relationship */
  threat_intel_campaign: Threat_Intel_Campaigns;
};

/** aggregated selection of "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_Aggregate = {
  __typename?: 'threat_intel_actor_to_campaign_aggregate';
  aggregate?: Maybe<Threat_Intel_Actor_To_Campaign_Aggregate_Fields>;
  nodes: Array<Threat_Intel_Actor_To_Campaign>;
};

export type Threat_Intel_Actor_To_Campaign_Aggregate_Bool_Exp = {
  count?: InputMaybe<Threat_Intel_Actor_To_Campaign_Aggregate_Bool_Exp_Count>;
};

export type Threat_Intel_Actor_To_Campaign_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_Aggregate_Fields = {
  __typename?: 'threat_intel_actor_to_campaign_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Threat_Intel_Actor_To_Campaign_Max_Fields>;
  min?: Maybe<Threat_Intel_Actor_To_Campaign_Min_Fields>;
};


/** aggregate fields of "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Threat_Intel_Actor_To_Campaign_Max_Order_By>;
  min?: InputMaybe<Threat_Intel_Actor_To_Campaign_Min_Order_By>;
};

/** input type for inserting array relation for remote table "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_Arr_Rel_Insert_Input = {
  data: Array<Threat_Intel_Actor_To_Campaign_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Threat_Intel_Actor_To_Campaign_On_Conflict>;
};

/** Boolean expression to filter rows from the table "threat_intel_actor_to_campaign". All fields are combined with a logical 'AND'. */
export type Threat_Intel_Actor_To_Campaign_Bool_Exp = {
  _and?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Bool_Exp>>;
  _not?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
  _or?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Bool_Exp>>;
  actor_id?: InputMaybe<Uuid_Comparison_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  threat_intel_actor?: InputMaybe<Threat_Intel_Actors_Bool_Exp>;
  threat_intel_campaign?: InputMaybe<Threat_Intel_Campaigns_Bool_Exp>;
};

/** unique or primary key constraints on table "threat_intel_actor_to_campaign" */
export enum Threat_Intel_Actor_To_Campaign_Constraint {
  /** unique or primary key constraint on columns "actor_id", "campaign_id" */
  ThreatIntelActorToCampaignPkey = 'threat_intel_actor_to_campaign_pkey'
}

/** input type for inserting data into table "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_Insert_Input = {
  actor_id?: InputMaybe<Scalars['uuid']>;
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  threat_intel_actor?: InputMaybe<Threat_Intel_Actors_Obj_Rel_Insert_Input>;
  threat_intel_campaign?: InputMaybe<Threat_Intel_Campaigns_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Threat_Intel_Actor_To_Campaign_Max_Fields = {
  __typename?: 'threat_intel_actor_to_campaign_max_fields';
  actor_id?: Maybe<Scalars['uuid']>;
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_Max_Order_By = {
  actor_id?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Threat_Intel_Actor_To_Campaign_Min_Fields = {
  __typename?: 'threat_intel_actor_to_campaign_min_fields';
  actor_id?: Maybe<Scalars['uuid']>;
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_Min_Order_By = {
  actor_id?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_Mutation_Response = {
  __typename?: 'threat_intel_actor_to_campaign_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Threat_Intel_Actor_To_Campaign>;
};

/** on_conflict condition type for table "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_On_Conflict = {
  constraint: Threat_Intel_Actor_To_Campaign_Constraint;
  update_columns?: Array<Threat_Intel_Actor_To_Campaign_Update_Column>;
  where?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
};

/** Ordering options when selecting data from "threat_intel_actor_to_campaign". */
export type Threat_Intel_Actor_To_Campaign_Order_By = {
  actor_id?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  threat_intel_actor?: InputMaybe<Threat_Intel_Actors_Order_By>;
  threat_intel_campaign?: InputMaybe<Threat_Intel_Campaigns_Order_By>;
};

/** primary key columns input for table: threat_intel_actor_to_campaign */
export type Threat_Intel_Actor_To_Campaign_Pk_Columns_Input = {
  actor_id: Scalars['uuid'];
  campaign_id: Scalars['uuid'];
};

/** select columns of table "threat_intel_actor_to_campaign" */
export enum Threat_Intel_Actor_To_Campaign_Select_Column {
  /** column name */
  ActorId = 'actor_id',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at'
}

/** input type for updating data in table "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_Set_Input = {
  actor_id?: InputMaybe<Scalars['uuid']>;
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "threat_intel_actor_to_campaign" */
export type Threat_Intel_Actor_To_Campaign_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Threat_Intel_Actor_To_Campaign_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Threat_Intel_Actor_To_Campaign_Stream_Cursor_Value_Input = {
  actor_id?: InputMaybe<Scalars['uuid']>;
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "threat_intel_actor_to_campaign" */
export enum Threat_Intel_Actor_To_Campaign_Update_Column {
  /** column name */
  ActorId = 'actor_id',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at'
}

export type Threat_Intel_Actor_To_Campaign_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Threat_Intel_Actor_To_Campaign_Set_Input>;
  /** filter the rows which have to be updated */
  where: Threat_Intel_Actor_To_Campaign_Bool_Exp;
};

/** columns and relationships of "threat_intel_actors" */
export type Threat_Intel_Actors = {
  __typename?: 'threat_intel_actors';
  created_at: Scalars['timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  threat_intel_actor_to_campaign: Array<Threat_Intel_Actor_To_Campaign>;
  /** An aggregate relationship */
  threat_intel_actor_to_campaign_aggregate: Threat_Intel_Actor_To_Campaign_Aggregate;
  updated_at: Scalars['timestamp'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
};


/** columns and relationships of "threat_intel_actors" */
export type Threat_Intel_ActorsThreat_Intel_Actor_To_CampaignArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
};


/** columns and relationships of "threat_intel_actors" */
export type Threat_Intel_ActorsThreat_Intel_Actor_To_Campaign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
};

/** aggregated selection of "threat_intel_actors" */
export type Threat_Intel_Actors_Aggregate = {
  __typename?: 'threat_intel_actors_aggregate';
  aggregate?: Maybe<Threat_Intel_Actors_Aggregate_Fields>;
  nodes: Array<Threat_Intel_Actors>;
};

/** aggregate fields of "threat_intel_actors" */
export type Threat_Intel_Actors_Aggregate_Fields = {
  __typename?: 'threat_intel_actors_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Threat_Intel_Actors_Max_Fields>;
  min?: Maybe<Threat_Intel_Actors_Min_Fields>;
};


/** aggregate fields of "threat_intel_actors" */
export type Threat_Intel_Actors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Threat_Intel_Actors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "threat_intel_actors". All fields are combined with a logical 'AND'. */
export type Threat_Intel_Actors_Bool_Exp = {
  _and?: InputMaybe<Array<Threat_Intel_Actors_Bool_Exp>>;
  _not?: InputMaybe<Threat_Intel_Actors_Bool_Exp>;
  _or?: InputMaybe<Array<Threat_Intel_Actors_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  threat_intel_actor_to_campaign?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
  threat_intel_actor_to_campaign_aggregate?: InputMaybe<Threat_Intel_Actor_To_Campaign_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "threat_intel_actors" */
export enum Threat_Intel_Actors_Constraint {
  /** unique or primary key constraint on columns "name" */
  ThreatIntelActorsNameKey = 'threat_intel_actors_name_key',
  /** unique or primary key constraint on columns "id" */
  ThreatIntelActorsPkey = 'threat_intel_actors_pkey'
}

/** input type for inserting data into table "threat_intel_actors" */
export type Threat_Intel_Actors_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  threat_intel_actor_to_campaign?: InputMaybe<Threat_Intel_Actor_To_Campaign_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Threat_Intel_Actors_Max_Fields = {
  __typename?: 'threat_intel_actors_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Threat_Intel_Actors_Min_Fields = {
  __typename?: 'threat_intel_actors_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "threat_intel_actors" */
export type Threat_Intel_Actors_Mutation_Response = {
  __typename?: 'threat_intel_actors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Threat_Intel_Actors>;
};

/** input type for inserting object relation for remote table "threat_intel_actors" */
export type Threat_Intel_Actors_Obj_Rel_Insert_Input = {
  data: Threat_Intel_Actors_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Threat_Intel_Actors_On_Conflict>;
};

/** on_conflict condition type for table "threat_intel_actors" */
export type Threat_Intel_Actors_On_Conflict = {
  constraint: Threat_Intel_Actors_Constraint;
  update_columns?: Array<Threat_Intel_Actors_Update_Column>;
  where?: InputMaybe<Threat_Intel_Actors_Bool_Exp>;
};

/** Ordering options when selecting data from "threat_intel_actors". */
export type Threat_Intel_Actors_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  threat_intel_actor_to_campaign_aggregate?: InputMaybe<Threat_Intel_Actor_To_Campaign_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: threat_intel_actors */
export type Threat_Intel_Actors_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "threat_intel_actors" */
export enum Threat_Intel_Actors_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "threat_intel_actors" */
export type Threat_Intel_Actors_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "threat_intel_actors" */
export type Threat_Intel_Actors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Threat_Intel_Actors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Threat_Intel_Actors_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "threat_intel_actors" */
export enum Threat_Intel_Actors_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Threat_Intel_Actors_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Threat_Intel_Actors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Threat_Intel_Actors_Bool_Exp;
};

/** columns and relationships of "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities = {
  __typename?: 'threat_intel_campaign_to_entities';
  campaign_id: Scalars['uuid'];
  created_at: Scalars['timestamp'];
  /** An object relationship */
  entity_data: Entity_Data;
  entity_data_id: Scalars['uuid'];
  status: Scalars['String'];
  /** An object relationship */
  threat_intel_campaign: Threat_Intel_Campaigns;
  updated_at: Scalars['timestamp'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
};

/** aggregated selection of "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_Aggregate = {
  __typename?: 'threat_intel_campaign_to_entities_aggregate';
  aggregate?: Maybe<Threat_Intel_Campaign_To_Entities_Aggregate_Fields>;
  nodes: Array<Threat_Intel_Campaign_To_Entities>;
};

export type Threat_Intel_Campaign_To_Entities_Aggregate_Bool_Exp = {
  count?: InputMaybe<Threat_Intel_Campaign_To_Entities_Aggregate_Bool_Exp_Count>;
};

export type Threat_Intel_Campaign_To_Entities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Threat_Intel_Campaign_To_Entities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_Aggregate_Fields = {
  __typename?: 'threat_intel_campaign_to_entities_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Threat_Intel_Campaign_To_Entities_Max_Fields>;
  min?: Maybe<Threat_Intel_Campaign_To_Entities_Min_Fields>;
};


/** aggregate fields of "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Threat_Intel_Campaign_To_Entities_Max_Order_By>;
  min?: InputMaybe<Threat_Intel_Campaign_To_Entities_Min_Order_By>;
};

/** input type for inserting array relation for remote table "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_Arr_Rel_Insert_Input = {
  data: Array<Threat_Intel_Campaign_To_Entities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Threat_Intel_Campaign_To_Entities_On_Conflict>;
};

/** Boolean expression to filter rows from the table "threat_intel_campaign_to_entities". All fields are combined with a logical 'AND'. */
export type Threat_Intel_Campaign_To_Entities_Bool_Exp = {
  _and?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Bool_Exp>>;
  _not?: InputMaybe<Threat_Intel_Campaign_To_Entities_Bool_Exp>;
  _or?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Bool_Exp>>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  entity_data?: InputMaybe<Entity_Data_Bool_Exp>;
  entity_data_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  threat_intel_campaign?: InputMaybe<Threat_Intel_Campaigns_Bool_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "threat_intel_campaign_to_entities" */
export enum Threat_Intel_Campaign_To_Entities_Constraint {
  /** unique or primary key constraint on columns "campaign_id", "entity_data_id" */
  ThreatIntelCampaignToEntitiesPkey = 'threat_intel_campaign_to_entities_pkey'
}

/** input type for inserting data into table "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_Insert_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  entity_data?: InputMaybe<Entity_Data_Obj_Rel_Insert_Input>;
  entity_data_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  threat_intel_campaign?: InputMaybe<Threat_Intel_Campaigns_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Threat_Intel_Campaign_To_Entities_Max_Fields = {
  __typename?: 'threat_intel_campaign_to_entities_max_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  entity_data_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_Max_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entity_data_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Threat_Intel_Campaign_To_Entities_Min_Fields = {
  __typename?: 'threat_intel_campaign_to_entities_min_fields';
  campaign_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  entity_data_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_Min_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entity_data_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_Mutation_Response = {
  __typename?: 'threat_intel_campaign_to_entities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Threat_Intel_Campaign_To_Entities>;
};

/** on_conflict condition type for table "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_On_Conflict = {
  constraint: Threat_Intel_Campaign_To_Entities_Constraint;
  update_columns?: Array<Threat_Intel_Campaign_To_Entities_Update_Column>;
  where?: InputMaybe<Threat_Intel_Campaign_To_Entities_Bool_Exp>;
};

/** Ordering options when selecting data from "threat_intel_campaign_to_entities". */
export type Threat_Intel_Campaign_To_Entities_Order_By = {
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entity_data?: InputMaybe<Entity_Data_Order_By>;
  entity_data_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  threat_intel_campaign?: InputMaybe<Threat_Intel_Campaigns_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: threat_intel_campaign_to_entities */
export type Threat_Intel_Campaign_To_Entities_Pk_Columns_Input = {
  campaign_id: Scalars['uuid'];
  entity_data_id: Scalars['uuid'];
};

/** select columns of table "threat_intel_campaign_to_entities" */
export enum Threat_Intel_Campaign_To_Entities_Select_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityDataId = 'entity_data_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_Set_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  entity_data_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "threat_intel_campaign_to_entities" */
export type Threat_Intel_Campaign_To_Entities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Threat_Intel_Campaign_To_Entities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Threat_Intel_Campaign_To_Entities_Stream_Cursor_Value_Input = {
  campaign_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  entity_data_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "threat_intel_campaign_to_entities" */
export enum Threat_Intel_Campaign_To_Entities_Update_Column {
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntityDataId = 'entity_data_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Threat_Intel_Campaign_To_Entities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Threat_Intel_Campaign_To_Entities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Threat_Intel_Campaign_To_Entities_Bool_Exp;
};

/** columns and relationships of "threat_intel_campaigns" */
export type Threat_Intel_Campaigns = {
  __typename?: 'threat_intel_campaigns';
  additional_metadata?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamp'];
  description?: Maybe<Scalars['String']>;
  first_seen?: Maybe<Scalars['timestamp']>;
  id: Scalars['uuid'];
  last_seen?: Maybe<Scalars['timestamp']>;
  name: Scalars['String'];
  region?: Maybe<Scalars['String']>;
  /** An array relationship */
  threat_intel_actor_to_campaign: Array<Threat_Intel_Actor_To_Campaign>;
  /** An aggregate relationship */
  threat_intel_actor_to_campaign_aggregate: Threat_Intel_Actor_To_Campaign_Aggregate;
  /** An array relationship */
  threat_intel_campaign_to_entities: Array<Threat_Intel_Campaign_To_Entities>;
  /** An aggregate relationship */
  threat_intel_campaign_to_entities_aggregate: Threat_Intel_Campaign_To_Entities_Aggregate;
  ttps?: Maybe<Array<Scalars['String']>>;
  updated_at: Scalars['timestamp'];
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
};


/** columns and relationships of "threat_intel_campaigns" */
export type Threat_Intel_CampaignsAdditional_MetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "threat_intel_campaigns" */
export type Threat_Intel_CampaignsThreat_Intel_Actor_To_CampaignArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
};


/** columns and relationships of "threat_intel_campaigns" */
export type Threat_Intel_CampaignsThreat_Intel_Actor_To_Campaign_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Actor_To_Campaign_Order_By>>;
  where?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
};


/** columns and relationships of "threat_intel_campaigns" */
export type Threat_Intel_CampaignsThreat_Intel_Campaign_To_EntitiesArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Order_By>>;
  where?: InputMaybe<Threat_Intel_Campaign_To_Entities_Bool_Exp>;
};


/** columns and relationships of "threat_intel_campaigns" */
export type Threat_Intel_CampaignsThreat_Intel_Campaign_To_Entities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Threat_Intel_Campaign_To_Entities_Order_By>>;
  where?: InputMaybe<Threat_Intel_Campaign_To_Entities_Bool_Exp>;
};

/** aggregated selection of "threat_intel_campaigns" */
export type Threat_Intel_Campaigns_Aggregate = {
  __typename?: 'threat_intel_campaigns_aggregate';
  aggregate?: Maybe<Threat_Intel_Campaigns_Aggregate_Fields>;
  nodes: Array<Threat_Intel_Campaigns>;
};

/** aggregate fields of "threat_intel_campaigns" */
export type Threat_Intel_Campaigns_Aggregate_Fields = {
  __typename?: 'threat_intel_campaigns_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Threat_Intel_Campaigns_Max_Fields>;
  min?: Maybe<Threat_Intel_Campaigns_Min_Fields>;
};


/** aggregate fields of "threat_intel_campaigns" */
export type Threat_Intel_Campaigns_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Threat_Intel_Campaigns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Threat_Intel_Campaigns_Append_Input = {
  additional_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "threat_intel_campaigns". All fields are combined with a logical 'AND'. */
export type Threat_Intel_Campaigns_Bool_Exp = {
  _and?: InputMaybe<Array<Threat_Intel_Campaigns_Bool_Exp>>;
  _not?: InputMaybe<Threat_Intel_Campaigns_Bool_Exp>;
  _or?: InputMaybe<Array<Threat_Intel_Campaigns_Bool_Exp>>;
  additional_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  first_seen?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_seen?: InputMaybe<Timestamp_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  threat_intel_actor_to_campaign?: InputMaybe<Threat_Intel_Actor_To_Campaign_Bool_Exp>;
  threat_intel_actor_to_campaign_aggregate?: InputMaybe<Threat_Intel_Actor_To_Campaign_Aggregate_Bool_Exp>;
  threat_intel_campaign_to_entities?: InputMaybe<Threat_Intel_Campaign_To_Entities_Bool_Exp>;
  threat_intel_campaign_to_entities_aggregate?: InputMaybe<Threat_Intel_Campaign_To_Entities_Aggregate_Bool_Exp>;
  ttps?: InputMaybe<String_Array_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "threat_intel_campaigns" */
export enum Threat_Intel_Campaigns_Constraint {
  /** unique or primary key constraint on columns "name" */
  ThreatIntelCampaignsNameKey = 'threat_intel_campaigns_name_key',
  /** unique or primary key constraint on columns "id" */
  ThreatIntelCampaignsPkey = 'threat_intel_campaigns_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Threat_Intel_Campaigns_Delete_At_Path_Input = {
  additional_metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Threat_Intel_Campaigns_Delete_Elem_Input = {
  additional_metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Threat_Intel_Campaigns_Delete_Key_Input = {
  additional_metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "threat_intel_campaigns" */
export type Threat_Intel_Campaigns_Insert_Input = {
  additional_metadata?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  first_seen?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_seen?: InputMaybe<Scalars['timestamp']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  threat_intel_actor_to_campaign?: InputMaybe<Threat_Intel_Actor_To_Campaign_Arr_Rel_Insert_Input>;
  threat_intel_campaign_to_entities?: InputMaybe<Threat_Intel_Campaign_To_Entities_Arr_Rel_Insert_Input>;
  ttps?: InputMaybe<Array<Scalars['String']>>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Threat_Intel_Campaigns_Max_Fields = {
  __typename?: 'threat_intel_campaigns_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  first_seen?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  last_seen?: Maybe<Scalars['timestamp']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  ttps?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Threat_Intel_Campaigns_Min_Fields = {
  __typename?: 'threat_intel_campaigns_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  first_seen?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  last_seen?: Maybe<Scalars['timestamp']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  ttps?: Maybe<Array<Scalars['String']>>;
  updated_at?: Maybe<Scalars['timestamp']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "threat_intel_campaigns" */
export type Threat_Intel_Campaigns_Mutation_Response = {
  __typename?: 'threat_intel_campaigns_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Threat_Intel_Campaigns>;
};

/** input type for inserting object relation for remote table "threat_intel_campaigns" */
export type Threat_Intel_Campaigns_Obj_Rel_Insert_Input = {
  data: Threat_Intel_Campaigns_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Threat_Intel_Campaigns_On_Conflict>;
};

/** on_conflict condition type for table "threat_intel_campaigns" */
export type Threat_Intel_Campaigns_On_Conflict = {
  constraint: Threat_Intel_Campaigns_Constraint;
  update_columns?: Array<Threat_Intel_Campaigns_Update_Column>;
  where?: InputMaybe<Threat_Intel_Campaigns_Bool_Exp>;
};

/** Ordering options when selecting data from "threat_intel_campaigns". */
export type Threat_Intel_Campaigns_Order_By = {
  additional_metadata?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  first_seen?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_seen?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  threat_intel_actor_to_campaign_aggregate?: InputMaybe<Threat_Intel_Actor_To_Campaign_Aggregate_Order_By>;
  threat_intel_campaign_to_entities_aggregate?: InputMaybe<Threat_Intel_Campaign_To_Entities_Aggregate_Order_By>;
  ttps?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: threat_intel_campaigns */
export type Threat_Intel_Campaigns_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Threat_Intel_Campaigns_Prepend_Input = {
  additional_metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "threat_intel_campaigns" */
export enum Threat_Intel_Campaigns_Select_Column {
  /** column name */
  AdditionalMetadata = 'additional_metadata',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FirstSeen = 'first_seen',
  /** column name */
  Id = 'id',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  Name = 'name',
  /** column name */
  Region = 'region',
  /** column name */
  Ttps = 'ttps',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** input type for updating data in table "threat_intel_campaigns" */
export type Threat_Intel_Campaigns_Set_Input = {
  additional_metadata?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  first_seen?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_seen?: InputMaybe<Scalars['timestamp']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  ttps?: InputMaybe<Array<Scalars['String']>>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "threat_intel_campaigns" */
export type Threat_Intel_Campaigns_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Threat_Intel_Campaigns_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Threat_Intel_Campaigns_Stream_Cursor_Value_Input = {
  additional_metadata?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  first_seen?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_seen?: InputMaybe<Scalars['timestamp']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  ttps?: InputMaybe<Array<Scalars['String']>>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "threat_intel_campaigns" */
export enum Threat_Intel_Campaigns_Update_Column {
  /** column name */
  AdditionalMetadata = 'additional_metadata',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FirstSeen = 'first_seen',
  /** column name */
  Id = 'id',
  /** column name */
  LastSeen = 'last_seen',
  /** column name */
  Name = 'name',
  /** column name */
  Region = 'region',
  /** column name */
  Ttps = 'ttps',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Threat_Intel_Campaigns_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Threat_Intel_Campaigns_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Threat_Intel_Campaigns_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Threat_Intel_Campaigns_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Threat_Intel_Campaigns_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Threat_Intel_Campaigns_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Threat_Intel_Campaigns_Set_Input>;
  /** filter the rows which have to be updated */
  where: Threat_Intel_Campaigns_Bool_Exp;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** information about trademarks */
export type Trademarks = {
  __typename?: 'trademarks';
  created_at?: Maybe<Scalars['timestamp']>;
  goods_or_services_class?: Maybe<Scalars['String']>;
  holder_address: Scalars['String'];
  holder_company_name?: Maybe<Scalars['String']>;
  /** 2 letters max */
  holder_country_code: Scalars['String'];
  holder_name: Scalars['String'];
  holder_twitter_slug?: Maybe<Scalars['String']>;
  holder_website?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  mark?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object relationship */
  organization?: Maybe<Organizations>;
  organization_id?: Maybe<Scalars['uuid']>;
  proof_of_ownership_url?: Maybe<Scalars['String']>;
  record_link?: Maybe<Scalars['String']>;
  registration_number: Scalars['String'];
  registration_office?: Maybe<Scalars['String']>;
  /** An object relationship */
  spoofing_entity?: Maybe<Spoofing_Entities>;
  spoofing_entity_id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  trademark_registration_certificate_url?: Maybe<Scalars['String']>;
  trademark_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "trademarks" */
export type Trademarks_Aggregate = {
  __typename?: 'trademarks_aggregate';
  aggregate?: Maybe<Trademarks_Aggregate_Fields>;
  nodes: Array<Trademarks>;
};

export type Trademarks_Aggregate_Bool_Exp = {
  count?: InputMaybe<Trademarks_Aggregate_Bool_Exp_Count>;
};

export type Trademarks_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Trademarks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Trademarks_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "trademarks" */
export type Trademarks_Aggregate_Fields = {
  __typename?: 'trademarks_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Trademarks_Max_Fields>;
  min?: Maybe<Trademarks_Min_Fields>;
};


/** aggregate fields of "trademarks" */
export type Trademarks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademarks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "trademarks" */
export type Trademarks_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trademarks_Max_Order_By>;
  min?: InputMaybe<Trademarks_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trademarks" */
export type Trademarks_Arr_Rel_Insert_Input = {
  data: Array<Trademarks_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademarks_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trademarks". All fields are combined with a logical 'AND'. */
export type Trademarks_Bool_Exp = {
  _and?: InputMaybe<Array<Trademarks_Bool_Exp>>;
  _not?: InputMaybe<Trademarks_Bool_Exp>;
  _or?: InputMaybe<Array<Trademarks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  goods_or_services_class?: InputMaybe<String_Comparison_Exp>;
  holder_address?: InputMaybe<String_Comparison_Exp>;
  holder_company_name?: InputMaybe<String_Comparison_Exp>;
  holder_country_code?: InputMaybe<String_Comparison_Exp>;
  holder_name?: InputMaybe<String_Comparison_Exp>;
  holder_twitter_slug?: InputMaybe<String_Comparison_Exp>;
  holder_website?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  mark?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  proof_of_ownership_url?: InputMaybe<String_Comparison_Exp>;
  record_link?: InputMaybe<String_Comparison_Exp>;
  registration_number?: InputMaybe<String_Comparison_Exp>;
  registration_office?: InputMaybe<String_Comparison_Exp>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Bool_Exp>;
  spoofing_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trademark_registration_certificate_url?: InputMaybe<String_Comparison_Exp>;
  trademark_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "trademarks" */
export enum Trademarks_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrademarksPkey = 'trademarks_pkey',
  /** unique or primary key constraint on columns "mark", "spoofing_entity_id" */
  TrademarksSpoofingEntityIdMarkKey = 'trademarks_spoofing_entity_id_mark_key'
}

/** input type for inserting data into table "trademarks" */
export type Trademarks_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  goods_or_services_class?: InputMaybe<Scalars['String']>;
  holder_address?: InputMaybe<Scalars['String']>;
  holder_company_name?: InputMaybe<Scalars['String']>;
  /** 2 letters max */
  holder_country_code?: InputMaybe<Scalars['String']>;
  holder_name?: InputMaybe<Scalars['String']>;
  holder_twitter_slug?: InputMaybe<Scalars['String']>;
  holder_website?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  mark?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  proof_of_ownership_url?: InputMaybe<Scalars['String']>;
  record_link?: InputMaybe<Scalars['String']>;
  registration_number?: InputMaybe<Scalars['String']>;
  registration_office?: InputMaybe<Scalars['String']>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Obj_Rel_Insert_Input>;
  spoofing_entity_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  trademark_registration_certificate_url?: InputMaybe<Scalars['String']>;
  trademark_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Trademarks_Max_Fields = {
  __typename?: 'trademarks_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  goods_or_services_class?: Maybe<Scalars['String']>;
  holder_address?: Maybe<Scalars['String']>;
  holder_company_name?: Maybe<Scalars['String']>;
  /** 2 letters max */
  holder_country_code?: Maybe<Scalars['String']>;
  holder_name?: Maybe<Scalars['String']>;
  holder_twitter_slug?: Maybe<Scalars['String']>;
  holder_website?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  mark?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  proof_of_ownership_url?: Maybe<Scalars['String']>;
  record_link?: Maybe<Scalars['String']>;
  registration_number?: Maybe<Scalars['String']>;
  registration_office?: Maybe<Scalars['String']>;
  spoofing_entity_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  trademark_registration_certificate_url?: Maybe<Scalars['String']>;
  trademark_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "trademarks" */
export type Trademarks_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  goods_or_services_class?: InputMaybe<Order_By>;
  holder_address?: InputMaybe<Order_By>;
  holder_company_name?: InputMaybe<Order_By>;
  /** 2 letters max */
  holder_country_code?: InputMaybe<Order_By>;
  holder_name?: InputMaybe<Order_By>;
  holder_twitter_slug?: InputMaybe<Order_By>;
  holder_website?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  mark?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  proof_of_ownership_url?: InputMaybe<Order_By>;
  record_link?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  registration_office?: InputMaybe<Order_By>;
  spoofing_entity_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trademark_registration_certificate_url?: InputMaybe<Order_By>;
  trademark_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trademarks_Min_Fields = {
  __typename?: 'trademarks_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  goods_or_services_class?: Maybe<Scalars['String']>;
  holder_address?: Maybe<Scalars['String']>;
  holder_company_name?: Maybe<Scalars['String']>;
  /** 2 letters max */
  holder_country_code?: Maybe<Scalars['String']>;
  holder_name?: Maybe<Scalars['String']>;
  holder_twitter_slug?: Maybe<Scalars['String']>;
  holder_website?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  mark?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  proof_of_ownership_url?: Maybe<Scalars['String']>;
  record_link?: Maybe<Scalars['String']>;
  registration_number?: Maybe<Scalars['String']>;
  registration_office?: Maybe<Scalars['String']>;
  spoofing_entity_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  trademark_registration_certificate_url?: Maybe<Scalars['String']>;
  trademark_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "trademarks" */
export type Trademarks_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  goods_or_services_class?: InputMaybe<Order_By>;
  holder_address?: InputMaybe<Order_By>;
  holder_company_name?: InputMaybe<Order_By>;
  /** 2 letters max */
  holder_country_code?: InputMaybe<Order_By>;
  holder_name?: InputMaybe<Order_By>;
  holder_twitter_slug?: InputMaybe<Order_By>;
  holder_website?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  mark?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  proof_of_ownership_url?: InputMaybe<Order_By>;
  record_link?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  registration_office?: InputMaybe<Order_By>;
  spoofing_entity_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trademark_registration_certificate_url?: InputMaybe<Order_By>;
  trademark_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trademarks" */
export type Trademarks_Mutation_Response = {
  __typename?: 'trademarks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademarks>;
};

/** input type for inserting object relation for remote table "trademarks" */
export type Trademarks_Obj_Rel_Insert_Input = {
  data: Trademarks_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademarks_On_Conflict>;
};

/** on_conflict condition type for table "trademarks" */
export type Trademarks_On_Conflict = {
  constraint: Trademarks_Constraint;
  update_columns?: Array<Trademarks_Update_Column>;
  where?: InputMaybe<Trademarks_Bool_Exp>;
};

/** Ordering options when selecting data from "trademarks". */
export type Trademarks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  goods_or_services_class?: InputMaybe<Order_By>;
  holder_address?: InputMaybe<Order_By>;
  holder_company_name?: InputMaybe<Order_By>;
  holder_country_code?: InputMaybe<Order_By>;
  holder_name?: InputMaybe<Order_By>;
  holder_twitter_slug?: InputMaybe<Order_By>;
  holder_website?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  mark?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  proof_of_ownership_url?: InputMaybe<Order_By>;
  record_link?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  registration_office?: InputMaybe<Order_By>;
  spoofing_entity?: InputMaybe<Spoofing_Entities_Order_By>;
  spoofing_entity_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trademark_registration_certificate_url?: InputMaybe<Order_By>;
  trademark_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademarks */
export type Trademarks_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "trademarks" */
export enum Trademarks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GoodsOrServicesClass = 'goods_or_services_class',
  /** column name */
  HolderAddress = 'holder_address',
  /** column name */
  HolderCompanyName = 'holder_company_name',
  /** column name */
  HolderCountryCode = 'holder_country_code',
  /** column name */
  HolderName = 'holder_name',
  /** column name */
  HolderTwitterSlug = 'holder_twitter_slug',
  /** column name */
  HolderWebsite = 'holder_website',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Mark = 'mark',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ProofOfOwnershipUrl = 'proof_of_ownership_url',
  /** column name */
  RecordLink = 'record_link',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  RegistrationOffice = 'registration_office',
  /** column name */
  SpoofingEntityId = 'spoofing_entity_id',
  /** column name */
  Status = 'status',
  /** column name */
  TrademarkRegistrationCertificateUrl = 'trademark_registration_certificate_url',
  /** column name */
  TrademarkType = 'trademark_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "trademarks" */
export type Trademarks_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  goods_or_services_class?: InputMaybe<Scalars['String']>;
  holder_address?: InputMaybe<Scalars['String']>;
  holder_company_name?: InputMaybe<Scalars['String']>;
  /** 2 letters max */
  holder_country_code?: InputMaybe<Scalars['String']>;
  holder_name?: InputMaybe<Scalars['String']>;
  holder_twitter_slug?: InputMaybe<Scalars['String']>;
  holder_website?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  mark?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  proof_of_ownership_url?: InputMaybe<Scalars['String']>;
  record_link?: InputMaybe<Scalars['String']>;
  registration_number?: InputMaybe<Scalars['String']>;
  registration_office?: InputMaybe<Scalars['String']>;
  spoofing_entity_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  trademark_registration_certificate_url?: InputMaybe<Scalars['String']>;
  trademark_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "trademarks" */
export type Trademarks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademarks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademarks_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  goods_or_services_class?: InputMaybe<Scalars['String']>;
  holder_address?: InputMaybe<Scalars['String']>;
  holder_company_name?: InputMaybe<Scalars['String']>;
  /** 2 letters max */
  holder_country_code?: InputMaybe<Scalars['String']>;
  holder_name?: InputMaybe<Scalars['String']>;
  holder_twitter_slug?: InputMaybe<Scalars['String']>;
  holder_website?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  mark?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  proof_of_ownership_url?: InputMaybe<Scalars['String']>;
  record_link?: InputMaybe<Scalars['String']>;
  registration_number?: InputMaybe<Scalars['String']>;
  registration_office?: InputMaybe<Scalars['String']>;
  spoofing_entity_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  trademark_registration_certificate_url?: InputMaybe<Scalars['String']>;
  trademark_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "trademarks" */
export enum Trademarks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GoodsOrServicesClass = 'goods_or_services_class',
  /** column name */
  HolderAddress = 'holder_address',
  /** column name */
  HolderCompanyName = 'holder_company_name',
  /** column name */
  HolderCountryCode = 'holder_country_code',
  /** column name */
  HolderName = 'holder_name',
  /** column name */
  HolderTwitterSlug = 'holder_twitter_slug',
  /** column name */
  HolderWebsite = 'holder_website',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  Mark = 'mark',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ProofOfOwnershipUrl = 'proof_of_ownership_url',
  /** column name */
  RecordLink = 'record_link',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  RegistrationOffice = 'registration_office',
  /** column name */
  SpoofingEntityId = 'spoofing_entity_id',
  /** column name */
  Status = 'status',
  /** column name */
  TrademarkRegistrationCertificateUrl = 'trademark_registration_certificate_url',
  /** column name */
  TrademarkType = 'trademark_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Trademarks_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademarks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademarks_Bool_Exp;
};

/** columns and relationships of "uploaded_files" */
export type Uploaded_Files = {
  __typename?: 'uploaded_files';
  created_at: Scalars['timestamptz'];
  file_name: Scalars['String'];
  gcs_path: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  spoofing_report: Spoofing_Reports;
  spoofing_report_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "uploaded_files" */
export type Uploaded_Files_Aggregate = {
  __typename?: 'uploaded_files_aggregate';
  aggregate?: Maybe<Uploaded_Files_Aggregate_Fields>;
  nodes: Array<Uploaded_Files>;
};

/** aggregate fields of "uploaded_files" */
export type Uploaded_Files_Aggregate_Fields = {
  __typename?: 'uploaded_files_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Uploaded_Files_Max_Fields>;
  min?: Maybe<Uploaded_Files_Min_Fields>;
};


/** aggregate fields of "uploaded_files" */
export type Uploaded_Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uploaded_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "uploaded_files". All fields are combined with a logical 'AND'. */
export type Uploaded_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Uploaded_Files_Bool_Exp>>;
  _not?: InputMaybe<Uploaded_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Uploaded_Files_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  gcs_path?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  spoofing_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "uploaded_files" */
export enum Uploaded_Files_Constraint {
  /** unique or primary key constraint on columns "id" */
  UploadedFilesPkey = 'uploaded_files_pkey'
}

/** input type for inserting data into table "uploaded_files" */
export type Uploaded_Files_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_name?: InputMaybe<Scalars['String']>;
  gcs_path?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Obj_Rel_Insert_Input>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Uploaded_Files_Max_Fields = {
  __typename?: 'uploaded_files_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  file_name?: Maybe<Scalars['String']>;
  gcs_path?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Uploaded_Files_Min_Fields = {
  __typename?: 'uploaded_files_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  file_name?: Maybe<Scalars['String']>;
  gcs_path?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  spoofing_report_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "uploaded_files" */
export type Uploaded_Files_Mutation_Response = {
  __typename?: 'uploaded_files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Uploaded_Files>;
};

/** on_conflict condition type for table "uploaded_files" */
export type Uploaded_Files_On_Conflict = {
  constraint: Uploaded_Files_Constraint;
  update_columns?: Array<Uploaded_Files_Update_Column>;
  where?: InputMaybe<Uploaded_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "uploaded_files". */
export type Uploaded_Files_Order_By = {
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  gcs_path?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  spoofing_report?: InputMaybe<Spoofing_Reports_Order_By>;
  spoofing_report_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uploaded_files */
export type Uploaded_Files_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "uploaded_files" */
export enum Uploaded_Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileName = 'file_name',
  /** column name */
  GcsPath = 'gcs_path',
  /** column name */
  Id = 'id',
  /** column name */
  SpoofingReportId = 'spoofing_report_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "uploaded_files" */
export type Uploaded_Files_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_name?: InputMaybe<Scalars['String']>;
  gcs_path?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "uploaded_files" */
export type Uploaded_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uploaded_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uploaded_Files_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_name?: InputMaybe<Scalars['String']>;
  gcs_path?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "uploaded_files" */
export enum Uploaded_Files_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileName = 'file_name',
  /** column name */
  GcsPath = 'gcs_path',
  /** column name */
  Id = 'id',
  /** column name */
  SpoofingReportId = 'spoofing_report_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Uploaded_Files_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uploaded_Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uploaded_Files_Bool_Exp;
};

/** Reports submitted through our in-app bug reporting widget */
export type User_Feedback = {
  __typename?: 'user_feedback';
  collection_report_id?: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  text: Scalars['String'];
  type: Scalars['String'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_feedback" */
export type User_Feedback_Aggregate = {
  __typename?: 'user_feedback_aggregate';
  aggregate?: Maybe<User_Feedback_Aggregate_Fields>;
  nodes: Array<User_Feedback>;
};

/** aggregate fields of "user_feedback" */
export type User_Feedback_Aggregate_Fields = {
  __typename?: 'user_feedback_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Feedback_Max_Fields>;
  min?: Maybe<User_Feedback_Min_Fields>;
};


/** aggregate fields of "user_feedback" */
export type User_Feedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_feedback". All fields are combined with a logical 'AND'. */
export type User_Feedback_Bool_Exp = {
  _and?: InputMaybe<Array<User_Feedback_Bool_Exp>>;
  _not?: InputMaybe<User_Feedback_Bool_Exp>;
  _or?: InputMaybe<Array<User_Feedback_Bool_Exp>>;
  collection_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_feedback" */
export enum User_Feedback_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserReportsPkey = 'user_reports_pkey'
}

/** input type for inserting data into table "user_feedback" */
export type User_Feedback_Insert_Input = {
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Feedback_Max_Fields = {
  __typename?: 'user_feedback_max_fields';
  collection_report_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type User_Feedback_Min_Fields = {
  __typename?: 'user_feedback_min_fields';
  collection_report_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "user_feedback" */
export type User_Feedback_Mutation_Response = {
  __typename?: 'user_feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Feedback>;
};

/** on_conflict condition type for table "user_feedback" */
export type User_Feedback_On_Conflict = {
  constraint: User_Feedback_Constraint;
  update_columns?: Array<User_Feedback_Update_Column>;
  where?: InputMaybe<User_Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "user_feedback". */
export type User_Feedback_Order_By = {
  collection_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_feedback */
export type User_Feedback_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_feedback" */
export enum User_Feedback_Select_Column {
  /** column name */
  CollectionReportId = 'collection_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Text = 'text',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_feedback" */
export type User_Feedback_Set_Input = {
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_feedback" */
export type User_Feedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Feedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Feedback_Stream_Cursor_Value_Input = {
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_feedback" */
export enum User_Feedback_Update_Column {
  /** column name */
  CollectionReportId = 'collection_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Text = 'text',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type User_Feedback_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Feedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Feedback_Bool_Exp;
};

/** Manages user to organizations relationship */
export type User_Organizations = {
  __typename?: 'user_organizations';
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
  /** An object relationship */
  role?: Maybe<Roles>;
  role_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_organizations" */
export type User_Organizations_Aggregate = {
  __typename?: 'user_organizations_aggregate';
  aggregate?: Maybe<User_Organizations_Aggregate_Fields>;
  nodes: Array<User_Organizations>;
};

export type User_Organizations_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Organizations_Aggregate_Bool_Exp_Count>;
};

export type User_Organizations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Organizations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_organizations" */
export type User_Organizations_Aggregate_Fields = {
  __typename?: 'user_organizations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Organizations_Max_Fields>;
  min?: Maybe<User_Organizations_Min_Fields>;
};


/** aggregate fields of "user_organizations" */
export type User_Organizations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_organizations" */
export type User_Organizations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Organizations_Max_Order_By>;
  min?: InputMaybe<User_Organizations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_organizations" */
export type User_Organizations_Arr_Rel_Insert_Input = {
  data: Array<User_Organizations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Organizations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_organizations". All fields are combined with a logical 'AND'. */
export type User_Organizations_Bool_Exp = {
  _and?: InputMaybe<Array<User_Organizations_Bool_Exp>>;
  _not?: InputMaybe<User_Organizations_Bool_Exp>;
  _or?: InputMaybe<Array<User_Organizations_Bool_Exp>>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_organizations" */
export enum User_Organizations_Constraint {
  /** unique or primary key constraint on columns "user_id", "organization_id" */
  UserOrganizationsPkey = 'user_organizations_pkey'
}

/** input type for inserting data into table "user_organizations" */
export type User_Organizations_Insert_Input = {
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Organizations_Max_Fields = {
  __typename?: 'user_organizations_max_fields';
  organization_id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_organizations" */
export type User_Organizations_Max_Order_By = {
  organization_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Organizations_Min_Fields = {
  __typename?: 'user_organizations_min_fields';
  organization_id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_organizations" */
export type User_Organizations_Min_Order_By = {
  organization_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_organizations" */
export type User_Organizations_Mutation_Response = {
  __typename?: 'user_organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Organizations>;
};

/** input type for inserting object relation for remote table "user_organizations" */
export type User_Organizations_Obj_Rel_Insert_Input = {
  data: User_Organizations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Organizations_On_Conflict>;
};

/** on_conflict condition type for table "user_organizations" */
export type User_Organizations_On_Conflict = {
  constraint: User_Organizations_Constraint;
  update_columns?: Array<User_Organizations_Update_Column>;
  where?: InputMaybe<User_Organizations_Bool_Exp>;
};

/** Ordering options when selecting data from "user_organizations". */
export type User_Organizations_Order_By = {
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_organizations */
export type User_Organizations_Pk_Columns_Input = {
  organization_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};

/** select columns of table "user_organizations" */
export enum User_Organizations_Select_Column {
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_organizations" */
export type User_Organizations_Set_Input = {
  organization_id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_organizations" */
export type User_Organizations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Organizations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Organizations_Stream_Cursor_Value_Input = {
  organization_id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_organizations" */
export enum User_Organizations_Update_Column {
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UserId = 'user_id'
}

export type User_Organizations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Organizations_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Organizations_Bool_Exp;
};

/** columns and relationships of "user_products" */
export type User_Products = {
  __typename?: 'user_products';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
  product: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_products" */
export type User_Products_Aggregate = {
  __typename?: 'user_products_aggregate';
  aggregate?: Maybe<User_Products_Aggregate_Fields>;
  nodes: Array<User_Products>;
};

export type User_Products_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Products_Aggregate_Bool_Exp_Count>;
};

export type User_Products_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Products_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_products" */
export type User_Products_Aggregate_Fields = {
  __typename?: 'user_products_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Products_Max_Fields>;
  min?: Maybe<User_Products_Min_Fields>;
};


/** aggregate fields of "user_products" */
export type User_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_products" */
export type User_Products_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Products_Max_Order_By>;
  min?: InputMaybe<User_Products_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_products" */
export type User_Products_Arr_Rel_Insert_Input = {
  data: Array<User_Products_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Products_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_products". All fields are combined with a logical 'AND'. */
export type User_Products_Bool_Exp = {
  _and?: InputMaybe<Array<User_Products_Bool_Exp>>;
  _not?: InputMaybe<User_Products_Bool_Exp>;
  _or?: InputMaybe<Array<User_Products_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_products" */
export enum User_Products_Constraint {
  /** unique or primary key constraint on columns "product", "user_id", "organization_id" */
  UserProductsPkey = 'user_products_pkey'
}

/** input type for inserting data into table "user_products" */
export type User_Products_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Products_Max_Fields = {
  __typename?: 'user_products_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  organization_id?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_products" */
export type User_Products_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Products_Min_Fields = {
  __typename?: 'user_products_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  organization_id?: Maybe<Scalars['uuid']>;
  product?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_products" */
export type User_Products_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_products" */
export type User_Products_Mutation_Response = {
  __typename?: 'user_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Products>;
};

/** on_conflict condition type for table "user_products" */
export type User_Products_On_Conflict = {
  constraint: User_Products_Constraint;
  update_columns?: Array<User_Products_Update_Column>;
  where?: InputMaybe<User_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "user_products". */
export type User_Products_Order_By = {
  created_at?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_products */
export type User_Products_Pk_Columns_Input = {
  organization_id: Scalars['uuid'];
  product: Scalars['String'];
  user_id: Scalars['uuid'];
};

/** select columns of table "user_products" */
export enum User_Products_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Product = 'product',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_products" */
export type User_Products_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_products" */
export type User_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Products_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_products" */
export enum User_Products_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Product = 'product',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Products_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Products_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  app_settings: Scalars['jsonb'];
  /** An array relationship */
  assigned_alerts: Array<Spoofing_Reports>;
  /** An aggregate relationship */
  assigned_alerts_aggregate: Spoofing_Reports_Aggregate;
  created_at: Scalars['timestamp'];
  created_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  email: Scalars['String'];
  has_accepted_tos?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  is_approver: Scalars['Boolean'];
  is_internal: Scalars['Boolean'];
  is_subscribed_daily_summary: Scalars['Boolean'];
  is_visible_temp: Scalars['Boolean'];
  /** An object relationship */
  last_org?: Maybe<Organizations>;
  last_org_context?: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  onboarding_status?: Maybe<Scalars['String']>;
  optery_member_uuid?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
  /** An array relationship */
  organizations: Array<User_Organizations>;
  /** An aggregate relationship */
  organizations_aggregate: User_Organizations_Aggregate;
  /** An array relationship */
  products: Array<User_Products>;
  /** An aggregate relationship */
  products_aggregate: User_Products_Aggregate;
  /** An object relationship */
  role?: Maybe<Roles>;
  role_id?: Maybe<Scalars['uuid']>;
  updated_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
};


/** columns and relationships of "users" */
export type UsersApp_SettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersAssigned_AlertsArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersAssigned_Alerts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Spoofing_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Reports_Order_By>>;
  where?: InputMaybe<Spoofing_Reports_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<User_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Organizations_Order_By>>;
  where?: InputMaybe<User_Organizations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Organizations_Order_By>>;
  where?: InputMaybe<User_Organizations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProductsArgs = {
  distinct_on?: InputMaybe<Array<User_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Products_Order_By>>;
  where?: InputMaybe<User_Products_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Products_Order_By>>;
  where?: InputMaybe<User_Products_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  app_settings?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  app_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  assigned_alerts?: InputMaybe<Spoofing_Reports_Bool_Exp>;
  assigned_alerts_aggregate?: InputMaybe<Spoofing_Reports_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  has_accepted_tos?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_approver?: InputMaybe<Boolean_Comparison_Exp>;
  is_internal?: InputMaybe<Boolean_Comparison_Exp>;
  is_subscribed_daily_summary?: InputMaybe<Boolean_Comparison_Exp>;
  is_visible_temp?: InputMaybe<Boolean_Comparison_Exp>;
  last_org?: InputMaybe<Organizations_Bool_Exp>;
  last_org_context?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  onboarding_status?: InputMaybe<String_Comparison_Exp>;
  optery_member_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  organizations?: InputMaybe<User_Organizations_Bool_Exp>;
  organizations_aggregate?: InputMaybe<User_Organizations_Aggregate_Bool_Exp>;
  products?: InputMaybe<User_Products_Bool_Exp>;
  products_aggregate?: InputMaybe<User_Products_Aggregate_Bool_Exp>;
  role?: InputMaybe<Roles_Bool_Exp>;
  role_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  updated_by_user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "optery_member_uuid" */
  UsersOpteryMemberUuidKey = 'users_optery_member_uuid_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  app_settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  app_settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  app_settings?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  app_settings?: InputMaybe<Scalars['jsonb']>;
  assigned_alerts?: InputMaybe<Spoofing_Reports_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['uuid']>;
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']>;
  has_accepted_tos?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_approver?: InputMaybe<Scalars['Boolean']>;
  is_internal?: InputMaybe<Scalars['Boolean']>;
  is_subscribed_daily_summary?: InputMaybe<Scalars['Boolean']>;
  is_visible_temp?: InputMaybe<Scalars['Boolean']>;
  last_org?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  last_org_context?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  onboarding_status?: InputMaybe<Scalars['String']>;
  optery_member_uuid?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  organizations?: InputMaybe<User_Organizations_Arr_Rel_Insert_Input>;
  products?: InputMaybe<User_Products_Arr_Rel_Insert_Input>;
  role?: InputMaybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['uuid']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
  updated_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_org_context?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  onboarding_status?: Maybe<Scalars['String']>;
  optery_member_uuid?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_org_context?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  onboarding_status?: InputMaybe<Order_By>;
  optery_member_uuid?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  created_by?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_org_context?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  onboarding_status?: Maybe<Scalars['String']>;
  optery_member_uuid?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  updated_by?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_org_context?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  onboarding_status?: InputMaybe<Order_By>;
  optery_member_uuid?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  app_settings?: InputMaybe<Order_By>;
  assigned_alerts_aggregate?: InputMaybe<Spoofing_Reports_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  email?: InputMaybe<Order_By>;
  has_accepted_tos?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_approver?: InputMaybe<Order_By>;
  is_internal?: InputMaybe<Order_By>;
  is_subscribed_daily_summary?: InputMaybe<Order_By>;
  is_visible_temp?: InputMaybe<Order_By>;
  last_org?: InputMaybe<Organizations_Order_By>;
  last_org_context?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  onboarding_status?: InputMaybe<Order_By>;
  optery_member_uuid?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  organizations_aggregate?: InputMaybe<User_Organizations_Aggregate_Order_By>;
  products_aggregate?: InputMaybe<User_Products_Aggregate_Order_By>;
  role?: InputMaybe<Roles_Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  app_settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AppSettings = 'app_settings',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  HasAcceptedTos = 'has_accepted_tos',
  /** column name */
  Id = 'id',
  /** column name */
  IsApprover = 'is_approver',
  /** column name */
  IsInternal = 'is_internal',
  /** column name */
  IsSubscribedDailySummary = 'is_subscribed_daily_summary',
  /** column name */
  IsVisibleTemp = 'is_visible_temp',
  /** column name */
  LastOrgContext = 'last_org_context',
  /** column name */
  Name = 'name',
  /** column name */
  OnboardingStatus = 'onboarding_status',
  /** column name */
  OpteryMemberUuid = 'optery_member_uuid',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasAcceptedTos = 'has_accepted_tos',
  /** column name */
  IsApprover = 'is_approver',
  /** column name */
  IsInternal = 'is_internal',
  /** column name */
  IsSubscribedDailySummary = 'is_subscribed_daily_summary',
  /** column name */
  IsVisibleTemp = 'is_visible_temp'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasAcceptedTos = 'has_accepted_tos',
  /** column name */
  IsApprover = 'is_approver',
  /** column name */
  IsInternal = 'is_internal',
  /** column name */
  IsSubscribedDailySummary = 'is_subscribed_daily_summary',
  /** column name */
  IsVisibleTemp = 'is_visible_temp'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  app_settings?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  has_accepted_tos?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_approver?: InputMaybe<Scalars['Boolean']>;
  is_internal?: InputMaybe<Scalars['Boolean']>;
  is_subscribed_daily_summary?: InputMaybe<Scalars['Boolean']>;
  is_visible_temp?: InputMaybe<Scalars['Boolean']>;
  last_org_context?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  onboarding_status?: InputMaybe<Scalars['String']>;
  optery_member_uuid?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  app_settings?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  created_by?: InputMaybe<Scalars['uuid']>;
  email?: InputMaybe<Scalars['String']>;
  has_accepted_tos?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_approver?: InputMaybe<Scalars['Boolean']>;
  is_internal?: InputMaybe<Scalars['Boolean']>;
  is_subscribed_daily_summary?: InputMaybe<Scalars['Boolean']>;
  is_visible_temp?: InputMaybe<Scalars['Boolean']>;
  last_org_context?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  onboarding_status?: InputMaybe<Scalars['String']>;
  optery_member_uuid?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
  updated_by?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  AppSettings = 'app_settings',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  HasAcceptedTos = 'has_accepted_tos',
  /** column name */
  Id = 'id',
  /** column name */
  IsApprover = 'is_approver',
  /** column name */
  IsInternal = 'is_internal',
  /** column name */
  IsSubscribedDailySummary = 'is_subscribed_daily_summary',
  /** column name */
  IsVisibleTemp = 'is_visible_temp',
  /** column name */
  LastOrgContext = 'last_org_context',
  /** column name */
  Name = 'name',
  /** column name */
  OnboardingStatus = 'onboarding_status',
  /** column name */
  OpteryMemberUuid = 'optery_member_uuid',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedBy = 'updated_by'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['uuid']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['uuid']>>;
  _eq?: InputMaybe<Array<Scalars['uuid']>>;
  _gt?: InputMaybe<Array<Scalars['uuid']>>;
  _gte?: InputMaybe<Array<Scalars['uuid']>>;
  _in?: InputMaybe<Array<Array<Scalars['uuid']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['uuid']>>;
  _lte?: InputMaybe<Array<Scalars['uuid']>>;
  _neq?: InputMaybe<Array<Scalars['uuid']>>;
  _nin?: InputMaybe<Array<Array<Scalars['uuid']>>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "vetric_screenshot_webhooks" */
export type Vetric_Screenshot_Webhooks = {
  __typename?: 'vetric_screenshot_webhooks';
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  /** the id of the entity in our system whose screenshot we are attempting to take */
  platform_entity_id?: Maybe<Scalars['uuid']>;
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: Maybe<Scalars['Int']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: Maybe<Scalars['Int']>;
  url_to_screenshot: Scalars['String'];
  /** the job id for the screenshot request */
  vetric_job_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "vetric_screenshot_webhooks" */
export type Vetric_Screenshot_Webhooks_Aggregate = {
  __typename?: 'vetric_screenshot_webhooks_aggregate';
  aggregate?: Maybe<Vetric_Screenshot_Webhooks_Aggregate_Fields>;
  nodes: Array<Vetric_Screenshot_Webhooks>;
};

/** aggregate fields of "vetric_screenshot_webhooks" */
export type Vetric_Screenshot_Webhooks_Aggregate_Fields = {
  __typename?: 'vetric_screenshot_webhooks_aggregate_fields';
  avg?: Maybe<Vetric_Screenshot_Webhooks_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Vetric_Screenshot_Webhooks_Max_Fields>;
  min?: Maybe<Vetric_Screenshot_Webhooks_Min_Fields>;
  stddev?: Maybe<Vetric_Screenshot_Webhooks_Stddev_Fields>;
  stddev_pop?: Maybe<Vetric_Screenshot_Webhooks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vetric_Screenshot_Webhooks_Stddev_Samp_Fields>;
  sum?: Maybe<Vetric_Screenshot_Webhooks_Sum_Fields>;
  var_pop?: Maybe<Vetric_Screenshot_Webhooks_Var_Pop_Fields>;
  var_samp?: Maybe<Vetric_Screenshot_Webhooks_Var_Samp_Fields>;
  variance?: Maybe<Vetric_Screenshot_Webhooks_Variance_Fields>;
};


/** aggregate fields of "vetric_screenshot_webhooks" */
export type Vetric_Screenshot_Webhooks_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vetric_Screenshot_Webhooks_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Vetric_Screenshot_Webhooks_Avg_Fields = {
  __typename?: 'vetric_screenshot_webhooks_avg_fields';
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: Maybe<Scalars['Float']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vetric_screenshot_webhooks". All fields are combined with a logical 'AND'. */
export type Vetric_Screenshot_Webhooks_Bool_Exp = {
  _and?: InputMaybe<Array<Vetric_Screenshot_Webhooks_Bool_Exp>>;
  _not?: InputMaybe<Vetric_Screenshot_Webhooks_Bool_Exp>;
  _or?: InputMaybe<Array<Vetric_Screenshot_Webhooks_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  platform_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  request_status_code?: InputMaybe<Int_Comparison_Exp>;
  response_status_code?: InputMaybe<Int_Comparison_Exp>;
  url_to_screenshot?: InputMaybe<String_Comparison_Exp>;
  vetric_job_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vetric_screenshot_webhooks" */
export enum Vetric_Screenshot_Webhooks_Constraint {
  /** unique or primary key constraint on columns "id" */
  VetricScreenshotWebhooksPkey = 'vetric_screenshot_webhooks_pkey',
  /** unique or primary key constraint on columns "vetric_job_id" */
  VetricScreenshotWebhooksVetricJobIdKey = 'vetric_screenshot_webhooks_vetric_job_id_key'
}

/** input type for incrementing numeric columns in table "vetric_screenshot_webhooks" */
export type Vetric_Screenshot_Webhooks_Inc_Input = {
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: InputMaybe<Scalars['Int']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vetric_screenshot_webhooks" */
export type Vetric_Screenshot_Webhooks_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** the id of the entity in our system whose screenshot we are attempting to take */
  platform_entity_id?: InputMaybe<Scalars['uuid']>;
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: InputMaybe<Scalars['Int']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: InputMaybe<Scalars['Int']>;
  url_to_screenshot?: InputMaybe<Scalars['String']>;
  /** the job id for the screenshot request */
  vetric_job_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Vetric_Screenshot_Webhooks_Max_Fields = {
  __typename?: 'vetric_screenshot_webhooks_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  /** the id of the entity in our system whose screenshot we are attempting to take */
  platform_entity_id?: Maybe<Scalars['uuid']>;
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: Maybe<Scalars['Int']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: Maybe<Scalars['Int']>;
  url_to_screenshot?: Maybe<Scalars['String']>;
  /** the job id for the screenshot request */
  vetric_job_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Vetric_Screenshot_Webhooks_Min_Fields = {
  __typename?: 'vetric_screenshot_webhooks_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  /** the id of the entity in our system whose screenshot we are attempting to take */
  platform_entity_id?: Maybe<Scalars['uuid']>;
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: Maybe<Scalars['Int']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: Maybe<Scalars['Int']>;
  url_to_screenshot?: Maybe<Scalars['String']>;
  /** the job id for the screenshot request */
  vetric_job_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vetric_screenshot_webhooks" */
export type Vetric_Screenshot_Webhooks_Mutation_Response = {
  __typename?: 'vetric_screenshot_webhooks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Vetric_Screenshot_Webhooks>;
};

/** on_conflict condition type for table "vetric_screenshot_webhooks" */
export type Vetric_Screenshot_Webhooks_On_Conflict = {
  constraint: Vetric_Screenshot_Webhooks_Constraint;
  update_columns?: Array<Vetric_Screenshot_Webhooks_Update_Column>;
  where?: InputMaybe<Vetric_Screenshot_Webhooks_Bool_Exp>;
};

/** Ordering options when selecting data from "vetric_screenshot_webhooks". */
export type Vetric_Screenshot_Webhooks_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform_entity_id?: InputMaybe<Order_By>;
  request_status_code?: InputMaybe<Order_By>;
  response_status_code?: InputMaybe<Order_By>;
  url_to_screenshot?: InputMaybe<Order_By>;
  vetric_job_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vetric_screenshot_webhooks */
export type Vetric_Screenshot_Webhooks_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "vetric_screenshot_webhooks" */
export enum Vetric_Screenshot_Webhooks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformEntityId = 'platform_entity_id',
  /** column name */
  RequestStatusCode = 'request_status_code',
  /** column name */
  ResponseStatusCode = 'response_status_code',
  /** column name */
  UrlToScreenshot = 'url_to_screenshot',
  /** column name */
  VetricJobId = 'vetric_job_id'
}

/** input type for updating data in table "vetric_screenshot_webhooks" */
export type Vetric_Screenshot_Webhooks_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** the id of the entity in our system whose screenshot we are attempting to take */
  platform_entity_id?: InputMaybe<Scalars['uuid']>;
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: InputMaybe<Scalars['Int']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: InputMaybe<Scalars['Int']>;
  url_to_screenshot?: InputMaybe<Scalars['String']>;
  /** the job id for the screenshot request */
  vetric_job_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Vetric_Screenshot_Webhooks_Stddev_Fields = {
  __typename?: 'vetric_screenshot_webhooks_stddev_fields';
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: Maybe<Scalars['Float']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Vetric_Screenshot_Webhooks_Stddev_Pop_Fields = {
  __typename?: 'vetric_screenshot_webhooks_stddev_pop_fields';
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: Maybe<Scalars['Float']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Vetric_Screenshot_Webhooks_Stddev_Samp_Fields = {
  __typename?: 'vetric_screenshot_webhooks_stddev_samp_fields';
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: Maybe<Scalars['Float']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "vetric_screenshot_webhooks" */
export type Vetric_Screenshot_Webhooks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vetric_Screenshot_Webhooks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vetric_Screenshot_Webhooks_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** the id of the entity in our system whose screenshot we are attempting to take */
  platform_entity_id?: InputMaybe<Scalars['uuid']>;
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: InputMaybe<Scalars['Int']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: InputMaybe<Scalars['Int']>;
  url_to_screenshot?: InputMaybe<Scalars['String']>;
  /** the job id for the screenshot request */
  vetric_job_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Vetric_Screenshot_Webhooks_Sum_Fields = {
  __typename?: 'vetric_screenshot_webhooks_sum_fields';
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: Maybe<Scalars['Int']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: Maybe<Scalars['Int']>;
};

/** update columns of table "vetric_screenshot_webhooks" */
export enum Vetric_Screenshot_Webhooks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformEntityId = 'platform_entity_id',
  /** column name */
  RequestStatusCode = 'request_status_code',
  /** column name */
  ResponseStatusCode = 'response_status_code',
  /** column name */
  UrlToScreenshot = 'url_to_screenshot',
  /** column name */
  VetricJobId = 'vetric_job_id'
}

export type Vetric_Screenshot_Webhooks_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Vetric_Screenshot_Webhooks_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vetric_Screenshot_Webhooks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vetric_Screenshot_Webhooks_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Vetric_Screenshot_Webhooks_Var_Pop_Fields = {
  __typename?: 'vetric_screenshot_webhooks_var_pop_fields';
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: Maybe<Scalars['Float']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Vetric_Screenshot_Webhooks_Var_Samp_Fields = {
  __typename?: 'vetric_screenshot_webhooks_var_samp_fields';
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: Maybe<Scalars['Float']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Vetric_Screenshot_Webhooks_Variance_Fields = {
  __typename?: 'vetric_screenshot_webhooks_variance_fields';
  /** the status code returned by vetric when we initiate the screenshot request */
  request_status_code?: Maybe<Scalars['Float']>;
  /** the status code of the screenshot webhook sent by vetric */
  response_status_code?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "webhook_targets" */
export type Webhook_Targets = {
  __typename?: 'webhook_targets';
  created_at: Scalars['timestamptz'];
  custom_fields?: Maybe<Scalars['jsonb']>;
  event_type: Scalars['String'];
  id: Scalars['uuid'];
  integration_type?: Maybe<Scalars['String']>;
  is_external?: Maybe<Scalars['Boolean']>;
  last_triggered?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  organization: Organizations;
  organization_id: Scalars['uuid'];
  status: Scalars['String'];
  target_url: Scalars['String'];
  token_name?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "webhook_targets" */
export type Webhook_TargetsCustom_FieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "webhook_targets" */
export type Webhook_Targets_Aggregate = {
  __typename?: 'webhook_targets_aggregate';
  aggregate?: Maybe<Webhook_Targets_Aggregate_Fields>;
  nodes: Array<Webhook_Targets>;
};

/** aggregate fields of "webhook_targets" */
export type Webhook_Targets_Aggregate_Fields = {
  __typename?: 'webhook_targets_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Webhook_Targets_Max_Fields>;
  min?: Maybe<Webhook_Targets_Min_Fields>;
};


/** aggregate fields of "webhook_targets" */
export type Webhook_Targets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Webhook_Targets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Webhook_Targets_Append_Input = {
  custom_fields?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "webhook_targets". All fields are combined with a logical 'AND'. */
export type Webhook_Targets_Bool_Exp = {
  _and?: InputMaybe<Array<Webhook_Targets_Bool_Exp>>;
  _not?: InputMaybe<Webhook_Targets_Bool_Exp>;
  _or?: InputMaybe<Array<Webhook_Targets_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  integration_type?: InputMaybe<String_Comparison_Exp>;
  is_external?: InputMaybe<Boolean_Comparison_Exp>;
  last_triggered?: InputMaybe<Timestamptz_Comparison_Exp>;
  organization?: InputMaybe<Organizations_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  target_url?: InputMaybe<String_Comparison_Exp>;
  token_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "webhook_targets" */
export enum Webhook_Targets_Constraint {
  /** unique or primary key constraint on columns "organization_id", "event_type", "target_url" */
  WebhookTargetsOrganizationIdEventTypeTargetUrlKey = 'webhook_targets_organization_id_event_type_target_url_key',
  /** unique or primary key constraint on columns "id" */
  WebhookTargetsPkey = 'webhook_targets_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Webhook_Targets_Delete_At_Path_Input = {
  custom_fields?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Webhook_Targets_Delete_Elem_Input = {
  custom_fields?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Webhook_Targets_Delete_Key_Input = {
  custom_fields?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "webhook_targets" */
export type Webhook_Targets_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_fields?: InputMaybe<Scalars['jsonb']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  integration_type?: InputMaybe<Scalars['String']>;
  is_external?: InputMaybe<Scalars['Boolean']>;
  last_triggered?: InputMaybe<Scalars['timestamptz']>;
  organization?: InputMaybe<Organizations_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  target_url?: InputMaybe<Scalars['String']>;
  token_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Webhook_Targets_Max_Fields = {
  __typename?: 'webhook_targets_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  integration_type?: Maybe<Scalars['String']>;
  last_triggered?: Maybe<Scalars['timestamptz']>;
  organization_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  target_url?: Maybe<Scalars['String']>;
  token_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Webhook_Targets_Min_Fields = {
  __typename?: 'webhook_targets_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  event_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  integration_type?: Maybe<Scalars['String']>;
  last_triggered?: Maybe<Scalars['timestamptz']>;
  organization_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  target_url?: Maybe<Scalars['String']>;
  token_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "webhook_targets" */
export type Webhook_Targets_Mutation_Response = {
  __typename?: 'webhook_targets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Webhook_Targets>;
};

/** on_conflict condition type for table "webhook_targets" */
export type Webhook_Targets_On_Conflict = {
  constraint: Webhook_Targets_Constraint;
  update_columns?: Array<Webhook_Targets_Update_Column>;
  where?: InputMaybe<Webhook_Targets_Bool_Exp>;
};

/** Ordering options when selecting data from "webhook_targets". */
export type Webhook_Targets_Order_By = {
  created_at?: InputMaybe<Order_By>;
  custom_fields?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  integration_type?: InputMaybe<Order_By>;
  is_external?: InputMaybe<Order_By>;
  last_triggered?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organizations_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_url?: InputMaybe<Order_By>;
  token_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: webhook_targets */
export type Webhook_Targets_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Webhook_Targets_Prepend_Input = {
  custom_fields?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "webhook_targets" */
export enum Webhook_Targets_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationType = 'integration_type',
  /** column name */
  IsExternal = 'is_external',
  /** column name */
  LastTriggered = 'last_triggered',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Status = 'status',
  /** column name */
  TargetUrl = 'target_url',
  /** column name */
  TokenName = 'token_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "webhook_targets" */
export type Webhook_Targets_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_fields?: InputMaybe<Scalars['jsonb']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  integration_type?: InputMaybe<Scalars['String']>;
  is_external?: InputMaybe<Scalars['Boolean']>;
  last_triggered?: InputMaybe<Scalars['timestamptz']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  target_url?: InputMaybe<Scalars['String']>;
  token_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "webhook_targets" */
export type Webhook_Targets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Webhook_Targets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Webhook_Targets_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_fields?: InputMaybe<Scalars['jsonb']>;
  event_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  integration_type?: InputMaybe<Scalars['String']>;
  is_external?: InputMaybe<Scalars['Boolean']>;
  last_triggered?: InputMaybe<Scalars['timestamptz']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  target_url?: InputMaybe<Scalars['String']>;
  token_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "webhook_targets" */
export enum Webhook_Targets_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  IntegrationType = 'integration_type',
  /** column name */
  IsExternal = 'is_external',
  /** column name */
  LastTriggered = 'last_triggered',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Status = 'status',
  /** column name */
  TargetUrl = 'target_url',
  /** column name */
  TokenName = 'token_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Webhook_Targets_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Webhook_Targets_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Webhook_Targets_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Webhook_Targets_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Webhook_Targets_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Webhook_Targets_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Webhook_Targets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Webhook_Targets_Bool_Exp;
};

export type Domain_DataFragment = { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null };

export type Social_Media_DataFragment = { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null };

export type Phone_NumberFragment = { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any };

export type Social_Media_PostFragment = { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null };

export type Social_Media_GroupFragment = { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null };

export type Ecommerce_ListingFragment = { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null };

export type Mobile_AppFragment = { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string };

export type Full_UrlFragment = { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } };

export type EmailFragment = { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null };

export type Email_CorrespondenceFragment = { __typename?: 'email_correspondence', created_at: any, body: string, sender: string, receiver: string, correspondence_type: string, message_id?: string | null, thread_id: string, user?: { __typename?: 'users', name: string } | null };

export type Dark_WebFragment = { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null };

export type Advertisement_DataFragment = { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null };

export type Platform_SubtypeFragment = { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string };

export type Spoof_MatchFragment = { __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> };

export type Spoofing_Report_Without_EnforcementsFragment = { __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> }, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null };

export type Spoofing_ReportFragment = { __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, status: string, platform: string, submission_external_id?: string | null, type: string, updated_at: any, collection_report_changes: Array<{ __typename?: 'collection_report_changes', timestamp: any }> }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> }, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null };

export type OrganizationFragment = { __typename?: 'organizations', id: any, created_at: any, name: string, organization_type: any, organization_email?: string | null, is_report_form_enabled?: boolean | null, is_original_ip_holder?: boolean | null, is_web2_enabled: boolean, organization_status: any, is_app_detection_enabled: boolean, is_paid_ads_detection_enabled: boolean, is_email_detection_enabled: boolean, is_crypto_detection_enabled: boolean, is_ecommerce_detection_enabled: boolean, is_dark_web_detection_enabled: boolean, approved_domains?: any | null, approved_emails?: any | null, analytics_summary_recipient_emails?: any | null, salesforce_account_id?: string | null, auth_configs?: any | null, is_social_media_detection_enabled: boolean, is_dark_market_detection_enabled: boolean, is_nft_detection_enabled: boolean, is_telco_detection_enabled: boolean, is_pii_detection_enabled: boolean, is_domain_purchasing_enabled: boolean, is_suspicious_emails_enabled?: boolean | null, is_email_abuse_box_enabled?: boolean | null, is_phishing_sim_enabled: boolean, is_code_repos_detection_enabled: boolean, customer_type: string, slack_access_token?: string | null, rubric_link?: string | null, abbr_name?: string | null, is_parent?: boolean | null, users: Array<{ __typename?: 'users', id: any, name: string, email: string, created_at: any, is_internal: boolean }>, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }>, enforcement_metadata?: { __typename?: 'enforcement_metadata', authorization_letter_url?: string | null, enforcement_email?: string | null, legal_name?: string | null, country_code?: string | null, authorization_letter_url_expiration_date?: any | null, allowed_domain_enforcement_types: any } | null, children: Array<{ __typename?: 'organizations', name: string, organization_users: Array<{ __typename?: 'user_organizations', user: { __typename?: 'users', email: string } }> }> };

export type Organization_InternalFragment = { __typename?: 'organizations', id: any, created_at: any, name: string, organization_type: any, is_report_form_enabled?: boolean | null, is_original_ip_holder?: boolean | null, is_web2_enabled: boolean, organization_status: any, is_app_detection_enabled: boolean, is_paid_ads_detection_enabled: boolean, is_email_detection_enabled: boolean, is_crypto_detection_enabled: boolean, is_ecommerce_detection_enabled: boolean, is_dark_web_detection_enabled: boolean, is_telco_detection_enabled: boolean, is_phishing_sim_enabled: boolean, is_code_repos_detection_enabled: boolean, is_pii_detection_enabled: boolean, is_domain_purchasing_enabled: boolean, approved_domains?: any | null, approved_emails?: any | null, analytics_summary_recipient_emails?: any | null, salesforce_account_id?: string | null, auth_configs?: any | null, is_social_media_detection_enabled: boolean, is_dark_market_detection_enabled: boolean, is_nft_detection_enabled: boolean, is_suspicious_emails_enabled?: boolean | null, is_email_abuse_box_enabled?: boolean | null, customer_type: string, slack_access_token?: string | null, rubric_link?: string | null, abbr_name?: string | null, customer_point_of_contact_email?: string | null, is_parent?: boolean | null, users: Array<{ __typename?: 'users', id: any, name: string, email: string, created_at: any, is_internal: boolean }>, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }>, enforcement_metadata?: { __typename?: 'enforcement_metadata', authorization_letter_url?: string | null, enforcement_email?: string | null, legal_name?: string | null, country_code?: string | null, authorization_letter_url_expiration_date?: any | null, allowed_domain_enforcement_types: any } | null, point_of_contact?: { __typename?: 'users', id: any, name: string, email: string } | null, children: Array<{ __typename?: 'organizations', name: string }>, parent?: { __typename?: 'organizations', name: string, id: any } | null };

export type Hourly_Spoofing_Report_StatsFragment = { __typename?: 'hourly_spoofing_reports_stats', id: any, date: any, report_type?: string | null, total_count: number, total_reported_count: number, total_resolved_count: number, median_latency_detected_to_reported?: any | null, median_latency_reported_to_first_mitigated?: any | null, median_latency_reported_to_delisted?: any | null, created_at: any, organization_id: any, original_entity_id?: any | null, spoofing_entity?: { __typename?: 'spoofing_entities', id: any, entity_name: string } | null };

export type Enforcement_RequestsFragment = { __typename?: 'enforcement_requests', id: any, updated_at: any, type: string, platform: string, status: string, submission_proof_url?: string | null, submitted_at?: any | null, reason?: string | null, submission_external_id?: string | null, created_at: any, submission_email?: string | null, submission_source?: string | null, retraction_description?: string | null, retraction_proof_url?: string | null, user?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null };

export type HandleAdminUrlSearchRequestMutationVariables = Exact<{
  handle_admin_url_search_request_input: HandleAdminUrlSearchRequestInput;
}>;


export type HandleAdminUrlSearchRequestMutation = { __typename?: 'mutation_root', handle_admin_url_search_request: { __typename?: 'HandleAdminUrlSearchRequestOutput', response?: any | null } };

export type HandleAutoActioningAlertSelectionMutationVariables = Exact<{
  handle_auto_actioning_alert_selection_input: HandleAutoActioningAlertSelectionInput;
}>;


export type HandleAutoActioningAlertSelectionMutation = { __typename?: 'mutation_root', handle_auto_actioning_alert_selection?: { __typename?: 'HandleAutoActioningAlertSelectionOutput', results?: any | null } | null };

export type GetReportStateChangesQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetReportStateChangesQuery = { __typename?: 'query_root', collection_report_state_changes: Array<{ __typename?: 'collection_report_state_changes', id: any, new_state: string, previous_state: string, reason_for_change?: string | null, timestamp_of_change: any, user?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null }> };

export type GetSpoofingReportsStatsFilterQueryVariables = Exact<{
  dates?: InputMaybe<Array<Scalars['date']> | Scalars['date']>;
  organization_id: Scalars['uuid'];
}>;


export type GetSpoofingReportsStatsFilterQuery = { __typename?: 'query_root', hourly_spoofing_reports_stats: Array<{ __typename?: 'hourly_spoofing_reports_stats', id: any, date: any, report_type?: string | null, total_count: number, total_reported_count: number, total_resolved_count: number, median_latency_detected_to_reported?: any | null, median_latency_reported_to_first_mitigated?: any | null, median_latency_reported_to_delisted?: any | null, created_at: any, organization_id: any, original_entity_id?: any | null, spoofing_entity?: { __typename?: 'spoofing_entities', id: any, entity_name: string } | null }> };

export type GetAlertsByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  includeCreditCardData?: Scalars['Boolean'];
}>;


export type GetAlertsByIdsQuery = { __typename?: 'query_root', spoofing_reports: Array<{ __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, status: string, platform: string, submission_external_id?: string | null, type: string, updated_at: any, collection_report_changes: Array<{ __typename?: 'collection_report_changes', timestamp: any }> }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> }, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null }> };

export type GetAlertsByIdsPaginatedQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  includeCreditCardData?: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by: Array<Spoofing_Reports_Order_By> | Spoofing_Reports_Order_By;
}>;


export type GetAlertsByIdsPaginatedQuery = { __typename?: 'query_root', spoofing_reports: Array<{ __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, status: string, platform: string, submission_external_id?: string | null, type: string, updated_at: any, collection_report_changes: Array<{ __typename?: 'collection_report_changes', timestamp: any }> }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> }, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null }>, spoofing_reports_aggregate: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null } };

export type GetSpoofingReportsStatsQueryVariables = Exact<{
  date_from: Scalars['date'];
  date_to?: InputMaybe<Scalars['date']>;
  organization_id: Scalars['uuid'];
}>;


export type GetSpoofingReportsStatsQuery = { __typename?: 'query_root', hourly_spoofing_reports_stats: Array<{ __typename?: 'hourly_spoofing_reports_stats', id: any, date: any, report_type?: string | null, total_count: number, total_reported_count: number, total_resolved_count: number, median_latency_detected_to_reported?: any | null, median_latency_reported_to_first_mitigated?: any | null, median_latency_reported_to_delisted?: any | null, created_at: any, organization_id: any, original_entity_id?: any | null, spoofing_entity?: { __typename?: 'spoofing_entities', id: any, entity_name: string } | null }> };

export type LoadFreeTrialEndedQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
}>;


export type LoadFreeTrialEndedQuery = { __typename?: 'query_root', organizations_by_pk?: { __typename?: 'organizations', name: string } | null, users_by_pk?: { __typename?: 'users', name: string } | null };

export type GetOrganizationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy: Array<Organizations_Order_By> | Organizations_Order_By;
  organizationsWhere?: InputMaybe<Organizations_Bool_Exp>;
}>;


export type GetOrganizationsQuery = { __typename?: 'query_root', organizations: Array<{ __typename?: 'organizations', id: any, created_at: any, name: string, organization_type: any, is_report_form_enabled?: boolean | null, is_original_ip_holder?: boolean | null, is_web2_enabled: boolean, organization_status: any, is_app_detection_enabled: boolean, is_paid_ads_detection_enabled: boolean, is_email_detection_enabled: boolean, is_crypto_detection_enabled: boolean, is_ecommerce_detection_enabled: boolean, is_dark_web_detection_enabled: boolean, is_telco_detection_enabled: boolean, is_phishing_sim_enabled: boolean, is_code_repos_detection_enabled: boolean, is_pii_detection_enabled: boolean, is_domain_purchasing_enabled: boolean, approved_domains?: any | null, approved_emails?: any | null, analytics_summary_recipient_emails?: any | null, salesforce_account_id?: string | null, auth_configs?: any | null, is_social_media_detection_enabled: boolean, is_dark_market_detection_enabled: boolean, is_nft_detection_enabled: boolean, is_suspicious_emails_enabled?: boolean | null, is_email_abuse_box_enabled?: boolean | null, customer_type: string, slack_access_token?: string | null, rubric_link?: string | null, abbr_name?: string | null, customer_point_of_contact_email?: string | null, is_parent?: boolean | null, users: Array<{ __typename?: 'users', id: any, name: string, email: string, created_at: any, is_internal: boolean }>, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }>, enforcement_metadata?: { __typename?: 'enforcement_metadata', authorization_letter_url?: string | null, enforcement_email?: string | null, legal_name?: string | null, country_code?: string | null, authorization_letter_url_expiration_date?: any | null, allowed_domain_enforcement_types: any } | null, point_of_contact?: { __typename?: 'users', id: any, name: string, email: string } | null, children: Array<{ __typename?: 'organizations', name: string }>, parent?: { __typename?: 'organizations', name: string, id: any } | null }> };

export type GetUsersQueryVariables = Exact<{
  usersWhere?: InputMaybe<Users_Bool_Exp>;
}>;


export type GetUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email: string, name: string, is_internal: boolean, created_at: any }> };

export type GetOrganizationsCountQueryVariables = Exact<{
  organizationsWhere: Organizations_Bool_Exp;
}>;


export type GetOrganizationsCountQuery = { __typename?: 'query_root', organizations_aggregate: { __typename?: 'organizations_aggregate', aggregate?: { __typename?: 'organizations_aggregate_fields', count: number } | null } };

export type GetOrganizationMetadataByOrgAndKeyQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
  key: Scalars['String'];
}>;


export type GetOrganizationMetadataByOrgAndKeyQuery = { __typename?: 'query_root', organizations_metadata: Array<{ __typename?: 'organizations_metadata', organization_id: any, key: string, value: string, created_at: any }> };

export type OrganizationQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
}>;


export type OrganizationQuery = { __typename?: 'query_root', organizations_by_pk?: { __typename?: 'organizations', id: any, created_at: any, name: string, organization_type: any, organization_email?: string | null, is_report_form_enabled?: boolean | null, is_original_ip_holder?: boolean | null, is_web2_enabled: boolean, organization_status: any, is_app_detection_enabled: boolean, is_paid_ads_detection_enabled: boolean, is_email_detection_enabled: boolean, is_crypto_detection_enabled: boolean, is_ecommerce_detection_enabled: boolean, is_dark_web_detection_enabled: boolean, approved_domains?: any | null, approved_emails?: any | null, analytics_summary_recipient_emails?: any | null, salesforce_account_id?: string | null, auth_configs?: any | null, is_social_media_detection_enabled: boolean, is_dark_market_detection_enabled: boolean, is_nft_detection_enabled: boolean, is_telco_detection_enabled: boolean, is_pii_detection_enabled: boolean, is_domain_purchasing_enabled: boolean, is_suspicious_emails_enabled?: boolean | null, is_email_abuse_box_enabled?: boolean | null, is_phishing_sim_enabled: boolean, is_code_repos_detection_enabled: boolean, customer_type: string, slack_access_token?: string | null, rubric_link?: string | null, abbr_name?: string | null, is_parent?: boolean | null, users: Array<{ __typename?: 'users', id: any, name: string, email: string, created_at: any, is_internal: boolean }>, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }>, enforcement_metadata?: { __typename?: 'enforcement_metadata', authorization_letter_url?: string | null, enforcement_email?: string | null, legal_name?: string | null, country_code?: string | null, authorization_letter_url_expiration_date?: any | null, allowed_domain_enforcement_types: any } | null, children: Array<{ __typename?: 'organizations', name: string, organization_users: Array<{ __typename?: 'user_organizations', user: { __typename?: 'users', email: string } }> }> } | null };

export type RequestBulkScrapeMutationVariables = Exact<{
  collection_reports: Array<InputMaybe<RequestBulkScrapeInput>> | InputMaybe<RequestBulkScrapeInput>;
}>;


export type RequestBulkScrapeMutation = { __typename?: 'mutation_root', request_bulk_scrape: { __typename?: 'RequestBulkScrapeOutput', collections_to_scrape: number } };

export type GetLastOrgContextQueryVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type GetLastOrgContextQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, last_org_context?: any | null, last_org?: { __typename?: 'organizations', id: any, created_at: any, name: string, organization_type: any, organization_email?: string | null, is_report_form_enabled?: boolean | null, is_original_ip_holder?: boolean | null, is_web2_enabled: boolean, organization_status: any, is_app_detection_enabled: boolean, is_paid_ads_detection_enabled: boolean, is_email_detection_enabled: boolean, is_crypto_detection_enabled: boolean, is_ecommerce_detection_enabled: boolean, is_dark_web_detection_enabled: boolean, approved_domains?: any | null, approved_emails?: any | null, analytics_summary_recipient_emails?: any | null, salesforce_account_id?: string | null, auth_configs?: any | null, is_social_media_detection_enabled: boolean, is_dark_market_detection_enabled: boolean, is_nft_detection_enabled: boolean, is_telco_detection_enabled: boolean, is_pii_detection_enabled: boolean, is_domain_purchasing_enabled: boolean, is_suspicious_emails_enabled?: boolean | null, is_email_abuse_box_enabled?: boolean | null, is_phishing_sim_enabled: boolean, is_code_repos_detection_enabled: boolean, customer_type: string, slack_access_token?: string | null, rubric_link?: string | null, abbr_name?: string | null, is_parent?: boolean | null, users: Array<{ __typename?: 'users', id: any, name: string, email: string, created_at: any, is_internal: boolean }>, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }>, enforcement_metadata?: { __typename?: 'enforcement_metadata', authorization_letter_url?: string | null, enforcement_email?: string | null, legal_name?: string | null, country_code?: string | null, authorization_letter_url_expiration_date?: any | null, allowed_domain_enforcement_types: any } | null, children: Array<{ __typename?: 'organizations', name: string, organization_users: Array<{ __typename?: 'user_organizations', user: { __typename?: 'users', email: string } }> }> } | null } | null };

export type UpdateLastOrgContextMutationVariables = Exact<{
  last_org_context: Scalars['uuid'];
  id: Scalars['uuid'];
}>;


export type UpdateLastOrgContextMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, last_org_context?: any | null, last_org?: { __typename?: 'organizations', id: any, created_at: any, name: string, organization_type: any, organization_email?: string | null, is_report_form_enabled?: boolean | null, is_original_ip_holder?: boolean | null, is_web2_enabled: boolean, organization_status: any, is_app_detection_enabled: boolean, is_paid_ads_detection_enabled: boolean, is_email_detection_enabled: boolean, is_crypto_detection_enabled: boolean, is_ecommerce_detection_enabled: boolean, is_dark_web_detection_enabled: boolean, approved_domains?: any | null, approved_emails?: any | null, analytics_summary_recipient_emails?: any | null, salesforce_account_id?: string | null, auth_configs?: any | null, is_social_media_detection_enabled: boolean, is_dark_market_detection_enabled: boolean, is_nft_detection_enabled: boolean, is_telco_detection_enabled: boolean, is_pii_detection_enabled: boolean, is_domain_purchasing_enabled: boolean, is_suspicious_emails_enabled?: boolean | null, is_email_abuse_box_enabled?: boolean | null, is_phishing_sim_enabled: boolean, is_code_repos_detection_enabled: boolean, customer_type: string, slack_access_token?: string | null, rubric_link?: string | null, abbr_name?: string | null, is_parent?: boolean | null, users: Array<{ __typename?: 'users', id: any, name: string, email: string, created_at: any, is_internal: boolean }>, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }>, enforcement_metadata?: { __typename?: 'enforcement_metadata', authorization_letter_url?: string | null, enforcement_email?: string | null, legal_name?: string | null, country_code?: string | null, authorization_letter_url_expiration_date?: any | null, allowed_domain_enforcement_types: any } | null, children: Array<{ __typename?: 'organizations', name: string, organization_users: Array<{ __typename?: 'user_organizations', user: { __typename?: 'users', email: string } }> }> } | null } | null };

export type InsertTagForReportsMutationVariables = Exact<{
  tagInsertionsInput: Array<Report_Tags_Insert_Input> | Report_Tags_Insert_Input;
}>;


export type InsertTagForReportsMutation = { __typename?: 'mutation_root', insert_report_tags?: { __typename?: 'report_tags_mutation_response', affected_rows: number } | null };

export type GetSpoofingReportsWithFullOrganizationQueryVariables = Exact<{
  spoofingReportsWhere: Spoofing_Reports_Bool_Exp;
  includeCreditCardData?: Scalars['Boolean'];
}>;


export type GetSpoofingReportsWithFullOrganizationQuery = { __typename?: 'query_root', spoofing_reports: Array<{ __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, created_at: any, organization_type: any, organization_email?: string | null, is_report_form_enabled?: boolean | null, is_original_ip_holder?: boolean | null, is_web2_enabled: boolean, organization_status: any, is_app_detection_enabled: boolean, is_paid_ads_detection_enabled: boolean, is_email_detection_enabled: boolean, is_crypto_detection_enabled: boolean, is_ecommerce_detection_enabled: boolean, is_dark_web_detection_enabled: boolean, approved_domains?: any | null, approved_emails?: any | null, analytics_summary_recipient_emails?: any | null, salesforce_account_id?: string | null, auth_configs?: any | null, is_social_media_detection_enabled: boolean, is_dark_market_detection_enabled: boolean, is_nft_detection_enabled: boolean, is_telco_detection_enabled: boolean, is_pii_detection_enabled: boolean, is_domain_purchasing_enabled: boolean, is_suspicious_emails_enabled?: boolean | null, is_email_abuse_box_enabled?: boolean | null, is_phishing_sim_enabled: boolean, is_code_repos_detection_enabled: boolean, customer_type: string, slack_access_token?: string | null, rubric_link?: string | null, is_parent?: boolean | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }>, users: Array<{ __typename?: 'users', id: any, name: string, email: string, created_at: any, is_internal: boolean }>, enforcement_metadata?: { __typename?: 'enforcement_metadata', authorization_letter_url?: string | null, enforcement_email?: string | null, legal_name?: string | null, country_code?: string | null, authorization_letter_url_expiration_date?: any | null, allowed_domain_enforcement_types: any } | null, children: Array<{ __typename?: 'organizations', name: string, organization_users: Array<{ __typename?: 'user_organizations', user: { __typename?: 'users', email: string } }> }> }, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, status: string, platform: string, submission_external_id?: string | null, type: string, updated_at: any, collection_report_changes: Array<{ __typename?: 'collection_report_changes', timestamp: any }> }>, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null }> };

export type SubmitUserFeedbackMutationVariables = Exact<{
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
}>;


export type SubmitUserFeedbackMutation = { __typename?: 'mutation_root', insert_user_feedback_one?: { __typename?: 'user_feedback', id: any } | null };

export type SpoofingReportsAutocompleteQueryVariables = Exact<{
  limit: Scalars['Int'];
  spoofingReportsWhere: Spoofing_Reports_Bool_Exp;
  searchKey?: InputMaybe<Scalars['String']>;
}>;


export type SpoofingReportsAutocompleteQuery = { __typename?: 'query_root', search_spoofing_reports: Array<{ __typename?: 'spoofing_reports', id: any, flagged_url: string, report_status: string, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, full_url?: { __typename?: 'full_urls', id: any, url: string } | null }> }> };

export type GetSpoofingReportsQueryVariables = Exact<{
  spoofingReportsWhere: Spoofing_Reports_Bool_Exp;
  orderBy: Array<Spoofing_Reports_Order_By> | Spoofing_Reports_Order_By;
  includeCreditCardData?: Scalars['Boolean'];
}>;


export type GetSpoofingReportsQuery = { __typename?: 'query_root', spoofing_reports: Array<{ __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, status: string, platform: string, submission_external_id?: string | null, type: string, updated_at: any, collection_report_changes: Array<{ __typename?: 'collection_report_changes', timestamp: any }> }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> }, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null }> };

export type SearchSpoofingReportsQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  refresh: Scalars['Boolean'];
  spoofingReportsWhere: Spoofing_Reports_Bool_Exp;
  skipNormalSearch: Scalars['Boolean'];
  skipFullTextSearch: Scalars['Boolean'];
  orderBy: Array<Spoofing_Reports_Order_By> | Spoofing_Reports_Order_By;
  searchKey?: InputMaybe<Scalars['String']>;
  includeCreditCardData?: Scalars['Boolean'];
}>;


export type SearchSpoofingReportsQuery = { __typename?: 'query_root', spoofing_reports?: Array<{ __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, status: string, platform: string, submission_external_id?: string | null, type: string, updated_at: any, collection_report_changes: Array<{ __typename?: 'collection_report_changes', timestamp: any }> }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> }, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null }>, search_spoofing_reports?: Array<{ __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, status: string, platform: string, submission_external_id?: string | null, type: string, updated_at: any, collection_report_changes: Array<{ __typename?: 'collection_report_changes', timestamp: any }> }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> }, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null }> };

export type SearchEmailReportsQueryVariables = Exact<{
  offset: Scalars['Int'];
  refresh: Scalars['Boolean'];
  where: Spoofing_Reports_Bool_Exp;
  orderBy: Array<Spoofing_Reports_Order_By> | Spoofing_Reports_Order_By;
  includeCreditCardData?: Scalars['Boolean'];
}>;


export type SearchEmailReportsQuery = { __typename?: 'query_root', spoofing_reports: Array<{ __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, status: string, platform: string, submission_external_id?: string | null, type: string, updated_at: any, collection_report_changes: Array<{ __typename?: 'collection_report_changes', timestamp: any }> }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> }, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null }> };

export type SearchEmailReportsCountQueryVariables = Exact<{
  where: Spoofing_Reports_Bool_Exp;
}>;


export type SearchEmailReportsCountQuery = { __typename?: 'query_root', spoofing_reports_aggregate: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null } };

export type SearchSpoofingReportsCountQueryVariables = Exact<{
  spoofingReportsWhere: Spoofing_Reports_Bool_Exp;
  skipNormalSearch: Scalars['Boolean'];
  skipFullTextSearch: Scalars['Boolean'];
  searchKey?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchSpoofingReportsCountQuery = { __typename?: 'query_root', spoofing_reports_aggregate?: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null }, search_spoofing_reports_aggregate?: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null } };

export type AlertsQueueStateCountByProductQueryVariables = Exact<{
  organizationId: Scalars['uuid'];
  queueState: Scalars['String'];
  limitPerProduct: Scalars['bigint'];
}>;


export type AlertsQueueStateCountByProductQuery = { __typename?: 'query_root', alerts_queue_state_count_by_product: Array<{ __typename?: 'alerts_queue_state_count_by_product', alerts_count: any, product: string }> };

export type UpdateSpoofingReportsMutationVariables = Exact<{
  input: UpdateReportsInput;
}>;


export type UpdateSpoofingReportsMutation = { __typename?: 'mutation_root', update_reports_action?: { __typename?: 'UpdateReportsOutput', ids: Array<any>, updated_fields?: any | null } | null };

export type UploadEnforcementScreenshotToSpoofingReportMutationVariables = Exact<{
  id: Scalars['uuid'];
  reportScreenshots: Scalars['jsonb'];
}>;


export type UploadEnforcementScreenshotToSpoofingReportMutation = { __typename?: 'mutation_root', update_spoofing_reports?: { __typename?: 'spoofing_reports_mutation_response', returning: Array<{ __typename?: 'spoofing_reports', id: any, report_screenshots?: any | null }> } | null };

export type UpsertEnforcementPlatformMutationVariables = Exact<{
  input: Enforcement_Platforms_Insert_Input;
}>;


export type UpsertEnforcementPlatformMutation = { __typename?: 'mutation_root', insert_enforcement_platforms_one?: { __typename?: 'enforcement_platforms', name: string } | null };

export type UpsertEnforcementTypesMutationVariables = Exact<{
  input: Array<Enforcement_Types_Insert_Input> | Enforcement_Types_Insert_Input;
}>;


export type UpsertEnforcementTypesMutation = { __typename?: 'mutation_root', insert_enforcement_types?: { __typename?: 'enforcement_types_mutation_response', returning: Array<{ __typename?: 'enforcement_types', id: any }> } | null };

export type DeleteEnforcementTypesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type DeleteEnforcementTypesMutation = { __typename?: 'mutation_root', delete_enforcement_types?: { __typename?: 'enforcement_types_mutation_response', returning: Array<{ __typename?: 'enforcement_types', id: any }> } | null };

export type InsertAiPromptMutationVariables = Exact<{
  input: Ai_Prompts_Insert_Input;
}>;


export type InsertAiPromptMutation = { __typename?: 'mutation_root', insert_ai_prompts_one?: { __typename?: 'ai_prompts', id: any } | null };

export type UpdateAiPromptMutationVariables = Exact<{
  id: Scalars['uuid'];
  prompt: Scalars['String'];
  type: Scalars['String'];
  role: Scalars['String'];
  metadata?: InputMaybe<Scalars['jsonb']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['String']>;
  updated_by: Scalars['uuid'];
}>;


export type UpdateAiPromptMutation = { __typename?: 'mutation_root', update_ai_prompts_by_pk?: { __typename?: 'ai_prompts', id: any } | null };

export type UpdateExternalSourceForReportMutationVariables = Exact<{
  id: Scalars['uuid'];
  external_source: Scalars['String'];
  report_change: Collection_Report_Changes_Insert_Input;
}>;


export type UpdateExternalSourceForReportMutation = { __typename?: 'mutation_root', update_spoofing_reports?: { __typename?: 'spoofing_reports_mutation_response', returning: Array<{ __typename?: 'spoofing_reports', id: any, external_source?: string | null }> } | null, insert_collection_report_changes_one?: { __typename?: 'collection_report_changes', id: any } | null };

export type UpdateOrgStatusMutationVariables = Exact<{
  id: Scalars['uuid'];
  organization_status: Scalars['organization_status'];
}>;


export type UpdateOrgStatusMutation = { __typename?: 'mutation_root', update_organizations?: { __typename?: 'organizations_mutation_response', returning: Array<{ __typename?: 'organizations', id: any, organization_status: any }> } | null };

export type GetReportChangesQueryVariables = Exact<{
  spoof_report_id: Scalars['uuid'];
}>;


export type GetReportChangesQuery = { __typename?: 'query_root', collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, old_value?: string | null, timestamp: any, type: string, source?: string | null, extra_data?: any | null, user?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, enforcement_request?: { __typename?: 'enforcement_requests', platform: string, type: string } | null }> };

export type GetTrademarksQueryVariables = Exact<{
  where: Trademarks_Bool_Exp;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTrademarksQuery = { __typename?: 'query_root', trademarks: Array<{ __typename?: 'trademarks', id: any, mark?: string | null, image_url?: string | null, record_link?: string | null, registration_number: string, registration_office?: string | null, holder_name: string, holder_company_name?: string | null, holder_address: string, holder_country_code: string, holder_website?: string | null, goods_or_services_class?: string | null, name: string, trademark_registration_certificate_url?: string | null, status: string, trademark_type?: string | null, spoofing_entity?: { __typename?: 'spoofing_entities', id: any, entity_name: string } | null }> };

export type GetBrandsCountQueryVariables = Exact<{
  where: Spoofing_Entities_Bool_Exp;
}>;


export type GetBrandsCountQuery = { __typename?: 'query_root', spoofing_entities_aggregate: { __typename?: 'spoofing_entities_aggregate', aggregate?: { __typename?: 'spoofing_entities_aggregate_fields', count: number } | null } };

export type GetBrandsQueryVariables = Exact<{
  where: Spoofing_Entities_Bool_Exp;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Entities_Order_By> | Spoofing_Entities_Order_By>;
}>;


export type GetBrandsQuery = { __typename?: 'query_root', spoofing_entities: Array<{ __typename?: 'spoofing_entities', id: any, organization_id: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null, domain_data: any, updated_at?: any | null, entity_name_search_queries?: any | null, organization: { __typename?: 'organizations', name: string }, last_updated_by_user?: { __typename?: 'users', id: any, name: string } | null, protected_assets: Array<{ __typename?: 'protected_assets', id: any, platform_name?: string | null, is_primary: boolean, should_monitor?: boolean | null, full_url?: { __typename?: 'full_urls', url: string } | null }>, customer_assets_to_brands: Array<{ __typename?: 'customer_assets_to_brands', customer_asset?: { __typename?: 'customer_assets', id: any } | null }>, designated_takedown_assets: Array<{ __typename?: 'designated_takedown_assets', id: any, customer_asset: { __typename?: 'customer_assets', id: any, platform_subtype_id?: any | null } }> }> };

export type GetCustomerAssetsByBrandsQueryVariables = Exact<{
  brand_ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetCustomerAssetsByBrandsQuery = { __typename?: 'query_root', customer_assets_to_brands: Array<{ __typename?: 'customer_assets_to_brands', brand_id: any, customer_asset_id: any }> };

export type GetBrandQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetBrandQuery = { __typename?: 'query_root', spoofing_entities_by_pk?: { __typename?: 'spoofing_entities', id: any, organization_id: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null, domain_data: any, updated_at?: any | null, entity_name_search_queries?: any | null, last_updated_by_user?: { __typename?: 'users', id: any, name: string } | null, protected_assets: Array<{ __typename?: 'protected_assets', id: any, platform_name?: string | null, is_primary: boolean, should_monitor?: boolean | null, full_url?: { __typename?: 'full_urls', url: string } | null }> } | null };

export type GetBrandNamesQueryVariables = Exact<{
  where: Spoofing_Entities_Bool_Exp;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Entities_Order_By> | Spoofing_Entities_Order_By>;
}>;


export type GetBrandNamesQuery = { __typename?: 'query_root', spoofing_entities: Array<{ __typename?: 'spoofing_entities', id: any, organization_id: any, entity_name: string }> };

export type GetBrandNamesWithOrgQueryVariables = Exact<{
  where: Spoofing_Entities_Bool_Exp;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Spoofing_Entities_Order_By> | Spoofing_Entities_Order_By>;
}>;


export type GetBrandNamesWithOrgQuery = { __typename?: 'query_root', spoofing_entities: Array<{ __typename?: 'spoofing_entities', id: any, organization_id: any, entity_name: string, organization: { __typename?: 'organizations', name: string } }> };

export type GetTrademarksCountQueryVariables = Exact<{
  where: Trademarks_Bool_Exp;
}>;


export type GetTrademarksCountQuery = { __typename?: 'query_root', trademarks_aggregate: { __typename?: 'trademarks_aggregate', aggregate?: { __typename?: 'trademarks_aggregate_fields', count: number } | null } };

export type GetSpoofTemplateInputQueryVariables = Exact<{
  entityId: Scalars['uuid'];
  designatedTakedownAssetsWhere: Designated_Takedown_Assets_Bool_Exp;
  orgDesignatedAssetsWhere: Designated_Takedown_Assets_Bool_Exp;
}>;


export type GetSpoofTemplateInputQuery = { __typename?: 'query_root', brandDesignatedAssets: Array<{ __typename?: 'designated_takedown_assets', customer_asset: { __typename?: 'customer_assets', value: string, social_media_data?: { __typename?: 'social_media_data', slug: string } | null } }>, orgDefaultDesignatedAssets: Array<{ __typename?: 'designated_takedown_assets', customer_asset: { __typename?: 'customer_assets', value: string, social_media_data?: { __typename?: 'social_media_data', slug: string } | null } }>, spoofing_entities: Array<{ __typename?: 'spoofing_entities', id: any, trademarks: Array<{ __typename?: 'trademarks', id: any, goods_or_services_class?: string | null, holder_address: string, holder_country_code: string, holder_name: string, holder_website?: string | null, holder_company_name?: string | null, mark?: string | null, record_link?: string | null, registration_number: string, registration_office?: string | null, trademark_registration_certificate_url?: string | null }>, organization: { __typename?: 'organizations', enforcement_metadata?: { __typename?: 'enforcement_metadata', authorization_letter_url?: string | null, enforcement_email?: string | null, legal_name?: string | null, country_code?: string | null, authorization_letter_url_expiration_date?: any | null } | null } }> };

export type GetSpoofTemplatesQueryVariables = Exact<{
  platform: Scalars['String'];
  type: Scalars['String'];
  stage: Scalars['String'];
}>;


export type GetSpoofTemplatesQuery = { __typename?: 'query_root', enforcement_templates: Array<{ __typename?: 'enforcement_templates', template_body: string, optional_input: any }> };

export type GetEnforcementRequestsForSpoofingReportQueryVariables = Exact<{
  spoofing_report_id: Scalars['uuid'];
}>;


export type GetEnforcementRequestsForSpoofingReportQuery = { __typename?: 'query_root', enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, updated_at: any, type: string, platform: string, status: string, submission_proof_url?: string | null, submitted_at?: any | null, reason?: string | null, submission_external_id?: string | null, created_at: any, submission_email?: string | null, submission_source?: string | null, retraction_description?: string | null, retraction_proof_url?: string | null, collection_report_changes: Array<{ __typename?: 'collection_report_changes', timestamp: any }>, user?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null }> };

export type GetEnforcementPlatformsComplianceStatusQueryVariables = Exact<{
  platform_names: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetEnforcementPlatformsComplianceStatusQuery = { __typename?: 'query_root', enforcement_platforms: Array<{ __typename?: 'enforcement_platforms', name: string, compliance_status: string }> };

export type GetJiraMetadataForEnforcementRequestsQueryVariables = Exact<{
  enforcement_request_ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetJiraMetadataForEnforcementRequestsQuery = { __typename?: 'query_root', jira_metadata: Array<{ __typename?: 'jira_metadata', ticket_id: string, status: string, enforcement_request_id?: any | null }> };

export type GetEnforcementRequestsForCollectionReportQueryVariables = Exact<{
  collection_report_id: Scalars['uuid'];
}>;


export type GetEnforcementRequestsForCollectionReportQuery = { __typename?: 'query_root', enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, updated_at: any, type: string, platform: string, status: string, submission_proof_url?: string | null, submitted_at?: any | null, reason?: string | null, submission_external_id?: string | null, created_at: any, submission_email?: string | null, submission_source?: string | null, retraction_description?: string | null, retraction_proof_url?: string | null, user?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null }> };

export type GetApprovalsQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  approvalsWhere: Approvals_Bool_Exp;
  refresh: Scalars['Boolean'];
  orderBy: Array<Approvals_Order_By> | Approvals_Order_By;
  includeCreditCardData?: Scalars['Boolean'];
}>;


export type GetApprovalsQuery = { __typename?: 'query_root', approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null, spoofing_report: { __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, status: string, platform: string, submission_external_id?: string | null, type: string, updated_at: any, collection_report_changes: Array<{ __typename?: 'collection_report_changes', timestamp: any }> }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> }, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null } }> };

export type GetApprovalsCountQueryVariables = Exact<{
  approvalsWhere: Approvals_Bool_Exp;
}>;


export type GetApprovalsCountQuery = { __typename?: 'query_root', approvals_aggregate: { __typename?: 'approvals_aggregate', aggregate?: { __typename?: 'approvals_aggregate_fields', count: number } | null } };

export type UpdateApprovalsStatusMutationVariables = Exact<{
  id: Scalars['uuid'];
  status: Scalars['approval_status'];
  approver_id: Scalars['uuid'];
}>;


export type UpdateApprovalsStatusMutation = { __typename?: 'mutation_root', update_approvals?: { __typename?: 'approvals_mutation_response', returning: Array<{ __typename?: 'approvals', id: any, status: any, updated_at: any }> } | null };

export type DeleteEnforcementRequestMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteEnforcementRequestMutation = { __typename?: 'mutation_root', delete_enforcement_requests?: { __typename?: 'enforcement_requests_mutation_response', returning: Array<{ __typename?: 'enforcement_requests', id: any }> } | null };

export type SendSlackMessageMutationVariables = Exact<{
  slack_message_input: SlackMessageInput;
}>;


export type SendSlackMessageMutation = { __typename?: 'mutation_root', send_slack_message?: { __typename?: 'SlackMessageOutput', success?: boolean | null } | null };

export type PublishRequestSpoofScreenshotMutationVariables = Exact<{
  report_id: Scalars['uuid'];
}>;


export type PublishRequestSpoofScreenshotMutation = { __typename?: 'mutation_root', publish_request_spoof_screenshot?: { __typename?: 'PublishRequestSpoofScreenshotOutput', report_screenshot_url: string, screenshot_url_already_exists: boolean, matches_published: Array<any> } | null };

export type UploadNewEnforcementRequestMutationVariables = Exact<{
  enforcement_type: Scalars['String'];
  platform: Scalars['String'];
  status: Scalars['String'];
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  screenshot_file?: InputMaybe<Scalars['String']>;
  trademark_id?: InputMaybe<Scalars['uuid']>;
  copyrighted_content_url?: InputMaybe<Scalars['String']>;
  original_content_type?: InputMaybe<Scalars['String']>;
  submission_email?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  suggested_enforcement_id?: InputMaybe<Scalars['uuid']>;
  copyright_original_work_description?: InputMaybe<Scalars['String']>;
  submission_source?: InputMaybe<Scalars['String']>;
}>;


export type UploadNewEnforcementRequestMutation = { __typename?: 'mutation_root', upload_new_enforcement_request?: { __typename?: 'UploadNewEnforcementRequestOutput', id: any } | null };

export type UploadNewEnforcementRequestV2MutationVariables = Exact<{
  enforcement_type: Scalars['String'];
  platform: Scalars['String'];
  status: Scalars['String'];
  spoofing_report_id?: InputMaybe<Scalars['uuid']>;
  collection_report_id?: InputMaybe<Scalars['uuid']>;
  submitted_at?: InputMaybe<Scalars['timestamp']>;
  screenshot_file?: InputMaybe<Scalars['String']>;
  trademark_id?: InputMaybe<Scalars['uuid']>;
  copyrighted_content_url?: InputMaybe<Scalars['String']>;
  original_content_type?: InputMaybe<Scalars['String']>;
  submission_email?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  suggested_enforcement_id?: InputMaybe<Scalars['uuid']>;
  copyright_original_work_description?: InputMaybe<Scalars['String']>;
  submission_source?: InputMaybe<Scalars['String']>;
}>;


export type UploadNewEnforcementRequestV2Mutation = { __typename?: 'mutation_root', upload_new_enforcement_request_v2?: { __typename?: 'UploadNewEnforcementRequestV2Output', enforcement_request?: { __typename?: 'UploadedNewEnforcementRequest', id: any } | null, error?: { __typename?: 'UploadedNewEnforcementRequestError', error_code: number, message: string } | null } | null };

export type UploadNewWeb2EntityMutationVariables = Exact<{
  entity_id?: InputMaybe<Scalars['uuid']>;
  entity_type: Scalars['String'];
  entity_name: Scalars['String'];
  domain_configs: Scalars['jsonb'];
  entity_url?: InputMaybe<Scalars['String']>;
  screenshot_url: Scalars['String'];
  entity_name_search_queries?: InputMaybe<Scalars['jsonb']>;
  organization_id: Scalars['uuid'];
}>;


export type UploadNewWeb2EntityMutation = { __typename?: 'mutation_root', upload_new_web2_entity?: { __typename?: 'UploadNewWeb2EntityOutput', id: any } | null };

export type UploadNewOrganizationMutationVariables = Exact<{
  upload_new_organization_input: UploadNewOrganizationInput;
}>;


export type UploadNewOrganizationMutation = { __typename?: 'mutation_root', upload_new_organization?: { __typename?: 'UploadNewOrganizationOutput', organization_id: string } | null };

export type UploadNewTagMutationVariables = Exact<{
  tag_name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  is_internal?: InputMaybe<Scalars['Boolean']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UploadNewTagMutation = { __typename?: 'mutation_root', insert_tags_one?: { __typename?: 'tags', id: any } | null };

export type UpdateTagMutationVariables = Exact<{
  tag_id?: InputMaybe<Scalars['uuid']>;
  new_name?: InputMaybe<Scalars['String']>;
  new_description?: InputMaybe<Scalars['String']>;
  new_is_internal?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateTagMutation = { __typename?: 'mutation_root', update_tags?: { __typename?: 'tags_mutation_response', returning: Array<{ __typename?: 'tags', name: string, description: string, is_internal: boolean }> } | null };

export type UploadNewNftMarketplaceCollectionMutationVariables = Exact<{
  organization_id: Scalars['String'];
  collection_slugs: Array<Scalars['String']> | Scalars['String'];
}>;


export type UploadNewNftMarketplaceCollectionMutation = { __typename?: 'mutation_root', upload_new_nft_marketplace_collection?: { __typename?: 'UploadNewNftMarketplaceCollectionOutput', collections: Array<{ __typename?: 'UploadNewNftMarketplaceCollectionOutputObj', id: string, slug: string }> } | null };

export type UploadNewNftCustomerCollectionMutationVariables = Exact<{
  organization_id: Scalars['uuid'];
  collection_name: Scalars['String'];
  collection_image_url?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Scalars['jsonb']>;
  images?: InputMaybe<Scalars['jsonb']>;
}>;


export type UploadNewNftCustomerCollectionMutation = { __typename?: 'mutation_root', upload_new_nft_customer_collection?: { __typename?: 'UploadNewNftCustomerCollectionOutput', collection_id: any, asset_ids: Array<any> } | null };

export type UploadNewReportMutationVariables = Exact<{
  url: Scalars['String'];
  brand_id?: InputMaybe<Scalars['uuid']>;
  organization_id: Scalars['uuid'];
  is_customer_sourced: Scalars['Boolean'];
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UploadNewReportMutation = { __typename?: 'mutation_root', upload_new_report_action?: { __typename?: 'UploadNewReportOutput', report?: { __typename?: 'UploadedNewReport', id: any, flagged_url: string, platform_name: string, product?: string | null, status: string, classification: string, brand_name: string, is_existing: boolean, notes?: string | null } | null, error?: { __typename?: 'UploadedNewReportError', flagged_url: string, reason: string } | null } | null };

export type UploadNewAlertMutationVariables = Exact<{
  entity_value: Scalars['String'];
  organization_id: Scalars['uuid'];
  brand_id?: InputMaybe<Scalars['uuid']>;
  is_customer_sourced: Scalars['Boolean'];
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UploadNewAlertMutation = { __typename?: 'mutation_root', upload_new_alert_action?: { __typename?: 'UploadNewAlertOutput', alert?: { __typename?: 'UploadedNewAlert', id: any, entity_value: string, platform_name: string, product?: string | null, queue_state: string, classification: string, brand_name: string, is_existing: boolean, notes?: string | null } | null, error?: { __typename?: 'UploadedNewAlertError', entity_value: string, reason: string } | null } | null };

export type UploadNewProtectedAssetMutationVariables = Exact<{
  unsanitized_url: Scalars['String'];
  brand_id: Scalars['String'];
  is_primary: Scalars['Boolean'];
  similarity_threshold?: InputMaybe<Scalars['Int']>;
  should_monitor: Scalars['Boolean'];
}>;


export type UploadNewProtectedAssetMutation = { __typename?: 'mutation_root', upload_new_protected_asset?: { __typename?: 'UploadNewProtectedAssetOutput', id: string } | null };

export type UploadSafelistItemMutationVariables = Exact<{
  unsanitized_url: Scalars['String'];
  brand_ids?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  organization_id: Scalars['uuid'];
}>;


export type UploadSafelistItemMutation = { __typename?: 'mutation_root', manage_safelist?: { __typename?: 'ManageSafelistOutput', id: any } | null };

export type ManageTrademarksMutationVariables = Exact<{
  manage_trademarks_input: ManageTrademarksInput;
}>;


export type ManageTrademarksMutation = { __typename?: 'mutation_root', manage_trademarks?: { __typename?: 'ManageTrademarksOutput', trademark_id: any } | null };

export type UploadNewDetectionAssetMutationVariables = Exact<{
  brand_id: Scalars['String'];
  value: Scalars['String'];
  type: Scalars['String'];
  enabled_usage: Scalars['String'];
  idempotency_key: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  is_generic_override?: InputMaybe<Scalars['Boolean']>;
  ir_to_dr_rule_override?: InputMaybe<Scalars['String']>;
}>;


export type UploadNewDetectionAssetMutation = { __typename?: 'mutation_root', upload_new_detection_asset?: { __typename?: 'UploadNewDetectionAssetOutput', id: string } | null };

export type UploadNewEnforcementTemplateMutationVariables = Exact<{
  enforcement_type: Scalars['String'];
  platform: Scalars['String'];
  template_body: Scalars['String'];
  stage: Scalars['String'];
}>;


export type UploadNewEnforcementTemplateMutation = { __typename?: 'mutation_root', upload_new_enforcement_template?: { __typename?: 'UploadNewEnforcementTemplateOutput', platform: string, template_body: string, type: string, stage: string } | null };

export type UpdateSuggestedEnforcementMutationVariables = Exact<{
  id: Scalars['uuid'];
  selected_platform_name: Scalars['String'];
  provider_name: Scalars['String'];
  status: Scalars['String'];
  allowed_enforcement_methods: Scalars['jsonb'];
  selected_method: Scalars['jsonb'];
  selected_platform_selection_method: Scalars['String'];
  updated_by: Scalars['uuid'];
  protected_content?: InputMaybe<Scalars['String']>;
  flagged_content?: InputMaybe<Scalars['String']>;
  unfilled_suggested_template?: InputMaybe<Scalars['String']>;
  suggested_template_fields?: InputMaybe<Scalars['jsonb']>;
  additional_template_info?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSuggestedEnforcementMutation = { __typename?: 'mutation_root', update_suggested_enforcements?: { __typename?: 'suggested_enforcements_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'suggested_enforcements', id: any }> } | null };

export type CheckEnforcementPlatformTypeByMatchStringQueryVariables = Exact<{
  match_string: Scalars['jsonb'];
}>;


export type CheckEnforcementPlatformTypeByMatchStringQuery = { __typename?: 'query_root', enforcement_platforms: Array<{ __typename?: 'enforcement_platforms', name: string, types?: any | null }> };

export type GenerateSuggestedEnforcementsMutationVariables = Exact<{
  generate_suggested_enforcements_input: GenerateSuggestedEnforcementsInput;
}>;


export type GenerateSuggestedEnforcementsMutation = { __typename?: 'mutation_root', generate_suggested_enforcements?: { __typename?: 'GenerateSuggestedEnforcementsOutput', generated_suggested_enforcements?: any | null } | null };

export type UpsertNewPlatformMutationVariables = Exact<{
  name: Scalars['String'];
  product: Scalars['platform_type'];
  platform_domains: Scalars['jsonb'];
  custom_urls_to_product: Scalars['jsonb'];
}>;


export type UpsertNewPlatformMutation = { __typename?: 'mutation_root', insert_platforms?: { __typename?: 'platforms_mutation_response', returning: Array<{ __typename?: 'platforms', name: string, product: any, custom_urls_to_product?: any | null, platform_domains: any }> } | null };

export type UploadNewPlatformMutationVariables = Exact<{
  upload_new_platform_input: UploadNewPlatformInput;
}>;


export type UploadNewPlatformMutation = { __typename?: 'mutation_root', upload_new_platform?: { __typename?: 'UploadNewPlatformOutput', name: string, product: string, custom_urls_to_product?: Array<string> | null, platform_domains?: Array<string> | null } | null };

export type SubmitAutoEnforcementRequestsMutationVariables = Exact<{
  submit_auto_enforcement_requests_input: SubmitAutoEnforcementRequestsInput;
}>;


export type SubmitAutoEnforcementRequestsMutation = { __typename?: 'mutation_root', submit_auto_enforcement_requests?: { __typename?: 'SubmitAutoEnforcementRequestsOutput', results?: any | null } | null };

export type SubmitFormAutoEnforcementRequestsMutationVariables = Exact<{
  submit_form_auto_enforcement_requests_input: SubmitFormAutoEnforcementRequestsInput;
}>;


export type SubmitFormAutoEnforcementRequestsMutation = { __typename?: 'mutation_root', submit_form_auto_enforcement_requests?: { __typename?: 'SubmitFormAutoEnforcementRequestsOutput', results?: any | null } | null };

export type UpdateEnforcementRequestStatusMutationVariables = Exact<{
  update_enforcement_request_status_input?: InputMaybe<UpdateEnforcementRequestStatusInput>;
}>;


export type UpdateEnforcementRequestStatusMutation = { __typename?: 'mutation_root', update_enforcement_request_status?: { __typename?: 'UpdateEnforcementRequestStatusOutput', enforcement_request_id: any } | null };

export type UpdateEnforcementRequestRetractionInfoMutationVariables = Exact<{
  id: Scalars['uuid'];
  retraction_description?: InputMaybe<Scalars['String']>;
  retraction_proof_url?: InputMaybe<Scalars['String']>;
}>;


export type UpdateEnforcementRequestRetractionInfoMutation = { __typename?: 'mutation_root', update_enforcement_requests?: { __typename?: 'enforcement_requests_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'enforcement_requests', id: any }> } | null };

export type UploadReportFileMutationVariables = Exact<{
  upload_report_file_input: UploadReportFileInput;
}>;


export type UploadReportFileMutation = { __typename?: 'mutation_root', upload_report_file?: { __typename?: 'UploadReportFileOutput', results?: any | null } | null };

export type UpdateSpoofingReportScreenshotMutationVariables = Exact<{
  id: Scalars['uuid'];
  screenshot_url?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSpoofingReportScreenshotMutation = { __typename?: 'mutation_root', update_spoofing_reports_by_pk?: { __typename?: 'spoofing_reports', id: any } | null };

export type UpdateFullUrlScreenshotMutationVariables = Exact<{
  id: Scalars['uuid'];
  screenshot_url?: InputMaybe<Scalars['String']>;
}>;


export type UpdateFullUrlScreenshotMutation = { __typename?: 'mutation_root', update_full_urls_by_pk?: { __typename?: 'full_urls', id: any } | null };

export type UpdateSocialMediaScreenshotMutationVariables = Exact<{
  id: Scalars['uuid'];
  screenshot_url?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSocialMediaScreenshotMutation = { __typename?: 'mutation_root', update_social_media_data_by_pk?: { __typename?: 'social_media_data', id: any } | null };

export type UpdateMobileAppScreenshotMutationVariables = Exact<{
  id: Scalars['uuid'];
  screenshot_url?: InputMaybe<Scalars['String']>;
}>;


export type UpdateMobileAppScreenshotMutation = { __typename?: 'mutation_root', update_mobile_apps_by_pk?: { __typename?: 'mobile_apps', id: any } | null };

export type SpoofReportsStatusCountsQueryVariables = Exact<{
  spoofingReportsWhere: Spoofing_Reports_Bool_Exp;
}>;


export type SpoofReportsStatusCountsQuery = { __typename?: 'query_root', needsReview: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null }, approvedDerivative: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null }, inProgress: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null }, archived: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null }, reported: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null }, resolved: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null } };

export type GetFilterablePlatformsByProductQueryVariables = Exact<{
  orgId: Scalars['uuid'];
  products: Array<Scalars['platform_type']> | Scalars['platform_type'];
  reportStatuses: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetFilterablePlatformsByProductQuery = { __typename?: 'query_root', spoofing_reports: Array<{ __typename?: 'spoofing_reports', id: any, type: string }> };

export type GetProductByPlatformQueryVariables = Exact<{
  platformName: Scalars['String'];
}>;


export type GetProductByPlatformQuery = { __typename?: 'query_root', platforms: Array<{ __typename?: 'platforms', name: string, product: any }> };

export type GetProtectedAssetsByOrgQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  protectedAssetsWhere: Protected_Assets_Bool_Exp;
  orderBy: Array<Protected_Assets_Order_By> | Protected_Assets_Order_By;
}>;


export type GetProtectedAssetsByOrgQuery = { __typename?: 'query_root', protected_assets: Array<{ __typename?: 'protected_assets', is_primary: boolean, updated_at?: any | null, created_at: any, id: any, is_generic?: boolean | null, similarity_threshold?: number | null, should_monitor?: boolean | null, value?: string | null, brand: { __typename?: 'spoofing_entities', entity_name: string, id: any }, mobile_app?: { __typename?: 'mobile_apps', title?: string | null, thumbnail_url?: string | null, link: string, description?: string | null } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, social_media?: { __typename?: 'social_media_data', platform_name: string, profile_image_url?: string | null, profile_display_name?: string | null, slug: string, profile_description?: string | null } | null, last_updated_by_user?: { __typename?: 'users', id: any, name: string, email: string, is_internal: boolean } | null, full_url?: { __typename?: 'full_urls', url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_text?: string | null, site_html_url?: string | null } | null }> };

export type GetCustomerAssetsByOrgQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  customerAssetsWhere: Customer_Assets_Bool_Exp;
  orderBy: Array<Customer_Assets_Order_By> | Customer_Assets_Order_By;
}>;


export type GetCustomerAssetsByOrgQuery = { __typename?: 'query_root', customer_assets: Array<{ __typename?: 'customer_assets', id: any, organization_id: any, value: string, created_at: any, updated_at: any, last_updated_by_user_id?: any | null, status: string, user?: { __typename?: 'users', id: any, name: string, email: string, is_internal: boolean } | null, customer_assets_to_brands: Array<{ __typename?: 'customer_assets_to_brands', brand_id: any, brand?: { __typename?: 'spoofing_entities', entity_name: string } | null }>, platform_subtype?: { __typename?: 'platform_subtypes', platform: string } | null }> };

export type GetCustomerAssetsWhereQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  customerAssetsWhere: Customer_Assets_Bool_Exp;
  orderBy: Array<Customer_Assets_Order_By> | Customer_Assets_Order_By;
  org_id: Scalars['uuid'];
}>;


export type GetCustomerAssetsWhereQuery = { __typename?: 'query_root', customer_assets: Array<{ __typename?: 'customer_assets', id: any, organization_id: any, value: string, created_at: any, updated_at: any, last_updated_by_user_id?: any | null, status: string, user?: { __typename?: 'users', id: any, name: string, email: string, is_internal: boolean } | null, customer_assets_to_brands: Array<{ __typename?: 'customer_assets_to_brands', brand_id: any, brand?: { __typename?: 'spoofing_entities', entity_name: string } | null }>, platform_subtype?: { __typename?: 'platform_subtypes', platform: string } | null }> };

export type GetCustomerAssetsCountQueryVariables = Exact<{
  customerAssetsWhere: Customer_Assets_Bool_Exp;
}>;


export type GetCustomerAssetsCountQuery = { __typename?: 'query_root', customer_assets_aggregate: { __typename?: 'customer_assets_aggregate', aggregate?: { __typename?: 'customer_assets_aggregate_fields', count: number } | null } };

export type GetProtectedAssetPlatformsByOrgQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['uuid']>;
}>;


export type GetProtectedAssetPlatformsByOrgQuery = { __typename?: 'query_root', protected_assets: Array<{ __typename?: 'protected_assets', platform_name?: string | null }> };

export type GetTagsQueryVariables = Exact<{
  orgIDs: Array<Scalars['uuid']> | Scalars['uuid'];
  includeGlobal?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetTagsQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'tags', id: any, name: string, created_at: any, created_by?: string | null, is_internal: boolean, organization_id?: any | null, description: string }> };

export type GetTagsByReportQueryVariables = Exact<{
  report_id: Scalars['uuid'];
}>;


export type GetTagsByReportQuery = { __typename?: 'query_root', report_tags: Array<{ __typename?: 'report_tags', tag_id: any, tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, organization_id?: any | null, description: string } }> };

export type GetRulesQueryVariables = Exact<{
  rulesWhere: Rules_Bool_Exp;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy: Array<Rules_Order_By> | Rules_Order_By;
}>;


export type GetRulesQuery = { __typename?: 'query_root', rules: Array<{ __typename?: 'rules', id: any, description: string, type: string, rule_expression: any, brand_id?: any | null, product_type: string, is_enabled: boolean, is_realtime: boolean, created_at: any, updated_at: any, created_by: string, notes?: string | null, spoofing_entity?: { __typename?: 'spoofing_entities', entity_name: string } | null }> };

export type GetRulesCountQueryVariables = Exact<{
  where: Rules_Bool_Exp;
}>;


export type GetRulesCountQuery = { __typename?: 'query_root', rules_aggregate: { __typename?: 'rules_aggregate', aggregate?: { __typename?: 'rules_aggregate_fields', count: number } | null } };

export type BatchUpdateRulesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
  is_enabled: Scalars['Boolean'];
}>;


export type BatchUpdateRulesMutation = { __typename?: 'mutation_root', update_rules?: { __typename?: 'rules_mutation_response', returning: Array<{ __typename?: 'rules', id: any }> } | null };

export type UpsertRuleMutationVariables = Exact<{
  description: Scalars['String'];
  type: Scalars['String'];
  rule_expression: Scalars['jsonb'];
  product_type: Scalars['String'];
  is_enabled: Scalars['Boolean'];
  is_realtime: Scalars['Boolean'];
  created_by: Scalars['String'];
  brand_id?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UpsertRuleMutation = { __typename?: 'mutation_root', insert_rules?: { __typename?: 'rules_mutation_response', returning: Array<{ __typename?: 'rules', id: any }> } | null };

export type GetDetectionConfigApprovalsQueryVariables = Exact<{
  detection_config_approvals_where: Detection_Config_Approvals_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by: Array<Detection_Config_Approvals_Order_By> | Detection_Config_Approvals_Order_By;
}>;


export type GetDetectionConfigApprovalsQuery = { __typename?: 'query_root', detection_config_approvals: Array<{ __typename?: 'detection_config_approvals', id: any, detection_config_id: any, detection_config_type: string, status: string, rejection_reason?: string | null, reviewed_by?: any | null, created_at: any, updated_at: any, approved_at?: any | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any, brand_id?: any | null, product_type: string, is_enabled: boolean, created_at: any, updated_at: any, created_by: string, notes?: string | null, spoofing_entity?: { __typename?: 'spoofing_entities', entity_name: string } | null } | null, sourcing_queries?: { __typename?: 'sourcing_queries', id: any, brand_id: any, query: string, sourcer_label: string, created_at: any, updated_at: any, created_by?: string | null, status: string, notes?: string | null, force_create_report: boolean, execution_frequency_minutes?: number | null, spoofing_entity: { __typename?: 'spoofing_entities', entity_name: string } } | null, ioc_detection_config_attribution?: { __typename?: 'ioc_detection_config_attribution', ioc_id: any } | null }> };

export type GetDetectionConfigApprovalsCountQueryVariables = Exact<{
  where: Detection_Config_Approvals_Bool_Exp;
}>;


export type GetDetectionConfigApprovalsCountQuery = { __typename?: 'query_root', detection_config_approvals_aggregate: { __typename?: 'detection_config_approvals_aggregate', aggregate?: { __typename?: 'detection_config_approvals_aggregate_fields', count: number } | null } };

export type UpdateDetectionConfigApprovalMutationVariables = Exact<{
  detection_config_id: Scalars['uuid'];
  status: Scalars['String'];
  reviewed_by: Scalars['uuid'];
  rejection_reason?: InputMaybe<Scalars['String']>;
  approved_at?: InputMaybe<Scalars['timestamptz']>;
}>;


export type UpdateDetectionConfigApprovalMutation = { __typename?: 'mutation_root', update_detection_config_approvals?: { __typename?: 'detection_config_approvals_mutation_response', returning: Array<{ __typename?: 'detection_config_approvals', id: any }> } | null };

export type GetSourcingQueriesQueryVariables = Exact<{
  sourcingQueriesWhere: Sourcing_Queries_Bool_Exp;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy: Array<Sourcing_Queries_Order_By> | Sourcing_Queries_Order_By;
}>;


export type GetSourcingQueriesQuery = { __typename?: 'query_root', sourcing_queries: Array<{ __typename?: 'sourcing_queries', brand_id: any, query: string, sourcer_label: string, created_at: any, updated_at: any, created_by?: string | null, id: any, status: string, notes?: string | null, force_create_report: boolean, execution_frequency_minutes?: number | null, spoofing_entity: { __typename?: 'spoofing_entities', entity_name: string } }> };

export type GetSourcingQueriesCountQueryVariables = Exact<{
  where: Sourcing_Queries_Bool_Exp;
}>;


export type GetSourcingQueriesCountQuery = { __typename?: 'query_root', sourcing_queries_aggregate: { __typename?: 'sourcing_queries_aggregate', aggregate?: { __typename?: 'sourcing_queries_aggregate_fields', count: number } | null } };

export type GetDistinctSourcingQueryCreatorsQueryVariables = Exact<{
  where: Sourcing_Queries_Bool_Exp;
}>;


export type GetDistinctSourcingQueryCreatorsQuery = { __typename?: 'query_root', distinct_creators: Array<{ __typename?: 'sourcing_queries', created_by?: string | null }> };

export type BatchUpdateSourcingQueryMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
  status: Scalars['String'];
  last_updated_by: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
}>;


export type BatchUpdateSourcingQueryMutation = { __typename?: 'mutation_root', update_sourcing_queries?: { __typename?: 'sourcing_queries_mutation_response', returning: Array<{ __typename?: 'sourcing_queries', id: any }> } | null };

export type UpdateSourcingQueryForceCreateReportMutationVariables = Exact<{
  id: Scalars['uuid'];
  force_create_report: Scalars['Boolean'];
  last_updated_by: Scalars['String'];
}>;


export type UpdateSourcingQueryForceCreateReportMutation = { __typename?: 'mutation_root', update_sourcing_queries?: { __typename?: 'sourcing_queries_mutation_response', returning: Array<{ __typename?: 'sourcing_queries', id: any }> } | null };

export type UpdateSourcingQueryExecutionFrequencyMutationVariables = Exact<{
  id: Scalars['uuid'];
  execution_frequency_minutes?: InputMaybe<Scalars['Int']>;
  last_updated_by: Scalars['String'];
}>;


export type UpdateSourcingQueryExecutionFrequencyMutation = { __typename?: 'mutation_root', update_sourcing_queries?: { __typename?: 'sourcing_queries_mutation_response', returning: Array<{ __typename?: 'sourcing_queries', id: any, execution_frequency_minutes?: number | null, last_updated_by?: string | null }> } | null };

export type UpdateSourcingQueryNotesMutationVariables = Exact<{
  id: Scalars['uuid'];
  notes?: InputMaybe<Scalars['String']>;
  last_updated_by: Scalars['String'];
}>;


export type UpdateSourcingQueryNotesMutation = { __typename?: 'mutation_root', update_sourcing_queries?: { __typename?: 'sourcing_queries_mutation_response', returning: Array<{ __typename?: 'sourcing_queries', id: any, notes?: string | null, last_updated_by?: string | null }> } | null };

export type UpsertSourcingQueriesMutationVariables = Exact<{
  brand_id?: InputMaybe<Scalars['uuid']>;
  sourcer_label?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['String']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  execution_frequency_minutes?: InputMaybe<Scalars['Int']>;
}>;


export type UpsertSourcingQueriesMutation = { __typename?: 'mutation_root', insert_sourcing_queries?: { __typename?: 'sourcing_queries_mutation_response', returning: Array<{ __typename?: 'sourcing_queries', brand_id: any, query: string, sourcer_label: string, created_at: any, updated_at: any, created_by?: string | null, id: any, execution_frequency_minutes?: number | null, notes?: string | null }> } | null };

export type GetDetectionAssetsQueryVariables = Exact<{
  detectionAssetsWhere: Detection_Assets_Bool_Exp;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy: Array<Detection_Assets_Order_By> | Detection_Assets_Order_By;
}>;


export type GetDetectionAssetsQuery = { __typename?: 'query_root', detection_assets: Array<{ __typename?: 'detection_assets', id: any, original_entity_id: any, value?: string | null, enabled_usage: string, type: string, is_valid?: boolean | null, is_generic: boolean, created_at: any, ir_to_dr_rule: string, description?: string | null, originator_id: any, originator_type: string, creation_method?: string | null, updated_at: any, spoofing_entity: { __typename?: 'spoofing_entities', entity_name: string }, full_url?: { __typename?: 'full_urls', url: string } | null }> };

export type GetDetectionAssetsCountQueryVariables = Exact<{
  where: Detection_Assets_Bool_Exp;
}>;


export type GetDetectionAssetsCountQuery = { __typename?: 'query_root', detection_assets_aggregate: { __typename?: 'detection_assets_aggregate', aggregate?: { __typename?: 'detection_assets_aggregate_fields', count: number } | null } };

export type UpdateDetectionAssetMutationVariables = Exact<{
  id: Scalars['uuid'];
  is_valid?: InputMaybe<Scalars['Boolean']>;
  is_generic: Scalars['Boolean'];
  ir_to_dr_rule: Scalars['String'];
  last_updated_by?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDetectionAssetMutation = { __typename?: 'mutation_root', update_detection_assets?: { __typename?: 'detection_assets_mutation_response', returning: Array<{ __typename?: 'detection_assets', id: any, is_valid?: boolean | null, is_generic: boolean, ir_to_dr_rule: string, last_updated_by?: string | null }> } | null };

export type BulkUpdateDetectionAssetsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
  is_valid?: InputMaybe<Scalars['Boolean']>;
  last_updated_by?: InputMaybe<Scalars['String']>;
}>;


export type BulkUpdateDetectionAssetsMutation = { __typename?: 'mutation_root', update_detection_assets?: { __typename?: 'detection_assets_mutation_response', returning: Array<{ __typename?: 'detection_assets', id: any, is_valid?: boolean | null, is_generic: boolean, ir_to_dr_rule: string, last_updated_by?: string | null }> } | null };

export type GetScrapingConfigsQueryVariables = Exact<{
  scrapingConfigsWhere: Scraping_Configs_Bool_Exp;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy: Array<Scraping_Configs_Order_By> | Scraping_Configs_Order_By;
}>;


export type GetScrapingConfigsQuery = { __typename?: 'query_root', scraping_configs: Array<{ __typename?: 'scraping_configs', id: any, organization_id: any, config: any, created_at: any, updated_at: any, organization: { __typename?: 'organizations', name: string } }> };

export type GetScrapingConfigsCountQueryVariables = Exact<{
  where: Scraping_Configs_Bool_Exp;
}>;


export type GetScrapingConfigsCountQuery = { __typename?: 'query_root', scraping_configs_aggregate: { __typename?: 'scraping_configs_aggregate', aggregate?: { __typename?: 'scraping_configs_aggregate_fields', count: number } | null } };

export type UpsertScrapingConfigMutationVariables = Exact<{
  organization_id: Scalars['uuid'];
  config: Scalars['jsonb'];
}>;


export type UpsertScrapingConfigMutation = { __typename?: 'mutation_root', insert_scraping_configs?: { __typename?: 'scraping_configs_mutation_response', returning: Array<{ __typename?: 'scraping_configs', id: any, organization_id: any, config: any }> } | null };

export type DeleteScrapingConfigMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteScrapingConfigMutation = { __typename?: 'mutation_root', delete_scraping_configs?: { __typename?: 'scraping_configs_mutation_response', returning: Array<{ __typename?: 'scraping_configs', id: any }> } | null };

export type DeleteProtectedAssetsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type DeleteProtectedAssetsMutation = { __typename?: 'mutation_root', delete_protected_assets?: { __typename?: 'protected_assets_mutation_response', returning: Array<{ __typename?: 'protected_assets', id: any }> } | null };

export type UpdateDesignatedTakedownAssetsStatusMutationVariables = Exact<{
  designated_takedown_assets_where: Array<Designated_Takedown_Assets_Bool_Exp> | Designated_Takedown_Assets_Bool_Exp;
  status?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDesignatedTakedownAssetsStatusMutation = { __typename?: 'mutation_root', update_designated_takedown_assets?: { __typename?: 'designated_takedown_assets_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'designated_takedown_assets', id: any }> } | null };

export type DeleteDesignatedTakedownAssetsMutationVariables = Exact<{
  designated_takedown_assets_where: Array<Designated_Takedown_Assets_Bool_Exp> | Designated_Takedown_Assets_Bool_Exp;
}>;


export type DeleteDesignatedTakedownAssetsMutation = { __typename?: 'mutation_root', delete_designated_takedown_assets?: { __typename?: 'designated_takedown_assets_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'designated_takedown_assets', id: any }> } | null };

export type DeleteSafelistItemMutationVariables = Exact<{
  id: Scalars['uuid'];
  organization_id: Scalars['uuid'];
}>;


export type DeleteSafelistItemMutation = { __typename?: 'mutation_root', manage_safelist?: { __typename?: 'ManageSafelistOutput', id: any } | null };

export type DeleteTagsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type DeleteTagsMutation = { __typename?: 'mutation_root', delete_tags?: { __typename?: 'tags_mutation_response', returning: Array<{ __typename?: 'tags', id: any }> } | null };

export type DeleteReportTagMutationVariables = Exact<{
  report_id: Scalars['uuid'];
  tag_id: Scalars['uuid'];
}>;


export type DeleteReportTagMutation = { __typename?: 'mutation_root', delete_report_tags?: { __typename?: 'report_tags_mutation_response', returning: Array<{ __typename?: 'report_tags', id: any }> } | null };

export type DeleteReportTagsMutationVariables = Exact<{
  tag_ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type DeleteReportTagsMutation = { __typename?: 'mutation_root', delete_report_tags?: { __typename?: 'report_tags_mutation_response', returning: Array<{ __typename?: 'report_tags', id: any }> } | null };

export type HandleSynchronousDetectionRequestMutationVariables = Exact<{
  on_demand_sourcing_brands?: InputMaybe<Scalars['jsonb']>;
  on_demand_sourcing_queries?: InputMaybe<Scalars['jsonb']>;
  create_detection_configs_for_url?: InputMaybe<Scalars['jsonb']>;
  create_detection_configs_for_ioc?: InputMaybe<Scalars['jsonb']>;
  generate_hash_for_html?: InputMaybe<Scalars['jsonb']>;
  run_detection_rule?: InputMaybe<Scalars['jsonb']>;
  publish_adhoc_candidates?: InputMaybe<Scalars['jsonb']>;
}>;


export type HandleSynchronousDetectionRequestMutation = { __typename?: 'mutation_root', handle_synchronous_detection_request: { __typename?: 'HandleSynchronousDetectionRequestOutput', success: boolean, response?: any | null } };

export type HandleSynchronousDetectionRequestAsyncActionMutationVariables = Exact<{
  create_detection_configs_for_url?: InputMaybe<Scalars['jsonb']>;
  run_detection_rule?: InputMaybe<Scalars['jsonb']>;
}>;


export type HandleSynchronousDetectionRequestAsyncActionMutation = { __typename?: 'mutation_root', handle_synchronous_detection_request_async_action: any };

export type GetPlatformsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  platformsWhere: Platforms_Bool_Exp;
  orderBy: Array<Platforms_Order_By> | Platforms_Order_By;
}>;


export type GetPlatformsQuery = { __typename?: 'query_root', platforms: Array<{ __typename?: 'platforms', name: string, platform_domains: any, product: any, custom_urls_to_product?: any | null, created_at: any, updated_at: any }> };

export type GetDomainDataWithDistinctRegistrarQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  domainDataWhere: Domain_Data_Bool_Exp;
  orderBy: Array<Domain_Data_Order_By> | Domain_Data_Order_By;
}>;


export type GetDomainDataWithDistinctRegistrarQuery = { __typename?: 'query_root', domain_data: Array<{ __typename?: 'domain_data', registrar_name?: string | null }> };

export type GetDomainDataWithDistinctHostingProviderQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  domainDataWhere: Domain_Data_Bool_Exp;
  orderBy: Array<Domain_Data_Order_By> | Domain_Data_Order_By;
}>;


export type GetDomainDataWithDistinctHostingProviderQuery = { __typename?: 'query_root', domain_data: Array<{ __typename?: 'domain_data', hosting_provider?: string | null }> };

export type GetEnforcementPlatformsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  enforcementPlatformsWhere: Enforcement_Platforms_Bool_Exp;
  orderBy: Array<Enforcement_Platforms_Order_By> | Enforcement_Platforms_Order_By;
}>;


export type GetEnforcementPlatformsQuery = { __typename?: 'query_root', enforcement_platforms: Array<{ __typename?: 'enforcement_platforms', name: string, enforcement_types: any, initial_enforcement_methods: any, escalate_enforcement_methods?: any | null, match_strings: any, types?: any | null, api_link?: string | null, form_link?: string | null, email?: string | null, default_timeout?: number | null, notes?: string | null, platform?: string | null, product?: string | null }> };

export type GetEnforcementPlatformsWithTypesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  enforcementPlatformsWhere: Enforcement_Platforms_Bool_Exp;
  enforcementTypesWhere: Enforcement_Types_Bool_Exp;
}>;


export type GetEnforcementPlatformsWithTypesQuery = { __typename?: 'query_root', enforcement_platforms: Array<{ __typename?: 'enforcement_platforms', name: string, match_strings: any, types?: any | null, notes?: string | null, platform?: string | null, product?: string | null, compliance_status: string, enforcement_categories: Array<{ __typename?: 'enforcement_types', enforcement_method_data?: string | null, enforcement_method_type?: string | null, priority: number }> }> };

export type GetEnforcementPlatformsTableQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  enforcementPlatformsWhere: Enforcement_Platforms_Bool_Exp;
  orderBy: Array<Enforcement_Platforms_Order_By> | Enforcement_Platforms_Order_By;
}>;


export type GetEnforcementPlatformsTableQuery = { __typename?: 'query_root', enforcement_platforms: Array<{ __typename?: 'enforcement_platforms', name: string, match_strings: any, types?: any | null, email?: string | null, default_timeout?: number | null, notes?: string | null, platform?: string | null, product?: string | null, compliance_status: string, enforcement_categories: Array<{ __typename?: 'enforcement_types', id: any, type: string, platform: string, enforcement_method_type?: string | null, enforcement_method_data?: string | null, content_type?: string | null, content_type_display_name?: string | null, priority: number, stage?: string | null }> }> };

export type GetSingleEnforcementPlatformQueryVariables = Exact<{
  platformName: Scalars['String'];
}>;


export type GetSingleEnforcementPlatformQuery = { __typename?: 'query_root', enforcement_platforms: Array<{ __typename?: 'enforcement_platforms', name: string, match_strings: any, types?: any | null, email?: string | null, default_timeout?: number | null, notes?: string | null, platform?: string | null, product?: string | null, enforcement_categories: Array<{ __typename?: 'enforcement_types', id: any, type: string, platform: string, enforcement_method_type?: string | null, enforcement_method_data?: string | null, content_type?: string | null, content_type_display_name?: string | null, priority: number, stage?: string | null }> }> };

export type GetEnforcementPlatformsCountQueryVariables = Exact<{
  enforcementPlatformsWhere: Enforcement_Platforms_Bool_Exp;
}>;


export type GetEnforcementPlatformsCountQuery = { __typename?: 'query_root', enforcement_platforms_aggregate: { __typename?: 'enforcement_platforms_aggregate', aggregate?: { __typename?: 'enforcement_platforms_aggregate_fields', count: number } | null } };

export type GetEnforcementPlatformNamesQueryVariables = Exact<{
  enforcementPlatformsWhere: Enforcement_Platforms_Bool_Exp;
}>;


export type GetEnforcementPlatformNamesQuery = { __typename?: 'query_root', enforcement_platforms: Array<{ __typename?: 'enforcement_platforms', name: string, compliance_status: string }> };

export type GetFormFieldsFromEnforcementTypesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  formFieldsWhere?: InputMaybe<Array<Enforcement_Types_Bool_Exp> | Enforcement_Types_Bool_Exp>;
  orderBy: Array<Enforcement_Types_Order_By> | Enforcement_Types_Order_By;
}>;


export type GetFormFieldsFromEnforcementTypesQuery = { __typename?: 'query_root', enforcement_types: Array<{ __typename?: 'enforcement_types', id: any, platform: string, type: string, content_type?: string | null, enforcement_method_type?: string | null, enforcement_method_data?: string | null, manual_form_fields?: any | null }> };

export type GetFormFieldsFromEnforcementTypesCountQueryVariables = Exact<{
  formFieldsWhere?: InputMaybe<Array<Enforcement_Types_Bool_Exp> | Enforcement_Types_Bool_Exp>;
}>;


export type GetFormFieldsFromEnforcementTypesCountQuery = { __typename?: 'query_root', enforcement_types_aggregate: { __typename?: 'enforcement_types_aggregate', aggregate?: { __typename?: 'enforcement_types_aggregate_fields', count: number } | null } };

export type GetFormFieldsEnforcementTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFormFieldsEnforcementTypesQuery = { __typename?: 'query_root', enforcement_types: Array<{ __typename?: 'enforcement_types', type: string }> };

export type GetFormFieldsContentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFormFieldsContentTypesQuery = { __typename?: 'query_root', enforcement_types: Array<{ __typename?: 'enforcement_types', content_type?: string | null }> };

export type UpdateManualFormFieldsInEnforcementTypesMutationVariables = Exact<{
  id: Scalars['uuid'];
  manual_form_fields?: InputMaybe<Scalars['jsonb']>;
}>;


export type UpdateManualFormFieldsInEnforcementTypesMutation = { __typename?: 'mutation_root', update_enforcement_types?: { __typename?: 'enforcement_types_mutation_response', returning: Array<{ __typename?: 'enforcement_types', id: any }> } | null };

export type GetAiPromptsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  aiPromptsWhere: Ai_Prompts_Bool_Exp;
  orderBy: Array<Ai_Prompts_Order_By> | Ai_Prompts_Order_By;
}>;


export type GetAiPromptsQuery = { __typename?: 'query_root', ai_prompts: Array<{ __typename?: 'ai_prompts', prompt: string, role?: string | null, metadata?: any | null, id: any, platform?: string | null, type: string, updated_at?: any | null, created_at?: any | null, organization?: { __typename?: 'organizations', id: any, name: string } | null, user?: { __typename?: 'users', id: any, name: string } | null }> };

export type GetSingleAiPromptQueryVariables = Exact<{
  aiPromptWhere: Ai_Prompts_Bool_Exp;
}>;


export type GetSingleAiPromptQuery = { __typename?: 'query_root', ai_prompts: Array<{ __typename?: 'ai_prompts', prompt: string, role?: string | null, metadata?: any | null, id: any, type: string, organization?: { __typename?: 'organizations', id: any, name: string } | null }> };

export type GetAiPromptsCountQueryVariables = Exact<{
  aiPromptsWhere: Ai_Prompts_Bool_Exp;
}>;


export type GetAiPromptsCountQuery = { __typename?: 'query_root', ai_prompts_aggregate: { __typename?: 'ai_prompts_aggregate', aggregate?: { __typename?: 'ai_prompts_aggregate_fields', count: number } | null } };

export type GetAiPromptPlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiPromptPlatformsQuery = { __typename?: 'query_root', ai_prompts: Array<{ __typename?: 'ai_prompts', platform?: string | null }> };

export type GetAiPromptRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiPromptRolesQuery = { __typename?: 'query_root', ai_prompts: Array<{ __typename?: 'ai_prompts', role?: string | null }> };

export type GetAiPromptTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiPromptTypesQuery = { __typename?: 'query_root', ai_prompts: Array<{ __typename?: 'ai_prompts', type: string }> };

export type GetAiPromptOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiPromptOrgsQuery = { __typename?: 'query_root', ai_prompts: Array<{ __typename?: 'ai_prompts', organization?: { __typename?: 'organizations', name: string, id: any } | null }> };

export type GetPlatformsCountQueryVariables = Exact<{
  platformsWhere: Platforms_Bool_Exp;
}>;


export type GetPlatformsCountQuery = { __typename?: 'query_root', platforms_aggregate: { __typename?: 'platforms_aggregate', aggregate?: { __typename?: 'platforms_aggregate_fields', count: number } | null } };

export type GetPlatformProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlatformProductsQuery = { __typename?: 'query_root', platforms: Array<{ __typename?: 'platforms', name: string, product: any }> };

export type GetEnforcementTemplatesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  enforcementTemplatesWhere: Enforcement_Templates_Bool_Exp;
  orderBy: Array<Enforcement_Templates_Order_By> | Enforcement_Templates_Order_By;
}>;


export type GetEnforcementTemplatesQuery = { __typename?: 'query_root', enforcement_templates: Array<{ __typename?: 'enforcement_templates', type: string, platform: string, template_body: string, stage?: string | null }> };

export type GetSingleEnforcementTemplateQueryVariables = Exact<{
  enforcementTemplateWhere: Enforcement_Templates_Bool_Exp;
}>;


export type GetSingleEnforcementTemplateQuery = { __typename?: 'query_root', enforcement_templates: Array<{ __typename?: 'enforcement_templates', type: string, platform: string, template_body: string, stage?: string | null }> };

export type GetEnforcementTemplatesCountQueryVariables = Exact<{
  enforcementTemplatesWhere: Enforcement_Templates_Bool_Exp;
}>;


export type GetEnforcementTemplatesCountQuery = { __typename?: 'query_root', enforcement_templates_aggregate: { __typename?: 'enforcement_templates_aggregate', aggregate?: { __typename?: 'enforcement_templates_aggregate_fields', count: number } | null } };

export type GetEnforcementTemplateTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnforcementTemplateTypesQuery = { __typename?: 'query_root', enforcement_templates: Array<{ __typename?: 'enforcement_templates', platform: string, type: string }> };

export type GetEnforcementTemplateStagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnforcementTemplateStagesQuery = { __typename?: 'query_root', enforcement_templates: Array<{ __typename?: 'enforcement_templates', stage?: string | null }> };

export type GetEnforcementRequestsQueryVariables = Exact<{
  enforcementStatuses: Array<Scalars['String']> | Scalars['String'];
  platforms: Array<Scalars['String']> | Scalars['String'];
  includeCreditCardData?: Scalars['Boolean'];
}>;


export type GetEnforcementRequestsQuery = { __typename?: 'query_root', enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, platform: string, updated_at: any, type: string, status: string, submission_external_id?: string | null, spoofing_report?: { __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, status: string, platform: string, submission_external_id?: string | null, type: string, updated_at: any, collection_report_changes: Array<{ __typename?: 'collection_report_changes', timestamp: any }> }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> }, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null } | null }> };

export type GetSpoofingReportFiltersWithPendingRequestsQueryVariables = Exact<{
  enforcementStatuses: Array<Scalars['String']> | Scalars['String'];
  platforms: Array<Scalars['String']> | Scalars['String'];
  products: Array<Scalars['platform_type']> | Scalars['platform_type'];
  submissionSources: Array<Scalars['String']> | Scalars['String'];
  includeCreditCardData?: Scalars['Boolean'];
}>;


export type GetSpoofingReportFiltersWithPendingRequestsQuery = { __typename?: 'query_root', spoofing_reports: Array<{ __typename?: 'spoofing_reports', spoofing_entity: { __typename?: 'spoofing_entities', entity_name: string }, organization: { __typename?: 'organizations', name: string }, enforcement_requests: Array<{ __typename?: 'enforcement_requests', platform: string }> }> };

export type GetSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables = Exact<{
  enforcementStatuses: Array<Scalars['String']> | Scalars['String'];
  platforms: Array<Scalars['String']> | Scalars['String'];
  products: Array<Scalars['platform_type']> | Scalars['platform_type'];
  submissionSources: Array<Scalars['String']> | Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  includeCreditCardData?: Scalars['Boolean'];
  organizationNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  entityNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetSpoofingReportsWithPendingRequestsAndOrgNameQuery = { __typename?: 'query_root', spoofing_reports: Array<{ __typename?: 'spoofing_reports', id: any, original_entity_id: any, report_status: string, type: string, screenshot_url?: string | null, spoof_status: any, report_screenshots?: any | null, flagged_url: string, unsanitized_url?: string | null, created_at: any, last_activity_timestamp: any, notes?: string | null, source?: string | null, website_content?: string | null, last_reported_at?: any | null, last_resolved_at?: any | null, estimated_usd_price?: number | null, score?: number | null, external_source?: string | null, is_customer_sourced?: boolean | null, external_id?: number | null, severity?: string | null, last_actioned_at?: any | null, collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', max?: { __typename?: 'collection_report_changes_max_fields', timestamp?: any | null } | null } | null }, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, platform: string, updated_at: any, type: string, status: string }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null, organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> }, spoofing_entity: { __typename?: 'spoofing_entities', id: any, domain_data: any, entity_name: string, entity_type: string, entity_url?: string | null, screenshot_url?: string | null }, domain_data?: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } | null, first_domain_data: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null }>, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, approvals: Array<{ __typename?: 'approvals', id: any, created_at: any, updated_at: any, status: any, reason?: string | null, requester: { __typename?: 'users', name: string }, approver?: { __typename?: 'users', name: string } | null }>, report_tags: Array<{ __typename?: 'report_tags', tag: { __typename?: 'tags', id: any, name: string, is_internal: boolean, description: string } }>, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, created_at: any, snapshot_source: string, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, email?: { __typename?: 'emails', id: any, subject?: string | null, body?: string | null, sender?: string | null, receiver?: string | null, screenshot_url?: string | null, dkim?: string | null, spf?: string | null, dmarc?: string | null, external_id?: string | null, headers?: any | null, cc?: string | null, bcc?: string | null, eml_url?: string | null, sentiment_analysis?: any | null, forward_data?: any | null, header_analysis?: any | null } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, social_media_group?: { __typename?: 'social_media_group', id: any, external_created_at?: any | null, external_id?: string | null, created_at: any, url?: string | null, raw_enriched_data?: any | null, platform_subtype_id: any, name?: string | null, image_url?: string | null, is_private?: boolean | null, num_members?: number | null, description?: string | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }>, match_attributions: Array<{ __typename?: 'match_attributions', id: any, attribution_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, force_create_report: boolean } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any } | null }> }>, uploader?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null, spoofing_reports_to_tags: Array<{ __typename?: 'spoofing_reports_to_tags', tag_name: string }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', id: any, new_value: string, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null }>, internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null, external_alert_assignee?: { __typename?: 'users', id: any, email: string } | null }> };

export type GetCountSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables = Exact<{
  enforcementStatuses: Array<Scalars['String']> | Scalars['String'];
  platforms: Array<Scalars['String']> | Scalars['String'];
  products: Array<Scalars['platform_type']> | Scalars['platform_type'];
  submissionSources: Array<Scalars['String']> | Scalars['String'];
  entityNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  organizationNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery = { __typename?: 'query_root', spoofing_reports_aggregate: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null } };

export type UpdateEnforcementRequestsStatusMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
  enforcementStatus: Scalars['String'];
  reportChanges: Array<Collection_Report_Changes_Insert_Input> | Collection_Report_Changes_Insert_Input;
}>;


export type UpdateEnforcementRequestsStatusMutation = { __typename?: 'mutation_root', update_enforcement_requests?: { __typename?: 'enforcement_requests_mutation_response', returning: Array<{ __typename?: 'enforcement_requests', id: any, status: string }> } | null, insert_collection_report_changes?: { __typename?: 'collection_report_changes_mutation_response', returning: Array<{ __typename?: 'collection_report_changes', id: any }> } | null };

export type GetMlFeaturesQueryVariables = Exact<{
  match_ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetMlFeaturesQuery = { __typename?: 'query_root', ml_features: Array<{ __typename?: 'ml_features', name: string, value: string, extra_data?: any | null, match_id: any, created_at: any, id: any, is_value_from_model: boolean, threshold?: any | null, normalized_value?: any | null }> };

export type GetAllPlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPlatformsQuery = { __typename?: 'query_root', platforms: Array<{ __typename?: 'platforms', name: string }> };

export type BulkUpdateTypeForReportsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
  type: Scalars['String'];
}>;


export type BulkUpdateTypeForReportsMutation = { __typename?: 'mutation_root', update_spoofing_reports?: { __typename?: 'spoofing_reports_mutation_response', returning: Array<{ __typename?: 'spoofing_reports', id: any, type: string }> } | null };

export type BulkUpdatePlatformSubtypeIdForReportsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
  platform_subtype_id: Scalars['uuid'];
}>;


export type BulkUpdatePlatformSubtypeIdForReportsMutation = { __typename?: 'mutation_root', update_spoofing_reports?: { __typename?: 'spoofing_reports_mutation_response', returning: Array<{ __typename?: 'spoofing_reports', id: any, platform_subtype_id?: any | null, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string } | null }> } | null };

export type BulkUpdateBrandForProtectedAssetsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
  brand_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
}>;


export type BulkUpdateBrandForProtectedAssetsMutation = { __typename?: 'mutation_root', update_protected_assets?: { __typename?: 'protected_assets_mutation_response', returning: Array<{ __typename?: 'protected_assets', id: any, original_entity_id: any, last_updated_by_user_id?: any | null }> } | null };

export type BulkUpdateBrandforCustomerAssetsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
  user_id: Scalars['uuid'];
  customer_assets_to_brands_conditions: Array<Customer_Assets_To_Brands_Bool_Exp> | Customer_Assets_To_Brands_Bool_Exp;
  customer_assets_to_brands_objects: Array<Customer_Assets_To_Brands_Insert_Input> | Customer_Assets_To_Brands_Insert_Input;
}>;


export type BulkUpdateBrandforCustomerAssetsMutation = { __typename?: 'mutation_root', update_customer_assets?: { __typename?: 'customer_assets_mutation_response', returning: Array<{ __typename?: 'customer_assets', id: any, organization_id: any, last_updated_by_user_id?: any | null }> } | null, delete_customer_assets_to_brands?: { __typename?: 'customer_assets_to_brands_mutation_response', affected_rows: number } | null, insert_customer_assets_to_brands?: { __typename?: 'customer_assets_to_brands_mutation_response', returning: Array<{ __typename?: 'customer_assets_to_brands', customer_asset_id: any, brand_id: any }> } | null };

export type UpdateBrandForCustomerAssetMutationVariables = Exact<{
  id: Scalars['uuid'];
  brand_ids: Array<Scalars['uuid']> | Scalars['uuid'];
  organization_id: Scalars['uuid'];
}>;


export type UpdateBrandForCustomerAssetMutation = { __typename?: 'mutation_root', manage_safelist?: { __typename?: 'ManageSafelistOutput', id: any } | null };

export type GetCustomerAssetsByValuesQueryVariables = Exact<{
  values: Array<Scalars['String']> | Scalars['String'];
  organization_id: Scalars['uuid'];
}>;


export type GetCustomerAssetsByValuesQuery = { __typename?: 'query_root', customer_assets: Array<{ __typename?: 'customer_assets', id: any, value: string }> };

export type BulkUpdateBrandForReportsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
  brand_id: Scalars['uuid'];
  audit_logs: Array<Collection_Report_Changes_Insert_Input> | Collection_Report_Changes_Insert_Input;
}>;


export type BulkUpdateBrandForReportsMutation = { __typename?: 'mutation_root', update_spoofing_reports?: { __typename?: 'spoofing_reports_mutation_response', returning: Array<{ __typename?: 'spoofing_reports', id: any, original_entity_id: any }> } | null, insert_collection_report_changes?: { __typename?: 'collection_report_changes_mutation_response', returning: Array<{ __typename?: 'collection_report_changes', id: any }> } | null };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserByIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email: string, name: string, is_internal: boolean, organization_id: any, app_settings: any, optery_member_uuid?: any | null }> };

export type GetUserEmailByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetUserEmailByIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', email: string }> };

export type UpdateAppSettingsForUserMutationVariables = Exact<{
  user_id: Scalars['uuid'];
  app_settings: Scalars['jsonb'];
}>;


export type UpdateAppSettingsForUserMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', id: any, app_settings: any }> } | null };

export type GetAllExternalUsersQueryVariables = Exact<{
  organization_ids?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type GetAllExternalUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email: string, name: string, is_internal: boolean, created_at: any, app_settings: any }> };

export type GetAllUsersForOrganizationQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
  is_internal?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAllUsersForOrganizationQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email: string, name: string, created_at: any, onboarding_status?: string | null, organizations: Array<{ __typename?: 'user_organizations', role?: { __typename?: 'roles', name: string } | null }>, products: Array<{ __typename?: 'user_products', product: string }> }> };

export type GetEnforcementDetailsBySpoofingReportIdQueryVariables = Exact<{
  spoofing_report_id: Scalars['uuid'];
}>;


export type GetEnforcementDetailsBySpoofingReportIdQuery = { __typename?: 'query_root', spoofing_reports_by_pk?: { __typename?: 'spoofing_reports', flagged_url: string, enforcement_requests: Array<{ __typename?: 'enforcement_requests', id: any, updated_at: any, type: string, platform: string, status: string, submission_proof_url?: string | null, submitted_at?: any | null, reason?: string | null, submission_external_id?: string | null, created_at: any, submission_email?: string | null, submission_source?: string | null, retraction_description?: string | null, retraction_proof_url?: string | null, user?: { __typename?: 'users', id: any, name: string, is_internal: boolean } | null }>, collection_report_changes: Array<{ __typename?: 'collection_report_changes', enforcement_request_id?: any | null, new_value: string, old_value?: string | null, source?: string | null, timestamp: any, type: string, user?: { __typename?: 'users', name: string, is_internal: boolean } | null, enforcement_request?: { __typename?: 'enforcement_requests', platform: string, type: string } | null, enforcement_email?: { __typename?: 'enforcement_emails', type: string } | null }> } | null };

export type GetEnforcementMetadataQueryVariables = Exact<{
  org_id: Scalars['uuid'];
}>;


export type GetEnforcementMetadataQuery = { __typename?: 'query_root', enforcement_metadata: Array<{ __typename?: 'enforcement_metadata', authorization_letter_url?: string | null, enforcement_email?: string | null, legal_name?: string | null, country_code?: string | null, authorization_letter_url_expiration_date?: any | null, allowed_domain_enforcement_types: any }> };

export type InsertEnforcementEmailMutationVariables = Exact<{
  sender: Scalars['String'];
  receiver: Scalars['String'];
  subject: Scalars['String'];
  received_at: Scalars['timestamp'];
  type: Scalars['String'];
}>;


export type InsertEnforcementEmailMutation = { __typename?: 'mutation_root', insert_enforcement_emails_one?: { __typename?: 'enforcement_emails', id: any } | null };

export type InsertCollectionReportChangesMutationVariables = Exact<{
  type: Scalars['String'];
  old_value: Scalars['String'];
  new_value: Scalars['String'];
  user_id: Scalars['uuid'];
  spoof_report_id?: InputMaybe<Scalars['uuid']>;
  source: Scalars['String'];
  enforcement_request_id?: InputMaybe<Scalars['uuid']>;
  enforcement_email_id?: InputMaybe<Scalars['uuid']>;
  timestamp?: InputMaybe<Scalars['timestamp']>;
}>;


export type InsertCollectionReportChangesMutation = { __typename?: 'mutation_root', insert_collection_report_changes_one?: { __typename?: 'collection_report_changes', id: any } | null };

export type GetStatsDataQueryVariables = Exact<{
  org_id: Scalars['uuid'];
  filter_by?: InputMaybe<Scalars['jsonb']>;
  group_by?: InputMaybe<Scalars['String']>;
  date_range?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['String']>;
  is_init_run?: InputMaybe<Scalars['Boolean']>;
  graph_name?: InputMaybe<Scalars['String']>;
  stat_type?: InputMaybe<Scalars['String']>;
}>;


export type GetStatsDataQuery = { __typename?: 'query_root', get_stats_data: { __typename?: 'GetStatsDataOutput', data?: any | null } };

export type UpsertNotificationSubscriptionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  org_id: Scalars['uuid'];
  sendgrid_template_id?: InputMaybe<Scalars['String']>;
  notification_type: Scalars['String'];
  frequency?: InputMaybe<Scalars['String']>;
  slack_channel_id?: InputMaybe<Scalars['String']>;
  emails_to_notify?: InputMaybe<Scalars['jsonb']>;
  platform: Scalars['String'];
  updated_by: Scalars['uuid'];
  first_notification_date?: InputMaybe<Scalars['timestamp']>;
  report_type?: InputMaybe<Scalars['String']>;
}>;


export type UpsertNotificationSubscriptionMutation = { __typename?: 'mutation_root', insert_notification_subscriptions?: { __typename?: 'notification_subscriptions_mutation_response', returning: Array<{ __typename?: 'notification_subscriptions', id: any, org_id: any, sendgrid_template_id?: string | null, notification_type: string, frequency: string, slack_channel_id?: string | null, emails_to_notify?: any | null, platform: string, updated_by: any, first_notification_date: any, report_type?: string | null }> } | null };

export type GetNotificationSubscriptionsByOrgQueryVariables = Exact<{
  org_id: Scalars['uuid'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Subscriptions_Order_By> | Notification_Subscriptions_Order_By>;
}>;


export type GetNotificationSubscriptionsByOrgQuery = { __typename?: 'query_root', notification_subscriptions: Array<{ __typename?: 'notification_subscriptions', id: any, org_id: any, sendgrid_template_id?: string | null, notification_type: string, frequency: string, slack_channel_id?: string | null, emails_to_notify?: any | null, platform: string, created_at: any, updated_at: any, first_notification_date: any, report_type?: string | null, user: { __typename?: 'users', name: string, email: string, is_internal: boolean }, organization: { __typename?: 'organizations', id: any, slack_access_token?: string | null } }> };

export type DeleteNotificationSubscriptionMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type DeleteNotificationSubscriptionMutation = { __typename?: 'mutation_root', delete_notification_subscriptions?: { __typename?: 'notification_subscriptions_mutation_response', returning: Array<{ __typename?: 'notification_subscriptions', id: any }> } | null };

export type GetNotificationSubscriptionCountByOrgQueryVariables = Exact<{
  org_id: Scalars['uuid'];
}>;


export type GetNotificationSubscriptionCountByOrgQuery = { __typename?: 'query_root', notification_subscriptions_aggregate: { __typename?: 'notification_subscriptions_aggregate', aggregate?: { __typename?: 'notification_subscriptions_aggregate_fields', count: number } | null } };

export type GetReportMatchesQueryVariables = Exact<{
  report_id: Scalars['uuid'];
  includeCreditCardData?: Scalars['Boolean'];
}>;


export type GetReportMatchesQuery = { __typename?: 'query_root', spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, classification: any, suspicion_score?: any | null, full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, screenshot_url?: string | null, site_html_url?: string | null, favicon_url?: string | null, domain_data: { __typename?: 'domain_data', id: any, created_date?: any | null, updated_date?: any | null, registrar_name?: string | null, contact_email?: string | null, ip_address?: string | null, country_code?: string | null, hosting_provider?: string | null, raw_data?: any | null, raw_data_json?: any | null, mx_records?: any | null } } | null, social_media_data?: { __typename?: 'social_media_data', id: any, num_followers?: number | null, account_creation_time?: any | null, platform_name: string, profile_image_url?: string | null, profile_image_hash?: string | null, profile_description?: string | null, profile_display_name?: string | null, profile_display_url?: string | null, slug: string, external_id?: string | null, screenshot_url?: string | null } | null, mobile_app?: { __typename?: 'mobile_apps', id: any, title?: string | null, description?: string | null, app_id?: string | null, screenshot_url?: string | null, thumbnail_url?: string | null, developer_id?: string | null, developer_name?: string | null, bundle_id?: string | null, external_created_at?: any | null, link: string, platform_name: string } | null, dark_web?: { __typename?: 'dark_web', id: any, crawled_at: any, created_at: any, body?: string | null, title?: string | null, risk_score?: any | null, uri?: string | null, url?: string | null, location?: string | null, domain?: string | null, ip?: string | null, email?: string | null, password?: string | null, leak_name?: string | null, network?: any | null, source: string, password_type?: any | null, additional_data?: any | null, languages?: any | null, translated_title?: string | null, translated_body?: string | null, credential_url?: string | null, credit_card_id?: any | null, credit_card?: { __typename?: 'credit_cards', id: any, bin: number, expiration_date: any, credit_card_number?: string | null, cardholder_name?: string | null, cardholder_address?: string | null } | null } | null, phone_number?: { __typename?: 'phone_numbers', id: any, number: string, country_code: string, telco_provider?: string | null, created_at: any, updated_at: any } | null, advertisement_data?: { __typename?: 'advertisement_data', id: any, ad_detail_link: string, platform_subtype_id: any, created_at: any, updated_at?: any | null, source: string, text_content?: string | null, image_content_urls?: Array<string> | null, video_content_urls?: Array<string> | null, screenshot_url?: string | null, ad_detail_html_url?: string | null, date_first_shown?: any | null, date_last_shown?: any | null, advertiser_data?: { __typename?: 'advertiser_data', id: any, name: string, platform_subtype_id: any, advertiser_profile_link: string, advertiser_ads_link: string, created_at: any, num_ads?: number | null, is_verified?: boolean | null, location?: string | null, updated_at?: any | null } | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null } | null, social_media_post?: { __typename?: 'social_media_post', id: any, full_text: string, external_created_at?: any | null, social_media_data_id?: any | null, num_upvotes?: number | null, num_reposts?: number | null, platform?: string | null, external_id?: string | null, created_at: any, url?: string | null, extra_urls?: any | null, screenshot_url?: string | null } | null, ecommerce_listing?: { __typename?: 'ecommerce_listings', id: any, title?: string | null, description?: string | null, price?: number | null, seller_name?: string | null, external_id?: string | null, external_created_at?: any | null, created_at: any, url: string, rating?: number | null, platform_name: string, source_url?: string | null, telegram_info?: any | null, discord_info?: any | null, num_units?: number | null, num_units_sold?: number | null, shop_name?: string | null } | null, ml_features: Array<{ __typename?: 'ml_features', id: any, name: string, threshold?: any | null, value: string, detection_asset?: { __typename?: 'detection_assets', type: string, value?: string | null } | null }> }> };

export type AiPromptFieldsFragment = { __typename?: 'ai_prompts', id: any, prompt: string, metadata?: any | null, platform?: string | null };

export type GetAiPromptsForDefaultActionQueryVariables = Exact<{
  role: Scalars['String'];
  type: Scalars['String'];
  platform: Scalars['String'];
  sub_type: Scalars['String'];
}>;


export type GetAiPromptsForDefaultActionQuery = { __typename?: 'query_root', ai_prompts: Array<{ __typename?: 'ai_prompts', id: any, prompt: string, metadata?: any | null, platform?: string | null }> };

export type RecordAiResponseFeedbackVotesMutationVariables = Exact<{
  id: Scalars['uuid'];
  upvotes?: InputMaybe<Scalars['Int']>;
  downvotes?: InputMaybe<Scalars['Int']>;
}>;


export type RecordAiResponseFeedbackVotesMutation = { __typename?: 'mutation_root', update_ai_responses_by_pk?: { __typename?: 'ai_responses', id: any, upvotes: number, downvotes: number } | null };

export type GetPiiReportsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  removalStatus?: InputMaybe<Scalars['Int']>;
  userId: Scalars['uuid'];
}>;


export type GetPiiReportsQuery = { __typename?: 'query_root', get_pii_reports_with_screenshots: Array<{ __typename?: 'pii_reports', id: any, user_id: any, created_at: any, exposure_status: number, exposure_status_description: string, removal_status: number, removal_status_description: string, screenshot_found_image?: string | null, screenshot_found_created_at?: any | null, screenshot_notfound_created_at?: any | null, screenshot_notfound_image?: string | null, databroker_uuid: any, databroker?: { __typename?: 'pii_databrokers', databroker_uuid: any, databroker_name: string } | null }> };

export type GetPiiReportDetailsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  databroker_uuid: Scalars['uuid'];
}>;


export type GetPiiReportDetailsQuery = { __typename?: 'query_root', get_pii_reports_with_screenshots: Array<{ __typename?: 'pii_reports', id: any, created_at: any, screenshot_found_image?: string | null, screenshot_found_created_at?: any | null, screenshot_notfound_image?: string | null, screenshot_notfound_created_at?: any | null, exposure_status_description: string, removal_status_description: string, exposure_url?: string | null, databroker_uuid: any, databroker?: { __typename?: 'pii_databrokers', databroker_uuid: any, databroker_name: string } | null }> };

export type GetPiiReportsCountsPerStatusQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetPiiReportsCountsPerStatusQuery = { __typename?: 'query_root', pending: { __typename?: 'pii_reports_aggregate', aggregate?: { __typename?: 'pii_reports_aggregate_fields', count: number } | null }, submitted: { __typename?: 'pii_reports_aggregate', aggregate?: { __typename?: 'pii_reports_aggregate_fields', count: number } | null }, removed_not_found: { __typename?: 'pii_reports_aggregate', aggregate?: { __typename?: 'pii_reports_aggregate_fields', count: number } | null }, non_compliant: { __typename?: 'pii_reports_aggregate', aggregate?: { __typename?: 'pii_reports_aggregate_fields', count: number } | null }, escalation_in_progress: { __typename?: 'pii_reports_aggregate', aggregate?: { __typename?: 'pii_reports_aggregate_fields', count: number } | null } };

export type GetPiiStatisticsQueryVariables = Exact<{
  userId: Scalars['uuid'];
  dateFrom?: InputMaybe<Scalars['date']>;
  dateTo?: InputMaybe<Scalars['date']>;
}>;


export type GetPiiStatisticsQuery = { __typename?: 'query_root', pii_statistics: Array<{ __typename?: 'pii_statistics', id: any, user_id: any, date: any, db_covered: number, exposed: number, removals_in_progress: number, removals_pending: number, removed_not_found: number, total_removed_not_found: number }> };

export type GetLatestPiiStatisticsQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetLatestPiiStatisticsQuery = { __typename?: 'query_root', pii_statistics: Array<{ __typename?: 'pii_statistics', id: any, user_id: any, date: any, db_covered: number, exposed: number, removals_in_progress: number, removals_pending: number, removed_not_found: number, total_removed_not_found: number }> };

export type GetUploadedFilesQueryVariables = Exact<{
  spoof_report_id: Scalars['uuid'];
}>;


export type GetUploadedFilesQuery = { __typename?: 'query_root', uploaded_files: Array<{ __typename?: 'uploaded_files', file_name: string, created_at: any, user: { __typename?: 'users', email: string } }> };

export type GetPiiLeaksByDatabrokerQueryVariables = Exact<{
  user_id: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPiiLeaksByDatabrokerQuery = { __typename?: 'query_root', pii_leaks_by_databroker: Array<{ __typename?: 'pii_leaks_by_databroker', databroker_name?: string | null, leak_count?: any | null }> };

export type GetPurchasableDomainsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  where: Defensive_Domain_Registration_Bool_Exp;
  orderBy: Defensive_Domain_Registration_Order_By;
}>;


export type GetPurchasableDomainsQuery = { __typename?: 'query_root', defensive_domain_registration: Array<{ __typename?: 'defensive_domain_registration', price: any, status: string, purchased_at?: any | null, updated_at: any, domain_data_id: any, id: any, domain_data: { __typename?: 'domain_data', root_domain: string }, spoofing_report?: { __typename?: 'spoofing_reports', id: any, report_status: string, external_id?: number | null } | null }> };

export type GetPurchasableDomainStatusCountsQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
}>;


export type GetPurchasableDomainStatusCountsQuery = { __typename?: 'query_root', available: { __typename?: 'defensive_domain_registration_aggregate', aggregate?: { __typename?: 'defensive_domain_registration_aggregate_fields', count: number } | null }, requested: { __typename?: 'defensive_domain_registration_aggregate', aggregate?: { __typename?: 'defensive_domain_registration_aggregate_fields', count: number } | null }, purchased: { __typename?: 'defensive_domain_registration_aggregate', aggregate?: { __typename?: 'defensive_domain_registration_aggregate_fields', count: number } | null } };

export type UpdateDefensiveDomainRegistrationManyMutationVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
  newStatus: Scalars['String'];
}>;


export type UpdateDefensiveDomainRegistrationManyMutation = { __typename?: 'mutation_root', update_defensive_domain_registration?: { __typename?: 'defensive_domain_registration_mutation_response', returning: Array<{ __typename?: 'defensive_domain_registration', id: any, status: string }> } | null };

export type GetTotalReportsInfoCountQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
  start_date?: InputMaybe<Scalars['timestamp']>;
  end_date?: InputMaybe<Scalars['timestamp']>;
  type: Array<Scalars['String']> | Scalars['String'];
  old_value: Array<Scalars['String']> | Scalars['String'];
  new_value: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetTotalReportsInfoCountQuery = { __typename?: 'query_root', collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', count: number } | null } };

export type GetSpecificReportsInfoCountQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
  start_date?: InputMaybe<Scalars['timestamp']>;
  end_date?: InputMaybe<Scalars['timestamp']>;
  type: Array<Scalars['String']> | Scalars['String'];
  new_value: Scalars['String'];
}>;


export type GetSpecificReportsInfoCountQuery = { __typename?: 'query_root', collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', count: number } | null } };

export type GetEnforcementTypesQueryVariables = Exact<{
  enforcementTypesWhere: Enforcement_Types_Bool_Exp;
}>;


export type GetEnforcementTypesQuery = { __typename?: 'query_root', enforcement_types: Array<{ __typename?: 'enforcement_types', priority: number, content_type?: string | null, content_type_display_name?: string | null, platform: string, type: string, updated_by?: any | null, enforcement_method_type?: string | null, enforcement_method_data?: string | null, enforcement_platform: { __typename?: 'enforcement_platforms', platform?: string | null, notes?: string | null, types?: any | null } }> };

export type GetContentTypesByEnforcementPlatformQueryVariables = Exact<{
  platform: Scalars['String'];
}>;


export type GetContentTypesByEnforcementPlatformQuery = { __typename?: 'query_root', enforcement_types: Array<{ __typename?: 'enforcement_types', content_type?: string | null, content_type_display_name?: string | null }> };

export type GetContentTypesByEnforcementPlatformAndContentTypeQueryVariables = Exact<{
  platform: Scalars['String'];
  content_type: Scalars['String'];
}>;


export type GetContentTypesByEnforcementPlatformAndContentTypeQuery = { __typename?: 'query_root', enforcement_types: Array<{ __typename?: 'enforcement_types', content_type?: string | null, content_type_display_name?: string | null }> };

export type GetEnforcementTypesByContentTypeQueryVariables = Exact<{
  platform: Scalars['String'];
  content_type_display_name: Scalars['String'];
}>;


export type GetEnforcementTypesByContentTypeQuery = { __typename?: 'query_root', enforcement_types: Array<{ __typename?: 'enforcement_types', type: string }> };

export type GetGcsObjectQueryVariables = Exact<{
  bucket_name: Scalars['String'];
  object_name: Scalars['String'];
  include_object?: InputMaybe<Scalars['Boolean']>;
  exact_match?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetGcsObjectQuery = { __typename?: 'query_root', get_gcs_object: { __typename?: 'ManageGCSObjectsOutput', object_info: any } };

export type DeleteGcsObjectMutationVariables = Exact<{
  bucket_name: Scalars['String'];
  object_name: Scalars['String'];
  generation_number?: InputMaybe<Scalars['String']>;
}>;


export type DeleteGcsObjectMutation = { __typename?: 'mutation_root', modify_gcs_object?: { __typename?: 'ModifyGCSObjectOutput', message?: string | null } | null };

export type CreateGcsObjectMutationVariables = Exact<{
  bucket_name: Scalars['String'];
  object_name: Scalars['String'];
  base64_content: Scalars['bytea'];
  mime_type: Scalars['String'];
  metadata?: InputMaybe<Scalars['jsonb']>;
}>;


export type CreateGcsObjectMutation = { __typename?: 'mutation_root', modify_gcs_object?: { __typename?: 'ModifyGCSObjectOutput', public_url?: string | null } | null };

export type DeleteAlertLinkMutationVariables = Exact<{
  alert_link_id: Scalars['String'];
}>;


export type DeleteAlertLinkMutation = { __typename?: 'mutation_root', modify_alert_links: { __typename?: 'ModifyAlertLinksOutput', response: any } };

export type CreateAlertLinkMutationVariables = Exact<{
  alert_id_1: Scalars['String'];
  alert_id_2: Scalars['String'];
  relationship: Scalars['String'];
  type: Scalars['String'];
}>;


export type CreateAlertLinkMutation = { __typename?: 'mutation_root', modify_alert_links: { __typename?: 'ModifyAlertLinksOutput', response: any } };

export type Linked_AlertFragment = { __typename?: 'spoofing_reports', id: any, external_id?: number | null, flagged_url: string, spoof_matches: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, site_html_url?: string | null } | null }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null }, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', name: string, platform: string, product: string } | null };

export type GetAlertLinksByAlertIdQueryVariables = Exact<{
  alert_id: Scalars['uuid'];
}>;


export type GetAlertLinksByAlertIdQuery = { __typename?: 'query_root', alert_links: Array<{ __typename?: 'alert_links', id: any, type: string, relationship: string, created_at: any, updated_at?: any | null, alert_1: { __typename?: 'spoofing_reports', id: any, external_id?: number | null, flagged_url: string, spoof_matches: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, site_html_url?: string | null } | null }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null }, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', name: string, platform: string, product: string } | null }, alert_2: { __typename?: 'spoofing_reports', id: any, external_id?: number | null, flagged_url: string, spoof_matches: Array<{ __typename?: 'spoof_matches', full_url?: { __typename?: 'full_urls', id: any, url: string, unsanitized_url?: string | null, site_html_url?: string | null } | null }>, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null }, platform?: { __typename?: 'platforms', name: string, product: any } | null, platform_subtype?: { __typename?: 'platform_subtypes', name: string, platform: string, product: string } | null }, user?: { __typename?: 'users', id: any, name: string } | null }> };

export type GetEnforcementLinkedAlertInfoQueryVariables = Exact<{
  alert_ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetEnforcementLinkedAlertInfoQuery = { __typename?: 'query_root', spoofing_reports: Array<{ __typename?: 'spoofing_reports', flagged_url: string, id: any, external_id?: number | null, organization: { __typename?: 'organizations', abbr_name?: string | null } }> };

export type GetJiraMetadataFromEnforcementRequestIdQueryVariables = Exact<{
  enforcement_request_id: Scalars['uuid'];
}>;


export type GetJiraMetadataFromEnforcementRequestIdQuery = { __typename?: 'query_root', jira_metadata: Array<{ __typename?: 'jira_metadata', status: string, has_platform_reply?: boolean | null }> };

export type CreateDarkWebCreditCardReportMutationVariables = Exact<{
  organization_id: Scalars['uuid'];
  brand_id: Scalars['uuid'];
  flagged_url: Scalars['String'];
  type: Scalars['String'];
  platform_subtype_id: Scalars['uuid'];
  source: Scalars['String'];
  report_status: Scalars['String'];
  spoofing_status: Scalars['spoofing_status'];
  uploader_id: Scalars['uuid'];
  suspicion_score: Scalars['numeric'];
  classification: Scalars['spoofing_status'];
  location: Scalars['String'];
  dark_web_id: Scalars['uuid'];
  dark_web_network: Scalars['dark_web_network'];
  credit_card_number: Scalars['String'];
  bin: Scalars['Int'];
  expiration_date: Scalars['date'];
  cardholder_name: Scalars['String'];
  cardholder_address: Scalars['String'];
}>;


export type CreateDarkWebCreditCardReportMutation = { __typename?: 'mutation_root', insert_spoofing_reports?: { __typename?: 'spoofing_reports_mutation_response', returning: Array<{ __typename?: 'spoofing_reports', id: any, original_entity_id: any, flagged_url: string, type: string, report_status: string, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, dark_web?: { __typename?: 'dark_web', id: any, credit_card?: { __typename?: 'credit_cards', id: any } | null } | null }> }> } | null };

export type UpsertIocAlertAttributionMutationVariables = Exact<{
  ioc_id: Scalars['uuid'];
  match_id: Scalars['uuid'];
}>;


export type UpsertIocAlertAttributionMutation = { __typename?: 'mutation_root', insert_ioc_alert_attribution_one?: { __typename?: 'ioc_alert_attribution', id: any } | null };

export type CreateDarkWebCredentialLeakReportMutationVariables = Exact<{
  organization_id: Scalars['uuid'];
  brand_id: Scalars['uuid'];
  flagged_url: Scalars['String'];
  type: Scalars['String'];
  platform_subtype_id: Scalars['uuid'];
  source: Scalars['String'];
  report_status: Scalars['String'];
  spoofing_status: Scalars['spoofing_status'];
  uploader_id: Scalars['uuid'];
  suspicion_score: Scalars['numeric'];
  classification: Scalars['spoofing_status'];
  location: Scalars['String'];
  dark_web_id: Scalars['uuid'];
  dark_web_network: Scalars['dark_web_network'];
  credentials: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  credential_url: Scalars['String'];
}>;


export type CreateDarkWebCredentialLeakReportMutation = { __typename?: 'mutation_root', insert_spoofing_reports?: { __typename?: 'spoofing_reports_mutation_response', returning: Array<{ __typename?: 'spoofing_reports', id: any, original_entity_id: any, flagged_url: string, type: string, report_status: string, spoof_matches: Array<{ __typename?: 'spoof_matches', id: any, dark_web?: { __typename?: 'dark_web', id: any, location?: string | null } | null }> }> } | null };

export type GetAllPlatformSubtypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPlatformSubtypesQuery = { __typename?: 'query_root', platform_subtypes: Array<{ __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string }> };

export type GetPlatformSubtypesByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetPlatformSubtypesByNameQuery = { __typename?: 'query_root', platform_subtypes: Array<{ __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string }> };

export type GetPlatformSubtypesByProductQueryVariables = Exact<{
  product?: InputMaybe<Scalars['String']>;
}>;


export type GetPlatformSubtypesByProductQuery = { __typename?: 'query_root', platform_subtypes: Array<{ __typename?: 'platform_subtypes', id: any, name: string, platform: string, archetype: string, product: string }> };

export type GetStateTransitionInfoFromCollectionReportChangesQueryVariables = Exact<{
  enforcement_request_id: Scalars['uuid'];
  new_value: Scalars['String'];
  type: Scalars['String'];
}>;


export type GetStateTransitionInfoFromCollectionReportChangesQuery = { __typename?: 'query_root', collection_report_changes: Array<{ __typename?: 'collection_report_changes', new_value: string, old_value?: string | null, timestamp: any, enforcement_request_id?: any | null }> };

export type GetIocsForMatchQueryVariables = Exact<{
  match_id: Scalars['uuid'];
}>;


export type GetIocsForMatchQuery = { __typename?: 'query_root', iocs: Array<{ __typename?: 'iocs', id: any, value: string, type: string, status: string, created_at: any, updated_at?: any | null }> };

export type GetIocsQueryVariables = Exact<{
  where: Iocs_Bool_Exp;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy: Array<Iocs_Order_By> | Iocs_Order_By;
}>;


export type GetIocsQuery = { __typename?: 'query_root', iocs: Array<{ __typename?: 'iocs', id: any, value: string, type: string, status: string, ioc_alert_attributions: Array<{ __typename?: 'ioc_alert_attribution', spoof_match: { __typename?: 'spoof_matches', spoofing_report?: { __typename?: 'spoofing_reports', spoofing_entity: { __typename?: 'spoofing_entities', id: any } } | null } }>, ioc_detection_config_attributions: Array<{ __typename?: 'ioc_detection_config_attribution', detection_config_type: string }> }> };

export type UpdateIocStatusMutationVariables = Exact<{
  id: Scalars['uuid'];
  status: Scalars['String'];
}>;


export type UpdateIocStatusMutation = { __typename?: 'mutation_root', update_iocs?: { __typename?: 'iocs_mutation_response', affected_rows: number } | null };

export type UpdateIocMutationVariables = Exact<{
  id: Scalars['uuid'];
  status: Scalars['String'];
  notes: Scalars['String'];
}>;


export type UpdateIocMutation = { __typename?: 'mutation_root', update_iocs?: { __typename?: 'iocs_mutation_response', affected_rows: number } | null };

export type GetIocForModalQueryVariables = Exact<{
  id: Scalars['uuid'];
  isEmployeeView: Scalars['Boolean'];
}>;


export type GetIocForModalQuery = { __typename?: 'query_root', iocs_by_pk?: { __typename?: 'iocs', id: any, value: string, type: string, status: string, additional_metadata: any, notes?: string | null, ioc_alert_attributions: Array<{ __typename?: 'ioc_alert_attribution', id: any, spoof_match: { __typename?: 'spoof_matches', spoofing_report?: { __typename?: 'spoofing_reports', id: any, external_id?: number | null, flagged_url: string, platform?: { __typename?: 'platforms', product: any, name: string } | null, spoofing_entity: { __typename?: 'spoofing_entities', entity_name: string, id: any, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null } }, organization: { __typename?: 'organizations', id: any, name: string, abbr_name?: string | null } } | null } }>, ioc_detection_config_attributions?: Array<{ __typename?: 'ioc_detection_config_attribution', id: any, detection_config_id: any, detection_config_type: string, sourcing_queries?: { __typename?: 'sourcing_queries', sourcer_label: string, query: string, spoofing_entity: { __typename?: 'spoofing_entities', entity_name: string } } | null, detection_assets?: { __typename?: 'detection_assets', id: any, value?: string | null, type: string, spoofing_entity: { __typename?: 'spoofing_entities', entity_name: string } } | null, rules?: { __typename?: 'rules', id: any, description: string, type: string, rule_expression: any, spoofing_entity?: { __typename?: 'spoofing_entities', entity_name: string } | null } | null }> } | null };

export type InsertIocSourcingQueryMutationVariables = Exact<{
  detection_config_id: Scalars['uuid'];
  detection_config_type: Scalars['String'];
  ioc_id: Scalars['uuid'];
}>;


export type InsertIocSourcingQueryMutation = { __typename?: 'mutation_root', insert_ioc_detection_config_attribution?: { __typename?: 'ioc_detection_config_attribution_mutation_response', returning: Array<{ __typename?: 'ioc_detection_config_attribution', id: any }> } | null };

export type GetIocsCountQueryVariables = Exact<{
  where: Iocs_Bool_Exp;
}>;


export type GetIocsCountQuery = { __typename?: 'query_root', iocs_aggregate: { __typename?: 'iocs_aggregate', aggregate?: { __typename?: 'iocs_aggregate_fields', count: number } | null } };

export type ActionOnEmailMutationVariables = Exact<{
  message_id?: InputMaybe<Scalars['String']>;
  alert_id: Scalars['String'];
  body: Scalars['String'];
  subject: Scalars['String'];
  should_send_to_soc: Scalars['Boolean'];
}>;


export type ActionOnEmailMutation = { __typename?: 'mutation_root', action_on_email?: { __typename?: 'ActionOnEmailOutput', email_id: string } | null };

export type GetGlobalTagIdByNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GetGlobalTagIdByNameQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'tags', id: any }> };

export type GetCorrespondenceForEmailQueryVariables = Exact<{
  email_id: Scalars['uuid'];
}>;


export type GetCorrespondenceForEmailQuery = { __typename?: 'query_root', email_correspondence: Array<{ __typename?: 'email_correspondence', created_at: any, body: string, sender: string, receiver: string, correspondence_type: string, message_id?: string | null, thread_id: string, user?: { __typename?: 'users', name: string } | null }> };

export type GetUserEmailsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type GetUserEmailsByIdsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email: string }> };

export type DeleteAlertMutationVariables = Exact<{
  alert_id: Scalars['String'];
}>;


export type DeleteAlertMutation = { __typename?: 'mutation_root', delete_alert?: { __typename?: 'DeleteAlertOutput', success: boolean } | null };

export type GetPiiEventsQueryVariables = Exact<{
  databroker_uuid: Scalars['uuid'];
  date_from: Scalars['timestamp'];
  date_to: Scalars['timestamp'];
  user_id: Scalars['uuid'];
}>;


export type GetPiiEventsQuery = { __typename?: 'query_root', pii_events: Array<{ __typename?: 'pii_events', message: string, external_created_at: any }> };

export type GetActivePiiDatabrokersOfUserQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetActivePiiDatabrokersOfUserQuery = { __typename?: 'query_root', get_pii_reports_with_screenshots: Array<{ __typename?: 'pii_reports', id: any, databroker?: { __typename?: 'pii_databrokers', databroker_name: string } | null }> };

export type GetAuditLogEntriesQueryVariables = Exact<{
  tableName: Scalars['String'];
  rowId: Scalars['String'];
  startDate?: InputMaybe<Scalars['timestamp']>;
}>;


export type GetAuditLogEntriesQuery = { __typename?: 'query_root', audit_logged_actions: Array<{ __typename?: 'audit_logged_actions', event_id: any, revision_id?: any | null, schema_name: string, table_name: string, row_id: string, action: string, column_name?: string | null, old_value?: string | null, new_value?: string | null, action_tstamp?: any | null }> };

export type GetSourcingQueryByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetSourcingQueryByIdQuery = { __typename?: 'query_root', sourcing_queries_by_pk?: { __typename?: 'sourcing_queries', id: any, status: string, created_at: any, updated_at: any, query: string, sourcer_label: string, force_create_report: boolean, created_by?: string | null, execution_frequency_minutes?: number | null, last_used_at?: any | null, notes?: string | null, spoofing_entity: { __typename?: 'spoofing_entities', id: any, entity_name: string, organization: { __typename?: 'organizations', id: any, name: string } } } | null };

export type GetDetectionAssetByIdQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetDetectionAssetByIdQuery = { __typename?: 'query_root', detection_assets_by_pk?: { __typename?: 'detection_assets', id: any, original_entity_id: any, value?: string | null, enabled_usage: string, type: string, is_valid?: boolean | null, is_generic: boolean, created_at: any, updated_at: any, ir_to_dr_rule: string, description?: string | null, originator_id: any, originator_type: string, last_updated_by?: string | null, full_url?: { __typename?: 'full_urls', id: any, url: string } | null, spoofing_entity: { __typename?: 'spoofing_entities', id: any, entity_name: string }, user?: { __typename?: 'users', id: any, email: string } | null, protected_asset?: { __typename?: 'protected_assets', id: any } | null, ioc?: { __typename?: 'iocs', id: any, value: string, type: string } | null, social_media?: { __typename?: 'social_media_data', id: any, platform_name: string, slug: string } | null } | null };

export type RequestAlertCsvExportMutationVariables = Exact<{
  organization_id?: InputMaybe<Scalars['uuid']>;
  product?: InputMaybe<Scalars['String']>;
  where_clause?: InputMaybe<Scalars['jsonb']>;
}>;


export type RequestAlertCsvExportMutation = { __typename?: 'mutation_root', request_alert_csv_export: any };

export type AlertCsvDownloadUrlSubscriptionVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type AlertCsvDownloadUrlSubscription = { __typename?: 'subscription_root', request_alert_csv_export?: { __typename?: 'request_alert_csv_export', errors?: any | null, output?: { __typename?: 'RequestAlertCSVExportOutput', download_url: string } | null } | null };

export type ManageElasticSearchQueryVariables = Exact<{
  query: Scalars['String'];
  size?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
}>;


export type ManageElasticSearchQuery = { __typename?: 'query_root', manage_elastic_search_queries: { __typename?: 'ElasticSearchQueriesOutput', status?: string | null, data?: any | null, message?: string | null } };

export type DeleteIocAlertAttributionMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteIocAlertAttributionMutation = { __typename?: 'mutation_root', delete_ioc_alert_attribution?: { __typename?: 'ioc_alert_attribution_mutation_response', returning: Array<{ __typename?: 'ioc_alert_attribution', id: any }> } | null };

export type CreateIocMutationVariables = Exact<{
  type: Scalars['String'];
  value: Scalars['String'];
  status: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  additional_metadata?: InputMaybe<Scalars['jsonb']>;
}>;


export type CreateIocMutation = { __typename?: 'mutation_root', insert_iocs_one?: { __typename?: 'iocs', id: any } | null };

export type DeleteIocAlertAttributionByIocAndMatchMutationVariables = Exact<{
  ioc_id: Scalars['uuid'];
  match_id: Scalars['uuid'];
}>;


export type DeleteIocAlertAttributionByIocAndMatchMutation = { __typename?: 'mutation_root', delete_ioc_alert_attribution?: { __typename?: 'ioc_alert_attribution_mutation_response', affected_rows: number } | null };

export type FindIocByTypeAndValueQueryVariables = Exact<{
  type: Scalars['String'];
  value: Scalars['String'];
}>;


export type FindIocByTypeAndValueQuery = { __typename?: 'query_root', iocs: Array<{ __typename?: 'iocs', id: any, type: string, value: string, status: string }> };

export type FindIocAlertAttributionByIocAndMatchQueryVariables = Exact<{
  ioc_id: Scalars['uuid'];
  match_id: Scalars['uuid'];
}>;


export type FindIocAlertAttributionByIocAndMatchQuery = { __typename?: 'query_root', ioc_alert_attribution: Array<{ __typename?: 'ioc_alert_attribution', id: any }> };

export type GetAnalyticsSummaryEmailsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetAnalyticsSummaryEmailsQuery = { __typename?: 'query_root', organizations: Array<{ __typename?: 'organizations', analytics_summary_recipient_emails?: any | null }> };

export type ResetSourcingQueryLastUsedAtMutationVariables = Exact<{
  id: Scalars['uuid'];
  last_updated_by?: InputMaybe<Scalars['String']>;
}>;


export type ResetSourcingQueryLastUsedAtMutation = { __typename?: 'mutation_root', update_sourcing_queries_by_pk?: { __typename?: 'sourcing_queries', id: any, last_used_at?: any | null } | null };

export type GetUserPermissionsAndProductsQueryVariables = Exact<{
  user_id: Scalars['uuid'];
  organization_id: Scalars['uuid'];
}>;


export type GetUserPermissionsAndProductsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, name: string, email: string, products: Array<{ __typename?: 'user_products', product: string }>, organizations: Array<{ __typename?: 'user_organizations', role?: { __typename?: 'roles', name: string, role_permissions: Array<{ __typename?: 'role_permissions', permission: { __typename?: 'permissions', resource: string, feature?: string | null, action: string } }> } | null }> }> };

export type PostIocUpdatedMutationVariables = Exact<{
  ioc_id: Scalars['String'];
  new_value: Scalars['String'];
  old_value: Scalars['String'];
  type: Scalars['String'];
}>;


export type PostIocUpdatedMutation = { __typename?: 'mutation_root', post_ioc_updated?: { __typename?: 'PostIocUpdatedOutput', success: boolean } | null };

export type UpdateUserRoleAndProductsMutationVariables = Exact<{
  user_id: Scalars['uuid'];
  organization_id: Scalars['uuid'];
  role?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type UpdateUserRoleAndProductsMutation = { __typename?: 'mutation_root', update_user_access?: { __typename?: 'ManageUserAccessOutput', user_id?: any | null, message?: string | null } | null };

export type GetDesignatedTakedownAssetsWhereQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  designated_assets_where: Designated_Takedown_Assets_Bool_Exp;
  orderBy?: InputMaybe<Array<Designated_Takedown_Assets_Order_By> | Designated_Takedown_Assets_Order_By>;
  org_id: Scalars['uuid'];
}>;


export type GetDesignatedTakedownAssetsWhereQuery = { __typename?: 'query_root', designated_takedown_assets: Array<{ __typename?: 'designated_takedown_assets', status: string, updated_at: any, created_at: any, is_organization_default: boolean, spoofing_entity?: { __typename?: 'spoofing_entities', id: any, entity_name: string } | null, customer_asset: { __typename?: 'customer_assets', id: any, value: string, status: string, platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string } | null } }> };

export type GetDesignatedTakedownAssetsCountQueryVariables = Exact<{
  designated_assets_where: Designated_Takedown_Assets_Bool_Exp;
  org_id: Scalars['uuid'];
}>;


export type GetDesignatedTakedownAssetsCountQuery = { __typename?: 'query_root', designated_takedown_assets_aggregate: { __typename?: 'designated_takedown_assets_aggregate', aggregate?: { __typename?: 'designated_takedown_assets_aggregate_fields', count: number } | null } };

export type GetDesignatedTakedownAssetsPlatformSubtypesQueryVariables = Exact<{
  org_id: Scalars['uuid'];
}>;


export type GetDesignatedTakedownAssetsPlatformSubtypesQuery = { __typename?: 'query_root', designated_takedown_assets: Array<{ __typename?: 'designated_takedown_assets', customer_asset: { __typename?: 'customer_assets', platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string, platform: string } | null } }> };

export type GetDesignatedTakedownAssetsBrandsQueryVariables = Exact<{
  org_id: Scalars['uuid'];
}>;


export type GetDesignatedTakedownAssetsBrandsQuery = { __typename?: 'query_root', designated_takedown_assets: Array<{ __typename?: 'designated_takedown_assets', spoofing_entity?: { __typename?: 'spoofing_entities', id: any, entity_name: string } | null }> };

export type GetCustomerAssetsByBrandWhereQueryVariables = Exact<{
  where: Customer_Assets_To_Brands_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Assets_To_Brands_Order_By> | Customer_Assets_To_Brands_Order_By>;
}>;


export type GetCustomerAssetsByBrandWhereQuery = { __typename?: 'query_root', customer_assets_to_brands: Array<{ __typename?: 'customer_assets_to_brands', brand_id: any, customer_asset?: { __typename?: 'customer_assets', id: any, value: string, status: string } | null }> };

export type GetCustomerAssetsByBrandCountQueryVariables = Exact<{
  where: Customer_Assets_To_Brands_Bool_Exp;
}>;


export type GetCustomerAssetsByBrandCountQuery = { __typename?: 'query_root', customer_assets_to_brands_aggregate: { __typename?: 'customer_assets_to_brands_aggregate', aggregate?: { __typename?: 'customer_assets_to_brands_aggregate_fields', count: number } | null } };

export type InsertDesignatedTakedownAssetMutationVariables = Exact<{
  customer_asset_id: Scalars['uuid'];
  is_organization_default: Scalars['Boolean'];
  status: Scalars['String'];
  brand_id?: InputMaybe<Scalars['uuid']>;
}>;


export type InsertDesignatedTakedownAssetMutation = { __typename?: 'mutation_root', insert_designated_takedown_assets_one?: { __typename?: 'designated_takedown_assets', id: any } | null };

export type InsertOrgDefaultTakedownAssetMutationVariables = Exact<{
  customer_asset_id: Scalars['uuid'];
  status: Scalars['String'];
}>;


export type InsertOrgDefaultTakedownAssetMutation = { __typename?: 'mutation_root', insert_designated_takedown_assets_one?: { __typename?: 'designated_takedown_assets', id: any } | null };

export type UpdateOrgDefaultDesignatedTakedownAssetStatusMutationVariables = Exact<{
  customer_asset_id: Scalars['uuid'];
  new_status: Scalars['String'];
}>;


export type UpdateOrgDefaultDesignatedTakedownAssetStatusMutation = { __typename?: 'mutation_root', update_designated_takedown_assets?: { __typename?: 'designated_takedown_assets_mutation_response', returning: Array<{ __typename?: 'designated_takedown_assets', id: any }> } | null };

export type UpdateDesignatedTakedownAssetStatusMutationVariables = Exact<{
  customer_asset_id: Scalars['uuid'];
  brand_id?: InputMaybe<Scalars['uuid']>;
  new_status: Scalars['String'];
}>;


export type UpdateDesignatedTakedownAssetStatusMutation = { __typename?: 'mutation_root', update_designated_takedown_assets?: { __typename?: 'designated_takedown_assets_mutation_response', returning: Array<{ __typename?: 'designated_takedown_assets', id: any }> } | null };

export type GetCustomerAssetToBrandEntryQueryVariables = Exact<{
  brand_id: Scalars['uuid'];
  customer_asset_id: Scalars['uuid'];
}>;


export type GetCustomerAssetToBrandEntryQuery = { __typename?: 'query_root', customer_assets_to_brands_by_pk?: { __typename?: 'customer_assets_to_brands', brand_id: any, customer_asset_id: any } | null };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String'];
  organizations: Array<Scalars['String']> | Scalars['String'];
  role: Scalars['String'];
  products: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  is_internal: Scalars['Boolean'];
}>;


export type CreateUserMutation = { __typename?: 'mutation_root', create_user_v2?: { __typename?: 'CreateUserOutput', message?: string | null, user_id?: any | null } | null };

export type DeleteUserMutationVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type DeleteUserMutation = { __typename?: 'mutation_root', delete_user?: { __typename?: 'DeleteUserOutput', message?: string | null } | null };

export type ActivateUserMutationVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type ActivateUserMutation = { __typename?: 'mutation_root', update_user_v2?: { __typename?: 'UpdateUserOutput', message?: string | null } | null };

export type GetAiPromptsIdsWhereQueryVariables = Exact<{
  ai_prompts_where: Ai_Prompts_Bool_Exp;
}>;


export type GetAiPromptsIdsWhereQuery = { __typename?: 'query_root', ai_prompts: Array<{ __typename?: 'ai_prompts', id: any }> };

export type GetCustomerAssetsSubtypesByOrgQueryVariables = Exact<{
  org_id: Scalars['uuid'];
}>;


export type GetCustomerAssetsSubtypesByOrgQuery = { __typename?: 'query_root', customer_assets: Array<{ __typename?: 'customer_assets', platform_subtype?: { __typename?: 'platform_subtypes', id: any, name: string } | null }> };

export type GetTakedownRequestsCountForTrialOrgQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
}>;


export type GetTakedownRequestsCountForTrialOrgQuery = { __typename?: 'query_root', collection_report_changes_aggregate: { __typename?: 'collection_report_changes_aggregate', aggregate?: { __typename?: 'collection_report_changes_aggregate_fields', count: number } | null } };

export type GetAssignedAlertCountsQueryVariables = Exact<{
  assigneeIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type GetAssignedAlertCountsQuery = { __typename?: 'query_root', assignee_counts: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null, nodes: Array<{ __typename?: 'spoofing_reports', internal_alert_assignee?: { __typename?: 'users', id: any, email: string } | null }> } };

export type GetAssignedAlertsQueryVariables = Exact<{
  assigneeId: Scalars['uuid'];
}>;


export type GetAssignedAlertsQuery = { __typename?: 'query_root', assigned_alerts: Array<{ __typename?: 'spoofing_reports', id: any }> };

export type EmailSettingsFragment = { __typename?: 'email_settings', id: any, pir_email_address?: string | null, abaas_email_address?: string | null, soc_email_address?: string | null, organization_id: any, er_acknowledgement_enabled?: boolean | null, email_domains: any, is_eur_enabled: boolean, malicious_template?: string | null, dne_template?: string | null, ntd_template?: string | null, should_send_eur_to_soc: boolean, spoofing_entity: { __typename?: 'spoofing_entities', id: any, entity_name: string } };

export type GetEmailSettingsByOrgIdQueryVariables = Exact<{
  org_id: Scalars['uuid'];
}>;


export type GetEmailSettingsByOrgIdQuery = { __typename?: 'query_root', email_settings: Array<{ __typename?: 'email_settings', id: any, pir_email_address?: string | null, abaas_email_address?: string | null, soc_email_address?: string | null, organization_id: any, er_acknowledgement_enabled?: boolean | null, email_domains: any, is_eur_enabled: boolean, malicious_template?: string | null, dne_template?: string | null, ntd_template?: string | null, should_send_eur_to_soc: boolean, spoofing_entity: { __typename?: 'spoofing_entities', id: any, entity_name: string } }> };

export type GetOrganizationIdsForUserWithRolesQueryVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type GetOrganizationIdsForUserWithRolesQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', organizations: Array<{ __typename?: 'user_organizations', role_id?: any | null, organization: { __typename?: 'organizations', id: any, name: string, is_parent?: boolean | null } }> } | null };

export type CreatePiiMemberMutationVariables = Exact<{
  input: PiiCreateMemberInput;
}>;


export type CreatePiiMemberMutation = { __typename?: 'mutation_root', create_pii_member?: { __typename?: 'PiiCreateMemberOutput', success: boolean, message: string, uuid: string } | null };

export type EditPiiMemberMutationVariables = Exact<{
  input: PiiEditMemberInput;
}>;


export type EditPiiMemberMutation = { __typename?: 'mutation_root', edit_pii_member?: { __typename?: 'PiiEditMemberOutput', success: boolean, message: string, uuid: string } | null };

export type GetPiiMemberQueryVariables = Exact<{
  input: PiiGetMemberInput;
}>;


export type GetPiiMemberQuery = { __typename?: 'query_root', get_pii_member?: { __typename?: 'PiiGetMemberOutput', linkedinUrl?: string | null, birthDay?: string | null, birthMonth?: string | null, birthYear?: string | null, emails: Array<{ __typename?: 'EmailOutput', email: string, uuid?: string | null }>, phoneNumbers: Array<{ __typename?: 'PhoneNumberOutput', number: string, uuid?: string | null }>, companies: Array<{ __typename?: 'CompanyOutput', name: string, isCurrent: boolean, uuid?: string | null }>, relatives: Array<{ __typename?: 'NameSetOutput', firstName: string, middleName?: string | null, lastName: string, uuid?: string | null }>, names: Array<{ __typename?: 'NameSetOutput', firstName: string, middleName?: string | null, lastName: string, uuid?: string | null }>, locations: Array<{ __typename?: 'LocationOutput', city: string, country: string, state: string, addressLine1?: string | null, addressLine2?: string | null, zipCode?: string | null, uuid?: string | null }> } | null };

export type GetPiiDropdownUsersQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
}>;


export type GetPiiDropdownUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email: string, name: string, is_internal: boolean, optery_member_uuid?: any | null }> };

export type GetUserOnboardingStatusQueryVariables = Exact<{
  userId: Scalars['uuid'];
}>;


export type GetUserOnboardingStatusQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, onboarding_status?: string | null } | null };

export type DeletePiiMemberMutationVariables = Exact<{
  input: PiiDeleteMemberInput;
}>;


export type DeletePiiMemberMutation = { __typename?: 'mutation_root', delete_pii_member?: { __typename?: 'PiiDeleteMemberOutput', success: boolean, message: string } | null };

export type GetThreatGraphDataQueryVariables = Exact<{
  alert_uuid: Scalars['uuid'];
}>;


export type GetThreatGraphDataQuery = { __typename?: 'query_root', get_threat_graph_data?: { __typename?: 'GetThreatGraphDataOutput', root_node_ids?: Array<string> | null, nodes: any, links: any } | null };

export type GetGlobalThreatGraphDataQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
  skipped_link_types?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetGlobalThreatGraphDataQuery = { __typename?: 'query_root', get_threat_graph_data?: { __typename?: 'GetThreatGraphDataOutput', nodes: any, links: any } | null };

export type ValidateEntityLinkQueryVariables = Exact<{
  parent_node: Scalars['jsonb'];
  child_node?: InputMaybe<Scalars['jsonb']>;
  link_type?: InputMaybe<Scalars['String']>;
}>;


export type ValidateEntityLinkQuery = { __typename?: 'query_root', validate_entity_link?: { __typename?: 'CreateEntityLinksOutput', is_valid: boolean, graph?: any | null, error?: string | null } | null };

export type CreateEntityLinkMutationVariables = Exact<{
  parent_node: Scalars['jsonb'];
  child_node: Scalars['jsonb'];
  link_type: Scalars['String'];
}>;


export type CreateEntityLinkMutation = { __typename?: 'mutation_root', create_entity_link?: { __typename?: 'CreateEntityLinksOutput', is_valid: boolean, graph?: any | null, error?: string | null } | null };

export type DeleteEntityLinkMutationVariables = Exact<{
  link_id: Scalars['uuid'];
}>;


export type DeleteEntityLinkMutation = { __typename?: 'mutation_root', archive_entity_link?: { __typename?: 'ArchiveEntityLinksOutput', message?: string | null } | null };

export type GetChildOrganizationsQueryVariables = Exact<{
  parent_org_id: Scalars['uuid'];
}>;


export type GetChildOrganizationsQuery = { __typename?: 'query_root', organizations: Array<{ __typename?: 'organizations', id: any, name: string, created_at: any, organization_users: Array<{ __typename?: 'user_organizations', user: { __typename?: 'users', id: any, email: string } }> }> };

export type UpdateOrganizationMutationVariables = Exact<{
  organization_id: Scalars['String'];
  users_to_add: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  users_to_remove: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type UpdateOrganizationMutation = { __typename?: 'mutation_root', update_organization?: { __typename?: 'UpdateOrganizationOutput', success?: boolean | null, message?: string | null } | null };

export type HandleDetectionSearchQueryVariables = Exact<{
  query: Scalars['String'];
  index_name: Scalars['String'];
  search_after?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type HandleDetectionSearchQuery = { __typename?: 'query_root', handle_detection_search: { __typename?: 'HandleDetectionSearchOutput', status?: string | null, message?: string | null, data?: any | null } };

export type GetSimUsersQueryVariables = Exact<{
  org_id: Scalars['uuid'];
}>;


export type GetSimUsersQuery = { __typename?: 'query_root', sim_users: Array<{ __typename?: 'sim_users', id: any, first_name: string, last_name: string, email_address: string }> };

export type Sim_CampaignFragment = { __typename?: 'sim_campaigns', id: any, name: string, launch_date: any, end_date: any, status: string, created_at: any, org_id: any };

export type GetSimCampaignQueryVariables = Exact<{
  campaign_id: Scalars['uuid'];
}>;


export type GetSimCampaignQuery = { __typename?: 'query_root', sim_campaigns: Array<{ __typename?: 'sim_campaigns', id: any, name: string, launch_date: any, end_date: any, status: string, created_at: any, org_id: any }> };

export type GetSimCampaignsQueryVariables = Exact<{
  org_id: Scalars['uuid'];
}>;


export type GetSimCampaignsQuery = { __typename?: 'query_root', sim_campaigns: Array<{ __typename?: 'sim_campaigns', id: any, name: string, launch_date: any, end_date: any, status: string, created_at: any, org_id: any }> };

export type Sim_EmailFragment = { __typename?: 'sim_emails', id: any, html: string, status: string, created_at: any, campaign_id: any, org_id: any, sim_user_id: any, subject?: string | null, sim_user: { __typename?: 'sim_users', first_name: string, last_name: string, email_address: string } };

export type GetSimEmailsQueryVariables = Exact<{
  orgId: Scalars['uuid'];
}>;


export type GetSimEmailsQuery = { __typename?: 'query_root', sim_emails: Array<{ __typename?: 'sim_emails', id: any, html: string, status: string, created_at: any, campaign_id: any, org_id: any, sim_user_id: any, subject?: string | null, sim_user: { __typename?: 'sim_users', first_name: string, last_name: string, email_address: string } }> };

export type GetSimEmailsByCampaignIdQueryVariables = Exact<{
  campaign_id: Scalars['uuid'];
}>;


export type GetSimEmailsByCampaignIdQuery = { __typename?: 'query_root', sim_emails: Array<{ __typename?: 'sim_emails', id: any, html: string, status: string, created_at: any, campaign_id: any, org_id: any, sim_user_id: any, subject?: string | null, sim_user: { __typename?: 'sim_users', first_name: string, last_name: string, email_address: string } }> };

export type CreateSimCampaignMutationVariables = Exact<{
  name: Scalars['String'];
  org_id: Scalars['String'];
  sender_address: Scalars['String'];
  launch_date: Scalars['String'];
  end_date: Scalars['String'];
  sim_user_ids: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type CreateSimCampaignMutation = { __typename?: 'mutation_root', create_sim_campaign?: { __typename?: 'CreateSimCampaignOutput', campaign_id: string } | null };

export type GetHasEmployeeBrandQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
}>;


export type GetHasEmployeeBrandQuery = { __typename?: 'query_root', spoofing_entities: Array<{ __typename?: 'spoofing_entities', id: any }> };

export type GetExecutiveProtectionAlertsCountsQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
  queue_state: Scalars['String'];
}>;


export type GetExecutiveProtectionAlertsCountsQuery = { __typename?: 'query_root', threat_alerts: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null }, darkweb_mentions: { __typename?: 'spoofing_reports_aggregate', aggregate?: { __typename?: 'spoofing_reports_aggregate_fields', count: number } | null } };

export type GetLatestPredictedEnforcementTypeQueryVariables = Exact<{
  match_id: Scalars['uuid'];
  alert_id: Scalars['uuid'];
}>;


export type GetLatestPredictedEnforcementTypeQuery = { __typename?: 'query_root', predicted_enforcement_types: Array<{ __typename?: 'predicted_enforcement_types', id: any, created_at: any, predicted_enforcement_type: string, llm_decision_reason: string, llm_invocation: any, alert_id: any, match_id: any }> };

export type GetSimCampaignObservationsByCampaignIdQueryVariables = Exact<{
  campaign_id: Scalars['uuid'];
}>;


export type GetSimCampaignObservationsByCampaignIdQuery = { __typename?: 'query_root', sim_campaign_observations: Array<{ __typename?: 'sim_campaign_observations', id: any, campaign_id: any, sim_user_id: any, action: string, created_at: any }> };

export type GetActiveAndTrialOrganizationProductsQueryVariables = Exact<{
  organization_id: Scalars['uuid'];
}>;


export type GetActiveAndTrialOrganizationProductsQuery = { __typename?: 'query_root', organization_products: Array<{ __typename?: 'organization_products', product: string, enablement_status: string }> };

export const Email_CorrespondenceFragmentDoc = gql`
    fragment EMAIL_CORRESPONDENCE on email_correspondence {
  created_at
  user {
    name
  }
  body
  sender
  receiver
  correspondence_type
  message_id
  thread_id
}
    `;
export const Domain_DataFragmentDoc = gql`
    fragment DOMAIN_DATA on domain_data {
  id
  created_date
  updated_date
  registrar_name
  contact_email
  ip_address
  country_code
  hosting_provider
  raw_data
  raw_data_json
  mx_records
}
    `;
export const Social_Media_DataFragmentDoc = gql`
    fragment SOCIAL_MEDIA_DATA on social_media_data {
  id
  num_followers
  account_creation_time
  platform_name
  profile_image_url
  profile_image_hash
  profile_description
  profile_display_name
  profile_display_url
  slug
  external_id
  screenshot_url
}
    `;
export const Social_Media_PostFragmentDoc = gql`
    fragment SOCIAL_MEDIA_POST on social_media_post {
  id
  full_text
  external_created_at
  social_media_data_id
  num_upvotes
  num_reposts
  platform
  external_id
  created_at
  url
  extra_urls
  screenshot_url
}
    `;
export const Full_UrlFragmentDoc = gql`
    fragment FULL_URL on full_urls {
  id
  url
  unsanitized_url
  screenshot_url
  site_html_url
  favicon_url
  domain_data {
    ...DOMAIN_DATA
  }
}
    ${Domain_DataFragmentDoc}`;
export const Mobile_AppFragmentDoc = gql`
    fragment MOBILE_APP on mobile_apps {
  id
  title
  description
  app_id
  screenshot_url
  thumbnail_url
  developer_id
  developer_name
  bundle_id
  external_created_at
  link
  platform_name
}
    `;
export const Dark_WebFragmentDoc = gql`
    fragment DARK_WEB on dark_web {
  id
  crawled_at
  created_at
  body
  title
  risk_score
  uri
  url
  location
  domain
  ip
  email
  password
  leak_name
  network
  source
  password_type
  additional_data
  languages
  translated_title
  translated_body
  credential_url
  credit_card_id
  credit_card @include(if: $includeCreditCardData) {
    id
    bin
    expiration_date
    credit_card_number
    cardholder_name
    cardholder_address
  }
}
    `;
export const EmailFragmentDoc = gql`
    fragment EMAIL on emails {
  id
  subject
  body
  sender
  receiver
  screenshot_url
  dkim
  spf
  dmarc
  external_id
  headers
  cc
  bcc
  eml_url
  sentiment_analysis
  forward_data
  header_analysis
}
    `;
export const Advertisement_DataFragmentDoc = gql`
    fragment ADVERTISEMENT_DATA on advertisement_data {
  id
  ad_detail_link
  advertiser_data {
    id
    name
    platform_subtype_id
    advertiser_profile_link
    advertiser_ads_link
    created_at
    num_ads
    is_verified
    location
    updated_at
  }
  platform_subtype_id
  full_url {
    id
    url
  }
  created_at
  updated_at
  source
  text_content
  image_content_urls
  video_content_urls
  screenshot_url
  ad_detail_html_url
  date_first_shown
  date_last_shown
}
    `;
export const Phone_NumberFragmentDoc = gql`
    fragment PHONE_NUMBER on phone_numbers {
  id
  number
  country_code
  telco_provider
  created_at
  updated_at
}
    `;
export const Social_Media_GroupFragmentDoc = gql`
    fragment SOCIAL_MEDIA_GROUP on social_media_group {
  id
  external_created_at
  external_id
  created_at
  url
  raw_enriched_data
  platform_subtype_id
  name
  image_url
  is_private
  num_members
  description
  screenshot_url
}
    `;
export const Ecommerce_ListingFragmentDoc = gql`
    fragment ECOMMERCE_LISTING on ecommerce_listings {
  id
  title
  description
  price
  seller_name
  external_id
  external_created_at
  created_at
  url
  rating
  platform_name
  source_url
  telegram_info
  discord_info
  num_units
  num_units_sold
  shop_name
}
    `;
export const Spoof_MatchFragmentDoc = gql`
    fragment SPOOF_MATCH on spoof_matches {
  id
  created_at
  snapshot_source
  full_url {
    ...FULL_URL
  }
  social_media_data {
    ...SOCIAL_MEDIA_DATA
  }
  mobile_app {
    ...MOBILE_APP
  }
  dark_web {
    ...DARK_WEB
  }
  email {
    ...EMAIL
  }
  advertisement_data {
    ...ADVERTISEMENT_DATA
  }
  phone_number {
    ...PHONE_NUMBER
  }
  classification
  social_media_post {
    ...SOCIAL_MEDIA_POST
  }
  social_media_group {
    ...SOCIAL_MEDIA_GROUP
  }
  ecommerce_listing {
    ...ECOMMERCE_LISTING
  }
  suspicion_score
  ml_features {
    id
    name
    threshold
    value
    detection_asset {
      type
      value
    }
  }
  match_attributions {
    id
    attribution_type
    sourcing_queries {
      sourcer_label
      query
      force_create_report
    }
    rules {
      id
      description
      type
      rule_expression
    }
  }
}
    ${Full_UrlFragmentDoc}
${Social_Media_DataFragmentDoc}
${Mobile_AppFragmentDoc}
${Dark_WebFragmentDoc}
${EmailFragmentDoc}
${Advertisement_DataFragmentDoc}
${Phone_NumberFragmentDoc}
${Social_Media_PostFragmentDoc}
${Social_Media_GroupFragmentDoc}
${Ecommerce_ListingFragmentDoc}`;
export const Platform_SubtypeFragmentDoc = gql`
    fragment PLATFORM_SUBTYPE on platform_subtypes {
  id
  name
  platform
  archetype
  product
}
    `;
export const Spoofing_Report_Without_EnforcementsFragmentDoc = gql`
    fragment SPOOFING_REPORT_WITHOUT_ENFORCEMENTS on spoofing_reports {
  id
  organization {
    id
    name
    abbr_name
    organization_products {
      product
      enablement_status
    }
  }
  original_entity_id
  report_status
  type
  screenshot_url
  spoof_status
  report_screenshots
  flagged_url
  unsanitized_url
  created_at
  last_activity_timestamp
  notes
  source
  website_content
  last_reported_at
  last_resolved_at
  estimated_usd_price
  score
  external_source
  is_customer_sourced
  external_id
  spoofing_entity {
    id
    domain_data
    entity_name
    entity_type
    entity_url
    screenshot_url
  }
  domain_data {
    ...DOMAIN_DATA
  }
  first_domain_data: spoof_matches(limit: 1) {
    full_url {
      domain_data {
        ...DOMAIN_DATA
      }
    }
  }
  social_media_data {
    ...SOCIAL_MEDIA_DATA
  }
  social_media_post {
    ...SOCIAL_MEDIA_POST
  }
  approvals {
    id
    created_at
    updated_at
    requester {
      name
    }
    approver {
      name
    }
    status
    reason
  }
  report_tags {
    tag {
      id
      name
      is_internal
      description
    }
  }
  spoof_matches(order_by: {created_at: desc}) {
    ...SPOOF_MATCH
  }
  uploader {
    id
    name
    is_internal
  }
  platform {
    name
    product
  }
  platform_subtype {
    ...PLATFORM_SUBTYPE
  }
  spoofing_reports_to_tags {
    tag_name
  }
  collection_report_changes {
    id
    new_value
    timestamp
    type
    user {
      name
      is_internal
    }
  }
  collection_report_changes_aggregate {
    aggregate {
      max {
        timestamp
      }
    }
  }
  severity
  last_actioned_at
  internal_alert_assignee {
    id
    email
  }
  external_alert_assignee {
    id
    email
  }
}
    ${Domain_DataFragmentDoc}
${Social_Media_DataFragmentDoc}
${Social_Media_PostFragmentDoc}
${Spoof_MatchFragmentDoc}
${Platform_SubtypeFragmentDoc}`;
export const Spoofing_ReportFragmentDoc = gql`
    fragment SPOOFING_REPORT on spoofing_reports {
  ...SPOOFING_REPORT_WITHOUT_ENFORCEMENTS
  enforcement_requests {
    id
    status
    platform
    submission_external_id
    type
    updated_at
    collection_report_changes(order_by: {timestamp: desc}, limit: 1) {
      timestamp
    }
  }
}
    ${Spoofing_Report_Without_EnforcementsFragmentDoc}`;
export const OrganizationFragmentDoc = gql`
    fragment ORGANIZATION on organizations {
  id
  created_at
  name
  organization_type
  organization_email
  users {
    id
    name
    email
    created_at
    is_internal
  }
  organization_products {
    product
    enablement_status
  }
  is_report_form_enabled
  is_original_ip_holder
  is_web2_enabled
  organization_status
  is_app_detection_enabled
  is_paid_ads_detection_enabled
  is_email_detection_enabled
  is_crypto_detection_enabled
  is_ecommerce_detection_enabled
  is_dark_web_detection_enabled
  approved_domains
  approved_emails
  analytics_summary_recipient_emails
  salesforce_account_id
  auth_configs
  is_social_media_detection_enabled
  is_dark_market_detection_enabled
  is_nft_detection_enabled
  is_telco_detection_enabled
  is_pii_detection_enabled
  is_domain_purchasing_enabled
  is_suspicious_emails_enabled
  is_email_abuse_box_enabled
  is_phishing_sim_enabled
  is_code_repos_detection_enabled
  enforcement_metadata {
    authorization_letter_url
    enforcement_email
    legal_name
    country_code
    authorization_letter_url_expiration_date
    allowed_domain_enforcement_types
  }
  customer_type
  slack_access_token
  rubric_link
  abbr_name
  is_parent
  children {
    name
    organization_users {
      user {
        email
      }
    }
  }
}
    `;
export const Organization_InternalFragmentDoc = gql`
    fragment ORGANIZATION_INTERNAL on organizations {
  id
  created_at
  name
  organization_type
  users {
    id
    name
    email
    created_at
    is_internal
  }
  organization_products {
    product
    enablement_status
  }
  is_report_form_enabled
  is_original_ip_holder
  is_web2_enabled
  organization_status
  is_app_detection_enabled
  is_paid_ads_detection_enabled
  is_email_detection_enabled
  is_crypto_detection_enabled
  is_ecommerce_detection_enabled
  is_dark_web_detection_enabled
  is_telco_detection_enabled
  is_phishing_sim_enabled
  is_code_repos_detection_enabled
  is_pii_detection_enabled
  is_domain_purchasing_enabled
  approved_domains
  approved_emails
  analytics_summary_recipient_emails
  salesforce_account_id
  auth_configs
  is_social_media_detection_enabled
  is_dark_market_detection_enabled
  is_nft_detection_enabled
  is_suspicious_emails_enabled
  is_email_abuse_box_enabled
  enforcement_metadata {
    authorization_letter_url
    enforcement_email
    legal_name
    country_code
    authorization_letter_url_expiration_date
    allowed_domain_enforcement_types
  }
  customer_type
  slack_access_token
  rubric_link
  abbr_name
  point_of_contact {
    id
    name
    email
  }
  customer_point_of_contact_email
  is_parent
  children {
    name
  }
  parent {
    name
    id
  }
}
    `;
export const Hourly_Spoofing_Report_StatsFragmentDoc = gql`
    fragment HOURLY_SPOOFING_REPORT_STATS on hourly_spoofing_reports_stats {
  id
  date
  report_type
  total_count
  total_reported_count
  total_resolved_count
  median_latency_detected_to_reported
  median_latency_reported_to_first_mitigated
  median_latency_reported_to_delisted
  created_at
  organization_id
  original_entity_id
  spoofing_entity {
    id
    entity_name
  }
}
    `;
export const Enforcement_RequestsFragmentDoc = gql`
    fragment ENFORCEMENT_REQUESTS on enforcement_requests {
  id
  updated_at
  type
  platform
  status
  submission_proof_url
  submitted_at
  reason
  user {
    id
    name
    is_internal
  }
  submission_external_id
  created_at
  updated_at
  submission_email
  submission_source
  retraction_description
  retraction_proof_url
}
    `;
export const AiPromptFieldsFragmentDoc = gql`
    fragment AiPromptFields on ai_prompts {
  id
  prompt
  metadata
  platform
}
    `;
export const Linked_AlertFragmentDoc = gql`
    fragment LINKED_ALERT on spoofing_reports {
  id
  external_id
  spoof_matches {
    full_url {
      id
      url
      unsanitized_url
      site_html_url
    }
  }
  organization {
    id
    name
    abbr_name
  }
  platform {
    name
    product
  }
  platform_subtype {
    name
    platform
    product
  }
  flagged_url
}
    `;
export const EmailSettingsFragmentDoc = gql`
    fragment EmailSettings on email_settings {
  id
  pir_email_address
  abaas_email_address
  soc_email_address
  spoofing_entity {
    id
    entity_name
  }
  organization_id
  er_acknowledgement_enabled
  email_domains
  is_eur_enabled
  malicious_template
  dne_template
  ntd_template
  should_send_eur_to_soc
}
    `;
export const Sim_CampaignFragmentDoc = gql`
    fragment SIM_CAMPAIGN on sim_campaigns {
  id
  name
  launch_date
  end_date
  status
  created_at
  org_id
}
    `;
export const Sim_EmailFragmentDoc = gql`
    fragment SIM_EMAIL on sim_emails {
  id
  html
  status
  created_at
  campaign_id
  org_id
  sim_user_id
  subject
  sim_user {
    first_name
    last_name
    email_address
  }
}
    `;
export const HandleAdminUrlSearchRequestDocument = gql`
    mutation HandleAdminUrlSearchRequest($handle_admin_url_search_request_input: HandleAdminUrlSearchRequestInput!) {
  handle_admin_url_search_request(
    handle_admin_url_search_request_input: $handle_admin_url_search_request_input
  ) {
    response
  }
}
    `;
export type HandleAdminUrlSearchRequestMutationFn = Apollo.MutationFunction<HandleAdminUrlSearchRequestMutation, HandleAdminUrlSearchRequestMutationVariables>;

/**
 * __useHandleAdminUrlSearchRequestMutation__
 *
 * To run a mutation, you first call `useHandleAdminUrlSearchRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleAdminUrlSearchRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleAdminUrlSearchRequestMutation, { data, loading, error }] = useHandleAdminUrlSearchRequestMutation({
 *   variables: {
 *      handle_admin_url_search_request_input: // value for 'handle_admin_url_search_request_input'
 *   },
 * });
 */
export function useHandleAdminUrlSearchRequestMutation(baseOptions?: Apollo.MutationHookOptions<HandleAdminUrlSearchRequestMutation, HandleAdminUrlSearchRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleAdminUrlSearchRequestMutation, HandleAdminUrlSearchRequestMutationVariables>(HandleAdminUrlSearchRequestDocument, options);
      }
export type HandleAdminUrlSearchRequestMutationHookResult = ReturnType<typeof useHandleAdminUrlSearchRequestMutation>;
export type HandleAdminUrlSearchRequestMutationResult = Apollo.MutationResult<HandleAdminUrlSearchRequestMutation>;
export type HandleAdminUrlSearchRequestMutationOptions = Apollo.BaseMutationOptions<HandleAdminUrlSearchRequestMutation, HandleAdminUrlSearchRequestMutationVariables>;
export const HandleAutoActioningAlertSelectionDocument = gql`
    mutation HandleAutoActioningAlertSelection($handle_auto_actioning_alert_selection_input: HandleAutoActioningAlertSelectionInput!) {
  handle_auto_actioning_alert_selection(
    handle_auto_actioning_alert_selection_input: $handle_auto_actioning_alert_selection_input
  ) {
    results
  }
}
    `;
export type HandleAutoActioningAlertSelectionMutationFn = Apollo.MutationFunction<HandleAutoActioningAlertSelectionMutation, HandleAutoActioningAlertSelectionMutationVariables>;

/**
 * __useHandleAutoActioningAlertSelectionMutation__
 *
 * To run a mutation, you first call `useHandleAutoActioningAlertSelectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleAutoActioningAlertSelectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleAutoActioningAlertSelectionMutation, { data, loading, error }] = useHandleAutoActioningAlertSelectionMutation({
 *   variables: {
 *      handle_auto_actioning_alert_selection_input: // value for 'handle_auto_actioning_alert_selection_input'
 *   },
 * });
 */
export function useHandleAutoActioningAlertSelectionMutation(baseOptions?: Apollo.MutationHookOptions<HandleAutoActioningAlertSelectionMutation, HandleAutoActioningAlertSelectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleAutoActioningAlertSelectionMutation, HandleAutoActioningAlertSelectionMutationVariables>(HandleAutoActioningAlertSelectionDocument, options);
      }
export type HandleAutoActioningAlertSelectionMutationHookResult = ReturnType<typeof useHandleAutoActioningAlertSelectionMutation>;
export type HandleAutoActioningAlertSelectionMutationResult = Apollo.MutationResult<HandleAutoActioningAlertSelectionMutation>;
export type HandleAutoActioningAlertSelectionMutationOptions = Apollo.BaseMutationOptions<HandleAutoActioningAlertSelectionMutation, HandleAutoActioningAlertSelectionMutationVariables>;
export const GetReportStateChangesDocument = gql`
    query GetReportStateChanges($id: uuid!) {
  collection_report_state_changes(
    where: {collection_report_id: {_eq: $id}}
    order_by: {timestamp_of_change: desc}
  ) {
    id
    new_state
    previous_state
    reason_for_change
    timestamp_of_change
    user {
      id
      name
      is_internal
    }
  }
}
    `;

/**
 * __useGetReportStateChangesQuery__
 *
 * To run a query within a React component, call `useGetReportStateChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportStateChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportStateChangesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportStateChangesQuery(baseOptions: Apollo.QueryHookOptions<GetReportStateChangesQuery, GetReportStateChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportStateChangesQuery, GetReportStateChangesQueryVariables>(GetReportStateChangesDocument, options);
      }
export function useGetReportStateChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportStateChangesQuery, GetReportStateChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportStateChangesQuery, GetReportStateChangesQueryVariables>(GetReportStateChangesDocument, options);
        }
export type GetReportStateChangesQueryHookResult = ReturnType<typeof useGetReportStateChangesQuery>;
export type GetReportStateChangesLazyQueryHookResult = ReturnType<typeof useGetReportStateChangesLazyQuery>;
export type GetReportStateChangesQueryResult = Apollo.QueryResult<GetReportStateChangesQuery, GetReportStateChangesQueryVariables>;
export const GetSpoofingReportsStatsFilterDocument = gql`
    query GetSpoofingReportsStatsFilter($dates: [date!], $organization_id: uuid!) @cached {
  hourly_spoofing_reports_stats(
    where: {_and: [{organization_id: {_eq: $organization_id}}, {date: {_in: $dates}}]}
    order_by: {date: asc}
  ) {
    ...HOURLY_SPOOFING_REPORT_STATS
  }
}
    ${Hourly_Spoofing_Report_StatsFragmentDoc}`;

/**
 * __useGetSpoofingReportsStatsFilterQuery__
 *
 * To run a query within a React component, call `useGetSpoofingReportsStatsFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpoofingReportsStatsFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpoofingReportsStatsFilterQuery({
 *   variables: {
 *      dates: // value for 'dates'
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetSpoofingReportsStatsFilterQuery(baseOptions: Apollo.QueryHookOptions<GetSpoofingReportsStatsFilterQuery, GetSpoofingReportsStatsFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpoofingReportsStatsFilterQuery, GetSpoofingReportsStatsFilterQueryVariables>(GetSpoofingReportsStatsFilterDocument, options);
      }
export function useGetSpoofingReportsStatsFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpoofingReportsStatsFilterQuery, GetSpoofingReportsStatsFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpoofingReportsStatsFilterQuery, GetSpoofingReportsStatsFilterQueryVariables>(GetSpoofingReportsStatsFilterDocument, options);
        }
export type GetSpoofingReportsStatsFilterQueryHookResult = ReturnType<typeof useGetSpoofingReportsStatsFilterQuery>;
export type GetSpoofingReportsStatsFilterLazyQueryHookResult = ReturnType<typeof useGetSpoofingReportsStatsFilterLazyQuery>;
export type GetSpoofingReportsStatsFilterQueryResult = Apollo.QueryResult<GetSpoofingReportsStatsFilterQuery, GetSpoofingReportsStatsFilterQueryVariables>;
export const GetAlertsByIdsDocument = gql`
    query getAlertsByIds($ids: [uuid!], $includeCreditCardData: Boolean! = true) {
  spoofing_reports(where: {id: {_in: $ids}}) {
    ...SPOOFING_REPORT
  }
}
    ${Spoofing_ReportFragmentDoc}`;

/**
 * __useGetAlertsByIdsQuery__
 *
 * To run a query within a React component, call `useGetAlertsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      includeCreditCardData: // value for 'includeCreditCardData'
 *   },
 * });
 */
export function useGetAlertsByIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetAlertsByIdsQuery, GetAlertsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertsByIdsQuery, GetAlertsByIdsQueryVariables>(GetAlertsByIdsDocument, options);
      }
export function useGetAlertsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertsByIdsQuery, GetAlertsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertsByIdsQuery, GetAlertsByIdsQueryVariables>(GetAlertsByIdsDocument, options);
        }
export type GetAlertsByIdsQueryHookResult = ReturnType<typeof useGetAlertsByIdsQuery>;
export type GetAlertsByIdsLazyQueryHookResult = ReturnType<typeof useGetAlertsByIdsLazyQuery>;
export type GetAlertsByIdsQueryResult = Apollo.QueryResult<GetAlertsByIdsQuery, GetAlertsByIdsQueryVariables>;
export const GetAlertsByIdsPaginatedDocument = gql`
    query GetAlertsByIdsPaginated($ids: [uuid!], $includeCreditCardData: Boolean! = true, $limit: Int, $offset: Int, $order_by: [spoofing_reports_order_by!]!) {
  spoofing_reports(
    where: {id: {_in: $ids}}
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    ...SPOOFING_REPORT
  }
  spoofing_reports_aggregate(where: {id: {_in: $ids}}) {
    aggregate {
      count
    }
  }
}
    ${Spoofing_ReportFragmentDoc}`;

/**
 * __useGetAlertsByIdsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetAlertsByIdsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertsByIdsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertsByIdsPaginatedQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      includeCreditCardData: // value for 'includeCreditCardData'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetAlertsByIdsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetAlertsByIdsPaginatedQuery, GetAlertsByIdsPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertsByIdsPaginatedQuery, GetAlertsByIdsPaginatedQueryVariables>(GetAlertsByIdsPaginatedDocument, options);
      }
export function useGetAlertsByIdsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertsByIdsPaginatedQuery, GetAlertsByIdsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertsByIdsPaginatedQuery, GetAlertsByIdsPaginatedQueryVariables>(GetAlertsByIdsPaginatedDocument, options);
        }
export type GetAlertsByIdsPaginatedQueryHookResult = ReturnType<typeof useGetAlertsByIdsPaginatedQuery>;
export type GetAlertsByIdsPaginatedLazyQueryHookResult = ReturnType<typeof useGetAlertsByIdsPaginatedLazyQuery>;
export type GetAlertsByIdsPaginatedQueryResult = Apollo.QueryResult<GetAlertsByIdsPaginatedQuery, GetAlertsByIdsPaginatedQueryVariables>;
export const GetSpoofingReportsStatsDocument = gql`
    query GetSpoofingReportsStats($date_from: date!, $date_to: date, $organization_id: uuid!) @cached {
  hourly_spoofing_reports_stats(
    where: {_and: [{organization_id: {_eq: $organization_id}}, {date: {_gte: $date_from}}, {date: {_lte: $date_to}}]}
    order_by: {date: asc}
  ) {
    ...HOURLY_SPOOFING_REPORT_STATS
  }
}
    ${Hourly_Spoofing_Report_StatsFragmentDoc}`;

/**
 * __useGetSpoofingReportsStatsQuery__
 *
 * To run a query within a React component, call `useGetSpoofingReportsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpoofingReportsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpoofingReportsStatsQuery({
 *   variables: {
 *      date_from: // value for 'date_from'
 *      date_to: // value for 'date_to'
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetSpoofingReportsStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSpoofingReportsStatsQuery, GetSpoofingReportsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpoofingReportsStatsQuery, GetSpoofingReportsStatsQueryVariables>(GetSpoofingReportsStatsDocument, options);
      }
export function useGetSpoofingReportsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpoofingReportsStatsQuery, GetSpoofingReportsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpoofingReportsStatsQuery, GetSpoofingReportsStatsQueryVariables>(GetSpoofingReportsStatsDocument, options);
        }
export type GetSpoofingReportsStatsQueryHookResult = ReturnType<typeof useGetSpoofingReportsStatsQuery>;
export type GetSpoofingReportsStatsLazyQueryHookResult = ReturnType<typeof useGetSpoofingReportsStatsLazyQuery>;
export type GetSpoofingReportsStatsQueryResult = Apollo.QueryResult<GetSpoofingReportsStatsQuery, GetSpoofingReportsStatsQueryVariables>;
export const LoadFreeTrialEndedDocument = gql`
    query LoadFreeTrialEnded($organization_id: uuid!, $user_id: uuid!) {
  organizations_by_pk(id: $organization_id) {
    name
  }
  users_by_pk(id: $user_id) {
    name
  }
}
    `;

/**
 * __useLoadFreeTrialEndedQuery__
 *
 * To run a query within a React component, call `useLoadFreeTrialEndedQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadFreeTrialEndedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadFreeTrialEndedQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useLoadFreeTrialEndedQuery(baseOptions: Apollo.QueryHookOptions<LoadFreeTrialEndedQuery, LoadFreeTrialEndedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadFreeTrialEndedQuery, LoadFreeTrialEndedQueryVariables>(LoadFreeTrialEndedDocument, options);
      }
export function useLoadFreeTrialEndedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadFreeTrialEndedQuery, LoadFreeTrialEndedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadFreeTrialEndedQuery, LoadFreeTrialEndedQueryVariables>(LoadFreeTrialEndedDocument, options);
        }
export type LoadFreeTrialEndedQueryHookResult = ReturnType<typeof useLoadFreeTrialEndedQuery>;
export type LoadFreeTrialEndedLazyQueryHookResult = ReturnType<typeof useLoadFreeTrialEndedLazyQuery>;
export type LoadFreeTrialEndedQueryResult = Apollo.QueryResult<LoadFreeTrialEndedQuery, LoadFreeTrialEndedQueryVariables>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations($offset: Int, $limit: Int, $orderBy: [organizations_order_by!]!, $organizationsWhere: organizations_bool_exp) @cached {
  organizations(
    offset: $offset
    limit: $limit
    order_by: $orderBy
    where: $organizationsWhere
  ) {
    ...ORGANIZATION_INTERNAL
  }
}
    ${Organization_InternalFragmentDoc}`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      organizationsWhere: // value for 'organizationsWhere'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($usersWhere: users_bool_exp) @cached {
  users(order_by: {name: desc}, where: $usersWhere) {
    id
    email
    name
    is_internal
    created_at
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      usersWhere: // value for 'usersWhere'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetOrganizationsCountDocument = gql`
    query GetOrganizationsCount($organizationsWhere: organizations_bool_exp!) {
  organizations_aggregate(where: $organizationsWhere) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetOrganizationsCountQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsCountQuery({
 *   variables: {
 *      organizationsWhere: // value for 'organizationsWhere'
 *   },
 * });
 */
export function useGetOrganizationsCountQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationsCountQuery, GetOrganizationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsCountQuery, GetOrganizationsCountQueryVariables>(GetOrganizationsCountDocument, options);
      }
export function useGetOrganizationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsCountQuery, GetOrganizationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsCountQuery, GetOrganizationsCountQueryVariables>(GetOrganizationsCountDocument, options);
        }
export type GetOrganizationsCountQueryHookResult = ReturnType<typeof useGetOrganizationsCountQuery>;
export type GetOrganizationsCountLazyQueryHookResult = ReturnType<typeof useGetOrganizationsCountLazyQuery>;
export type GetOrganizationsCountQueryResult = Apollo.QueryResult<GetOrganizationsCountQuery, GetOrganizationsCountQueryVariables>;
export const GetOrganizationMetadataByOrgAndKeyDocument = gql`
    query GetOrganizationMetadataByOrgAndKey($organization_id: uuid!, $key: String!) {
  organizations_metadata(
    where: {organization_id: {_eq: $organization_id}, key: {_eq: $key}}
    order_by: {created_at: desc}
  ) {
    organization_id
    key
    value
    created_at
  }
}
    `;

/**
 * __useGetOrganizationMetadataByOrgAndKeyQuery__
 *
 * To run a query within a React component, call `useGetOrganizationMetadataByOrgAndKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationMetadataByOrgAndKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationMetadataByOrgAndKeyQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetOrganizationMetadataByOrgAndKeyQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationMetadataByOrgAndKeyQuery, GetOrganizationMetadataByOrgAndKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationMetadataByOrgAndKeyQuery, GetOrganizationMetadataByOrgAndKeyQueryVariables>(GetOrganizationMetadataByOrgAndKeyDocument, options);
      }
export function useGetOrganizationMetadataByOrgAndKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationMetadataByOrgAndKeyQuery, GetOrganizationMetadataByOrgAndKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationMetadataByOrgAndKeyQuery, GetOrganizationMetadataByOrgAndKeyQueryVariables>(GetOrganizationMetadataByOrgAndKeyDocument, options);
        }
export type GetOrganizationMetadataByOrgAndKeyQueryHookResult = ReturnType<typeof useGetOrganizationMetadataByOrgAndKeyQuery>;
export type GetOrganizationMetadataByOrgAndKeyLazyQueryHookResult = ReturnType<typeof useGetOrganizationMetadataByOrgAndKeyLazyQuery>;
export type GetOrganizationMetadataByOrgAndKeyQueryResult = Apollo.QueryResult<GetOrganizationMetadataByOrgAndKeyQuery, GetOrganizationMetadataByOrgAndKeyQueryVariables>;
export const OrganizationDocument = gql`
    query Organization($organization_id: uuid!) @cached {
  organizations_by_pk(id: $organization_id) {
    ...ORGANIZATION
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const RequestBulkScrapeDocument = gql`
    mutation RequestBulkScrape($collection_reports: [RequestBulkScrapeInput]!) {
  request_bulk_scrape(collection_reports: $collection_reports) {
    collections_to_scrape
  }
}
    `;
export type RequestBulkScrapeMutationFn = Apollo.MutationFunction<RequestBulkScrapeMutation, RequestBulkScrapeMutationVariables>;

/**
 * __useRequestBulkScrapeMutation__
 *
 * To run a mutation, you first call `useRequestBulkScrapeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBulkScrapeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBulkScrapeMutation, { data, loading, error }] = useRequestBulkScrapeMutation({
 *   variables: {
 *      collection_reports: // value for 'collection_reports'
 *   },
 * });
 */
export function useRequestBulkScrapeMutation(baseOptions?: Apollo.MutationHookOptions<RequestBulkScrapeMutation, RequestBulkScrapeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBulkScrapeMutation, RequestBulkScrapeMutationVariables>(RequestBulkScrapeDocument, options);
      }
export type RequestBulkScrapeMutationHookResult = ReturnType<typeof useRequestBulkScrapeMutation>;
export type RequestBulkScrapeMutationResult = Apollo.MutationResult<RequestBulkScrapeMutation>;
export type RequestBulkScrapeMutationOptions = Apollo.BaseMutationOptions<RequestBulkScrapeMutation, RequestBulkScrapeMutationVariables>;
export const GetLastOrgContextDocument = gql`
    query GetLastOrgContext($user_id: uuid!) {
  users_by_pk(id: $user_id) {
    id
    last_org_context
    last_org {
      ...ORGANIZATION
    }
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useGetLastOrgContextQuery__
 *
 * To run a query within a React component, call `useGetLastOrgContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastOrgContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastOrgContextQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetLastOrgContextQuery(baseOptions: Apollo.QueryHookOptions<GetLastOrgContextQuery, GetLastOrgContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastOrgContextQuery, GetLastOrgContextQueryVariables>(GetLastOrgContextDocument, options);
      }
export function useGetLastOrgContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastOrgContextQuery, GetLastOrgContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastOrgContextQuery, GetLastOrgContextQueryVariables>(GetLastOrgContextDocument, options);
        }
export type GetLastOrgContextQueryHookResult = ReturnType<typeof useGetLastOrgContextQuery>;
export type GetLastOrgContextLazyQueryHookResult = ReturnType<typeof useGetLastOrgContextLazyQuery>;
export type GetLastOrgContextQueryResult = Apollo.QueryResult<GetLastOrgContextQuery, GetLastOrgContextQueryVariables>;
export const UpdateLastOrgContextDocument = gql`
    mutation UpdateLastOrgContext($last_org_context: uuid!, $id: uuid!) {
  update_users_by_pk(
    _set: {last_org_context: $last_org_context}
    pk_columns: {id: $id}
  ) {
    id
    last_org_context
    last_org {
      ...ORGANIZATION
    }
  }
}
    ${OrganizationFragmentDoc}`;
export type UpdateLastOrgContextMutationFn = Apollo.MutationFunction<UpdateLastOrgContextMutation, UpdateLastOrgContextMutationVariables>;

/**
 * __useUpdateLastOrgContextMutation__
 *
 * To run a mutation, you first call `useUpdateLastOrgContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastOrgContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastOrgContextMutation, { data, loading, error }] = useUpdateLastOrgContextMutation({
 *   variables: {
 *      last_org_context: // value for 'last_org_context'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLastOrgContextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLastOrgContextMutation, UpdateLastOrgContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLastOrgContextMutation, UpdateLastOrgContextMutationVariables>(UpdateLastOrgContextDocument, options);
      }
export type UpdateLastOrgContextMutationHookResult = ReturnType<typeof useUpdateLastOrgContextMutation>;
export type UpdateLastOrgContextMutationResult = Apollo.MutationResult<UpdateLastOrgContextMutation>;
export type UpdateLastOrgContextMutationOptions = Apollo.BaseMutationOptions<UpdateLastOrgContextMutation, UpdateLastOrgContextMutationVariables>;
export const InsertTagForReportsDocument = gql`
    mutation InsertTagForReports($tagInsertionsInput: [report_tags_insert_input!]!) {
  insert_report_tags(
    objects: $tagInsertionsInput
    on_conflict: {constraint: report_tags_report_id_tag_id_key, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export type InsertTagForReportsMutationFn = Apollo.MutationFunction<InsertTagForReportsMutation, InsertTagForReportsMutationVariables>;

/**
 * __useInsertTagForReportsMutation__
 *
 * To run a mutation, you first call `useInsertTagForReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertTagForReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTagForReportsMutation, { data, loading, error }] = useInsertTagForReportsMutation({
 *   variables: {
 *      tagInsertionsInput: // value for 'tagInsertionsInput'
 *   },
 * });
 */
export function useInsertTagForReportsMutation(baseOptions?: Apollo.MutationHookOptions<InsertTagForReportsMutation, InsertTagForReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertTagForReportsMutation, InsertTagForReportsMutationVariables>(InsertTagForReportsDocument, options);
      }
export type InsertTagForReportsMutationHookResult = ReturnType<typeof useInsertTagForReportsMutation>;
export type InsertTagForReportsMutationResult = Apollo.MutationResult<InsertTagForReportsMutation>;
export type InsertTagForReportsMutationOptions = Apollo.BaseMutationOptions<InsertTagForReportsMutation, InsertTagForReportsMutationVariables>;
export const GetSpoofingReportsWithFullOrganizationDocument = gql`
    query GetSpoofingReportsWithFullOrganization($spoofingReportsWhere: spoofing_reports_bool_exp!, $includeCreditCardData: Boolean! = true) {
  spoofing_reports(where: $spoofingReportsWhere) {
    ...SPOOFING_REPORT
    organization {
      ...ORGANIZATION
    }
  }
}
    ${Spoofing_ReportFragmentDoc}
${OrganizationFragmentDoc}`;

/**
 * __useGetSpoofingReportsWithFullOrganizationQuery__
 *
 * To run a query within a React component, call `useGetSpoofingReportsWithFullOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpoofingReportsWithFullOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpoofingReportsWithFullOrganizationQuery({
 *   variables: {
 *      spoofingReportsWhere: // value for 'spoofingReportsWhere'
 *      includeCreditCardData: // value for 'includeCreditCardData'
 *   },
 * });
 */
export function useGetSpoofingReportsWithFullOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetSpoofingReportsWithFullOrganizationQuery, GetSpoofingReportsWithFullOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpoofingReportsWithFullOrganizationQuery, GetSpoofingReportsWithFullOrganizationQueryVariables>(GetSpoofingReportsWithFullOrganizationDocument, options);
      }
export function useGetSpoofingReportsWithFullOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpoofingReportsWithFullOrganizationQuery, GetSpoofingReportsWithFullOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpoofingReportsWithFullOrganizationQuery, GetSpoofingReportsWithFullOrganizationQueryVariables>(GetSpoofingReportsWithFullOrganizationDocument, options);
        }
export type GetSpoofingReportsWithFullOrganizationQueryHookResult = ReturnType<typeof useGetSpoofingReportsWithFullOrganizationQuery>;
export type GetSpoofingReportsWithFullOrganizationLazyQueryHookResult = ReturnType<typeof useGetSpoofingReportsWithFullOrganizationLazyQuery>;
export type GetSpoofingReportsWithFullOrganizationQueryResult = Apollo.QueryResult<GetSpoofingReportsWithFullOrganizationQuery, GetSpoofingReportsWithFullOrganizationQueryVariables>;
export const SubmitUserFeedbackDocument = gql`
    mutation SubmitUserFeedback($collection_report_id: uuid, $text: String, $type: String, $user_id: uuid) {
  insert_user_feedback_one(
    object: {collection_report_id: $collection_report_id, text: $text, type: $type, user_id: $user_id}
  ) {
    id
  }
}
    `;
export type SubmitUserFeedbackMutationFn = Apollo.MutationFunction<SubmitUserFeedbackMutation, SubmitUserFeedbackMutationVariables>;

/**
 * __useSubmitUserFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitUserFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitUserFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitUserFeedbackMutation, { data, loading, error }] = useSubmitUserFeedbackMutation({
 *   variables: {
 *      collection_report_id: // value for 'collection_report_id'
 *      text: // value for 'text'
 *      type: // value for 'type'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useSubmitUserFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitUserFeedbackMutation, SubmitUserFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitUserFeedbackMutation, SubmitUserFeedbackMutationVariables>(SubmitUserFeedbackDocument, options);
      }
export type SubmitUserFeedbackMutationHookResult = ReturnType<typeof useSubmitUserFeedbackMutation>;
export type SubmitUserFeedbackMutationResult = Apollo.MutationResult<SubmitUserFeedbackMutation>;
export type SubmitUserFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitUserFeedbackMutation, SubmitUserFeedbackMutationVariables>;
export const SpoofingReportsAutocompleteDocument = gql`
    query SpoofingReportsAutocomplete($limit: Int!, $spoofingReportsWhere: spoofing_reports_bool_exp!, $searchKey: String) @cached(ttl: 10) {
  search_spoofing_reports(
    args: {search: $searchKey}
    where: $spoofingReportsWhere
    limit: $limit
  ) {
    id
    flagged_url
    report_status
    spoof_matches {
      id
      full_url {
        id
        url
      }
    }
  }
}
    `;

/**
 * __useSpoofingReportsAutocompleteQuery__
 *
 * To run a query within a React component, call `useSpoofingReportsAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpoofingReportsAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpoofingReportsAutocompleteQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      spoofingReportsWhere: // value for 'spoofingReportsWhere'
 *      searchKey: // value for 'searchKey'
 *   },
 * });
 */
export function useSpoofingReportsAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<SpoofingReportsAutocompleteQuery, SpoofingReportsAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpoofingReportsAutocompleteQuery, SpoofingReportsAutocompleteQueryVariables>(SpoofingReportsAutocompleteDocument, options);
      }
export function useSpoofingReportsAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpoofingReportsAutocompleteQuery, SpoofingReportsAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpoofingReportsAutocompleteQuery, SpoofingReportsAutocompleteQueryVariables>(SpoofingReportsAutocompleteDocument, options);
        }
export type SpoofingReportsAutocompleteQueryHookResult = ReturnType<typeof useSpoofingReportsAutocompleteQuery>;
export type SpoofingReportsAutocompleteLazyQueryHookResult = ReturnType<typeof useSpoofingReportsAutocompleteLazyQuery>;
export type SpoofingReportsAutocompleteQueryResult = Apollo.QueryResult<SpoofingReportsAutocompleteQuery, SpoofingReportsAutocompleteQueryVariables>;
export const GetSpoofingReportsDocument = gql`
    query GetSpoofingReports($spoofingReportsWhere: spoofing_reports_bool_exp!, $orderBy: [spoofing_reports_order_by!]!, $includeCreditCardData: Boolean! = false) {
  spoofing_reports(where: $spoofingReportsWhere, order_by: $orderBy) {
    ...SPOOFING_REPORT
  }
}
    ${Spoofing_ReportFragmentDoc}`;

/**
 * __useGetSpoofingReportsQuery__
 *
 * To run a query within a React component, call `useGetSpoofingReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpoofingReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpoofingReportsQuery({
 *   variables: {
 *      spoofingReportsWhere: // value for 'spoofingReportsWhere'
 *      orderBy: // value for 'orderBy'
 *      includeCreditCardData: // value for 'includeCreditCardData'
 *   },
 * });
 */
export function useGetSpoofingReportsQuery(baseOptions: Apollo.QueryHookOptions<GetSpoofingReportsQuery, GetSpoofingReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpoofingReportsQuery, GetSpoofingReportsQueryVariables>(GetSpoofingReportsDocument, options);
      }
export function useGetSpoofingReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpoofingReportsQuery, GetSpoofingReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpoofingReportsQuery, GetSpoofingReportsQueryVariables>(GetSpoofingReportsDocument, options);
        }
export type GetSpoofingReportsQueryHookResult = ReturnType<typeof useGetSpoofingReportsQuery>;
export type GetSpoofingReportsLazyQueryHookResult = ReturnType<typeof useGetSpoofingReportsLazyQuery>;
export type GetSpoofingReportsQueryResult = Apollo.QueryResult<GetSpoofingReportsQuery, GetSpoofingReportsQueryVariables>;
export const SearchSpoofingReportsDocument = gql`
    query SearchSpoofingReports($offset: Int!, $limit: Int!, $refresh: Boolean!, $spoofingReportsWhere: spoofing_reports_bool_exp!, $skipNormalSearch: Boolean!, $skipFullTextSearch: Boolean!, $orderBy: [spoofing_reports_order_by!]!, $searchKey: String, $includeCreditCardData: Boolean! = false) @cached(ttl: 10, refresh: $refresh) {
  spoofing_reports(
    where: $spoofingReportsWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) @skip(if: $skipNormalSearch) {
    ...SPOOFING_REPORT
  }
  search_spoofing_reports(
    args: {search: $searchKey}
    offset: $offset
    limit: $limit
    order_by: $orderBy
    where: $spoofingReportsWhere
  ) @skip(if: $skipFullTextSearch) {
    ...SPOOFING_REPORT
  }
}
    ${Spoofing_ReportFragmentDoc}`;

/**
 * __useSearchSpoofingReportsQuery__
 *
 * To run a query within a React component, call `useSearchSpoofingReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSpoofingReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSpoofingReportsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      refresh: // value for 'refresh'
 *      spoofingReportsWhere: // value for 'spoofingReportsWhere'
 *      skipNormalSearch: // value for 'skipNormalSearch'
 *      skipFullTextSearch: // value for 'skipFullTextSearch'
 *      orderBy: // value for 'orderBy'
 *      searchKey: // value for 'searchKey'
 *      includeCreditCardData: // value for 'includeCreditCardData'
 *   },
 * });
 */
export function useSearchSpoofingReportsQuery(baseOptions: Apollo.QueryHookOptions<SearchSpoofingReportsQuery, SearchSpoofingReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSpoofingReportsQuery, SearchSpoofingReportsQueryVariables>(SearchSpoofingReportsDocument, options);
      }
export function useSearchSpoofingReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSpoofingReportsQuery, SearchSpoofingReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSpoofingReportsQuery, SearchSpoofingReportsQueryVariables>(SearchSpoofingReportsDocument, options);
        }
export type SearchSpoofingReportsQueryHookResult = ReturnType<typeof useSearchSpoofingReportsQuery>;
export type SearchSpoofingReportsLazyQueryHookResult = ReturnType<typeof useSearchSpoofingReportsLazyQuery>;
export type SearchSpoofingReportsQueryResult = Apollo.QueryResult<SearchSpoofingReportsQuery, SearchSpoofingReportsQueryVariables>;
export const SearchEmailReportsDocument = gql`
    query SearchEmailReports($offset: Int!, $refresh: Boolean!, $where: spoofing_reports_bool_exp!, $orderBy: [spoofing_reports_order_by!]!, $includeCreditCardData: Boolean! = false) @cached(ttl: 10, refresh: $refresh) {
  spoofing_reports(where: $where, offset: $offset, order_by: $orderBy) {
    ...SPOOFING_REPORT
  }
}
    ${Spoofing_ReportFragmentDoc}`;

/**
 * __useSearchEmailReportsQuery__
 *
 * To run a query within a React component, call `useSearchEmailReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmailReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmailReportsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      refresh: // value for 'refresh'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      includeCreditCardData: // value for 'includeCreditCardData'
 *   },
 * });
 */
export function useSearchEmailReportsQuery(baseOptions: Apollo.QueryHookOptions<SearchEmailReportsQuery, SearchEmailReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEmailReportsQuery, SearchEmailReportsQueryVariables>(SearchEmailReportsDocument, options);
      }
export function useSearchEmailReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEmailReportsQuery, SearchEmailReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEmailReportsQuery, SearchEmailReportsQueryVariables>(SearchEmailReportsDocument, options);
        }
export type SearchEmailReportsQueryHookResult = ReturnType<typeof useSearchEmailReportsQuery>;
export type SearchEmailReportsLazyQueryHookResult = ReturnType<typeof useSearchEmailReportsLazyQuery>;
export type SearchEmailReportsQueryResult = Apollo.QueryResult<SearchEmailReportsQuery, SearchEmailReportsQueryVariables>;
export const SearchEmailReportsCountDocument = gql`
    query SearchEmailReportsCount($where: spoofing_reports_bool_exp!) {
  spoofing_reports_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useSearchEmailReportsCountQuery__
 *
 * To run a query within a React component, call `useSearchEmailReportsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmailReportsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmailReportsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSearchEmailReportsCountQuery(baseOptions: Apollo.QueryHookOptions<SearchEmailReportsCountQuery, SearchEmailReportsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEmailReportsCountQuery, SearchEmailReportsCountQueryVariables>(SearchEmailReportsCountDocument, options);
      }
export function useSearchEmailReportsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEmailReportsCountQuery, SearchEmailReportsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEmailReportsCountQuery, SearchEmailReportsCountQueryVariables>(SearchEmailReportsCountDocument, options);
        }
export type SearchEmailReportsCountQueryHookResult = ReturnType<typeof useSearchEmailReportsCountQuery>;
export type SearchEmailReportsCountLazyQueryHookResult = ReturnType<typeof useSearchEmailReportsCountLazyQuery>;
export type SearchEmailReportsCountQueryResult = Apollo.QueryResult<SearchEmailReportsCountQuery, SearchEmailReportsCountQueryVariables>;
export const SearchSpoofingReportsCountDocument = gql`
    query SearchSpoofingReportsCount($spoofingReportsWhere: spoofing_reports_bool_exp!, $skipNormalSearch: Boolean!, $skipFullTextSearch: Boolean!, $searchKey: String, $limit: Int) {
  spoofing_reports_aggregate(where: $spoofingReportsWhere, limit: $limit) @skip(if: $skipNormalSearch) {
    aggregate {
      count
    }
  }
  search_spoofing_reports_aggregate(
    args: {search: $searchKey}
    where: $spoofingReportsWhere
    limit: $limit
  ) @skip(if: $skipFullTextSearch) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useSearchSpoofingReportsCountQuery__
 *
 * To run a query within a React component, call `useSearchSpoofingReportsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSpoofingReportsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSpoofingReportsCountQuery({
 *   variables: {
 *      spoofingReportsWhere: // value for 'spoofingReportsWhere'
 *      skipNormalSearch: // value for 'skipNormalSearch'
 *      skipFullTextSearch: // value for 'skipFullTextSearch'
 *      searchKey: // value for 'searchKey'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchSpoofingReportsCountQuery(baseOptions: Apollo.QueryHookOptions<SearchSpoofingReportsCountQuery, SearchSpoofingReportsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSpoofingReportsCountQuery, SearchSpoofingReportsCountQueryVariables>(SearchSpoofingReportsCountDocument, options);
      }
export function useSearchSpoofingReportsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSpoofingReportsCountQuery, SearchSpoofingReportsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSpoofingReportsCountQuery, SearchSpoofingReportsCountQueryVariables>(SearchSpoofingReportsCountDocument, options);
        }
export type SearchSpoofingReportsCountQueryHookResult = ReturnType<typeof useSearchSpoofingReportsCountQuery>;
export type SearchSpoofingReportsCountLazyQueryHookResult = ReturnType<typeof useSearchSpoofingReportsCountLazyQuery>;
export type SearchSpoofingReportsCountQueryResult = Apollo.QueryResult<SearchSpoofingReportsCountQuery, SearchSpoofingReportsCountQueryVariables>;
export const AlertsQueueStateCountByProductDocument = gql`
    query AlertsQueueStateCountByProduct($organizationId: uuid!, $queueState: String!, $limitPerProduct: bigint!) {
  alerts_queue_state_count_by_product(
    args: {organization_id: $organizationId, queue_state: $queueState, limit_per_product: $limitPerProduct}
  ) {
    alerts_count
    product
  }
}
    `;

/**
 * __useAlertsQueueStateCountByProductQuery__
 *
 * To run a query within a React component, call `useAlertsQueueStateCountByProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsQueueStateCountByProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsQueueStateCountByProductQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      queueState: // value for 'queueState'
 *      limitPerProduct: // value for 'limitPerProduct'
 *   },
 * });
 */
export function useAlertsQueueStateCountByProductQuery(baseOptions: Apollo.QueryHookOptions<AlertsQueueStateCountByProductQuery, AlertsQueueStateCountByProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertsQueueStateCountByProductQuery, AlertsQueueStateCountByProductQueryVariables>(AlertsQueueStateCountByProductDocument, options);
      }
export function useAlertsQueueStateCountByProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertsQueueStateCountByProductQuery, AlertsQueueStateCountByProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertsQueueStateCountByProductQuery, AlertsQueueStateCountByProductQueryVariables>(AlertsQueueStateCountByProductDocument, options);
        }
export type AlertsQueueStateCountByProductQueryHookResult = ReturnType<typeof useAlertsQueueStateCountByProductQuery>;
export type AlertsQueueStateCountByProductLazyQueryHookResult = ReturnType<typeof useAlertsQueueStateCountByProductLazyQuery>;
export type AlertsQueueStateCountByProductQueryResult = Apollo.QueryResult<AlertsQueueStateCountByProductQuery, AlertsQueueStateCountByProductQueryVariables>;
export const UpdateSpoofingReportsDocument = gql`
    mutation UpdateSpoofingReports($input: UpdateReportsInput!) {
  update_reports_action(update_reports_input: $input) {
    ids
    updated_fields
  }
}
    `;
export type UpdateSpoofingReportsMutationFn = Apollo.MutationFunction<UpdateSpoofingReportsMutation, UpdateSpoofingReportsMutationVariables>;

/**
 * __useUpdateSpoofingReportsMutation__
 *
 * To run a mutation, you first call `useUpdateSpoofingReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpoofingReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpoofingReportsMutation, { data, loading, error }] = useUpdateSpoofingReportsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpoofingReportsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpoofingReportsMutation, UpdateSpoofingReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpoofingReportsMutation, UpdateSpoofingReportsMutationVariables>(UpdateSpoofingReportsDocument, options);
      }
export type UpdateSpoofingReportsMutationHookResult = ReturnType<typeof useUpdateSpoofingReportsMutation>;
export type UpdateSpoofingReportsMutationResult = Apollo.MutationResult<UpdateSpoofingReportsMutation>;
export type UpdateSpoofingReportsMutationOptions = Apollo.BaseMutationOptions<UpdateSpoofingReportsMutation, UpdateSpoofingReportsMutationVariables>;
export const UploadEnforcementScreenshotToSpoofingReportDocument = gql`
    mutation UploadEnforcementScreenshotToSpoofingReport($id: uuid!, $reportScreenshots: jsonb!) {
  update_spoofing_reports(
    where: {id: {_eq: $id}}
    _set: {report_screenshots: $reportScreenshots}
  ) {
    returning {
      id
      report_screenshots
    }
  }
}
    `;
export type UploadEnforcementScreenshotToSpoofingReportMutationFn = Apollo.MutationFunction<UploadEnforcementScreenshotToSpoofingReportMutation, UploadEnforcementScreenshotToSpoofingReportMutationVariables>;

/**
 * __useUploadEnforcementScreenshotToSpoofingReportMutation__
 *
 * To run a mutation, you first call `useUploadEnforcementScreenshotToSpoofingReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEnforcementScreenshotToSpoofingReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEnforcementScreenshotToSpoofingReportMutation, { data, loading, error }] = useUploadEnforcementScreenshotToSpoofingReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reportScreenshots: // value for 'reportScreenshots'
 *   },
 * });
 */
export function useUploadEnforcementScreenshotToSpoofingReportMutation(baseOptions?: Apollo.MutationHookOptions<UploadEnforcementScreenshotToSpoofingReportMutation, UploadEnforcementScreenshotToSpoofingReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadEnforcementScreenshotToSpoofingReportMutation, UploadEnforcementScreenshotToSpoofingReportMutationVariables>(UploadEnforcementScreenshotToSpoofingReportDocument, options);
      }
export type UploadEnforcementScreenshotToSpoofingReportMutationHookResult = ReturnType<typeof useUploadEnforcementScreenshotToSpoofingReportMutation>;
export type UploadEnforcementScreenshotToSpoofingReportMutationResult = Apollo.MutationResult<UploadEnforcementScreenshotToSpoofingReportMutation>;
export type UploadEnforcementScreenshotToSpoofingReportMutationOptions = Apollo.BaseMutationOptions<UploadEnforcementScreenshotToSpoofingReportMutation, UploadEnforcementScreenshotToSpoofingReportMutationVariables>;
export const UpsertEnforcementPlatformDocument = gql`
    mutation UpsertEnforcementPlatform($input: enforcement_platforms_insert_input!) {
  insert_enforcement_platforms_one(
    object: $input
    on_conflict: {constraint: enforcement_platforms_pkey, update_columns: [name, platform, product, api_link, form_link, email, default_timeout, enforcement_types, initial_enforcement_methods, match_strings, types, escalate_enforcement_methods, notes, escalate_time, updated_by, compliance_status]}
  ) {
    name
  }
}
    `;
export type UpsertEnforcementPlatformMutationFn = Apollo.MutationFunction<UpsertEnforcementPlatformMutation, UpsertEnforcementPlatformMutationVariables>;

/**
 * __useUpsertEnforcementPlatformMutation__
 *
 * To run a mutation, you first call `useUpsertEnforcementPlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEnforcementPlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEnforcementPlatformMutation, { data, loading, error }] = useUpsertEnforcementPlatformMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEnforcementPlatformMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEnforcementPlatformMutation, UpsertEnforcementPlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEnforcementPlatformMutation, UpsertEnforcementPlatformMutationVariables>(UpsertEnforcementPlatformDocument, options);
      }
export type UpsertEnforcementPlatformMutationHookResult = ReturnType<typeof useUpsertEnforcementPlatformMutation>;
export type UpsertEnforcementPlatformMutationResult = Apollo.MutationResult<UpsertEnforcementPlatformMutation>;
export type UpsertEnforcementPlatformMutationOptions = Apollo.BaseMutationOptions<UpsertEnforcementPlatformMutation, UpsertEnforcementPlatformMutationVariables>;
export const UpsertEnforcementTypesDocument = gql`
    mutation UpsertEnforcementTypes($input: [enforcement_types_insert_input!]!) {
  insert_enforcement_types(
    objects: $input
    on_conflict: {constraint: enforcement_types_pkey, update_columns: [content_type, content_type_display_name, type, platform, priority, stage, enforcement_method_type, enforcement_method_data, updated_by]}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpsertEnforcementTypesMutationFn = Apollo.MutationFunction<UpsertEnforcementTypesMutation, UpsertEnforcementTypesMutationVariables>;

/**
 * __useUpsertEnforcementTypesMutation__
 *
 * To run a mutation, you first call `useUpsertEnforcementTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEnforcementTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEnforcementTypesMutation, { data, loading, error }] = useUpsertEnforcementTypesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEnforcementTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEnforcementTypesMutation, UpsertEnforcementTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEnforcementTypesMutation, UpsertEnforcementTypesMutationVariables>(UpsertEnforcementTypesDocument, options);
      }
export type UpsertEnforcementTypesMutationHookResult = ReturnType<typeof useUpsertEnforcementTypesMutation>;
export type UpsertEnforcementTypesMutationResult = Apollo.MutationResult<UpsertEnforcementTypesMutation>;
export type UpsertEnforcementTypesMutationOptions = Apollo.BaseMutationOptions<UpsertEnforcementTypesMutation, UpsertEnforcementTypesMutationVariables>;
export const DeleteEnforcementTypesDocument = gql`
    mutation DeleteEnforcementTypes($ids: [uuid!]!) {
  delete_enforcement_types(where: {id: {_in: $ids}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteEnforcementTypesMutationFn = Apollo.MutationFunction<DeleteEnforcementTypesMutation, DeleteEnforcementTypesMutationVariables>;

/**
 * __useDeleteEnforcementTypesMutation__
 *
 * To run a mutation, you first call `useDeleteEnforcementTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnforcementTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnforcementTypesMutation, { data, loading, error }] = useDeleteEnforcementTypesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteEnforcementTypesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEnforcementTypesMutation, DeleteEnforcementTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEnforcementTypesMutation, DeleteEnforcementTypesMutationVariables>(DeleteEnforcementTypesDocument, options);
      }
export type DeleteEnforcementTypesMutationHookResult = ReturnType<typeof useDeleteEnforcementTypesMutation>;
export type DeleteEnforcementTypesMutationResult = Apollo.MutationResult<DeleteEnforcementTypesMutation>;
export type DeleteEnforcementTypesMutationOptions = Apollo.BaseMutationOptions<DeleteEnforcementTypesMutation, DeleteEnforcementTypesMutationVariables>;
export const InsertAiPromptDocument = gql`
    mutation InsertAiPrompt($input: ai_prompts_insert_input!) {
  insert_ai_prompts_one(object: $input) {
    id
  }
}
    `;
export type InsertAiPromptMutationFn = Apollo.MutationFunction<InsertAiPromptMutation, InsertAiPromptMutationVariables>;

/**
 * __useInsertAiPromptMutation__
 *
 * To run a mutation, you first call `useInsertAiPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAiPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAiPromptMutation, { data, loading, error }] = useInsertAiPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertAiPromptMutation(baseOptions?: Apollo.MutationHookOptions<InsertAiPromptMutation, InsertAiPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAiPromptMutation, InsertAiPromptMutationVariables>(InsertAiPromptDocument, options);
      }
export type InsertAiPromptMutationHookResult = ReturnType<typeof useInsertAiPromptMutation>;
export type InsertAiPromptMutationResult = Apollo.MutationResult<InsertAiPromptMutation>;
export type InsertAiPromptMutationOptions = Apollo.BaseMutationOptions<InsertAiPromptMutation, InsertAiPromptMutationVariables>;
export const UpdateAiPromptDocument = gql`
    mutation UpdateAiPrompt($id: uuid!, $prompt: String!, $type: String!, $role: String!, $metadata: jsonb, $org_id: uuid, $platform: String, $updated_by: uuid!) {
  update_ai_prompts_by_pk(
    pk_columns: {id: $id}
    _set: {prompt: $prompt, type: $type, role: $role, metadata: $metadata, org_id: $org_id, platform: $platform, updated_by: $updated_by}
  ) {
    id
  }
}
    `;
export type UpdateAiPromptMutationFn = Apollo.MutationFunction<UpdateAiPromptMutation, UpdateAiPromptMutationVariables>;

/**
 * __useUpdateAiPromptMutation__
 *
 * To run a mutation, you first call `useUpdateAiPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiPromptMutation, { data, loading, error }] = useUpdateAiPromptMutation({
 *   variables: {
 *      id: // value for 'id'
 *      prompt: // value for 'prompt'
 *      type: // value for 'type'
 *      role: // value for 'role'
 *      metadata: // value for 'metadata'
 *      org_id: // value for 'org_id'
 *      platform: // value for 'platform'
 *      updated_by: // value for 'updated_by'
 *   },
 * });
 */
export function useUpdateAiPromptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiPromptMutation, UpdateAiPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiPromptMutation, UpdateAiPromptMutationVariables>(UpdateAiPromptDocument, options);
      }
export type UpdateAiPromptMutationHookResult = ReturnType<typeof useUpdateAiPromptMutation>;
export type UpdateAiPromptMutationResult = Apollo.MutationResult<UpdateAiPromptMutation>;
export type UpdateAiPromptMutationOptions = Apollo.BaseMutationOptions<UpdateAiPromptMutation, UpdateAiPromptMutationVariables>;
export const UpdateExternalSourceForReportDocument = gql`
    mutation UpdateExternalSourceForReport($id: uuid!, $external_source: String!, $report_change: collection_report_changes_insert_input!) {
  update_spoofing_reports(
    where: {id: {_eq: $id}}
    _set: {external_source: $external_source}
  ) {
    returning {
      id
      external_source
    }
  }
  insert_collection_report_changes_one(object: $report_change) {
    id
  }
}
    `;
export type UpdateExternalSourceForReportMutationFn = Apollo.MutationFunction<UpdateExternalSourceForReportMutation, UpdateExternalSourceForReportMutationVariables>;

/**
 * __useUpdateExternalSourceForReportMutation__
 *
 * To run a mutation, you first call `useUpdateExternalSourceForReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalSourceForReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalSourceForReportMutation, { data, loading, error }] = useUpdateExternalSourceForReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      external_source: // value for 'external_source'
 *      report_change: // value for 'report_change'
 *   },
 * });
 */
export function useUpdateExternalSourceForReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalSourceForReportMutation, UpdateExternalSourceForReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalSourceForReportMutation, UpdateExternalSourceForReportMutationVariables>(UpdateExternalSourceForReportDocument, options);
      }
export type UpdateExternalSourceForReportMutationHookResult = ReturnType<typeof useUpdateExternalSourceForReportMutation>;
export type UpdateExternalSourceForReportMutationResult = Apollo.MutationResult<UpdateExternalSourceForReportMutation>;
export type UpdateExternalSourceForReportMutationOptions = Apollo.BaseMutationOptions<UpdateExternalSourceForReportMutation, UpdateExternalSourceForReportMutationVariables>;
export const UpdateOrgStatusDocument = gql`
    mutation UpdateOrgStatus($id: uuid!, $organization_status: organization_status!) {
  update_organizations(
    where: {id: {_eq: $id}}
    _set: {organization_status: $organization_status}
  ) {
    returning {
      id
      organization_status
    }
  }
}
    `;
export type UpdateOrgStatusMutationFn = Apollo.MutationFunction<UpdateOrgStatusMutation, UpdateOrgStatusMutationVariables>;

/**
 * __useUpdateOrgStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrgStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgStatusMutation, { data, loading, error }] = useUpdateOrgStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organization_status: // value for 'organization_status'
 *   },
 * });
 */
export function useUpdateOrgStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgStatusMutation, UpdateOrgStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgStatusMutation, UpdateOrgStatusMutationVariables>(UpdateOrgStatusDocument, options);
      }
export type UpdateOrgStatusMutationHookResult = ReturnType<typeof useUpdateOrgStatusMutation>;
export type UpdateOrgStatusMutationResult = Apollo.MutationResult<UpdateOrgStatusMutation>;
export type UpdateOrgStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrgStatusMutation, UpdateOrgStatusMutationVariables>;
export const GetReportChangesDocument = gql`
    query GetReportChanges($spoof_report_id: uuid!) {
  collection_report_changes(
    where: {spoof_report_id: {_eq: $spoof_report_id}}
    order_by: {timestamp: desc}
  ) {
    id
    new_value
    old_value
    timestamp
    type
    source
    user {
      id
      name
      is_internal
    }
    enforcement_request {
      platform
      type
    }
    extra_data
  }
}
    `;

/**
 * __useGetReportChangesQuery__
 *
 * To run a query within a React component, call `useGetReportChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportChangesQuery({
 *   variables: {
 *      spoof_report_id: // value for 'spoof_report_id'
 *   },
 * });
 */
export function useGetReportChangesQuery(baseOptions: Apollo.QueryHookOptions<GetReportChangesQuery, GetReportChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportChangesQuery, GetReportChangesQueryVariables>(GetReportChangesDocument, options);
      }
export function useGetReportChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportChangesQuery, GetReportChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportChangesQuery, GetReportChangesQueryVariables>(GetReportChangesDocument, options);
        }
export type GetReportChangesQueryHookResult = ReturnType<typeof useGetReportChangesQuery>;
export type GetReportChangesLazyQueryHookResult = ReturnType<typeof useGetReportChangesLazyQuery>;
export type GetReportChangesQueryResult = Apollo.QueryResult<GetReportChangesQuery, GetReportChangesQueryVariables>;
export const GetTrademarksDocument = gql`
    query GetTrademarks($where: trademarks_bool_exp!, $offset: Int, $limit: Int) {
  trademarks(
    where: $where
    offset: $offset
    limit: $limit
    order_by: {created_at: asc}
  ) {
    id
    mark
    image_url
    record_link
    registration_number
    registration_office
    holder_name
    holder_company_name
    holder_address
    holder_country_code
    holder_website
    goods_or_services_class
    spoofing_entity {
      id
      entity_name
    }
    name
    trademark_registration_certificate_url
    status
    trademark_type
    image_url
  }
}
    `;

/**
 * __useGetTrademarksQuery__
 *
 * To run a query within a React component, call `useGetTrademarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrademarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrademarksQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrademarksQuery(baseOptions: Apollo.QueryHookOptions<GetTrademarksQuery, GetTrademarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrademarksQuery, GetTrademarksQueryVariables>(GetTrademarksDocument, options);
      }
export function useGetTrademarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrademarksQuery, GetTrademarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrademarksQuery, GetTrademarksQueryVariables>(GetTrademarksDocument, options);
        }
export type GetTrademarksQueryHookResult = ReturnType<typeof useGetTrademarksQuery>;
export type GetTrademarksLazyQueryHookResult = ReturnType<typeof useGetTrademarksLazyQuery>;
export type GetTrademarksQueryResult = Apollo.QueryResult<GetTrademarksQuery, GetTrademarksQueryVariables>;
export const GetBrandsCountDocument = gql`
    query GetBrandsCount($where: spoofing_entities_bool_exp!) {
  spoofing_entities_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetBrandsCountQuery__
 *
 * To run a query within a React component, call `useGetBrandsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetBrandsCountQuery(baseOptions: Apollo.QueryHookOptions<GetBrandsCountQuery, GetBrandsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsCountQuery, GetBrandsCountQueryVariables>(GetBrandsCountDocument, options);
      }
export function useGetBrandsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsCountQuery, GetBrandsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsCountQuery, GetBrandsCountQueryVariables>(GetBrandsCountDocument, options);
        }
export type GetBrandsCountQueryHookResult = ReturnType<typeof useGetBrandsCountQuery>;
export type GetBrandsCountLazyQueryHookResult = ReturnType<typeof useGetBrandsCountLazyQuery>;
export type GetBrandsCountQueryResult = Apollo.QueryResult<GetBrandsCountQuery, GetBrandsCountQueryVariables>;
export const GetBrandsDocument = gql`
    query GetBrands($where: spoofing_entities_bool_exp!, $offset: Int, $limit: Int, $order_by: [spoofing_entities_order_by!]) {
  spoofing_entities(
    where: $where
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    id
    organization_id
    entity_name
    entity_type
    entity_url
    screenshot_url
    domain_data
    updated_at
    entity_name_search_queries
    organization {
      name
    }
    last_updated_by_user {
      id
      name
    }
    protected_assets {
      id
      platform_name
      is_primary
      should_monitor
      full_url {
        url
      }
    }
    customer_assets_to_brands(where: {customer_asset: {status: {_eq: "active"}}}) {
      customer_asset {
        id
      }
    }
    designated_takedown_assets(where: {status: {_eq: "active"}}) {
      id
      customer_asset {
        id
        platform_subtype_id
      }
    }
  }
}
    `;

/**
 * __useGetBrandsQuery__
 *
 * To run a query within a React component, call `useGetBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetBrandsQuery(baseOptions: Apollo.QueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
      }
export function useGetBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsQuery, GetBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsQuery, GetBrandsQueryVariables>(GetBrandsDocument, options);
        }
export type GetBrandsQueryHookResult = ReturnType<typeof useGetBrandsQuery>;
export type GetBrandsLazyQueryHookResult = ReturnType<typeof useGetBrandsLazyQuery>;
export type GetBrandsQueryResult = Apollo.QueryResult<GetBrandsQuery, GetBrandsQueryVariables>;
export const GetCustomerAssetsByBrandsDocument = gql`
    query GetCustomerAssetsByBrands($brand_ids: [uuid!]!) {
  customer_assets_to_brands(
    where: {brand_id: {_in: $brand_ids}, customer_asset: {status: {_eq: "active"}}}
  ) {
    brand_id
    customer_asset_id
  }
}
    `;

/**
 * __useGetCustomerAssetsByBrandsQuery__
 *
 * To run a query within a React component, call `useGetCustomerAssetsByBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAssetsByBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAssetsByBrandsQuery({
 *   variables: {
 *      brand_ids: // value for 'brand_ids'
 *   },
 * });
 */
export function useGetCustomerAssetsByBrandsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAssetsByBrandsQuery, GetCustomerAssetsByBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAssetsByBrandsQuery, GetCustomerAssetsByBrandsQueryVariables>(GetCustomerAssetsByBrandsDocument, options);
      }
export function useGetCustomerAssetsByBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAssetsByBrandsQuery, GetCustomerAssetsByBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAssetsByBrandsQuery, GetCustomerAssetsByBrandsQueryVariables>(GetCustomerAssetsByBrandsDocument, options);
        }
export type GetCustomerAssetsByBrandsQueryHookResult = ReturnType<typeof useGetCustomerAssetsByBrandsQuery>;
export type GetCustomerAssetsByBrandsLazyQueryHookResult = ReturnType<typeof useGetCustomerAssetsByBrandsLazyQuery>;
export type GetCustomerAssetsByBrandsQueryResult = Apollo.QueryResult<GetCustomerAssetsByBrandsQuery, GetCustomerAssetsByBrandsQueryVariables>;
export const GetBrandDocument = gql`
    query GetBrand($id: uuid!) {
  spoofing_entities_by_pk(id: $id) {
    id
    organization_id
    entity_name
    entity_type
    entity_url
    screenshot_url
    domain_data
    updated_at
    entity_name_search_queries
    last_updated_by_user {
      id
      name
    }
    protected_assets {
      id
      platform_name
      is_primary
      should_monitor
      full_url {
        url
      }
    }
  }
}
    `;

/**
 * __useGetBrandQuery__
 *
 * To run a query within a React component, call `useGetBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandQuery(baseOptions: Apollo.QueryHookOptions<GetBrandQuery, GetBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandQuery, GetBrandQueryVariables>(GetBrandDocument, options);
      }
export function useGetBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandQuery, GetBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandQuery, GetBrandQueryVariables>(GetBrandDocument, options);
        }
export type GetBrandQueryHookResult = ReturnType<typeof useGetBrandQuery>;
export type GetBrandLazyQueryHookResult = ReturnType<typeof useGetBrandLazyQuery>;
export type GetBrandQueryResult = Apollo.QueryResult<GetBrandQuery, GetBrandQueryVariables>;
export const GetBrandNamesDocument = gql`
    query GetBrandNames($where: spoofing_entities_bool_exp!, $offset: Int, $limit: Int, $order_by: [spoofing_entities_order_by!]) {
  spoofing_entities(
    where: $where
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    id
    organization_id
    entity_name
  }
}
    `;

/**
 * __useGetBrandNamesQuery__
 *
 * To run a query within a React component, call `useGetBrandNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandNamesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetBrandNamesQuery(baseOptions: Apollo.QueryHookOptions<GetBrandNamesQuery, GetBrandNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandNamesQuery, GetBrandNamesQueryVariables>(GetBrandNamesDocument, options);
      }
export function useGetBrandNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandNamesQuery, GetBrandNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandNamesQuery, GetBrandNamesQueryVariables>(GetBrandNamesDocument, options);
        }
export type GetBrandNamesQueryHookResult = ReturnType<typeof useGetBrandNamesQuery>;
export type GetBrandNamesLazyQueryHookResult = ReturnType<typeof useGetBrandNamesLazyQuery>;
export type GetBrandNamesQueryResult = Apollo.QueryResult<GetBrandNamesQuery, GetBrandNamesQueryVariables>;
export const GetBrandNamesWithOrgDocument = gql`
    query GetBrandNamesWithOrg($where: spoofing_entities_bool_exp!, $offset: Int, $limit: Int, $order_by: [spoofing_entities_order_by!]) {
  spoofing_entities(
    where: $where
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    id
    organization_id
    entity_name
    organization {
      name
    }
  }
}
    `;

/**
 * __useGetBrandNamesWithOrgQuery__
 *
 * To run a query within a React component, call `useGetBrandNamesWithOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandNamesWithOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandNamesWithOrgQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetBrandNamesWithOrgQuery(baseOptions: Apollo.QueryHookOptions<GetBrandNamesWithOrgQuery, GetBrandNamesWithOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandNamesWithOrgQuery, GetBrandNamesWithOrgQueryVariables>(GetBrandNamesWithOrgDocument, options);
      }
export function useGetBrandNamesWithOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandNamesWithOrgQuery, GetBrandNamesWithOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandNamesWithOrgQuery, GetBrandNamesWithOrgQueryVariables>(GetBrandNamesWithOrgDocument, options);
        }
export type GetBrandNamesWithOrgQueryHookResult = ReturnType<typeof useGetBrandNamesWithOrgQuery>;
export type GetBrandNamesWithOrgLazyQueryHookResult = ReturnType<typeof useGetBrandNamesWithOrgLazyQuery>;
export type GetBrandNamesWithOrgQueryResult = Apollo.QueryResult<GetBrandNamesWithOrgQuery, GetBrandNamesWithOrgQueryVariables>;
export const GetTrademarksCountDocument = gql`
    query GetTrademarksCount($where: trademarks_bool_exp!) {
  trademarks_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetTrademarksCountQuery__
 *
 * To run a query within a React component, call `useGetTrademarksCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrademarksCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrademarksCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTrademarksCountQuery(baseOptions: Apollo.QueryHookOptions<GetTrademarksCountQuery, GetTrademarksCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrademarksCountQuery, GetTrademarksCountQueryVariables>(GetTrademarksCountDocument, options);
      }
export function useGetTrademarksCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrademarksCountQuery, GetTrademarksCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrademarksCountQuery, GetTrademarksCountQueryVariables>(GetTrademarksCountDocument, options);
        }
export type GetTrademarksCountQueryHookResult = ReturnType<typeof useGetTrademarksCountQuery>;
export type GetTrademarksCountLazyQueryHookResult = ReturnType<typeof useGetTrademarksCountLazyQuery>;
export type GetTrademarksCountQueryResult = Apollo.QueryResult<GetTrademarksCountQuery, GetTrademarksCountQueryVariables>;
export const GetSpoofTemplateInputDocument = gql`
    query GetSpoofTemplateInput($entityId: uuid!, $designatedTakedownAssetsWhere: designated_takedown_assets_bool_exp!, $orgDesignatedAssetsWhere: designated_takedown_assets_bool_exp!) {
  brandDesignatedAssets: designated_takedown_assets(
    where: {_and: [$designatedTakedownAssetsWhere, {brand_id: {_eq: $entityId}}, {customer_asset: {customer_assets_to_brands: {brand_id: {_eq: $entityId}}}}]}
  ) {
    customer_asset {
      social_media_data {
        slug
      }
      value
    }
  }
  orgDefaultDesignatedAssets: designated_takedown_assets(
    where: $orgDesignatedAssetsWhere
  ) {
    customer_asset {
      social_media_data {
        slug
      }
      value
    }
  }
  spoofing_entities(where: {id: {_eq: $entityId}}) {
    trademarks {
      id
      goods_or_services_class
      holder_address
      holder_country_code
      holder_name
      holder_website
      holder_company_name
      mark
      record_link
      registration_number
      registration_office
      trademark_registration_certificate_url
    }
    organization {
      enforcement_metadata {
        authorization_letter_url
        enforcement_email
        legal_name
        country_code
        authorization_letter_url_expiration_date
      }
    }
    id
  }
}
    `;

/**
 * __useGetSpoofTemplateInputQuery__
 *
 * To run a query within a React component, call `useGetSpoofTemplateInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpoofTemplateInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpoofTemplateInputQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      designatedTakedownAssetsWhere: // value for 'designatedTakedownAssetsWhere'
 *      orgDesignatedAssetsWhere: // value for 'orgDesignatedAssetsWhere'
 *   },
 * });
 */
export function useGetSpoofTemplateInputQuery(baseOptions: Apollo.QueryHookOptions<GetSpoofTemplateInputQuery, GetSpoofTemplateInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpoofTemplateInputQuery, GetSpoofTemplateInputQueryVariables>(GetSpoofTemplateInputDocument, options);
      }
export function useGetSpoofTemplateInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpoofTemplateInputQuery, GetSpoofTemplateInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpoofTemplateInputQuery, GetSpoofTemplateInputQueryVariables>(GetSpoofTemplateInputDocument, options);
        }
export type GetSpoofTemplateInputQueryHookResult = ReturnType<typeof useGetSpoofTemplateInputQuery>;
export type GetSpoofTemplateInputLazyQueryHookResult = ReturnType<typeof useGetSpoofTemplateInputLazyQuery>;
export type GetSpoofTemplateInputQueryResult = Apollo.QueryResult<GetSpoofTemplateInputQuery, GetSpoofTemplateInputQueryVariables>;
export const GetSpoofTemplatesDocument = gql`
    query GetSpoofTemplates($platform: String!, $type: String!, $stage: String!) {
  enforcement_templates(
    where: {platform: {_eq: $platform}, type: {_eq: $type}, stage: {_eq: $stage}}
  ) {
    template_body
    optional_input
  }
}
    `;

/**
 * __useGetSpoofTemplatesQuery__
 *
 * To run a query within a React component, call `useGetSpoofTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpoofTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpoofTemplatesQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *      type: // value for 'type'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useGetSpoofTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetSpoofTemplatesQuery, GetSpoofTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpoofTemplatesQuery, GetSpoofTemplatesQueryVariables>(GetSpoofTemplatesDocument, options);
      }
export function useGetSpoofTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpoofTemplatesQuery, GetSpoofTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpoofTemplatesQuery, GetSpoofTemplatesQueryVariables>(GetSpoofTemplatesDocument, options);
        }
export type GetSpoofTemplatesQueryHookResult = ReturnType<typeof useGetSpoofTemplatesQuery>;
export type GetSpoofTemplatesLazyQueryHookResult = ReturnType<typeof useGetSpoofTemplatesLazyQuery>;
export type GetSpoofTemplatesQueryResult = Apollo.QueryResult<GetSpoofTemplatesQuery, GetSpoofTemplatesQueryVariables>;
export const GetEnforcementRequestsForSpoofingReportDocument = gql`
    query GetEnforcementRequestsForSpoofingReport($spoofing_report_id: uuid!) {
  enforcement_requests(where: {spoofing_report_id: {_eq: $spoofing_report_id}}) {
    ...ENFORCEMENT_REQUESTS
    collection_report_changes(order_by: {timestamp: desc}, limit: 1) {
      timestamp
    }
  }
}
    ${Enforcement_RequestsFragmentDoc}`;

/**
 * __useGetEnforcementRequestsForSpoofingReportQuery__
 *
 * To run a query within a React component, call `useGetEnforcementRequestsForSpoofingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementRequestsForSpoofingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementRequestsForSpoofingReportQuery({
 *   variables: {
 *      spoofing_report_id: // value for 'spoofing_report_id'
 *   },
 * });
 */
export function useGetEnforcementRequestsForSpoofingReportQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementRequestsForSpoofingReportQuery, GetEnforcementRequestsForSpoofingReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementRequestsForSpoofingReportQuery, GetEnforcementRequestsForSpoofingReportQueryVariables>(GetEnforcementRequestsForSpoofingReportDocument, options);
      }
export function useGetEnforcementRequestsForSpoofingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementRequestsForSpoofingReportQuery, GetEnforcementRequestsForSpoofingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementRequestsForSpoofingReportQuery, GetEnforcementRequestsForSpoofingReportQueryVariables>(GetEnforcementRequestsForSpoofingReportDocument, options);
        }
export type GetEnforcementRequestsForSpoofingReportQueryHookResult = ReturnType<typeof useGetEnforcementRequestsForSpoofingReportQuery>;
export type GetEnforcementRequestsForSpoofingReportLazyQueryHookResult = ReturnType<typeof useGetEnforcementRequestsForSpoofingReportLazyQuery>;
export type GetEnforcementRequestsForSpoofingReportQueryResult = Apollo.QueryResult<GetEnforcementRequestsForSpoofingReportQuery, GetEnforcementRequestsForSpoofingReportQueryVariables>;
export const GetEnforcementPlatformsComplianceStatusDocument = gql`
    query GetEnforcementPlatformsComplianceStatus($platform_names: [String!]!) {
  enforcement_platforms(where: {name: {_in: $platform_names}}) {
    name
    compliance_status
  }
}
    `;

/**
 * __useGetEnforcementPlatformsComplianceStatusQuery__
 *
 * To run a query within a React component, call `useGetEnforcementPlatformsComplianceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementPlatformsComplianceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementPlatformsComplianceStatusQuery({
 *   variables: {
 *      platform_names: // value for 'platform_names'
 *   },
 * });
 */
export function useGetEnforcementPlatformsComplianceStatusQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementPlatformsComplianceStatusQuery, GetEnforcementPlatformsComplianceStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementPlatformsComplianceStatusQuery, GetEnforcementPlatformsComplianceStatusQueryVariables>(GetEnforcementPlatformsComplianceStatusDocument, options);
      }
export function useGetEnforcementPlatformsComplianceStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementPlatformsComplianceStatusQuery, GetEnforcementPlatformsComplianceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementPlatformsComplianceStatusQuery, GetEnforcementPlatformsComplianceStatusQueryVariables>(GetEnforcementPlatformsComplianceStatusDocument, options);
        }
export type GetEnforcementPlatformsComplianceStatusQueryHookResult = ReturnType<typeof useGetEnforcementPlatformsComplianceStatusQuery>;
export type GetEnforcementPlatformsComplianceStatusLazyQueryHookResult = ReturnType<typeof useGetEnforcementPlatformsComplianceStatusLazyQuery>;
export type GetEnforcementPlatformsComplianceStatusQueryResult = Apollo.QueryResult<GetEnforcementPlatformsComplianceStatusQuery, GetEnforcementPlatformsComplianceStatusQueryVariables>;
export const GetJiraMetadataForEnforcementRequestsDocument = gql`
    query GetJiraMetadataForEnforcementRequests($enforcement_request_ids: [uuid!]!) {
  jira_metadata(where: {enforcement_request_id: {_in: $enforcement_request_ids}}) {
    ticket_id
    status
    enforcement_request_id
  }
}
    `;

/**
 * __useGetJiraMetadataForEnforcementRequestsQuery__
 *
 * To run a query within a React component, call `useGetJiraMetadataForEnforcementRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJiraMetadataForEnforcementRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJiraMetadataForEnforcementRequestsQuery({
 *   variables: {
 *      enforcement_request_ids: // value for 'enforcement_request_ids'
 *   },
 * });
 */
export function useGetJiraMetadataForEnforcementRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetJiraMetadataForEnforcementRequestsQuery, GetJiraMetadataForEnforcementRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJiraMetadataForEnforcementRequestsQuery, GetJiraMetadataForEnforcementRequestsQueryVariables>(GetJiraMetadataForEnforcementRequestsDocument, options);
      }
export function useGetJiraMetadataForEnforcementRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJiraMetadataForEnforcementRequestsQuery, GetJiraMetadataForEnforcementRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJiraMetadataForEnforcementRequestsQuery, GetJiraMetadataForEnforcementRequestsQueryVariables>(GetJiraMetadataForEnforcementRequestsDocument, options);
        }
export type GetJiraMetadataForEnforcementRequestsQueryHookResult = ReturnType<typeof useGetJiraMetadataForEnforcementRequestsQuery>;
export type GetJiraMetadataForEnforcementRequestsLazyQueryHookResult = ReturnType<typeof useGetJiraMetadataForEnforcementRequestsLazyQuery>;
export type GetJiraMetadataForEnforcementRequestsQueryResult = Apollo.QueryResult<GetJiraMetadataForEnforcementRequestsQuery, GetJiraMetadataForEnforcementRequestsQueryVariables>;
export const GetEnforcementRequestsForCollectionReportDocument = gql`
    query GetEnforcementRequestsForCollectionReport($collection_report_id: uuid!) {
  enforcement_requests(
    where: {collection_report_id: {_eq: $collection_report_id}}
  ) {
    ...ENFORCEMENT_REQUESTS
  }
}
    ${Enforcement_RequestsFragmentDoc}`;

/**
 * __useGetEnforcementRequestsForCollectionReportQuery__
 *
 * To run a query within a React component, call `useGetEnforcementRequestsForCollectionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementRequestsForCollectionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementRequestsForCollectionReportQuery({
 *   variables: {
 *      collection_report_id: // value for 'collection_report_id'
 *   },
 * });
 */
export function useGetEnforcementRequestsForCollectionReportQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementRequestsForCollectionReportQuery, GetEnforcementRequestsForCollectionReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementRequestsForCollectionReportQuery, GetEnforcementRequestsForCollectionReportQueryVariables>(GetEnforcementRequestsForCollectionReportDocument, options);
      }
export function useGetEnforcementRequestsForCollectionReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementRequestsForCollectionReportQuery, GetEnforcementRequestsForCollectionReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementRequestsForCollectionReportQuery, GetEnforcementRequestsForCollectionReportQueryVariables>(GetEnforcementRequestsForCollectionReportDocument, options);
        }
export type GetEnforcementRequestsForCollectionReportQueryHookResult = ReturnType<typeof useGetEnforcementRequestsForCollectionReportQuery>;
export type GetEnforcementRequestsForCollectionReportLazyQueryHookResult = ReturnType<typeof useGetEnforcementRequestsForCollectionReportLazyQuery>;
export type GetEnforcementRequestsForCollectionReportQueryResult = Apollo.QueryResult<GetEnforcementRequestsForCollectionReportQuery, GetEnforcementRequestsForCollectionReportQueryVariables>;
export const GetApprovalsDocument = gql`
    query GetApprovals($offset: Int!, $limit: Int!, $approvalsWhere: approvals_bool_exp!, $refresh: Boolean!, $orderBy: [approvals_order_by!]!, $includeCreditCardData: Boolean! = false) @cached(ttl: 10, refresh: $refresh) {
  approvals(
    offset: $offset
    limit: $limit
    where: $approvalsWhere
    order_by: $orderBy
  ) {
    id
    created_at
    updated_at
    requester {
      name
    }
    approver {
      name
    }
    status
    reason
    spoofing_report {
      ...SPOOFING_REPORT
    }
  }
}
    ${Spoofing_ReportFragmentDoc}`;

/**
 * __useGetApprovalsQuery__
 *
 * To run a query within a React component, call `useGetApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      approvalsWhere: // value for 'approvalsWhere'
 *      refresh: // value for 'refresh'
 *      orderBy: // value for 'orderBy'
 *      includeCreditCardData: // value for 'includeCreditCardData'
 *   },
 * });
 */
export function useGetApprovalsQuery(baseOptions: Apollo.QueryHookOptions<GetApprovalsQuery, GetApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalsQuery, GetApprovalsQueryVariables>(GetApprovalsDocument, options);
      }
export function useGetApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalsQuery, GetApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalsQuery, GetApprovalsQueryVariables>(GetApprovalsDocument, options);
        }
export type GetApprovalsQueryHookResult = ReturnType<typeof useGetApprovalsQuery>;
export type GetApprovalsLazyQueryHookResult = ReturnType<typeof useGetApprovalsLazyQuery>;
export type GetApprovalsQueryResult = Apollo.QueryResult<GetApprovalsQuery, GetApprovalsQueryVariables>;
export const GetApprovalsCountDocument = gql`
    query GetApprovalsCount($approvalsWhere: approvals_bool_exp!) {
  approvals_aggregate(where: $approvalsWhere) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetApprovalsCountQuery__
 *
 * To run a query within a React component, call `useGetApprovalsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalsCountQuery({
 *   variables: {
 *      approvalsWhere: // value for 'approvalsWhere'
 *   },
 * });
 */
export function useGetApprovalsCountQuery(baseOptions: Apollo.QueryHookOptions<GetApprovalsCountQuery, GetApprovalsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalsCountQuery, GetApprovalsCountQueryVariables>(GetApprovalsCountDocument, options);
      }
export function useGetApprovalsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalsCountQuery, GetApprovalsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalsCountQuery, GetApprovalsCountQueryVariables>(GetApprovalsCountDocument, options);
        }
export type GetApprovalsCountQueryHookResult = ReturnType<typeof useGetApprovalsCountQuery>;
export type GetApprovalsCountLazyQueryHookResult = ReturnType<typeof useGetApprovalsCountLazyQuery>;
export type GetApprovalsCountQueryResult = Apollo.QueryResult<GetApprovalsCountQuery, GetApprovalsCountQueryVariables>;
export const UpdateApprovalsStatusDocument = gql`
    mutation UpdateApprovalsStatus($id: uuid!, $status: approval_status!, $approver_id: uuid!) {
  update_approvals(
    where: {id: {_eq: $id}}
    _set: {status: $status, approver_id: $approver_id}
  ) {
    returning {
      id
      status
      updated_at
    }
  }
}
    `;
export type UpdateApprovalsStatusMutationFn = Apollo.MutationFunction<UpdateApprovalsStatusMutation, UpdateApprovalsStatusMutationVariables>;

/**
 * __useUpdateApprovalsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateApprovalsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApprovalsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApprovalsStatusMutation, { data, loading, error }] = useUpdateApprovalsStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      approver_id: // value for 'approver_id'
 *   },
 * });
 */
export function useUpdateApprovalsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApprovalsStatusMutation, UpdateApprovalsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApprovalsStatusMutation, UpdateApprovalsStatusMutationVariables>(UpdateApprovalsStatusDocument, options);
      }
export type UpdateApprovalsStatusMutationHookResult = ReturnType<typeof useUpdateApprovalsStatusMutation>;
export type UpdateApprovalsStatusMutationResult = Apollo.MutationResult<UpdateApprovalsStatusMutation>;
export type UpdateApprovalsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateApprovalsStatusMutation, UpdateApprovalsStatusMutationVariables>;
export const DeleteEnforcementRequestDocument = gql`
    mutation DeleteEnforcementRequest($id: uuid!) {
  delete_enforcement_requests(where: {id: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteEnforcementRequestMutationFn = Apollo.MutationFunction<DeleteEnforcementRequestMutation, DeleteEnforcementRequestMutationVariables>;

/**
 * __useDeleteEnforcementRequestMutation__
 *
 * To run a mutation, you first call `useDeleteEnforcementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnforcementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnforcementRequestMutation, { data, loading, error }] = useDeleteEnforcementRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEnforcementRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEnforcementRequestMutation, DeleteEnforcementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEnforcementRequestMutation, DeleteEnforcementRequestMutationVariables>(DeleteEnforcementRequestDocument, options);
      }
export type DeleteEnforcementRequestMutationHookResult = ReturnType<typeof useDeleteEnforcementRequestMutation>;
export type DeleteEnforcementRequestMutationResult = Apollo.MutationResult<DeleteEnforcementRequestMutation>;
export type DeleteEnforcementRequestMutationOptions = Apollo.BaseMutationOptions<DeleteEnforcementRequestMutation, DeleteEnforcementRequestMutationVariables>;
export const SendSlackMessageDocument = gql`
    mutation SendSlackMessage($slack_message_input: SlackMessageInput!) {
  send_slack_message(slack_message_input: $slack_message_input) {
    success
  }
}
    `;
export type SendSlackMessageMutationFn = Apollo.MutationFunction<SendSlackMessageMutation, SendSlackMessageMutationVariables>;

/**
 * __useSendSlackMessageMutation__
 *
 * To run a mutation, you first call `useSendSlackMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSlackMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSlackMessageMutation, { data, loading, error }] = useSendSlackMessageMutation({
 *   variables: {
 *      slack_message_input: // value for 'slack_message_input'
 *   },
 * });
 */
export function useSendSlackMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendSlackMessageMutation, SendSlackMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSlackMessageMutation, SendSlackMessageMutationVariables>(SendSlackMessageDocument, options);
      }
export type SendSlackMessageMutationHookResult = ReturnType<typeof useSendSlackMessageMutation>;
export type SendSlackMessageMutationResult = Apollo.MutationResult<SendSlackMessageMutation>;
export type SendSlackMessageMutationOptions = Apollo.BaseMutationOptions<SendSlackMessageMutation, SendSlackMessageMutationVariables>;
export const PublishRequestSpoofScreenshotDocument = gql`
    mutation PublishRequestSpoofScreenshot($report_id: uuid!) {
  publish_request_spoof_screenshot(
    publish_request_spoof_screenshot_input: {report_id: $report_id}
  ) {
    report_screenshot_url
    screenshot_url_already_exists
    matches_published
  }
}
    `;
export type PublishRequestSpoofScreenshotMutationFn = Apollo.MutationFunction<PublishRequestSpoofScreenshotMutation, PublishRequestSpoofScreenshotMutationVariables>;

/**
 * __usePublishRequestSpoofScreenshotMutation__
 *
 * To run a mutation, you first call `usePublishRequestSpoofScreenshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishRequestSpoofScreenshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishRequestSpoofScreenshotMutation, { data, loading, error }] = usePublishRequestSpoofScreenshotMutation({
 *   variables: {
 *      report_id: // value for 'report_id'
 *   },
 * });
 */
export function usePublishRequestSpoofScreenshotMutation(baseOptions?: Apollo.MutationHookOptions<PublishRequestSpoofScreenshotMutation, PublishRequestSpoofScreenshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishRequestSpoofScreenshotMutation, PublishRequestSpoofScreenshotMutationVariables>(PublishRequestSpoofScreenshotDocument, options);
      }
export type PublishRequestSpoofScreenshotMutationHookResult = ReturnType<typeof usePublishRequestSpoofScreenshotMutation>;
export type PublishRequestSpoofScreenshotMutationResult = Apollo.MutationResult<PublishRequestSpoofScreenshotMutation>;
export type PublishRequestSpoofScreenshotMutationOptions = Apollo.BaseMutationOptions<PublishRequestSpoofScreenshotMutation, PublishRequestSpoofScreenshotMutationVariables>;
export const UploadNewEnforcementRequestDocument = gql`
    mutation UploadNewEnforcementRequest($enforcement_type: String!, $platform: String!, $status: String!, $spoofing_report_id: uuid, $collection_report_id: uuid, $submitted_at: timestamp, $screenshot_file: String, $trademark_id: uuid, $copyrighted_content_url: String, $original_content_type: String, $submission_email: String, $body: String, $suggested_enforcement_id: uuid, $copyright_original_work_description: String, $submission_source: String) {
  upload_new_enforcement_request(
    upload_new_enforcement_request_input: {enforcement_type: $enforcement_type, platform: $platform, status: $status, spoofing_report_id: $spoofing_report_id, collection_report_id: $collection_report_id, submitted_at: $submitted_at, screenshot_file: $screenshot_file, trademark_id: $trademark_id, copyrighted_content_url: $copyrighted_content_url, original_content_type: $original_content_type, submission_email: $submission_email, body: $body, suggested_enforcement_id: $suggested_enforcement_id, copyright_original_work_description: $copyright_original_work_description, submission_source: $submission_source}
  ) {
    id
  }
}
    `;
export type UploadNewEnforcementRequestMutationFn = Apollo.MutationFunction<UploadNewEnforcementRequestMutation, UploadNewEnforcementRequestMutationVariables>;

/**
 * __useUploadNewEnforcementRequestMutation__
 *
 * To run a mutation, you first call `useUploadNewEnforcementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewEnforcementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewEnforcementRequestMutation, { data, loading, error }] = useUploadNewEnforcementRequestMutation({
 *   variables: {
 *      enforcement_type: // value for 'enforcement_type'
 *      platform: // value for 'platform'
 *      status: // value for 'status'
 *      spoofing_report_id: // value for 'spoofing_report_id'
 *      collection_report_id: // value for 'collection_report_id'
 *      submitted_at: // value for 'submitted_at'
 *      screenshot_file: // value for 'screenshot_file'
 *      trademark_id: // value for 'trademark_id'
 *      copyrighted_content_url: // value for 'copyrighted_content_url'
 *      original_content_type: // value for 'original_content_type'
 *      submission_email: // value for 'submission_email'
 *      body: // value for 'body'
 *      suggested_enforcement_id: // value for 'suggested_enforcement_id'
 *      copyright_original_work_description: // value for 'copyright_original_work_description'
 *      submission_source: // value for 'submission_source'
 *   },
 * });
 */
export function useUploadNewEnforcementRequestMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewEnforcementRequestMutation, UploadNewEnforcementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewEnforcementRequestMutation, UploadNewEnforcementRequestMutationVariables>(UploadNewEnforcementRequestDocument, options);
      }
export type UploadNewEnforcementRequestMutationHookResult = ReturnType<typeof useUploadNewEnforcementRequestMutation>;
export type UploadNewEnforcementRequestMutationResult = Apollo.MutationResult<UploadNewEnforcementRequestMutation>;
export type UploadNewEnforcementRequestMutationOptions = Apollo.BaseMutationOptions<UploadNewEnforcementRequestMutation, UploadNewEnforcementRequestMutationVariables>;
export const UploadNewEnforcementRequestV2Document = gql`
    mutation UploadNewEnforcementRequestV2($enforcement_type: String!, $platform: String!, $status: String!, $spoofing_report_id: uuid, $collection_report_id: uuid, $submitted_at: timestamp, $screenshot_file: String, $trademark_id: uuid, $copyrighted_content_url: String, $original_content_type: String, $submission_email: String, $body: String, $suggested_enforcement_id: uuid, $copyright_original_work_description: String, $submission_source: String) {
  upload_new_enforcement_request_v2(
    upload_new_enforcement_request_v2_input: {enforcement_type: $enforcement_type, platform: $platform, status: $status, spoofing_report_id: $spoofing_report_id, collection_report_id: $collection_report_id, submitted_at: $submitted_at, screenshot_file: $screenshot_file, trademark_id: $trademark_id, copyrighted_content_url: $copyrighted_content_url, original_content_type: $original_content_type, submission_email: $submission_email, body: $body, suggested_enforcement_id: $suggested_enforcement_id, copyright_original_work_description: $copyright_original_work_description, submission_source: $submission_source}
  ) {
    enforcement_request {
      id
    }
    error {
      error_code
      message
    }
  }
}
    `;
export type UploadNewEnforcementRequestV2MutationFn = Apollo.MutationFunction<UploadNewEnforcementRequestV2Mutation, UploadNewEnforcementRequestV2MutationVariables>;

/**
 * __useUploadNewEnforcementRequestV2Mutation__
 *
 * To run a mutation, you first call `useUploadNewEnforcementRequestV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewEnforcementRequestV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewEnforcementRequestV2Mutation, { data, loading, error }] = useUploadNewEnforcementRequestV2Mutation({
 *   variables: {
 *      enforcement_type: // value for 'enforcement_type'
 *      platform: // value for 'platform'
 *      status: // value for 'status'
 *      spoofing_report_id: // value for 'spoofing_report_id'
 *      collection_report_id: // value for 'collection_report_id'
 *      submitted_at: // value for 'submitted_at'
 *      screenshot_file: // value for 'screenshot_file'
 *      trademark_id: // value for 'trademark_id'
 *      copyrighted_content_url: // value for 'copyrighted_content_url'
 *      original_content_type: // value for 'original_content_type'
 *      submission_email: // value for 'submission_email'
 *      body: // value for 'body'
 *      suggested_enforcement_id: // value for 'suggested_enforcement_id'
 *      copyright_original_work_description: // value for 'copyright_original_work_description'
 *      submission_source: // value for 'submission_source'
 *   },
 * });
 */
export function useUploadNewEnforcementRequestV2Mutation(baseOptions?: Apollo.MutationHookOptions<UploadNewEnforcementRequestV2Mutation, UploadNewEnforcementRequestV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewEnforcementRequestV2Mutation, UploadNewEnforcementRequestV2MutationVariables>(UploadNewEnforcementRequestV2Document, options);
      }
export type UploadNewEnforcementRequestV2MutationHookResult = ReturnType<typeof useUploadNewEnforcementRequestV2Mutation>;
export type UploadNewEnforcementRequestV2MutationResult = Apollo.MutationResult<UploadNewEnforcementRequestV2Mutation>;
export type UploadNewEnforcementRequestV2MutationOptions = Apollo.BaseMutationOptions<UploadNewEnforcementRequestV2Mutation, UploadNewEnforcementRequestV2MutationVariables>;
export const UploadNewWeb2EntityDocument = gql`
    mutation UploadNewWeb2Entity($entity_id: uuid, $entity_type: String!, $entity_name: String!, $domain_configs: jsonb!, $entity_url: String, $screenshot_url: String!, $entity_name_search_queries: jsonb, $organization_id: uuid!) {
  upload_new_web2_entity(
    upload_new_web2_entity_input: {entity_id: $entity_id, entity_type: $entity_type, entity_name: $entity_name, domain_configs: $domain_configs, entity_url: $entity_url, screenshot_url: $screenshot_url, entity_name_search_queries: $entity_name_search_queries, organization_id: $organization_id}
  ) {
    id
  }
}
    `;
export type UploadNewWeb2EntityMutationFn = Apollo.MutationFunction<UploadNewWeb2EntityMutation, UploadNewWeb2EntityMutationVariables>;

/**
 * __useUploadNewWeb2EntityMutation__
 *
 * To run a mutation, you first call `useUploadNewWeb2EntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewWeb2EntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewWeb2EntityMutation, { data, loading, error }] = useUploadNewWeb2EntityMutation({
 *   variables: {
 *      entity_id: // value for 'entity_id'
 *      entity_type: // value for 'entity_type'
 *      entity_name: // value for 'entity_name'
 *      domain_configs: // value for 'domain_configs'
 *      entity_url: // value for 'entity_url'
 *      screenshot_url: // value for 'screenshot_url'
 *      entity_name_search_queries: // value for 'entity_name_search_queries'
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useUploadNewWeb2EntityMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewWeb2EntityMutation, UploadNewWeb2EntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewWeb2EntityMutation, UploadNewWeb2EntityMutationVariables>(UploadNewWeb2EntityDocument, options);
      }
export type UploadNewWeb2EntityMutationHookResult = ReturnType<typeof useUploadNewWeb2EntityMutation>;
export type UploadNewWeb2EntityMutationResult = Apollo.MutationResult<UploadNewWeb2EntityMutation>;
export type UploadNewWeb2EntityMutationOptions = Apollo.BaseMutationOptions<UploadNewWeb2EntityMutation, UploadNewWeb2EntityMutationVariables>;
export const UploadNewOrganizationDocument = gql`
    mutation UploadNewOrganization($upload_new_organization_input: UploadNewOrganizationInput!) {
  upload_new_organization(
    upload_new_organization_input: $upload_new_organization_input
  ) {
    organization_id
  }
}
    `;
export type UploadNewOrganizationMutationFn = Apollo.MutationFunction<UploadNewOrganizationMutation, UploadNewOrganizationMutationVariables>;

/**
 * __useUploadNewOrganizationMutation__
 *
 * To run a mutation, you first call `useUploadNewOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewOrganizationMutation, { data, loading, error }] = useUploadNewOrganizationMutation({
 *   variables: {
 *      upload_new_organization_input: // value for 'upload_new_organization_input'
 *   },
 * });
 */
export function useUploadNewOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewOrganizationMutation, UploadNewOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewOrganizationMutation, UploadNewOrganizationMutationVariables>(UploadNewOrganizationDocument, options);
      }
export type UploadNewOrganizationMutationHookResult = ReturnType<typeof useUploadNewOrganizationMutation>;
export type UploadNewOrganizationMutationResult = Apollo.MutationResult<UploadNewOrganizationMutation>;
export type UploadNewOrganizationMutationOptions = Apollo.BaseMutationOptions<UploadNewOrganizationMutation, UploadNewOrganizationMutationVariables>;
export const UploadNewTagDocument = gql`
    mutation UploadNewTag($tag_name: String, $org_id: uuid, $is_internal: Boolean, $created_by: String, $description: String) {
  insert_tags_one(
    object: {name: $tag_name, organization_id: $org_id, is_internal: $is_internal, created_by: $created_by, description: $description}
    on_conflict: {constraint: tags_name_organization_id_key, update_columns: []}
  ) {
    id
  }
}
    `;
export type UploadNewTagMutationFn = Apollo.MutationFunction<UploadNewTagMutation, UploadNewTagMutationVariables>;

/**
 * __useUploadNewTagMutation__
 *
 * To run a mutation, you first call `useUploadNewTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewTagMutation, { data, loading, error }] = useUploadNewTagMutation({
 *   variables: {
 *      tag_name: // value for 'tag_name'
 *      org_id: // value for 'org_id'
 *      is_internal: // value for 'is_internal'
 *      created_by: // value for 'created_by'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUploadNewTagMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewTagMutation, UploadNewTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewTagMutation, UploadNewTagMutationVariables>(UploadNewTagDocument, options);
      }
export type UploadNewTagMutationHookResult = ReturnType<typeof useUploadNewTagMutation>;
export type UploadNewTagMutationResult = Apollo.MutationResult<UploadNewTagMutation>;
export type UploadNewTagMutationOptions = Apollo.BaseMutationOptions<UploadNewTagMutation, UploadNewTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($tag_id: uuid, $new_name: String, $new_description: String, $new_is_internal: Boolean) {
  update_tags(
    where: {id: {_eq: $tag_id}}
    _set: {name: $new_name, description: $new_description, is_internal: $new_is_internal}
  ) {
    returning {
      name
      description
      is_internal
    }
  }
}
    `;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      tag_id: // value for 'tag_id'
 *      new_name: // value for 'new_name'
 *      new_description: // value for 'new_description'
 *      new_is_internal: // value for 'new_is_internal'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const UploadNewNftMarketplaceCollectionDocument = gql`
    mutation UploadNewNftMarketplaceCollection($organization_id: String!, $collection_slugs: [String!]!) {
  upload_new_nft_marketplace_collection(
    upload_new_nft_marketplace_collection_input: {organization_id: $organization_id, collection_slugs: $collection_slugs}
  ) {
    collections {
      id
      slug
    }
  }
}
    `;
export type UploadNewNftMarketplaceCollectionMutationFn = Apollo.MutationFunction<UploadNewNftMarketplaceCollectionMutation, UploadNewNftMarketplaceCollectionMutationVariables>;

/**
 * __useUploadNewNftMarketplaceCollectionMutation__
 *
 * To run a mutation, you first call `useUploadNewNftMarketplaceCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewNftMarketplaceCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewNftMarketplaceCollectionMutation, { data, loading, error }] = useUploadNewNftMarketplaceCollectionMutation({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      collection_slugs: // value for 'collection_slugs'
 *   },
 * });
 */
export function useUploadNewNftMarketplaceCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewNftMarketplaceCollectionMutation, UploadNewNftMarketplaceCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewNftMarketplaceCollectionMutation, UploadNewNftMarketplaceCollectionMutationVariables>(UploadNewNftMarketplaceCollectionDocument, options);
      }
export type UploadNewNftMarketplaceCollectionMutationHookResult = ReturnType<typeof useUploadNewNftMarketplaceCollectionMutation>;
export type UploadNewNftMarketplaceCollectionMutationResult = Apollo.MutationResult<UploadNewNftMarketplaceCollectionMutation>;
export type UploadNewNftMarketplaceCollectionMutationOptions = Apollo.BaseMutationOptions<UploadNewNftMarketplaceCollectionMutation, UploadNewNftMarketplaceCollectionMutationVariables>;
export const UploadNewNftCustomerCollectionDocument = gql`
    mutation UploadNewNftCustomerCollection($organization_id: uuid!, $collection_name: String!, $collection_image_url: String, $keywords: jsonb, $images: jsonb) {
  upload_new_nft_customer_collection(
    upload_new_nft_customer_collection_input: {organization_id: $organization_id, collection_name: $collection_name, collection_image_url: $collection_image_url, keywords: $keywords, images: $images}
  ) {
    collection_id
    asset_ids
  }
}
    `;
export type UploadNewNftCustomerCollectionMutationFn = Apollo.MutationFunction<UploadNewNftCustomerCollectionMutation, UploadNewNftCustomerCollectionMutationVariables>;

/**
 * __useUploadNewNftCustomerCollectionMutation__
 *
 * To run a mutation, you first call `useUploadNewNftCustomerCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewNftCustomerCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewNftCustomerCollectionMutation, { data, loading, error }] = useUploadNewNftCustomerCollectionMutation({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      collection_name: // value for 'collection_name'
 *      collection_image_url: // value for 'collection_image_url'
 *      keywords: // value for 'keywords'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useUploadNewNftCustomerCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewNftCustomerCollectionMutation, UploadNewNftCustomerCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewNftCustomerCollectionMutation, UploadNewNftCustomerCollectionMutationVariables>(UploadNewNftCustomerCollectionDocument, options);
      }
export type UploadNewNftCustomerCollectionMutationHookResult = ReturnType<typeof useUploadNewNftCustomerCollectionMutation>;
export type UploadNewNftCustomerCollectionMutationResult = Apollo.MutationResult<UploadNewNftCustomerCollectionMutation>;
export type UploadNewNftCustomerCollectionMutationOptions = Apollo.BaseMutationOptions<UploadNewNftCustomerCollectionMutation, UploadNewNftCustomerCollectionMutationVariables>;
export const UploadNewReportDocument = gql`
    mutation UploadNewReport($url: String!, $brand_id: uuid, $organization_id: uuid!, $is_customer_sourced: Boolean!, $notes: String) {
  upload_new_report_action(
    upload_new_report_input: {url: $url, brand_id: $brand_id, organization_id: $organization_id, is_customer_sourced: $is_customer_sourced, notes: $notes}
  ) {
    report {
      id
      flagged_url
      platform_name
      product
      status
      classification
      brand_name
      is_existing
      notes
    }
    error {
      flagged_url
      reason
    }
  }
}
    `;
export type UploadNewReportMutationFn = Apollo.MutationFunction<UploadNewReportMutation, UploadNewReportMutationVariables>;

/**
 * __useUploadNewReportMutation__
 *
 * To run a mutation, you first call `useUploadNewReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewReportMutation, { data, loading, error }] = useUploadNewReportMutation({
 *   variables: {
 *      url: // value for 'url'
 *      brand_id: // value for 'brand_id'
 *      organization_id: // value for 'organization_id'
 *      is_customer_sourced: // value for 'is_customer_sourced'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUploadNewReportMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewReportMutation, UploadNewReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewReportMutation, UploadNewReportMutationVariables>(UploadNewReportDocument, options);
      }
export type UploadNewReportMutationHookResult = ReturnType<typeof useUploadNewReportMutation>;
export type UploadNewReportMutationResult = Apollo.MutationResult<UploadNewReportMutation>;
export type UploadNewReportMutationOptions = Apollo.BaseMutationOptions<UploadNewReportMutation, UploadNewReportMutationVariables>;
export const UploadNewAlertDocument = gql`
    mutation UploadNewAlert($entity_value: String!, $organization_id: uuid!, $brand_id: uuid, $is_customer_sourced: Boolean!, $notes: String) {
  upload_new_alert_action(
    upload_new_alert_input: {entity_value: $entity_value, organization_id: $organization_id, brand_id: $brand_id, is_customer_sourced: $is_customer_sourced, notes: $notes}
  ) {
    alert {
      id
      entity_value
      platform_name
      product
      queue_state
      classification
      brand_name
      is_existing
      notes
    }
    error {
      entity_value
      reason
    }
  }
}
    `;
export type UploadNewAlertMutationFn = Apollo.MutationFunction<UploadNewAlertMutation, UploadNewAlertMutationVariables>;

/**
 * __useUploadNewAlertMutation__
 *
 * To run a mutation, you first call `useUploadNewAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewAlertMutation, { data, loading, error }] = useUploadNewAlertMutation({
 *   variables: {
 *      entity_value: // value for 'entity_value'
 *      organization_id: // value for 'organization_id'
 *      brand_id: // value for 'brand_id'
 *      is_customer_sourced: // value for 'is_customer_sourced'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUploadNewAlertMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewAlertMutation, UploadNewAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewAlertMutation, UploadNewAlertMutationVariables>(UploadNewAlertDocument, options);
      }
export type UploadNewAlertMutationHookResult = ReturnType<typeof useUploadNewAlertMutation>;
export type UploadNewAlertMutationResult = Apollo.MutationResult<UploadNewAlertMutation>;
export type UploadNewAlertMutationOptions = Apollo.BaseMutationOptions<UploadNewAlertMutation, UploadNewAlertMutationVariables>;
export const UploadNewProtectedAssetDocument = gql`
    mutation UploadNewProtectedAsset($unsanitized_url: String!, $brand_id: String!, $is_primary: Boolean!, $similarity_threshold: Int, $should_monitor: Boolean!) {
  upload_new_protected_asset(
    upload_new_protected_asset_input: {unsanitized_url: $unsanitized_url, brand_id: $brand_id, is_primary: $is_primary, similarity_threshold: $similarity_threshold, should_monitor: $should_monitor}
  ) {
    id
  }
}
    `;
export type UploadNewProtectedAssetMutationFn = Apollo.MutationFunction<UploadNewProtectedAssetMutation, UploadNewProtectedAssetMutationVariables>;

/**
 * __useUploadNewProtectedAssetMutation__
 *
 * To run a mutation, you first call `useUploadNewProtectedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewProtectedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewProtectedAssetMutation, { data, loading, error }] = useUploadNewProtectedAssetMutation({
 *   variables: {
 *      unsanitized_url: // value for 'unsanitized_url'
 *      brand_id: // value for 'brand_id'
 *      is_primary: // value for 'is_primary'
 *      similarity_threshold: // value for 'similarity_threshold'
 *      should_monitor: // value for 'should_monitor'
 *   },
 * });
 */
export function useUploadNewProtectedAssetMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewProtectedAssetMutation, UploadNewProtectedAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewProtectedAssetMutation, UploadNewProtectedAssetMutationVariables>(UploadNewProtectedAssetDocument, options);
      }
export type UploadNewProtectedAssetMutationHookResult = ReturnType<typeof useUploadNewProtectedAssetMutation>;
export type UploadNewProtectedAssetMutationResult = Apollo.MutationResult<UploadNewProtectedAssetMutation>;
export type UploadNewProtectedAssetMutationOptions = Apollo.BaseMutationOptions<UploadNewProtectedAssetMutation, UploadNewProtectedAssetMutationVariables>;
export const UploadSafelistItemDocument = gql`
    mutation UploadSafelistItem($unsanitized_url: String!, $brand_ids: [uuid!], $organization_id: uuid!) {
  manage_safelist(
    manage_safelist_input: {unsanitized_input: $unsanitized_url, brand_ids: $brand_ids, organization_id: $organization_id, request_type: "create"}
  ) {
    id
  }
}
    `;
export type UploadSafelistItemMutationFn = Apollo.MutationFunction<UploadSafelistItemMutation, UploadSafelistItemMutationVariables>;

/**
 * __useUploadSafelistItemMutation__
 *
 * To run a mutation, you first call `useUploadSafelistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSafelistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSafelistItemMutation, { data, loading, error }] = useUploadSafelistItemMutation({
 *   variables: {
 *      unsanitized_url: // value for 'unsanitized_url'
 *      brand_ids: // value for 'brand_ids'
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useUploadSafelistItemMutation(baseOptions?: Apollo.MutationHookOptions<UploadSafelistItemMutation, UploadSafelistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadSafelistItemMutation, UploadSafelistItemMutationVariables>(UploadSafelistItemDocument, options);
      }
export type UploadSafelistItemMutationHookResult = ReturnType<typeof useUploadSafelistItemMutation>;
export type UploadSafelistItemMutationResult = Apollo.MutationResult<UploadSafelistItemMutation>;
export type UploadSafelistItemMutationOptions = Apollo.BaseMutationOptions<UploadSafelistItemMutation, UploadSafelistItemMutationVariables>;
export const ManageTrademarksDocument = gql`
    mutation ManageTrademarks($manage_trademarks_input: ManageTrademarksInput!) {
  manage_trademarks(manage_trademarks_input: $manage_trademarks_input) {
    trademark_id
  }
}
    `;
export type ManageTrademarksMutationFn = Apollo.MutationFunction<ManageTrademarksMutation, ManageTrademarksMutationVariables>;

/**
 * __useManageTrademarksMutation__
 *
 * To run a mutation, you first call `useManageTrademarksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageTrademarksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageTrademarksMutation, { data, loading, error }] = useManageTrademarksMutation({
 *   variables: {
 *      manage_trademarks_input: // value for 'manage_trademarks_input'
 *   },
 * });
 */
export function useManageTrademarksMutation(baseOptions?: Apollo.MutationHookOptions<ManageTrademarksMutation, ManageTrademarksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageTrademarksMutation, ManageTrademarksMutationVariables>(ManageTrademarksDocument, options);
      }
export type ManageTrademarksMutationHookResult = ReturnType<typeof useManageTrademarksMutation>;
export type ManageTrademarksMutationResult = Apollo.MutationResult<ManageTrademarksMutation>;
export type ManageTrademarksMutationOptions = Apollo.BaseMutationOptions<ManageTrademarksMutation, ManageTrademarksMutationVariables>;
export const UploadNewDetectionAssetDocument = gql`
    mutation UploadNewDetectionAsset($brand_id: String!, $value: String!, $type: String!, $enabled_usage: String!, $idempotency_key: String!, $description: String, $is_generic_override: Boolean, $ir_to_dr_rule_override: String) {
  upload_new_detection_asset(
    upload_new_detection_asset_input: {brand_id: $brand_id, value: $value, type: $type, enabled_usage: $enabled_usage, idempotency_key: $idempotency_key, description: $description, is_generic_override: $is_generic_override, ir_to_dr_rule_override: $ir_to_dr_rule_override}
  ) {
    id
  }
}
    `;
export type UploadNewDetectionAssetMutationFn = Apollo.MutationFunction<UploadNewDetectionAssetMutation, UploadNewDetectionAssetMutationVariables>;

/**
 * __useUploadNewDetectionAssetMutation__
 *
 * To run a mutation, you first call `useUploadNewDetectionAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewDetectionAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewDetectionAssetMutation, { data, loading, error }] = useUploadNewDetectionAssetMutation({
 *   variables: {
 *      brand_id: // value for 'brand_id'
 *      value: // value for 'value'
 *      type: // value for 'type'
 *      enabled_usage: // value for 'enabled_usage'
 *      idempotency_key: // value for 'idempotency_key'
 *      description: // value for 'description'
 *      is_generic_override: // value for 'is_generic_override'
 *      ir_to_dr_rule_override: // value for 'ir_to_dr_rule_override'
 *   },
 * });
 */
export function useUploadNewDetectionAssetMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewDetectionAssetMutation, UploadNewDetectionAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewDetectionAssetMutation, UploadNewDetectionAssetMutationVariables>(UploadNewDetectionAssetDocument, options);
      }
export type UploadNewDetectionAssetMutationHookResult = ReturnType<typeof useUploadNewDetectionAssetMutation>;
export type UploadNewDetectionAssetMutationResult = Apollo.MutationResult<UploadNewDetectionAssetMutation>;
export type UploadNewDetectionAssetMutationOptions = Apollo.BaseMutationOptions<UploadNewDetectionAssetMutation, UploadNewDetectionAssetMutationVariables>;
export const UploadNewEnforcementTemplateDocument = gql`
    mutation UploadNewEnforcementTemplate($enforcement_type: String!, $platform: String!, $template_body: String!, $stage: String!) {
  upload_new_enforcement_template(
    upload_new_enforcement_template_input: {enforcement_type: $enforcement_type, platform: $platform, template_body: $template_body, stage: $stage}
  ) {
    platform
    template_body
    type
    stage
  }
}
    `;
export type UploadNewEnforcementTemplateMutationFn = Apollo.MutationFunction<UploadNewEnforcementTemplateMutation, UploadNewEnforcementTemplateMutationVariables>;

/**
 * __useUploadNewEnforcementTemplateMutation__
 *
 * To run a mutation, you first call `useUploadNewEnforcementTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewEnforcementTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewEnforcementTemplateMutation, { data, loading, error }] = useUploadNewEnforcementTemplateMutation({
 *   variables: {
 *      enforcement_type: // value for 'enforcement_type'
 *      platform: // value for 'platform'
 *      template_body: // value for 'template_body'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useUploadNewEnforcementTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewEnforcementTemplateMutation, UploadNewEnforcementTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewEnforcementTemplateMutation, UploadNewEnforcementTemplateMutationVariables>(UploadNewEnforcementTemplateDocument, options);
      }
export type UploadNewEnforcementTemplateMutationHookResult = ReturnType<typeof useUploadNewEnforcementTemplateMutation>;
export type UploadNewEnforcementTemplateMutationResult = Apollo.MutationResult<UploadNewEnforcementTemplateMutation>;
export type UploadNewEnforcementTemplateMutationOptions = Apollo.BaseMutationOptions<UploadNewEnforcementTemplateMutation, UploadNewEnforcementTemplateMutationVariables>;
export const UpdateSuggestedEnforcementDocument = gql`
    mutation UpdateSuggestedEnforcement($id: uuid!, $selected_platform_name: String!, $provider_name: String!, $status: String!, $allowed_enforcement_methods: jsonb!, $selected_method: jsonb!, $selected_platform_selection_method: String!, $updated_by: uuid!, $protected_content: String, $flagged_content: String, $unfilled_suggested_template: String, $suggested_template_fields: jsonb, $additional_template_info: String) {
  update_suggested_enforcements(
    _set: {selected_platform_name: $selected_platform_name, provider_name: $provider_name, status: $status, allowed_enforcement_methods: $allowed_enforcement_methods, selected_method: $selected_method, selected_platform_selection_method: $selected_platform_selection_method, updated_by: $updated_by, protected_content: $protected_content, flagged_content: $flagged_content, unfilled_suggested_template: $unfilled_suggested_template, suggested_template_fields: $suggested_template_fields, additional_template_info: $additional_template_info}
    where: {id: {_eq: $id}}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type UpdateSuggestedEnforcementMutationFn = Apollo.MutationFunction<UpdateSuggestedEnforcementMutation, UpdateSuggestedEnforcementMutationVariables>;

/**
 * __useUpdateSuggestedEnforcementMutation__
 *
 * To run a mutation, you first call `useUpdateSuggestedEnforcementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSuggestedEnforcementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSuggestedEnforcementMutation, { data, loading, error }] = useUpdateSuggestedEnforcementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      selected_platform_name: // value for 'selected_platform_name'
 *      provider_name: // value for 'provider_name'
 *      status: // value for 'status'
 *      allowed_enforcement_methods: // value for 'allowed_enforcement_methods'
 *      selected_method: // value for 'selected_method'
 *      selected_platform_selection_method: // value for 'selected_platform_selection_method'
 *      updated_by: // value for 'updated_by'
 *      protected_content: // value for 'protected_content'
 *      flagged_content: // value for 'flagged_content'
 *      unfilled_suggested_template: // value for 'unfilled_suggested_template'
 *      suggested_template_fields: // value for 'suggested_template_fields'
 *      additional_template_info: // value for 'additional_template_info'
 *   },
 * });
 */
export function useUpdateSuggestedEnforcementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSuggestedEnforcementMutation, UpdateSuggestedEnforcementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSuggestedEnforcementMutation, UpdateSuggestedEnforcementMutationVariables>(UpdateSuggestedEnforcementDocument, options);
      }
export type UpdateSuggestedEnforcementMutationHookResult = ReturnType<typeof useUpdateSuggestedEnforcementMutation>;
export type UpdateSuggestedEnforcementMutationResult = Apollo.MutationResult<UpdateSuggestedEnforcementMutation>;
export type UpdateSuggestedEnforcementMutationOptions = Apollo.BaseMutationOptions<UpdateSuggestedEnforcementMutation, UpdateSuggestedEnforcementMutationVariables>;
export const CheckEnforcementPlatformTypeByMatchStringDocument = gql`
    query CheckEnforcementPlatformTypeByMatchString($match_string: jsonb!) {
  enforcement_platforms(
    where: {match_strings: {_contains: $match_string}, enforcement_categories: {stage: {_eq: "initial"}}, types: {_contained_in: ["shortener", "builder"]}}
    limit: 1
  ) {
    name
    types
  }
}
    `;

/**
 * __useCheckEnforcementPlatformTypeByMatchStringQuery__
 *
 * To run a query within a React component, call `useCheckEnforcementPlatformTypeByMatchStringQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEnforcementPlatformTypeByMatchStringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEnforcementPlatformTypeByMatchStringQuery({
 *   variables: {
 *      match_string: // value for 'match_string'
 *   },
 * });
 */
export function useCheckEnforcementPlatformTypeByMatchStringQuery(baseOptions: Apollo.QueryHookOptions<CheckEnforcementPlatformTypeByMatchStringQuery, CheckEnforcementPlatformTypeByMatchStringQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckEnforcementPlatformTypeByMatchStringQuery, CheckEnforcementPlatformTypeByMatchStringQueryVariables>(CheckEnforcementPlatformTypeByMatchStringDocument, options);
      }
export function useCheckEnforcementPlatformTypeByMatchStringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckEnforcementPlatformTypeByMatchStringQuery, CheckEnforcementPlatformTypeByMatchStringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckEnforcementPlatformTypeByMatchStringQuery, CheckEnforcementPlatformTypeByMatchStringQueryVariables>(CheckEnforcementPlatformTypeByMatchStringDocument, options);
        }
export type CheckEnforcementPlatformTypeByMatchStringQueryHookResult = ReturnType<typeof useCheckEnforcementPlatformTypeByMatchStringQuery>;
export type CheckEnforcementPlatformTypeByMatchStringLazyQueryHookResult = ReturnType<typeof useCheckEnforcementPlatformTypeByMatchStringLazyQuery>;
export type CheckEnforcementPlatformTypeByMatchStringQueryResult = Apollo.QueryResult<CheckEnforcementPlatformTypeByMatchStringQuery, CheckEnforcementPlatformTypeByMatchStringQueryVariables>;
export const GenerateSuggestedEnforcementsDocument = gql`
    mutation GenerateSuggestedEnforcements($generate_suggested_enforcements_input: GenerateSuggestedEnforcementsInput!) {
  generate_suggested_enforcements(
    generate_suggested_enforcements_input: $generate_suggested_enforcements_input
  ) {
    generated_suggested_enforcements
  }
}
    `;
export type GenerateSuggestedEnforcementsMutationFn = Apollo.MutationFunction<GenerateSuggestedEnforcementsMutation, GenerateSuggestedEnforcementsMutationVariables>;

/**
 * __useGenerateSuggestedEnforcementsMutation__
 *
 * To run a mutation, you first call `useGenerateSuggestedEnforcementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSuggestedEnforcementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSuggestedEnforcementsMutation, { data, loading, error }] = useGenerateSuggestedEnforcementsMutation({
 *   variables: {
 *      generate_suggested_enforcements_input: // value for 'generate_suggested_enforcements_input'
 *   },
 * });
 */
export function useGenerateSuggestedEnforcementsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSuggestedEnforcementsMutation, GenerateSuggestedEnforcementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSuggestedEnforcementsMutation, GenerateSuggestedEnforcementsMutationVariables>(GenerateSuggestedEnforcementsDocument, options);
      }
export type GenerateSuggestedEnforcementsMutationHookResult = ReturnType<typeof useGenerateSuggestedEnforcementsMutation>;
export type GenerateSuggestedEnforcementsMutationResult = Apollo.MutationResult<GenerateSuggestedEnforcementsMutation>;
export type GenerateSuggestedEnforcementsMutationOptions = Apollo.BaseMutationOptions<GenerateSuggestedEnforcementsMutation, GenerateSuggestedEnforcementsMutationVariables>;
export const UpsertNewPlatformDocument = gql`
    mutation UpsertNewPlatform($name: String!, $product: platform_type!, $platform_domains: jsonb!, $custom_urls_to_product: jsonb!) {
  insert_platforms(
    objects: {name: $name, product: $product, platform_domains: $platform_domains, custom_urls_to_product: $custom_urls_to_product}
    on_conflict: {constraint: platforms_name_key, update_columns: [name, product, platform_domains, custom_urls_to_product]}
  ) {
    returning {
      name
      product
      custom_urls_to_product
      platform_domains
    }
  }
}
    `;
export type UpsertNewPlatformMutationFn = Apollo.MutationFunction<UpsertNewPlatformMutation, UpsertNewPlatformMutationVariables>;

/**
 * __useUpsertNewPlatformMutation__
 *
 * To run a mutation, you first call `useUpsertNewPlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNewPlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNewPlatformMutation, { data, loading, error }] = useUpsertNewPlatformMutation({
 *   variables: {
 *      name: // value for 'name'
 *      product: // value for 'product'
 *      platform_domains: // value for 'platform_domains'
 *      custom_urls_to_product: // value for 'custom_urls_to_product'
 *   },
 * });
 */
export function useUpsertNewPlatformMutation(baseOptions?: Apollo.MutationHookOptions<UpsertNewPlatformMutation, UpsertNewPlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertNewPlatformMutation, UpsertNewPlatformMutationVariables>(UpsertNewPlatformDocument, options);
      }
export type UpsertNewPlatformMutationHookResult = ReturnType<typeof useUpsertNewPlatformMutation>;
export type UpsertNewPlatformMutationResult = Apollo.MutationResult<UpsertNewPlatformMutation>;
export type UpsertNewPlatformMutationOptions = Apollo.BaseMutationOptions<UpsertNewPlatformMutation, UpsertNewPlatformMutationVariables>;
export const UploadNewPlatformDocument = gql`
    mutation UploadNewPlatform($upload_new_platform_input: UploadNewPlatformInput!) {
  upload_new_platform(upload_new_platform_input: $upload_new_platform_input) {
    name
    product
    custom_urls_to_product
    platform_domains
  }
}
    `;
export type UploadNewPlatformMutationFn = Apollo.MutationFunction<UploadNewPlatformMutation, UploadNewPlatformMutationVariables>;

/**
 * __useUploadNewPlatformMutation__
 *
 * To run a mutation, you first call `useUploadNewPlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNewPlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNewPlatformMutation, { data, loading, error }] = useUploadNewPlatformMutation({
 *   variables: {
 *      upload_new_platform_input: // value for 'upload_new_platform_input'
 *   },
 * });
 */
export function useUploadNewPlatformMutation(baseOptions?: Apollo.MutationHookOptions<UploadNewPlatformMutation, UploadNewPlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNewPlatformMutation, UploadNewPlatformMutationVariables>(UploadNewPlatformDocument, options);
      }
export type UploadNewPlatformMutationHookResult = ReturnType<typeof useUploadNewPlatformMutation>;
export type UploadNewPlatformMutationResult = Apollo.MutationResult<UploadNewPlatformMutation>;
export type UploadNewPlatformMutationOptions = Apollo.BaseMutationOptions<UploadNewPlatformMutation, UploadNewPlatformMutationVariables>;
export const SubmitAutoEnforcementRequestsDocument = gql`
    mutation SubmitAutoEnforcementRequests($submit_auto_enforcement_requests_input: SubmitAutoEnforcementRequestsInput!) {
  submit_auto_enforcement_requests(
    submit_auto_enforcement_requests_input: $submit_auto_enforcement_requests_input
  ) {
    results
  }
}
    `;
export type SubmitAutoEnforcementRequestsMutationFn = Apollo.MutationFunction<SubmitAutoEnforcementRequestsMutation, SubmitAutoEnforcementRequestsMutationVariables>;

/**
 * __useSubmitAutoEnforcementRequestsMutation__
 *
 * To run a mutation, you first call `useSubmitAutoEnforcementRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAutoEnforcementRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAutoEnforcementRequestsMutation, { data, loading, error }] = useSubmitAutoEnforcementRequestsMutation({
 *   variables: {
 *      submit_auto_enforcement_requests_input: // value for 'submit_auto_enforcement_requests_input'
 *   },
 * });
 */
export function useSubmitAutoEnforcementRequestsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAutoEnforcementRequestsMutation, SubmitAutoEnforcementRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAutoEnforcementRequestsMutation, SubmitAutoEnforcementRequestsMutationVariables>(SubmitAutoEnforcementRequestsDocument, options);
      }
export type SubmitAutoEnforcementRequestsMutationHookResult = ReturnType<typeof useSubmitAutoEnforcementRequestsMutation>;
export type SubmitAutoEnforcementRequestsMutationResult = Apollo.MutationResult<SubmitAutoEnforcementRequestsMutation>;
export type SubmitAutoEnforcementRequestsMutationOptions = Apollo.BaseMutationOptions<SubmitAutoEnforcementRequestsMutation, SubmitAutoEnforcementRequestsMutationVariables>;
export const SubmitFormAutoEnforcementRequestsDocument = gql`
    mutation SubmitFormAutoEnforcementRequests($submit_form_auto_enforcement_requests_input: SubmitFormAutoEnforcementRequestsInput!) {
  submit_form_auto_enforcement_requests(
    submit_form_auto_enforcement_requests_input: $submit_form_auto_enforcement_requests_input
  ) {
    results
  }
}
    `;
export type SubmitFormAutoEnforcementRequestsMutationFn = Apollo.MutationFunction<SubmitFormAutoEnforcementRequestsMutation, SubmitFormAutoEnforcementRequestsMutationVariables>;

/**
 * __useSubmitFormAutoEnforcementRequestsMutation__
 *
 * To run a mutation, you first call `useSubmitFormAutoEnforcementRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormAutoEnforcementRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormAutoEnforcementRequestsMutation, { data, loading, error }] = useSubmitFormAutoEnforcementRequestsMutation({
 *   variables: {
 *      submit_form_auto_enforcement_requests_input: // value for 'submit_form_auto_enforcement_requests_input'
 *   },
 * });
 */
export function useSubmitFormAutoEnforcementRequestsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFormAutoEnforcementRequestsMutation, SubmitFormAutoEnforcementRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFormAutoEnforcementRequestsMutation, SubmitFormAutoEnforcementRequestsMutationVariables>(SubmitFormAutoEnforcementRequestsDocument, options);
      }
export type SubmitFormAutoEnforcementRequestsMutationHookResult = ReturnType<typeof useSubmitFormAutoEnforcementRequestsMutation>;
export type SubmitFormAutoEnforcementRequestsMutationResult = Apollo.MutationResult<SubmitFormAutoEnforcementRequestsMutation>;
export type SubmitFormAutoEnforcementRequestsMutationOptions = Apollo.BaseMutationOptions<SubmitFormAutoEnforcementRequestsMutation, SubmitFormAutoEnforcementRequestsMutationVariables>;
export const UpdateEnforcementRequestStatusDocument = gql`
    mutation UpdateEnforcementRequestStatus($update_enforcement_request_status_input: UpdateEnforcementRequestStatusInput) {
  update_enforcement_request_status(
    update_enforcement_request_status_input: $update_enforcement_request_status_input
  ) {
    enforcement_request_id
  }
}
    `;
export type UpdateEnforcementRequestStatusMutationFn = Apollo.MutationFunction<UpdateEnforcementRequestStatusMutation, UpdateEnforcementRequestStatusMutationVariables>;

/**
 * __useUpdateEnforcementRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEnforcementRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnforcementRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnforcementRequestStatusMutation, { data, loading, error }] = useUpdateEnforcementRequestStatusMutation({
 *   variables: {
 *      update_enforcement_request_status_input: // value for 'update_enforcement_request_status_input'
 *   },
 * });
 */
export function useUpdateEnforcementRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnforcementRequestStatusMutation, UpdateEnforcementRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnforcementRequestStatusMutation, UpdateEnforcementRequestStatusMutationVariables>(UpdateEnforcementRequestStatusDocument, options);
      }
export type UpdateEnforcementRequestStatusMutationHookResult = ReturnType<typeof useUpdateEnforcementRequestStatusMutation>;
export type UpdateEnforcementRequestStatusMutationResult = Apollo.MutationResult<UpdateEnforcementRequestStatusMutation>;
export type UpdateEnforcementRequestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateEnforcementRequestStatusMutation, UpdateEnforcementRequestStatusMutationVariables>;
export const UpdateEnforcementRequestRetractionInfoDocument = gql`
    mutation UpdateEnforcementRequestRetractionInfo($id: uuid!, $retraction_description: String, $retraction_proof_url: String) {
  update_enforcement_requests(
    _set: {retraction_description: $retraction_description, retraction_proof_url: $retraction_proof_url}
    where: {id: {_eq: $id}}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type UpdateEnforcementRequestRetractionInfoMutationFn = Apollo.MutationFunction<UpdateEnforcementRequestRetractionInfoMutation, UpdateEnforcementRequestRetractionInfoMutationVariables>;

/**
 * __useUpdateEnforcementRequestRetractionInfoMutation__
 *
 * To run a mutation, you first call `useUpdateEnforcementRequestRetractionInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnforcementRequestRetractionInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnforcementRequestRetractionInfoMutation, { data, loading, error }] = useUpdateEnforcementRequestRetractionInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      retraction_description: // value for 'retraction_description'
 *      retraction_proof_url: // value for 'retraction_proof_url'
 *   },
 * });
 */
export function useUpdateEnforcementRequestRetractionInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnforcementRequestRetractionInfoMutation, UpdateEnforcementRequestRetractionInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnforcementRequestRetractionInfoMutation, UpdateEnforcementRequestRetractionInfoMutationVariables>(UpdateEnforcementRequestRetractionInfoDocument, options);
      }
export type UpdateEnforcementRequestRetractionInfoMutationHookResult = ReturnType<typeof useUpdateEnforcementRequestRetractionInfoMutation>;
export type UpdateEnforcementRequestRetractionInfoMutationResult = Apollo.MutationResult<UpdateEnforcementRequestRetractionInfoMutation>;
export type UpdateEnforcementRequestRetractionInfoMutationOptions = Apollo.BaseMutationOptions<UpdateEnforcementRequestRetractionInfoMutation, UpdateEnforcementRequestRetractionInfoMutationVariables>;
export const UploadReportFileDocument = gql`
    mutation UploadReportFile($upload_report_file_input: UploadReportFileInput!) {
  upload_report_file(upload_report_file_input: $upload_report_file_input) {
    results
  }
}
    `;
export type UploadReportFileMutationFn = Apollo.MutationFunction<UploadReportFileMutation, UploadReportFileMutationVariables>;

/**
 * __useUploadReportFileMutation__
 *
 * To run a mutation, you first call `useUploadReportFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadReportFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadReportFileMutation, { data, loading, error }] = useUploadReportFileMutation({
 *   variables: {
 *      upload_report_file_input: // value for 'upload_report_file_input'
 *   },
 * });
 */
export function useUploadReportFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadReportFileMutation, UploadReportFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadReportFileMutation, UploadReportFileMutationVariables>(UploadReportFileDocument, options);
      }
export type UploadReportFileMutationHookResult = ReturnType<typeof useUploadReportFileMutation>;
export type UploadReportFileMutationResult = Apollo.MutationResult<UploadReportFileMutation>;
export type UploadReportFileMutationOptions = Apollo.BaseMutationOptions<UploadReportFileMutation, UploadReportFileMutationVariables>;
export const UpdateSpoofingReportScreenshotDocument = gql`
    mutation UpdateSpoofingReportScreenshot($id: uuid!, $screenshot_url: String) {
  update_spoofing_reports_by_pk(
    pk_columns: {id: $id}
    _set: {screenshot_url: $screenshot_url}
  ) {
    id
  }
}
    `;
export type UpdateSpoofingReportScreenshotMutationFn = Apollo.MutationFunction<UpdateSpoofingReportScreenshotMutation, UpdateSpoofingReportScreenshotMutationVariables>;

/**
 * __useUpdateSpoofingReportScreenshotMutation__
 *
 * To run a mutation, you first call `useUpdateSpoofingReportScreenshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpoofingReportScreenshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpoofingReportScreenshotMutation, { data, loading, error }] = useUpdateSpoofingReportScreenshotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      screenshot_url: // value for 'screenshot_url'
 *   },
 * });
 */
export function useUpdateSpoofingReportScreenshotMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpoofingReportScreenshotMutation, UpdateSpoofingReportScreenshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpoofingReportScreenshotMutation, UpdateSpoofingReportScreenshotMutationVariables>(UpdateSpoofingReportScreenshotDocument, options);
      }
export type UpdateSpoofingReportScreenshotMutationHookResult = ReturnType<typeof useUpdateSpoofingReportScreenshotMutation>;
export type UpdateSpoofingReportScreenshotMutationResult = Apollo.MutationResult<UpdateSpoofingReportScreenshotMutation>;
export type UpdateSpoofingReportScreenshotMutationOptions = Apollo.BaseMutationOptions<UpdateSpoofingReportScreenshotMutation, UpdateSpoofingReportScreenshotMutationVariables>;
export const UpdateFullUrlScreenshotDocument = gql`
    mutation UpdateFullUrlScreenshot($id: uuid!, $screenshot_url: String) {
  update_full_urls_by_pk(
    pk_columns: {id: $id}
    _set: {screenshot_url: $screenshot_url}
  ) {
    id
  }
}
    `;
export type UpdateFullUrlScreenshotMutationFn = Apollo.MutationFunction<UpdateFullUrlScreenshotMutation, UpdateFullUrlScreenshotMutationVariables>;

/**
 * __useUpdateFullUrlScreenshotMutation__
 *
 * To run a mutation, you first call `useUpdateFullUrlScreenshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFullUrlScreenshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFullUrlScreenshotMutation, { data, loading, error }] = useUpdateFullUrlScreenshotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      screenshot_url: // value for 'screenshot_url'
 *   },
 * });
 */
export function useUpdateFullUrlScreenshotMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFullUrlScreenshotMutation, UpdateFullUrlScreenshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFullUrlScreenshotMutation, UpdateFullUrlScreenshotMutationVariables>(UpdateFullUrlScreenshotDocument, options);
      }
export type UpdateFullUrlScreenshotMutationHookResult = ReturnType<typeof useUpdateFullUrlScreenshotMutation>;
export type UpdateFullUrlScreenshotMutationResult = Apollo.MutationResult<UpdateFullUrlScreenshotMutation>;
export type UpdateFullUrlScreenshotMutationOptions = Apollo.BaseMutationOptions<UpdateFullUrlScreenshotMutation, UpdateFullUrlScreenshotMutationVariables>;
export const UpdateSocialMediaScreenshotDocument = gql`
    mutation UpdateSocialMediaScreenshot($id: uuid!, $screenshot_url: String) {
  update_social_media_data_by_pk(
    pk_columns: {id: $id}
    _set: {profile_image_url: $screenshot_url}
  ) {
    id
  }
}
    `;
export type UpdateSocialMediaScreenshotMutationFn = Apollo.MutationFunction<UpdateSocialMediaScreenshotMutation, UpdateSocialMediaScreenshotMutationVariables>;

/**
 * __useUpdateSocialMediaScreenshotMutation__
 *
 * To run a mutation, you first call `useUpdateSocialMediaScreenshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialMediaScreenshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialMediaScreenshotMutation, { data, loading, error }] = useUpdateSocialMediaScreenshotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      screenshot_url: // value for 'screenshot_url'
 *   },
 * });
 */
export function useUpdateSocialMediaScreenshotMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialMediaScreenshotMutation, UpdateSocialMediaScreenshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialMediaScreenshotMutation, UpdateSocialMediaScreenshotMutationVariables>(UpdateSocialMediaScreenshotDocument, options);
      }
export type UpdateSocialMediaScreenshotMutationHookResult = ReturnType<typeof useUpdateSocialMediaScreenshotMutation>;
export type UpdateSocialMediaScreenshotMutationResult = Apollo.MutationResult<UpdateSocialMediaScreenshotMutation>;
export type UpdateSocialMediaScreenshotMutationOptions = Apollo.BaseMutationOptions<UpdateSocialMediaScreenshotMutation, UpdateSocialMediaScreenshotMutationVariables>;
export const UpdateMobileAppScreenshotDocument = gql`
    mutation UpdateMobileAppScreenshot($id: uuid!, $screenshot_url: String) {
  update_mobile_apps_by_pk(
    pk_columns: {id: $id}
    _set: {screenshot_url: $screenshot_url}
  ) {
    id
  }
}
    `;
export type UpdateMobileAppScreenshotMutationFn = Apollo.MutationFunction<UpdateMobileAppScreenshotMutation, UpdateMobileAppScreenshotMutationVariables>;

/**
 * __useUpdateMobileAppScreenshotMutation__
 *
 * To run a mutation, you first call `useUpdateMobileAppScreenshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMobileAppScreenshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMobileAppScreenshotMutation, { data, loading, error }] = useUpdateMobileAppScreenshotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      screenshot_url: // value for 'screenshot_url'
 *   },
 * });
 */
export function useUpdateMobileAppScreenshotMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMobileAppScreenshotMutation, UpdateMobileAppScreenshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMobileAppScreenshotMutation, UpdateMobileAppScreenshotMutationVariables>(UpdateMobileAppScreenshotDocument, options);
      }
export type UpdateMobileAppScreenshotMutationHookResult = ReturnType<typeof useUpdateMobileAppScreenshotMutation>;
export type UpdateMobileAppScreenshotMutationResult = Apollo.MutationResult<UpdateMobileAppScreenshotMutation>;
export type UpdateMobileAppScreenshotMutationOptions = Apollo.BaseMutationOptions<UpdateMobileAppScreenshotMutation, UpdateMobileAppScreenshotMutationVariables>;
export const SpoofReportsStatusCountsDocument = gql`
    query SpoofReportsStatusCounts($spoofingReportsWhere: spoofing_reports_bool_exp!) {
  needsReview: spoofing_reports_aggregate(
    where: {_and: [$spoofingReportsWhere, {report_status: {_eq: "needs_review"}}]}
  ) {
    aggregate {
      count
    }
  }
  approvedDerivative: spoofing_reports_aggregate(
    where: {_and: [$spoofingReportsWhere, {report_status: {_eq: "approved_derivative"}}]}
  ) {
    aggregate {
      count
    }
  }
  inProgress: spoofing_reports_aggregate(
    where: {_and: [$spoofingReportsWhere, {report_status: {_eq: "needs_action"}}]}
  ) {
    aggregate {
      count
    }
  }
  archived: spoofing_reports_aggregate(
    where: {_and: [$spoofingReportsWhere, {report_status: {_eq: "archived"}}]}
  ) {
    aggregate {
      count
    }
  }
  reported: spoofing_reports_aggregate(
    where: {_and: [$spoofingReportsWhere, {report_status: {_eq: "reported"}}]}
  ) {
    aggregate {
      count
    }
  }
  resolved: spoofing_reports_aggregate(
    where: {_and: [$spoofingReportsWhere, {report_status: {_eq: "resolved"}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useSpoofReportsStatusCountsQuery__
 *
 * To run a query within a React component, call `useSpoofReportsStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpoofReportsStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpoofReportsStatusCountsQuery({
 *   variables: {
 *      spoofingReportsWhere: // value for 'spoofingReportsWhere'
 *   },
 * });
 */
export function useSpoofReportsStatusCountsQuery(baseOptions: Apollo.QueryHookOptions<SpoofReportsStatusCountsQuery, SpoofReportsStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpoofReportsStatusCountsQuery, SpoofReportsStatusCountsQueryVariables>(SpoofReportsStatusCountsDocument, options);
      }
export function useSpoofReportsStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpoofReportsStatusCountsQuery, SpoofReportsStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpoofReportsStatusCountsQuery, SpoofReportsStatusCountsQueryVariables>(SpoofReportsStatusCountsDocument, options);
        }
export type SpoofReportsStatusCountsQueryHookResult = ReturnType<typeof useSpoofReportsStatusCountsQuery>;
export type SpoofReportsStatusCountsLazyQueryHookResult = ReturnType<typeof useSpoofReportsStatusCountsLazyQuery>;
export type SpoofReportsStatusCountsQueryResult = Apollo.QueryResult<SpoofReportsStatusCountsQuery, SpoofReportsStatusCountsQueryVariables>;
export const GetFilterablePlatformsByProductDocument = gql`
    query GetFilterablePlatformsByProduct($orgId: uuid!, $products: [platform_type!]!, $reportStatuses: [String!]!) @cached(ttl: 60) {
  spoofing_reports(
    where: {platform: {product: {_in: $products}}, report_status: {_in: $reportStatuses}, organization_id: {_eq: $orgId}}
    distinct_on: type
    order_by: {type: asc}
  ) {
    id
    type
  }
}
    `;

/**
 * __useGetFilterablePlatformsByProductQuery__
 *
 * To run a query within a React component, call `useGetFilterablePlatformsByProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterablePlatformsByProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterablePlatformsByProductQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      products: // value for 'products'
 *      reportStatuses: // value for 'reportStatuses'
 *   },
 * });
 */
export function useGetFilterablePlatformsByProductQuery(baseOptions: Apollo.QueryHookOptions<GetFilterablePlatformsByProductQuery, GetFilterablePlatformsByProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterablePlatformsByProductQuery, GetFilterablePlatformsByProductQueryVariables>(GetFilterablePlatformsByProductDocument, options);
      }
export function useGetFilterablePlatformsByProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterablePlatformsByProductQuery, GetFilterablePlatformsByProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterablePlatformsByProductQuery, GetFilterablePlatformsByProductQueryVariables>(GetFilterablePlatformsByProductDocument, options);
        }
export type GetFilterablePlatformsByProductQueryHookResult = ReturnType<typeof useGetFilterablePlatformsByProductQuery>;
export type GetFilterablePlatformsByProductLazyQueryHookResult = ReturnType<typeof useGetFilterablePlatformsByProductLazyQuery>;
export type GetFilterablePlatformsByProductQueryResult = Apollo.QueryResult<GetFilterablePlatformsByProductQuery, GetFilterablePlatformsByProductQueryVariables>;
export const GetProductByPlatformDocument = gql`
    query GetProductByPlatform($platformName: String!) {
  platforms(where: {name: {_eq: $platformName}}) {
    name
    product
  }
}
    `;

/**
 * __useGetProductByPlatformQuery__
 *
 * To run a query within a React component, call `useGetProductByPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductByPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductByPlatformQuery({
 *   variables: {
 *      platformName: // value for 'platformName'
 *   },
 * });
 */
export function useGetProductByPlatformQuery(baseOptions: Apollo.QueryHookOptions<GetProductByPlatformQuery, GetProductByPlatformQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductByPlatformQuery, GetProductByPlatformQueryVariables>(GetProductByPlatformDocument, options);
      }
export function useGetProductByPlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductByPlatformQuery, GetProductByPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductByPlatformQuery, GetProductByPlatformQueryVariables>(GetProductByPlatformDocument, options);
        }
export type GetProductByPlatformQueryHookResult = ReturnType<typeof useGetProductByPlatformQuery>;
export type GetProductByPlatformLazyQueryHookResult = ReturnType<typeof useGetProductByPlatformLazyQuery>;
export type GetProductByPlatformQueryResult = Apollo.QueryResult<GetProductByPlatformQuery, GetProductByPlatformQueryVariables>;
export const GetProtectedAssetsByOrgDocument = gql`
    query GetProtectedAssetsByOrg($offset: Int, $limit: Int, $protectedAssetsWhere: protected_assets_bool_exp!, $orderBy: [protected_assets_order_by!]!) {
  protected_assets(
    where: $protectedAssetsWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    brand {
      entity_name
      id
    }
    is_primary
    mobile_app {
      title
      thumbnail_url
      link
      description
    }
    platform {
      name
      product
    }
    social_media {
      platform_name
      profile_image_url
      profile_display_name
      slug
      profile_description
    }
    last_updated_by_user {
      id
      name
      email
      is_internal
    }
    full_url {
      url
      unsanitized_url
      screenshot_url
      site_text
      site_html_url
    }
    updated_at
    created_at
    id
    is_generic
    similarity_threshold
    should_monitor
    value
  }
}
    `;

/**
 * __useGetProtectedAssetsByOrgQuery__
 *
 * To run a query within a React component, call `useGetProtectedAssetsByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProtectedAssetsByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProtectedAssetsByOrgQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      protectedAssetsWhere: // value for 'protectedAssetsWhere'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetProtectedAssetsByOrgQuery(baseOptions: Apollo.QueryHookOptions<GetProtectedAssetsByOrgQuery, GetProtectedAssetsByOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProtectedAssetsByOrgQuery, GetProtectedAssetsByOrgQueryVariables>(GetProtectedAssetsByOrgDocument, options);
      }
export function useGetProtectedAssetsByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProtectedAssetsByOrgQuery, GetProtectedAssetsByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProtectedAssetsByOrgQuery, GetProtectedAssetsByOrgQueryVariables>(GetProtectedAssetsByOrgDocument, options);
        }
export type GetProtectedAssetsByOrgQueryHookResult = ReturnType<typeof useGetProtectedAssetsByOrgQuery>;
export type GetProtectedAssetsByOrgLazyQueryHookResult = ReturnType<typeof useGetProtectedAssetsByOrgLazyQuery>;
export type GetProtectedAssetsByOrgQueryResult = Apollo.QueryResult<GetProtectedAssetsByOrgQuery, GetProtectedAssetsByOrgQueryVariables>;
export const GetCustomerAssetsByOrgDocument = gql`
    query GetCustomerAssetsByOrg($offset: Int, $limit: Int, $customerAssetsWhere: customer_assets_bool_exp!, $orderBy: [customer_assets_order_by!]!) {
  customer_assets(
    where: $customerAssetsWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    id
    organization_id
    value
    created_at
    updated_at
    last_updated_by_user_id
    user {
      id
      name
      email
      is_internal
    }
    status
    customer_assets_to_brands {
      brand_id
      brand {
        entity_name
      }
    }
    platform_subtype {
      platform
    }
  }
}
    `;

/**
 * __useGetCustomerAssetsByOrgQuery__
 *
 * To run a query within a React component, call `useGetCustomerAssetsByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAssetsByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAssetsByOrgQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      customerAssetsWhere: // value for 'customerAssetsWhere'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetCustomerAssetsByOrgQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAssetsByOrgQuery, GetCustomerAssetsByOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAssetsByOrgQuery, GetCustomerAssetsByOrgQueryVariables>(GetCustomerAssetsByOrgDocument, options);
      }
export function useGetCustomerAssetsByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAssetsByOrgQuery, GetCustomerAssetsByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAssetsByOrgQuery, GetCustomerAssetsByOrgQueryVariables>(GetCustomerAssetsByOrgDocument, options);
        }
export type GetCustomerAssetsByOrgQueryHookResult = ReturnType<typeof useGetCustomerAssetsByOrgQuery>;
export type GetCustomerAssetsByOrgLazyQueryHookResult = ReturnType<typeof useGetCustomerAssetsByOrgLazyQuery>;
export type GetCustomerAssetsByOrgQueryResult = Apollo.QueryResult<GetCustomerAssetsByOrgQuery, GetCustomerAssetsByOrgQueryVariables>;
export const GetCustomerAssetsWhereDocument = gql`
    query GetCustomerAssetsWhere($offset: Int, $limit: Int, $customerAssetsWhere: customer_assets_bool_exp!, $orderBy: [customer_assets_order_by!]!, $org_id: uuid!) {
  customer_assets(
    where: {_and: [{organization_id: {_eq: $org_id}}, $customerAssetsWhere]}
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    id
    organization_id
    value
    created_at
    updated_at
    last_updated_by_user_id
    user {
      id
      name
      email
      is_internal
    }
    status
    customer_assets_to_brands {
      brand_id
      brand {
        entity_name
      }
    }
    platform_subtype {
      platform
    }
  }
}
    `;

/**
 * __useGetCustomerAssetsWhereQuery__
 *
 * To run a query within a React component, call `useGetCustomerAssetsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAssetsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAssetsWhereQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      customerAssetsWhere: // value for 'customerAssetsWhere'
 *      orderBy: // value for 'orderBy'
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetCustomerAssetsWhereQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAssetsWhereQuery, GetCustomerAssetsWhereQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAssetsWhereQuery, GetCustomerAssetsWhereQueryVariables>(GetCustomerAssetsWhereDocument, options);
      }
export function useGetCustomerAssetsWhereLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAssetsWhereQuery, GetCustomerAssetsWhereQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAssetsWhereQuery, GetCustomerAssetsWhereQueryVariables>(GetCustomerAssetsWhereDocument, options);
        }
export type GetCustomerAssetsWhereQueryHookResult = ReturnType<typeof useGetCustomerAssetsWhereQuery>;
export type GetCustomerAssetsWhereLazyQueryHookResult = ReturnType<typeof useGetCustomerAssetsWhereLazyQuery>;
export type GetCustomerAssetsWhereQueryResult = Apollo.QueryResult<GetCustomerAssetsWhereQuery, GetCustomerAssetsWhereQueryVariables>;
export const GetCustomerAssetsCountDocument = gql`
    query GetCustomerAssetsCount($customerAssetsWhere: customer_assets_bool_exp!) {
  customer_assets_aggregate(where: $customerAssetsWhere) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCustomerAssetsCountQuery__
 *
 * To run a query within a React component, call `useGetCustomerAssetsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAssetsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAssetsCountQuery({
 *   variables: {
 *      customerAssetsWhere: // value for 'customerAssetsWhere'
 *   },
 * });
 */
export function useGetCustomerAssetsCountQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAssetsCountQuery, GetCustomerAssetsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAssetsCountQuery, GetCustomerAssetsCountQueryVariables>(GetCustomerAssetsCountDocument, options);
      }
export function useGetCustomerAssetsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAssetsCountQuery, GetCustomerAssetsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAssetsCountQuery, GetCustomerAssetsCountQueryVariables>(GetCustomerAssetsCountDocument, options);
        }
export type GetCustomerAssetsCountQueryHookResult = ReturnType<typeof useGetCustomerAssetsCountQuery>;
export type GetCustomerAssetsCountLazyQueryHookResult = ReturnType<typeof useGetCustomerAssetsCountLazyQuery>;
export type GetCustomerAssetsCountQueryResult = Apollo.QueryResult<GetCustomerAssetsCountQuery, GetCustomerAssetsCountQueryVariables>;
export const GetProtectedAssetPlatformsByOrgDocument = gql`
    query GetProtectedAssetPlatformsByOrg($organizationId: uuid) {
  protected_assets(
    distinct_on: platform_name
    where: {brand: {organization_id: {_eq: $organizationId}}}
  ) {
    platform_name
  }
}
    `;

/**
 * __useGetProtectedAssetPlatformsByOrgQuery__
 *
 * To run a query within a React component, call `useGetProtectedAssetPlatformsByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProtectedAssetPlatformsByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProtectedAssetPlatformsByOrgQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetProtectedAssetPlatformsByOrgQuery(baseOptions?: Apollo.QueryHookOptions<GetProtectedAssetPlatformsByOrgQuery, GetProtectedAssetPlatformsByOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProtectedAssetPlatformsByOrgQuery, GetProtectedAssetPlatformsByOrgQueryVariables>(GetProtectedAssetPlatformsByOrgDocument, options);
      }
export function useGetProtectedAssetPlatformsByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProtectedAssetPlatformsByOrgQuery, GetProtectedAssetPlatformsByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProtectedAssetPlatformsByOrgQuery, GetProtectedAssetPlatformsByOrgQueryVariables>(GetProtectedAssetPlatformsByOrgDocument, options);
        }
export type GetProtectedAssetPlatformsByOrgQueryHookResult = ReturnType<typeof useGetProtectedAssetPlatformsByOrgQuery>;
export type GetProtectedAssetPlatformsByOrgLazyQueryHookResult = ReturnType<typeof useGetProtectedAssetPlatformsByOrgLazyQuery>;
export type GetProtectedAssetPlatformsByOrgQueryResult = Apollo.QueryResult<GetProtectedAssetPlatformsByOrgQuery, GetProtectedAssetPlatformsByOrgQueryVariables>;
export const GetTagsDocument = gql`
    query GetTags($orgIDs: [uuid!]!, $includeGlobal: Boolean) {
  tags(
    distinct_on: name
    where: {_or: [{organization_id: {_in: $orgIDs}}, {_and: [{organization_id: {_is_null: $includeGlobal}}, {organization_id: {_is_null: true}}]}]}
    order_by: {name: asc}
  ) {
    id
    name
    created_at
    created_by
    is_internal
    organization_id
    description
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *      orgIDs: // value for 'orgIDs'
 *      includeGlobal: // value for 'includeGlobal'
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetTagsByReportDocument = gql`
    query GetTagsByReport($report_id: uuid!) {
  report_tags(where: {report_id: {_eq: $report_id}}, order_by: {tag: {name: asc}}) {
    tag_id
    tag {
      id
      name
      is_internal
      organization_id
      description
    }
  }
}
    `;

/**
 * __useGetTagsByReportQuery__
 *
 * To run a query within a React component, call `useGetTagsByReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsByReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsByReportQuery({
 *   variables: {
 *      report_id: // value for 'report_id'
 *   },
 * });
 */
export function useGetTagsByReportQuery(baseOptions: Apollo.QueryHookOptions<GetTagsByReportQuery, GetTagsByReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsByReportQuery, GetTagsByReportQueryVariables>(GetTagsByReportDocument, options);
      }
export function useGetTagsByReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsByReportQuery, GetTagsByReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsByReportQuery, GetTagsByReportQueryVariables>(GetTagsByReportDocument, options);
        }
export type GetTagsByReportQueryHookResult = ReturnType<typeof useGetTagsByReportQuery>;
export type GetTagsByReportLazyQueryHookResult = ReturnType<typeof useGetTagsByReportLazyQuery>;
export type GetTagsByReportQueryResult = Apollo.QueryResult<GetTagsByReportQuery, GetTagsByReportQueryVariables>;
export const GetRulesDocument = gql`
    query GetRules($rulesWhere: rules_bool_exp!, $offset: Int, $limit: Int, $orderBy: [rules_order_by!]!) {
  rules(where: $rulesWhere, offset: $offset, limit: $limit, order_by: $orderBy) {
    spoofing_entity {
      entity_name
    }
    id
    description
    type
    rule_expression
    brand_id
    product_type
    is_enabled
    is_realtime
    created_at
    updated_at
    created_by
    notes
  }
}
    `;

/**
 * __useGetRulesQuery__
 *
 * To run a query within a React component, call `useGetRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRulesQuery({
 *   variables: {
 *      rulesWhere: // value for 'rulesWhere'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetRulesQuery(baseOptions: Apollo.QueryHookOptions<GetRulesQuery, GetRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRulesQuery, GetRulesQueryVariables>(GetRulesDocument, options);
      }
export function useGetRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRulesQuery, GetRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRulesQuery, GetRulesQueryVariables>(GetRulesDocument, options);
        }
export type GetRulesQueryHookResult = ReturnType<typeof useGetRulesQuery>;
export type GetRulesLazyQueryHookResult = ReturnType<typeof useGetRulesLazyQuery>;
export type GetRulesQueryResult = Apollo.QueryResult<GetRulesQuery, GetRulesQueryVariables>;
export const GetRulesCountDocument = gql`
    query GetRulesCount($where: rules_bool_exp!) {
  rules_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetRulesCountQuery__
 *
 * To run a query within a React component, call `useGetRulesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRulesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRulesCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetRulesCountQuery(baseOptions: Apollo.QueryHookOptions<GetRulesCountQuery, GetRulesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRulesCountQuery, GetRulesCountQueryVariables>(GetRulesCountDocument, options);
      }
export function useGetRulesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRulesCountQuery, GetRulesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRulesCountQuery, GetRulesCountQueryVariables>(GetRulesCountDocument, options);
        }
export type GetRulesCountQueryHookResult = ReturnType<typeof useGetRulesCountQuery>;
export type GetRulesCountLazyQueryHookResult = ReturnType<typeof useGetRulesCountLazyQuery>;
export type GetRulesCountQueryResult = Apollo.QueryResult<GetRulesCountQuery, GetRulesCountQueryVariables>;
export const BatchUpdateRulesDocument = gql`
    mutation BatchUpdateRules($ids: [uuid!]!, $is_enabled: Boolean!) {
  update_rules(where: {id: {_in: $ids}}, _set: {is_enabled: $is_enabled}) {
    returning {
      id
    }
  }
}
    `;
export type BatchUpdateRulesMutationFn = Apollo.MutationFunction<BatchUpdateRulesMutation, BatchUpdateRulesMutationVariables>;

/**
 * __useBatchUpdateRulesMutation__
 *
 * To run a mutation, you first call `useBatchUpdateRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateRulesMutation, { data, loading, error }] = useBatchUpdateRulesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      is_enabled: // value for 'is_enabled'
 *   },
 * });
 */
export function useBatchUpdateRulesMutation(baseOptions?: Apollo.MutationHookOptions<BatchUpdateRulesMutation, BatchUpdateRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchUpdateRulesMutation, BatchUpdateRulesMutationVariables>(BatchUpdateRulesDocument, options);
      }
export type BatchUpdateRulesMutationHookResult = ReturnType<typeof useBatchUpdateRulesMutation>;
export type BatchUpdateRulesMutationResult = Apollo.MutationResult<BatchUpdateRulesMutation>;
export type BatchUpdateRulesMutationOptions = Apollo.BaseMutationOptions<BatchUpdateRulesMutation, BatchUpdateRulesMutationVariables>;
export const UpsertRuleDocument = gql`
    mutation UpsertRule($description: String!, $type: String!, $rule_expression: jsonb!, $product_type: String!, $is_enabled: Boolean!, $is_realtime: Boolean!, $created_by: String!, $brand_id: uuid, $notes: String) {
  insert_rules(
    objects: {brand_id: $brand_id, description: $description, type: $type, rule_expression: $rule_expression, product_type: $product_type, is_enabled: $is_enabled, is_realtime: $is_realtime, created_by: $created_by, notes: $notes}
    on_conflict: {constraint: rules_rule_expression_brand_id_product_type_key, update_columns: [description, is_enabled, is_realtime, notes]}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpsertRuleMutationFn = Apollo.MutationFunction<UpsertRuleMutation, UpsertRuleMutationVariables>;

/**
 * __useUpsertRuleMutation__
 *
 * To run a mutation, you first call `useUpsertRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRuleMutation, { data, loading, error }] = useUpsertRuleMutation({
 *   variables: {
 *      description: // value for 'description'
 *      type: // value for 'type'
 *      rule_expression: // value for 'rule_expression'
 *      product_type: // value for 'product_type'
 *      is_enabled: // value for 'is_enabled'
 *      is_realtime: // value for 'is_realtime'
 *      created_by: // value for 'created_by'
 *      brand_id: // value for 'brand_id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpsertRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpsertRuleMutation, UpsertRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertRuleMutation, UpsertRuleMutationVariables>(UpsertRuleDocument, options);
      }
export type UpsertRuleMutationHookResult = ReturnType<typeof useUpsertRuleMutation>;
export type UpsertRuleMutationResult = Apollo.MutationResult<UpsertRuleMutation>;
export type UpsertRuleMutationOptions = Apollo.BaseMutationOptions<UpsertRuleMutation, UpsertRuleMutationVariables>;
export const GetDetectionConfigApprovalsDocument = gql`
    query GetDetectionConfigApprovals($detection_config_approvals_where: detection_config_approvals_bool_exp!, $limit: Int, $offset: Int, $order_by: [detection_config_approvals_order_by!]!) {
  detection_config_approvals(
    where: $detection_config_approvals_where
    limit: $limit
    offset: $offset
    order_by: $order_by
  ) {
    id
    detection_config_id
    detection_config_type
    status
    rejection_reason
    reviewed_by
    created_at
    updated_at
    approved_at
    rules {
      spoofing_entity {
        entity_name
      }
      id
      description
      type
      rule_expression
      brand_id
      product_type
      is_enabled
      created_at
      updated_at
      created_by
      notes
    }
    sourcing_queries {
      spoofing_entity {
        entity_name
      }
      id
      brand_id
      query
      sourcer_label
      created_at
      updated_at
      created_by
      status
      notes
      force_create_report
      execution_frequency_minutes
    }
    ioc_detection_config_attribution {
      ioc_id
    }
  }
}
    `;

/**
 * __useGetDetectionConfigApprovalsQuery__
 *
 * To run a query within a React component, call `useGetDetectionConfigApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetectionConfigApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetectionConfigApprovalsQuery({
 *   variables: {
 *      detection_config_approvals_where: // value for 'detection_config_approvals_where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetDetectionConfigApprovalsQuery(baseOptions: Apollo.QueryHookOptions<GetDetectionConfigApprovalsQuery, GetDetectionConfigApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetectionConfigApprovalsQuery, GetDetectionConfigApprovalsQueryVariables>(GetDetectionConfigApprovalsDocument, options);
      }
export function useGetDetectionConfigApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetectionConfigApprovalsQuery, GetDetectionConfigApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetectionConfigApprovalsQuery, GetDetectionConfigApprovalsQueryVariables>(GetDetectionConfigApprovalsDocument, options);
        }
export type GetDetectionConfigApprovalsQueryHookResult = ReturnType<typeof useGetDetectionConfigApprovalsQuery>;
export type GetDetectionConfigApprovalsLazyQueryHookResult = ReturnType<typeof useGetDetectionConfigApprovalsLazyQuery>;
export type GetDetectionConfigApprovalsQueryResult = Apollo.QueryResult<GetDetectionConfigApprovalsQuery, GetDetectionConfigApprovalsQueryVariables>;
export const GetDetectionConfigApprovalsCountDocument = gql`
    query GetDetectionConfigApprovalsCount($where: detection_config_approvals_bool_exp!) {
  detection_config_approvals_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetDetectionConfigApprovalsCountQuery__
 *
 * To run a query within a React component, call `useGetDetectionConfigApprovalsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetectionConfigApprovalsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetectionConfigApprovalsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDetectionConfigApprovalsCountQuery(baseOptions: Apollo.QueryHookOptions<GetDetectionConfigApprovalsCountQuery, GetDetectionConfigApprovalsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetectionConfigApprovalsCountQuery, GetDetectionConfigApprovalsCountQueryVariables>(GetDetectionConfigApprovalsCountDocument, options);
      }
export function useGetDetectionConfigApprovalsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetectionConfigApprovalsCountQuery, GetDetectionConfigApprovalsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetectionConfigApprovalsCountQuery, GetDetectionConfigApprovalsCountQueryVariables>(GetDetectionConfigApprovalsCountDocument, options);
        }
export type GetDetectionConfigApprovalsCountQueryHookResult = ReturnType<typeof useGetDetectionConfigApprovalsCountQuery>;
export type GetDetectionConfigApprovalsCountLazyQueryHookResult = ReturnType<typeof useGetDetectionConfigApprovalsCountLazyQuery>;
export type GetDetectionConfigApprovalsCountQueryResult = Apollo.QueryResult<GetDetectionConfigApprovalsCountQuery, GetDetectionConfigApprovalsCountQueryVariables>;
export const UpdateDetectionConfigApprovalDocument = gql`
    mutation UpdateDetectionConfigApproval($detection_config_id: uuid!, $status: String!, $reviewed_by: uuid!, $rejection_reason: String, $approved_at: timestamptz) {
  update_detection_config_approvals(
    where: {detection_config_id: {_eq: $detection_config_id}}
    _set: {status: $status, rejection_reason: $rejection_reason, reviewed_by: $reviewed_by, approved_at: $approved_at}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateDetectionConfigApprovalMutationFn = Apollo.MutationFunction<UpdateDetectionConfigApprovalMutation, UpdateDetectionConfigApprovalMutationVariables>;

/**
 * __useUpdateDetectionConfigApprovalMutation__
 *
 * To run a mutation, you first call `useUpdateDetectionConfigApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDetectionConfigApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDetectionConfigApprovalMutation, { data, loading, error }] = useUpdateDetectionConfigApprovalMutation({
 *   variables: {
 *      detection_config_id: // value for 'detection_config_id'
 *      status: // value for 'status'
 *      reviewed_by: // value for 'reviewed_by'
 *      rejection_reason: // value for 'rejection_reason'
 *      approved_at: // value for 'approved_at'
 *   },
 * });
 */
export function useUpdateDetectionConfigApprovalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDetectionConfigApprovalMutation, UpdateDetectionConfigApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDetectionConfigApprovalMutation, UpdateDetectionConfigApprovalMutationVariables>(UpdateDetectionConfigApprovalDocument, options);
      }
export type UpdateDetectionConfigApprovalMutationHookResult = ReturnType<typeof useUpdateDetectionConfigApprovalMutation>;
export type UpdateDetectionConfigApprovalMutationResult = Apollo.MutationResult<UpdateDetectionConfigApprovalMutation>;
export type UpdateDetectionConfigApprovalMutationOptions = Apollo.BaseMutationOptions<UpdateDetectionConfigApprovalMutation, UpdateDetectionConfigApprovalMutationVariables>;
export const GetSourcingQueriesDocument = gql`
    query GetSourcingQueries($sourcingQueriesWhere: sourcing_queries_bool_exp!, $offset: Int, $limit: Int, $orderBy: [sourcing_queries_order_by!]!) {
  sourcing_queries(
    where: $sourcingQueriesWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    spoofing_entity {
      entity_name
    }
    brand_id
    query
    sourcer_label
    created_at
    updated_at
    created_by
    id
    status
    notes
    force_create_report
    execution_frequency_minutes
  }
}
    `;

/**
 * __useGetSourcingQueriesQuery__
 *
 * To run a query within a React component, call `useGetSourcingQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcingQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcingQueriesQuery({
 *   variables: {
 *      sourcingQueriesWhere: // value for 'sourcingQueriesWhere'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetSourcingQueriesQuery(baseOptions: Apollo.QueryHookOptions<GetSourcingQueriesQuery, GetSourcingQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourcingQueriesQuery, GetSourcingQueriesQueryVariables>(GetSourcingQueriesDocument, options);
      }
export function useGetSourcingQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourcingQueriesQuery, GetSourcingQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourcingQueriesQuery, GetSourcingQueriesQueryVariables>(GetSourcingQueriesDocument, options);
        }
export type GetSourcingQueriesQueryHookResult = ReturnType<typeof useGetSourcingQueriesQuery>;
export type GetSourcingQueriesLazyQueryHookResult = ReturnType<typeof useGetSourcingQueriesLazyQuery>;
export type GetSourcingQueriesQueryResult = Apollo.QueryResult<GetSourcingQueriesQuery, GetSourcingQueriesQueryVariables>;
export const GetSourcingQueriesCountDocument = gql`
    query GetSourcingQueriesCount($where: sourcing_queries_bool_exp!) {
  sourcing_queries_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSourcingQueriesCountQuery__
 *
 * To run a query within a React component, call `useGetSourcingQueriesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcingQueriesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcingQueriesCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSourcingQueriesCountQuery(baseOptions: Apollo.QueryHookOptions<GetSourcingQueriesCountQuery, GetSourcingQueriesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourcingQueriesCountQuery, GetSourcingQueriesCountQueryVariables>(GetSourcingQueriesCountDocument, options);
      }
export function useGetSourcingQueriesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourcingQueriesCountQuery, GetSourcingQueriesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourcingQueriesCountQuery, GetSourcingQueriesCountQueryVariables>(GetSourcingQueriesCountDocument, options);
        }
export type GetSourcingQueriesCountQueryHookResult = ReturnType<typeof useGetSourcingQueriesCountQuery>;
export type GetSourcingQueriesCountLazyQueryHookResult = ReturnType<typeof useGetSourcingQueriesCountLazyQuery>;
export type GetSourcingQueriesCountQueryResult = Apollo.QueryResult<GetSourcingQueriesCountQuery, GetSourcingQueriesCountQueryVariables>;
export const GetDistinctSourcingQueryCreatorsDocument = gql`
    query GetDistinctSourcingQueryCreators($where: sourcing_queries_bool_exp!) {
  distinct_creators: sourcing_queries(where: $where, distinct_on: created_by) {
    created_by
  }
}
    `;

/**
 * __useGetDistinctSourcingQueryCreatorsQuery__
 *
 * To run a query within a React component, call `useGetDistinctSourcingQueryCreatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistinctSourcingQueryCreatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistinctSourcingQueryCreatorsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDistinctSourcingQueryCreatorsQuery(baseOptions: Apollo.QueryHookOptions<GetDistinctSourcingQueryCreatorsQuery, GetDistinctSourcingQueryCreatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistinctSourcingQueryCreatorsQuery, GetDistinctSourcingQueryCreatorsQueryVariables>(GetDistinctSourcingQueryCreatorsDocument, options);
      }
export function useGetDistinctSourcingQueryCreatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistinctSourcingQueryCreatorsQuery, GetDistinctSourcingQueryCreatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistinctSourcingQueryCreatorsQuery, GetDistinctSourcingQueryCreatorsQueryVariables>(GetDistinctSourcingQueryCreatorsDocument, options);
        }
export type GetDistinctSourcingQueryCreatorsQueryHookResult = ReturnType<typeof useGetDistinctSourcingQueryCreatorsQuery>;
export type GetDistinctSourcingQueryCreatorsLazyQueryHookResult = ReturnType<typeof useGetDistinctSourcingQueryCreatorsLazyQuery>;
export type GetDistinctSourcingQueryCreatorsQueryResult = Apollo.QueryResult<GetDistinctSourcingQueryCreatorsQuery, GetDistinctSourcingQueryCreatorsQueryVariables>;
export const BatchUpdateSourcingQueryDocument = gql`
    mutation BatchUpdateSourcingQuery($ids: [uuid!]!, $status: String!, $last_updated_by: String!, $notes: String) {
  update_sourcing_queries(
    where: {id: {_in: $ids}}
    _set: {status: $status, last_updated_by: $last_updated_by, notes: $notes}
  ) {
    returning {
      id
    }
  }
}
    `;
export type BatchUpdateSourcingQueryMutationFn = Apollo.MutationFunction<BatchUpdateSourcingQueryMutation, BatchUpdateSourcingQueryMutationVariables>;

/**
 * __useBatchUpdateSourcingQueryMutation__
 *
 * To run a mutation, you first call `useBatchUpdateSourcingQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateSourcingQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateSourcingQueryMutation, { data, loading, error }] = useBatchUpdateSourcingQueryMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *      last_updated_by: // value for 'last_updated_by'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useBatchUpdateSourcingQueryMutation(baseOptions?: Apollo.MutationHookOptions<BatchUpdateSourcingQueryMutation, BatchUpdateSourcingQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchUpdateSourcingQueryMutation, BatchUpdateSourcingQueryMutationVariables>(BatchUpdateSourcingQueryDocument, options);
      }
export type BatchUpdateSourcingQueryMutationHookResult = ReturnType<typeof useBatchUpdateSourcingQueryMutation>;
export type BatchUpdateSourcingQueryMutationResult = Apollo.MutationResult<BatchUpdateSourcingQueryMutation>;
export type BatchUpdateSourcingQueryMutationOptions = Apollo.BaseMutationOptions<BatchUpdateSourcingQueryMutation, BatchUpdateSourcingQueryMutationVariables>;
export const UpdateSourcingQueryForceCreateReportDocument = gql`
    mutation UpdateSourcingQueryForceCreateReport($id: uuid!, $force_create_report: Boolean!, $last_updated_by: String!) {
  update_sourcing_queries(
    where: {id: {_eq: $id}}
    _set: {force_create_report: $force_create_report, last_updated_by: $last_updated_by}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateSourcingQueryForceCreateReportMutationFn = Apollo.MutationFunction<UpdateSourcingQueryForceCreateReportMutation, UpdateSourcingQueryForceCreateReportMutationVariables>;

/**
 * __useUpdateSourcingQueryForceCreateReportMutation__
 *
 * To run a mutation, you first call `useUpdateSourcingQueryForceCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSourcingQueryForceCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSourcingQueryForceCreateReportMutation, { data, loading, error }] = useUpdateSourcingQueryForceCreateReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      force_create_report: // value for 'force_create_report'
 *      last_updated_by: // value for 'last_updated_by'
 *   },
 * });
 */
export function useUpdateSourcingQueryForceCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSourcingQueryForceCreateReportMutation, UpdateSourcingQueryForceCreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSourcingQueryForceCreateReportMutation, UpdateSourcingQueryForceCreateReportMutationVariables>(UpdateSourcingQueryForceCreateReportDocument, options);
      }
export type UpdateSourcingQueryForceCreateReportMutationHookResult = ReturnType<typeof useUpdateSourcingQueryForceCreateReportMutation>;
export type UpdateSourcingQueryForceCreateReportMutationResult = Apollo.MutationResult<UpdateSourcingQueryForceCreateReportMutation>;
export type UpdateSourcingQueryForceCreateReportMutationOptions = Apollo.BaseMutationOptions<UpdateSourcingQueryForceCreateReportMutation, UpdateSourcingQueryForceCreateReportMutationVariables>;
export const UpdateSourcingQueryExecutionFrequencyDocument = gql`
    mutation UpdateSourcingQueryExecutionFrequency($id: uuid!, $execution_frequency_minutes: Int, $last_updated_by: String!) {
  update_sourcing_queries(
    where: {id: {_eq: $id}}
    _set: {execution_frequency_minutes: $execution_frequency_minutes, last_updated_by: $last_updated_by}
  ) {
    returning {
      id
      execution_frequency_minutes
      last_updated_by
    }
  }
}
    `;
export type UpdateSourcingQueryExecutionFrequencyMutationFn = Apollo.MutationFunction<UpdateSourcingQueryExecutionFrequencyMutation, UpdateSourcingQueryExecutionFrequencyMutationVariables>;

/**
 * __useUpdateSourcingQueryExecutionFrequencyMutation__
 *
 * To run a mutation, you first call `useUpdateSourcingQueryExecutionFrequencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSourcingQueryExecutionFrequencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSourcingQueryExecutionFrequencyMutation, { data, loading, error }] = useUpdateSourcingQueryExecutionFrequencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      execution_frequency_minutes: // value for 'execution_frequency_minutes'
 *      last_updated_by: // value for 'last_updated_by'
 *   },
 * });
 */
export function useUpdateSourcingQueryExecutionFrequencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSourcingQueryExecutionFrequencyMutation, UpdateSourcingQueryExecutionFrequencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSourcingQueryExecutionFrequencyMutation, UpdateSourcingQueryExecutionFrequencyMutationVariables>(UpdateSourcingQueryExecutionFrequencyDocument, options);
      }
export type UpdateSourcingQueryExecutionFrequencyMutationHookResult = ReturnType<typeof useUpdateSourcingQueryExecutionFrequencyMutation>;
export type UpdateSourcingQueryExecutionFrequencyMutationResult = Apollo.MutationResult<UpdateSourcingQueryExecutionFrequencyMutation>;
export type UpdateSourcingQueryExecutionFrequencyMutationOptions = Apollo.BaseMutationOptions<UpdateSourcingQueryExecutionFrequencyMutation, UpdateSourcingQueryExecutionFrequencyMutationVariables>;
export const UpdateSourcingQueryNotesDocument = gql`
    mutation UpdateSourcingQueryNotes($id: uuid!, $notes: String, $last_updated_by: String!) {
  update_sourcing_queries(
    where: {id: {_eq: $id}}
    _set: {notes: $notes, last_updated_by: $last_updated_by}
  ) {
    returning {
      id
      notes
      last_updated_by
    }
  }
}
    `;
export type UpdateSourcingQueryNotesMutationFn = Apollo.MutationFunction<UpdateSourcingQueryNotesMutation, UpdateSourcingQueryNotesMutationVariables>;

/**
 * __useUpdateSourcingQueryNotesMutation__
 *
 * To run a mutation, you first call `useUpdateSourcingQueryNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSourcingQueryNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSourcingQueryNotesMutation, { data, loading, error }] = useUpdateSourcingQueryNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *      last_updated_by: // value for 'last_updated_by'
 *   },
 * });
 */
export function useUpdateSourcingQueryNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSourcingQueryNotesMutation, UpdateSourcingQueryNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSourcingQueryNotesMutation, UpdateSourcingQueryNotesMutationVariables>(UpdateSourcingQueryNotesDocument, options);
      }
export type UpdateSourcingQueryNotesMutationHookResult = ReturnType<typeof useUpdateSourcingQueryNotesMutation>;
export type UpdateSourcingQueryNotesMutationResult = Apollo.MutationResult<UpdateSourcingQueryNotesMutation>;
export type UpdateSourcingQueryNotesMutationOptions = Apollo.BaseMutationOptions<UpdateSourcingQueryNotesMutation, UpdateSourcingQueryNotesMutationVariables>;
export const UpsertSourcingQueriesDocument = gql`
    mutation UpsertSourcingQueries($brand_id: uuid = "", $sourcer_label: String = "", $query: String = "", $created_by: String = "", $last_updated_by: String = "", $status: String = "", $notes: String = "", $execution_frequency_minutes: Int) {
  insert_sourcing_queries(
    objects: {brand_id: $brand_id, query: $query, sourcer_label: $sourcer_label, created_by: $created_by, last_updated_by: $last_updated_by, status: $status, notes: $notes, execution_frequency_minutes: $execution_frequency_minutes}
  ) {
    returning {
      brand_id
      query
      sourcer_label
      created_at
      updated_at
      created_by
      id
      execution_frequency_minutes
      notes
    }
  }
}
    `;
export type UpsertSourcingQueriesMutationFn = Apollo.MutationFunction<UpsertSourcingQueriesMutation, UpsertSourcingQueriesMutationVariables>;

/**
 * __useUpsertSourcingQueriesMutation__
 *
 * To run a mutation, you first call `useUpsertSourcingQueriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSourcingQueriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSourcingQueriesMutation, { data, loading, error }] = useUpsertSourcingQueriesMutation({
 *   variables: {
 *      brand_id: // value for 'brand_id'
 *      sourcer_label: // value for 'sourcer_label'
 *      query: // value for 'query'
 *      created_by: // value for 'created_by'
 *      last_updated_by: // value for 'last_updated_by'
 *      status: // value for 'status'
 *      notes: // value for 'notes'
 *      execution_frequency_minutes: // value for 'execution_frequency_minutes'
 *   },
 * });
 */
export function useUpsertSourcingQueriesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSourcingQueriesMutation, UpsertSourcingQueriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSourcingQueriesMutation, UpsertSourcingQueriesMutationVariables>(UpsertSourcingQueriesDocument, options);
      }
export type UpsertSourcingQueriesMutationHookResult = ReturnType<typeof useUpsertSourcingQueriesMutation>;
export type UpsertSourcingQueriesMutationResult = Apollo.MutationResult<UpsertSourcingQueriesMutation>;
export type UpsertSourcingQueriesMutationOptions = Apollo.BaseMutationOptions<UpsertSourcingQueriesMutation, UpsertSourcingQueriesMutationVariables>;
export const GetDetectionAssetsDocument = gql`
    query GetDetectionAssets($detectionAssetsWhere: detection_assets_bool_exp!, $offset: Int, $limit: Int, $orderBy: [detection_assets_order_by!]!) {
  detection_assets(
    where: $detectionAssetsWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    spoofing_entity {
      entity_name
    }
    id
    original_entity_id
    value
    enabled_usage
    type
    is_valid
    is_generic
    created_at
    ir_to_dr_rule
    description
    full_url {
      url
    }
    originator_id
    originator_type
    creation_method
    updated_at
  }
}
    `;

/**
 * __useGetDetectionAssetsQuery__
 *
 * To run a query within a React component, call `useGetDetectionAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetectionAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetectionAssetsQuery({
 *   variables: {
 *      detectionAssetsWhere: // value for 'detectionAssetsWhere'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetDetectionAssetsQuery(baseOptions: Apollo.QueryHookOptions<GetDetectionAssetsQuery, GetDetectionAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetectionAssetsQuery, GetDetectionAssetsQueryVariables>(GetDetectionAssetsDocument, options);
      }
export function useGetDetectionAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetectionAssetsQuery, GetDetectionAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetectionAssetsQuery, GetDetectionAssetsQueryVariables>(GetDetectionAssetsDocument, options);
        }
export type GetDetectionAssetsQueryHookResult = ReturnType<typeof useGetDetectionAssetsQuery>;
export type GetDetectionAssetsLazyQueryHookResult = ReturnType<typeof useGetDetectionAssetsLazyQuery>;
export type GetDetectionAssetsQueryResult = Apollo.QueryResult<GetDetectionAssetsQuery, GetDetectionAssetsQueryVariables>;
export const GetDetectionAssetsCountDocument = gql`
    query GetDetectionAssetsCount($where: detection_assets_bool_exp!) {
  detection_assets_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetDetectionAssetsCountQuery__
 *
 * To run a query within a React component, call `useGetDetectionAssetsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetectionAssetsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetectionAssetsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDetectionAssetsCountQuery(baseOptions: Apollo.QueryHookOptions<GetDetectionAssetsCountQuery, GetDetectionAssetsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetectionAssetsCountQuery, GetDetectionAssetsCountQueryVariables>(GetDetectionAssetsCountDocument, options);
      }
export function useGetDetectionAssetsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetectionAssetsCountQuery, GetDetectionAssetsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetectionAssetsCountQuery, GetDetectionAssetsCountQueryVariables>(GetDetectionAssetsCountDocument, options);
        }
export type GetDetectionAssetsCountQueryHookResult = ReturnType<typeof useGetDetectionAssetsCountQuery>;
export type GetDetectionAssetsCountLazyQueryHookResult = ReturnType<typeof useGetDetectionAssetsCountLazyQuery>;
export type GetDetectionAssetsCountQueryResult = Apollo.QueryResult<GetDetectionAssetsCountQuery, GetDetectionAssetsCountQueryVariables>;
export const UpdateDetectionAssetDocument = gql`
    mutation UpdateDetectionAsset($id: uuid!, $is_valid: Boolean, $is_generic: Boolean!, $ir_to_dr_rule: String!, $last_updated_by: String) {
  update_detection_assets(
    where: {id: {_eq: $id}}
    _set: {is_valid: $is_valid, is_generic: $is_generic, ir_to_dr_rule: $ir_to_dr_rule, last_updated_by: $last_updated_by}
  ) {
    returning {
      id
      is_valid
      is_generic
      ir_to_dr_rule
      last_updated_by
    }
  }
}
    `;
export type UpdateDetectionAssetMutationFn = Apollo.MutationFunction<UpdateDetectionAssetMutation, UpdateDetectionAssetMutationVariables>;

/**
 * __useUpdateDetectionAssetMutation__
 *
 * To run a mutation, you first call `useUpdateDetectionAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDetectionAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDetectionAssetMutation, { data, loading, error }] = useUpdateDetectionAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_valid: // value for 'is_valid'
 *      is_generic: // value for 'is_generic'
 *      ir_to_dr_rule: // value for 'ir_to_dr_rule'
 *      last_updated_by: // value for 'last_updated_by'
 *   },
 * });
 */
export function useUpdateDetectionAssetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDetectionAssetMutation, UpdateDetectionAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDetectionAssetMutation, UpdateDetectionAssetMutationVariables>(UpdateDetectionAssetDocument, options);
      }
export type UpdateDetectionAssetMutationHookResult = ReturnType<typeof useUpdateDetectionAssetMutation>;
export type UpdateDetectionAssetMutationResult = Apollo.MutationResult<UpdateDetectionAssetMutation>;
export type UpdateDetectionAssetMutationOptions = Apollo.BaseMutationOptions<UpdateDetectionAssetMutation, UpdateDetectionAssetMutationVariables>;
export const BulkUpdateDetectionAssetsDocument = gql`
    mutation BulkUpdateDetectionAssets($ids: [uuid!]!, $is_valid: Boolean, $last_updated_by: String) {
  update_detection_assets(
    where: {id: {_in: $ids}}
    _set: {is_valid: $is_valid, last_updated_by: $last_updated_by}
  ) {
    returning {
      id
      is_valid
      is_generic
      ir_to_dr_rule
      last_updated_by
    }
  }
}
    `;
export type BulkUpdateDetectionAssetsMutationFn = Apollo.MutationFunction<BulkUpdateDetectionAssetsMutation, BulkUpdateDetectionAssetsMutationVariables>;

/**
 * __useBulkUpdateDetectionAssetsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateDetectionAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateDetectionAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateDetectionAssetsMutation, { data, loading, error }] = useBulkUpdateDetectionAssetsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      is_valid: // value for 'is_valid'
 *      last_updated_by: // value for 'last_updated_by'
 *   },
 * });
 */
export function useBulkUpdateDetectionAssetsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateDetectionAssetsMutation, BulkUpdateDetectionAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateDetectionAssetsMutation, BulkUpdateDetectionAssetsMutationVariables>(BulkUpdateDetectionAssetsDocument, options);
      }
export type BulkUpdateDetectionAssetsMutationHookResult = ReturnType<typeof useBulkUpdateDetectionAssetsMutation>;
export type BulkUpdateDetectionAssetsMutationResult = Apollo.MutationResult<BulkUpdateDetectionAssetsMutation>;
export type BulkUpdateDetectionAssetsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateDetectionAssetsMutation, BulkUpdateDetectionAssetsMutationVariables>;
export const GetScrapingConfigsDocument = gql`
    query GetScrapingConfigs($scrapingConfigsWhere: scraping_configs_bool_exp!, $offset: Int, $limit: Int, $orderBy: [scraping_configs_order_by!]!) {
  scraping_configs(
    where: $scrapingConfigsWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    id
    organization_id
    config
    organization {
      name
    }
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetScrapingConfigsQuery__
 *
 * To run a query within a React component, call `useGetScrapingConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScrapingConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScrapingConfigsQuery({
 *   variables: {
 *      scrapingConfigsWhere: // value for 'scrapingConfigsWhere'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetScrapingConfigsQuery(baseOptions: Apollo.QueryHookOptions<GetScrapingConfigsQuery, GetScrapingConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScrapingConfigsQuery, GetScrapingConfigsQueryVariables>(GetScrapingConfigsDocument, options);
      }
export function useGetScrapingConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScrapingConfigsQuery, GetScrapingConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScrapingConfigsQuery, GetScrapingConfigsQueryVariables>(GetScrapingConfigsDocument, options);
        }
export type GetScrapingConfigsQueryHookResult = ReturnType<typeof useGetScrapingConfigsQuery>;
export type GetScrapingConfigsLazyQueryHookResult = ReturnType<typeof useGetScrapingConfigsLazyQuery>;
export type GetScrapingConfigsQueryResult = Apollo.QueryResult<GetScrapingConfigsQuery, GetScrapingConfigsQueryVariables>;
export const GetScrapingConfigsCountDocument = gql`
    query GetScrapingConfigsCount($where: scraping_configs_bool_exp!) {
  scraping_configs_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetScrapingConfigsCountQuery__
 *
 * To run a query within a React component, call `useGetScrapingConfigsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScrapingConfigsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScrapingConfigsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetScrapingConfigsCountQuery(baseOptions: Apollo.QueryHookOptions<GetScrapingConfigsCountQuery, GetScrapingConfigsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScrapingConfigsCountQuery, GetScrapingConfigsCountQueryVariables>(GetScrapingConfigsCountDocument, options);
      }
export function useGetScrapingConfigsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScrapingConfigsCountQuery, GetScrapingConfigsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScrapingConfigsCountQuery, GetScrapingConfigsCountQueryVariables>(GetScrapingConfigsCountDocument, options);
        }
export type GetScrapingConfigsCountQueryHookResult = ReturnType<typeof useGetScrapingConfigsCountQuery>;
export type GetScrapingConfigsCountLazyQueryHookResult = ReturnType<typeof useGetScrapingConfigsCountLazyQuery>;
export type GetScrapingConfigsCountQueryResult = Apollo.QueryResult<GetScrapingConfigsCountQuery, GetScrapingConfigsCountQueryVariables>;
export const UpsertScrapingConfigDocument = gql`
    mutation UpsertScrapingConfig($organization_id: uuid!, $config: jsonb!) {
  insert_scraping_configs(
    objects: {organization_id: $organization_id, config: $config}
    on_conflict: {constraint: scraping_configs_organization_id_key, update_columns: [config]}
  ) {
    returning {
      id
      organization_id
      config
    }
  }
}
    `;
export type UpsertScrapingConfigMutationFn = Apollo.MutationFunction<UpsertScrapingConfigMutation, UpsertScrapingConfigMutationVariables>;

/**
 * __useUpsertScrapingConfigMutation__
 *
 * To run a mutation, you first call `useUpsertScrapingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertScrapingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertScrapingConfigMutation, { data, loading, error }] = useUpsertScrapingConfigMutation({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpsertScrapingConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpsertScrapingConfigMutation, UpsertScrapingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertScrapingConfigMutation, UpsertScrapingConfigMutationVariables>(UpsertScrapingConfigDocument, options);
      }
export type UpsertScrapingConfigMutationHookResult = ReturnType<typeof useUpsertScrapingConfigMutation>;
export type UpsertScrapingConfigMutationResult = Apollo.MutationResult<UpsertScrapingConfigMutation>;
export type UpsertScrapingConfigMutationOptions = Apollo.BaseMutationOptions<UpsertScrapingConfigMutation, UpsertScrapingConfigMutationVariables>;
export const DeleteScrapingConfigDocument = gql`
    mutation DeleteScrapingConfig($id: uuid!) {
  delete_scraping_configs(where: {id: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteScrapingConfigMutationFn = Apollo.MutationFunction<DeleteScrapingConfigMutation, DeleteScrapingConfigMutationVariables>;

/**
 * __useDeleteScrapingConfigMutation__
 *
 * To run a mutation, you first call `useDeleteScrapingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScrapingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScrapingConfigMutation, { data, loading, error }] = useDeleteScrapingConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScrapingConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScrapingConfigMutation, DeleteScrapingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScrapingConfigMutation, DeleteScrapingConfigMutationVariables>(DeleteScrapingConfigDocument, options);
      }
export type DeleteScrapingConfigMutationHookResult = ReturnType<typeof useDeleteScrapingConfigMutation>;
export type DeleteScrapingConfigMutationResult = Apollo.MutationResult<DeleteScrapingConfigMutation>;
export type DeleteScrapingConfigMutationOptions = Apollo.BaseMutationOptions<DeleteScrapingConfigMutation, DeleteScrapingConfigMutationVariables>;
export const DeleteProtectedAssetsDocument = gql`
    mutation DeleteProtectedAssets($ids: [uuid!]!) {
  delete_protected_assets(where: {id: {_in: $ids}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteProtectedAssetsMutationFn = Apollo.MutationFunction<DeleteProtectedAssetsMutation, DeleteProtectedAssetsMutationVariables>;

/**
 * __useDeleteProtectedAssetsMutation__
 *
 * To run a mutation, you first call `useDeleteProtectedAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProtectedAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProtectedAssetsMutation, { data, loading, error }] = useDeleteProtectedAssetsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteProtectedAssetsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProtectedAssetsMutation, DeleteProtectedAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProtectedAssetsMutation, DeleteProtectedAssetsMutationVariables>(DeleteProtectedAssetsDocument, options);
      }
export type DeleteProtectedAssetsMutationHookResult = ReturnType<typeof useDeleteProtectedAssetsMutation>;
export type DeleteProtectedAssetsMutationResult = Apollo.MutationResult<DeleteProtectedAssetsMutation>;
export type DeleteProtectedAssetsMutationOptions = Apollo.BaseMutationOptions<DeleteProtectedAssetsMutation, DeleteProtectedAssetsMutationVariables>;
export const UpdateDesignatedTakedownAssetsStatusDocument = gql`
    mutation UpdateDesignatedTakedownAssetsStatus($designated_takedown_assets_where: [designated_takedown_assets_bool_exp!]!, $status: String) {
  update_designated_takedown_assets(
    where: {_or: $designated_takedown_assets_where}
    _set: {status: $status}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type UpdateDesignatedTakedownAssetsStatusMutationFn = Apollo.MutationFunction<UpdateDesignatedTakedownAssetsStatusMutation, UpdateDesignatedTakedownAssetsStatusMutationVariables>;

/**
 * __useUpdateDesignatedTakedownAssetsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDesignatedTakedownAssetsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDesignatedTakedownAssetsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDesignatedTakedownAssetsStatusMutation, { data, loading, error }] = useUpdateDesignatedTakedownAssetsStatusMutation({
 *   variables: {
 *      designated_takedown_assets_where: // value for 'designated_takedown_assets_where'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateDesignatedTakedownAssetsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDesignatedTakedownAssetsStatusMutation, UpdateDesignatedTakedownAssetsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDesignatedTakedownAssetsStatusMutation, UpdateDesignatedTakedownAssetsStatusMutationVariables>(UpdateDesignatedTakedownAssetsStatusDocument, options);
      }
export type UpdateDesignatedTakedownAssetsStatusMutationHookResult = ReturnType<typeof useUpdateDesignatedTakedownAssetsStatusMutation>;
export type UpdateDesignatedTakedownAssetsStatusMutationResult = Apollo.MutationResult<UpdateDesignatedTakedownAssetsStatusMutation>;
export type UpdateDesignatedTakedownAssetsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDesignatedTakedownAssetsStatusMutation, UpdateDesignatedTakedownAssetsStatusMutationVariables>;
export const DeleteDesignatedTakedownAssetsDocument = gql`
    mutation DeleteDesignatedTakedownAssets($designated_takedown_assets_where: [designated_takedown_assets_bool_exp!]!) {
  delete_designated_takedown_assets(
    where: {_or: $designated_takedown_assets_where}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type DeleteDesignatedTakedownAssetsMutationFn = Apollo.MutationFunction<DeleteDesignatedTakedownAssetsMutation, DeleteDesignatedTakedownAssetsMutationVariables>;

/**
 * __useDeleteDesignatedTakedownAssetsMutation__
 *
 * To run a mutation, you first call `useDeleteDesignatedTakedownAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDesignatedTakedownAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDesignatedTakedownAssetsMutation, { data, loading, error }] = useDeleteDesignatedTakedownAssetsMutation({
 *   variables: {
 *      designated_takedown_assets_where: // value for 'designated_takedown_assets_where'
 *   },
 * });
 */
export function useDeleteDesignatedTakedownAssetsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDesignatedTakedownAssetsMutation, DeleteDesignatedTakedownAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDesignatedTakedownAssetsMutation, DeleteDesignatedTakedownAssetsMutationVariables>(DeleteDesignatedTakedownAssetsDocument, options);
      }
export type DeleteDesignatedTakedownAssetsMutationHookResult = ReturnType<typeof useDeleteDesignatedTakedownAssetsMutation>;
export type DeleteDesignatedTakedownAssetsMutationResult = Apollo.MutationResult<DeleteDesignatedTakedownAssetsMutation>;
export type DeleteDesignatedTakedownAssetsMutationOptions = Apollo.BaseMutationOptions<DeleteDesignatedTakedownAssetsMutation, DeleteDesignatedTakedownAssetsMutationVariables>;
export const DeleteSafelistItemDocument = gql`
    mutation DeleteSafelistItem($id: uuid!, $organization_id: uuid!) {
  manage_safelist(
    manage_safelist_input: {customer_asset_id: $id, organization_id: $organization_id, request_type: "delete"}
  ) {
    id
  }
}
    `;
export type DeleteSafelistItemMutationFn = Apollo.MutationFunction<DeleteSafelistItemMutation, DeleteSafelistItemMutationVariables>;

/**
 * __useDeleteSafelistItemMutation__
 *
 * To run a mutation, you first call `useDeleteSafelistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSafelistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSafelistItemMutation, { data, loading, error }] = useDeleteSafelistItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useDeleteSafelistItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSafelistItemMutation, DeleteSafelistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSafelistItemMutation, DeleteSafelistItemMutationVariables>(DeleteSafelistItemDocument, options);
      }
export type DeleteSafelistItemMutationHookResult = ReturnType<typeof useDeleteSafelistItemMutation>;
export type DeleteSafelistItemMutationResult = Apollo.MutationResult<DeleteSafelistItemMutation>;
export type DeleteSafelistItemMutationOptions = Apollo.BaseMutationOptions<DeleteSafelistItemMutation, DeleteSafelistItemMutationVariables>;
export const DeleteTagsDocument = gql`
    mutation DeleteTags($ids: [uuid!]!) {
  delete_tags(where: {id: {_in: $ids}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteTagsMutationFn = Apollo.MutationFunction<DeleteTagsMutation, DeleteTagsMutationVariables>;

/**
 * __useDeleteTagsMutation__
 *
 * To run a mutation, you first call `useDeleteTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagsMutation, { data, loading, error }] = useDeleteTagsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteTagsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagsMutation, DeleteTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagsMutation, DeleteTagsMutationVariables>(DeleteTagsDocument, options);
      }
export type DeleteTagsMutationHookResult = ReturnType<typeof useDeleteTagsMutation>;
export type DeleteTagsMutationResult = Apollo.MutationResult<DeleteTagsMutation>;
export type DeleteTagsMutationOptions = Apollo.BaseMutationOptions<DeleteTagsMutation, DeleteTagsMutationVariables>;
export const DeleteReportTagDocument = gql`
    mutation DeleteReportTag($report_id: uuid!, $tag_id: uuid!) {
  delete_report_tags(
    where: {report_id: {_eq: $report_id}, tag_id: {_eq: $tag_id}}
  ) {
    returning {
      id
    }
  }
}
    `;
export type DeleteReportTagMutationFn = Apollo.MutationFunction<DeleteReportTagMutation, DeleteReportTagMutationVariables>;

/**
 * __useDeleteReportTagMutation__
 *
 * To run a mutation, you first call `useDeleteReportTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportTagMutation, { data, loading, error }] = useDeleteReportTagMutation({
 *   variables: {
 *      report_id: // value for 'report_id'
 *      tag_id: // value for 'tag_id'
 *   },
 * });
 */
export function useDeleteReportTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportTagMutation, DeleteReportTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportTagMutation, DeleteReportTagMutationVariables>(DeleteReportTagDocument, options);
      }
export type DeleteReportTagMutationHookResult = ReturnType<typeof useDeleteReportTagMutation>;
export type DeleteReportTagMutationResult = Apollo.MutationResult<DeleteReportTagMutation>;
export type DeleteReportTagMutationOptions = Apollo.BaseMutationOptions<DeleteReportTagMutation, DeleteReportTagMutationVariables>;
export const DeleteReportTagsDocument = gql`
    mutation DeleteReportTags($tag_ids: [uuid!]!) {
  delete_report_tags(where: {tag_id: {_in: $tag_ids}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteReportTagsMutationFn = Apollo.MutationFunction<DeleteReportTagsMutation, DeleteReportTagsMutationVariables>;

/**
 * __useDeleteReportTagsMutation__
 *
 * To run a mutation, you first call `useDeleteReportTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportTagsMutation, { data, loading, error }] = useDeleteReportTagsMutation({
 *   variables: {
 *      tag_ids: // value for 'tag_ids'
 *   },
 * });
 */
export function useDeleteReportTagsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportTagsMutation, DeleteReportTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportTagsMutation, DeleteReportTagsMutationVariables>(DeleteReportTagsDocument, options);
      }
export type DeleteReportTagsMutationHookResult = ReturnType<typeof useDeleteReportTagsMutation>;
export type DeleteReportTagsMutationResult = Apollo.MutationResult<DeleteReportTagsMutation>;
export type DeleteReportTagsMutationOptions = Apollo.BaseMutationOptions<DeleteReportTagsMutation, DeleteReportTagsMutationVariables>;
export const HandleSynchronousDetectionRequestDocument = gql`
    mutation HandleSynchronousDetectionRequest($on_demand_sourcing_brands: jsonb, $on_demand_sourcing_queries: jsonb, $create_detection_configs_for_url: jsonb, $create_detection_configs_for_ioc: jsonb, $generate_hash_for_html: jsonb, $run_detection_rule: jsonb, $publish_adhoc_candidates: jsonb) {
  handle_synchronous_detection_request(
    handle_synchronous_detection_request_input: {on_demand_sourcing_brands: $on_demand_sourcing_brands, on_demand_sourcing_queries: $on_demand_sourcing_queries, create_detection_configs_for_url: $create_detection_configs_for_url, create_detection_configs_for_ioc: $create_detection_configs_for_ioc, generate_hash_for_html: $generate_hash_for_html, run_detection_rule: $run_detection_rule, publish_adhoc_candidates: $publish_adhoc_candidates}
  ) {
    success
    response
  }
}
    `;
export type HandleSynchronousDetectionRequestMutationFn = Apollo.MutationFunction<HandleSynchronousDetectionRequestMutation, HandleSynchronousDetectionRequestMutationVariables>;

/**
 * __useHandleSynchronousDetectionRequestMutation__
 *
 * To run a mutation, you first call `useHandleSynchronousDetectionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleSynchronousDetectionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleSynchronousDetectionRequestMutation, { data, loading, error }] = useHandleSynchronousDetectionRequestMutation({
 *   variables: {
 *      on_demand_sourcing_brands: // value for 'on_demand_sourcing_brands'
 *      on_demand_sourcing_queries: // value for 'on_demand_sourcing_queries'
 *      create_detection_configs_for_url: // value for 'create_detection_configs_for_url'
 *      create_detection_configs_for_ioc: // value for 'create_detection_configs_for_ioc'
 *      generate_hash_for_html: // value for 'generate_hash_for_html'
 *      run_detection_rule: // value for 'run_detection_rule'
 *      publish_adhoc_candidates: // value for 'publish_adhoc_candidates'
 *   },
 * });
 */
export function useHandleSynchronousDetectionRequestMutation(baseOptions?: Apollo.MutationHookOptions<HandleSynchronousDetectionRequestMutation, HandleSynchronousDetectionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleSynchronousDetectionRequestMutation, HandleSynchronousDetectionRequestMutationVariables>(HandleSynchronousDetectionRequestDocument, options);
      }
export type HandleSynchronousDetectionRequestMutationHookResult = ReturnType<typeof useHandleSynchronousDetectionRequestMutation>;
export type HandleSynchronousDetectionRequestMutationResult = Apollo.MutationResult<HandleSynchronousDetectionRequestMutation>;
export type HandleSynchronousDetectionRequestMutationOptions = Apollo.BaseMutationOptions<HandleSynchronousDetectionRequestMutation, HandleSynchronousDetectionRequestMutationVariables>;
export const HandleSynchronousDetectionRequestAsyncActionDocument = gql`
    mutation HandleSynchronousDetectionRequestAsyncAction($create_detection_configs_for_url: jsonb, $run_detection_rule: jsonb) {
  handle_synchronous_detection_request_async_action(
    handle_synchronous_detection_request_input: {create_detection_configs_for_url: $create_detection_configs_for_url, run_detection_rule: $run_detection_rule}
  )
}
    `;
export type HandleSynchronousDetectionRequestAsyncActionMutationFn = Apollo.MutationFunction<HandleSynchronousDetectionRequestAsyncActionMutation, HandleSynchronousDetectionRequestAsyncActionMutationVariables>;

/**
 * __useHandleSynchronousDetectionRequestAsyncActionMutation__
 *
 * To run a mutation, you first call `useHandleSynchronousDetectionRequestAsyncActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleSynchronousDetectionRequestAsyncActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleSynchronousDetectionRequestAsyncActionMutation, { data, loading, error }] = useHandleSynchronousDetectionRequestAsyncActionMutation({
 *   variables: {
 *      create_detection_configs_for_url: // value for 'create_detection_configs_for_url'
 *      run_detection_rule: // value for 'run_detection_rule'
 *   },
 * });
 */
export function useHandleSynchronousDetectionRequestAsyncActionMutation(baseOptions?: Apollo.MutationHookOptions<HandleSynchronousDetectionRequestAsyncActionMutation, HandleSynchronousDetectionRequestAsyncActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleSynchronousDetectionRequestAsyncActionMutation, HandleSynchronousDetectionRequestAsyncActionMutationVariables>(HandleSynchronousDetectionRequestAsyncActionDocument, options);
      }
export type HandleSynchronousDetectionRequestAsyncActionMutationHookResult = ReturnType<typeof useHandleSynchronousDetectionRequestAsyncActionMutation>;
export type HandleSynchronousDetectionRequestAsyncActionMutationResult = Apollo.MutationResult<HandleSynchronousDetectionRequestAsyncActionMutation>;
export type HandleSynchronousDetectionRequestAsyncActionMutationOptions = Apollo.BaseMutationOptions<HandleSynchronousDetectionRequestAsyncActionMutation, HandleSynchronousDetectionRequestAsyncActionMutationVariables>;
export const GetPlatformsDocument = gql`
    query GetPlatforms($offset: Int, $limit: Int, $platformsWhere: platforms_bool_exp!, $orderBy: [platforms_order_by!]!) {
  platforms(
    where: $platformsWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    name
    platform_domains
    product
    custom_urls_to_product
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetPlatformsQuery__
 *
 * To run a query within a React component, call `useGetPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      platformsWhere: // value for 'platformsWhere'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPlatformsQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformsQuery, GetPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformsQuery, GetPlatformsQueryVariables>(GetPlatformsDocument, options);
      }
export function useGetPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformsQuery, GetPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformsQuery, GetPlatformsQueryVariables>(GetPlatformsDocument, options);
        }
export type GetPlatformsQueryHookResult = ReturnType<typeof useGetPlatformsQuery>;
export type GetPlatformsLazyQueryHookResult = ReturnType<typeof useGetPlatformsLazyQuery>;
export type GetPlatformsQueryResult = Apollo.QueryResult<GetPlatformsQuery, GetPlatformsQueryVariables>;
export const GetDomainDataWithDistinctRegistrarDocument = gql`
    query GetDomainDataWithDistinctRegistrar($offset: Int, $limit: Int, $domainDataWhere: domain_data_bool_exp!, $orderBy: [domain_data_order_by!]!) {
  domain_data(
    where: $domainDataWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
    distinct_on: registrar_name
  ) {
    registrar_name
  }
}
    `;

/**
 * __useGetDomainDataWithDistinctRegistrarQuery__
 *
 * To run a query within a React component, call `useGetDomainDataWithDistinctRegistrarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDomainDataWithDistinctRegistrarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDomainDataWithDistinctRegistrarQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      domainDataWhere: // value for 'domainDataWhere'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetDomainDataWithDistinctRegistrarQuery(baseOptions: Apollo.QueryHookOptions<GetDomainDataWithDistinctRegistrarQuery, GetDomainDataWithDistinctRegistrarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDomainDataWithDistinctRegistrarQuery, GetDomainDataWithDistinctRegistrarQueryVariables>(GetDomainDataWithDistinctRegistrarDocument, options);
      }
export function useGetDomainDataWithDistinctRegistrarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDomainDataWithDistinctRegistrarQuery, GetDomainDataWithDistinctRegistrarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDomainDataWithDistinctRegistrarQuery, GetDomainDataWithDistinctRegistrarQueryVariables>(GetDomainDataWithDistinctRegistrarDocument, options);
        }
export type GetDomainDataWithDistinctRegistrarQueryHookResult = ReturnType<typeof useGetDomainDataWithDistinctRegistrarQuery>;
export type GetDomainDataWithDistinctRegistrarLazyQueryHookResult = ReturnType<typeof useGetDomainDataWithDistinctRegistrarLazyQuery>;
export type GetDomainDataWithDistinctRegistrarQueryResult = Apollo.QueryResult<GetDomainDataWithDistinctRegistrarQuery, GetDomainDataWithDistinctRegistrarQueryVariables>;
export const GetDomainDataWithDistinctHostingProviderDocument = gql`
    query GetDomainDataWithDistinctHostingProvider($offset: Int, $limit: Int, $domainDataWhere: domain_data_bool_exp!, $orderBy: [domain_data_order_by!]!) {
  domain_data(
    where: $domainDataWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
    distinct_on: hosting_provider
  ) {
    hosting_provider
  }
}
    `;

/**
 * __useGetDomainDataWithDistinctHostingProviderQuery__
 *
 * To run a query within a React component, call `useGetDomainDataWithDistinctHostingProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDomainDataWithDistinctHostingProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDomainDataWithDistinctHostingProviderQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      domainDataWhere: // value for 'domainDataWhere'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetDomainDataWithDistinctHostingProviderQuery(baseOptions: Apollo.QueryHookOptions<GetDomainDataWithDistinctHostingProviderQuery, GetDomainDataWithDistinctHostingProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDomainDataWithDistinctHostingProviderQuery, GetDomainDataWithDistinctHostingProviderQueryVariables>(GetDomainDataWithDistinctHostingProviderDocument, options);
      }
export function useGetDomainDataWithDistinctHostingProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDomainDataWithDistinctHostingProviderQuery, GetDomainDataWithDistinctHostingProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDomainDataWithDistinctHostingProviderQuery, GetDomainDataWithDistinctHostingProviderQueryVariables>(GetDomainDataWithDistinctHostingProviderDocument, options);
        }
export type GetDomainDataWithDistinctHostingProviderQueryHookResult = ReturnType<typeof useGetDomainDataWithDistinctHostingProviderQuery>;
export type GetDomainDataWithDistinctHostingProviderLazyQueryHookResult = ReturnType<typeof useGetDomainDataWithDistinctHostingProviderLazyQuery>;
export type GetDomainDataWithDistinctHostingProviderQueryResult = Apollo.QueryResult<GetDomainDataWithDistinctHostingProviderQuery, GetDomainDataWithDistinctHostingProviderQueryVariables>;
export const GetEnforcementPlatformsDocument = gql`
    query GetEnforcementPlatforms($offset: Int, $limit: Int, $enforcementPlatformsWhere: enforcement_platforms_bool_exp!, $orderBy: [enforcement_platforms_order_by!]!) {
  enforcement_platforms(
    where: $enforcementPlatformsWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    name
    enforcement_types
    initial_enforcement_methods
    escalate_enforcement_methods
    match_strings
    types
    api_link
    form_link
    email
    default_timeout
    notes
    platform
    product
  }
}
    `;

/**
 * __useGetEnforcementPlatformsQuery__
 *
 * To run a query within a React component, call `useGetEnforcementPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementPlatformsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      enforcementPlatformsWhere: // value for 'enforcementPlatformsWhere'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetEnforcementPlatformsQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementPlatformsQuery, GetEnforcementPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementPlatformsQuery, GetEnforcementPlatformsQueryVariables>(GetEnforcementPlatformsDocument, options);
      }
export function useGetEnforcementPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementPlatformsQuery, GetEnforcementPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementPlatformsQuery, GetEnforcementPlatformsQueryVariables>(GetEnforcementPlatformsDocument, options);
        }
export type GetEnforcementPlatformsQueryHookResult = ReturnType<typeof useGetEnforcementPlatformsQuery>;
export type GetEnforcementPlatformsLazyQueryHookResult = ReturnType<typeof useGetEnforcementPlatformsLazyQuery>;
export type GetEnforcementPlatformsQueryResult = Apollo.QueryResult<GetEnforcementPlatformsQuery, GetEnforcementPlatformsQueryVariables>;
export const GetEnforcementPlatformsWithTypesDocument = gql`
    query GetEnforcementPlatformsWithTypes($limit: Int, $enforcementPlatformsWhere: enforcement_platforms_bool_exp!, $enforcementTypesWhere: enforcement_types_bool_exp!) {
  enforcement_platforms(where: $enforcementPlatformsWhere, limit: $limit) {
    name
    match_strings
    types
    notes
    platform
    product
    compliance_status
    enforcement_categories(where: $enforcementTypesWhere, order_by: {priority: asc}) {
      enforcement_method_data
      enforcement_method_type
      priority
    }
  }
}
    `;

/**
 * __useGetEnforcementPlatformsWithTypesQuery__
 *
 * To run a query within a React component, call `useGetEnforcementPlatformsWithTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementPlatformsWithTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementPlatformsWithTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      enforcementPlatformsWhere: // value for 'enforcementPlatformsWhere'
 *      enforcementTypesWhere: // value for 'enforcementTypesWhere'
 *   },
 * });
 */
export function useGetEnforcementPlatformsWithTypesQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementPlatformsWithTypesQuery, GetEnforcementPlatformsWithTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementPlatformsWithTypesQuery, GetEnforcementPlatformsWithTypesQueryVariables>(GetEnforcementPlatformsWithTypesDocument, options);
      }
export function useGetEnforcementPlatformsWithTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementPlatformsWithTypesQuery, GetEnforcementPlatformsWithTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementPlatformsWithTypesQuery, GetEnforcementPlatformsWithTypesQueryVariables>(GetEnforcementPlatformsWithTypesDocument, options);
        }
export type GetEnforcementPlatformsWithTypesQueryHookResult = ReturnType<typeof useGetEnforcementPlatformsWithTypesQuery>;
export type GetEnforcementPlatformsWithTypesLazyQueryHookResult = ReturnType<typeof useGetEnforcementPlatformsWithTypesLazyQuery>;
export type GetEnforcementPlatformsWithTypesQueryResult = Apollo.QueryResult<GetEnforcementPlatformsWithTypesQuery, GetEnforcementPlatformsWithTypesQueryVariables>;
export const GetEnforcementPlatformsTableDocument = gql`
    query GetEnforcementPlatformsTable($offset: Int, $limit: Int, $enforcementPlatformsWhere: enforcement_platforms_bool_exp!, $orderBy: [enforcement_platforms_order_by!]!) {
  enforcement_platforms(
    where: $enforcementPlatformsWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    name
    match_strings
    types
    email
    default_timeout
    notes
    platform
    product
    compliance_status
    enforcement_categories {
      id
      type
      platform
      enforcement_method_type
      enforcement_method_data
      content_type
      content_type_display_name
      priority
      stage
    }
  }
}
    `;

/**
 * __useGetEnforcementPlatformsTableQuery__
 *
 * To run a query within a React component, call `useGetEnforcementPlatformsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementPlatformsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementPlatformsTableQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      enforcementPlatformsWhere: // value for 'enforcementPlatformsWhere'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetEnforcementPlatformsTableQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementPlatformsTableQuery, GetEnforcementPlatformsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementPlatformsTableQuery, GetEnforcementPlatformsTableQueryVariables>(GetEnforcementPlatformsTableDocument, options);
      }
export function useGetEnforcementPlatformsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementPlatformsTableQuery, GetEnforcementPlatformsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementPlatformsTableQuery, GetEnforcementPlatformsTableQueryVariables>(GetEnforcementPlatformsTableDocument, options);
        }
export type GetEnforcementPlatformsTableQueryHookResult = ReturnType<typeof useGetEnforcementPlatformsTableQuery>;
export type GetEnforcementPlatformsTableLazyQueryHookResult = ReturnType<typeof useGetEnforcementPlatformsTableLazyQuery>;
export type GetEnforcementPlatformsTableQueryResult = Apollo.QueryResult<GetEnforcementPlatformsTableQuery, GetEnforcementPlatformsTableQueryVariables>;
export const GetSingleEnforcementPlatformDocument = gql`
    query GetSingleEnforcementPlatform($platformName: String!) {
  enforcement_platforms(
    where: {name: {_eq: $platformName}, enforcement_categories: {platform: {_eq: $platformName}}}
  ) {
    name
    match_strings
    types
    email
    default_timeout
    notes
    platform
    product
    enforcement_categories {
      id
      type
      platform
      enforcement_method_type
      enforcement_method_data
      content_type
      content_type_display_name
      priority
      stage
    }
  }
}
    `;

/**
 * __useGetSingleEnforcementPlatformQuery__
 *
 * To run a query within a React component, call `useGetSingleEnforcementPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleEnforcementPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleEnforcementPlatformQuery({
 *   variables: {
 *      platformName: // value for 'platformName'
 *   },
 * });
 */
export function useGetSingleEnforcementPlatformQuery(baseOptions: Apollo.QueryHookOptions<GetSingleEnforcementPlatformQuery, GetSingleEnforcementPlatformQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleEnforcementPlatformQuery, GetSingleEnforcementPlatformQueryVariables>(GetSingleEnforcementPlatformDocument, options);
      }
export function useGetSingleEnforcementPlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleEnforcementPlatformQuery, GetSingleEnforcementPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleEnforcementPlatformQuery, GetSingleEnforcementPlatformQueryVariables>(GetSingleEnforcementPlatformDocument, options);
        }
export type GetSingleEnforcementPlatformQueryHookResult = ReturnType<typeof useGetSingleEnforcementPlatformQuery>;
export type GetSingleEnforcementPlatformLazyQueryHookResult = ReturnType<typeof useGetSingleEnforcementPlatformLazyQuery>;
export type GetSingleEnforcementPlatformQueryResult = Apollo.QueryResult<GetSingleEnforcementPlatformQuery, GetSingleEnforcementPlatformQueryVariables>;
export const GetEnforcementPlatformsCountDocument = gql`
    query GetEnforcementPlatformsCount($enforcementPlatformsWhere: enforcement_platforms_bool_exp!) {
  enforcement_platforms_aggregate(where: $enforcementPlatformsWhere) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetEnforcementPlatformsCountQuery__
 *
 * To run a query within a React component, call `useGetEnforcementPlatformsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementPlatformsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementPlatformsCountQuery({
 *   variables: {
 *      enforcementPlatformsWhere: // value for 'enforcementPlatformsWhere'
 *   },
 * });
 */
export function useGetEnforcementPlatformsCountQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementPlatformsCountQuery, GetEnforcementPlatformsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementPlatformsCountQuery, GetEnforcementPlatformsCountQueryVariables>(GetEnforcementPlatformsCountDocument, options);
      }
export function useGetEnforcementPlatformsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementPlatformsCountQuery, GetEnforcementPlatformsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementPlatformsCountQuery, GetEnforcementPlatformsCountQueryVariables>(GetEnforcementPlatformsCountDocument, options);
        }
export type GetEnforcementPlatformsCountQueryHookResult = ReturnType<typeof useGetEnforcementPlatformsCountQuery>;
export type GetEnforcementPlatformsCountLazyQueryHookResult = ReturnType<typeof useGetEnforcementPlatformsCountLazyQuery>;
export type GetEnforcementPlatformsCountQueryResult = Apollo.QueryResult<GetEnforcementPlatformsCountQuery, GetEnforcementPlatformsCountQueryVariables>;
export const GetEnforcementPlatformNamesDocument = gql`
    query GetEnforcementPlatformNames($enforcementPlatformsWhere: enforcement_platforms_bool_exp!) {
  enforcement_platforms(where: $enforcementPlatformsWhere) {
    name
    compliance_status
  }
}
    `;

/**
 * __useGetEnforcementPlatformNamesQuery__
 *
 * To run a query within a React component, call `useGetEnforcementPlatformNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementPlatformNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementPlatformNamesQuery({
 *   variables: {
 *      enforcementPlatformsWhere: // value for 'enforcementPlatformsWhere'
 *   },
 * });
 */
export function useGetEnforcementPlatformNamesQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementPlatformNamesQuery, GetEnforcementPlatformNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementPlatformNamesQuery, GetEnforcementPlatformNamesQueryVariables>(GetEnforcementPlatformNamesDocument, options);
      }
export function useGetEnforcementPlatformNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementPlatformNamesQuery, GetEnforcementPlatformNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementPlatformNamesQuery, GetEnforcementPlatformNamesQueryVariables>(GetEnforcementPlatformNamesDocument, options);
        }
export type GetEnforcementPlatformNamesQueryHookResult = ReturnType<typeof useGetEnforcementPlatformNamesQuery>;
export type GetEnforcementPlatformNamesLazyQueryHookResult = ReturnType<typeof useGetEnforcementPlatformNamesLazyQuery>;
export type GetEnforcementPlatformNamesQueryResult = Apollo.QueryResult<GetEnforcementPlatformNamesQuery, GetEnforcementPlatformNamesQueryVariables>;
export const GetFormFieldsFromEnforcementTypesDocument = gql`
    query GetFormFieldsFromEnforcementTypes($offset: Int, $limit: Int, $formFieldsWhere: [enforcement_types_bool_exp!], $orderBy: [enforcement_types_order_by!]!) {
  enforcement_types(
    where: {enforcement_method_type: {_in: ["manual_form", "auto_form"]}, _and: $formFieldsWhere}
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    id
    platform
    type
    content_type
    enforcement_method_type
    enforcement_method_data
    manual_form_fields
  }
}
    `;

/**
 * __useGetFormFieldsFromEnforcementTypesQuery__
 *
 * To run a query within a React component, call `useGetFormFieldsFromEnforcementTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormFieldsFromEnforcementTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormFieldsFromEnforcementTypesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      formFieldsWhere: // value for 'formFieldsWhere'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetFormFieldsFromEnforcementTypesQuery(baseOptions: Apollo.QueryHookOptions<GetFormFieldsFromEnforcementTypesQuery, GetFormFieldsFromEnforcementTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormFieldsFromEnforcementTypesQuery, GetFormFieldsFromEnforcementTypesQueryVariables>(GetFormFieldsFromEnforcementTypesDocument, options);
      }
export function useGetFormFieldsFromEnforcementTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormFieldsFromEnforcementTypesQuery, GetFormFieldsFromEnforcementTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormFieldsFromEnforcementTypesQuery, GetFormFieldsFromEnforcementTypesQueryVariables>(GetFormFieldsFromEnforcementTypesDocument, options);
        }
export type GetFormFieldsFromEnforcementTypesQueryHookResult = ReturnType<typeof useGetFormFieldsFromEnforcementTypesQuery>;
export type GetFormFieldsFromEnforcementTypesLazyQueryHookResult = ReturnType<typeof useGetFormFieldsFromEnforcementTypesLazyQuery>;
export type GetFormFieldsFromEnforcementTypesQueryResult = Apollo.QueryResult<GetFormFieldsFromEnforcementTypesQuery, GetFormFieldsFromEnforcementTypesQueryVariables>;
export const GetFormFieldsFromEnforcementTypesCountDocument = gql`
    query GetFormFieldsFromEnforcementTypesCount($formFieldsWhere: [enforcement_types_bool_exp!]) {
  enforcement_types_aggregate(
    where: {enforcement_method_type: {_in: ["manual_form", "auto_form"]}, enforcement_method_data: {_is_null: false}, _and: $formFieldsWhere}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetFormFieldsFromEnforcementTypesCountQuery__
 *
 * To run a query within a React component, call `useGetFormFieldsFromEnforcementTypesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormFieldsFromEnforcementTypesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormFieldsFromEnforcementTypesCountQuery({
 *   variables: {
 *      formFieldsWhere: // value for 'formFieldsWhere'
 *   },
 * });
 */
export function useGetFormFieldsFromEnforcementTypesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetFormFieldsFromEnforcementTypesCountQuery, GetFormFieldsFromEnforcementTypesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormFieldsFromEnforcementTypesCountQuery, GetFormFieldsFromEnforcementTypesCountQueryVariables>(GetFormFieldsFromEnforcementTypesCountDocument, options);
      }
export function useGetFormFieldsFromEnforcementTypesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormFieldsFromEnforcementTypesCountQuery, GetFormFieldsFromEnforcementTypesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormFieldsFromEnforcementTypesCountQuery, GetFormFieldsFromEnforcementTypesCountQueryVariables>(GetFormFieldsFromEnforcementTypesCountDocument, options);
        }
export type GetFormFieldsFromEnforcementTypesCountQueryHookResult = ReturnType<typeof useGetFormFieldsFromEnforcementTypesCountQuery>;
export type GetFormFieldsFromEnforcementTypesCountLazyQueryHookResult = ReturnType<typeof useGetFormFieldsFromEnforcementTypesCountLazyQuery>;
export type GetFormFieldsFromEnforcementTypesCountQueryResult = Apollo.QueryResult<GetFormFieldsFromEnforcementTypesCountQuery, GetFormFieldsFromEnforcementTypesCountQueryVariables>;
export const GetFormFieldsEnforcementTypesDocument = gql`
    query GetFormFieldsEnforcementTypes {
  enforcement_types(
    distinct_on: type
    where: {_and: [{enforcement_method_type: {_in: ["manual_form", "auto_form"]}}, {enforcement_method_data: {_is_null: false}}]}
  ) {
    type
  }
}
    `;

/**
 * __useGetFormFieldsEnforcementTypesQuery__
 *
 * To run a query within a React component, call `useGetFormFieldsEnforcementTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormFieldsEnforcementTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormFieldsEnforcementTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFormFieldsEnforcementTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetFormFieldsEnforcementTypesQuery, GetFormFieldsEnforcementTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormFieldsEnforcementTypesQuery, GetFormFieldsEnforcementTypesQueryVariables>(GetFormFieldsEnforcementTypesDocument, options);
      }
export function useGetFormFieldsEnforcementTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormFieldsEnforcementTypesQuery, GetFormFieldsEnforcementTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormFieldsEnforcementTypesQuery, GetFormFieldsEnforcementTypesQueryVariables>(GetFormFieldsEnforcementTypesDocument, options);
        }
export type GetFormFieldsEnforcementTypesQueryHookResult = ReturnType<typeof useGetFormFieldsEnforcementTypesQuery>;
export type GetFormFieldsEnforcementTypesLazyQueryHookResult = ReturnType<typeof useGetFormFieldsEnforcementTypesLazyQuery>;
export type GetFormFieldsEnforcementTypesQueryResult = Apollo.QueryResult<GetFormFieldsEnforcementTypesQuery, GetFormFieldsEnforcementTypesQueryVariables>;
export const GetFormFieldsContentTypesDocument = gql`
    query GetFormFieldsContentTypes {
  enforcement_types(
    distinct_on: content_type
    where: {_and: [{enforcement_method_type: {_in: ["manual_form", "auto_form"]}}, {enforcement_method_data: {_is_null: false}}]}
  ) {
    content_type
  }
}
    `;

/**
 * __useGetFormFieldsContentTypesQuery__
 *
 * To run a query within a React component, call `useGetFormFieldsContentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormFieldsContentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormFieldsContentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFormFieldsContentTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetFormFieldsContentTypesQuery, GetFormFieldsContentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormFieldsContentTypesQuery, GetFormFieldsContentTypesQueryVariables>(GetFormFieldsContentTypesDocument, options);
      }
export function useGetFormFieldsContentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormFieldsContentTypesQuery, GetFormFieldsContentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormFieldsContentTypesQuery, GetFormFieldsContentTypesQueryVariables>(GetFormFieldsContentTypesDocument, options);
        }
export type GetFormFieldsContentTypesQueryHookResult = ReturnType<typeof useGetFormFieldsContentTypesQuery>;
export type GetFormFieldsContentTypesLazyQueryHookResult = ReturnType<typeof useGetFormFieldsContentTypesLazyQuery>;
export type GetFormFieldsContentTypesQueryResult = Apollo.QueryResult<GetFormFieldsContentTypesQuery, GetFormFieldsContentTypesQueryVariables>;
export const UpdateManualFormFieldsInEnforcementTypesDocument = gql`
    mutation UpdateManualFormFieldsInEnforcementTypes($id: uuid!, $manual_form_fields: jsonb) {
  update_enforcement_types(
    where: {id: {_eq: $id}}
    _set: {manual_form_fields: $manual_form_fields}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateManualFormFieldsInEnforcementTypesMutationFn = Apollo.MutationFunction<UpdateManualFormFieldsInEnforcementTypesMutation, UpdateManualFormFieldsInEnforcementTypesMutationVariables>;

/**
 * __useUpdateManualFormFieldsInEnforcementTypesMutation__
 *
 * To run a mutation, you first call `useUpdateManualFormFieldsInEnforcementTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManualFormFieldsInEnforcementTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManualFormFieldsInEnforcementTypesMutation, { data, loading, error }] = useUpdateManualFormFieldsInEnforcementTypesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      manual_form_fields: // value for 'manual_form_fields'
 *   },
 * });
 */
export function useUpdateManualFormFieldsInEnforcementTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManualFormFieldsInEnforcementTypesMutation, UpdateManualFormFieldsInEnforcementTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManualFormFieldsInEnforcementTypesMutation, UpdateManualFormFieldsInEnforcementTypesMutationVariables>(UpdateManualFormFieldsInEnforcementTypesDocument, options);
      }
export type UpdateManualFormFieldsInEnforcementTypesMutationHookResult = ReturnType<typeof useUpdateManualFormFieldsInEnforcementTypesMutation>;
export type UpdateManualFormFieldsInEnforcementTypesMutationResult = Apollo.MutationResult<UpdateManualFormFieldsInEnforcementTypesMutation>;
export type UpdateManualFormFieldsInEnforcementTypesMutationOptions = Apollo.BaseMutationOptions<UpdateManualFormFieldsInEnforcementTypesMutation, UpdateManualFormFieldsInEnforcementTypesMutationVariables>;
export const GetAiPromptsDocument = gql`
    query GetAiPrompts($offset: Int, $limit: Int, $aiPromptsWhere: ai_prompts_bool_exp!, $orderBy: [ai_prompts_order_by!]!) {
  ai_prompts(
    where: $aiPromptsWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    prompt
    role
    metadata
    id
    platform
    organization {
      id
      name
    }
    type
    user {
      id
      name
    }
    updated_at
    created_at
  }
}
    `;

/**
 * __useGetAiPromptsQuery__
 *
 * To run a query within a React component, call `useGetAiPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiPromptsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      aiPromptsWhere: // value for 'aiPromptsWhere'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetAiPromptsQuery(baseOptions: Apollo.QueryHookOptions<GetAiPromptsQuery, GetAiPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiPromptsQuery, GetAiPromptsQueryVariables>(GetAiPromptsDocument, options);
      }
export function useGetAiPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiPromptsQuery, GetAiPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiPromptsQuery, GetAiPromptsQueryVariables>(GetAiPromptsDocument, options);
        }
export type GetAiPromptsQueryHookResult = ReturnType<typeof useGetAiPromptsQuery>;
export type GetAiPromptsLazyQueryHookResult = ReturnType<typeof useGetAiPromptsLazyQuery>;
export type GetAiPromptsQueryResult = Apollo.QueryResult<GetAiPromptsQuery, GetAiPromptsQueryVariables>;
export const GetSingleAiPromptDocument = gql`
    query GetSingleAiPrompt($aiPromptWhere: ai_prompts_bool_exp!) {
  ai_prompts(where: $aiPromptWhere) {
    prompt
    role
    metadata
    id
    organization {
      id
      name
    }
    type
  }
}
    `;

/**
 * __useGetSingleAiPromptQuery__
 *
 * To run a query within a React component, call `useGetSingleAiPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleAiPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleAiPromptQuery({
 *   variables: {
 *      aiPromptWhere: // value for 'aiPromptWhere'
 *   },
 * });
 */
export function useGetSingleAiPromptQuery(baseOptions: Apollo.QueryHookOptions<GetSingleAiPromptQuery, GetSingleAiPromptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleAiPromptQuery, GetSingleAiPromptQueryVariables>(GetSingleAiPromptDocument, options);
      }
export function useGetSingleAiPromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleAiPromptQuery, GetSingleAiPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleAiPromptQuery, GetSingleAiPromptQueryVariables>(GetSingleAiPromptDocument, options);
        }
export type GetSingleAiPromptQueryHookResult = ReturnType<typeof useGetSingleAiPromptQuery>;
export type GetSingleAiPromptLazyQueryHookResult = ReturnType<typeof useGetSingleAiPromptLazyQuery>;
export type GetSingleAiPromptQueryResult = Apollo.QueryResult<GetSingleAiPromptQuery, GetSingleAiPromptQueryVariables>;
export const GetAiPromptsCountDocument = gql`
    query GetAiPromptsCount($aiPromptsWhere: ai_prompts_bool_exp!) {
  ai_prompts_aggregate(where: $aiPromptsWhere) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetAiPromptsCountQuery__
 *
 * To run a query within a React component, call `useGetAiPromptsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiPromptsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiPromptsCountQuery({
 *   variables: {
 *      aiPromptsWhere: // value for 'aiPromptsWhere'
 *   },
 * });
 */
export function useGetAiPromptsCountQuery(baseOptions: Apollo.QueryHookOptions<GetAiPromptsCountQuery, GetAiPromptsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiPromptsCountQuery, GetAiPromptsCountQueryVariables>(GetAiPromptsCountDocument, options);
      }
export function useGetAiPromptsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiPromptsCountQuery, GetAiPromptsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiPromptsCountQuery, GetAiPromptsCountQueryVariables>(GetAiPromptsCountDocument, options);
        }
export type GetAiPromptsCountQueryHookResult = ReturnType<typeof useGetAiPromptsCountQuery>;
export type GetAiPromptsCountLazyQueryHookResult = ReturnType<typeof useGetAiPromptsCountLazyQuery>;
export type GetAiPromptsCountQueryResult = Apollo.QueryResult<GetAiPromptsCountQuery, GetAiPromptsCountQueryVariables>;
export const GetAiPromptPlatformsDocument = gql`
    query GetAiPromptPlatforms {
  ai_prompts(distinct_on: platform) {
    platform
  }
}
    `;

/**
 * __useGetAiPromptPlatformsQuery__
 *
 * To run a query within a React component, call `useGetAiPromptPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiPromptPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiPromptPlatformsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiPromptPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<GetAiPromptPlatformsQuery, GetAiPromptPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiPromptPlatformsQuery, GetAiPromptPlatformsQueryVariables>(GetAiPromptPlatformsDocument, options);
      }
export function useGetAiPromptPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiPromptPlatformsQuery, GetAiPromptPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiPromptPlatformsQuery, GetAiPromptPlatformsQueryVariables>(GetAiPromptPlatformsDocument, options);
        }
export type GetAiPromptPlatformsQueryHookResult = ReturnType<typeof useGetAiPromptPlatformsQuery>;
export type GetAiPromptPlatformsLazyQueryHookResult = ReturnType<typeof useGetAiPromptPlatformsLazyQuery>;
export type GetAiPromptPlatformsQueryResult = Apollo.QueryResult<GetAiPromptPlatformsQuery, GetAiPromptPlatformsQueryVariables>;
export const GetAiPromptRolesDocument = gql`
    query GetAiPromptRoles {
  ai_prompts(distinct_on: role) {
    role
  }
}
    `;

/**
 * __useGetAiPromptRolesQuery__
 *
 * To run a query within a React component, call `useGetAiPromptRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiPromptRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiPromptRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiPromptRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetAiPromptRolesQuery, GetAiPromptRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiPromptRolesQuery, GetAiPromptRolesQueryVariables>(GetAiPromptRolesDocument, options);
      }
export function useGetAiPromptRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiPromptRolesQuery, GetAiPromptRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiPromptRolesQuery, GetAiPromptRolesQueryVariables>(GetAiPromptRolesDocument, options);
        }
export type GetAiPromptRolesQueryHookResult = ReturnType<typeof useGetAiPromptRolesQuery>;
export type GetAiPromptRolesLazyQueryHookResult = ReturnType<typeof useGetAiPromptRolesLazyQuery>;
export type GetAiPromptRolesQueryResult = Apollo.QueryResult<GetAiPromptRolesQuery, GetAiPromptRolesQueryVariables>;
export const GetAiPromptTypesDocument = gql`
    query GetAiPromptTypes {
  ai_prompts(distinct_on: type) {
    type
  }
}
    `;

/**
 * __useGetAiPromptTypesQuery__
 *
 * To run a query within a React component, call `useGetAiPromptTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiPromptTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiPromptTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiPromptTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAiPromptTypesQuery, GetAiPromptTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiPromptTypesQuery, GetAiPromptTypesQueryVariables>(GetAiPromptTypesDocument, options);
      }
export function useGetAiPromptTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiPromptTypesQuery, GetAiPromptTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiPromptTypesQuery, GetAiPromptTypesQueryVariables>(GetAiPromptTypesDocument, options);
        }
export type GetAiPromptTypesQueryHookResult = ReturnType<typeof useGetAiPromptTypesQuery>;
export type GetAiPromptTypesLazyQueryHookResult = ReturnType<typeof useGetAiPromptTypesLazyQuery>;
export type GetAiPromptTypesQueryResult = Apollo.QueryResult<GetAiPromptTypesQuery, GetAiPromptTypesQueryVariables>;
export const GetAiPromptOrgsDocument = gql`
    query GetAiPromptOrgs {
  ai_prompts(distinct_on: org_id) {
    organization {
      name
      id
    }
  }
}
    `;

/**
 * __useGetAiPromptOrgsQuery__
 *
 * To run a query within a React component, call `useGetAiPromptOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiPromptOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiPromptOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiPromptOrgsQuery(baseOptions?: Apollo.QueryHookOptions<GetAiPromptOrgsQuery, GetAiPromptOrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiPromptOrgsQuery, GetAiPromptOrgsQueryVariables>(GetAiPromptOrgsDocument, options);
      }
export function useGetAiPromptOrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiPromptOrgsQuery, GetAiPromptOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiPromptOrgsQuery, GetAiPromptOrgsQueryVariables>(GetAiPromptOrgsDocument, options);
        }
export type GetAiPromptOrgsQueryHookResult = ReturnType<typeof useGetAiPromptOrgsQuery>;
export type GetAiPromptOrgsLazyQueryHookResult = ReturnType<typeof useGetAiPromptOrgsLazyQuery>;
export type GetAiPromptOrgsQueryResult = Apollo.QueryResult<GetAiPromptOrgsQuery, GetAiPromptOrgsQueryVariables>;
export const GetPlatformsCountDocument = gql`
    query GetPlatformsCount($platformsWhere: platforms_bool_exp!) {
  platforms_aggregate(where: $platformsWhere) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPlatformsCountQuery__
 *
 * To run a query within a React component, call `useGetPlatformsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformsCountQuery({
 *   variables: {
 *      platformsWhere: // value for 'platformsWhere'
 *   },
 * });
 */
export function useGetPlatformsCountQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformsCountQuery, GetPlatformsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformsCountQuery, GetPlatformsCountQueryVariables>(GetPlatformsCountDocument, options);
      }
export function useGetPlatformsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformsCountQuery, GetPlatformsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformsCountQuery, GetPlatformsCountQueryVariables>(GetPlatformsCountDocument, options);
        }
export type GetPlatformsCountQueryHookResult = ReturnType<typeof useGetPlatformsCountQuery>;
export type GetPlatformsCountLazyQueryHookResult = ReturnType<typeof useGetPlatformsCountLazyQuery>;
export type GetPlatformsCountQueryResult = Apollo.QueryResult<GetPlatformsCountQuery, GetPlatformsCountQueryVariables>;
export const GetPlatformProductsDocument = gql`
    query GetPlatformProducts {
  platforms(distinct_on: product) {
    name
    product
  }
}
    `;

/**
 * __useGetPlatformProductsQuery__
 *
 * To run a query within a React component, call `useGetPlatformProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlatformProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetPlatformProductsQuery, GetPlatformProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformProductsQuery, GetPlatformProductsQueryVariables>(GetPlatformProductsDocument, options);
      }
export function useGetPlatformProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformProductsQuery, GetPlatformProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformProductsQuery, GetPlatformProductsQueryVariables>(GetPlatformProductsDocument, options);
        }
export type GetPlatformProductsQueryHookResult = ReturnType<typeof useGetPlatformProductsQuery>;
export type GetPlatformProductsLazyQueryHookResult = ReturnType<typeof useGetPlatformProductsLazyQuery>;
export type GetPlatformProductsQueryResult = Apollo.QueryResult<GetPlatformProductsQuery, GetPlatformProductsQueryVariables>;
export const GetEnforcementTemplatesDocument = gql`
    query GetEnforcementTemplates($offset: Int, $limit: Int, $enforcementTemplatesWhere: enforcement_templates_bool_exp!, $orderBy: [enforcement_templates_order_by!]!) {
  enforcement_templates(
    where: $enforcementTemplatesWhere
    offset: $offset
    limit: $limit
    order_by: $orderBy
  ) {
    type
    platform
    template_body
    stage
  }
}
    `;

/**
 * __useGetEnforcementTemplatesQuery__
 *
 * To run a query within a React component, call `useGetEnforcementTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementTemplatesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      enforcementTemplatesWhere: // value for 'enforcementTemplatesWhere'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetEnforcementTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementTemplatesQuery, GetEnforcementTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementTemplatesQuery, GetEnforcementTemplatesQueryVariables>(GetEnforcementTemplatesDocument, options);
      }
export function useGetEnforcementTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementTemplatesQuery, GetEnforcementTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementTemplatesQuery, GetEnforcementTemplatesQueryVariables>(GetEnforcementTemplatesDocument, options);
        }
export type GetEnforcementTemplatesQueryHookResult = ReturnType<typeof useGetEnforcementTemplatesQuery>;
export type GetEnforcementTemplatesLazyQueryHookResult = ReturnType<typeof useGetEnforcementTemplatesLazyQuery>;
export type GetEnforcementTemplatesQueryResult = Apollo.QueryResult<GetEnforcementTemplatesQuery, GetEnforcementTemplatesQueryVariables>;
export const GetSingleEnforcementTemplateDocument = gql`
    query GetSingleEnforcementTemplate($enforcementTemplateWhere: enforcement_templates_bool_exp!) {
  enforcement_templates(where: $enforcementTemplateWhere) {
    type
    platform
    template_body
    stage
  }
}
    `;

/**
 * __useGetSingleEnforcementTemplateQuery__
 *
 * To run a query within a React component, call `useGetSingleEnforcementTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleEnforcementTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleEnforcementTemplateQuery({
 *   variables: {
 *      enforcementTemplateWhere: // value for 'enforcementTemplateWhere'
 *   },
 * });
 */
export function useGetSingleEnforcementTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetSingleEnforcementTemplateQuery, GetSingleEnforcementTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleEnforcementTemplateQuery, GetSingleEnforcementTemplateQueryVariables>(GetSingleEnforcementTemplateDocument, options);
      }
export function useGetSingleEnforcementTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleEnforcementTemplateQuery, GetSingleEnforcementTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleEnforcementTemplateQuery, GetSingleEnforcementTemplateQueryVariables>(GetSingleEnforcementTemplateDocument, options);
        }
export type GetSingleEnforcementTemplateQueryHookResult = ReturnType<typeof useGetSingleEnforcementTemplateQuery>;
export type GetSingleEnforcementTemplateLazyQueryHookResult = ReturnType<typeof useGetSingleEnforcementTemplateLazyQuery>;
export type GetSingleEnforcementTemplateQueryResult = Apollo.QueryResult<GetSingleEnforcementTemplateQuery, GetSingleEnforcementTemplateQueryVariables>;
export const GetEnforcementTemplatesCountDocument = gql`
    query GetEnforcementTemplatesCount($enforcementTemplatesWhere: enforcement_templates_bool_exp!) {
  enforcement_templates_aggregate(where: $enforcementTemplatesWhere) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetEnforcementTemplatesCountQuery__
 *
 * To run a query within a React component, call `useGetEnforcementTemplatesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementTemplatesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementTemplatesCountQuery({
 *   variables: {
 *      enforcementTemplatesWhere: // value for 'enforcementTemplatesWhere'
 *   },
 * });
 */
export function useGetEnforcementTemplatesCountQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementTemplatesCountQuery, GetEnforcementTemplatesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementTemplatesCountQuery, GetEnforcementTemplatesCountQueryVariables>(GetEnforcementTemplatesCountDocument, options);
      }
export function useGetEnforcementTemplatesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementTemplatesCountQuery, GetEnforcementTemplatesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementTemplatesCountQuery, GetEnforcementTemplatesCountQueryVariables>(GetEnforcementTemplatesCountDocument, options);
        }
export type GetEnforcementTemplatesCountQueryHookResult = ReturnType<typeof useGetEnforcementTemplatesCountQuery>;
export type GetEnforcementTemplatesCountLazyQueryHookResult = ReturnType<typeof useGetEnforcementTemplatesCountLazyQuery>;
export type GetEnforcementTemplatesCountQueryResult = Apollo.QueryResult<GetEnforcementTemplatesCountQuery, GetEnforcementTemplatesCountQueryVariables>;
export const GetEnforcementTemplateTypesDocument = gql`
    query GetEnforcementTemplateTypes {
  enforcement_templates(distinct_on: type) {
    platform
    type
  }
}
    `;

/**
 * __useGetEnforcementTemplateTypesQuery__
 *
 * To run a query within a React component, call `useGetEnforcementTemplateTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementTemplateTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementTemplateTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnforcementTemplateTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetEnforcementTemplateTypesQuery, GetEnforcementTemplateTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementTemplateTypesQuery, GetEnforcementTemplateTypesQueryVariables>(GetEnforcementTemplateTypesDocument, options);
      }
export function useGetEnforcementTemplateTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementTemplateTypesQuery, GetEnforcementTemplateTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementTemplateTypesQuery, GetEnforcementTemplateTypesQueryVariables>(GetEnforcementTemplateTypesDocument, options);
        }
export type GetEnforcementTemplateTypesQueryHookResult = ReturnType<typeof useGetEnforcementTemplateTypesQuery>;
export type GetEnforcementTemplateTypesLazyQueryHookResult = ReturnType<typeof useGetEnforcementTemplateTypesLazyQuery>;
export type GetEnforcementTemplateTypesQueryResult = Apollo.QueryResult<GetEnforcementTemplateTypesQuery, GetEnforcementTemplateTypesQueryVariables>;
export const GetEnforcementTemplateStagesDocument = gql`
    query GetEnforcementTemplateStages {
  enforcement_templates(distinct_on: stage) {
    stage
  }
}
    `;

/**
 * __useGetEnforcementTemplateStagesQuery__
 *
 * To run a query within a React component, call `useGetEnforcementTemplateStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementTemplateStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementTemplateStagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnforcementTemplateStagesQuery(baseOptions?: Apollo.QueryHookOptions<GetEnforcementTemplateStagesQuery, GetEnforcementTemplateStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementTemplateStagesQuery, GetEnforcementTemplateStagesQueryVariables>(GetEnforcementTemplateStagesDocument, options);
      }
export function useGetEnforcementTemplateStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementTemplateStagesQuery, GetEnforcementTemplateStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementTemplateStagesQuery, GetEnforcementTemplateStagesQueryVariables>(GetEnforcementTemplateStagesDocument, options);
        }
export type GetEnforcementTemplateStagesQueryHookResult = ReturnType<typeof useGetEnforcementTemplateStagesQuery>;
export type GetEnforcementTemplateStagesLazyQueryHookResult = ReturnType<typeof useGetEnforcementTemplateStagesLazyQuery>;
export type GetEnforcementTemplateStagesQueryResult = Apollo.QueryResult<GetEnforcementTemplateStagesQuery, GetEnforcementTemplateStagesQueryVariables>;
export const GetEnforcementRequestsDocument = gql`
    query GetEnforcementRequests($enforcementStatuses: [String!]!, $platforms: [String!]!, $includeCreditCardData: Boolean! = false) {
  enforcement_requests(
    where: {platform: {_in: $platforms}, status: {_in: $enforcementStatuses}, spoofing_report: {organization: {organization_status: {_neq: "test_org"}}}, type: {_eq: "phishing"}}
  ) {
    id
    platform
    updated_at
    spoofing_report {
      ...SPOOFING_REPORT
      collection_report_changes_aggregate {
        aggregate {
          max {
            timestamp
          }
        }
      }
    }
    type
    status
    submission_external_id
  }
}
    ${Spoofing_ReportFragmentDoc}`;

/**
 * __useGetEnforcementRequestsQuery__
 *
 * To run a query within a React component, call `useGetEnforcementRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementRequestsQuery({
 *   variables: {
 *      enforcementStatuses: // value for 'enforcementStatuses'
 *      platforms: // value for 'platforms'
 *      includeCreditCardData: // value for 'includeCreditCardData'
 *   },
 * });
 */
export function useGetEnforcementRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementRequestsQuery, GetEnforcementRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementRequestsQuery, GetEnforcementRequestsQueryVariables>(GetEnforcementRequestsDocument, options);
      }
export function useGetEnforcementRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementRequestsQuery, GetEnforcementRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementRequestsQuery, GetEnforcementRequestsQueryVariables>(GetEnforcementRequestsDocument, options);
        }
export type GetEnforcementRequestsQueryHookResult = ReturnType<typeof useGetEnforcementRequestsQuery>;
export type GetEnforcementRequestsLazyQueryHookResult = ReturnType<typeof useGetEnforcementRequestsLazyQuery>;
export type GetEnforcementRequestsQueryResult = Apollo.QueryResult<GetEnforcementRequestsQuery, GetEnforcementRequestsQueryVariables>;
export const GetSpoofingReportFiltersWithPendingRequestsDocument = gql`
    query GetSpoofingReportFiltersWithPendingRequests($enforcementStatuses: [String!]!, $platforms: [String!]!, $products: [platform_type!]!, $submissionSources: [String!]!, $includeCreditCardData: Boolean! = false) {
  spoofing_reports(
    where: {report_status: {_eq: "reported"}, enforcement_requests: {_or: [{platform: {_in: $platforms}}, {spoofing_report: {platform: {product: {_in: $products}}}}], submission_source: {_in: $submissionSources}, status: {_in: $enforcementStatuses}, spoofing_report: {organization: {organization_status: {_neq: "test_org"}}}}}
  ) {
    spoofing_entity {
      entity_name
    }
    organization {
      name
    }
    enforcement_requests(
      where: {_or: [{platform: {_in: $platforms}}, {spoofing_report: {platform: {product: {_in: $products}}}}], submission_source: {_in: $submissionSources}, status: {_in: $enforcementStatuses}, spoofing_report: {organization: {organization_status: {_neq: "test_org"}}}}
    ) {
      platform
    }
  }
}
    `;

/**
 * __useGetSpoofingReportFiltersWithPendingRequestsQuery__
 *
 * To run a query within a React component, call `useGetSpoofingReportFiltersWithPendingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpoofingReportFiltersWithPendingRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpoofingReportFiltersWithPendingRequestsQuery({
 *   variables: {
 *      enforcementStatuses: // value for 'enforcementStatuses'
 *      platforms: // value for 'platforms'
 *      products: // value for 'products'
 *      submissionSources: // value for 'submissionSources'
 *      includeCreditCardData: // value for 'includeCreditCardData'
 *   },
 * });
 */
export function useGetSpoofingReportFiltersWithPendingRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetSpoofingReportFiltersWithPendingRequestsQuery, GetSpoofingReportFiltersWithPendingRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpoofingReportFiltersWithPendingRequestsQuery, GetSpoofingReportFiltersWithPendingRequestsQueryVariables>(GetSpoofingReportFiltersWithPendingRequestsDocument, options);
      }
export function useGetSpoofingReportFiltersWithPendingRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpoofingReportFiltersWithPendingRequestsQuery, GetSpoofingReportFiltersWithPendingRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpoofingReportFiltersWithPendingRequestsQuery, GetSpoofingReportFiltersWithPendingRequestsQueryVariables>(GetSpoofingReportFiltersWithPendingRequestsDocument, options);
        }
export type GetSpoofingReportFiltersWithPendingRequestsQueryHookResult = ReturnType<typeof useGetSpoofingReportFiltersWithPendingRequestsQuery>;
export type GetSpoofingReportFiltersWithPendingRequestsLazyQueryHookResult = ReturnType<typeof useGetSpoofingReportFiltersWithPendingRequestsLazyQuery>;
export type GetSpoofingReportFiltersWithPendingRequestsQueryResult = Apollo.QueryResult<GetSpoofingReportFiltersWithPendingRequestsQuery, GetSpoofingReportFiltersWithPendingRequestsQueryVariables>;
export const GetSpoofingReportsWithPendingRequestsAndOrgNameDocument = gql`
    query GetSpoofingReportsWithPendingRequestsAndOrgName($enforcementStatuses: [String!]!, $platforms: [String!]!, $products: [platform_type!]!, $submissionSources: [String!]!, $limit: Int, $offset: Int, $includeCreditCardData: Boolean! = false, $organizationNames: [String!], $entityNames: [String!]) {
  spoofing_reports(
    where: {report_status: {_eq: "reported"}, enforcement_requests: {_or: [{platform: {_in: $platforms}}, {spoofing_report: {platform: {product: {_in: $products}}}}], submission_source: {_in: $submissionSources}, status: {_in: $enforcementStatuses}, spoofing_report: {organization: {organization_status: {_neq: "test_org"}, name: {_in: $organizationNames}}, spoofing_entity: {entity_name: {_in: $entityNames}}}}, organization: {name: {_in: $organizationNames}}}
    limit: $limit
    offset: $offset
  ) {
    ...SPOOFING_REPORT_WITHOUT_ENFORCEMENTS
    collection_report_changes_aggregate {
      aggregate {
        max {
          timestamp
        }
      }
    }
    enforcement_requests(
      where: {_or: [{platform: {_in: $platforms}}, {spoofing_report: {platform: {product: {_in: $products}}}}], submission_source: {_in: $submissionSources}, status: {_in: $enforcementStatuses}, spoofing_report: {organization: {organization_status: {_neq: "test_org"}}}}
    ) {
      id
      platform
      updated_at
      type
      status
    }
  }
}
    ${Spoofing_Report_Without_EnforcementsFragmentDoc}`;

/**
 * __useGetSpoofingReportsWithPendingRequestsAndOrgNameQuery__
 *
 * To run a query within a React component, call `useGetSpoofingReportsWithPendingRequestsAndOrgNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpoofingReportsWithPendingRequestsAndOrgNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpoofingReportsWithPendingRequestsAndOrgNameQuery({
 *   variables: {
 *      enforcementStatuses: // value for 'enforcementStatuses'
 *      platforms: // value for 'platforms'
 *      products: // value for 'products'
 *      submissionSources: // value for 'submissionSources'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      includeCreditCardData: // value for 'includeCreditCardData'
 *      organizationNames: // value for 'organizationNames'
 *      entityNames: // value for 'entityNames'
 *   },
 * });
 */
export function useGetSpoofingReportsWithPendingRequestsAndOrgNameQuery(baseOptions: Apollo.QueryHookOptions<GetSpoofingReportsWithPendingRequestsAndOrgNameQuery, GetSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpoofingReportsWithPendingRequestsAndOrgNameQuery, GetSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables>(GetSpoofingReportsWithPendingRequestsAndOrgNameDocument, options);
      }
export function useGetSpoofingReportsWithPendingRequestsAndOrgNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpoofingReportsWithPendingRequestsAndOrgNameQuery, GetSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpoofingReportsWithPendingRequestsAndOrgNameQuery, GetSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables>(GetSpoofingReportsWithPendingRequestsAndOrgNameDocument, options);
        }
export type GetSpoofingReportsWithPendingRequestsAndOrgNameQueryHookResult = ReturnType<typeof useGetSpoofingReportsWithPendingRequestsAndOrgNameQuery>;
export type GetSpoofingReportsWithPendingRequestsAndOrgNameLazyQueryHookResult = ReturnType<typeof useGetSpoofingReportsWithPendingRequestsAndOrgNameLazyQuery>;
export type GetSpoofingReportsWithPendingRequestsAndOrgNameQueryResult = Apollo.QueryResult<GetSpoofingReportsWithPendingRequestsAndOrgNameQuery, GetSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables>;
export const GetCountSpoofingReportsWithPendingRequestsAndOrgNameDocument = gql`
    query GetCountSpoofingReportsWithPendingRequestsAndOrgName($enforcementStatuses: [String!]!, $platforms: [String!]!, $products: [platform_type!]!, $submissionSources: [String!]!, $entityNames: [String!], $organizationNames: [String!]) {
  spoofing_reports_aggregate(
    where: {report_status: {_eq: "reported"}, enforcement_requests: {_or: [{platform: {_in: $platforms}}, {spoofing_report: {platform: {product: {_in: $products}}}}], submission_source: {_in: $submissionSources}, status: {_in: $enforcementStatuses}, spoofing_report: {organization: {organization_status: {_neq: "test_org"}, name: {_in: $organizationNames}}, spoofing_entity: {entity_name: {_in: $entityNames}}}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery__
 *
 * To run a query within a React component, call `useGetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery({
 *   variables: {
 *      enforcementStatuses: // value for 'enforcementStatuses'
 *      platforms: // value for 'platforms'
 *      products: // value for 'products'
 *      submissionSources: // value for 'submissionSources'
 *      entityNames: // value for 'entityNames'
 *      organizationNames: // value for 'organizationNames'
 *   },
 * });
 */
export function useGetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery(baseOptions: Apollo.QueryHookOptions<GetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery, GetCountSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery, GetCountSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables>(GetCountSpoofingReportsWithPendingRequestsAndOrgNameDocument, options);
      }
export function useGetCountSpoofingReportsWithPendingRequestsAndOrgNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery, GetCountSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery, GetCountSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables>(GetCountSpoofingReportsWithPendingRequestsAndOrgNameDocument, options);
        }
export type GetCountSpoofingReportsWithPendingRequestsAndOrgNameQueryHookResult = ReturnType<typeof useGetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery>;
export type GetCountSpoofingReportsWithPendingRequestsAndOrgNameLazyQueryHookResult = ReturnType<typeof useGetCountSpoofingReportsWithPendingRequestsAndOrgNameLazyQuery>;
export type GetCountSpoofingReportsWithPendingRequestsAndOrgNameQueryResult = Apollo.QueryResult<GetCountSpoofingReportsWithPendingRequestsAndOrgNameQuery, GetCountSpoofingReportsWithPendingRequestsAndOrgNameQueryVariables>;
export const UpdateEnforcementRequestsStatusDocument = gql`
    mutation UpdateEnforcementRequestsStatus($ids: [uuid!]!, $enforcementStatus: String!, $reportChanges: [collection_report_changes_insert_input!]!) {
  update_enforcement_requests(
    where: {id: {_in: $ids}}
    _set: {status: $enforcementStatus}
  ) {
    returning {
      id
      status
    }
  }
  insert_collection_report_changes(objects: $reportChanges) {
    returning {
      id
    }
  }
}
    `;
export type UpdateEnforcementRequestsStatusMutationFn = Apollo.MutationFunction<UpdateEnforcementRequestsStatusMutation, UpdateEnforcementRequestsStatusMutationVariables>;

/**
 * __useUpdateEnforcementRequestsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEnforcementRequestsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnforcementRequestsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnforcementRequestsStatusMutation, { data, loading, error }] = useUpdateEnforcementRequestsStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      enforcementStatus: // value for 'enforcementStatus'
 *      reportChanges: // value for 'reportChanges'
 *   },
 * });
 */
export function useUpdateEnforcementRequestsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnforcementRequestsStatusMutation, UpdateEnforcementRequestsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnforcementRequestsStatusMutation, UpdateEnforcementRequestsStatusMutationVariables>(UpdateEnforcementRequestsStatusDocument, options);
      }
export type UpdateEnforcementRequestsStatusMutationHookResult = ReturnType<typeof useUpdateEnforcementRequestsStatusMutation>;
export type UpdateEnforcementRequestsStatusMutationResult = Apollo.MutationResult<UpdateEnforcementRequestsStatusMutation>;
export type UpdateEnforcementRequestsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateEnforcementRequestsStatusMutation, UpdateEnforcementRequestsStatusMutationVariables>;
export const GetMlFeaturesDocument = gql`
    query GetMLFeatures($match_ids: [uuid!]!) {
  ml_features(where: {match_id: {_in: $match_ids}}) {
    name
    value
    extra_data
    match_id
    created_at
    id
    is_value_from_model
    threshold
    normalized_value
  }
}
    `;

/**
 * __useGetMlFeaturesQuery__
 *
 * To run a query within a React component, call `useGetMlFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMlFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMlFeaturesQuery({
 *   variables: {
 *      match_ids: // value for 'match_ids'
 *   },
 * });
 */
export function useGetMlFeaturesQuery(baseOptions: Apollo.QueryHookOptions<GetMlFeaturesQuery, GetMlFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMlFeaturesQuery, GetMlFeaturesQueryVariables>(GetMlFeaturesDocument, options);
      }
export function useGetMlFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMlFeaturesQuery, GetMlFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMlFeaturesQuery, GetMlFeaturesQueryVariables>(GetMlFeaturesDocument, options);
        }
export type GetMlFeaturesQueryHookResult = ReturnType<typeof useGetMlFeaturesQuery>;
export type GetMlFeaturesLazyQueryHookResult = ReturnType<typeof useGetMlFeaturesLazyQuery>;
export type GetMlFeaturesQueryResult = Apollo.QueryResult<GetMlFeaturesQuery, GetMlFeaturesQueryVariables>;
export const GetAllPlatformsDocument = gql`
    query GetAllPlatforms {
  platforms(order_by: {name: asc}) {
    name
  }
}
    `;

/**
 * __useGetAllPlatformsQuery__
 *
 * To run a query within a React component, call `useGetAllPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPlatformsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPlatformsQuery, GetAllPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPlatformsQuery, GetAllPlatformsQueryVariables>(GetAllPlatformsDocument, options);
      }
export function useGetAllPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPlatformsQuery, GetAllPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPlatformsQuery, GetAllPlatformsQueryVariables>(GetAllPlatformsDocument, options);
        }
export type GetAllPlatformsQueryHookResult = ReturnType<typeof useGetAllPlatformsQuery>;
export type GetAllPlatformsLazyQueryHookResult = ReturnType<typeof useGetAllPlatformsLazyQuery>;
export type GetAllPlatformsQueryResult = Apollo.QueryResult<GetAllPlatformsQuery, GetAllPlatformsQueryVariables>;
export const BulkUpdateTypeForReportsDocument = gql`
    mutation BulkUpdateTypeForReports($ids: [uuid!]!, $type: String!) {
  update_spoofing_reports(where: {id: {_in: $ids}}, _set: {type: $type}) {
    returning {
      id
      type
    }
  }
}
    `;
export type BulkUpdateTypeForReportsMutationFn = Apollo.MutationFunction<BulkUpdateTypeForReportsMutation, BulkUpdateTypeForReportsMutationVariables>;

/**
 * __useBulkUpdateTypeForReportsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateTypeForReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateTypeForReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateTypeForReportsMutation, { data, loading, error }] = useBulkUpdateTypeForReportsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useBulkUpdateTypeForReportsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateTypeForReportsMutation, BulkUpdateTypeForReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateTypeForReportsMutation, BulkUpdateTypeForReportsMutationVariables>(BulkUpdateTypeForReportsDocument, options);
      }
export type BulkUpdateTypeForReportsMutationHookResult = ReturnType<typeof useBulkUpdateTypeForReportsMutation>;
export type BulkUpdateTypeForReportsMutationResult = Apollo.MutationResult<BulkUpdateTypeForReportsMutation>;
export type BulkUpdateTypeForReportsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateTypeForReportsMutation, BulkUpdateTypeForReportsMutationVariables>;
export const BulkUpdatePlatformSubtypeIdForReportsDocument = gql`
    mutation BulkUpdatePlatformSubtypeIdForReports($ids: [uuid!]!, $platform_subtype_id: uuid!) {
  update_spoofing_reports(
    where: {id: {_in: $ids}}
    _set: {platform_subtype_id: $platform_subtype_id}
  ) {
    returning {
      id
      platform_subtype_id
      platform_subtype {
        ...PLATFORM_SUBTYPE
      }
    }
  }
}
    ${Platform_SubtypeFragmentDoc}`;
export type BulkUpdatePlatformSubtypeIdForReportsMutationFn = Apollo.MutationFunction<BulkUpdatePlatformSubtypeIdForReportsMutation, BulkUpdatePlatformSubtypeIdForReportsMutationVariables>;

/**
 * __useBulkUpdatePlatformSubtypeIdForReportsMutation__
 *
 * To run a mutation, you first call `useBulkUpdatePlatformSubtypeIdForReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdatePlatformSubtypeIdForReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdatePlatformSubtypeIdForReportsMutation, { data, loading, error }] = useBulkUpdatePlatformSubtypeIdForReportsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      platform_subtype_id: // value for 'platform_subtype_id'
 *   },
 * });
 */
export function useBulkUpdatePlatformSubtypeIdForReportsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdatePlatformSubtypeIdForReportsMutation, BulkUpdatePlatformSubtypeIdForReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdatePlatformSubtypeIdForReportsMutation, BulkUpdatePlatformSubtypeIdForReportsMutationVariables>(BulkUpdatePlatformSubtypeIdForReportsDocument, options);
      }
export type BulkUpdatePlatformSubtypeIdForReportsMutationHookResult = ReturnType<typeof useBulkUpdatePlatformSubtypeIdForReportsMutation>;
export type BulkUpdatePlatformSubtypeIdForReportsMutationResult = Apollo.MutationResult<BulkUpdatePlatformSubtypeIdForReportsMutation>;
export type BulkUpdatePlatformSubtypeIdForReportsMutationOptions = Apollo.BaseMutationOptions<BulkUpdatePlatformSubtypeIdForReportsMutation, BulkUpdatePlatformSubtypeIdForReportsMutationVariables>;
export const BulkUpdateBrandForProtectedAssetsDocument = gql`
    mutation BulkUpdateBrandForProtectedAssets($ids: [uuid!]!, $brand_id: uuid!, $user_id: uuid!) {
  update_protected_assets(
    where: {id: {_in: $ids}}
    _set: {original_entity_id: $brand_id, last_updated_by_user_id: $user_id}
  ) {
    returning {
      id
      original_entity_id
      last_updated_by_user_id
    }
  }
}
    `;
export type BulkUpdateBrandForProtectedAssetsMutationFn = Apollo.MutationFunction<BulkUpdateBrandForProtectedAssetsMutation, BulkUpdateBrandForProtectedAssetsMutationVariables>;

/**
 * __useBulkUpdateBrandForProtectedAssetsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateBrandForProtectedAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateBrandForProtectedAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateBrandForProtectedAssetsMutation, { data, loading, error }] = useBulkUpdateBrandForProtectedAssetsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      brand_id: // value for 'brand_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useBulkUpdateBrandForProtectedAssetsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateBrandForProtectedAssetsMutation, BulkUpdateBrandForProtectedAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateBrandForProtectedAssetsMutation, BulkUpdateBrandForProtectedAssetsMutationVariables>(BulkUpdateBrandForProtectedAssetsDocument, options);
      }
export type BulkUpdateBrandForProtectedAssetsMutationHookResult = ReturnType<typeof useBulkUpdateBrandForProtectedAssetsMutation>;
export type BulkUpdateBrandForProtectedAssetsMutationResult = Apollo.MutationResult<BulkUpdateBrandForProtectedAssetsMutation>;
export type BulkUpdateBrandForProtectedAssetsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateBrandForProtectedAssetsMutation, BulkUpdateBrandForProtectedAssetsMutationVariables>;
export const BulkUpdateBrandforCustomerAssetsDocument = gql`
    mutation BulkUpdateBrandforCustomerAssets($ids: [uuid!]!, $user_id: uuid!, $customer_assets_to_brands_conditions: [customer_assets_to_brands_bool_exp!]!, $customer_assets_to_brands_objects: [customer_assets_to_brands_insert_input!]!) {
  update_customer_assets(
    where: {id: {_in: $ids}}
    _set: {last_updated_by_user_id: $user_id}
  ) {
    returning {
      id
      organization_id
      last_updated_by_user_id
    }
  }
  delete_customer_assets_to_brands(
    where: {_or: $customer_assets_to_brands_conditions}
  ) {
    affected_rows
  }
  insert_customer_assets_to_brands(objects: $customer_assets_to_brands_objects) {
    returning {
      customer_asset_id
      brand_id
    }
  }
}
    `;
export type BulkUpdateBrandforCustomerAssetsMutationFn = Apollo.MutationFunction<BulkUpdateBrandforCustomerAssetsMutation, BulkUpdateBrandforCustomerAssetsMutationVariables>;

/**
 * __useBulkUpdateBrandforCustomerAssetsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateBrandforCustomerAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateBrandforCustomerAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateBrandforCustomerAssetsMutation, { data, loading, error }] = useBulkUpdateBrandforCustomerAssetsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      user_id: // value for 'user_id'
 *      customer_assets_to_brands_conditions: // value for 'customer_assets_to_brands_conditions'
 *      customer_assets_to_brands_objects: // value for 'customer_assets_to_brands_objects'
 *   },
 * });
 */
export function useBulkUpdateBrandforCustomerAssetsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateBrandforCustomerAssetsMutation, BulkUpdateBrandforCustomerAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateBrandforCustomerAssetsMutation, BulkUpdateBrandforCustomerAssetsMutationVariables>(BulkUpdateBrandforCustomerAssetsDocument, options);
      }
export type BulkUpdateBrandforCustomerAssetsMutationHookResult = ReturnType<typeof useBulkUpdateBrandforCustomerAssetsMutation>;
export type BulkUpdateBrandforCustomerAssetsMutationResult = Apollo.MutationResult<BulkUpdateBrandforCustomerAssetsMutation>;
export type BulkUpdateBrandforCustomerAssetsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateBrandforCustomerAssetsMutation, BulkUpdateBrandforCustomerAssetsMutationVariables>;
export const UpdateBrandForCustomerAssetDocument = gql`
    mutation UpdateBrandForCustomerAsset($id: uuid!, $brand_ids: [uuid!]!, $organization_id: uuid!) {
  manage_safelist(
    manage_safelist_input: {customer_asset_id: $id, brand_ids: $brand_ids, organization_id: $organization_id, request_type: "update"}
  ) {
    id
  }
}
    `;
export type UpdateBrandForCustomerAssetMutationFn = Apollo.MutationFunction<UpdateBrandForCustomerAssetMutation, UpdateBrandForCustomerAssetMutationVariables>;

/**
 * __useUpdateBrandForCustomerAssetMutation__
 *
 * To run a mutation, you first call `useUpdateBrandForCustomerAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandForCustomerAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandForCustomerAssetMutation, { data, loading, error }] = useUpdateBrandForCustomerAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      brand_ids: // value for 'brand_ids'
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useUpdateBrandForCustomerAssetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandForCustomerAssetMutation, UpdateBrandForCustomerAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandForCustomerAssetMutation, UpdateBrandForCustomerAssetMutationVariables>(UpdateBrandForCustomerAssetDocument, options);
      }
export type UpdateBrandForCustomerAssetMutationHookResult = ReturnType<typeof useUpdateBrandForCustomerAssetMutation>;
export type UpdateBrandForCustomerAssetMutationResult = Apollo.MutationResult<UpdateBrandForCustomerAssetMutation>;
export type UpdateBrandForCustomerAssetMutationOptions = Apollo.BaseMutationOptions<UpdateBrandForCustomerAssetMutation, UpdateBrandForCustomerAssetMutationVariables>;
export const GetCustomerAssetsByValuesDocument = gql`
    query GetCustomerAssetsByValues($values: [String!]!, $organization_id: uuid!) {
  customer_assets(
    where: {value: {_in: $values}, organization_id: {_eq: $organization_id}}
  ) {
    id
    value
  }
}
    `;

/**
 * __useGetCustomerAssetsByValuesQuery__
 *
 * To run a query within a React component, call `useGetCustomerAssetsByValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAssetsByValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAssetsByValuesQuery({
 *   variables: {
 *      values: // value for 'values'
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetCustomerAssetsByValuesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAssetsByValuesQuery, GetCustomerAssetsByValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAssetsByValuesQuery, GetCustomerAssetsByValuesQueryVariables>(GetCustomerAssetsByValuesDocument, options);
      }
export function useGetCustomerAssetsByValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAssetsByValuesQuery, GetCustomerAssetsByValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAssetsByValuesQuery, GetCustomerAssetsByValuesQueryVariables>(GetCustomerAssetsByValuesDocument, options);
        }
export type GetCustomerAssetsByValuesQueryHookResult = ReturnType<typeof useGetCustomerAssetsByValuesQuery>;
export type GetCustomerAssetsByValuesLazyQueryHookResult = ReturnType<typeof useGetCustomerAssetsByValuesLazyQuery>;
export type GetCustomerAssetsByValuesQueryResult = Apollo.QueryResult<GetCustomerAssetsByValuesQuery, GetCustomerAssetsByValuesQueryVariables>;
export const BulkUpdateBrandForReportsDocument = gql`
    mutation BulkUpdateBrandForReports($ids: [uuid!]!, $brand_id: uuid!, $audit_logs: [collection_report_changes_insert_input!]!) {
  update_spoofing_reports(
    where: {id: {_in: $ids}}
    _set: {original_entity_id: $brand_id}
  ) {
    returning {
      id
      original_entity_id
    }
  }
  insert_collection_report_changes(objects: $audit_logs) {
    returning {
      id
    }
  }
}
    `;
export type BulkUpdateBrandForReportsMutationFn = Apollo.MutationFunction<BulkUpdateBrandForReportsMutation, BulkUpdateBrandForReportsMutationVariables>;

/**
 * __useBulkUpdateBrandForReportsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateBrandForReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateBrandForReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateBrandForReportsMutation, { data, loading, error }] = useBulkUpdateBrandForReportsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      brand_id: // value for 'brand_id'
 *      audit_logs: // value for 'audit_logs'
 *   },
 * });
 */
export function useBulkUpdateBrandForReportsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateBrandForReportsMutation, BulkUpdateBrandForReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateBrandForReportsMutation, BulkUpdateBrandForReportsMutationVariables>(BulkUpdateBrandForReportsDocument, options);
      }
export type BulkUpdateBrandForReportsMutationHookResult = ReturnType<typeof useBulkUpdateBrandForReportsMutation>;
export type BulkUpdateBrandForReportsMutationResult = Apollo.MutationResult<BulkUpdateBrandForReportsMutation>;
export type BulkUpdateBrandForReportsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateBrandForReportsMutation, BulkUpdateBrandForReportsMutationVariables>;
export const GetUserByIdDocument = gql`
    query GetUserById($id: uuid!) {
  users(where: {id: {_eq: $id}}) {
    id
    email
    name
    is_internal
    organization_id
    app_settings
    optery_member_uuid
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetUserEmailByIdDocument = gql`
    query GetUserEmailById($id: uuid!) {
  users(where: {id: {_eq: $id}}) {
    email
  }
}
    `;

/**
 * __useGetUserEmailByIdQuery__
 *
 * To run a query within a React component, call `useGetUserEmailByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEmailByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEmailByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserEmailByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserEmailByIdQuery, GetUserEmailByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEmailByIdQuery, GetUserEmailByIdQueryVariables>(GetUserEmailByIdDocument, options);
      }
export function useGetUserEmailByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEmailByIdQuery, GetUserEmailByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEmailByIdQuery, GetUserEmailByIdQueryVariables>(GetUserEmailByIdDocument, options);
        }
export type GetUserEmailByIdQueryHookResult = ReturnType<typeof useGetUserEmailByIdQuery>;
export type GetUserEmailByIdLazyQueryHookResult = ReturnType<typeof useGetUserEmailByIdLazyQuery>;
export type GetUserEmailByIdQueryResult = Apollo.QueryResult<GetUserEmailByIdQuery, GetUserEmailByIdQueryVariables>;
export const UpdateAppSettingsForUserDocument = gql`
    mutation UpdateAppSettingsForUser($user_id: uuid!, $app_settings: jsonb!) {
  update_users(where: {id: {_eq: $user_id}}, _set: {app_settings: $app_settings}) {
    returning {
      id
      app_settings
    }
  }
}
    `;
export type UpdateAppSettingsForUserMutationFn = Apollo.MutationFunction<UpdateAppSettingsForUserMutation, UpdateAppSettingsForUserMutationVariables>;

/**
 * __useUpdateAppSettingsForUserMutation__
 *
 * To run a mutation, you first call `useUpdateAppSettingsForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppSettingsForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppSettingsForUserMutation, { data, loading, error }] = useUpdateAppSettingsForUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      app_settings: // value for 'app_settings'
 *   },
 * });
 */
export function useUpdateAppSettingsForUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppSettingsForUserMutation, UpdateAppSettingsForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppSettingsForUserMutation, UpdateAppSettingsForUserMutationVariables>(UpdateAppSettingsForUserDocument, options);
      }
export type UpdateAppSettingsForUserMutationHookResult = ReturnType<typeof useUpdateAppSettingsForUserMutation>;
export type UpdateAppSettingsForUserMutationResult = Apollo.MutationResult<UpdateAppSettingsForUserMutation>;
export type UpdateAppSettingsForUserMutationOptions = Apollo.BaseMutationOptions<UpdateAppSettingsForUserMutation, UpdateAppSettingsForUserMutationVariables>;
export const GetAllExternalUsersDocument = gql`
    query GetAllExternalUsers($organization_ids: [uuid!]) {
  users(
    order_by: {created_at: desc}
    where: {_and: [{is_internal: {_eq: false}}, {organizations: {organization_id: {_in: $organization_ids}}}], is_visible_temp: {_eq: true}}
  ) {
    id
    email
    name
    is_internal
    created_at
    app_settings
  }
}
    `;

/**
 * __useGetAllExternalUsersQuery__
 *
 * To run a query within a React component, call `useGetAllExternalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllExternalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllExternalUsersQuery({
 *   variables: {
 *      organization_ids: // value for 'organization_ids'
 *   },
 * });
 */
export function useGetAllExternalUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllExternalUsersQuery, GetAllExternalUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllExternalUsersQuery, GetAllExternalUsersQueryVariables>(GetAllExternalUsersDocument, options);
      }
export function useGetAllExternalUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllExternalUsersQuery, GetAllExternalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllExternalUsersQuery, GetAllExternalUsersQueryVariables>(GetAllExternalUsersDocument, options);
        }
export type GetAllExternalUsersQueryHookResult = ReturnType<typeof useGetAllExternalUsersQuery>;
export type GetAllExternalUsersLazyQueryHookResult = ReturnType<typeof useGetAllExternalUsersLazyQuery>;
export type GetAllExternalUsersQueryResult = Apollo.QueryResult<GetAllExternalUsersQuery, GetAllExternalUsersQueryVariables>;
export const GetAllUsersForOrganizationDocument = gql`
    query GetAllUsersForOrganization($organization_id: uuid!, $is_internal: Boolean) {
  users(
    order_by: {email: asc}
    where: {_and: [{is_internal: {_eq: $is_internal}}, {organizations: {organization_id: {_eq: $organization_id}}}], is_visible_temp: {_eq: true}, onboarding_status: {_neq: "deactivated"}}
  ) {
    id
    email
    name
    created_at
    organizations(where: {organization_id: {_eq: $organization_id}}) {
      role {
        name
      }
    }
    products(where: {organization_id: {_eq: $organization_id}}) {
      product
    }
    onboarding_status
  }
}
    `;

/**
 * __useGetAllUsersForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAllUsersForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersForOrganizationQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      is_internal: // value for 'is_internal'
 *   },
 * });
 */
export function useGetAllUsersForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetAllUsersForOrganizationQuery, GetAllUsersForOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUsersForOrganizationQuery, GetAllUsersForOrganizationQueryVariables>(GetAllUsersForOrganizationDocument, options);
      }
export function useGetAllUsersForOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersForOrganizationQuery, GetAllUsersForOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUsersForOrganizationQuery, GetAllUsersForOrganizationQueryVariables>(GetAllUsersForOrganizationDocument, options);
        }
export type GetAllUsersForOrganizationQueryHookResult = ReturnType<typeof useGetAllUsersForOrganizationQuery>;
export type GetAllUsersForOrganizationLazyQueryHookResult = ReturnType<typeof useGetAllUsersForOrganizationLazyQuery>;
export type GetAllUsersForOrganizationQueryResult = Apollo.QueryResult<GetAllUsersForOrganizationQuery, GetAllUsersForOrganizationQueryVariables>;
export const GetEnforcementDetailsBySpoofingReportIdDocument = gql`
    query GetEnforcementDetailsBySpoofingReportId($spoofing_report_id: uuid!) {
  spoofing_reports_by_pk(id: $spoofing_report_id) {
    flagged_url
    enforcement_requests {
      ...ENFORCEMENT_REQUESTS
    }
    collection_report_changes(
      where: {type: {_in: ["enforcement_email_status", "enforcement_request_status"]}}
    ) {
      enforcement_request_id
      new_value
      old_value
      source
      timestamp
      type
      user {
        name
        is_internal
      }
      enforcement_request {
        platform
        type
      }
      enforcement_email {
        type
      }
    }
  }
}
    ${Enforcement_RequestsFragmentDoc}`;

/**
 * __useGetEnforcementDetailsBySpoofingReportIdQuery__
 *
 * To run a query within a React component, call `useGetEnforcementDetailsBySpoofingReportIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementDetailsBySpoofingReportIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementDetailsBySpoofingReportIdQuery({
 *   variables: {
 *      spoofing_report_id: // value for 'spoofing_report_id'
 *   },
 * });
 */
export function useGetEnforcementDetailsBySpoofingReportIdQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementDetailsBySpoofingReportIdQuery, GetEnforcementDetailsBySpoofingReportIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementDetailsBySpoofingReportIdQuery, GetEnforcementDetailsBySpoofingReportIdQueryVariables>(GetEnforcementDetailsBySpoofingReportIdDocument, options);
      }
export function useGetEnforcementDetailsBySpoofingReportIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementDetailsBySpoofingReportIdQuery, GetEnforcementDetailsBySpoofingReportIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementDetailsBySpoofingReportIdQuery, GetEnforcementDetailsBySpoofingReportIdQueryVariables>(GetEnforcementDetailsBySpoofingReportIdDocument, options);
        }
export type GetEnforcementDetailsBySpoofingReportIdQueryHookResult = ReturnType<typeof useGetEnforcementDetailsBySpoofingReportIdQuery>;
export type GetEnforcementDetailsBySpoofingReportIdLazyQueryHookResult = ReturnType<typeof useGetEnforcementDetailsBySpoofingReportIdLazyQuery>;
export type GetEnforcementDetailsBySpoofingReportIdQueryResult = Apollo.QueryResult<GetEnforcementDetailsBySpoofingReportIdQuery, GetEnforcementDetailsBySpoofingReportIdQueryVariables>;
export const GetEnforcementMetadataDocument = gql`
    query GetEnforcementMetadata($org_id: uuid!) {
  enforcement_metadata(where: {organization_id: {_eq: $org_id}}) {
    authorization_letter_url
    enforcement_email
    legal_name
    country_code
    authorization_letter_url_expiration_date
    allowed_domain_enforcement_types
  }
}
    `;

/**
 * __useGetEnforcementMetadataQuery__
 *
 * To run a query within a React component, call `useGetEnforcementMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementMetadataQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetEnforcementMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementMetadataQuery, GetEnforcementMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementMetadataQuery, GetEnforcementMetadataQueryVariables>(GetEnforcementMetadataDocument, options);
      }
export function useGetEnforcementMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementMetadataQuery, GetEnforcementMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementMetadataQuery, GetEnforcementMetadataQueryVariables>(GetEnforcementMetadataDocument, options);
        }
export type GetEnforcementMetadataQueryHookResult = ReturnType<typeof useGetEnforcementMetadataQuery>;
export type GetEnforcementMetadataLazyQueryHookResult = ReturnType<typeof useGetEnforcementMetadataLazyQuery>;
export type GetEnforcementMetadataQueryResult = Apollo.QueryResult<GetEnforcementMetadataQuery, GetEnforcementMetadataQueryVariables>;
export const InsertEnforcementEmailDocument = gql`
    mutation InsertEnforcementEmail($sender: String!, $receiver: String!, $subject: String!, $received_at: timestamp!, $type: String!) {
  insert_enforcement_emails_one(
    object: {sender: $sender, receiver: $receiver, subject: $subject, received_at: $received_at, type: $type}
  ) {
    id
  }
}
    `;
export type InsertEnforcementEmailMutationFn = Apollo.MutationFunction<InsertEnforcementEmailMutation, InsertEnforcementEmailMutationVariables>;

/**
 * __useInsertEnforcementEmailMutation__
 *
 * To run a mutation, you first call `useInsertEnforcementEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertEnforcementEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertEnforcementEmailMutation, { data, loading, error }] = useInsertEnforcementEmailMutation({
 *   variables: {
 *      sender: // value for 'sender'
 *      receiver: // value for 'receiver'
 *      subject: // value for 'subject'
 *      received_at: // value for 'received_at'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useInsertEnforcementEmailMutation(baseOptions?: Apollo.MutationHookOptions<InsertEnforcementEmailMutation, InsertEnforcementEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertEnforcementEmailMutation, InsertEnforcementEmailMutationVariables>(InsertEnforcementEmailDocument, options);
      }
export type InsertEnforcementEmailMutationHookResult = ReturnType<typeof useInsertEnforcementEmailMutation>;
export type InsertEnforcementEmailMutationResult = Apollo.MutationResult<InsertEnforcementEmailMutation>;
export type InsertEnforcementEmailMutationOptions = Apollo.BaseMutationOptions<InsertEnforcementEmailMutation, InsertEnforcementEmailMutationVariables>;
export const InsertCollectionReportChangesDocument = gql`
    mutation InsertCollectionReportChanges($type: String!, $old_value: String!, $new_value: String!, $user_id: uuid!, $spoof_report_id: uuid, $source: String!, $enforcement_request_id: uuid, $enforcement_email_id: uuid, $timestamp: timestamp) {
  insert_collection_report_changes_one(
    object: {type: $type, old_value: $old_value, new_value: $new_value, user_id: $user_id, spoof_report_id: $spoof_report_id, source: $source, enforcement_request_id: $enforcement_request_id, enforcement_email_id: $enforcement_email_id, timestamp: $timestamp}
  ) {
    id
  }
}
    `;
export type InsertCollectionReportChangesMutationFn = Apollo.MutationFunction<InsertCollectionReportChangesMutation, InsertCollectionReportChangesMutationVariables>;

/**
 * __useInsertCollectionReportChangesMutation__
 *
 * To run a mutation, you first call `useInsertCollectionReportChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertCollectionReportChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertCollectionReportChangesMutation, { data, loading, error }] = useInsertCollectionReportChangesMutation({
 *   variables: {
 *      type: // value for 'type'
 *      old_value: // value for 'old_value'
 *      new_value: // value for 'new_value'
 *      user_id: // value for 'user_id'
 *      spoof_report_id: // value for 'spoof_report_id'
 *      source: // value for 'source'
 *      enforcement_request_id: // value for 'enforcement_request_id'
 *      enforcement_email_id: // value for 'enforcement_email_id'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useInsertCollectionReportChangesMutation(baseOptions?: Apollo.MutationHookOptions<InsertCollectionReportChangesMutation, InsertCollectionReportChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertCollectionReportChangesMutation, InsertCollectionReportChangesMutationVariables>(InsertCollectionReportChangesDocument, options);
      }
export type InsertCollectionReportChangesMutationHookResult = ReturnType<typeof useInsertCollectionReportChangesMutation>;
export type InsertCollectionReportChangesMutationResult = Apollo.MutationResult<InsertCollectionReportChangesMutation>;
export type InsertCollectionReportChangesMutationOptions = Apollo.BaseMutationOptions<InsertCollectionReportChangesMutation, InsertCollectionReportChangesMutationVariables>;
export const GetStatsDataDocument = gql`
    query GetStatsData($org_id: uuid!, $filter_by: jsonb, $group_by: String, $date_range: String, $start_date: String, $end_date: String, $is_init_run: Boolean, $graph_name: String, $stat_type: String) {
  get_stats_data(
    get_stats_data_input: {organization_id: $org_id, filter_by: $filter_by, group_by: $group_by, date_range: $date_range, start_date: $start_date, end_date: $end_date, is_init_run: $is_init_run, graph_name: $graph_name, stat_type: $stat_type}
  ) {
    data
  }
}
    `;

/**
 * __useGetStatsDataQuery__
 *
 * To run a query within a React component, call `useGetStatsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatsDataQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      filter_by: // value for 'filter_by'
 *      group_by: // value for 'group_by'
 *      date_range: // value for 'date_range'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      is_init_run: // value for 'is_init_run'
 *      graph_name: // value for 'graph_name'
 *      stat_type: // value for 'stat_type'
 *   },
 * });
 */
export function useGetStatsDataQuery(baseOptions: Apollo.QueryHookOptions<GetStatsDataQuery, GetStatsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatsDataQuery, GetStatsDataQueryVariables>(GetStatsDataDocument, options);
      }
export function useGetStatsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatsDataQuery, GetStatsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatsDataQuery, GetStatsDataQueryVariables>(GetStatsDataDocument, options);
        }
export type GetStatsDataQueryHookResult = ReturnType<typeof useGetStatsDataQuery>;
export type GetStatsDataLazyQueryHookResult = ReturnType<typeof useGetStatsDataLazyQuery>;
export type GetStatsDataQueryResult = Apollo.QueryResult<GetStatsDataQuery, GetStatsDataQueryVariables>;
export const UpsertNotificationSubscriptionDocument = gql`
    mutation UpsertNotificationSubscription($id: uuid, $org_id: uuid!, $sendgrid_template_id: String, $notification_type: String!, $frequency: String, $slack_channel_id: String, $emails_to_notify: jsonb, $platform: String!, $updated_by: uuid!, $first_notification_date: timestamp, $report_type: String) {
  insert_notification_subscriptions(
    objects: {org_id: $org_id, sendgrid_template_id: $sendgrid_template_id, notification_type: $notification_type, frequency: $frequency, slack_channel_id: $slack_channel_id, emails_to_notify: $emails_to_notify, platform: $platform, updated_by: $updated_by, first_notification_date: $first_notification_date, report_type: $report_type}
    on_conflict: {constraint: notification_subscriptions_pkey, update_columns: [sendgrid_template_id, frequency, slack_channel_id, emails_to_notify, platform, updated_by, first_notification_date, report_type]}
  ) {
    returning {
      id
      org_id
      sendgrid_template_id
      notification_type
      frequency
      slack_channel_id
      emails_to_notify
      platform
      updated_by
      first_notification_date
      report_type
    }
  }
}
    `;
export type UpsertNotificationSubscriptionMutationFn = Apollo.MutationFunction<UpsertNotificationSubscriptionMutation, UpsertNotificationSubscriptionMutationVariables>;

/**
 * __useUpsertNotificationSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpsertNotificationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNotificationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNotificationSubscriptionMutation, { data, loading, error }] = useUpsertNotificationSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      org_id: // value for 'org_id'
 *      sendgrid_template_id: // value for 'sendgrid_template_id'
 *      notification_type: // value for 'notification_type'
 *      frequency: // value for 'frequency'
 *      slack_channel_id: // value for 'slack_channel_id'
 *      emails_to_notify: // value for 'emails_to_notify'
 *      platform: // value for 'platform'
 *      updated_by: // value for 'updated_by'
 *      first_notification_date: // value for 'first_notification_date'
 *      report_type: // value for 'report_type'
 *   },
 * });
 */
export function useUpsertNotificationSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertNotificationSubscriptionMutation, UpsertNotificationSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertNotificationSubscriptionMutation, UpsertNotificationSubscriptionMutationVariables>(UpsertNotificationSubscriptionDocument, options);
      }
export type UpsertNotificationSubscriptionMutationHookResult = ReturnType<typeof useUpsertNotificationSubscriptionMutation>;
export type UpsertNotificationSubscriptionMutationResult = Apollo.MutationResult<UpsertNotificationSubscriptionMutation>;
export type UpsertNotificationSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpsertNotificationSubscriptionMutation, UpsertNotificationSubscriptionMutationVariables>;
export const GetNotificationSubscriptionsByOrgDocument = gql`
    query GetNotificationSubscriptionsByOrg($org_id: uuid!, $offset: Int, $limit: Int, $order_by: [notification_subscriptions_order_by!]) {
  notification_subscriptions(
    where: {org_id: {_eq: $org_id}}
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    id
    org_id
    sendgrid_template_id
    notification_type
    frequency
    slack_channel_id
    emails_to_notify
    platform
    created_at
    updated_at
    user {
      name
      email
      is_internal
    }
    organization {
      id
      slack_access_token
    }
    first_notification_date
    report_type
  }
}
    `;

/**
 * __useGetNotificationSubscriptionsByOrgQuery__
 *
 * To run a query within a React component, call `useGetNotificationSubscriptionsByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationSubscriptionsByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationSubscriptionsByOrgQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetNotificationSubscriptionsByOrgQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationSubscriptionsByOrgQuery, GetNotificationSubscriptionsByOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationSubscriptionsByOrgQuery, GetNotificationSubscriptionsByOrgQueryVariables>(GetNotificationSubscriptionsByOrgDocument, options);
      }
export function useGetNotificationSubscriptionsByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationSubscriptionsByOrgQuery, GetNotificationSubscriptionsByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationSubscriptionsByOrgQuery, GetNotificationSubscriptionsByOrgQueryVariables>(GetNotificationSubscriptionsByOrgDocument, options);
        }
export type GetNotificationSubscriptionsByOrgQueryHookResult = ReturnType<typeof useGetNotificationSubscriptionsByOrgQuery>;
export type GetNotificationSubscriptionsByOrgLazyQueryHookResult = ReturnType<typeof useGetNotificationSubscriptionsByOrgLazyQuery>;
export type GetNotificationSubscriptionsByOrgQueryResult = Apollo.QueryResult<GetNotificationSubscriptionsByOrgQuery, GetNotificationSubscriptionsByOrgQueryVariables>;
export const DeleteNotificationSubscriptionDocument = gql`
    mutation DeleteNotificationSubscription($ids: [uuid!]!) {
  delete_notification_subscriptions(where: {id: {_in: $ids}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteNotificationSubscriptionMutationFn = Apollo.MutationFunction<DeleteNotificationSubscriptionMutation, DeleteNotificationSubscriptionMutationVariables>;

/**
 * __useDeleteNotificationSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationSubscriptionMutation, { data, loading, error }] = useDeleteNotificationSubscriptionMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteNotificationSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationSubscriptionMutation, DeleteNotificationSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationSubscriptionMutation, DeleteNotificationSubscriptionMutationVariables>(DeleteNotificationSubscriptionDocument, options);
      }
export type DeleteNotificationSubscriptionMutationHookResult = ReturnType<typeof useDeleteNotificationSubscriptionMutation>;
export type DeleteNotificationSubscriptionMutationResult = Apollo.MutationResult<DeleteNotificationSubscriptionMutation>;
export type DeleteNotificationSubscriptionMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationSubscriptionMutation, DeleteNotificationSubscriptionMutationVariables>;
export const GetNotificationSubscriptionCountByOrgDocument = gql`
    query GetNotificationSubscriptionCountByOrg($org_id: uuid!) {
  notification_subscriptions_aggregate(where: {org_id: {_eq: $org_id}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetNotificationSubscriptionCountByOrgQuery__
 *
 * To run a query within a React component, call `useGetNotificationSubscriptionCountByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationSubscriptionCountByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationSubscriptionCountByOrgQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetNotificationSubscriptionCountByOrgQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationSubscriptionCountByOrgQuery, GetNotificationSubscriptionCountByOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationSubscriptionCountByOrgQuery, GetNotificationSubscriptionCountByOrgQueryVariables>(GetNotificationSubscriptionCountByOrgDocument, options);
      }
export function useGetNotificationSubscriptionCountByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationSubscriptionCountByOrgQuery, GetNotificationSubscriptionCountByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationSubscriptionCountByOrgQuery, GetNotificationSubscriptionCountByOrgQueryVariables>(GetNotificationSubscriptionCountByOrgDocument, options);
        }
export type GetNotificationSubscriptionCountByOrgQueryHookResult = ReturnType<typeof useGetNotificationSubscriptionCountByOrgQuery>;
export type GetNotificationSubscriptionCountByOrgLazyQueryHookResult = ReturnType<typeof useGetNotificationSubscriptionCountByOrgLazyQuery>;
export type GetNotificationSubscriptionCountByOrgQueryResult = Apollo.QueryResult<GetNotificationSubscriptionCountByOrgQuery, GetNotificationSubscriptionCountByOrgQueryVariables>;
export const GetReportMatchesDocument = gql`
    query GetReportMatches($report_id: uuid!, $includeCreditCardData: Boolean! = false) {
  spoof_matches(where: {spoof_report_id: {_eq: $report_id}}) {
    id
    full_url {
      ...FULL_URL
    }
    social_media_data {
      ...SOCIAL_MEDIA_DATA
    }
    mobile_app {
      ...MOBILE_APP
    }
    dark_web {
      ...DARK_WEB
    }
    phone_number {
      ...PHONE_NUMBER
    }
    advertisement_data {
      ...ADVERTISEMENT_DATA
    }
    classification
    social_media_post {
      ...SOCIAL_MEDIA_POST
    }
    ecommerce_listing {
      ...ECOMMERCE_LISTING
    }
    suspicion_score
    ml_features {
      id
      name
      threshold
      value
      detection_asset {
        type
        value
      }
    }
  }
}
    ${Full_UrlFragmentDoc}
${Social_Media_DataFragmentDoc}
${Mobile_AppFragmentDoc}
${Dark_WebFragmentDoc}
${Phone_NumberFragmentDoc}
${Advertisement_DataFragmentDoc}
${Social_Media_PostFragmentDoc}
${Ecommerce_ListingFragmentDoc}`;

/**
 * __useGetReportMatchesQuery__
 *
 * To run a query within a React component, call `useGetReportMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportMatchesQuery({
 *   variables: {
 *      report_id: // value for 'report_id'
 *      includeCreditCardData: // value for 'includeCreditCardData'
 *   },
 * });
 */
export function useGetReportMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetReportMatchesQuery, GetReportMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportMatchesQuery, GetReportMatchesQueryVariables>(GetReportMatchesDocument, options);
      }
export function useGetReportMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportMatchesQuery, GetReportMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportMatchesQuery, GetReportMatchesQueryVariables>(GetReportMatchesDocument, options);
        }
export type GetReportMatchesQueryHookResult = ReturnType<typeof useGetReportMatchesQuery>;
export type GetReportMatchesLazyQueryHookResult = ReturnType<typeof useGetReportMatchesLazyQuery>;
export type GetReportMatchesQueryResult = Apollo.QueryResult<GetReportMatchesQuery, GetReportMatchesQueryVariables>;
export const GetAiPromptsForDefaultActionDocument = gql`
    query GetAiPromptsForDefaultAction($role: String!, $type: String!, $platform: String!, $sub_type: String!) {
  ai_prompts(
    where: {_and: [{role: {_eq: $role}}, {type: {_eq: $type}}, {platform: {_eq: $platform}}, {metadata: {_contains: {type: $sub_type}}}, {org_id: {_is_null: true}}]}
  ) {
    ...AiPromptFields
  }
}
    ${AiPromptFieldsFragmentDoc}`;

/**
 * __useGetAiPromptsForDefaultActionQuery__
 *
 * To run a query within a React component, call `useGetAiPromptsForDefaultActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiPromptsForDefaultActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiPromptsForDefaultActionQuery({
 *   variables: {
 *      role: // value for 'role'
 *      type: // value for 'type'
 *      platform: // value for 'platform'
 *      sub_type: // value for 'sub_type'
 *   },
 * });
 */
export function useGetAiPromptsForDefaultActionQuery(baseOptions: Apollo.QueryHookOptions<GetAiPromptsForDefaultActionQuery, GetAiPromptsForDefaultActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiPromptsForDefaultActionQuery, GetAiPromptsForDefaultActionQueryVariables>(GetAiPromptsForDefaultActionDocument, options);
      }
export function useGetAiPromptsForDefaultActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiPromptsForDefaultActionQuery, GetAiPromptsForDefaultActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiPromptsForDefaultActionQuery, GetAiPromptsForDefaultActionQueryVariables>(GetAiPromptsForDefaultActionDocument, options);
        }
export type GetAiPromptsForDefaultActionQueryHookResult = ReturnType<typeof useGetAiPromptsForDefaultActionQuery>;
export type GetAiPromptsForDefaultActionLazyQueryHookResult = ReturnType<typeof useGetAiPromptsForDefaultActionLazyQuery>;
export type GetAiPromptsForDefaultActionQueryResult = Apollo.QueryResult<GetAiPromptsForDefaultActionQuery, GetAiPromptsForDefaultActionQueryVariables>;
export const RecordAiResponseFeedbackVotesDocument = gql`
    mutation recordAiResponseFeedbackVotes($id: uuid!, $upvotes: Int, $downvotes: Int) {
  update_ai_responses_by_pk(
    pk_columns: {id: $id}
    _inc: {upvotes: $upvotes, downvotes: $downvotes}
  ) {
    id
    upvotes
    downvotes
  }
}
    `;
export type RecordAiResponseFeedbackVotesMutationFn = Apollo.MutationFunction<RecordAiResponseFeedbackVotesMutation, RecordAiResponseFeedbackVotesMutationVariables>;

/**
 * __useRecordAiResponseFeedbackVotesMutation__
 *
 * To run a mutation, you first call `useRecordAiResponseFeedbackVotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordAiResponseFeedbackVotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordAiResponseFeedbackVotesMutation, { data, loading, error }] = useRecordAiResponseFeedbackVotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      upvotes: // value for 'upvotes'
 *      downvotes: // value for 'downvotes'
 *   },
 * });
 */
export function useRecordAiResponseFeedbackVotesMutation(baseOptions?: Apollo.MutationHookOptions<RecordAiResponseFeedbackVotesMutation, RecordAiResponseFeedbackVotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordAiResponseFeedbackVotesMutation, RecordAiResponseFeedbackVotesMutationVariables>(RecordAiResponseFeedbackVotesDocument, options);
      }
export type RecordAiResponseFeedbackVotesMutationHookResult = ReturnType<typeof useRecordAiResponseFeedbackVotesMutation>;
export type RecordAiResponseFeedbackVotesMutationResult = Apollo.MutationResult<RecordAiResponseFeedbackVotesMutation>;
export type RecordAiResponseFeedbackVotesMutationOptions = Apollo.BaseMutationOptions<RecordAiResponseFeedbackVotesMutation, RecordAiResponseFeedbackVotesMutationVariables>;
export const GetPiiReportsDocument = gql`
    query GetPIIReports($limit: Int, $offset: Int, $removalStatus: Int, $userId: uuid!) {
  get_pii_reports_with_screenshots(
    args: {p_limit: $limit, p_offset: $offset, p_removal_status: $removalStatus, p_user_id: $userId}
  ) {
    id
    user_id
    created_at
    exposure_status
    exposure_status_description
    removal_status
    removal_status_description
    screenshot_found_image
    screenshot_found_created_at
    screenshot_notfound_created_at
    screenshot_notfound_image
    databroker_uuid
    databroker {
      databroker_uuid
      databroker_name
    }
  }
}
    `;

/**
 * __useGetPiiReportsQuery__
 *
 * To run a query within a React component, call `useGetPiiReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPiiReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPiiReportsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      removalStatus: // value for 'removalStatus'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPiiReportsQuery(baseOptions: Apollo.QueryHookOptions<GetPiiReportsQuery, GetPiiReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPiiReportsQuery, GetPiiReportsQueryVariables>(GetPiiReportsDocument, options);
      }
export function useGetPiiReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPiiReportsQuery, GetPiiReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPiiReportsQuery, GetPiiReportsQueryVariables>(GetPiiReportsDocument, options);
        }
export type GetPiiReportsQueryHookResult = ReturnType<typeof useGetPiiReportsQuery>;
export type GetPiiReportsLazyQueryHookResult = ReturnType<typeof useGetPiiReportsLazyQuery>;
export type GetPiiReportsQueryResult = Apollo.QueryResult<GetPiiReportsQuery, GetPiiReportsQueryVariables>;
export const GetPiiReportDetailsDocument = gql`
    query GetPIIReportDetails($userId: uuid!, $databroker_uuid: uuid!) {
  get_pii_reports_with_screenshots(
    args: {p_user_id: $userId, p_databroker_uuid: $databroker_uuid, p_limit: 1}
  ) {
    id
    created_at
    screenshot_found_image
    screenshot_found_created_at
    screenshot_notfound_image
    screenshot_notfound_created_at
    exposure_status_description
    removal_status_description
    exposure_url
    databroker_uuid
    databroker {
      databroker_uuid
      databroker_name
    }
  }
}
    `;

/**
 * __useGetPiiReportDetailsQuery__
 *
 * To run a query within a React component, call `useGetPiiReportDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPiiReportDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPiiReportDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      databroker_uuid: // value for 'databroker_uuid'
 *   },
 * });
 */
export function useGetPiiReportDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPiiReportDetailsQuery, GetPiiReportDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPiiReportDetailsQuery, GetPiiReportDetailsQueryVariables>(GetPiiReportDetailsDocument, options);
      }
export function useGetPiiReportDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPiiReportDetailsQuery, GetPiiReportDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPiiReportDetailsQuery, GetPiiReportDetailsQueryVariables>(GetPiiReportDetailsDocument, options);
        }
export type GetPiiReportDetailsQueryHookResult = ReturnType<typeof useGetPiiReportDetailsQuery>;
export type GetPiiReportDetailsLazyQueryHookResult = ReturnType<typeof useGetPiiReportDetailsLazyQuery>;
export type GetPiiReportDetailsQueryResult = Apollo.QueryResult<GetPiiReportDetailsQuery, GetPiiReportDetailsQueryVariables>;
export const GetPiiReportsCountsPerStatusDocument = gql`
    query GetPIIReportsCountsPerStatus($userId: uuid!) {
  pending: pii_reports_aggregate(
    where: {removal_status: {_eq: 0}, user_id: {_eq: $userId}}
  ) {
    aggregate {
      count
    }
  }
  submitted: pii_reports_aggregate(
    where: {removal_status: {_eq: 10}, user_id: {_eq: $userId}}
  ) {
    aggregate {
      count
    }
  }
  removed_not_found: pii_reports_aggregate(
    where: {removal_status: {_eq: 40}, user_id: {_eq: $userId}}
  ) {
    aggregate {
      count
    }
  }
  non_compliant: pii_reports_aggregate(
    where: {removal_status: {_eq: 50}, user_id: {_eq: $userId}}
  ) {
    aggregate {
      count
    }
  }
  escalation_in_progress: pii_reports_aggregate(
    where: {removal_status: {_eq: 60}, user_id: {_eq: $userId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPiiReportsCountsPerStatusQuery__
 *
 * To run a query within a React component, call `useGetPiiReportsCountsPerStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPiiReportsCountsPerStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPiiReportsCountsPerStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPiiReportsCountsPerStatusQuery(baseOptions: Apollo.QueryHookOptions<GetPiiReportsCountsPerStatusQuery, GetPiiReportsCountsPerStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPiiReportsCountsPerStatusQuery, GetPiiReportsCountsPerStatusQueryVariables>(GetPiiReportsCountsPerStatusDocument, options);
      }
export function useGetPiiReportsCountsPerStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPiiReportsCountsPerStatusQuery, GetPiiReportsCountsPerStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPiiReportsCountsPerStatusQuery, GetPiiReportsCountsPerStatusQueryVariables>(GetPiiReportsCountsPerStatusDocument, options);
        }
export type GetPiiReportsCountsPerStatusQueryHookResult = ReturnType<typeof useGetPiiReportsCountsPerStatusQuery>;
export type GetPiiReportsCountsPerStatusLazyQueryHookResult = ReturnType<typeof useGetPiiReportsCountsPerStatusLazyQuery>;
export type GetPiiReportsCountsPerStatusQueryResult = Apollo.QueryResult<GetPiiReportsCountsPerStatusQuery, GetPiiReportsCountsPerStatusQueryVariables>;
export const GetPiiStatisticsDocument = gql`
    query GetPIIStatistics($userId: uuid!, $dateFrom: date, $dateTo: date) {
  pii_statistics(
    order_by: {date: asc}
    where: {user_id: {_eq: $userId}, date: {_gte: $dateFrom, _lte: $dateTo}}
  ) {
    id
    user_id
    date
    db_covered
    exposed
    removals_in_progress
    removals_pending
    removed_not_found
    total_removed_not_found
  }
}
    `;

/**
 * __useGetPiiStatisticsQuery__
 *
 * To run a query within a React component, call `useGetPiiStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPiiStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPiiStatisticsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useGetPiiStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetPiiStatisticsQuery, GetPiiStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPiiStatisticsQuery, GetPiiStatisticsQueryVariables>(GetPiiStatisticsDocument, options);
      }
export function useGetPiiStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPiiStatisticsQuery, GetPiiStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPiiStatisticsQuery, GetPiiStatisticsQueryVariables>(GetPiiStatisticsDocument, options);
        }
export type GetPiiStatisticsQueryHookResult = ReturnType<typeof useGetPiiStatisticsQuery>;
export type GetPiiStatisticsLazyQueryHookResult = ReturnType<typeof useGetPiiStatisticsLazyQuery>;
export type GetPiiStatisticsQueryResult = Apollo.QueryResult<GetPiiStatisticsQuery, GetPiiStatisticsQueryVariables>;
export const GetLatestPiiStatisticsDocument = gql`
    query GetLatestPIIStatistics($userId: uuid!) {
  pii_statistics(
    order_by: {date: desc}
    limit: 1
    where: {user_id: {_eq: $userId}}
  ) {
    id
    user_id
    date
    db_covered
    exposed
    removals_in_progress
    removals_pending
    removed_not_found
    total_removed_not_found
  }
}
    `;

/**
 * __useGetLatestPiiStatisticsQuery__
 *
 * To run a query within a React component, call `useGetLatestPiiStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestPiiStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestPiiStatisticsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetLatestPiiStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetLatestPiiStatisticsQuery, GetLatestPiiStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestPiiStatisticsQuery, GetLatestPiiStatisticsQueryVariables>(GetLatestPiiStatisticsDocument, options);
      }
export function useGetLatestPiiStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestPiiStatisticsQuery, GetLatestPiiStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestPiiStatisticsQuery, GetLatestPiiStatisticsQueryVariables>(GetLatestPiiStatisticsDocument, options);
        }
export type GetLatestPiiStatisticsQueryHookResult = ReturnType<typeof useGetLatestPiiStatisticsQuery>;
export type GetLatestPiiStatisticsLazyQueryHookResult = ReturnType<typeof useGetLatestPiiStatisticsLazyQuery>;
export type GetLatestPiiStatisticsQueryResult = Apollo.QueryResult<GetLatestPiiStatisticsQuery, GetLatestPiiStatisticsQueryVariables>;
export const GetUploadedFilesDocument = gql`
    query GetUploadedFiles($spoof_report_id: uuid!) {
  uploaded_files(where: {spoofing_report_id: {_eq: $spoof_report_id}}) {
    file_name
    created_at
    user {
      email
    }
  }
}
    `;

/**
 * __useGetUploadedFilesQuery__
 *
 * To run a query within a React component, call `useGetUploadedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadedFilesQuery({
 *   variables: {
 *      spoof_report_id: // value for 'spoof_report_id'
 *   },
 * });
 */
export function useGetUploadedFilesQuery(baseOptions: Apollo.QueryHookOptions<GetUploadedFilesQuery, GetUploadedFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadedFilesQuery, GetUploadedFilesQueryVariables>(GetUploadedFilesDocument, options);
      }
export function useGetUploadedFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadedFilesQuery, GetUploadedFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadedFilesQuery, GetUploadedFilesQueryVariables>(GetUploadedFilesDocument, options);
        }
export type GetUploadedFilesQueryHookResult = ReturnType<typeof useGetUploadedFilesQuery>;
export type GetUploadedFilesLazyQueryHookResult = ReturnType<typeof useGetUploadedFilesLazyQuery>;
export type GetUploadedFilesQueryResult = Apollo.QueryResult<GetUploadedFilesQuery, GetUploadedFilesQueryVariables>;
export const GetPiiLeaksByDatabrokerDocument = gql`
    query GetPIILeaksByDatabroker($user_id: uuid!, $limit: Int) {
  pii_leaks_by_databroker(where: {user_id: {_eq: $user_id}}, limit: $limit) {
    databroker_name
    leak_count
  }
}
    `;

/**
 * __useGetPiiLeaksByDatabrokerQuery__
 *
 * To run a query within a React component, call `useGetPiiLeaksByDatabrokerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPiiLeaksByDatabrokerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPiiLeaksByDatabrokerQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPiiLeaksByDatabrokerQuery(baseOptions: Apollo.QueryHookOptions<GetPiiLeaksByDatabrokerQuery, GetPiiLeaksByDatabrokerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPiiLeaksByDatabrokerQuery, GetPiiLeaksByDatabrokerQueryVariables>(GetPiiLeaksByDatabrokerDocument, options);
      }
export function useGetPiiLeaksByDatabrokerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPiiLeaksByDatabrokerQuery, GetPiiLeaksByDatabrokerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPiiLeaksByDatabrokerQuery, GetPiiLeaksByDatabrokerQueryVariables>(GetPiiLeaksByDatabrokerDocument, options);
        }
export type GetPiiLeaksByDatabrokerQueryHookResult = ReturnType<typeof useGetPiiLeaksByDatabrokerQuery>;
export type GetPiiLeaksByDatabrokerLazyQueryHookResult = ReturnType<typeof useGetPiiLeaksByDatabrokerLazyQuery>;
export type GetPiiLeaksByDatabrokerQueryResult = Apollo.QueryResult<GetPiiLeaksByDatabrokerQuery, GetPiiLeaksByDatabrokerQueryVariables>;
export const GetPurchasableDomainsDocument = gql`
    query GetPurchasableDomains($offset: Int, $limit: Int, $where: defensive_domain_registration_bool_exp!, $orderBy: defensive_domain_registration_order_by!) {
  defensive_domain_registration(
    offset: $offset
    limit: $limit
    where: $where
    order_by: [$orderBy]
  ) {
    domain_data {
      root_domain
    }
    price
    status
    purchased_at
    updated_at
    domain_data_id
    id
    spoofing_report {
      id
      report_status
      external_id
    }
  }
}
    `;

/**
 * __useGetPurchasableDomainsQuery__
 *
 * To run a query within a React component, call `useGetPurchasableDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchasableDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchasableDomainsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPurchasableDomainsQuery(baseOptions: Apollo.QueryHookOptions<GetPurchasableDomainsQuery, GetPurchasableDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchasableDomainsQuery, GetPurchasableDomainsQueryVariables>(GetPurchasableDomainsDocument, options);
      }
export function useGetPurchasableDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchasableDomainsQuery, GetPurchasableDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchasableDomainsQuery, GetPurchasableDomainsQueryVariables>(GetPurchasableDomainsDocument, options);
        }
export type GetPurchasableDomainsQueryHookResult = ReturnType<typeof useGetPurchasableDomainsQuery>;
export type GetPurchasableDomainsLazyQueryHookResult = ReturnType<typeof useGetPurchasableDomainsLazyQuery>;
export type GetPurchasableDomainsQueryResult = Apollo.QueryResult<GetPurchasableDomainsQuery, GetPurchasableDomainsQueryVariables>;
export const GetPurchasableDomainStatusCountsDocument = gql`
    query GetPurchasableDomainStatusCounts($organization_id: uuid!) {
  available: defensive_domain_registration_aggregate(
    where: {status: {_eq: "available"}, organization_id: {_eq: $organization_id}}
  ) {
    aggregate {
      count
    }
  }
  requested: defensive_domain_registration_aggregate(
    where: {status: {_eq: "requested"}, organization_id: {_eq: $organization_id}}
  ) {
    aggregate {
      count
    }
  }
  purchased: defensive_domain_registration_aggregate(
    where: {status: {_eq: "purchased"}, organization_id: {_eq: $organization_id}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetPurchasableDomainStatusCountsQuery__
 *
 * To run a query within a React component, call `useGetPurchasableDomainStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchasableDomainStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchasableDomainStatusCountsQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetPurchasableDomainStatusCountsQuery(baseOptions: Apollo.QueryHookOptions<GetPurchasableDomainStatusCountsQuery, GetPurchasableDomainStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchasableDomainStatusCountsQuery, GetPurchasableDomainStatusCountsQueryVariables>(GetPurchasableDomainStatusCountsDocument, options);
      }
export function useGetPurchasableDomainStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchasableDomainStatusCountsQuery, GetPurchasableDomainStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchasableDomainStatusCountsQuery, GetPurchasableDomainStatusCountsQueryVariables>(GetPurchasableDomainStatusCountsDocument, options);
        }
export type GetPurchasableDomainStatusCountsQueryHookResult = ReturnType<typeof useGetPurchasableDomainStatusCountsQuery>;
export type GetPurchasableDomainStatusCountsLazyQueryHookResult = ReturnType<typeof useGetPurchasableDomainStatusCountsLazyQuery>;
export type GetPurchasableDomainStatusCountsQueryResult = Apollo.QueryResult<GetPurchasableDomainStatusCountsQuery, GetPurchasableDomainStatusCountsQueryVariables>;
export const UpdateDefensiveDomainRegistrationManyDocument = gql`
    mutation updateDefensiveDomainRegistrationMany($ids: [uuid!]!, $newStatus: String!) {
  update_defensive_domain_registration(
    where: {id: {_in: $ids}}
    _set: {status: $newStatus}
  ) {
    returning {
      id
      status
    }
  }
}
    `;
export type UpdateDefensiveDomainRegistrationManyMutationFn = Apollo.MutationFunction<UpdateDefensiveDomainRegistrationManyMutation, UpdateDefensiveDomainRegistrationManyMutationVariables>;

/**
 * __useUpdateDefensiveDomainRegistrationManyMutation__
 *
 * To run a mutation, you first call `useUpdateDefensiveDomainRegistrationManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefensiveDomainRegistrationManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefensiveDomainRegistrationManyMutation, { data, loading, error }] = useUpdateDefensiveDomainRegistrationManyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useUpdateDefensiveDomainRegistrationManyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefensiveDomainRegistrationManyMutation, UpdateDefensiveDomainRegistrationManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefensiveDomainRegistrationManyMutation, UpdateDefensiveDomainRegistrationManyMutationVariables>(UpdateDefensiveDomainRegistrationManyDocument, options);
      }
export type UpdateDefensiveDomainRegistrationManyMutationHookResult = ReturnType<typeof useUpdateDefensiveDomainRegistrationManyMutation>;
export type UpdateDefensiveDomainRegistrationManyMutationResult = Apollo.MutationResult<UpdateDefensiveDomainRegistrationManyMutation>;
export type UpdateDefensiveDomainRegistrationManyMutationOptions = Apollo.BaseMutationOptions<UpdateDefensiveDomainRegistrationManyMutation, UpdateDefensiveDomainRegistrationManyMutationVariables>;
export const GetTotalReportsInfoCountDocument = gql`
    query GetTotalReportsInfoCount($organization_id: uuid!, $start_date: timestamp, $end_date: timestamp, $type: [String!]!, $old_value: [String!]!, $new_value: [String!]!) {
  collection_report_changes_aggregate(
    where: {type: {_in: $type}, _or: [{old_value: {_in: $old_value}}, {old_value: {_is_null: true}}], new_value: {_in: $new_value}, spoofing_report: {organization_id: {_eq: $organization_id}}, timestamp: {_gte: $start_date, _lte: $end_date}}
    distinct_on: spoof_report_id
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetTotalReportsInfoCountQuery__
 *
 * To run a query within a React component, call `useGetTotalReportsInfoCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalReportsInfoCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalReportsInfoCountQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      type: // value for 'type'
 *      old_value: // value for 'old_value'
 *      new_value: // value for 'new_value'
 *   },
 * });
 */
export function useGetTotalReportsInfoCountQuery(baseOptions: Apollo.QueryHookOptions<GetTotalReportsInfoCountQuery, GetTotalReportsInfoCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalReportsInfoCountQuery, GetTotalReportsInfoCountQueryVariables>(GetTotalReportsInfoCountDocument, options);
      }
export function useGetTotalReportsInfoCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalReportsInfoCountQuery, GetTotalReportsInfoCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalReportsInfoCountQuery, GetTotalReportsInfoCountQueryVariables>(GetTotalReportsInfoCountDocument, options);
        }
export type GetTotalReportsInfoCountQueryHookResult = ReturnType<typeof useGetTotalReportsInfoCountQuery>;
export type GetTotalReportsInfoCountLazyQueryHookResult = ReturnType<typeof useGetTotalReportsInfoCountLazyQuery>;
export type GetTotalReportsInfoCountQueryResult = Apollo.QueryResult<GetTotalReportsInfoCountQuery, GetTotalReportsInfoCountQueryVariables>;
export const GetSpecificReportsInfoCountDocument = gql`
    query GetSpecificReportsInfoCount($organization_id: uuid!, $start_date: timestamp, $end_date: timestamp, $type: [String!]!, $new_value: String!) {
  collection_report_changes_aggregate(
    where: {type: {_in: $type}, new_value: {_eq: $new_value}, spoofing_report: {organization_id: {_eq: $organization_id}}, timestamp: {_gte: $start_date, _lte: $end_date}}
    distinct_on: spoof_report_id
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetSpecificReportsInfoCountQuery__
 *
 * To run a query within a React component, call `useGetSpecificReportsInfoCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecificReportsInfoCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecificReportsInfoCountQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      type: // value for 'type'
 *      new_value: // value for 'new_value'
 *   },
 * });
 */
export function useGetSpecificReportsInfoCountQuery(baseOptions: Apollo.QueryHookOptions<GetSpecificReportsInfoCountQuery, GetSpecificReportsInfoCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecificReportsInfoCountQuery, GetSpecificReportsInfoCountQueryVariables>(GetSpecificReportsInfoCountDocument, options);
      }
export function useGetSpecificReportsInfoCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecificReportsInfoCountQuery, GetSpecificReportsInfoCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecificReportsInfoCountQuery, GetSpecificReportsInfoCountQueryVariables>(GetSpecificReportsInfoCountDocument, options);
        }
export type GetSpecificReportsInfoCountQueryHookResult = ReturnType<typeof useGetSpecificReportsInfoCountQuery>;
export type GetSpecificReportsInfoCountLazyQueryHookResult = ReturnType<typeof useGetSpecificReportsInfoCountLazyQuery>;
export type GetSpecificReportsInfoCountQueryResult = Apollo.QueryResult<GetSpecificReportsInfoCountQuery, GetSpecificReportsInfoCountQueryVariables>;
export const GetEnforcementTypesDocument = gql`
    query GetEnforcementTypes($enforcementTypesWhere: enforcement_types_bool_exp!) {
  enforcement_types(where: $enforcementTypesWhere, order_by: {priority: asc}) {
    priority
    content_type
    content_type_display_name
    platform
    type
    updated_by
    enforcement_method_type
    enforcement_method_data
    enforcement_platform {
      platform
      notes
      types
    }
  }
}
    `;

/**
 * __useGetEnforcementTypesQuery__
 *
 * To run a query within a React component, call `useGetEnforcementTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementTypesQuery({
 *   variables: {
 *      enforcementTypesWhere: // value for 'enforcementTypesWhere'
 *   },
 * });
 */
export function useGetEnforcementTypesQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementTypesQuery, GetEnforcementTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementTypesQuery, GetEnforcementTypesQueryVariables>(GetEnforcementTypesDocument, options);
      }
export function useGetEnforcementTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementTypesQuery, GetEnforcementTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementTypesQuery, GetEnforcementTypesQueryVariables>(GetEnforcementTypesDocument, options);
        }
export type GetEnforcementTypesQueryHookResult = ReturnType<typeof useGetEnforcementTypesQuery>;
export type GetEnforcementTypesLazyQueryHookResult = ReturnType<typeof useGetEnforcementTypesLazyQuery>;
export type GetEnforcementTypesQueryResult = Apollo.QueryResult<GetEnforcementTypesQuery, GetEnforcementTypesQueryVariables>;
export const GetContentTypesByEnforcementPlatformDocument = gql`
    query GetContentTypesByEnforcementPlatform($platform: String!) {
  enforcement_types(where: {platform: {_eq: $platform}}) {
    content_type
    content_type_display_name
  }
}
    `;

/**
 * __useGetContentTypesByEnforcementPlatformQuery__
 *
 * To run a query within a React component, call `useGetContentTypesByEnforcementPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentTypesByEnforcementPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentTypesByEnforcementPlatformQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetContentTypesByEnforcementPlatformQuery(baseOptions: Apollo.QueryHookOptions<GetContentTypesByEnforcementPlatformQuery, GetContentTypesByEnforcementPlatformQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentTypesByEnforcementPlatformQuery, GetContentTypesByEnforcementPlatformQueryVariables>(GetContentTypesByEnforcementPlatformDocument, options);
      }
export function useGetContentTypesByEnforcementPlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentTypesByEnforcementPlatformQuery, GetContentTypesByEnforcementPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentTypesByEnforcementPlatformQuery, GetContentTypesByEnforcementPlatformQueryVariables>(GetContentTypesByEnforcementPlatformDocument, options);
        }
export type GetContentTypesByEnforcementPlatformQueryHookResult = ReturnType<typeof useGetContentTypesByEnforcementPlatformQuery>;
export type GetContentTypesByEnforcementPlatformLazyQueryHookResult = ReturnType<typeof useGetContentTypesByEnforcementPlatformLazyQuery>;
export type GetContentTypesByEnforcementPlatformQueryResult = Apollo.QueryResult<GetContentTypesByEnforcementPlatformQuery, GetContentTypesByEnforcementPlatformQueryVariables>;
export const GetContentTypesByEnforcementPlatformAndContentTypeDocument = gql`
    query GetContentTypesByEnforcementPlatformAndContentType($platform: String!, $content_type: String!) {
  enforcement_types(
    where: {platform: {_eq: $platform}, _and: {content_type: {_eq: $content_type}}}
  ) {
    content_type
    content_type_display_name
  }
}
    `;

/**
 * __useGetContentTypesByEnforcementPlatformAndContentTypeQuery__
 *
 * To run a query within a React component, call `useGetContentTypesByEnforcementPlatformAndContentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentTypesByEnforcementPlatformAndContentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentTypesByEnforcementPlatformAndContentTypeQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *      content_type: // value for 'content_type'
 *   },
 * });
 */
export function useGetContentTypesByEnforcementPlatformAndContentTypeQuery(baseOptions: Apollo.QueryHookOptions<GetContentTypesByEnforcementPlatformAndContentTypeQuery, GetContentTypesByEnforcementPlatformAndContentTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentTypesByEnforcementPlatformAndContentTypeQuery, GetContentTypesByEnforcementPlatformAndContentTypeQueryVariables>(GetContentTypesByEnforcementPlatformAndContentTypeDocument, options);
      }
export function useGetContentTypesByEnforcementPlatformAndContentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentTypesByEnforcementPlatformAndContentTypeQuery, GetContentTypesByEnforcementPlatformAndContentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentTypesByEnforcementPlatformAndContentTypeQuery, GetContentTypesByEnforcementPlatformAndContentTypeQueryVariables>(GetContentTypesByEnforcementPlatformAndContentTypeDocument, options);
        }
export type GetContentTypesByEnforcementPlatformAndContentTypeQueryHookResult = ReturnType<typeof useGetContentTypesByEnforcementPlatformAndContentTypeQuery>;
export type GetContentTypesByEnforcementPlatformAndContentTypeLazyQueryHookResult = ReturnType<typeof useGetContentTypesByEnforcementPlatformAndContentTypeLazyQuery>;
export type GetContentTypesByEnforcementPlatformAndContentTypeQueryResult = Apollo.QueryResult<GetContentTypesByEnforcementPlatformAndContentTypeQuery, GetContentTypesByEnforcementPlatformAndContentTypeQueryVariables>;
export const GetEnforcementTypesByContentTypeDocument = gql`
    query GetEnforcementTypesByContentType($platform: String!, $content_type_display_name: String!) {
  enforcement_types(
    where: {platform: {_eq: $platform}, _and: {content_type_display_name: {_eq: $content_type_display_name}}}
  ) {
    type
  }
}
    `;

/**
 * __useGetEnforcementTypesByContentTypeQuery__
 *
 * To run a query within a React component, call `useGetEnforcementTypesByContentTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementTypesByContentTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementTypesByContentTypeQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *      content_type_display_name: // value for 'content_type_display_name'
 *   },
 * });
 */
export function useGetEnforcementTypesByContentTypeQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementTypesByContentTypeQuery, GetEnforcementTypesByContentTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementTypesByContentTypeQuery, GetEnforcementTypesByContentTypeQueryVariables>(GetEnforcementTypesByContentTypeDocument, options);
      }
export function useGetEnforcementTypesByContentTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementTypesByContentTypeQuery, GetEnforcementTypesByContentTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementTypesByContentTypeQuery, GetEnforcementTypesByContentTypeQueryVariables>(GetEnforcementTypesByContentTypeDocument, options);
        }
export type GetEnforcementTypesByContentTypeQueryHookResult = ReturnType<typeof useGetEnforcementTypesByContentTypeQuery>;
export type GetEnforcementTypesByContentTypeLazyQueryHookResult = ReturnType<typeof useGetEnforcementTypesByContentTypeLazyQuery>;
export type GetEnforcementTypesByContentTypeQueryResult = Apollo.QueryResult<GetEnforcementTypesByContentTypeQuery, GetEnforcementTypesByContentTypeQueryVariables>;
export const GetGcsObjectDocument = gql`
    query GetGCSObject($bucket_name: String!, $object_name: String!, $include_object: Boolean, $exact_match: Boolean) {
  get_gcs_object(
    manage_gcs_objects_input: {request_type: "get", bucket_name: $bucket_name, object_name: $object_name, include_object: $include_object, exact_match: $exact_match}
  ) {
    object_info
  }
}
    `;

/**
 * __useGetGcsObjectQuery__
 *
 * To run a query within a React component, call `useGetGcsObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGcsObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGcsObjectQuery({
 *   variables: {
 *      bucket_name: // value for 'bucket_name'
 *      object_name: // value for 'object_name'
 *      include_object: // value for 'include_object'
 *      exact_match: // value for 'exact_match'
 *   },
 * });
 */
export function useGetGcsObjectQuery(baseOptions: Apollo.QueryHookOptions<GetGcsObjectQuery, GetGcsObjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGcsObjectQuery, GetGcsObjectQueryVariables>(GetGcsObjectDocument, options);
      }
export function useGetGcsObjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGcsObjectQuery, GetGcsObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGcsObjectQuery, GetGcsObjectQueryVariables>(GetGcsObjectDocument, options);
        }
export type GetGcsObjectQueryHookResult = ReturnType<typeof useGetGcsObjectQuery>;
export type GetGcsObjectLazyQueryHookResult = ReturnType<typeof useGetGcsObjectLazyQuery>;
export type GetGcsObjectQueryResult = Apollo.QueryResult<GetGcsObjectQuery, GetGcsObjectQueryVariables>;
export const DeleteGcsObjectDocument = gql`
    mutation DeleteGCSObject($bucket_name: String!, $object_name: String!, $generation_number: String) {
  modify_gcs_object(
    manage_gcs_objects_input: {request_type: "delete", bucket_name: $bucket_name, object_name: $object_name, generation_number: $generation_number}
  ) {
    message
  }
}
    `;
export type DeleteGcsObjectMutationFn = Apollo.MutationFunction<DeleteGcsObjectMutation, DeleteGcsObjectMutationVariables>;

/**
 * __useDeleteGcsObjectMutation__
 *
 * To run a mutation, you first call `useDeleteGcsObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGcsObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGcsObjectMutation, { data, loading, error }] = useDeleteGcsObjectMutation({
 *   variables: {
 *      bucket_name: // value for 'bucket_name'
 *      object_name: // value for 'object_name'
 *      generation_number: // value for 'generation_number'
 *   },
 * });
 */
export function useDeleteGcsObjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGcsObjectMutation, DeleteGcsObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGcsObjectMutation, DeleteGcsObjectMutationVariables>(DeleteGcsObjectDocument, options);
      }
export type DeleteGcsObjectMutationHookResult = ReturnType<typeof useDeleteGcsObjectMutation>;
export type DeleteGcsObjectMutationResult = Apollo.MutationResult<DeleteGcsObjectMutation>;
export type DeleteGcsObjectMutationOptions = Apollo.BaseMutationOptions<DeleteGcsObjectMutation, DeleteGcsObjectMutationVariables>;
export const CreateGcsObjectDocument = gql`
    mutation CreateGCSObject($bucket_name: String!, $object_name: String!, $base64_content: bytea!, $mime_type: String!, $metadata: jsonb) {
  modify_gcs_object(
    manage_gcs_objects_input: {request_type: "create", bucket_name: $bucket_name, object_name: $object_name, file: {content: $base64_content, mime_type: $mime_type, metadata: $metadata}}
  ) {
    public_url
  }
}
    `;
export type CreateGcsObjectMutationFn = Apollo.MutationFunction<CreateGcsObjectMutation, CreateGcsObjectMutationVariables>;

/**
 * __useCreateGcsObjectMutation__
 *
 * To run a mutation, you first call `useCreateGcsObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGcsObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGcsObjectMutation, { data, loading, error }] = useCreateGcsObjectMutation({
 *   variables: {
 *      bucket_name: // value for 'bucket_name'
 *      object_name: // value for 'object_name'
 *      base64_content: // value for 'base64_content'
 *      mime_type: // value for 'mime_type'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateGcsObjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateGcsObjectMutation, CreateGcsObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGcsObjectMutation, CreateGcsObjectMutationVariables>(CreateGcsObjectDocument, options);
      }
export type CreateGcsObjectMutationHookResult = ReturnType<typeof useCreateGcsObjectMutation>;
export type CreateGcsObjectMutationResult = Apollo.MutationResult<CreateGcsObjectMutation>;
export type CreateGcsObjectMutationOptions = Apollo.BaseMutationOptions<CreateGcsObjectMutation, CreateGcsObjectMutationVariables>;
export const DeleteAlertLinkDocument = gql`
    mutation DeleteAlertLink($alert_link_id: String!) {
  modify_alert_links(
    modify_alert_links_input: {request_type: "delete", request_input: {alert_link_id: $alert_link_id}}
  ) {
    response
  }
}
    `;
export type DeleteAlertLinkMutationFn = Apollo.MutationFunction<DeleteAlertLinkMutation, DeleteAlertLinkMutationVariables>;

/**
 * __useDeleteAlertLinkMutation__
 *
 * To run a mutation, you first call `useDeleteAlertLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertLinkMutation, { data, loading, error }] = useDeleteAlertLinkMutation({
 *   variables: {
 *      alert_link_id: // value for 'alert_link_id'
 *   },
 * });
 */
export function useDeleteAlertLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlertLinkMutation, DeleteAlertLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlertLinkMutation, DeleteAlertLinkMutationVariables>(DeleteAlertLinkDocument, options);
      }
export type DeleteAlertLinkMutationHookResult = ReturnType<typeof useDeleteAlertLinkMutation>;
export type DeleteAlertLinkMutationResult = Apollo.MutationResult<DeleteAlertLinkMutation>;
export type DeleteAlertLinkMutationOptions = Apollo.BaseMutationOptions<DeleteAlertLinkMutation, DeleteAlertLinkMutationVariables>;
export const CreateAlertLinkDocument = gql`
    mutation CreateAlertLink($alert_id_1: String!, $alert_id_2: String!, $relationship: String!, $type: String!) {
  modify_alert_links(
    modify_alert_links_input: {request_type: "create", request_input: {alert_id_1: $alert_id_1, alert_id_2: $alert_id_2, relationship: $relationship, type: $type}}
  ) {
    response
  }
}
    `;
export type CreateAlertLinkMutationFn = Apollo.MutationFunction<CreateAlertLinkMutation, CreateAlertLinkMutationVariables>;

/**
 * __useCreateAlertLinkMutation__
 *
 * To run a mutation, you first call `useCreateAlertLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertLinkMutation, { data, loading, error }] = useCreateAlertLinkMutation({
 *   variables: {
 *      alert_id_1: // value for 'alert_id_1'
 *      alert_id_2: // value for 'alert_id_2'
 *      relationship: // value for 'relationship'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateAlertLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlertLinkMutation, CreateAlertLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlertLinkMutation, CreateAlertLinkMutationVariables>(CreateAlertLinkDocument, options);
      }
export type CreateAlertLinkMutationHookResult = ReturnType<typeof useCreateAlertLinkMutation>;
export type CreateAlertLinkMutationResult = Apollo.MutationResult<CreateAlertLinkMutation>;
export type CreateAlertLinkMutationOptions = Apollo.BaseMutationOptions<CreateAlertLinkMutation, CreateAlertLinkMutationVariables>;
export const GetAlertLinksByAlertIdDocument = gql`
    query GetAlertLinksByAlertId($alert_id: uuid!) {
  alert_links(
    where: {_or: [{alert_id_1: {_eq: $alert_id}}, {alert_id_2: {_eq: $alert_id}}]}
  ) {
    id
    alert_1 {
      ...LINKED_ALERT
    }
    alert_2 {
      ...LINKED_ALERT
    }
    type
    relationship
    created_at
    updated_at
    user {
      id
      name
    }
  }
}
    ${Linked_AlertFragmentDoc}`;

/**
 * __useGetAlertLinksByAlertIdQuery__
 *
 * To run a query within a React component, call `useGetAlertLinksByAlertIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertLinksByAlertIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertLinksByAlertIdQuery({
 *   variables: {
 *      alert_id: // value for 'alert_id'
 *   },
 * });
 */
export function useGetAlertLinksByAlertIdQuery(baseOptions: Apollo.QueryHookOptions<GetAlertLinksByAlertIdQuery, GetAlertLinksByAlertIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlertLinksByAlertIdQuery, GetAlertLinksByAlertIdQueryVariables>(GetAlertLinksByAlertIdDocument, options);
      }
export function useGetAlertLinksByAlertIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlertLinksByAlertIdQuery, GetAlertLinksByAlertIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlertLinksByAlertIdQuery, GetAlertLinksByAlertIdQueryVariables>(GetAlertLinksByAlertIdDocument, options);
        }
export type GetAlertLinksByAlertIdQueryHookResult = ReturnType<typeof useGetAlertLinksByAlertIdQuery>;
export type GetAlertLinksByAlertIdLazyQueryHookResult = ReturnType<typeof useGetAlertLinksByAlertIdLazyQuery>;
export type GetAlertLinksByAlertIdQueryResult = Apollo.QueryResult<GetAlertLinksByAlertIdQuery, GetAlertLinksByAlertIdQueryVariables>;
export const GetEnforcementLinkedAlertInfoDocument = gql`
    query GetEnforcementLinkedAlertInfo($alert_ids: [uuid!]!) {
  spoofing_reports(where: {id: {_in: $alert_ids}}) {
    flagged_url
    id
    organization {
      abbr_name
    }
    external_id
  }
}
    `;

/**
 * __useGetEnforcementLinkedAlertInfoQuery__
 *
 * To run a query within a React component, call `useGetEnforcementLinkedAlertInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnforcementLinkedAlertInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnforcementLinkedAlertInfoQuery({
 *   variables: {
 *      alert_ids: // value for 'alert_ids'
 *   },
 * });
 */
export function useGetEnforcementLinkedAlertInfoQuery(baseOptions: Apollo.QueryHookOptions<GetEnforcementLinkedAlertInfoQuery, GetEnforcementLinkedAlertInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnforcementLinkedAlertInfoQuery, GetEnforcementLinkedAlertInfoQueryVariables>(GetEnforcementLinkedAlertInfoDocument, options);
      }
export function useGetEnforcementLinkedAlertInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnforcementLinkedAlertInfoQuery, GetEnforcementLinkedAlertInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnforcementLinkedAlertInfoQuery, GetEnforcementLinkedAlertInfoQueryVariables>(GetEnforcementLinkedAlertInfoDocument, options);
        }
export type GetEnforcementLinkedAlertInfoQueryHookResult = ReturnType<typeof useGetEnforcementLinkedAlertInfoQuery>;
export type GetEnforcementLinkedAlertInfoLazyQueryHookResult = ReturnType<typeof useGetEnforcementLinkedAlertInfoLazyQuery>;
export type GetEnforcementLinkedAlertInfoQueryResult = Apollo.QueryResult<GetEnforcementLinkedAlertInfoQuery, GetEnforcementLinkedAlertInfoQueryVariables>;
export const GetJiraMetadataFromEnforcementRequestIdDocument = gql`
    query GetJiraMetadataFromEnforcementRequestId($enforcement_request_id: uuid!) {
  jira_metadata(where: {enforcement_request_id: {_eq: $enforcement_request_id}}) {
    status
    has_platform_reply
  }
}
    `;

/**
 * __useGetJiraMetadataFromEnforcementRequestIdQuery__
 *
 * To run a query within a React component, call `useGetJiraMetadataFromEnforcementRequestIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJiraMetadataFromEnforcementRequestIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJiraMetadataFromEnforcementRequestIdQuery({
 *   variables: {
 *      enforcement_request_id: // value for 'enforcement_request_id'
 *   },
 * });
 */
export function useGetJiraMetadataFromEnforcementRequestIdQuery(baseOptions: Apollo.QueryHookOptions<GetJiraMetadataFromEnforcementRequestIdQuery, GetJiraMetadataFromEnforcementRequestIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJiraMetadataFromEnforcementRequestIdQuery, GetJiraMetadataFromEnforcementRequestIdQueryVariables>(GetJiraMetadataFromEnforcementRequestIdDocument, options);
      }
export function useGetJiraMetadataFromEnforcementRequestIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJiraMetadataFromEnforcementRequestIdQuery, GetJiraMetadataFromEnforcementRequestIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJiraMetadataFromEnforcementRequestIdQuery, GetJiraMetadataFromEnforcementRequestIdQueryVariables>(GetJiraMetadataFromEnforcementRequestIdDocument, options);
        }
export type GetJiraMetadataFromEnforcementRequestIdQueryHookResult = ReturnType<typeof useGetJiraMetadataFromEnforcementRequestIdQuery>;
export type GetJiraMetadataFromEnforcementRequestIdLazyQueryHookResult = ReturnType<typeof useGetJiraMetadataFromEnforcementRequestIdLazyQuery>;
export type GetJiraMetadataFromEnforcementRequestIdQueryResult = Apollo.QueryResult<GetJiraMetadataFromEnforcementRequestIdQuery, GetJiraMetadataFromEnforcementRequestIdQueryVariables>;
export const CreateDarkWebCreditCardReportDocument = gql`
    mutation CreateDarkWebCreditCardReport($organization_id: uuid!, $brand_id: uuid!, $flagged_url: String!, $type: String!, $platform_subtype_id: uuid!, $source: String!, $report_status: String!, $spoofing_status: spoofing_status!, $uploader_id: uuid!, $suspicion_score: numeric!, $classification: spoofing_status!, $location: String!, $dark_web_id: uuid!, $dark_web_network: dark_web_network!, $credit_card_number: String!, $bin: Int!, $expiration_date: date!, $cardholder_name: String!, $cardholder_address: String!) {
  insert_spoofing_reports(
    objects: [{organization_id: $organization_id, original_entity_id: $brand_id, flagged_url: $flagged_url, type: $type, platform_subtype_id: $platform_subtype_id, source: $source, spoof_status: $spoofing_status, report_status: $report_status, uploader_id: $uploader_id, spoof_matches: {data: [{suspicion_score: $suspicion_score, classification: $classification, platform_subtype_id: $platform_subtype_id, universal_entity_id: $dark_web_id, dark_web: {data: {id: $dark_web_id, location: $location, network: $dark_web_network, organization_id: $organization_id, credit_card: {data: {credit_card_number: $credit_card_number, bin: $bin, expiration_date: $expiration_date, organization_id: $organization_id, cardholder_name: $cardholder_name, cardholder_address: $cardholder_address}}, source: $source}}}]}}]
  ) {
    returning {
      id
      original_entity_id
      flagged_url
      type
      report_status
      spoof_matches {
        id
        dark_web {
          id
          credit_card {
            id
          }
        }
      }
    }
  }
}
    `;
export type CreateDarkWebCreditCardReportMutationFn = Apollo.MutationFunction<CreateDarkWebCreditCardReportMutation, CreateDarkWebCreditCardReportMutationVariables>;

/**
 * __useCreateDarkWebCreditCardReportMutation__
 *
 * To run a mutation, you first call `useCreateDarkWebCreditCardReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDarkWebCreditCardReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDarkWebCreditCardReportMutation, { data, loading, error }] = useCreateDarkWebCreditCardReportMutation({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      brand_id: // value for 'brand_id'
 *      flagged_url: // value for 'flagged_url'
 *      type: // value for 'type'
 *      platform_subtype_id: // value for 'platform_subtype_id'
 *      source: // value for 'source'
 *      report_status: // value for 'report_status'
 *      spoofing_status: // value for 'spoofing_status'
 *      uploader_id: // value for 'uploader_id'
 *      suspicion_score: // value for 'suspicion_score'
 *      classification: // value for 'classification'
 *      location: // value for 'location'
 *      dark_web_id: // value for 'dark_web_id'
 *      dark_web_network: // value for 'dark_web_network'
 *      credit_card_number: // value for 'credit_card_number'
 *      bin: // value for 'bin'
 *      expiration_date: // value for 'expiration_date'
 *      cardholder_name: // value for 'cardholder_name'
 *      cardholder_address: // value for 'cardholder_address'
 *   },
 * });
 */
export function useCreateDarkWebCreditCardReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateDarkWebCreditCardReportMutation, CreateDarkWebCreditCardReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDarkWebCreditCardReportMutation, CreateDarkWebCreditCardReportMutationVariables>(CreateDarkWebCreditCardReportDocument, options);
      }
export type CreateDarkWebCreditCardReportMutationHookResult = ReturnType<typeof useCreateDarkWebCreditCardReportMutation>;
export type CreateDarkWebCreditCardReportMutationResult = Apollo.MutationResult<CreateDarkWebCreditCardReportMutation>;
export type CreateDarkWebCreditCardReportMutationOptions = Apollo.BaseMutationOptions<CreateDarkWebCreditCardReportMutation, CreateDarkWebCreditCardReportMutationVariables>;
export const UpsertIocAlertAttributionDocument = gql`
    mutation UpsertIocAlertAttribution($ioc_id: uuid!, $match_id: uuid!) {
  insert_ioc_alert_attribution_one(
    object: {ioc_id: $ioc_id, match_id: $match_id}
    on_conflict: {constraint: ioc_alert_attribution_ioc_id_match_id_key, update_columns: [updated_at]}
  ) {
    id
  }
}
    `;
export type UpsertIocAlertAttributionMutationFn = Apollo.MutationFunction<UpsertIocAlertAttributionMutation, UpsertIocAlertAttributionMutationVariables>;

/**
 * __useUpsertIocAlertAttributionMutation__
 *
 * To run a mutation, you first call `useUpsertIocAlertAttributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertIocAlertAttributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertIocAlertAttributionMutation, { data, loading, error }] = useUpsertIocAlertAttributionMutation({
 *   variables: {
 *      ioc_id: // value for 'ioc_id'
 *      match_id: // value for 'match_id'
 *   },
 * });
 */
export function useUpsertIocAlertAttributionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertIocAlertAttributionMutation, UpsertIocAlertAttributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertIocAlertAttributionMutation, UpsertIocAlertAttributionMutationVariables>(UpsertIocAlertAttributionDocument, options);
      }
export type UpsertIocAlertAttributionMutationHookResult = ReturnType<typeof useUpsertIocAlertAttributionMutation>;
export type UpsertIocAlertAttributionMutationResult = Apollo.MutationResult<UpsertIocAlertAttributionMutation>;
export type UpsertIocAlertAttributionMutationOptions = Apollo.BaseMutationOptions<UpsertIocAlertAttributionMutation, UpsertIocAlertAttributionMutationVariables>;
export const CreateDarkWebCredentialLeakReportDocument = gql`
    mutation CreateDarkWebCredentialLeakReport($organization_id: uuid!, $brand_id: uuid!, $flagged_url: String!, $type: String!, $platform_subtype_id: uuid!, $source: String!, $report_status: String!, $spoofing_status: spoofing_status!, $uploader_id: uuid!, $suspicion_score: numeric!, $classification: spoofing_status!, $location: String!, $dark_web_id: uuid!, $dark_web_network: dark_web_network!, $credentials: String!, $email: String!, $password: String!, $credential_url: String!) {
  insert_spoofing_reports(
    objects: [{organization_id: $organization_id, original_entity_id: $brand_id, flagged_url: $flagged_url, type: $type, platform_subtype_id: $platform_subtype_id, source: $source, spoof_status: $spoofing_status, report_status: $report_status, uploader_id: $uploader_id, spoof_matches: {data: [{suspicion_score: $suspicion_score, classification: $classification, platform_subtype_id: $platform_subtype_id, universal_entity_id: $dark_web_id, dark_web: {data: {id: $dark_web_id, email: $email, password: $password, location: $location, network: $dark_web_network, organization_id: $organization_id, source: $source, title: $credentials, credential_url: $credential_url}}}]}}]
  ) {
    returning {
      id
      original_entity_id
      flagged_url
      type
      report_status
      spoof_matches {
        id
        dark_web {
          id
          location
        }
      }
    }
  }
}
    `;
export type CreateDarkWebCredentialLeakReportMutationFn = Apollo.MutationFunction<CreateDarkWebCredentialLeakReportMutation, CreateDarkWebCredentialLeakReportMutationVariables>;

/**
 * __useCreateDarkWebCredentialLeakReportMutation__
 *
 * To run a mutation, you first call `useCreateDarkWebCredentialLeakReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDarkWebCredentialLeakReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDarkWebCredentialLeakReportMutation, { data, loading, error }] = useCreateDarkWebCredentialLeakReportMutation({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      brand_id: // value for 'brand_id'
 *      flagged_url: // value for 'flagged_url'
 *      type: // value for 'type'
 *      platform_subtype_id: // value for 'platform_subtype_id'
 *      source: // value for 'source'
 *      report_status: // value for 'report_status'
 *      spoofing_status: // value for 'spoofing_status'
 *      uploader_id: // value for 'uploader_id'
 *      suspicion_score: // value for 'suspicion_score'
 *      classification: // value for 'classification'
 *      location: // value for 'location'
 *      dark_web_id: // value for 'dark_web_id'
 *      dark_web_network: // value for 'dark_web_network'
 *      credentials: // value for 'credentials'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      credential_url: // value for 'credential_url'
 *   },
 * });
 */
export function useCreateDarkWebCredentialLeakReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateDarkWebCredentialLeakReportMutation, CreateDarkWebCredentialLeakReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDarkWebCredentialLeakReportMutation, CreateDarkWebCredentialLeakReportMutationVariables>(CreateDarkWebCredentialLeakReportDocument, options);
      }
export type CreateDarkWebCredentialLeakReportMutationHookResult = ReturnType<typeof useCreateDarkWebCredentialLeakReportMutation>;
export type CreateDarkWebCredentialLeakReportMutationResult = Apollo.MutationResult<CreateDarkWebCredentialLeakReportMutation>;
export type CreateDarkWebCredentialLeakReportMutationOptions = Apollo.BaseMutationOptions<CreateDarkWebCredentialLeakReportMutation, CreateDarkWebCredentialLeakReportMutationVariables>;
export const GetAllPlatformSubtypesDocument = gql`
    query GetAllPlatformSubtypes {
  platform_subtypes {
    ...PLATFORM_SUBTYPE
  }
}
    ${Platform_SubtypeFragmentDoc}`;

/**
 * __useGetAllPlatformSubtypesQuery__
 *
 * To run a query within a React component, call `useGetAllPlatformSubtypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPlatformSubtypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPlatformSubtypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPlatformSubtypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPlatformSubtypesQuery, GetAllPlatformSubtypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPlatformSubtypesQuery, GetAllPlatformSubtypesQueryVariables>(GetAllPlatformSubtypesDocument, options);
      }
export function useGetAllPlatformSubtypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPlatformSubtypesQuery, GetAllPlatformSubtypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPlatformSubtypesQuery, GetAllPlatformSubtypesQueryVariables>(GetAllPlatformSubtypesDocument, options);
        }
export type GetAllPlatformSubtypesQueryHookResult = ReturnType<typeof useGetAllPlatformSubtypesQuery>;
export type GetAllPlatformSubtypesLazyQueryHookResult = ReturnType<typeof useGetAllPlatformSubtypesLazyQuery>;
export type GetAllPlatformSubtypesQueryResult = Apollo.QueryResult<GetAllPlatformSubtypesQuery, GetAllPlatformSubtypesQueryVariables>;
export const GetPlatformSubtypesByNameDocument = gql`
    query GetPlatformSubtypesByName($name: String!) {
  platform_subtypes(where: {name: {_eq: $name}}) {
    ...PLATFORM_SUBTYPE
  }
}
    ${Platform_SubtypeFragmentDoc}`;

/**
 * __useGetPlatformSubtypesByNameQuery__
 *
 * To run a query within a React component, call `useGetPlatformSubtypesByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformSubtypesByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformSubtypesByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetPlatformSubtypesByNameQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformSubtypesByNameQuery, GetPlatformSubtypesByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformSubtypesByNameQuery, GetPlatformSubtypesByNameQueryVariables>(GetPlatformSubtypesByNameDocument, options);
      }
export function useGetPlatformSubtypesByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformSubtypesByNameQuery, GetPlatformSubtypesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformSubtypesByNameQuery, GetPlatformSubtypesByNameQueryVariables>(GetPlatformSubtypesByNameDocument, options);
        }
export type GetPlatformSubtypesByNameQueryHookResult = ReturnType<typeof useGetPlatformSubtypesByNameQuery>;
export type GetPlatformSubtypesByNameLazyQueryHookResult = ReturnType<typeof useGetPlatformSubtypesByNameLazyQuery>;
export type GetPlatformSubtypesByNameQueryResult = Apollo.QueryResult<GetPlatformSubtypesByNameQuery, GetPlatformSubtypesByNameQueryVariables>;
export const GetPlatformSubtypesByProductDocument = gql`
    query GetPlatformSubtypesByProduct($product: String) {
  platform_subtypes(where: {product: {_eq: $product}}) {
    ...PLATFORM_SUBTYPE
  }
}
    ${Platform_SubtypeFragmentDoc}`;

/**
 * __useGetPlatformSubtypesByProductQuery__
 *
 * To run a query within a React component, call `useGetPlatformSubtypesByProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformSubtypesByProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformSubtypesByProductQuery({
 *   variables: {
 *      product: // value for 'product'
 *   },
 * });
 */
export function useGetPlatformSubtypesByProductQuery(baseOptions?: Apollo.QueryHookOptions<GetPlatformSubtypesByProductQuery, GetPlatformSubtypesByProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformSubtypesByProductQuery, GetPlatformSubtypesByProductQueryVariables>(GetPlatformSubtypesByProductDocument, options);
      }
export function useGetPlatformSubtypesByProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformSubtypesByProductQuery, GetPlatformSubtypesByProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformSubtypesByProductQuery, GetPlatformSubtypesByProductQueryVariables>(GetPlatformSubtypesByProductDocument, options);
        }
export type GetPlatformSubtypesByProductQueryHookResult = ReturnType<typeof useGetPlatformSubtypesByProductQuery>;
export type GetPlatformSubtypesByProductLazyQueryHookResult = ReturnType<typeof useGetPlatformSubtypesByProductLazyQuery>;
export type GetPlatformSubtypesByProductQueryResult = Apollo.QueryResult<GetPlatformSubtypesByProductQuery, GetPlatformSubtypesByProductQueryVariables>;
export const GetStateTransitionInfoFromCollectionReportChangesDocument = gql`
    query GetStateTransitionInfoFromCollectionReportChanges($enforcement_request_id: uuid!, $new_value: String!, $type: String!) {
  collection_report_changes(
    where: {enforcement_request_id: {_eq: $enforcement_request_id}, new_value: {_eq: $new_value}, type: {_eq: $type}}
  ) {
    new_value
    old_value
    timestamp
    enforcement_request_id
  }
}
    `;

/**
 * __useGetStateTransitionInfoFromCollectionReportChangesQuery__
 *
 * To run a query within a React component, call `useGetStateTransitionInfoFromCollectionReportChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStateTransitionInfoFromCollectionReportChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStateTransitionInfoFromCollectionReportChangesQuery({
 *   variables: {
 *      enforcement_request_id: // value for 'enforcement_request_id'
 *      new_value: // value for 'new_value'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetStateTransitionInfoFromCollectionReportChangesQuery(baseOptions: Apollo.QueryHookOptions<GetStateTransitionInfoFromCollectionReportChangesQuery, GetStateTransitionInfoFromCollectionReportChangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStateTransitionInfoFromCollectionReportChangesQuery, GetStateTransitionInfoFromCollectionReportChangesQueryVariables>(GetStateTransitionInfoFromCollectionReportChangesDocument, options);
      }
export function useGetStateTransitionInfoFromCollectionReportChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStateTransitionInfoFromCollectionReportChangesQuery, GetStateTransitionInfoFromCollectionReportChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStateTransitionInfoFromCollectionReportChangesQuery, GetStateTransitionInfoFromCollectionReportChangesQueryVariables>(GetStateTransitionInfoFromCollectionReportChangesDocument, options);
        }
export type GetStateTransitionInfoFromCollectionReportChangesQueryHookResult = ReturnType<typeof useGetStateTransitionInfoFromCollectionReportChangesQuery>;
export type GetStateTransitionInfoFromCollectionReportChangesLazyQueryHookResult = ReturnType<typeof useGetStateTransitionInfoFromCollectionReportChangesLazyQuery>;
export type GetStateTransitionInfoFromCollectionReportChangesQueryResult = Apollo.QueryResult<GetStateTransitionInfoFromCollectionReportChangesQuery, GetStateTransitionInfoFromCollectionReportChangesQueryVariables>;
export const GetIocsForMatchDocument = gql`
    query GetIocsForMatch($match_id: uuid!) {
  iocs(where: {ioc_alert_attributions: {spoof_match: {id: {_eq: $match_id}}}}) {
    id
    value
    type
    status
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetIocsForMatchQuery__
 *
 * To run a query within a React component, call `useGetIocsForMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIocsForMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIocsForMatchQuery({
 *   variables: {
 *      match_id: // value for 'match_id'
 *   },
 * });
 */
export function useGetIocsForMatchQuery(baseOptions: Apollo.QueryHookOptions<GetIocsForMatchQuery, GetIocsForMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIocsForMatchQuery, GetIocsForMatchQueryVariables>(GetIocsForMatchDocument, options);
      }
export function useGetIocsForMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIocsForMatchQuery, GetIocsForMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIocsForMatchQuery, GetIocsForMatchQueryVariables>(GetIocsForMatchDocument, options);
        }
export type GetIocsForMatchQueryHookResult = ReturnType<typeof useGetIocsForMatchQuery>;
export type GetIocsForMatchLazyQueryHookResult = ReturnType<typeof useGetIocsForMatchLazyQuery>;
export type GetIocsForMatchQueryResult = Apollo.QueryResult<GetIocsForMatchQuery, GetIocsForMatchQueryVariables>;
export const GetIocsDocument = gql`
    query GetIocs($where: iocs_bool_exp!, $offset: Int, $limit: Int, $orderBy: [iocs_order_by!]!) {
  iocs(where: $where, offset: $offset, limit: $limit, order_by: $orderBy) {
    id
    value
    type
    status
    ioc_alert_attributions {
      spoof_match {
        spoofing_report {
          spoofing_entity {
            id
          }
        }
      }
    }
    ioc_detection_config_attributions {
      detection_config_type
    }
  }
}
    `;

/**
 * __useGetIocsQuery__
 *
 * To run a query within a React component, call `useGetIocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIocsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetIocsQuery(baseOptions: Apollo.QueryHookOptions<GetIocsQuery, GetIocsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIocsQuery, GetIocsQueryVariables>(GetIocsDocument, options);
      }
export function useGetIocsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIocsQuery, GetIocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIocsQuery, GetIocsQueryVariables>(GetIocsDocument, options);
        }
export type GetIocsQueryHookResult = ReturnType<typeof useGetIocsQuery>;
export type GetIocsLazyQueryHookResult = ReturnType<typeof useGetIocsLazyQuery>;
export type GetIocsQueryResult = Apollo.QueryResult<GetIocsQuery, GetIocsQueryVariables>;
export const UpdateIocStatusDocument = gql`
    mutation UpdateIOCStatus($id: uuid!, $status: String!) {
  update_iocs(where: {id: {_eq: $id}}, _set: {status: $status}) {
    affected_rows
  }
}
    `;
export type UpdateIocStatusMutationFn = Apollo.MutationFunction<UpdateIocStatusMutation, UpdateIocStatusMutationVariables>;

/**
 * __useUpdateIocStatusMutation__
 *
 * To run a mutation, you first call `useUpdateIocStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIocStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIocStatusMutation, { data, loading, error }] = useUpdateIocStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateIocStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIocStatusMutation, UpdateIocStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIocStatusMutation, UpdateIocStatusMutationVariables>(UpdateIocStatusDocument, options);
      }
export type UpdateIocStatusMutationHookResult = ReturnType<typeof useUpdateIocStatusMutation>;
export type UpdateIocStatusMutationResult = Apollo.MutationResult<UpdateIocStatusMutation>;
export type UpdateIocStatusMutationOptions = Apollo.BaseMutationOptions<UpdateIocStatusMutation, UpdateIocStatusMutationVariables>;
export const UpdateIocDocument = gql`
    mutation UpdateIOC($id: uuid!, $status: String!, $notes: String!) {
  update_iocs(where: {id: {_eq: $id}}, _set: {status: $status, notes: $notes}) {
    affected_rows
  }
}
    `;
export type UpdateIocMutationFn = Apollo.MutationFunction<UpdateIocMutation, UpdateIocMutationVariables>;

/**
 * __useUpdateIocMutation__
 *
 * To run a mutation, you first call `useUpdateIocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIocMutation, { data, loading, error }] = useUpdateIocMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateIocMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIocMutation, UpdateIocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIocMutation, UpdateIocMutationVariables>(UpdateIocDocument, options);
      }
export type UpdateIocMutationHookResult = ReturnType<typeof useUpdateIocMutation>;
export type UpdateIocMutationResult = Apollo.MutationResult<UpdateIocMutation>;
export type UpdateIocMutationOptions = Apollo.BaseMutationOptions<UpdateIocMutation, UpdateIocMutationVariables>;
export const GetIocForModalDocument = gql`
    query GetIocForModal($id: uuid!, $isEmployeeView: Boolean!) {
  iocs_by_pk(id: $id) {
    id
    value
    type
    status
    additional_metadata
    notes @include(if: $isEmployeeView)
    ioc_alert_attributions {
      id
      spoof_match {
        spoofing_report {
          id
          external_id
          flagged_url
          platform {
            product
            name
          }
          spoofing_entity {
            entity_name
            id
            organization {
              id
              name
              abbr_name
            }
          }
          organization {
            id
            name
            abbr_name
          }
        }
      }
    }
    ioc_detection_config_attributions @include(if: $isEmployeeView) {
      id
      detection_config_id
      detection_config_type
      sourcing_queries {
        sourcer_label
        query
        spoofing_entity {
          entity_name
        }
      }
      detection_assets {
        id
        value
        type
        spoofing_entity {
          entity_name
        }
      }
      rules {
        id
        description
        type
        rule_expression
        spoofing_entity {
          entity_name
        }
      }
    }
  }
}
    `;

/**
 * __useGetIocForModalQuery__
 *
 * To run a query within a React component, call `useGetIocForModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIocForModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIocForModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isEmployeeView: // value for 'isEmployeeView'
 *   },
 * });
 */
export function useGetIocForModalQuery(baseOptions: Apollo.QueryHookOptions<GetIocForModalQuery, GetIocForModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIocForModalQuery, GetIocForModalQueryVariables>(GetIocForModalDocument, options);
      }
export function useGetIocForModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIocForModalQuery, GetIocForModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIocForModalQuery, GetIocForModalQueryVariables>(GetIocForModalDocument, options);
        }
export type GetIocForModalQueryHookResult = ReturnType<typeof useGetIocForModalQuery>;
export type GetIocForModalLazyQueryHookResult = ReturnType<typeof useGetIocForModalLazyQuery>;
export type GetIocForModalQueryResult = Apollo.QueryResult<GetIocForModalQuery, GetIocForModalQueryVariables>;
export const InsertIocSourcingQueryDocument = gql`
    mutation InsertIOCSourcingQuery($detection_config_id: uuid!, $detection_config_type: String!, $ioc_id: uuid!) {
  insert_ioc_detection_config_attribution(
    objects: {detection_config_id: $detection_config_id, detection_config_type: $detection_config_type, ioc_id: $ioc_id}
  ) {
    returning {
      id
    }
  }
}
    `;
export type InsertIocSourcingQueryMutationFn = Apollo.MutationFunction<InsertIocSourcingQueryMutation, InsertIocSourcingQueryMutationVariables>;

/**
 * __useInsertIocSourcingQueryMutation__
 *
 * To run a mutation, you first call `useInsertIocSourcingQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertIocSourcingQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertIocSourcingQueryMutation, { data, loading, error }] = useInsertIocSourcingQueryMutation({
 *   variables: {
 *      detection_config_id: // value for 'detection_config_id'
 *      detection_config_type: // value for 'detection_config_type'
 *      ioc_id: // value for 'ioc_id'
 *   },
 * });
 */
export function useInsertIocSourcingQueryMutation(baseOptions?: Apollo.MutationHookOptions<InsertIocSourcingQueryMutation, InsertIocSourcingQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertIocSourcingQueryMutation, InsertIocSourcingQueryMutationVariables>(InsertIocSourcingQueryDocument, options);
      }
export type InsertIocSourcingQueryMutationHookResult = ReturnType<typeof useInsertIocSourcingQueryMutation>;
export type InsertIocSourcingQueryMutationResult = Apollo.MutationResult<InsertIocSourcingQueryMutation>;
export type InsertIocSourcingQueryMutationOptions = Apollo.BaseMutationOptions<InsertIocSourcingQueryMutation, InsertIocSourcingQueryMutationVariables>;
export const GetIocsCountDocument = gql`
    query GetIocsCount($where: iocs_bool_exp!) {
  iocs_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetIocsCountQuery__
 *
 * To run a query within a React component, call `useGetIocsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIocsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIocsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetIocsCountQuery(baseOptions: Apollo.QueryHookOptions<GetIocsCountQuery, GetIocsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIocsCountQuery, GetIocsCountQueryVariables>(GetIocsCountDocument, options);
      }
export function useGetIocsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIocsCountQuery, GetIocsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIocsCountQuery, GetIocsCountQueryVariables>(GetIocsCountDocument, options);
        }
export type GetIocsCountQueryHookResult = ReturnType<typeof useGetIocsCountQuery>;
export type GetIocsCountLazyQueryHookResult = ReturnType<typeof useGetIocsCountLazyQuery>;
export type GetIocsCountQueryResult = Apollo.QueryResult<GetIocsCountQuery, GetIocsCountQueryVariables>;
export const ActionOnEmailDocument = gql`
    mutation ActionOnEmail($message_id: String, $alert_id: String!, $body: String!, $subject: String!, $should_send_to_soc: Boolean!) {
  action_on_email(
    action_on_email_input: {message_id: $message_id, alert_id: $alert_id, body: $body, subject: $subject, should_send_to_soc: $should_send_to_soc}
  ) {
    email_id
  }
}
    `;
export type ActionOnEmailMutationFn = Apollo.MutationFunction<ActionOnEmailMutation, ActionOnEmailMutationVariables>;

/**
 * __useActionOnEmailMutation__
 *
 * To run a mutation, you first call `useActionOnEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActionOnEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actionOnEmailMutation, { data, loading, error }] = useActionOnEmailMutation({
 *   variables: {
 *      message_id: // value for 'message_id'
 *      alert_id: // value for 'alert_id'
 *      body: // value for 'body'
 *      subject: // value for 'subject'
 *      should_send_to_soc: // value for 'should_send_to_soc'
 *   },
 * });
 */
export function useActionOnEmailMutation(baseOptions?: Apollo.MutationHookOptions<ActionOnEmailMutation, ActionOnEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActionOnEmailMutation, ActionOnEmailMutationVariables>(ActionOnEmailDocument, options);
      }
export type ActionOnEmailMutationHookResult = ReturnType<typeof useActionOnEmailMutation>;
export type ActionOnEmailMutationResult = Apollo.MutationResult<ActionOnEmailMutation>;
export type ActionOnEmailMutationOptions = Apollo.BaseMutationOptions<ActionOnEmailMutation, ActionOnEmailMutationVariables>;
export const GetGlobalTagIdByNameDocument = gql`
    query GetGlobalTagIDByName($name: String!) {
  tags(
    where: {created_by: {_is_null: false}, is_internal: {_eq: true}, name: {_eq: $name}}
  ) {
    id
  }
}
    `;

/**
 * __useGetGlobalTagIdByNameQuery__
 *
 * To run a query within a React component, call `useGetGlobalTagIdByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalTagIdByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalTagIdByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetGlobalTagIdByNameQuery(baseOptions: Apollo.QueryHookOptions<GetGlobalTagIdByNameQuery, GetGlobalTagIdByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalTagIdByNameQuery, GetGlobalTagIdByNameQueryVariables>(GetGlobalTagIdByNameDocument, options);
      }
export function useGetGlobalTagIdByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalTagIdByNameQuery, GetGlobalTagIdByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalTagIdByNameQuery, GetGlobalTagIdByNameQueryVariables>(GetGlobalTagIdByNameDocument, options);
        }
export type GetGlobalTagIdByNameQueryHookResult = ReturnType<typeof useGetGlobalTagIdByNameQuery>;
export type GetGlobalTagIdByNameLazyQueryHookResult = ReturnType<typeof useGetGlobalTagIdByNameLazyQuery>;
export type GetGlobalTagIdByNameQueryResult = Apollo.QueryResult<GetGlobalTagIdByNameQuery, GetGlobalTagIdByNameQueryVariables>;
export const GetCorrespondenceForEmailDocument = gql`
    query GetCorrespondenceForEmail($email_id: uuid!) {
  email_correspondence(where: {email_id: {_eq: $email_id}}) {
    ...EMAIL_CORRESPONDENCE
  }
}
    ${Email_CorrespondenceFragmentDoc}`;

/**
 * __useGetCorrespondenceForEmailQuery__
 *
 * To run a query within a React component, call `useGetCorrespondenceForEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorrespondenceForEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorrespondenceForEmailQuery({
 *   variables: {
 *      email_id: // value for 'email_id'
 *   },
 * });
 */
export function useGetCorrespondenceForEmailQuery(baseOptions: Apollo.QueryHookOptions<GetCorrespondenceForEmailQuery, GetCorrespondenceForEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorrespondenceForEmailQuery, GetCorrespondenceForEmailQueryVariables>(GetCorrespondenceForEmailDocument, options);
      }
export function useGetCorrespondenceForEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorrespondenceForEmailQuery, GetCorrespondenceForEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorrespondenceForEmailQuery, GetCorrespondenceForEmailQueryVariables>(GetCorrespondenceForEmailDocument, options);
        }
export type GetCorrespondenceForEmailQueryHookResult = ReturnType<typeof useGetCorrespondenceForEmailQuery>;
export type GetCorrespondenceForEmailLazyQueryHookResult = ReturnType<typeof useGetCorrespondenceForEmailLazyQuery>;
export type GetCorrespondenceForEmailQueryResult = Apollo.QueryResult<GetCorrespondenceForEmailQuery, GetCorrespondenceForEmailQueryVariables>;
export const GetUserEmailsByIdsDocument = gql`
    query GetUserEmailsByIds($ids: [uuid!]!) {
  users(where: {id: {_in: $ids}}) {
    id
    email
  }
}
    `;

/**
 * __useGetUserEmailsByIdsQuery__
 *
 * To run a query within a React component, call `useGetUserEmailsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEmailsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEmailsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetUserEmailsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetUserEmailsByIdsQuery, GetUserEmailsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserEmailsByIdsQuery, GetUserEmailsByIdsQueryVariables>(GetUserEmailsByIdsDocument, options);
      }
export function useGetUserEmailsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserEmailsByIdsQuery, GetUserEmailsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserEmailsByIdsQuery, GetUserEmailsByIdsQueryVariables>(GetUserEmailsByIdsDocument, options);
        }
export type GetUserEmailsByIdsQueryHookResult = ReturnType<typeof useGetUserEmailsByIdsQuery>;
export type GetUserEmailsByIdsLazyQueryHookResult = ReturnType<typeof useGetUserEmailsByIdsLazyQuery>;
export type GetUserEmailsByIdsQueryResult = Apollo.QueryResult<GetUserEmailsByIdsQuery, GetUserEmailsByIdsQueryVariables>;
export const DeleteAlertDocument = gql`
    mutation DeleteAlert($alert_id: String!) {
  delete_alert(delete_alert_input: {alert_id: $alert_id}) {
    success
  }
}
    `;
export type DeleteAlertMutationFn = Apollo.MutationFunction<DeleteAlertMutation, DeleteAlertMutationVariables>;

/**
 * __useDeleteAlertMutation__
 *
 * To run a mutation, you first call `useDeleteAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertMutation, { data, loading, error }] = useDeleteAlertMutation({
 *   variables: {
 *      alert_id: // value for 'alert_id'
 *   },
 * });
 */
export function useDeleteAlertMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlertMutation, DeleteAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlertMutation, DeleteAlertMutationVariables>(DeleteAlertDocument, options);
      }
export type DeleteAlertMutationHookResult = ReturnType<typeof useDeleteAlertMutation>;
export type DeleteAlertMutationResult = Apollo.MutationResult<DeleteAlertMutation>;
export type DeleteAlertMutationOptions = Apollo.BaseMutationOptions<DeleteAlertMutation, DeleteAlertMutationVariables>;
export const GetPiiEventsDocument = gql`
    query GetPIIEvents($databroker_uuid: uuid!, $date_from: timestamp!, $date_to: timestamp!, $user_id: uuid!) {
  pii_events(
    where: {databroker_uuid: {_eq: $databroker_uuid}, external_created_at: {_gte: $date_from, _lte: $date_to}, user_id: {_eq: $user_id}}
    order_by: {external_created_at: desc}
  ) {
    message
    external_created_at
  }
}
    `;

/**
 * __useGetPiiEventsQuery__
 *
 * To run a query within a React component, call `useGetPiiEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPiiEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPiiEventsQuery({
 *   variables: {
 *      databroker_uuid: // value for 'databroker_uuid'
 *      date_from: // value for 'date_from'
 *      date_to: // value for 'date_to'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetPiiEventsQuery(baseOptions: Apollo.QueryHookOptions<GetPiiEventsQuery, GetPiiEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPiiEventsQuery, GetPiiEventsQueryVariables>(GetPiiEventsDocument, options);
      }
export function useGetPiiEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPiiEventsQuery, GetPiiEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPiiEventsQuery, GetPiiEventsQueryVariables>(GetPiiEventsDocument, options);
        }
export type GetPiiEventsQueryHookResult = ReturnType<typeof useGetPiiEventsQuery>;
export type GetPiiEventsLazyQueryHookResult = ReturnType<typeof useGetPiiEventsLazyQuery>;
export type GetPiiEventsQueryResult = Apollo.QueryResult<GetPiiEventsQuery, GetPiiEventsQueryVariables>;
export const GetActivePiiDatabrokersOfUserDocument = gql`
    query GetActivePIIDatabrokersOfUser($userId: uuid!) {
  get_pii_reports_with_screenshots(args: {p_user_id: $userId}) {
    id
    databroker {
      databroker_name
    }
  }
}
    `;

/**
 * __useGetActivePiiDatabrokersOfUserQuery__
 *
 * To run a query within a React component, call `useGetActivePiiDatabrokersOfUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePiiDatabrokersOfUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePiiDatabrokersOfUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetActivePiiDatabrokersOfUserQuery(baseOptions: Apollo.QueryHookOptions<GetActivePiiDatabrokersOfUserQuery, GetActivePiiDatabrokersOfUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivePiiDatabrokersOfUserQuery, GetActivePiiDatabrokersOfUserQueryVariables>(GetActivePiiDatabrokersOfUserDocument, options);
      }
export function useGetActivePiiDatabrokersOfUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivePiiDatabrokersOfUserQuery, GetActivePiiDatabrokersOfUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivePiiDatabrokersOfUserQuery, GetActivePiiDatabrokersOfUserQueryVariables>(GetActivePiiDatabrokersOfUserDocument, options);
        }
export type GetActivePiiDatabrokersOfUserQueryHookResult = ReturnType<typeof useGetActivePiiDatabrokersOfUserQuery>;
export type GetActivePiiDatabrokersOfUserLazyQueryHookResult = ReturnType<typeof useGetActivePiiDatabrokersOfUserLazyQuery>;
export type GetActivePiiDatabrokersOfUserQueryResult = Apollo.QueryResult<GetActivePiiDatabrokersOfUserQuery, GetActivePiiDatabrokersOfUserQueryVariables>;
export const GetAuditLogEntriesDocument = gql`
    query GetAuditLogEntries($tableName: String!, $rowId: String!, $startDate: timestamp) @cached {
  audit_logged_actions(
    where: {table_name: {_eq: $tableName}, row_id: {_eq: $rowId}, action_tstamp: {_gte: $startDate}}
    order_by: {action_tstamp: desc}
  ) {
    event_id
    revision_id
    schema_name
    table_name
    row_id
    action
    column_name
    old_value
    new_value
    action_tstamp
  }
}
    `;

/**
 * __useGetAuditLogEntriesQuery__
 *
 * To run a query within a React component, call `useGetAuditLogEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogEntriesQuery({
 *   variables: {
 *      tableName: // value for 'tableName'
 *      rowId: // value for 'rowId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetAuditLogEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetAuditLogEntriesQuery, GetAuditLogEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditLogEntriesQuery, GetAuditLogEntriesQueryVariables>(GetAuditLogEntriesDocument, options);
      }
export function useGetAuditLogEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditLogEntriesQuery, GetAuditLogEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditLogEntriesQuery, GetAuditLogEntriesQueryVariables>(GetAuditLogEntriesDocument, options);
        }
export type GetAuditLogEntriesQueryHookResult = ReturnType<typeof useGetAuditLogEntriesQuery>;
export type GetAuditLogEntriesLazyQueryHookResult = ReturnType<typeof useGetAuditLogEntriesLazyQuery>;
export type GetAuditLogEntriesQueryResult = Apollo.QueryResult<GetAuditLogEntriesQuery, GetAuditLogEntriesQueryVariables>;
export const GetSourcingQueryByIdDocument = gql`
    query GetSourcingQueryById($id: uuid!) {
  sourcing_queries_by_pk(id: $id) {
    id
    status
    created_at
    updated_at
    query
    sourcer_label
    force_create_report
    created_by
    execution_frequency_minutes
    last_used_at
    notes
    spoofing_entity {
      id
      entity_name
      organization {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetSourcingQueryByIdQuery__
 *
 * To run a query within a React component, call `useGetSourcingQueryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcingQueryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcingQueryByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSourcingQueryByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSourcingQueryByIdQuery, GetSourcingQueryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourcingQueryByIdQuery, GetSourcingQueryByIdQueryVariables>(GetSourcingQueryByIdDocument, options);
      }
export function useGetSourcingQueryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourcingQueryByIdQuery, GetSourcingQueryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourcingQueryByIdQuery, GetSourcingQueryByIdQueryVariables>(GetSourcingQueryByIdDocument, options);
        }
export type GetSourcingQueryByIdQueryHookResult = ReturnType<typeof useGetSourcingQueryByIdQuery>;
export type GetSourcingQueryByIdLazyQueryHookResult = ReturnType<typeof useGetSourcingQueryByIdLazyQuery>;
export type GetSourcingQueryByIdQueryResult = Apollo.QueryResult<GetSourcingQueryByIdQuery, GetSourcingQueryByIdQueryVariables>;
export const GetDetectionAssetByIdDocument = gql`
    query GetDetectionAssetById($id: uuid!) {
  detection_assets_by_pk(id: $id) {
    id
    original_entity_id
    value
    enabled_usage
    type
    is_valid
    is_generic
    created_at
    updated_at
    ir_to_dr_rule
    description
    originator_id
    originator_type
    last_updated_by
    full_url {
      id
      url
    }
    spoofing_entity {
      id
      entity_name
    }
    user {
      id
      email
    }
    protected_asset {
      id
    }
    ioc {
      id
      value
      type
    }
    social_media {
      id
      platform_name
      slug
    }
  }
}
    `;

/**
 * __useGetDetectionAssetByIdQuery__
 *
 * To run a query within a React component, call `useGetDetectionAssetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetectionAssetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetectionAssetByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDetectionAssetByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDetectionAssetByIdQuery, GetDetectionAssetByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetectionAssetByIdQuery, GetDetectionAssetByIdQueryVariables>(GetDetectionAssetByIdDocument, options);
      }
export function useGetDetectionAssetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetectionAssetByIdQuery, GetDetectionAssetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetectionAssetByIdQuery, GetDetectionAssetByIdQueryVariables>(GetDetectionAssetByIdDocument, options);
        }
export type GetDetectionAssetByIdQueryHookResult = ReturnType<typeof useGetDetectionAssetByIdQuery>;
export type GetDetectionAssetByIdLazyQueryHookResult = ReturnType<typeof useGetDetectionAssetByIdLazyQuery>;
export type GetDetectionAssetByIdQueryResult = Apollo.QueryResult<GetDetectionAssetByIdQuery, GetDetectionAssetByIdQueryVariables>;
export const RequestAlertCsvExportDocument = gql`
    mutation RequestAlertCSVExport($organization_id: uuid, $product: String, $where_clause: jsonb) {
  request_alert_csv_export(
    request_alert_csv_export_input: {organization_id: $organization_id, product: $product, where_clause: $where_clause}
  )
}
    `;
export type RequestAlertCsvExportMutationFn = Apollo.MutationFunction<RequestAlertCsvExportMutation, RequestAlertCsvExportMutationVariables>;

/**
 * __useRequestAlertCsvExportMutation__
 *
 * To run a mutation, you first call `useRequestAlertCsvExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAlertCsvExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAlertCsvExportMutation, { data, loading, error }] = useRequestAlertCsvExportMutation({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      product: // value for 'product'
 *      where_clause: // value for 'where_clause'
 *   },
 * });
 */
export function useRequestAlertCsvExportMutation(baseOptions?: Apollo.MutationHookOptions<RequestAlertCsvExportMutation, RequestAlertCsvExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAlertCsvExportMutation, RequestAlertCsvExportMutationVariables>(RequestAlertCsvExportDocument, options);
      }
export type RequestAlertCsvExportMutationHookResult = ReturnType<typeof useRequestAlertCsvExportMutation>;
export type RequestAlertCsvExportMutationResult = Apollo.MutationResult<RequestAlertCsvExportMutation>;
export type RequestAlertCsvExportMutationOptions = Apollo.BaseMutationOptions<RequestAlertCsvExportMutation, RequestAlertCsvExportMutationVariables>;
export const AlertCsvDownloadUrlDocument = gql`
    subscription AlertCSVDownloadUrl($id: uuid!) {
  request_alert_csv_export(id: $id) {
    output {
      download_url
    }
    errors
  }
}
    `;

/**
 * __useAlertCsvDownloadUrlSubscription__
 *
 * To run a query within a React component, call `useAlertCsvDownloadUrlSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAlertCsvDownloadUrlSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertCsvDownloadUrlSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAlertCsvDownloadUrlSubscription(baseOptions: Apollo.SubscriptionHookOptions<AlertCsvDownloadUrlSubscription, AlertCsvDownloadUrlSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AlertCsvDownloadUrlSubscription, AlertCsvDownloadUrlSubscriptionVariables>(AlertCsvDownloadUrlDocument, options);
      }
export type AlertCsvDownloadUrlSubscriptionHookResult = ReturnType<typeof useAlertCsvDownloadUrlSubscription>;
export type AlertCsvDownloadUrlSubscriptionResult = Apollo.SubscriptionResult<AlertCsvDownloadUrlSubscription>;
export const ManageElasticSearchDocument = gql`
    query ManageElasticSearch($query: String!, $size: Int, $from: Int, $organizationId: uuid) {
  manage_elastic_search_queries(
    elastic_search_queries_input: {query: $query, size: $size, from: $from, organization_id: $organizationId}
  ) {
    status
    data
    message
  }
}
    `;

/**
 * __useManageElasticSearchQuery__
 *
 * To run a query within a React component, call `useManageElasticSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageElasticSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageElasticSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useManageElasticSearchQuery(baseOptions: Apollo.QueryHookOptions<ManageElasticSearchQuery, ManageElasticSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageElasticSearchQuery, ManageElasticSearchQueryVariables>(ManageElasticSearchDocument, options);
      }
export function useManageElasticSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageElasticSearchQuery, ManageElasticSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageElasticSearchQuery, ManageElasticSearchQueryVariables>(ManageElasticSearchDocument, options);
        }
export type ManageElasticSearchQueryHookResult = ReturnType<typeof useManageElasticSearchQuery>;
export type ManageElasticSearchLazyQueryHookResult = ReturnType<typeof useManageElasticSearchLazyQuery>;
export type ManageElasticSearchQueryResult = Apollo.QueryResult<ManageElasticSearchQuery, ManageElasticSearchQueryVariables>;
export const DeleteIocAlertAttributionDocument = gql`
    mutation DeleteIocAlertAttribution($id: uuid!) {
  delete_ioc_alert_attribution(where: {id: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteIocAlertAttributionMutationFn = Apollo.MutationFunction<DeleteIocAlertAttributionMutation, DeleteIocAlertAttributionMutationVariables>;

/**
 * __useDeleteIocAlertAttributionMutation__
 *
 * To run a mutation, you first call `useDeleteIocAlertAttributionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIocAlertAttributionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIocAlertAttributionMutation, { data, loading, error }] = useDeleteIocAlertAttributionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIocAlertAttributionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIocAlertAttributionMutation, DeleteIocAlertAttributionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIocAlertAttributionMutation, DeleteIocAlertAttributionMutationVariables>(DeleteIocAlertAttributionDocument, options);
      }
export type DeleteIocAlertAttributionMutationHookResult = ReturnType<typeof useDeleteIocAlertAttributionMutation>;
export type DeleteIocAlertAttributionMutationResult = Apollo.MutationResult<DeleteIocAlertAttributionMutation>;
export type DeleteIocAlertAttributionMutationOptions = Apollo.BaseMutationOptions<DeleteIocAlertAttributionMutation, DeleteIocAlertAttributionMutationVariables>;
export const CreateIocDocument = gql`
    mutation CreateIoc($type: String!, $value: String!, $status: String!, $notes: String, $additional_metadata: jsonb) {
  insert_iocs_one(
    object: {type: $type, value: $value, status: $status, notes: $notes, additional_metadata: $additional_metadata}
  ) {
    id
  }
}
    `;
export type CreateIocMutationFn = Apollo.MutationFunction<CreateIocMutation, CreateIocMutationVariables>;

/**
 * __useCreateIocMutation__
 *
 * To run a mutation, you first call `useCreateIocMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIocMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIocMutation, { data, loading, error }] = useCreateIocMutation({
 *   variables: {
 *      type: // value for 'type'
 *      value: // value for 'value'
 *      status: // value for 'status'
 *      notes: // value for 'notes'
 *      additional_metadata: // value for 'additional_metadata'
 *   },
 * });
 */
export function useCreateIocMutation(baseOptions?: Apollo.MutationHookOptions<CreateIocMutation, CreateIocMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIocMutation, CreateIocMutationVariables>(CreateIocDocument, options);
      }
export type CreateIocMutationHookResult = ReturnType<typeof useCreateIocMutation>;
export type CreateIocMutationResult = Apollo.MutationResult<CreateIocMutation>;
export type CreateIocMutationOptions = Apollo.BaseMutationOptions<CreateIocMutation, CreateIocMutationVariables>;
export const DeleteIocAlertAttributionByIocAndMatchDocument = gql`
    mutation DeleteIocAlertAttributionByIocAndMatch($ioc_id: uuid!, $match_id: uuid!) {
  delete_ioc_alert_attribution(
    where: {ioc_id: {_eq: $ioc_id}, match_id: {_eq: $match_id}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteIocAlertAttributionByIocAndMatchMutationFn = Apollo.MutationFunction<DeleteIocAlertAttributionByIocAndMatchMutation, DeleteIocAlertAttributionByIocAndMatchMutationVariables>;

/**
 * __useDeleteIocAlertAttributionByIocAndMatchMutation__
 *
 * To run a mutation, you first call `useDeleteIocAlertAttributionByIocAndMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIocAlertAttributionByIocAndMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIocAlertAttributionByIocAndMatchMutation, { data, loading, error }] = useDeleteIocAlertAttributionByIocAndMatchMutation({
 *   variables: {
 *      ioc_id: // value for 'ioc_id'
 *      match_id: // value for 'match_id'
 *   },
 * });
 */
export function useDeleteIocAlertAttributionByIocAndMatchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIocAlertAttributionByIocAndMatchMutation, DeleteIocAlertAttributionByIocAndMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIocAlertAttributionByIocAndMatchMutation, DeleteIocAlertAttributionByIocAndMatchMutationVariables>(DeleteIocAlertAttributionByIocAndMatchDocument, options);
      }
export type DeleteIocAlertAttributionByIocAndMatchMutationHookResult = ReturnType<typeof useDeleteIocAlertAttributionByIocAndMatchMutation>;
export type DeleteIocAlertAttributionByIocAndMatchMutationResult = Apollo.MutationResult<DeleteIocAlertAttributionByIocAndMatchMutation>;
export type DeleteIocAlertAttributionByIocAndMatchMutationOptions = Apollo.BaseMutationOptions<DeleteIocAlertAttributionByIocAndMatchMutation, DeleteIocAlertAttributionByIocAndMatchMutationVariables>;
export const FindIocByTypeAndValueDocument = gql`
    query FindIOCByTypeAndValue($type: String!, $value: String!) {
  iocs(where: {type: {_eq: $type}, value: {_eq: $value}}) {
    id
    type
    value
    status
  }
}
    `;

/**
 * __useFindIocByTypeAndValueQuery__
 *
 * To run a query within a React component, call `useFindIocByTypeAndValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindIocByTypeAndValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindIocByTypeAndValueQuery({
 *   variables: {
 *      type: // value for 'type'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useFindIocByTypeAndValueQuery(baseOptions: Apollo.QueryHookOptions<FindIocByTypeAndValueQuery, FindIocByTypeAndValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindIocByTypeAndValueQuery, FindIocByTypeAndValueQueryVariables>(FindIocByTypeAndValueDocument, options);
      }
export function useFindIocByTypeAndValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindIocByTypeAndValueQuery, FindIocByTypeAndValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindIocByTypeAndValueQuery, FindIocByTypeAndValueQueryVariables>(FindIocByTypeAndValueDocument, options);
        }
export type FindIocByTypeAndValueQueryHookResult = ReturnType<typeof useFindIocByTypeAndValueQuery>;
export type FindIocByTypeAndValueLazyQueryHookResult = ReturnType<typeof useFindIocByTypeAndValueLazyQuery>;
export type FindIocByTypeAndValueQueryResult = Apollo.QueryResult<FindIocByTypeAndValueQuery, FindIocByTypeAndValueQueryVariables>;
export const FindIocAlertAttributionByIocAndMatchDocument = gql`
    query FindIocAlertAttributionByIocAndMatch($ioc_id: uuid!, $match_id: uuid!) {
  ioc_alert_attribution(
    where: {ioc_id: {_eq: $ioc_id}, match_id: {_eq: $match_id}}
  ) {
    id
  }
}
    `;

/**
 * __useFindIocAlertAttributionByIocAndMatchQuery__
 *
 * To run a query within a React component, call `useFindIocAlertAttributionByIocAndMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindIocAlertAttributionByIocAndMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindIocAlertAttributionByIocAndMatchQuery({
 *   variables: {
 *      ioc_id: // value for 'ioc_id'
 *      match_id: // value for 'match_id'
 *   },
 * });
 */
export function useFindIocAlertAttributionByIocAndMatchQuery(baseOptions: Apollo.QueryHookOptions<FindIocAlertAttributionByIocAndMatchQuery, FindIocAlertAttributionByIocAndMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindIocAlertAttributionByIocAndMatchQuery, FindIocAlertAttributionByIocAndMatchQueryVariables>(FindIocAlertAttributionByIocAndMatchDocument, options);
      }
export function useFindIocAlertAttributionByIocAndMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindIocAlertAttributionByIocAndMatchQuery, FindIocAlertAttributionByIocAndMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindIocAlertAttributionByIocAndMatchQuery, FindIocAlertAttributionByIocAndMatchQueryVariables>(FindIocAlertAttributionByIocAndMatchDocument, options);
        }
export type FindIocAlertAttributionByIocAndMatchQueryHookResult = ReturnType<typeof useFindIocAlertAttributionByIocAndMatchQuery>;
export type FindIocAlertAttributionByIocAndMatchLazyQueryHookResult = ReturnType<typeof useFindIocAlertAttributionByIocAndMatchLazyQuery>;
export type FindIocAlertAttributionByIocAndMatchQueryResult = Apollo.QueryResult<FindIocAlertAttributionByIocAndMatchQuery, FindIocAlertAttributionByIocAndMatchQueryVariables>;
export const GetAnalyticsSummaryEmailsDocument = gql`
    query GetAnalyticsSummaryEmails($id: uuid!) {
  organizations(where: {id: {_eq: $id}}) {
    analytics_summary_recipient_emails
  }
}
    `;

/**
 * __useGetAnalyticsSummaryEmailsQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsSummaryEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsSummaryEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsSummaryEmailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAnalyticsSummaryEmailsQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsSummaryEmailsQuery, GetAnalyticsSummaryEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsSummaryEmailsQuery, GetAnalyticsSummaryEmailsQueryVariables>(GetAnalyticsSummaryEmailsDocument, options);
      }
export function useGetAnalyticsSummaryEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsSummaryEmailsQuery, GetAnalyticsSummaryEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsSummaryEmailsQuery, GetAnalyticsSummaryEmailsQueryVariables>(GetAnalyticsSummaryEmailsDocument, options);
        }
export type GetAnalyticsSummaryEmailsQueryHookResult = ReturnType<typeof useGetAnalyticsSummaryEmailsQuery>;
export type GetAnalyticsSummaryEmailsLazyQueryHookResult = ReturnType<typeof useGetAnalyticsSummaryEmailsLazyQuery>;
export type GetAnalyticsSummaryEmailsQueryResult = Apollo.QueryResult<GetAnalyticsSummaryEmailsQuery, GetAnalyticsSummaryEmailsQueryVariables>;
export const ResetSourcingQueryLastUsedAtDocument = gql`
    mutation ResetSourcingQueryLastUsedAt($id: uuid!, $last_updated_by: String) {
  update_sourcing_queries_by_pk(
    pk_columns: {id: $id}
    _set: {last_used_at: null, last_updated_by: $last_updated_by}
  ) {
    id
    last_used_at
  }
}
    `;
export type ResetSourcingQueryLastUsedAtMutationFn = Apollo.MutationFunction<ResetSourcingQueryLastUsedAtMutation, ResetSourcingQueryLastUsedAtMutationVariables>;

/**
 * __useResetSourcingQueryLastUsedAtMutation__
 *
 * To run a mutation, you first call `useResetSourcingQueryLastUsedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSourcingQueryLastUsedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSourcingQueryLastUsedAtMutation, { data, loading, error }] = useResetSourcingQueryLastUsedAtMutation({
 *   variables: {
 *      id: // value for 'id'
 *      last_updated_by: // value for 'last_updated_by'
 *   },
 * });
 */
export function useResetSourcingQueryLastUsedAtMutation(baseOptions?: Apollo.MutationHookOptions<ResetSourcingQueryLastUsedAtMutation, ResetSourcingQueryLastUsedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetSourcingQueryLastUsedAtMutation, ResetSourcingQueryLastUsedAtMutationVariables>(ResetSourcingQueryLastUsedAtDocument, options);
      }
export type ResetSourcingQueryLastUsedAtMutationHookResult = ReturnType<typeof useResetSourcingQueryLastUsedAtMutation>;
export type ResetSourcingQueryLastUsedAtMutationResult = Apollo.MutationResult<ResetSourcingQueryLastUsedAtMutation>;
export type ResetSourcingQueryLastUsedAtMutationOptions = Apollo.BaseMutationOptions<ResetSourcingQueryLastUsedAtMutation, ResetSourcingQueryLastUsedAtMutationVariables>;
export const GetUserPermissionsAndProductsDocument = gql`
    query GetUserPermissionsAndProducts($user_id: uuid!, $organization_id: uuid!) {
  users(where: {id: {_eq: $user_id}}) {
    id
    name
    email
    products(where: {organization_id: {_eq: $organization_id}}) {
      product
    }
    organizations(where: {organization_id: {_eq: $organization_id}}) {
      role {
        name
        role_permissions {
          permission {
            resource
            feature
            action
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserPermissionsAndProductsQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionsAndProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionsAndProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionsAndProductsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetUserPermissionsAndProductsQuery(baseOptions: Apollo.QueryHookOptions<GetUserPermissionsAndProductsQuery, GetUserPermissionsAndProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPermissionsAndProductsQuery, GetUserPermissionsAndProductsQueryVariables>(GetUserPermissionsAndProductsDocument, options);
      }
export function useGetUserPermissionsAndProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPermissionsAndProductsQuery, GetUserPermissionsAndProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPermissionsAndProductsQuery, GetUserPermissionsAndProductsQueryVariables>(GetUserPermissionsAndProductsDocument, options);
        }
export type GetUserPermissionsAndProductsQueryHookResult = ReturnType<typeof useGetUserPermissionsAndProductsQuery>;
export type GetUserPermissionsAndProductsLazyQueryHookResult = ReturnType<typeof useGetUserPermissionsAndProductsLazyQuery>;
export type GetUserPermissionsAndProductsQueryResult = Apollo.QueryResult<GetUserPermissionsAndProductsQuery, GetUserPermissionsAndProductsQueryVariables>;
export const PostIocUpdatedDocument = gql`
    mutation PostIOCUpdated($ioc_id: String!, $new_value: String!, $old_value: String!, $type: String!) {
  post_ioc_updated(
    post_ioc_updated_input: {ioc_id: $ioc_id, new_value: $new_value, old_value: $old_value, type: $type}
  ) {
    success
  }
}
    `;
export type PostIocUpdatedMutationFn = Apollo.MutationFunction<PostIocUpdatedMutation, PostIocUpdatedMutationVariables>;

/**
 * __usePostIocUpdatedMutation__
 *
 * To run a mutation, you first call `usePostIocUpdatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostIocUpdatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postIocUpdatedMutation, { data, loading, error }] = usePostIocUpdatedMutation({
 *   variables: {
 *      ioc_id: // value for 'ioc_id'
 *      new_value: // value for 'new_value'
 *      old_value: // value for 'old_value'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePostIocUpdatedMutation(baseOptions?: Apollo.MutationHookOptions<PostIocUpdatedMutation, PostIocUpdatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostIocUpdatedMutation, PostIocUpdatedMutationVariables>(PostIocUpdatedDocument, options);
      }
export type PostIocUpdatedMutationHookResult = ReturnType<typeof usePostIocUpdatedMutation>;
export type PostIocUpdatedMutationResult = Apollo.MutationResult<PostIocUpdatedMutation>;
export type PostIocUpdatedMutationOptions = Apollo.BaseMutationOptions<PostIocUpdatedMutation, PostIocUpdatedMutationVariables>;
export const UpdateUserRoleAndProductsDocument = gql`
    mutation UpdateUserRoleAndProducts($user_id: uuid!, $organization_id: uuid!, $role: String, $products: [String]) {
  update_user_access(
    manage_user_access_input: {request_type: "update", user_id: $user_id, organization_id: $organization_id, role: $role, products: $products}
  ) {
    user_id
    message
  }
}
    `;
export type UpdateUserRoleAndProductsMutationFn = Apollo.MutationFunction<UpdateUserRoleAndProductsMutation, UpdateUserRoleAndProductsMutationVariables>;

/**
 * __useUpdateUserRoleAndProductsMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleAndProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleAndProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleAndProductsMutation, { data, loading, error }] = useUpdateUserRoleAndProductsMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      organization_id: // value for 'organization_id'
 *      role: // value for 'role'
 *      products: // value for 'products'
 *   },
 * });
 */
export function useUpdateUserRoleAndProductsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleAndProductsMutation, UpdateUserRoleAndProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleAndProductsMutation, UpdateUserRoleAndProductsMutationVariables>(UpdateUserRoleAndProductsDocument, options);
      }
export type UpdateUserRoleAndProductsMutationHookResult = ReturnType<typeof useUpdateUserRoleAndProductsMutation>;
export type UpdateUserRoleAndProductsMutationResult = Apollo.MutationResult<UpdateUserRoleAndProductsMutation>;
export type UpdateUserRoleAndProductsMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleAndProductsMutation, UpdateUserRoleAndProductsMutationVariables>;
export const GetDesignatedTakedownAssetsWhereDocument = gql`
    query GetDesignatedTakedownAssetsWhere($offset: Int, $limit: Int, $designated_assets_where: designated_takedown_assets_bool_exp!, $orderBy: [designated_takedown_assets_order_by!], $org_id: uuid!) {
  designated_takedown_assets(
    where: {_and: [$designated_assets_where, {customer_asset: {organization_id: {_eq: $org_id}}}]}
    order_by: $orderBy
    offset: $offset
    limit: $limit
  ) {
    spoofing_entity {
      id
      entity_name
    }
    status
    updated_at
    created_at
    customer_asset {
      id
      value
      status
      platform_subtype {
        id
        name
        platform
      }
    }
    is_organization_default
  }
}
    `;

/**
 * __useGetDesignatedTakedownAssetsWhereQuery__
 *
 * To run a query within a React component, call `useGetDesignatedTakedownAssetsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignatedTakedownAssetsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignatedTakedownAssetsWhereQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      designated_assets_where: // value for 'designated_assets_where'
 *      orderBy: // value for 'orderBy'
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetDesignatedTakedownAssetsWhereQuery(baseOptions: Apollo.QueryHookOptions<GetDesignatedTakedownAssetsWhereQuery, GetDesignatedTakedownAssetsWhereQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignatedTakedownAssetsWhereQuery, GetDesignatedTakedownAssetsWhereQueryVariables>(GetDesignatedTakedownAssetsWhereDocument, options);
      }
export function useGetDesignatedTakedownAssetsWhereLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignatedTakedownAssetsWhereQuery, GetDesignatedTakedownAssetsWhereQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignatedTakedownAssetsWhereQuery, GetDesignatedTakedownAssetsWhereQueryVariables>(GetDesignatedTakedownAssetsWhereDocument, options);
        }
export type GetDesignatedTakedownAssetsWhereQueryHookResult = ReturnType<typeof useGetDesignatedTakedownAssetsWhereQuery>;
export type GetDesignatedTakedownAssetsWhereLazyQueryHookResult = ReturnType<typeof useGetDesignatedTakedownAssetsWhereLazyQuery>;
export type GetDesignatedTakedownAssetsWhereQueryResult = Apollo.QueryResult<GetDesignatedTakedownAssetsWhereQuery, GetDesignatedTakedownAssetsWhereQueryVariables>;
export const GetDesignatedTakedownAssetsCountDocument = gql`
    query GetDesignatedTakedownAssetsCount($designated_assets_where: designated_takedown_assets_bool_exp!, $org_id: uuid!) {
  designated_takedown_assets_aggregate(
    where: {_and: [$designated_assets_where, {customer_asset: {organization_id: {_eq: $org_id}}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetDesignatedTakedownAssetsCountQuery__
 *
 * To run a query within a React component, call `useGetDesignatedTakedownAssetsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignatedTakedownAssetsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignatedTakedownAssetsCountQuery({
 *   variables: {
 *      designated_assets_where: // value for 'designated_assets_where'
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetDesignatedTakedownAssetsCountQuery(baseOptions: Apollo.QueryHookOptions<GetDesignatedTakedownAssetsCountQuery, GetDesignatedTakedownAssetsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignatedTakedownAssetsCountQuery, GetDesignatedTakedownAssetsCountQueryVariables>(GetDesignatedTakedownAssetsCountDocument, options);
      }
export function useGetDesignatedTakedownAssetsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignatedTakedownAssetsCountQuery, GetDesignatedTakedownAssetsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignatedTakedownAssetsCountQuery, GetDesignatedTakedownAssetsCountQueryVariables>(GetDesignatedTakedownAssetsCountDocument, options);
        }
export type GetDesignatedTakedownAssetsCountQueryHookResult = ReturnType<typeof useGetDesignatedTakedownAssetsCountQuery>;
export type GetDesignatedTakedownAssetsCountLazyQueryHookResult = ReturnType<typeof useGetDesignatedTakedownAssetsCountLazyQuery>;
export type GetDesignatedTakedownAssetsCountQueryResult = Apollo.QueryResult<GetDesignatedTakedownAssetsCountQuery, GetDesignatedTakedownAssetsCountQueryVariables>;
export const GetDesignatedTakedownAssetsPlatformSubtypesDocument = gql`
    query GetDesignatedTakedownAssetsPlatformSubtypes($org_id: uuid!) {
  designated_takedown_assets(
    where: {_and: [{customer_asset: {organization_id: {_eq: $org_id}}}]}
  ) {
    customer_asset {
      platform_subtype {
        id
        name
        platform
      }
    }
  }
}
    `;

/**
 * __useGetDesignatedTakedownAssetsPlatformSubtypesQuery__
 *
 * To run a query within a React component, call `useGetDesignatedTakedownAssetsPlatformSubtypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignatedTakedownAssetsPlatformSubtypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignatedTakedownAssetsPlatformSubtypesQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetDesignatedTakedownAssetsPlatformSubtypesQuery(baseOptions: Apollo.QueryHookOptions<GetDesignatedTakedownAssetsPlatformSubtypesQuery, GetDesignatedTakedownAssetsPlatformSubtypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignatedTakedownAssetsPlatformSubtypesQuery, GetDesignatedTakedownAssetsPlatformSubtypesQueryVariables>(GetDesignatedTakedownAssetsPlatformSubtypesDocument, options);
      }
export function useGetDesignatedTakedownAssetsPlatformSubtypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignatedTakedownAssetsPlatformSubtypesQuery, GetDesignatedTakedownAssetsPlatformSubtypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignatedTakedownAssetsPlatformSubtypesQuery, GetDesignatedTakedownAssetsPlatformSubtypesQueryVariables>(GetDesignatedTakedownAssetsPlatformSubtypesDocument, options);
        }
export type GetDesignatedTakedownAssetsPlatformSubtypesQueryHookResult = ReturnType<typeof useGetDesignatedTakedownAssetsPlatformSubtypesQuery>;
export type GetDesignatedTakedownAssetsPlatformSubtypesLazyQueryHookResult = ReturnType<typeof useGetDesignatedTakedownAssetsPlatformSubtypesLazyQuery>;
export type GetDesignatedTakedownAssetsPlatformSubtypesQueryResult = Apollo.QueryResult<GetDesignatedTakedownAssetsPlatformSubtypesQuery, GetDesignatedTakedownAssetsPlatformSubtypesQueryVariables>;
export const GetDesignatedTakedownAssetsBrandsDocument = gql`
    query GetDesignatedTakedownAssetsBrands($org_id: uuid!) {
  designated_takedown_assets(
    distinct_on: brand_id
    where: {_and: [{customer_asset: {organization_id: {_eq: $org_id}}}]}
  ) {
    spoofing_entity {
      id
      entity_name
    }
  }
}
    `;

/**
 * __useGetDesignatedTakedownAssetsBrandsQuery__
 *
 * To run a query within a React component, call `useGetDesignatedTakedownAssetsBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignatedTakedownAssetsBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignatedTakedownAssetsBrandsQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetDesignatedTakedownAssetsBrandsQuery(baseOptions: Apollo.QueryHookOptions<GetDesignatedTakedownAssetsBrandsQuery, GetDesignatedTakedownAssetsBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignatedTakedownAssetsBrandsQuery, GetDesignatedTakedownAssetsBrandsQueryVariables>(GetDesignatedTakedownAssetsBrandsDocument, options);
      }
export function useGetDesignatedTakedownAssetsBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignatedTakedownAssetsBrandsQuery, GetDesignatedTakedownAssetsBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignatedTakedownAssetsBrandsQuery, GetDesignatedTakedownAssetsBrandsQueryVariables>(GetDesignatedTakedownAssetsBrandsDocument, options);
        }
export type GetDesignatedTakedownAssetsBrandsQueryHookResult = ReturnType<typeof useGetDesignatedTakedownAssetsBrandsQuery>;
export type GetDesignatedTakedownAssetsBrandsLazyQueryHookResult = ReturnType<typeof useGetDesignatedTakedownAssetsBrandsLazyQuery>;
export type GetDesignatedTakedownAssetsBrandsQueryResult = Apollo.QueryResult<GetDesignatedTakedownAssetsBrandsQuery, GetDesignatedTakedownAssetsBrandsQueryVariables>;
export const GetCustomerAssetsByBrandWhereDocument = gql`
    query GetCustomerAssetsByBrandWhere($where: customer_assets_to_brands_bool_exp!, $limit: Int, $offset: Int, $order_by: [customer_assets_to_brands_order_by!]) {
  customer_assets_to_brands(
    where: $where
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    brand_id
    customer_asset {
      id
      value
      status
    }
  }
}
    `;

/**
 * __useGetCustomerAssetsByBrandWhereQuery__
 *
 * To run a query within a React component, call `useGetCustomerAssetsByBrandWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAssetsByBrandWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAssetsByBrandWhereQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetCustomerAssetsByBrandWhereQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAssetsByBrandWhereQuery, GetCustomerAssetsByBrandWhereQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAssetsByBrandWhereQuery, GetCustomerAssetsByBrandWhereQueryVariables>(GetCustomerAssetsByBrandWhereDocument, options);
      }
export function useGetCustomerAssetsByBrandWhereLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAssetsByBrandWhereQuery, GetCustomerAssetsByBrandWhereQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAssetsByBrandWhereQuery, GetCustomerAssetsByBrandWhereQueryVariables>(GetCustomerAssetsByBrandWhereDocument, options);
        }
export type GetCustomerAssetsByBrandWhereQueryHookResult = ReturnType<typeof useGetCustomerAssetsByBrandWhereQuery>;
export type GetCustomerAssetsByBrandWhereLazyQueryHookResult = ReturnType<typeof useGetCustomerAssetsByBrandWhereLazyQuery>;
export type GetCustomerAssetsByBrandWhereQueryResult = Apollo.QueryResult<GetCustomerAssetsByBrandWhereQuery, GetCustomerAssetsByBrandWhereQueryVariables>;
export const GetCustomerAssetsByBrandCountDocument = gql`
    query GetCustomerAssetsByBrandCount($where: customer_assets_to_brands_bool_exp!) {
  customer_assets_to_brands_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetCustomerAssetsByBrandCountQuery__
 *
 * To run a query within a React component, call `useGetCustomerAssetsByBrandCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAssetsByBrandCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAssetsByBrandCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCustomerAssetsByBrandCountQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAssetsByBrandCountQuery, GetCustomerAssetsByBrandCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAssetsByBrandCountQuery, GetCustomerAssetsByBrandCountQueryVariables>(GetCustomerAssetsByBrandCountDocument, options);
      }
export function useGetCustomerAssetsByBrandCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAssetsByBrandCountQuery, GetCustomerAssetsByBrandCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAssetsByBrandCountQuery, GetCustomerAssetsByBrandCountQueryVariables>(GetCustomerAssetsByBrandCountDocument, options);
        }
export type GetCustomerAssetsByBrandCountQueryHookResult = ReturnType<typeof useGetCustomerAssetsByBrandCountQuery>;
export type GetCustomerAssetsByBrandCountLazyQueryHookResult = ReturnType<typeof useGetCustomerAssetsByBrandCountLazyQuery>;
export type GetCustomerAssetsByBrandCountQueryResult = Apollo.QueryResult<GetCustomerAssetsByBrandCountQuery, GetCustomerAssetsByBrandCountQueryVariables>;
export const InsertDesignatedTakedownAssetDocument = gql`
    mutation InsertDesignatedTakedownAsset($customer_asset_id: uuid!, $is_organization_default: Boolean!, $status: String!, $brand_id: uuid) {
  insert_designated_takedown_assets_one(
    object: {brand_id: $brand_id, customer_asset_id: $customer_asset_id, is_organization_default: $is_organization_default, status: $status}
    on_conflict: {constraint: designated_takedown_assets_customer_asset_id_brand_id_key, update_columns: [status]}
  ) {
    id
  }
}
    `;
export type InsertDesignatedTakedownAssetMutationFn = Apollo.MutationFunction<InsertDesignatedTakedownAssetMutation, InsertDesignatedTakedownAssetMutationVariables>;

/**
 * __useInsertDesignatedTakedownAssetMutation__
 *
 * To run a mutation, you first call `useInsertDesignatedTakedownAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDesignatedTakedownAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDesignatedTakedownAssetMutation, { data, loading, error }] = useInsertDesignatedTakedownAssetMutation({
 *   variables: {
 *      customer_asset_id: // value for 'customer_asset_id'
 *      is_organization_default: // value for 'is_organization_default'
 *      status: // value for 'status'
 *      brand_id: // value for 'brand_id'
 *   },
 * });
 */
export function useInsertDesignatedTakedownAssetMutation(baseOptions?: Apollo.MutationHookOptions<InsertDesignatedTakedownAssetMutation, InsertDesignatedTakedownAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertDesignatedTakedownAssetMutation, InsertDesignatedTakedownAssetMutationVariables>(InsertDesignatedTakedownAssetDocument, options);
      }
export type InsertDesignatedTakedownAssetMutationHookResult = ReturnType<typeof useInsertDesignatedTakedownAssetMutation>;
export type InsertDesignatedTakedownAssetMutationResult = Apollo.MutationResult<InsertDesignatedTakedownAssetMutation>;
export type InsertDesignatedTakedownAssetMutationOptions = Apollo.BaseMutationOptions<InsertDesignatedTakedownAssetMutation, InsertDesignatedTakedownAssetMutationVariables>;
export const InsertOrgDefaultTakedownAssetDocument = gql`
    mutation InsertOrgDefaultTakedownAsset($customer_asset_id: uuid!, $status: String!) {
  insert_designated_takedown_assets_one(
    object: {customer_asset_id: $customer_asset_id, is_organization_default: true, status: $status}
  ) {
    id
  }
}
    `;
export type InsertOrgDefaultTakedownAssetMutationFn = Apollo.MutationFunction<InsertOrgDefaultTakedownAssetMutation, InsertOrgDefaultTakedownAssetMutationVariables>;

/**
 * __useInsertOrgDefaultTakedownAssetMutation__
 *
 * To run a mutation, you first call `useInsertOrgDefaultTakedownAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertOrgDefaultTakedownAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertOrgDefaultTakedownAssetMutation, { data, loading, error }] = useInsertOrgDefaultTakedownAssetMutation({
 *   variables: {
 *      customer_asset_id: // value for 'customer_asset_id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useInsertOrgDefaultTakedownAssetMutation(baseOptions?: Apollo.MutationHookOptions<InsertOrgDefaultTakedownAssetMutation, InsertOrgDefaultTakedownAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertOrgDefaultTakedownAssetMutation, InsertOrgDefaultTakedownAssetMutationVariables>(InsertOrgDefaultTakedownAssetDocument, options);
      }
export type InsertOrgDefaultTakedownAssetMutationHookResult = ReturnType<typeof useInsertOrgDefaultTakedownAssetMutation>;
export type InsertOrgDefaultTakedownAssetMutationResult = Apollo.MutationResult<InsertOrgDefaultTakedownAssetMutation>;
export type InsertOrgDefaultTakedownAssetMutationOptions = Apollo.BaseMutationOptions<InsertOrgDefaultTakedownAssetMutation, InsertOrgDefaultTakedownAssetMutationVariables>;
export const UpdateOrgDefaultDesignatedTakedownAssetStatusDocument = gql`
    mutation UpdateOrgDefaultDesignatedTakedownAssetStatus($customer_asset_id: uuid!, $new_status: String!) {
  update_designated_takedown_assets(
    where: {_and: {is_organization_default: {_eq: true}, customer_asset_id: {_eq: $customer_asset_id}}}
    _set: {status: $new_status}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateOrgDefaultDesignatedTakedownAssetStatusMutationFn = Apollo.MutationFunction<UpdateOrgDefaultDesignatedTakedownAssetStatusMutation, UpdateOrgDefaultDesignatedTakedownAssetStatusMutationVariables>;

/**
 * __useUpdateOrgDefaultDesignatedTakedownAssetStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrgDefaultDesignatedTakedownAssetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgDefaultDesignatedTakedownAssetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgDefaultDesignatedTakedownAssetStatusMutation, { data, loading, error }] = useUpdateOrgDefaultDesignatedTakedownAssetStatusMutation({
 *   variables: {
 *      customer_asset_id: // value for 'customer_asset_id'
 *      new_status: // value for 'new_status'
 *   },
 * });
 */
export function useUpdateOrgDefaultDesignatedTakedownAssetStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgDefaultDesignatedTakedownAssetStatusMutation, UpdateOrgDefaultDesignatedTakedownAssetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgDefaultDesignatedTakedownAssetStatusMutation, UpdateOrgDefaultDesignatedTakedownAssetStatusMutationVariables>(UpdateOrgDefaultDesignatedTakedownAssetStatusDocument, options);
      }
export type UpdateOrgDefaultDesignatedTakedownAssetStatusMutationHookResult = ReturnType<typeof useUpdateOrgDefaultDesignatedTakedownAssetStatusMutation>;
export type UpdateOrgDefaultDesignatedTakedownAssetStatusMutationResult = Apollo.MutationResult<UpdateOrgDefaultDesignatedTakedownAssetStatusMutation>;
export type UpdateOrgDefaultDesignatedTakedownAssetStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrgDefaultDesignatedTakedownAssetStatusMutation, UpdateOrgDefaultDesignatedTakedownAssetStatusMutationVariables>;
export const UpdateDesignatedTakedownAssetStatusDocument = gql`
    mutation UpdateDesignatedTakedownAssetStatus($customer_asset_id: uuid!, $brand_id: uuid, $new_status: String!) {
  update_designated_takedown_assets(
    where: {_and: {brand_id: {_eq: $brand_id}, customer_asset_id: {_eq: $customer_asset_id}}}
    _set: {status: $new_status}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateDesignatedTakedownAssetStatusMutationFn = Apollo.MutationFunction<UpdateDesignatedTakedownAssetStatusMutation, UpdateDesignatedTakedownAssetStatusMutationVariables>;

/**
 * __useUpdateDesignatedTakedownAssetStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDesignatedTakedownAssetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDesignatedTakedownAssetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDesignatedTakedownAssetStatusMutation, { data, loading, error }] = useUpdateDesignatedTakedownAssetStatusMutation({
 *   variables: {
 *      customer_asset_id: // value for 'customer_asset_id'
 *      brand_id: // value for 'brand_id'
 *      new_status: // value for 'new_status'
 *   },
 * });
 */
export function useUpdateDesignatedTakedownAssetStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDesignatedTakedownAssetStatusMutation, UpdateDesignatedTakedownAssetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDesignatedTakedownAssetStatusMutation, UpdateDesignatedTakedownAssetStatusMutationVariables>(UpdateDesignatedTakedownAssetStatusDocument, options);
      }
export type UpdateDesignatedTakedownAssetStatusMutationHookResult = ReturnType<typeof useUpdateDesignatedTakedownAssetStatusMutation>;
export type UpdateDesignatedTakedownAssetStatusMutationResult = Apollo.MutationResult<UpdateDesignatedTakedownAssetStatusMutation>;
export type UpdateDesignatedTakedownAssetStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDesignatedTakedownAssetStatusMutation, UpdateDesignatedTakedownAssetStatusMutationVariables>;
export const GetCustomerAssetToBrandEntryDocument = gql`
    query GetCustomerAssetToBrandEntry($brand_id: uuid!, $customer_asset_id: uuid!) {
  customer_assets_to_brands_by_pk(
    brand_id: $brand_id
    customer_asset_id: $customer_asset_id
  ) {
    brand_id
    customer_asset_id
  }
}
    `;

/**
 * __useGetCustomerAssetToBrandEntryQuery__
 *
 * To run a query within a React component, call `useGetCustomerAssetToBrandEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAssetToBrandEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAssetToBrandEntryQuery({
 *   variables: {
 *      brand_id: // value for 'brand_id'
 *      customer_asset_id: // value for 'customer_asset_id'
 *   },
 * });
 */
export function useGetCustomerAssetToBrandEntryQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAssetToBrandEntryQuery, GetCustomerAssetToBrandEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAssetToBrandEntryQuery, GetCustomerAssetToBrandEntryQueryVariables>(GetCustomerAssetToBrandEntryDocument, options);
      }
export function useGetCustomerAssetToBrandEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAssetToBrandEntryQuery, GetCustomerAssetToBrandEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAssetToBrandEntryQuery, GetCustomerAssetToBrandEntryQueryVariables>(GetCustomerAssetToBrandEntryDocument, options);
        }
export type GetCustomerAssetToBrandEntryQueryHookResult = ReturnType<typeof useGetCustomerAssetToBrandEntryQuery>;
export type GetCustomerAssetToBrandEntryLazyQueryHookResult = ReturnType<typeof useGetCustomerAssetToBrandEntryLazyQuery>;
export type GetCustomerAssetToBrandEntryQueryResult = Apollo.QueryResult<GetCustomerAssetToBrandEntryQuery, GetCustomerAssetToBrandEntryQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($email: String!, $organizations: [String!]!, $role: String!, $products: [String]!, $is_internal: Boolean!) {
  create_user_v2(
    manage_users_input: {request_type: "create", email: $email, name: $email, organizations: $organizations, role: $role, products: $products, is_internal: $is_internal}
  ) {
    message
    user_id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      organizations: // value for 'organizations'
 *      role: // value for 'role'
 *      products: // value for 'products'
 *      is_internal: // value for 'is_internal'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($user_id: uuid!) {
  delete_user(manage_users_input: {request_type: "delete", user_id: $user_id}) {
    message
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ActivateUserDocument = gql`
    mutation ActivateUser($user_id: uuid!) {
  update_user_v2(
    manage_users_input: {request_type: "update", user_id: $user_id, onboarding_status: "active"}
  ) {
    message
  }
}
    `;
export type ActivateUserMutationFn = Apollo.MutationFunction<ActivateUserMutation, ActivateUserMutationVariables>;

/**
 * __useActivateUserMutation__
 *
 * To run a mutation, you first call `useActivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUserMutation, { data, loading, error }] = useActivateUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useActivateUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateUserMutation, ActivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateUserMutation, ActivateUserMutationVariables>(ActivateUserDocument, options);
      }
export type ActivateUserMutationHookResult = ReturnType<typeof useActivateUserMutation>;
export type ActivateUserMutationResult = Apollo.MutationResult<ActivateUserMutation>;
export type ActivateUserMutationOptions = Apollo.BaseMutationOptions<ActivateUserMutation, ActivateUserMutationVariables>;
export const GetAiPromptsIdsWhereDocument = gql`
    query GetAiPromptsIdsWhere($ai_prompts_where: ai_prompts_bool_exp!) {
  ai_prompts(where: $ai_prompts_where) {
    id
  }
}
    `;

/**
 * __useGetAiPromptsIdsWhereQuery__
 *
 * To run a query within a React component, call `useGetAiPromptsIdsWhereQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiPromptsIdsWhereQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiPromptsIdsWhereQuery({
 *   variables: {
 *      ai_prompts_where: // value for 'ai_prompts_where'
 *   },
 * });
 */
export function useGetAiPromptsIdsWhereQuery(baseOptions: Apollo.QueryHookOptions<GetAiPromptsIdsWhereQuery, GetAiPromptsIdsWhereQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiPromptsIdsWhereQuery, GetAiPromptsIdsWhereQueryVariables>(GetAiPromptsIdsWhereDocument, options);
      }
export function useGetAiPromptsIdsWhereLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiPromptsIdsWhereQuery, GetAiPromptsIdsWhereQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiPromptsIdsWhereQuery, GetAiPromptsIdsWhereQueryVariables>(GetAiPromptsIdsWhereDocument, options);
        }
export type GetAiPromptsIdsWhereQueryHookResult = ReturnType<typeof useGetAiPromptsIdsWhereQuery>;
export type GetAiPromptsIdsWhereLazyQueryHookResult = ReturnType<typeof useGetAiPromptsIdsWhereLazyQuery>;
export type GetAiPromptsIdsWhereQueryResult = Apollo.QueryResult<GetAiPromptsIdsWhereQuery, GetAiPromptsIdsWhereQueryVariables>;
export const GetCustomerAssetsSubtypesByOrgDocument = gql`
    query GetCustomerAssetsSubtypesByOrg($org_id: uuid!) {
  customer_assets(
    distinct_on: platform_subtype_id
    where: {_and: [{organization_id: {_eq: $org_id}}]}
  ) {
    platform_subtype {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCustomerAssetsSubtypesByOrgQuery__
 *
 * To run a query within a React component, call `useGetCustomerAssetsSubtypesByOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAssetsSubtypesByOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAssetsSubtypesByOrgQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetCustomerAssetsSubtypesByOrgQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAssetsSubtypesByOrgQuery, GetCustomerAssetsSubtypesByOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAssetsSubtypesByOrgQuery, GetCustomerAssetsSubtypesByOrgQueryVariables>(GetCustomerAssetsSubtypesByOrgDocument, options);
      }
export function useGetCustomerAssetsSubtypesByOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAssetsSubtypesByOrgQuery, GetCustomerAssetsSubtypesByOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAssetsSubtypesByOrgQuery, GetCustomerAssetsSubtypesByOrgQueryVariables>(GetCustomerAssetsSubtypesByOrgDocument, options);
        }
export type GetCustomerAssetsSubtypesByOrgQueryHookResult = ReturnType<typeof useGetCustomerAssetsSubtypesByOrgQuery>;
export type GetCustomerAssetsSubtypesByOrgLazyQueryHookResult = ReturnType<typeof useGetCustomerAssetsSubtypesByOrgLazyQuery>;
export type GetCustomerAssetsSubtypesByOrgQueryResult = Apollo.QueryResult<GetCustomerAssetsSubtypesByOrgQuery, GetCustomerAssetsSubtypesByOrgQueryVariables>;
export const GetTakedownRequestsCountForTrialOrgDocument = gql`
    query GetTakedownRequestsCountForTrialOrg($organization_id: uuid!) {
  collection_report_changes_aggregate(
    where: {spoofing_report: {organization_id: {_eq: $organization_id}}, type: {_eq: "report_status"}, new_value: {_eq: "reported"}}
    distinct_on: spoof_report_id
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetTakedownRequestsCountForTrialOrgQuery__
 *
 * To run a query within a React component, call `useGetTakedownRequestsCountForTrialOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTakedownRequestsCountForTrialOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTakedownRequestsCountForTrialOrgQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetTakedownRequestsCountForTrialOrgQuery(baseOptions: Apollo.QueryHookOptions<GetTakedownRequestsCountForTrialOrgQuery, GetTakedownRequestsCountForTrialOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTakedownRequestsCountForTrialOrgQuery, GetTakedownRequestsCountForTrialOrgQueryVariables>(GetTakedownRequestsCountForTrialOrgDocument, options);
      }
export function useGetTakedownRequestsCountForTrialOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTakedownRequestsCountForTrialOrgQuery, GetTakedownRequestsCountForTrialOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTakedownRequestsCountForTrialOrgQuery, GetTakedownRequestsCountForTrialOrgQueryVariables>(GetTakedownRequestsCountForTrialOrgDocument, options);
        }
export type GetTakedownRequestsCountForTrialOrgQueryHookResult = ReturnType<typeof useGetTakedownRequestsCountForTrialOrgQuery>;
export type GetTakedownRequestsCountForTrialOrgLazyQueryHookResult = ReturnType<typeof useGetTakedownRequestsCountForTrialOrgLazyQuery>;
export type GetTakedownRequestsCountForTrialOrgQueryResult = Apollo.QueryResult<GetTakedownRequestsCountForTrialOrgQuery, GetTakedownRequestsCountForTrialOrgQueryVariables>;
export const GetAssignedAlertCountsDocument = gql`
    query GetAssignedAlertCounts($assigneeIds: [uuid!]) {
  assignee_counts: spoofing_reports_aggregate(
    where: {_and: [{internal_alert_assignee: {id: {_in: $assigneeIds}}}, {organization: {organization_status: {_neq: "test_org"}}}]}
  ) {
    aggregate {
      count
    }
    nodes {
      internal_alert_assignee {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useGetAssignedAlertCountsQuery__
 *
 * To run a query within a React component, call `useGetAssignedAlertCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedAlertCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedAlertCountsQuery({
 *   variables: {
 *      assigneeIds: // value for 'assigneeIds'
 *   },
 * });
 */
export function useGetAssignedAlertCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssignedAlertCountsQuery, GetAssignedAlertCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedAlertCountsQuery, GetAssignedAlertCountsQueryVariables>(GetAssignedAlertCountsDocument, options);
      }
export function useGetAssignedAlertCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedAlertCountsQuery, GetAssignedAlertCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedAlertCountsQuery, GetAssignedAlertCountsQueryVariables>(GetAssignedAlertCountsDocument, options);
        }
export type GetAssignedAlertCountsQueryHookResult = ReturnType<typeof useGetAssignedAlertCountsQuery>;
export type GetAssignedAlertCountsLazyQueryHookResult = ReturnType<typeof useGetAssignedAlertCountsLazyQuery>;
export type GetAssignedAlertCountsQueryResult = Apollo.QueryResult<GetAssignedAlertCountsQuery, GetAssignedAlertCountsQueryVariables>;
export const GetAssignedAlertsDocument = gql`
    query GetAssignedAlerts($assigneeId: uuid!) {
  assigned_alerts: spoofing_reports(
    where: {internal_alert_assignee: {id: {_eq: $assigneeId}}}
  ) {
    id
  }
}
    `;

/**
 * __useGetAssignedAlertsQuery__
 *
 * To run a query within a React component, call `useGetAssignedAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedAlertsQuery({
 *   variables: {
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useGetAssignedAlertsQuery(baseOptions: Apollo.QueryHookOptions<GetAssignedAlertsQuery, GetAssignedAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedAlertsQuery, GetAssignedAlertsQueryVariables>(GetAssignedAlertsDocument, options);
      }
export function useGetAssignedAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedAlertsQuery, GetAssignedAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedAlertsQuery, GetAssignedAlertsQueryVariables>(GetAssignedAlertsDocument, options);
        }
export type GetAssignedAlertsQueryHookResult = ReturnType<typeof useGetAssignedAlertsQuery>;
export type GetAssignedAlertsLazyQueryHookResult = ReturnType<typeof useGetAssignedAlertsLazyQuery>;
export type GetAssignedAlertsQueryResult = Apollo.QueryResult<GetAssignedAlertsQuery, GetAssignedAlertsQueryVariables>;
export const GetEmailSettingsByOrgIdDocument = gql`
    query GetEmailSettingsByOrgId($org_id: uuid!) {
  email_settings(where: {organization_id: {_eq: $org_id}}) {
    ...EmailSettings
  }
}
    ${EmailSettingsFragmentDoc}`;

/**
 * __useGetEmailSettingsByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetEmailSettingsByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailSettingsByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailSettingsByOrgIdQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetEmailSettingsByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<GetEmailSettingsByOrgIdQuery, GetEmailSettingsByOrgIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailSettingsByOrgIdQuery, GetEmailSettingsByOrgIdQueryVariables>(GetEmailSettingsByOrgIdDocument, options);
      }
export function useGetEmailSettingsByOrgIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailSettingsByOrgIdQuery, GetEmailSettingsByOrgIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailSettingsByOrgIdQuery, GetEmailSettingsByOrgIdQueryVariables>(GetEmailSettingsByOrgIdDocument, options);
        }
export type GetEmailSettingsByOrgIdQueryHookResult = ReturnType<typeof useGetEmailSettingsByOrgIdQuery>;
export type GetEmailSettingsByOrgIdLazyQueryHookResult = ReturnType<typeof useGetEmailSettingsByOrgIdLazyQuery>;
export type GetEmailSettingsByOrgIdQueryResult = Apollo.QueryResult<GetEmailSettingsByOrgIdQuery, GetEmailSettingsByOrgIdQueryVariables>;
export const GetOrganizationIdsForUserWithRolesDocument = gql`
    query GetOrganizationIdsForUserWithRoles($user_id: uuid!) {
  users_by_pk(id: $user_id) {
    organizations {
      organization {
        id
        name
        is_parent
      }
      role_id
    }
  }
}
    `;

/**
 * __useGetOrganizationIdsForUserWithRolesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationIdsForUserWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationIdsForUserWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationIdsForUserWithRolesQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetOrganizationIdsForUserWithRolesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationIdsForUserWithRolesQuery, GetOrganizationIdsForUserWithRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationIdsForUserWithRolesQuery, GetOrganizationIdsForUserWithRolesQueryVariables>(GetOrganizationIdsForUserWithRolesDocument, options);
      }
export function useGetOrganizationIdsForUserWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationIdsForUserWithRolesQuery, GetOrganizationIdsForUserWithRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationIdsForUserWithRolesQuery, GetOrganizationIdsForUserWithRolesQueryVariables>(GetOrganizationIdsForUserWithRolesDocument, options);
        }
export type GetOrganizationIdsForUserWithRolesQueryHookResult = ReturnType<typeof useGetOrganizationIdsForUserWithRolesQuery>;
export type GetOrganizationIdsForUserWithRolesLazyQueryHookResult = ReturnType<typeof useGetOrganizationIdsForUserWithRolesLazyQuery>;
export type GetOrganizationIdsForUserWithRolesQueryResult = Apollo.QueryResult<GetOrganizationIdsForUserWithRolesQuery, GetOrganizationIdsForUserWithRolesQueryVariables>;
export const CreatePiiMemberDocument = gql`
    mutation CreatePIIMember($input: PiiCreateMemberInput!) {
  create_pii_member(pii_create_member_input: $input) {
    success
    message
    uuid
  }
}
    `;
export type CreatePiiMemberMutationFn = Apollo.MutationFunction<CreatePiiMemberMutation, CreatePiiMemberMutationVariables>;

/**
 * __useCreatePiiMemberMutation__
 *
 * To run a mutation, you first call `useCreatePiiMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePiiMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPiiMemberMutation, { data, loading, error }] = useCreatePiiMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePiiMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreatePiiMemberMutation, CreatePiiMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePiiMemberMutation, CreatePiiMemberMutationVariables>(CreatePiiMemberDocument, options);
      }
export type CreatePiiMemberMutationHookResult = ReturnType<typeof useCreatePiiMemberMutation>;
export type CreatePiiMemberMutationResult = Apollo.MutationResult<CreatePiiMemberMutation>;
export type CreatePiiMemberMutationOptions = Apollo.BaseMutationOptions<CreatePiiMemberMutation, CreatePiiMemberMutationVariables>;
export const EditPiiMemberDocument = gql`
    mutation EditPIIMember($input: PiiEditMemberInput!) {
  edit_pii_member(pii_edit_member_input: $input) {
    success
    message
    uuid
  }
}
    `;
export type EditPiiMemberMutationFn = Apollo.MutationFunction<EditPiiMemberMutation, EditPiiMemberMutationVariables>;

/**
 * __useEditPiiMemberMutation__
 *
 * To run a mutation, you first call `useEditPiiMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPiiMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPiiMemberMutation, { data, loading, error }] = useEditPiiMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPiiMemberMutation(baseOptions?: Apollo.MutationHookOptions<EditPiiMemberMutation, EditPiiMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPiiMemberMutation, EditPiiMemberMutationVariables>(EditPiiMemberDocument, options);
      }
export type EditPiiMemberMutationHookResult = ReturnType<typeof useEditPiiMemberMutation>;
export type EditPiiMemberMutationResult = Apollo.MutationResult<EditPiiMemberMutation>;
export type EditPiiMemberMutationOptions = Apollo.BaseMutationOptions<EditPiiMemberMutation, EditPiiMemberMutationVariables>;
export const GetPiiMemberDocument = gql`
    query GetPIIMember($input: PiiGetMemberInput!) {
  get_pii_member(pii_get_member_input: $input) {
    emails {
      email
      uuid
    }
    phoneNumbers {
      number
      uuid
    }
    companies {
      name
      isCurrent
      uuid
    }
    linkedinUrl
    relatives {
      firstName
      middleName
      lastName
      uuid
    }
    names {
      firstName
      middleName
      lastName
      uuid
    }
    locations {
      city
      country
      state
      addressLine1
      addressLine2
      zipCode
      uuid
    }
    birthDay
    birthMonth
    birthYear
  }
}
    `;

/**
 * __useGetPiiMemberQuery__
 *
 * To run a query within a React component, call `useGetPiiMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPiiMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPiiMemberQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPiiMemberQuery(baseOptions: Apollo.QueryHookOptions<GetPiiMemberQuery, GetPiiMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPiiMemberQuery, GetPiiMemberQueryVariables>(GetPiiMemberDocument, options);
      }
export function useGetPiiMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPiiMemberQuery, GetPiiMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPiiMemberQuery, GetPiiMemberQueryVariables>(GetPiiMemberDocument, options);
        }
export type GetPiiMemberQueryHookResult = ReturnType<typeof useGetPiiMemberQuery>;
export type GetPiiMemberLazyQueryHookResult = ReturnType<typeof useGetPiiMemberLazyQuery>;
export type GetPiiMemberQueryResult = Apollo.QueryResult<GetPiiMemberQuery, GetPiiMemberQueryVariables>;
export const GetPiiDropdownUsersDocument = gql`
    query GetPIIDropdownUsers($organization_id: uuid!) {
  users(
    where: {organization_id: {_eq: $organization_id}, _or: [{optery_member_uuid: {_is_null: false}}, {email: {_eq: "julian.decurnex@doppel.com"}}]}
  ) {
    id
    email
    name
    is_internal
    optery_member_uuid
  }
}
    `;

/**
 * __useGetPiiDropdownUsersQuery__
 *
 * To run a query within a React component, call `useGetPiiDropdownUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPiiDropdownUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPiiDropdownUsersQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetPiiDropdownUsersQuery(baseOptions: Apollo.QueryHookOptions<GetPiiDropdownUsersQuery, GetPiiDropdownUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPiiDropdownUsersQuery, GetPiiDropdownUsersQueryVariables>(GetPiiDropdownUsersDocument, options);
      }
export function useGetPiiDropdownUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPiiDropdownUsersQuery, GetPiiDropdownUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPiiDropdownUsersQuery, GetPiiDropdownUsersQueryVariables>(GetPiiDropdownUsersDocument, options);
        }
export type GetPiiDropdownUsersQueryHookResult = ReturnType<typeof useGetPiiDropdownUsersQuery>;
export type GetPiiDropdownUsersLazyQueryHookResult = ReturnType<typeof useGetPiiDropdownUsersLazyQuery>;
export type GetPiiDropdownUsersQueryResult = Apollo.QueryResult<GetPiiDropdownUsersQuery, GetPiiDropdownUsersQueryVariables>;
export const GetUserOnboardingStatusDocument = gql`
    query GetUserOnboardingStatus($userId: uuid!) {
  users_by_pk(id: $userId) {
    id
    onboarding_status
  }
}
    `;

/**
 * __useGetUserOnboardingStatusQuery__
 *
 * To run a query within a React component, call `useGetUserOnboardingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOnboardingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOnboardingStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserOnboardingStatusQuery(baseOptions: Apollo.QueryHookOptions<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>(GetUserOnboardingStatusDocument, options);
      }
export function useGetUserOnboardingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>(GetUserOnboardingStatusDocument, options);
        }
export type GetUserOnboardingStatusQueryHookResult = ReturnType<typeof useGetUserOnboardingStatusQuery>;
export type GetUserOnboardingStatusLazyQueryHookResult = ReturnType<typeof useGetUserOnboardingStatusLazyQuery>;
export type GetUserOnboardingStatusQueryResult = Apollo.QueryResult<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>;
export const DeletePiiMemberDocument = gql`
    mutation DeletePIIMember($input: PiiDeleteMemberInput!) {
  delete_pii_member(pii_delete_member_input: $input) {
    success
    message
  }
}
    `;
export type DeletePiiMemberMutationFn = Apollo.MutationFunction<DeletePiiMemberMutation, DeletePiiMemberMutationVariables>;

/**
 * __useDeletePiiMemberMutation__
 *
 * To run a mutation, you first call `useDeletePiiMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePiiMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePiiMemberMutation, { data, loading, error }] = useDeletePiiMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePiiMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeletePiiMemberMutation, DeletePiiMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePiiMemberMutation, DeletePiiMemberMutationVariables>(DeletePiiMemberDocument, options);
      }
export type DeletePiiMemberMutationHookResult = ReturnType<typeof useDeletePiiMemberMutation>;
export type DeletePiiMemberMutationResult = Apollo.MutationResult<DeletePiiMemberMutation>;
export type DeletePiiMemberMutationOptions = Apollo.BaseMutationOptions<DeletePiiMemberMutation, DeletePiiMemberMutationVariables>;
export const GetThreatGraphDataDocument = gql`
    query GetThreatGraphData($alert_uuid: uuid!) {
  get_threat_graph_data(get_threat_graph_data_input: {alert_uuid: $alert_uuid}) {
    root_node_ids
    nodes
    links
  }
}
    `;

/**
 * __useGetThreatGraphDataQuery__
 *
 * To run a query within a React component, call `useGetThreatGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreatGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreatGraphDataQuery({
 *   variables: {
 *      alert_uuid: // value for 'alert_uuid'
 *   },
 * });
 */
export function useGetThreatGraphDataQuery(baseOptions: Apollo.QueryHookOptions<GetThreatGraphDataQuery, GetThreatGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreatGraphDataQuery, GetThreatGraphDataQueryVariables>(GetThreatGraphDataDocument, options);
      }
export function useGetThreatGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThreatGraphDataQuery, GetThreatGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreatGraphDataQuery, GetThreatGraphDataQueryVariables>(GetThreatGraphDataDocument, options);
        }
export type GetThreatGraphDataQueryHookResult = ReturnType<typeof useGetThreatGraphDataQuery>;
export type GetThreatGraphDataLazyQueryHookResult = ReturnType<typeof useGetThreatGraphDataLazyQuery>;
export type GetThreatGraphDataQueryResult = Apollo.QueryResult<GetThreatGraphDataQuery, GetThreatGraphDataQueryVariables>;
export const GetGlobalThreatGraphDataDocument = gql`
    query GetGlobalThreatGraphData($organization_id: uuid!, $skipped_link_types: [String!]) {
  get_threat_graph_data(
    get_threat_graph_data_input: {organization_id: $organization_id, skipped_link_types: $skipped_link_types}
  ) {
    nodes
    links
  }
}
    `;

/**
 * __useGetGlobalThreatGraphDataQuery__
 *
 * To run a query within a React component, call `useGetGlobalThreatGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalThreatGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalThreatGraphDataQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      skipped_link_types: // value for 'skipped_link_types'
 *   },
 * });
 */
export function useGetGlobalThreatGraphDataQuery(baseOptions: Apollo.QueryHookOptions<GetGlobalThreatGraphDataQuery, GetGlobalThreatGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalThreatGraphDataQuery, GetGlobalThreatGraphDataQueryVariables>(GetGlobalThreatGraphDataDocument, options);
      }
export function useGetGlobalThreatGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalThreatGraphDataQuery, GetGlobalThreatGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalThreatGraphDataQuery, GetGlobalThreatGraphDataQueryVariables>(GetGlobalThreatGraphDataDocument, options);
        }
export type GetGlobalThreatGraphDataQueryHookResult = ReturnType<typeof useGetGlobalThreatGraphDataQuery>;
export type GetGlobalThreatGraphDataLazyQueryHookResult = ReturnType<typeof useGetGlobalThreatGraphDataLazyQuery>;
export type GetGlobalThreatGraphDataQueryResult = Apollo.QueryResult<GetGlobalThreatGraphDataQuery, GetGlobalThreatGraphDataQueryVariables>;
export const ValidateEntityLinkDocument = gql`
    query ValidateEntityLink($parent_node: jsonb!, $child_node: jsonb, $link_type: String) {
  validate_entity_link(
    create_entity_links_input: {parent_node: $parent_node, child_node: $child_node, link_type: $link_type, request_type: "validate"}
  ) {
    is_valid
    graph
    error
  }
}
    `;

/**
 * __useValidateEntityLinkQuery__
 *
 * To run a query within a React component, call `useValidateEntityLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateEntityLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateEntityLinkQuery({
 *   variables: {
 *      parent_node: // value for 'parent_node'
 *      child_node: // value for 'child_node'
 *      link_type: // value for 'link_type'
 *   },
 * });
 */
export function useValidateEntityLinkQuery(baseOptions: Apollo.QueryHookOptions<ValidateEntityLinkQuery, ValidateEntityLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateEntityLinkQuery, ValidateEntityLinkQueryVariables>(ValidateEntityLinkDocument, options);
      }
export function useValidateEntityLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateEntityLinkQuery, ValidateEntityLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateEntityLinkQuery, ValidateEntityLinkQueryVariables>(ValidateEntityLinkDocument, options);
        }
export type ValidateEntityLinkQueryHookResult = ReturnType<typeof useValidateEntityLinkQuery>;
export type ValidateEntityLinkLazyQueryHookResult = ReturnType<typeof useValidateEntityLinkLazyQuery>;
export type ValidateEntityLinkQueryResult = Apollo.QueryResult<ValidateEntityLinkQuery, ValidateEntityLinkQueryVariables>;
export const CreateEntityLinkDocument = gql`
    mutation CreateEntityLink($parent_node: jsonb!, $child_node: jsonb!, $link_type: String!) {
  create_entity_link(
    create_entity_links_input: {parent_node: $parent_node, child_node: $child_node, link_type: $link_type, request_type: "create"}
  ) {
    is_valid
    graph
    error
  }
}
    `;
export type CreateEntityLinkMutationFn = Apollo.MutationFunction<CreateEntityLinkMutation, CreateEntityLinkMutationVariables>;

/**
 * __useCreateEntityLinkMutation__
 *
 * To run a mutation, you first call `useCreateEntityLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityLinkMutation, { data, loading, error }] = useCreateEntityLinkMutation({
 *   variables: {
 *      parent_node: // value for 'parent_node'
 *      child_node: // value for 'child_node'
 *      link_type: // value for 'link_type'
 *   },
 * });
 */
export function useCreateEntityLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityLinkMutation, CreateEntityLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityLinkMutation, CreateEntityLinkMutationVariables>(CreateEntityLinkDocument, options);
      }
export type CreateEntityLinkMutationHookResult = ReturnType<typeof useCreateEntityLinkMutation>;
export type CreateEntityLinkMutationResult = Apollo.MutationResult<CreateEntityLinkMutation>;
export type CreateEntityLinkMutationOptions = Apollo.BaseMutationOptions<CreateEntityLinkMutation, CreateEntityLinkMutationVariables>;
export const DeleteEntityLinkDocument = gql`
    mutation DeleteEntityLink($link_id: uuid!) {
  archive_entity_link(
    archive_entity_links_input: {link_uuid: $link_id, request_type: "delete"}
  ) {
    message
  }
}
    `;
export type DeleteEntityLinkMutationFn = Apollo.MutationFunction<DeleteEntityLinkMutation, DeleteEntityLinkMutationVariables>;

/**
 * __useDeleteEntityLinkMutation__
 *
 * To run a mutation, you first call `useDeleteEntityLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityLinkMutation, { data, loading, error }] = useDeleteEntityLinkMutation({
 *   variables: {
 *      link_id: // value for 'link_id'
 *   },
 * });
 */
export function useDeleteEntityLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEntityLinkMutation, DeleteEntityLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEntityLinkMutation, DeleteEntityLinkMutationVariables>(DeleteEntityLinkDocument, options);
      }
export type DeleteEntityLinkMutationHookResult = ReturnType<typeof useDeleteEntityLinkMutation>;
export type DeleteEntityLinkMutationResult = Apollo.MutationResult<DeleteEntityLinkMutation>;
export type DeleteEntityLinkMutationOptions = Apollo.BaseMutationOptions<DeleteEntityLinkMutation, DeleteEntityLinkMutationVariables>;
export const GetChildOrganizationsDocument = gql`
    query GetChildOrganizations($parent_org_id: uuid!) {
  organizations(where: {parent_org_id: {_eq: $parent_org_id}}) {
    id
    name
    created_at
    organization_users {
      user {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useGetChildOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetChildOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildOrganizationsQuery({
 *   variables: {
 *      parent_org_id: // value for 'parent_org_id'
 *   },
 * });
 */
export function useGetChildOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetChildOrganizationsQuery, GetChildOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildOrganizationsQuery, GetChildOrganizationsQueryVariables>(GetChildOrganizationsDocument, options);
      }
export function useGetChildOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildOrganizationsQuery, GetChildOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildOrganizationsQuery, GetChildOrganizationsQueryVariables>(GetChildOrganizationsDocument, options);
        }
export type GetChildOrganizationsQueryHookResult = ReturnType<typeof useGetChildOrganizationsQuery>;
export type GetChildOrganizationsLazyQueryHookResult = ReturnType<typeof useGetChildOrganizationsLazyQuery>;
export type GetChildOrganizationsQueryResult = Apollo.QueryResult<GetChildOrganizationsQuery, GetChildOrganizationsQueryVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($organization_id: String!, $users_to_add: [String]!, $users_to_remove: [String]!) {
  update_organization(
    manage_organization_input: {request_type: "update", organization_id: $organization_id, users_to_add: $users_to_add, users_to_remove: $users_to_remove}
  ) {
    success
    message
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      users_to_add: // value for 'users_to_add'
 *      users_to_remove: // value for 'users_to_remove'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const HandleDetectionSearchDocument = gql`
    query HandleDetectionSearch($query: String!, $index_name: String!, $search_after: String, $limit: Int) {
  handle_detection_search(
    handle_detection_search_input: {query: $query, index_name: $index_name, search_after: $search_after, limit: $limit}
  ) {
    status
    message
    data
  }
}
    `;

/**
 * __useHandleDetectionSearchQuery__
 *
 * To run a query within a React component, call `useHandleDetectionSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useHandleDetectionSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHandleDetectionSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      index_name: // value for 'index_name'
 *      search_after: // value for 'search_after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useHandleDetectionSearchQuery(baseOptions: Apollo.QueryHookOptions<HandleDetectionSearchQuery, HandleDetectionSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HandleDetectionSearchQuery, HandleDetectionSearchQueryVariables>(HandleDetectionSearchDocument, options);
      }
export function useHandleDetectionSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HandleDetectionSearchQuery, HandleDetectionSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HandleDetectionSearchQuery, HandleDetectionSearchQueryVariables>(HandleDetectionSearchDocument, options);
        }
export type HandleDetectionSearchQueryHookResult = ReturnType<typeof useHandleDetectionSearchQuery>;
export type HandleDetectionSearchLazyQueryHookResult = ReturnType<typeof useHandleDetectionSearchLazyQuery>;
export type HandleDetectionSearchQueryResult = Apollo.QueryResult<HandleDetectionSearchQuery, HandleDetectionSearchQueryVariables>;
export const GetSimUsersDocument = gql`
    query GetSimUsers($org_id: uuid!) {
  sim_users(where: {org_id: {_eq: $org_id}}, order_by: {created_at: desc}) {
    id
    first_name
    last_name
    email_address
  }
}
    `;

/**
 * __useGetSimUsersQuery__
 *
 * To run a query within a React component, call `useGetSimUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimUsersQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetSimUsersQuery(baseOptions: Apollo.QueryHookOptions<GetSimUsersQuery, GetSimUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimUsersQuery, GetSimUsersQueryVariables>(GetSimUsersDocument, options);
      }
export function useGetSimUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimUsersQuery, GetSimUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimUsersQuery, GetSimUsersQueryVariables>(GetSimUsersDocument, options);
        }
export type GetSimUsersQueryHookResult = ReturnType<typeof useGetSimUsersQuery>;
export type GetSimUsersLazyQueryHookResult = ReturnType<typeof useGetSimUsersLazyQuery>;
export type GetSimUsersQueryResult = Apollo.QueryResult<GetSimUsersQuery, GetSimUsersQueryVariables>;
export const GetSimCampaignDocument = gql`
    query GetSimCampaign($campaign_id: uuid!) {
  sim_campaigns(where: {id: {_eq: $campaign_id}}) {
    ...SIM_CAMPAIGN
  }
}
    ${Sim_CampaignFragmentDoc}`;

/**
 * __useGetSimCampaignQuery__
 *
 * To run a query within a React component, call `useGetSimCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimCampaignQuery({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useGetSimCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetSimCampaignQuery, GetSimCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimCampaignQuery, GetSimCampaignQueryVariables>(GetSimCampaignDocument, options);
      }
export function useGetSimCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimCampaignQuery, GetSimCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimCampaignQuery, GetSimCampaignQueryVariables>(GetSimCampaignDocument, options);
        }
export type GetSimCampaignQueryHookResult = ReturnType<typeof useGetSimCampaignQuery>;
export type GetSimCampaignLazyQueryHookResult = ReturnType<typeof useGetSimCampaignLazyQuery>;
export type GetSimCampaignQueryResult = Apollo.QueryResult<GetSimCampaignQuery, GetSimCampaignQueryVariables>;
export const GetSimCampaignsDocument = gql`
    query GetSimCampaigns($org_id: uuid!) {
  sim_campaigns(where: {org_id: {_eq: $org_id}}, order_by: {created_at: desc}) {
    ...SIM_CAMPAIGN
  }
}
    ${Sim_CampaignFragmentDoc}`;

/**
 * __useGetSimCampaignsQuery__
 *
 * To run a query within a React component, call `useGetSimCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimCampaignsQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useGetSimCampaignsQuery(baseOptions: Apollo.QueryHookOptions<GetSimCampaignsQuery, GetSimCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimCampaignsQuery, GetSimCampaignsQueryVariables>(GetSimCampaignsDocument, options);
      }
export function useGetSimCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimCampaignsQuery, GetSimCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimCampaignsQuery, GetSimCampaignsQueryVariables>(GetSimCampaignsDocument, options);
        }
export type GetSimCampaignsQueryHookResult = ReturnType<typeof useGetSimCampaignsQuery>;
export type GetSimCampaignsLazyQueryHookResult = ReturnType<typeof useGetSimCampaignsLazyQuery>;
export type GetSimCampaignsQueryResult = Apollo.QueryResult<GetSimCampaignsQuery, GetSimCampaignsQueryVariables>;
export const GetSimEmailsDocument = gql`
    query GetSimEmails($orgId: uuid!) {
  sim_emails(where: {org_id: {_eq: $orgId}}) {
    ...SIM_EMAIL
  }
}
    ${Sim_EmailFragmentDoc}`;

/**
 * __useGetSimEmailsQuery__
 *
 * To run a query within a React component, call `useGetSimEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimEmailsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetSimEmailsQuery(baseOptions: Apollo.QueryHookOptions<GetSimEmailsQuery, GetSimEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimEmailsQuery, GetSimEmailsQueryVariables>(GetSimEmailsDocument, options);
      }
export function useGetSimEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimEmailsQuery, GetSimEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimEmailsQuery, GetSimEmailsQueryVariables>(GetSimEmailsDocument, options);
        }
export type GetSimEmailsQueryHookResult = ReturnType<typeof useGetSimEmailsQuery>;
export type GetSimEmailsLazyQueryHookResult = ReturnType<typeof useGetSimEmailsLazyQuery>;
export type GetSimEmailsQueryResult = Apollo.QueryResult<GetSimEmailsQuery, GetSimEmailsQueryVariables>;
export const GetSimEmailsByCampaignIdDocument = gql`
    query GetSimEmailsByCampaignId($campaign_id: uuid!) {
  sim_emails(where: {campaign_id: {_eq: $campaign_id}}) {
    ...SIM_EMAIL
  }
}
    ${Sim_EmailFragmentDoc}`;

/**
 * __useGetSimEmailsByCampaignIdQuery__
 *
 * To run a query within a React component, call `useGetSimEmailsByCampaignIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimEmailsByCampaignIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimEmailsByCampaignIdQuery({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useGetSimEmailsByCampaignIdQuery(baseOptions: Apollo.QueryHookOptions<GetSimEmailsByCampaignIdQuery, GetSimEmailsByCampaignIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimEmailsByCampaignIdQuery, GetSimEmailsByCampaignIdQueryVariables>(GetSimEmailsByCampaignIdDocument, options);
      }
export function useGetSimEmailsByCampaignIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimEmailsByCampaignIdQuery, GetSimEmailsByCampaignIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimEmailsByCampaignIdQuery, GetSimEmailsByCampaignIdQueryVariables>(GetSimEmailsByCampaignIdDocument, options);
        }
export type GetSimEmailsByCampaignIdQueryHookResult = ReturnType<typeof useGetSimEmailsByCampaignIdQuery>;
export type GetSimEmailsByCampaignIdLazyQueryHookResult = ReturnType<typeof useGetSimEmailsByCampaignIdLazyQuery>;
export type GetSimEmailsByCampaignIdQueryResult = Apollo.QueryResult<GetSimEmailsByCampaignIdQuery, GetSimEmailsByCampaignIdQueryVariables>;
export const CreateSimCampaignDocument = gql`
    mutation CreateSimCampaign($name: String!, $org_id: String!, $sender_address: String!, $launch_date: String!, $end_date: String!, $sim_user_ids: [String]!) {
  create_sim_campaign(
    create_sim_campaign_input: {name: $name, org_id: $org_id, sender_address: $sender_address, launch_date: $launch_date, end_date: $end_date, sim_user_ids: $sim_user_ids}
  ) {
    campaign_id
  }
}
    `;
export type CreateSimCampaignMutationFn = Apollo.MutationFunction<CreateSimCampaignMutation, CreateSimCampaignMutationVariables>;

/**
 * __useCreateSimCampaignMutation__
 *
 * To run a mutation, you first call `useCreateSimCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSimCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSimCampaignMutation, { data, loading, error }] = useCreateSimCampaignMutation({
 *   variables: {
 *      name: // value for 'name'
 *      org_id: // value for 'org_id'
 *      sender_address: // value for 'sender_address'
 *      launch_date: // value for 'launch_date'
 *      end_date: // value for 'end_date'
 *      sim_user_ids: // value for 'sim_user_ids'
 *   },
 * });
 */
export function useCreateSimCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateSimCampaignMutation, CreateSimCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSimCampaignMutation, CreateSimCampaignMutationVariables>(CreateSimCampaignDocument, options);
      }
export type CreateSimCampaignMutationHookResult = ReturnType<typeof useCreateSimCampaignMutation>;
export type CreateSimCampaignMutationResult = Apollo.MutationResult<CreateSimCampaignMutation>;
export type CreateSimCampaignMutationOptions = Apollo.BaseMutationOptions<CreateSimCampaignMutation, CreateSimCampaignMutationVariables>;
export const GetHasEmployeeBrandDocument = gql`
    query GetHasEmployeeBrand($organization_id: uuid!) {
  spoofing_entities(
    where: {organization_id: {_eq: $organization_id}, entity_type: {_eq: "personal_brand"}}
    limit: 1
  ) {
    id
  }
}
    `;

/**
 * __useGetHasEmployeeBrandQuery__
 *
 * To run a query within a React component, call `useGetHasEmployeeBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasEmployeeBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasEmployeeBrandQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetHasEmployeeBrandQuery(baseOptions: Apollo.QueryHookOptions<GetHasEmployeeBrandQuery, GetHasEmployeeBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHasEmployeeBrandQuery, GetHasEmployeeBrandQueryVariables>(GetHasEmployeeBrandDocument, options);
      }
export function useGetHasEmployeeBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHasEmployeeBrandQuery, GetHasEmployeeBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHasEmployeeBrandQuery, GetHasEmployeeBrandQueryVariables>(GetHasEmployeeBrandDocument, options);
        }
export type GetHasEmployeeBrandQueryHookResult = ReturnType<typeof useGetHasEmployeeBrandQuery>;
export type GetHasEmployeeBrandLazyQueryHookResult = ReturnType<typeof useGetHasEmployeeBrandLazyQuery>;
export type GetHasEmployeeBrandQueryResult = Apollo.QueryResult<GetHasEmployeeBrandQuery, GetHasEmployeeBrandQueryVariables>;
export const GetExecutiveProtectionAlertsCountsDocument = gql`
    query GetExecutiveProtectionAlertsCounts($organization_id: uuid!, $queue_state: String!) {
  threat_alerts: spoofing_reports_aggregate(
    where: {organization_id: {_eq: $organization_id}, report_status: {_eq: $queue_state}, spoofing_entity: {entity_type: {_eq: "personal_brand"}}, platform_subtype: {product: {_neq: "darkweb"}}}
  ) {
    aggregate {
      count
    }
  }
  darkweb_mentions: spoofing_reports_aggregate(
    where: {organization_id: {_eq: $organization_id}, report_status: {_eq: $queue_state}, spoofing_entity: {entity_type: {_eq: "personal_brand"}}, platform_subtype: {name: {_eq: "darkweb"}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetExecutiveProtectionAlertsCountsQuery__
 *
 * To run a query within a React component, call `useGetExecutiveProtectionAlertsCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExecutiveProtectionAlertsCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExecutiveProtectionAlertsCountsQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *      queue_state: // value for 'queue_state'
 *   },
 * });
 */
export function useGetExecutiveProtectionAlertsCountsQuery(baseOptions: Apollo.QueryHookOptions<GetExecutiveProtectionAlertsCountsQuery, GetExecutiveProtectionAlertsCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExecutiveProtectionAlertsCountsQuery, GetExecutiveProtectionAlertsCountsQueryVariables>(GetExecutiveProtectionAlertsCountsDocument, options);
      }
export function useGetExecutiveProtectionAlertsCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExecutiveProtectionAlertsCountsQuery, GetExecutiveProtectionAlertsCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExecutiveProtectionAlertsCountsQuery, GetExecutiveProtectionAlertsCountsQueryVariables>(GetExecutiveProtectionAlertsCountsDocument, options);
        }
export type GetExecutiveProtectionAlertsCountsQueryHookResult = ReturnType<typeof useGetExecutiveProtectionAlertsCountsQuery>;
export type GetExecutiveProtectionAlertsCountsLazyQueryHookResult = ReturnType<typeof useGetExecutiveProtectionAlertsCountsLazyQuery>;
export type GetExecutiveProtectionAlertsCountsQueryResult = Apollo.QueryResult<GetExecutiveProtectionAlertsCountsQuery, GetExecutiveProtectionAlertsCountsQueryVariables>;
export const GetLatestPredictedEnforcementTypeDocument = gql`
    query GetLatestPredictedEnforcementType($match_id: uuid!, $alert_id: uuid!) {
  predicted_enforcement_types(
    where: {match_id: {_eq: $match_id}, alert_id: {_eq: $alert_id}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    id
    created_at
    predicted_enforcement_type
    llm_decision_reason
    llm_invocation
    alert_id
    match_id
  }
}
    `;

/**
 * __useGetLatestPredictedEnforcementTypeQuery__
 *
 * To run a query within a React component, call `useGetLatestPredictedEnforcementTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestPredictedEnforcementTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestPredictedEnforcementTypeQuery({
 *   variables: {
 *      match_id: // value for 'match_id'
 *      alert_id: // value for 'alert_id'
 *   },
 * });
 */
export function useGetLatestPredictedEnforcementTypeQuery(baseOptions: Apollo.QueryHookOptions<GetLatestPredictedEnforcementTypeQuery, GetLatestPredictedEnforcementTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestPredictedEnforcementTypeQuery, GetLatestPredictedEnforcementTypeQueryVariables>(GetLatestPredictedEnforcementTypeDocument, options);
      }
export function useGetLatestPredictedEnforcementTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestPredictedEnforcementTypeQuery, GetLatestPredictedEnforcementTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestPredictedEnforcementTypeQuery, GetLatestPredictedEnforcementTypeQueryVariables>(GetLatestPredictedEnforcementTypeDocument, options);
        }
export type GetLatestPredictedEnforcementTypeQueryHookResult = ReturnType<typeof useGetLatestPredictedEnforcementTypeQuery>;
export type GetLatestPredictedEnforcementTypeLazyQueryHookResult = ReturnType<typeof useGetLatestPredictedEnforcementTypeLazyQuery>;
export type GetLatestPredictedEnforcementTypeQueryResult = Apollo.QueryResult<GetLatestPredictedEnforcementTypeQuery, GetLatestPredictedEnforcementTypeQueryVariables>;
export const GetSimCampaignObservationsByCampaignIdDocument = gql`
    query GetSimCampaignObservationsByCampaignId($campaign_id: uuid!) {
  sim_campaign_observations(where: {campaign_id: {_eq: $campaign_id}}) {
    id
    campaign_id
    sim_user_id
    action
    created_at
  }
}
    `;

/**
 * __useGetSimCampaignObservationsByCampaignIdQuery__
 *
 * To run a query within a React component, call `useGetSimCampaignObservationsByCampaignIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimCampaignObservationsByCampaignIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimCampaignObservationsByCampaignIdQuery({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useGetSimCampaignObservationsByCampaignIdQuery(baseOptions: Apollo.QueryHookOptions<GetSimCampaignObservationsByCampaignIdQuery, GetSimCampaignObservationsByCampaignIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimCampaignObservationsByCampaignIdQuery, GetSimCampaignObservationsByCampaignIdQueryVariables>(GetSimCampaignObservationsByCampaignIdDocument, options);
      }
export function useGetSimCampaignObservationsByCampaignIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimCampaignObservationsByCampaignIdQuery, GetSimCampaignObservationsByCampaignIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimCampaignObservationsByCampaignIdQuery, GetSimCampaignObservationsByCampaignIdQueryVariables>(GetSimCampaignObservationsByCampaignIdDocument, options);
        }
export type GetSimCampaignObservationsByCampaignIdQueryHookResult = ReturnType<typeof useGetSimCampaignObservationsByCampaignIdQuery>;
export type GetSimCampaignObservationsByCampaignIdLazyQueryHookResult = ReturnType<typeof useGetSimCampaignObservationsByCampaignIdLazyQuery>;
export type GetSimCampaignObservationsByCampaignIdQueryResult = Apollo.QueryResult<GetSimCampaignObservationsByCampaignIdQuery, GetSimCampaignObservationsByCampaignIdQueryVariables>;
export const GetActiveAndTrialOrganizationProductsDocument = gql`
    query GetActiveAndTrialOrganizationProducts($organization_id: uuid!) {
  organization_products(
    where: {organization_id: {_eq: $organization_id}, enablement_status: {_in: ["enabled", "trial"]}}
  ) {
    product
    enablement_status
  }
}
    `;

/**
 * __useGetActiveAndTrialOrganizationProductsQuery__
 *
 * To run a query within a React component, call `useGetActiveAndTrialOrganizationProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveAndTrialOrganizationProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveAndTrialOrganizationProductsQuery({
 *   variables: {
 *      organization_id: // value for 'organization_id'
 *   },
 * });
 */
export function useGetActiveAndTrialOrganizationProductsQuery(baseOptions: Apollo.QueryHookOptions<GetActiveAndTrialOrganizationProductsQuery, GetActiveAndTrialOrganizationProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveAndTrialOrganizationProductsQuery, GetActiveAndTrialOrganizationProductsQueryVariables>(GetActiveAndTrialOrganizationProductsDocument, options);
      }
export function useGetActiveAndTrialOrganizationProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveAndTrialOrganizationProductsQuery, GetActiveAndTrialOrganizationProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveAndTrialOrganizationProductsQuery, GetActiveAndTrialOrganizationProductsQueryVariables>(GetActiveAndTrialOrganizationProductsDocument, options);
        }
export type GetActiveAndTrialOrganizationProductsQueryHookResult = ReturnType<typeof useGetActiveAndTrialOrganizationProductsQuery>;
export type GetActiveAndTrialOrganizationProductsLazyQueryHookResult = ReturnType<typeof useGetActiveAndTrialOrganizationProductsLazyQuery>;
export type GetActiveAndTrialOrganizationProductsQueryResult = Apollo.QueryResult<GetActiveAndTrialOrganizationProductsQuery, GetActiveAndTrialOrganizationProductsQueryVariables>;